
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire785f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire785f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';
parcelRequire("013Yp");

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$g = 60103;
$1bb9784afa87e369$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $1bb9784afa87e369$var$h = Symbol.for;
    $1bb9784afa87e369$var$g = $1bb9784afa87e369$var$h("react.element");
    $1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$h("react.fragment");
}
var $1bb9784afa87e369$var$m = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$n = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$1bb9784afa87e369$var$n.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $1bb9784afa87e369$var$m.current
    };
}
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("013Yp", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $00332d224329ec89$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $00332d224329ec89$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $00332d224329ec89$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $00332d224329ec89$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $00332d224329ec89$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $00332d224329ec89$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $00332d224329ec89$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($00332d224329ec89$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($00332d224329ec89$var$getOwnPropertySymbols) {
            symbols = $00332d224329ec89$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($00332d224329ec89$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';

var $013Yp = parcelRequire("013Yp");
var $b9040d2deeb360f4$var$n = 60103, $b9040d2deeb360f4$var$p = 60106;
$b9040d2deeb360f4$export$ffb0004e005737fa = 60107;
$b9040d2deeb360f4$export$5f8d39834fd61797 = 60108;
$b9040d2deeb360f4$export$e2c29f18771995cb = 60114;
var $b9040d2deeb360f4$var$q = 60109, $b9040d2deeb360f4$var$r = 60110, $b9040d2deeb360f4$var$t = 60112;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = 60113;
var $b9040d2deeb360f4$var$u = 60115, $b9040d2deeb360f4$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $b9040d2deeb360f4$var$w = Symbol.for;
    $b9040d2deeb360f4$var$n = $b9040d2deeb360f4$var$w("react.element");
    $b9040d2deeb360f4$var$p = $b9040d2deeb360f4$var$w("react.portal");
    $b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$w("react.fragment");
    $b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$w("react.strict_mode");
    $b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$w("react.profiler");
    $b9040d2deeb360f4$var$q = $b9040d2deeb360f4$var$w("react.provider");
    $b9040d2deeb360f4$var$r = $b9040d2deeb360f4$var$w("react.context");
    $b9040d2deeb360f4$var$t = $b9040d2deeb360f4$var$w("react.forward_ref");
    $b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w("react.suspense");
    $b9040d2deeb360f4$var$u = $b9040d2deeb360f4$var$w("react.memo");
    $b9040d2deeb360f4$var$v = $b9040d2deeb360f4$var$w("react.lazy");
}
var $b9040d2deeb360f4$var$x = "function" === typeof Symbol && Symbol.iterator;
function $b9040d2deeb360f4$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$x && a[$b9040d2deeb360f4$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $b9040d2deeb360f4$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b9040d2deeb360f4$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$B = {};
function $b9040d2deeb360f4$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$B;
    this.updater = c || $b9040d2deeb360f4$var$A;
}
$b9040d2deeb360f4$var$C.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($b9040d2deeb360f4$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$D() {}
$b9040d2deeb360f4$var$D.prototype = $b9040d2deeb360f4$var$C.prototype;
function $b9040d2deeb360f4$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$B;
    this.updater = c || $b9040d2deeb360f4$var$A;
}
var $b9040d2deeb360f4$var$F = $b9040d2deeb360f4$var$E.prototype = new $b9040d2deeb360f4$var$D;
$b9040d2deeb360f4$var$F.constructor = $b9040d2deeb360f4$var$E;
$013Yp($b9040d2deeb360f4$var$F, $b9040d2deeb360f4$var$C.prototype);
$b9040d2deeb360f4$var$F.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$G = {
    current: null
}, $b9040d2deeb360f4$var$H = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$H.call(b, e) && !$b9040d2deeb360f4$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $b9040d2deeb360f4$var$G.current
    };
}
function $b9040d2deeb360f4$var$K(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$n;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$M = /\/+/g;
function $b9040d2deeb360f4$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$n:
                case $b9040d2deeb360f4$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $b9040d2deeb360f4$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($b9040d2deeb360f4$var$M, "$&/") + "/"), $b9040d2deeb360f4$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($b9040d2deeb360f4$var$L(d) && (d = $b9040d2deeb360f4$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($b9040d2deeb360f4$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $b9040d2deeb360f4$var$N(k, g);
        h += $b9040d2deeb360f4$var$O(k, b, c, f, d);
    }
    else if (f = $b9040d2deeb360f4$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $b9040d2deeb360f4$var$N(k, g++), h += $b9040d2deeb360f4$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($b9040d2deeb360f4$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $b9040d2deeb360f4$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $b9040d2deeb360f4$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $b9040d2deeb360f4$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $b9040d2deeb360f4$var$R = {
    current: null
};
function $b9040d2deeb360f4$var$S() {
    var a = $b9040d2deeb360f4$var$R.current;
    if (null === a) throw Error($b9040d2deeb360f4$var$z(321));
    return a;
}
var $b9040d2deeb360f4$var$T = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $b9040d2deeb360f4$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $013Yp
};
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$P,
    forEach: function(a, b, c) {
        $b9040d2deeb360f4$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$L(a)) throw Error($b9040d2deeb360f4$var$z(143));
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$C;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$T;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($b9040d2deeb360f4$var$z(267, a));
    var e = $013Yp({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$H.call(b, f) && !$b9040d2deeb360f4$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $b9040d2deeb360f4$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$J;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$J.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$t,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$L;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$Q
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useContext(a, b);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useEffect(a, b);
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, c) {
    return $b9040d2deeb360f4$var$S().useImperativeHandle(a, b, c);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$S().useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, c) {
    return $b9040d2deeb360f4$var$S().useReducer(a, b, c);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$S().useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$S().useState(a);
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("fw0lo", function(module, exports) {
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

module.exports = (parcelRequire("6EA3T"));

});
parcelRegister("6EA3T", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $013Yp = parcelRequire("013Yp");

var $33s19 = parcelRequire("33s19");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$7fPBF) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $013Yp({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $7fPBF.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $013Yp({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $013Yp({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $013Yp({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $33s19.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $33s19.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $33s19.unstable_UserBlockingPriority, ed = $33s19.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $013Yp(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $013Yp({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $013Yp({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $013Yp({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $013Yp({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $013Yp({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $013Yp({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $013Yp({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $013Yp({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $013Yp({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $013Yp({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $013Yp({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $013Yp({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $013Yp({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $33s19.unstable_runWithPriority, Of = $33s19.unstable_scheduleCallback, Pf = $33s19.unstable_cancelCallback, Qf = $33s19.unstable_shouldYield, Rf = $33s19.unstable_requestPaint, Sf = $33s19.unstable_now, Tf = $33s19.unstable_getCurrentPriorityLevel, Uf = $33s19.unstable_ImmediatePriority, Vf = $33s19.unstable_UserBlockingPriority, Wf = $33s19.unstable_NormalPriority, Xf = $33s19.unstable_LowPriority, Yf = $33s19.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $013Yp({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $013Yp({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $7fPBF.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $013Yp({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $013Yp({}, e, {
                    value: void 0
                });
                d = $013Yp({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $013Yp({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
var $749777fefd570b40$var$f, $749777fefd570b40$var$g, $749777fefd570b40$var$h, $749777fefd570b40$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $749777fefd570b40$var$t = null, $749777fefd570b40$var$u = null, $749777fefd570b40$var$w = function() {
        if (null !== $749777fefd570b40$var$t) try {
            var a = $749777fefd570b40$export$c4744153514ff05d();
            $749777fefd570b40$var$t(!0, a);
            $749777fefd570b40$var$t = null;
        } catch (b) {
            throw setTimeout($749777fefd570b40$var$w, 0), b;
        }
    };
    $749777fefd570b40$var$f = function(a) {
        null !== $749777fefd570b40$var$t ? setTimeout($749777fefd570b40$var$f, 0, a) : ($749777fefd570b40$var$t = a, setTimeout($749777fefd570b40$var$w, 0));
    };
    $749777fefd570b40$var$g = function(a, b) {
        $749777fefd570b40$var$u = setTimeout(a, b);
    };
    $749777fefd570b40$var$h = function() {
        clearTimeout($749777fefd570b40$var$u);
    };
    $749777fefd570b40$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $749777fefd570b40$var$k = $749777fefd570b40$export$d66a1c1c77bd778b = function() {};
} else {
    var $749777fefd570b40$var$x = window.setTimeout, $749777fefd570b40$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $749777fefd570b40$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $749777fefd570b40$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = null, $749777fefd570b40$var$C = -1, $749777fefd570b40$var$D = 5, $749777fefd570b40$var$E = 0;
    $749777fefd570b40$export$b5836b71941fa3ed = function() {
        return $749777fefd570b40$export$c4744153514ff05d() >= $749777fefd570b40$var$E;
    };
    $749777fefd570b40$var$k = function() {};
    $749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $749777fefd570b40$var$F = new MessageChannel, $749777fefd570b40$var$G = $749777fefd570b40$var$F.port2;
    $749777fefd570b40$var$F.port1.onmessage = function() {
        if (null !== $749777fefd570b40$var$B) {
            var a = $749777fefd570b40$export$c4744153514ff05d();
            $749777fefd570b40$var$E = a + $749777fefd570b40$var$D;
            try {
                $749777fefd570b40$var$B(!0, a) ? $749777fefd570b40$var$G.postMessage(null) : ($749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = null);
            } catch (b) {
                throw $749777fefd570b40$var$G.postMessage(null), b;
            }
        } else $749777fefd570b40$var$A = !1;
    };
    $749777fefd570b40$var$f = function(a) {
        $749777fefd570b40$var$B = a;
        $749777fefd570b40$var$A || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$G.postMessage(null));
    };
    $749777fefd570b40$var$g = function(a, b) {
        $749777fefd570b40$var$C = $749777fefd570b40$var$x(function() {
            a($749777fefd570b40$export$c4744153514ff05d());
        }, b);
    };
    $749777fefd570b40$var$h = function() {
        $749777fefd570b40$var$y($749777fefd570b40$var$C);
        $749777fefd570b40$var$C = -1;
    };
}
function $749777fefd570b40$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $749777fefd570b40$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $749777fefd570b40$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $749777fefd570b40$var$I(n, c)) void 0 !== r && 0 > $749777fefd570b40$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $749777fefd570b40$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $749777fefd570b40$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $749777fefd570b40$var$L = [], $749777fefd570b40$var$M = [], $749777fefd570b40$var$N = 1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$P = 3, $749777fefd570b40$var$Q = !1, $749777fefd570b40$var$R = !1, $749777fefd570b40$var$S = !1;
function $749777fefd570b40$var$T(a) {
    for(var b = $749777fefd570b40$var$J($749777fefd570b40$var$M); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$K($749777fefd570b40$var$M);
        else if (b.startTime <= a) $749777fefd570b40$var$K($749777fefd570b40$var$M), b.sortIndex = b.expirationTime, $749777fefd570b40$var$H($749777fefd570b40$var$L, b);
        else break;
        b = $749777fefd570b40$var$J($749777fefd570b40$var$M);
    }
}
function $749777fefd570b40$var$U(a) {
    $749777fefd570b40$var$S = !1;
    $749777fefd570b40$var$T(a);
    if (!$749777fefd570b40$var$R) {
        if (null !== $749777fefd570b40$var$J($749777fefd570b40$var$L)) $749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V);
        else {
            var b = $749777fefd570b40$var$J($749777fefd570b40$var$M);
            null !== b && $749777fefd570b40$var$g($749777fefd570b40$var$U, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$V(a, b) {
    $749777fefd570b40$var$R = !1;
    $749777fefd570b40$var$S && ($749777fefd570b40$var$S = !1, $749777fefd570b40$var$h());
    $749777fefd570b40$var$Q = !0;
    var c = $749777fefd570b40$var$P;
    try {
        $749777fefd570b40$var$T(b);
        for($749777fefd570b40$var$O = $749777fefd570b40$var$J($749777fefd570b40$var$L); null !== $749777fefd570b40$var$O && (!($749777fefd570b40$var$O.expirationTime > b) || a && !$749777fefd570b40$export$b5836b71941fa3ed());){
            var d = $749777fefd570b40$var$O.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$O.callback = null;
                $749777fefd570b40$var$P = $749777fefd570b40$var$O.priorityLevel;
                var e = d($749777fefd570b40$var$O.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$O.callback = e : $749777fefd570b40$var$O === $749777fefd570b40$var$J($749777fefd570b40$var$L) && $749777fefd570b40$var$K($749777fefd570b40$var$L);
                $749777fefd570b40$var$T(b);
            } else $749777fefd570b40$var$K($749777fefd570b40$var$L);
            $749777fefd570b40$var$O = $749777fefd570b40$var$J($749777fefd570b40$var$L);
        }
        if (null !== $749777fefd570b40$var$O) var m = !0;
        else {
            var n = $749777fefd570b40$var$J($749777fefd570b40$var$M);
            null !== n && $749777fefd570b40$var$g($749777fefd570b40$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $749777fefd570b40$var$O = null, $749777fefd570b40$var$P = c, $749777fefd570b40$var$Q = !1;
    }
}
var $749777fefd570b40$var$W = $749777fefd570b40$var$k;
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$R || $749777fefd570b40$var$Q || ($749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V));
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$P;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$J($749777fefd570b40$var$L);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$P;
    }
    var c = $749777fefd570b40$var$P;
    $749777fefd570b40$var$P = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$P = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = $749777fefd570b40$var$W;
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$P;
    $749777fefd570b40$var$P = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$P = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$H($749777fefd570b40$var$M, a), null === $749777fefd570b40$var$J($749777fefd570b40$var$L) && a === $749777fefd570b40$var$J($749777fefd570b40$var$M) && ($749777fefd570b40$var$S ? $749777fefd570b40$var$h() : $749777fefd570b40$var$S = !0, $749777fefd570b40$var$g($749777fefd570b40$var$U, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$H($749777fefd570b40$var$L, a), $749777fefd570b40$var$R || $749777fefd570b40$var$Q || ($749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V)));
    return a;
};
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$P;
    return function() {
        var c = $749777fefd570b40$var$P;
        $749777fefd570b40$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$P = c;
        }
    };
};

});




parcelRegister("lzq3r", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("kPsoI")).then(()=>parcelRequire('3GJ3v'));

});
parcelRegister("1iyJ7", function(module, exports) {
"use strict";

var $e0V30 = parcelRequire("e0V30");
module.exports = $e0V30(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("e0V30", function(module, exports) {
"use strict";
var $a33d51355b1da95d$var$cachedBundles = {};
var $a33d51355b1da95d$var$cachedPreloads = {};
var $a33d51355b1da95d$var$cachedPrefetches = {};
function $a33d51355b1da95d$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a33d51355b1da95d$var$cachedPreloads;
        case 'prefetch':
            return $a33d51355b1da95d$var$cachedPrefetches;
        default:
            return $a33d51355b1da95d$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a33d51355b1da95d$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("a04va", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $6zjya = parcelRequire("6zjya");

var $8PZpp = parcelRequire("8PZpp");

var $5f6d7 = parcelRequire("5f6d7");

var $9X39E = parcelRequire("9X39E");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    var context = new $8PZpp(defaultConfig);
    var instance = $6zjya($8PZpp.prototype.request, context);
    // Copy axios.prototype to instance
    $adReO.extend(instance, $8PZpp.prototype, context);
    // Copy context to instance
    $adReO.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance($5f6d7(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance($9X39E);
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = $8PZpp;

// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.Cancel = (parcelRequire("2W85d"));

$747d656b899e6115$var$axios.CancelToken = (parcelRequire("kZZD0"));

$747d656b899e6115$var$axios.isCancel = (parcelRequire("4IsRW"));

$747d656b899e6115$var$axios.VERSION = (parcelRequire("cR4ZD")).version;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$747d656b899e6115$var$axios.spread = (parcelRequire("b676K"));

// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (parcelRequire("kgiwQ"));
module.exports = $747d656b899e6115$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $747d656b899e6115$var$axios;

});
parcelRegister("adReO", function(module, exports) {
'use strict';

var $6zjya = parcelRequire("6zjya");
// utils is a library of generic helper functions non-specific to axios
var $77146a31cb578292$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $77146a31cb578292$var$isArray(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $77146a31cb578292$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBuffer(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $77146a31cb578292$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $77146a31cb578292$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $77146a31cb578292$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $77146a31cb578292$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $77146a31cb578292$var$isPlainObject(val) {
    if ($77146a31cb578292$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $77146a31cb578292$var$isDate(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $77146a31cb578292$var$isFile(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $77146a31cb578292$var$isBlob(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $77146a31cb578292$var$isFunction(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $77146a31cb578292$var$isStream(val) {
    return $77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $77146a31cb578292$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $77146a31cb578292$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $77146a31cb578292$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $77146a31cb578292$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($77146a31cb578292$var$isPlainObject(result[key]) && $77146a31cb578292$var$isPlainObject(val)) result[key] = $77146a31cb578292$var$merge(result[key], val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[key] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$77146a31cb578292$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $77146a31cb578292$var$extend(a, b, thisArg) {
    $77146a31cb578292$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $6zjya(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $77146a31cb578292$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isBlob: $77146a31cb578292$var$isBlob,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isStandardBrowserEnv: $77146a31cb578292$var$isStandardBrowserEnv,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM
};

});
parcelRegister("6zjya", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("8PZpp", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $6nvAH = parcelRequire("6nvAH");

var $khPLX = parcelRequire("khPLX");

var $eystn = parcelRequire("eystn");

var $5f6d7 = parcelRequire("5f6d7");

var $2iR5D = parcelRequire("2iR5D");
var $66f2b8a41463d1e8$var$validators = $2iR5D.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $66f2b8a41463d1e8$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $khPLX(),
        response: new $khPLX()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $66f2b8a41463d1e8$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $5f6d7(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $2iR5D.assertOptions(transitional, {
        silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
        forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
        clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $eystn,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $eystn(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$66f2b8a41463d1e8$var$Axios.prototype.getUri = function getUri(config) {
    config = $5f6d7(this.defaults, config);
    return $6nvAH(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$adReO.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request($5f6d7(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$adReO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($5f6d7(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $66f2b8a41463d1e8$var$Axios;

});
parcelRegister("6nvAH", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
function $4a4d655613ae826e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($adReO.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $adReO.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($adReO.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $adReO.forEach(val, function parseValue(v) {
                if ($adReO.isDate(v)) v = v.toISOString();
                else if ($adReO.isObject(v)) v = JSON.stringify(v);
                parts.push($4a4d655613ae826e$var$encode(key) + '=' + $4a4d655613ae826e$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("khPLX", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
function $ec4d8e24b0699790$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $adReO.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $ec4d8e24b0699790$var$InterceptorManager;

});

parcelRegister("eystn", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $15ANS = parcelRequire("15ANS");

var $4IsRW = parcelRequire("4IsRW");

var $9X39E = parcelRequire("9X39E");

var $2W85d = parcelRequire("2W85d");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $2W85d('canceled');
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $15ANS.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $adReO.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $adReO.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $9X39E.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $15ANS.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$4IsRW(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $15ANS.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("15ANS", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $9X39E = parcelRequire("9X39E");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $9X39E;
    /*eslint no-param-reassign:0*/ $adReO.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("9X39E", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $9y7wC = parcelRequire("9y7wC");

var $3leq5 = parcelRequire("3leq5");
var $73ec122cfcba4842$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $73ec122cfcba4842$var$setContentTypeIfUnset(headers, value) {
    if (!$adReO.isUndefined(headers) && $adReO.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $73ec122cfcba4842$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("3PMHb"));
    return adapter;
}
function $73ec122cfcba4842$var$stringifySafely(rawValue, parser, encoder) {
    if ($adReO.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $adReO.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $73ec122cfcba4842$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $73ec122cfcba4842$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $9y7wC(headers, 'Accept');
            $9y7wC(headers, 'Content-Type');
            if ($adReO.isFormData(data) || $adReO.isArrayBuffer(data) || $adReO.isBuffer(data) || $adReO.isStream(data) || $adReO.isFile(data) || $adReO.isBlob(data)) return data;
            if ($adReO.isArrayBufferView(data)) return data.buffer;
            if ($adReO.isURLSearchParams(data)) {
                $73ec122cfcba4842$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($adReO.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $73ec122cfcba4842$var$setContentTypeIfUnset(headers, 'application/json');
                return $73ec122cfcba4842$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $73ec122cfcba4842$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $adReO.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $3leq5(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$adReO.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $73ec122cfcba4842$var$defaults.headers[method] = {};
});
$adReO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $73ec122cfcba4842$var$defaults.headers[method] = $adReO.merge($73ec122cfcba4842$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $73ec122cfcba4842$var$defaults;

});
parcelRegister("9y7wC", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $adReO.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("3leq5", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("3PMHb", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $3PfpF = parcelRequire("3PfpF");

var $79n0f = parcelRequire("79n0f");

var $6nvAH = parcelRequire("6nvAH");

var $40T1q = parcelRequire("40T1q");

var $hMzvi = parcelRequire("hMzvi");

var $besJL = parcelRequire("besJL");

var $hHo9F = parcelRequire("hHo9F");

var $9X39E = parcelRequire("9X39E");

var $2W85d = parcelRequire("2W85d");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($adReO.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $40T1q(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $6nvAH(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $hMzvi(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $3PfpF(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($hHo9F('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($hHo9F('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $9X39E.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($hHo9F(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($adReO.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $besJL(fullPath)) && config.xsrfCookieName ? $79n0f.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $adReO.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$adReO.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $2W85d('canceled') : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("3PfpF", function(module, exports) {
'use strict';

var $hHo9F = parcelRequire("hHo9F");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($hHo9F('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("hHo9F", function(module, exports) {
'use strict';

var $3leq5 = parcelRequire("3leq5");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $3leq5(error, config, code, request, response);
};

});


parcelRegister("79n0f", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = $adReO.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($adReO.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($adReO.isString(path)) cookie.push('path=' + path);
            if ($adReO.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("40T1q", function(module, exports) {
'use strict';

var $1yk63 = parcelRequire("1yk63");

var $l45Ly = parcelRequire("l45Ly");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$1yk63(requestedURL)) return $l45Ly(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("1yk63", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("l45Ly", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("hMzvi", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $cf2275aca40d6d88$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $adReO.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $adReO.trim(line.substr(0, i)).toLowerCase();
        val = $adReO.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $cf2275aca40d6d88$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("besJL", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = $adReO.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $adReO.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("2W85d", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $223744b24e5d0b4c$var$Cancel(message) {
    this.message = message;
}
$223744b24e5d0b4c$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$223744b24e5d0b4c$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $223744b24e5d0b4c$var$Cancel;

});




parcelRegister("4IsRW", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("5f6d7", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($adReO.isPlainObject(target) && $adReO.isPlainObject(source)) return $adReO.merge(target, source);
        else if ($adReO.isPlainObject(source)) return $adReO.merge({}, source);
        else if ($adReO.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$adReO.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$adReO.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$adReO.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$adReO.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$adReO.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $adReO.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $adReO.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("2iR5D", function(module, exports) {
'use strict';

var $cR4ZD = parcelRequire("cR4ZD");
var $1ad671c27810423e$require$VERSION = $cR4ZD.version;
var $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $1ad671c27810423e$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};

});
parcelRegister("cR4ZD", function(module, exports) {
module.exports = {
    "version": "0.24.0"
};

});



parcelRegister("kZZD0", function(module, exports) {
'use strict';

var $2W85d = parcelRequire("2W85d");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $f4994f37c883aea2$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $2W85d(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $f4994f37c883aea2$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $f4994f37c883aea2$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $f4994f37c883aea2$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $f4994f37c883aea2$var$CancelToken.source = function source() {
    var cancel;
    var token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $f4994f37c883aea2$var$CancelToken;

});

parcelRegister("b676K", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("kgiwQ", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});


parcelRegister("asDSe", function(module, exports) {

var $ihqFb = parcelRequire("ihqFb");
module.exports = function(jwt, options) {
    options = options || {};
    var decoded = $ihqFb.decode(jwt, options);
    if (!decoded) return null;
    var payload = decoded.payload;
    //try parse the payload
    if (typeof payload === 'string') try {
        var obj = JSON.parse(payload);
        if (obj !== null && typeof obj === 'object') payload = obj;
    } catch (e) {}
    //return header if `complete` option is enabled.  header includes claims
    //such as `kid` and `alg` used to select the key within a JWKS needed to
    //verify the signature
    if (options.complete === true) return {
        header: decoded.header,
        payload: payload,
        signature: decoded.signature
    };
    return payload;
};

});
parcelRegister("ihqFb", function(module, exports) {

$parcel$export(module.exports, "sign", function () { return $d4ee7f4800ec4eba$export$c5552dfdbc7cec71; }, function (v) { return $d4ee7f4800ec4eba$export$c5552dfdbc7cec71 = v; });
$parcel$export(module.exports, "verify", function () { return $d4ee7f4800ec4eba$export$532244b5b8b0b4b6; }, function (v) { return $d4ee7f4800ec4eba$export$532244b5b8b0b4b6 = v; });
$parcel$export(module.exports, "decode", function () { return $d4ee7f4800ec4eba$export$2f872c0f2117be69; }, function (v) { return $d4ee7f4800ec4eba$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "createSign", function () { return $d4ee7f4800ec4eba$export$45df7cae684751af; }, function (v) { return $d4ee7f4800ec4eba$export$45df7cae684751af = v; });
/*global exports*/ var $d4ee7f4800ec4eba$export$6f6fa4628974a579;
var $d4ee7f4800ec4eba$export$c5552dfdbc7cec71;
var $d4ee7f4800ec4eba$export$532244b5b8b0b4b6;
var $d4ee7f4800ec4eba$export$2f872c0f2117be69;
var $d4ee7f4800ec4eba$export$1ea939691cdc45b8;
var $d4ee7f4800ec4eba$export$45df7cae684751af;
var $d4ee7f4800ec4eba$export$6f65485f87568e37;

var $9Z1dG = parcelRequire("9Z1dG");

var $cFKIK = parcelRequire("cFKIK");
var $d4ee7f4800ec4eba$var$ALGORITHMS = [
    'HS256',
    'HS384',
    'HS512',
    'RS256',
    'RS384',
    'RS512',
    'PS256',
    'PS384',
    'PS512',
    'ES256',
    'ES384',
    'ES512'
];
$d4ee7f4800ec4eba$export$6f6fa4628974a579 = $d4ee7f4800ec4eba$var$ALGORITHMS;
$d4ee7f4800ec4eba$export$c5552dfdbc7cec71 = $9Z1dG.sign;
$d4ee7f4800ec4eba$export$532244b5b8b0b4b6 = $cFKIK.verify;
$d4ee7f4800ec4eba$export$2f872c0f2117be69 = $cFKIK.decode;
$d4ee7f4800ec4eba$export$1ea939691cdc45b8 = $cFKIK.isValid;
$d4ee7f4800ec4eba$export$45df7cae684751af = function createSign(opts) {
    return new $9Z1dG(opts);
};
$d4ee7f4800ec4eba$export$6f65485f87568e37 = function createVerify(opts) {
    return new $cFKIK(opts);
};

});
parcelRegister("9Z1dG", function(module, exports) {
/*global module*/ 
var $838j1 = parcelRequire("838j1");
var $744ac1c582c082a8$require$Buffer = $838j1.Buffer;

var $2lgVM = parcelRequire("2lgVM");

var $gUhMZ = parcelRequire("gUhMZ");

var $3DkjE = parcelRequire("3DkjE");

var $q8HNf = parcelRequire("q8HNf");

var $5LV4O = parcelRequire("5LV4O");
function $744ac1c582c082a8$var$base64url(string, encoding) {
    return $744ac1c582c082a8$require$Buffer.from(string, encoding).toString('base64').replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $744ac1c582c082a8$var$jwsSecuredInput(header, payload, encoding) {
    encoding = encoding || 'utf8';
    var encodedHeader = $744ac1c582c082a8$var$base64url($q8HNf(header), 'binary');
    var encodedPayload = $744ac1c582c082a8$var$base64url($q8HNf(payload), encoding);
    return $5LV4O.format('%s.%s', encodedHeader, encodedPayload);
}
function $744ac1c582c082a8$var$jwsSign(opts) {
    var header = opts.header;
    var payload = opts.payload;
    var secretOrKey = opts.secret || opts.privateKey;
    var encoding = opts.encoding;
    var algo = $gUhMZ(header.alg);
    var securedInput = $744ac1c582c082a8$var$jwsSecuredInput(header, payload, encoding);
    var signature = algo.sign(securedInput, secretOrKey);
    return $5LV4O.format('%s.%s', securedInput, signature);
}
function $744ac1c582c082a8$var$SignStream(opts) {
    var secret = opts.secret || opts.privateKey || opts.key;
    var secretStream = new $2lgVM(secret);
    this.readable = true;
    this.header = opts.header;
    this.encoding = opts.encoding;
    this.secret = this.privateKey = this.key = secretStream;
    this.payload = new $2lgVM(opts.payload);
    this.secret.once('close', (function() {
        if (!this.payload.writable && this.readable) this.sign();
    }).bind(this));
    this.payload.once('close', (function() {
        if (!this.secret.writable && this.readable) this.sign();
    }).bind(this));
}
$5LV4O.inherits($744ac1c582c082a8$var$SignStream, $3DkjE);
$744ac1c582c082a8$var$SignStream.prototype.sign = function sign() {
    try {
        var signature = $744ac1c582c082a8$var$jwsSign({
            header: this.header,
            payload: this.payload.buffer,
            secret: this.secret.buffer,
            encoding: this.encoding
        });
        this.emit('done', signature);
        this.emit('data', signature);
        this.emit('end');
        this.readable = false;
        return signature;
    } catch (e) {
        this.readable = false;
        this.emit('error', e);
        this.emit('close');
    }
};
$744ac1c582c082a8$var$SignStream.sign = $744ac1c582c082a8$var$jwsSign;
module.exports = $744ac1c582c082a8$var$SignStream;

});
parcelRegister("838j1", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $5dc50be4850cea7a$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $5dc50be4850cea7a$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($5dc50be4850cea7a$var$Buffer.from && $5dc50be4850cea7a$var$Buffer.alloc && $5dc50be4850cea7a$var$Buffer.allocUnsafe && $5dc50be4850cea7a$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $5dc50be4850cea7a$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $5dc50be4850cea7a$var$SafeBuffer;
}
function $5dc50be4850cea7a$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $5dc50be4850cea7a$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$5dc50be4850cea7a$var$copyProps($5dc50be4850cea7a$var$Buffer, $5dc50be4850cea7a$var$SafeBuffer);
$5dc50be4850cea7a$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $5dc50be4850cea7a$var$Buffer(arg, encodingOrOffset, length);
};
$5dc50be4850cea7a$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $5dc50be4850cea7a$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$5dc50be4850cea7a$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $5dc50be4850cea7a$var$Buffer(size);
};
$5dc50be4850cea7a$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});
parcelRegister("bdjQ6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $82a04c4ec6982288$export$a143d493d941bafc; }, function (v) { return $82a04c4ec6982288$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $82a04c4ec6982288$export$e4cf37d7f6fb9e0a; }, function (v) { return $82a04c4ec6982288$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $82a04c4ec6982288$export$f99ded8fe4b79145; }, function (v) { return $82a04c4ec6982288$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $82a04c4ec6982288$export$599f31c3813fae4d; }, function (v) { return $82a04c4ec6982288$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82a04c4ec6982288$export$a143d493d941bafc;
var $82a04c4ec6982288$export$e4cf37d7f6fb9e0a;
var $82a04c4ec6982288$export$f99ded8fe4b79145;
var $82a04c4ec6982288$export$599f31c3813fae4d;
'use strict';

var $3nocJ = parcelRequire("3nocJ");

var $gU9iR = parcelRequire("gU9iR");
const $82a04c4ec6982288$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$82a04c4ec6982288$export$a143d493d941bafc = $82a04c4ec6982288$var$Buffer;
$82a04c4ec6982288$export$e4cf37d7f6fb9e0a = $82a04c4ec6982288$var$SlowBuffer;
$82a04c4ec6982288$export$f99ded8fe4b79145 = 50;
const $82a04c4ec6982288$var$K_MAX_LENGTH = 0x7fffffff;
$82a04c4ec6982288$export$599f31c3813fae4d = $82a04c4ec6982288$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT = $82a04c4ec6982288$var$typedArraySupport();
if (!$82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82a04c4ec6982288$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82a04c4ec6982288$var$createBuffer(length) {
    if (length > $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82a04c4ec6982288$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82a04c4ec6982288$var$allocUnsafe(arg);
    }
    return $82a04c4ec6982288$var$from(arg, encodingOrOffset, length);
}
$82a04c4ec6982288$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82a04c4ec6982288$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $82a04c4ec6982288$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82a04c4ec6982288$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82a04c4ec6982288$var$isInstance(value, ArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, ArrayBuffer)) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($82a04c4ec6982288$var$isInstance(value, SharedArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, SharedArrayBuffer))) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82a04c4ec6982288$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $82a04c4ec6982288$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $82a04c4ec6982288$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82a04c4ec6982288$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82a04c4ec6982288$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer, Uint8Array);
function $82a04c4ec6982288$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82a04c4ec6982288$var$alloc(size, fill, encoding) {
    $82a04c4ec6982288$var$assertSize(size);
    if (size <= 0) return $82a04c4ec6982288$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $82a04c4ec6982288$var$createBuffer(size).fill(fill, encoding) : $82a04c4ec6982288$var$createBuffer(size).fill(fill);
    return $82a04c4ec6982288$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82a04c4ec6982288$var$Buffer.alloc = function(size, fill, encoding) {
    return $82a04c4ec6982288$var$alloc(size, fill, encoding);
};
function $82a04c4ec6982288$var$allocUnsafe(size) {
    $82a04c4ec6982288$var$assertSize(size);
    return $82a04c4ec6982288$var$createBuffer(size < 0 ? 0 : $82a04c4ec6982288$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82a04c4ec6982288$var$Buffer.allocUnsafe = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82a04c4ec6982288$var$Buffer.allocUnsafeSlow = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
function $82a04c4ec6982288$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $82a04c4ec6982288$var$byteLength(string, encoding) | 0;
    let buf = $82a04c4ec6982288$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82a04c4ec6982288$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $82a04c4ec6982288$var$checked(array.length) | 0;
    const buf = $82a04c4ec6982288$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82a04c4ec6982288$var$fromArrayView(arrayView) {
    if ($82a04c4ec6982288$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $82a04c4ec6982288$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82a04c4ec6982288$var$fromArrayLike(arrayView);
}
function $82a04c4ec6982288$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
function $82a04c4ec6982288$var$fromObject(obj) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(obj)) {
        const len = $82a04c4ec6982288$var$checked(obj.length) | 0;
        const buf = $82a04c4ec6982288$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $82a04c4ec6982288$var$numberIsNaN(obj.length)) return $82a04c4ec6982288$var$createBuffer(0);
        return $82a04c4ec6982288$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $82a04c4ec6982288$var$fromArrayLike(obj.data);
}
function $82a04c4ec6982288$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82a04c4ec6982288$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $82a04c4ec6982288$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82a04c4ec6982288$var$Buffer.alloc(+length);
}
$82a04c4ec6982288$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82a04c4ec6982288$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82a04c4ec6982288$var$Buffer.compare = function compare(a, b) {
    if ($82a04c4ec6982288$var$isInstance(a, Uint8Array)) a = $82a04c4ec6982288$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82a04c4ec6982288$var$isInstance(b, Uint8Array)) b = $82a04c4ec6982288$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(a) || !$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82a04c4ec6982288$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$82a04c4ec6982288$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82a04c4ec6982288$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $82a04c4ec6982288$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($82a04c4ec6982288$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) buf = $82a04c4ec6982288$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82a04c4ec6982288$var$byteLength(string, encoding) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82a04c4ec6982288$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $82a04c4ec6982288$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82a04c4ec6982288$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82a04c4ec6982288$var$Buffer.byteLength = $82a04c4ec6982288$var$byteLength;
function $82a04c4ec6982288$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Slice(this, start, end);
        case 'ascii':
            return $82a04c4ec6982288$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$latin1Slice(this, start, end);
        case 'base64':
            return $82a04c4ec6982288$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82a04c4ec6982288$var$Buffer.prototype._isBuffer = true;
function $82a04c4ec6982288$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82a04c4ec6982288$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$82a04c4ec6982288$var$swap(this, i, i + 1);
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $82a04c4ec6982288$var$swap(this, i, i + 3);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $82a04c4ec6982288$var$swap(this, i, i + 7);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 6);
        $82a04c4ec6982288$var$swap(this, i + 2, i + 5);
        $82a04c4ec6982288$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $82a04c4ec6982288$var$utf8Slice(this, 0, length);
    return $82a04c4ec6982288$var$slowToString.apply(this, arguments);
};
$82a04c4ec6982288$var$Buffer.prototype.toLocaleString = $82a04c4ec6982288$var$Buffer.prototype.toString;
$82a04c4ec6982288$var$Buffer.prototype.equals = function equals(b) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $82a04c4ec6982288$var$Buffer.compare(this, b) === 0;
};
$82a04c4ec6982288$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $82a04c4ec6982288$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($82a04c4ec6982288$var$customInspectSymbol) $82a04c4ec6982288$var$Buffer.prototype[$82a04c4ec6982288$var$customInspectSymbol] = $82a04c4ec6982288$var$Buffer.prototype.inspect;
$82a04c4ec6982288$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82a04c4ec6982288$var$isInstance(target, Uint8Array)) target = $82a04c4ec6982288$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82a04c4ec6982288$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82a04c4ec6982288$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $82a04c4ec6982288$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82a04c4ec6982288$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $82a04c4ec6982288$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82a04c4ec6982288$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82a04c4ec6982288$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82a04c4ec6982288$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82a04c4ec6982288$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82a04c4ec6982288$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82a04c4ec6982288$var$utf8Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82a04c4ec6982288$var$asciiWrite(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$asciiToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$base64Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$base64ToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$ucs2Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82a04c4ec6982288$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $82a04c4ec6982288$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82a04c4ec6982288$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82a04c4ec6982288$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3nocJ.fromByteArray(buf);
    else return $3nocJ.fromByteArray(buf.slice(start, end));
}
function $82a04c4ec6982288$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82a04c4ec6982288$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82a04c4ec6982288$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82a04c4ec6982288$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82a04c4ec6982288$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82a04c4ec6982288$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $82a04c4ec6982288$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82a04c4ec6982288$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82a04c4ec6982288$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82a04c4ec6982288$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82a04c4ec6982288$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$82a04c4ec6982288$var$Buffer.prototype.readUintLE = $82a04c4ec6982288$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUintBE = $82a04c4ec6982288$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint8 = $82a04c4ec6982288$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$82a04c4ec6982288$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$82a04c4ec6982288$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, true, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, false, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, true, 52, 8);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, false, 52, 8);
};
function $82a04c4ec6982288$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$82a04c4ec6982288$var$Buffer.prototype.writeUintLE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUintBE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint8 = $82a04c4ec6982288$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82a04c4ec6982288$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $82a04c4ec6982288$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $82a04c4ec6982288$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82a04c4ec6982288$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, false, noAssert);
};
function $82a04c4ec6982288$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82a04c4ec6982288$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82a04c4ec6982288$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $82a04c4ec6982288$var$Buffer.isBuffer(val) ? val : $82a04c4ec6982288$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $82a04c4ec6982288$var$errors = {};
function $82a04c4ec6982288$var$E(sym, getMessage, Base) {
    $82a04c4ec6982288$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$82a04c4ec6982288$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$82a04c4ec6982288$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$82a04c4ec6982288$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $82a04c4ec6982288$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $82a04c4ec6982288$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $82a04c4ec6982288$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength) {
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $82a04c4ec6982288$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength);
}
function $82a04c4ec6982288$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $82a04c4ec6982288$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $82a04c4ec6982288$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $82a04c4ec6982288$var$validateNumber(value, type);
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $82a04c4ec6982288$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $82a04c4ec6982288$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82a04c4ec6982288$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82a04c4ec6982288$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $82a04c4ec6982288$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $82a04c4ec6982288$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82a04c4ec6982288$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82a04c4ec6982288$var$base64ToBytes(str) {
    return $3nocJ.toByteArray($82a04c4ec6982288$var$base64clean(str));
}
function $82a04c4ec6982288$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82a04c4ec6982288$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82a04c4ec6982288$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $82a04c4ec6982288$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $82a04c4ec6982288$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $82a04c4ec6982288$var$BufferBigIntNotDefined : fn;
}
function $82a04c4ec6982288$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("3nocJ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $27564b8a0078aa3d$export$d622b2ad8d90c771; }, function (v) { return $27564b8a0078aa3d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $27564b8a0078aa3d$export$6100ba28696e12de; }, function (v) { return $27564b8a0078aa3d$export$6100ba28696e12de = v; });
var $27564b8a0078aa3d$export$a48f0734ac7c2329;
var $27564b8a0078aa3d$export$d622b2ad8d90c771;
var $27564b8a0078aa3d$export$6100ba28696e12de;
'use strict';
$27564b8a0078aa3d$export$a48f0734ac7c2329 = $27564b8a0078aa3d$var$byteLength;
$27564b8a0078aa3d$export$d622b2ad8d90c771 = $27564b8a0078aa3d$var$toByteArray;
$27564b8a0078aa3d$export$6100ba28696e12de = $27564b8a0078aa3d$var$fromByteArray;
var $27564b8a0078aa3d$var$lookup = [];
var $27564b8a0078aa3d$var$revLookup = [];
var $27564b8a0078aa3d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $27564b8a0078aa3d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $27564b8a0078aa3d$var$i = 0, $27564b8a0078aa3d$var$len = $27564b8a0078aa3d$var$code.length; $27564b8a0078aa3d$var$i < $27564b8a0078aa3d$var$len; ++$27564b8a0078aa3d$var$i){
    $27564b8a0078aa3d$var$lookup[$27564b8a0078aa3d$var$i] = $27564b8a0078aa3d$var$code[$27564b8a0078aa3d$var$i];
    $27564b8a0078aa3d$var$revLookup[$27564b8a0078aa3d$var$code.charCodeAt($27564b8a0078aa3d$var$i)] = $27564b8a0078aa3d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$27564b8a0078aa3d$var$revLookup['-'.charCodeAt(0)] = 62;
$27564b8a0078aa3d$var$revLookup['_'.charCodeAt(0)] = 63;
function $27564b8a0078aa3d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $27564b8a0078aa3d$var$byteLength(b64) {
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$toByteArray(b64) {
    var tmp;
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $27564b8a0078aa3d$var$Arr($27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 18 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 2 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 10 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $27564b8a0078aa3d$var$tripletToBase64(num) {
    return $27564b8a0078aa3d$var$lookup[num >> 18 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 12 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 6 & 0x3F] + $27564b8a0078aa3d$var$lookup[num & 0x3F];
}
function $27564b8a0078aa3d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($27564b8a0078aa3d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $27564b8a0078aa3d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($27564b8a0078aa3d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 2] + $27564b8a0078aa3d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 10] + $27564b8a0078aa3d$var$lookup[tmp >> 4 & 0x3F] + $27564b8a0078aa3d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("gU9iR", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $c4e917b4c37bfab7$export$aafa59e2e03f2942; }, function (v) { return $c4e917b4c37bfab7$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $c4e917b4c37bfab7$export$68d8715fc104d294; }, function (v) { return $c4e917b4c37bfab7$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c4e917b4c37bfab7$export$aafa59e2e03f2942;
var $c4e917b4c37bfab7$export$68d8715fc104d294;
$c4e917b4c37bfab7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c4e917b4c37bfab7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("2lgVM", function(module, exports) {
/*global module, process*/ 
var $4ZL0H = parcelRequire("4ZL0H");

var $838j1 = parcelRequire("838j1");
var $1b4aad135d3f35c1$require$Buffer = $838j1.Buffer;

var $3DkjE = parcelRequire("3DkjE");

var $5LV4O = parcelRequire("5LV4O");
function $1b4aad135d3f35c1$var$DataStream(data) {
    this.buffer = null;
    this.writable = true;
    this.readable = true;
    // No input
    if (!data) {
        this.buffer = $1b4aad135d3f35c1$require$Buffer.alloc(0);
        return this;
    }
    // Stream
    if (typeof data.pipe === 'function') {
        this.buffer = $1b4aad135d3f35c1$require$Buffer.alloc(0);
        data.pipe(this);
        return this;
    }
    // Buffer or String
    // or Object (assumedly a passworded key)
    if (data.length || typeof data === 'object') {
        this.buffer = data;
        this.writable = false;
        $4ZL0H.nextTick((function() {
            this.emit('end', data);
            this.readable = false;
            this.emit('close');
        }).bind(this));
        return this;
    }
    throw new TypeError('Unexpected data type (' + typeof data + ')');
}
$5LV4O.inherits($1b4aad135d3f35c1$var$DataStream, $3DkjE);
$1b4aad135d3f35c1$var$DataStream.prototype.write = function write(data) {
    this.buffer = $1b4aad135d3f35c1$require$Buffer.concat([
        this.buffer,
        $1b4aad135d3f35c1$require$Buffer.from(data)
    ]);
    this.emit('data', data);
};
$1b4aad135d3f35c1$var$DataStream.prototype.end = function end(data) {
    if (data) this.write(data);
    this.emit('end', data);
    this.emit('close');
    this.writable = false;
    this.readable = false;
};
module.exports = $1b4aad135d3f35c1$var$DataStream;

});
parcelRegister("4ZL0H", function(module, exports) {
// shim for using process in browser
var $3a3153321729209f$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3a3153321729209f$var$cachedSetTimeout;
var $3a3153321729209f$var$cachedClearTimeout;
function $3a3153321729209f$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3a3153321729209f$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        else $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    } catch (e) {
        $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        else $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    } catch (e) {
        $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    }
})();
function $3a3153321729209f$var$runTimeout(fun) {
    if ($3a3153321729209f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedSetTimeout === $3a3153321729209f$var$defaultSetTimout || !$3a3153321729209f$var$cachedSetTimeout) && setTimeout) {
        $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3a3153321729209f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3a3153321729209f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3a3153321729209f$var$runClearTimeout(marker) {
    if ($3a3153321729209f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedClearTimeout === $3a3153321729209f$var$defaultClearTimeout || !$3a3153321729209f$var$cachedClearTimeout) && clearTimeout) {
        $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3a3153321729209f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3a3153321729209f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3a3153321729209f$var$queue = [];
var $3a3153321729209f$var$draining = false;
var $3a3153321729209f$var$currentQueue;
var $3a3153321729209f$var$queueIndex = -1;
function $3a3153321729209f$var$cleanUpNextTick() {
    if (!$3a3153321729209f$var$draining || !$3a3153321729209f$var$currentQueue) return;
    $3a3153321729209f$var$draining = false;
    if ($3a3153321729209f$var$currentQueue.length) $3a3153321729209f$var$queue = $3a3153321729209f$var$currentQueue.concat($3a3153321729209f$var$queue);
    else $3a3153321729209f$var$queueIndex = -1;
    if ($3a3153321729209f$var$queue.length) $3a3153321729209f$var$drainQueue();
}
function $3a3153321729209f$var$drainQueue() {
    if ($3a3153321729209f$var$draining) return;
    var timeout = $3a3153321729209f$var$runTimeout($3a3153321729209f$var$cleanUpNextTick);
    $3a3153321729209f$var$draining = true;
    var len = $3a3153321729209f$var$queue.length;
    while(len){
        $3a3153321729209f$var$currentQueue = $3a3153321729209f$var$queue;
        $3a3153321729209f$var$queue = [];
        while(++$3a3153321729209f$var$queueIndex < len)if ($3a3153321729209f$var$currentQueue) $3a3153321729209f$var$currentQueue[$3a3153321729209f$var$queueIndex].run();
        $3a3153321729209f$var$queueIndex = -1;
        len = $3a3153321729209f$var$queue.length;
    }
    $3a3153321729209f$var$currentQueue = null;
    $3a3153321729209f$var$draining = false;
    $3a3153321729209f$var$runClearTimeout(timeout);
}
$3a3153321729209f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3a3153321729209f$var$queue.push(new $3a3153321729209f$var$Item(fun, args));
    if ($3a3153321729209f$var$queue.length === 1 && !$3a3153321729209f$var$draining) $3a3153321729209f$var$runTimeout($3a3153321729209f$var$drainQueue);
};
// v8 likes predictible objects
function $3a3153321729209f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3a3153321729209f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3a3153321729209f$var$process.title = 'browser';
$3a3153321729209f$var$process.browser = true;
$3a3153321729209f$var$process.env = {};
$3a3153321729209f$var$process.argv = [];
$3a3153321729209f$var$process.version = ''; // empty string to avoid regexp issues
$3a3153321729209f$var$process.versions = {};
function $3a3153321729209f$var$noop() {}
$3a3153321729209f$var$process.on = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.addListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.once = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.off = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeAllListeners = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.emit = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependOnceListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.listeners = function(name) {
    return [];
};
$3a3153321729209f$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$3a3153321729209f$var$process.cwd = function() {
    return '/';
};
$3a3153321729209f$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$3a3153321729209f$var$process.umask = function() {
    return 0;
};

});

parcelRegister("3DkjE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $2a54c5edd7835136$var$Stream;

var $fzCxw = parcelRequire("fzCxw");
var $2a54c5edd7835136$require$EE = $fzCxw.EventEmitter;

var $dhT4G = parcelRequire("dhT4G");
$dhT4G($2a54c5edd7835136$var$Stream, $2a54c5edd7835136$require$EE);

$2a54c5edd7835136$var$Stream.Readable = (parcelRequire("g4ZW2"));

$2a54c5edd7835136$var$Stream.Writable = (parcelRequire("g6cJS"));

$2a54c5edd7835136$var$Stream.Duplex = (parcelRequire("hxbeF"));

$2a54c5edd7835136$var$Stream.Transform = (parcelRequire("k0KBi"));

$2a54c5edd7835136$var$Stream.PassThrough = (parcelRequire("jYFEV"));

$2a54c5edd7835136$var$Stream.finished = (parcelRequire("b6CHN"));

$2a54c5edd7835136$var$Stream.pipeline = (parcelRequire("gPAeR"));
// Backwards-compat with node 0.4.x
$2a54c5edd7835136$var$Stream.Stream = $2a54c5edd7835136$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $2a54c5edd7835136$var$Stream() {
    $2a54c5edd7835136$require$EE.call(this);
}
$2a54c5edd7835136$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($2a54c5edd7835136$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("fzCxw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $b5680518dd48c196$var$R = typeof Reflect === 'object' ? Reflect : null;
var $b5680518dd48c196$var$ReflectApply = $b5680518dd48c196$var$R && typeof $b5680518dd48c196$var$R.apply === 'function' ? $b5680518dd48c196$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $b5680518dd48c196$var$ReflectOwnKeys;
if ($b5680518dd48c196$var$R && typeof $b5680518dd48c196$var$R.ownKeys === 'function') $b5680518dd48c196$var$ReflectOwnKeys = $b5680518dd48c196$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $b5680518dd48c196$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $b5680518dd48c196$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $b5680518dd48c196$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $b5680518dd48c196$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $b5680518dd48c196$var$EventEmitter() {
    $b5680518dd48c196$var$EventEmitter.init.call(this);
}
module.exports = $b5680518dd48c196$var$EventEmitter;
module.exports.once = $b5680518dd48c196$var$once;
// Backwards-compat with node 0.10.x
$b5680518dd48c196$var$EventEmitter.EventEmitter = $b5680518dd48c196$var$EventEmitter;
$b5680518dd48c196$var$EventEmitter.prototype._events = undefined;
$b5680518dd48c196$var$EventEmitter.prototype._eventsCount = 0;
$b5680518dd48c196$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $b5680518dd48c196$var$defaultMaxListeners = 10;
function $b5680518dd48c196$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($b5680518dd48c196$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $b5680518dd48c196$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $b5680518dd48c196$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $b5680518dd48c196$var$defaultMaxListeners = arg;
    }
});
$b5680518dd48c196$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$b5680518dd48c196$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $b5680518dd48c196$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $b5680518dd48c196$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $b5680518dd48c196$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$b5680518dd48c196$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $b5680518dd48c196$var$_getMaxListeners(this);
};
$b5680518dd48c196$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $b5680518dd48c196$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $b5680518dd48c196$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$b5680518dd48c196$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $b5680518dd48c196$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $b5680518dd48c196$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $b5680518dd48c196$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $b5680518dd48c196$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$b5680518dd48c196$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $b5680518dd48c196$var$_addListener(this, type, listener, false);
};
$b5680518dd48c196$var$EventEmitter.prototype.on = $b5680518dd48c196$var$EventEmitter.prototype.addListener;
$b5680518dd48c196$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $b5680518dd48c196$var$_addListener(this, type, listener, true);
};
function $b5680518dd48c196$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $b5680518dd48c196$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $b5680518dd48c196$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$b5680518dd48c196$var$EventEmitter.prototype.once = function once(type, listener) {
    $b5680518dd48c196$var$checkListener(listener);
    this.on(type, $b5680518dd48c196$var$_onceWrap(this, type, listener));
    return this;
};
$b5680518dd48c196$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $b5680518dd48c196$var$checkListener(listener);
    this.prependListener(type, $b5680518dd48c196$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$b5680518dd48c196$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $b5680518dd48c196$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $b5680518dd48c196$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$b5680518dd48c196$var$EventEmitter.prototype.off = $b5680518dd48c196$var$EventEmitter.prototype.removeListener;
$b5680518dd48c196$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $b5680518dd48c196$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $b5680518dd48c196$var$unwrapListeners(evlistener) : $b5680518dd48c196$var$arrayClone(evlistener, evlistener.length);
}
$b5680518dd48c196$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $b5680518dd48c196$var$_listeners(this, type, true);
};
$b5680518dd48c196$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $b5680518dd48c196$var$_listeners(this, type, false);
};
$b5680518dd48c196$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $b5680518dd48c196$var$listenerCount.call(emitter, type);
};
$b5680518dd48c196$var$EventEmitter.prototype.listenerCount = $b5680518dd48c196$var$listenerCount;
function $b5680518dd48c196$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$b5680518dd48c196$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $b5680518dd48c196$var$ReflectOwnKeys(this._events) : [];
};
function $b5680518dd48c196$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $b5680518dd48c196$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $b5680518dd48c196$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $b5680518dd48c196$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $b5680518dd48c196$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $b5680518dd48c196$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("dhT4G", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("g4ZW2", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
module.exports = $bb4d100ed8009141$var$Readable;
/*<replacement>*/ var $bb4d100ed8009141$var$Duplex;
/*</replacement>*/ $bb4d100ed8009141$var$Readable.ReadableState = $bb4d100ed8009141$var$ReadableState;

var $fzCxw = parcelRequire("fzCxw");
var $bb4d100ed8009141$require$EE = $fzCxw.EventEmitter;
var $bb4d100ed8009141$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $bSqQK = parcelRequire("bSqQK");

var $bdjQ6 = parcelRequire("bdjQ6");
var $bb4d100ed8009141$require$Buffer = $bdjQ6.Buffer;
var $bb4d100ed8009141$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $bb4d100ed8009141$var$_uint8ArrayToBuffer(chunk) {
    return $bb4d100ed8009141$require$Buffer.from(chunk);
}
function $bb4d100ed8009141$var$_isUint8Array(obj) {
    return $bb4d100ed8009141$require$Buffer.isBuffer(obj) || obj instanceof $bb4d100ed8009141$var$OurUint8Array;
}

var $ifbub = parcelRequire("ifbub");
var $bb4d100ed8009141$var$debug;
if ($ifbub && $ifbub.debuglog) $bb4d100ed8009141$var$debug = $ifbub.debuglog('stream');
else $bb4d100ed8009141$var$debug = function debug() {};

var $9sE5l = parcelRequire("9sE5l");

var $ktkM5 = parcelRequire("ktkM5");

var $feK8s = parcelRequire("feK8s");
var $bb4d100ed8009141$var$getHighWaterMark = $feK8s.getHighWaterMark;

var $h2o3J = parcelRequire("h2o3J");
var $bb4d100ed8009141$require$_require$codes = $h2o3J.codes;
var $bb4d100ed8009141$var$ERR_INVALID_ARG_TYPE = $bb4d100ed8009141$require$_require$codes.ERR_INVALID_ARG_TYPE, $bb4d100ed8009141$var$ERR_STREAM_PUSH_AFTER_EOF = $bb4d100ed8009141$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $bb4d100ed8009141$var$ERR_METHOD_NOT_IMPLEMENTED = $bb4d100ed8009141$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $bb4d100ed8009141$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $bb4d100ed8009141$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $bb4d100ed8009141$var$StringDecoder;
var $bb4d100ed8009141$var$createReadableStreamAsyncIterator;
var $bb4d100ed8009141$var$from;

(parcelRequire("dhT4G"))($bb4d100ed8009141$var$Readable, $bSqQK);
var $bb4d100ed8009141$var$errorOrDestroy = $ktkM5.errorOrDestroy;
var $bb4d100ed8009141$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $bb4d100ed8009141$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $bb4d100ed8009141$var$ReadableState(options, stream, isDuplex) {
    $bb4d100ed8009141$var$Duplex = $bb4d100ed8009141$var$Duplex || (parcelRequire("hxbeF"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $bb4d100ed8009141$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $bb4d100ed8009141$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $9sE5l();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$bb4d100ed8009141$var$StringDecoder) $bb4d100ed8009141$var$StringDecoder = (parcelRequire("iGJyf")).StringDecoder;
        this.decoder = new $bb4d100ed8009141$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $bb4d100ed8009141$var$Readable(options) {
    $bb4d100ed8009141$var$Duplex = $bb4d100ed8009141$var$Duplex || (parcelRequire("hxbeF"));
    if (!(this instanceof $bb4d100ed8009141$var$Readable)) return new $bb4d100ed8009141$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $bb4d100ed8009141$var$Duplex;
    this._readableState = new $bb4d100ed8009141$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $bSqQK.call(this);
}
Object.defineProperty($bb4d100ed8009141$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$bb4d100ed8009141$var$Readable.prototype.destroy = $ktkM5.destroy;
$bb4d100ed8009141$var$Readable.prototype._undestroy = $ktkM5.undestroy;
$bb4d100ed8009141$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$bb4d100ed8009141$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $bb4d100ed8009141$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $bb4d100ed8009141$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$bb4d100ed8009141$var$Readable.prototype.unshift = function(chunk) {
    return $bb4d100ed8009141$var$readableAddChunk(this, chunk, null, true, false);
};
function $bb4d100ed8009141$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $bb4d100ed8009141$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $bb4d100ed8009141$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $bb4d100ed8009141$var$chunkInvalid(state, chunk);
        if (er) $bb4d100ed8009141$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $bb4d100ed8009141$require$Buffer.prototype) chunk = $bb4d100ed8009141$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $bb4d100ed8009141$var$errorOrDestroy(stream, new $bb4d100ed8009141$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $bb4d100ed8009141$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $bb4d100ed8009141$var$errorOrDestroy(stream, new $bb4d100ed8009141$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $bb4d100ed8009141$var$addChunk(stream, state, chunk, false);
                    else $bb4d100ed8009141$var$maybeReadMore(stream, state);
                } else $bb4d100ed8009141$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $bb4d100ed8009141$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $bb4d100ed8009141$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $bb4d100ed8009141$var$emitReadable(stream);
    }
    $bb4d100ed8009141$var$maybeReadMore(stream, state);
}
function $bb4d100ed8009141$var$chunkInvalid(state, chunk) {
    var er;
    if (!$bb4d100ed8009141$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $bb4d100ed8009141$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$bb4d100ed8009141$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$bb4d100ed8009141$var$Readable.prototype.setEncoding = function(enc) {
    if (!$bb4d100ed8009141$var$StringDecoder) $bb4d100ed8009141$var$StringDecoder = (parcelRequire("iGJyf")).StringDecoder;
    var decoder = new $bb4d100ed8009141$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $bb4d100ed8009141$var$MAX_HWM = 0x40000000;
function $bb4d100ed8009141$var$computeNewHighWaterMark(n) {
    if (n >= $bb4d100ed8009141$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $bb4d100ed8009141$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bb4d100ed8009141$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $bb4d100ed8009141$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$bb4d100ed8009141$var$Readable.prototype.read = function(n) {
    $bb4d100ed8009141$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $bb4d100ed8009141$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $bb4d100ed8009141$var$endReadable(this);
        else $bb4d100ed8009141$var$emitReadable(this);
        return null;
    }
    n = $bb4d100ed8009141$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $bb4d100ed8009141$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $bb4d100ed8009141$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $bb4d100ed8009141$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $bb4d100ed8009141$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $bb4d100ed8009141$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $bb4d100ed8009141$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $bb4d100ed8009141$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $bb4d100ed8009141$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $bb4d100ed8009141$var$onEofChunk(stream, state) {
    $bb4d100ed8009141$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $bb4d100ed8009141$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $bb4d100ed8009141$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $bb4d100ed8009141$var$emitReadable(stream) {
    var state = stream._readableState;
    $bb4d100ed8009141$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $bb4d100ed8009141$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $4ZL0H.nextTick($bb4d100ed8009141$var$emitReadable_, stream);
    }
}
function $bb4d100ed8009141$var$emitReadable_(stream) {
    var state = stream._readableState;
    $bb4d100ed8009141$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $bb4d100ed8009141$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $bb4d100ed8009141$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4ZL0H.nextTick($bb4d100ed8009141$var$maybeReadMore_, stream, state);
    }
}
function $bb4d100ed8009141$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $bb4d100ed8009141$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$bb4d100ed8009141$var$Readable.prototype._read = function(n) {
    $bb4d100ed8009141$var$errorOrDestroy(this, new $bb4d100ed8009141$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$bb4d100ed8009141$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $bb4d100ed8009141$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4ZL0H.stdout && dest !== $4ZL0H.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4ZL0H.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $bb4d100ed8009141$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $bb4d100ed8009141$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $bb4d100ed8009141$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $bb4d100ed8009141$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $bb4d100ed8009141$var$debug('ondata');
        var ret = dest.write(chunk);
        $bb4d100ed8009141$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $bb4d100ed8009141$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $bb4d100ed8009141$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $bb4d100ed8009141$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($bb4d100ed8009141$var$EElistenerCount(dest, 'error') === 0) $bb4d100ed8009141$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $bb4d100ed8009141$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $bb4d100ed8009141$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $bb4d100ed8009141$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $bb4d100ed8009141$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $bb4d100ed8009141$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $bb4d100ed8009141$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $bb4d100ed8009141$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $bb4d100ed8009141$var$flow(src);
        }
    };
}
$bb4d100ed8009141$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $bb4d100ed8009141$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$bb4d100ed8009141$var$Readable.prototype.on = function(ev, fn) {
    var res = $bSqQK.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $bb4d100ed8009141$var$debug('on readable', state.length, state.reading);
            if (state.length) $bb4d100ed8009141$var$emitReadable(this);
            else if (!state.reading) $4ZL0H.nextTick($bb4d100ed8009141$var$nReadingNextTick, this);
        }
    }
    return res;
};
$bb4d100ed8009141$var$Readable.prototype.addListener = $bb4d100ed8009141$var$Readable.prototype.on;
$bb4d100ed8009141$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $bSqQK.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4ZL0H.nextTick($bb4d100ed8009141$var$updateReadableListening, this);
    return res;
};
$bb4d100ed8009141$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $bSqQK.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4ZL0H.nextTick($bb4d100ed8009141$var$updateReadableListening, this);
    return res;
};
function $bb4d100ed8009141$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $bb4d100ed8009141$var$nReadingNextTick(self1) {
    $bb4d100ed8009141$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$bb4d100ed8009141$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $bb4d100ed8009141$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $bb4d100ed8009141$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $bb4d100ed8009141$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4ZL0H.nextTick($bb4d100ed8009141$var$resume_, stream, state);
    }
}
function $bb4d100ed8009141$var$resume_(stream, state) {
    $bb4d100ed8009141$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $bb4d100ed8009141$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$bb4d100ed8009141$var$Readable.prototype.pause = function() {
    $bb4d100ed8009141$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $bb4d100ed8009141$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $bb4d100ed8009141$var$flow(stream) {
    var state = stream._readableState;
    $bb4d100ed8009141$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$bb4d100ed8009141$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $bb4d100ed8009141$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $bb4d100ed8009141$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $bb4d100ed8009141$var$kProxyEvents.length; n++)stream.on($bb4d100ed8009141$var$kProxyEvents[n], this.emit.bind(this, $bb4d100ed8009141$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $bb4d100ed8009141$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $bb4d100ed8009141$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($bb4d100ed8009141$var$createReadableStreamAsyncIterator === undefined) $bb4d100ed8009141$var$createReadableStreamAsyncIterator = (parcelRequire("iO1WB"));
    return $bb4d100ed8009141$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($bb4d100ed8009141$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($bb4d100ed8009141$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($bb4d100ed8009141$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$bb4d100ed8009141$var$Readable._fromList = $bb4d100ed8009141$var$fromList;
Object.defineProperty($bb4d100ed8009141$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bb4d100ed8009141$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $bb4d100ed8009141$var$endReadable(stream) {
    var state = stream._readableState;
    $bb4d100ed8009141$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4ZL0H.nextTick($bb4d100ed8009141$var$endReadableNT, state, stream);
    }
}
function $bb4d100ed8009141$var$endReadableNT(state, stream) {
    $bb4d100ed8009141$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $bb4d100ed8009141$var$Readable.from = function(iterable, opts) {
    if ($bb4d100ed8009141$var$from === undefined) $bb4d100ed8009141$var$from = (parcelRequire("bcqRj"));
    return $bb4d100ed8009141$var$from($bb4d100ed8009141$var$Readable, iterable, opts);
};
function $bb4d100ed8009141$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("bSqQK", function(module, exports) {

module.exports = (parcelRequire("fzCxw")).EventEmitter;

});

parcelRegister("ifbub", function(module, exports) {
"use strict";

});

parcelRegister("9sE5l", function(module, exports) {
'use strict';
function $6e35d2b0bb5f897e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6e35d2b0bb5f897e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6e35d2b0bb5f897e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6e35d2b0bb5f897e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6e35d2b0bb5f897e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6e35d2b0bb5f897e$var$_defineProperty(obj, key, value) {
    key = $6e35d2b0bb5f897e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6e35d2b0bb5f897e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6e35d2b0bb5f897e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6e35d2b0bb5f897e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6e35d2b0bb5f897e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6e35d2b0bb5f897e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6e35d2b0bb5f897e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6e35d2b0bb5f897e$var$_toPropertyKey(arg) {
    var key = $6e35d2b0bb5f897e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $6e35d2b0bb5f897e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $bdjQ6 = parcelRequire("bdjQ6");
var $6e35d2b0bb5f897e$var$Buffer = $bdjQ6.Buffer;

var $ifbub = parcelRequire("ifbub");
var $6e35d2b0bb5f897e$var$inspect = $ifbub.inspect;
var $6e35d2b0bb5f897e$var$custom = $6e35d2b0bb5f897e$var$inspect && $6e35d2b0bb5f897e$var$inspect.custom || 'inspect';
function $6e35d2b0bb5f897e$var$copyBuffer(src, target, offset) {
    $6e35d2b0bb5f897e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $6e35d2b0bb5f897e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $6e35d2b0bb5f897e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $6e35d2b0bb5f897e$var$Buffer.alloc(0);
                var ret = $6e35d2b0bb5f897e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $6e35d2b0bb5f897e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $6e35d2b0bb5f897e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $6e35d2b0bb5f897e$var$custom,
            value: function value(_, options) {
                return $6e35d2b0bb5f897e$var$inspect(this, $6e35d2b0bb5f897e$var$_objectSpread($6e35d2b0bb5f897e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("ktkM5", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $ee76a179a649e840$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4ZL0H.nextTick($ee76a179a649e840$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4ZL0H.nextTick($ee76a179a649e840$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4ZL0H.nextTick($ee76a179a649e840$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4ZL0H.nextTick($ee76a179a649e840$var$emitErrorAndCloseNT, _this, err);
            } else $4ZL0H.nextTick($ee76a179a649e840$var$emitCloseNT, _this);
        } else if (cb) {
            $4ZL0H.nextTick($ee76a179a649e840$var$emitCloseNT, _this);
            cb(err);
        } else $4ZL0H.nextTick($ee76a179a649e840$var$emitCloseNT, _this);
    });
    return this;
}
function $ee76a179a649e840$var$emitErrorAndCloseNT(self, err) {
    $ee76a179a649e840$var$emitErrorNT(self, err);
    $ee76a179a649e840$var$emitCloseNT(self);
}
function $ee76a179a649e840$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $ee76a179a649e840$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $ee76a179a649e840$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $ee76a179a649e840$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $ee76a179a649e840$var$destroy,
    undestroy: $ee76a179a649e840$var$undestroy,
    errorOrDestroy: $ee76a179a649e840$var$errorOrDestroy
};

});

parcelRegister("feK8s", function(module, exports) {
'use strict';

var $b17bf35c1afd9061$var$ERR_INVALID_OPT_VALUE = (parcelRequire("h2o3J")).codes.ERR_INVALID_OPT_VALUE;
function $b17bf35c1afd9061$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $b17bf35c1afd9061$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $b17bf35c1afd9061$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $b17bf35c1afd9061$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $b17bf35c1afd9061$var$getHighWaterMark
};

});
parcelRegister("h2o3J", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $c675493ebf8be1e5$export$e45cb6485273080e; }, function (v) { return $c675493ebf8be1e5$export$e45cb6485273080e = v; });
var $c675493ebf8be1e5$export$e45cb6485273080e;
'use strict';
function $c675493ebf8be1e5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $c675493ebf8be1e5$var$codes = {};
function $c675493ebf8be1e5$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $c675493ebf8be1e5$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $c675493ebf8be1e5$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $c675493ebf8be1e5$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $c675493ebf8be1e5$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $c675493ebf8be1e5$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $c675493ebf8be1e5$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$c675493ebf8be1e5$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$c675493ebf8be1e5$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $c675493ebf8be1e5$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($c675493ebf8be1e5$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($c675493ebf8be1e5$var$oneOf(expected, 'type'));
    else {
        var type = $c675493ebf8be1e5$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($c675493ebf8be1e5$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$c675493ebf8be1e5$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$c675493ebf8be1e5$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$c675493ebf8be1e5$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$c675493ebf8be1e5$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$c675493ebf8be1e5$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$c675493ebf8be1e5$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$c675493ebf8be1e5$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$c675493ebf8be1e5$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$c675493ebf8be1e5$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$c675493ebf8be1e5$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$c675493ebf8be1e5$export$e45cb6485273080e = $c675493ebf8be1e5$var$codes;

});


parcelRegister("hxbeF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
/*<replacement>*/ var $cc3e3be8c0373de4$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $cc3e3be8c0373de4$var$Duplex;

var $g4ZW2 = parcelRequire("g4ZW2");

var $g6cJS = parcelRequire("g6cJS");

(parcelRequire("dhT4G"))($cc3e3be8c0373de4$var$Duplex, $g4ZW2);
// Allow the keys array to be GC'ed.
var $cc3e3be8c0373de4$var$keys = $cc3e3be8c0373de4$var$objectKeys($g6cJS.prototype);
for(var $cc3e3be8c0373de4$var$v = 0; $cc3e3be8c0373de4$var$v < $cc3e3be8c0373de4$var$keys.length; $cc3e3be8c0373de4$var$v++){
    var $cc3e3be8c0373de4$var$method = $cc3e3be8c0373de4$var$keys[$cc3e3be8c0373de4$var$v];
    if (!$cc3e3be8c0373de4$var$Duplex.prototype[$cc3e3be8c0373de4$var$method]) $cc3e3be8c0373de4$var$Duplex.prototype[$cc3e3be8c0373de4$var$method] = $g6cJS.prototype[$cc3e3be8c0373de4$var$method];
}
function $cc3e3be8c0373de4$var$Duplex(options) {
    if (!(this instanceof $cc3e3be8c0373de4$var$Duplex)) return new $cc3e3be8c0373de4$var$Duplex(options);
    $g4ZW2.call(this, options);
    $g6cJS.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $cc3e3be8c0373de4$var$onend);
        }
    }
}
Object.defineProperty($cc3e3be8c0373de4$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($cc3e3be8c0373de4$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($cc3e3be8c0373de4$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $cc3e3be8c0373de4$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $4ZL0H.nextTick($cc3e3be8c0373de4$var$onEndNT, this);
}
function $cc3e3be8c0373de4$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($cc3e3be8c0373de4$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("g6cJS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
module.exports = $bb8716969b605b7d$var$Writable;
/* <replacement> */ function $bb8716969b605b7d$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $bb8716969b605b7d$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $bb8716969b605b7d$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $bb8716969b605b7d$var$Duplex;
/*</replacement>*/ $bb8716969b605b7d$var$Writable.WritableState = $bb8716969b605b7d$var$WritableState;

/*<replacement>*/ var $bb8716969b605b7d$var$internalUtil = {
    deprecate: (parcelRequire("4SymK"))
};

var $bSqQK = parcelRequire("bSqQK");

var $bdjQ6 = parcelRequire("bdjQ6");
var $bb8716969b605b7d$require$Buffer = $bdjQ6.Buffer;
var $bb8716969b605b7d$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $bb8716969b605b7d$var$_uint8ArrayToBuffer(chunk) {
    return $bb8716969b605b7d$require$Buffer.from(chunk);
}
function $bb8716969b605b7d$var$_isUint8Array(obj) {
    return $bb8716969b605b7d$require$Buffer.isBuffer(obj) || obj instanceof $bb8716969b605b7d$var$OurUint8Array;
}

var $ktkM5 = parcelRequire("ktkM5");

var $feK8s = parcelRequire("feK8s");
var $bb8716969b605b7d$var$getHighWaterMark = $feK8s.getHighWaterMark;

var $h2o3J = parcelRequire("h2o3J");
var $bb8716969b605b7d$require$_require$codes = $h2o3J.codes;
var $bb8716969b605b7d$var$ERR_INVALID_ARG_TYPE = $bb8716969b605b7d$require$_require$codes.ERR_INVALID_ARG_TYPE, $bb8716969b605b7d$var$ERR_METHOD_NOT_IMPLEMENTED = $bb8716969b605b7d$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $bb8716969b605b7d$var$ERR_MULTIPLE_CALLBACK = $bb8716969b605b7d$require$_require$codes.ERR_MULTIPLE_CALLBACK, $bb8716969b605b7d$var$ERR_STREAM_CANNOT_PIPE = $bb8716969b605b7d$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $bb8716969b605b7d$var$ERR_STREAM_DESTROYED = $bb8716969b605b7d$require$_require$codes.ERR_STREAM_DESTROYED, $bb8716969b605b7d$var$ERR_STREAM_NULL_VALUES = $bb8716969b605b7d$require$_require$codes.ERR_STREAM_NULL_VALUES, $bb8716969b605b7d$var$ERR_STREAM_WRITE_AFTER_END = $bb8716969b605b7d$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $bb8716969b605b7d$var$ERR_UNKNOWN_ENCODING = $bb8716969b605b7d$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $bb8716969b605b7d$var$errorOrDestroy = $ktkM5.errorOrDestroy;

(parcelRequire("dhT4G"))($bb8716969b605b7d$var$Writable, $bSqQK);
function $bb8716969b605b7d$var$nop() {}

function $bb8716969b605b7d$var$WritableState(options, stream, isDuplex) {
    $bb8716969b605b7d$var$Duplex = $bb8716969b605b7d$var$Duplex || (parcelRequire("hxbeF"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $bb8716969b605b7d$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $bb8716969b605b7d$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $bb8716969b605b7d$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $bb8716969b605b7d$var$CorkedRequest(this);
}
$bb8716969b605b7d$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($bb8716969b605b7d$var$WritableState.prototype, 'buffer', {
            get: $bb8716969b605b7d$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $bb8716969b605b7d$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $bb8716969b605b7d$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($bb8716969b605b7d$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($bb8716969b605b7d$var$realHasInstance.call(this, object)) return true;
            if (this !== $bb8716969b605b7d$var$Writable) return false;
            return object && object._writableState instanceof $bb8716969b605b7d$var$WritableState;
        }
    });
} else $bb8716969b605b7d$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $bb8716969b605b7d$var$Writable(options) {
    $bb8716969b605b7d$var$Duplex = $bb8716969b605b7d$var$Duplex || (parcelRequire("hxbeF"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $bb8716969b605b7d$var$Duplex;
    if (!isDuplex && !$bb8716969b605b7d$var$realHasInstance.call($bb8716969b605b7d$var$Writable, this)) return new $bb8716969b605b7d$var$Writable(options);
    this._writableState = new $bb8716969b605b7d$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $bSqQK.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$bb8716969b605b7d$var$Writable.prototype.pipe = function() {
    $bb8716969b605b7d$var$errorOrDestroy(this, new $bb8716969b605b7d$var$ERR_STREAM_CANNOT_PIPE());
};
function $bb8716969b605b7d$var$writeAfterEnd(stream, cb) {
    var er = new $bb8716969b605b7d$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $bb8716969b605b7d$var$errorOrDestroy(stream, er);
    $4ZL0H.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $bb8716969b605b7d$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $bb8716969b605b7d$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $bb8716969b605b7d$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $bb8716969b605b7d$var$errorOrDestroy(stream, er);
        $4ZL0H.nextTick(cb, er);
        return false;
    }
    return true;
}
$bb8716969b605b7d$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $bb8716969b605b7d$var$_isUint8Array(chunk);
    if (isBuf && !$bb8716969b605b7d$require$Buffer.isBuffer(chunk)) chunk = $bb8716969b605b7d$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $bb8716969b605b7d$var$nop;
    if (state.ending) $bb8716969b605b7d$var$writeAfterEnd(this, cb);
    else if (isBuf || $bb8716969b605b7d$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $bb8716969b605b7d$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$bb8716969b605b7d$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$bb8716969b605b7d$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $bb8716969b605b7d$var$clearBuffer(this, state);
    }
};
$bb8716969b605b7d$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $bb8716969b605b7d$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($bb8716969b605b7d$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $bb8716969b605b7d$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $bb8716969b605b7d$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($bb8716969b605b7d$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $bb8716969b605b7d$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $bb8716969b605b7d$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $bb8716969b605b7d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $bb8716969b605b7d$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $bb8716969b605b7d$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $bb8716969b605b7d$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4ZL0H.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $4ZL0H.nextTick($bb8716969b605b7d$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $bb8716969b605b7d$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $bb8716969b605b7d$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $bb8716969b605b7d$var$finishMaybe(stream, state);
    }
}
function $bb8716969b605b7d$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $bb8716969b605b7d$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $bb8716969b605b7d$var$ERR_MULTIPLE_CALLBACK();
    $bb8716969b605b7d$var$onwriteStateUpdate(state);
    if (er) $bb8716969b605b7d$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $bb8716969b605b7d$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $bb8716969b605b7d$var$clearBuffer(stream, state);
        if (sync) $4ZL0H.nextTick($bb8716969b605b7d$var$afterWrite, stream, state, finished, cb);
        else $bb8716969b605b7d$var$afterWrite(stream, state, finished, cb);
    }
}
function $bb8716969b605b7d$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $bb8716969b605b7d$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $bb8716969b605b7d$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $bb8716969b605b7d$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $bb8716969b605b7d$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $bb8716969b605b7d$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $bb8716969b605b7d$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $bb8716969b605b7d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$bb8716969b605b7d$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $bb8716969b605b7d$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$bb8716969b605b7d$var$Writable.prototype._writev = null;
$bb8716969b605b7d$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $bb8716969b605b7d$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($bb8716969b605b7d$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $bb8716969b605b7d$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $bb8716969b605b7d$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $bb8716969b605b7d$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $bb8716969b605b7d$var$finishMaybe(stream, state);
    });
}
function $bb8716969b605b7d$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4ZL0H.nextTick($bb8716969b605b7d$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $bb8716969b605b7d$var$finishMaybe(stream, state) {
    var need = $bb8716969b605b7d$var$needFinish(state);
    if (need) {
        $bb8716969b605b7d$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $bb8716969b605b7d$var$endWritable(stream, state, cb) {
    state.ending = true;
    $bb8716969b605b7d$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4ZL0H.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $bb8716969b605b7d$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($bb8716969b605b7d$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$bb8716969b605b7d$var$Writable.prototype.destroy = $ktkM5.destroy;
$bb8716969b605b7d$var$Writable.prototype._undestroy = $ktkM5.undestroy;
$bb8716969b605b7d$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("4SymK", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $38d6dce7fbf76fcf$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $38d6dce7fbf76fcf$var$deprecate(fn, msg) {
    if ($38d6dce7fbf76fcf$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($38d6dce7fbf76fcf$var$config('throwDeprecation')) throw new Error(msg);
            else if ($38d6dce7fbf76fcf$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $38d6dce7fbf76fcf$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("iGJyf", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $d9af7bc5baf161c1$export$63a7aa211a91ed69; }, function (v) { return $d9af7bc5baf161c1$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d9af7bc5baf161c1$export$63a7aa211a91ed69;
'use strict';

var $8SoLd = parcelRequire("8SoLd");
var $d9af7bc5baf161c1$require$Buffer = $8SoLd.Buffer;
/*</replacement>*/ var $d9af7bc5baf161c1$var$isEncoding = $d9af7bc5baf161c1$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $d9af7bc5baf161c1$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d9af7bc5baf161c1$var$normalizeEncoding(enc) {
    var nenc = $d9af7bc5baf161c1$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($d9af7bc5baf161c1$require$Buffer.isEncoding === $d9af7bc5baf161c1$var$isEncoding || !$d9af7bc5baf161c1$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$d9af7bc5baf161c1$export$63a7aa211a91ed69 = $d9af7bc5baf161c1$var$StringDecoder;
function $d9af7bc5baf161c1$var$StringDecoder(encoding) {
    this.encoding = $d9af7bc5baf161c1$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $d9af7bc5baf161c1$var$utf16Text;
            this.end = $d9af7bc5baf161c1$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $d9af7bc5baf161c1$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $d9af7bc5baf161c1$var$base64Text;
            this.end = $d9af7bc5baf161c1$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d9af7bc5baf161c1$var$simpleWrite;
            this.end = $d9af7bc5baf161c1$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d9af7bc5baf161c1$require$Buffer.allocUnsafe(nb);
}
$d9af7bc5baf161c1$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$d9af7bc5baf161c1$var$StringDecoder.prototype.end = $d9af7bc5baf161c1$var$utf8End;
// Returns only complete characters in a Buffer
$d9af7bc5baf161c1$var$StringDecoder.prototype.text = $d9af7bc5baf161c1$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d9af7bc5baf161c1$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d9af7bc5baf161c1$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d9af7bc5baf161c1$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d9af7bc5baf161c1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d9af7bc5baf161c1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d9af7bc5baf161c1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d9af7bc5baf161c1$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d9af7bc5baf161c1$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d9af7bc5baf161c1$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d9af7bc5baf161c1$var$utf8Text(buf, i) {
    var total = $d9af7bc5baf161c1$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d9af7bc5baf161c1$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d9af7bc5baf161c1$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d9af7bc5baf161c1$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $d9af7bc5baf161c1$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $d9af7bc5baf161c1$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d9af7bc5baf161c1$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d9af7bc5baf161c1$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("8SoLd", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $676692cc3a322af6$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $676692cc3a322af6$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($676692cc3a322af6$var$Buffer.from && $676692cc3a322af6$var$Buffer.alloc && $676692cc3a322af6$var$Buffer.allocUnsafe && $676692cc3a322af6$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $676692cc3a322af6$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $676692cc3a322af6$var$SafeBuffer;
}
function $676692cc3a322af6$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $676692cc3a322af6$var$Buffer(arg, encodingOrOffset, length);
}
$676692cc3a322af6$var$SafeBuffer.prototype = Object.create($676692cc3a322af6$var$Buffer.prototype);
// Copy static methods from Buffer
$676692cc3a322af6$var$copyProps($676692cc3a322af6$var$Buffer, $676692cc3a322af6$var$SafeBuffer);
$676692cc3a322af6$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $676692cc3a322af6$var$Buffer(arg, encodingOrOffset, length);
};
$676692cc3a322af6$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $676692cc3a322af6$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$676692cc3a322af6$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $676692cc3a322af6$var$Buffer(size);
};
$676692cc3a322af6$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});


parcelRegister("iO1WB", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
var $03887d8aa87c05b0$var$_Object$setPrototypeO;
function $03887d8aa87c05b0$var$_defineProperty(obj, key, value) {
    key = $03887d8aa87c05b0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $03887d8aa87c05b0$var$_toPropertyKey(arg) {
    var key = $03887d8aa87c05b0$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $03887d8aa87c05b0$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $b6CHN = parcelRequire("b6CHN");
var $03887d8aa87c05b0$var$kLastResolve = Symbol('lastResolve');
var $03887d8aa87c05b0$var$kLastReject = Symbol('lastReject');
var $03887d8aa87c05b0$var$kError = Symbol('error');
var $03887d8aa87c05b0$var$kEnded = Symbol('ended');
var $03887d8aa87c05b0$var$kLastPromise = Symbol('lastPromise');
var $03887d8aa87c05b0$var$kHandlePromise = Symbol('handlePromise');
var $03887d8aa87c05b0$var$kStream = Symbol('stream');
function $03887d8aa87c05b0$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $03887d8aa87c05b0$var$readAndResolve(iter) {
    var resolve = iter[$03887d8aa87c05b0$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$03887d8aa87c05b0$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$03887d8aa87c05b0$var$kLastPromise] = null;
            iter[$03887d8aa87c05b0$var$kLastResolve] = null;
            iter[$03887d8aa87c05b0$var$kLastReject] = null;
            resolve($03887d8aa87c05b0$var$createIterResult(data, false));
        }
    }
}
function $03887d8aa87c05b0$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4ZL0H.nextTick($03887d8aa87c05b0$var$readAndResolve, iter);
}
function $03887d8aa87c05b0$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$03887d8aa87c05b0$var$kEnded]) {
                resolve($03887d8aa87c05b0$var$createIterResult(undefined, true));
                return;
            }
            iter[$03887d8aa87c05b0$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $03887d8aa87c05b0$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $03887d8aa87c05b0$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($03887d8aa87c05b0$var$_Object$setPrototypeO = {
    get stream () {
        return this[$03887d8aa87c05b0$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$03887d8aa87c05b0$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$03887d8aa87c05b0$var$kEnded]) return Promise.resolve($03887d8aa87c05b0$var$createIterResult(undefined, true));
        if (this[$03887d8aa87c05b0$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4ZL0H.nextTick(function() {
                if (_this[$03887d8aa87c05b0$var$kError]) reject(_this[$03887d8aa87c05b0$var$kError]);
                else resolve($03887d8aa87c05b0$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$03887d8aa87c05b0$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($03887d8aa87c05b0$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$03887d8aa87c05b0$var$kStream].read();
            if (data !== null) return Promise.resolve($03887d8aa87c05b0$var$createIterResult(data, false));
            promise = new Promise(this[$03887d8aa87c05b0$var$kHandlePromise]);
        }
        this[$03887d8aa87c05b0$var$kLastPromise] = promise;
        return promise;
    }
}, $03887d8aa87c05b0$var$_defineProperty($03887d8aa87c05b0$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $03887d8aa87c05b0$var$_defineProperty($03887d8aa87c05b0$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$03887d8aa87c05b0$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($03887d8aa87c05b0$var$createIterResult(undefined, true));
        });
    });
}), $03887d8aa87c05b0$var$_Object$setPrototypeO), $03887d8aa87c05b0$var$AsyncIteratorPrototype);
var $03887d8aa87c05b0$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($03887d8aa87c05b0$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $03887d8aa87c05b0$var$_defineProperty(_Object$create, $03887d8aa87c05b0$var$kStream, {
        value: stream,
        writable: true
    }), $03887d8aa87c05b0$var$_defineProperty(_Object$create, $03887d8aa87c05b0$var$kLastResolve, {
        value: null,
        writable: true
    }), $03887d8aa87c05b0$var$_defineProperty(_Object$create, $03887d8aa87c05b0$var$kLastReject, {
        value: null,
        writable: true
    }), $03887d8aa87c05b0$var$_defineProperty(_Object$create, $03887d8aa87c05b0$var$kError, {
        value: null,
        writable: true
    }), $03887d8aa87c05b0$var$_defineProperty(_Object$create, $03887d8aa87c05b0$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $03887d8aa87c05b0$var$_defineProperty(_Object$create, $03887d8aa87c05b0$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$03887d8aa87c05b0$var$kStream].read();
            if (data) {
                iterator[$03887d8aa87c05b0$var$kLastPromise] = null;
                iterator[$03887d8aa87c05b0$var$kLastResolve] = null;
                iterator[$03887d8aa87c05b0$var$kLastReject] = null;
                resolve($03887d8aa87c05b0$var$createIterResult(data, false));
            } else {
                iterator[$03887d8aa87c05b0$var$kLastResolve] = resolve;
                iterator[$03887d8aa87c05b0$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$03887d8aa87c05b0$var$kLastPromise] = null;
    $b6CHN(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$03887d8aa87c05b0$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$03887d8aa87c05b0$var$kLastPromise] = null;
                iterator[$03887d8aa87c05b0$var$kLastResolve] = null;
                iterator[$03887d8aa87c05b0$var$kLastReject] = null;
                reject(err);
            }
            iterator[$03887d8aa87c05b0$var$kError] = err;
            return;
        }
        var resolve = iterator[$03887d8aa87c05b0$var$kLastResolve];
        if (resolve !== null) {
            iterator[$03887d8aa87c05b0$var$kLastPromise] = null;
            iterator[$03887d8aa87c05b0$var$kLastResolve] = null;
            iterator[$03887d8aa87c05b0$var$kLastReject] = null;
            resolve($03887d8aa87c05b0$var$createIterResult(undefined, true));
        }
        iterator[$03887d8aa87c05b0$var$kEnded] = true;
    });
    stream.on('readable', $03887d8aa87c05b0$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $03887d8aa87c05b0$var$createReadableStreamAsyncIterator;

});
parcelRegister("b6CHN", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $815e475a8421193f$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("h2o3J")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $815e475a8421193f$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $815e475a8421193f$var$noop() {}
function $815e475a8421193f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $815e475a8421193f$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $815e475a8421193f$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $815e475a8421193f$var$once(callback || $815e475a8421193f$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $815e475a8421193f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $815e475a8421193f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($815e475a8421193f$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $815e475a8421193f$var$eos;

});


parcelRegister("bcqRj", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("k0KBi", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $e917f49caec6d43d$var$Transform;

var $h2o3J = parcelRequire("h2o3J");
var $e917f49caec6d43d$require$_require$codes = $h2o3J.codes;
var $e917f49caec6d43d$var$ERR_METHOD_NOT_IMPLEMENTED = $e917f49caec6d43d$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $e917f49caec6d43d$var$ERR_MULTIPLE_CALLBACK = $e917f49caec6d43d$require$_require$codes.ERR_MULTIPLE_CALLBACK, $e917f49caec6d43d$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $e917f49caec6d43d$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e917f49caec6d43d$var$ERR_TRANSFORM_WITH_LENGTH_0 = $e917f49caec6d43d$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $hxbeF = parcelRequire("hxbeF");

(parcelRequire("dhT4G"))($e917f49caec6d43d$var$Transform, $hxbeF);
function $e917f49caec6d43d$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $e917f49caec6d43d$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e917f49caec6d43d$var$Transform(options) {
    if (!(this instanceof $e917f49caec6d43d$var$Transform)) return new $e917f49caec6d43d$var$Transform(options);
    $hxbeF.call(this, options);
    this._transformState = {
        afterTransform: $e917f49caec6d43d$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $e917f49caec6d43d$var$prefinish);
}
function $e917f49caec6d43d$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $e917f49caec6d43d$var$done(_this, er, data);
    });
    else $e917f49caec6d43d$var$done(this, null, null);
}
$e917f49caec6d43d$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $hxbeF.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e917f49caec6d43d$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $e917f49caec6d43d$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$e917f49caec6d43d$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e917f49caec6d43d$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e917f49caec6d43d$var$Transform.prototype._destroy = function(err, cb) {
    $hxbeF.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $e917f49caec6d43d$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $e917f49caec6d43d$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $e917f49caec6d43d$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("jYFEV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $e8b3ef8ac56f630d$var$PassThrough;

var $k0KBi = parcelRequire("k0KBi");

(parcelRequire("dhT4G"))($e8b3ef8ac56f630d$var$PassThrough, $k0KBi);
function $e8b3ef8ac56f630d$var$PassThrough(options) {
    if (!(this instanceof $e8b3ef8ac56f630d$var$PassThrough)) return new $e8b3ef8ac56f630d$var$PassThrough(options);
    $k0KBi.call(this, options);
}
$e8b3ef8ac56f630d$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("gPAeR", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $c40d850090abf052$var$eos;
function $c40d850090abf052$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $h2o3J = parcelRequire("h2o3J");
var $c40d850090abf052$require$_require$codes = $h2o3J.codes;
var $c40d850090abf052$var$ERR_MISSING_ARGS = $c40d850090abf052$require$_require$codes.ERR_MISSING_ARGS, $c40d850090abf052$var$ERR_STREAM_DESTROYED = $c40d850090abf052$require$_require$codes.ERR_STREAM_DESTROYED;
function $c40d850090abf052$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $c40d850090abf052$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $c40d850090abf052$var$destroyer(stream, reading, writing, callback) {
    callback = $c40d850090abf052$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($c40d850090abf052$var$eos === undefined) $c40d850090abf052$var$eos = (parcelRequire("b6CHN"));
    $c40d850090abf052$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($c40d850090abf052$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $c40d850090abf052$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $c40d850090abf052$var$call(fn) {
    fn();
}
function $c40d850090abf052$var$pipe(from, to) {
    return from.pipe(to);
}
function $c40d850090abf052$var$popCallback(streams) {
    if (!streams.length) return $c40d850090abf052$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $c40d850090abf052$var$noop;
    return streams.pop();
}
function $c40d850090abf052$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $c40d850090abf052$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $c40d850090abf052$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $c40d850090abf052$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($c40d850090abf052$var$call);
            if (reading) return;
            destroys.forEach($c40d850090abf052$var$call);
            callback(error);
        });
    });
    return streams.reduce($c40d850090abf052$var$pipe);
}
module.exports = $c40d850090abf052$var$pipeline;

});


parcelRegister("5LV4O", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4ZL0H = parcelRequire("4ZL0H");
var $433d9dc7b7117565$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $433d9dc7b7117565$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$433d9dc7b7117565$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($433d9dc7b7117565$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($433d9dc7b7117565$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($433d9dc7b7117565$var$isNull(x) || !$433d9dc7b7117565$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $433d9dc7b7117565$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($4ZL0H.throwDeprecation) throw new Error(msg);
            else if ($4ZL0H.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $433d9dc7b7117565$var$debugs = {};
var $433d9dc7b7117565$var$debugEnvRegex = /^$/;
var $433d9dc7b7117565$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$433d9dc7b7117565$var$debugs[set]) {
        if ($433d9dc7b7117565$var$debugEnvRegex.test(set)) {
            var pid = $4ZL0H.pid;
            $433d9dc7b7117565$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $433d9dc7b7117565$var$debugs[set] = function() {};
    }
    return $433d9dc7b7117565$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $433d9dc7b7117565$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $433d9dc7b7117565$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($433d9dc7b7117565$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($433d9dc7b7117565$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($433d9dc7b7117565$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($433d9dc7b7117565$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($433d9dc7b7117565$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $433d9dc7b7117565$var$stylizeWithColor;
    return $433d9dc7b7117565$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $433d9dc7b7117565$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$433d9dc7b7117565$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$433d9dc7b7117565$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $433d9dc7b7117565$var$stylizeWithColor(str, styleType) {
    var style = $433d9dc7b7117565$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $433d9dc7b7117565$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $433d9dc7b7117565$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $433d9dc7b7117565$var$stylizeNoColor(str, styleType) {
    return str;
}
function $433d9dc7b7117565$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $433d9dc7b7117565$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $433d9dc7b7117565$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$433d9dc7b7117565$var$isString(ret)) ret = $433d9dc7b7117565$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $433d9dc7b7117565$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $433d9dc7b7117565$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($433d9dc7b7117565$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $433d9dc7b7117565$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($433d9dc7b7117565$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($433d9dc7b7117565$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($433d9dc7b7117565$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($433d9dc7b7117565$var$isError(value)) return $433d9dc7b7117565$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($433d9dc7b7117565$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($433d9dc7b7117565$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($433d9dc7b7117565$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($433d9dc7b7117565$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($433d9dc7b7117565$var$isError(value)) base = ' ' + $433d9dc7b7117565$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($433d9dc7b7117565$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $433d9dc7b7117565$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $433d9dc7b7117565$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $433d9dc7b7117565$var$reduceToSingleString(output, base, braces);
}
function $433d9dc7b7117565$var$formatPrimitive(ctx, value) {
    if ($433d9dc7b7117565$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($433d9dc7b7117565$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($433d9dc7b7117565$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($433d9dc7b7117565$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($433d9dc7b7117565$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $433d9dc7b7117565$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $433d9dc7b7117565$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($433d9dc7b7117565$var$hasOwnProperty(value, String(i))) output.push($433d9dc7b7117565$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($433d9dc7b7117565$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $433d9dc7b7117565$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$433d9dc7b7117565$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($433d9dc7b7117565$var$isNull(recurseTimes)) str = $433d9dc7b7117565$var$formatValue(ctx, desc.value, null);
            else str = $433d9dc7b7117565$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($433d9dc7b7117565$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $433d9dc7b7117565$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("84NGl"));
function $433d9dc7b7117565$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $433d9dc7b7117565$var$isArray;
function $433d9dc7b7117565$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $433d9dc7b7117565$var$isBoolean;
function $433d9dc7b7117565$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $433d9dc7b7117565$var$isNull;
function $433d9dc7b7117565$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $433d9dc7b7117565$var$isNullOrUndefined;
function $433d9dc7b7117565$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $433d9dc7b7117565$var$isNumber;
function $433d9dc7b7117565$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $433d9dc7b7117565$var$isString;
function $433d9dc7b7117565$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $433d9dc7b7117565$var$isSymbol;
function $433d9dc7b7117565$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $433d9dc7b7117565$var$isUndefined;
function $433d9dc7b7117565$var$isRegExp(re) {
    return $433d9dc7b7117565$var$isObject(re) && $433d9dc7b7117565$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $433d9dc7b7117565$var$isRegExp;
module.exports.types.isRegExp = $433d9dc7b7117565$var$isRegExp;
function $433d9dc7b7117565$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $433d9dc7b7117565$var$isObject;
function $433d9dc7b7117565$var$isDate(d) {
    return $433d9dc7b7117565$var$isObject(d) && $433d9dc7b7117565$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $433d9dc7b7117565$var$isDate;
module.exports.types.isDate = $433d9dc7b7117565$var$isDate;
function $433d9dc7b7117565$var$isError(e) {
    return $433d9dc7b7117565$var$isObject(e) && ($433d9dc7b7117565$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $433d9dc7b7117565$var$isError;
module.exports.types.isNativeError = $433d9dc7b7117565$var$isError;
function $433d9dc7b7117565$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $433d9dc7b7117565$var$isFunction;
function $433d9dc7b7117565$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $433d9dc7b7117565$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("15hNQ"));
function $433d9dc7b7117565$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $433d9dc7b7117565$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $433d9dc7b7117565$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $433d9dc7b7117565$var$timestamp() {
    var d = new Date();
    var time = [
        $433d9dc7b7117565$var$pad(d.getHours()),
        $433d9dc7b7117565$var$pad(d.getMinutes()),
        $433d9dc7b7117565$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $433d9dc7b7117565$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $433d9dc7b7117565$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dhT4G"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$433d9dc7b7117565$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $433d9dc7b7117565$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $433d9dc7b7117565$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($433d9dc7b7117565$var$kCustomPromisifiedSymbol && original[$433d9dc7b7117565$var$kCustomPromisifiedSymbol]) {
        var fn = original[$433d9dc7b7117565$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $433d9dc7b7117565$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($433d9dc7b7117565$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $433d9dc7b7117565$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $433d9dc7b7117565$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $433d9dc7b7117565$var$kCustomPromisifiedSymbol;
function $433d9dc7b7117565$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $433d9dc7b7117565$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $4ZL0H.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $4ZL0H.nextTick($433d9dc7b7117565$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $433d9dc7b7117565$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $433d9dc7b7117565$var$callbackify;

});
parcelRegister("84NGl", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $1CYP9 = parcelRequire("1CYP9");

var $hPT6u = parcelRequire("hPT6u");

var $3y8Uz = parcelRequire("3y8Uz");

var $3v1VX = parcelRequire("3v1VX");
function $5e153c455be43079$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $5e153c455be43079$var$BigIntSupported = typeof BigInt !== 'undefined';
var $5e153c455be43079$var$SymbolSupported = typeof Symbol !== 'undefined';
var $5e153c455be43079$var$ObjectToString = $5e153c455be43079$var$uncurryThis(Object.prototype.toString);
var $5e153c455be43079$var$numberValue = $5e153c455be43079$var$uncurryThis(Number.prototype.valueOf);
var $5e153c455be43079$var$stringValue = $5e153c455be43079$var$uncurryThis(String.prototype.valueOf);
var $5e153c455be43079$var$booleanValue = $5e153c455be43079$var$uncurryThis(Boolean.prototype.valueOf);
if ($5e153c455be43079$var$BigIntSupported) var $5e153c455be43079$var$bigIntValue = $5e153c455be43079$var$uncurryThis(BigInt.prototype.valueOf);
if ($5e153c455be43079$var$SymbolSupported) var $5e153c455be43079$var$symbolValue = $5e153c455be43079$var$uncurryThis(Symbol.prototype.valueOf);
function $5e153c455be43079$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $1CYP9;
module.exports.isGeneratorFunction = $hPT6u;
module.exports.isTypedArray = $3v1VX;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $5e153c455be43079$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $5e153c455be43079$var$isPromise;
function $5e153c455be43079$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $3v1VX(value) || $5e153c455be43079$var$isDataView(value);
}
module.exports.isArrayBufferView = $5e153c455be43079$var$isArrayBufferView;
function $5e153c455be43079$var$isUint8Array(value) {
    return $3y8Uz(value) === 'Uint8Array';
}
module.exports.isUint8Array = $5e153c455be43079$var$isUint8Array;
function $5e153c455be43079$var$isUint8ClampedArray(value) {
    return $3y8Uz(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $5e153c455be43079$var$isUint8ClampedArray;
function $5e153c455be43079$var$isUint16Array(value) {
    return $3y8Uz(value) === 'Uint16Array';
}
module.exports.isUint16Array = $5e153c455be43079$var$isUint16Array;
function $5e153c455be43079$var$isUint32Array(value) {
    return $3y8Uz(value) === 'Uint32Array';
}
module.exports.isUint32Array = $5e153c455be43079$var$isUint32Array;
function $5e153c455be43079$var$isInt8Array(value) {
    return $3y8Uz(value) === 'Int8Array';
}
module.exports.isInt8Array = $5e153c455be43079$var$isInt8Array;
function $5e153c455be43079$var$isInt16Array(value) {
    return $3y8Uz(value) === 'Int16Array';
}
module.exports.isInt16Array = $5e153c455be43079$var$isInt16Array;
function $5e153c455be43079$var$isInt32Array(value) {
    return $3y8Uz(value) === 'Int32Array';
}
module.exports.isInt32Array = $5e153c455be43079$var$isInt32Array;
function $5e153c455be43079$var$isFloat32Array(value) {
    return $3y8Uz(value) === 'Float32Array';
}
module.exports.isFloat32Array = $5e153c455be43079$var$isFloat32Array;
function $5e153c455be43079$var$isFloat64Array(value) {
    return $3y8Uz(value) === 'Float64Array';
}
module.exports.isFloat64Array = $5e153c455be43079$var$isFloat64Array;
function $5e153c455be43079$var$isBigInt64Array(value) {
    return $3y8Uz(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $5e153c455be43079$var$isBigInt64Array;
function $5e153c455be43079$var$isBigUint64Array(value) {
    return $3y8Uz(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $5e153c455be43079$var$isBigUint64Array;
function $5e153c455be43079$var$isMapToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object Map]';
}
$5e153c455be43079$var$isMapToString.working = typeof Map !== 'undefined' && $5e153c455be43079$var$isMapToString(new Map());
function $5e153c455be43079$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $5e153c455be43079$var$isMapToString.working ? $5e153c455be43079$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $5e153c455be43079$var$isMap;
function $5e153c455be43079$var$isSetToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object Set]';
}
$5e153c455be43079$var$isSetToString.working = typeof Set !== 'undefined' && $5e153c455be43079$var$isSetToString(new Set());
function $5e153c455be43079$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $5e153c455be43079$var$isSetToString.working ? $5e153c455be43079$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $5e153c455be43079$var$isSet;
function $5e153c455be43079$var$isWeakMapToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object WeakMap]';
}
$5e153c455be43079$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $5e153c455be43079$var$isWeakMapToString(new WeakMap());
function $5e153c455be43079$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $5e153c455be43079$var$isWeakMapToString.working ? $5e153c455be43079$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $5e153c455be43079$var$isWeakMap;
function $5e153c455be43079$var$isWeakSetToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object WeakSet]';
}
$5e153c455be43079$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $5e153c455be43079$var$isWeakSetToString(new WeakSet());
function $5e153c455be43079$var$isWeakSet(value) {
    return $5e153c455be43079$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $5e153c455be43079$var$isWeakSet;
function $5e153c455be43079$var$isArrayBufferToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$5e153c455be43079$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $5e153c455be43079$var$isArrayBufferToString(new ArrayBuffer());
function $5e153c455be43079$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $5e153c455be43079$var$isArrayBufferToString.working ? $5e153c455be43079$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $5e153c455be43079$var$isArrayBuffer;
function $5e153c455be43079$var$isDataViewToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object DataView]';
}
$5e153c455be43079$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $5e153c455be43079$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $5e153c455be43079$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $5e153c455be43079$var$isDataViewToString.working ? $5e153c455be43079$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $5e153c455be43079$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $5e153c455be43079$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $5e153c455be43079$var$isSharedArrayBufferToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $5e153c455be43079$var$isSharedArrayBuffer(value) {
    if (typeof $5e153c455be43079$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $5e153c455be43079$var$isSharedArrayBufferToString.working === 'undefined') $5e153c455be43079$var$isSharedArrayBufferToString.working = $5e153c455be43079$var$isSharedArrayBufferToString(new $5e153c455be43079$var$SharedArrayBufferCopy());
    return $5e153c455be43079$var$isSharedArrayBufferToString.working ? $5e153c455be43079$var$isSharedArrayBufferToString(value) : value instanceof $5e153c455be43079$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $5e153c455be43079$var$isSharedArrayBuffer;
function $5e153c455be43079$var$isAsyncFunction(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $5e153c455be43079$var$isAsyncFunction;
function $5e153c455be43079$var$isMapIterator(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $5e153c455be43079$var$isMapIterator;
function $5e153c455be43079$var$isSetIterator(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $5e153c455be43079$var$isSetIterator;
function $5e153c455be43079$var$isGeneratorObject(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $5e153c455be43079$var$isGeneratorObject;
function $5e153c455be43079$var$isWebAssemblyCompiledModule(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $5e153c455be43079$var$isWebAssemblyCompiledModule;
function $5e153c455be43079$var$isNumberObject(value) {
    return $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$numberValue);
}
module.exports.isNumberObject = $5e153c455be43079$var$isNumberObject;
function $5e153c455be43079$var$isStringObject(value) {
    return $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$stringValue);
}
module.exports.isStringObject = $5e153c455be43079$var$isStringObject;
function $5e153c455be43079$var$isBooleanObject(value) {
    return $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$booleanValue);
}
module.exports.isBooleanObject = $5e153c455be43079$var$isBooleanObject;
function $5e153c455be43079$var$isBigIntObject(value) {
    return $5e153c455be43079$var$BigIntSupported && $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$bigIntValue);
}
module.exports.isBigIntObject = $5e153c455be43079$var$isBigIntObject;
function $5e153c455be43079$var$isSymbolObject(value) {
    return $5e153c455be43079$var$SymbolSupported && $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$symbolValue);
}
module.exports.isSymbolObject = $5e153c455be43079$var$isSymbolObject;
function $5e153c455be43079$var$isBoxedPrimitive(value) {
    return $5e153c455be43079$var$isNumberObject(value) || $5e153c455be43079$var$isStringObject(value) || $5e153c455be43079$var$isBooleanObject(value) || $5e153c455be43079$var$isBigIntObject(value) || $5e153c455be43079$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $5e153c455be43079$var$isBoxedPrimitive;
function $5e153c455be43079$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($5e153c455be43079$var$isArrayBuffer(value) || $5e153c455be43079$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $5e153c455be43079$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("1CYP9", function(module, exports) {
'use strict';

var $12f8857680b8d243$var$hasToStringTag = (parcelRequire("1Zhkx"))();

var $eC3A3 = parcelRequire("eC3A3");
var $12f8857680b8d243$var$$toString = $eC3A3('Object.prototype.toString');
/** @type {import('.')} */ var $12f8857680b8d243$var$isStandardArguments = function isArguments(value) {
    if ($12f8857680b8d243$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $12f8857680b8d243$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $12f8857680b8d243$var$isLegacyArguments = function isArguments(value) {
    if ($12f8857680b8d243$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $12f8857680b8d243$var$$toString(value) !== '[object Array]' && 'callee' in value && $12f8857680b8d243$var$$toString(value.callee) === '[object Function]';
};
var $12f8857680b8d243$var$supportsStandardArguments = function() {
    return $12f8857680b8d243$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$12f8857680b8d243$var$isStandardArguments.isLegacyArguments = $12f8857680b8d243$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $12f8857680b8d243$var$supportsStandardArguments ? $12f8857680b8d243$var$isStandardArguments : $12f8857680b8d243$var$isLegacyArguments;

});
parcelRegister("1Zhkx", function(module, exports) {
'use strict';

var $f2BFz = parcelRequire("f2BFz");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $f2BFz() && !!Symbol.toStringTag;
};

});
parcelRegister("f2BFz", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("eC3A3", function(module, exports) {
'use strict';

var $hkNzn = parcelRequire("hkNzn");

var $593ev = parcelRequire("593ev");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $aa3764525413497a$var$$indexOf = $593ev([
    $hkNzn('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $hkNzn(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $aa3764525413497a$var$$indexOf(name, '.prototype.') > -1) return $593ev(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("hkNzn", function(module, exports) {
'use strict';
var $c9eac16840c8f75d$var$undefined1;

var $aEzGq = parcelRequire("aEzGq");

var $6xoeI = parcelRequire("6xoeI");

var $SKRnU = parcelRequire("SKRnU");

var $6iFy7 = parcelRequire("6iFy7");

var $j0Ert = parcelRequire("j0Ert");

var $bw8YX = parcelRequire("bw8YX");

var $5Xz8R = parcelRequire("5Xz8R");

var $62IVw = parcelRequire("62IVw");

var $iuXCA = parcelRequire("iuXCA");

var $57uf1 = parcelRequire("57uf1");

var $8KJjU = parcelRequire("8KJjU");

var $cmoNf = parcelRequire("cmoNf");

var $eaKh2 = parcelRequire("eaKh2");

var $13WPP = parcelRequire("13WPP");

var $g26DA = parcelRequire("g26DA");
var $c9eac16840c8f75d$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $c9eac16840c8f75d$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $c9eac16840c8f75d$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $gNKV7 = parcelRequire("gNKV7");

var $bKXTU = parcelRequire("bKXTU");
var $c9eac16840c8f75d$var$throwTypeError = function() {
    throw new $5Xz8R();
};
var $c9eac16840c8f75d$var$ThrowTypeError = $gNKV7 ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $c9eac16840c8f75d$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gNKV7(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $c9eac16840c8f75d$var$throwTypeError;
        }
    }
}() : $c9eac16840c8f75d$var$throwTypeError;

var $c9eac16840c8f75d$var$hasSymbols = (parcelRequire("4qQ7b"))();

var $b7uaR = parcelRequire("b7uaR");

var $4kTCn = parcelRequire("4kTCn");

var $1Gomj = parcelRequire("1Gomj");

var $aYzei = parcelRequire("aYzei");

var $bSEx1 = parcelRequire("bSEx1");
var $c9eac16840c8f75d$var$needsEval = {};
var $c9eac16840c8f75d$var$TypedArray = typeof Uint8Array === 'undefined' || !$b7uaR ? undefined : $b7uaR(Uint8Array);
var $c9eac16840c8f75d$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $b7uaR ? $b7uaR([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncGenerator%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncGeneratorFunction%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncIteratorPrototype%': $c9eac16840c8f75d$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $6xoeI,
    '%eval%': eval,
    '%EvalError%': $SKRnU,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $c9eac16840c8f75d$var$$Function,
    '%GeneratorFunction%': $c9eac16840c8f75d$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $b7uaR ? $b7uaR($b7uaR([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$c9eac16840c8f75d$var$hasSymbols || !$b7uaR ? undefined : $b7uaR(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $aEzGq,
    '%Object.getOwnPropertyDescriptor%': $gNKV7,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $6iFy7,
    '%ReferenceError%': $j0Ert,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$c9eac16840c8f75d$var$hasSymbols || !$b7uaR ? undefined : $b7uaR(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $b7uaR ? $b7uaR(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $c9eac16840c8f75d$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $bw8YX,
    '%ThrowTypeError%': $c9eac16840c8f75d$var$ThrowTypeError,
    '%TypedArray%': $c9eac16840c8f75d$var$TypedArray,
    '%TypeError%': $5Xz8R,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $62IVw,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $bSEx1,
    '%Function.prototype.apply%': $aYzei,
    '%Object.defineProperty%': $bKXTU,
    '%Object.getPrototypeOf%': $4kTCn,
    '%Math.abs%': $iuXCA,
    '%Math.floor%': $57uf1,
    '%Math.max%': $8KJjU,
    '%Math.min%': $cmoNf,
    '%Math.pow%': $eaKh2,
    '%Math.round%': $13WPP,
    '%Math.sign%': $g26DA,
    '%Reflect.getPrototypeOf%': $1Gomj
};
if ($b7uaR) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $c9eac16840c8f75d$var$errorProto = $b7uaR($b7uaR(e));
    $c9eac16840c8f75d$var$INTRINSICS['%Error.prototype%'] = $c9eac16840c8f75d$var$errorProto;
}
var $c9eac16840c8f75d$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $b7uaR) value = $b7uaR(gen.prototype);
    }
    $c9eac16840c8f75d$var$INTRINSICS[name] = value;
    return value;
};
var $c9eac16840c8f75d$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $eQ7C3 = parcelRequire("eQ7C3");

var $8byr2 = parcelRequire("8byr2");
var $c9eac16840c8f75d$var$$concat = $eQ7C3.call($bSEx1, Array.prototype.concat);
var $c9eac16840c8f75d$var$$spliceApply = $eQ7C3.call($aYzei, Array.prototype.splice);
var $c9eac16840c8f75d$var$$replace = $eQ7C3.call($bSEx1, String.prototype.replace);
var $c9eac16840c8f75d$var$$strSlice = $eQ7C3.call($bSEx1, String.prototype.slice);
var $c9eac16840c8f75d$var$$exec = $eQ7C3.call($bSEx1, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $c9eac16840c8f75d$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $c9eac16840c8f75d$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $c9eac16840c8f75d$var$stringToPath = function stringToPath(string) {
    var first = $c9eac16840c8f75d$var$$strSlice(string, 0, 1);
    var last = $c9eac16840c8f75d$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $bw8YX('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $bw8YX('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $c9eac16840c8f75d$var$$replace(string, $c9eac16840c8f75d$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $c9eac16840c8f75d$var$$replace(subString, $c9eac16840c8f75d$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $c9eac16840c8f75d$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($8byr2($c9eac16840c8f75d$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $c9eac16840c8f75d$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($8byr2($c9eac16840c8f75d$var$INTRINSICS, intrinsicName)) {
        var value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicName];
        if (value === $c9eac16840c8f75d$var$needsEval) value = $c9eac16840c8f75d$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $5Xz8R('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $bw8YX('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $5Xz8R('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $5Xz8R('"allowMissing" argument must be a boolean');
    if ($c9eac16840c8f75d$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $bw8YX('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $c9eac16840c8f75d$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $c9eac16840c8f75d$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $c9eac16840c8f75d$var$$spliceApply(parts, $c9eac16840c8f75d$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $c9eac16840c8f75d$var$$strSlice(part, 0, 1);
        var last = $c9eac16840c8f75d$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $bw8YX('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($8byr2($c9eac16840c8f75d$var$INTRINSICS, intrinsicRealName)) value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $5Xz8R('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($gNKV7 && i + 1 >= parts.length) {
                var desc = $gNKV7(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $8byr2(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("aEzGq", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("6xoeI", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("SKRnU", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("6iFy7", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("j0Ert", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("bw8YX", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("5Xz8R", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("62IVw", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("iuXCA", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("57uf1", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("8KJjU", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("cmoNf", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("eaKh2", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("13WPP", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("g26DA", function(module, exports) {
'use strict';

var $8hbPu = parcelRequire("8hbPu");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($8hbPu(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("8hbPu", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("gNKV7", function(module, exports) {
'use strict';

var $87tme = parcelRequire("87tme");
var $c3b59e512f612c17$require$$gOPD = $87tme;
if ($c3b59e512f612c17$require$$gOPD) try {
    $c3b59e512f612c17$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $c3b59e512f612c17$require$$gOPD = null;
}
module.exports = $c3b59e512f612c17$require$$gOPD;

});
parcelRegister("87tme", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("bKXTU", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $88f2749ea03868eb$var$$defineProperty = Object.defineProperty || false;
if ($88f2749ea03868eb$var$$defineProperty) try {
    $88f2749ea03868eb$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $88f2749ea03868eb$var$$defineProperty = false;
}
module.exports = $88f2749ea03868eb$var$$defineProperty;

});

parcelRegister("4qQ7b", function(module, exports) {
'use strict';
var $33a204135f6b8445$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $f2BFz = parcelRequire("f2BFz");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $33a204135f6b8445$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $33a204135f6b8445$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $f2BFz();
};

});

parcelRegister("b7uaR", function(module, exports) {
'use strict';

var $1Gomj = parcelRequire("1Gomj");

var $4kTCn = parcelRequire("4kTCn");

var $2mxVo = parcelRequire("2mxVo");
/** @type {import('.')} */ module.exports = $1Gomj ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $1Gomj(O);
} : $4kTCn ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $4kTCn(O);
} : $2mxVo ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $2mxVo(O);
} : null;

});
parcelRegister("1Gomj", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("4kTCn", function(module, exports) {
'use strict';

var $aEzGq = parcelRequire("aEzGq");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $aEzGq.getPrototypeOf || null;

});

parcelRegister("2mxVo", function(module, exports) {
'use strict';

var $593ev = parcelRequire("593ev");

var $gNKV7 = parcelRequire("gNKV7");
var $1b87f3939656d8ea$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $1b87f3939656d8ea$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $1b87f3939656d8ea$var$desc = !!$1b87f3939656d8ea$var$hasProtoAccessor && $gNKV7 && $gNKV7(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $1b87f3939656d8ea$var$$Object = Object;
var $1b87f3939656d8ea$var$$getPrototypeOf = $1b87f3939656d8ea$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $1b87f3939656d8ea$var$desc && typeof $1b87f3939656d8ea$var$desc.get === 'function' ? $593ev([
    $1b87f3939656d8ea$var$desc.get
]) : typeof $1b87f3939656d8ea$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $1b87f3939656d8ea$var$$getPrototypeOf(value == null ? value : $1b87f3939656d8ea$var$$Object(value));
} : false;

});
parcelRegister("593ev", function(module, exports) {
'use strict';

var $eQ7C3 = parcelRequire("eQ7C3");

var $5Xz8R = parcelRequire("5Xz8R");

var $bSEx1 = parcelRequire("bSEx1");

var $04tsO = parcelRequire("04tsO");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $5Xz8R('a function is required');
    return $04tsO($eQ7C3, $bSEx1, args);
};

});
parcelRegister("eQ7C3", function(module, exports) {
'use strict';

var $gfKZG = parcelRequire("gfKZG");
module.exports = Function.prototype.bind || $gfKZG;

});
parcelRegister("gfKZG", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $bd52800b6fae4c57$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $bd52800b6fae4c57$var$toStr = Object.prototype.toString;
var $bd52800b6fae4c57$var$max = Math.max;
var $bd52800b6fae4c57$var$funcType = '[object Function]';
var $bd52800b6fae4c57$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $bd52800b6fae4c57$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $bd52800b6fae4c57$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $bd52800b6fae4c57$var$toStr.apply(target) !== $bd52800b6fae4c57$var$funcType) throw new TypeError($bd52800b6fae4c57$var$ERROR_MESSAGE + target);
    var args = $bd52800b6fae4c57$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $bd52800b6fae4c57$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $bd52800b6fae4c57$var$concatty(args, arguments));
    };
    var boundLength = $bd52800b6fae4c57$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $bd52800b6fae4c57$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("bSEx1", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("04tsO", function(module, exports) {
'use strict';

var $eQ7C3 = parcelRequire("eQ7C3");

var $aYzei = parcelRequire("aYzei");

var $bSEx1 = parcelRequire("bSEx1");

var $fYjQh = parcelRequire("fYjQh");
/** @type {import('./actualApply')} */ module.exports = $fYjQh || $eQ7C3.call($bSEx1, $aYzei);

});
parcelRegister("aYzei", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("fYjQh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("8byr2", function(module, exports) {
'use strict';
var $5f5a0fe320c1ef2a$var$call = Function.prototype.call;
var $5f5a0fe320c1ef2a$var$$hasOwn = Object.prototype.hasOwnProperty;

var $eQ7C3 = parcelRequire("eQ7C3");
/** @type {import('.')} */ module.exports = $eQ7C3.call($5f5a0fe320c1ef2a$var$call, $5f5a0fe320c1ef2a$var$$hasOwn);

});




parcelRegister("hPT6u", function(module, exports) {
'use strict';

var $eC3A3 = parcelRequire("eC3A3");

var $8IoOS = parcelRequire("8IoOS");
var $cfc1f18425c87f72$var$isFnRegex = $8IoOS(/^\s*(?:function)?\*/);

var $cfc1f18425c87f72$var$hasToStringTag = (parcelRequire("1Zhkx"))();

var $b7uaR = parcelRequire("b7uaR");
var $cfc1f18425c87f72$var$toStr = $eC3A3('Object.prototype.toString');
var $cfc1f18425c87f72$var$fnToStr = $eC3A3('Function.prototype.toString');

var $9PEkm = parcelRequire("9PEkm");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($cfc1f18425c87f72$var$isFnRegex($cfc1f18425c87f72$var$fnToStr(fn))) return true;
    if (!$cfc1f18425c87f72$var$hasToStringTag) {
        var str = $cfc1f18425c87f72$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$b7uaR) return false;
    var GeneratorFunction = $9PEkm();
    return GeneratorFunction && $b7uaR(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("8IoOS", function(module, exports) {
'use strict';

var $eC3A3 = parcelRequire("eC3A3");

var $2kOHf = parcelRequire("2kOHf");
var $6585af70518b6cbc$var$$exec = $eC3A3('RegExp.prototype.exec');

var $5Xz8R = parcelRequire("5Xz8R");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$2kOHf(regex)) throw new $5Xz8R('`regex` must be a RegExp');
    return function test(s) {
        return $6585af70518b6cbc$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("2kOHf", function(module, exports) {
'use strict';

var $eC3A3 = parcelRequire("eC3A3");

var $1b34c64db5454254$var$hasToStringTag = (parcelRequire("1Zhkx"))();

var $8byr2 = parcelRequire("8byr2");

var $gNKV7 = parcelRequire("gNKV7");
/** @type {import('.')} */ var $1b34c64db5454254$var$fn;
if ($1b34c64db5454254$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $1b34c64db5454254$var$$exec = $eC3A3('RegExp.prototype.exec');
    /** @type {object} */ var $1b34c64db5454254$var$isRegexMarker = {};
    var $1b34c64db5454254$var$throwRegexMarker = function() {
        throw $1b34c64db5454254$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $1b34c64db5454254$var$badStringifier = {
        toString: $1b34c64db5454254$var$throwRegexMarker,
        valueOf: $1b34c64db5454254$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $1b34c64db5454254$var$badStringifier[Symbol.toPrimitive] = $1b34c64db5454254$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $1b34c64db5454254$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $gNKV7(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $8byr2(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $1b34c64db5454254$var$$exec(value, /** @type {unknown} */ $1b34c64db5454254$var$badStringifier);
        } catch (e) {
            return e === $1b34c64db5454254$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $1b34c64db5454254$var$$toString = $eC3A3('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $1b34c64db5454254$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $1b34c64db5454254$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $1b34c64db5454254$var$$toString(value) === $1b34c64db5454254$var$regexClass;
    };
}
module.exports = $1b34c64db5454254$var$fn;

});


parcelRegister("9PEkm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $47a2ef17a37c7dc7$export$2e2bcd8739ae039; });

var $44bcj = parcelRequire("44bcj");
var /** @type {import('./index.d.mts').default} */ $47a2ef17a37c7dc7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($44bcj)));

});
parcelRegister("44bcj", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $2f6038bd01dc2b99$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$2f6038bd01dc2b99$var$cached;

});



parcelRegister("3y8Uz", function(module, exports) {
'use strict';

var $4t3RV = parcelRequire("4t3RV");

var $gxzn4 = parcelRequire("gxzn4");

var $e6nwk = parcelRequire("e6nwk");

var $eC3A3 = parcelRequire("eC3A3");

var $gNKV7 = parcelRequire("gNKV7");

var $b7uaR = parcelRequire("b7uaR");
var $295b75af42290f89$var$$toString = $eC3A3('Object.prototype.toString');

var $295b75af42290f89$var$hasToStringTag = (parcelRequire("1Zhkx"))();
var $295b75af42290f89$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $295b75af42290f89$var$typedArrays = $gxzn4();
var $295b75af42290f89$var$$slice = $eC3A3('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $295b75af42290f89$var$$indexOf = $eC3A3('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $295b75af42290f89$var$cache = {
    __proto__: null
};
if ($295b75af42290f89$var$hasToStringTag && $gNKV7 && $b7uaR) $4t3RV($295b75af42290f89$var$typedArrays, function(typedArray) {
    var arr = new $295b75af42290f89$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $b7uaR) {
        var proto = $b7uaR(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $gNKV7(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $b7uaR(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $gNKV7(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $295b75af42290f89$var$cache['$' + typedArray] = $e6nwk(descriptor.get);
    }
});
else $4t3RV($295b75af42290f89$var$typedArrays, function(typedArray) {
    var arr = new $295b75af42290f89$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $295b75af42290f89$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $e6nwk(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $295b75af42290f89$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $4t3RV(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $295b75af42290f89$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $295b75af42290f89$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $295b75af42290f89$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $4t3RV(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $295b75af42290f89$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $295b75af42290f89$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$295b75af42290f89$var$hasToStringTag) {
        /** @type {string} */ var tag = $295b75af42290f89$var$$slice($295b75af42290f89$var$$toString(value), 8, -1);
        if ($295b75af42290f89$var$$indexOf($295b75af42290f89$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $295b75af42290f89$var$trySlices(value);
    }
    if (!$gNKV7) return null;
     // unknown engine
    return $295b75af42290f89$var$tryTypedArrays(value);
};

});
parcelRegister("4t3RV", function(module, exports) {
'use strict';

var $jUn8P = parcelRequire("jUn8P");
var $340cdf18336e158b$var$toStr = Object.prototype.toString;
var $340cdf18336e158b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $340cdf18336e158b$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($340cdf18336e158b$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $340cdf18336e158b$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $340cdf18336e158b$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($340cdf18336e158b$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $340cdf18336e158b$var$isArray(x) {
    return $340cdf18336e158b$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$jUn8P(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($340cdf18336e158b$var$isArray(list)) $340cdf18336e158b$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $340cdf18336e158b$var$forEachString(list, iterator, receiver);
    else $340cdf18336e158b$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("jUn8P", function(module, exports) {
'use strict';
var $e7e532a9f9e12dda$var$fnToStr = Function.prototype.toString;
var $e7e532a9f9e12dda$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $e7e532a9f9e12dda$var$badArrayLike;
var $e7e532a9f9e12dda$var$isCallableMarker;
if (typeof $e7e532a9f9e12dda$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $e7e532a9f9e12dda$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $e7e532a9f9e12dda$var$isCallableMarker;
        }
    });
    $e7e532a9f9e12dda$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $e7e532a9f9e12dda$var$reflectApply(function() {
        throw 42;
    }, null, $e7e532a9f9e12dda$var$badArrayLike);
} catch (_) {
    if (_ !== $e7e532a9f9e12dda$var$isCallableMarker) $e7e532a9f9e12dda$var$reflectApply = null;
}
else $e7e532a9f9e12dda$var$reflectApply = null;
var $e7e532a9f9e12dda$var$constructorRegex = /^\s*class\b/;
var $e7e532a9f9e12dda$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $e7e532a9f9e12dda$var$fnToStr.call(value);
        return $e7e532a9f9e12dda$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $e7e532a9f9e12dda$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($e7e532a9f9e12dda$var$isES6ClassFn(value)) return false;
        $e7e532a9f9e12dda$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $e7e532a9f9e12dda$var$toStr = Object.prototype.toString;
var $e7e532a9f9e12dda$var$objectClass = '[object Object]';
var $e7e532a9f9e12dda$var$fnClass = '[object Function]';
var $e7e532a9f9e12dda$var$genClass = '[object GeneratorFunction]';
var $e7e532a9f9e12dda$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $e7e532a9f9e12dda$var$ddaClass2 = '[object HTML document.all class]';
var $e7e532a9f9e12dda$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $e7e532a9f9e12dda$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $e7e532a9f9e12dda$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $e7e532a9f9e12dda$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $e7e532a9f9e12dda$var$all = document.all;
    if ($e7e532a9f9e12dda$var$toStr.call($e7e532a9f9e12dda$var$all) === $e7e532a9f9e12dda$var$toStr.call(document.all)) $e7e532a9f9e12dda$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($e7e532a9f9e12dda$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $e7e532a9f9e12dda$var$toStr.call(value);
            return (str === $e7e532a9f9e12dda$var$ddaClass || str === $e7e532a9f9e12dda$var$ddaClass2 || str === $e7e532a9f9e12dda$var$ddaClass3 // opera 12.16
             || str === $e7e532a9f9e12dda$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $e7e532a9f9e12dda$var$reflectApply ? function isCallable(value) {
    if ($e7e532a9f9e12dda$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $e7e532a9f9e12dda$var$reflectApply(value, null, $e7e532a9f9e12dda$var$badArrayLike);
    } catch (e) {
        if (e !== $e7e532a9f9e12dda$var$isCallableMarker) return false;
    }
    return !$e7e532a9f9e12dda$var$isES6ClassFn(value) && $e7e532a9f9e12dda$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($e7e532a9f9e12dda$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($e7e532a9f9e12dda$var$hasToStringTag) return $e7e532a9f9e12dda$var$tryFunctionObject(value);
    if ($e7e532a9f9e12dda$var$isES6ClassFn(value)) return false;
    var strClass = $e7e532a9f9e12dda$var$toStr.call(value);
    if (strClass !== $e7e532a9f9e12dda$var$fnClass && strClass !== $e7e532a9f9e12dda$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $e7e532a9f9e12dda$var$tryFunctionObject(value);
};

});


parcelRegister("gxzn4", function(module, exports) {
'use strict';

var $9nxil = parcelRequire("9nxil");
var $c0ab2a592dd1c9f4$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $9nxil.length; i++)if (typeof $c0ab2a592dd1c9f4$var$g[$9nxil[i]] === 'function') // @ts-expect-error
    out[out.length] = $9nxil[i];
    return out;
};

});
parcelRegister("9nxil", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("e6nwk", function(module, exports) {
'use strict';

var $5i5al = parcelRequire("5i5al");

var $bKXTU = parcelRequire("bKXTU");

var $593ev = parcelRequire("593ev");

var $02PIM = parcelRequire("02PIM");
module.exports = function callBind(originalFunction) {
    var func = $593ev(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $5i5al(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($bKXTU) $bKXTU(module.exports, 'apply', {
    value: $02PIM
});
else module.exports.apply = $02PIM;

});
parcelRegister("5i5al", function(module, exports) {
'use strict';

var $hkNzn = parcelRequire("hkNzn");

var $g8VEL = parcelRequire("g8VEL");

var $3da2a40616138e3d$var$hasDescriptors = (parcelRequire("iSORN"))();

var $gNKV7 = parcelRequire("gNKV7");

var $5Xz8R = parcelRequire("5Xz8R");
var $3da2a40616138e3d$var$$floor = $hkNzn('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $5Xz8R('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $3da2a40616138e3d$var$$floor(length) !== length) throw new $5Xz8R('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $gNKV7) {
        var desc = $gNKV7(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($3da2a40616138e3d$var$hasDescriptors) $g8VEL(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $g8VEL(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("g8VEL", function(module, exports) {
'use strict';

var $bKXTU = parcelRequire("bKXTU");

var $bw8YX = parcelRequire("bw8YX");

var $5Xz8R = parcelRequire("5Xz8R");

var $gNKV7 = parcelRequire("gNKV7");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $5Xz8R('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $5Xz8R('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $5Xz8R('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $5Xz8R('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $5Xz8R('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $5Xz8R('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$gNKV7 && $gNKV7(obj, property);
    if ($bKXTU) $bKXTU(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $bw8YX('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("iSORN", function(module, exports) {
'use strict';

var $bKXTU = parcelRequire("bKXTU");
var $dbf4ba30baa712f1$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$bKXTU;
};
$dbf4ba30baa712f1$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$bKXTU) return null;
    try {
        return $bKXTU([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $dbf4ba30baa712f1$var$hasPropertyDescriptors;

});


parcelRegister("02PIM", function(module, exports) {
'use strict';

var $eQ7C3 = parcelRequire("eQ7C3");

var $aYzei = parcelRequire("aYzei");

var $04tsO = parcelRequire("04tsO");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $04tsO($eQ7C3, $aYzei, arguments);
};

});



parcelRegister("3v1VX", function(module, exports) {
'use strict';

var $3y8Uz = parcelRequire("3y8Uz");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$3y8Uz(value);
};

});


parcelRegister("15hNQ", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});



parcelRegister("gUhMZ", function(module, exports) {

var $2ounp = parcelRequire("2ounp");

var $838j1 = parcelRequire("838j1");
var $c4efacd6ddafd7d8$require$Buffer = $838j1.Buffer;

var $6AcGf = parcelRequire("6AcGf");

var $9YAY5 = parcelRequire("9YAY5");

var $5LV4O = parcelRequire("5LV4O");
var $c4efacd6ddafd7d8$var$MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".';
var $c4efacd6ddafd7d8$var$MSG_INVALID_SECRET = 'secret must be a string or buffer';
var $c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY = 'key must be a string or a buffer';
var $c4efacd6ddafd7d8$var$MSG_INVALID_SIGNER_KEY = 'key must be a string, a buffer or an object';
var $c4efacd6ddafd7d8$var$supportsKeyObjects = typeof $6AcGf.createPublicKey === 'function';
if ($c4efacd6ddafd7d8$var$supportsKeyObjects) {
    $c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY += ' or a KeyObject';
    $c4efacd6ddafd7d8$var$MSG_INVALID_SECRET += 'or a KeyObject';
}
function $c4efacd6ddafd7d8$var$checkIsPublicKey(key) {
    if ($c4efacd6ddafd7d8$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return;
    if (!$c4efacd6ddafd7d8$var$supportsKeyObjects) throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key !== 'object') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.type !== 'string') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.asymmetricKeyType !== 'string') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.export !== 'function') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY);
}
function $c4efacd6ddafd7d8$var$checkIsPrivateKey(key) {
    if ($c4efacd6ddafd7d8$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return;
    if (typeof key === 'object') return;
    throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_SIGNER_KEY);
}
function $c4efacd6ddafd7d8$var$checkIsSecretKey(key) {
    if ($c4efacd6ddafd7d8$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return key;
    if (!$c4efacd6ddafd7d8$var$supportsKeyObjects) throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_SECRET);
    if (typeof key !== 'object') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_SECRET);
    if (key.type !== 'secret') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_SECRET);
    if (typeof key.export !== 'function') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_SECRET);
}
function $c4efacd6ddafd7d8$var$fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $c4efacd6ddafd7d8$var$toBase64(base64url) {
    base64url = base64url.toString();
    var padding = 4 - base64url.length % 4;
    if (padding !== 4) for(var i = 0; i < padding; ++i)base64url += '=';
    return base64url.replace(/\-/g, '+').replace(/_/g, '/');
}
function $c4efacd6ddafd7d8$var$typeError(template) {
    var args = [].slice.call(arguments, 1);
    var errMsg = $5LV4O.format.bind($5LV4O, template).apply(null, args);
    return new TypeError(errMsg);
}
function $c4efacd6ddafd7d8$var$bufferOrString(obj) {
    return $c4efacd6ddafd7d8$require$Buffer.isBuffer(obj) || typeof obj === 'string';
}
function $c4efacd6ddafd7d8$var$normalizeInput(thing) {
    if (!$c4efacd6ddafd7d8$var$bufferOrString(thing)) thing = JSON.stringify(thing);
    return thing;
}
function $c4efacd6ddafd7d8$var$createHmacSigner(bits) {
    return function sign(thing, secret) {
        $c4efacd6ddafd7d8$var$checkIsSecretKey(secret);
        thing = $c4efacd6ddafd7d8$var$normalizeInput(thing);
        var hmac = $6AcGf.createHmac('sha' + bits, secret);
        var sig = (hmac.update(thing), hmac.digest('base64'));
        return $c4efacd6ddafd7d8$var$fromBase64(sig);
    };
}
function $c4efacd6ddafd7d8$var$createHmacVerifier(bits) {
    return function verify(thing, signature, secret) {
        var computedSig = $c4efacd6ddafd7d8$var$createHmacSigner(bits)(thing, secret);
        return $2ounp($c4efacd6ddafd7d8$require$Buffer.from(signature), $c4efacd6ddafd7d8$require$Buffer.from(computedSig));
    };
}
function $c4efacd6ddafd7d8$var$createKeySigner(bits) {
    return function sign(thing, privateKey) {
        $c4efacd6ddafd7d8$var$checkIsPrivateKey(privateKey);
        thing = $c4efacd6ddafd7d8$var$normalizeInput(thing);
        // Even though we are specifying "RSA" here, this works with ECDSA
        // keys as well.
        var signer = $6AcGf.createSign('RSA-SHA' + bits);
        var sig = (signer.update(thing), signer.sign(privateKey, 'base64'));
        return $c4efacd6ddafd7d8$var$fromBase64(sig);
    };
}
function $c4efacd6ddafd7d8$var$createKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $c4efacd6ddafd7d8$var$checkIsPublicKey(publicKey);
        thing = $c4efacd6ddafd7d8$var$normalizeInput(thing);
        signature = $c4efacd6ddafd7d8$var$toBase64(signature);
        var verifier = $6AcGf.createVerify('RSA-SHA' + bits);
        verifier.update(thing);
        return verifier.verify(publicKey, signature, 'base64');
    };
}
function $c4efacd6ddafd7d8$var$createPSSKeySigner(bits) {
    return function sign(thing, privateKey) {
        $c4efacd6ddafd7d8$var$checkIsPrivateKey(privateKey);
        thing = $c4efacd6ddafd7d8$var$normalizeInput(thing);
        var signer = $6AcGf.createSign('RSA-SHA' + bits);
        var sig = (signer.update(thing), signer.sign({
            key: privateKey,
            padding: $6AcGf.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $6AcGf.constants.RSA_PSS_SALTLEN_DIGEST
        }, 'base64'));
        return $c4efacd6ddafd7d8$var$fromBase64(sig);
    };
}
function $c4efacd6ddafd7d8$var$createPSSKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $c4efacd6ddafd7d8$var$checkIsPublicKey(publicKey);
        thing = $c4efacd6ddafd7d8$var$normalizeInput(thing);
        signature = $c4efacd6ddafd7d8$var$toBase64(signature);
        var verifier = $6AcGf.createVerify('RSA-SHA' + bits);
        verifier.update(thing);
        return verifier.verify({
            key: publicKey,
            padding: $6AcGf.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $6AcGf.constants.RSA_PSS_SALTLEN_DIGEST
        }, signature, 'base64');
    };
}
function $c4efacd6ddafd7d8$var$createECDSASigner(bits) {
    var inner = $c4efacd6ddafd7d8$var$createKeySigner(bits);
    return function sign() {
        var signature = inner.apply(null, arguments);
        signature = $9YAY5.derToJose(signature, 'ES' + bits);
        return signature;
    };
}
function $c4efacd6ddafd7d8$var$createECDSAVerifer(bits) {
    var inner = $c4efacd6ddafd7d8$var$createKeyVerifier(bits);
    return function verify(thing, signature, publicKey) {
        signature = $9YAY5.joseToDer(signature, 'ES' + bits).toString('base64');
        var result = inner(thing, signature, publicKey);
        return result;
    };
}
function $c4efacd6ddafd7d8$var$createNoneSigner() {
    return function sign() {
        return '';
    };
}
function $c4efacd6ddafd7d8$var$createNoneVerifier() {
    return function verify(thing, signature) {
        return signature === '';
    };
}
module.exports = function jwa(algorithm) {
    var signerFactories = {
        hs: $c4efacd6ddafd7d8$var$createHmacSigner,
        rs: $c4efacd6ddafd7d8$var$createKeySigner,
        ps: $c4efacd6ddafd7d8$var$createPSSKeySigner,
        es: $c4efacd6ddafd7d8$var$createECDSASigner,
        none: $c4efacd6ddafd7d8$var$createNoneSigner
    };
    var verifierFactories = {
        hs: $c4efacd6ddafd7d8$var$createHmacVerifier,
        rs: $c4efacd6ddafd7d8$var$createKeyVerifier,
        ps: $c4efacd6ddafd7d8$var$createPSSKeyVerifier,
        es: $c4efacd6ddafd7d8$var$createECDSAVerifer,
        none: $c4efacd6ddafd7d8$var$createNoneVerifier
    };
    var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/i);
    if (!match) throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_ALGORITHM, algorithm);
    var algo = (match[1] || match[3]).toLowerCase();
    var bits = match[2];
    return {
        sign: signerFactories[algo](bits),
        verify: verifierFactories[algo](bits)
    };
};

});
parcelRegister("2ounp", function(module, exports) {
/*jshint node:true */ 'use strict';

var $bdjQ6 = parcelRequire("bdjQ6");
var $1be562d14bdb385f$require$Buffer = $bdjQ6.Buffer;

var $bdjQ6 = parcelRequire("bdjQ6");
var $1be562d14bdb385f$require$SlowBuffer = $bdjQ6.SlowBuffer;
module.exports = $1be562d14bdb385f$var$bufferEq;
function $1be562d14bdb385f$var$bufferEq(a, b) {
    // shortcutting on type is necessary for correctness
    if (!$1be562d14bdb385f$require$Buffer.isBuffer(a) || !$1be562d14bdb385f$require$Buffer.isBuffer(b)) return false;
    // buffer sizes should be well-known information, so despite this
    // shortcutting, it doesn't leak any information about the *contents* of the
    // buffers.
    if (a.length !== b.length) return false;
    var c = 0;
    for(var i = 0; i < a.length; i++)/*jshint bitwise:false */ c |= a[i] ^ b[i]; // XOR
    return c === 0;
}
$1be562d14bdb385f$var$bufferEq.install = function() {
    $1be562d14bdb385f$require$Buffer.prototype.equal = $1be562d14bdb385f$require$SlowBuffer.prototype.equal = function equal(that) {
        return $1be562d14bdb385f$var$bufferEq(this, that);
    };
};
var $1be562d14bdb385f$var$origBufEqual = $1be562d14bdb385f$require$Buffer.prototype.equal;
var $1be562d14bdb385f$var$origSlowBufEqual = $1be562d14bdb385f$require$SlowBuffer.prototype.equal;
$1be562d14bdb385f$var$bufferEq.restore = function() {
    $1be562d14bdb385f$require$Buffer.prototype.equal = $1be562d14bdb385f$var$origBufEqual;
    $1be562d14bdb385f$require$SlowBuffer.prototype.equal = $1be562d14bdb385f$var$origSlowBufEqual;
};

});

parcelRegister("6AcGf", function(module, exports) {

$parcel$export(module.exports, "createHmac", function () { return $4caff0eaeff97cc6$export$da39cf97e1eb7c91; }, function (v) { return $4caff0eaeff97cc6$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "createSign", function () { return $4caff0eaeff97cc6$export$45df7cae684751af; }, function (v) { return $4caff0eaeff97cc6$export$45df7cae684751af = v; });
$parcel$export(module.exports, "createVerify", function () { return $4caff0eaeff97cc6$export$6f65485f87568e37; }, function (v) { return $4caff0eaeff97cc6$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "constants", function () { return $4caff0eaeff97cc6$export$1a988e7317c65621; }, function (v) { return $4caff0eaeff97cc6$export$1a988e7317c65621 = v; });
// eslint-disable-next-line no-multi-assign
var $4caff0eaeff97cc6$export$5f828d93ff035aa8;
var $4caff0eaeff97cc6$export$cd94982b18c6332c;
var $4caff0eaeff97cc6$export$1d518568e4f529b0;
var $4caff0eaeff97cc6$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $4caff0eaeff97cc6$export$2fb37efbf6ae0c0e;
var $4caff0eaeff97cc6$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $4caff0eaeff97cc6$export$da39cf97e1eb7c91;
var $4caff0eaeff97cc6$export$52a9039d7177394f;
var $4caff0eaeff97cc6$export$f7201db400317331;
var $4caff0eaeff97cc6$export$448fa22aedc9dbca;
var $4caff0eaeff97cc6$export$b80c7ba289c8fa56;
var $4caff0eaeff97cc6$export$26e5786e8ac8e530;
var $4caff0eaeff97cc6$export$bdd223f16383713e;
var $4caff0eaeff97cc6$export$20533d26f07f1ee0;
var $4caff0eaeff97cc6$export$2f64596b8cbf08b4;
var $4caff0eaeff97cc6$export$2ce6d8d0e8b04e1a;
var $4caff0eaeff97cc6$export$12ada9414fbc594c;
var $4caff0eaeff97cc6$export$f5e7e39d57cd9700;
var $4caff0eaeff97cc6$export$36b6d6ef312eab39;
var $4caff0eaeff97cc6$export$58a258485f1e49f6;
var $4caff0eaeff97cc6$export$dedd8dc3dc62b370;
var $4caff0eaeff97cc6$export$971862a2fcb1bb40;
var $4caff0eaeff97cc6$export$c6ff6a88acbeaf40;
var $4caff0eaeff97cc6$export$fdc27893e98845cc;
var $4caff0eaeff97cc6$export$6671fb9a1323bed;
var $4caff0eaeff97cc6$export$d74daf141a551db;
var $4caff0eaeff97cc6$export$45df7cae684751af;
var $4caff0eaeff97cc6$export$1db683ad541682f6;
var $4caff0eaeff97cc6$export$6f65485f87568e37;
var $4caff0eaeff97cc6$export$91a8e56769aeb334;
var $4caff0eaeff97cc6$export$2d4117e99c2179e4;
var $4caff0eaeff97cc6$export$512823e338ddb1b7;
var $4caff0eaeff97cc6$export$9d0e0c0c4a8d30f3;
var $4caff0eaeff97cc6$export$b9d55ff329113abd;
var $4caff0eaeff97cc6$export$7efb24e2fddf99b9;
var $4caff0eaeff97cc6$export$bb1abf2ce84fc7e8;
var $4caff0eaeff97cc6$export$2f7171e78e524d5e;
var $4caff0eaeff97cc6$export$e1d879b482f37d98;
var $4caff0eaeff97cc6$export$1a988e7317c65621;
'use strict';

$4caff0eaeff97cc6$export$5f828d93ff035aa8 = $4caff0eaeff97cc6$export$cd94982b18c6332c = $4caff0eaeff97cc6$export$1d518568e4f529b0 = $4caff0eaeff97cc6$export$5285b6d41c912b41 = (parcelRequire("f08he"));

$4caff0eaeff97cc6$export$2fb37efbf6ae0c0e = $4caff0eaeff97cc6$export$ab85ecd77ce6a5cd = (parcelRequire("eNPUV"));

$4caff0eaeff97cc6$export$da39cf97e1eb7c91 = $4caff0eaeff97cc6$export$52a9039d7177394f = (parcelRequire("cL3Ff"));

var $bci9C = parcelRequire("bci9C");
var $4caff0eaeff97cc6$var$algoKeys = Object.keys($bci9C);
var $4caff0eaeff97cc6$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($4caff0eaeff97cc6$var$algoKeys);
$4caff0eaeff97cc6$export$f7201db400317331 = function() {
    return $4caff0eaeff97cc6$var$hashes;
};

var $d0xYH = parcelRequire("d0xYH");
$4caff0eaeff97cc6$export$448fa22aedc9dbca = $d0xYH.pbkdf2;
$4caff0eaeff97cc6$export$b80c7ba289c8fa56 = $d0xYH.pbkdf2Sync;

var $jGT0o = parcelRequire("jGT0o");
$4caff0eaeff97cc6$export$26e5786e8ac8e530 = $jGT0o.Cipher;
$4caff0eaeff97cc6$export$bdd223f16383713e = $jGT0o.createCipher;
$4caff0eaeff97cc6$export$20533d26f07f1ee0 = $jGT0o.Cipheriv;
$4caff0eaeff97cc6$export$2f64596b8cbf08b4 = $jGT0o.createCipheriv;
$4caff0eaeff97cc6$export$2ce6d8d0e8b04e1a = $jGT0o.Decipher;
$4caff0eaeff97cc6$export$12ada9414fbc594c = $jGT0o.createDecipher;
$4caff0eaeff97cc6$export$f5e7e39d57cd9700 = $jGT0o.Decipheriv;
$4caff0eaeff97cc6$export$36b6d6ef312eab39 = $jGT0o.createDecipheriv;
$4caff0eaeff97cc6$export$58a258485f1e49f6 = $jGT0o.getCiphers;
$4caff0eaeff97cc6$export$dedd8dc3dc62b370 = $jGT0o.listCiphers;

var $8wQsp = parcelRequire("8wQsp");
$4caff0eaeff97cc6$export$971862a2fcb1bb40 = $8wQsp.DiffieHellmanGroup;
$4caff0eaeff97cc6$export$c6ff6a88acbeaf40 = $8wQsp.createDiffieHellmanGroup;
$4caff0eaeff97cc6$export$fdc27893e98845cc = $8wQsp.getDiffieHellman;
$4caff0eaeff97cc6$export$6671fb9a1323bed = $8wQsp.createDiffieHellman;
$4caff0eaeff97cc6$export$d74daf141a551db = $8wQsp.DiffieHellman;

var $bASYu = parcelRequire("bASYu");
$4caff0eaeff97cc6$export$45df7cae684751af = $bASYu.createSign;
$4caff0eaeff97cc6$export$1db683ad541682f6 = $bASYu.Sign;
$4caff0eaeff97cc6$export$6f65485f87568e37 = $bASYu.createVerify;
$4caff0eaeff97cc6$export$91a8e56769aeb334 = $bASYu.Verify;

$4caff0eaeff97cc6$export$2d4117e99c2179e4 = (parcelRequire("iT16E"));

var $estFo = parcelRequire("estFo");
$4caff0eaeff97cc6$export$512823e338ddb1b7 = $estFo.publicEncrypt;
$4caff0eaeff97cc6$export$9d0e0c0c4a8d30f3 = $estFo.privateEncrypt;
$4caff0eaeff97cc6$export$b9d55ff329113abd = $estFo.publicDecrypt;
$4caff0eaeff97cc6$export$7efb24e2fddf99b9 = $estFo.privateDecrypt;

var $3yLuA = parcelRequire("3yLuA");
$4caff0eaeff97cc6$export$bb1abf2ce84fc7e8 = $3yLuA.randomFill;
$4caff0eaeff97cc6$export$2f7171e78e524d5e = $3yLuA.randomFillSync;
$4caff0eaeff97cc6$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$4caff0eaeff97cc6$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("f08he", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $aebd46b710a95c96$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $aebd46b710a95c96$var$MAX_UINT32 = 4294967295;
function $aebd46b710a95c96$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $838j1 = parcelRequire("838j1");
var $aebd46b710a95c96$require$Buffer = $838j1.Buffer;
var $aebd46b710a95c96$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($aebd46b710a95c96$var$crypto && $aebd46b710a95c96$var$crypto.getRandomValues) module.exports = $aebd46b710a95c96$var$randomBytes;
else module.exports = $aebd46b710a95c96$var$oldBrowser;
function $aebd46b710a95c96$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $aebd46b710a95c96$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $aebd46b710a95c96$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $aebd46b710a95c96$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $aebd46b710a95c96$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $aebd46b710a95c96$var$crypto.getRandomValues(bytes.slice(generated, generated + $aebd46b710a95c96$var$MAX_BYTES));
        else $aebd46b710a95c96$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $4ZL0H.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("eNPUV", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $2GAk4 = parcelRequire("2GAk4");

var $1Jsb3 = parcelRequire("1Jsb3");

var $15EwC = parcelRequire("15EwC");

var $6GOuC = parcelRequire("6GOuC");
function $ac6de9f97af53a66$var$Hash(hash) {
    $6GOuC.call(this, 'digest');
    this._hash = hash;
}
$dhT4G($ac6de9f97af53a66$var$Hash, $6GOuC);
$ac6de9f97af53a66$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$ac6de9f97af53a66$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $2GAk4();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $1Jsb3();
    return new $ac6de9f97af53a66$var$Hash($15EwC(alg));
};

});
parcelRegister("2GAk4", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $fMFLx = parcelRequire("fMFLx");

var $838j1 = parcelRequire("838j1");
var $1f4badf6a671bb38$require$Buffer = $838j1.Buffer;
var $1f4badf6a671bb38$var$ARRAY16 = new Array(16);
function $1f4badf6a671bb38$var$MD5() {
    $fMFLx.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dhT4G($1f4badf6a671bb38$var$MD5, $fMFLx);
$1f4badf6a671bb38$var$MD5.prototype._update = function() {
    var M = $1f4badf6a671bb38$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $1f4badf6a671bb38$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $1f4badf6a671bb38$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $1f4badf6a671bb38$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $1f4badf6a671bb38$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $1f4badf6a671bb38$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $1f4badf6a671bb38$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $1f4badf6a671bb38$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $1f4badf6a671bb38$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $1f4badf6a671bb38$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $1f4badf6a671bb38$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $1f4badf6a671bb38$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $1f4badf6a671bb38$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $1f4badf6a671bb38$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $1f4badf6a671bb38$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $1f4badf6a671bb38$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $1f4badf6a671bb38$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $1f4badf6a671bb38$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $1f4badf6a671bb38$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $1f4badf6a671bb38$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $1f4badf6a671bb38$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $1f4badf6a671bb38$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $1f4badf6a671bb38$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $1f4badf6a671bb38$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $1f4badf6a671bb38$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $1f4badf6a671bb38$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $1f4badf6a671bb38$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $1f4badf6a671bb38$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $1f4badf6a671bb38$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $1f4badf6a671bb38$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $1f4badf6a671bb38$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $1f4badf6a671bb38$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $1f4badf6a671bb38$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $1f4badf6a671bb38$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $1f4badf6a671bb38$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $1f4badf6a671bb38$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $1f4badf6a671bb38$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $1f4badf6a671bb38$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $1f4badf6a671bb38$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $1f4badf6a671bb38$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $1f4badf6a671bb38$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $1f4badf6a671bb38$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $1f4badf6a671bb38$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $1f4badf6a671bb38$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $1f4badf6a671bb38$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $1f4badf6a671bb38$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $1f4badf6a671bb38$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $1f4badf6a671bb38$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $1f4badf6a671bb38$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $1f4badf6a671bb38$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $1f4badf6a671bb38$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $1f4badf6a671bb38$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $1f4badf6a671bb38$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $1f4badf6a671bb38$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $1f4badf6a671bb38$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $1f4badf6a671bb38$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $1f4badf6a671bb38$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $1f4badf6a671bb38$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $1f4badf6a671bb38$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $1f4badf6a671bb38$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $1f4badf6a671bb38$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $1f4badf6a671bb38$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $1f4badf6a671bb38$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $1f4badf6a671bb38$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $1f4badf6a671bb38$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$1f4badf6a671bb38$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $1f4badf6a671bb38$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $1f4badf6a671bb38$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $1f4badf6a671bb38$var$fnF(a, b, c, d, m, k, s) {
    return $1f4badf6a671bb38$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $1f4badf6a671bb38$var$fnG(a, b, c, d, m, k, s) {
    return $1f4badf6a671bb38$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $1f4badf6a671bb38$var$fnH(a, b, c, d, m, k, s) {
    return $1f4badf6a671bb38$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $1f4badf6a671bb38$var$fnI(a, b, c, d, m, k, s) {
    return $1f4badf6a671bb38$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $1f4badf6a671bb38$var$MD5;

});
parcelRegister("fMFLx", function(module, exports) {
'use strict';

var $h9ueh = parcelRequire("h9ueh");
var $b7dbbc848410cd66$require$Buffer = $h9ueh.Buffer;

var $3DkjE = parcelRequire("3DkjE");
var $b7dbbc848410cd66$require$Transform = $3DkjE.Transform;

var $dhT4G = parcelRequire("dhT4G");
function $b7dbbc848410cd66$var$HashBase(blockSize) {
    $b7dbbc848410cd66$require$Transform.call(this);
    this._block = $b7dbbc848410cd66$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dhT4G($b7dbbc848410cd66$var$HashBase, $b7dbbc848410cd66$require$Transform);
$b7dbbc848410cd66$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$b7dbbc848410cd66$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $b7dbbc848410cd66$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $b7dbbc848410cd66$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($b7dbbc848410cd66$require$Buffer.prototype instanceof Uint8Array || $b7dbbc848410cd66$require$Buffer.TYPED_ARRAY_SUPPORT);
function $b7dbbc848410cd66$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $b7dbbc848410cd66$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $b7dbbc848410cd66$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($b7dbbc848410cd66$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $b7dbbc848410cd66$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $b7dbbc848410cd66$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($b7dbbc848410cd66$var$useUint8Array && data instanceof Uint8Array) return $b7dbbc848410cd66$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($b7dbbc848410cd66$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $b7dbbc848410cd66$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$b7dbbc848410cd66$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $b7dbbc848410cd66$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$b7dbbc848410cd66$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$b7dbbc848410cd66$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$b7dbbc848410cd66$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $b7dbbc848410cd66$var$HashBase;

});
parcelRegister("h9ueh", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $c7cab9d44ebbb814$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $c7cab9d44ebbb814$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($c7cab9d44ebbb814$var$Buffer.from && $c7cab9d44ebbb814$var$Buffer.alloc && $c7cab9d44ebbb814$var$Buffer.allocUnsafe && $c7cab9d44ebbb814$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $c7cab9d44ebbb814$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $c7cab9d44ebbb814$var$SafeBuffer;
}
function $c7cab9d44ebbb814$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $c7cab9d44ebbb814$var$Buffer(arg, encodingOrOffset, length);
}
$c7cab9d44ebbb814$var$SafeBuffer.prototype = Object.create($c7cab9d44ebbb814$var$Buffer.prototype);
// Copy static methods from Buffer
$c7cab9d44ebbb814$var$copyProps($c7cab9d44ebbb814$var$Buffer, $c7cab9d44ebbb814$var$SafeBuffer);
$c7cab9d44ebbb814$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $c7cab9d44ebbb814$var$Buffer(arg, encodingOrOffset, length);
};
$c7cab9d44ebbb814$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $c7cab9d44ebbb814$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$c7cab9d44ebbb814$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $c7cab9d44ebbb814$var$Buffer(size);
};
$c7cab9d44ebbb814$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});



parcelRegister("1Jsb3", function(module, exports) {
'use strict';

var $bdjQ6 = parcelRequire("bdjQ6");
var $142fd9dc489aa108$require$Buffer = $bdjQ6.Buffer;

var $dhT4G = parcelRequire("dhT4G");

var $lV0fd = parcelRequire("lV0fd");
var $142fd9dc489aa108$var$ARRAY16 = new Array(16);
var $142fd9dc489aa108$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $142fd9dc489aa108$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $142fd9dc489aa108$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $142fd9dc489aa108$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $142fd9dc489aa108$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $142fd9dc489aa108$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $142fd9dc489aa108$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $142fd9dc489aa108$var$fn1(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$fn2(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$fn3(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$fn4(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$fn5(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$RIPEMD160() {
    $lV0fd.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dhT4G($142fd9dc489aa108$var$RIPEMD160, $lV0fd);
$142fd9dc489aa108$var$RIPEMD160.prototype._update = function() {
    var words = $142fd9dc489aa108$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $142fd9dc489aa108$var$fn1(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[0], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn5(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[0], $142fd9dc489aa108$var$sr[i]);
        } else if (i < 32) {
            tl = $142fd9dc489aa108$var$fn2(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[1], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn4(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[1], $142fd9dc489aa108$var$sr[i]);
        } else if (i < 48) {
            tl = $142fd9dc489aa108$var$fn3(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[2], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn3(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[2], $142fd9dc489aa108$var$sr[i]);
        } else if (i < 64) {
            tl = $142fd9dc489aa108$var$fn4(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[3], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn2(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[3], $142fd9dc489aa108$var$sr[i]);
        } else {
            tl = $142fd9dc489aa108$var$fn5(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[4], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn1(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[4], $142fd9dc489aa108$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $142fd9dc489aa108$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $142fd9dc489aa108$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$142fd9dc489aa108$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $142fd9dc489aa108$require$Buffer.alloc ? $142fd9dc489aa108$require$Buffer.alloc(20) : new $142fd9dc489aa108$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $142fd9dc489aa108$var$RIPEMD160;

});
parcelRegister("lV0fd", function(module, exports) {
'use strict';

var $7ldg8 = parcelRequire("7ldg8");
var $ff4f1c6668d95823$require$Buffer = $7ldg8.Buffer;

var $a9qQG = parcelRequire("a9qQG");

var $kZjFb = parcelRequire("kZjFb");
var $ff4f1c6668d95823$require$Transform = $kZjFb.Transform;

var $dhT4G = parcelRequire("dhT4G");
function $ff4f1c6668d95823$var$HashBase(blockSize) {
    $ff4f1c6668d95823$require$Transform.call(this);
    this._block = $ff4f1c6668d95823$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dhT4G($ff4f1c6668d95823$var$HashBase, $ff4f1c6668d95823$require$Transform);
$ff4f1c6668d95823$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$ff4f1c6668d95823$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$ff4f1c6668d95823$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $a9qQG(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$ff4f1c6668d95823$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$ff4f1c6668d95823$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$ff4f1c6668d95823$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $ff4f1c6668d95823$var$HashBase;

});
parcelRegister("7ldg8", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $5584c793bb8777a0$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $5584c793bb8777a0$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($5584c793bb8777a0$var$Buffer.from && $5584c793bb8777a0$var$Buffer.alloc && $5584c793bb8777a0$var$Buffer.allocUnsafe && $5584c793bb8777a0$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $5584c793bb8777a0$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $5584c793bb8777a0$var$SafeBuffer;
}
function $5584c793bb8777a0$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $5584c793bb8777a0$var$Buffer(arg, encodingOrOffset, length);
}
$5584c793bb8777a0$var$SafeBuffer.prototype = Object.create($5584c793bb8777a0$var$Buffer.prototype);
// Copy static methods from Buffer
$5584c793bb8777a0$var$copyProps($5584c793bb8777a0$var$Buffer, $5584c793bb8777a0$var$SafeBuffer);
$5584c793bb8777a0$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $5584c793bb8777a0$var$Buffer(arg, encodingOrOffset, length);
};
$5584c793bb8777a0$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $5584c793bb8777a0$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$5584c793bb8777a0$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $5584c793bb8777a0$var$Buffer(size);
};
$5584c793bb8777a0$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});

parcelRegister("a9qQG", function(module, exports) {
'use strict';

var $7ldg8 = parcelRequire("7ldg8");
var $763f923ff3649c26$require$Buffer = $7ldg8.Buffer;

var $iDFZs = parcelRequire("iDFZs");
var $763f923ff3649c26$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $763f923ff3649c26$var$useArrayBuffer = $763f923ff3649c26$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $763f923ff3649c26$var$isView = $763f923ff3649c26$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $763f923ff3649c26$require$Buffer.isBuffer(thing) || $763f923ff3649c26$var$useUint8Array && thing instanceof Uint8Array || $763f923ff3649c26$var$isView && $763f923ff3649c26$var$isView(thing)) return $iDFZs(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("iDFZs", function(module, exports) {
'use strict';

var $39XI5 = parcelRequire("39XI5");
var $d91c70e90d0fdaa9$require$Buffer = $39XI5.Buffer;

var $gzvFb = parcelRequire("gzvFb");

var $awmI8 = parcelRequire("awmI8");
var $d91c70e90d0fdaa9$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $awmI8(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $d91c70e90d0fdaa9$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $d91c70e90d0fdaa9$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $d91c70e90d0fdaa9$var$useFromArrayBuffer = $d91c70e90d0fdaa9$var$useArrayBuffer && ($d91c70e90d0fdaa9$require$Buffer.prototype instanceof Uint8Array || $d91c70e90d0fdaa9$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($d91c70e90d0fdaa9$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $d91c70e90d0fdaa9$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $d91c70e90d0fdaa9$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($d91c70e90d0fdaa9$var$useArrayBuffer && $d91c70e90d0fdaa9$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $d91c70e90d0fdaa9$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($d91c70e90d0fdaa9$var$useFromArrayBuffer) {
            var res = $d91c70e90d0fdaa9$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $d91c70e90d0fdaa9$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($d91c70e90d0fdaa9$var$useUint8Array && data instanceof Uint8Array) return $d91c70e90d0fdaa9$require$Buffer.from(data);
    var isArr = $gzvFb(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $d91c70e90d0fdaa9$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $d91c70e90d0fdaa9$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("39XI5", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $24d0878c9ac7e286$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $24d0878c9ac7e286$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($24d0878c9ac7e286$var$Buffer.from && $24d0878c9ac7e286$var$Buffer.alloc && $24d0878c9ac7e286$var$Buffer.allocUnsafe && $24d0878c9ac7e286$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $24d0878c9ac7e286$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $24d0878c9ac7e286$var$SafeBuffer;
}
function $24d0878c9ac7e286$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $24d0878c9ac7e286$var$Buffer(arg, encodingOrOffset, length);
}
$24d0878c9ac7e286$var$SafeBuffer.prototype = Object.create($24d0878c9ac7e286$var$Buffer.prototype);
// Copy static methods from Buffer
$24d0878c9ac7e286$var$copyProps($24d0878c9ac7e286$var$Buffer, $24d0878c9ac7e286$var$SafeBuffer);
$24d0878c9ac7e286$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $24d0878c9ac7e286$var$Buffer(arg, encodingOrOffset, length);
};
$24d0878c9ac7e286$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $24d0878c9ac7e286$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$24d0878c9ac7e286$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $24d0878c9ac7e286$var$Buffer(size);
};
$24d0878c9ac7e286$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});

parcelRegister("gzvFb", function(module, exports) {
var $c10879e6d2766179$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $c10879e6d2766179$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("awmI8", function(module, exports) {
'use strict';

var $5Xz8R = parcelRequire("5Xz8R");

var $eC3A3 = parcelRequire("eC3A3");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $7a8e8270e20ed7b6$var$$typedArrayBuffer = $eC3A3('TypedArray.prototype.buffer', true);

var $3v1VX = parcelRequire("3v1VX");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $7a8e8270e20ed7b6$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$3v1VX(x)) throw new $5Xz8R('Not a Typed Array');
    return x.buffer;
};

});



parcelRegister("kZjFb", function(module, exports) {

exports = module.exports = (parcelRequire("eBpYV"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("72oi4"));

exports.Duplex = (parcelRequire("M8bgE"));

exports.Transform = (parcelRequire("70Df1"));

exports.PassThrough = (parcelRequire("g1x2n"));

});
parcelRegister("eBpYV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ module.exports = $aa18accb4250c423$var$Readable;

var $2f8X5 = parcelRequire("2f8X5");
/*</replacement>*/ /*<replacement>*/ var $aa18accb4250c423$var$Duplex;
/*</replacement>*/ $aa18accb4250c423$var$Readable.ReadableState = $aa18accb4250c423$var$ReadableState;

var $fzCxw = parcelRequire("fzCxw");
var $aa18accb4250c423$require$EE = $fzCxw.EventEmitter;
var $aa18accb4250c423$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $7zYEG = parcelRequire("7zYEG");

var $838j1 = parcelRequire("838j1");
var $aa18accb4250c423$require$Buffer = $838j1.Buffer;
var $aa18accb4250c423$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $aa18accb4250c423$var$_uint8ArrayToBuffer(chunk) {
    return $aa18accb4250c423$require$Buffer.from(chunk);
}
function $aa18accb4250c423$var$_isUint8Array(obj) {
    return $aa18accb4250c423$require$Buffer.isBuffer(obj) || obj instanceof $aa18accb4250c423$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $aa18accb4250c423$var$util = Object.create((parcelRequire("6PLnu")));

$aa18accb4250c423$var$util.inherits = (parcelRequire("dhT4G"));

var $ifbub = parcelRequire("ifbub");
var $aa18accb4250c423$var$debug = void 0;
if ($ifbub && $ifbub.debuglog) $aa18accb4250c423$var$debug = $ifbub.debuglog('stream');
else $aa18accb4250c423$var$debug = function() {};

var $cXpsY = parcelRequire("cXpsY");

var $59kLR = parcelRequire("59kLR");
var $aa18accb4250c423$var$StringDecoder;
$aa18accb4250c423$var$util.inherits($aa18accb4250c423$var$Readable, $7zYEG);
var $aa18accb4250c423$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $aa18accb4250c423$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($2f8X5(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $aa18accb4250c423$var$ReadableState(options, stream) {
    $aa18accb4250c423$var$Duplex = $aa18accb4250c423$var$Duplex || (parcelRequire("M8bgE"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $aa18accb4250c423$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $cXpsY();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$aa18accb4250c423$var$StringDecoder) $aa18accb4250c423$var$StringDecoder = (parcelRequire("3bkX9")).StringDecoder;
        this.decoder = new $aa18accb4250c423$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $aa18accb4250c423$var$Readable(options) {
    $aa18accb4250c423$var$Duplex = $aa18accb4250c423$var$Duplex || (parcelRequire("M8bgE"));
    if (!(this instanceof $aa18accb4250c423$var$Readable)) return new $aa18accb4250c423$var$Readable(options);
    this._readableState = new $aa18accb4250c423$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $7zYEG.call(this);
}
Object.defineProperty($aa18accb4250c423$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$aa18accb4250c423$var$Readable.prototype.destroy = $59kLR.destroy;
$aa18accb4250c423$var$Readable.prototype._undestroy = $59kLR.undestroy;
$aa18accb4250c423$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$aa18accb4250c423$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $aa18accb4250c423$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $aa18accb4250c423$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$aa18accb4250c423$var$Readable.prototype.unshift = function(chunk) {
    return $aa18accb4250c423$var$readableAddChunk(this, chunk, null, true, false);
};
function $aa18accb4250c423$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $aa18accb4250c423$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $aa18accb4250c423$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $aa18accb4250c423$require$Buffer.prototype) chunk = $aa18accb4250c423$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $aa18accb4250c423$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $aa18accb4250c423$var$addChunk(stream, state, chunk, false);
                    else $aa18accb4250c423$var$maybeReadMore(stream, state);
                } else $aa18accb4250c423$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $aa18accb4250c423$var$needMoreData(state);
}
function $aa18accb4250c423$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $aa18accb4250c423$var$emitReadable(stream);
    }
    $aa18accb4250c423$var$maybeReadMore(stream, state);
}
function $aa18accb4250c423$var$chunkInvalid(state, chunk) {
    var er;
    if (!$aa18accb4250c423$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $aa18accb4250c423$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$aa18accb4250c423$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$aa18accb4250c423$var$Readable.prototype.setEncoding = function(enc) {
    if (!$aa18accb4250c423$var$StringDecoder) $aa18accb4250c423$var$StringDecoder = (parcelRequire("3bkX9")).StringDecoder;
    this._readableState.decoder = new $aa18accb4250c423$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $aa18accb4250c423$var$MAX_HWM = 0x800000;
function $aa18accb4250c423$var$computeNewHighWaterMark(n) {
    if (n >= $aa18accb4250c423$var$MAX_HWM) n = $aa18accb4250c423$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $aa18accb4250c423$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $aa18accb4250c423$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$aa18accb4250c423$var$Readable.prototype.read = function(n) {
    $aa18accb4250c423$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $aa18accb4250c423$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $aa18accb4250c423$var$endReadable(this);
        else $aa18accb4250c423$var$emitReadable(this);
        return null;
    }
    n = $aa18accb4250c423$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $aa18accb4250c423$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $aa18accb4250c423$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $aa18accb4250c423$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $aa18accb4250c423$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $aa18accb4250c423$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $aa18accb4250c423$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $aa18accb4250c423$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $aa18accb4250c423$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $aa18accb4250c423$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $aa18accb4250c423$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $aa18accb4250c423$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $aa18accb4250c423$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $e5LkN.nextTick($aa18accb4250c423$var$emitReadable_, stream);
        else $aa18accb4250c423$var$emitReadable_(stream);
    }
}
function $aa18accb4250c423$var$emitReadable_(stream) {
    $aa18accb4250c423$var$debug('emit readable');
    stream.emit('readable');
    $aa18accb4250c423$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $aa18accb4250c423$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $e5LkN.nextTick($aa18accb4250c423$var$maybeReadMore_, stream, state);
    }
}
function $aa18accb4250c423$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $aa18accb4250c423$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$aa18accb4250c423$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$aa18accb4250c423$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $aa18accb4250c423$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4ZL0H.stdout && dest !== $4ZL0H.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $e5LkN.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $aa18accb4250c423$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $aa18accb4250c423$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $aa18accb4250c423$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $aa18accb4250c423$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $aa18accb4250c423$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $aa18accb4250c423$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $aa18accb4250c423$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $aa18accb4250c423$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($aa18accb4250c423$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $aa18accb4250c423$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $aa18accb4250c423$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $aa18accb4250c423$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $aa18accb4250c423$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $aa18accb4250c423$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $aa18accb4250c423$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $aa18accb4250c423$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $aa18accb4250c423$var$flow(src);
        }
    };
}
$aa18accb4250c423$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $aa18accb4250c423$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$aa18accb4250c423$var$Readable.prototype.on = function(ev, fn) {
    var res = $7zYEG.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $e5LkN.nextTick($aa18accb4250c423$var$nReadingNextTick, this);
            else if (state.length) $aa18accb4250c423$var$emitReadable(this);
        }
    }
    return res;
};
$aa18accb4250c423$var$Readable.prototype.addListener = $aa18accb4250c423$var$Readable.prototype.on;
function $aa18accb4250c423$var$nReadingNextTick(self1) {
    $aa18accb4250c423$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$aa18accb4250c423$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $aa18accb4250c423$var$debug('resume');
        state.flowing = true;
        $aa18accb4250c423$var$resume(this, state);
    }
    return this;
};
function $aa18accb4250c423$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $e5LkN.nextTick($aa18accb4250c423$var$resume_, stream, state);
    }
}
function $aa18accb4250c423$var$resume_(stream, state) {
    if (!state.reading) {
        $aa18accb4250c423$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $aa18accb4250c423$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$aa18accb4250c423$var$Readable.prototype.pause = function() {
    $aa18accb4250c423$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $aa18accb4250c423$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $aa18accb4250c423$var$flow(stream) {
    var state = stream._readableState;
    $aa18accb4250c423$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$aa18accb4250c423$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $aa18accb4250c423$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $aa18accb4250c423$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $aa18accb4250c423$var$kProxyEvents.length; n++)stream.on($aa18accb4250c423$var$kProxyEvents[n], this.emit.bind(this, $aa18accb4250c423$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $aa18accb4250c423$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($aa18accb4250c423$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$aa18accb4250c423$var$Readable._fromList = $aa18accb4250c423$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $aa18accb4250c423$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $aa18accb4250c423$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $aa18accb4250c423$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $aa18accb4250c423$var$copyFromBufferString(n, list) : $aa18accb4250c423$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $aa18accb4250c423$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $aa18accb4250c423$var$copyFromBuffer(n, list) {
    var ret = $aa18accb4250c423$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $aa18accb4250c423$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $e5LkN.nextTick($aa18accb4250c423$var$endReadableNT, state, stream);
    }
}
function $aa18accb4250c423$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $aa18accb4250c423$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("e5LkN", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
module.exports = {
    nextTick: $a4263fec5066d64f$var$nextTick
};
function $a4263fec5066d64f$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $4ZL0H.nextTick(fn);
        case 2:
            return $4ZL0H.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $4ZL0H.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $4ZL0H.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $4ZL0H.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("2f8X5", function(module, exports) {
var $1a23ed312042a126$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $1a23ed312042a126$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("7zYEG", function(module, exports) {

module.exports = (parcelRequire("fzCxw")).EventEmitter;

});

parcelRegister("6PLnu", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $4f9c41bc251cd7a3$export$43bee75e5e14138e; }, function (v) { return $4f9c41bc251cd7a3$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $4f9c41bc251cd7a3$export$f9ce7b637dfbe238; }, function (v) { return $4f9c41bc251cd7a3$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isNull", function () { return $4f9c41bc251cd7a3$export$630801d484da15df; }, function (v) { return $4f9c41bc251cd7a3$export$630801d484da15df = v; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $4f9c41bc251cd7a3$export$bedb7023a7733221; }, function (v) { return $4f9c41bc251cd7a3$export$bedb7023a7733221 = v; });
$parcel$export(module.exports, "isNumber", function () { return $4f9c41bc251cd7a3$export$7e4aa119212bc614; }, function (v) { return $4f9c41bc251cd7a3$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isString", function () { return $4f9c41bc251cd7a3$export$844ec244b1367d54; }, function (v) { return $4f9c41bc251cd7a3$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSymbol", function () { return $4f9c41bc251cd7a3$export$a244864fd9645c7f; }, function (v) { return $4f9c41bc251cd7a3$export$a244864fd9645c7f = v; });
$parcel$export(module.exports, "isUndefined", function () { return $4f9c41bc251cd7a3$export$fce6876652108ab; }, function (v) { return $4f9c41bc251cd7a3$export$fce6876652108ab = v; });
$parcel$export(module.exports, "isRegExp", function () { return $4f9c41bc251cd7a3$export$49841c62b9eff15; }, function (v) { return $4f9c41bc251cd7a3$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isObject", function () { return $4f9c41bc251cd7a3$export$a6cdc56e425d0d0a; }, function (v) { return $4f9c41bc251cd7a3$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isDate", function () { return $4f9c41bc251cd7a3$export$871608497c498473; }, function (v) { return $4f9c41bc251cd7a3$export$871608497c498473 = v; });
$parcel$export(module.exports, "isError", function () { return $4f9c41bc251cd7a3$export$e6127cc7fe7395c3; }, function (v) { return $4f9c41bc251cd7a3$export$e6127cc7fe7395c3 = v; });
$parcel$export(module.exports, "isFunction", function () { return $4f9c41bc251cd7a3$export$f6e2535fb5126e54; }, function (v) { return $4f9c41bc251cd7a3$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isPrimitive", function () { return $4f9c41bc251cd7a3$export$c3825b437cbdea5c; }, function (v) { return $4f9c41bc251cd7a3$export$c3825b437cbdea5c = v; });
$parcel$export(module.exports, "isBuffer", function () { return $4f9c41bc251cd7a3$export$a7884ebc965f8f54; }, function (v) { return $4f9c41bc251cd7a3$export$a7884ebc965f8f54 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $4f9c41bc251cd7a3$export$43bee75e5e14138e;
var $4f9c41bc251cd7a3$export$f9ce7b637dfbe238;
var $4f9c41bc251cd7a3$export$630801d484da15df;
var $4f9c41bc251cd7a3$export$bedb7023a7733221;
var $4f9c41bc251cd7a3$export$7e4aa119212bc614;
var $4f9c41bc251cd7a3$export$844ec244b1367d54;
var $4f9c41bc251cd7a3$export$a244864fd9645c7f;
var $4f9c41bc251cd7a3$export$fce6876652108ab;
var $4f9c41bc251cd7a3$export$49841c62b9eff15;
var $4f9c41bc251cd7a3$export$a6cdc56e425d0d0a;
var $4f9c41bc251cd7a3$export$871608497c498473;
var $4f9c41bc251cd7a3$export$e6127cc7fe7395c3;
var $4f9c41bc251cd7a3$export$f6e2535fb5126e54;
var $4f9c41bc251cd7a3$export$c3825b437cbdea5c;
var $4f9c41bc251cd7a3$export$a7884ebc965f8f54;
function $4f9c41bc251cd7a3$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $4f9c41bc251cd7a3$var$objectToString(arg) === '[object Array]';
}
$4f9c41bc251cd7a3$export$43bee75e5e14138e = $4f9c41bc251cd7a3$var$isArray;
function $4f9c41bc251cd7a3$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$4f9c41bc251cd7a3$export$f9ce7b637dfbe238 = $4f9c41bc251cd7a3$var$isBoolean;
function $4f9c41bc251cd7a3$var$isNull(arg) {
    return arg === null;
}
$4f9c41bc251cd7a3$export$630801d484da15df = $4f9c41bc251cd7a3$var$isNull;
function $4f9c41bc251cd7a3$var$isNullOrUndefined(arg) {
    return arg == null;
}
$4f9c41bc251cd7a3$export$bedb7023a7733221 = $4f9c41bc251cd7a3$var$isNullOrUndefined;
function $4f9c41bc251cd7a3$var$isNumber(arg) {
    return typeof arg === 'number';
}
$4f9c41bc251cd7a3$export$7e4aa119212bc614 = $4f9c41bc251cd7a3$var$isNumber;
function $4f9c41bc251cd7a3$var$isString(arg) {
    return typeof arg === 'string';
}
$4f9c41bc251cd7a3$export$844ec244b1367d54 = $4f9c41bc251cd7a3$var$isString;
function $4f9c41bc251cd7a3$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$4f9c41bc251cd7a3$export$a244864fd9645c7f = $4f9c41bc251cd7a3$var$isSymbol;
function $4f9c41bc251cd7a3$var$isUndefined(arg) {
    return arg === void 0;
}
$4f9c41bc251cd7a3$export$fce6876652108ab = $4f9c41bc251cd7a3$var$isUndefined;
function $4f9c41bc251cd7a3$var$isRegExp(re) {
    return $4f9c41bc251cd7a3$var$objectToString(re) === '[object RegExp]';
}
$4f9c41bc251cd7a3$export$49841c62b9eff15 = $4f9c41bc251cd7a3$var$isRegExp;
function $4f9c41bc251cd7a3$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$4f9c41bc251cd7a3$export$a6cdc56e425d0d0a = $4f9c41bc251cd7a3$var$isObject;
function $4f9c41bc251cd7a3$var$isDate(d) {
    return $4f9c41bc251cd7a3$var$objectToString(d) === '[object Date]';
}
$4f9c41bc251cd7a3$export$871608497c498473 = $4f9c41bc251cd7a3$var$isDate;
function $4f9c41bc251cd7a3$var$isError(e) {
    return $4f9c41bc251cd7a3$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$4f9c41bc251cd7a3$export$e6127cc7fe7395c3 = $4f9c41bc251cd7a3$var$isError;
function $4f9c41bc251cd7a3$var$isFunction(arg) {
    return typeof arg === 'function';
}
$4f9c41bc251cd7a3$export$f6e2535fb5126e54 = $4f9c41bc251cd7a3$var$isFunction;
function $4f9c41bc251cd7a3$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$4f9c41bc251cd7a3$export$c3825b437cbdea5c = $4f9c41bc251cd7a3$var$isPrimitive;

$4f9c41bc251cd7a3$export$a7884ebc965f8f54 = (parcelRequire("bdjQ6")).Buffer.isBuffer;
function $4f9c41bc251cd7a3$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("cXpsY", function(module, exports) {
'use strict';
function $96eebfcc5e434be5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $838j1 = parcelRequire("838j1");
var $96eebfcc5e434be5$require$Buffer = $838j1.Buffer;

var $ifbub = parcelRequire("ifbub");
function $96eebfcc5e434be5$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $96eebfcc5e434be5$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $96eebfcc5e434be5$require$Buffer.alloc(0);
        var ret = $96eebfcc5e434be5$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $96eebfcc5e434be5$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($ifbub && $ifbub.inspect && $ifbub.inspect.custom) module.exports.prototype[$ifbub.inspect.custom] = function() {
    var obj = $ifbub.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("59kLR", function(module, exports) {
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $3bfde7b3c84d4228$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $e5LkN.nextTick($3bfde7b3c84d4228$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $e5LkN.nextTick($3bfde7b3c84d4228$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $e5LkN.nextTick($3bfde7b3c84d4228$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $e5LkN.nextTick($3bfde7b3c84d4228$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $3bfde7b3c84d4228$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $3bfde7b3c84d4228$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $3bfde7b3c84d4228$var$destroy,
    undestroy: $3bfde7b3c84d4228$var$undestroy
};

});

parcelRegister("M8bgE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ /*<replacement>*/ var $090ad45546cce123$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $090ad45546cce123$var$Duplex;

/*<replacement>*/ var $090ad45546cce123$var$util = Object.create((parcelRequire("6PLnu")));

$090ad45546cce123$var$util.inherits = (parcelRequire("dhT4G"));

var $eBpYV = parcelRequire("eBpYV");

var $72oi4 = parcelRequire("72oi4");
$090ad45546cce123$var$util.inherits($090ad45546cce123$var$Duplex, $eBpYV);
// avoid scope creep, the keys array can then be collected
var $090ad45546cce123$var$keys = $090ad45546cce123$var$objectKeys($72oi4.prototype);
for(var $090ad45546cce123$var$v = 0; $090ad45546cce123$var$v < $090ad45546cce123$var$keys.length; $090ad45546cce123$var$v++){
    var $090ad45546cce123$var$method = $090ad45546cce123$var$keys[$090ad45546cce123$var$v];
    if (!$090ad45546cce123$var$Duplex.prototype[$090ad45546cce123$var$method]) $090ad45546cce123$var$Duplex.prototype[$090ad45546cce123$var$method] = $72oi4.prototype[$090ad45546cce123$var$method];
}
function $090ad45546cce123$var$Duplex(options) {
    if (!(this instanceof $090ad45546cce123$var$Duplex)) return new $090ad45546cce123$var$Duplex(options);
    $eBpYV.call(this, options);
    $72oi4.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $090ad45546cce123$var$onend);
}
Object.defineProperty($090ad45546cce123$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $090ad45546cce123$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $e5LkN.nextTick($090ad45546cce123$var$onEndNT, this);
}
function $090ad45546cce123$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($090ad45546cce123$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$090ad45546cce123$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $e5LkN.nextTick(cb, err);
};

});
parcelRegister("72oi4", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ module.exports = $51fb8fe837a90695$var$Writable;
/* <replacement> */ function $51fb8fe837a90695$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $51fb8fe837a90695$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $51fb8fe837a90695$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $51fb8fe837a90695$var$asyncWrite = (0, $e5LkN.nextTick);
/*</replacement>*/ /*<replacement>*/ var $51fb8fe837a90695$var$Duplex;
/*</replacement>*/ $51fb8fe837a90695$var$Writable.WritableState = $51fb8fe837a90695$var$WritableState;

/*<replacement>*/ var $51fb8fe837a90695$var$util = Object.create((parcelRequire("6PLnu")));

$51fb8fe837a90695$var$util.inherits = (parcelRequire("dhT4G"));

/*</replacement>*/ /*<replacement>*/ var $51fb8fe837a90695$var$internalUtil = {
    deprecate: (parcelRequire("4SymK"))
};

var $7zYEG = parcelRequire("7zYEG");

var $838j1 = parcelRequire("838j1");
var $51fb8fe837a90695$require$Buffer = $838j1.Buffer;
var $51fb8fe837a90695$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $51fb8fe837a90695$var$_uint8ArrayToBuffer(chunk) {
    return $51fb8fe837a90695$require$Buffer.from(chunk);
}
function $51fb8fe837a90695$var$_isUint8Array(obj) {
    return $51fb8fe837a90695$require$Buffer.isBuffer(obj) || obj instanceof $51fb8fe837a90695$var$OurUint8Array;
}

var $59kLR = parcelRequire("59kLR");
$51fb8fe837a90695$var$util.inherits($51fb8fe837a90695$var$Writable, $7zYEG);
function $51fb8fe837a90695$var$nop() {}

function $51fb8fe837a90695$var$WritableState(options, stream) {
    $51fb8fe837a90695$var$Duplex = $51fb8fe837a90695$var$Duplex || (parcelRequire("M8bgE"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $51fb8fe837a90695$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $51fb8fe837a90695$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $51fb8fe837a90695$var$CorkedRequest(this);
}
$51fb8fe837a90695$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($51fb8fe837a90695$var$WritableState.prototype, 'buffer', {
            get: $51fb8fe837a90695$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $51fb8fe837a90695$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $51fb8fe837a90695$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($51fb8fe837a90695$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($51fb8fe837a90695$var$realHasInstance.call(this, object)) return true;
            if (this !== $51fb8fe837a90695$var$Writable) return false;
            return object && object._writableState instanceof $51fb8fe837a90695$var$WritableState;
        }
    });
} else $51fb8fe837a90695$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $51fb8fe837a90695$var$Writable(options) {
    $51fb8fe837a90695$var$Duplex = $51fb8fe837a90695$var$Duplex || (parcelRequire("M8bgE"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$51fb8fe837a90695$var$realHasInstance.call($51fb8fe837a90695$var$Writable, this) && !(this instanceof $51fb8fe837a90695$var$Duplex)) return new $51fb8fe837a90695$var$Writable(options);
    this._writableState = new $51fb8fe837a90695$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $7zYEG.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$51fb8fe837a90695$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $51fb8fe837a90695$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $e5LkN.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $51fb8fe837a90695$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $e5LkN.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$51fb8fe837a90695$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $51fb8fe837a90695$var$_isUint8Array(chunk);
    if (isBuf && !$51fb8fe837a90695$require$Buffer.isBuffer(chunk)) chunk = $51fb8fe837a90695$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $51fb8fe837a90695$var$nop;
    if (state.ended) $51fb8fe837a90695$var$writeAfterEnd(this, cb);
    else if (isBuf || $51fb8fe837a90695$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $51fb8fe837a90695$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$51fb8fe837a90695$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$51fb8fe837a90695$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $51fb8fe837a90695$var$clearBuffer(this, state);
    }
};
$51fb8fe837a90695$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $51fb8fe837a90695$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $51fb8fe837a90695$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($51fb8fe837a90695$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $51fb8fe837a90695$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $51fb8fe837a90695$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $51fb8fe837a90695$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $51fb8fe837a90695$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $51fb8fe837a90695$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $e5LkN.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $e5LkN.nextTick($51fb8fe837a90695$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $51fb8fe837a90695$var$finishMaybe(stream, state);
    }
}
function $51fb8fe837a90695$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $51fb8fe837a90695$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $51fb8fe837a90695$var$onwriteStateUpdate(state);
    if (er) $51fb8fe837a90695$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $51fb8fe837a90695$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $51fb8fe837a90695$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $51fb8fe837a90695$var$asyncWrite($51fb8fe837a90695$var$afterWrite, stream, state, finished, cb);
        else $51fb8fe837a90695$var$afterWrite(stream, state, finished, cb);
    }
}
function $51fb8fe837a90695$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $51fb8fe837a90695$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $51fb8fe837a90695$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $51fb8fe837a90695$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $51fb8fe837a90695$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $51fb8fe837a90695$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $51fb8fe837a90695$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $51fb8fe837a90695$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$51fb8fe837a90695$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$51fb8fe837a90695$var$Writable.prototype._writev = null;
$51fb8fe837a90695$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $51fb8fe837a90695$var$endWritable(this, state, cb);
};
function $51fb8fe837a90695$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $51fb8fe837a90695$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $51fb8fe837a90695$var$finishMaybe(stream, state);
    });
}
function $51fb8fe837a90695$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $e5LkN.nextTick($51fb8fe837a90695$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $51fb8fe837a90695$var$finishMaybe(stream, state) {
    var need = $51fb8fe837a90695$var$needFinish(state);
    if (need) {
        $51fb8fe837a90695$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $51fb8fe837a90695$var$endWritable(stream, state, cb) {
    state.ending = true;
    $51fb8fe837a90695$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $e5LkN.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $51fb8fe837a90695$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($51fb8fe837a90695$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$51fb8fe837a90695$var$Writable.prototype.destroy = $59kLR.destroy;
$51fb8fe837a90695$var$Writable.prototype._undestroy = $59kLR.undestroy;
$51fb8fe837a90695$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("3bkX9", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $2512a700ca3f3eee$export$63a7aa211a91ed69; }, function (v) { return $2512a700ca3f3eee$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $2512a700ca3f3eee$export$63a7aa211a91ed69;
'use strict';

var $838j1 = parcelRequire("838j1");
var $2512a700ca3f3eee$require$Buffer = $838j1.Buffer;
/*</replacement>*/ var $2512a700ca3f3eee$var$isEncoding = $2512a700ca3f3eee$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $2512a700ca3f3eee$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $2512a700ca3f3eee$var$normalizeEncoding(enc) {
    var nenc = $2512a700ca3f3eee$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($2512a700ca3f3eee$require$Buffer.isEncoding === $2512a700ca3f3eee$var$isEncoding || !$2512a700ca3f3eee$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$2512a700ca3f3eee$export$63a7aa211a91ed69 = $2512a700ca3f3eee$var$StringDecoder;
function $2512a700ca3f3eee$var$StringDecoder(encoding) {
    this.encoding = $2512a700ca3f3eee$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $2512a700ca3f3eee$var$utf16Text;
            this.end = $2512a700ca3f3eee$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $2512a700ca3f3eee$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $2512a700ca3f3eee$var$base64Text;
            this.end = $2512a700ca3f3eee$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $2512a700ca3f3eee$var$simpleWrite;
            this.end = $2512a700ca3f3eee$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $2512a700ca3f3eee$require$Buffer.allocUnsafe(nb);
}
$2512a700ca3f3eee$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$2512a700ca3f3eee$var$StringDecoder.prototype.end = $2512a700ca3f3eee$var$utf8End;
// Returns only complete characters in a Buffer
$2512a700ca3f3eee$var$StringDecoder.prototype.text = $2512a700ca3f3eee$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$2512a700ca3f3eee$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $2512a700ca3f3eee$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $2512a700ca3f3eee$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $2512a700ca3f3eee$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $2512a700ca3f3eee$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $2512a700ca3f3eee$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $2512a700ca3f3eee$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $2512a700ca3f3eee$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $2512a700ca3f3eee$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $2512a700ca3f3eee$var$utf8Text(buf, i) {
    var total = $2512a700ca3f3eee$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $2512a700ca3f3eee$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $2512a700ca3f3eee$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $2512a700ca3f3eee$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $2512a700ca3f3eee$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $2512a700ca3f3eee$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $2512a700ca3f3eee$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $2512a700ca3f3eee$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("70Df1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $51a6f900f9cdcf30$var$Transform;

var $M8bgE = parcelRequire("M8bgE");

/*<replacement>*/ var $51a6f900f9cdcf30$var$util = Object.create((parcelRequire("6PLnu")));

$51a6f900f9cdcf30$var$util.inherits = (parcelRequire("dhT4G"));
/*</replacement>*/ $51a6f900f9cdcf30$var$util.inherits($51a6f900f9cdcf30$var$Transform, $M8bgE);
function $51a6f900f9cdcf30$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $51a6f900f9cdcf30$var$Transform(options) {
    if (!(this instanceof $51a6f900f9cdcf30$var$Transform)) return new $51a6f900f9cdcf30$var$Transform(options);
    $M8bgE.call(this, options);
    this._transformState = {
        afterTransform: $51a6f900f9cdcf30$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $51a6f900f9cdcf30$var$prefinish);
}
function $51a6f900f9cdcf30$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $51a6f900f9cdcf30$var$done(_this, er, data);
    });
    else $51a6f900f9cdcf30$var$done(this, null, null);
}
$51a6f900f9cdcf30$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $M8bgE.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$51a6f900f9cdcf30$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$51a6f900f9cdcf30$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$51a6f900f9cdcf30$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$51a6f900f9cdcf30$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $M8bgE.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $51a6f900f9cdcf30$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("g1x2n", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $baa65ddfb744d0cd$var$PassThrough;

var $70Df1 = parcelRequire("70Df1");

/*<replacement>*/ var $baa65ddfb744d0cd$var$util = Object.create((parcelRequire("6PLnu")));

$baa65ddfb744d0cd$var$util.inherits = (parcelRequire("dhT4G"));
/*</replacement>*/ $baa65ddfb744d0cd$var$util.inherits($baa65ddfb744d0cd$var$PassThrough, $70Df1);
function $baa65ddfb744d0cd$var$PassThrough(options) {
    if (!(this instanceof $baa65ddfb744d0cd$var$PassThrough)) return new $baa65ddfb744d0cd$var$PassThrough(options);
    $70Df1.call(this, options);
}
$baa65ddfb744d0cd$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("15EwC", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("k2Afl"));

module.exports.sha1 = (parcelRequire("hlzHi"));

module.exports.sha224 = (parcelRequire("lzTLZ"));

module.exports.sha256 = (parcelRequire("kC2XM"));

module.exports.sha384 = (parcelRequire("jDuRY"));

module.exports.sha512 = (parcelRequire("c4ppm"));

});
parcelRegister("k2Afl", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $klEcH = parcelRequire("klEcH");

var $aM3fX = parcelRequire("aM3fX");
var $e9701c5afa941cb3$require$Buffer = $aM3fX.Buffer;
var $e9701c5afa941cb3$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $e9701c5afa941cb3$var$W = new Array(80);
function $e9701c5afa941cb3$var$Sha() {
    this.init();
    this._w = $e9701c5afa941cb3$var$W;
    $klEcH.call(this, 64, 56);
}
$dhT4G($e9701c5afa941cb3$var$Sha, $klEcH);
$e9701c5afa941cb3$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $e9701c5afa941cb3$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $e9701c5afa941cb3$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $e9701c5afa941cb3$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$e9701c5afa941cb3$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $e9701c5afa941cb3$var$rotl5(a) + $e9701c5afa941cb3$var$ft(s, b, c, d) + e + w[j] + $e9701c5afa941cb3$var$K[s] | 0;
        e = d;
        d = c;
        c = $e9701c5afa941cb3$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$e9701c5afa941cb3$var$Sha.prototype._hash = function() {
    var H = $e9701c5afa941cb3$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $e9701c5afa941cb3$var$Sha;

});
parcelRegister("klEcH", function(module, exports) {
'use strict';

var $aM3fX = parcelRequire("aM3fX");
var $ed04f4701195f7c9$require$Buffer = $aM3fX.Buffer;

var $iDFZs = parcelRequire("iDFZs");
// prototype class for hash functions
function $ed04f4701195f7c9$var$Hash(blockSize, finalSize) {
    this._block = $ed04f4701195f7c9$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$ed04f4701195f7c9$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $iDFZs(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$ed04f4701195f7c9$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$ed04f4701195f7c9$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $ed04f4701195f7c9$var$Hash;

});
parcelRegister("aM3fX", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $7d80e9bbf605882b$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $7d80e9bbf605882b$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($7d80e9bbf605882b$var$Buffer.from && $7d80e9bbf605882b$var$Buffer.alloc && $7d80e9bbf605882b$var$Buffer.allocUnsafe && $7d80e9bbf605882b$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $7d80e9bbf605882b$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $7d80e9bbf605882b$var$SafeBuffer;
}
function $7d80e9bbf605882b$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $7d80e9bbf605882b$var$Buffer(arg, encodingOrOffset, length);
}
$7d80e9bbf605882b$var$SafeBuffer.prototype = Object.create($7d80e9bbf605882b$var$Buffer.prototype);
// Copy static methods from Buffer
$7d80e9bbf605882b$var$copyProps($7d80e9bbf605882b$var$Buffer, $7d80e9bbf605882b$var$SafeBuffer);
$7d80e9bbf605882b$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $7d80e9bbf605882b$var$Buffer(arg, encodingOrOffset, length);
};
$7d80e9bbf605882b$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $7d80e9bbf605882b$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$7d80e9bbf605882b$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $7d80e9bbf605882b$var$Buffer(size);
};
$7d80e9bbf605882b$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});



parcelRegister("hlzHi", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $klEcH = parcelRequire("klEcH");

var $aM3fX = parcelRequire("aM3fX");
var $ca10169aa7393b0d$require$Buffer = $aM3fX.Buffer;
var $ca10169aa7393b0d$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $ca10169aa7393b0d$var$W = new Array(80);
function $ca10169aa7393b0d$var$Sha1() {
    this.init();
    this._w = $ca10169aa7393b0d$var$W;
    $klEcH.call(this, 64, 56);
}
$dhT4G($ca10169aa7393b0d$var$Sha1, $klEcH);
$ca10169aa7393b0d$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $ca10169aa7393b0d$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $ca10169aa7393b0d$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $ca10169aa7393b0d$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $ca10169aa7393b0d$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$ca10169aa7393b0d$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $ca10169aa7393b0d$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $ca10169aa7393b0d$var$rotl5(a) + $ca10169aa7393b0d$var$ft(s, b, c, d) + e + w[j] + $ca10169aa7393b0d$var$K[s] | 0;
        e = d;
        d = c;
        c = $ca10169aa7393b0d$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$ca10169aa7393b0d$var$Sha1.prototype._hash = function() {
    var H = $ca10169aa7393b0d$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $ca10169aa7393b0d$var$Sha1;

});

parcelRegister("lzTLZ", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $kC2XM = parcelRequire("kC2XM");

var $klEcH = parcelRequire("klEcH");

var $aM3fX = parcelRequire("aM3fX");
var $fb5821351ada7f8b$require$Buffer = $aM3fX.Buffer;
var $fb5821351ada7f8b$var$W = new Array(64);
function $fb5821351ada7f8b$var$Sha224() {
    this.init();
    this._w = $fb5821351ada7f8b$var$W; // new Array(64)
    $klEcH.call(this, 64, 56);
}
$dhT4G($fb5821351ada7f8b$var$Sha224, $kC2XM);
$fb5821351ada7f8b$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$fb5821351ada7f8b$var$Sha224.prototype._hash = function() {
    var H = $fb5821351ada7f8b$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $fb5821351ada7f8b$var$Sha224;

});
parcelRegister("kC2XM", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $klEcH = parcelRequire("klEcH");

var $aM3fX = parcelRequire("aM3fX");
var $f019a7adf5bdf392$require$Buffer = $aM3fX.Buffer;
var $f019a7adf5bdf392$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $f019a7adf5bdf392$var$W = new Array(64);
function $f019a7adf5bdf392$var$Sha256() {
    this.init();
    this._w = $f019a7adf5bdf392$var$W; // new Array(64)
    $klEcH.call(this, 64, 56);
}
$dhT4G($f019a7adf5bdf392$var$Sha256, $klEcH);
$f019a7adf5bdf392$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $f019a7adf5bdf392$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $f019a7adf5bdf392$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $f019a7adf5bdf392$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $f019a7adf5bdf392$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $f019a7adf5bdf392$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $f019a7adf5bdf392$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$f019a7adf5bdf392$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $f019a7adf5bdf392$var$gamma1(w[i - 2]) + w[i - 7] + $f019a7adf5bdf392$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $f019a7adf5bdf392$var$sigma1(e) + $f019a7adf5bdf392$var$ch(e, f, g) + $f019a7adf5bdf392$var$K[j] + w[j] | 0;
        var T2 = $f019a7adf5bdf392$var$sigma0(a) + $f019a7adf5bdf392$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$f019a7adf5bdf392$var$Sha256.prototype._hash = function() {
    var H = $f019a7adf5bdf392$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $f019a7adf5bdf392$var$Sha256;

});


parcelRegister("jDuRY", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $c4ppm = parcelRequire("c4ppm");

var $klEcH = parcelRequire("klEcH");

var $aM3fX = parcelRequire("aM3fX");
var $e4b99ae2d3c6980e$require$Buffer = $aM3fX.Buffer;
var $e4b99ae2d3c6980e$var$W = new Array(160);
function $e4b99ae2d3c6980e$var$Sha384() {
    this.init();
    this._w = $e4b99ae2d3c6980e$var$W;
    $klEcH.call(this, 128, 112);
}
$dhT4G($e4b99ae2d3c6980e$var$Sha384, $c4ppm);
$e4b99ae2d3c6980e$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$e4b99ae2d3c6980e$var$Sha384.prototype._hash = function() {
    var H = $e4b99ae2d3c6980e$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $e4b99ae2d3c6980e$var$Sha384;

});
parcelRegister("c4ppm", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $klEcH = parcelRequire("klEcH");

var $aM3fX = parcelRequire("aM3fX");
var $8c99914a22a7c866$require$Buffer = $aM3fX.Buffer;
var $8c99914a22a7c866$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8c99914a22a7c866$var$W = new Array(160);
function $8c99914a22a7c866$var$Sha512() {
    this.init();
    this._w = $8c99914a22a7c866$var$W;
    $klEcH.call(this, 128, 112);
}
$dhT4G($8c99914a22a7c866$var$Sha512, $klEcH);
$8c99914a22a7c866$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8c99914a22a7c866$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8c99914a22a7c866$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8c99914a22a7c866$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8c99914a22a7c866$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8c99914a22a7c866$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8c99914a22a7c866$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8c99914a22a7c866$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8c99914a22a7c866$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8c99914a22a7c866$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8c99914a22a7c866$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $8c99914a22a7c866$var$Gamma0(xh, xl);
        var gamma0l = $8c99914a22a7c866$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $8c99914a22a7c866$var$Gamma1(xh, xl);
        var gamma1l = $8c99914a22a7c866$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8c99914a22a7c866$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8c99914a22a7c866$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8c99914a22a7c866$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $8c99914a22a7c866$var$maj(ah, bh, ch);
        var majl = $8c99914a22a7c866$var$maj(al, bl, cl);
        var sigma0h = $8c99914a22a7c866$var$sigma0(ah, al);
        var sigma0l = $8c99914a22a7c866$var$sigma0(al, ah);
        var sigma1h = $8c99914a22a7c866$var$sigma1(eh, el);
        var sigma1l = $8c99914a22a7c866$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $8c99914a22a7c866$var$K[j];
        var Kil = $8c99914a22a7c866$var$K[j + 1];
        var chh = $8c99914a22a7c866$var$Ch(eh, fh, gh);
        var chl = $8c99914a22a7c866$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8c99914a22a7c866$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8c99914a22a7c866$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8c99914a22a7c866$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8c99914a22a7c866$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8c99914a22a7c866$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8c99914a22a7c866$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8c99914a22a7c866$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8c99914a22a7c866$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8c99914a22a7c866$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8c99914a22a7c866$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8c99914a22a7c866$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8c99914a22a7c866$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8c99914a22a7c866$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8c99914a22a7c866$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8c99914a22a7c866$var$getCarry(this._hl, hl) | 0;
};
$8c99914a22a7c866$var$Sha512.prototype._hash = function() {
    var H = $8c99914a22a7c866$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8c99914a22a7c866$var$Sha512;

});



parcelRegister("6GOuC", function(module, exports) {
'use strict';

var $eAzYy = parcelRequire("eAzYy");
var $4dedd5233519b29a$require$Buffer = $eAzYy.Buffer;

var $3DkjE = parcelRequire("3DkjE");
var $4dedd5233519b29a$require$Transform = $3DkjE.Transform;

var $iGJyf = parcelRequire("iGJyf");
var $4dedd5233519b29a$require$StringDecoder = $iGJyf.StringDecoder;

var $dhT4G = parcelRequire("dhT4G");

var $iDFZs = parcelRequire("iDFZs");
function $4dedd5233519b29a$var$CipherBase(hashMode) {
    $4dedd5233519b29a$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dhT4G($4dedd5233519b29a$var$CipherBase, $4dedd5233519b29a$require$Transform);
$4dedd5233519b29a$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $iDFZs(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$4dedd5233519b29a$var$CipherBase.prototype.setAutoPadding = function() {};
$4dedd5233519b29a$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$4dedd5233519b29a$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$4dedd5233519b29a$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$4dedd5233519b29a$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$4dedd5233519b29a$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$4dedd5233519b29a$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $4dedd5233519b29a$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$4dedd5233519b29a$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $4dedd5233519b29a$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $4dedd5233519b29a$var$CipherBase;

});
parcelRegister("eAzYy", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $a9f0557c13a3c50b$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $a9f0557c13a3c50b$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($a9f0557c13a3c50b$var$Buffer.from && $a9f0557c13a3c50b$var$Buffer.alloc && $a9f0557c13a3c50b$var$Buffer.allocUnsafe && $a9f0557c13a3c50b$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $a9f0557c13a3c50b$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $a9f0557c13a3c50b$var$SafeBuffer;
}
function $a9f0557c13a3c50b$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $a9f0557c13a3c50b$var$Buffer(arg, encodingOrOffset, length);
}
$a9f0557c13a3c50b$var$SafeBuffer.prototype = Object.create($a9f0557c13a3c50b$var$Buffer.prototype);
// Copy static methods from Buffer
$a9f0557c13a3c50b$var$copyProps($a9f0557c13a3c50b$var$Buffer, $a9f0557c13a3c50b$var$SafeBuffer);
$a9f0557c13a3c50b$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $a9f0557c13a3c50b$var$Buffer(arg, encodingOrOffset, length);
};
$a9f0557c13a3c50b$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $a9f0557c13a3c50b$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$a9f0557c13a3c50b$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $a9f0557c13a3c50b$var$Buffer(size);
};
$a9f0557c13a3c50b$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});



parcelRegister("cL3Ff", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $9gEy8 = parcelRequire("9gEy8");

var $6GOuC = parcelRequire("6GOuC");

var $838j1 = parcelRequire("838j1");
var $949cb77e369e305c$require$Buffer = $838j1.Buffer;

var $7S8oP = parcelRequire("7S8oP");

var $1Jsb3 = parcelRequire("1Jsb3");

var $15EwC = parcelRequire("15EwC");
var $949cb77e369e305c$var$ZEROS = $949cb77e369e305c$require$Buffer.alloc(128);
function $949cb77e369e305c$var$Hmac(alg, key) {
    $6GOuC.call(this, 'digest');
    if (typeof key === 'string') key = $949cb77e369e305c$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $1Jsb3() : $15EwC(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $949cb77e369e305c$require$Buffer.concat([
        key,
        $949cb77e369e305c$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $949cb77e369e305c$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $949cb77e369e305c$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $1Jsb3() : $15EwC(alg);
    this._hash.update(ipad);
}
$dhT4G($949cb77e369e305c$var$Hmac, $6GOuC);
$949cb77e369e305c$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$949cb77e369e305c$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $1Jsb3() : $15EwC(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $949cb77e369e305c$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $9gEy8($7S8oP, key);
    return new $949cb77e369e305c$var$Hmac(alg, key);
};

});
parcelRegister("9gEy8", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $838j1 = parcelRequire("838j1");
var $6bf50ffe31847a3e$require$Buffer = $838j1.Buffer;

var $6GOuC = parcelRequire("6GOuC");
var $6bf50ffe31847a3e$var$ZEROS = $6bf50ffe31847a3e$require$Buffer.alloc(128);
var $6bf50ffe31847a3e$var$blocksize = 64;
function $6bf50ffe31847a3e$var$Hmac(alg, key) {
    $6GOuC.call(this, 'digest');
    if (typeof key === 'string') key = $6bf50ffe31847a3e$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $6bf50ffe31847a3e$var$blocksize) key = alg(key);
    else if (key.length < $6bf50ffe31847a3e$var$blocksize) key = $6bf50ffe31847a3e$require$Buffer.concat([
        key,
        $6bf50ffe31847a3e$var$ZEROS
    ], $6bf50ffe31847a3e$var$blocksize);
    var ipad = this._ipad = $6bf50ffe31847a3e$require$Buffer.allocUnsafe($6bf50ffe31847a3e$var$blocksize);
    var opad = this._opad = $6bf50ffe31847a3e$require$Buffer.allocUnsafe($6bf50ffe31847a3e$var$blocksize);
    for(var i = 0; i < $6bf50ffe31847a3e$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dhT4G($6bf50ffe31847a3e$var$Hmac, $6GOuC);
$6bf50ffe31847a3e$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$6bf50ffe31847a3e$var$Hmac.prototype._final = function() {
    var h = this._alg($6bf50ffe31847a3e$require$Buffer.concat(this._hash));
    return this._alg($6bf50ffe31847a3e$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $6bf50ffe31847a3e$var$Hmac;

});

parcelRegister("7S8oP", function(module, exports) {

var $2GAk4 = parcelRequire("2GAk4");
module.exports = function(buffer) {
    return new $2GAk4().update(buffer).digest();
};

});


parcelRegister("bci9C", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gm4QM"));

});
parcelRegister("gm4QM", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("d0xYH", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $9785a1c88b34149b$export$448fa22aedc9dbca; }, function (v) { return $9785a1c88b34149b$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $9785a1c88b34149b$export$b80c7ba289c8fa56; }, function (v) { return $9785a1c88b34149b$export$b80c7ba289c8fa56 = v; });
var $9785a1c88b34149b$export$448fa22aedc9dbca;
var $9785a1c88b34149b$export$b80c7ba289c8fa56;
'use strict';

$9785a1c88b34149b$export$448fa22aedc9dbca = (parcelRequire("jZEYv"));

$9785a1c88b34149b$export$b80c7ba289c8fa56 = (parcelRequire("9Tp97"));

});
parcelRegister("jZEYv", function(module, exports) {
'use strict';

var $7YyUC = parcelRequire("7YyUC");
var $e8e37f9705f45c6f$require$Buffer = $7YyUC.Buffer;

var $cGyf5 = parcelRequire("cGyf5");

var $i7B8N = parcelRequire("i7B8N");

var $9Tp97 = parcelRequire("9Tp97");

var $8NXst = parcelRequire("8NXst");
var $e8e37f9705f45c6f$var$ZERO_BUF;
var $e8e37f9705f45c6f$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $e8e37f9705f45c6f$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $e8e37f9705f45c6f$var$checks = [];
var $e8e37f9705f45c6f$var$nextTick;
function $e8e37f9705f45c6f$var$getNextTick() {
    if ($e8e37f9705f45c6f$var$nextTick) return $e8e37f9705f45c6f$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $e8e37f9705f45c6f$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $e8e37f9705f45c6f$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $e8e37f9705f45c6f$var$nextTick = $parcel$global.setImmediate;
    else $e8e37f9705f45c6f$var$nextTick = $parcel$global.setTimeout;
    return $e8e37f9705f45c6f$var$nextTick;
}
function $e8e37f9705f45c6f$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $e8e37f9705f45c6f$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $e8e37f9705f45c6f$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $e8e37f9705f45c6f$require$Buffer.from(res);
    });
}
function $e8e37f9705f45c6f$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$e8e37f9705f45c6f$var$subtle || !$e8e37f9705f45c6f$var$subtle.importKey || !$e8e37f9705f45c6f$var$subtle.deriveBits) return Promise.resolve(false);
    if ($e8e37f9705f45c6f$var$checks[algo] !== undefined) return $e8e37f9705f45c6f$var$checks[algo];
    $e8e37f9705f45c6f$var$ZERO_BUF = $e8e37f9705f45c6f$var$ZERO_BUF || $e8e37f9705f45c6f$require$Buffer.alloc(8);
    var prom = $e8e37f9705f45c6f$var$browserPbkdf2($e8e37f9705f45c6f$var$ZERO_BUF, $e8e37f9705f45c6f$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $e8e37f9705f45c6f$var$checks[algo] = prom;
    return prom;
}
function $e8e37f9705f45c6f$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $e8e37f9705f45c6f$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $e8e37f9705f45c6f$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    $cGyf5(iterations, keylen);
    password = $8NXst(password, $i7B8N, 'Password');
    salt = $8NXst(salt, $i7B8N, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $e8e37f9705f45c6f$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $e8e37f9705f45c6f$var$getNextTick()(function() {
            var out;
            try {
                out = $9Tp97(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $e8e37f9705f45c6f$var$resolvePromise($e8e37f9705f45c6f$var$checkNative(algo).then(function(resp) {
        if (resp) return $e8e37f9705f45c6f$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $9Tp97(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7YyUC", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $5ce937d35cf66b34$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $5ce937d35cf66b34$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($5ce937d35cf66b34$var$Buffer.from && $5ce937d35cf66b34$var$Buffer.alloc && $5ce937d35cf66b34$var$Buffer.allocUnsafe && $5ce937d35cf66b34$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $5ce937d35cf66b34$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $5ce937d35cf66b34$var$SafeBuffer;
}
function $5ce937d35cf66b34$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $5ce937d35cf66b34$var$Buffer(arg, encodingOrOffset, length);
}
$5ce937d35cf66b34$var$SafeBuffer.prototype = Object.create($5ce937d35cf66b34$var$Buffer.prototype);
// Copy static methods from Buffer
$5ce937d35cf66b34$var$copyProps($5ce937d35cf66b34$var$Buffer, $5ce937d35cf66b34$var$SafeBuffer);
$5ce937d35cf66b34$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $5ce937d35cf66b34$var$Buffer(arg, encodingOrOffset, length);
};
$5ce937d35cf66b34$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $5ce937d35cf66b34$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$5ce937d35cf66b34$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $5ce937d35cf66b34$var$Buffer(size);
};
$5ce937d35cf66b34$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});

parcelRegister("cGyf5", function(module, exports) {
'use strict';
var $93c3f812afbfc00a$var$$isFinite = isFinite;
var $93c3f812afbfc00a$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$93c3f812afbfc00a$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $93c3f812afbfc00a$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("i7B8N", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
var $d315b0d2c7e0b4e5$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $d315b0d2c7e0b4e5$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $d315b0d2c7e0b4e5$var$pVersionMajor = parseInt($4ZL0H.version.split('.')[0].slice(1), 10);
    $d315b0d2c7e0b4e5$var$defaultEncoding = $d315b0d2c7e0b4e5$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $d315b0d2c7e0b4e5$var$defaultEncoding = 'utf-8';
module.exports = $d315b0d2c7e0b4e5$var$defaultEncoding;

});

parcelRegister("9Tp97", function(module, exports) {
'use strict';

var $7S8oP = parcelRequire("7S8oP");

var $1Jsb3 = parcelRequire("1Jsb3");

var $15EwC = parcelRequire("15EwC");

var $7YyUC = parcelRequire("7YyUC");
var $01dbd19307582e29$require$Buffer = $7YyUC.Buffer;

var $cGyf5 = parcelRequire("cGyf5");

var $i7B8N = parcelRequire("i7B8N");

var $8NXst = parcelRequire("8NXst");
var $01dbd19307582e29$var$ZEROS = $01dbd19307582e29$require$Buffer.alloc(128);
var $01dbd19307582e29$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $01dbd19307582e29$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $01dbd19307582e29$var$rmd160Func(data) {
    return new $1Jsb3().update(data).digest();
}
function $01dbd19307582e29$var$getDigest(alg) {
    function shaFunc(data) {
        return $15EwC(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $01dbd19307582e29$var$rmd160Func;
    if (alg === 'md5') return $7S8oP;
    return shaFunc;
}
function $01dbd19307582e29$var$Hmac(alg, key, saltLen) {
    var hash = $01dbd19307582e29$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $01dbd19307582e29$require$Buffer.concat([
        key,
        $01dbd19307582e29$var$ZEROS
    ], blocksize);
    var ipad = $01dbd19307582e29$require$Buffer.allocUnsafe(blocksize + $01dbd19307582e29$var$sizes[alg]);
    var opad = $01dbd19307582e29$require$Buffer.allocUnsafe(blocksize + $01dbd19307582e29$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $01dbd19307582e29$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $01dbd19307582e29$var$sizes[alg];
}
$01dbd19307582e29$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $01dbd19307582e29$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $cGyf5(iterations, keylen);
    password = $8NXst(password, $i7B8N, 'Password');
    salt = $8NXst(salt, $i7B8N, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $01dbd19307582e29$var$mapping[lowerDigest] || lowerDigest;
    var size = $01dbd19307582e29$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $01dbd19307582e29$var$Hmac(mappedDigest, password, salt.length);
    var DK = $01dbd19307582e29$require$Buffer.allocUnsafe(keylen);
    var block1 = $01dbd19307582e29$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $01dbd19307582e29$var$pbkdf2;

});
parcelRegister("8NXst", function(module, exports) {
'use strict';

var $7YyUC = parcelRequire("7YyUC");
var $66910584d1dc48dd$require$Buffer = $7YyUC.Buffer;

var $iDFZs = parcelRequire("iDFZs");
var $66910584d1dc48dd$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $66910584d1dc48dd$var$useArrayBuffer = $66910584d1dc48dd$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $66910584d1dc48dd$var$isView = $66910584d1dc48dd$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $66910584d1dc48dd$require$Buffer.isBuffer(thing) || $66910584d1dc48dd$var$useUint8Array && thing instanceof Uint8Array || $66910584d1dc48dd$var$isView && $66910584d1dc48dd$var$isView(thing)) return $iDFZs(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});




parcelRegister("jGT0o", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $e55c9b7f3ad34522$export$bdd223f16383713e; }, function (v) { return $e55c9b7f3ad34522$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $e55c9b7f3ad34522$export$26e5786e8ac8e530; }, function (v) { return $e55c9b7f3ad34522$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $e55c9b7f3ad34522$export$2f64596b8cbf08b4; }, function (v) { return $e55c9b7f3ad34522$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $e55c9b7f3ad34522$export$20533d26f07f1ee0; }, function (v) { return $e55c9b7f3ad34522$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $e55c9b7f3ad34522$export$12ada9414fbc594c; }, function (v) { return $e55c9b7f3ad34522$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $e55c9b7f3ad34522$export$2ce6d8d0e8b04e1a; }, function (v) { return $e55c9b7f3ad34522$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $e55c9b7f3ad34522$export$36b6d6ef312eab39; }, function (v) { return $e55c9b7f3ad34522$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $e55c9b7f3ad34522$export$f5e7e39d57cd9700; }, function (v) { return $e55c9b7f3ad34522$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $e55c9b7f3ad34522$export$dedd8dc3dc62b370; }, function (v) { return $e55c9b7f3ad34522$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $e55c9b7f3ad34522$export$58a258485f1e49f6; }, function (v) { return $e55c9b7f3ad34522$export$58a258485f1e49f6 = v; });
var $e55c9b7f3ad34522$export$bdd223f16383713e;
var $e55c9b7f3ad34522$export$26e5786e8ac8e530;
var $e55c9b7f3ad34522$export$2f64596b8cbf08b4;
var $e55c9b7f3ad34522$export$20533d26f07f1ee0;
var $e55c9b7f3ad34522$export$12ada9414fbc594c;
var $e55c9b7f3ad34522$export$2ce6d8d0e8b04e1a;
var $e55c9b7f3ad34522$export$36b6d6ef312eab39;
var $e55c9b7f3ad34522$export$f5e7e39d57cd9700;
var $e55c9b7f3ad34522$export$dedd8dc3dc62b370;
var $e55c9b7f3ad34522$export$58a258485f1e49f6;

var $cRnXs = parcelRequire("cRnXs");

var $jGDtA = parcelRequire("jGDtA");

var $gaNIZ = parcelRequire("gaNIZ");

var $baPH8 = parcelRequire("baPH8");

var $iWvja = parcelRequire("iWvja");
function $e55c9b7f3ad34522$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($gaNIZ[suite]) {
        keyLen = $gaNIZ[suite].key;
        ivLen = $gaNIZ[suite].iv;
    } else if ($baPH8[suite]) {
        keyLen = $baPH8[suite].key * 8;
        ivLen = $baPH8[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $iWvja(password, false, keyLen, ivLen);
    return $e55c9b7f3ad34522$var$createCipheriv(suite, keys.key, keys.iv);
}
function $e55c9b7f3ad34522$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($gaNIZ[suite]) {
        keyLen = $gaNIZ[suite].key;
        ivLen = $gaNIZ[suite].iv;
    } else if ($baPH8[suite]) {
        keyLen = $baPH8[suite].key * 8;
        ivLen = $baPH8[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $iWvja(password, false, keyLen, ivLen);
    return $e55c9b7f3ad34522$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $e55c9b7f3ad34522$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($gaNIZ[suite]) return $jGDtA.createCipheriv(suite, key, iv);
    if ($baPH8[suite]) return new $cRnXs({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $e55c9b7f3ad34522$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($gaNIZ[suite]) return $jGDtA.createDecipheriv(suite, key, iv);
    if ($baPH8[suite]) return new $cRnXs({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $e55c9b7f3ad34522$var$getCiphers() {
    return Object.keys($baPH8).concat($jGDtA.getCiphers());
}
$e55c9b7f3ad34522$export$bdd223f16383713e = $e55c9b7f3ad34522$export$26e5786e8ac8e530 = $e55c9b7f3ad34522$var$createCipher;
$e55c9b7f3ad34522$export$2f64596b8cbf08b4 = $e55c9b7f3ad34522$export$20533d26f07f1ee0 = $e55c9b7f3ad34522$var$createCipheriv;
$e55c9b7f3ad34522$export$12ada9414fbc594c = $e55c9b7f3ad34522$export$2ce6d8d0e8b04e1a = $e55c9b7f3ad34522$var$createDecipher;
$e55c9b7f3ad34522$export$36b6d6ef312eab39 = $e55c9b7f3ad34522$export$f5e7e39d57cd9700 = $e55c9b7f3ad34522$var$createDecipheriv;
$e55c9b7f3ad34522$export$dedd8dc3dc62b370 = $e55c9b7f3ad34522$export$58a258485f1e49f6 = $e55c9b7f3ad34522$var$getCiphers;

});
parcelRegister("cRnXs", function(module, exports) {

var $6GOuC = parcelRequire("6GOuC");

var $gXgD6 = parcelRequire("gXgD6");

var $dhT4G = parcelRequire("dhT4G");

var $838j1 = parcelRequire("838j1");
var $95cd04dabc1eb7c8$require$Buffer = $838j1.Buffer;
var $95cd04dabc1eb7c8$var$modes = {
    'des-ede3-cbc': $gXgD6.CBC.instantiate($gXgD6.EDE),
    'des-ede3': $gXgD6.EDE,
    'des-ede-cbc': $gXgD6.CBC.instantiate($gXgD6.EDE),
    'des-ede': $gXgD6.EDE,
    'des-cbc': $gXgD6.CBC.instantiate($gXgD6.DES),
    'des-ecb': $gXgD6.DES
};
$95cd04dabc1eb7c8$var$modes.des = $95cd04dabc1eb7c8$var$modes['des-cbc'];
$95cd04dabc1eb7c8$var$modes.des3 = $95cd04dabc1eb7c8$var$modes['des-ede3-cbc'];
module.exports = $95cd04dabc1eb7c8$var$DES;
$dhT4G($95cd04dabc1eb7c8$var$DES, $6GOuC);
function $95cd04dabc1eb7c8$var$DES(opts) {
    $6GOuC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $95cd04dabc1eb7c8$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$95cd04dabc1eb7c8$require$Buffer.isBuffer(key)) key = $95cd04dabc1eb7c8$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $95cd04dabc1eb7c8$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$95cd04dabc1eb7c8$require$Buffer.isBuffer(iv)) iv = $95cd04dabc1eb7c8$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$95cd04dabc1eb7c8$var$DES.prototype._update = function(data) {
    return $95cd04dabc1eb7c8$require$Buffer.from(this._des.update(data));
};
$95cd04dabc1eb7c8$var$DES.prototype._final = function() {
    return $95cd04dabc1eb7c8$require$Buffer.from(this._des.final());
};

});
parcelRegister("gXgD6", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $c57f0e5ad20890a2$export$cc8859615686b300; }, function (v) { return $c57f0e5ad20890a2$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $c57f0e5ad20890a2$export$8ad3f227af08fcc5; }, function (v) { return $c57f0e5ad20890a2$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $c57f0e5ad20890a2$export$947646e34766044f; }, function (v) { return $c57f0e5ad20890a2$export$947646e34766044f = v; });
var $c57f0e5ad20890a2$export$eab97d15b1788b8d;
var $c57f0e5ad20890a2$export$26e5786e8ac8e530;
var $c57f0e5ad20890a2$export$cc8859615686b300;
var $c57f0e5ad20890a2$export$8ad3f227af08fcc5;
var $c57f0e5ad20890a2$export$947646e34766044f;
'use strict';

$c57f0e5ad20890a2$export$eab97d15b1788b8d = (parcelRequire("aSiVb"));

$c57f0e5ad20890a2$export$26e5786e8ac8e530 = (parcelRequire("en1ji"));

$c57f0e5ad20890a2$export$cc8859615686b300 = (parcelRequire("gv6xd"));

$c57f0e5ad20890a2$export$8ad3f227af08fcc5 = (parcelRequire("f8Mbw"));

$c57f0e5ad20890a2$export$947646e34766044f = (parcelRequire("f5Nr9"));

});
parcelRegister("aSiVb", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $7ead9fe90fb60003$export$cfaef8ed399428b0; }, function (v) { return $7ead9fe90fb60003$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $7ead9fe90fb60003$export$a80c7deaea7cbd80; }, function (v) { return $7ead9fe90fb60003$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $7ead9fe90fb60003$export$ed7577ae6e1cd0ef; }, function (v) { return $7ead9fe90fb60003$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $7ead9fe90fb60003$export$5dcbef3aa594f567; }, function (v) { return $7ead9fe90fb60003$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $7ead9fe90fb60003$export$5bc8001ca71ed9c5; }, function (v) { return $7ead9fe90fb60003$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $7ead9fe90fb60003$export$3e714e2c5d5d8cb2; }, function (v) { return $7ead9fe90fb60003$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $7ead9fe90fb60003$export$94c3e544fd062b7f; }, function (v) { return $7ead9fe90fb60003$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $7ead9fe90fb60003$export$9f77e0932fb78f72; }, function (v) { return $7ead9fe90fb60003$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $7ead9fe90fb60003$export$d865ce2836f5927f; }, function (v) { return $7ead9fe90fb60003$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $7ead9fe90fb60003$export$95e62ad65da8b7d2; }, function (v) { return $7ead9fe90fb60003$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $7ead9fe90fb60003$export$209139ff098c441a; }, function (v) { return $7ead9fe90fb60003$export$209139ff098c441a = v; });
var $7ead9fe90fb60003$export$cfaef8ed399428b0;
var $7ead9fe90fb60003$export$a80c7deaea7cbd80;
var $7ead9fe90fb60003$export$ed7577ae6e1cd0ef;
var $7ead9fe90fb60003$export$5dcbef3aa594f567;
var $7ead9fe90fb60003$export$5bc8001ca71ed9c5;
var $7ead9fe90fb60003$export$3e714e2c5d5d8cb2;
var $7ead9fe90fb60003$export$94c3e544fd062b7f;
var $7ead9fe90fb60003$export$9f77e0932fb78f72;
var $7ead9fe90fb60003$export$d865ce2836f5927f;
var $7ead9fe90fb60003$export$95e62ad65da8b7d2;
var $7ead9fe90fb60003$export$209139ff098c441a;
'use strict';
$7ead9fe90fb60003$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$7ead9fe90fb60003$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$7ead9fe90fb60003$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ead9fe90fb60003$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ead9fe90fb60003$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ead9fe90fb60003$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $7ead9fe90fb60003$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$7ead9fe90fb60003$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $7ead9fe90fb60003$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $7ead9fe90fb60003$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $7ead9fe90fb60003$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $7ead9fe90fb60003$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ead9fe90fb60003$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $7ead9fe90fb60003$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$7ead9fe90fb60003$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $7ead9fe90fb60003$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $7ead9fe90fb60003$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $7ead9fe90fb60003$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$7ead9fe90fb60003$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $7ead9fe90fb60003$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $7ead9fe90fb60003$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$7ead9fe90fb60003$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("en1ji", function(module, exports) {
'use strict';

var $jLTFB = parcelRequire("jLTFB");
function $a7643ad938c9a927$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a7643ad938c9a927$var$Cipher;
$a7643ad938c9a927$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a7643ad938c9a927$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a7643ad938c9a927$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a7643ad938c9a927$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a7643ad938c9a927$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a7643ad938c9a927$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a7643ad938c9a927$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a7643ad938c9a927$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a7643ad938c9a927$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a7643ad938c9a927$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a7643ad938c9a927$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $jLTFB.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("jLTFB", function(module, exports) {
module.exports = $e64d96feb50adf1f$var$assert;
function $e64d96feb50adf1f$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$e64d96feb50adf1f$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("gv6xd", function(module, exports) {
'use strict';

var $jLTFB = parcelRequire("jLTFB");

var $dhT4G = parcelRequire("dhT4G");

var $aSiVb = parcelRequire("aSiVb");

var $en1ji = parcelRequire("en1ji");
function $c0349c4390f1b908$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $c0349c4390f1b908$var$DES(options) {
    $en1ji.call(this, options);
    var state = new $c0349c4390f1b908$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dhT4G($c0349c4390f1b908$var$DES, $en1ji);
module.exports = $c0349c4390f1b908$var$DES;
$c0349c4390f1b908$var$DES.create = function create(options) {
    return new $c0349c4390f1b908$var$DES(options);
};
var $c0349c4390f1b908$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$c0349c4390f1b908$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $jLTFB.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $aSiVb.readUInt32BE(key, 0);
    var kR = $aSiVb.readUInt32BE(key, 4);
    $aSiVb.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $c0349c4390f1b908$var$shiftTable[i >>> 1];
        kL = $aSiVb.r28shl(kL, shift);
        kR = $aSiVb.r28shl(kR, shift);
        $aSiVb.pc2(kL, kR, state.keys, i);
    }
};
$c0349c4390f1b908$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $aSiVb.readUInt32BE(inp, inOff);
    var r = $aSiVb.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $aSiVb.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $aSiVb.writeUInt32BE(out, l, outOff);
    $aSiVb.writeUInt32BE(out, r, outOff + 4);
};
$c0349c4390f1b908$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$c0349c4390f1b908$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$jLTFB.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$c0349c4390f1b908$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aSiVb.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aSiVb.substitute(keyL, keyR);
        var f = $aSiVb.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $aSiVb.rip(r, l, out, off);
};
$c0349c4390f1b908$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aSiVb.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aSiVb.substitute(keyL, keyR);
        var f = $aSiVb.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $aSiVb.rip(l, r, out, off);
};

});

parcelRegister("f8Mbw", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $b05cfadcd775606f$export$f9bb8d20ccc7477a; }, function (v) { return $b05cfadcd775606f$export$f9bb8d20ccc7477a = v; });
var $b05cfadcd775606f$export$f9bb8d20ccc7477a;
'use strict';

var $jLTFB = parcelRequire("jLTFB");

var $dhT4G = parcelRequire("dhT4G");
var $b05cfadcd775606f$var$proto = {};
function $b05cfadcd775606f$var$CBCState(iv) {
    $jLTFB.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $b05cfadcd775606f$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dhT4G(CBC, Base);
    var keys = Object.keys($b05cfadcd775606f$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $b05cfadcd775606f$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$b05cfadcd775606f$export$f9bb8d20ccc7477a = $b05cfadcd775606f$var$instantiate;
$b05cfadcd775606f$var$proto._cbcInit = function _cbcInit() {
    var state = new $b05cfadcd775606f$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$b05cfadcd775606f$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("f5Nr9", function(module, exports) {
'use strict';

var $jLTFB = parcelRequire("jLTFB");

var $dhT4G = parcelRequire("dhT4G");

var $en1ji = parcelRequire("en1ji");

var $gv6xd = parcelRequire("gv6xd");
function $afcdabc931806f45$var$EDEState(type, key) {
    $jLTFB.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $gv6xd.create({
            type: 'encrypt',
            key: k1
        }),
        $gv6xd.create({
            type: 'decrypt',
            key: k2
        }),
        $gv6xd.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $gv6xd.create({
            type: 'decrypt',
            key: k3
        }),
        $gv6xd.create({
            type: 'encrypt',
            key: k2
        }),
        $gv6xd.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $afcdabc931806f45$var$EDE(options) {
    $en1ji.call(this, options);
    var state = new $afcdabc931806f45$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dhT4G($afcdabc931806f45$var$EDE, $en1ji);
module.exports = $afcdabc931806f45$var$EDE;
$afcdabc931806f45$var$EDE.create = function create(options) {
    return new $afcdabc931806f45$var$EDE(options);
};
$afcdabc931806f45$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$afcdabc931806f45$var$EDE.prototype._pad = $gv6xd.prototype._pad;
$afcdabc931806f45$var$EDE.prototype._unpad = $gv6xd.prototype._unpad;

});



parcelRegister("jGDtA", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $e5508fb2c65b1709$export$2f64596b8cbf08b4; }, function (v) { return $e5508fb2c65b1709$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $e5508fb2c65b1709$export$36b6d6ef312eab39; }, function (v) { return $e5508fb2c65b1709$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $e5508fb2c65b1709$export$58a258485f1e49f6; }, function (v) { return $e5508fb2c65b1709$export$58a258485f1e49f6 = v; });
var $e5508fb2c65b1709$export$bdd223f16383713e;
var $e5508fb2c65b1709$export$26e5786e8ac8e530;
var $e5508fb2c65b1709$export$2f64596b8cbf08b4;
var $e5508fb2c65b1709$export$20533d26f07f1ee0;
var $e5508fb2c65b1709$export$12ada9414fbc594c;
var $e5508fb2c65b1709$export$2ce6d8d0e8b04e1a;
var $e5508fb2c65b1709$export$36b6d6ef312eab39;
var $e5508fb2c65b1709$export$f5e7e39d57cd9700;
var $e5508fb2c65b1709$export$dedd8dc3dc62b370;
var $e5508fb2c65b1709$export$58a258485f1e49f6;

var $2wD6K = parcelRequire("2wD6K");

var $3eloO = parcelRequire("3eloO");

var $fmEa8 = parcelRequire("fmEa8");
function $e5508fb2c65b1709$var$getCiphers() {
    return Object.keys($fmEa8);
}
$e5508fb2c65b1709$export$bdd223f16383713e = $e5508fb2c65b1709$export$26e5786e8ac8e530 = $2wD6K.createCipher;
$e5508fb2c65b1709$export$2f64596b8cbf08b4 = $e5508fb2c65b1709$export$20533d26f07f1ee0 = $2wD6K.createCipheriv;
$e5508fb2c65b1709$export$12ada9414fbc594c = $e5508fb2c65b1709$export$2ce6d8d0e8b04e1a = $3eloO.createDecipher;
$e5508fb2c65b1709$export$36b6d6ef312eab39 = $e5508fb2c65b1709$export$f5e7e39d57cd9700 = $3eloO.createDecipheriv;
$e5508fb2c65b1709$export$dedd8dc3dc62b370 = $e5508fb2c65b1709$export$58a258485f1e49f6 = $e5508fb2c65b1709$var$getCiphers;

});
parcelRegister("2wD6K", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $1d6ce7ec05afe9d6$export$2f64596b8cbf08b4; }, function (v) { return $1d6ce7ec05afe9d6$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $1d6ce7ec05afe9d6$export$bdd223f16383713e; }, function (v) { return $1d6ce7ec05afe9d6$export$bdd223f16383713e = v; });
var $1d6ce7ec05afe9d6$export$2f64596b8cbf08b4;
var $1d6ce7ec05afe9d6$export$bdd223f16383713e;

var $gaNIZ = parcelRequire("gaNIZ");

var $kvo4q = parcelRequire("kvo4q");

var $838j1 = parcelRequire("838j1");
var $1d6ce7ec05afe9d6$require$Buffer = $838j1.Buffer;

var $2mx7M = parcelRequire("2mx7M");

var $6GOuC = parcelRequire("6GOuC");

var $caH4w = parcelRequire("caH4w");

var $iWvja = parcelRequire("iWvja");

var $dhT4G = parcelRequire("dhT4G");
function $1d6ce7ec05afe9d6$var$Cipher(mode, key, iv) {
    $6GOuC.call(this);
    this._cache = new $1d6ce7ec05afe9d6$var$Splitter();
    this._cipher = new $caH4w.AES(key);
    this._prev = $1d6ce7ec05afe9d6$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dhT4G($1d6ce7ec05afe9d6$var$Cipher, $6GOuC);
$1d6ce7ec05afe9d6$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $1d6ce7ec05afe9d6$require$Buffer.concat(out);
};
var $1d6ce7ec05afe9d6$var$PADDING = $1d6ce7ec05afe9d6$require$Buffer.alloc(16, 0x10);
$1d6ce7ec05afe9d6$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($1d6ce7ec05afe9d6$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$1d6ce7ec05afe9d6$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $1d6ce7ec05afe9d6$var$Splitter() {
    this.cache = $1d6ce7ec05afe9d6$require$Buffer.allocUnsafe(0);
}
$1d6ce7ec05afe9d6$var$Splitter.prototype.add = function(data) {
    this.cache = $1d6ce7ec05afe9d6$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$1d6ce7ec05afe9d6$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$1d6ce7ec05afe9d6$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $1d6ce7ec05afe9d6$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $1d6ce7ec05afe9d6$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $1d6ce7ec05afe9d6$var$createCipheriv(suite, password, iv) {
    var config = $gaNIZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $1d6ce7ec05afe9d6$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $1d6ce7ec05afe9d6$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $2mx7M(config.module, password, iv);
    else if (config.type === 'auth') return new $kvo4q(config.module, password, iv);
    return new $1d6ce7ec05afe9d6$var$Cipher(config.module, password, iv);
}
function $1d6ce7ec05afe9d6$var$createCipher(suite, password) {
    var config = $gaNIZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $iWvja(password, false, config.key, config.iv);
    return $1d6ce7ec05afe9d6$var$createCipheriv(suite, keys.key, keys.iv);
}
$1d6ce7ec05afe9d6$export$2f64596b8cbf08b4 = $1d6ce7ec05afe9d6$var$createCipheriv;
$1d6ce7ec05afe9d6$export$bdd223f16383713e = $1d6ce7ec05afe9d6$var$createCipher;

});
parcelRegister("gaNIZ", function(module, exports) {








var $bc6426c4a0e99f84$var$modeModules = {
    ECB: (parcelRequire("4VNRd")),
    CBC: (parcelRequire("dSvNa")),
    CFB: (parcelRequire("hBCvG")),
    CFB8: (parcelRequire("4EjJt")),
    CFB1: (parcelRequire("deF8T")),
    OFB: (parcelRequire("bxTz8")),
    CTR: (parcelRequire("5DIgH")),
    GCM: (parcelRequire("5DIgH"))
};

var $fmEa8 = parcelRequire("fmEa8");
for(var $bc6426c4a0e99f84$var$key in $fmEa8)$fmEa8[$bc6426c4a0e99f84$var$key].module = $bc6426c4a0e99f84$var$modeModules[$fmEa8[$bc6426c4a0e99f84$var$key].mode];
module.exports = $fmEa8;

});
parcelRegister("4VNRd", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $397328e55f3c5ce5$export$5b0f6292f11d1d18; }, function (v) { return $397328e55f3c5ce5$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $397328e55f3c5ce5$export$e85a0c9a1067c5d3; }, function (v) { return $397328e55f3c5ce5$export$e85a0c9a1067c5d3 = v; });
var $397328e55f3c5ce5$export$5b0f6292f11d1d18;
var $397328e55f3c5ce5$export$e85a0c9a1067c5d3;
$397328e55f3c5ce5$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$397328e55f3c5ce5$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("dSvNa", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $a1a8faba74f8f15b$export$5b0f6292f11d1d18; }, function (v) { return $a1a8faba74f8f15b$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $a1a8faba74f8f15b$export$e85a0c9a1067c5d3; }, function (v) { return $a1a8faba74f8f15b$export$e85a0c9a1067c5d3 = v; });
var $a1a8faba74f8f15b$export$5b0f6292f11d1d18;
var $a1a8faba74f8f15b$export$e85a0c9a1067c5d3;

var $lG93x = parcelRequire("lG93x");
$a1a8faba74f8f15b$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $lG93x(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$a1a8faba74f8f15b$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $lG93x(out, pad);
};

});
parcelRegister("lG93x", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $fc848b8cbe231ed8$require$Buffer = $bdjQ6.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $fc848b8cbe231ed8$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("hBCvG", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $cd13c3a99dff038d$export$5b0f6292f11d1d18; }, function (v) { return $cd13c3a99dff038d$export$5b0f6292f11d1d18 = v; });
var $cd13c3a99dff038d$export$5b0f6292f11d1d18;

var $838j1 = parcelRequire("838j1");
var $cd13c3a99dff038d$require$Buffer = $838j1.Buffer;

var $lG93x = parcelRequire("lG93x");
function $cd13c3a99dff038d$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $lG93x(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $cd13c3a99dff038d$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$cd13c3a99dff038d$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $cd13c3a99dff038d$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $cd13c3a99dff038d$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $cd13c3a99dff038d$require$Buffer.concat([
                out,
                $cd13c3a99dff038d$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $cd13c3a99dff038d$require$Buffer.concat([
                out,
                $cd13c3a99dff038d$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("4EjJt", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $362a34512b2cb660$export$5b0f6292f11d1d18; }, function (v) { return $362a34512b2cb660$export$5b0f6292f11d1d18 = v; });
var $362a34512b2cb660$export$5b0f6292f11d1d18;

var $838j1 = parcelRequire("838j1");
var $362a34512b2cb660$require$Buffer = $838j1.Buffer;
function $362a34512b2cb660$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $362a34512b2cb660$require$Buffer.concat([
        self._prev.slice(1),
        $362a34512b2cb660$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$362a34512b2cb660$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $362a34512b2cb660$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $362a34512b2cb660$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("deF8T", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $9a2c7f2fbbd3a86b$export$5b0f6292f11d1d18; }, function (v) { return $9a2c7f2fbbd3a86b$export$5b0f6292f11d1d18 = v; });
var $9a2c7f2fbbd3a86b$export$5b0f6292f11d1d18;

var $838j1 = parcelRequire("838j1");
var $9a2c7f2fbbd3a86b$require$Buffer = $838j1.Buffer;
function $9a2c7f2fbbd3a86b$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $9a2c7f2fbbd3a86b$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $9a2c7f2fbbd3a86b$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $9a2c7f2fbbd3a86b$require$Buffer.allocUnsafe(buffer.length);
    buffer = $9a2c7f2fbbd3a86b$require$Buffer.concat([
        buffer,
        $9a2c7f2fbbd3a86b$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$9a2c7f2fbbd3a86b$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $9a2c7f2fbbd3a86b$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $9a2c7f2fbbd3a86b$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("bxTz8", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $867de0f3149c6687$export$5b0f6292f11d1d18; }, function (v) { return $867de0f3149c6687$export$5b0f6292f11d1d18 = v; });
var $867de0f3149c6687$export$5b0f6292f11d1d18;

var $bdjQ6 = parcelRequire("bdjQ6");
var $867de0f3149c6687$require$Buffer = $bdjQ6.Buffer;

var $lG93x = parcelRequire("lG93x");
function $867de0f3149c6687$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$867de0f3149c6687$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $867de0f3149c6687$require$Buffer.concat([
        self._cache,
        $867de0f3149c6687$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $lG93x(chunk, pad);
};

});

parcelRegister("5DIgH", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $41b2ef081a6e05a6$export$5b0f6292f11d1d18; }, function (v) { return $41b2ef081a6e05a6$export$5b0f6292f11d1d18 = v; });
var $41b2ef081a6e05a6$export$5b0f6292f11d1d18;

var $lG93x = parcelRequire("lG93x");

var $838j1 = parcelRequire("838j1");
var $41b2ef081a6e05a6$require$Buffer = $838j1.Buffer;

var $h75HQ = parcelRequire("h75HQ");
function $41b2ef081a6e05a6$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $h75HQ(self._prev);
    return out;
}
var $41b2ef081a6e05a6$var$blockSize = 16;
$41b2ef081a6e05a6$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $41b2ef081a6e05a6$var$blockSize);
    var start = self._cache.length;
    self._cache = $41b2ef081a6e05a6$require$Buffer.concat([
        self._cache,
        $41b2ef081a6e05a6$require$Buffer.allocUnsafe(chunkNum * $41b2ef081a6e05a6$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $41b2ef081a6e05a6$var$getBlock(self);
        var offset = start + i * $41b2ef081a6e05a6$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $lG93x(chunk, pad);
};

});
parcelRegister("h75HQ", function(module, exports) {
function $c7578441bba1d8c9$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $c7578441bba1d8c9$var$incr32;

});


parcelRegister("fmEa8", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("kvo4q", function(module, exports) {

var $caH4w = parcelRequire("caH4w");

var $838j1 = parcelRequire("838j1");
var $eed95fc46cf3d7a4$require$Buffer = $838j1.Buffer;

var $6GOuC = parcelRequire("6GOuC");

var $dhT4G = parcelRequire("dhT4G");

var $9hgQS = parcelRequire("9hgQS");

var $lG93x = parcelRequire("lG93x");

var $h75HQ = parcelRequire("h75HQ");
function $eed95fc46cf3d7a4$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $eed95fc46cf3d7a4$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $eed95fc46cf3d7a4$require$Buffer.concat([
            iv,
            $eed95fc46cf3d7a4$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $eed95fc46cf3d7a4$require$Buffer.concat([
            iv,
            $eed95fc46cf3d7a4$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $9hgQS(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($eed95fc46cf3d7a4$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($eed95fc46cf3d7a4$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $eed95fc46cf3d7a4$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $eed95fc46cf3d7a4$require$Buffer.from(self._finID);
    $h75HQ(out);
    return out;
}
function $eed95fc46cf3d7a4$var$StreamCipher(mode, key, iv, decrypt) {
    $6GOuC.call(this);
    var h = $eed95fc46cf3d7a4$require$Buffer.alloc(4, 0);
    this._cipher = new $caH4w.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $9hgQS(ck);
    iv = $eed95fc46cf3d7a4$var$calcIv(this, iv, ck);
    this._prev = $eed95fc46cf3d7a4$require$Buffer.from(iv);
    this._cache = $eed95fc46cf3d7a4$require$Buffer.allocUnsafe(0);
    this._secCache = $eed95fc46cf3d7a4$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dhT4G($eed95fc46cf3d7a4$var$StreamCipher, $6GOuC);
$eed95fc46cf3d7a4$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $eed95fc46cf3d7a4$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$eed95fc46cf3d7a4$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $lG93x(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $eed95fc46cf3d7a4$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$eed95fc46cf3d7a4$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$eed95fc46cf3d7a4$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$eed95fc46cf3d7a4$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$eed95fc46cf3d7a4$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $eed95fc46cf3d7a4$var$StreamCipher;

});
parcelRegister("caH4w", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $8dc7d467606a8980$export$b80fbe1c3a2b92b5; }, function (v) { return $8dc7d467606a8980$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $8dc7d467606a8980$export$b80fbe1c3a2b92b5;

var $838j1 = parcelRequire("838j1");
var $8dc7d467606a8980$require$Buffer = $838j1.Buffer;
function $8dc7d467606a8980$var$asUInt32Array(buf) {
    if (!$8dc7d467606a8980$require$Buffer.isBuffer(buf)) buf = $8dc7d467606a8980$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $8dc7d467606a8980$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $8dc7d467606a8980$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $8dc7d467606a8980$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $8dc7d467606a8980$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $8dc7d467606a8980$var$AES(key) {
    this._key = $8dc7d467606a8980$var$asUInt32Array(key);
    this._reset();
}
$8dc7d467606a8980$var$AES.blockSize = 16;
$8dc7d467606a8980$var$AES.keySize = 32;
$8dc7d467606a8980$var$AES.prototype.blockSize = $8dc7d467606a8980$var$AES.blockSize;
$8dc7d467606a8980$var$AES.prototype.keySize = $8dc7d467606a8980$var$AES.keySize;
$8dc7d467606a8980$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $8dc7d467606a8980$var$G.SBOX[t >>> 24] << 24 | $8dc7d467606a8980$var$G.SBOX[t >>> 16 & 0xff] << 16 | $8dc7d467606a8980$var$G.SBOX[t >>> 8 & 0xff] << 8 | $8dc7d467606a8980$var$G.SBOX[t & 0xff];
            t ^= $8dc7d467606a8980$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $8dc7d467606a8980$var$G.SBOX[t >>> 24] << 24 | $8dc7d467606a8980$var$G.SBOX[t >>> 16 & 0xff] << 16 | $8dc7d467606a8980$var$G.SBOX[t >>> 8 & 0xff] << 8 | $8dc7d467606a8980$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $8dc7d467606a8980$var$G.INV_SUB_MIX[0][$8dc7d467606a8980$var$G.SBOX[tt >>> 24]] ^ $8dc7d467606a8980$var$G.INV_SUB_MIX[1][$8dc7d467606a8980$var$G.SBOX[tt >>> 16 & 0xff]] ^ $8dc7d467606a8980$var$G.INV_SUB_MIX[2][$8dc7d467606a8980$var$G.SBOX[tt >>> 8 & 0xff]] ^ $8dc7d467606a8980$var$G.INV_SUB_MIX[3][$8dc7d467606a8980$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$8dc7d467606a8980$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $8dc7d467606a8980$var$asUInt32Array(M);
    return $8dc7d467606a8980$var$cryptBlock(M, this._keySchedule, $8dc7d467606a8980$var$G.SUB_MIX, $8dc7d467606a8980$var$G.SBOX, this._nRounds);
};
$8dc7d467606a8980$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $8dc7d467606a8980$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$8dc7d467606a8980$var$AES.prototype.decryptBlock = function(M) {
    M = $8dc7d467606a8980$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $8dc7d467606a8980$var$cryptBlock(M, this._invKeySchedule, $8dc7d467606a8980$var$G.INV_SUB_MIX, $8dc7d467606a8980$var$G.INV_SBOX, this._nRounds);
    var buf = $8dc7d467606a8980$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$8dc7d467606a8980$var$AES.prototype.scrub = function() {
    $8dc7d467606a8980$var$scrubVec(this._keySchedule);
    $8dc7d467606a8980$var$scrubVec(this._invKeySchedule);
    $8dc7d467606a8980$var$scrubVec(this._key);
};
$8dc7d467606a8980$export$b80fbe1c3a2b92b5 = $8dc7d467606a8980$var$AES;

});

parcelRegister("9hgQS", function(module, exports) {

var $838j1 = parcelRequire("838j1");
var $6c12c604584aeb07$require$Buffer = $838j1.Buffer;
var $6c12c604584aeb07$var$ZEROES = $6c12c604584aeb07$require$Buffer.alloc(16, 0);
function $6c12c604584aeb07$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $6c12c604584aeb07$var$fromArray(out) {
    var buf = $6c12c604584aeb07$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $6c12c604584aeb07$var$GHASH(key) {
    this.h = key;
    this.state = $6c12c604584aeb07$require$Buffer.alloc(16, 0);
    this.cache = $6c12c604584aeb07$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$6c12c604584aeb07$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$6c12c604584aeb07$var$GHASH.prototype._multiply = function() {
    var Vi = $6c12c604584aeb07$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $6c12c604584aeb07$var$fromArray(Zi);
};
$6c12c604584aeb07$var$GHASH.prototype.update = function(buf) {
    this.cache = $6c12c604584aeb07$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$6c12c604584aeb07$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($6c12c604584aeb07$require$Buffer.concat([
        this.cache,
        $6c12c604584aeb07$var$ZEROES
    ], 16));
    this.ghash($6c12c604584aeb07$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $6c12c604584aeb07$var$GHASH;

});


parcelRegister("2mx7M", function(module, exports) {

var $caH4w = parcelRequire("caH4w");

var $838j1 = parcelRequire("838j1");
var $1b8754b29224ac43$require$Buffer = $838j1.Buffer;

var $6GOuC = parcelRequire("6GOuC");

var $dhT4G = parcelRequire("dhT4G");
function $1b8754b29224ac43$var$StreamCipher(mode, key, iv, decrypt) {
    $6GOuC.call(this);
    this._cipher = new $caH4w.AES(key);
    this._prev = $1b8754b29224ac43$require$Buffer.from(iv);
    this._cache = $1b8754b29224ac43$require$Buffer.allocUnsafe(0);
    this._secCache = $1b8754b29224ac43$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dhT4G($1b8754b29224ac43$var$StreamCipher, $6GOuC);
$1b8754b29224ac43$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$1b8754b29224ac43$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $1b8754b29224ac43$var$StreamCipher;

});

parcelRegister("iWvja", function(module, exports) {

var $838j1 = parcelRequire("838j1");
var $dca5eded79f2f8af$require$Buffer = $838j1.Buffer;

var $2GAk4 = parcelRequire("2GAk4");
/* eslint-disable camelcase */ function $dca5eded79f2f8af$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$dca5eded79f2f8af$require$Buffer.isBuffer(password)) password = $dca5eded79f2f8af$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$dca5eded79f2f8af$require$Buffer.isBuffer(salt)) salt = $dca5eded79f2f8af$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $dca5eded79f2f8af$require$Buffer.alloc(keyLen);
    var iv = $dca5eded79f2f8af$require$Buffer.alloc(ivLen || 0);
    var tmp = $dca5eded79f2f8af$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $2GAk4();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $dca5eded79f2f8af$var$EVP_BytesToKey;

});


parcelRegister("3eloO", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $25a34751f31406fd$export$12ada9414fbc594c; }, function (v) { return $25a34751f31406fd$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $25a34751f31406fd$export$36b6d6ef312eab39; }, function (v) { return $25a34751f31406fd$export$36b6d6ef312eab39 = v; });
var $25a34751f31406fd$export$12ada9414fbc594c;
var $25a34751f31406fd$export$36b6d6ef312eab39;

var $kvo4q = parcelRequire("kvo4q");

var $838j1 = parcelRequire("838j1");
var $25a34751f31406fd$require$Buffer = $838j1.Buffer;

var $gaNIZ = parcelRequire("gaNIZ");

var $2mx7M = parcelRequire("2mx7M");

var $6GOuC = parcelRequire("6GOuC");

var $caH4w = parcelRequire("caH4w");

var $iWvja = parcelRequire("iWvja");

var $dhT4G = parcelRequire("dhT4G");
function $25a34751f31406fd$var$Decipher(mode, key, iv) {
    $6GOuC.call(this);
    this._cache = new $25a34751f31406fd$var$Splitter();
    this._last = void 0;
    this._cipher = new $caH4w.AES(key);
    this._prev = $25a34751f31406fd$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dhT4G($25a34751f31406fd$var$Decipher, $6GOuC);
$25a34751f31406fd$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $25a34751f31406fd$require$Buffer.concat(out);
};
$25a34751f31406fd$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $25a34751f31406fd$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$25a34751f31406fd$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $25a34751f31406fd$var$Splitter() {
    this.cache = $25a34751f31406fd$require$Buffer.allocUnsafe(0);
}
$25a34751f31406fd$var$Splitter.prototype.add = function(data) {
    this.cache = $25a34751f31406fd$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$25a34751f31406fd$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$25a34751f31406fd$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $25a34751f31406fd$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $25a34751f31406fd$var$createDecipheriv(suite, password, iv) {
    var config = $gaNIZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $25a34751f31406fd$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $25a34751f31406fd$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $2mx7M(config.module, password, iv, true);
    else if (config.type === 'auth') return new $kvo4q(config.module, password, iv, true);
    return new $25a34751f31406fd$var$Decipher(config.module, password, iv);
}
function $25a34751f31406fd$var$createDecipher(suite, password) {
    var config = $gaNIZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $iWvja(password, false, config.key, config.iv);
    return $25a34751f31406fd$var$createDecipheriv(suite, keys.key, keys.iv);
}
$25a34751f31406fd$export$12ada9414fbc594c = $25a34751f31406fd$var$createDecipher;
$25a34751f31406fd$export$36b6d6ef312eab39 = $25a34751f31406fd$var$createDecipheriv;

});


parcelRegister("baPH8", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $8228ba5d20e426a7$export$116f8a5cee447347; }, function (v) { return $8228ba5d20e426a7$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $8228ba5d20e426a7$export$7483c4066bfb7ae9; }, function (v) { return $8228ba5d20e426a7$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $8228ba5d20e426a7$export$e7a565d2e588bb06; }, function (v) { return $8228ba5d20e426a7$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $8228ba5d20e426a7$export$aaa2f54a426f3eb8; }, function (v) { return $8228ba5d20e426a7$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $8228ba5d20e426a7$export$eba20568dde4ada; }, function (v) { return $8228ba5d20e426a7$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $8228ba5d20e426a7$export$d3b5e5996938f5ae; }, function (v) { return $8228ba5d20e426a7$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $8228ba5d20e426a7$export$57c08356130bc99b; }, function (v) { return $8228ba5d20e426a7$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $8228ba5d20e426a7$export$c7169791d5c1e65d; }, function (v) { return $8228ba5d20e426a7$export$c7169791d5c1e65d = v; });
var $8228ba5d20e426a7$export$116f8a5cee447347;
var $8228ba5d20e426a7$export$7483c4066bfb7ae9;
var $8228ba5d20e426a7$export$e7a565d2e588bb06;
var $8228ba5d20e426a7$export$aaa2f54a426f3eb8;
var $8228ba5d20e426a7$export$eba20568dde4ada;
var $8228ba5d20e426a7$export$d3b5e5996938f5ae;
var $8228ba5d20e426a7$export$57c08356130bc99b;
var $8228ba5d20e426a7$export$c7169791d5c1e65d;
$8228ba5d20e426a7$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$8228ba5d20e426a7$export$7483c4066bfb7ae9 = $8228ba5d20e426a7$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$8228ba5d20e426a7$export$aaa2f54a426f3eb8 = $8228ba5d20e426a7$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$8228ba5d20e426a7$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$8228ba5d20e426a7$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$8228ba5d20e426a7$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("8wQsp", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $635a00d17aeeed5c$export$971862a2fcb1bb40; }, function (v) { return $635a00d17aeeed5c$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $635a00d17aeeed5c$export$c6ff6a88acbeaf40; }, function (v) { return $635a00d17aeeed5c$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $635a00d17aeeed5c$export$fdc27893e98845cc; }, function (v) { return $635a00d17aeeed5c$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $635a00d17aeeed5c$export$6671fb9a1323bed; }, function (v) { return $635a00d17aeeed5c$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $635a00d17aeeed5c$export$d74daf141a551db; }, function (v) { return $635a00d17aeeed5c$export$d74daf141a551db = v; });
var $635a00d17aeeed5c$export$971862a2fcb1bb40;
var $635a00d17aeeed5c$export$c6ff6a88acbeaf40;
var $635a00d17aeeed5c$export$fdc27893e98845cc;
var $635a00d17aeeed5c$export$6671fb9a1323bed;
var $635a00d17aeeed5c$export$d74daf141a551db;

var $bdjQ6 = parcelRequire("bdjQ6");
var $635a00d17aeeed5c$require$Buffer = $bdjQ6.Buffer;

var $9quzp = parcelRequire("9quzp");

var $lNdHe = parcelRequire("lNdHe");

var $8Xury = parcelRequire("8Xury");
function $635a00d17aeeed5c$var$getDiffieHellman(mod) {
    var prime = new $635a00d17aeeed5c$require$Buffer($lNdHe[mod].prime, 'hex');
    var gen = new $635a00d17aeeed5c$require$Buffer($lNdHe[mod].gen, 'hex');
    return new $8Xury(prime, gen);
}
var $635a00d17aeeed5c$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $635a00d17aeeed5c$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($635a00d17aeeed5c$require$Buffer.isBuffer(enc) || $635a00d17aeeed5c$var$ENCODINGS[enc] === undefined) return $635a00d17aeeed5c$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $635a00d17aeeed5c$require$Buffer([
        2
    ]);
    if (!$635a00d17aeeed5c$require$Buffer.isBuffer(generator)) generator = new $635a00d17aeeed5c$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $8Xury($9quzp(prime, generator), generator, true);
    if (!$635a00d17aeeed5c$require$Buffer.isBuffer(prime)) prime = new $635a00d17aeeed5c$require$Buffer(prime, enc);
    return new $8Xury(prime, generator, true);
}
$635a00d17aeeed5c$export$971862a2fcb1bb40 = $635a00d17aeeed5c$export$c6ff6a88acbeaf40 = $635a00d17aeeed5c$export$fdc27893e98845cc = $635a00d17aeeed5c$var$getDiffieHellman;
$635a00d17aeeed5c$export$6671fb9a1323bed = $635a00d17aeeed5c$export$d74daf141a551db = $635a00d17aeeed5c$var$createDiffieHellman;

});
parcelRegister("9quzp", function(module, exports) {

var $f08he = parcelRequire("f08he");
module.exports = $6dce41594cded7d5$var$findPrime;
$6dce41594cded7d5$var$findPrime.simpleSieve = $6dce41594cded7d5$var$simpleSieve;
$6dce41594cded7d5$var$findPrime.fermatTest = $6dce41594cded7d5$var$fermatTest;

var $8pG42 = parcelRequire("8pG42");
var $6dce41594cded7d5$var$TWENTYFOUR = new $8pG42(24);

var $gVwT3 = parcelRequire("gVwT3");
var $6dce41594cded7d5$var$millerRabin = new $gVwT3();
var $6dce41594cded7d5$var$ONE = new $8pG42(1);
var $6dce41594cded7d5$var$TWO = new $8pG42(2);
var $6dce41594cded7d5$var$FIVE = new $8pG42(5);
var $6dce41594cded7d5$var$SIXTEEN = new $8pG42(16);
var $6dce41594cded7d5$var$EIGHT = new $8pG42(8);
var $6dce41594cded7d5$var$TEN = new $8pG42(10);
var $6dce41594cded7d5$var$THREE = new $8pG42(3);
var $6dce41594cded7d5$var$SEVEN = new $8pG42(7);
var $6dce41594cded7d5$var$ELEVEN = new $8pG42(11);
var $6dce41594cded7d5$var$FOUR = new $8pG42(4);
var $6dce41594cded7d5$var$TWELVE = new $8pG42(12);
var $6dce41594cded7d5$var$primes = null;
function $6dce41594cded7d5$var$_getPrimes() {
    if ($6dce41594cded7d5$var$primes !== null) return $6dce41594cded7d5$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $6dce41594cded7d5$var$primes = res;
    return res;
}
function $6dce41594cded7d5$var$simpleSieve(p) {
    var primes = $6dce41594cded7d5$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $6dce41594cded7d5$var$fermatTest(p) {
    var red = $8pG42.mont(p);
    return $6dce41594cded7d5$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $6dce41594cded7d5$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $8pG42([
            0x8c,
            0x7b
        ]);
        else return new $8pG42([
            0x8c,
            0x27
        ]);
    }
    gen = new $8pG42(gen);
    var num, n2;
    while(true){
        num = new $8pG42($f08he(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($6dce41594cded7d5$var$ONE);
        if (!num.testn(1)) num.iadd($6dce41594cded7d5$var$TWO);
        if (!gen.cmp($6dce41594cded7d5$var$TWO)) while(num.mod($6dce41594cded7d5$var$TWENTYFOUR).cmp($6dce41594cded7d5$var$ELEVEN))num.iadd($6dce41594cded7d5$var$FOUR);
        else if (!gen.cmp($6dce41594cded7d5$var$FIVE)) while(num.mod($6dce41594cded7d5$var$TEN).cmp($6dce41594cded7d5$var$THREE))num.iadd($6dce41594cded7d5$var$FOUR);
        n2 = num.shrn(1);
        if ($6dce41594cded7d5$var$simpleSieve(n2) && $6dce41594cded7d5$var$simpleSieve(num) && $6dce41594cded7d5$var$fermatTest(n2) && $6dce41594cded7d5$var$fermatTest(num) && $6dce41594cded7d5$var$millerRabin.test(n2) && $6dce41594cded7d5$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("8pG42", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("gVwT3", function(module, exports) {

var $8OaS6 = parcelRequire("8OaS6");

var $gWiKw = parcelRequire("gWiKw");
function $c52b7ae23bf69e77$var$MillerRabin(rand) {
    this.rand = rand || new $gWiKw.Rand();
}
module.exports = $c52b7ae23bf69e77$var$MillerRabin;
$c52b7ae23bf69e77$var$MillerRabin.create = function create(rand) {
    return new $c52b7ae23bf69e77$var$MillerRabin(rand);
};
$c52b7ae23bf69e77$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $8OaS6(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$c52b7ae23bf69e77$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$c52b7ae23bf69e77$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $8OaS6.mont(n);
    var rone = new $8OaS6(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $8OaS6(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$c52b7ae23bf69e77$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $8OaS6.mont(n);
    var rone = new $8OaS6(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $8OaS6(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("8OaS6", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("gWiKw", function(module, exports) {
var $c5509b5bd465f083$var$r;
module.exports = function rand(len) {
    if (!$c5509b5bd465f083$var$r) $c5509b5bd465f083$var$r = new $c5509b5bd465f083$var$Rand(null);
    return $c5509b5bd465f083$var$r.generate(len);
};
function $c5509b5bd465f083$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $c5509b5bd465f083$var$Rand;
$c5509b5bd465f083$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$c5509b5bd465f083$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $c5509b5bd465f083$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $c5509b5bd465f083$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $c5509b5bd465f083$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $c5509b5bd465f083$var$crypto = (parcelRequire("ifbub"));
    if (typeof $c5509b5bd465f083$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $c5509b5bd465f083$var$Rand.prototype._rand = function _rand(n) {
        return $c5509b5bd465f083$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("lNdHe", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("8Xury", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $685b72df33913130$require$Buffer = $bdjQ6.Buffer;

var $8pG42 = parcelRequire("8pG42");

var $gVwT3 = parcelRequire("gVwT3");
var $685b72df33913130$var$millerRabin = new $gVwT3();
var $685b72df33913130$var$TWENTYFOUR = new $8pG42(24);
var $685b72df33913130$var$ELEVEN = new $8pG42(11);
var $685b72df33913130$var$TEN = new $8pG42(10);
var $685b72df33913130$var$THREE = new $8pG42(3);
var $685b72df33913130$var$SEVEN = new $8pG42(7);

var $9quzp = parcelRequire("9quzp");

var $f08he = parcelRequire("f08he");
module.exports = $685b72df33913130$var$DH;
function $685b72df33913130$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$685b72df33913130$require$Buffer.isBuffer(pub)) pub = new $685b72df33913130$require$Buffer(pub, enc);
    this._pub = new $8pG42(pub);
    return this;
}
function $685b72df33913130$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$685b72df33913130$require$Buffer.isBuffer(priv)) priv = new $685b72df33913130$require$Buffer(priv, enc);
    this._priv = new $8pG42(priv);
    return this;
}
var $685b72df33913130$var$primeCache = {};
function $685b72df33913130$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $685b72df33913130$var$primeCache) return $685b72df33913130$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$9quzp.simpleSieve || !$9quzp.fermatTest(prime) || !$685b72df33913130$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $685b72df33913130$var$primeCache[hex] = error;
        return error;
    }
    if (!$685b72df33913130$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($685b72df33913130$var$TWENTYFOUR).cmp($685b72df33913130$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($685b72df33913130$var$TEN);
            if (rem.cmp($685b72df33913130$var$THREE) && rem.cmp($685b72df33913130$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $685b72df33913130$var$primeCache[hex] = error;
    return error;
}
function $685b72df33913130$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $8pG42(prime);
    this._prime = $8pG42.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $685b72df33913130$var$setPublicKey;
        this.setPrivateKey = $685b72df33913130$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($685b72df33913130$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $685b72df33913130$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$685b72df33913130$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $8pG42($f08he(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$685b72df33913130$var$DH.prototype.computeSecret = function(other) {
    other = new $8pG42(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $685b72df33913130$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $685b72df33913130$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $685b72df33913130$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$685b72df33913130$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $685b72df33913130$var$formatReturnValue(this._pub, enc);
};
$685b72df33913130$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $685b72df33913130$var$formatReturnValue(this._priv, enc);
};
$685b72df33913130$var$DH.prototype.getPrime = function(enc) {
    return $685b72df33913130$var$formatReturnValue(this.__prime, enc);
};
$685b72df33913130$var$DH.prototype.getGenerator = function(enc) {
    return $685b72df33913130$var$formatReturnValue(this._gen, enc);
};
$685b72df33913130$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$685b72df33913130$require$Buffer.isBuffer(gen)) gen = new $685b72df33913130$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $8pG42(gen);
    return this;
};
function $685b72df33913130$var$formatReturnValue(bn, enc) {
    var buf = new $685b72df33913130$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("bASYu", function(module, exports) {
'use strict';

var $2BV4h = parcelRequire("2BV4h");
var $870db353fba87e6d$require$Buffer = $2BV4h.Buffer;

var $eNPUV = parcelRequire("eNPUV");

var $3FzHL = parcelRequire("3FzHL");

var $dhT4G = parcelRequire("dhT4G");

var $61Mau = parcelRequire("61Mau");

var $7LwOP = parcelRequire("7LwOP");

var $gm4QM = parcelRequire("gm4QM");
Object.keys($gm4QM).forEach(function(key) {
    $gm4QM[key].id = $870db353fba87e6d$require$Buffer.from($gm4QM[key].id, 'hex');
    $gm4QM[key.toLowerCase()] = $gm4QM[key];
});
function $870db353fba87e6d$var$Sign(algorithm) {
    $3FzHL.Writable.call(this);
    var data = $gm4QM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $eNPUV(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dhT4G($870db353fba87e6d$var$Sign, $3FzHL.Writable);
$870db353fba87e6d$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$870db353fba87e6d$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $870db353fba87e6d$require$Buffer.from(data, enc) : data);
    return this;
};
$870db353fba87e6d$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $61Mau(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $870db353fba87e6d$var$Verify(algorithm) {
    $3FzHL.Writable.call(this);
    var data = $gm4QM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $eNPUV(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dhT4G($870db353fba87e6d$var$Verify, $3FzHL.Writable);
$870db353fba87e6d$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$870db353fba87e6d$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $870db353fba87e6d$require$Buffer.from(data, enc) : data);
    return this;
};
$870db353fba87e6d$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $870db353fba87e6d$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $7LwOP(sigBuffer, hash, key, this._signType, this._tag);
};
function $870db353fba87e6d$var$createSign(algorithm) {
    return new $870db353fba87e6d$var$Sign(algorithm);
}
function $870db353fba87e6d$var$createVerify(algorithm) {
    return new $870db353fba87e6d$var$Verify(algorithm);
}
module.exports = {
    Sign: $870db353fba87e6d$var$createSign,
    Verify: $870db353fba87e6d$var$createVerify,
    createSign: $870db353fba87e6d$var$createSign,
    createVerify: $870db353fba87e6d$var$createVerify
};

});
parcelRegister("2BV4h", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $1e6b4e049f87d160$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $1e6b4e049f87d160$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1e6b4e049f87d160$var$Buffer.from && $1e6b4e049f87d160$var$Buffer.alloc && $1e6b4e049f87d160$var$Buffer.allocUnsafe && $1e6b4e049f87d160$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $1e6b4e049f87d160$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $1e6b4e049f87d160$var$SafeBuffer;
}
function $1e6b4e049f87d160$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1e6b4e049f87d160$var$Buffer(arg, encodingOrOffset, length);
}
$1e6b4e049f87d160$var$SafeBuffer.prototype = Object.create($1e6b4e049f87d160$var$Buffer.prototype);
// Copy static methods from Buffer
$1e6b4e049f87d160$var$copyProps($1e6b4e049f87d160$var$Buffer, $1e6b4e049f87d160$var$SafeBuffer);
$1e6b4e049f87d160$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1e6b4e049f87d160$var$Buffer(arg, encodingOrOffset, length);
};
$1e6b4e049f87d160$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1e6b4e049f87d160$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1e6b4e049f87d160$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1e6b4e049f87d160$var$Buffer(size);
};
$1e6b4e049f87d160$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});

parcelRegister("3FzHL", function(module, exports) {

exports = module.exports = (parcelRequire("7gczh"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("f3mh1"));

exports.Duplex = (parcelRequire("ep9tV"));

exports.Transform = (parcelRequire("9x3zF"));

exports.PassThrough = (parcelRequire("lSfvK"));

});
parcelRegister("7gczh", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ module.exports = $5493c6c74711d5c3$var$Readable;

var $lhjsw = parcelRequire("lhjsw");
/*</replacement>*/ /*<replacement>*/ var $5493c6c74711d5c3$var$Duplex;
/*</replacement>*/ $5493c6c74711d5c3$var$Readable.ReadableState = $5493c6c74711d5c3$var$ReadableState;

var $fzCxw = parcelRequire("fzCxw");
var $5493c6c74711d5c3$require$EE = $fzCxw.EventEmitter;
var $5493c6c74711d5c3$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $haBXF = parcelRequire("haBXF");

var $7yWZN = parcelRequire("7yWZN");
var $5493c6c74711d5c3$require$Buffer = $7yWZN.Buffer;
var $5493c6c74711d5c3$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $5493c6c74711d5c3$var$_uint8ArrayToBuffer(chunk) {
    return $5493c6c74711d5c3$require$Buffer.from(chunk);
}
function $5493c6c74711d5c3$var$_isUint8Array(obj) {
    return $5493c6c74711d5c3$require$Buffer.isBuffer(obj) || obj instanceof $5493c6c74711d5c3$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $5493c6c74711d5c3$var$util = Object.create((parcelRequire("6PLnu")));

$5493c6c74711d5c3$var$util.inherits = (parcelRequire("dhT4G"));

var $ifbub = parcelRequire("ifbub");
var $5493c6c74711d5c3$var$debug = void 0;
if ($ifbub && $ifbub.debuglog) $5493c6c74711d5c3$var$debug = $ifbub.debuglog('stream');
else $5493c6c74711d5c3$var$debug = function() {};

var $aLzcH = parcelRequire("aLzcH");

var $eexjm = parcelRequire("eexjm");
var $5493c6c74711d5c3$var$StringDecoder;
$5493c6c74711d5c3$var$util.inherits($5493c6c74711d5c3$var$Readable, $haBXF);
var $5493c6c74711d5c3$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $5493c6c74711d5c3$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($lhjsw(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $5493c6c74711d5c3$var$ReadableState(options, stream) {
    $5493c6c74711d5c3$var$Duplex = $5493c6c74711d5c3$var$Duplex || (parcelRequire("ep9tV"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $5493c6c74711d5c3$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $aLzcH();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$5493c6c74711d5c3$var$StringDecoder) $5493c6c74711d5c3$var$StringDecoder = (parcelRequire("adA2x")).StringDecoder;
        this.decoder = new $5493c6c74711d5c3$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $5493c6c74711d5c3$var$Readable(options) {
    $5493c6c74711d5c3$var$Duplex = $5493c6c74711d5c3$var$Duplex || (parcelRequire("ep9tV"));
    if (!(this instanceof $5493c6c74711d5c3$var$Readable)) return new $5493c6c74711d5c3$var$Readable(options);
    this._readableState = new $5493c6c74711d5c3$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $haBXF.call(this);
}
Object.defineProperty($5493c6c74711d5c3$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$5493c6c74711d5c3$var$Readable.prototype.destroy = $eexjm.destroy;
$5493c6c74711d5c3$var$Readable.prototype._undestroy = $eexjm.undestroy;
$5493c6c74711d5c3$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$5493c6c74711d5c3$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $5493c6c74711d5c3$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $5493c6c74711d5c3$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$5493c6c74711d5c3$var$Readable.prototype.unshift = function(chunk) {
    return $5493c6c74711d5c3$var$readableAddChunk(this, chunk, null, true, false);
};
function $5493c6c74711d5c3$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $5493c6c74711d5c3$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $5493c6c74711d5c3$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $5493c6c74711d5c3$require$Buffer.prototype) chunk = $5493c6c74711d5c3$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $5493c6c74711d5c3$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $5493c6c74711d5c3$var$addChunk(stream, state, chunk, false);
                    else $5493c6c74711d5c3$var$maybeReadMore(stream, state);
                } else $5493c6c74711d5c3$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $5493c6c74711d5c3$var$needMoreData(state);
}
function $5493c6c74711d5c3$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $5493c6c74711d5c3$var$emitReadable(stream);
    }
    $5493c6c74711d5c3$var$maybeReadMore(stream, state);
}
function $5493c6c74711d5c3$var$chunkInvalid(state, chunk) {
    var er;
    if (!$5493c6c74711d5c3$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $5493c6c74711d5c3$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$5493c6c74711d5c3$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$5493c6c74711d5c3$var$Readable.prototype.setEncoding = function(enc) {
    if (!$5493c6c74711d5c3$var$StringDecoder) $5493c6c74711d5c3$var$StringDecoder = (parcelRequire("adA2x")).StringDecoder;
    this._readableState.decoder = new $5493c6c74711d5c3$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $5493c6c74711d5c3$var$MAX_HWM = 0x800000;
function $5493c6c74711d5c3$var$computeNewHighWaterMark(n) {
    if (n >= $5493c6c74711d5c3$var$MAX_HWM) n = $5493c6c74711d5c3$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $5493c6c74711d5c3$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $5493c6c74711d5c3$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$5493c6c74711d5c3$var$Readable.prototype.read = function(n) {
    $5493c6c74711d5c3$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $5493c6c74711d5c3$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $5493c6c74711d5c3$var$endReadable(this);
        else $5493c6c74711d5c3$var$emitReadable(this);
        return null;
    }
    n = $5493c6c74711d5c3$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $5493c6c74711d5c3$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $5493c6c74711d5c3$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $5493c6c74711d5c3$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $5493c6c74711d5c3$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $5493c6c74711d5c3$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $5493c6c74711d5c3$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $5493c6c74711d5c3$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $5493c6c74711d5c3$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $5493c6c74711d5c3$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $5493c6c74711d5c3$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $5493c6c74711d5c3$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $5493c6c74711d5c3$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $e5LkN.nextTick($5493c6c74711d5c3$var$emitReadable_, stream);
        else $5493c6c74711d5c3$var$emitReadable_(stream);
    }
}
function $5493c6c74711d5c3$var$emitReadable_(stream) {
    $5493c6c74711d5c3$var$debug('emit readable');
    stream.emit('readable');
    $5493c6c74711d5c3$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $5493c6c74711d5c3$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $e5LkN.nextTick($5493c6c74711d5c3$var$maybeReadMore_, stream, state);
    }
}
function $5493c6c74711d5c3$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $5493c6c74711d5c3$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$5493c6c74711d5c3$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$5493c6c74711d5c3$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $5493c6c74711d5c3$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4ZL0H.stdout && dest !== $4ZL0H.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $e5LkN.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $5493c6c74711d5c3$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $5493c6c74711d5c3$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $5493c6c74711d5c3$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $5493c6c74711d5c3$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $5493c6c74711d5c3$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $5493c6c74711d5c3$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $5493c6c74711d5c3$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $5493c6c74711d5c3$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($5493c6c74711d5c3$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $5493c6c74711d5c3$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $5493c6c74711d5c3$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $5493c6c74711d5c3$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $5493c6c74711d5c3$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $5493c6c74711d5c3$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $5493c6c74711d5c3$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $5493c6c74711d5c3$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $5493c6c74711d5c3$var$flow(src);
        }
    };
}
$5493c6c74711d5c3$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $5493c6c74711d5c3$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$5493c6c74711d5c3$var$Readable.prototype.on = function(ev, fn) {
    var res = $haBXF.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $e5LkN.nextTick($5493c6c74711d5c3$var$nReadingNextTick, this);
            else if (state.length) $5493c6c74711d5c3$var$emitReadable(this);
        }
    }
    return res;
};
$5493c6c74711d5c3$var$Readable.prototype.addListener = $5493c6c74711d5c3$var$Readable.prototype.on;
function $5493c6c74711d5c3$var$nReadingNextTick(self1) {
    $5493c6c74711d5c3$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$5493c6c74711d5c3$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $5493c6c74711d5c3$var$debug('resume');
        state.flowing = true;
        $5493c6c74711d5c3$var$resume(this, state);
    }
    return this;
};
function $5493c6c74711d5c3$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $e5LkN.nextTick($5493c6c74711d5c3$var$resume_, stream, state);
    }
}
function $5493c6c74711d5c3$var$resume_(stream, state) {
    if (!state.reading) {
        $5493c6c74711d5c3$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $5493c6c74711d5c3$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$5493c6c74711d5c3$var$Readable.prototype.pause = function() {
    $5493c6c74711d5c3$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $5493c6c74711d5c3$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $5493c6c74711d5c3$var$flow(stream) {
    var state = stream._readableState;
    $5493c6c74711d5c3$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$5493c6c74711d5c3$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $5493c6c74711d5c3$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $5493c6c74711d5c3$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $5493c6c74711d5c3$var$kProxyEvents.length; n++)stream.on($5493c6c74711d5c3$var$kProxyEvents[n], this.emit.bind(this, $5493c6c74711d5c3$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $5493c6c74711d5c3$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($5493c6c74711d5c3$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$5493c6c74711d5c3$var$Readable._fromList = $5493c6c74711d5c3$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $5493c6c74711d5c3$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $5493c6c74711d5c3$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $5493c6c74711d5c3$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $5493c6c74711d5c3$var$copyFromBufferString(n, list) : $5493c6c74711d5c3$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $5493c6c74711d5c3$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $5493c6c74711d5c3$var$copyFromBuffer(n, list) {
    var ret = $5493c6c74711d5c3$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $5493c6c74711d5c3$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $e5LkN.nextTick($5493c6c74711d5c3$var$endReadableNT, state, stream);
    }
}
function $5493c6c74711d5c3$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $5493c6c74711d5c3$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("lhjsw", function(module, exports) {
var $f7da47a93bef43f5$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $f7da47a93bef43f5$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("haBXF", function(module, exports) {

module.exports = (parcelRequire("fzCxw")).EventEmitter;

});

parcelRegister("7yWZN", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $581978b6b4c3b5bc$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $581978b6b4c3b5bc$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($581978b6b4c3b5bc$var$Buffer.from && $581978b6b4c3b5bc$var$Buffer.alloc && $581978b6b4c3b5bc$var$Buffer.allocUnsafe && $581978b6b4c3b5bc$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $581978b6b4c3b5bc$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $581978b6b4c3b5bc$var$SafeBuffer;
}
function $581978b6b4c3b5bc$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $581978b6b4c3b5bc$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$581978b6b4c3b5bc$var$copyProps($581978b6b4c3b5bc$var$Buffer, $581978b6b4c3b5bc$var$SafeBuffer);
$581978b6b4c3b5bc$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $581978b6b4c3b5bc$var$Buffer(arg, encodingOrOffset, length);
};
$581978b6b4c3b5bc$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $581978b6b4c3b5bc$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$581978b6b4c3b5bc$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $581978b6b4c3b5bc$var$Buffer(size);
};
$581978b6b4c3b5bc$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});

parcelRegister("aLzcH", function(module, exports) {
'use strict';
function $7d6999f0216a30e8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $7yWZN = parcelRequire("7yWZN");
var $7d6999f0216a30e8$require$Buffer = $7yWZN.Buffer;

var $ifbub = parcelRequire("ifbub");
function $7d6999f0216a30e8$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $7d6999f0216a30e8$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $7d6999f0216a30e8$require$Buffer.alloc(0);
        var ret = $7d6999f0216a30e8$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $7d6999f0216a30e8$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($ifbub && $ifbub.inspect && $ifbub.inspect.custom) module.exports.prototype[$ifbub.inspect.custom] = function() {
    var obj = $ifbub.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("eexjm", function(module, exports) {
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $a5cc3668aa1f8ecc$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $e5LkN.nextTick($a5cc3668aa1f8ecc$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $e5LkN.nextTick($a5cc3668aa1f8ecc$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $e5LkN.nextTick($a5cc3668aa1f8ecc$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $e5LkN.nextTick($a5cc3668aa1f8ecc$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $a5cc3668aa1f8ecc$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $a5cc3668aa1f8ecc$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $a5cc3668aa1f8ecc$var$destroy,
    undestroy: $a5cc3668aa1f8ecc$var$undestroy
};

});

parcelRegister("ep9tV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ /*<replacement>*/ var $a7cac15e86eecd2a$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $a7cac15e86eecd2a$var$Duplex;

/*<replacement>*/ var $a7cac15e86eecd2a$var$util = Object.create((parcelRequire("6PLnu")));

$a7cac15e86eecd2a$var$util.inherits = (parcelRequire("dhT4G"));

var $7gczh = parcelRequire("7gczh");

var $f3mh1 = parcelRequire("f3mh1");
$a7cac15e86eecd2a$var$util.inherits($a7cac15e86eecd2a$var$Duplex, $7gczh);
// avoid scope creep, the keys array can then be collected
var $a7cac15e86eecd2a$var$keys = $a7cac15e86eecd2a$var$objectKeys($f3mh1.prototype);
for(var $a7cac15e86eecd2a$var$v = 0; $a7cac15e86eecd2a$var$v < $a7cac15e86eecd2a$var$keys.length; $a7cac15e86eecd2a$var$v++){
    var $a7cac15e86eecd2a$var$method = $a7cac15e86eecd2a$var$keys[$a7cac15e86eecd2a$var$v];
    if (!$a7cac15e86eecd2a$var$Duplex.prototype[$a7cac15e86eecd2a$var$method]) $a7cac15e86eecd2a$var$Duplex.prototype[$a7cac15e86eecd2a$var$method] = $f3mh1.prototype[$a7cac15e86eecd2a$var$method];
}
function $a7cac15e86eecd2a$var$Duplex(options) {
    if (!(this instanceof $a7cac15e86eecd2a$var$Duplex)) return new $a7cac15e86eecd2a$var$Duplex(options);
    $7gczh.call(this, options);
    $f3mh1.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $a7cac15e86eecd2a$var$onend);
}
Object.defineProperty($a7cac15e86eecd2a$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $a7cac15e86eecd2a$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $e5LkN.nextTick($a7cac15e86eecd2a$var$onEndNT, this);
}
function $a7cac15e86eecd2a$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($a7cac15e86eecd2a$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$a7cac15e86eecd2a$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $e5LkN.nextTick(cb, err);
};

});
parcelRegister("f3mh1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ module.exports = $af5869e6402c9d87$var$Writable;
/* <replacement> */ function $af5869e6402c9d87$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $af5869e6402c9d87$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $af5869e6402c9d87$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $af5869e6402c9d87$var$asyncWrite = (0, $e5LkN.nextTick);
/*</replacement>*/ /*<replacement>*/ var $af5869e6402c9d87$var$Duplex;
/*</replacement>*/ $af5869e6402c9d87$var$Writable.WritableState = $af5869e6402c9d87$var$WritableState;

/*<replacement>*/ var $af5869e6402c9d87$var$util = Object.create((parcelRequire("6PLnu")));

$af5869e6402c9d87$var$util.inherits = (parcelRequire("dhT4G"));

/*</replacement>*/ /*<replacement>*/ var $af5869e6402c9d87$var$internalUtil = {
    deprecate: (parcelRequire("4SymK"))
};

var $haBXF = parcelRequire("haBXF");

var $7yWZN = parcelRequire("7yWZN");
var $af5869e6402c9d87$require$Buffer = $7yWZN.Buffer;
var $af5869e6402c9d87$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $af5869e6402c9d87$var$_uint8ArrayToBuffer(chunk) {
    return $af5869e6402c9d87$require$Buffer.from(chunk);
}
function $af5869e6402c9d87$var$_isUint8Array(obj) {
    return $af5869e6402c9d87$require$Buffer.isBuffer(obj) || obj instanceof $af5869e6402c9d87$var$OurUint8Array;
}

var $eexjm = parcelRequire("eexjm");
$af5869e6402c9d87$var$util.inherits($af5869e6402c9d87$var$Writable, $haBXF);
function $af5869e6402c9d87$var$nop() {}

function $af5869e6402c9d87$var$WritableState(options, stream) {
    $af5869e6402c9d87$var$Duplex = $af5869e6402c9d87$var$Duplex || (parcelRequire("ep9tV"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $af5869e6402c9d87$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $af5869e6402c9d87$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $af5869e6402c9d87$var$CorkedRequest(this);
}
$af5869e6402c9d87$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($af5869e6402c9d87$var$WritableState.prototype, 'buffer', {
            get: $af5869e6402c9d87$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $af5869e6402c9d87$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $af5869e6402c9d87$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($af5869e6402c9d87$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($af5869e6402c9d87$var$realHasInstance.call(this, object)) return true;
            if (this !== $af5869e6402c9d87$var$Writable) return false;
            return object && object._writableState instanceof $af5869e6402c9d87$var$WritableState;
        }
    });
} else $af5869e6402c9d87$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $af5869e6402c9d87$var$Writable(options) {
    $af5869e6402c9d87$var$Duplex = $af5869e6402c9d87$var$Duplex || (parcelRequire("ep9tV"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$af5869e6402c9d87$var$realHasInstance.call($af5869e6402c9d87$var$Writable, this) && !(this instanceof $af5869e6402c9d87$var$Duplex)) return new $af5869e6402c9d87$var$Writable(options);
    this._writableState = new $af5869e6402c9d87$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $haBXF.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$af5869e6402c9d87$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $af5869e6402c9d87$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $e5LkN.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $af5869e6402c9d87$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $e5LkN.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$af5869e6402c9d87$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $af5869e6402c9d87$var$_isUint8Array(chunk);
    if (isBuf && !$af5869e6402c9d87$require$Buffer.isBuffer(chunk)) chunk = $af5869e6402c9d87$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $af5869e6402c9d87$var$nop;
    if (state.ended) $af5869e6402c9d87$var$writeAfterEnd(this, cb);
    else if (isBuf || $af5869e6402c9d87$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $af5869e6402c9d87$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$af5869e6402c9d87$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$af5869e6402c9d87$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $af5869e6402c9d87$var$clearBuffer(this, state);
    }
};
$af5869e6402c9d87$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $af5869e6402c9d87$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $af5869e6402c9d87$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($af5869e6402c9d87$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $af5869e6402c9d87$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $af5869e6402c9d87$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $af5869e6402c9d87$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $af5869e6402c9d87$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $af5869e6402c9d87$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $e5LkN.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $e5LkN.nextTick($af5869e6402c9d87$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $af5869e6402c9d87$var$finishMaybe(stream, state);
    }
}
function $af5869e6402c9d87$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $af5869e6402c9d87$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $af5869e6402c9d87$var$onwriteStateUpdate(state);
    if (er) $af5869e6402c9d87$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $af5869e6402c9d87$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $af5869e6402c9d87$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $af5869e6402c9d87$var$asyncWrite($af5869e6402c9d87$var$afterWrite, stream, state, finished, cb);
        else $af5869e6402c9d87$var$afterWrite(stream, state, finished, cb);
    }
}
function $af5869e6402c9d87$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $af5869e6402c9d87$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $af5869e6402c9d87$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $af5869e6402c9d87$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $af5869e6402c9d87$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $af5869e6402c9d87$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $af5869e6402c9d87$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $af5869e6402c9d87$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$af5869e6402c9d87$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$af5869e6402c9d87$var$Writable.prototype._writev = null;
$af5869e6402c9d87$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $af5869e6402c9d87$var$endWritable(this, state, cb);
};
function $af5869e6402c9d87$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $af5869e6402c9d87$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $af5869e6402c9d87$var$finishMaybe(stream, state);
    });
}
function $af5869e6402c9d87$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $e5LkN.nextTick($af5869e6402c9d87$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $af5869e6402c9d87$var$finishMaybe(stream, state) {
    var need = $af5869e6402c9d87$var$needFinish(state);
    if (need) {
        $af5869e6402c9d87$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $af5869e6402c9d87$var$endWritable(stream, state, cb) {
    state.ending = true;
    $af5869e6402c9d87$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $e5LkN.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $af5869e6402c9d87$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($af5869e6402c9d87$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$af5869e6402c9d87$var$Writable.prototype.destroy = $eexjm.destroy;
$af5869e6402c9d87$var$Writable.prototype._undestroy = $eexjm.undestroy;
$af5869e6402c9d87$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("adA2x", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $77071313de625c79$export$63a7aa211a91ed69; }, function (v) { return $77071313de625c79$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $77071313de625c79$export$63a7aa211a91ed69;
'use strict';

var $3pd7a = parcelRequire("3pd7a");
var $77071313de625c79$require$Buffer = $3pd7a.Buffer;
/*</replacement>*/ var $77071313de625c79$var$isEncoding = $77071313de625c79$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $77071313de625c79$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $77071313de625c79$var$normalizeEncoding(enc) {
    var nenc = $77071313de625c79$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($77071313de625c79$require$Buffer.isEncoding === $77071313de625c79$var$isEncoding || !$77071313de625c79$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$77071313de625c79$export$63a7aa211a91ed69 = $77071313de625c79$var$StringDecoder;
function $77071313de625c79$var$StringDecoder(encoding) {
    this.encoding = $77071313de625c79$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $77071313de625c79$var$utf16Text;
            this.end = $77071313de625c79$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $77071313de625c79$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $77071313de625c79$var$base64Text;
            this.end = $77071313de625c79$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $77071313de625c79$var$simpleWrite;
            this.end = $77071313de625c79$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $77071313de625c79$require$Buffer.allocUnsafe(nb);
}
$77071313de625c79$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$77071313de625c79$var$StringDecoder.prototype.end = $77071313de625c79$var$utf8End;
// Returns only complete characters in a Buffer
$77071313de625c79$var$StringDecoder.prototype.text = $77071313de625c79$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$77071313de625c79$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $77071313de625c79$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $77071313de625c79$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $77071313de625c79$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $77071313de625c79$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $77071313de625c79$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $77071313de625c79$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $77071313de625c79$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $77071313de625c79$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $77071313de625c79$var$utf8Text(buf, i) {
    var total = $77071313de625c79$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $77071313de625c79$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $77071313de625c79$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $77071313de625c79$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $77071313de625c79$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $77071313de625c79$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $77071313de625c79$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $77071313de625c79$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("3pd7a", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $27ade13088d22028$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $27ade13088d22028$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($27ade13088d22028$var$Buffer.from && $27ade13088d22028$var$Buffer.alloc && $27ade13088d22028$var$Buffer.allocUnsafe && $27ade13088d22028$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $27ade13088d22028$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $27ade13088d22028$var$SafeBuffer;
}
function $27ade13088d22028$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $27ade13088d22028$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$27ade13088d22028$var$copyProps($27ade13088d22028$var$Buffer, $27ade13088d22028$var$SafeBuffer);
$27ade13088d22028$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $27ade13088d22028$var$Buffer(arg, encodingOrOffset, length);
};
$27ade13088d22028$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $27ade13088d22028$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$27ade13088d22028$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $27ade13088d22028$var$Buffer(size);
};
$27ade13088d22028$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});



parcelRegister("9x3zF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $6f09f7ea836591a2$var$Transform;

var $ep9tV = parcelRequire("ep9tV");

/*<replacement>*/ var $6f09f7ea836591a2$var$util = Object.create((parcelRequire("6PLnu")));

$6f09f7ea836591a2$var$util.inherits = (parcelRequire("dhT4G"));
/*</replacement>*/ $6f09f7ea836591a2$var$util.inherits($6f09f7ea836591a2$var$Transform, $ep9tV);
function $6f09f7ea836591a2$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $6f09f7ea836591a2$var$Transform(options) {
    if (!(this instanceof $6f09f7ea836591a2$var$Transform)) return new $6f09f7ea836591a2$var$Transform(options);
    $ep9tV.call(this, options);
    this._transformState = {
        afterTransform: $6f09f7ea836591a2$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $6f09f7ea836591a2$var$prefinish);
}
function $6f09f7ea836591a2$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $6f09f7ea836591a2$var$done(_this, er, data);
    });
    else $6f09f7ea836591a2$var$done(this, null, null);
}
$6f09f7ea836591a2$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $ep9tV.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$6f09f7ea836591a2$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$6f09f7ea836591a2$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$6f09f7ea836591a2$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$6f09f7ea836591a2$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $ep9tV.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $6f09f7ea836591a2$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("lSfvK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $fecaac48db337b2f$var$PassThrough;

var $9x3zF = parcelRequire("9x3zF");

/*<replacement>*/ var $fecaac48db337b2f$var$util = Object.create((parcelRequire("6PLnu")));

$fecaac48db337b2f$var$util.inherits = (parcelRequire("dhT4G"));
/*</replacement>*/ $fecaac48db337b2f$var$util.inherits($fecaac48db337b2f$var$PassThrough, $9x3zF);
function $fecaac48db337b2f$var$PassThrough(options) {
    if (!(this instanceof $fecaac48db337b2f$var$PassThrough)) return new $fecaac48db337b2f$var$PassThrough(options);
    $9x3zF.call(this, options);
}
$fecaac48db337b2f$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("61Mau", function(module, exports) {
'use strict';

var $2BV4h = parcelRequire("2BV4h");
var $463833414b7fa82a$require$Buffer = $2BV4h.Buffer;

var $cL3Ff = parcelRequire("cL3Ff");

var $2jcIV = parcelRequire("2jcIV");

var $a2sGY = parcelRequire("a2sGY");
var $463833414b7fa82a$require$EC = $a2sGY.ec;

var $aVh2m = parcelRequire("aVh2m");

var $hdVtR = parcelRequire("hdVtR");

var $6cUou = parcelRequire("6cUou");
var $463833414b7fa82a$var$RSA_PKCS1_PADDING = 1;
function $463833414b7fa82a$var$sign(hash, key, hashType, signType, tag) {
    var priv = $hdVtR(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $463833414b7fa82a$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $463833414b7fa82a$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $463833414b7fa82a$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $463833414b7fa82a$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $2jcIV(pad, priv);
    return out;
}
function $463833414b7fa82a$var$ecSign(hash, priv) {
    var curveId = $6cUou[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $463833414b7fa82a$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $463833414b7fa82a$require$Buffer.from(out.toDER());
}
function $463833414b7fa82a$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $aVh2m(0);
    var k;
    var H = $463833414b7fa82a$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $463833414b7fa82a$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $463833414b7fa82a$var$makeKey(q, kv, algo);
        r = $463833414b7fa82a$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $aVh2m(0);
        }
    }
    return $463833414b7fa82a$var$toDER(r, s);
}
function $463833414b7fa82a$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $463833414b7fa82a$require$Buffer.from(res);
}
function $463833414b7fa82a$var$getKey(x, q, hash, algo) {
    x = $463833414b7fa82a$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $463833414b7fa82a$require$Buffer.alloc(q.byteLength() - x.length);
        x = $463833414b7fa82a$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $463833414b7fa82a$var$bits2octets(hash, q);
    var v = $463833414b7fa82a$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $463833414b7fa82a$require$Buffer.alloc(hlen);
    k = $cL3Ff(algo, k).update(v).update($463833414b7fa82a$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $cL3Ff(algo, k).update(v).digest();
    k = $cL3Ff(algo, k).update(v).update($463833414b7fa82a$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $cL3Ff(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $463833414b7fa82a$var$bits2int(obits, q) {
    var bits = new $aVh2m(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $463833414b7fa82a$var$bits2octets(bits, q) {
    bits = $463833414b7fa82a$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $463833414b7fa82a$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $463833414b7fa82a$require$Buffer.alloc(q.byteLength() - out.length);
        out = $463833414b7fa82a$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $463833414b7fa82a$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $463833414b7fa82a$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $cL3Ff(algo, kv.k).update(kv.v).digest();
            t = $463833414b7fa82a$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $463833414b7fa82a$var$bits2int(t, q);
        kv.k = $cL3Ff(algo, kv.k).update(kv.v).update($463833414b7fa82a$require$Buffer.from([
            0
        ])).digest();
        kv.v = $cL3Ff(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $463833414b7fa82a$var$makeR(g, k, p, q) {
    return g.toRed($aVh2m.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $463833414b7fa82a$var$sign;
module.exports.getKey = $463833414b7fa82a$var$getKey;
module.exports.makeKey = $463833414b7fa82a$var$makeKey;

});
parcelRegister("2jcIV", function(module, exports) {
'use strict';

var $aVh2m = parcelRequire("aVh2m");

var $f08he = parcelRequire("f08he");

var $1C8ZE = parcelRequire("1C8ZE");
var $1ae739bfcb63454f$require$Buffer = $1C8ZE.Buffer;
function $1ae739bfcb63454f$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $aVh2m($f08he(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $1ae739bfcb63454f$var$blind(priv) {
    var r = $1ae739bfcb63454f$var$getr(priv);
    var blinder = r.toRed($aVh2m.mont(priv.modulus)).redPow(new $aVh2m(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $1ae739bfcb63454f$var$crt(msg, priv) {
    var blinds = $1ae739bfcb63454f$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $aVh2m(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($aVh2m.mont(priv.prime1));
    var c2 = blinded.toRed($aVh2m.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($1ae739bfcb63454f$require$Buffer, 'be', len);
}
$1ae739bfcb63454f$var$crt.getr = $1ae739bfcb63454f$var$getr;
module.exports = $1ae739bfcb63454f$var$crt;

});
parcelRegister("aVh2m", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("1C8ZE", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $12d050edbbf35d7e$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $12d050edbbf35d7e$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($12d050edbbf35d7e$var$Buffer.from && $12d050edbbf35d7e$var$Buffer.alloc && $12d050edbbf35d7e$var$Buffer.allocUnsafe && $12d050edbbf35d7e$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $12d050edbbf35d7e$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $12d050edbbf35d7e$var$SafeBuffer;
}
function $12d050edbbf35d7e$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $12d050edbbf35d7e$var$Buffer(arg, encodingOrOffset, length);
}
$12d050edbbf35d7e$var$SafeBuffer.prototype = Object.create($12d050edbbf35d7e$var$Buffer.prototype);
// Copy static methods from Buffer
$12d050edbbf35d7e$var$copyProps($12d050edbbf35d7e$var$Buffer, $12d050edbbf35d7e$var$SafeBuffer);
$12d050edbbf35d7e$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $12d050edbbf35d7e$var$Buffer(arg, encodingOrOffset, length);
};
$12d050edbbf35d7e$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $12d050edbbf35d7e$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$12d050edbbf35d7e$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $12d050edbbf35d7e$var$Buffer(size);
};
$12d050edbbf35d7e$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});


parcelRegister("a2sGY", function(module, exports) {
'use strict';
var $74f058f4ed5df70c$var$elliptic = module.exports;

$74f058f4ed5df70c$var$elliptic.version = (parcelRequire("5yWHA")).version;

$74f058f4ed5df70c$var$elliptic.utils = (parcelRequire("2KPxf"));

$74f058f4ed5df70c$var$elliptic.rand = (parcelRequire("gWiKw"));

$74f058f4ed5df70c$var$elliptic.curve = (parcelRequire("5Hkfi"));

$74f058f4ed5df70c$var$elliptic.curves = (parcelRequire("hKjoi"));

// Protocols
$74f058f4ed5df70c$var$elliptic.ec = (parcelRequire("ijEQd"));

$74f058f4ed5df70c$var$elliptic.eddsa = (parcelRequire("9fmHx"));

});
parcelRegister("5yWHA", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("2KPxf", function(module, exports) {
'use strict';
var $2017da7f3b92fe8f$var$utils = module.exports;

var $7iECc = parcelRequire("7iECc");

var $jLTFB = parcelRequire("jLTFB");

var $bA0W1 = parcelRequire("bA0W1");
$2017da7f3b92fe8f$var$utils.assert = $jLTFB;
$2017da7f3b92fe8f$var$utils.toArray = $bA0W1.toArray;
$2017da7f3b92fe8f$var$utils.zero2 = $bA0W1.zero2;
$2017da7f3b92fe8f$var$utils.toHex = $bA0W1.toHex;
$2017da7f3b92fe8f$var$utils.encode = $bA0W1.encode;
// Represent num in a w-NAF form
function $2017da7f3b92fe8f$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$2017da7f3b92fe8f$var$utils.getNAF = $2017da7f3b92fe8f$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $2017da7f3b92fe8f$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$2017da7f3b92fe8f$var$utils.getJSF = $2017da7f3b92fe8f$var$getJSF;
function $2017da7f3b92fe8f$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$2017da7f3b92fe8f$var$utils.cachedProperty = $2017da7f3b92fe8f$var$cachedProperty;
function $2017da7f3b92fe8f$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $2017da7f3b92fe8f$var$utils.toArray(bytes, 'hex') : bytes;
}
$2017da7f3b92fe8f$var$utils.parseBytes = $2017da7f3b92fe8f$var$parseBytes;
function $2017da7f3b92fe8f$var$intFromLE(bytes) {
    return new $7iECc(bytes, 'hex', 'le');
}
$2017da7f3b92fe8f$var$utils.intFromLE = $2017da7f3b92fe8f$var$intFromLE;

});
parcelRegister("7iECc", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("bA0W1", function(module, exports) {
'use strict';
var $86e3c8252f82bd4d$var$utils = module.exports;
function $86e3c8252f82bd4d$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$86e3c8252f82bd4d$var$utils.toArray = $86e3c8252f82bd4d$var$toArray;
function $86e3c8252f82bd4d$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$86e3c8252f82bd4d$var$utils.zero2 = $86e3c8252f82bd4d$var$zero2;
function $86e3c8252f82bd4d$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $86e3c8252f82bd4d$var$zero2(msg[i].toString(16));
    return res;
}
$86e3c8252f82bd4d$var$utils.toHex = $86e3c8252f82bd4d$var$toHex;
$86e3c8252f82bd4d$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $86e3c8252f82bd4d$var$toHex(arr);
    else return arr;
};

});


parcelRegister("5Hkfi", function(module, exports) {
'use strict';
var $4260ac48d49db708$var$curve = module.exports;

$4260ac48d49db708$var$curve.base = (parcelRequire("8dytk"));

$4260ac48d49db708$var$curve.short = (parcelRequire("6gfS3"));

$4260ac48d49db708$var$curve.mont = (parcelRequire("cpeEK"));

$4260ac48d49db708$var$curve.edwards = (parcelRequire("1tM9R"));

});
parcelRegister("8dytk", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $2KPxf = parcelRequire("2KPxf");
var $5fba47135c9f13e6$var$getNAF = $2KPxf.getNAF;
var $5fba47135c9f13e6$var$getJSF = $2KPxf.getJSF;
var $5fba47135c9f13e6$var$assert = $2KPxf.assert;
function $5fba47135c9f13e6$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $7iECc(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $7iECc.red(conf.prime) : $7iECc.mont(this.p);
    // Useful for many curves
    this.zero = new $7iECc(0).toRed(this.red);
    this.one = new $7iECc(1).toRed(this.red);
    this.two = new $7iECc(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $7iECc(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $5fba47135c9f13e6$var$BaseCurve;
$5fba47135c9f13e6$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$5fba47135c9f13e6$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$5fba47135c9f13e6$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $5fba47135c9f13e6$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $5fba47135c9f13e6$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$5fba47135c9f13e6$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $5fba47135c9f13e6$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $5fba47135c9f13e6$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$5fba47135c9f13e6$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $5fba47135c9f13e6$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $5fba47135c9f13e6$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $5fba47135c9f13e6$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $5fba47135c9f13e6$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$5fba47135c9f13e6$var$BaseCurve.BasePoint = $5fba47135c9f13e6$var$BasePoint;
$5fba47135c9f13e6$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$5fba47135c9f13e6$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$5fba47135c9f13e6$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $2KPxf.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $5fba47135c9f13e6$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $5fba47135c9f13e6$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$5fba47135c9f13e6$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$5fba47135c9f13e6$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$5fba47135c9f13e6$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $2KPxf.encode(this._encode(compact), enc);
};
$5fba47135c9f13e6$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$5fba47135c9f13e6$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$5fba47135c9f13e6$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$5fba47135c9f13e6$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$5fba47135c9f13e6$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$5fba47135c9f13e6$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("6gfS3", function(module, exports) {
'use strict';

var $2KPxf = parcelRequire("2KPxf");

var $7iECc = parcelRequire("7iECc");

var $dhT4G = parcelRequire("dhT4G");

var $8dytk = parcelRequire("8dytk");
var $48f08c4e491a3d05$var$assert = $2KPxf.assert;
function $48f08c4e491a3d05$var$ShortCurve(conf) {
    $8dytk.call(this, 'short', conf);
    this.a = new $7iECc(conf.a, 16).toRed(this.red);
    this.b = new $7iECc(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dhT4G($48f08c4e491a3d05$var$ShortCurve, $8dytk);
module.exports = $48f08c4e491a3d05$var$ShortCurve;
$48f08c4e491a3d05$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $7iECc(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $7iECc(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $48f08c4e491a3d05$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $7iECc(vec.a, 16),
            b: new $7iECc(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$48f08c4e491a3d05$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $7iECc.mont(num);
    var tinv = new $7iECc(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $7iECc(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$48f08c4e491a3d05$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $7iECc(1);
    var y1 = new $7iECc(0);
    var x2 = new $7iECc(0);
    var y2 = new $7iECc(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$48f08c4e491a3d05$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$48f08c4e491a3d05$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7iECc(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$48f08c4e491a3d05$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$48f08c4e491a3d05$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $48f08c4e491a3d05$var$Point(curve, x, y, isRed) {
    $8dytk.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $7iECc(x, 16);
        this.y = new $7iECc(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dhT4G($48f08c4e491a3d05$var$Point, $8dytk.BasePoint);
$48f08c4e491a3d05$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $48f08c4e491a3d05$var$Point(this, x, y, isRed);
};
$48f08c4e491a3d05$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $48f08c4e491a3d05$var$Point.fromJSON(this, obj, red);
};
$48f08c4e491a3d05$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$48f08c4e491a3d05$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$48f08c4e491a3d05$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$48f08c4e491a3d05$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$48f08c4e491a3d05$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$48f08c4e491a3d05$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$48f08c4e491a3d05$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$48f08c4e491a3d05$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$48f08c4e491a3d05$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$48f08c4e491a3d05$var$Point.prototype.mul = function mul(k) {
    k = new $7iECc(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$48f08c4e491a3d05$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$48f08c4e491a3d05$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$48f08c4e491a3d05$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$48f08c4e491a3d05$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$48f08c4e491a3d05$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $48f08c4e491a3d05$var$JPoint(curve, x, y, z) {
    $8dytk.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $7iECc(0);
    } else {
        this.x = new $7iECc(x, 16);
        this.y = new $7iECc(y, 16);
        this.z = new $7iECc(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dhT4G($48f08c4e491a3d05$var$JPoint, $8dytk.BasePoint);
$48f08c4e491a3d05$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $48f08c4e491a3d05$var$JPoint(this, x, y, z);
};
$48f08c4e491a3d05$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$48f08c4e491a3d05$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$48f08c4e491a3d05$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$48f08c4e491a3d05$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$48f08c4e491a3d05$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $7iECc(k, kbase);
    return this.curve._wnafMul(this, k);
};
$48f08c4e491a3d05$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$48f08c4e491a3d05$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$48f08c4e491a3d05$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$48f08c4e491a3d05$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("cpeEK", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $dhT4G = parcelRequire("dhT4G");

var $8dytk = parcelRequire("8dytk");

var $2KPxf = parcelRequire("2KPxf");
function $90833044cafb30f7$var$MontCurve(conf) {
    $8dytk.call(this, 'mont', conf);
    this.a = new $7iECc(conf.a, 16).toRed(this.red);
    this.b = new $7iECc(conf.b, 16).toRed(this.red);
    this.i4 = new $7iECc(4).toRed(this.red).redInvm();
    this.two = new $7iECc(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dhT4G($90833044cafb30f7$var$MontCurve, $8dytk);
module.exports = $90833044cafb30f7$var$MontCurve;
$90833044cafb30f7$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $90833044cafb30f7$var$Point(curve, x, z) {
    $8dytk.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $7iECc(x, 16);
        this.z = new $7iECc(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dhT4G($90833044cafb30f7$var$Point, $8dytk.BasePoint);
$90833044cafb30f7$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($2KPxf.toArray(bytes, enc), 1);
};
$90833044cafb30f7$var$MontCurve.prototype.point = function point(x, z) {
    return new $90833044cafb30f7$var$Point(this, x, z);
};
$90833044cafb30f7$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $90833044cafb30f7$var$Point.fromJSON(this, obj);
};
$90833044cafb30f7$var$Point.prototype.precompute = function precompute() {
// No-op
};
$90833044cafb30f7$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$90833044cafb30f7$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $90833044cafb30f7$var$Point(curve, obj[0], obj[1] || curve.one);
};
$90833044cafb30f7$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$90833044cafb30f7$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$90833044cafb30f7$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$90833044cafb30f7$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$90833044cafb30f7$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$90833044cafb30f7$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$90833044cafb30f7$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$90833044cafb30f7$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$90833044cafb30f7$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$90833044cafb30f7$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$90833044cafb30f7$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("1tM9R", function(module, exports) {
'use strict';

var $2KPxf = parcelRequire("2KPxf");

var $7iECc = parcelRequire("7iECc");

var $dhT4G = parcelRequire("dhT4G");

var $8dytk = parcelRequire("8dytk");
var $113ddb0a953c55e8$var$assert = $2KPxf.assert;
function $113ddb0a953c55e8$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $8dytk.call(this, 'edwards', conf);
    this.a = new $7iECc(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $7iECc(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $7iECc(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $113ddb0a953c55e8$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dhT4G($113ddb0a953c55e8$var$EdwardsCurve, $8dytk);
module.exports = $113ddb0a953c55e8$var$EdwardsCurve;
$113ddb0a953c55e8$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$113ddb0a953c55e8$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7iECc(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $7iECc(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $113ddb0a953c55e8$var$Point(curve, x, y, z, t) {
    $8dytk.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $7iECc(x, 16);
        this.y = new $7iECc(y, 16);
        this.z = z ? new $7iECc(z, 16) : this.curve.one;
        this.t = t && new $7iECc(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dhT4G($113ddb0a953c55e8$var$Point, $8dytk.BasePoint);
$113ddb0a953c55e8$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $113ddb0a953c55e8$var$Point.fromJSON(this, obj);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $113ddb0a953c55e8$var$Point(this, x, y, z, t);
};
$113ddb0a953c55e8$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $113ddb0a953c55e8$var$Point(curve, obj[0], obj[1], obj[2]);
};
$113ddb0a953c55e8$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$113ddb0a953c55e8$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$113ddb0a953c55e8$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$113ddb0a953c55e8$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$113ddb0a953c55e8$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$113ddb0a953c55e8$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$113ddb0a953c55e8$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$113ddb0a953c55e8$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$113ddb0a953c55e8$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$113ddb0a953c55e8$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$113ddb0a953c55e8$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$113ddb0a953c55e8$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$113ddb0a953c55e8$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$113ddb0a953c55e8$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$113ddb0a953c55e8$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$113ddb0a953c55e8$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$113ddb0a953c55e8$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$113ddb0a953c55e8$var$Point.prototype.toP = $113ddb0a953c55e8$var$Point.prototype.normalize;
$113ddb0a953c55e8$var$Point.prototype.mixedAdd = $113ddb0a953c55e8$var$Point.prototype.add;

});


parcelRegister("hKjoi", function(module, exports) {
'use strict';
var $ceb5c625f77262d6$var$curves = module.exports;

var $gVjbv = parcelRequire("gVjbv");

var $5Hkfi = parcelRequire("5Hkfi");

var $2KPxf = parcelRequire("2KPxf");
var $ceb5c625f77262d6$var$assert = $2KPxf.assert;
function $ceb5c625f77262d6$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $5Hkfi.short(options);
    else if (options.type === 'edwards') this.curve = new $5Hkfi.edwards(options);
    else this.curve = new $5Hkfi.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $ceb5c625f77262d6$var$assert(this.g.validate(), 'Invalid curve');
    $ceb5c625f77262d6$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$ceb5c625f77262d6$var$curves.PresetCurve = $ceb5c625f77262d6$var$PresetCurve;
function $ceb5c625f77262d6$var$defineCurve(name, options) {
    Object.defineProperty($ceb5c625f77262d6$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $ceb5c625f77262d6$var$PresetCurve(options);
            Object.defineProperty($ceb5c625f77262d6$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$ceb5c625f77262d6$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$ceb5c625f77262d6$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$ceb5c625f77262d6$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$ceb5c625f77262d6$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $gVjbv.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$ceb5c625f77262d6$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $gVjbv.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$ceb5c625f77262d6$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$ceb5c625f77262d6$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $ceb5c625f77262d6$var$pre;

try {
    $ceb5c625f77262d6$var$pre = (parcelRequire("8M60a"));
} catch (e) {
    $ceb5c625f77262d6$var$pre = undefined;
}
$ceb5c625f77262d6$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $gVjbv.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $ceb5c625f77262d6$var$pre
    ]
});

});
parcelRegister("gVjbv", function(module, exports) {
var $c520d9d9fb7ed821$var$hash = module.exports;

$c520d9d9fb7ed821$var$hash.utils = (parcelRequire("1JocC"));

$c520d9d9fb7ed821$var$hash.common = (parcelRequire("cx4L0"));

$c520d9d9fb7ed821$var$hash.sha = (parcelRequire("czP09"));

$c520d9d9fb7ed821$var$hash.ripemd = (parcelRequire("1KcMM"));

$c520d9d9fb7ed821$var$hash.hmac = (parcelRequire("iBkDX"));
// Proxy hash functions to the main object
$c520d9d9fb7ed821$var$hash.sha1 = $c520d9d9fb7ed821$var$hash.sha.sha1;
$c520d9d9fb7ed821$var$hash.sha256 = $c520d9d9fb7ed821$var$hash.sha.sha256;
$c520d9d9fb7ed821$var$hash.sha224 = $c520d9d9fb7ed821$var$hash.sha.sha224;
$c520d9d9fb7ed821$var$hash.sha384 = $c520d9d9fb7ed821$var$hash.sha.sha384;
$c520d9d9fb7ed821$var$hash.sha512 = $c520d9d9fb7ed821$var$hash.sha.sha512;
$c520d9d9fb7ed821$var$hash.ripemd160 = $c520d9d9fb7ed821$var$hash.ripemd.ripemd160;

});
parcelRegister("1JocC", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $142cc48ad6105c40$export$69f1b2dcda23c5f8; }, function (v) { return $142cc48ad6105c40$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $142cc48ad6105c40$export$45b10814cc054894; }, function (v) { return $142cc48ad6105c40$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $142cc48ad6105c40$export$7ea66e3774a60b67; }, function (v) { return $142cc48ad6105c40$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $142cc48ad6105c40$export$34a52f00f601f6f1; }, function (v) { return $142cc48ad6105c40$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $142cc48ad6105c40$export$812b0cbd5e8a72ab; }, function (v) { return $142cc48ad6105c40$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $142cc48ad6105c40$export$f24f9e11d63bb314; }, function (v) { return $142cc48ad6105c40$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $142cc48ad6105c40$export$b71357c7e07ca1f1; }, function (v) { return $142cc48ad6105c40$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $142cc48ad6105c40$export$2e58a4b541fdcbe8; }, function (v) { return $142cc48ad6105c40$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $142cc48ad6105c40$export$183b950bde9faab8; }, function (v) { return $142cc48ad6105c40$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $142cc48ad6105c40$export$4785c77169fea59e; }, function (v) { return $142cc48ad6105c40$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $142cc48ad6105c40$export$242a185dfcffac5b; }, function (v) { return $142cc48ad6105c40$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $142cc48ad6105c40$export$58c04ae0ae31877d; }, function (v) { return $142cc48ad6105c40$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $142cc48ad6105c40$export$d058ca695f8c6f11; }, function (v) { return $142cc48ad6105c40$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $142cc48ad6105c40$export$a1efd7fc3e986367; }, function (v) { return $142cc48ad6105c40$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $142cc48ad6105c40$export$bbfea4a2b5abaab4; }, function (v) { return $142cc48ad6105c40$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $142cc48ad6105c40$export$97ad4afc7de86152; }, function (v) { return $142cc48ad6105c40$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $142cc48ad6105c40$export$ce4673d9a79f6a4b; }, function (v) { return $142cc48ad6105c40$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $142cc48ad6105c40$export$786cc99fc6eedc0b; }, function (v) { return $142cc48ad6105c40$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $142cc48ad6105c40$export$45c59b9a1848dd0; }, function (v) { return $142cc48ad6105c40$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $142cc48ad6105c40$export$50d8f613e76d3034; }, function (v) { return $142cc48ad6105c40$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $142cc48ad6105c40$export$b8e83683c60ee162; }, function (v) { return $142cc48ad6105c40$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $142cc48ad6105c40$export$aeeb51790d1bcc4a; }, function (v) { return $142cc48ad6105c40$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $142cc48ad6105c40$export$bb7c616f719ad9c; }, function (v) { return $142cc48ad6105c40$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $142cc48ad6105c40$export$4d63290824f9d7df; }, function (v) { return $142cc48ad6105c40$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $142cc48ad6105c40$export$2f64ceb90ef28ea1; }, function (v) { return $142cc48ad6105c40$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $142cc48ad6105c40$export$8d2089d465f6d10d; }, function (v) { return $142cc48ad6105c40$export$8d2089d465f6d10d = v; });
var $142cc48ad6105c40$export$69f1b2dcda23c5f8;
var $142cc48ad6105c40$export$45b10814cc054894;
var $142cc48ad6105c40$export$7ea66e3774a60b67;
var $142cc48ad6105c40$export$34a52f00f601f6f1;
var $142cc48ad6105c40$export$812b0cbd5e8a72ab;
var $142cc48ad6105c40$export$f24f9e11d63bb314;
var $142cc48ad6105c40$export$b71357c7e07ca1f1;
var $142cc48ad6105c40$export$2e58a4b541fdcbe8;
var $142cc48ad6105c40$export$183b950bde9faab8;
var $142cc48ad6105c40$export$4785c77169fea59e;
var $142cc48ad6105c40$export$242a185dfcffac5b;
var $142cc48ad6105c40$export$58c04ae0ae31877d;
var $142cc48ad6105c40$export$d058ca695f8c6f11;
var $142cc48ad6105c40$export$a1efd7fc3e986367;
var $142cc48ad6105c40$export$bbfea4a2b5abaab4;
var $142cc48ad6105c40$export$97ad4afc7de86152;
var $142cc48ad6105c40$export$ce4673d9a79f6a4b;
var $142cc48ad6105c40$export$786cc99fc6eedc0b;
var $142cc48ad6105c40$export$45c59b9a1848dd0;
var $142cc48ad6105c40$export$50d8f613e76d3034;
var $142cc48ad6105c40$export$b8e83683c60ee162;
var $142cc48ad6105c40$export$aeeb51790d1bcc4a;
var $142cc48ad6105c40$export$bb7c616f719ad9c;
var $142cc48ad6105c40$export$4d63290824f9d7df;
var $142cc48ad6105c40$export$2f64ceb90ef28ea1;
var $142cc48ad6105c40$export$8d2089d465f6d10d;
'use strict';

var $jLTFB = parcelRequire("jLTFB");

var $dhT4G = parcelRequire("dhT4G");
$142cc48ad6105c40$export$69f1b2dcda23c5f8 = $dhT4G;
function $142cc48ad6105c40$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $142cc48ad6105c40$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($142cc48ad6105c40$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$142cc48ad6105c40$export$45b10814cc054894 = $142cc48ad6105c40$var$toArray;
function $142cc48ad6105c40$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $142cc48ad6105c40$var$zero2(msg[i].toString(16));
    return res;
}
$142cc48ad6105c40$export$7ea66e3774a60b67 = $142cc48ad6105c40$var$toHex;
function $142cc48ad6105c40$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$142cc48ad6105c40$export$34a52f00f601f6f1 = $142cc48ad6105c40$var$htonl;
function $142cc48ad6105c40$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $142cc48ad6105c40$var$htonl(w);
        res += $142cc48ad6105c40$var$zero8(w.toString(16));
    }
    return res;
}
$142cc48ad6105c40$export$812b0cbd5e8a72ab = $142cc48ad6105c40$var$toHex32;
function $142cc48ad6105c40$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$142cc48ad6105c40$export$f24f9e11d63bb314 = $142cc48ad6105c40$var$zero2;
function $142cc48ad6105c40$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$142cc48ad6105c40$export$b71357c7e07ca1f1 = $142cc48ad6105c40$var$zero8;
function $142cc48ad6105c40$var$join32(msg, start, end, endian) {
    var len = end - start;
    $jLTFB(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$142cc48ad6105c40$export$2e58a4b541fdcbe8 = $142cc48ad6105c40$var$join32;
function $142cc48ad6105c40$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$142cc48ad6105c40$export$183b950bde9faab8 = $142cc48ad6105c40$var$split32;
function $142cc48ad6105c40$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$142cc48ad6105c40$export$4785c77169fea59e = $142cc48ad6105c40$var$rotr32;
function $142cc48ad6105c40$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$142cc48ad6105c40$export$242a185dfcffac5b = $142cc48ad6105c40$var$rotl32;
function $142cc48ad6105c40$var$sum32(a, b) {
    return a + b >>> 0;
}
$142cc48ad6105c40$export$58c04ae0ae31877d = $142cc48ad6105c40$var$sum32;
function $142cc48ad6105c40$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$142cc48ad6105c40$export$d058ca695f8c6f11 = $142cc48ad6105c40$var$sum32_3;
function $142cc48ad6105c40$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$142cc48ad6105c40$export$a1efd7fc3e986367 = $142cc48ad6105c40$var$sum32_4;
function $142cc48ad6105c40$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$142cc48ad6105c40$export$bbfea4a2b5abaab4 = $142cc48ad6105c40$var$sum32_5;
function $142cc48ad6105c40$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$142cc48ad6105c40$export$97ad4afc7de86152 = $142cc48ad6105c40$var$sum64;
function $142cc48ad6105c40$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$142cc48ad6105c40$export$ce4673d9a79f6a4b = $142cc48ad6105c40$var$sum64_hi;
function $142cc48ad6105c40$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$142cc48ad6105c40$export$786cc99fc6eedc0b = $142cc48ad6105c40$var$sum64_lo;
function $142cc48ad6105c40$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$142cc48ad6105c40$export$45c59b9a1848dd0 = $142cc48ad6105c40$var$sum64_4_hi;
function $142cc48ad6105c40$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$142cc48ad6105c40$export$50d8f613e76d3034 = $142cc48ad6105c40$var$sum64_4_lo;
function $142cc48ad6105c40$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$142cc48ad6105c40$export$b8e83683c60ee162 = $142cc48ad6105c40$var$sum64_5_hi;
function $142cc48ad6105c40$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$142cc48ad6105c40$export$aeeb51790d1bcc4a = $142cc48ad6105c40$var$sum64_5_lo;
function $142cc48ad6105c40$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$142cc48ad6105c40$export$bb7c616f719ad9c = $142cc48ad6105c40$var$rotr64_hi;
function $142cc48ad6105c40$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$142cc48ad6105c40$export$4d63290824f9d7df = $142cc48ad6105c40$var$rotr64_lo;
function $142cc48ad6105c40$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$142cc48ad6105c40$export$2f64ceb90ef28ea1 = $142cc48ad6105c40$var$shr64_hi;
function $142cc48ad6105c40$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$142cc48ad6105c40$export$8d2089d465f6d10d = $142cc48ad6105c40$var$shr64_lo;

});

parcelRegister("cx4L0", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $91fc41c6f399bfd6$export$8687658379b577e6; }, function (v) { return $91fc41c6f399bfd6$export$8687658379b577e6 = v; });
var $91fc41c6f399bfd6$export$8687658379b577e6;
'use strict';

var $1JocC = parcelRequire("1JocC");

var $jLTFB = parcelRequire("jLTFB");
function $91fc41c6f399bfd6$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$91fc41c6f399bfd6$export$8687658379b577e6 = $91fc41c6f399bfd6$var$BlockHash;
$91fc41c6f399bfd6$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $1JocC.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $1JocC.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$91fc41c6f399bfd6$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $jLTFB(this.pending === null);
    return this._digest(enc);
};
$91fc41c6f399bfd6$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("czP09", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $928050bd9f998c99$export$5091bdda49ba90f5; }, function (v) { return $928050bd9f998c99$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $928050bd9f998c99$export$97b70509d4e397ea; }, function (v) { return $928050bd9f998c99$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $928050bd9f998c99$export$bced8d2aada2d1c9; }, function (v) { return $928050bd9f998c99$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $928050bd9f998c99$export$612d47d55dedde45; }, function (v) { return $928050bd9f998c99$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $928050bd9f998c99$export$a888d2532e6dc7bb; }, function (v) { return $928050bd9f998c99$export$a888d2532e6dc7bb = v; });
var $928050bd9f998c99$export$5091bdda49ba90f5;
var $928050bd9f998c99$export$97b70509d4e397ea;
var $928050bd9f998c99$export$bced8d2aada2d1c9;
var $928050bd9f998c99$export$612d47d55dedde45;
var $928050bd9f998c99$export$a888d2532e6dc7bb;
'use strict';

$928050bd9f998c99$export$5091bdda49ba90f5 = (parcelRequire("7jFEf"));

$928050bd9f998c99$export$97b70509d4e397ea = (parcelRequire("aE1Pb"));

$928050bd9f998c99$export$bced8d2aada2d1c9 = (parcelRequire("6lk1c"));

$928050bd9f998c99$export$612d47d55dedde45 = (parcelRequire("tUPWi"));

$928050bd9f998c99$export$a888d2532e6dc7bb = (parcelRequire("joihk"));

});
parcelRegister("7jFEf", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $cx4L0 = parcelRequire("cx4L0");

var $aoikt = parcelRequire("aoikt");
var $553a9d345907d8a6$var$rotl32 = $1JocC.rotl32;
var $553a9d345907d8a6$var$sum32 = $1JocC.sum32;
var $553a9d345907d8a6$var$sum32_5 = $1JocC.sum32_5;
var $553a9d345907d8a6$var$ft_1 = $aoikt.ft_1;
var $553a9d345907d8a6$var$BlockHash = $cx4L0.BlockHash;
var $553a9d345907d8a6$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $553a9d345907d8a6$var$SHA1() {
    if (!(this instanceof $553a9d345907d8a6$var$SHA1)) return new $553a9d345907d8a6$var$SHA1();
    $553a9d345907d8a6$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$1JocC.inherits($553a9d345907d8a6$var$SHA1, $553a9d345907d8a6$var$BlockHash);
module.exports = $553a9d345907d8a6$var$SHA1;
$553a9d345907d8a6$var$SHA1.blockSize = 512;
$553a9d345907d8a6$var$SHA1.outSize = 160;
$553a9d345907d8a6$var$SHA1.hmacStrength = 80;
$553a9d345907d8a6$var$SHA1.padLength = 64;
$553a9d345907d8a6$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $553a9d345907d8a6$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $553a9d345907d8a6$var$sum32_5($553a9d345907d8a6$var$rotl32(a, 5), $553a9d345907d8a6$var$ft_1(s, b, c, d), e, W[i], $553a9d345907d8a6$var$sha1_K[s]);
        e = d;
        d = c;
        c = $553a9d345907d8a6$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $553a9d345907d8a6$var$sum32(this.h[0], a);
    this.h[1] = $553a9d345907d8a6$var$sum32(this.h[1], b);
    this.h[2] = $553a9d345907d8a6$var$sum32(this.h[2], c);
    this.h[3] = $553a9d345907d8a6$var$sum32(this.h[3], d);
    this.h[4] = $553a9d345907d8a6$var$sum32(this.h[4], e);
};
$553a9d345907d8a6$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h, 'big');
    else return $1JocC.split32(this.h, 'big');
};

});
parcelRegister("aoikt", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $790a5d18b6572c07$export$5a92649d7ddb9f63; }, function (v) { return $790a5d18b6572c07$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $790a5d18b6572c07$export$c6d0d020c3a6269; }, function (v) { return $790a5d18b6572c07$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $790a5d18b6572c07$export$eb90c27fca05f956; }, function (v) { return $790a5d18b6572c07$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $790a5d18b6572c07$export$14a4a98e063b1999; }, function (v) { return $790a5d18b6572c07$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $790a5d18b6572c07$export$d20cecfa1564c686; }, function (v) { return $790a5d18b6572c07$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $790a5d18b6572c07$export$44fd472a12fc6db; }, function (v) { return $790a5d18b6572c07$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $790a5d18b6572c07$export$1ed238bb6ea1dd47; }, function (v) { return $790a5d18b6572c07$export$1ed238bb6ea1dd47 = v; });
var $790a5d18b6572c07$export$5a92649d7ddb9f63;
var $790a5d18b6572c07$export$c6d0d020c3a6269;
var $790a5d18b6572c07$export$eb90c27fca05f956;
var $790a5d18b6572c07$export$cc992891a14496a1;
var $790a5d18b6572c07$export$14a4a98e063b1999;
var $790a5d18b6572c07$export$d20cecfa1564c686;
var $790a5d18b6572c07$export$44fd472a12fc6db;
var $790a5d18b6572c07$export$1ed238bb6ea1dd47;
'use strict';

var $1JocC = parcelRequire("1JocC");
var $790a5d18b6572c07$var$rotr32 = $1JocC.rotr32;
function $790a5d18b6572c07$var$ft_1(s, x, y, z) {
    if (s === 0) return $790a5d18b6572c07$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $790a5d18b6572c07$var$p32(x, y, z);
    if (s === 2) return $790a5d18b6572c07$var$maj32(x, y, z);
}
$790a5d18b6572c07$export$5a92649d7ddb9f63 = $790a5d18b6572c07$var$ft_1;
function $790a5d18b6572c07$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$790a5d18b6572c07$export$c6d0d020c3a6269 = $790a5d18b6572c07$var$ch32;
function $790a5d18b6572c07$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$790a5d18b6572c07$export$eb90c27fca05f956 = $790a5d18b6572c07$var$maj32;
function $790a5d18b6572c07$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$790a5d18b6572c07$export$cc992891a14496a1 = $790a5d18b6572c07$var$p32;
function $790a5d18b6572c07$var$s0_256(x) {
    return $790a5d18b6572c07$var$rotr32(x, 2) ^ $790a5d18b6572c07$var$rotr32(x, 13) ^ $790a5d18b6572c07$var$rotr32(x, 22);
}
$790a5d18b6572c07$export$14a4a98e063b1999 = $790a5d18b6572c07$var$s0_256;
function $790a5d18b6572c07$var$s1_256(x) {
    return $790a5d18b6572c07$var$rotr32(x, 6) ^ $790a5d18b6572c07$var$rotr32(x, 11) ^ $790a5d18b6572c07$var$rotr32(x, 25);
}
$790a5d18b6572c07$export$d20cecfa1564c686 = $790a5d18b6572c07$var$s1_256;
function $790a5d18b6572c07$var$g0_256(x) {
    return $790a5d18b6572c07$var$rotr32(x, 7) ^ $790a5d18b6572c07$var$rotr32(x, 18) ^ x >>> 3;
}
$790a5d18b6572c07$export$44fd472a12fc6db = $790a5d18b6572c07$var$g0_256;
function $790a5d18b6572c07$var$g1_256(x) {
    return $790a5d18b6572c07$var$rotr32(x, 17) ^ $790a5d18b6572c07$var$rotr32(x, 19) ^ x >>> 10;
}
$790a5d18b6572c07$export$1ed238bb6ea1dd47 = $790a5d18b6572c07$var$g1_256;

});


parcelRegister("aE1Pb", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $6lk1c = parcelRequire("6lk1c");
function $7bff0e1ea26927f0$var$SHA224() {
    if (!(this instanceof $7bff0e1ea26927f0$var$SHA224)) return new $7bff0e1ea26927f0$var$SHA224();
    $6lk1c.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$1JocC.inherits($7bff0e1ea26927f0$var$SHA224, $6lk1c);
module.exports = $7bff0e1ea26927f0$var$SHA224;
$7bff0e1ea26927f0$var$SHA224.blockSize = 512;
$7bff0e1ea26927f0$var$SHA224.outSize = 224;
$7bff0e1ea26927f0$var$SHA224.hmacStrength = 192;
$7bff0e1ea26927f0$var$SHA224.padLength = 64;
$7bff0e1ea26927f0$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $1JocC.toHex32(this.h.slice(0, 7), 'big');
    else return $1JocC.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("6lk1c", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $cx4L0 = parcelRequire("cx4L0");

var $aoikt = parcelRequire("aoikt");

var $jLTFB = parcelRequire("jLTFB");
var $49e43b734242bc05$var$sum32 = $1JocC.sum32;
var $49e43b734242bc05$var$sum32_4 = $1JocC.sum32_4;
var $49e43b734242bc05$var$sum32_5 = $1JocC.sum32_5;
var $49e43b734242bc05$var$ch32 = $aoikt.ch32;
var $49e43b734242bc05$var$maj32 = $aoikt.maj32;
var $49e43b734242bc05$var$s0_256 = $aoikt.s0_256;
var $49e43b734242bc05$var$s1_256 = $aoikt.s1_256;
var $49e43b734242bc05$var$g0_256 = $aoikt.g0_256;
var $49e43b734242bc05$var$g1_256 = $aoikt.g1_256;
var $49e43b734242bc05$var$BlockHash = $cx4L0.BlockHash;
var $49e43b734242bc05$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $49e43b734242bc05$var$SHA256() {
    if (!(this instanceof $49e43b734242bc05$var$SHA256)) return new $49e43b734242bc05$var$SHA256();
    $49e43b734242bc05$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $49e43b734242bc05$var$sha256_K;
    this.W = new Array(64);
}
$1JocC.inherits($49e43b734242bc05$var$SHA256, $49e43b734242bc05$var$BlockHash);
module.exports = $49e43b734242bc05$var$SHA256;
$49e43b734242bc05$var$SHA256.blockSize = 512;
$49e43b734242bc05$var$SHA256.outSize = 256;
$49e43b734242bc05$var$SHA256.hmacStrength = 192;
$49e43b734242bc05$var$SHA256.padLength = 64;
$49e43b734242bc05$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $49e43b734242bc05$var$sum32_4($49e43b734242bc05$var$g1_256(W[i - 2]), W[i - 7], $49e43b734242bc05$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $jLTFB(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $49e43b734242bc05$var$sum32_5(h, $49e43b734242bc05$var$s1_256(e), $49e43b734242bc05$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $49e43b734242bc05$var$sum32($49e43b734242bc05$var$s0_256(a), $49e43b734242bc05$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $49e43b734242bc05$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $49e43b734242bc05$var$sum32(T1, T2);
    }
    this.h[0] = $49e43b734242bc05$var$sum32(this.h[0], a);
    this.h[1] = $49e43b734242bc05$var$sum32(this.h[1], b);
    this.h[2] = $49e43b734242bc05$var$sum32(this.h[2], c);
    this.h[3] = $49e43b734242bc05$var$sum32(this.h[3], d);
    this.h[4] = $49e43b734242bc05$var$sum32(this.h[4], e);
    this.h[5] = $49e43b734242bc05$var$sum32(this.h[5], f);
    this.h[6] = $49e43b734242bc05$var$sum32(this.h[6], g);
    this.h[7] = $49e43b734242bc05$var$sum32(this.h[7], h);
};
$49e43b734242bc05$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h, 'big');
    else return $1JocC.split32(this.h, 'big');
};

});


parcelRegister("tUPWi", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $joihk = parcelRequire("joihk");
function $059ecc239a13035c$var$SHA384() {
    if (!(this instanceof $059ecc239a13035c$var$SHA384)) return new $059ecc239a13035c$var$SHA384();
    $joihk.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$1JocC.inherits($059ecc239a13035c$var$SHA384, $joihk);
module.exports = $059ecc239a13035c$var$SHA384;
$059ecc239a13035c$var$SHA384.blockSize = 1024;
$059ecc239a13035c$var$SHA384.outSize = 384;
$059ecc239a13035c$var$SHA384.hmacStrength = 192;
$059ecc239a13035c$var$SHA384.padLength = 128;
$059ecc239a13035c$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h.slice(0, 12), 'big');
    else return $1JocC.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("joihk", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $cx4L0 = parcelRequire("cx4L0");

var $jLTFB = parcelRequire("jLTFB");
var $e1de6ff53e4a4c3f$var$rotr64_hi = $1JocC.rotr64_hi;
var $e1de6ff53e4a4c3f$var$rotr64_lo = $1JocC.rotr64_lo;
var $e1de6ff53e4a4c3f$var$shr64_hi = $1JocC.shr64_hi;
var $e1de6ff53e4a4c3f$var$shr64_lo = $1JocC.shr64_lo;
var $e1de6ff53e4a4c3f$var$sum64 = $1JocC.sum64;
var $e1de6ff53e4a4c3f$var$sum64_hi = $1JocC.sum64_hi;
var $e1de6ff53e4a4c3f$var$sum64_lo = $1JocC.sum64_lo;
var $e1de6ff53e4a4c3f$var$sum64_4_hi = $1JocC.sum64_4_hi;
var $e1de6ff53e4a4c3f$var$sum64_4_lo = $1JocC.sum64_4_lo;
var $e1de6ff53e4a4c3f$var$sum64_5_hi = $1JocC.sum64_5_hi;
var $e1de6ff53e4a4c3f$var$sum64_5_lo = $1JocC.sum64_5_lo;
var $e1de6ff53e4a4c3f$var$BlockHash = $cx4L0.BlockHash;
var $e1de6ff53e4a4c3f$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $e1de6ff53e4a4c3f$var$SHA512() {
    if (!(this instanceof $e1de6ff53e4a4c3f$var$SHA512)) return new $e1de6ff53e4a4c3f$var$SHA512();
    $e1de6ff53e4a4c3f$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $e1de6ff53e4a4c3f$var$sha512_K;
    this.W = new Array(160);
}
$1JocC.inherits($e1de6ff53e4a4c3f$var$SHA512, $e1de6ff53e4a4c3f$var$BlockHash);
module.exports = $e1de6ff53e4a4c3f$var$SHA512;
$e1de6ff53e4a4c3f$var$SHA512.blockSize = 1024;
$e1de6ff53e4a4c3f$var$SHA512.outSize = 512;
$e1de6ff53e4a4c3f$var$SHA512.hmacStrength = 192;
$e1de6ff53e4a4c3f$var$SHA512.padLength = 128;
$e1de6ff53e4a4c3f$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $e1de6ff53e4a4c3f$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $e1de6ff53e4a4c3f$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $e1de6ff53e4a4c3f$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $e1de6ff53e4a4c3f$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $e1de6ff53e4a4c3f$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $e1de6ff53e4a4c3f$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$e1de6ff53e4a4c3f$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $jLTFB(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $e1de6ff53e4a4c3f$var$s1_512_hi(eh, el);
        var c1_lo = $e1de6ff53e4a4c3f$var$s1_512_lo(eh, el);
        var c2_hi = $e1de6ff53e4a4c3f$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $e1de6ff53e4a4c3f$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $e1de6ff53e4a4c3f$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $e1de6ff53e4a4c3f$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $e1de6ff53e4a4c3f$var$s0_512_hi(ah, al);
        c0_lo = $e1de6ff53e4a4c3f$var$s0_512_lo(ah, al);
        c1_hi = $e1de6ff53e4a4c3f$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $e1de6ff53e4a4c3f$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $e1de6ff53e4a4c3f$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $e1de6ff53e4a4c3f$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $e1de6ff53e4a4c3f$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $e1de6ff53e4a4c3f$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $e1de6ff53e4a4c3f$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $e1de6ff53e4a4c3f$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $e1de6ff53e4a4c3f$var$sum64(this.h, 0, ah, al);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 2, bh, bl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 4, ch, cl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 6, dh, dl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 8, eh, el);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 10, fh, fl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 12, gh, gl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 14, hh, hl);
};
$e1de6ff53e4a4c3f$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h, 'big');
    else return $1JocC.split32(this.h, 'big');
};
function $e1de6ff53e4a4c3f$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$s0_512_hi(xh, xl) {
    var c0_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$s0_512_lo(xh, xl) {
    var c0_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$s1_512_hi(xh, xl) {
    var c0_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$s1_512_lo(xh, xl) {
    var c0_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$g0_512_hi(xh, xl) {
    var c0_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $e1de6ff53e4a4c3f$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$g0_512_lo(xh, xl) {
    var c0_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $e1de6ff53e4a4c3f$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$g1_512_hi(xh, xl) {
    var c0_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $e1de6ff53e4a4c3f$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$g1_512_lo(xh, xl) {
    var c0_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $e1de6ff53e4a4c3f$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("1KcMM", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $14540152db666e38$export$d1cea0ee4e3f0d3e; }, function (v) { return $14540152db666e38$export$d1cea0ee4e3f0d3e = v; });
var $14540152db666e38$export$d1cea0ee4e3f0d3e;
'use strict';

var $1JocC = parcelRequire("1JocC");

var $cx4L0 = parcelRequire("cx4L0");
var $14540152db666e38$var$rotl32 = $1JocC.rotl32;
var $14540152db666e38$var$sum32 = $1JocC.sum32;
var $14540152db666e38$var$sum32_3 = $1JocC.sum32_3;
var $14540152db666e38$var$sum32_4 = $1JocC.sum32_4;
var $14540152db666e38$var$BlockHash = $cx4L0.BlockHash;
function $14540152db666e38$var$RIPEMD160() {
    if (!(this instanceof $14540152db666e38$var$RIPEMD160)) return new $14540152db666e38$var$RIPEMD160();
    $14540152db666e38$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$1JocC.inherits($14540152db666e38$var$RIPEMD160, $14540152db666e38$var$BlockHash);
$14540152db666e38$export$d1cea0ee4e3f0d3e = $14540152db666e38$var$RIPEMD160;
$14540152db666e38$var$RIPEMD160.blockSize = 512;
$14540152db666e38$var$RIPEMD160.outSize = 160;
$14540152db666e38$var$RIPEMD160.hmacStrength = 192;
$14540152db666e38$var$RIPEMD160.padLength = 64;
$14540152db666e38$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $14540152db666e38$var$sum32($14540152db666e38$var$rotl32($14540152db666e38$var$sum32_4(A, $14540152db666e38$var$f(j, B, C, D), msg[$14540152db666e38$var$r[j] + start], $14540152db666e38$var$K(j)), $14540152db666e38$var$s[j]), E);
        A = E;
        E = D;
        D = $14540152db666e38$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $14540152db666e38$var$sum32($14540152db666e38$var$rotl32($14540152db666e38$var$sum32_4(Ah, $14540152db666e38$var$f(79 - j, Bh, Ch, Dh), msg[$14540152db666e38$var$rh[j] + start], $14540152db666e38$var$Kh(j)), $14540152db666e38$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $14540152db666e38$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $14540152db666e38$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $14540152db666e38$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $14540152db666e38$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $14540152db666e38$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $14540152db666e38$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$14540152db666e38$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h, 'little');
    else return $1JocC.split32(this.h, 'little');
};
function $14540152db666e38$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $14540152db666e38$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $14540152db666e38$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $14540152db666e38$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $14540152db666e38$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $14540152db666e38$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $14540152db666e38$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("iBkDX", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $jLTFB = parcelRequire("jLTFB");
function $d8abb2129232a5b9$var$Hmac(hash, key, enc) {
    if (!(this instanceof $d8abb2129232a5b9$var$Hmac)) return new $d8abb2129232a5b9$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($1JocC.toArray(key, enc));
}
module.exports = $d8abb2129232a5b9$var$Hmac;
$d8abb2129232a5b9$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $jLTFB(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$d8abb2129232a5b9$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$d8abb2129232a5b9$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("8M60a", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("ijEQd", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $aZYpB = parcelRequire("aZYpB");

var $2KPxf = parcelRequire("2KPxf");

var $hKjoi = parcelRequire("hKjoi");

var $gWiKw = parcelRequire("gWiKw");
var $d559ae8cfe0978b7$var$assert = $2KPxf.assert;

var $6PbNu = parcelRequire("6PbNu");

var $3Q3Ml = parcelRequire("3Q3Ml");
function $d559ae8cfe0978b7$var$EC(options) {
    if (!(this instanceof $d559ae8cfe0978b7$var$EC)) return new $d559ae8cfe0978b7$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $d559ae8cfe0978b7$var$assert(Object.prototype.hasOwnProperty.call($hKjoi, options), 'Unknown curve ' + options);
        options = $hKjoi[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $hKjoi.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $d559ae8cfe0978b7$var$EC;
$d559ae8cfe0978b7$var$EC.prototype.keyPair = function keyPair(options) {
    return new $6PbNu(this, options);
};
$d559ae8cfe0978b7$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $6PbNu.fromPrivate(this, priv, enc);
};
$d559ae8cfe0978b7$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $6PbNu.fromPublic(this, pub, enc);
};
$d559ae8cfe0978b7$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $aZYpB({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $gWiKw(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $7iECc(2));
    for(;;){
        var priv = new $7iECc(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$d559ae8cfe0978b7$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($7iECc.isBN(msg) || typeof msg === 'number') {
        msg = new $7iECc(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $7iECc(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $7iECc(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$d559ae8cfe0978b7$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$7iECc.isBN(msg)) {
        $d559ae8cfe0978b7$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $d559ae8cfe0978b7$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$d559ae8cfe0978b7$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $d559ae8cfe0978b7$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $d559ae8cfe0978b7$var$assert(new $7iECc(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $aZYpB({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $7iECc(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $7iECc(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $3Q3Ml({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$d559ae8cfe0978b7$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $3Q3Ml(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$d559ae8cfe0978b7$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $d559ae8cfe0978b7$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $3Q3Ml(signature, enc);
    var n = this.n;
    var e = new $7iECc(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$d559ae8cfe0978b7$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $3Q3Ml(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("aZYpB", function(module, exports) {
'use strict';

var $gVjbv = parcelRequire("gVjbv");

var $bA0W1 = parcelRequire("bA0W1");

var $jLTFB = parcelRequire("jLTFB");
function $801e766dffc0af0b$var$HmacDRBG(options) {
    if (!(this instanceof $801e766dffc0af0b$var$HmacDRBG)) return new $801e766dffc0af0b$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $bA0W1.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $bA0W1.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $bA0W1.toArray(options.pers, options.persEnc || 'hex');
    $jLTFB(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $801e766dffc0af0b$var$HmacDRBG;
$801e766dffc0af0b$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$801e766dffc0af0b$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $gVjbv.hmac(this.hash, this.K);
};
$801e766dffc0af0b$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$801e766dffc0af0b$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $bA0W1.toArray(entropy, entropyEnc);
    add = $bA0W1.toArray(add, addEnc);
    $jLTFB(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$801e766dffc0af0b$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $bA0W1.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $bA0W1.encode(res, enc);
};

});

parcelRegister("6PbNu", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $2KPxf = parcelRequire("2KPxf");
var $4f80a828047f5860$var$assert = $2KPxf.assert;
function $4f80a828047f5860$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $4f80a828047f5860$var$KeyPair;
$4f80a828047f5860$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $4f80a828047f5860$var$KeyPair) return pub;
    return new $4f80a828047f5860$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$4f80a828047f5860$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $4f80a828047f5860$var$KeyPair) return priv;
    return new $4f80a828047f5860$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$4f80a828047f5860$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$4f80a828047f5860$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$4f80a828047f5860$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$4f80a828047f5860$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $7iECc(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$4f80a828047f5860$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $4f80a828047f5860$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $4f80a828047f5860$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$4f80a828047f5860$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $4f80a828047f5860$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$4f80a828047f5860$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$4f80a828047f5860$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$4f80a828047f5860$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("3Q3Ml", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $2KPxf = parcelRequire("2KPxf");
var $2cb928d2a10fb271$var$assert = $2KPxf.assert;
function $2cb928d2a10fb271$var$Signature(options, enc) {
    if (options instanceof $2cb928d2a10fb271$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $2cb928d2a10fb271$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $7iECc(options.r, 16);
    this.s = new $7iECc(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $2cb928d2a10fb271$var$Signature;
function $2cb928d2a10fb271$var$Position() {
    this.place = 0;
}
function $2cb928d2a10fb271$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $2cb928d2a10fb271$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$2cb928d2a10fb271$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $2KPxf.toArray(data, enc);
    var p = new $2cb928d2a10fb271$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $2cb928d2a10fb271$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $2cb928d2a10fb271$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $2cb928d2a10fb271$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $7iECc(r);
    this.s = new $7iECc(s);
    this.recoveryParam = null;
    return true;
};
function $2cb928d2a10fb271$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$2cb928d2a10fb271$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $2cb928d2a10fb271$var$rmPadding(r);
    s = $2cb928d2a10fb271$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $2cb928d2a10fb271$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $2cb928d2a10fb271$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $2cb928d2a10fb271$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $2KPxf.encode(res, enc);
};

});


parcelRegister("9fmHx", function(module, exports) {
'use strict';

var $gVjbv = parcelRequire("gVjbv");

var $hKjoi = parcelRequire("hKjoi");

var $2KPxf = parcelRequire("2KPxf");
var $6bb71fc30329a406$var$assert = $2KPxf.assert;
var $6bb71fc30329a406$var$parseBytes = $2KPxf.parseBytes;

var $FCwLh = parcelRequire("FCwLh");

var $gKHZ3 = parcelRequire("gKHZ3");
function $6bb71fc30329a406$var$EDDSA(curve) {
    $6bb71fc30329a406$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $6bb71fc30329a406$var$EDDSA)) return new $6bb71fc30329a406$var$EDDSA(curve);
    curve = $hKjoi[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $gVjbv.sha512;
}
module.exports = $6bb71fc30329a406$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $6bb71fc30329a406$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $6bb71fc30329a406$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $6bb71fc30329a406$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $6bb71fc30329a406$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$6bb71fc30329a406$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $2KPxf.intFromLE(hash.digest()).umod(this.curve.n);
};
$6bb71fc30329a406$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $FCwLh.fromPublic(this, pub);
};
$6bb71fc30329a406$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $FCwLh.fromSecret(this, secret);
};
$6bb71fc30329a406$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $gKHZ3) return sig;
    return new $gKHZ3(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $6bb71fc30329a406$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$6bb71fc30329a406$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $2KPxf.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $2KPxf.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$6bb71fc30329a406$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$6bb71fc30329a406$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $2KPxf.intFromLE(bytes);
};
$6bb71fc30329a406$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("FCwLh", function(module, exports) {
'use strict';

var $2KPxf = parcelRequire("2KPxf");
var $07d1b731153c430e$var$assert = $2KPxf.assert;
var $07d1b731153c430e$var$parseBytes = $2KPxf.parseBytes;
var $07d1b731153c430e$var$cachedProperty = $2KPxf.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $07d1b731153c430e$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $07d1b731153c430e$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $07d1b731153c430e$var$parseBytes(params.pub);
}
$07d1b731153c430e$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $07d1b731153c430e$var$KeyPair) return pub;
    return new $07d1b731153c430e$var$KeyPair(eddsa, {
        pub: pub
    });
};
$07d1b731153c430e$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $07d1b731153c430e$var$KeyPair) return secret;
    return new $07d1b731153c430e$var$KeyPair(eddsa, {
        secret: secret
    });
};
$07d1b731153c430e$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$07d1b731153c430e$var$KeyPair.prototype.sign = function sign(message) {
    $07d1b731153c430e$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$07d1b731153c430e$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$07d1b731153c430e$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $07d1b731153c430e$var$assert(this._secret, 'KeyPair is public only');
    return $2KPxf.encode(this.secret(), enc);
};
$07d1b731153c430e$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $2KPxf.encode(this.pubBytes(), enc);
};
module.exports = $07d1b731153c430e$var$KeyPair;

});

parcelRegister("gKHZ3", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $2KPxf = parcelRequire("2KPxf");
var $c3230f7d16d20b95$var$assert = $2KPxf.assert;
var $c3230f7d16d20b95$var$cachedProperty = $2KPxf.cachedProperty;
var $c3230f7d16d20b95$var$parseBytes = $2KPxf.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $c3230f7d16d20b95$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $c3230f7d16d20b95$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $c3230f7d16d20b95$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $c3230f7d16d20b95$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $7iECc) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$c3230f7d16d20b95$var$cachedProperty($c3230f7d16d20b95$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$c3230f7d16d20b95$var$cachedProperty($c3230f7d16d20b95$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$c3230f7d16d20b95$var$cachedProperty($c3230f7d16d20b95$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$c3230f7d16d20b95$var$cachedProperty($c3230f7d16d20b95$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$c3230f7d16d20b95$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$c3230f7d16d20b95$var$Signature.prototype.toHex = function toHex() {
    return $2KPxf.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $c3230f7d16d20b95$var$Signature;

});



parcelRegister("hdVtR", function(module, exports) {
'use strict';

var $1mcce = parcelRequire("1mcce");

var $7sB41 = parcelRequire("7sB41");

var $afsnk = parcelRequire("afsnk");

var $jGDtA = parcelRequire("jGDtA");

var $d0xYH = parcelRequire("d0xYH");
var $c8a03d08adb7e240$require$pbkdf2Sync = $d0xYH.pbkdf2Sync;

var $fVcWy = parcelRequire("fVcWy");
var $c8a03d08adb7e240$require$Buffer = $fVcWy.Buffer;
function $c8a03d08adb7e240$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $7sB41[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $c8a03d08adb7e240$require$pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $jGDtA.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $c8a03d08adb7e240$require$Buffer.concat(out);
}
function $c8a03d08adb7e240$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$c8a03d08adb7e240$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $c8a03d08adb7e240$require$Buffer.from(buffer);
    var stripped = $afsnk(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $1mcce.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $1mcce.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $1mcce.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $1mcce.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $1mcce.EncryptedPrivateKey.decode(data, 'der');
            data = $c8a03d08adb7e240$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $1mcce.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $1mcce.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $1mcce.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $1mcce.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $1mcce.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $1mcce.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $1mcce.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $1mcce.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$c8a03d08adb7e240$var$parseKeys.signature = $1mcce.signature;
module.exports = $c8a03d08adb7e240$var$parseKeys;

});
parcelRegister("1mcce", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $0fd14e73698eb927$export$c98397a6eb8d0678; }, function (v) { return $0fd14e73698eb927$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $0fd14e73698eb927$export$f4aab6816f64fa6b; }, function (v) { return $0fd14e73698eb927$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $0fd14e73698eb927$export$4471f5c65d097c11; }, function (v) { return $0fd14e73698eb927$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $0fd14e73698eb927$export$ca8b6604d6ce14de; }, function (v) { return $0fd14e73698eb927$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $0fd14e73698eb927$export$8f54525b330fd87b; }, function (v) { return $0fd14e73698eb927$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $0fd14e73698eb927$export$23cd2842b44ca3e7; }, function (v) { return $0fd14e73698eb927$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $0fd14e73698eb927$export$245c9aaa9f5ce4ce; }, function (v) { return $0fd14e73698eb927$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $0fd14e73698eb927$export$8ad762e3e6399afe; }, function (v) { return $0fd14e73698eb927$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $0fd14e73698eb927$export$32ef6f92e22c6ab0; }, function (v) { return $0fd14e73698eb927$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $0fd14e73698eb927$export$c9cd164b539ebb63; }, function (v) { return $0fd14e73698eb927$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $0fd14e73698eb927$export$c98397a6eb8d0678;
var $0fd14e73698eb927$export$f4aab6816f64fa6b;
var $0fd14e73698eb927$export$4471f5c65d097c11;
var $0fd14e73698eb927$export$ca8b6604d6ce14de;
var $0fd14e73698eb927$export$8f54525b330fd87b;
var $0fd14e73698eb927$export$23cd2842b44ca3e7;
var $0fd14e73698eb927$export$245c9aaa9f5ce4ce;
var $0fd14e73698eb927$export$8ad762e3e6399afe;
var $0fd14e73698eb927$export$32ef6f92e22c6ab0;
var $0fd14e73698eb927$export$c9cd164b539ebb63;
'use strict';

var $hl0ih = parcelRequire("hl0ih");

$0fd14e73698eb927$export$c98397a6eb8d0678 = (parcelRequire("8PYd1"));
var $0fd14e73698eb927$var$RSAPrivateKey = $hl0ih.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$0fd14e73698eb927$export$f4aab6816f64fa6b = $0fd14e73698eb927$var$RSAPrivateKey;
var $0fd14e73698eb927$var$RSAPublicKey = $hl0ih.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$0fd14e73698eb927$export$4471f5c65d097c11 = $0fd14e73698eb927$var$RSAPublicKey;
var $0fd14e73698eb927$var$AlgorithmIdentifier = $hl0ih.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $0fd14e73698eb927$var$PublicKey = $hl0ih.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($0fd14e73698eb927$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$0fd14e73698eb927$export$ca8b6604d6ce14de = $0fd14e73698eb927$var$PublicKey;
var $0fd14e73698eb927$var$PrivateKeyInfo = $hl0ih.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($0fd14e73698eb927$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$0fd14e73698eb927$export$8f54525b330fd87b = $0fd14e73698eb927$var$PrivateKeyInfo;
var $0fd14e73698eb927$var$EncryptedPrivateKeyInfo = $hl0ih.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$0fd14e73698eb927$export$23cd2842b44ca3e7 = $0fd14e73698eb927$var$EncryptedPrivateKeyInfo;
var $0fd14e73698eb927$var$DSAPrivateKey = $hl0ih.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$0fd14e73698eb927$export$245c9aaa9f5ce4ce = $0fd14e73698eb927$var$DSAPrivateKey;
$0fd14e73698eb927$export$8ad762e3e6399afe = $hl0ih.define('DSAparam', function() {
    this['int']();
});
var $0fd14e73698eb927$var$ECParameters = $hl0ih.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $0fd14e73698eb927$var$ECPrivateKey = $hl0ih.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($0fd14e73698eb927$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$0fd14e73698eb927$export$32ef6f92e22c6ab0 = $0fd14e73698eb927$var$ECPrivateKey;
$0fd14e73698eb927$export$c9cd164b539ebb63 = $hl0ih.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("hl0ih", function(module, exports) {
var $c9f4a02d1f59d6a6$var$asn1 = module.exports;

$c9f4a02d1f59d6a6$var$asn1.bignum = (parcelRequire("hlAHM"));

$c9f4a02d1f59d6a6$var$asn1.define = (parcelRequire("7C5CY")).define;

$c9f4a02d1f59d6a6$var$asn1.base = (parcelRequire("iWwea"));

$c9f4a02d1f59d6a6$var$asn1.constants = (parcelRequire("1fb9t"));

$c9f4a02d1f59d6a6$var$asn1.decoders = (parcelRequire("4hyYb"));

$c9f4a02d1f59d6a6$var$asn1.encoders = (parcelRequire("lDvlV"));

});
parcelRegister("hlAHM", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7C5CY", function(module, exports) {

var $hl0ih = parcelRequire("hl0ih");

var $dhT4G = parcelRequire("dhT4G");
var $58b0728c3ed07e03$var$api = module.exports;
$58b0728c3ed07e03$var$api.define = function define(name, body) {
    return new $58b0728c3ed07e03$var$Entity(name, body);
};
function $58b0728c3ed07e03$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$58b0728c3ed07e03$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("eqQT5")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $dhT4G(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$58b0728c3ed07e03$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($hl0ih.decoders[enc]);
    return this.decoders[enc];
};
$58b0728c3ed07e03$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$58b0728c3ed07e03$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($hl0ih.encoders[enc]);
    return this.encoders[enc];
};
$58b0728c3ed07e03$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("eqQT5", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("iWwea", function(module, exports) {
var $dca6a4813cf30630$var$base = module.exports;

$dca6a4813cf30630$var$base.Reporter = (parcelRequire("5bsbC")).Reporter;

$dca6a4813cf30630$var$base.DecoderBuffer = (parcelRequire("jH2v3")).DecoderBuffer;

$dca6a4813cf30630$var$base.EncoderBuffer = (parcelRequire("jH2v3")).EncoderBuffer;

$dca6a4813cf30630$var$base.Node = (parcelRequire("3kihE"));

});
parcelRegister("5bsbC", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $3c63d8098c4065a1$export$957313a2f485e5ed; }, function (v) { return $3c63d8098c4065a1$export$957313a2f485e5ed = v; });
var $3c63d8098c4065a1$export$957313a2f485e5ed;

var $dhT4G = parcelRequire("dhT4G");
function $3c63d8098c4065a1$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$3c63d8098c4065a1$export$957313a2f485e5ed = $3c63d8098c4065a1$var$Reporter;
$3c63d8098c4065a1$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $3c63d8098c4065a1$var$ReporterError;
};
$3c63d8098c4065a1$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$3c63d8098c4065a1$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$3c63d8098c4065a1$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$3c63d8098c4065a1$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$3c63d8098c4065a1$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$3c63d8098c4065a1$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$3c63d8098c4065a1$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$3c63d8098c4065a1$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$3c63d8098c4065a1$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $3c63d8098c4065a1$var$ReporterError;
    if (inherited) err = msg;
    else err = new $3c63d8098c4065a1$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$3c63d8098c4065a1$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $3c63d8098c4065a1$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dhT4G($3c63d8098c4065a1$var$ReporterError, Error);
$3c63d8098c4065a1$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $3c63d8098c4065a1$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("jH2v3", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $e563f8e7c404a610$export$bf9f79cdc4a49163; }, function (v) { return $e563f8e7c404a610$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $e563f8e7c404a610$export$8ff24f7760c7a78e; }, function (v) { return $e563f8e7c404a610$export$8ff24f7760c7a78e = v; });
var $e563f8e7c404a610$export$bf9f79cdc4a49163;
var $e563f8e7c404a610$export$8ff24f7760c7a78e;

var $dhT4G = parcelRequire("dhT4G");

var $iWwea = parcelRequire("iWwea");
var $e563f8e7c404a610$require$Reporter = $iWwea.Reporter;

var $bdjQ6 = parcelRequire("bdjQ6");
var $e563f8e7c404a610$require$Buffer = $bdjQ6.Buffer;
function $e563f8e7c404a610$var$DecoderBuffer(base, options) {
    $e563f8e7c404a610$require$Reporter.call(this, options);
    if (!$e563f8e7c404a610$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dhT4G($e563f8e7c404a610$var$DecoderBuffer, $e563f8e7c404a610$require$Reporter);
$e563f8e7c404a610$export$bf9f79cdc4a49163 = $e563f8e7c404a610$var$DecoderBuffer;
$e563f8e7c404a610$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $e563f8e7c404a610$require$Reporter.prototype.save.call(this)
    };
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $e563f8e7c404a610$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $e563f8e7c404a610$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $e563f8e7c404a610$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $e563f8e7c404a610$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $e563f8e7c404a610$var$EncoderBuffer)) item = new $e563f8e7c404a610$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $e563f8e7c404a610$require$Buffer.byteLength(value);
    } else if ($e563f8e7c404a610$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$e563f8e7c404a610$export$8ff24f7760c7a78e = $e563f8e7c404a610$var$EncoderBuffer;
$e563f8e7c404a610$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $e563f8e7c404a610$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($e563f8e7c404a610$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("3kihE", function(module, exports) {

var $iWwea = parcelRequire("iWwea");
var $26c16c1a02aab51e$require$Reporter = $iWwea.Reporter;

var $iWwea = parcelRequire("iWwea");
var $26c16c1a02aab51e$require$EncoderBuffer = $iWwea.EncoderBuffer;

var $iWwea = parcelRequire("iWwea");
var $26c16c1a02aab51e$require$DecoderBuffer = $iWwea.DecoderBuffer;

var $jLTFB = parcelRequire("jLTFB");
// Supported tags
var $26c16c1a02aab51e$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $26c16c1a02aab51e$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($26c16c1a02aab51e$var$tags);
// Overrided methods list
var $26c16c1a02aab51e$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $26c16c1a02aab51e$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $26c16c1a02aab51e$var$Node;
var $26c16c1a02aab51e$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$26c16c1a02aab51e$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $26c16c1a02aab51e$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$26c16c1a02aab51e$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $26c16c1a02aab51e$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$26c16c1a02aab51e$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $jLTFB(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $jLTFB.equal(state.children.length, 1, 'Root node can have only one child');
};
$26c16c1a02aab51e$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $jLTFB(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $jLTFB(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$26c16c1a02aab51e$var$overrided.forEach(function(method) {
    $26c16c1a02aab51e$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$26c16c1a02aab51e$var$tags.forEach(function(tag) {
    $26c16c1a02aab51e$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $jLTFB(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$26c16c1a02aab51e$var$Node.prototype.use = function use(item) {
    $jLTFB(item);
    var state = this._baseState;
    $jLTFB(state.use === null);
    state.use = item;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $jLTFB(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $jLTFB(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $jLTFB(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $jLTFB(state.key === null);
    state.key = newKey;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $jLTFB(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $jLTFB(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$26c16c1a02aab51e$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $26c16c1a02aab51e$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$26c16c1a02aab51e$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$26c16c1a02aab51e$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $jLTFB(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$26c16c1a02aab51e$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$26c16c1a02aab51e$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $26c16c1a02aab51e$require$EncoderBuffer(data, this.reporter);
};
$26c16c1a02aab51e$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$26c16c1a02aab51e$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $26c16c1a02aab51e$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$26c16c1a02aab51e$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $jLTFB(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$26c16c1a02aab51e$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$26c16c1a02aab51e$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$26c16c1a02aab51e$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("1fb9t", function(module, exports) {
var $0e7fd7b3172df5b4$var$constants = module.exports;
// Helper
$0e7fd7b3172df5b4$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$0e7fd7b3172df5b4$var$constants.der = (parcelRequire("1k4L4"));

});
parcelRegister("1k4L4", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $0f6b5998036e2e79$export$3584c46ed60baee8; }, function (v) { return $0f6b5998036e2e79$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $0f6b5998036e2e79$export$f18596ef8d632e49; }, function (v) { return $0f6b5998036e2e79$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $0f6b5998036e2e79$export$2b067c6666111485; }, function (v) { return $0f6b5998036e2e79$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $0f6b5998036e2e79$export$f17df38a421ab9e3; }, function (v) { return $0f6b5998036e2e79$export$f17df38a421ab9e3 = v; });
var $0f6b5998036e2e79$export$3584c46ed60baee8;
var $0f6b5998036e2e79$export$f18596ef8d632e49;
var $0f6b5998036e2e79$export$2b067c6666111485;
var $0f6b5998036e2e79$export$f17df38a421ab9e3;

var $1fb9t = parcelRequire("1fb9t");
$0f6b5998036e2e79$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$0f6b5998036e2e79$export$f18596ef8d632e49 = $1fb9t._reverse($0f6b5998036e2e79$export$3584c46ed60baee8);
$0f6b5998036e2e79$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$0f6b5998036e2e79$export$f17df38a421ab9e3 = $1fb9t._reverse($0f6b5998036e2e79$export$2b067c6666111485);

});


parcelRegister("4hyYb", function(module, exports) {
var $31e3e03616588660$var$decoders = module.exports;

$31e3e03616588660$var$decoders.der = (parcelRequire("lOUAW"));

$31e3e03616588660$var$decoders.pem = (parcelRequire("hXQvW"));

});
parcelRegister("lOUAW", function(module, exports) {

var $dhT4G = parcelRequire("dhT4G");

var $hl0ih = parcelRequire("hl0ih");
var $fe2a2b049a9573f9$var$base = $hl0ih.base;
var $fe2a2b049a9573f9$var$bignum = $hl0ih.bignum;
// Import DER constants
var $fe2a2b049a9573f9$var$der = $hl0ih.constants.der;
function $fe2a2b049a9573f9$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $fe2a2b049a9573f9$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $fe2a2b049a9573f9$var$DERDecoder;
$fe2a2b049a9573f9$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $fe2a2b049a9573f9$var$base.DecoderBuffer)) data = new $fe2a2b049a9573f9$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $fe2a2b049a9573f9$var$DERNode(parent) {
    $fe2a2b049a9573f9$var$base.Node.call(this, 'der', parent);
}
$dhT4G($fe2a2b049a9573f9$var$DERNode, $fe2a2b049a9573f9$var$base.Node);
$fe2a2b049a9573f9$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $fe2a2b049a9573f9$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $fe2a2b049a9573f9$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $fe2a2b049a9573f9$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$fe2a2b049a9573f9$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $fe2a2b049a9573f9$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $fe2a2b049a9573f9$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $fe2a2b049a9573f9$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$fe2a2b049a9573f9$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $fe2a2b049a9573f9$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $fe2a2b049a9573f9$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $fe2a2b049a9573f9$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $fe2a2b049a9573f9$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("hXQvW", function(module, exports) {

var $dhT4G = parcelRequire("dhT4G");

var $bdjQ6 = parcelRequire("bdjQ6");
var $d140ae98da07bebb$require$Buffer = $bdjQ6.Buffer;

var $lOUAW = parcelRequire("lOUAW");
function $d140ae98da07bebb$var$PEMDecoder(entity) {
    $lOUAW.call(this, entity);
    this.enc = 'pem';
}
$dhT4G($d140ae98da07bebb$var$PEMDecoder, $lOUAW);
module.exports = $d140ae98da07bebb$var$PEMDecoder;
$d140ae98da07bebb$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $d140ae98da07bebb$require$Buffer(base64, 'base64');
    return $lOUAW.prototype.decode.call(this, input, options);
};

});


parcelRegister("lDvlV", function(module, exports) {
var $fc058f72de806c01$var$encoders = module.exports;

$fc058f72de806c01$var$encoders.der = (parcelRequire("aowvn"));

$fc058f72de806c01$var$encoders.pem = (parcelRequire("lJ9hm"));

});
parcelRegister("aowvn", function(module, exports) {

var $dhT4G = parcelRequire("dhT4G");

var $bdjQ6 = parcelRequire("bdjQ6");
var $79155c1e61c68e60$require$Buffer = $bdjQ6.Buffer;

var $hl0ih = parcelRequire("hl0ih");
var $79155c1e61c68e60$var$base = $hl0ih.base;
// Import DER constants
var $79155c1e61c68e60$var$der = $hl0ih.constants.der;
function $79155c1e61c68e60$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $79155c1e61c68e60$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $79155c1e61c68e60$var$DEREncoder;
$79155c1e61c68e60$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $79155c1e61c68e60$var$DERNode(parent) {
    $79155c1e61c68e60$var$base.Node.call(this, 'der', parent);
}
$dhT4G($79155c1e61c68e60$var$DERNode, $79155c1e61c68e60$var$base.Node);
$79155c1e61c68e60$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $79155c1e61c68e60$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $79155c1e61c68e60$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $79155c1e61c68e60$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$79155c1e61c68e60$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $79155c1e61c68e60$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$79155c1e61c68e60$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $79155c1e61c68e60$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $79155c1e61c68e60$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$79155c1e61c68e60$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $79155c1e61c68e60$var$two(date.getFullYear()),
        $79155c1e61c68e60$var$two(date.getUTCMonth() + 1),
        $79155c1e61c68e60$var$two(date.getUTCDate()),
        $79155c1e61c68e60$var$two(date.getUTCHours()),
        $79155c1e61c68e60$var$two(date.getUTCMinutes()),
        $79155c1e61c68e60$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $79155c1e61c68e60$var$two(date.getFullYear() % 100),
        $79155c1e61c68e60$var$two(date.getUTCMonth() + 1),
        $79155c1e61c68e60$var$two(date.getUTCDate()),
        $79155c1e61c68e60$var$two(date.getUTCHours()),
        $79155c1e61c68e60$var$two(date.getUTCMinutes()),
        $79155c1e61c68e60$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$79155c1e61c68e60$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$79155c1e61c68e60$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$79155c1e61c68e60$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $79155c1e61c68e60$require$Buffer(numArray);
    }
    if ($79155c1e61c68e60$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $79155c1e61c68e60$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $79155c1e61c68e60$require$Buffer(out));
};
$79155c1e61c68e60$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$79155c1e61c68e60$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$79155c1e61c68e60$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $79155c1e61c68e60$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($79155c1e61c68e60$var$der.tagByName.hasOwnProperty(tag)) res = $79155c1e61c68e60$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $79155c1e61c68e60$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("lJ9hm", function(module, exports) {

var $dhT4G = parcelRequire("dhT4G");

var $aowvn = parcelRequire("aowvn");
function $fd14ff90396c39a5$var$PEMEncoder(entity) {
    $aowvn.call(this, entity);
    this.enc = 'pem';
}
$dhT4G($fd14ff90396c39a5$var$PEMEncoder, $aowvn);
module.exports = $fd14ff90396c39a5$var$PEMEncoder;
$fd14ff90396c39a5$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $aowvn.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("8PYd1", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $hl0ih = parcelRequire("hl0ih");
var $66f1ca64d4f026a4$var$Time = $hl0ih.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $66f1ca64d4f026a4$var$AttributeTypeValue = $hl0ih.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $66f1ca64d4f026a4$var$AlgorithmIdentifier = $hl0ih.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $66f1ca64d4f026a4$var$SubjectPublicKeyInfo = $hl0ih.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($66f1ca64d4f026a4$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $66f1ca64d4f026a4$var$RelativeDistinguishedName = $hl0ih.define('RelativeDistinguishedName', function() {
    this.setof($66f1ca64d4f026a4$var$AttributeTypeValue);
});
var $66f1ca64d4f026a4$var$RDNSequence = $hl0ih.define('RDNSequence', function() {
    this.seqof($66f1ca64d4f026a4$var$RelativeDistinguishedName);
});
var $66f1ca64d4f026a4$var$Name = $hl0ih.define('Name', function() {
    this.choice({
        rdnSequence: this.use($66f1ca64d4f026a4$var$RDNSequence)
    });
});
var $66f1ca64d4f026a4$var$Validity = $hl0ih.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($66f1ca64d4f026a4$var$Time), this.key('notAfter').use($66f1ca64d4f026a4$var$Time));
});
var $66f1ca64d4f026a4$var$Extension = $hl0ih.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $66f1ca64d4f026a4$var$TBSCertificate = $hl0ih.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($66f1ca64d4f026a4$var$AlgorithmIdentifier), this.key('issuer').use($66f1ca64d4f026a4$var$Name), this.key('validity').use($66f1ca64d4f026a4$var$Validity), this.key('subject').use($66f1ca64d4f026a4$var$Name), this.key('subjectPublicKeyInfo').use($66f1ca64d4f026a4$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($66f1ca64d4f026a4$var$Extension).optional());
});
var $66f1ca64d4f026a4$var$X509Certificate = $hl0ih.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($66f1ca64d4f026a4$var$TBSCertificate), this.key('signatureAlgorithm').use($66f1ca64d4f026a4$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $66f1ca64d4f026a4$var$X509Certificate;

});


parcelRegister("7sB41", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("afsnk", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $776150cf36ad152d$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $776150cf36ad152d$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $776150cf36ad152d$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $iWvja = parcelRequire("iWvja");

var $jGDtA = parcelRequire("jGDtA");

var $fVcWy = parcelRequire("fVcWy");
var $776150cf36ad152d$require$Buffer = $fVcWy.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($776150cf36ad152d$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($776150cf36ad152d$var$fullRegex);
        decrypted = $776150cf36ad152d$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $776150cf36ad152d$require$Buffer.from(match[2], 'hex');
        var cipherText = $776150cf36ad152d$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $iWvja(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $jGDtA.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $776150cf36ad152d$require$Buffer.concat(out);
    }
    var tag = key.match($776150cf36ad152d$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("fVcWy", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $b9763828198f5ce8$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $b9763828198f5ce8$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($b9763828198f5ce8$var$Buffer.from && $b9763828198f5ce8$var$Buffer.alloc && $b9763828198f5ce8$var$Buffer.allocUnsafe && $b9763828198f5ce8$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $b9763828198f5ce8$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $b9763828198f5ce8$var$SafeBuffer;
}
function $b9763828198f5ce8$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $b9763828198f5ce8$var$Buffer(arg, encodingOrOffset, length);
}
$b9763828198f5ce8$var$SafeBuffer.prototype = Object.create($b9763828198f5ce8$var$Buffer.prototype);
// Copy static methods from Buffer
$b9763828198f5ce8$var$copyProps($b9763828198f5ce8$var$Buffer, $b9763828198f5ce8$var$SafeBuffer);
$b9763828198f5ce8$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $b9763828198f5ce8$var$Buffer(arg, encodingOrOffset, length);
};
$b9763828198f5ce8$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $b9763828198f5ce8$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$b9763828198f5ce8$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b9763828198f5ce8$var$Buffer(size);
};
$b9763828198f5ce8$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});



parcelRegister("6cUou", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("7LwOP", function(module, exports) {
'use strict';

var $2BV4h = parcelRequire("2BV4h");
var $5a766155c8ab551b$require$Buffer = $2BV4h.Buffer;

var $aVh2m = parcelRequire("aVh2m");

var $a2sGY = parcelRequire("a2sGY");
var $5a766155c8ab551b$require$EC = $a2sGY.ec;

var $hdVtR = parcelRequire("hdVtR");

var $6cUou = parcelRequire("6cUou");
function $5a766155c8ab551b$var$verify(sig, hash, key, signType, tag) {
    var pub = $hdVtR(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $5a766155c8ab551b$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $5a766155c8ab551b$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $5a766155c8ab551b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $5a766155c8ab551b$require$Buffer.from(pad);
    var red = $aVh2m.mont(pub.modulus);
    sig = new $aVh2m(sig).toRed(red);
    sig = sig.redPow(new $aVh2m(pub.publicExponent));
    sig = $5a766155c8ab551b$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $5a766155c8ab551b$var$ecVerify(sig, hash, pub) {
    var curveId = $6cUou[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $5a766155c8ab551b$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $5a766155c8ab551b$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $hdVtR.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $5a766155c8ab551b$var$checkValue(s, q);
    $5a766155c8ab551b$var$checkValue(r, q);
    var montp = $aVh2m.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $aVh2m(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $5a766155c8ab551b$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $5a766155c8ab551b$var$verify;

});


parcelRegister("iT16E", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $dbfe38b5b3f041f5$require$Buffer = $bdjQ6.Buffer;

var $a2sGY = parcelRequire("a2sGY");

var $f8x3B = parcelRequire("f8x3B");
module.exports = function createECDH(curve) {
    return new $dbfe38b5b3f041f5$var$ECDH(curve);
};
var $dbfe38b5b3f041f5$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$dbfe38b5b3f041f5$var$aliases.p224 = $dbfe38b5b3f041f5$var$aliases.secp224r1;
$dbfe38b5b3f041f5$var$aliases.p256 = $dbfe38b5b3f041f5$var$aliases.secp256r1 = $dbfe38b5b3f041f5$var$aliases.prime256v1;
$dbfe38b5b3f041f5$var$aliases.p192 = $dbfe38b5b3f041f5$var$aliases.secp192r1 = $dbfe38b5b3f041f5$var$aliases.prime192v1;
$dbfe38b5b3f041f5$var$aliases.p384 = $dbfe38b5b3f041f5$var$aliases.secp384r1;
$dbfe38b5b3f041f5$var$aliases.p521 = $dbfe38b5b3f041f5$var$aliases.secp521r1;
function $dbfe38b5b3f041f5$var$ECDH(curve) {
    this.curveType = $dbfe38b5b3f041f5$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $a2sGY.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$dbfe38b5b3f041f5$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$dbfe38b5b3f041f5$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$dbfe38b5b3f041f5$require$Buffer.isBuffer(other)) other = new $dbfe38b5b3f041f5$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $dbfe38b5b3f041f5$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$dbfe38b5b3f041f5$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $dbfe38b5b3f041f5$var$formatReturnValue(key, enc);
};
$dbfe38b5b3f041f5$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $dbfe38b5b3f041f5$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$dbfe38b5b3f041f5$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$dbfe38b5b3f041f5$require$Buffer.isBuffer(pub)) pub = new $dbfe38b5b3f041f5$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$dbfe38b5b3f041f5$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$dbfe38b5b3f041f5$require$Buffer.isBuffer(priv)) priv = new $dbfe38b5b3f041f5$require$Buffer(priv, enc);
    var _priv = new $f8x3B(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $dbfe38b5b3f041f5$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $dbfe38b5b3f041f5$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $dbfe38b5b3f041f5$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $dbfe38b5b3f041f5$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("f8x3B", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("estFo", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $a86ab166e2d75ba5$export$512823e338ddb1b7; }, function (v) { return $a86ab166e2d75ba5$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $a86ab166e2d75ba5$export$7efb24e2fddf99b9; }, function (v) { return $a86ab166e2d75ba5$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $a86ab166e2d75ba5$export$9d0e0c0c4a8d30f3; }, function (v) { return $a86ab166e2d75ba5$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $a86ab166e2d75ba5$export$b9d55ff329113abd; }, function (v) { return $a86ab166e2d75ba5$export$b9d55ff329113abd = v; });
var $a86ab166e2d75ba5$export$512823e338ddb1b7;
var $a86ab166e2d75ba5$export$7efb24e2fddf99b9;
var $a86ab166e2d75ba5$export$9d0e0c0c4a8d30f3;
var $a86ab166e2d75ba5$export$b9d55ff329113abd;

$a86ab166e2d75ba5$export$512823e338ddb1b7 = (parcelRequire("eWI2k"));

$a86ab166e2d75ba5$export$7efb24e2fddf99b9 = (parcelRequire("fUUOC"));
$a86ab166e2d75ba5$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $a86ab166e2d75ba5$export$512823e338ddb1b7(key, buf, true);
};
$a86ab166e2d75ba5$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $a86ab166e2d75ba5$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("eWI2k", function(module, exports) {

var $hdVtR = parcelRequire("hdVtR");

var $f08he = parcelRequire("f08he");

var $eNPUV = parcelRequire("eNPUV");

var $k9jil = parcelRequire("k9jil");

var $kkDNX = parcelRequire("kkDNX");

var $jKpja = parcelRequire("jKpja");

var $argyJ = parcelRequire("argyJ");

var $2jcIV = parcelRequire("2jcIV");

var $838j1 = parcelRequire("838j1");
var $ae18a42fc88e982d$require$Buffer = $838j1.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $hdVtR(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $ae18a42fc88e982d$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $ae18a42fc88e982d$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $jKpja(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $2jcIV(paddedMsg, key);
    else return $argyJ(paddedMsg, key);
};
function $ae18a42fc88e982d$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $eNPUV('sha1').update($ae18a42fc88e982d$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $ae18a42fc88e982d$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $f08he(hLen);
    var maskedDb = $kkDNX($ae18a42fc88e982d$require$Buffer.concat([
        iHash,
        ps,
        $ae18a42fc88e982d$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $k9jil(seed, dblen));
    var maskedSeed = $kkDNX(seed, $k9jil(maskedDb, hLen));
    return new $jKpja($ae18a42fc88e982d$require$Buffer.concat([
        $ae18a42fc88e982d$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $ae18a42fc88e982d$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $ae18a42fc88e982d$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $ae18a42fc88e982d$var$nonZero(k - mLen - 3);
    return new $jKpja($ae18a42fc88e982d$require$Buffer.concat([
        $ae18a42fc88e982d$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $ae18a42fc88e982d$require$Buffer.alloc(1),
        msg
    ], k));
}
function $ae18a42fc88e982d$var$nonZero(len) {
    var out = $ae18a42fc88e982d$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $f08he(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $f08he(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("k9jil", function(module, exports) {

var $eNPUV = parcelRequire("eNPUV");

var $838j1 = parcelRequire("838j1");
var $eab39d77b6a56d48$require$Buffer = $838j1.Buffer;
module.exports = function(seed, len) {
    var t = $eab39d77b6a56d48$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $eab39d77b6a56d48$var$i2ops(i++);
        t = $eab39d77b6a56d48$require$Buffer.concat([
            t,
            $eNPUV('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $eab39d77b6a56d48$var$i2ops(c) {
    var out = $eab39d77b6a56d48$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("kkDNX", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("jKpja", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("argyJ", function(module, exports) {

var $jKpja = parcelRequire("jKpja");

var $838j1 = parcelRequire("838j1");
var $799945527bd57bd7$require$Buffer = $838j1.Buffer;
function $799945527bd57bd7$var$withPublic(paddedMsg, key) {
    return $799945527bd57bd7$require$Buffer.from(paddedMsg.toRed($jKpja.mont(key.modulus)).redPow(new $jKpja(key.publicExponent)).fromRed().toArray());
}
module.exports = $799945527bd57bd7$var$withPublic;

});


parcelRegister("fUUOC", function(module, exports) {

var $hdVtR = parcelRequire("hdVtR");

var $k9jil = parcelRequire("k9jil");

var $kkDNX = parcelRequire("kkDNX");

var $jKpja = parcelRequire("jKpja");

var $2jcIV = parcelRequire("2jcIV");

var $eNPUV = parcelRequire("eNPUV");

var $argyJ = parcelRequire("argyJ");

var $838j1 = parcelRequire("838j1");
var $b9682859c179c6a2$require$Buffer = $838j1.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $hdVtR(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $jKpja(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $argyJ(new $jKpja(enc), key);
    else msg = $2jcIV(enc, key);
    var zBuffer = $b9682859c179c6a2$require$Buffer.alloc(k - msg.length);
    msg = $b9682859c179c6a2$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $b9682859c179c6a2$var$oaep(key, msg);
    else if (padding === 1) return $b9682859c179c6a2$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $b9682859c179c6a2$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $eNPUV('sha1').update($b9682859c179c6a2$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $kkDNX(maskedSeed, $k9jil(maskedDb, hLen));
    var db = $kkDNX(maskedDb, $k9jil(seed, k - hLen - 1));
    if ($b9682859c179c6a2$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $b9682859c179c6a2$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $b9682859c179c6a2$var$compare(a, b) {
    a = $b9682859c179c6a2$require$Buffer.from(a);
    b = $b9682859c179c6a2$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("3yLuA", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $29796313a5dc60f7$export$bb1abf2ce84fc7e8; }, function (v) { return $29796313a5dc60f7$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $29796313a5dc60f7$export$2f7171e78e524d5e; }, function (v) { return $29796313a5dc60f7$export$2f7171e78e524d5e = v; });
var $29796313a5dc60f7$export$bb1abf2ce84fc7e8;
var $29796313a5dc60f7$export$2f7171e78e524d5e;

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
function $29796313a5dc60f7$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $838j1 = parcelRequire("838j1");

var $f08he = parcelRequire("f08he");
var $29796313a5dc60f7$var$Buffer = $838j1.Buffer;
var $29796313a5dc60f7$var$kBufferMaxLength = $838j1.kMaxLength;
var $29796313a5dc60f7$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $29796313a5dc60f7$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $29796313a5dc60f7$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $29796313a5dc60f7$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $29796313a5dc60f7$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $29796313a5dc60f7$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $29796313a5dc60f7$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $29796313a5dc60f7$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($29796313a5dc60f7$var$crypto && $29796313a5dc60f7$var$crypto.getRandomValues || false) {
    $29796313a5dc60f7$export$bb1abf2ce84fc7e8 = $29796313a5dc60f7$var$randomFill;
    $29796313a5dc60f7$export$2f7171e78e524d5e = $29796313a5dc60f7$var$randomFillSync;
} else {
    $29796313a5dc60f7$export$bb1abf2ce84fc7e8 = $29796313a5dc60f7$var$oldBrowser;
    $29796313a5dc60f7$export$2f7171e78e524d5e = $29796313a5dc60f7$var$oldBrowser;
}
function $29796313a5dc60f7$var$randomFill(buf, offset, size, cb) {
    if (!$29796313a5dc60f7$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $29796313a5dc60f7$var$assertOffset(offset, buf.length);
    $29796313a5dc60f7$var$assertSize(size, offset, buf.length);
    return $29796313a5dc60f7$var$actualFill(buf, offset, size, cb);
}
function $29796313a5dc60f7$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $29796313a5dc60f7$var$crypto.getRandomValues(uint);
    if (cb) {
        $4ZL0H.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $f08he(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $f08he(size);
    bytes.copy(buf, offset);
    return buf;
}
function $29796313a5dc60f7$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$29796313a5dc60f7$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $29796313a5dc60f7$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $29796313a5dc60f7$var$assertSize(size, offset, buf.length);
    return $29796313a5dc60f7$var$actualFill(buf, offset, size);
}

});


parcelRegister("9YAY5", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $743664c4b8fd32ff$require$Buffer = $838j1.Buffer;

var $gmRjM = parcelRequire("gmRjM");
var $743664c4b8fd32ff$var$MAX_OCTET = 0x80, $743664c4b8fd32ff$var$CLASS_UNIVERSAL = 0, $743664c4b8fd32ff$var$PRIMITIVE_BIT = 0x20, $743664c4b8fd32ff$var$TAG_SEQ = 0x10, $743664c4b8fd32ff$var$TAG_INT = 0x02, $743664c4b8fd32ff$var$ENCODED_TAG_SEQ = $743664c4b8fd32ff$var$TAG_SEQ | $743664c4b8fd32ff$var$PRIMITIVE_BIT | $743664c4b8fd32ff$var$CLASS_UNIVERSAL << 6, $743664c4b8fd32ff$var$ENCODED_TAG_INT = $743664c4b8fd32ff$var$TAG_INT | $743664c4b8fd32ff$var$CLASS_UNIVERSAL << 6;
function $743664c4b8fd32ff$var$base64Url(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $743664c4b8fd32ff$var$signatureAsBuffer(signature) {
    if ($743664c4b8fd32ff$require$Buffer.isBuffer(signature)) return signature;
    else if ('string' === typeof signature) return $743664c4b8fd32ff$require$Buffer.from(signature, 'base64');
    throw new TypeError('ECDSA signature must be a Base64 string or a Buffer');
}
function $743664c4b8fd32ff$var$derToJose(signature, alg) {
    signature = $743664c4b8fd32ff$var$signatureAsBuffer(signature);
    var paramBytes = $gmRjM(alg);
    // the DER encoded param should at most be the param size, plus a padding
    // zero, since due to being a signed integer
    var maxEncodedParamLength = paramBytes + 1;
    var inputLength = signature.length;
    var offset = 0;
    if (signature[offset++] !== $743664c4b8fd32ff$var$ENCODED_TAG_SEQ) throw new Error('Could not find expected "seq"');
    var seqLength = signature[offset++];
    if (seqLength === ($743664c4b8fd32ff$var$MAX_OCTET | 1)) seqLength = signature[offset++];
    if (inputLength - offset < seqLength) throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
    if (signature[offset++] !== $743664c4b8fd32ff$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "r"');
    var rLength = signature[offset++];
    if (inputLength - offset - 2 < rLength) throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
    if (maxEncodedParamLength < rLength) throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var rOffset = offset;
    offset += rLength;
    if (signature[offset++] !== $743664c4b8fd32ff$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "s"');
    var sLength = signature[offset++];
    if (inputLength - offset !== sLength) throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
    if (maxEncodedParamLength < sLength) throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var sOffset = offset;
    offset += sLength;
    if (offset !== inputLength) throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
    var rPadding = paramBytes - rLength, sPadding = paramBytes - sLength;
    var dst = $743664c4b8fd32ff$require$Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);
    for(offset = 0; offset < rPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);
    offset = paramBytes;
    for(var o = offset; offset < o + sPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);
    dst = dst.toString('base64');
    dst = $743664c4b8fd32ff$var$base64Url(dst);
    return dst;
}
function $743664c4b8fd32ff$var$countPadding(buf, start, stop) {
    var padding = 0;
    while(start + padding < stop && buf[start + padding] === 0)++padding;
    var needsSign = buf[start + padding] >= $743664c4b8fd32ff$var$MAX_OCTET;
    if (needsSign) --padding;
    return padding;
}
function $743664c4b8fd32ff$var$joseToDer(signature, alg) {
    signature = $743664c4b8fd32ff$var$signatureAsBuffer(signature);
    var paramBytes = $gmRjM(alg);
    var signatureBytes = signature.length;
    if (signatureBytes !== paramBytes * 2) throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
    var rPadding = $743664c4b8fd32ff$var$countPadding(signature, 0, paramBytes);
    var sPadding = $743664c4b8fd32ff$var$countPadding(signature, paramBytes, signature.length);
    var rLength = paramBytes - rPadding;
    var sLength = paramBytes - sPadding;
    var rsBytes = 2 + rLength + 1 + 1 + sLength;
    var shortLength = rsBytes < $743664c4b8fd32ff$var$MAX_OCTET;
    var dst = $743664c4b8fd32ff$require$Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);
    var offset = 0;
    dst[offset++] = $743664c4b8fd32ff$var$ENCODED_TAG_SEQ;
    if (shortLength) // Bit 8 has value "0"
    // bits 7-1 give the length.
    dst[offset++] = rsBytes;
    else {
        // Bit 8 of first octet has value "1"
        // bits 7-1 give the number of additional length octets.
        dst[offset++] = $743664c4b8fd32ff$var$MAX_OCTET | 1;
        // length, base 256
        dst[offset++] = rsBytes & 0xff;
    }
    dst[offset++] = $743664c4b8fd32ff$var$ENCODED_TAG_INT;
    dst[offset++] = rLength;
    if (rPadding < 0) {
        dst[offset++] = 0;
        offset += signature.copy(dst, offset, 0, paramBytes);
    } else offset += signature.copy(dst, offset, rPadding, paramBytes);
    dst[offset++] = $743664c4b8fd32ff$var$ENCODED_TAG_INT;
    dst[offset++] = sLength;
    if (sPadding < 0) {
        dst[offset++] = 0;
        signature.copy(dst, offset, paramBytes);
    } else signature.copy(dst, offset, paramBytes + sPadding);
    return dst;
}
module.exports = {
    derToJose: $743664c4b8fd32ff$var$derToJose,
    joseToDer: $743664c4b8fd32ff$var$joseToDer
};

});
parcelRegister("gmRjM", function(module, exports) {
'use strict';
function $bea80f403d43bf62$var$getParamSize(keySize) {
    var result = (keySize / 8 | 0) + (keySize % 8 === 0 ? 0 : 1);
    return result;
}
var $bea80f403d43bf62$var$paramBytesForAlg = {
    ES256: $bea80f403d43bf62$var$getParamSize(256),
    ES384: $bea80f403d43bf62$var$getParamSize(384),
    ES512: $bea80f403d43bf62$var$getParamSize(521)
};
function $bea80f403d43bf62$var$getParamBytesForAlg(alg) {
    var paramBytes = $bea80f403d43bf62$var$paramBytesForAlg[alg];
    if (paramBytes) return paramBytes;
    throw new Error('Unknown algorithm "' + alg + '"');
}
module.exports = $bea80f403d43bf62$var$getParamBytesForAlg;

});



parcelRegister("q8HNf", function(module, exports) {
/*global module*/ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $04e92e85da0db810$require$Buffer = $bdjQ6.Buffer;
module.exports = function toString(obj) {
    if (typeof obj === 'string') return obj;
    if (typeof obj === 'number' || $04e92e85da0db810$require$Buffer.isBuffer(obj)) return obj.toString();
    return JSON.stringify(obj);
};

});


parcelRegister("cFKIK", function(module, exports) {
/*global module*/ 
var $838j1 = parcelRequire("838j1");
var $0261824ac7f3e46a$require$Buffer = $838j1.Buffer;

var $2lgVM = parcelRequire("2lgVM");

var $gUhMZ = parcelRequire("gUhMZ");

var $3DkjE = parcelRequire("3DkjE");

var $q8HNf = parcelRequire("q8HNf");

var $5LV4O = parcelRequire("5LV4O");
var $0261824ac7f3e46a$var$JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
function $0261824ac7f3e46a$var$isObject(thing) {
    return Object.prototype.toString.call(thing) === '[object Object]';
}
function $0261824ac7f3e46a$var$safeJsonParse(thing) {
    if ($0261824ac7f3e46a$var$isObject(thing)) return thing;
    try {
        return JSON.parse(thing);
    } catch (e) {
        return undefined;
    }
}
function $0261824ac7f3e46a$var$headerFromJWS(jwsSig) {
    var encodedHeader = jwsSig.split('.', 1)[0];
    return $0261824ac7f3e46a$var$safeJsonParse($0261824ac7f3e46a$require$Buffer.from(encodedHeader, 'base64').toString('binary'));
}
function $0261824ac7f3e46a$var$securedInputFromJWS(jwsSig) {
    return jwsSig.split('.', 2).join('.');
}
function $0261824ac7f3e46a$var$signatureFromJWS(jwsSig) {
    return jwsSig.split('.')[2];
}
function $0261824ac7f3e46a$var$payloadFromJWS(jwsSig, encoding) {
    encoding = encoding || 'utf8';
    var payload = jwsSig.split('.')[1];
    return $0261824ac7f3e46a$require$Buffer.from(payload, 'base64').toString(encoding);
}
function $0261824ac7f3e46a$var$isValidJws(string) {
    return $0261824ac7f3e46a$var$JWS_REGEX.test(string) && !!$0261824ac7f3e46a$var$headerFromJWS(string);
}
function $0261824ac7f3e46a$var$jwsVerify(jwsSig, algorithm, secretOrKey) {
    if (!algorithm) {
        var err = new Error("Missing algorithm parameter for jws.verify");
        err.code = "MISSING_ALGORITHM";
        throw err;
    }
    jwsSig = $q8HNf(jwsSig);
    var signature = $0261824ac7f3e46a$var$signatureFromJWS(jwsSig);
    var securedInput = $0261824ac7f3e46a$var$securedInputFromJWS(jwsSig);
    var algo = $gUhMZ(algorithm);
    return algo.verify(securedInput, signature, secretOrKey);
}
function $0261824ac7f3e46a$var$jwsDecode(jwsSig, opts) {
    opts = opts || {};
    jwsSig = $q8HNf(jwsSig);
    if (!$0261824ac7f3e46a$var$isValidJws(jwsSig)) return null;
    var header = $0261824ac7f3e46a$var$headerFromJWS(jwsSig);
    if (!header) return null;
    var payload = $0261824ac7f3e46a$var$payloadFromJWS(jwsSig);
    if (header.typ === 'JWT' || opts.json) payload = JSON.parse(payload, opts.encoding);
    return {
        header: header,
        payload: payload,
        signature: $0261824ac7f3e46a$var$signatureFromJWS(jwsSig)
    };
}
function $0261824ac7f3e46a$var$VerifyStream(opts) {
    opts = opts || {};
    var secretOrKey = opts.secret || opts.publicKey || opts.key;
    var secretStream = new $2lgVM(secretOrKey);
    this.readable = true;
    this.algorithm = opts.algorithm;
    this.encoding = opts.encoding;
    this.secret = this.publicKey = this.key = secretStream;
    this.signature = new $2lgVM(opts.signature);
    this.secret.once('close', (function() {
        if (!this.signature.writable && this.readable) this.verify();
    }).bind(this));
    this.signature.once('close', (function() {
        if (!this.secret.writable && this.readable) this.verify();
    }).bind(this));
}
$5LV4O.inherits($0261824ac7f3e46a$var$VerifyStream, $3DkjE);
$0261824ac7f3e46a$var$VerifyStream.prototype.verify = function verify() {
    try {
        var valid = $0261824ac7f3e46a$var$jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
        var obj = $0261824ac7f3e46a$var$jwsDecode(this.signature.buffer, this.encoding);
        this.emit('done', valid, obj);
        this.emit('data', valid);
        this.emit('end');
        this.readable = false;
        return valid;
    } catch (e) {
        this.readable = false;
        this.emit('error', e);
        this.emit('close');
    }
};
$0261824ac7f3e46a$var$VerifyStream.decode = $0261824ac7f3e46a$var$jwsDecode;
$0261824ac7f3e46a$var$VerifyStream.isValid = $0261824ac7f3e46a$var$isValidJws;
$0261824ac7f3e46a$var$VerifyStream.verify = $0261824ac7f3e46a$var$jwsVerify;
module.exports = $0261824ac7f3e46a$var$VerifyStream;

});



parcelRegister("7RGJO", function(module, exports) {

var $ifPfG = parcelRequire("ifPfG");

var $63AiW = parcelRequire("63AiW");

var $bB7TK = parcelRequire("bB7TK");

var $asDSe = parcelRequire("asDSe");

var $1shls = parcelRequire("1shls");

var $eOSWc = parcelRequire("eOSWc");

var $ihqFb = parcelRequire("ihqFb");
var $5b9ea2864b0b5d7a$var$PUB_KEY_ALGS = [
    'RS256',
    'RS384',
    'RS512',
    'ES256',
    'ES384',
    'ES512'
];
var $5b9ea2864b0b5d7a$var$RSA_KEY_ALGS = [
    'RS256',
    'RS384',
    'RS512'
];
var $5b9ea2864b0b5d7a$var$HS_ALGS = [
    'HS256',
    'HS384',
    'HS512'
];
if ($eOSWc) {
    $5b9ea2864b0b5d7a$var$PUB_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
    $5b9ea2864b0b5d7a$var$RSA_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
}
module.exports = function(jwtString, secretOrPublicKey, options, callback) {
    if (typeof options === 'function' && !callback) {
        callback = options;
        options = {};
    }
    if (!options) options = {};
    //clone this object since we are going to mutate it.
    options = Object.assign({}, options);
    var done;
    if (callback) done = callback;
    else done = function(err, data) {
        if (err) throw err;
        return data;
    };
    if (options.clockTimestamp && typeof options.clockTimestamp !== 'number') return done(new $ifPfG('clockTimestamp must be a number'));
    if (options.nonce !== undefined && (typeof options.nonce !== 'string' || options.nonce.trim() === '')) return done(new $ifPfG('nonce must be a non-empty string'));
    var clockTimestamp = options.clockTimestamp || Math.floor(Date.now() / 1000);
    if (!jwtString) return done(new $ifPfG('jwt must be provided'));
    if (typeof jwtString !== 'string') return done(new $ifPfG('jwt must be a string'));
    var parts = jwtString.split('.');
    if (parts.length !== 3) return done(new $ifPfG('jwt malformed'));
    var decodedToken;
    try {
        decodedToken = $asDSe(jwtString, {
            complete: true
        });
    } catch (err) {
        return done(err);
    }
    if (!decodedToken) return done(new $ifPfG('invalid token'));
    var header = decodedToken.header;
    var getSecret;
    if (typeof secretOrPublicKey === 'function') {
        if (!callback) return done(new $ifPfG('verify must be called asynchronous if secret or public key is provided as a callback'));
        getSecret = secretOrPublicKey;
    } else getSecret = function(header, secretCallback) {
        return secretCallback(null, secretOrPublicKey);
    };
    return getSecret(header, function(err, secretOrPublicKey) {
        if (err) return done(new $ifPfG('error in secret or public key callback: ' + err.message));
        var hasSignature = parts[2].trim() !== '';
        if (!hasSignature && secretOrPublicKey) return done(new $ifPfG('jwt signature is required'));
        if (hasSignature && !secretOrPublicKey) return done(new $ifPfG('secret or public key must be provided'));
        if (!hasSignature && !options.algorithms) options.algorithms = [
            'none'
        ];
        if (!options.algorithms) options.algorithms = ~secretOrPublicKey.toString().indexOf('BEGIN CERTIFICATE') || ~secretOrPublicKey.toString().indexOf('BEGIN PUBLIC KEY') ? $5b9ea2864b0b5d7a$var$PUB_KEY_ALGS : ~secretOrPublicKey.toString().indexOf('BEGIN RSA PUBLIC KEY') ? $5b9ea2864b0b5d7a$var$RSA_KEY_ALGS : $5b9ea2864b0b5d7a$var$HS_ALGS;
        if (!~options.algorithms.indexOf(decodedToken.header.alg)) return done(new $ifPfG('invalid algorithm'));
        var valid;
        try {
            valid = $ihqFb.verify(jwtString, decodedToken.header.alg, secretOrPublicKey);
        } catch (e) {
            return done(e);
        }
        if (!valid) return done(new $ifPfG('invalid signature'));
        var payload = decodedToken.payload;
        if (typeof payload.nbf !== 'undefined' && !options.ignoreNotBefore) {
            if (typeof payload.nbf !== 'number') return done(new $ifPfG('invalid nbf value'));
            if (payload.nbf > clockTimestamp + (options.clockTolerance || 0)) return done(new $63AiW('jwt not active', new Date(payload.nbf * 1000)));
        }
        if (typeof payload.exp !== 'undefined' && !options.ignoreExpiration) {
            if (typeof payload.exp !== 'number') return done(new $ifPfG('invalid exp value'));
            if (clockTimestamp >= payload.exp + (options.clockTolerance || 0)) return done(new $bB7TK('jwt expired', new Date(payload.exp * 1000)));
        }
        if (options.audience) {
            var audiences = Array.isArray(options.audience) ? options.audience : [
                options.audience
            ];
            var target = Array.isArray(payload.aud) ? payload.aud : [
                payload.aud
            ];
            var match = target.some(function(targetAudience) {
                return audiences.some(function(audience) {
                    return audience instanceof RegExp ? audience.test(targetAudience) : audience === targetAudience;
                });
            });
            if (!match) return done(new $ifPfG('jwt audience invalid. expected: ' + audiences.join(' or ')));
        }
        if (options.issuer) {
            var invalid_issuer = typeof options.issuer === 'string' && payload.iss !== options.issuer || Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1;
            if (invalid_issuer) return done(new $ifPfG('jwt issuer invalid. expected: ' + options.issuer));
        }
        if (options.subject) {
            if (payload.sub !== options.subject) return done(new $ifPfG('jwt subject invalid. expected: ' + options.subject));
        }
        if (options.jwtid) {
            if (payload.jti !== options.jwtid) return done(new $ifPfG('jwt jwtid invalid. expected: ' + options.jwtid));
        }
        if (options.nonce) {
            if (payload.nonce !== options.nonce) return done(new $ifPfG('jwt nonce invalid. expected: ' + options.nonce));
        }
        if (options.maxAge) {
            if (typeof payload.iat !== 'number') return done(new $ifPfG('iat required when maxAge is specified'));
            var maxAgeTimestamp = $1shls(options.maxAge, payload.iat);
            if (typeof maxAgeTimestamp === 'undefined') return done(new $ifPfG('"maxAge" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
            if (clockTimestamp >= maxAgeTimestamp + (options.clockTolerance || 0)) return done(new $bB7TK('maxAge exceeded', new Date(maxAgeTimestamp * 1000)));
        }
        if (options.complete === true) {
            var signature = decodedToken.signature;
            return done(null, {
                header: header,
                payload: payload,
                signature: signature
            });
        }
        return done(null, payload);
    });
};

});
parcelRegister("ifPfG", function(module, exports) {
var $036df532c7faedba$var$JsonWebTokenError = function(message, error) {
    Error.call(this, message);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    this.name = 'JsonWebTokenError';
    this.message = message;
    if (error) this.inner = error;
};
$036df532c7faedba$var$JsonWebTokenError.prototype = Object.create(Error.prototype);
$036df532c7faedba$var$JsonWebTokenError.prototype.constructor = $036df532c7faedba$var$JsonWebTokenError;
module.exports = $036df532c7faedba$var$JsonWebTokenError;

});

parcelRegister("63AiW", function(module, exports) {

var $ifPfG = parcelRequire("ifPfG");
var $468f2f34c3d3bd1b$var$NotBeforeError = function(message, date) {
    $ifPfG.call(this, message);
    this.name = 'NotBeforeError';
    this.date = date;
};
$468f2f34c3d3bd1b$var$NotBeforeError.prototype = Object.create($ifPfG.prototype);
$468f2f34c3d3bd1b$var$NotBeforeError.prototype.constructor = $468f2f34c3d3bd1b$var$NotBeforeError;
module.exports = $468f2f34c3d3bd1b$var$NotBeforeError;

});

parcelRegister("bB7TK", function(module, exports) {

var $ifPfG = parcelRequire("ifPfG");
var $871946d0e8877ebe$var$TokenExpiredError = function(message, expiredAt) {
    $ifPfG.call(this, message);
    this.name = 'TokenExpiredError';
    this.expiredAt = expiredAt;
};
$871946d0e8877ebe$var$TokenExpiredError.prototype = Object.create($ifPfG.prototype);
$871946d0e8877ebe$var$TokenExpiredError.prototype.constructor = $871946d0e8877ebe$var$TokenExpiredError;
module.exports = $871946d0e8877ebe$var$TokenExpiredError;

});

parcelRegister("1shls", function(module, exports) {

var $ji0pn = parcelRequire("ji0pn");
module.exports = function(time, iat) {
    var timestamp = iat || Math.floor(Date.now() / 1000);
    if (typeof time === 'string') {
        var milliseconds = $ji0pn(time);
        if (typeof milliseconds === 'undefined') return;
        return Math.floor(timestamp + milliseconds / 1000);
    } else if (typeof time === 'number') return timestamp + time;
    else return;
};

});
parcelRegister("ji0pn", function(module, exports) {
/**
 * Helpers.
 */ var $e0b003d12845a58e$var$s = 1000;
var $e0b003d12845a58e$var$m = $e0b003d12845a58e$var$s * 60;
var $e0b003d12845a58e$var$h = $e0b003d12845a58e$var$m * 60;
var $e0b003d12845a58e$var$d = $e0b003d12845a58e$var$h * 24;
var $e0b003d12845a58e$var$w = $e0b003d12845a58e$var$d * 7;
var $e0b003d12845a58e$var$y = $e0b003d12845a58e$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $e0b003d12845a58e$var$parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? $e0b003d12845a58e$var$fmtLong(val) : $e0b003d12845a58e$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $e0b003d12845a58e$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $e0b003d12845a58e$var$y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * $e0b003d12845a58e$var$w;
        case 'days':
        case 'day':
        case 'd':
            return n * $e0b003d12845a58e$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $e0b003d12845a58e$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $e0b003d12845a58e$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $e0b003d12845a58e$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $e0b003d12845a58e$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $e0b003d12845a58e$var$d) return Math.round(ms / $e0b003d12845a58e$var$d) + 'd';
    if (msAbs >= $e0b003d12845a58e$var$h) return Math.round(ms / $e0b003d12845a58e$var$h) + 'h';
    if (msAbs >= $e0b003d12845a58e$var$m) return Math.round(ms / $e0b003d12845a58e$var$m) + 'm';
    if (msAbs >= $e0b003d12845a58e$var$s) return Math.round(ms / $e0b003d12845a58e$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $e0b003d12845a58e$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $e0b003d12845a58e$var$d) return $e0b003d12845a58e$var$plural(ms, msAbs, $e0b003d12845a58e$var$d, 'day');
    if (msAbs >= $e0b003d12845a58e$var$h) return $e0b003d12845a58e$var$plural(ms, msAbs, $e0b003d12845a58e$var$h, 'hour');
    if (msAbs >= $e0b003d12845a58e$var$m) return $e0b003d12845a58e$var$plural(ms, msAbs, $e0b003d12845a58e$var$m, 'minute');
    if (msAbs >= $e0b003d12845a58e$var$s) return $e0b003d12845a58e$var$plural(ms, msAbs, $e0b003d12845a58e$var$s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $e0b003d12845a58e$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

});


parcelRegister("eOSWc", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");

var $dm5kc = parcelRequire("dm5kc");
module.exports = $dm5kc.satisfies($4ZL0H.version, '^6.12.0 || >=8.0.0');

});
parcelRegister("dm5kc", function(module, exports) {
exports = module.exports = SemVer;
var debug;
debug = function() {};
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';
var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
var MAX_SAFE_COMPONENT_LENGTH = 16;
// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';
// ## Main Version
// Three dot-separated numeric identifiers.
var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' + '(' + src[NUMERICIDENTIFIER] + ')\\.' + '(' + src[NUMERICIDENTIFIER] + ')';
var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' + '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' + '(' + src[NUMERICIDENTIFIERLOOSE] + ')';
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] + '|' + src[NONNUMERICIDENTIFIER] + ')';
var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] + '|' + src[NONNUMERICIDENTIFIER] + ')';
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] + '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';
var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] + '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] + '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] + src[PRERELEASE] + '?' + src[BUILD] + '?';
src[FULL] = '^' + FULLPLAIN + '$';
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] + src[PRERELEASELOOSE] + '?' + src[BUILD] + '?';
var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';
var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';
var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' + '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' + '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' + '(?:' + src[PRERELEASE] + ')?' + src[BUILD] + '?' + ')?)?';
var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' + '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' + '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' + '(?:' + src[PRERELEASELOOSE] + ')?' + src[BUILD] + '?' + ')?)?';
var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
var COERCE = R++;
src[COERCE] = "(?:^|[^\\d])(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + '})' + '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' + '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' + '(?:$|[^\\d])';
// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';
var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';
var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';
// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';
var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';
var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';
// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] + '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';
// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' + '\\s+-\\s+' + '(' + src[XRANGEPLAIN] + ')' + '\\s*$';
var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' + '\\s+-\\s+' + '(' + src[XRANGEPLAINLOOSE] + ')' + '\\s*$';
// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';
// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for(var i = 0; i < R; i++){
    debug(i, src[i]);
    if (!re[i]) re[i] = new RegExp(src[i]);
}
exports.parse = parse;
function parse(version, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) return version;
    if (typeof version !== 'string') return null;
    if (version.length > MAX_LENGTH) return null;
    var r = options.loose ? re[LOOSE] : re[FULL];
    if (!r.test(version)) return null;
    try {
        return new SemVer(version, options);
    } catch (er) {
        return null;
    }
}
exports.valid = valid;
function valid(version, options) {
    var v = parse(version, options);
    return v ? v.version : null;
}
exports.clean = clean;
function clean(version, options) {
    var s = parse(version.trim().replace(/^[=v]+/, ''), options);
    return s ? s.version : null;
}
exports.SemVer = SemVer;
function SemVer(version, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) {
        if (version.loose === options.loose) return version;
        else version = version.version;
    } else if (typeof version !== 'string') throw new TypeError('Invalid Version: ' + version);
    if (version.length > MAX_LENGTH) throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters');
    if (!(this instanceof SemVer)) return new SemVer(version, options);
    debug('SemVer', version, options);
    this.options = options;
    this.loose = !!options.loose;
    var m = version.trim().match(options.loose ? re[LOOSE] : re[FULL]);
    if (!m) throw new TypeError('Invalid Version: ' + version);
    this.raw = version;
    // these are actually numbers
    this.major = +m[1];
    this.minor = +m[2];
    this.patch = +m[3];
    if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
    // numberify any prerelease numeric ids
    if (!m[4]) this.prerelease = [];
    else this.prerelease = m[4].split('.').map(function(id) {
        if (/^[0-9]+$/.test(id)) {
            var num = +id;
            if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
        }
        return id;
    });
    this.build = m[5] ? m[5].split('.') : [];
    this.format();
}
SemVer.prototype.format = function() {
    this.version = this.major + '.' + this.minor + '.' + this.patch;
    if (this.prerelease.length) this.version += '-' + this.prerelease.join('.');
    return this.version;
};
SemVer.prototype.toString = function() {
    return this.version;
};
SemVer.prototype.compare = function(other) {
    debug('SemVer.compare', this.version, this.options, other);
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return this.compareMain(other) || this.comparePre(other);
};
SemVer.prototype.compareMain = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
};
SemVer.prototype.comparePre = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    // NOT having a prerelease is > having one
    if (this.prerelease.length && !other.prerelease.length) return -1;
    else if (!this.prerelease.length && other.prerelease.length) return 1;
    else if (!this.prerelease.length && !other.prerelease.length) return 0;
    var i = 0;
    do {
        var a = this.prerelease[i];
        var b = other.prerelease[i];
        debug('prerelease compare', i, a, b);
        if (a === undefined && b === undefined) return 0;
        else if (b === undefined) return 1;
        else if (a === undefined) return -1;
        else if (a === b) continue;
        else return compareIdentifiers(a, b);
    }while (++i);
};
// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
    switch(release){
        case 'premajor':
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor = 0;
            this.major++;
            this.inc('pre', identifier);
            break;
        case 'preminor':
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor++;
            this.inc('pre', identifier);
            break;
        case 'prepatch':
            // If this is already a prerelease, it will bump to the next version
            // drop any prereleases that might already exist, since they are not
            // relevant at this point.
            this.prerelease.length = 0;
            this.inc('patch', identifier);
            this.inc('pre', identifier);
            break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case 'prerelease':
            if (this.prerelease.length === 0) this.inc('patch', identifier);
            this.inc('pre', identifier);
            break;
        case 'major':
            // If this is a pre-major version, bump up to the same major version.
            // Otherwise increment major.
            // 1.0.0-5 bumps to 1.0.0
            // 1.1.0 bumps to 2.0.0
            if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
            this.minor = 0;
            this.patch = 0;
            this.prerelease = [];
            break;
        case 'minor':
            // If this is a pre-minor version, bump up to the same minor version.
            // Otherwise increment minor.
            // 1.2.0-5 bumps to 1.2.0
            // 1.2.1 bumps to 1.3.0
            if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
            this.patch = 0;
            this.prerelease = [];
            break;
        case 'patch':
            // If this is not a pre-release version, it will increment the patch.
            // If it is a pre-release it will bump up to the same patch version.
            // 1.2.0-5 patches to 1.2.0
            // 1.2.0 patches to 1.2.1
            if (this.prerelease.length === 0) this.patch++;
            this.prerelease = [];
            break;
        // This probably shouldn't be used publicly.
        // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
        case 'pre':
            if (this.prerelease.length === 0) this.prerelease = [
                0
            ];
            else {
                var i = this.prerelease.length;
                while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                    this.prerelease[i]++;
                    i = -2;
                }
                if (i === -1) // didn't increment anything
                this.prerelease.push(0);
            }
            if (identifier) {
                // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                if (this.prerelease[0] === identifier) {
                    if (isNaN(this.prerelease[1])) this.prerelease = [
                        identifier,
                        0
                    ];
                } else this.prerelease = [
                    identifier,
                    0
                ];
            }
            break;
        default:
            throw new Error('invalid increment argument: ' + release);
    }
    this.format();
    this.raw = this.version;
    return this;
};
exports.inc = inc;
function inc(version, release, loose, identifier) {
    if (typeof loose === 'string') {
        identifier = loose;
        loose = undefined;
    }
    try {
        return new SemVer(version, loose).inc(release, identifier).version;
    } catch (er) {
        return null;
    }
}
exports.diff = diff;
function diff(version1, version2) {
    if (eq(version1, version2)) return null;
    else {
        var v1 = parse(version1);
        var v2 = parse(version2);
        var prefix = '';
        if (v1.prerelease.length || v2.prerelease.length) {
            prefix = 'pre';
            var defaultResult = 'prerelease';
        }
        for(var key in v1)if (key === 'major' || key === 'minor' || key === 'patch') {
            if (v1[key] !== v2[key]) return prefix + key;
        }
        return defaultResult // may be undefined
        ;
    }
}
exports.compareIdentifiers = compareIdentifiers;
var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
    var anum = numeric.test(a);
    var bnum = numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
}
exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
    return compareIdentifiers(b, a);
}
exports.major = major;
function major(a, loose) {
    return new SemVer(a, loose).major;
}
exports.minor = minor;
function minor(a, loose) {
    return new SemVer(a, loose).minor;
}
exports.patch = patch;
function patch(a, loose) {
    return new SemVer(a, loose).patch;
}
exports.compare = compare;
function compare(a, b, loose) {
    return new SemVer(a, loose).compare(new SemVer(b, loose));
}
exports.compareLoose = compareLoose;
function compareLoose(a, b) {
    return compare(a, b, true);
}
exports.rcompare = rcompare;
function rcompare(a, b, loose) {
    return compare(b, a, loose);
}
exports.sort = sort;
function sort(list, loose) {
    return list.sort(function(a, b) {
        return exports.compare(a, b, loose);
    });
}
exports.rsort = rsort;
function rsort(list, loose) {
    return list.sort(function(a, b) {
        return exports.rcompare(a, b, loose);
    });
}
exports.gt = gt;
function gt(a, b, loose) {
    return compare(a, b, loose) > 0;
}
exports.lt = lt;
function lt(a, b, loose) {
    return compare(a, b, loose) < 0;
}
exports.eq = eq;
function eq(a, b, loose) {
    return compare(a, b, loose) === 0;
}
exports.neq = neq;
function neq(a, b, loose) {
    return compare(a, b, loose) !== 0;
}
exports.gte = gte;
function gte(a, b, loose) {
    return compare(a, b, loose) >= 0;
}
exports.lte = lte;
function lte(a, b, loose) {
    return compare(a, b, loose) <= 0;
}
exports.cmp = cmp;
function cmp(a, op, b, loose) {
    switch(op){
        case '===':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a === b;
        case '!==':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a !== b;
        case '':
        case '=':
        case '==':
            return eq(a, b, loose);
        case '!=':
            return neq(a, b, loose);
        case '>':
            return gt(a, b, loose);
        case '>=':
            return gte(a, b, loose);
        case '<':
            return lt(a, b, loose);
        case '<=':
            return lte(a, b, loose);
        default:
            throw new TypeError('Invalid operator: ' + op);
    }
}
exports.Comparator = Comparator;
function Comparator(comp, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (comp instanceof Comparator) {
        if (comp.loose === !!options.loose) return comp;
        else comp = comp.value;
    }
    if (!(this instanceof Comparator)) return new Comparator(comp, options);
    debug('comparator', comp, options);
    this.options = options;
    this.loose = !!options.loose;
    this.parse(comp);
    if (this.semver === ANY) this.value = '';
    else this.value = this.operator + this.semver.version;
    debug('comp', this);
}
var ANY = {};
Comparator.prototype.parse = function(comp) {
    var r = this.options.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
    var m = comp.match(r);
    if (!m) throw new TypeError('Invalid comparator: ' + comp);
    this.operator = m[1];
    if (this.operator === '=') this.operator = '';
    // if it literally is just '>' or '' then allow anything.
    if (!m[2]) this.semver = ANY;
    else this.semver = new SemVer(m[2], this.options.loose);
};
Comparator.prototype.toString = function() {
    return this.value;
};
Comparator.prototype.test = function(version) {
    debug('Comparator.test', version, this.options.loose);
    if (this.semver === ANY) return true;
    if (typeof version === 'string') version = new SemVer(version, this.options);
    return cmp(version, this.operator, this.semver, this.options);
};
Comparator.prototype.intersects = function(comp, options) {
    if (!(comp instanceof Comparator)) throw new TypeError('a Comparator is required');
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    var rangeTmp;
    if (this.operator === '') {
        rangeTmp = new Range(comp.value, options);
        return satisfies(this.value, rangeTmp, options);
    } else if (comp.operator === '') {
        rangeTmp = new Range(this.value, options);
        return satisfies(comp.semver, rangeTmp, options);
    }
    var sameDirectionIncreasing = (this.operator === '>=' || this.operator === '>') && (comp.operator === '>=' || comp.operator === '>');
    var sameDirectionDecreasing = (this.operator === '<=' || this.operator === '<') && (comp.operator === '<=' || comp.operator === '<');
    var sameSemVer = this.semver.version === comp.semver.version;
    var differentDirectionsInclusive = (this.operator === '>=' || this.operator === '<=') && (comp.operator === '>=' || comp.operator === '<=');
    var oppositeDirectionsLessThan = cmp(this.semver, '<', comp.semver, options) && (this.operator === '>=' || this.operator === '>') && (comp.operator === '<=' || comp.operator === '<');
    var oppositeDirectionsGreaterThan = cmp(this.semver, '>', comp.semver, options) && (this.operator === '<=' || this.operator === '<') && (comp.operator === '>=' || comp.operator === '>');
    return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
};
exports.Range = Range;
function Range(range, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (range instanceof Range) {
        if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
        else return new Range(range.raw, options);
    }
    if (range instanceof Comparator) return new Range(range.value, options);
    if (!(this instanceof Range)) return new Range(range, options);
    this.options = options;
    this.loose = !!options.loose;
    this.includePrerelease = !!options.includePrerelease;
    // First, split based on boolean or ||
    this.raw = range;
    this.set = range.split(/\s*\|\|\s*/).map(function(range) {
        return this.parseRange(range.trim());
    }, this).filter(function(c) {
        // throw out any that are not relevant for whatever reason
        return c.length;
    });
    if (!this.set.length) throw new TypeError('Invalid SemVer Range: ' + range);
    this.format();
}
Range.prototype.format = function() {
    this.range = this.set.map(function(comps) {
        return comps.join(' ').trim();
    }).join('||').trim();
    return this.range;
};
Range.prototype.toString = function() {
    return this.range;
};
Range.prototype.parseRange = function(range) {
    var loose = this.options.loose;
    range = range.trim();
    // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
    var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
    range = range.replace(hr, hyphenReplace);
    debug('hyphen replace', range);
    // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
    range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
    debug('comparator trim', range, re[COMPARATORTRIM]);
    // `~ 1.2.3` => `~1.2.3`
    range = range.replace(re[TILDETRIM], tildeTrimReplace);
    // `^ 1.2.3` => `^1.2.3`
    range = range.replace(re[CARETTRIM], caretTrimReplace);
    // normalize spaces
    range = range.split(/\s+/).join(' ');
    // At this point, the range is completely trimmed and
    // ready to be split into comparators.
    var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
    var set = range.split(' ').map(function(comp) {
        return parseComparator(comp, this.options);
    }, this).join(' ').split(/\s+/);
    if (this.options.loose) // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
        return !!comp.match(compRe);
    });
    set = set.map(function(comp) {
        return new Comparator(comp, this.options);
    }, this);
    return set;
};
Range.prototype.intersects = function(range, options) {
    if (!(range instanceof Range)) throw new TypeError('a Range is required');
    return this.set.some(function(thisComparators) {
        return thisComparators.every(function(thisComparator) {
            return range.set.some(function(rangeComparators) {
                return rangeComparators.every(function(rangeComparator) {
                    return thisComparator.intersects(rangeComparator, options);
                });
            });
        });
    });
};
// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, options) {
    return new Range(range, options).set.map(function(comp) {
        return comp.map(function(c) {
            return c.value;
        }).join(' ').trim().split(' ');
    });
}
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, options) {
    debug('comp', comp, options);
    comp = replaceCarets(comp, options);
    debug('caret', comp);
    comp = replaceTildes(comp, options);
    debug('tildes', comp);
    comp = replaceXRanges(comp, options);
    debug('xrange', comp);
    comp = replaceStars(comp, options);
    debug('stars', comp);
    return comp;
}
function isX(id) {
    return !id || id.toLowerCase() === 'x' || id === '*';
}
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceTilde(comp, options);
    }).join(' ');
}
function replaceTilde(comp, options) {
    var r = options.loose ? re[TILDELOOSE] : re[TILDE];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug('tilde', comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
        else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
        else if (pr) {
            debug('replaceTilde pr', pr);
            ret = '>=' + M + '.' + m + '.' + p + '-' + pr + ' <' + M + '.' + (+m + 1) + '.0';
        } else // ~1.2.3 == >=1.2.3 <1.3.0
        ret = '>=' + M + '.' + m + '.' + p + ' <' + M + '.' + (+m + 1) + '.0';
        debug('tilde return', ret);
        return ret;
    });
}
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceCaret(comp, options);
    }).join(' ');
}
function replaceCaret(comp, options) {
    debug('caret', comp, options);
    var r = options.loose ? re[CARETLOOSE] : re[CARET];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug('caret', comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
        else if (isX(p)) {
            if (M === '0') ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
            else ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
        } else if (pr) {
            debug('replaceCaret pr', pr);
            if (M === '0') {
                if (m === '0') ret = '>=' + M + '.' + m + '.' + p + '-' + pr + ' <' + M + '.' + m + '.' + (+p + 1);
                else ret = '>=' + M + '.' + m + '.' + p + '-' + pr + ' <' + M + '.' + (+m + 1) + '.0';
            } else ret = '>=' + M + '.' + m + '.' + p + '-' + pr + ' <' + (+M + 1) + '.0.0';
        } else {
            debug('no pr');
            if (M === '0') {
                if (m === '0') ret = '>=' + M + '.' + m + '.' + p + ' <' + M + '.' + m + '.' + (+p + 1);
                else ret = '>=' + M + '.' + m + '.' + p + ' <' + M + '.' + (+m + 1) + '.0';
            } else ret = '>=' + M + '.' + m + '.' + p + ' <' + (+M + 1) + '.0.0';
        }
        debug('caret return', ret);
        return ret;
    });
}
function replaceXRanges(comp, options) {
    debug('replaceXRanges', comp, options);
    return comp.split(/\s+/).map(function(comp) {
        return replaceXRange(comp, options);
    }).join(' ');
}
function replaceXRange(comp, options) {
    comp = comp.trim();
    var r = options.loose ? re[XRANGELOOSE] : re[XRANGE];
    return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
        debug('xRange', comp, ret, gtlt, M, m, p, pr);
        var xM = isX(M);
        var xm = xM || isX(m);
        var xp = xm || isX(p);
        var anyX = xp;
        if (gtlt === '=' && anyX) gtlt = '';
        if (xM) {
            if (gtlt === '>' || gtlt === '<') // nothing is allowed
            ret = '<0.0.0';
            else // nothing is forbidden
            ret = '*';
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === '>') {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                // >1.2.3 => >= 1.2.4
                gtlt = '>=';
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === '<=') {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = '<';
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            ret = gtlt + M + '.' + m + '.' + p;
        } else if (xm) ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
        else if (xp) ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
        debug('xRange return', ret);
        return ret;
    });
}
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, options) {
    debug('replaceStars', comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace(re[STAR], '');
}
// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) {
    if (isX(fM)) from = '';
    else if (isX(fm)) from = '>=' + fM + '.0.0';
    else if (isX(fp)) from = '>=' + fM + '.' + fm + '.0';
    else from = '>=' + from;
    if (isX(tM)) to = '';
    else if (isX(tm)) to = '<' + (+tM + 1) + '.0.0';
    else if (isX(tp)) to = '<' + tM + '.' + (+tm + 1) + '.0';
    else if (tpr) to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
    else to = '<=' + to;
    return (from + ' ' + to).trim();
}
// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
    if (!version) return false;
    if (typeof version === 'string') version = new SemVer(version, this.options);
    for(var i = 0; i < this.set.length; i++){
        if (testSet(this.set[i], version, this.options)) return true;
    }
    return false;
};
function testSet(set, version, options) {
    for(var i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(i = 0; i < set.length; i++){
            debug(set[i].semver);
            if (set[i].semver === ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                var allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
}
exports.satisfies = satisfies;
function satisfies(version, range, options) {
    try {
        range = new Range(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
}
exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, options) {
    var max = null;
    var maxSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new SemVer(max, options);
            }
        }
    });
    return max;
}
exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, options) {
    var min = null;
    var minSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new SemVer(min, options);
            }
        }
    });
    return min;
}
exports.minVersion = minVersion;
function minVersion(range, loose) {
    range = new Range(range, loose);
    var minver = new SemVer('0.0.0');
    if (range.test(minver)) return minver;
    minver = new SemVer('0.0.0-0');
    if (range.test(minver)) return minver;
    minver = null;
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        comparators.forEach(function(comparator) {
            // Clone to avoid manipulating the comparator's semver object.
            var compver = new SemVer(comparator.semver.version);
            switch(comparator.operator){
                case '>':
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case '':
                case '>=':
                    if (!minver || gt(minver, compver)) minver = compver;
                    break;
                case '<':
                case '<=':
                    break;
                /* istanbul ignore next */ default:
                    throw new Error('Unexpected operation: ' + comparator.operator);
            }
        });
    }
    if (minver && range.test(minver)) return minver;
    return null;
}
exports.validRange = validRange;
function validRange(range, options) {
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new Range(range, options).range || '*';
    } catch (er) {
        return null;
    }
}
// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, options) {
    return outside(version, range, '<', options);
}
// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, options) {
    return outside(version, range, '>', options);
}
exports.outside = outside;
function outside(version, range, hilo, options) {
    version = new SemVer(version, options);
    range = new Range(range, options);
    var gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case '>':
            gtfn = gt;
            ltefn = lte;
            ltfn = lt;
            comp = '>';
            ecomp = '>=';
            break;
        case '<':
            gtfn = lt;
            ltefn = gte;
            ltfn = gt;
            comp = '<';
            ecomp = '<=';
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisifes the range it is not outside
    if (satisfies(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        var high = null;
        var low = null;
        comparators.forEach(function(comparator) {
            if (comparator.semver === ANY) comparator = new Comparator('>=0.0.0');
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
}
exports.prerelease = prerelease;
function prerelease(version, options) {
    var parsed = parse(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
}
exports.intersects = intersects;
function intersects(r1, r2, options) {
    r1 = new Range(r1, options);
    r2 = new Range(r2, options);
    return r1.intersects(r2);
}
exports.coerce = coerce;
function coerce(version) {
    if (version instanceof SemVer) return version;
    if (typeof version !== 'string') return null;
    var match = version.match(re[COERCE]);
    if (match == null) return null;
    return parse(match[1] + '.' + (match[2] || '0') + '.' + (match[3] || '0'));
}

});



parcelRegister("6Grea", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $4ddbc922f182ce54$require$Buffer = $bdjQ6.Buffer;

var $1shls = parcelRequire("1shls");

var $eOSWc = parcelRequire("eOSWc");

var $ihqFb = parcelRequire("ihqFb");

var $5EnhC = parcelRequire("5EnhC");

var $fPqc4 = parcelRequire("fPqc4");

var $3hU0A = parcelRequire("3hU0A");

var $iXTVJ = parcelRequire("iXTVJ");

var $jt7gQ = parcelRequire("jt7gQ");

var $gSPry = parcelRequire("gSPry");

var $kOJaT = parcelRequire("kOJaT");
var $4ddbc922f182ce54$var$SUPPORTED_ALGS = [
    'RS256',
    'RS384',
    'RS512',
    'ES256',
    'ES384',
    'ES512',
    'HS256',
    'HS384',
    'HS512',
    'none'
];
if ($eOSWc) $4ddbc922f182ce54$var$SUPPORTED_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
var $4ddbc922f182ce54$var$sign_options_schema = {
    expiresIn: {
        isValid: function(value) {
            return $3hU0A(value) || $gSPry(value) && value;
        },
        message: '"expiresIn" should be a number of seconds or string representing a timespan'
    },
    notBefore: {
        isValid: function(value) {
            return $3hU0A(value) || $gSPry(value) && value;
        },
        message: '"notBefore" should be a number of seconds or string representing a timespan'
    },
    audience: {
        isValid: function(value) {
            return $gSPry(value) || Array.isArray(value);
        },
        message: '"audience" must be a string or array'
    },
    algorithm: {
        isValid: $5EnhC.bind(null, $4ddbc922f182ce54$var$SUPPORTED_ALGS),
        message: '"algorithm" must be a valid string enum value'
    },
    header: {
        isValid: $jt7gQ,
        message: '"header" must be an object'
    },
    encoding: {
        isValid: $gSPry,
        message: '"encoding" must be a string'
    },
    issuer: {
        isValid: $gSPry,
        message: '"issuer" must be a string'
    },
    subject: {
        isValid: $gSPry,
        message: '"subject" must be a string'
    },
    jwtid: {
        isValid: $gSPry,
        message: '"jwtid" must be a string'
    },
    noTimestamp: {
        isValid: $fPqc4,
        message: '"noTimestamp" must be a boolean'
    },
    keyid: {
        isValid: $gSPry,
        message: '"keyid" must be a string'
    },
    mutatePayload: {
        isValid: $fPqc4,
        message: '"mutatePayload" must be a boolean'
    }
};
var $4ddbc922f182ce54$var$registered_claims_schema = {
    iat: {
        isValid: $iXTVJ,
        message: '"iat" should be a number of seconds'
    },
    exp: {
        isValid: $iXTVJ,
        message: '"exp" should be a number of seconds'
    },
    nbf: {
        isValid: $iXTVJ,
        message: '"nbf" should be a number of seconds'
    }
};
function $4ddbc922f182ce54$var$validate(schema, allowUnknown, object, parameterName) {
    if (!$jt7gQ(object)) throw new Error('Expected "' + parameterName + '" to be a plain object.');
    Object.keys(object).forEach(function(key) {
        var validator = schema[key];
        if (!validator) {
            if (!allowUnknown) throw new Error('"' + key + '" is not allowed in "' + parameterName + '"');
            return;
        }
        if (!validator.isValid(object[key])) throw new Error(validator.message);
    });
}
function $4ddbc922f182ce54$var$validateOptions(options) {
    return $4ddbc922f182ce54$var$validate($4ddbc922f182ce54$var$sign_options_schema, false, options, 'options');
}
function $4ddbc922f182ce54$var$validatePayload(payload) {
    return $4ddbc922f182ce54$var$validate($4ddbc922f182ce54$var$registered_claims_schema, true, payload, 'payload');
}
var $4ddbc922f182ce54$var$options_to_payload = {
    'audience': 'aud',
    'issuer': 'iss',
    'subject': 'sub',
    'jwtid': 'jti'
};
var $4ddbc922f182ce54$var$options_for_objects = [
    'expiresIn',
    'notBefore',
    'noTimestamp',
    'audience',
    'issuer',
    'subject',
    'jwtid'
];
module.exports = function(payload, secretOrPrivateKey, options, callback) {
    if (typeof options === 'function') {
        callback = options;
        options = {};
    } else options = options || {};
    var isObjectPayload = typeof payload === 'object' && !$4ddbc922f182ce54$require$Buffer.isBuffer(payload);
    var header = Object.assign({
        alg: options.algorithm || 'HS256',
        typ: isObjectPayload ? 'JWT' : undefined,
        kid: options.keyid
    }, options.header);
    function failure(err) {
        if (callback) return callback(err);
        throw err;
    }
    if (!secretOrPrivateKey && options.algorithm !== 'none') return failure(new Error('secretOrPrivateKey must have a value'));
    if (typeof payload === 'undefined') return failure(new Error('payload is required'));
    else if (isObjectPayload) {
        try {
            $4ddbc922f182ce54$var$validatePayload(payload);
        } catch (error) {
            return failure(error);
        }
        if (!options.mutatePayload) payload = Object.assign({}, payload);
    } else {
        var invalid_options = $4ddbc922f182ce54$var$options_for_objects.filter(function(opt) {
            return typeof options[opt] !== 'undefined';
        });
        if (invalid_options.length > 0) return failure(new Error('invalid ' + invalid_options.join(',') + ' option for ' + typeof payload + ' payload'));
    }
    if (typeof payload.exp !== 'undefined' && typeof options.expiresIn !== 'undefined') return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
    if (typeof payload.nbf !== 'undefined' && typeof options.notBefore !== 'undefined') return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
    try {
        $4ddbc922f182ce54$var$validateOptions(options);
    } catch (error) {
        return failure(error);
    }
    var timestamp = payload.iat || Math.floor(Date.now() / 1000);
    if (options.noTimestamp) delete payload.iat;
    else if (isObjectPayload) payload.iat = timestamp;
    if (typeof options.notBefore !== 'undefined') {
        try {
            payload.nbf = $1shls(options.notBefore, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.nbf === 'undefined') return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    if (typeof options.expiresIn !== 'undefined' && typeof payload === 'object') {
        try {
            payload.exp = $1shls(options.expiresIn, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.exp === 'undefined') return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    Object.keys($4ddbc922f182ce54$var$options_to_payload).forEach(function(key) {
        var claim = $4ddbc922f182ce54$var$options_to_payload[key];
        if (typeof options[key] !== 'undefined') {
            if (typeof payload[claim] !== 'undefined') return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
            payload[claim] = options[key];
        }
    });
    var encoding = options.encoding || 'utf8';
    if (typeof callback === 'function') {
        callback = callback && $kOJaT(callback);
        $ihqFb.createSign({
            header: header,
            privateKey: secretOrPrivateKey,
            payload: payload,
            encoding: encoding
        }).once('error', callback).once('done', function(signature) {
            callback(null, signature);
        });
    } else return $ihqFb.sign({
        header: header,
        payload: payload,
        secret: secretOrPrivateKey,
        encoding: encoding
    });
};

});
parcelRegister("5EnhC", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $41d2bfbf13644492$var$INFINITY = 1 / 0, $41d2bfbf13644492$var$MAX_SAFE_INTEGER = 9007199254740991, $41d2bfbf13644492$var$MAX_INTEGER = 1.7976931348623157e+308, $41d2bfbf13644492$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $41d2bfbf13644492$var$argsTag = '[object Arguments]', $41d2bfbf13644492$var$funcTag = '[object Function]', $41d2bfbf13644492$var$genTag = '[object GeneratorFunction]', $41d2bfbf13644492$var$stringTag = '[object String]', $41d2bfbf13644492$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $41d2bfbf13644492$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $41d2bfbf13644492$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $41d2bfbf13644492$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $41d2bfbf13644492$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $41d2bfbf13644492$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Built-in method references without a dependency on `root`. */ var $41d2bfbf13644492$var$freeParseInt = parseInt;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $41d2bfbf13644492$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $41d2bfbf13644492$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $41d2bfbf13644492$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $41d2bfbf13644492$var$baseFindIndex(array, $41d2bfbf13644492$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $41d2bfbf13644492$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $41d2bfbf13644492$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $41d2bfbf13644492$var$baseValues(object, props) {
    return $41d2bfbf13644492$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $41d2bfbf13644492$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $41d2bfbf13644492$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $41d2bfbf13644492$var$hasOwnProperty = $41d2bfbf13644492$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $41d2bfbf13644492$var$objectToString = $41d2bfbf13644492$var$objectProto.toString;
/** Built-in value references. */ var $41d2bfbf13644492$var$propertyIsEnumerable = $41d2bfbf13644492$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $41d2bfbf13644492$var$nativeKeys = $41d2bfbf13644492$var$overArg(Object.keys, Object), $41d2bfbf13644492$var$nativeMax = Math.max;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $41d2bfbf13644492$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $41d2bfbf13644492$var$isArray(value) || $41d2bfbf13644492$var$isArguments(value) ? $41d2bfbf13644492$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $41d2bfbf13644492$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || $41d2bfbf13644492$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $41d2bfbf13644492$var$baseKeys(object) {
    if (!$41d2bfbf13644492$var$isPrototype(object)) return $41d2bfbf13644492$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($41d2bfbf13644492$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $41d2bfbf13644492$var$isIndex(value, length) {
    length = length == null ? $41d2bfbf13644492$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || $41d2bfbf13644492$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $41d2bfbf13644492$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $41d2bfbf13644492$var$objectProto;
    return value === proto;
}
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $41d2bfbf13644492$var$includes(collection, value, fromIndex, guard) {
    collection = $41d2bfbf13644492$var$isArrayLike(collection) ? collection : $41d2bfbf13644492$var$values(collection);
    fromIndex = fromIndex && !guard ? $41d2bfbf13644492$var$toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $41d2bfbf13644492$var$nativeMax(length + fromIndex, 0);
    return $41d2bfbf13644492$var$isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $41d2bfbf13644492$var$baseIndexOf(collection, value, fromIndex) > -1;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $41d2bfbf13644492$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $41d2bfbf13644492$var$isArrayLikeObject(value) && $41d2bfbf13644492$var$hasOwnProperty.call(value, 'callee') && (!$41d2bfbf13644492$var$propertyIsEnumerable.call(value, 'callee') || $41d2bfbf13644492$var$objectToString.call(value) == $41d2bfbf13644492$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $41d2bfbf13644492$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $41d2bfbf13644492$var$isArrayLike(value) {
    return value != null && $41d2bfbf13644492$var$isLength(value.length) && !$41d2bfbf13644492$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $41d2bfbf13644492$var$isArrayLikeObject(value) {
    return $41d2bfbf13644492$var$isObjectLike(value) && $41d2bfbf13644492$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $41d2bfbf13644492$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $41d2bfbf13644492$var$isObject(value) ? $41d2bfbf13644492$var$objectToString.call(value) : '';
    return tag == $41d2bfbf13644492$var$funcTag || tag == $41d2bfbf13644492$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $41d2bfbf13644492$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $41d2bfbf13644492$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $41d2bfbf13644492$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $41d2bfbf13644492$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $41d2bfbf13644492$var$isString(value) {
    return typeof value == 'string' || !$41d2bfbf13644492$var$isArray(value) && $41d2bfbf13644492$var$isObjectLike(value) && $41d2bfbf13644492$var$objectToString.call(value) == $41d2bfbf13644492$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $41d2bfbf13644492$var$isSymbol(value) {
    return typeof value == 'symbol' || $41d2bfbf13644492$var$isObjectLike(value) && $41d2bfbf13644492$var$objectToString.call(value) == $41d2bfbf13644492$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $41d2bfbf13644492$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $41d2bfbf13644492$var$toNumber(value);
    if (value === $41d2bfbf13644492$var$INFINITY || value === -$41d2bfbf13644492$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $41d2bfbf13644492$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $41d2bfbf13644492$var$toInteger(value) {
    var result = $41d2bfbf13644492$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $41d2bfbf13644492$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($41d2bfbf13644492$var$isSymbol(value)) return $41d2bfbf13644492$var$NAN;
    if ($41d2bfbf13644492$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $41d2bfbf13644492$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($41d2bfbf13644492$var$reTrim, '');
    var isBinary = $41d2bfbf13644492$var$reIsBinary.test(value);
    return isBinary || $41d2bfbf13644492$var$reIsOctal.test(value) ? $41d2bfbf13644492$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $41d2bfbf13644492$var$reIsBadHex.test(value) ? $41d2bfbf13644492$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $41d2bfbf13644492$var$keys(object) {
    return $41d2bfbf13644492$var$isArrayLike(object) ? $41d2bfbf13644492$var$arrayLikeKeys(object) : $41d2bfbf13644492$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $41d2bfbf13644492$var$values(object) {
    return object ? $41d2bfbf13644492$var$baseValues(object, $41d2bfbf13644492$var$keys(object)) : [];
}
module.exports = $41d2bfbf13644492$var$includes;

});

parcelRegister("fPqc4", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $b85feff69e3fdd99$var$boolTag = '[object Boolean]';
/** Used for built-in method references. */ var $b85feff69e3fdd99$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b85feff69e3fdd99$var$objectToString = $b85feff69e3fdd99$var$objectProto.toString;
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $b85feff69e3fdd99$var$isBoolean(value) {
    return value === true || value === false || $b85feff69e3fdd99$var$isObjectLike(value) && $b85feff69e3fdd99$var$objectToString.call(value) == $b85feff69e3fdd99$var$boolTag;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b85feff69e3fdd99$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
module.exports = $b85feff69e3fdd99$var$isBoolean;

});

parcelRegister("3hU0A", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $264e67be8f3841d1$var$INFINITY = 1 / 0, $264e67be8f3841d1$var$MAX_INTEGER = 1.7976931348623157e+308, $264e67be8f3841d1$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $264e67be8f3841d1$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $264e67be8f3841d1$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $264e67be8f3841d1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $264e67be8f3841d1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $264e67be8f3841d1$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $264e67be8f3841d1$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $264e67be8f3841d1$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $264e67be8f3841d1$var$objectToString = $264e67be8f3841d1$var$objectProto.toString;
/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */ function $264e67be8f3841d1$var$isInteger(value) {
    return typeof value == 'number' && value == $264e67be8f3841d1$var$toInteger(value);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $264e67be8f3841d1$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $264e67be8f3841d1$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $264e67be8f3841d1$var$isSymbol(value) {
    return typeof value == 'symbol' || $264e67be8f3841d1$var$isObjectLike(value) && $264e67be8f3841d1$var$objectToString.call(value) == $264e67be8f3841d1$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $264e67be8f3841d1$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $264e67be8f3841d1$var$toNumber(value);
    if (value === $264e67be8f3841d1$var$INFINITY || value === -$264e67be8f3841d1$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $264e67be8f3841d1$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $264e67be8f3841d1$var$toInteger(value) {
    var result = $264e67be8f3841d1$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $264e67be8f3841d1$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($264e67be8f3841d1$var$isSymbol(value)) return $264e67be8f3841d1$var$NAN;
    if ($264e67be8f3841d1$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $264e67be8f3841d1$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($264e67be8f3841d1$var$reTrim, '');
    var isBinary = $264e67be8f3841d1$var$reIsBinary.test(value);
    return isBinary || $264e67be8f3841d1$var$reIsOctal.test(value) ? $264e67be8f3841d1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $264e67be8f3841d1$var$reIsBadHex.test(value) ? $264e67be8f3841d1$var$NAN : +value;
}
module.exports = $264e67be8f3841d1$var$isInteger;

});

parcelRegister("iXTVJ", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $dce91f3cbf3cc0bf$var$numberTag = '[object Number]';
/** Used for built-in method references. */ var $dce91f3cbf3cc0bf$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dce91f3cbf3cc0bf$var$objectToString = $dce91f3cbf3cc0bf$var$objectProto.toString;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $dce91f3cbf3cc0bf$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $dce91f3cbf3cc0bf$var$isNumber(value) {
    return typeof value == 'number' || $dce91f3cbf3cc0bf$var$isObjectLike(value) && $dce91f3cbf3cc0bf$var$objectToString.call(value) == $dce91f3cbf3cc0bf$var$numberTag;
}
module.exports = $dce91f3cbf3cc0bf$var$isNumber;

});

parcelRegister("jt7gQ", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $03a85c59201b119a$var$objectTag = '[object Object]';
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $03a85c59201b119a$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $03a85c59201b119a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $03a85c59201b119a$var$funcProto = Function.prototype, $03a85c59201b119a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $03a85c59201b119a$var$funcToString = $03a85c59201b119a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $03a85c59201b119a$var$hasOwnProperty = $03a85c59201b119a$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $03a85c59201b119a$var$objectCtorString = $03a85c59201b119a$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $03a85c59201b119a$var$objectToString = $03a85c59201b119a$var$objectProto.toString;
/** Built-in value references. */ var $03a85c59201b119a$var$getPrototype = $03a85c59201b119a$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $03a85c59201b119a$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $03a85c59201b119a$var$isPlainObject(value) {
    if (!$03a85c59201b119a$var$isObjectLike(value) || $03a85c59201b119a$var$objectToString.call(value) != $03a85c59201b119a$var$objectTag || $03a85c59201b119a$var$isHostObject(value)) return false;
    var proto = $03a85c59201b119a$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $03a85c59201b119a$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $03a85c59201b119a$var$funcToString.call(Ctor) == $03a85c59201b119a$var$objectCtorString;
}
module.exports = $03a85c59201b119a$var$isPlainObject;

});

parcelRegister("gSPry", function(module, exports) {
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $c4a998130330480e$var$stringTag = '[object String]';
/** Used for built-in method references. */ var $c4a998130330480e$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c4a998130330480e$var$objectToString = $c4a998130330480e$var$objectProto.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c4a998130330480e$var$isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c4a998130330480e$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $c4a998130330480e$var$isString(value) {
    return typeof value == 'string' || !$c4a998130330480e$var$isArray(value) && $c4a998130330480e$var$isObjectLike(value) && $c4a998130330480e$var$objectToString.call(value) == $c4a998130330480e$var$stringTag;
}
module.exports = $c4a998130330480e$var$isString;

});

parcelRegister("kOJaT", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $f27b84ee56edb271$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $f27b84ee56edb271$var$INFINITY = 1 / 0, $f27b84ee56edb271$var$MAX_INTEGER = 1.7976931348623157e+308, $f27b84ee56edb271$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $f27b84ee56edb271$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $f27b84ee56edb271$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $f27b84ee56edb271$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $f27b84ee56edb271$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $f27b84ee56edb271$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $f27b84ee56edb271$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $f27b84ee56edb271$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f27b84ee56edb271$var$objectToString = $f27b84ee56edb271$var$objectProto.toString;
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $f27b84ee56edb271$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($f27b84ee56edb271$var$FUNC_ERROR_TEXT);
    n = $f27b84ee56edb271$var$toInteger(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $f27b84ee56edb271$var$once(func) {
    return $f27b84ee56edb271$var$before(2, func);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f27b84ee56edb271$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $f27b84ee56edb271$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $f27b84ee56edb271$var$isSymbol(value) {
    return typeof value == 'symbol' || $f27b84ee56edb271$var$isObjectLike(value) && $f27b84ee56edb271$var$objectToString.call(value) == $f27b84ee56edb271$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $f27b84ee56edb271$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $f27b84ee56edb271$var$toNumber(value);
    if (value === $f27b84ee56edb271$var$INFINITY || value === -$f27b84ee56edb271$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $f27b84ee56edb271$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $f27b84ee56edb271$var$toInteger(value) {
    var result = $f27b84ee56edb271$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $f27b84ee56edb271$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($f27b84ee56edb271$var$isSymbol(value)) return $f27b84ee56edb271$var$NAN;
    if ($f27b84ee56edb271$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f27b84ee56edb271$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($f27b84ee56edb271$var$reTrim, '');
    var isBinary = $f27b84ee56edb271$var$reIsBinary.test(value);
    return isBinary || $f27b84ee56edb271$var$reIsOctal.test(value) ? $f27b84ee56edb271$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $f27b84ee56edb271$var$reIsBadHex.test(value) ? $f27b84ee56edb271$var$NAN : +value;
}
module.exports = $f27b84ee56edb271$var$once;

});


parcelRegister("2oXYc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("iDep4"))();

});
parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});



parcelRegister("jicu4", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(' ');
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("a5Tnv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $759553f6ee74cd0d$export$2e2bcd8739ae039; });

var $l1IMy = parcelRequire("l1IMy");
function $759553f6ee74cd0d$export$2e2bcd8739ae039(value) {
    (0, $l1IMy.default)(1, arguments);
    return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});
parcelRegister("l1IMy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4ec6dc17078088c$export$2e2bcd8739ae039; });
function $f4ec6dc17078088c$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("4K8y5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $374216e389d08fec$export$2e2bcd8739ae039; });

var $a5Tnv = parcelRequire("a5Tnv");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $374216e389d08fec$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    if (!(0, $a5Tnv.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $uikl2.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("uikl2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $05b104d2fa74b1c7$export$2e2bcd8739ae039; });

var $l1IMy = parcelRequire("l1IMy");
function $05b104d2fa74b1c7$export$2e2bcd8739ae039(argument) {
    (0, $l1IMy.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});


parcelRegister("MqaTG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0918c9925a326e99$export$2e2bcd8739ae039; });

var $4K8y5 = parcelRequire("4K8y5");

var $lBRFE = parcelRequire("lBRFE");

var $4tT1o = parcelRequire("4tT1o");

var $uikl2 = parcelRequire("uikl2");

var $9KRld = parcelRequire("9KRld");

var $kvQ3g = parcelRequire("kvQ3g");

var $dS93T = parcelRequire("dS93T");

var $1BdKP = parcelRequire("1BdKP");

var $gPRuN = parcelRequire("gPRuN");

var $l1IMy = parcelRequire("l1IMy");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $0918c9925a326e99$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $0918c9925a326e99$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $0918c9925a326e99$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $0918c9925a326e99$var$doubleQuoteRegExp = /''/g;
var $0918c9925a326e99$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $0918c9925a326e99$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $l1IMy.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || (0, $lBRFE.default);
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $gPRuN.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $gPRuN.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $gPRuN.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $gPRuN.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $uikl2.default)(dirtyDate);
    if (!(0, $4K8y5.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $dS93T.default)(originalDate);
    var utcDate = (0, $4tT1o.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($0918c9925a326e99$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $kvQ3g.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($0918c9925a326e99$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $0918c9925a326e99$var$cleanEscapedString(substring);
        var formatter = (0, $9KRld.default)[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $1BdKP.isProtectedWeekYearToken)(substring)) (0, $1BdKP.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $1BdKP.isProtectedDayOfYearToken)(substring)) (0, $1BdKP.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($0918c9925a326e99$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $0918c9925a326e99$var$cleanEscapedString(input) {
    return input.match($0918c9925a326e99$var$escapedStringRegExp)[1].replace($0918c9925a326e99$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("lBRFE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbb6af908147d006$export$2e2bcd8739ae039; });

var $3EDEV = parcelRequire("3EDEV");

var $ekOFl = parcelRequire("ekOFl");

var $8cIKN = parcelRequire("8cIKN");

var $1mS6E = parcelRequire("1mS6E");

var $aHHAy = parcelRequire("aHHAy");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $fbb6af908147d006$var$locale = {
    code: 'en-US',
    formatDistance: (0, $3EDEV.default),
    formatLong: (0, $ekOFl.default),
    formatRelative: (0, $8cIKN.default),
    localize: (0, $1mS6E.default),
    match: (0, $aHHAy.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $fbb6af908147d006$export$2e2bcd8739ae039 = $fbb6af908147d006$var$locale;

});
parcelRegister("3EDEV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a93defe0440ad2b$export$2e2bcd8739ae039; });
var $2a93defe0440ad2b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $2a93defe0440ad2b$var$formatDistance = function(token, count, options) {
    var result;
    var tokenValue = $2a93defe0440ad2b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $2a93defe0440ad2b$export$2e2bcd8739ae039 = $2a93defe0440ad2b$var$formatDistance;

});

parcelRegister("ekOFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6fa3c1fbba4fd67$export$2e2bcd8739ae039; });

var $7n9p6 = parcelRequire("7n9p6");
var $a6fa3c1fbba4fd67$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $a6fa3c1fbba4fd67$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $a6fa3c1fbba4fd67$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a6fa3c1fbba4fd67$var$formatLong = {
    date: (0, $7n9p6.default)({
        formats: $a6fa3c1fbba4fd67$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $7n9p6.default)({
        formats: $a6fa3c1fbba4fd67$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $7n9p6.default)({
        formats: $a6fa3c1fbba4fd67$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a6fa3c1fbba4fd67$export$2e2bcd8739ae039 = $a6fa3c1fbba4fd67$var$formatLong;

});
parcelRegister("7n9p6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55e1f9cf760fc530$export$2e2bcd8739ae039; });
function $55e1f9cf760fc530$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("8cIKN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f9228dede0d6aa7$export$2e2bcd8739ae039; });
var $5f9228dede0d6aa7$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $5f9228dede0d6aa7$var$formatRelative = function(token, _date, _baseDate, _options) {
    return $5f9228dede0d6aa7$var$formatRelativeLocale[token];
};
var $5f9228dede0d6aa7$export$2e2bcd8739ae039 = $5f9228dede0d6aa7$var$formatRelative;

});

parcelRegister("1mS6E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ff1d0e06551a5c1$export$2e2bcd8739ae039; });

var $5XK0Y = parcelRequire("5XK0Y");
var $0ff1d0e06551a5c1$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $0ff1d0e06551a5c1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $0ff1d0e06551a5c1$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $0ff1d0e06551a5c1$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $0ff1d0e06551a5c1$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $0ff1d0e06551a5c1$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $0ff1d0e06551a5c1$var$ordinalNumber = function(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $0ff1d0e06551a5c1$var$localize = {
    ordinalNumber: $0ff1d0e06551a5c1$var$ordinalNumber,
    era: (0, $5XK0Y.default)({
        values: $0ff1d0e06551a5c1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $5XK0Y.default)({
        values: $0ff1d0e06551a5c1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $5XK0Y.default)({
        values: $0ff1d0e06551a5c1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $5XK0Y.default)({
        values: $0ff1d0e06551a5c1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $5XK0Y.default)({
        values: $0ff1d0e06551a5c1$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0ff1d0e06551a5c1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0ff1d0e06551a5c1$export$2e2bcd8739ae039 = $0ff1d0e06551a5c1$var$localize;

});
parcelRegister("5XK0Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $457628062959e556$export$2e2bcd8739ae039; });
function $457628062959e556$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("aHHAy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cafbb556cfb2776$export$2e2bcd8739ae039; });

var $l56pp = parcelRequire("l56pp");

var $knfbR = parcelRequire("knfbR");
var $7cafbb556cfb2776$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $7cafbb556cfb2776$var$parseOrdinalNumberPattern = /\d+/i;
var $7cafbb556cfb2776$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $7cafbb556cfb2776$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $7cafbb556cfb2776$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $7cafbb556cfb2776$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7cafbb556cfb2776$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $7cafbb556cfb2776$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $7cafbb556cfb2776$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $7cafbb556cfb2776$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $7cafbb556cfb2776$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $7cafbb556cfb2776$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $7cafbb556cfb2776$var$match = {
    ordinalNumber: (0, $knfbR.default)({
        matchPattern: $7cafbb556cfb2776$var$matchOrdinalNumberPattern,
        parsePattern: $7cafbb556cfb2776$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $l56pp.default)({
        matchPatterns: $7cafbb556cfb2776$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $l56pp.default)({
        matchPatterns: $7cafbb556cfb2776$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $l56pp.default)({
        matchPatterns: $7cafbb556cfb2776$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $l56pp.default)({
        matchPatterns: $7cafbb556cfb2776$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $l56pp.default)({
        matchPatterns: $7cafbb556cfb2776$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7cafbb556cfb2776$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7cafbb556cfb2776$export$2e2bcd8739ae039 = $7cafbb556cfb2776$var$match;

});
parcelRegister("l56pp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f58f09468deb70ae$export$2e2bcd8739ae039; });
function $f58f09468deb70ae$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f58f09468deb70ae$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f58f09468deb70ae$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f58f09468deb70ae$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f58f09468deb70ae$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("knfbR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed51bd2201b1ffe0$export$2e2bcd8739ae039; });
function $ed51bd2201b1ffe0$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("4tT1o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34348cf8fa5b62a4$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $ggoRP = parcelRequire("ggoRP");

var $l1IMy = parcelRequire("l1IMy");
function $34348cf8fa5b62a4$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $ggoRP.default)(dirtyDate, -amount);
}

});
parcelRegister("gPRuN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c41ae7eb91efecef$export$2e2bcd8739ae039; });
function $c41ae7eb91efecef$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("ggoRP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd716e10292c6930$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $bd716e10292c6930$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var timestamp = (0, $uikl2.default)(dirtyDate).getTime();
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});


parcelRegister("9KRld", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71a1c96437171265$export$2e2bcd8739ae039; });

var $f5iZj = parcelRequire("f5iZj");

var $faNbH = parcelRequire("faNbH");

var $707Yy = parcelRequire("707Yy");

var $7xu1W = parcelRequire("7xu1W");

var $gqKyl = parcelRequire("gqKyl");

var $7GG93 = parcelRequire("7GG93");

var $bHnlP = parcelRequire("bHnlP");
var $71a1c96437171265$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $71a1c96437171265$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $bHnlP.default).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $gqKyl.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $7GG93.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $7GG93.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $707Yy.default)(date); // Padding
        return (0, $7GG93.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $7GG93.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $7GG93.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $7GG93.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $bHnlP.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $7GG93.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $7xu1W.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $7GG93.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $faNbH.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $7GG93.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $bHnlP.default).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $f5iZj.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $7GG93.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $7GG93.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $7GG93.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $7GG93.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $bHnlP.default).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $bHnlP.default).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $7GG93.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $7GG93.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $bHnlP.default).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $bHnlP.default).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $bHnlP.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $71a1c96437171265$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $71a1c96437171265$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $71a1c96437171265$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $71a1c96437171265$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $7GG93.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $7GG93.default)(timestamp, token.length);
    }
};
function $71a1c96437171265$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $7GG93.default)(minutes, 2);
}
function $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $7GG93.default)(Math.abs(offset) / 60, 2);
    }
    return $71a1c96437171265$var$formatTimezone(offset, dirtyDelimiter);
}
function $71a1c96437171265$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $7GG93.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $7GG93.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $71a1c96437171265$export$2e2bcd8739ae039 = $71a1c96437171265$var$formatters;

});
parcelRegister("f5iZj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afb60d42de991571$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
var $afb60d42de991571$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
function $afb60d42de991571$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $afb60d42de991571$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("faNbH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0bdf1d2df59ff38$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $4FakD = parcelRequire("4FakD");

var $5A4VE = parcelRequire("5A4VE");

var $l1IMy = parcelRequire("l1IMy");
var $b0bdf1d2df59ff38$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
function $b0bdf1d2df59ff38$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var diff = (0, $4FakD.default)(date).getTime() - (0, $5A4VE.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $b0bdf1d2df59ff38$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("4FakD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $365301764998b714$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $365301764998b714$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $uikl2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("5A4VE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41042352236130d1$export$2e2bcd8739ae039; });

var $707Yy = parcelRequire("707Yy");

var $4FakD = parcelRequire("4FakD");

var $l1IMy = parcelRequire("l1IMy");
function $41042352236130d1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var year = (0, $707Yy.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $4FakD.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("707Yy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $518eb844f291f762$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");

var $4FakD = parcelRequire("4FakD");
function $518eb844f291f762$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $4FakD.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $4FakD.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("7xu1W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57d2e8e06c23527b$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $8M8d4 = parcelRequire("8M8d4");

var $4Nge6 = parcelRequire("4Nge6");

var $l1IMy = parcelRequire("l1IMy");
var $57d2e8e06c23527b$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
function $57d2e8e06c23527b$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var diff = (0, $8M8d4.default)(date, options).getTime() - (0, $4Nge6.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $57d2e8e06c23527b$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("8M8d4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66392cbb34f04ad9$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");

var $gPRuN = parcelRequire("gPRuN");
function $66392cbb34f04ad9$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $l1IMy.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $gPRuN.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $gPRuN.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $uikl2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("4Nge6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37d853466602e505$export$2e2bcd8739ae039; });

var $gqKyl = parcelRequire("gqKyl");

var $l1IMy = parcelRequire("l1IMy");

var $8M8d4 = parcelRequire("8M8d4");

var $gPRuN = parcelRequire("gPRuN");
function $37d853466602e505$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $l1IMy.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $gPRuN.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $gPRuN.default)(options.firstWeekContainsDate);
    var year = (0, $gqKyl.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $8M8d4.default)(firstWeek, dirtyOptions);
    return date;
}

});
parcelRegister("gqKyl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf632f7e6fcf0087$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");

var $8M8d4 = parcelRequire("8M8d4");

var $gPRuN = parcelRequire("gPRuN");
function $bf632f7e6fcf0087$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $gPRuN.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $gPRuN.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8M8d4.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8M8d4.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("7GG93", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $598d25c1f2e4f194$export$2e2bcd8739ae039; });
function $598d25c1f2e4f194$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("bHnlP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8845d2e14e26c506$export$2e2bcd8739ae039; });

var $7GG93 = parcelRequire("7GG93");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8845d2e14e26c506$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $7GG93.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $7GG93.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $7GG93.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $7GG93.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $7GG93.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $7GG93.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $7GG93.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $7GG93.default)(fractionalSeconds, token.length);
    }
};
var $8845d2e14e26c506$export$2e2bcd8739ae039 = $8845d2e14e26c506$var$formatters;

});


parcelRegister("kvQ3g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeef144218f64d7d$export$2e2bcd8739ae039; });
function $eeef144218f64d7d$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $eeef144218f64d7d$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $eeef144218f64d7d$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $eeef144218f64d7d$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $eeef144218f64d7d$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $eeef144218f64d7d$var$timeLongFormatter(timePattern, formatLong));
}
var $eeef144218f64d7d$var$longFormatters = {
    p: $eeef144218f64d7d$var$timeLongFormatter,
    P: $eeef144218f64d7d$var$dateTimeLongFormatter
};
var $eeef144218f64d7d$export$2e2bcd8739ae039 = $eeef144218f64d7d$var$longFormatters;

});

parcelRegister("dS93T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a197590075b6aa6e$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $a197590075b6aa6e$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("1BdKP", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $12a3ea762b495ad3$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $12a3ea762b495ad3$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $12a3ea762b495ad3$export$8073c1ae88f0e727; });
var $12a3ea762b495ad3$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $12a3ea762b495ad3$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $12a3ea762b495ad3$export$c6cc36aa33304772(token) {
    return $12a3ea762b495ad3$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $12a3ea762b495ad3$export$c6b49d6dceb604a1(token) {
    return $12a3ea762b495ad3$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $12a3ea762b495ad3$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("9o4jv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6d59b3906efd21bf$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $ggoRP = parcelRequire("ggoRP");

var $l1IMy = parcelRequire("l1IMy");
var $6d59b3906efd21bf$var$MILLISECONDS_IN_MINUTE = 60000;
function $6d59b3906efd21bf$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $ggoRP.default)(dirtyDate, amount * $6d59b3906efd21bf$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("ikvbb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d58247d27eb0dbf7$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $ggoRP = parcelRequire("ggoRP");

var $l1IMy = parcelRequire("l1IMy");
var $d58247d27eb0dbf7$var$MILLISECONDS_IN_HOUR = 3600000;
function $d58247d27eb0dbf7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $ggoRP.default)(dirtyDate, amount * $d58247d27eb0dbf7$var$MILLISECONDS_IN_HOUR);
}

});

parcelRegister("g2qsw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $bad15b7880e6f97c$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $bad15b7880e6f97c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("kyhHe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ef64b5b7aae137f5$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $g2qsw = parcelRequire("g2qsw");

var $l1IMy = parcelRequire("l1IMy");
function $ef64b5b7aae137f5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $g2qsw.default)(dirtyDate, days);
}

});

parcelRegister("fHB48", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b6e79fa3dbe621a2$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $b6e79fa3dbe621a2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("56MqC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3b831424db570743$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $fHB48 = parcelRequire("fHB48");

var $l1IMy = parcelRequire("l1IMy");
function $3b831424db570743$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $fHB48.default)(dirtyDate, amount * 12);
}

});

parcelRegister("3WWqy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2e041c519df2ea92$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $9o4jv = parcelRequire("9o4jv");

var $l1IMy = parcelRequire("l1IMy");
function $2e041c519df2ea92$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $9o4jv.default)(dirtyDate, -amount);
}

});

parcelRegister("7XbaL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5ca6b5bde8697f12$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $ikvbb = parcelRequire("ikvbb");

var $l1IMy = parcelRequire("l1IMy");
function $5ca6b5bde8697f12$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $ikvbb.default)(dirtyDate, -amount);
}

});

parcelRegister("kOZIv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f28859da9faf09db$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $g2qsw = parcelRequire("g2qsw");

var $l1IMy = parcelRequire("l1IMy");
function $f28859da9faf09db$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $g2qsw.default)(dirtyDate, -amount);
}

});

parcelRegister("5Q5cq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4405d79342e3778c$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $kyhHe = parcelRequire("kyhHe");

var $l1IMy = parcelRequire("l1IMy");
function $4405d79342e3778c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $kyhHe.default)(dirtyDate, -amount);
}

});

parcelRegister("47vGx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $300064de58ce8200$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $fHB48 = parcelRequire("fHB48");

var $l1IMy = parcelRequire("l1IMy");
function $300064de58ce8200$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $fHB48.default)(dirtyDate, -amount);
}

});

parcelRegister("83lF6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5dcf6825012fa4ab$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $56MqC = parcelRequire("56MqC");

var $l1IMy = parcelRequire("l1IMy");
function $5dcf6825012fa4ab$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $l1IMy.default)(2, arguments);
    var amount = (0, $gPRuN.default)(dirtyAmount);
    return (0, $56MqC.default)(dirtyDate, -amount);
}

});

parcelRegister("1AHlB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $128ac71efb3a2f51$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $128ac71efb3a2f51$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

});

parcelRegister("9haxa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6c0ddf6f2e376b6f$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $6c0ddf6f2e376b6f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

});

parcelRegister("hWihv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d0f608c42e15b075$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $d0f608c42e15b075$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

});

parcelRegister("7EB9n", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $59291611c6d37351$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $59291611c6d37351$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

});

parcelRegister("6szzw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4b40f36c6c4e8120$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $4b40f36c6c4e8120$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

});

parcelRegister("fM9Kf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b7c2e5da36abe2bf$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $ehcRC = parcelRequire("ehcRC");

var $4BPAz = parcelRequire("4BPAz");

var $l1IMy = parcelRequire("l1IMy");
var $b7c2e5da36abe2bf$var$MILLISECONDS_IN_WEEK = 604800000;
function $b7c2e5da36abe2bf$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var diff = (0, $ehcRC.default)(date).getTime() - (0, $4BPAz.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $b7c2e5da36abe2bf$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("ehcRC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a64ca1b54a4cba4e$export$2e2bcd8739ae039; });

var $7yFGs = parcelRequire("7yFGs");

var $l1IMy = parcelRequire("l1IMy");
function $a64ca1b54a4cba4e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    return (0, $7yFGs.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});
parcelRegister("7yFGs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $580c0aebe042d20a$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $gPRuN = parcelRequire("gPRuN");

var $l1IMy = parcelRequire("l1IMy");
function $580c0aebe042d20a$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $l1IMy.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $gPRuN.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $gPRuN.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $uikl2.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("4BPAz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35b2a29e6c9d67ff$export$2e2bcd8739ae039; });

var $j2ruZ = parcelRequire("j2ruZ");

var $ehcRC = parcelRequire("ehcRC");

var $l1IMy = parcelRequire("l1IMy");
function $35b2a29e6c9d67ff$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var year = (0, $j2ruZ.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $ehcRC.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("j2ruZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddc388e95f4cda62$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $ehcRC = parcelRequire("ehcRC");

var $l1IMy = parcelRequire("l1IMy");
function $ddc388e95f4cda62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $ehcRC.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $ehcRC.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("5m1kc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3e6008e0d859cbde$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $3e6008e0d859cbde$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

});

parcelRegister("3J3av", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2b680846005cb1a6$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $2b680846005cb1a6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
}

});

parcelRegister("bGmT1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $88155eb6456a8ca8$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $88155eb6456a8ca8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    return (0, $uikl2.default)(dirtyDate).getFullYear();
}

});

parcelRegister("h8bGW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c78c40bc46b39387$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $c78c40bc46b39387$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

});

parcelRegister("bKtOQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $88db1f07d3462e3c$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $88db1f07d3462e3c$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var seconds = (0, $gPRuN.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

});

parcelRegister("gi6xd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $bdc3656b920d564d$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $bdc3656b920d564d$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var minutes = (0, $gPRuN.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

});

parcelRegister("ks4l0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ee39c98c5378a0a6$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $ee39c98c5378a0a6$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var hours = (0, $gPRuN.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

});

parcelRegister("81pra", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5d7226012cddb1a9$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $2ndhV = parcelRequire("2ndhV");

var $l1IMy = parcelRequire("l1IMy");
function $5d7226012cddb1a9$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var month = (0, $gPRuN.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $2ndhV.default)(dateWithDesiredMonth); // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

});
parcelRegister("2ndhV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ba80981c4aaa361$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $1ba80981c4aaa361$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});


parcelRegister("3gYJv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2621fa037f835ce7$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $81pra = parcelRequire("81pra");

var $l1IMy = parcelRequire("l1IMy");
function $2621fa037f835ce7$export$2e2bcd8739ae039(dirtyDate, dirtyQuarter) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var quarter = (0, $gPRuN.default)(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, $81pra.default)(date, date.getMonth() + diff * 3);
}

});

parcelRegister("eZ85K", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ae8d0a047d9558ed$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $ae8d0a047d9558ed$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var year = (0, $gPRuN.default)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

});

parcelRegister("dQzgo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a14b7c472277bc19$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $a14b7c472277bc19$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $l1IMy.default)(1, arguments);
    var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
    else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $uikl2.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("1r0i5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $10b889c90d40f9ac$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $10b889c90d40f9ac$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $l1IMy.default)(1, arguments);
    var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
    else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $uikl2.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("1n0nj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0ff83ae00b0d75a6$export$2e2bcd8739ae039; });

var $dS93T = parcelRequire("dS93T");

var $jk6bs = parcelRequire("jk6bs");

var $l1IMy = parcelRequire("l1IMy");
var $0ff83ae00b0d75a6$var$MILLISECONDS_IN_DAY = 86400000;
function $0ff83ae00b0d75a6$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var startOfDayLeft = (0, $jk6bs.default)(dirtyDateLeft);
    var startOfDayRight = (0, $jk6bs.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $dS93T.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $dS93T.default)(startOfDayRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $0ff83ae00b0d75a6$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("jk6bs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e114ae87b2fb4d54$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $e114ae87b2fb4d54$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("848HI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5df572e1c801b5e3$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $5df572e1c801b5e3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyDateLeft);
    var dateRight = (0, $uikl2.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("aYd0L", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7fc999c158ebb538$export$2e2bcd8739ae039; });

var $7yFGs = parcelRequire("7yFGs");

var $dS93T = parcelRequire("dS93T");

var $l1IMy = parcelRequire("l1IMy");
var $7fc999c158ebb538$var$MILLISECONDS_IN_WEEK = 604800000;
function $7fc999c158ebb538$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
    (0, $l1IMy.default)(2, arguments);
    var startOfWeekLeft = (0, $7yFGs.default)(dirtyDateLeft, dirtyOptions);
    var startOfWeekRight = (0, $7yFGs.default)(dirtyDateRight, dirtyOptions);
    var timestampLeft = startOfWeekLeft.getTime() - (0, $dS93T.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, $dS93T.default)(startOfWeekRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $7fc999c158ebb538$var$MILLISECONDS_IN_WEEK);
}

});

parcelRegister("5aOOs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3c454d4799b2e5e2$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $3c454d4799b2e5e2$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyDateLeft);
    var dateRight = (0, $uikl2.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("jYJM6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e8b720dd7751e2f7$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $e8b720dd7751e2f7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("1ML50", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $14cecb311c51eefa$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $14cecb311c51eefa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("kb4zK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $eb08625b8e4078ad$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $eb08625b8e4078ad$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var cleanDate = (0, $uikl2.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("7YbDm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5cd7293820fa2400$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $5cd7293820fa2400$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("519j3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3a7443c6796c86d0$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $gPRuN = parcelRequire("gPRuN");

var $l1IMy = parcelRequire("l1IMy");
function $3a7443c6796c86d0$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $l1IMy.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $gPRuN.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $gPRuN.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $uikl2.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("hoAlg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $caa0de56b1948e3d$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $caa0de56b1948e3d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $l1IMy.default)(1, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("xNYKg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0659d9ec4d7dbbf0$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $0659d9ec4d7dbbf0$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyLeftDate);
    var dateRight = (0, $uikl2.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

});

parcelRegister("bnDdH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $849043f97da8598e$export$2e2bcd8739ae039; });

var $jk6bs = parcelRequire("jk6bs");

var $l1IMy = parcelRequire("l1IMy");
function $849043f97da8598e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeftStartOfDay = (0, $jk6bs.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $jk6bs.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("8nupm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $61980f1dae65c9e0$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $61980f1dae65c9e0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyDateLeft);
    var dateRight = (0, $uikl2.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("kW7J5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f3df37b4dec5127a$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $f3df37b4dec5127a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeft = (0, $uikl2.default)(dirtyDateLeft);
    var dateRight = (0, $uikl2.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("7csev", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $53df8ddf3728281c$export$2e2bcd8739ae039; });

var $1ML50 = parcelRequire("1ML50");

var $l1IMy = parcelRequire("l1IMy");
function $53df8ddf3728281c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $l1IMy.default)(2, arguments);
    var dateLeftStartOfQuarter = (0, $1ML50.default)(dirtyDateLeft);
    var dateRightStartOfQuarter = (0, $1ML50.default)(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

});

parcelRegister("4uWbm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3467188658b165bd$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $3467188658b165bd$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var dateToCompare = (0, $uikl2.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("cj6VA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8f5ca214877b2a80$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $8f5ca214877b2a80$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var dateToCompare = (0, $uikl2.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("g7Fca", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $bbcd414b3c303484$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");
function $bbcd414b3c303484$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $l1IMy.default)(2, arguments);
    var time = (0, $uikl2.default)(dirtyDate).getTime();
    var startTime = (0, $uikl2.default)(interval.start).getTime();
    var endTime = (0, $uikl2.default)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}

});

parcelRegister("jqdd7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e23ab16419322690$export$2e2bcd8739ae039; });

var $lBRFE = parcelRequire("lBRFE");

var $4tT1o = parcelRequire("4tT1o");

var $uikl2 = parcelRequire("uikl2");

var $9x9mK = parcelRequire("9x9mK");

var $kvQ3g = parcelRequire("kvQ3g");

var $dS93T = parcelRequire("dS93T");

var $1BdKP = parcelRequire("1BdKP");

var $gPRuN = parcelRequire("gPRuN");

var $eyVcr = parcelRequire("eyVcr");

var $l1IMy = parcelRequire("l1IMy");
var $e23ab16419322690$var$TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e23ab16419322690$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e23ab16419322690$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e23ab16419322690$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e23ab16419322690$var$doubleQuoteRegExp = /''/g;
var $e23ab16419322690$var$notWhitespaceRegExp = /\S/;
var $e23ab16419322690$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e23ab16419322690$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
    (0, $l1IMy.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var options = dirtyOptions || {};
    var locale = options.locale || (0, $lBRFE.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $gPRuN.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $gPRuN.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $gPRuN.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $gPRuN.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $uikl2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    }; // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        {
            priority: $e23ab16419322690$var$TIMEZONE_UNIT_PRIORITY,
            subPriority: -1,
            set: $e23ab16419322690$var$dateToSystemTimezone,
            index: 0
        }
    ];
    var i;
    var tokens = formatString.match($e23ab16419322690$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $kvQ3g.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong, subFnOptions);
        }
        return substring;
    }).join('').match($e23ab16419322690$var$formattingTokensRegExp);
    var usedTokens = [];
    for(i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (!options.useAdditionalWeekYearTokens && (0, $1BdKP.isProtectedWeekYearToken)(token)) (0, $1BdKP.throwProtectedError)(token, formatString, dirtyDateString);
        if (!options.useAdditionalDayOfYearTokens && (0, $1BdKP.isProtectedDayOfYearToken)(token)) (0, $1BdKP.throwProtectedError)(token, formatString, dirtyDateString);
        var firstCharacter = token[0];
        var parser = (0, $eyVcr.default)[firstCharacter];
        if (parser) {
            var incompatibleTokens = parser.incompatibleTokens;
            if (Array.isArray(incompatibleTokens)) {
                var incompatibleToken = void 0;
                for(var _i = 0; _i < usedTokens.length; _i++){
                    var usedToken = usedTokens[_i].token;
                    if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
                        incompatibleToken = usedTokens[_i];
                        break;
                    }
                }
                if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
            } else if (parser.incompatibleTokens === '*' && usedTokens.length) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
            if (!parseResult) return new Date(NaN);
            setters.push({
                priority: parser.priority,
                subPriority: parser.subPriority || 0,
                set: parser.set,
                validate: parser.validate,
                value: parseResult.value,
                index: setters.length
            });
            dateString = parseResult.rest;
        } else {
            if (firstCharacter.match($e23ab16419322690$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
             // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $e23ab16419322690$var$cleanEscapedString(token);
             // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
            else return new Date(NaN);
        }
    } // Check if the remaining input contains something other than whitespace
    if (dateString.length > 0 && $e23ab16419322690$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $uikl2.default)(dirtyReferenceDate);
    if (isNaN(date)) return new Date(NaN);
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
    var utcDate = (0, $4tT1o.default)(date, (0, $dS93T.default)(date));
    var flags = {};
    for(i = 0; i < uniquePrioritySetters.length; i++){
        var setter = uniquePrioritySetters[i];
        if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) return new Date(NaN);
        var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
        if (result[0]) {
            utcDate = result[0];
            (0, $9x9mK.default)(flags, result[1]); // Result is date
        } else utcDate = result;
    }
    return utcDate;
}
function $e23ab16419322690$var$dateToSystemTimezone(date, flags) {
    if (flags.timestampIsSet) return date;
    var convertedDate = new Date(0);
    convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    return convertedDate;
}
function $e23ab16419322690$var$cleanEscapedString(input) {
    return input.match($e23ab16419322690$var$escapedStringRegExp)[1].replace($e23ab16419322690$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("9x9mK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f0e75fc27c44afd$export$2e2bcd8739ae039; });
function $6f0e75fc27c44afd$export$2e2bcd8739ae039(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}

});

parcelRegister("eyVcr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9a09c5462def3d7$export$2e2bcd8739ae039; });

var $gqKyl = parcelRequire("gqKyl");

var $iMSzR = parcelRequire("iMSzR");

var $ajDLz = parcelRequire("ajDLz");

var $gFYW2 = parcelRequire("gFYW2");

var $dFIau = parcelRequire("dFIau");

var $4FakD = parcelRequire("4FakD");

var $8M8d4 = parcelRequire("8M8d4");
var $a9a09c5462def3d7$var$MILLISECONDS_IN_HOUR = 3600000;
var $a9a09c5462def3d7$var$MILLISECONDS_IN_MINUTE = 60000;
var $a9a09c5462def3d7$var$MILLISECONDS_IN_SECOND = 1000;
var $a9a09c5462def3d7$var$numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $a9a09c5462def3d7$var$timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function $a9a09c5462def3d7$var$parseNumericPattern(pattern, string, valueCallback) {
    var matchResult = string.match(pattern);
    if (!matchResult) return null;
    var value = parseInt(matchResult[0], 10);
    return {
        value: valueCallback ? valueCallback(value) : value,
        rest: string.slice(matchResult[0].length)
    };
}
function $a9a09c5462def3d7$var$parseTimezonePattern(pattern, string) {
    var matchResult = string.match(pattern);
    if (!matchResult) return null;
     // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: string.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $a9a09c5462def3d7$var$MILLISECONDS_IN_HOUR + minutes * $a9a09c5462def3d7$var$MILLISECONDS_IN_MINUTE + seconds * $a9a09c5462def3d7$var$MILLISECONDS_IN_SECOND),
        rest: string.slice(matchResult[0].length)
    };
}
function $a9a09c5462def3d7$var$parseAnyDigitsSigned(string, valueCallback) {
    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.anyDigitsSigned, string, valueCallback);
}
function $a9a09c5462def3d7$var$parseNDigits(n, string, valueCallback) {
    switch(n){
        case 1:
            return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.singleDigit, string, valueCallback);
        case 2:
            return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.twoDigits, string, valueCallback);
        case 3:
            return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.threeDigits, string, valueCallback);
        case 4:
            return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.fourDigits, string, valueCallback);
        default:
            return $a9a09c5462def3d7$var$parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
    }
}
function $a9a09c5462def3d7$var$parseNDigitsSigned(n, string, valueCallback) {
    switch(n){
        case 1:
            return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.singleDigitSigned, string, valueCallback);
        case 2:
            return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.twoDigitsSigned, string, valueCallback);
        case 3:
            return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.threeDigitsSigned, string, valueCallback);
        case 4:
            return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.fourDigitsSigned, string, valueCallback);
        default:
            return $a9a09c5462def3d7$var$parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
    }
}
function $a9a09c5462def3d7$var$dayPeriodEnumToHours(enumValue) {
    switch(enumValue){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $a9a09c5462def3d7$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0; // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
var $a9a09c5462def3d7$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $a9a09c5462def3d7$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
]; // User for validation
function $a9a09c5462def3d7$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ var $a9a09c5462def3d7$var$parsers = {
    // Era
    G: {
        priority: 140,
        parse: function(string, token, match, _options) {
            switch(token){
                // AD, BC
                case 'G':
                case 'GG':
                case 'GGG':
                    return match.era(string, {
                        width: 'abbreviated'
                    }) || match.era(string, {
                        width: 'narrow'
                    });
                // A, B
                case 'GGGGG':
                    return match.era(string, {
                        width: 'narrow'
                    });
                // Anno Domini, Before Christ
                case 'GGGG':
                default:
                    return match.era(string, {
                        width: 'wide'
                    }) || match.era(string, {
                        width: 'abbreviated'
                    }) || match.era(string, {
                        width: 'narrow'
                    });
            }
        },
        set: function(date, flags, value, _options) {
            flags.era = value;
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'R',
            'u',
            't',
            'T'
        ]
    },
    // Year
    y: {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        priority: 130,
        parse: function(string, token, match, _options) {
            var valueCallback = function(year) {
                return {
                    year: year,
                    isTwoDigitYear: token === 'yy'
                };
            };
            switch(token){
                case 'y':
                    return $a9a09c5462def3d7$var$parseNDigits(4, string, valueCallback);
                case 'yo':
                    return match.ordinalNumber(string, {
                        unit: 'year',
                        valueCallback: valueCallback
                    });
                default:
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string, valueCallback);
            }
        },
        validate: function(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
        },
        set: function(date, flags, value, _options) {
            var currentYear = date.getUTCFullYear();
            if (value.isTwoDigitYear) {
                var normalizedTwoDigitYear = $a9a09c5462def3d7$var$normalizeTwoDigitYear(value.year, currentYear);
                date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
            var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Local week-numbering year
    Y: {
        priority: 130,
        parse: function(string, token, match, _options) {
            var valueCallback = function(year) {
                return {
                    year: year,
                    isTwoDigitYear: token === 'YY'
                };
            };
            switch(token){
                case 'Y':
                    return $a9a09c5462def3d7$var$parseNDigits(4, string, valueCallback);
                case 'Yo':
                    return match.ordinalNumber(string, {
                        unit: 'year',
                        valueCallback: valueCallback
                    });
                default:
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string, valueCallback);
            }
        },
        validate: function(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
        },
        set: function(date, flags, value, options) {
            var currentYear = (0, $gqKyl.default)(date, options);
            if (value.isTwoDigitYear) {
                var normalizedTwoDigitYear = $a9a09c5462def3d7$var$normalizeTwoDigitYear(value.year, currentYear);
                date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $8M8d4.default)(date, options);
            }
            var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
            date.setUTCHours(0, 0, 0, 0);
            return (0, $8M8d4.default)(date, options);
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]
    },
    // ISO week-numbering year
    R: {
        priority: 130,
        parse: function(string, token, _match, _options) {
            if (token === 'R') return $a9a09c5462def3d7$var$parseNDigitsSigned(4, string);
            return $a9a09c5462def3d7$var$parseNDigitsSigned(token.length, string);
        },
        set: function(_date, _flags, value, _options) {
            var firstWeekOfYear = new Date(0);
            firstWeekOfYear.setUTCFullYear(value, 0, 4);
            firstWeekOfYear.setUTCHours(0, 0, 0, 0);
            return (0, $4FakD.default)(firstWeekOfYear);
        },
        incompatibleTokens: [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Extended year
    u: {
        priority: 130,
        parse: function(string, token, _match, _options) {
            if (token === 'u') return $a9a09c5462def3d7$var$parseNDigitsSigned(4, string);
            return $a9a09c5462def3d7$var$parseNDigitsSigned(token.length, string);
        },
        set: function(date, _flags, value, _options) {
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Quarter
    Q: {
        priority: 120,
        parse: function(string, token, match, _options) {
            switch(token){
                // 1, 2, 3, 4
                case 'Q':
                case 'QQ':
                    // 01, 02, 03, 04
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
                // 1st, 2nd, 3rd, 4th
                case 'Qo':
                    return match.ordinalNumber(string, {
                        unit: 'quarter'
                    });
                // Q1, Q2, Q3, Q4
                case 'QQQ':
                    return match.quarter(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                case 'QQQQQ':
                    return match.quarter(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // 1st quarter, 2nd quarter, ...
                case 'QQQQ':
                default:
                    return match.quarter(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.quarter(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 4;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Stand-alone quarter
    q: {
        priority: 120,
        parse: function(string, token, match, _options) {
            switch(token){
                // 1, 2, 3, 4
                case 'q':
                case 'qq':
                    // 01, 02, 03, 04
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
                // 1st, 2nd, 3rd, 4th
                case 'qo':
                    return match.ordinalNumber(string, {
                        unit: 'quarter'
                    });
                // Q1, Q2, Q3, Q4
                case 'qqq':
                    return match.quarter(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                case 'qqqqq':
                    return match.quarter(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // 1st quarter, 2nd quarter, ...
                case 'qqqq':
                default:
                    return match.quarter(string, {
                        width: 'wide',
                        context: 'standalone'
                    }) || match.quarter(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 4;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Month
    M: {
        priority: 110,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                return value - 1;
            };
            switch(token){
                // 1, 2, ..., 12
                case 'M':
                    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.month, string, valueCallback);
                // 01, 02, ..., 12
                case 'MM':
                    return $a9a09c5462def3d7$var$parseNDigits(2, string, valueCallback);
                // 1st, 2nd, ..., 12th
                case 'Mo':
                    return match.ordinalNumber(string, {
                        unit: 'month',
                        valueCallback: valueCallback
                    });
                // Jan, Feb, ..., Dec
                case 'MMM':
                    return match.month(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // J, F, ..., D
                case 'MMMMM':
                    return match.month(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // January, February, ..., December
                case 'MMMM':
                default:
                    return match.month(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.month(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Stand-alone month
    L: {
        priority: 110,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                return value - 1;
            };
            switch(token){
                // 1, 2, ..., 12
                case 'L':
                    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.month, string, valueCallback);
                // 01, 02, ..., 12
                case 'LL':
                    return $a9a09c5462def3d7$var$parseNDigits(2, string, valueCallback);
                // 1st, 2nd, ..., 12th
                case 'Lo':
                    return match.ordinalNumber(string, {
                        unit: 'month',
                        valueCallback: valueCallback
                    });
                // Jan, Feb, ..., Dec
                case 'LLL':
                    return match.month(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // J, F, ..., D
                case 'LLLLL':
                    return match.month(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // January, February, ..., December
                case 'LLLL':
                default:
                    return match.month(string, {
                        width: 'wide',
                        context: 'standalone'
                    }) || match.month(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Local week of year
    w: {
        priority: 100,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'w':
                    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.week, string);
                case 'wo':
                    return match.ordinalNumber(string, {
                        unit: 'week'
                    });
                default:
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 53;
        },
        set: function(date, _flags, value, options) {
            return (0, $8M8d4.default)((0, $dFIau.default)(date, value, options), options);
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]
    },
    // ISO week of year
    I: {
        priority: 100,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'I':
                    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.week, string);
                case 'Io':
                    return match.ordinalNumber(string, {
                        unit: 'week'
                    });
                default:
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 53;
        },
        set: function(date, _flags, value, options) {
            return (0, $4FakD.default)((0, $gFYW2.default)(date, value, options), options);
        },
        incompatibleTokens: [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Day of the month
    d: {
        priority: 90,
        subPriority: 1,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'd':
                    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.date, string);
                case 'do':
                    return match.ordinalNumber(string, {
                        unit: 'date'
                    });
                default:
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
            }
        },
        validate: function(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = $a9a09c5462def3d7$var$isLeapYearIndex(year);
            var month = date.getUTCMonth();
            if (isLeapYear) return value >= 1 && value <= $a9a09c5462def3d7$var$DAYS_IN_MONTH_LEAP_YEAR[month];
            else return value >= 1 && value <= $a9a09c5462def3d7$var$DAYS_IN_MONTH[month];
        },
        set: function(date, _flags, value, _options) {
            date.setUTCDate(value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Day of year
    D: {
        priority: 90,
        subPriority: 1,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'D':
                case 'DD':
                    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.dayOfYear, string);
                case 'Do':
                    return match.ordinalNumber(string, {
                        unit: 'date'
                    });
                default:
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
            }
        },
        validate: function(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = $a9a09c5462def3d7$var$isLeapYearIndex(year);
            if (isLeapYear) return value >= 1 && value <= 366;
            else return value >= 1 && value <= 365;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(0, value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Day of week
    E: {
        priority: 90,
        parse: function(string, token, match, _options) {
            switch(token){
                // Tue
                case 'E':
                case 'EE':
                case 'EEE':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // T
                case 'EEEEE':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tu
                case 'EEEEEE':
                    return match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tuesday
                case 'EEEE':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $iMSzR.default)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Local day of week
    e: {
        priority: 90,
        parse: function(string, token, match, options) {
            var valueCallback = function(value) {
                var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };
            switch(token){
                // 3
                case 'e':
                case 'ee':
                    // 03
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string, valueCallback);
                // 3rd
                case 'eo':
                    return match.ordinalNumber(string, {
                        unit: 'day',
                        valueCallback: valueCallback
                    });
                // Tue
                case 'eee':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // T
                case 'eeeee':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tu
                case 'eeeeee':
                    return match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tuesday
                case 'eeee':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $iMSzR.default)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]
    },
    // Stand-alone local day of week
    c: {
        priority: 90,
        parse: function(string, token, match, options) {
            var valueCallback = function(value) {
                var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };
            switch(token){
                // 3
                case 'c':
                case 'cc':
                    // 03
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string, valueCallback);
                // 3rd
                case 'co':
                    return match.ordinalNumber(string, {
                        unit: 'day',
                        valueCallback: valueCallback
                    });
                // Tue
                case 'ccc':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // T
                case 'ccccc':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // Tu
                case 'cccccc':
                    return match.day(string, {
                        width: 'short',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // Tuesday
                case 'cccc':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $iMSzR.default)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]
    },
    // ISO day of week
    i: {
        priority: 90,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                if (value === 0) return 7;
                return value;
            };
            switch(token){
                // 2
                case 'i':
                case 'ii':
                    // 02
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
                // 2nd
                case 'io':
                    return match.ordinalNumber(string, {
                        unit: 'day'
                    });
                // Tue
                case 'iii':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
                // T
                case 'iiiii':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
                // Tu
                case 'iiiiii':
                    return match.day(string, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
                // Tuesday
                case 'iiii':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 7;
        },
        set: function(date, _flags, value, options) {
            date = (0, $ajDLz.default)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // AM or PM
    a: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'a':
                case 'aa':
                case 'aaa':
                    return match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaaa':
                    return match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaa':
                default:
                    return match.dayPeriod(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($a9a09c5462def3d7$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]
    },
    // AM, PM, midnight
    b: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'b':
                case 'bb':
                case 'bbb':
                    return match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbbb':
                    return match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbb':
                default:
                    return match.dayPeriod(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($a9a09c5462def3d7$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]
    },
    // in the morning, in the afternoon, in the evening, at night
    B: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'B':
                case 'BB':
                case 'BBB':
                    return match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBBB':
                    return match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBB':
                default:
                    return match.dayPeriod(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($a9a09c5462def3d7$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            't',
            'T'
        ]
    },
    // Hour [1-12]
    h: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'h':
                    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.hour12h, string);
                case 'ho':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 12;
        },
        set: function(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;
            if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
            else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
            else date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    // Hour [0-23]
    H: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'H':
                    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.hour23h, string);
                case 'Ho':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 23;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]
    },
    // Hour [0-11]
    K: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'K':
                    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.hour11h, string);
                case 'Ko':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;
            if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
            else date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'h',
            'H',
            'k',
            't',
            'T'
        ]
    },
    // Hour [1-24]
    k: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'k':
                    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.hour24h, string);
                case 'ko':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 24;
        },
        set: function(date, _flags, value, _options) {
            var hours = value <= 24 ? value % 24 : value;
            date.setUTCHours(hours, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]
    },
    // Minute
    m: {
        priority: 60,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'm':
                    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.minute, string);
                case 'mo':
                    return match.ordinalNumber(string, {
                        unit: 'minute'
                    });
                default:
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 59;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMinutes(value, 0, 0);
            return date;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    // Second
    s: {
        priority: 50,
        parse: function(string, token, match, _options) {
            switch(token){
                case 's':
                    return $a9a09c5462def3d7$var$parseNumericPattern($a9a09c5462def3d7$var$numericPatterns.second, string);
                case 'so':
                    return match.ordinalNumber(string, {
                        unit: 'second'
                    });
                default:
                    return $a9a09c5462def3d7$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 59;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCSeconds(value, 0);
            return date;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    // Fraction of second
    S: {
        priority: 30,
        parse: function(string, token, _match, _options) {
            var valueCallback = function(value) {
                return Math.floor(value * Math.pow(10, -token.length + 3));
            };
            return $a9a09c5462def3d7$var$parseNDigits(token.length, string, valueCallback);
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMilliseconds(value);
            return date;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    // Timezone (ISO-8601. +00:00 is `'Z'`)
    X: {
        priority: 10,
        parse: function(string, token, _match, _options) {
            switch(token){
                case 'X':
                    return $a9a09c5462def3d7$var$parseTimezonePattern($a9a09c5462def3d7$var$timezonePatterns.basicOptionalMinutes, string);
                case 'XX':
                    return $a9a09c5462def3d7$var$parseTimezonePattern($a9a09c5462def3d7$var$timezonePatterns.basic, string);
                case 'XXXX':
                    return $a9a09c5462def3d7$var$parseTimezonePattern($a9a09c5462def3d7$var$timezonePatterns.basicOptionalSeconds, string);
                case 'XXXXX':
                    return $a9a09c5462def3d7$var$parseTimezonePattern($a9a09c5462def3d7$var$timezonePatterns.extendedOptionalSeconds, string);
                case 'XXX':
                default:
                    return $a9a09c5462def3d7$var$parseTimezonePattern($a9a09c5462def3d7$var$timezonePatterns.extended, string);
            }
        },
        set: function(date, flags, value, _options) {
            if (flags.timestampIsSet) return date;
            return new Date(date.getTime() - value);
        },
        incompatibleTokens: [
            't',
            'T',
            'x'
        ]
    },
    // Timezone (ISO-8601)
    x: {
        priority: 10,
        parse: function(string, token, _match, _options) {
            switch(token){
                case 'x':
                    return $a9a09c5462def3d7$var$parseTimezonePattern($a9a09c5462def3d7$var$timezonePatterns.basicOptionalMinutes, string);
                case 'xx':
                    return $a9a09c5462def3d7$var$parseTimezonePattern($a9a09c5462def3d7$var$timezonePatterns.basic, string);
                case 'xxxx':
                    return $a9a09c5462def3d7$var$parseTimezonePattern($a9a09c5462def3d7$var$timezonePatterns.basicOptionalSeconds, string);
                case 'xxxxx':
                    return $a9a09c5462def3d7$var$parseTimezonePattern($a9a09c5462def3d7$var$timezonePatterns.extendedOptionalSeconds, string);
                case 'xxx':
                default:
                    return $a9a09c5462def3d7$var$parseTimezonePattern($a9a09c5462def3d7$var$timezonePatterns.extended, string);
            }
        },
        set: function(date, flags, value, _options) {
            if (flags.timestampIsSet) return date;
            return new Date(date.getTime() - value);
        },
        incompatibleTokens: [
            't',
            'T',
            'X'
        ]
    },
    // Seconds timestamp
    t: {
        priority: 40,
        parse: function(string, _token, _match, _options) {
            return $a9a09c5462def3d7$var$parseAnyDigitsSigned(string);
        },
        set: function(_date, _flags, value, _options) {
            return [
                new Date(value * 1000),
                {
                    timestampIsSet: true
                }
            ];
        },
        incompatibleTokens: '*'
    },
    // Milliseconds timestamp
    T: {
        priority: 20,
        parse: function(string, _token, _match, _options) {
            return $a9a09c5462def3d7$var$parseAnyDigitsSigned(string);
        },
        set: function(_date, _flags, value, _options) {
            return [
                new Date(value),
                {
                    timestampIsSet: true
                }
            ];
        },
        incompatibleTokens: '*'
    }
};
var $a9a09c5462def3d7$export$2e2bcd8739ae039 = $a9a09c5462def3d7$var$parsers;

});
parcelRegister("iMSzR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dad70b9d49228da0$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");

var $gPRuN = parcelRequire("gPRuN");
function $dad70b9d49228da0$export$2e2bcd8739ae039(dirtyDate, dirtyDay, dirtyOptions) {
    (0, $l1IMy.default)(2, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $gPRuN.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $gPRuN.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $uikl2.default)(dirtyDate);
    var day = (0, $gPRuN.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("ajDLz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $782a867d325da60d$export$2e2bcd8739ae039; });

var $uikl2 = parcelRequire("uikl2");

var $l1IMy = parcelRequire("l1IMy");

var $gPRuN = parcelRequire("gPRuN");
function $782a867d325da60d$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $l1IMy.default)(2, arguments);
    var day = (0, $gPRuN.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $uikl2.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("gFYW2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c23fbe21a3e9d7ec$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $faNbH = parcelRequire("faNbH");

var $l1IMy = parcelRequire("l1IMy");
function $c23fbe21a3e9d7ec$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var isoWeek = (0, $gPRuN.default)(dirtyISOWeek);
    var diff = (0, $faNbH.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("dFIau", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f415d9aa929cb5f$export$2e2bcd8739ae039; });

var $gPRuN = parcelRequire("gPRuN");

var $uikl2 = parcelRequire("uikl2");

var $7xu1W = parcelRequire("7xu1W");

var $l1IMy = parcelRequire("l1IMy");
function $9f415d9aa929cb5f$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $l1IMy.default)(2, arguments);
    var date = (0, $uikl2.default)(dirtyDate);
    var week = (0, $gPRuN.default)(dirtyWeek);
    var diff = (0, $7xu1W.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});



parcelRegister("1RhTA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $15a89f5e74b8913f$export$2e2bcd8739ae039; });

var $fiiUx = parcelRequire("fiiUx");

var $l1IMy = parcelRequire("l1IMy");

var $gPRuN = parcelRequire("gPRuN");
function $15a89f5e74b8913f$export$2e2bcd8739ae039(argument, dirtyOptions) {
    (0, $l1IMy.default)(1, arguments);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? 2 : (0, $gPRuN.default)(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $15a89f5e74b8913f$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $15a89f5e74b8913f$var$parseYear(dateStrings.date, additionalDigits);
        date = $15a89f5e74b8913f$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $15a89f5e74b8913f$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $15a89f5e74b8913f$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $15a89f5e74b8913f$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $15a89f5e74b8913f$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $15a89f5e74b8913f$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $15a89f5e74b8913f$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $15a89f5e74b8913f$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($15a89f5e74b8913f$var$patterns.dateTimeDelimiter);
    var timeString; // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($15a89f5e74b8913f$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($15a89f5e74b8913f$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $15a89f5e74b8913f$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $15a89f5e74b8913f$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex); // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $15a89f5e74b8913f$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($15a89f5e74b8913f$var$dateRegex); // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $15a89f5e74b8913f$var$parseDateUnit(captures[1]);
    var month = $15a89f5e74b8913f$var$parseDateUnit(captures[2]) - 1;
    var day = $15a89f5e74b8913f$var$parseDateUnit(captures[3]);
    var week = $15a89f5e74b8913f$var$parseDateUnit(captures[4]);
    var dayOfWeek = $15a89f5e74b8913f$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$15a89f5e74b8913f$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $15a89f5e74b8913f$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$15a89f5e74b8913f$var$validateDate(year, month, day) || !$15a89f5e74b8913f$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $15a89f5e74b8913f$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $15a89f5e74b8913f$var$parseTime(timeString) {
    var captures = timeString.match($15a89f5e74b8913f$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $15a89f5e74b8913f$var$parseTimeUnit(captures[1]);
    var minutes = $15a89f5e74b8913f$var$parseTimeUnit(captures[2]);
    var seconds = $15a89f5e74b8913f$var$parseTimeUnit(captures[3]);
    if (!$15a89f5e74b8913f$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $fiiUx.millisecondsInHour) + minutes * (0, $fiiUx.millisecondsInMinute) + seconds * 1000;
}
function $15a89f5e74b8913f$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $15a89f5e74b8913f$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($15a89f5e74b8913f$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$15a89f5e74b8913f$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $fiiUx.millisecondsInHour) + minutes * (0, $fiiUx.millisecondsInMinute));
}
function $15a89f5e74b8913f$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
} // Validation functions
// February is null to handle the leap year (using ||)
var $15a89f5e74b8913f$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $15a89f5e74b8913f$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $15a89f5e74b8913f$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($15a89f5e74b8913f$var$daysInMonths[month] || ($15a89f5e74b8913f$var$isLeapYearIndex(year) ? 29 : 28));
}
function $15a89f5e74b8913f$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($15a89f5e74b8913f$var$isLeapYearIndex(year) ? 366 : 365);
}
function $15a89f5e74b8913f$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $15a89f5e74b8913f$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $15a89f5e74b8913f$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});
parcelRegister("fiiUx", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", function () { return $b22734c988ed96b7$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $b22734c988ed96b7$export$7f72910d6dfd237a; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $b22734c988ed96b7$export$dfd9b671c89acc8e = 7;
var $b22734c988ed96b7$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $b22734c988ed96b7$export$91246f0b9bd9beff = 60000;
var $b22734c988ed96b7$export$7f72910d6dfd237a = 3600000;
var $b22734c988ed96b7$export$397c2d5776aa9055 = 1000;
var $b22734c988ed96b7$export$4dec998e48f9c246 = -$b22734c988ed96b7$export$81caae6e1cc7a622;
var $b22734c988ed96b7$export$f2f5ae5a8e2d8f9f = 60;
var $b22734c988ed96b7$export$3c58128db900d44e = 3;
var $b22734c988ed96b7$export$80d7e435f744f319 = 12;
var $b22734c988ed96b7$export$4db7641526e3241f = 4;
var $b22734c988ed96b7$export$698aec755e92c695 = 3600;
var $b22734c988ed96b7$export$a77c1a7ebebe2a5a = 60;

});


parcelRegister("bGse9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IGNORE_CLASS_NAME", function () { return $8819834e779be0f9$export$e2911fc69bd3195e; });
$parcel$export(module.exports, "default", function () { return $8819834e779be0f9$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
function $8819834e779be0f9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8819834e779be0f9$var$_setPrototypeOf(subClass, superClass);
}
function $8819834e779be0f9$var$_setPrototypeOf(o, p) {
    $8819834e779be0f9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8819834e779be0f9$var$_setPrototypeOf(o, p);
}
function $8819834e779be0f9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8819834e779be0f9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function $8819834e779be0f9$var$isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function $8819834e779be0f9$var$findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && $8819834e779be0f9$var$isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function $8819834e779be0f9$var$clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var $8819834e779be0f9$var$testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    var passive = false;
    var options = Object.defineProperty({}, 'passive', {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, options);
    window.removeEventListener('testPassiveEventSupport', noop, options);
    return passive;
};
function $8819834e779be0f9$var$autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var $8819834e779be0f9$var$uid = $8819834e779be0f9$var$autoInc();
var $8819834e779be0f9$var$passiveEventSupport;
var $8819834e779be0f9$var$handlersMap = {};
var $8819834e779be0f9$var$enabledInstances = {};
var $8819834e779be0f9$var$touchEvents = [
    'touchstart',
    'touchmove'
];
var $8819834e779be0f9$export$e2911fc69bd3195e = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */ function $8819834e779be0f9$var$getEventHandlerOptions(instance, eventName) {
    var handlerOptions = null;
    var isTouchEvent = $8819834e779be0f9$var$touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && $8819834e779be0f9$var$passiveEventSupport) handlerOptions = {
        passive: !instance.props.preventDefault
    };
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function $8819834e779be0f9$var$onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $8819834e779be0f9$var$_inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === 'function') {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === 'function') {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === 'function') {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === 'function') return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === 'function') return instance.setClickOutsideRef();
                return (0, $fw0lo.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === 'undefined' || $8819834e779be0f9$var$enabledInstances[_this._uid]) return;
                if (typeof $8819834e779be0f9$var$passiveEventSupport === 'undefined') $8819834e779be0f9$var$passiveEventSupport = $8819834e779be0f9$var$testPassiveEventSupport();
                $8819834e779be0f9$var$enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                $8819834e779be0f9$var$handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && $8819834e779be0f9$var$clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if ($8819834e779be0f9$var$findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, $8819834e779be0f9$var$handlersMap[_this._uid], $8819834e779be0f9$var$getEventHandlerOptions($8819834e779be0f9$var$_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete $8819834e779be0f9$var$enabledInstances[_this._uid];
                var fn = $8819834e779be0f9$var$handlersMap[_this._uid];
                if (fn && typeof document !== 'undefined') {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, $8819834e779be0f9$var$getEventHandlerOptions($8819834e779be0f9$var$_assertThisInitialized(_this), eventName));
                    });
                    delete $8819834e779be0f9$var$handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = $8819834e779be0f9$var$uid();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === 'undefined' || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === 'function') {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== 'function') throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        };
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = $8819834e779be0f9$var$_objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, $7fPBF.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, $7fPBF.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            'mousedown',
            'touchstart'
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: $8819834e779be0f9$export$e2911fc69bd3195e,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
var $8819834e779be0f9$export$2e2bcd8739ae039 = $8819834e779be0f9$var$onClickOutsideHOC;

});

parcelRegister("aYFRA", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return (parcelRequire("04tGR")).Popper; });
$parcel$export(module.exports, "Manager", function () { return (parcelRequire("cK45H")).Manager; });
$parcel$export(module.exports, "Reference", function () { return (parcelRequire("9EvNa")).Reference; });
$parcel$export(module.exports, "usePopper", function () { return (parcelRequire("2EMG5")).usePopper; });
// Public components

var $04tGR = parcelRequire("04tGR");

var $cK45H = parcelRequire("cK45H");

var $9EvNa = parcelRequire("9EvNa");

var $2EMG5 = parcelRequire("2EMG5");
 // Public types

});
parcelRegister("04tGR", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $00d767b55afb0685$export$badac9ada3a0bdf9; });

var $7fPBF = parcelRequire("7fPBF");

var $cK45H = parcelRequire("cK45H");

var $1nU4Z = parcelRequire("1nU4Z");

var $2EMG5 = parcelRequire("2EMG5");
var $00d767b55afb0685$var$NOOP = function NOOP() {
    return void 0;
};
var $00d767b55afb0685$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $00d767b55afb0685$var$EMPTY_MODIFIERS = [];
function $00d767b55afb0685$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $00d767b55afb0685$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $7fPBF.useContext((0, $cK45H.ManagerReferenceNodeContext));
    var _React$useState = $7fPBF.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $7fPBF.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $7fPBF.useEffect(function() {
        (0, $1nU4Z.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $7fPBF.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $2EMG5.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $7fPBF.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $00d767b55afb0685$var$NOOP,
            update: update || $00d767b55afb0685$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $1nU4Z.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("cK45H", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $946cf4462dcf0c84$export$3dbd3405086fec7b; });
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", function () { return $946cf4462dcf0c84$export$cbabb21c2529b130; });
$parcel$export(module.exports, "Manager", function () { return $946cf4462dcf0c84$export$d0d38e7dec7a1a61; });

var $7fPBF = parcelRequire("7fPBF");
var $946cf4462dcf0c84$export$3dbd3405086fec7b = $7fPBF.createContext();
var $946cf4462dcf0c84$export$cbabb21c2529b130 = $7fPBF.createContext();
function $946cf4462dcf0c84$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $7fPBF.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $7fPBF.useRef(false);
    $7fPBF.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $7fPBF.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $7fPBF.createElement($946cf4462dcf0c84$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $7fPBF.createElement($946cf4462dcf0c84$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("1nU4Z", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", function () { return $102370a2b7376d38$export$f52c55943429c8b6; });
$parcel$export(module.exports, "safeInvoke", function () { return $102370a2b7376d38$export$3dfa7c28635fe028; });
$parcel$export(module.exports, "setRef", function () { return $102370a2b7376d38$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $102370a2b7376d38$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $102370a2b7376d38$export$700979bc83e7db82; });

var $7fPBF = parcelRequire("7fPBF");
var $102370a2b7376d38$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $102370a2b7376d38$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $102370a2b7376d38$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $102370a2b7376d38$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $102370a2b7376d38$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $102370a2b7376d38$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;

});

parcelRegister("2EMG5", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $1ef5139d3c6891c9$export$f4d5bf230a36dd6e; });

var $7fPBF = parcelRequire("7fPBF");

var $efdLW = parcelRequire("efdLW");

var $iC4RG = parcelRequire("iC4RG");

var $1nU4Z = parcelRequire("1nU4Z");
var $1ef5139d3c6891c9$var$EMPTY_MODIFIERS = [];
var $1ef5139d3c6891c9$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $7fPBF.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $1ef5139d3c6891c9$var$EMPTY_MODIFIERS
    };
    var _React$useState = $7fPBF.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $7fPBF.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                setState({
                    styles: (0, $1nU4Z.fromEntries)(elements.map(function(element) {
                        return [
                            element,
                            state.styles[element] || {}
                        ];
                    })),
                    attributes: (0, $1nU4Z.fromEntries)(elements.map(function(element) {
                        return [
                            element,
                            state.attributes[element]
                        ];
                    }))
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $7fPBF.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $7fPBF.useRef();
    (0, $1nU4Z.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $1nU4Z.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $efdLW.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("efdLW", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $a5ed26444bdb4d3e$export$8f7491d57c8f97a9; });

var $bDLFF = parcelRequire("bDLFF");

var $1PRym = parcelRequire("1PRym");

var $jh6oc = parcelRequire("jh6oc");

var $eWblW = parcelRequire("eWblW");

var $7TCz5 = parcelRequire("7TCz5");

var $eylfk = parcelRequire("eylfk");

var $exXrj = parcelRequire("exXrj");

var $hOZ6Q = parcelRequire("hOZ6Q");

var $jUFYE = parcelRequire("jUFYE");

var $a2tLm = parcelRequire("a2tLm");


var $a5ed26444bdb4d3e$export$d34966752335dd47 = [
    (0, $1PRym.default),
    (0, $jh6oc.default),
    (0, $eWblW.default),
    (0, $7TCz5.default),
    (0, $eylfk.default),
    (0, $exXrj.default),
    (0, $hOZ6Q.default),
    (0, $jUFYE.default),
    (0, $a2tLm.default)
];
var $a5ed26444bdb4d3e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $bDLFF.popperGenerator)({
    defaultModifiers: $a5ed26444bdb4d3e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("bDLFF", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $879850b738b0fd85$export$ed5e13716264f202; });

var $7A5zv = parcelRequire("7A5zv");

var $aooBM = parcelRequire("aooBM");

var $5fhgl = parcelRequire("5fhgl");

var $9vuui = parcelRequire("9vuui");


var $1HbbS = parcelRequire("1HbbS");

var $6zw26 = parcelRequire("6zw26");




var $4irPP = parcelRequire("4irPP");


var $kWkO0 = parcelRequire("kWkO0");

var $879850b738b0fd85$var$INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var $879850b738b0fd85$var$INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var $879850b738b0fd85$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $879850b738b0fd85$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $879850b738b0fd85$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $879850b738b0fd85$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $879850b738b0fd85$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $kWkO0.isElement)(reference) ? (0, $5fhgl.default)(reference) : reference.contextElement ? (0, $5fhgl.default)(reference.contextElement) : [],
                    popper: (0, $5fhgl.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $1HbbS.default)((0, $4irPP.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $7A5zv.default)(reference, (0, $9vuui.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $aooBM.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6zw26.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $879850b738b0fd85$export$8f7491d57c8f97a9 = /*#__PURE__*/ $879850b738b0fd85$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("7A5zv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $585037a155f95873$export$2e2bcd8739ae039; });

var $jTgmx = parcelRequire("jTgmx");

var $luMSI = parcelRequire("luMSI");

var $fRINz = parcelRequire("fRINz");

var $kWkO0 = parcelRequire("kWkO0");

var $jhPl0 = parcelRequire("jhPl0");

var $aMuSx = parcelRequire("aMuSx");

var $dbfQ4 = parcelRequire("dbfQ4");

var $hsTEw = parcelRequire("hsTEw");
function $585037a155f95873$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $hsTEw.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $hsTEw.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $585037a155f95873$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $kWkO0.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $kWkO0.isHTMLElement)(offsetParent) && $585037a155f95873$var$isElementScaled(offsetParent);
    var documentElement = (0, $aMuSx.default)(offsetParent);
    var rect = (0, $jTgmx.default)(elementOrVirtualElement, offsetParentIsScaled);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $fRINz.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $dbfQ4.default)(documentElement)) scroll = (0, $luMSI.default)(offsetParent);
        if ((0, $kWkO0.isHTMLElement)(offsetParent)) {
            offsets = (0, $jTgmx.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $jhPl0.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("jTgmx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7afd89efa353b85$export$2e2bcd8739ae039; });

var $kWkO0 = parcelRequire("kWkO0");

var $hsTEw = parcelRequire("hsTEw");
function $e7afd89efa353b85$export$2e2bcd8739ae039(element, includeScale) {
    if (includeScale === void 0) includeScale = false;
    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if ((0, $kWkO0.isHTMLElement)(element) && includeScale) {
        var offsetHeight = element.offsetHeight;
        var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
        // Fallback to 1 in case both values are `0`
        if (offsetWidth > 0) scaleX = (0, $hsTEw.round)(rect.width) / offsetWidth || 1;
        if (offsetHeight > 0) scaleY = (0, $hsTEw.round)(rect.height) / offsetHeight || 1;
    }
    return {
        width: rect.width / scaleX,
        height: rect.height / scaleY,
        top: rect.top / scaleY,
        right: rect.right / scaleX,
        bottom: rect.bottom / scaleY,
        left: rect.left / scaleX,
        x: rect.left / scaleX,
        y: rect.top / scaleY
    };
}

});
parcelRegister("kWkO0", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $f3e95cf60f991b3e$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $f3e95cf60f991b3e$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $f3e95cf60f991b3e$export$af51f0f06c0f328a; });

var $7LvDQ = parcelRequire("7LvDQ");
function $f3e95cf60f991b3e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $7LvDQ.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f3e95cf60f991b3e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $7LvDQ.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f3e95cf60f991b3e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $7LvDQ.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("7LvDQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a7577945ba4d648$export$2e2bcd8739ae039; });
function $5a7577945ba4d648$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("hsTEw", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $cb70389d1b75072d$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $cb70389d1b75072d$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $cb70389d1b75072d$export$2077e0241d6afd3c; });
var $cb70389d1b75072d$export$8960430cfd85939f = Math.max;
var $cb70389d1b75072d$export$96ec731ed4dcb222 = Math.min;
var $cb70389d1b75072d$export$2077e0241d6afd3c = Math.round;

});


parcelRegister("luMSI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa62512f527d34a4$export$2e2bcd8739ae039; });

var $k28Ly = parcelRequire("k28Ly");

var $7LvDQ = parcelRequire("7LvDQ");

var $kWkO0 = parcelRequire("kWkO0");

var $91ESz = parcelRequire("91ESz");
function $fa62512f527d34a4$export$2e2bcd8739ae039(node) {
    if (node === (0, $7LvDQ.default)(node) || !(0, $kWkO0.isHTMLElement)(node)) return (0, $k28Ly.default)(node);
    else return (0, $91ESz.default)(node);
}

});
parcelRegister("k28Ly", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e95acb4acf5ee909$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");
function $e95acb4acf5ee909$export$2e2bcd8739ae039(node) {
    var win = (0, $7LvDQ.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("91ESz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6923eaccf7a43aef$export$2e2bcd8739ae039; });
function $6923eaccf7a43aef$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("fRINz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8ce8e5214ef2302$export$2e2bcd8739ae039; });
function $b8ce8e5214ef2302$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("jhPl0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0a76d77d33c9d6e$export$2e2bcd8739ae039; });

var $jTgmx = parcelRequire("jTgmx");

var $aMuSx = parcelRequire("aMuSx");

var $k28Ly = parcelRequire("k28Ly");
function $e0a76d77d33c9d6e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $jTgmx.default)((0, $aMuSx.default)(element)).left + (0, $k28Ly.default)(element).scrollLeft;
}

});
parcelRegister("aMuSx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d9656f011992b2b$export$2e2bcd8739ae039; });

var $kWkO0 = parcelRequire("kWkO0");
function $7d9656f011992b2b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $kWkO0.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("dbfQ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $998896b7349c78b7$export$2e2bcd8739ae039; });

var $5lm85 = parcelRequire("5lm85");
function $998896b7349c78b7$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5lm85.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("5lm85", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e40145ffd569d9c$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");
function $3e40145ffd569d9c$export$2e2bcd8739ae039(element) {
    return (0, $7LvDQ.default)(element).getComputedStyle(element);
}

});



parcelRegister("aooBM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $790f3bf845b39e8e$export$2e2bcd8739ae039; });

var $jTgmx = parcelRequire("jTgmx");
function $790f3bf845b39e8e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $jTgmx.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("5fhgl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d1bbe7c8c599173$export$2e2bcd8739ae039; });

var $2vPbO = parcelRequire("2vPbO");

var $d8xUD = parcelRequire("d8xUD");

var $7LvDQ = parcelRequire("7LvDQ");

var $dbfQ4 = parcelRequire("dbfQ4");
function $3d1bbe7c8c599173$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2vPbO.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $7LvDQ.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $dbfQ4.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3d1bbe7c8c599173$export$2e2bcd8739ae039((0, $d8xUD.default)(target)));
}

});
parcelRegister("2vPbO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d462f2c86b4c65a$export$2e2bcd8739ae039; });

var $d8xUD = parcelRequire("d8xUD");

var $dbfQ4 = parcelRequire("dbfQ4");

var $fRINz = parcelRequire("fRINz");

var $kWkO0 = parcelRequire("kWkO0");
function $1d462f2c86b4c65a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $fRINz.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $kWkO0.isHTMLElement)(node) && (0, $dbfQ4.default)(node)) return node;
    return $1d462f2c86b4c65a$export$2e2bcd8739ae039((0, $d8xUD.default)(node));
}

});
parcelRegister("d8xUD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9906540837c752ea$export$2e2bcd8739ae039; });

var $fRINz = parcelRequire("fRINz");

var $aMuSx = parcelRequire("aMuSx");

var $kWkO0 = parcelRequire("kWkO0");
function $9906540837c752ea$export$2e2bcd8739ae039(element) {
    if ((0, $fRINz.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $kWkO0.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $aMuSx.default)(element) // fallback
    );
}

});



parcelRegister("9vuui", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ebea87f6f98e49c$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");

var $fRINz = parcelRequire("fRINz");

var $5lm85 = parcelRequire("5lm85");

var $kWkO0 = parcelRequire("kWkO0");

var $KQ9YG = parcelRequire("KQ9YG");

var $d8xUD = parcelRequire("d8xUD");
function $6ebea87f6f98e49c$var$getTrueOffsetParent(element) {
    if (!(0, $kWkO0.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5lm85.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6ebea87f6f98e49c$var$getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
    var isIE = navigator.userAgent.indexOf('Trident') !== -1;
    if (isIE && (0, $kWkO0.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5lm85.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $d8xUD.default)(element);
    if ((0, $kWkO0.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $kWkO0.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $fRINz.default)(currentNode)) < 0){
        var css = (0, $5lm85.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6ebea87f6f98e49c$export$2e2bcd8739ae039(element) {
    var window = (0, $7LvDQ.default)(element);
    var offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $KQ9YG.default)(offsetParent) && (0, $5lm85.default)(offsetParent).position === 'static')offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $fRINz.default)(offsetParent) === 'html' || (0, $fRINz.default)(offsetParent) === 'body' && (0, $5lm85.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $6ebea87f6f98e49c$var$getContainingBlock(element) || window;
}

});
parcelRegister("KQ9YG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08ccc1de57d53c59$export$2e2bcd8739ae039; });

var $fRINz = parcelRequire("fRINz");
function $08ccc1de57d53c59$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $fRINz.default)(element)) >= 0;
}

});


parcelRegister("1HbbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13c27cceb4b24b2f$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");
function $13c27cceb4b24b2f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $13c27cceb4b24b2f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $13c27cceb4b24b2f$var$order(modifiers); // order based on phase
    return (0, $aHbEK.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("aHbEK", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $7c96f63dd602b579$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $7c96f63dd602b579$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $7c96f63dd602b579$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $7c96f63dd602b579$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $7c96f63dd602b579$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $7c96f63dd602b579$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $7c96f63dd602b579$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $7c96f63dd602b579$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $7c96f63dd602b579$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $7c96f63dd602b579$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $7c96f63dd602b579$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $7c96f63dd602b579$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $7c96f63dd602b579$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $7c96f63dd602b579$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $7c96f63dd602b579$export$d087d3878fdf71d5; });
var $7c96f63dd602b579$export$1e95b668f3b82d = 'top';
var $7c96f63dd602b579$export$40e543e69a8b3fbb = 'bottom';
var $7c96f63dd602b579$export$79ffe56a765070d2 = 'right';
var $7c96f63dd602b579$export$eabcd2c8791e7bf4 = 'left';
var $7c96f63dd602b579$export$dfb5619354ba860 = 'auto';
var $7c96f63dd602b579$export$aec2ce47c367b8c3 = [
    $7c96f63dd602b579$export$1e95b668f3b82d,
    $7c96f63dd602b579$export$40e543e69a8b3fbb,
    $7c96f63dd602b579$export$79ffe56a765070d2,
    $7c96f63dd602b579$export$eabcd2c8791e7bf4
];
var $7c96f63dd602b579$export$b3571188c770cc5a = 'start';
var $7c96f63dd602b579$export$bd5df0f255a350f8 = 'end';
var $7c96f63dd602b579$export$390fd549c5303b4d = 'clippingParents';
var $7c96f63dd602b579$export$d7b7311ec04a3e8f = 'viewport';
var $7c96f63dd602b579$export$ae5ab1c730825774 = 'popper';
var $7c96f63dd602b579$export$ca50aac9f3ba507f = 'reference';
var $7c96f63dd602b579$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7c96f63dd602b579$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []);
var $7c96f63dd602b579$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7c96f63dd602b579$export$aec2ce47c367b8c3, [
    $7c96f63dd602b579$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7c96f63dd602b579$export$421679a7c3d56e = 'beforeRead';
var $7c96f63dd602b579$export$aafa59e2e03f2942 = 'read';
var $7c96f63dd602b579$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $7c96f63dd602b579$export$c65e99957a05207c = 'beforeMain';
var $7c96f63dd602b579$export$f22da7240b7add18 = 'main';
var $7c96f63dd602b579$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7c96f63dd602b579$export$8d4d2d70e7d46032 = 'beforeWrite';
var $7c96f63dd602b579$export$68d8715fc104d294 = 'write';
var $7c96f63dd602b579$export$70a6e5159acce2e6 = 'afterWrite';
var $7c96f63dd602b579$export$d087d3878fdf71d5 = [
    $7c96f63dd602b579$export$421679a7c3d56e,
    $7c96f63dd602b579$export$aafa59e2e03f2942,
    $7c96f63dd602b579$export$6964f6c886723980,
    $7c96f63dd602b579$export$c65e99957a05207c,
    $7c96f63dd602b579$export$f22da7240b7add18,
    $7c96f63dd602b579$export$bab79516f2d662fe,
    $7c96f63dd602b579$export$8d4d2d70e7d46032,
    $7c96f63dd602b579$export$68d8715fc104d294,
    $7c96f63dd602b579$export$70a6e5159acce2e6
];

});


parcelRegister("6zw26", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c8edc0cb4d5666b$export$2e2bcd8739ae039; });
function $4c8edc0cb4d5666b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("4irPP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $320e6f4d2835a922$export$2e2bcd8739ae039; });
function $320e6f4d2835a922$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("1PRym", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1564186ea0096528$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");
var $1564186ea0096528$var$passive = {
    passive: true
};
function $1564186ea0096528$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $7LvDQ.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1564186ea0096528$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1564186ea0096528$var$effect,
    data: {}
};

});

parcelRegister("jh6oc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0848fa64ca744df$export$2e2bcd8739ae039; });

var $gIQYz = parcelRequire("gIQYz");
function $e0848fa64ca744df$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $gIQYz.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0848fa64ca744df$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e0848fa64ca744df$var$popperOffsets,
    data: {}
};

});
parcelRegister("gIQYz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c9d9550c09d816$export$2e2bcd8739ae039; });

var $3ZGTg = parcelRequire("3ZGTg");

var $hD45i = parcelRequire("hD45i");

var $4p02M = parcelRequire("4p02M");

var $aHbEK = parcelRequire("aHbEK");
function $c2c9d9550c09d816$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3ZGTg.default)(placement) : null;
    var variation = placement ? (0, $hD45i.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $aHbEK.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $aHbEK.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $aHbEK.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $aHbEK.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $4p02M.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $aHbEK.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $aHbEK.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("3ZGTg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e8856bdb677ff8e$export$2e2bcd8739ae039; });

function $2e8856bdb677ff8e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hD45i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd593f453867f36a$export$2e2bcd8739ae039; });
function $cd593f453867f36a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("4p02M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $334987ecb6fc56c7$export$2e2bcd8739ae039; });
function $334987ecb6fc56c7$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("eWblW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adff49e8d09ee1e5$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $9vuui = parcelRequire("9vuui");

var $7LvDQ = parcelRequire("7LvDQ");

var $aMuSx = parcelRequire("aMuSx");

var $5lm85 = parcelRequire("5lm85");

var $3ZGTg = parcelRequire("3ZGTg");

var $hD45i = parcelRequire("hD45i");

var $hsTEw = parcelRequire("hsTEw");
var $adff49e8d09ee1e5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $adff49e8d09ee1e5$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $hsTEw.round)(x * dpr) / dpr || 0,
        y: (0, $hsTEw.round)(y * dpr) / dpr || 0
    };
}
function $adff49e8d09ee1e5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $aHbEK.left);
    var sideY = (0, $aHbEK.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $9vuui.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $7LvDQ.default)(popper)) {
            offsetParent = (0, $aMuSx.default)(popper);
            if ((0, $5lm85.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $aHbEK.top) || (placement === (0, $aHbEK.left) || placement === (0, $aHbEK.right)) && variation === (0, $aHbEK.end)) {
            sideY = (0, $aHbEK.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $aHbEK.left) || (placement === (0, $aHbEK.top) || placement === (0, $aHbEK.bottom)) && variation === (0, $aHbEK.end)) {
            sideX = (0, $aHbEK.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $adff49e8d09ee1e5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $adff49e8d09ee1e5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $adff49e8d09ee1e5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $3ZGTg.default)(state.placement),
        variation: (0, $hD45i.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $adff49e8d09ee1e5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $adff49e8d09ee1e5$var$computeStyles,
    data: {}
};

});

parcelRegister("7TCz5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bfb95a331f35baa$export$2e2bcd8739ae039; });

var $fRINz = parcelRequire("fRINz");

var $kWkO0 = parcelRequire("kWkO0");
// and applies them to the HTMLElements such as popper and arrow
function $5bfb95a331f35baa$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $kWkO0.isHTMLElement)(element) || !(0, $fRINz.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $5bfb95a331f35baa$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $kWkO0.isHTMLElement)(element) || !(0, $fRINz.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $5bfb95a331f35baa$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $5bfb95a331f35baa$var$applyStyles,
    effect: $5bfb95a331f35baa$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("eylfk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a984b8b647b41eeb$export$2e2bcd8739ae039; });

var $3ZGTg = parcelRequire("3ZGTg");

var $aHbEK = parcelRequire("aHbEK");
function $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3ZGTg.default)(placement);
    var invertDistance = [
        (0, $aHbEK.left),
        (0, $aHbEK.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $aHbEK.left),
        (0, $aHbEK.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a984b8b647b41eeb$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $aHbEK.placements).reduce(function(acc, placement) {
        acc[placement] = $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a984b8b647b41eeb$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a984b8b647b41eeb$var$offset
};

});

parcelRegister("exXrj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a97241372b70cd07$export$2e2bcd8739ae039; });

var $910or = parcelRequire("910or");

var $3ZGTg = parcelRequire("3ZGTg");

var $1EPiP = parcelRequire("1EPiP");

var $74FGG = parcelRequire("74FGG");

var $ewHfg = parcelRequire("ewHfg");

var $aHbEK = parcelRequire("aHbEK");

var $hD45i = parcelRequire("hD45i");
function $a97241372b70cd07$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3ZGTg.default)(placement) === (0, $aHbEK.auto)) return [];
    var oppositePlacement = (0, $910or.default)(placement);
    return [
        (0, $1EPiP.default)(placement),
        oppositePlacement,
        (0, $1EPiP.default)(oppositePlacement)
    ];
}
function $a97241372b70cd07$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3ZGTg.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $910or.default)(preferredPlacement)
    ] : $a97241372b70cd07$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3ZGTg.default)(placement) === (0, $aHbEK.auto) ? (0, $ewHfg.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3ZGTg.default)(placement);
        var isStartVariation = (0, $hD45i.default)(placement) === (0, $aHbEK.start);
        var isVertical = [
            (0, $aHbEK.top),
            (0, $aHbEK.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $74FGG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $aHbEK.right) : (0, $aHbEK.left) : isStartVariation ? (0, $aHbEK.bottom) : (0, $aHbEK.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $910or.default)(mainVariationSide);
        var altVariationSide = (0, $910or.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a97241372b70cd07$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a97241372b70cd07$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("910or", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $690483208b9a3207$export$2e2bcd8739ae039; });
var $690483208b9a3207$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $690483208b9a3207$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $690483208b9a3207$var$hash[matched];
    });
}

});

parcelRegister("1EPiP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13515282412eb271$export$2e2bcd8739ae039; });
var $13515282412eb271$var$hash = {
    start: 'end',
    end: 'start'
};
function $13515282412eb271$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $13515282412eb271$var$hash[matched];
    });
}

});

parcelRegister("74FGG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52693e6050d55014$export$2e2bcd8739ae039; });

var $bxNPU = parcelRequire("bxNPU");

var $aMuSx = parcelRequire("aMuSx");

var $jTgmx = parcelRequire("jTgmx");

var $gIQYz = parcelRequire("gIQYz");

var $245PV = parcelRequire("245PV");

var $aHbEK = parcelRequire("aHbEK");

var $kWkO0 = parcelRequire("kWkO0");

var $lVDOe = parcelRequire("lVDOe");

var $hf3yY = parcelRequire("hf3yY");
function $52693e6050d55014$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $aHbEK.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $aHbEK.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $aHbEK.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $lVDOe.default)(typeof padding !== 'number' ? padding : (0, $hf3yY.default)(padding, (0, $aHbEK.basePlacements)));
    var altContext = elementContext === (0, $aHbEK.popper) ? (0, $aHbEK.reference) : (0, $aHbEK.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $bxNPU.default)((0, $kWkO0.isElement)(element) ? element : element.contextElement || (0, $aMuSx.default)(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = (0, $jTgmx.default)(state.elements.reference);
    var popperOffsets = (0, $gIQYz.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $245PV.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $aHbEK.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $aHbEK.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $aHbEK.right),
                (0, $aHbEK.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $aHbEK.top),
                (0, $aHbEK.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("bxNPU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86796f3d3717fc99$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $tIQGN = parcelRequire("tIQGN");

var $kNUmP = parcelRequire("kNUmP");

var $5fhgl = parcelRequire("5fhgl");

var $9vuui = parcelRequire("9vuui");

var $aMuSx = parcelRequire("aMuSx");

var $5lm85 = parcelRequire("5lm85");

var $kWkO0 = parcelRequire("kWkO0");

var $jTgmx = parcelRequire("jTgmx");

var $d8xUD = parcelRequire("d8xUD");

var $ltVxa = parcelRequire("ltVxa");

var $fRINz = parcelRequire("fRINz");

var $245PV = parcelRequire("245PV");

var $hsTEw = parcelRequire("hsTEw");
function $86796f3d3717fc99$var$getInnerBoundingClientRect(element) {
    var rect = (0, $jTgmx.default)(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === (0, $aHbEK.viewport) ? (0, $245PV.default)((0, $tIQGN.default)(element)) : (0, $kWkO0.isElement)(clippingParent) ? $86796f3d3717fc99$var$getInnerBoundingClientRect(clippingParent) : (0, $245PV.default)((0, $kNUmP.default)((0, $aMuSx.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $86796f3d3717fc99$var$getClippingParents(element) {
    var clippingParents = (0, $5fhgl.default)((0, $d8xUD.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $5lm85.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $kWkO0.isHTMLElement)(element) ? (0, $9vuui.default)(element) : element;
    if (!(0, $kWkO0.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $kWkO0.isElement)(clippingParent) && (0, $ltVxa.default)(clippingParent, clipperElement) && (0, $fRINz.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $86796f3d3717fc99$export$2e2bcd8739ae039(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === 'clippingParents' ? $86796f3d3717fc99$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent);
        accRect.top = (0, $hsTEw.max)(rect.top, accRect.top);
        accRect.right = (0, $hsTEw.min)(rect.right, accRect.right);
        accRect.bottom = (0, $hsTEw.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $hsTEw.max)(rect.left, accRect.left);
        return accRect;
    }, $86796f3d3717fc99$var$getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("tIQGN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05957f974ad3b041$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");

var $aMuSx = parcelRequire("aMuSx");

var $jhPl0 = parcelRequire("jhPl0");
function $05957f974ad3b041$export$2e2bcd8739ae039(element) {
    var win = (0, $7LvDQ.default)(element);
    var html = (0, $aMuSx.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
        // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
        // errors due to floating point numbers, so we need to check precision.
        // Safari returns a number <= 0, usually < -1 when pinch-zoomed
        // Feature detection fails in mobile emulation mode in Chrome.
        // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
        // 0.001
        // Fallback here: "Not Safari" userAgent
        if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $jhPl0.default)(element),
        y: y
    };
}

});

parcelRegister("kNUmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2541b971d258cf0$export$2e2bcd8739ae039; });

var $aMuSx = parcelRequire("aMuSx");

var $5lm85 = parcelRequire("5lm85");

var $jhPl0 = parcelRequire("jhPl0");

var $k28Ly = parcelRequire("k28Ly");

var $hsTEw = parcelRequire("hsTEw");
function $f2541b971d258cf0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $aMuSx.default)(element);
    var winScroll = (0, $k28Ly.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $hsTEw.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $hsTEw.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $jhPl0.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5lm85.default)(body || html).direction === 'rtl') x += (0, $hsTEw.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ltVxa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa38ef77d76834a0$export$2e2bcd8739ae039; });

var $kWkO0 = parcelRequire("kWkO0");
function $fa38ef77d76834a0$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $kWkO0.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("245PV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18107b7e48021ffa$export$2e2bcd8739ae039; });
function $18107b7e48021ffa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("lVDOe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff6dcd1b0906e9b8$export$2e2bcd8739ae039; });

var $2CmeP = parcelRequire("2CmeP");
function $ff6dcd1b0906e9b8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $2CmeP.default)(), paddingObject);
}

});
parcelRegister("2CmeP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e806166c2cdf48d$export$2e2bcd8739ae039; });
function $1e806166c2cdf48d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hf3yY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8d699eb93b3090c$export$2e2bcd8739ae039; });
function $c8d699eb93b3090c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("ewHfg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a935996b3496591b$export$2e2bcd8739ae039; });

var $hD45i = parcelRequire("hD45i");

var $aHbEK = parcelRequire("aHbEK");

var $74FGG = parcelRequire("74FGG");

var $3ZGTg = parcelRequire("3ZGTg");
function $a935996b3496591b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $aHbEK.placements) : _options$allowedAutoP;
    var variation = (0, $hD45i.default)(placement);
    var placements = variation ? flipVariations ? (0, $aHbEK.variationPlacements) : (0, $aHbEK.variationPlacements).filter(function(placement) {
        return (0, $hD45i.default)(placement) === variation;
    }) : (0, $aHbEK.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $74FGG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3ZGTg.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("hOZ6Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf968237b9d7dd4a$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $3ZGTg = parcelRequire("3ZGTg");

var $4p02M = parcelRequire("4p02M");

var $c8xyK = parcelRequire("c8xyK");

var $1MeQS = parcelRequire("1MeQS");

var $aooBM = parcelRequire("aooBM");

var $9vuui = parcelRequire("9vuui");

var $74FGG = parcelRequire("74FGG");

var $hD45i = parcelRequire("hD45i");

var $2CmeP = parcelRequire("2CmeP");

var $hsTEw = parcelRequire("hsTEw");
function $cf968237b9d7dd4a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $74FGG.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3ZGTg.default)(state.placement);
    var variation = (0, $hD45i.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $4p02M.default)(basePlacement);
    var altAxis = (0, $c8xyK.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $aHbEK.top) : (0, $aHbEK.left);
        var altSide = mainAxis === 'y' ? (0, $aHbEK.bottom) : (0, $aHbEK.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $aHbEK.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $aHbEK.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $aooBM.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $2CmeP.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1MeQS.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $9vuui.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1MeQS.within)(tether ? (0, $hsTEw.min)(min, tetherMin) : min, offset, tether ? (0, $hsTEw.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $aHbEK.top) : (0, $aHbEK.left);
        var _altSide = mainAxis === 'x' ? (0, $aHbEK.bottom) : (0, $aHbEK.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $aHbEK.top),
            (0, $aHbEK.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1MeQS.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1MeQS.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cf968237b9d7dd4a$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $cf968237b9d7dd4a$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("c8xyK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d60439f259d6a8c$export$2e2bcd8739ae039; });
function $8d60439f259d6a8c$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("1MeQS", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $14b5cb667dce379f$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $14b5cb667dce379f$export$86c8af6d3ef0b4a; });

var $hsTEw = parcelRequire("hsTEw");
function $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max) {
    return (0, $hsTEw.max)(min, (0, $hsTEw.min)(value, max));
}
function $14b5cb667dce379f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("jUFYE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7f3cf13e0769248$export$2e2bcd8739ae039; });

var $3ZGTg = parcelRequire("3ZGTg");

var $aooBM = parcelRequire("aooBM");

var $ltVxa = parcelRequire("ltVxa");

var $9vuui = parcelRequire("9vuui");

var $4p02M = parcelRequire("4p02M");

var $1MeQS = parcelRequire("1MeQS");

var $lVDOe = parcelRequire("lVDOe");

var $hf3yY = parcelRequire("hf3yY");

var $aHbEK = parcelRequire("aHbEK");

var $e7f3cf13e0769248$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $lVDOe.default)(typeof padding !== 'number' ? padding : (0, $hf3yY.default)(padding, (0, $aHbEK.basePlacements)));
};
function $e7f3cf13e0769248$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3ZGTg.default)(state.placement);
    var axis = (0, $4p02M.default)(basePlacement);
    var isVertical = [
        (0, $aHbEK.left),
        (0, $aHbEK.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e7f3cf13e0769248$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $aooBM.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $aHbEK.top) : (0, $aHbEK.left);
    var maxProp = axis === 'y' ? (0, $aHbEK.bottom) : (0, $aHbEK.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $9vuui.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1MeQS.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e7f3cf13e0769248$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ltVxa.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e7f3cf13e0769248$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $e7f3cf13e0769248$var$arrow,
    effect: $e7f3cf13e0769248$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("a2tLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74f12d998f890694$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $74FGG = parcelRequire("74FGG");
function $74f12d998f890694$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $74f12d998f890694$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $aHbEK.top),
        (0, $aHbEK.right),
        (0, $aHbEK.bottom),
        (0, $aHbEK.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $74f12d998f890694$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $74FGG.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $74FGG.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $74f12d998f890694$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $74f12d998f890694$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $74f12d998f890694$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $74f12d998f890694$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $74f12d998f890694$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $74f12d998f890694$var$hide
};

});


parcelRegister("iC4RG", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $d8cf8ca5172c2b64$var$hasElementType = typeof Element !== 'undefined';
var $d8cf8ca5172c2b64$var$hasMap = typeof Map === 'function';
var $d8cf8ca5172c2b64$var$hasSet = typeof Set === 'function';
var $d8cf8ca5172c2b64$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $d8cf8ca5172c2b64$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$d8cf8ca5172c2b64$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($d8cf8ca5172c2b64$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$d8cf8ca5172c2b64$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($d8cf8ca5172c2b64$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($d8cf8ca5172c2b64$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($d8cf8ca5172c2b64$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$d8cf8ca5172c2b64$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $d8cf8ca5172c2b64$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("9EvNa", function(module, exports) {

$parcel$export(module.exports, "Reference", function () { return $707082bb5d4c97c5$export$e0be378c32fb70a7; });

var $7fPBF = parcelRequire("7fPBF");

var $6Buvl = parcelRequire("6Buvl");

var $cK45H = parcelRequire("cK45H");

var $1nU4Z = parcelRequire("1nU4Z");
function $707082bb5d4c97c5$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $7fPBF.useContext((0, $cK45H.ManagerReferenceNodeSetterContext));
    var refHandler = $7fPBF.useCallback(function(node) {
        (0, $1nU4Z.setRef)(innerRef, node);
        (0, $1nU4Z.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    $7fPBF.useEffect(function() {
        return function() {
            return (0, $1nU4Z.setRef)(innerRef, null);
        };
    });
    $7fPBF.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6Buvl)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $1nU4Z.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("6Buvl", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $4ceddc5ee7e9d694$var$__DEV__ = false;
var $4ceddc5ee7e9d694$var$warning = function() {};
if ($4ceddc5ee7e9d694$var$__DEV__) {
    var $4ceddc5ee7e9d694$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $4ceddc5ee7e9d694$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $4ceddc5ee7e9d694$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $4ceddc5ee7e9d694$var$warning;

});



parcelRegister("as5xI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $79c0d19c7e2c68ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $79c0d19c7e2c68ac$var$_menuFactory2 = $79c0d19c7e2c68ac$var$_interopRequireDefault($6muFC);
var $79c0d19c7e2c68ac$var$styles = {};
module.exports['default'] = (0, $79c0d19c7e2c68ac$var$_menuFactory2['default'])($79c0d19c7e2c68ac$var$styles);
module.exports = module.exports['default'];

});
parcelRegister("6muFC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
var $4a1c969d0a878047$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i['return']) _i['return']();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError('Invalid attempt to destructure non-iterable instance');
    };
}();
var $4a1c969d0a878047$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $4a1c969d0a878047$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $7fPBF = parcelRequire("7fPBF");
var $4a1c969d0a878047$var$_react2 = $4a1c969d0a878047$var$_interopRequireDefault($7fPBF);

var $fw0lo = parcelRequire("fw0lo");
var $4a1c969d0a878047$var$_reactDom2 = $4a1c969d0a878047$var$_interopRequireDefault($fw0lo);

var $2oXYc = parcelRequire("2oXYc");
var $4a1c969d0a878047$var$_propTypes2 = $4a1c969d0a878047$var$_interopRequireDefault($2oXYc);

var $iQrFS = parcelRequire("iQrFS");
var $4a1c969d0a878047$var$_helpersBaseStyles2 = $4a1c969d0a878047$var$_interopRequireDefault($iQrFS);

var $dW40D = parcelRequire("dW40D");

var $hzVO1 = parcelRequire("hzVO1");
var $4a1c969d0a878047$var$_componentsBurgerIcon2 = $4a1c969d0a878047$var$_interopRequireDefault($hzVO1);

var $1Uy6W = parcelRequire("1Uy6W");
var $4a1c969d0a878047$var$_componentsCrossIcon2 = $4a1c969d0a878047$var$_interopRequireDefault($1Uy6W);
module.exports['default'] = function(styles) {
    if (!styles) throw new Error('No styles supplied');
    var ARROW_DOWN = 'ArrowDown';
    var ARROW_UP = 'ArrowUp';
    var ESCAPE = 'Escape';
    var SPACE = ' ';
    var HOME = 'Home';
    var END = 'End';
    function usePrevious(value) {
        var ref = $4a1c969d0a878047$var$_react2['default'].useRef(value);
        $4a1c969d0a878047$var$_react2['default'].useEffect(function() {
            ref.current = value;
        });
        return ref.current;
    }
    var Menu = function Menu(props) {
        var _React$useState = $4a1c969d0a878047$var$_react2['default'].useState(false);
        var _React$useState2 = $4a1c969d0a878047$var$_slicedToArray(_React$useState, 2);
        var isOpen = _React$useState2[0];
        var setIsOpen = _React$useState2[1];
        var timeoutId = $4a1c969d0a878047$var$_react2['default'].useRef();
        var toggleOptions = $4a1c969d0a878047$var$_react2['default'].useRef({});
        var prevIsOpenProp = usePrevious(props.isOpen);
        $4a1c969d0a878047$var$_react2['default'].useEffect(function() {
            if (props.isOpen) toggleMenu({
                isOpen: true,
                noStateChange: true
            });
            return function cleanup() {
                applyWrapperStyles(false);
                clearCurrentTimeout();
            };
        }, []);
        $4a1c969d0a878047$var$_react2['default'].useEffect(function() {
            var wasToggled = typeof props.isOpen !== 'undefined' && props.isOpen !== isOpen && props.isOpen !== prevIsOpenProp;
            if (wasToggled) {
                toggleMenu();
                // Toggling changes SVG animation requirements, so defer these until next update
                return;
            }
            if (styles.svg) (function() {
                var morphShape = document.getElementById('bm-morph-shape');
                var path = styles.svg.lib(morphShape).select('path');
                if (isOpen) // Animate SVG path
                styles.svg.animate(path);
                else // Reset path (timeout ensures animation happens off screen)
                setTimeout(function() {
                    path.attr('d', styles.svg.pathInitial);
                }, 300);
            })();
        });
        $4a1c969d0a878047$var$_react2['default'].useEffect(function() {
            var _toggleOptions$current = toggleOptions.current;
            var noStateChange = _toggleOptions$current.noStateChange;
            var focusOnLastItem = _toggleOptions$current.focusOnLastItem;
            if (!noStateChange) props.onStateChange({
                isOpen: isOpen
            });
            if (!props.disableAutoFocus) {
                // For accessibility reasons, ensures that when we toggle open,
                // we focus the first or last menu item according to given parameter
                if (isOpen) focusOnLastItem ? (0, $dW40D.focusOnLastMenuItem)() : (0, $dW40D.focusOnFirstMenuItem)();
                else if (document.activeElement) document.activeElement.blur();
                else document.body.blur(); // Needed for IE
            }
            // Timeout ensures wrappers are cleared after animation finishes
            clearCurrentTimeout();
            timeoutId.current = setTimeout(function() {
                timeoutId.current = null;
                if (!isOpen) applyWrapperStyles(false);
            }, 500);
            // Bind keydown handlers (or custom function if supplied)
            var defaultOnKeyDown = isOpen ? onKeyDownOpen : onKeyDownClosed;
            var onKeyDown = props.customOnKeyDown || defaultOnKeyDown;
            window.addEventListener('keydown', onKeyDown);
            return function cleanup() {
                window.removeEventListener('keydown', onKeyDown);
            };
        }, [
            isOpen
        ]);
        function toggleMenu() {
            var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
            toggleOptions.current = options;
            applyWrapperStyles();
            // Ensures wrapper styles are applied before the menu is toggled
            setTimeout(function() {
                setIsOpen(function(open) {
                    return typeof options.isOpen !== 'undefined' ? options.isOpen : !open;
                });
            });
        }
        function open() {
            if (typeof props.onOpen === 'function') props.onOpen();
            else toggleMenu();
        }
        function close() {
            if (typeof props.onClose === 'function') props.onClose();
            else toggleMenu();
        }
        function getStyle(style, index) {
            var width = props.width;
            var right = props.right;
            var formattedWidth = typeof width !== 'string' ? width + 'px' : width;
            return style(isOpen, formattedWidth, right, index);
        }
        // Builds styles incrementally for a given element
        function getStyles(el, index, inline) {
            var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());
            // Set base styles
            var output = $4a1c969d0a878047$var$_helpersBaseStyles2['default'][el] ? getStyle($4a1c969d0a878047$var$_helpersBaseStyles2['default'][el]) : {};
            // Add animation-specific styles
            if (styles[el]) output = $4a1c969d0a878047$var$_extends({}, output, getStyle(styles[el], index + 1));
            // Add custom styles
            if (props.styles[propName]) output = $4a1c969d0a878047$var$_extends({}, output, props.styles[propName]);
            // Add element inline styles
            if (inline) output = $4a1c969d0a878047$var$_extends({}, output, inline);
            // Remove transition if required
            // (useful if rendering open initially)
            if (props.noTransition) delete output.transition;
            return output;
        }
        // Sets or unsets styles on DOM elements outside the menu component
        // This is necessary for correct page interaction with some of the menus
        // Throws and returns if the required external elements don't exist,
        // which means any external page animations won't be applied
        function handleExternalWrapper(id, wrapperStyles, set) {
            var wrapper = document.getElementById(id);
            if (!wrapper) {
                console.error("Element with ID '" + id + "' not found");
                return;
            }
            var builtStyles = getStyle(wrapperStyles);
            for(var prop in builtStyles)if (builtStyles.hasOwnProperty(prop)) wrapper.style[prop] = set ? builtStyles[prop] : '';
            // Prevent any horizontal scroll
            // Only set overflow-x as an inline style if htmlClassName or
            // bodyClassName is not passed in. Otherwise, it is up to the caller to
            // decide if they want to set the overflow style in CSS using the custom
            // class names
            var applyOverflow = function applyOverflow(el) {
                return el.style['overflow-x'] = set ? 'hidden' : '';
            };
            if (!props.htmlClassName) applyOverflow(document.querySelector('html'));
            if (!props.bodyClassName) applyOverflow(document.querySelector('body'));
        }
        // Applies component-specific styles to external wrapper elements
        function applyWrapperStyles() {
            var set = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
            var applyClass = function applyClass(el, className) {
                return el.classList[set ? 'add' : 'remove'](className);
            };
            if (props.htmlClassName) applyClass(document.querySelector('html'), props.htmlClassName);
            if (props.bodyClassName) applyClass(document.querySelector('body'), props.bodyClassName);
            if (styles.pageWrap && props.pageWrapId) handleExternalWrapper(props.pageWrapId, styles.pageWrap, set);
            if (styles.outerContainer && props.outerContainerId) handleExternalWrapper(props.outerContainerId, styles.outerContainer, set);
            var menuWrap = document.querySelector('.bm-menu-wrap');
            if (menuWrap) {
                if (set) menuWrap.removeAttribute('hidden');
                else menuWrap.setAttribute('hidden', true);
            }
        }
        // Avoids potentially attempting to update an unmounted component
        function clearCurrentTimeout() {
            if (timeoutId.current) clearTimeout(timeoutId.current);
        }
        function onKeyDownOpen(e) {
            e = e || window.event;
            switch(e.key){
                case ESCAPE:
                    // Close on ESC, unless disabled
                    if (!props.disableCloseOnEsc) {
                        close();
                        (0, $dW40D.focusOnMenuButton)();
                    }
                    break;
                case ARROW_DOWN:
                    (0, $dW40D.focusOnNextMenuItem)();
                    break;
                case ARROW_UP:
                    (0, $dW40D.focusOnPreviousMenuItem)();
                    break;
                case HOME:
                    (0, $dW40D.focusOnFirstMenuItem)();
                    break;
                case END:
                    (0, $dW40D.focusOnLastMenuItem)();
                    break;
            }
        }
        function onKeyDownClosed(e) {
            e = e || window.event;
            // Key downs came from menu button
            if (e.target === document.getElementById('react-burger-menu-btn')) switch(e.key){
                case ARROW_DOWN:
                case SPACE:
                    // If down arrow, space or enter, open menu and focus on first menuitem
                    toggleMenu();
                    break;
                case ARROW_UP:
                    // If arrow up, open menu and focus on last menuitem
                    toggleMenu({
                        focusOnLastItem: true
                    });
                    break;
            }
        }
        function handleOverlayClick() {
            if (props.disableOverlayClick === true || typeof props.disableOverlayClick === 'function' && props.disableOverlayClick()) return;
            else close();
        }
        return $4a1c969d0a878047$var$_react2['default'].createElement('div', null, !props.noOverlay && $4a1c969d0a878047$var$_react2['default'].createElement('div', {
            className: ('bm-overlay ' + props.overlayClassName).trim(),
            onClick: handleOverlayClick,
            style: getStyles('overlay')
        }), props.customBurgerIcon !== false && $4a1c969d0a878047$var$_react2['default'].createElement('div', {
            style: getStyles('burgerIcon')
        }, $4a1c969d0a878047$var$_react2['default'].createElement($4a1c969d0a878047$var$_componentsBurgerIcon2['default'], {
            onClick: open,
            styles: props.styles,
            customIcon: props.customBurgerIcon,
            className: props.burgerButtonClassName,
            barClassName: props.burgerBarClassName,
            onIconStateChange: props.onIconStateChange
        })), $4a1c969d0a878047$var$_react2['default'].createElement('div', {
            id: props.id,
            className: ('bm-menu-wrap ' + props.className).trim(),
            style: getStyles('menuWrap'),
            'aria-hidden': !isOpen
        }, styles.svg && $4a1c969d0a878047$var$_react2['default'].createElement('div', {
            id: 'bm-morph-shape',
            className: ('bm-morph-shape ' + props.morphShapeClassName).trim(),
            style: getStyles('morphShape')
        }, $4a1c969d0a878047$var$_react2['default'].createElement('svg', {
            width: '100%',
            height: '100%',
            viewBox: '0 0 100 800',
            preserveAspectRatio: 'none'
        }, $4a1c969d0a878047$var$_react2['default'].createElement('path', {
            d: styles.svg.pathInitial
        }))), $4a1c969d0a878047$var$_react2['default'].createElement('div', {
            className: ('bm-menu ' + props.menuClassName).trim(),
            style: getStyles('menu')
        }, $4a1c969d0a878047$var$_react2['default'].createElement(props.itemListElement, {
            className: ('bm-item-list ' + props.itemListClassName).trim(),
            style: getStyles('itemList')
        }, $4a1c969d0a878047$var$_react2['default'].Children.map(props.children, function(item, index) {
            if (item) {
                var classList = [
                    'bm-item',
                    props.itemClassName,
                    item.props.className
                ].filter(function(className) {
                    return !!className;
                }).join(' ');
                var extraProps = $4a1c969d0a878047$var$_extends({
                    key: index,
                    className: classList,
                    style: getStyles('item', index, item.props.style)
                }, !isOpen && {
                    tabIndex: -1
                });
                return $4a1c969d0a878047$var$_react2['default'].cloneElement(item, extraProps);
            }
        }))), props.customCrossIcon !== false && $4a1c969d0a878047$var$_react2['default'].createElement('div', {
            style: getStyles('closeButton')
        }, $4a1c969d0a878047$var$_react2['default'].createElement($4a1c969d0a878047$var$_componentsCrossIcon2['default'], {
            onClick: close,
            styles: props.styles,
            customIcon: props.customCrossIcon,
            className: props.crossButtonClassName,
            crossClassName: props.crossClassName,
            isOpen: isOpen
        }))));
    };
    Menu.propTypes = {
        bodyClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        burgerBarClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        burgerButtonClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        className: $4a1c969d0a878047$var$_propTypes2['default'].string,
        crossButtonClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        crossClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        customBurgerIcon: $4a1c969d0a878047$var$_propTypes2['default'].oneOfType([
            $4a1c969d0a878047$var$_propTypes2['default'].element,
            $4a1c969d0a878047$var$_propTypes2['default'].oneOf([
                false
            ])
        ]),
        customCrossIcon: $4a1c969d0a878047$var$_propTypes2['default'].oneOfType([
            $4a1c969d0a878047$var$_propTypes2['default'].element,
            $4a1c969d0a878047$var$_propTypes2['default'].oneOf([
                false
            ])
        ]),
        customOnKeyDown: $4a1c969d0a878047$var$_propTypes2['default'].func,
        disableAutoFocus: $4a1c969d0a878047$var$_propTypes2['default'].bool,
        disableCloseOnEsc: $4a1c969d0a878047$var$_propTypes2['default'].bool,
        disableOverlayClick: $4a1c969d0a878047$var$_propTypes2['default'].oneOfType([
            $4a1c969d0a878047$var$_propTypes2['default'].bool,
            $4a1c969d0a878047$var$_propTypes2['default'].func
        ]),
        htmlClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        id: $4a1c969d0a878047$var$_propTypes2['default'].string,
        isOpen: $4a1c969d0a878047$var$_propTypes2['default'].bool,
        itemClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        itemListClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        itemListElement: $4a1c969d0a878047$var$_propTypes2['default'].oneOf([
            'div',
            'nav'
        ]),
        menuClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        morphShapeClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        noOverlay: $4a1c969d0a878047$var$_propTypes2['default'].bool,
        noTransition: $4a1c969d0a878047$var$_propTypes2['default'].bool,
        onClose: $4a1c969d0a878047$var$_propTypes2['default'].func,
        onIconHoverChange: $4a1c969d0a878047$var$_propTypes2['default'].func,
        onOpen: $4a1c969d0a878047$var$_propTypes2['default'].func,
        onStateChange: $4a1c969d0a878047$var$_propTypes2['default'].func,
        outerContainerId: styles && styles.outerContainer ? $4a1c969d0a878047$var$_propTypes2['default'].string.isRequired : $4a1c969d0a878047$var$_propTypes2['default'].string,
        overlayClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        pageWrapId: styles && styles.pageWrap ? $4a1c969d0a878047$var$_propTypes2['default'].string.isRequired : $4a1c969d0a878047$var$_propTypes2['default'].string,
        right: $4a1c969d0a878047$var$_propTypes2['default'].bool,
        styles: $4a1c969d0a878047$var$_propTypes2['default'].object,
        width: $4a1c969d0a878047$var$_propTypes2['default'].oneOfType([
            $4a1c969d0a878047$var$_propTypes2['default'].number,
            $4a1c969d0a878047$var$_propTypes2['default'].string
        ])
    };
    Menu.defaultProps = {
        bodyClassName: '',
        burgerBarClassName: '',
        burgerButtonClassName: '',
        className: '',
        crossButtonClassName: '',
        crossClassName: '',
        disableAutoFocus: false,
        disableCloseOnEsc: false,
        htmlClassName: '',
        id: '',
        itemClassName: '',
        itemListClassName: '',
        menuClassName: '',
        morphShapeClassName: '',
        noOverlay: false,
        noTransition: false,
        onStateChange: function onStateChange() {},
        outerContainerId: '',
        overlayClassName: '',
        pageWrapId: '',
        styles: {},
        width: 300,
        onIconHoverChange: function onIconHoverChange() {},
        itemListElement: 'nav'
    };
    return Menu;
};
module.exports = module.exports['default'];

});
parcelRegister("iQrFS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
var $db828ce58ee26ca8$var$styles = {
    overlay: function overlay(isOpen) {
        return {
            position: 'fixed',
            zIndex: 1000,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.3)',
            opacity: isOpen ? 1 : 0,
            MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
            MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
            OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
            WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
            transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
            transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
        };
    },
    menuWrap: function menuWrap(isOpen, width, right) {
        return {
            position: 'fixed',
            right: right ? 0 : 'inherit',
            zIndex: 1100,
            width: width,
            height: '100%',
            MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            transition: 'all 0.5s'
        };
    },
    menu: function menu() {
        return {
            height: '100%',
            boxSizing: 'border-box',
            overflow: 'auto'
        };
    },
    itemList: function itemList() {
        return {
            height: '100%'
        };
    },
    item: function item() {
        return {
            display: 'block'
        };
    }
};
module.exports['default'] = $db828ce58ee26ca8$var$styles;
module.exports = module.exports['default'];

});

parcelRegister("dW40D", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.focusOnFirstMenuItem = $a253cd4a17c3e40c$var$focusOnFirstMenuItem;
module.exports.focusOnLastMenuItem = $a253cd4a17c3e40c$var$focusOnLastMenuItem;
module.exports.focusOnCrossButton = $a253cd4a17c3e40c$var$focusOnCrossButton;
module.exports.focusOnMenuButton = $a253cd4a17c3e40c$var$focusOnMenuButton;
module.exports.focusOnMenuItem = $a253cd4a17c3e40c$var$focusOnMenuItem;
module.exports.focusOnNextMenuItem = $a253cd4a17c3e40c$var$focusOnNextMenuItem;
module.exports.focusOnPreviousMenuItem = $a253cd4a17c3e40c$var$focusOnPreviousMenuItem;
function $a253cd4a17c3e40c$var$focusOnFirstMenuItem() {
    var firstItem = Array.from(document.getElementsByClassName('bm-item')).shift();
    if (firstItem) firstItem.focus();
}
function $a253cd4a17c3e40c$var$focusOnLastMenuItem() {
    var lastItem = Array.from(document.getElementsByClassName('bm-item')).pop();
    if (lastItem) lastItem.focus();
}
function $a253cd4a17c3e40c$var$focusOnCrossButton() {
    var crossButton = document.getElementById('react-burger-cross-btn');
    if (crossButton) crossButton.focus();
}
function $a253cd4a17c3e40c$var$focusOnMenuButton() {
    var menuButton = document.getElementById('react-burger-menu-btn');
    if (menuButton) menuButton.focus();
}
function $a253cd4a17c3e40c$var$focusOnMenuItem(siblingType) {
    if (document.activeElement.className.includes('bm-item')) {
        var sibling = document.activeElement[siblingType];
        if (sibling) sibling.focus();
        else $a253cd4a17c3e40c$var$focusOnCrossButton();
    } else if (siblingType === 'previousElementSibling') $a253cd4a17c3e40c$var$focusOnLastMenuItem();
    else $a253cd4a17c3e40c$var$focusOnFirstMenuItem();
}
function $a253cd4a17c3e40c$var$focusOnNextMenuItem() {
    $a253cd4a17c3e40c$var$focusOnMenuItem('nextElementSibling');
}
function $a253cd4a17c3e40c$var$focusOnPreviousMenuItem() {
    $a253cd4a17c3e40c$var$focusOnMenuItem('previousElementSibling');
}

});

parcelRegister("hzVO1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
var $ccc28b9b2253a78e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ccc28b9b2253a78e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $ccc28b9b2253a78e$var$_get = function get(_x, _x2, _x3) {
    var _again = true;
    _function: while(_again){
        var object = _x, property = _x2, receiver = _x3;
        _again = false;
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);
        if (desc === undefined) {
            var parent = Object.getPrototypeOf(object);
            if (parent === null) return undefined;
            else {
                _x = parent;
                _x2 = property;
                _x3 = receiver;
                _again = true;
                desc = parent = undefined;
                continue _function;
            }
        } else if ('value' in desc) return desc.value;
        else {
            var getter = desc.get;
            if (getter === undefined) return undefined;
            return getter.call(receiver);
        }
    }
};
function $ccc28b9b2253a78e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $ccc28b9b2253a78e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}
function $ccc28b9b2253a78e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $7fPBF = parcelRequire("7fPBF");
var $ccc28b9b2253a78e$var$_react2 = $ccc28b9b2253a78e$var$_interopRequireDefault($7fPBF);

var $2oXYc = parcelRequire("2oXYc");
var $ccc28b9b2253a78e$var$_propTypes2 = $ccc28b9b2253a78e$var$_interopRequireDefault($2oXYc);
var $ccc28b9b2253a78e$var$BurgerIcon = function(_Component) {
    $ccc28b9b2253a78e$var$_inherits(BurgerIcon, _Component);
    function BurgerIcon(props) {
        $ccc28b9b2253a78e$var$_classCallCheck(this, BurgerIcon);
        $ccc28b9b2253a78e$var$_get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
        this.state = {
            hover: false
        };
    }
    $ccc28b9b2253a78e$var$_createClass(BurgerIcon, [
        {
            key: 'getLineStyle',
            value: function getLineStyle(index) {
                return $ccc28b9b2253a78e$var$_extends({
                    position: 'absolute',
                    height: '20%',
                    left: 0,
                    right: 0,
                    top: 20 * (index * 2) + '%',
                    opacity: this.state.hover ? 0.6 : 1
                }, this.state.hover && this.props.styles.bmBurgerBarsHover);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this = this;
                var icon = undefined;
                var buttonStyle = {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    zIndex: 1,
                    width: '100%',
                    height: '100%',
                    margin: 0,
                    padding: 0,
                    border: 'none',
                    fontSize: 0,
                    background: 'transparent',
                    cursor: 'pointer'
                };
                if (this.props.customIcon) {
                    var extraProps = {
                        className: ('bm-icon ' + (this.props.customIcon.props.className || '')).trim(),
                        style: $ccc28b9b2253a78e$var$_extends({
                            width: '100%',
                            height: '100%'
                        }, this.props.styles.bmIcon)
                    };
                    icon = $ccc28b9b2253a78e$var$_react2['default'].cloneElement(this.props.customIcon, extraProps);
                } else icon = $ccc28b9b2253a78e$var$_react2['default'].createElement('span', null, [
                    0,
                    1,
                    2
                ].map(function(bar) {
                    return $ccc28b9b2253a78e$var$_react2['default'].createElement('span', {
                        key: bar,
                        className: ('bm-burger-bars ' + _this.props.barClassName + ' ' + (_this.state.hover ? 'bm-burger-bars-hover' : '')).trim(),
                        style: $ccc28b9b2253a78e$var$_extends({}, _this.getLineStyle(bar), _this.props.styles.bmBurgerBars)
                    });
                }));
                return $ccc28b9b2253a78e$var$_react2['default'].createElement('div', {
                    className: ('bm-burger-button ' + this.props.className).trim(),
                    style: $ccc28b9b2253a78e$var$_extends({
                        zIndex: 1000
                    }, this.props.styles.bmBurgerButton)
                }, $ccc28b9b2253a78e$var$_react2['default'].createElement('button', {
                    type: 'button',
                    id: 'react-burger-menu-btn',
                    onClick: this.props.onClick,
                    onMouseOver: function() {
                        _this.setState({
                            hover: true
                        });
                        if (_this.props.onIconHoverChange) _this.props.onIconHoverChange({
                            isMouseIn: true
                        });
                    },
                    onMouseOut: function() {
                        _this.setState({
                            hover: false
                        });
                        if (_this.props.onIconHoverChange) _this.props.onIconHoverChange({
                            isMouseIn: false
                        });
                    },
                    style: buttonStyle
                }, 'Open Menu'), icon);
            }
        }
    ]);
    return BurgerIcon;
}($7fPBF.Component);
module.exports['default'] = $ccc28b9b2253a78e$var$BurgerIcon;
$ccc28b9b2253a78e$var$BurgerIcon.propTypes = {
    barClassName: $ccc28b9b2253a78e$var$_propTypes2['default'].string,
    customIcon: $ccc28b9b2253a78e$var$_propTypes2['default'].element,
    styles: $ccc28b9b2253a78e$var$_propTypes2['default'].object
};
$ccc28b9b2253a78e$var$BurgerIcon.defaultProps = {
    barClassName: '',
    className: '',
    styles: {}
};
module.exports = module.exports['default'];

});

parcelRegister("1Uy6W", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
var $16457b278626c6a3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $16457b278626c6a3$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $16457b278626c6a3$var$_get = function get(_x, _x2, _x3) {
    var _again = true;
    _function: while(_again){
        var object = _x, property = _x2, receiver = _x3;
        _again = false;
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);
        if (desc === undefined) {
            var parent = Object.getPrototypeOf(object);
            if (parent === null) return undefined;
            else {
                _x = parent;
                _x2 = property;
                _x3 = receiver;
                _again = true;
                desc = parent = undefined;
                continue _function;
            }
        } else if ('value' in desc) return desc.value;
        else {
            var getter = desc.get;
            if (getter === undefined) return undefined;
            return getter.call(receiver);
        }
    }
};
function $16457b278626c6a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $16457b278626c6a3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}
function $16457b278626c6a3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $7fPBF = parcelRequire("7fPBF");
var $16457b278626c6a3$var$_react2 = $16457b278626c6a3$var$_interopRequireDefault($7fPBF);

var $2oXYc = parcelRequire("2oXYc");
var $16457b278626c6a3$var$_propTypes2 = $16457b278626c6a3$var$_interopRequireDefault($2oXYc);
var $16457b278626c6a3$var$CrossIcon = function(_Component) {
    $16457b278626c6a3$var$_inherits(CrossIcon, _Component);
    function CrossIcon() {
        $16457b278626c6a3$var$_classCallCheck(this, CrossIcon);
        $16457b278626c6a3$var$_get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
    }
    $16457b278626c6a3$var$_createClass(CrossIcon, [
        {
            key: 'getCrossStyle',
            value: function getCrossStyle(type) {
                return {
                    position: 'absolute',
                    width: 3,
                    height: 14,
                    transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
                };
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this = this;
                var icon;
                var buttonWrapperStyle = {
                    position: 'absolute',
                    width: 24,
                    height: 24,
                    right: 8,
                    top: 8
                };
                var buttonStyle = {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    zIndex: 1,
                    width: '100%',
                    height: '100%',
                    margin: 0,
                    padding: 0,
                    border: 'none',
                    fontSize: 0,
                    background: 'transparent',
                    cursor: 'pointer'
                };
                if (this.props.customIcon) {
                    var extraProps = {
                        className: ('bm-cross ' + (this.props.customIcon.props.className || '')).trim(),
                        style: $16457b278626c6a3$var$_extends({
                            width: '100%',
                            height: '100%'
                        }, this.props.styles.bmCross)
                    };
                    icon = $16457b278626c6a3$var$_react2['default'].cloneElement(this.props.customIcon, extraProps);
                } else icon = $16457b278626c6a3$var$_react2['default'].createElement('span', {
                    style: {
                        position: 'absolute',
                        top: '6px',
                        right: '14px'
                    }
                }, [
                    'before',
                    'after'
                ].map(function(type, i) {
                    return $16457b278626c6a3$var$_react2['default'].createElement('span', {
                        key: i,
                        className: ('bm-cross ' + _this.props.crossClassName).trim(),
                        style: $16457b278626c6a3$var$_extends({}, _this.getCrossStyle(type), _this.props.styles.bmCross)
                    });
                }));
                return $16457b278626c6a3$var$_react2['default'].createElement('div', {
                    className: ('bm-cross-button ' + this.props.className).trim(),
                    style: $16457b278626c6a3$var$_extends({}, buttonWrapperStyle, this.props.styles.bmCrossButton)
                }, $16457b278626c6a3$var$_react2['default'].createElement('button', $16457b278626c6a3$var$_extends({
                    type: 'button',
                    id: 'react-burger-cross-btn',
                    onClick: this.props.onClick,
                    style: buttonStyle
                }, !this.props.isOpen && {
                    tabIndex: -1
                }), 'Close Menu'), icon);
            }
        }
    ]);
    return CrossIcon;
}($7fPBF.Component);
module.exports['default'] = $16457b278626c6a3$var$CrossIcon;
$16457b278626c6a3$var$CrossIcon.propTypes = {
    crossClassName: $16457b278626c6a3$var$_propTypes2['default'].string,
    customIcon: $16457b278626c6a3$var$_propTypes2['default'].element,
    isOpen: $16457b278626c6a3$var$_propTypes2['default'].bool,
    styles: $16457b278626c6a3$var$_propTypes2['default'].object
};
$16457b278626c6a3$var$CrossIcon.defaultProps = {
    crossClassName: '',
    className: '',
    styles: {},
    isOpen: false
};
module.exports = module.exports['default'];

});



parcelRegister("8LDbR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $66211ce7119cf1f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $66211ce7119cf1f3$var$_menuFactory2 = $66211ce7119cf1f3$var$_interopRequireDefault($6muFC);
var $66211ce7119cf1f3$var$styles = {
    menuWrap: function menuWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
            transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0.4s cubic-bezier(0.7, 0, 0.3, 1)'
        };
    },
    item: function item(isOpen, width, right, nthChild) {
        return {
            MozTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
            MsTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
            OTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
            WebkitTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
            transform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
            transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0s 0.2s cubic-bezier(0.7, 0, 0.3, 1)'
        };
    }
};
module.exports['default'] = (0, $66211ce7119cf1f3$var$_menuFactory2['default'])($66211ce7119cf1f3$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("5Z3UW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $45b5b027790b8fed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $c3Chv = parcelRequire("c3Chv");
var $45b5b027790b8fed$var$_helpersSnapsvgImporter2 = $45b5b027790b8fed$var$_interopRequireDefault($c3Chv);

var $6muFC = parcelRequire("6muFC");
var $45b5b027790b8fed$var$_menuFactory2 = $45b5b027790b8fed$var$_interopRequireDefault($6muFC);

var $e1he6 = parcelRequire("e1he6");
var $45b5b027790b8fed$var$MORPH_SHAPE_WIDTH = 120;
var $45b5b027790b8fed$var$styles = {
    svg: {
        lib: $45b5b027790b8fed$var$_helpersSnapsvgImporter2['default'],
        pathInitial: 'M-1,0h101c0,0-97.833,153.603-97.833,396.167C2.167,627.579,100,800,100,800H-1V0z',
        pathOpen: 'M-1,0h101c0,0,0-1,0,395c0,404,0,405,0,405H-1V0z',
        animate: function animate(path) {
            path.animate({
                path: this.pathOpen
            }, 400, window.mina.easeinout);
        }
    },
    morphShape: function morphShape(isOpen, width, right) {
        return {
            position: 'absolute',
            width: $45b5b027790b8fed$var$MORPH_SHAPE_WIDTH,
            height: '100%',
            right: right ? 'inherit' : 0,
            left: right ? 0 : 'inherit',
            MozTransform: right ? 'rotateY(180deg)' : '',
            MsTransform: right ? 'rotateY(180deg)' : '',
            OTransform: right ? 'rotateY(180deg)' : '',
            WebkitTransform: right ? 'rotateY(180deg)' : '',
            transform: right ? 'rotateY(180deg)' : ''
        };
    },
    menuWrap: function menuWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            transition: 'all 0.3s'
        };
    },
    menu: function menu(isOpen, width, right) {
        return {
            position: 'fixed',
            right: right ? 0 : 'inherit',
            width: (0, $e1he6.pxToNum)(width) - $45b5b027790b8fed$var$MORPH_SHAPE_WIDTH,
            whiteSpace: 'nowrap',
            boxSizing: 'border-box',
            overflow: 'visible'
        };
    },
    itemList: function itemList(isOpen, width, right) {
        if (right) return {
            position: 'relative',
            left: '-110px',
            width: '170%',
            overflow: 'auto'
        };
    },
    pageWrap: function pageWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
            transition: isOpen ? 'all 0.3s' : 'all 0.3s 0.1s'
        };
    },
    outerContainer: function outerContainer(isOpen) {
        return {
            overflow: isOpen ? '' : 'hidden'
        };
    }
};
module.exports['default'] = (0, $45b5b027790b8fed$var$_menuFactory2['default'])($45b5b027790b8fed$var$styles);
module.exports = module.exports['default'];

});
parcelRegister("c3Chv", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

module.exports['default'] = function() {
    var Snap = undefined;
    try {
        Snap = (parcelRequire("kEG1j"));
    } finally{
        return Snap;
    }
};
module.exports = module.exports['default'];

});
parcelRegister("kEG1j", function(module, exports) {

window.eve = (parcelRequire("fXTr3"));
// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var $f098236b7e761f68$var$mina = function(eve1) {
    var animations = {}, requestAnimFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
        setTimeout(callback, 16, new Date().getTime());
        return true;
    }, requestID, isArray = Array.isArray || function(a) {
        return a instanceof Array || Object.prototype.toString.call(a) == "[object Array]";
    }, idgen = 0, idprefix = "M" + (+new Date).toString(36), ID = function() {
        return idprefix + (idgen++).toString(36);
    }, diff = function(a, b, A, B) {
        if (isArray(a)) {
            res = [];
            for(var i = 0, ii = a.length; i < ii; i++)res[i] = diff(a[i], b, A[i], B);
            return res;
        }
        var dif = (A - a) / (B - b);
        return function(bb) {
            return a + dif * (bb - b);
        };
    }, timer = Date.now || function() {
        return +new Date;
    }, sta = function(val) {
        var a = this;
        if (val == null) return a.s;
        var ds = a.s - val;
        a.b += a.dur * ds;
        a.B += a.dur * ds;
        a.s = val;
    }, speed = function(val) {
        var a = this;
        if (val == null) return a.spd;
        a.spd = val;
    }, duration = function(val) {
        var a = this;
        if (val == null) return a.dur;
        a.s = a.s * val / a.dur;
        a.dur = val;
    }, stopit = function() {
        var a = this;
        delete animations[a.id];
        a.update();
        eve1("mina.stop." + a.id, a);
    }, pause = function() {
        var a = this;
        if (a.pdif) return;
        delete animations[a.id];
        a.update();
        a.pdif = a.get() - a.b;
    }, resume = function() {
        var a = this;
        if (!a.pdif) return;
        a.b = a.get() - a.pdif;
        delete a.pdif;
        animations[a.id] = a;
        frame();
    }, update = function() {
        var a = this, res1;
        if (isArray(a.start)) {
            res1 = [];
            for(var j = 0, jj = a.start.length; j < jj; j++)res1[j] = +a.start[j] + (a.end[j] - a.start[j]) * a.easing(a.s);
        } else res1 = +a.start + (a.end - a.start) * a.easing(a.s);
        a.set(res1);
    }, frame = function(timeStamp) {
        // Manual invokation?
        if (!timeStamp) {
            // Frame loop stopped?
            if (!requestID) // Start frame loop...
            requestID = requestAnimFrame(frame);
            return;
        }
        var len = 0;
        for(var i in animations)if (animations.hasOwnProperty(i)) {
            var a = animations[i], b = a.get(), res1;
            len++;
            a.s = (b - a.b) / (a.dur / a.spd);
            if (a.s >= 1) {
                delete animations[i];
                a.s = 1;
                len--;
                (function(a) {
                    setTimeout(function() {
                        eve1("mina.finish." + a.id, a);
                    });
                })(a);
            }
            a.update();
        }
        requestID = len ? requestAnimFrame(frame) : false;
    }, /*\
     * mina
     [ method ]
     **
     * Generic animation of numbers
     **
     - a (number) start _slave_ number
     - A (number) end _slave_ number
     - b (number) start _master_ number (start time in general case)
     - B (number) end _master_ number (end time in general case)
     - get (function) getter of _master_ number (see @mina.time)
     - set (function) setter of _slave_ number
     - easing (function) #optional easing function, default is @mina.linear
     = (object) animation descriptor
     o {
     o         id (string) animation id,
     o         start (number) start _slave_ number,
     o         end (number) end _slave_ number,
     o         b (number) start _master_ number,
     o         s (number) animation status (0..1),
     o         dur (number) animation duration,
     o         spd (number) animation speed,
     o         get (function) getter of _master_ number (see @mina.time),
     o         set (function) setter of _slave_ number,
     o         easing (function) easing function, default is @mina.linear,
     o         status (function) status getter/setter,
     o         speed (function) speed getter/setter,
     o         duration (function) duration getter/setter,
     o         stop (function) animation stopper
     o         pause (function) pauses the animation
     o         resume (function) resumes the animation
     o         update (function) calles setter with the right value of the animation
     o }
    \*/ mina = function(a, A, b, B, get, set, easing) {
        var anim = {
            id: ID(),
            start: a,
            end: A,
            b: b,
            s: 0,
            dur: B - b,
            spd: 1,
            get: get,
            set: set,
            easing: easing || mina.linear,
            status: sta,
            speed: speed,
            duration: duration,
            stop: stopit,
            pause: pause,
            resume: resume,
            update: update
        };
        animations[anim.id] = anim;
        var len = 0, i;
        for(i in animations)if (animations.hasOwnProperty(i)) {
            len++;
            if (len == 2) break;
        }
        len == 1 && frame();
        return anim;
    };
    /*\
     * mina.time
     [ method ]
     **
     * Returns the current time. Equivalent to:
     | function () {
     |     return (new Date).getTime();
     | }
    \*/ mina.time = timer;
    /*\
     * mina.getById
     [ method ]
     **
     * Returns an animation by its id
     - id (string) animation's id
     = (object) See @mina
    \*/ mina.getById = function(id) {
        return animations[id] || null;
    };
    /*\
     * mina.linear
     [ method ]
     **
     * Default linear easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.linear = function(n) {
        return n;
    };
    /*\
     * mina.easeout
     [ method ]
     **
     * Easeout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.easeout = function(n) {
        return Math.pow(n, 1.7);
    };
    /*\
     * mina.easein
     [ method ]
     **
     * Easein easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.easein = function(n) {
        return Math.pow(n, .48);
    };
    /*\
     * mina.easeinout
     [ method ]
     **
     * Easeinout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.easeinout = function(n) {
        if (n == 1) return 1;
        if (n == 0) return 0;
        var q = .48 - n / 1.04, Q = Math.sqrt(.1734 + q * q), x = Q - q, X = Math.pow(Math.abs(x), 1 / 3) * (x < 0 ? -1 : 1), y = -Q - q, Y = Math.pow(Math.abs(y), 1 / 3) * (y < 0 ? -1 : 1), t = X + Y + .5;
        return (1 - t) * 3 * t * t + t * t * t;
    };
    /*\
     * mina.backin
     [ method ]
     **
     * Backin easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.backin = function(n) {
        if (n == 1) return 1;
        var s = 1.70158;
        return n * n * ((s + 1) * n - s);
    };
    /*\
     * mina.backout
     [ method ]
     **
     * Backout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.backout = function(n) {
        if (n == 0) return 0;
        n = n - 1;
        var s = 1.70158;
        return n * n * ((s + 1) * n + s) + 1;
    };
    /*\
     * mina.elastic
     [ method ]
     **
     * Elastic easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.elastic = function(n) {
        if (n == !!n) return n;
        return Math.pow(2, -10 * n) * Math.sin((n - .075) * (2 * Math.PI) / .3) + 1;
    };
    /*\
     * mina.bounce
     [ method ]
     **
     * Bounce easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.bounce = function(n) {
        var s = 7.5625, p = 2.75, l;
        if (n < 1 / p) l = s * n * n;
        else {
            if (n < 2 / p) {
                n -= 1.5 / p;
                l = s * n * n + .75;
            } else if (n < 2.5 / p) {
                n -= 2.25 / p;
                l = s * n * n + .9375;
            } else {
                n -= 2.625 / p;
                l = s * n * n + .984375;
            }
        }
        return l;
    };
    window.mina = mina;
    return mina;
}(typeof eve == "undefined" ? function() {} : eve);
// Copyright (c) 2013 - 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var $f098236b7e761f68$var$Snap = function(root) {
    Snap.version = "0.5.1";
    /*\
 * Snap
 [ method ]
 **
 * Creates a drawing surface or wraps existing SVG element.
 **
 - width (number|string) width of surface
 - height (number|string) height of surface
 * or
 - DOM (SVGElement) element to be wrapped into Snap structure
 * or
 - array (array) array of elements (will return set of elements)
 * or
 - query (string) CSS query selector
 = (object) @Element
\*/ function Snap(w, h) {
        if (w) {
            if (w.nodeType) return wrap(w);
            if (is(w, "array") && Snap.set) return Snap.set.apply(Snap, w);
            if (w instanceof Element) return w;
            if (h == null) try {
                w = glob.doc.querySelector(String(w));
                return wrap(w);
            } catch (e) {
                return null;
            }
        }
        w = w == null ? "100%" : w;
        h = h == null ? "100%" : h;
        return new Paper(w, h);
    }
    Snap.toString = function() {
        return "Snap v" + this.version;
    };
    Snap._ = {};
    var glob = {
        win: root.window,
        doc: root.window.document
    };
    Snap._.glob = glob;
    var has = "hasOwnProperty", Str = String, toFloat = parseFloat, toInt = parseInt, math1 = Math, mmax = math1.max, mmin = math1.min, abs = math1.abs, pow = math1.pow, PI = math1.PI, round = math1.round, E = "", S = " ", objectToString = Object.prototype.toString, ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i, colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i, bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/, separator = Snap._.separator = /[,\s]+/, whitespace = /[\s]/g, commaSpaces = /[\s]*,[\s]*/, hsrg = {
        hs: 1,
        rg: 1
    }, pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig, tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig, pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/ig, idgen = 0, idprefix = "S" + (+new Date).toString(36), ID = function(el) {
        return (el && el.type ? el.type : E) + idprefix + (idgen++).toString(36);
    }, xlink = "http://www.w3.org/1999/xlink", xmlns = "http://www.w3.org/2000/svg", hub = {}, /*\
     * Snap.url
     [ method ]
     **
     * Wraps path into `"url('<path>')"`.
     - value (string) path
     = (string) wrapped path
    \*/ URL = Snap.url = function(url) {
        return "url('#" + url + "')";
    };
    function $(el, attr) {
        if (attr) {
            if (el == "#text") el = glob.doc.createTextNode(attr.text || attr["#text"] || "");
            if (el == "#comment") el = glob.doc.createComment(attr.text || attr["#text"] || "");
            if (typeof el == "string") el = $(el);
            if (typeof attr == "string") {
                if (el.nodeType == 1) {
                    if (attr.substring(0, 6) == "xlink:") return el.getAttributeNS(xlink, attr.substring(6));
                    if (attr.substring(0, 4) == "xml:") return el.getAttributeNS(xmlns, attr.substring(4));
                    return el.getAttribute(attr);
                } else if (attr == "text") return el.nodeValue;
                else return null;
            }
            if (el.nodeType == 1) {
                for(var key in attr)if (attr[has](key)) {
                    var val = Str(attr[key]);
                    if (val) {
                        if (key.substring(0, 6) == "xlink:") el.setAttributeNS(xlink, key.substring(6), val);
                        else if (key.substring(0, 4) == "xml:") el.setAttributeNS(xmlns, key.substring(4), val);
                        else el.setAttribute(key, val);
                    } else el.removeAttribute(key);
                }
            } else if ("text" in attr) el.nodeValue = attr.text;
        } else el = glob.doc.createElementNS(xmlns, el);
        return el;
    }
    Snap._.$ = $;
    Snap._.id = ID;
    function getAttrs(el) {
        var attrs = el.attributes, name, out = {};
        for(var i = 0; i < attrs.length; i++){
            if (attrs[i].namespaceURI == xlink) name = "xlink:";
            else name = "";
            name += attrs[i].name;
            out[name] = attrs[i].textContent;
        }
        return out;
    }
    function is(o, type) {
        type = Str.prototype.toLowerCase.call(type);
        if (type == "finite") return isFinite(o);
        if (type == "array" && (o instanceof Array || Array.isArray && Array.isArray(o))) return true;
        return type == "null" && o === null || type == typeof o && o !== null || type == "object" && o === Object(o) || objectToString.call(o).slice(8, -1).toLowerCase() == type;
    }
    /*\
 * Snap.format
 [ method ]
 **
 * Replaces construction of type `{<name>}` to the corresponding argument
 **
 - token (string) string to format
 - json (object) object which properties are used as a replacement
 = (string) formatted string
 > Usage
 | // this draws a rectangular shape equivalent to "M10,20h40v50h-40z"
 | paper.path(Snap.format("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
 |     x: 10,
 |     y: 20,
 |     dim: {
 |         width: 40,
 |         height: 50,
 |         "negative width": -40
 |     }
 | }));
\*/ Snap.format = function() {
        var tokenRegex = /\{([^\}]+)\}/g, objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, replacer = function(all, key, obj) {
            var res1 = obj;
            key.replace(objNotationRegex, function(all, name, quote, quotedName, isFunc) {
                name = name || quotedName;
                if (res1) {
                    if (name in res1) res1 = res1[name];
                    typeof res1 == "function" && isFunc && (res1 = res1());
                }
            });
            res1 = (res1 == null || res1 == obj ? all : res1) + "";
            return res1;
        };
        return function(str, obj) {
            return Str(str).replace(tokenRegex, function(all, key) {
                return replacer(all, key, obj);
            });
        };
    }();
    function clone(obj) {
        if (typeof obj == "function" || Object(obj) !== obj) return obj;
        var res1 = new obj.constructor;
        for(var key in obj)if (obj[has](key)) res1[key] = clone(obj[key]);
        return res1;
    }
    Snap._.clone = clone;
    function repush(array, item) {
        for(var i = 0, ii = array.length; i < ii; i++)if (array[i] === item) return array.push(array.splice(i, 1)[0]);
    }
    function cacher(f, scope, postprocessor) {
        function newf() {
            var arg = Array.prototype.slice.call(arguments, 0), args = arg.join("\u2400"), cache = newf.cache = newf.cache || {}, count = newf.count = newf.count || [];
            if (cache[has](args)) {
                repush(count, args);
                return postprocessor ? postprocessor(cache[args]) : cache[args];
            }
            count.length >= 1e3 && delete cache[count.shift()];
            count.push(args);
            cache[args] = f.apply(scope, arg);
            return postprocessor ? postprocessor(cache[args]) : cache[args];
        }
        return newf;
    }
    Snap._.cacher = cacher;
    function angle(x1, y1, x2, y2, x3, y3) {
        if (x3 == null) {
            var x = x1 - x2, y = y1 - y2;
            if (!x && !y) return 0;
            return (180 + math1.atan2(-y, -x) * 180 / PI + 360) % 360;
        } else return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
    }
    function rad(deg) {
        return deg % 360 * PI / 180;
    }
    function deg(rad) {
        return rad * 180 / PI % 360;
    }
    function x_y() {
        return this.x + S + this.y;
    }
    function x_y_w_h() {
        return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
    }
    /*\
 * Snap.rad
 [ method ]
 **
 * Transform angle to radians
 - deg (number) angle in degrees
 = (number) angle in radians
\*/ Snap.rad = rad;
    /*\
 * Snap.deg
 [ method ]
 **
 * Transform angle to degrees
 - rad (number) angle in radians
 = (number) angle in degrees
\*/ Snap.deg = deg;
    /*\
 * Snap.sin
 [ method ]
 **
 * Equivalent to `Math.sin()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) sin
\*/ Snap.sin = function(angle) {
        return math1.sin(Snap.rad(angle));
    };
    /*\
 * Snap.tan
 [ method ]
 **
 * Equivalent to `Math.tan()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) tan
\*/ Snap.tan = function(angle) {
        return math1.tan(Snap.rad(angle));
    };
    /*\
 * Snap.cos
 [ method ]
 **
 * Equivalent to `Math.cos()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) cos
\*/ Snap.cos = function(angle) {
        return math1.cos(Snap.rad(angle));
    };
    /*\
 * Snap.asin
 [ method ]
 **
 * Equivalent to `Math.asin()` only works with degrees, not radians.
 - num (number) value
 = (number) asin in degrees
\*/ Snap.asin = function(num) {
        return Snap.deg(math1.asin(num));
    };
    /*\
 * Snap.acos
 [ method ]
 **
 * Equivalent to `Math.acos()` only works with degrees, not radians.
 - num (number) value
 = (number) acos in degrees
\*/ Snap.acos = function(num) {
        return Snap.deg(math1.acos(num));
    };
    /*\
 * Snap.atan
 [ method ]
 **
 * Equivalent to `Math.atan()` only works with degrees, not radians.
 - num (number) value
 = (number) atan in degrees
\*/ Snap.atan = function(num) {
        return Snap.deg(math1.atan(num));
    };
    /*\
 * Snap.atan2
 [ method ]
 **
 * Equivalent to `Math.atan2()` only works with degrees, not radians.
 - num (number) value
 = (number) atan2 in degrees
\*/ Snap.atan2 = function(num) {
        return Snap.deg(math1.atan2(num));
    };
    /*\
 * Snap.angle
 [ method ]
 **
 * Returns an angle between two or three points
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 - x3 (number) #optional x coord of third point
 - y3 (number) #optional y coord of third point
 = (number) angle in degrees
\*/ Snap.angle = angle;
    /*\
 * Snap.len
 [ method ]
 **
 * Returns distance between two points
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 = (number) distance
\*/ Snap.len = function(x1, y1, x2, y2) {
        return Math.sqrt(Snap.len2(x1, y1, x2, y2));
    };
    /*\
 * Snap.len2
 [ method ]
 **
 * Returns squared distance between two points
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 = (number) distance
\*/ Snap.len2 = function(x1, y1, x2, y2) {
        return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
    };
    /*\
 * Snap.closestPoint
 [ method ]
 **
 * Returns closest point to a given one on a given path.
 - path (Element) path element
 - x (number) x coord of a point
 - y (number) y coord of a point
 = (object) in format
 {
    x (number) x coord of the point on the path
    y (number) y coord of the point on the path
    length (number) length of the path to the point
    distance (number) distance from the given point to the path
 }
\*/ // Copied from http://bl.ocks.org/mbostock/8027637
    Snap.closestPoint = function(path, x, y) {
        function distance2(p) {
            var dx = p.x - x, dy = p.y - y;
            return dx * dx + dy * dy;
        }
        var pathNode = path.node, pathLength = pathNode.getTotalLength(), precision = pathLength / pathNode.pathSegList.numberOfItems * .125, best, bestLength, bestDistance = Infinity;
        // linear scan for coarse approximation
        for(var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision)if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
            best = scan;
            bestLength = scanLength;
            bestDistance = scanDistance;
        }
        // binary search for precise estimate
        precision *= .5;
        while(precision > .5){
            var before, after, beforeLength, afterLength, beforeDistance, afterDistance;
            if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
                best = before;
                bestLength = beforeLength;
                bestDistance = beforeDistance;
            } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
                best = after;
                bestLength = afterLength;
                bestDistance = afterDistance;
            } else precision *= .5;
        }
        best = {
            x: best.x,
            y: best.y,
            length: bestLength,
            distance: Math.sqrt(bestDistance)
        };
        return best;
    };
    /*\
 * Snap.is
 [ method ]
 **
 * Handy replacement for the `typeof` operator
 - o (…) any object or primitive
 - type (string) name of the type, e.g., `string`, `function`, `number`, etc.
 = (boolean) `true` if given value is of given type
\*/ Snap.is = is;
    /*\
 * Snap.snapTo
 [ method ]
 **
 * Snaps given value to given grid
 - values (array|number) given array of values or step of the grid
 - value (number) value to adjust
 - tolerance (number) #optional maximum distance to the target value that would trigger the snap. Default is `10`.
 = (number) adjusted value
\*/ Snap.snapTo = function(values, value, tolerance) {
        tolerance = is(tolerance, "finite") ? tolerance : 10;
        if (is(values, "array")) {
            var i = values.length;
            while(i--)if (abs(values[i] - value) <= tolerance) return values[i];
        } else {
            values = +values;
            var rem = value % values;
            if (rem < tolerance) return value - rem;
            if (rem > values - tolerance) return value - rem + values;
        }
        return value;
    };
    // Colour
    /*\
 * Snap.getRGB
 [ method ]
 **
 * Parses color string as RGB object
 - color (string) color string in one of the following formats:
 # <ul>
 #     <li>Color name (<code>red</code>, <code>green</code>, <code>cornflowerblue</code>, etc)</li>
 #     <li>#••• — shortened HTML color: (<code>#000</code>, <code>#fc0</code>, etc.)</li>
 #     <li>#•••••• — full length HTML color: (<code>#000000</code>, <code>#bd2300</code>)</li>
 #     <li>rgb(•••, •••, •••) — red, green and blue channels values: (<code>rgb(200,&nbsp;100,&nbsp;0)</code>)</li>
 #     <li>rgba(•••, •••, •••, •••) — also with opacity</li>
 #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>)</li>
 #     <li>rgba(•••%, •••%, •••%, •••%) — also with opacity</li>
 #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>)</li>
 #     <li>hsba(•••, •••, •••, •••) — also with opacity</li>
 #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
 #     <li>hsba(•••%, •••%, •••%, •••%) — also with opacity</li>
 #     <li>hsl(•••, •••, •••) — hue, saturation and luminosity values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;0.5)</code>)</li>
 #     <li>hsla(•••, •••, •••, •••) — also with opacity</li>
 #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
 #     <li>hsla(•••%, •••%, •••%, •••%) — also with opacity</li>
 # </ul>
 * Note that `%` can be used any time: `rgb(20%, 255, 50%)`.
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••,
 o     error (boolean) true if string can't be parsed
 o }
\*/ Snap.getRGB = cacher(function(colour) {
        if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) return {
            r: -1,
            g: -1,
            b: -1,
            hex: "none",
            error: 1,
            toString: rgbtoString
        };
        if (colour == "none") return {
            r: -1,
            g: -1,
            b: -1,
            hex: "none",
            toString: rgbtoString
        };
        !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
        if (!colour) return {
            r: -1,
            g: -1,
            b: -1,
            hex: "none",
            error: 1,
            toString: rgbtoString
        };
        var res1, red, green, blue, opacity, t, values, rgb = colour.match(colourRegExp);
        if (rgb) {
            if (rgb[2]) {
                blue = toInt(rgb[2].substring(5), 16);
                green = toInt(rgb[2].substring(3, 5), 16);
                red = toInt(rgb[2].substring(1, 3), 16);
            }
            if (rgb[3]) {
                blue = toInt((t = rgb[3].charAt(3)) + t, 16);
                green = toInt((t = rgb[3].charAt(2)) + t, 16);
                red = toInt((t = rgb[3].charAt(1)) + t, 16);
            }
            if (rgb[4]) {
                values = rgb[4].split(commaSpaces);
                red = toFloat(values[0]);
                values[0].slice(-1) == "%" && (red *= 2.55);
                green = toFloat(values[1]);
                values[1].slice(-1) == "%" && (green *= 2.55);
                blue = toFloat(values[2]);
                values[2].slice(-1) == "%" && (blue *= 2.55);
                rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
                values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
            }
            if (rgb[5]) {
                values = rgb[5].split(commaSpaces);
                red = toFloat(values[0]);
                values[0].slice(-1) == "%" && (red /= 100);
                green = toFloat(values[1]);
                values[1].slice(-1) == "%" && (green /= 100);
                blue = toFloat(values[2]);
                values[2].slice(-1) == "%" && (blue /= 100);
                (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
                rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
                values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
                return Snap.hsb2rgb(red, green, blue, opacity);
            }
            if (rgb[6]) {
                values = rgb[6].split(commaSpaces);
                red = toFloat(values[0]);
                values[0].slice(-1) == "%" && (red /= 100);
                green = toFloat(values[1]);
                values[1].slice(-1) == "%" && (green /= 100);
                blue = toFloat(values[2]);
                values[2].slice(-1) == "%" && (blue /= 100);
                (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
                rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
                values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
                return Snap.hsl2rgb(red, green, blue, opacity);
            }
            red = mmin(math1.round(red), 255);
            green = mmin(math1.round(green), 255);
            blue = mmin(math1.round(blue), 255);
            opacity = mmin(mmax(opacity, 0), 1);
            rgb = {
                r: red,
                g: green,
                b: blue,
                toString: rgbtoString
            };
            rgb.hex = "#" + (16777216 | blue | green << 8 | red << 16).toString(16).slice(1);
            rgb.opacity = is(opacity, "finite") ? opacity : 1;
            return rgb;
        }
        return {
            r: -1,
            g: -1,
            b: -1,
            hex: "none",
            error: 1,
            toString: rgbtoString
        };
    }, Snap);
    /*\
 * Snap.hsb
 [ method ]
 **
 * Converts HSB values to a hex representation of the color
 - h (number) hue
 - s (number) saturation
 - b (number) value or brightness
 = (string) hex representation of the color
\*/ Snap.hsb = cacher(function(h, s, b) {
        return Snap.hsb2rgb(h, s, b).hex;
    });
    /*\
 * Snap.hsl
 [ method ]
 **
 * Converts HSL values to a hex representation of the color
 - h (number) hue
 - s (number) saturation
 - l (number) luminosity
 = (string) hex representation of the color
\*/ Snap.hsl = cacher(function(h, s, l) {
        return Snap.hsl2rgb(h, s, l).hex;
    });
    /*\
 * Snap.rgb
 [ method ]
 **
 * Converts RGB values to a hex representation of the color
 - r (number) red
 - g (number) green
 - b (number) blue
 = (string) hex representation of the color
\*/ Snap.rgb = cacher(function(r, g1, b, o) {
        if (is(o, "finite")) {
            var round = math1.round;
            return "rgba(" + [
                round(r),
                round(g1),
                round(b),
                +o.toFixed(2)
            ] + ")";
        }
        return "#" + (16777216 | b | g1 << 8 | r << 16).toString(16).slice(1);
    });
    var toHex = function(color) {
        var i = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0], red = "rgb(255, 0, 0)";
        toHex = cacher(function(color) {
            if (color.toLowerCase() == "red") return red;
            i.style.color = red;
            i.style.color = color;
            var out = glob.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
            return out == red ? null : out;
        });
        return toHex(color);
    }, hsbtoString = function() {
        return "hsb(" + [
            this.h,
            this.s,
            this.b
        ] + ")";
    }, hsltoString = function() {
        return "hsl(" + [
            this.h,
            this.s,
            this.l
        ] + ")";
    }, rgbtoString = function() {
        return this.opacity == 1 || this.opacity == null ? this.hex : "rgba(" + [
            this.r,
            this.g,
            this.b,
            this.opacity
        ] + ")";
    }, prepareRGB = function(r, g1, b) {
        if (g1 == null && is(r, "object") && "r" in r && "g" in r && "b" in r) {
            b = r.b;
            g1 = r.g;
            r = r.r;
        }
        if (g1 == null && is(r, string)) {
            var clr = Snap.getRGB(r);
            r = clr.r;
            g1 = clr.g;
            b = clr.b;
        }
        if (r > 1 || g1 > 1 || b > 1) {
            r /= 255;
            g1 /= 255;
            b /= 255;
        }
        return [
            r,
            g1,
            b
        ];
    }, packageRGB = function(r, g1, b, o) {
        r = math1.round(r * 255);
        g1 = math1.round(g1 * 255);
        b = math1.round(b * 255);
        var rgb = {
            r: r,
            g: g1,
            b: b,
            opacity: is(o, "finite") ? o : 1,
            hex: Snap.rgb(r, g1, b),
            toString: rgbtoString
        };
        is(o, "finite") && (rgb.opacity = o);
        return rgb;
    };
    /*\
 * Snap.color
 [ method ]
 **
 * Parses the color string and returns an object featuring the color's component values
 - clr (string) color string in one of the supported formats (see @Snap.getRGB)
 = (object) Combined RGB/HSB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••,
 o     error (boolean) `true` if string can't be parsed,
 o     h (number) hue,
 o     s (number) saturation,
 o     v (number) value (brightness),
 o     l (number) lightness
 o }
\*/ Snap.color = function(clr) {
        var rgb;
        if (is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
            rgb = Snap.hsb2rgb(clr);
            clr.r = rgb.r;
            clr.g = rgb.g;
            clr.b = rgb.b;
            clr.opacity = 1;
            clr.hex = rgb.hex;
        } else if (is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
            rgb = Snap.hsl2rgb(clr);
            clr.r = rgb.r;
            clr.g = rgb.g;
            clr.b = rgb.b;
            clr.opacity = 1;
            clr.hex = rgb.hex;
        } else {
            if (is(clr, "string")) clr = Snap.getRGB(clr);
            if (is(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
                rgb = Snap.rgb2hsl(clr);
                clr.h = rgb.h;
                clr.s = rgb.s;
                clr.l = rgb.l;
                rgb = Snap.rgb2hsb(clr);
                clr.v = rgb.b;
            } else {
                clr = {
                    hex: "none"
                };
                clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
                clr.error = 1;
            }
        }
        clr.toString = rgbtoString;
        return clr;
    };
    /*\
 * Snap.hsb2rgb
 [ method ]
 **
 * Converts HSB values to an RGB object
 - h (number) hue
 - s (number) saturation
 - v (number) value or brightness
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••
 o }
\*/ Snap.hsb2rgb = function(h, s, v, o) {
        if (is(h, "object") && "h" in h && "s" in h && "b" in h) {
            v = h.b;
            s = h.s;
            o = h.o;
            h = h.h;
        }
        h *= 360;
        var R, G, B, X, C;
        h = h % 360 / 60;
        C = v * s;
        X = C * (1 - abs(h % 2 - 1));
        R = G = B = v - C;
        h = ~~h;
        R += [
            C,
            X,
            0,
            0,
            X,
            C
        ][h];
        G += [
            X,
            C,
            C,
            X,
            0,
            0
        ][h];
        B += [
            0,
            0,
            X,
            C,
            C,
            X
        ][h];
        return packageRGB(R, G, B, o);
    };
    /*\
 * Snap.hsl2rgb
 [ method ]
 **
 * Converts HSL values to an RGB object
 - h (number) hue
 - s (number) saturation
 - l (number) luminosity
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••
 o }
\*/ Snap.hsl2rgb = function(h, s, l, o) {
        if (is(h, "object") && "h" in h && "s" in h && "l" in h) {
            l = h.l;
            s = h.s;
            h = h.h;
        }
        if (h > 1 || s > 1 || l > 1) {
            h /= 360;
            s /= 100;
            l /= 100;
        }
        h *= 360;
        var R, G, B, X, C;
        h = h % 360 / 60;
        C = 2 * s * (l < .5 ? l : 1 - l);
        X = C * (1 - abs(h % 2 - 1));
        R = G = B = l - C / 2;
        h = ~~h;
        R += [
            C,
            X,
            0,
            0,
            X,
            C
        ][h];
        G += [
            X,
            C,
            C,
            X,
            0,
            0
        ][h];
        B += [
            0,
            0,
            X,
            C,
            C,
            X
        ][h];
        return packageRGB(R, G, B, o);
    };
    /*\
 * Snap.rgb2hsb
 [ method ]
 **
 * Converts RGB values to an HSB object
 - r (number) red
 - g (number) green
 - b (number) blue
 = (object) HSB object in the following format:
 o {
 o     h (number) hue,
 o     s (number) saturation,
 o     b (number) brightness
 o }
\*/ Snap.rgb2hsb = function(r, g1, b) {
        b = prepareRGB(r, g1, b);
        r = b[0];
        g1 = b[1];
        b = b[2];
        var H, S, V, C;
        V = mmax(r, g1, b);
        C = V - mmin(r, g1, b);
        H = C == 0 ? null : V == r ? (g1 - b) / C : V == g1 ? (b - r) / C + 2 : (r - g1) / C + 4;
        H = (H + 360) % 6 * 60 / 360;
        S = C == 0 ? 0 : C / V;
        return {
            h: H,
            s: S,
            b: V,
            toString: hsbtoString
        };
    };
    /*\
 * Snap.rgb2hsl
 [ method ]
 **
 * Converts RGB values to an HSL object
 - r (number) red
 - g (number) green
 - b (number) blue
 = (object) HSL object in the following format:
 o {
 o     h (number) hue,
 o     s (number) saturation,
 o     l (number) luminosity
 o }
\*/ Snap.rgb2hsl = function(r, g1, b) {
        b = prepareRGB(r, g1, b);
        r = b[0];
        g1 = b[1];
        b = b[2];
        var H, S, L, M, m, C;
        M = mmax(r, g1, b);
        m = mmin(r, g1, b);
        C = M - m;
        H = C == 0 ? null : M == r ? (g1 - b) / C : M == g1 ? (b - r) / C + 2 : (r - g1) / C + 4;
        H = (H + 360) % 6 * 60 / 360;
        L = (M + m) / 2;
        S = C == 0 ? 0 : L < .5 ? C / (2 * L) : C / (2 - 2 * L);
        return {
            h: H,
            s: S,
            l: L,
            toString: hsltoString
        };
    };
    // Transformations
    /*\
 * Snap.parsePathString
 [ method ]
 **
 * Utility method
 **
 * Parses given path string into an array of arrays of path segments
 - pathString (string|array) path string or array of segments (in the last case it is returned straight away)
 = (array) array of segments
\*/ Snap.parsePathString = function(pathString) {
        if (!pathString) return null;
        var pth = Snap.path(pathString);
        if (pth.arr) return Snap.path.clone(pth.arr);
        var paramCounts = {
            a: 7,
            c: 6,
            o: 2,
            h: 1,
            l: 2,
            m: 2,
            r: 4,
            q: 4,
            s: 4,
            t: 2,
            v: 1,
            u: 3,
            z: 0
        }, data = [];
        if (is(pathString, "array") && is(pathString[0], "array")) data = Snap.path.clone(pathString);
        if (!data.length) Str(pathString).replace(pathCommand, function(a, b, c) {
            var params = [], name = b.toLowerCase();
            c.replace(pathValues, function(a, b) {
                b && params.push(+b);
            });
            if (name == "m" && params.length > 2) {
                data.push([
                    b
                ].concat(params.splice(0, 2)));
                name = "l";
                b = b == "m" ? "l" : "L";
            }
            if (name == "o" && params.length == 1) data.push([
                b,
                params[0]
            ]);
            if (name == "r") data.push([
                b
            ].concat(params));
            else while(params.length >= paramCounts[name]){
                data.push([
                    b
                ].concat(params.splice(0, paramCounts[name])));
                if (!paramCounts[name]) break;
            }
        });
        data.toString = Snap.path.toString;
        pth.arr = Snap.path.clone(data);
        return data;
    };
    /*\
 * Snap.parseTransformString
 [ method ]
 **
 * Utility method
 **
 * Parses given transform string into an array of transformations
 - TString (string|array) transform string or array of transformations (in the last case it is returned straight away)
 = (array) array of transformations
\*/ var parseTransformString = Snap.parseTransformString = function(TString) {
        if (!TString) return null;
        var paramCounts = {
            r: 3,
            s: 4,
            t: 2,
            m: 6
        }, data = [];
        if (is(TString, "array") && is(TString[0], "array")) data = Snap.path.clone(TString);
        if (!data.length) Str(TString).replace(tCommand, function(a, b, c) {
            var params = [], name = b.toLowerCase();
            c.replace(pathValues, function(a, b) {
                b && params.push(+b);
            });
            data.push([
                b
            ].concat(params));
        });
        data.toString = Snap.path.toString;
        return data;
    };
    function svgTransform2string(tstr) {
        var res1 = [];
        tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function(all, name, params) {
            params = params.split(/\s*,\s*|\s+/);
            if (name == "rotate" && params.length == 1) params.push(0, 0);
            if (name == "scale") {
                if (params.length > 2) params = params.slice(0, 2);
                else if (params.length == 2) params.push(0, 0);
                if (params.length == 1) params.push(params[0], 0, 0);
            }
            if (name == "skewX") res1.push([
                "m",
                1,
                0,
                math1.tan(rad(params[0])),
                1,
                0,
                0
            ]);
            else if (name == "skewY") res1.push([
                "m",
                1,
                math1.tan(rad(params[0])),
                0,
                1,
                0,
                0
            ]);
            else res1.push([
                name.charAt(0)
            ].concat(params));
            return all;
        });
        return res1;
    }
    Snap._.svgTransform2string = svgTransform2string;
    Snap._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
    function transform2matrix(tstr, bbox) {
        var tdata = parseTransformString(tstr), m = new Snap.Matrix;
        if (tdata) for(var i = 0, ii = tdata.length; i < ii; i++){
            var t = tdata[i], tlen = t.length, command = Str(t[0]).toLowerCase(), absolute = t[0] != command, inver = absolute ? m.invert() : 0, x1, y1, x2, y2, bb;
            if (command == "t" && tlen == 2) m.translate(t[1], 0);
            else if (command == "t" && tlen == 3) {
                if (absolute) {
                    x1 = inver.x(0, 0);
                    y1 = inver.y(0, 0);
                    x2 = inver.x(t[1], t[2]);
                    y2 = inver.y(t[1], t[2]);
                    m.translate(x2 - x1, y2 - y1);
                } else m.translate(t[1], t[2]);
            } else if (command == "r") {
                if (tlen == 2) {
                    bb = bb || bbox;
                    m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                } else if (tlen == 4) {
                    if (absolute) {
                        x2 = inver.x(t[2], t[3]);
                        y2 = inver.y(t[2], t[3]);
                        m.rotate(t[1], x2, y2);
                    } else m.rotate(t[1], t[2], t[3]);
                }
            } else if (command == "s") {
                if (tlen == 2 || tlen == 3) {
                    bb = bb || bbox;
                    m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                } else if (tlen == 4) {
                    if (absolute) {
                        x2 = inver.x(t[2], t[3]);
                        y2 = inver.y(t[2], t[3]);
                        m.scale(t[1], t[1], x2, y2);
                    } else m.scale(t[1], t[1], t[2], t[3]);
                } else if (tlen == 5) {
                    if (absolute) {
                        x2 = inver.x(t[3], t[4]);
                        y2 = inver.y(t[3], t[4]);
                        m.scale(t[1], t[2], x2, y2);
                    } else m.scale(t[1], t[2], t[3], t[4]);
                }
            } else if (command == "m" && tlen == 7) m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
        }
        return m;
    }
    Snap._.transform2matrix = transform2matrix;
    Snap._unit2px = unit2px;
    var contains = glob.doc.contains || glob.doc.compareDocumentPosition ? function(a, b) {
        var adown = a.nodeType == 9 ? a.documentElement : a, bup = b && b.parentNode;
        return a == bup || !!(bup && bup.nodeType == 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    } : function(a, b) {
        if (b) while(b){
            b = b.parentNode;
            if (b == a) return true;
        }
        return false;
    };
    function getSomeDefs(el) {
        var p = el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || el.node.parentNode && wrap(el.node.parentNode) || Snap.select("svg") || Snap(0, 0), pdefs = p.select("defs"), defs = pdefs == null ? false : pdefs.node;
        if (!defs) defs = make("defs", p.node).node;
        return defs;
    }
    function getSomeSVG(el) {
        return el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || Snap.select("svg");
    }
    Snap._.getSomeDefs = getSomeDefs;
    Snap._.getSomeSVG = getSomeSVG;
    function unit2px(el, name, value) {
        var svg = getSomeSVG(el).node, out = {}, mgr = svg.querySelector(".svg---mgr");
        if (!mgr) {
            mgr = $("rect");
            $(mgr, {
                x: -9000000000,
                y: -9000000000,
                width: 10,
                height: 10,
                "class": "svg---mgr",
                fill: "none"
            });
            svg.appendChild(mgr);
        }
        function getW(val) {
            if (val == null) return E;
            if (val == +val) return val;
            $(mgr, {
                width: val
            });
            try {
                return mgr.getBBox().width;
            } catch (e) {
                return 0;
            }
        }
        function getH(val) {
            if (val == null) return E;
            if (val == +val) return val;
            $(mgr, {
                height: val
            });
            try {
                return mgr.getBBox().height;
            } catch (e) {
                return 0;
            }
        }
        function set(nam, f) {
            if (name == null) out[nam] = f(el.attr(nam) || 0);
            else if (nam == name) out = f(value == null ? el.attr(nam) || 0 : value);
        }
        switch(el.type){
            case "rect":
                set("rx", getW);
                set("ry", getH);
            case "image":
                set("width", getW);
                set("height", getH);
            case "text":
                set("x", getW);
                set("y", getH);
                break;
            case "circle":
                set("cx", getW);
                set("cy", getH);
                set("r", getW);
                break;
            case "ellipse":
                set("cx", getW);
                set("cy", getH);
                set("rx", getW);
                set("ry", getH);
                break;
            case "line":
                set("x1", getW);
                set("x2", getW);
                set("y1", getH);
                set("y2", getH);
                break;
            case "marker":
                set("refX", getW);
                set("markerWidth", getW);
                set("refY", getH);
                set("markerHeight", getH);
                break;
            case "radialGradient":
                set("fx", getW);
                set("fy", getH);
                break;
            case "tspan":
                set("dx", getW);
                set("dy", getH);
                break;
            default:
                set(name, getW);
        }
        svg.removeChild(mgr);
        return out;
    }
    /*\
 * Snap.select
 [ method ]
 **
 * Wraps a DOM element specified by CSS selector as @Element
 - query (string) CSS selector of the element
 = (Element) the current element
\*/ Snap.select = function(query) {
        query = Str(query).replace(/([^\\]):/g, "$1\\:");
        return wrap(glob.doc.querySelector(query));
    };
    /*\
 * Snap.selectAll
 [ method ]
 **
 * Wraps DOM elements specified by CSS selector as set or array of @Element
 - query (string) CSS selector of the element
 = (Element) the current element
\*/ Snap.selectAll = function(query) {
        var nodelist = glob.doc.querySelectorAll(query), set = (Snap.set || Array)();
        for(var i = 0; i < nodelist.length; i++)set.push(wrap(nodelist[i]));
        return set;
    };
    function add2group(list) {
        if (!is(list, "array")) list = Array.prototype.slice.call(arguments, 0);
        var i = 0, j = 0, node = this.node;
        while(this[i])delete this[i++];
        for(i = 0; i < list.length; i++)if (list[i].type == "set") list[i].forEach(function(el) {
            node.appendChild(el.node);
        });
        else node.appendChild(list[i].node);
        var children = node.childNodes;
        for(i = 0; i < children.length; i++)this[j++] = wrap(children[i]);
        return this;
    }
    // Hub garbage collector every 10s
    setInterval(function() {
        for(var key in hub)if (hub[has](key)) {
            var el = hub[key], node = el.node;
            if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) delete hub[key];
        }
    }, 1e4);
    function Element(el) {
        if (el.snap in hub) return hub[el.snap];
        var svg;
        try {
            svg = el.ownerSVGElement;
        } catch (e) {}
        /*\
     * Element.node
     [ property (object) ]
     **
     * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
     > Usage
     | // draw a circle at coordinate 10,10 with radius of 10
     | var c = paper.circle(10, 10, 10);
     | c.node.onclick = function () {
     |     c.attr("fill", "red");
     | };
    \*/ this.node = el;
        if (svg) this.paper = new Paper(svg);
        /*\
     * Element.type
     [ property (string) ]
     **
     * SVG tag name of the given element.
    \*/ this.type = el.tagName || el.nodeName;
        var id = this.id = ID(this);
        this.anims = {};
        this._ = {
            transform: []
        };
        el.snap = id;
        hub[id] = this;
        if (this.type == "g") this.add = add2group;
        if (this.type in {
            g: 1,
            mask: 1,
            pattern: 1,
            symbol: 1
        }) {
            for(var method in Paper.prototype)if (Paper.prototype[has](method)) this[method] = Paper.prototype[method];
        }
    }
    /*\
     * Element.attr
     [ method ]
     **
     * Gets or sets given attributes of the element.
     **
     - params (object) contains key-value pairs of attributes you want to set
     * or
     - param (string) name of the attribute
     = (Element) the current element
     * or
     = (string) value of attribute
     > Usage
     | el.attr({
     |     fill: "#fc0",
     |     stroke: "#000",
     |     strokeWidth: 2, // CamelCase...
     |     "fill-opacity": 0.5, // or dash-separated names
     |     width: "*=2" // prefixed values
     | });
     | console.log(el.attr("fill")); // #fc0
     * Prefixed values in format `"+=10"` supported. All four operations
     * (`+`, `-`, `*` and `/`) could be used. Optionally you can use units for `+`
     * and `-`: `"+=2em"`.
    \*/ Element.prototype.attr = function(params, value) {
        var el = this, node = el.node;
        if (!params) {
            if (node.nodeType != 1) return {
                text: node.nodeValue
            };
            var attr = node.attributes, out = {};
            for(var i = 0, ii = attr.length; i < ii; i++)out[attr[i].nodeName] = attr[i].nodeValue;
            return out;
        }
        if (is(params, "string")) {
            if (arguments.length > 1) {
                var json = {};
                json[params] = value;
                params = json;
            } else return eve("snap.util.getattr." + params, el).firstDefined();
        }
        for(var att in params)if (params[has](att)) eve("snap.util.attr." + att, el, params[att]);
        return el;
    };
    /*\
 * Snap.parse
 [ method ]
 **
 * Parses SVG fragment and converts it into a @Fragment
 **
 - svg (string) SVG string
 = (Fragment) the @Fragment
\*/ Snap.parse = function(svg) {
        var f = glob.doc.createDocumentFragment(), full = true, div = glob.doc.createElement("div");
        svg = Str(svg);
        if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
            svg = "<svg>" + svg + "</svg>";
            full = false;
        }
        div.innerHTML = svg;
        svg = div.getElementsByTagName("svg")[0];
        if (svg) {
            if (full) f = svg;
            else while(svg.firstChild)f.appendChild(svg.firstChild);
        }
        return new Fragment(f);
    };
    function Fragment(frag) {
        this.node = frag;
    }
    /*\
 * Snap.fragment
 [ method ]
 **
 * Creates a DOM fragment from a given list of elements or strings
 **
 - varargs (…) SVG string
 = (Fragment) the @Fragment
\*/ Snap.fragment = function() {
        var args = Array.prototype.slice.call(arguments, 0), f = glob.doc.createDocumentFragment();
        for(var i = 0, ii = args.length; i < ii; i++){
            var item = args[i];
            if (item.node && item.node.nodeType) f.appendChild(item.node);
            if (item.nodeType) f.appendChild(item);
            if (typeof item == "string") f.appendChild(Snap.parse(item).node);
        }
        return new Fragment(f);
    };
    function make(name, parent) {
        var res1 = $(name);
        parent.appendChild(res1);
        var el = wrap(res1);
        return el;
    }
    function Paper(w, h) {
        var res1, desc, defs, proto = Paper.prototype;
        if (w && w.tagName && w.tagName.toLowerCase() == "svg") {
            if (w.snap in hub) return hub[w.snap];
            var doc = w.ownerDocument;
            res1 = new Element(w);
            desc = w.getElementsByTagName("desc")[0];
            defs = w.getElementsByTagName("defs")[0];
            if (!desc) {
                desc = $("desc");
                desc.appendChild(doc.createTextNode("Created with Snap"));
                res1.node.appendChild(desc);
            }
            if (!defs) {
                defs = $("defs");
                res1.node.appendChild(defs);
            }
            res1.defs = defs;
            for(var key in proto)if (proto[has](key)) res1[key] = proto[key];
            res1.paper = res1.root = res1;
        } else {
            res1 = make("svg", glob.doc.body);
            $(res1.node, {
                height: h,
                version: 1.1,
                width: w,
                xmlns: xmlns
            });
        }
        return res1;
    }
    function wrap(dom) {
        if (!dom) return dom;
        if (dom instanceof Element || dom instanceof Fragment) return dom;
        if (dom.tagName && dom.tagName.toLowerCase() == "svg") return new Paper(dom);
        if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
        return new Element(dom);
    }
    Snap._.make = make;
    Snap._.wrap = wrap;
    /*\
 * Paper.el
 [ method ]
 **
 * Creates an element on paper with a given name and no attributes
 **
 - name (string) tag name
 - attr (object) attributes
 = (Element) the current element
 > Usage
 | var c = paper.circle(10, 10, 10); // is the same as...
 | var c = paper.el("circle").attr({
 |     cx: 10,
 |     cy: 10,
 |     r: 10
 | });
 | // and the same as
 | var c = paper.el("circle", {
 |     cx: 10,
 |     cy: 10,
 |     r: 10
 | });
\*/ Paper.prototype.el = function(name, attr) {
        var el = make(name, this.node);
        attr && el.attr(attr);
        return el;
    };
    /*\
 * Element.children
 [ method ]
 **
 * Returns array of all the children of the element.
 = (array) array of Elements
\*/ Element.prototype.children = function() {
        var out = [], ch = this.node.childNodes;
        for(var i = 0, ii = ch.length; i < ii; i++)out[i] = Snap(ch[i]);
        return out;
    };
    function jsonFiller(root, o) {
        for(var i = 0, ii = root.length; i < ii; i++){
            var item = {
                type: root[i].type,
                attr: root[i].attr()
            }, children = root[i].children();
            o.push(item);
            if (children.length) jsonFiller(children, item.childNodes = []);
        }
    }
    /*\
 * Element.toJSON
 [ method ]
 **
 * Returns object representation of the given element and all its children.
 = (object) in format
 o {
 o     type (string) this.type,
 o     attr (object) attributes map,
 o     childNodes (array) optional array of children in the same format
 o }
\*/ Element.prototype.toJSON = function() {
        var out = [];
        jsonFiller([
            this
        ], out);
        return out[0];
    };
    // default
    eve.on("snap.util.getattr", function() {
        var att = eve.nt();
        att = att.substring(att.lastIndexOf(".") + 1);
        var css = att.replace(/[A-Z]/g, function(letter) {
            return "-" + letter.toLowerCase();
        });
        if (cssAttr[has](css)) return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
        else return $(this.node, att);
    });
    var cssAttr = {
        "alignment-baseline": 0,
        "baseline-shift": 0,
        "clip": 0,
        "clip-path": 0,
        "clip-rule": 0,
        "color": 0,
        "color-interpolation": 0,
        "color-interpolation-filters": 0,
        "color-profile": 0,
        "color-rendering": 0,
        "cursor": 0,
        "direction": 0,
        "display": 0,
        "dominant-baseline": 0,
        "enable-background": 0,
        "fill": 0,
        "fill-opacity": 0,
        "fill-rule": 0,
        "filter": 0,
        "flood-color": 0,
        "flood-opacity": 0,
        "font": 0,
        "font-family": 0,
        "font-size": 0,
        "font-size-adjust": 0,
        "font-stretch": 0,
        "font-style": 0,
        "font-variant": 0,
        "font-weight": 0,
        "glyph-orientation-horizontal": 0,
        "glyph-orientation-vertical": 0,
        "image-rendering": 0,
        "kerning": 0,
        "letter-spacing": 0,
        "lighting-color": 0,
        "marker": 0,
        "marker-end": 0,
        "marker-mid": 0,
        "marker-start": 0,
        "mask": 0,
        "opacity": 0,
        "overflow": 0,
        "pointer-events": 0,
        "shape-rendering": 0,
        "stop-color": 0,
        "stop-opacity": 0,
        "stroke": 0,
        "stroke-dasharray": 0,
        "stroke-dashoffset": 0,
        "stroke-linecap": 0,
        "stroke-linejoin": 0,
        "stroke-miterlimit": 0,
        "stroke-opacity": 0,
        "stroke-width": 0,
        "text-anchor": 0,
        "text-decoration": 0,
        "text-rendering": 0,
        "unicode-bidi": 0,
        "visibility": 0,
        "word-spacing": 0,
        "writing-mode": 0
    };
    eve.on("snap.util.attr", function(value) {
        var att = eve.nt(), attr = {};
        att = att.substring(att.lastIndexOf(".") + 1);
        attr[att] = value;
        var style = att.replace(/-(\w)/gi, function(all, letter) {
            return letter.toUpperCase();
        }), css = att.replace(/[A-Z]/g, function(letter) {
            return "-" + letter.toLowerCase();
        });
        if (cssAttr[has](css)) this.node.style[style] = value == null ? E : value;
        else $(this.node, attr);
    });
    Paper.prototype;
    // simple ajax
    /*\
 * Snap.ajax
 [ method ]
 **
 * Simple implementation of Ajax
 **
 - url (string) URL
 - postData (object|string) data for post request
 - callback (function) callback
 - scope (object) #optional scope of callback
 * or
 - url (string) URL
 - callback (function) callback
 - scope (object) #optional scope of callback
 = (XMLHttpRequest) the XMLHttpRequest object, just in case
\*/ Snap.ajax = function(url, postData, callback, scope) {
        var req = new XMLHttpRequest, id = ID();
        if (req) {
            if (is(postData, "function")) {
                scope = callback;
                callback = postData;
                postData = null;
            } else if (is(postData, "object")) {
                var pd = [];
                for(var key in postData)if (postData.hasOwnProperty(key)) pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
                postData = pd.join("&");
            }
            req.open(postData ? "POST" : "GET", url, true);
            if (postData) {
                req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            }
            if (callback) {
                eve.once("snap.ajax." + id + ".0", callback);
                eve.once("snap.ajax." + id + ".200", callback);
                eve.once("snap.ajax." + id + ".304", callback);
            }
            req.onreadystatechange = function() {
                if (req.readyState != 4) return;
                eve("snap.ajax." + id + "." + req.status, scope, req);
            };
            if (req.readyState == 4) return req;
            req.send(postData);
            return req;
        }
    };
    /*\
 * Snap.load
 [ method ]
 **
 * Loads external SVG file as a @Fragment (see @Snap.ajax for more advanced AJAX)
 **
 - url (string) URL
 - callback (function) callback
 - scope (object) #optional scope of callback
\*/ Snap.load = function(url, callback, scope) {
        Snap.ajax(url, function(req) {
            var f = Snap.parse(req.responseText);
            scope ? callback.call(scope, f) : callback(f);
        });
    };
    var getOffset = function(elem) {
        var box = elem.getBoundingClientRect(), doc = elem.ownerDocument, body = doc.body, docElem = doc.documentElement, clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0, top = box.top + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop) - clientTop, left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
        return {
            y: top,
            x: left
        };
    };
    /*\
 * Snap.getElementByPoint
 [ method ]
 **
 * Returns you topmost element under given point.
 **
 = (object) Snap element object
 - x (number) x coordinate from the top left corner of the window
 - y (number) y coordinate from the top left corner of the window
 > Usage
 | Snap.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
\*/ Snap.getElementByPoint = function(x, y) {
        var paper = this, svg = paper.canvas, target = glob.doc.elementFromPoint(x, y);
        if (glob.win.opera && target.tagName == "svg") {
            var so = getOffset(target), sr = target.createSVGRect();
            sr.x = x - so.x;
            sr.y = y - so.y;
            sr.width = sr.height = 1;
            var hits = target.getIntersectionList(sr, null);
            if (hits.length) target = hits[hits.length - 1];
        }
        if (!target) return null;
        return wrap(target);
    };
    /*\
 * Snap.plugin
 [ method ]
 **
 * Let you write plugins. You pass in a function with five arguments, like this:
 | Snap.plugin(function (Snap, Element, Paper, global, Fragment) {
 |     Snap.newmethod = function () {};
 |     Element.prototype.newmethod = function () {};
 |     Paper.prototype.newmethod = function () {};
 | });
 * Inside the function you have access to all main objects (and their
 * prototypes). This allow you to extend anything you want.
 **
 - f (function) your plugin body
\*/ Snap.plugin = function(f) {
        f(Snap, Element, Paper, glob, Fragment);
    };
    glob.win.Snap = Snap;
    return Snap;
}(window || module.exports);
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var elproto = Element.prototype, is = Snap.is, Str = String, unit2px = Snap._unit2px, $ = Snap._.$, make = Snap._.make, getSomeDefs = Snap._.getSomeDefs, has = "hasOwnProperty", wrap = Snap._.wrap;
    /*\
     * Element.getBBox
     [ method ]
     **
     * Returns the bounding box descriptor for the given element
     **
     = (object) bounding box descriptor:
     o {
     o     cx: (number) x of the center,
     o     cy: (number) x of the center,
     o     h: (number) height,
     o     height: (number) height,
     o     path: (string) path command for the box,
     o     r0: (number) radius of a circle that fully encloses the box,
     o     r1: (number) radius of the smallest circle that can be enclosed,
     o     r2: (number) radius of the largest circle that can be enclosed,
     o     vb: (string) box as a viewbox command,
     o     w: (number) width,
     o     width: (number) width,
     o     x2: (number) x of the right side,
     o     x: (number) x of the left side,
     o     y2: (number) y of the bottom edge,
     o     y: (number) y of the top edge
     o }
    \*/ elproto.getBBox = function(isWithoutTransform) {
        if (this.type == "tspan") return Snap._.box(this.node.getClientRects().item(0));
        if (!Snap.Matrix || !Snap.path) return this.node.getBBox();
        var el = this, m = new Snap.Matrix;
        if (el.removed) return Snap._.box();
        while(el.type == "use"){
            if (!isWithoutTransform) m = m.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
            if (el.original) el = el.original;
            else {
                var href = el.attr("xlink:href");
                el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
            }
        }
        var _ = el._, pathfinder = Snap.path.get[el.type] || Snap.path.get.deflt;
        try {
            if (isWithoutTransform) {
                _.bboxwt = pathfinder ? Snap.path.getBBox(el.realPath = pathfinder(el)) : Snap._.box(el.node.getBBox());
                return Snap._.box(_.bboxwt);
            } else {
                el.realPath = pathfinder(el);
                el.matrix = el.transform().localMatrix;
                _.bbox = Snap.path.getBBox(Snap.path.map(el.realPath, m.add(el.matrix)));
                return Snap._.box(_.bbox);
            }
        } catch (e) {
            // Firefox doesn’t give you bbox of hidden element
            return Snap._.box();
        }
    };
    var propString = function() {
        return this.string;
    };
    function extractTransform(el, tstr) {
        if (tstr == null) {
            var doReturn = true;
            if (el.type == "linearGradient" || el.type == "radialGradient") tstr = el.node.getAttribute("gradientTransform");
            else if (el.type == "pattern") tstr = el.node.getAttribute("patternTransform");
            else tstr = el.node.getAttribute("transform");
            if (!tstr) return new Snap.Matrix;
            tstr = Snap._.svgTransform2string(tstr);
        } else {
            if (!Snap._.rgTransform.test(tstr)) tstr = Snap._.svgTransform2string(tstr);
            else tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || "");
            if (is(tstr, "array")) tstr = Snap.path ? Snap.path.toString.call(tstr) : Str(tstr);
            el._.transform = tstr;
        }
        var m = Snap._.transform2matrix(tstr, el.getBBox(1));
        if (doReturn) return m;
        else el.matrix = m;
    }
    /*\
     * Element.transform
     [ method ]
     **
     * Gets or sets transformation of the element
     **
     - tstr (string) transform string in Snap or SVG format
     = (Element) the current element
     * or
     = (object) transformation descriptor:
     o {
     o     string (string) transform string,
     o     globalMatrix (Matrix) matrix of all transformations applied to element or its parents,
     o     localMatrix (Matrix) matrix of transformations applied only to the element,
     o     diffMatrix (Matrix) matrix of difference between global and local transformations,
     o     global (string) global transformation as string,
     o     local (string) local transformation as string,
     o     toString (function) returns `string` property
     o }
    \*/ elproto.transform = function(tstr) {
        var _ = this._;
        if (tstr == null) {
            var papa = this, global = new Snap.Matrix(this.node.getCTM()), local = extractTransform(this), ms = [
                local
            ], m = new Snap.Matrix, i, localString = local.toTransformString(), string1 = Str(local) == Str(this.matrix) ? Str(_.transform) : localString;
            while(papa.type != "svg" && (papa = papa.parent()))ms.push(extractTransform(papa));
            i = ms.length;
            while(i--)m.add(ms[i]);
            return {
                string: string1,
                globalMatrix: global,
                totalMatrix: m,
                localMatrix: local,
                diffMatrix: global.clone().add(local.invert()),
                global: global.toTransformString(),
                total: m.toTransformString(),
                local: localString,
                toString: propString
            };
        }
        if (tstr instanceof Snap.Matrix) {
            this.matrix = tstr;
            this._.transform = tstr.toTransformString();
        } else extractTransform(this, tstr);
        if (this.node) {
            if (this.type == "linearGradient" || this.type == "radialGradient") $(this.node, {
                gradientTransform: this.matrix
            });
            else if (this.type == "pattern") $(this.node, {
                patternTransform: this.matrix
            });
            else $(this.node, {
                transform: this.matrix
            });
        }
        return this;
    };
    /*\
     * Element.parent
     [ method ]
     **
     * Returns the element's parent
     **
     = (Element) the parent element
    \*/ elproto.parent = function() {
        return wrap(this.node.parentNode);
    };
    /*\
     * Element.append
     [ method ]
     **
     * Appends the given element to current one
     **
     - el (Element|Set) element to append
     = (Element) the parent element
    \*/ /*\
     * Element.add
     [ method ]
     **
     * See @Element.append
    \*/ elproto.append = elproto.add = function(el) {
        if (el) {
            if (el.type == "set") {
                var it = this;
                el.forEach(function(el) {
                    it.add(el);
                });
                return this;
            }
            el = wrap(el);
            this.node.appendChild(el.node);
            el.paper = this.paper;
        }
        return this;
    };
    /*\
     * Element.appendTo
     [ method ]
     **
     * Appends the current element to the given one
     **
     - el (Element) parent element to append to
     = (Element) the child element
    \*/ elproto.appendTo = function(el) {
        if (el) {
            el = wrap(el);
            el.append(this);
        }
        return this;
    };
    /*\
     * Element.prepend
     [ method ]
     **
     * Prepends the given element to the current one
     **
     - el (Element) element to prepend
     = (Element) the parent element
    \*/ elproto.prepend = function(el) {
        if (el) {
            if (el.type == "set") {
                var it = this, first;
                el.forEach(function(el) {
                    if (first) first.after(el);
                    else it.prepend(el);
                    first = el;
                });
                return this;
            }
            el = wrap(el);
            var parent = el.parent();
            this.node.insertBefore(el.node, this.node.firstChild);
            this.add && this.add();
            el.paper = this.paper;
            this.parent() && this.parent().add();
            parent && parent.add();
        }
        return this;
    };
    /*\
     * Element.prependTo
     [ method ]
     **
     * Prepends the current element to the given one
     **
     - el (Element) parent element to prepend to
     = (Element) the child element
    \*/ elproto.prependTo = function(el) {
        el = wrap(el);
        el.prepend(this);
        return this;
    };
    /*\
     * Element.before
     [ method ]
     **
     * Inserts given element before the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/ elproto.before = function(el) {
        if (el.type == "set") {
            var it = this;
            el.forEach(function(el) {
                var parent = el.parent();
                it.node.parentNode.insertBefore(el.node, it.node);
                parent && parent.add();
            });
            this.parent().add();
            return this;
        }
        el = wrap(el);
        var parent = el.parent();
        this.node.parentNode.insertBefore(el.node, this.node);
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
    };
    /*\
     * Element.after
     [ method ]
     **
     * Inserts given element after the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/ elproto.after = function(el) {
        el = wrap(el);
        var parent = el.parent();
        if (this.node.nextSibling) this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
        else this.node.parentNode.appendChild(el.node);
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
    };
    /*\
     * Element.insertBefore
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/ elproto.insertBefore = function(el) {
        el = wrap(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
    };
    /*\
     * Element.insertAfter
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/ elproto.insertAfter = function(el) {
        el = wrap(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
    };
    /*\
     * Element.remove
     [ method ]
     **
     * Removes element from the DOM
     = (Element) the detached element
    \*/ elproto.remove = function() {
        var parent = this.parent();
        this.node.parentNode && this.node.parentNode.removeChild(this.node);
        delete this.paper;
        this.removed = true;
        parent && parent.add();
        return this;
    };
    /*\
     * Element.select
     [ method ]
     **
     * Gathers the nested @Element matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Element) result of query selection
    \*/ elproto.select = function(query) {
        return wrap(this.node.querySelector(query));
    };
    /*\
     * Element.selectAll
     [ method ]
     **
     * Gathers nested @Element objects matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Set|array) result of query selection
    \*/ elproto.selectAll = function(query) {
        var nodelist = this.node.querySelectorAll(query), set = (Snap.set || Array)();
        for(var i = 0; i < nodelist.length; i++)set.push(wrap(nodelist[i]));
        return set;
    };
    /*\
     * Element.asPX
     [ method ]
     **
     * Returns given attribute of the element as a `px` value (not %, em, etc.)
     **
     - attr (string) attribute name
     - value (string) #optional attribute value
     = (Element) result of query selection
    \*/ elproto.asPX = function(attr, value) {
        if (value == null) value = this.attr(attr);
        return +unit2px(this, attr, value);
    };
    // SIERRA Element.use(): I suggest adding a note about how to access the original element the returned <use> instantiates. It's a part of SVG with which ordinary web developers may be least familiar.
    /*\
     * Element.use
     [ method ]
     **
     * Creates a `<use>` element linked to the current element
     **
     = (Element) the `<use>` element
    \*/ elproto.use = function() {
        var use, id = this.node.id;
        if (!id) {
            id = this.id;
            $(this.node, {
                id: id
            });
        }
        if (this.type == "linearGradient" || this.type == "radialGradient" || this.type == "pattern") use = make(this.type, this.node.parentNode);
        else use = make("use", this.node.parentNode);
        $(use.node, {
            "xlink:href": "#" + id
        });
        use.original = this;
        return use;
    };
    function fixids(el) {
        var els = el.selectAll("*"), it, url = /^\s*url\(("|'|)(.*)\1\)\s*$/, ids = [], uses = {};
        function urltest(it, name) {
            var val = $(it.node, name);
            val = val && val.match(url);
            val = val && val[2];
            if (val && val.charAt() == "#") val = val.substring(1);
            else return;
            if (val) uses[val] = (uses[val] || []).concat(function(id) {
                var attr = {};
                attr[name] = Snap.url(id);
                $(it.node, attr);
            });
        }
        function linktest(it) {
            var val = $(it.node, "xlink:href");
            if (val && val.charAt() == "#") val = val.substring(1);
            else return;
            if (val) uses[val] = (uses[val] || []).concat(function(id) {
                it.attr("xlink:href", "#" + id);
            });
        }
        for(var i = 0, ii = els.length; i < ii; i++){
            it = els[i];
            urltest(it, "fill");
            urltest(it, "stroke");
            urltest(it, "filter");
            urltest(it, "mask");
            urltest(it, "clip-path");
            linktest(it);
            var oldid = $(it.node, "id");
            if (oldid) {
                $(it.node, {
                    id: it.id
                });
                ids.push({
                    old: oldid,
                    id: it.id
                });
            }
        }
        for(i = 0, ii = ids.length; i < ii; i++){
            var fs = uses[ids[i].old];
            if (fs) for(var j = 0, jj = fs.length; j < jj; j++)fs[j](ids[i].id);
        }
    }
    /*\
     * Element.clone
     [ method ]
     **
     * Creates a clone of the element and inserts it after the element
     **
     = (Element) the clone
    \*/ elproto.clone = function() {
        var clone = wrap(this.node.cloneNode(true));
        if ($(clone.node, "id")) $(clone.node, {
            id: clone.id
        });
        fixids(clone);
        clone.insertAfter(this);
        return clone;
    };
    /*\
     * Element.toDefs
     [ method ]
     **
     * Moves element to the shared `<defs>` area
     **
     = (Element) the element
    \*/ elproto.toDefs = function() {
        var defs = getSomeDefs(this);
        defs.appendChild(this.node);
        return this;
    };
    /*\
     * Element.toPattern
     [ method ]
     **
     * Creates a `<pattern>` element from the current element
     **
     * To create a pattern you have to specify the pattern rect:
     - x (string|number)
     - y (string|number)
     - width (string|number)
     - height (string|number)
     = (Element) the `<pattern>` element
     * You can use pattern later on as an argument for `fill` attribute:
     | var p = paper.path("M10-5-10,15M15,0,0,15M0-5-20,15").attr({
     |         fill: "none",
     |         stroke: "#bada55",
     |         strokeWidth: 5
     |     }).pattern(0, 0, 10, 10),
     |     c = paper.circle(200, 200, 100);
     | c.attr({
     |     fill: p
     | });
    \*/ elproto.pattern = elproto.toPattern = function(x, y, width, height) {
        var p = make("pattern", getSomeDefs(this));
        if (x == null) x = this.getBBox();
        if (is(x, "object") && "x" in x) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        $(p.node, {
            x: x,
            y: y,
            width: width,
            height: height,
            patternUnits: "userSpaceOnUse",
            id: p.id,
            viewBox: [
                x,
                y,
                width,
                height
            ].join(" ")
        });
        p.node.appendChild(this.node);
        return p;
    };
    // SIERRA Element.marker(): clarify what a reference point is. E.g., helps you offset the object from its edge such as when centering it over a path.
    // SIERRA Element.marker(): I suggest the method should accept default reference point values.  Perhaps centered with (refX = width/2) and (refY = height/2)? Also, couldn't it assume the element's current _width_ and _height_? And please specify what _x_ and _y_ mean: offsets? If so, from where?  Couldn't they also be assigned default values?
    /*\
     * Element.marker
     [ method ]
     **
     * Creates a `<marker>` element from the current element
     **
     * To create a marker you have to specify the bounding rect and reference point:
     - x (number)
     - y (number)
     - width (number)
     - height (number)
     - refX (number)
     - refY (number)
     = (Element) the `<marker>` element
     * You can specify the marker later as an argument for `marker-start`, `marker-end`, `marker-mid`, and `marker` attributes. The `marker` attribute places the marker at every point along the path, and `marker-mid` places them at every point except the start and end.
    \*/ // TODO add usage for markers
    elproto.marker = function(x, y, width, height, refX, refY) {
        var p = make("marker", getSomeDefs(this));
        if (x == null) x = this.getBBox();
        if (is(x, "object") && "x" in x) {
            y = x.y;
            width = x.width;
            height = x.height;
            refX = x.refX || x.cx;
            refY = x.refY || x.cy;
            x = x.x;
        }
        $(p.node, {
            viewBox: [
                x,
                y,
                width,
                height
            ].join(" "),
            markerWidth: width,
            markerHeight: height,
            orient: "auto",
            refX: refX || 0,
            refY: refY || 0,
            id: p.id
        });
        p.node.appendChild(this.node);
        return p;
    };
    var eldata = {};
    /*\
     * Element.data
     [ method ]
     **
     * Adds or retrieves given value associated with given key. (Don’t confuse
     * with `data-` attributes)
     *
     * See also @Element.removeData
     - key (string) key to store data
     - value (any) #optional value to store
     = (object) @Element
     * or, if value is not specified:
     = (any) value
     > Usage
     | for (var i = 0, i < 5, i++) {
     |     paper.circle(10 + 15 * i, 10, 10)
     |          .attr({fill: "#000"})
     |          .data("i", i)
     |          .click(function () {
     |             alert(this.data("i"));
     |          });
     | }
    \*/ elproto.data = function(key, value) {
        var data = eldata[this.id] = eldata[this.id] || {};
        if (arguments.length == 0) {
            eve("snap.data.get." + this.id, this, data, null);
            return data;
        }
        if (arguments.length == 1) {
            if (Snap.is(key, "object")) {
                for(var i in key)if (key[has](i)) this.data(i, key[i]);
                return this;
            }
            eve("snap.data.get." + this.id, this, data[key], key);
            return data[key];
        }
        data[key] = value;
        eve("snap.data.set." + this.id, this, value, key);
        return this;
    };
    /*\
     * Element.removeData
     [ method ]
     **
     * Removes value associated with an element by given key.
     * If key is not provided, removes all the data of the element.
     - key (string) #optional key
     = (object) @Element
    \*/ elproto.removeData = function(key) {
        if (key == null) eldata[this.id] = {};
        else eldata[this.id] && delete eldata[this.id][key];
        return this;
    };
    /*\
     * Element.outerSVG
     [ method ]
     **
     * Returns SVG code for the element, equivalent to HTML's `outerHTML`.
     *
     * See also @Element.innerSVG
     = (string) SVG code for the element
    \*/ /*\
     * Element.toString
     [ method ]
     **
     * See @Element.outerSVG
    \*/ elproto.outerSVG = elproto.toString = toString(1);
    /*\
     * Element.innerSVG
     [ method ]
     **
     * Returns SVG code for the element's contents, equivalent to HTML's `innerHTML`
     = (string) SVG code for the element
    \*/ elproto.innerSVG = toString();
    function toString(type) {
        return function() {
            var res1 = type ? "<" + this.type : "", attr = this.node.attributes, chld = this.node.childNodes;
            if (type) for(var i = 0, ii = attr.length; i < ii; i++)res1 += " " + attr[i].name + '="' + attr[i].value.replace(/"/g, '\\"') + '"';
            if (chld.length) {
                type && (res1 += ">");
                for(i = 0, ii = chld.length; i < ii; i++){
                    if (chld[i].nodeType == 3) res1 += chld[i].nodeValue;
                    else if (chld[i].nodeType == 1) res1 += wrap(chld[i]).toString();
                }
                type && (res1 += "</" + this.type + ">");
            } else type && (res1 += "/>");
            return res1;
        };
    }
    elproto.toDataURL = function() {
        if (window && window.btoa) {
            var bb = this.getBBox(), svg = Snap.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
                x: +bb.x.toFixed(3),
                y: +bb.y.toFixed(3),
                width: +bb.width.toFixed(3),
                height: +bb.height.toFixed(3),
                contents: this.outerSVG()
            });
            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
        }
    };
    /*\
     * Fragment.select
     [ method ]
     **
     * See @Element.select
    \*/ Fragment.prototype.select = elproto.select;
    /*\
     * Fragment.selectAll
     [ method ]
     **
     * See @Element.selectAll
    \*/ Fragment.prototype.selectAll = elproto.selectAll;
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var objectToString = Object.prototype.toString, Str = String, math1 = Math, E = "";
    function Matrix(a, b, c, d, e, f) {
        if (b == null && objectToString.call(a) == "[object SVGMatrix]") {
            this.a = a.a;
            this.b = a.b;
            this.c = a.c;
            this.d = a.d;
            this.e = a.e;
            this.f = a.f;
            return;
        }
        if (a != null) {
            this.a = +a;
            this.b = +b;
            this.c = +c;
            this.d = +d;
            this.e = +e;
            this.f = +f;
        } else {
            this.a = 1;
            this.b = 0;
            this.c = 0;
            this.d = 1;
            this.e = 0;
            this.f = 0;
        }
    }
    (function(matrixproto) {
        /*\
         * Matrix.add
         [ method ]
         **
         * Adds the given matrix to existing one
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         * or
         - matrix (object) @Matrix
        \*/ matrixproto.add = function(a, b, c, d, e, f) {
            if (a && a instanceof Matrix) return this.add(a.a, a.b, a.c, a.d, a.e, a.f);
            var aNew = a * this.a + b * this.c, bNew = a * this.b + b * this.d;
            this.e += e * this.a + f * this.c;
            this.f += e * this.b + f * this.d;
            this.c = c * this.a + d * this.c;
            this.d = c * this.b + d * this.d;
            this.a = aNew;
            this.b = bNew;
            return this;
        };
        /*\
         * Matrix.multLeft
         [ method ]
         **
         * Multiplies a passed affine transform to the left: M * this.
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         * or
         - matrix (object) @Matrix
        \*/ Matrix.prototype.multLeft = function(a, b, c, d, e, f) {
            if (a && a instanceof Matrix) return this.multLeft(a.a, a.b, a.c, a.d, a.e, a.f);
            var aNew = a * this.a + c * this.b, cNew = a * this.c + c * this.d, eNew = a * this.e + c * this.f + e;
            this.b = b * this.a + d * this.b;
            this.d = b * this.c + d * this.d;
            this.f = b * this.e + d * this.f + f;
            this.a = aNew;
            this.c = cNew;
            this.e = eNew;
            return this;
        };
        /*\
         * Matrix.invert
         [ method ]
         **
         * Returns an inverted version of the matrix
         = (object) @Matrix
        \*/ matrixproto.invert = function() {
            var me = this, x = me.a * me.d - me.b * me.c;
            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
        };
        /*\
         * Matrix.clone
         [ method ]
         **
         * Returns a copy of the matrix
         = (object) @Matrix
        \*/ matrixproto.clone = function() {
            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
        };
        /*\
         * Matrix.translate
         [ method ]
         **
         * Translate the matrix
         - x (number) horizontal offset distance
         - y (number) vertical offset distance
        \*/ matrixproto.translate = function(x, y) {
            this.e += x * this.a + y * this.c;
            this.f += x * this.b + y * this.d;
            return this;
        };
        /*\
         * Matrix.scale
         [ method ]
         **
         * Scales the matrix
         - x (number) amount to be scaled, with `1` resulting in no change
         - y (number) #optional amount to scale along the vertical axis. (Otherwise `x` applies to both axes.)
         - cx (number) #optional horizontal origin point from which to scale
         - cy (number) #optional vertical origin point from which to scale
         * Default cx, cy is the middle point of the element.
        \*/ matrixproto.scale = function(x, y, cx, cy) {
            y == null && (y = x);
            (cx || cy) && this.translate(cx, cy);
            this.a *= x;
            this.b *= x;
            this.c *= y;
            this.d *= y;
            (cx || cy) && this.translate(-cx, -cy);
            return this;
        };
        /*\
         * Matrix.rotate
         [ method ]
         **
         * Rotates the matrix
         - a (number) angle of rotation, in degrees
         - x (number) horizontal origin point from which to rotate
         - y (number) vertical origin point from which to rotate
        \*/ matrixproto.rotate = function(a, x, y) {
            a = Snap.rad(a);
            x = x || 0;
            y = y || 0;
            var cos = +math1.cos(a).toFixed(9), sin = +math1.sin(a).toFixed(9);
            this.add(cos, sin, -sin, cos, x, y);
            return this.add(1, 0, 0, 1, -x, -y);
        };
        /*\
         * Matrix.skewX
         [ method ]
         **
         * Skews the matrix along the x-axis
         - x (number) Angle to skew along the x-axis (in degrees).
        \*/ matrixproto.skewX = function(x) {
            return this.skew(x, 0);
        };
        /*\
         * Matrix.skewY
         [ method ]
         **
         * Skews the matrix along the y-axis
         - y (number) Angle to skew along the y-axis (in degrees).
        \*/ matrixproto.skewY = function(y) {
            return this.skew(0, y);
        };
        /*\
         * Matrix.skew
         [ method ]
         **
         * Skews the matrix
         - y (number) Angle to skew along the y-axis (in degrees).
         - x (number) Angle to skew along the x-axis (in degrees).
        \*/ matrixproto.skew = function(x, y) {
            x = x || 0;
            y = y || 0;
            x = Snap.rad(x);
            y = Snap.rad(y);
            var c = math1.tan(x).toFixed(9);
            var b = math1.tan(y).toFixed(9);
            return this.add(1, b, c, 1, 0, 0);
        };
        /*\
         * Matrix.x
         [ method ]
         **
         * Returns x coordinate for given point after transformation described by the matrix. See also @Matrix.y
         - x (number)
         - y (number)
         = (number) x
        \*/ matrixproto.x = function(x, y) {
            return x * this.a + y * this.c + this.e;
        };
        /*\
         * Matrix.y
         [ method ]
         **
         * Returns y coordinate for given point after transformation described by the matrix. See also @Matrix.x
         - x (number)
         - y (number)
         = (number) y
        \*/ matrixproto.y = function(x, y) {
            return x * this.b + y * this.d + this.f;
        };
        matrixproto.get = function(i) {
            return +this[Str.fromCharCode(97 + i)].toFixed(4);
        };
        matrixproto.toString = function() {
            return "matrix(" + [
                this.get(0),
                this.get(1),
                this.get(2),
                this.get(3),
                this.get(4),
                this.get(5)
            ].join() + ")";
        };
        matrixproto.offset = function() {
            return [
                this.e.toFixed(4),
                this.f.toFixed(4)
            ];
        };
        function norm(a) {
            return a[0] * a[0] + a[1] * a[1];
        }
        function normalize(a) {
            var mag = math1.sqrt(norm(a));
            a[0] && (a[0] /= mag);
            a[1] && (a[1] /= mag);
        }
        /*\
         * Matrix.determinant
         [ method ]
         **
         * Finds determinant of the given matrix.
         = (number) determinant
        \*/ matrixproto.determinant = function() {
            return this.a * this.d - this.b * this.c;
        };
        /*\
         * Matrix.split
         [ method ]
         **
         * Splits matrix into primitive transformations
         = (object) in format:
         o dx (number) translation by x
         o dy (number) translation by y
         o scalex (number) scale by x
         o scaley (number) scale by y
         o shear (number) shear
         o rotate (number) rotation in deg
         o isSimple (boolean) could it be represented via simple transformations
        \*/ matrixproto.split = function() {
            var out = {};
            // translation
            out.dx = this.e;
            out.dy = this.f;
            // scale and shear
            var row = [
                [
                    this.a,
                    this.b
                ],
                [
                    this.c,
                    this.d
                ]
            ];
            out.scalex = math1.sqrt(norm(row[0]));
            normalize(row[0]);
            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
            row[1] = [
                row[1][0] - row[0][0] * out.shear,
                row[1][1] - row[0][1] * out.shear
            ];
            out.scaley = math1.sqrt(norm(row[1]));
            normalize(row[1]);
            out.shear /= out.scaley;
            if (this.determinant() < 0) out.scalex = -out.scalex;
            // rotation
            var sin = row[0][1], cos = row[1][1];
            if (cos < 0) {
                out.rotate = Snap.deg(math1.acos(cos));
                if (sin < 0) out.rotate = 360 - out.rotate;
            } else out.rotate = Snap.deg(math1.asin(sin));
            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
            return out;
        };
        /*\
         * Matrix.toTransformString
         [ method ]
         **
         * Returns transform string that represents given matrix
         = (string) transform string
        \*/ matrixproto.toTransformString = function(shorter) {
            var s = shorter || this.split();
            if (!+s.shear.toFixed(9)) {
                s.scalex = +s.scalex.toFixed(4);
                s.scaley = +s.scaley.toFixed(4);
                s.rotate = +s.rotate.toFixed(4);
                return (s.dx || s.dy ? "t" + [
                    +s.dx.toFixed(4),
                    +s.dy.toFixed(4)
                ] : E) + (s.rotate ? "r" + [
                    +s.rotate.toFixed(4),
                    0,
                    0
                ] : E) + (s.scalex != 1 || s.scaley != 1 ? "s" + [
                    s.scalex,
                    s.scaley,
                    0,
                    0
                ] : E);
            } else return "m" + [
                this.get(0),
                this.get(1),
                this.get(2),
                this.get(3),
                this.get(4),
                this.get(5)
            ];
        };
    })(Matrix.prototype);
    /*\
     * Snap.Matrix
     [ method ]
     **
     * Matrix constructor, extend on your own risk.
     * To create matrices use @Snap.matrix.
    \*/ Snap.Matrix = Matrix;
    /*\
     * Snap.matrix
     [ method ]
     **
     * Utility method
     **
     * Returns a matrix based on the given parameters
     - a (number)
     - b (number)
     - c (number)
     - d (number)
     - e (number)
     - f (number)
     * or
     - svgMatrix (SVGMatrix)
     = (object) @Matrix
    \*/ Snap.matrix = function(a, b, c, d, e, f) {
        return new Matrix(a, b, c, d, e, f);
    };
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var has = "hasOwnProperty", make = Snap._.make, wrap = Snap._.wrap, is = Snap.is, getSomeDefs = Snap._.getSomeDefs, reURLValue = /^url\((['"]?)([^)]+)\1\)$/, $ = Snap._.$, URL = Snap.url, Str = String, separator = Snap._.separator, E = "";
    /*\
     * Snap.deurl
     [ method ]
     **
     * Unwraps path from `"url(<path>)"`.
     - value (string) url path
     = (string) unwrapped path
    \*/ Snap.deurl = function(value) {
        var res1 = String(value).match(reURLValue);
        return res1 ? res1[2] : value;
    };
    // Attributes event handlers
    eve.on("snap.util.attr.mask", function(value) {
        if (value instanceof Element || value instanceof Fragment) {
            eve.stop();
            if (value instanceof Fragment && value.node.childNodes.length == 1) {
                value = value.node.firstChild;
                getSomeDefs(this).appendChild(value);
                value = wrap(value);
            }
            if (value.type == "mask") var mask = value;
            else {
                mask = make("mask", getSomeDefs(this));
                mask.node.appendChild(value.node);
            }
            !mask.node.id && $(mask.node, {
                id: mask.id
            });
            $(this.node, {
                mask: URL(mask.id)
            });
        }
    });
    (function(clipIt) {
        eve.on("snap.util.attr.clip", clipIt);
        eve.on("snap.util.attr.clip-path", clipIt);
        eve.on("snap.util.attr.clipPath", clipIt);
    })(function(value) {
        if (value instanceof Element || value instanceof Fragment) {
            eve.stop();
            var clip, node = value.node;
            while(node){
                if (node.nodeName === "clipPath") {
                    clip = new Element(node);
                    break;
                }
                if (node.nodeName === "svg") {
                    clip = undefined;
                    break;
                }
                node = node.parentNode;
            }
            if (!clip) {
                clip = make("clipPath", getSomeDefs(this));
                clip.node.appendChild(value.node);
                !clip.node.id && $(clip.node, {
                    id: clip.id
                });
            }
            $(this.node, {
                "clip-path": URL(clip.node.id || clip.id)
            });
        }
    });
    function fillStroke(name) {
        return function(value) {
            eve.stop();
            if (value instanceof Fragment && value.node.childNodes.length == 1 && (value.node.firstChild.tagName == "radialGradient" || value.node.firstChild.tagName == "linearGradient" || value.node.firstChild.tagName == "pattern")) {
                value = value.node.firstChild;
                getSomeDefs(this).appendChild(value);
                value = wrap(value);
            }
            if (value instanceof Element) {
                if (value.type == "radialGradient" || value.type == "linearGradient" || value.type == "pattern") {
                    if (!value.node.id) $(value.node, {
                        id: value.id
                    });
                    var fill = URL(value.node.id);
                } else fill = value.attr(name);
            } else {
                fill = Snap.color(value);
                if (fill.error) {
                    var grad = Snap(getSomeDefs(this).ownerSVGElement).gradient(value);
                    if (grad) {
                        if (!grad.node.id) $(grad.node, {
                            id: grad.id
                        });
                        fill = URL(grad.node.id);
                    } else fill = value;
                } else fill = Str(fill);
            }
            var attrs = {};
            attrs[name] = fill;
            $(this.node, attrs);
            this.node.style[name] = E;
        };
    }
    eve.on("snap.util.attr.fill", fillStroke("fill"));
    eve.on("snap.util.attr.stroke", fillStroke("stroke"));
    var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
    eve.on("snap.util.grad.parse", function parseGrad(string1) {
        string1 = Str(string1);
        var tokens = string1.match(gradrg);
        if (!tokens) return null;
        var type = tokens[1], params = tokens[2], stops = tokens[3];
        params = params.split(/\s*,\s*/).map(function(el) {
            return +el == el ? +el : el;
        });
        if (params.length == 1 && params[0] == 0) params = [];
        stops = stops.split("-");
        stops = stops.map(function(el) {
            el = el.split(":");
            var out = {
                color: el[0]
            };
            if (el[1]) out.offset = parseFloat(el[1]);
            return out;
        });
        var len = stops.length, start = 0, j = 0;
        function seed(i, end) {
            var step = (end - start) / (i - j);
            for(var k = j; k < i; k++)stops[k].offset = +(+start + step * (k - j)).toFixed(2);
            j = i;
            start = end;
        }
        len--;
        for(var i = 0; i < len; i++)if ("offset" in stops[i]) seed(i, stops[i].offset);
        stops[len].offset = stops[len].offset || 100;
        seed(len, stops[len].offset);
        return {
            type: type,
            params: params,
            stops: stops
        };
    });
    eve.on("snap.util.attr.d", function(value) {
        eve.stop();
        if (is(value, "array") && is(value[0], "array")) value = Snap.path.toString.call(value);
        value = Str(value);
        if (value.match(/[ruo]/i)) value = Snap.path.toAbsolute(value);
        $(this.node, {
            d: value
        });
    })(-1);
    eve.on("snap.util.attr.#text", function(value) {
        eve.stop();
        value = Str(value);
        var txt = glob.doc.createTextNode(value);
        while(this.node.firstChild)this.node.removeChild(this.node.firstChild);
        this.node.appendChild(txt);
    })(-1);
    eve.on("snap.util.attr.path", function(value) {
        eve.stop();
        this.attr({
            d: value
        });
    })(-1);
    eve.on("snap.util.attr.class", function(value) {
        eve.stop();
        this.node.className.baseVal = value;
    })(-1);
    eve.on("snap.util.attr.viewBox", function(value) {
        var vb;
        if (is(value, "object") && "x" in value) vb = [
            value.x,
            value.y,
            value.width,
            value.height
        ].join(" ");
        else if (is(value, "array")) vb = value.join(" ");
        else vb = value;
        $(this.node, {
            viewBox: vb
        });
        eve.stop();
    })(-1);
    eve.on("snap.util.attr.transform", function(value) {
        this.transform(value);
        eve.stop();
    })(-1);
    eve.on("snap.util.attr.r", function(value) {
        if (this.type == "rect") {
            eve.stop();
            $(this.node, {
                rx: value,
                ry: value
            });
        }
    })(-1);
    eve.on("snap.util.attr.textpath", function(value) {
        eve.stop();
        if (this.type == "text") {
            var id, tp, node;
            if (!value && this.textPath) {
                tp = this.textPath;
                while(tp.node.firstChild)this.node.appendChild(tp.node.firstChild);
                tp.remove();
                delete this.textPath;
                return;
            }
            if (is(value, "string")) {
                var defs = getSomeDefs(this), path = wrap(defs.parentNode).path(value);
                defs.appendChild(path.node);
                id = path.id;
                path.attr({
                    id: id
                });
            } else {
                value = wrap(value);
                if (value instanceof Element) {
                    id = value.attr("id");
                    if (!id) {
                        id = value.id;
                        value.attr({
                            id: id
                        });
                    }
                }
            }
            if (id) {
                tp = this.textPath;
                node = this.node;
                if (tp) tp.attr({
                    "xlink:href": "#" + id
                });
                else {
                    tp = $("textPath", {
                        "xlink:href": "#" + id
                    });
                    while(node.firstChild)tp.appendChild(node.firstChild);
                    node.appendChild(tp);
                    this.textPath = wrap(tp);
                }
            }
        }
    })(-1);
    eve.on("snap.util.attr.text", function(value) {
        if (this.type == "text") {
            var i = 0, node = this.node, tuner = function(chunk) {
                var out = $("tspan");
                if (is(chunk, "array")) for(var i = 0; i < chunk.length; i++)out.appendChild(tuner(chunk[i]));
                else out.appendChild(glob.doc.createTextNode(chunk));
                out.normalize && out.normalize();
                return out;
            };
            while(node.firstChild)node.removeChild(node.firstChild);
            var tuned = tuner(value);
            while(tuned.firstChild)node.appendChild(tuned.firstChild);
        }
        eve.stop();
    })(-1);
    function setFontSize(value) {
        eve.stop();
        if (value == +value) value += "px";
        this.node.style.fontSize = value;
    }
    eve.on("snap.util.attr.fontSize", setFontSize)(-1);
    eve.on("snap.util.attr.font-size", setFontSize)(-1);
    eve.on("snap.util.getattr.transform", function() {
        eve.stop();
        return this.transform();
    })(-1);
    eve.on("snap.util.getattr.textpath", function() {
        eve.stop();
        return this.textPath;
    })(-1);
    // Markers
    (function() {
        function getter(end) {
            return function() {
                eve.stop();
                var style = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
                if (style == "none") return style;
                else return Snap(glob.doc.getElementById(style.match(reURLValue)[1]));
            };
        }
        function setter(end) {
            return function(value) {
                eve.stop();
                var name = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
                if (value == "" || !value) {
                    this.node.style[name] = "none";
                    return;
                }
                if (value.type == "marker") {
                    var id = value.node.id;
                    if (!id) $(value.node, {
                        id: value.id
                    });
                    this.node.style[name] = URL(id);
                    return;
                }
            };
        }
        eve.on("snap.util.getattr.marker-end", getter("end"))(-1);
        eve.on("snap.util.getattr.markerEnd", getter("end"))(-1);
        eve.on("snap.util.getattr.marker-start", getter("start"))(-1);
        eve.on("snap.util.getattr.markerStart", getter("start"))(-1);
        eve.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
        eve.on("snap.util.getattr.markerMid", getter("mid"))(-1);
        eve.on("snap.util.attr.marker-end", setter("end"))(-1);
        eve.on("snap.util.attr.markerEnd", setter("end"))(-1);
        eve.on("snap.util.attr.marker-start", setter("start"))(-1);
        eve.on("snap.util.attr.markerStart", setter("start"))(-1);
        eve.on("snap.util.attr.marker-mid", setter("mid"))(-1);
        eve.on("snap.util.attr.markerMid", setter("mid"))(-1);
    })();
    eve.on("snap.util.getattr.r", function() {
        if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
            eve.stop();
            return $(this.node, "rx");
        }
    })(-1);
    function textExtract(node) {
        var out = [];
        var children = node.childNodes;
        for(var i = 0, ii = children.length; i < ii; i++){
            var chi = children[i];
            if (chi.nodeType == 3) out.push(chi.nodeValue);
            if (chi.tagName == "tspan") {
                if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) out.push(chi.firstChild.nodeValue);
                else out.push(textExtract(chi));
            }
        }
        return out;
    }
    eve.on("snap.util.getattr.text", function() {
        if (this.type == "text" || this.type == "tspan") {
            eve.stop();
            var out = textExtract(this.node);
            return out.length == 1 ? out[0] : out;
        }
    })(-1);
    eve.on("snap.util.getattr.#text", function() {
        return this.node.textContent;
    })(-1);
    eve.on("snap.util.getattr.fill", function(internal) {
        if (internal) return;
        eve.stop();
        var value = eve("snap.util.getattr.fill", this, true).firstDefined();
        return Snap(Snap.deurl(value)) || value;
    })(-1);
    eve.on("snap.util.getattr.stroke", function(internal) {
        if (internal) return;
        eve.stop();
        var value = eve("snap.util.getattr.stroke", this, true).firstDefined();
        return Snap(Snap.deurl(value)) || value;
    })(-1);
    eve.on("snap.util.getattr.viewBox", function() {
        eve.stop();
        var vb = $(this.node, "viewBox");
        if (vb) {
            vb = vb.split(separator);
            return Snap._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
        } else return;
    })(-1);
    eve.on("snap.util.getattr.points", function() {
        var p = $(this.node, "points");
        eve.stop();
        if (p) return p.split(separator);
        else return;
    })(-1);
    eve.on("snap.util.getattr.path", function() {
        var p = $(this.node, "d");
        eve.stop();
        return p;
    })(-1);
    eve.on("snap.util.getattr.class", function() {
        return this.node.className.baseVal;
    })(-1);
    function getFontSize() {
        eve.stop();
        return this.node.style.fontSize;
    }
    eve.on("snap.util.getattr.fontSize", getFontSize)(-1);
    eve.on("snap.util.getattr.font-size", getFontSize)(-1);
});
// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var rgNotSpace = /\S+/g, rgBadSpace = /[\t\r\n\f]/g, rgTrim = /(^\s+|\s+$)/g, Str = String, elproto = Element.prototype;
    /*\
     * Element.addClass
     [ method ]
     **
     * Adds given class name or list of class names to the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/ elproto.addClass = function(value) {
        var classes = Str(value || "").match(rgNotSpace) || [], elem = this.node, className = elem.className.baseVal, curClasses = className.match(rgNotSpace) || [], j, pos, clazz, finalValue;
        if (classes.length) {
            j = 0;
            while(clazz = classes[j++]){
                pos = curClasses.indexOf(clazz);
                if (!~pos) curClasses.push(clazz);
            }
            finalValue = curClasses.join(" ");
            if (className != finalValue) elem.className.baseVal = finalValue;
        }
        return this;
    };
    /*\
     * Element.removeClass
     [ method ]
     **
     * Removes given class name or list of class names from the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/ elproto.removeClass = function(value) {
        var classes = Str(value || "").match(rgNotSpace) || [], elem = this.node, className = elem.className.baseVal, curClasses = className.match(rgNotSpace) || [], j, pos, clazz, finalValue;
        if (curClasses.length) {
            j = 0;
            while(clazz = classes[j++]){
                pos = curClasses.indexOf(clazz);
                if (~pos) curClasses.splice(pos, 1);
            }
            finalValue = curClasses.join(" ");
            if (className != finalValue) elem.className.baseVal = finalValue;
        }
        return this;
    };
    /*\
     * Element.hasClass
     [ method ]
     **
     * Checks if the element has a given class name in the list of class names applied to it.
     - value (string) class name
     **
     = (boolean) `true` if the element has given class
    \*/ elproto.hasClass = function(value) {
        var elem = this.node, className = elem.className.baseVal, curClasses = className.match(rgNotSpace) || [];
        return !!~curClasses.indexOf(value);
    };
    /*\
     * Element.toggleClass
     [ method ]
     **
     * Add or remove one or more classes from the element, depending on either
     * the class’s presence or the value of the `flag` argument.
     - value (string) class name or space separated list of class names
     - flag (boolean) value to determine whether the class should be added or removed
     **
     = (Element) original element.
    \*/ elproto.toggleClass = function(value, flag) {
        if (flag != null) {
            if (flag) return this.addClass(value);
            else return this.removeClass(value);
        }
        var classes = (value || "").match(rgNotSpace) || [], elem = this.node, className = elem.className.baseVal, curClasses = className.match(rgNotSpace) || [], j, pos, clazz, finalValue;
        j = 0;
        while(clazz = classes[j++]){
            pos = curClasses.indexOf(clazz);
            if (~pos) curClasses.splice(pos, 1);
            else curClasses.push(clazz);
        }
        finalValue = curClasses.join(" ");
        if (className != finalValue) elem.className.baseVal = finalValue;
        return this;
    };
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var operators = {
        "+": function(x, y) {
            return x + y;
        },
        "-": function(x, y) {
            return x - y;
        },
        "/": function(x, y) {
            return x / y;
        },
        "*": function(x, y) {
            return x * y;
        }
    }, Str = String, reUnit = /[a-z]+$/i, reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
    function getNumber(val) {
        return val;
    }
    function getUnit(unit) {
        return function(val) {
            return +val.toFixed(3) + unit;
        };
    }
    eve.on("snap.util.attr", function(val) {
        var plus = Str(val).match(reAddon);
        if (plus) {
            var evnt = eve.nt(), name = evnt.substring(evnt.lastIndexOf(".") + 1), a = this.attr(name), atr = {};
            eve.stop();
            var unit = plus[3] || "", aUnit = a.match(reUnit), op = operators[plus[1]];
            if (aUnit && aUnit == unit) val = op(parseFloat(a), +plus[2]);
            else {
                a = this.asPX(name);
                val = op(this.asPX(name), this.asPX(name, plus[2] + unit));
            }
            if (isNaN(a) || isNaN(val)) return;
            atr[name] = val;
            this.attr(atr);
        }
    })(-10);
    eve.on("snap.util.equal", function(name, b) {
        var A, B, a = Str(this.attr(name) || ""), el = this, bplus = Str(b).match(reAddon);
        if (bplus) {
            eve.stop();
            var unit = bplus[3] || "", aUnit = a.match(reUnit), op = operators[bplus[1]];
            if (aUnit && aUnit == unit) return {
                from: parseFloat(a),
                to: op(parseFloat(a), +bplus[2]),
                f: getUnit(aUnit)
            };
            else {
                a = this.asPX(name);
                return {
                    from: a,
                    to: op(a, this.asPX(name, bplus[2] + unit)),
                    f: getNumber
                };
            }
        }
    })(-10);
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var proto = Paper.prototype, is = Snap.is;
    /*\
     * Paper.rect
     [ method ]
     *
     * Draws a rectangle
     **
     - x (number) x coordinate of the top left corner
     - y (number) y coordinate of the top left corner
     - width (number) width
     - height (number) height
     - rx (number) #optional horizontal radius for rounded corners, default is 0
     - ry (number) #optional vertical radius for rounded corners, default is rx or 0
     = (object) the `rect` element
     **
     > Usage
     | // regular rectangle
     | var c = paper.rect(10, 10, 50, 50);
     | // rectangle with rounded corners
     | var c = paper.rect(40, 40, 50, 50, 10);
    \*/ proto.rect = function(x, y, w, h, rx, ry) {
        var attr;
        if (ry == null) ry = rx;
        if (is(x, "object") && x == "[object Object]") attr = x;
        else if (x != null) {
            attr = {
                x: x,
                y: y,
                width: w,
                height: h
            };
            if (rx != null) {
                attr.rx = rx;
                attr.ry = ry;
            }
        }
        return this.el("rect", attr);
    };
    /*\
     * Paper.circle
     [ method ]
     **
     * Draws a circle
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - r (number) radius
     = (object) the `circle` element
     **
     > Usage
     | var c = paper.circle(50, 50, 40);
    \*/ proto.circle = function(cx, cy, r) {
        var attr;
        if (is(cx, "object") && cx == "[object Object]") attr = cx;
        else if (cx != null) attr = {
            cx: cx,
            cy: cy,
            r: r
        };
        return this.el("circle", attr);
    };
    var preload = function() {
        function onerror() {
            this.parentNode.removeChild(this);
        }
        return function(src, f) {
            var img = glob.doc.createElement("img"), body = glob.doc.body;
            img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
            img.onload = function() {
                f.call(img);
                img.onload = img.onerror = null;
                body.removeChild(img);
            };
            img.onerror = onerror;
            body.appendChild(img);
            img.src = src;
        };
    }();
    /*\
     * Paper.image
     [ method ]
     **
     * Places an image on the surface
     **
     - src (string) URI of the source image
     - x (number) x offset position
     - y (number) y offset position
     - width (number) width of the image
     - height (number) height of the image
     = (object) the `image` element
     * or
     = (object) Snap element object with type `image`
     **
     > Usage
     | var c = paper.image("apple.png", 10, 10, 80, 80);
    \*/ proto.image = function(src, x, y, width, height) {
        var el = this.el("image");
        if (is(src, "object") && "src" in src) el.attr(src);
        else if (src != null) {
            var set = {
                "xlink:href": src,
                preserveAspectRatio: "none"
            };
            if (x != null && y != null) {
                set.x = x;
                set.y = y;
            }
            if (width != null && height != null) {
                set.width = width;
                set.height = height;
            } else preload(src, function() {
                Snap._.$(el.node, {
                    width: this.offsetWidth,
                    height: this.offsetHeight
                });
            });
            Snap._.$(el.node, set);
        }
        return el;
    };
    /*\
     * Paper.ellipse
     [ method ]
     **
     * Draws an ellipse
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - rx (number) horizontal radius
     - ry (number) vertical radius
     = (object) the `ellipse` element
     **
     > Usage
     | var c = paper.ellipse(50, 50, 40, 20);
    \*/ proto.ellipse = function(cx, cy, rx, ry) {
        var attr;
        if (is(cx, "object") && cx == "[object Object]") attr = cx;
        else if (cx != null) attr = {
            cx: cx,
            cy: cy,
            rx: rx,
            ry: ry
        };
        return this.el("ellipse", attr);
    };
    // SIERRA Paper.path(): Unclear from the link what a Catmull-Rom curveto is, and why it would make life any easier.
    /*\
     * Paper.path
     [ method ]
     **
     * Creates a `<path>` element using the given string as the path's definition
     - pathString (string) #optional path string in SVG format
     * Path string consists of one-letter commands, followed by comma seprarated arguments in numerical form. Example:
     | "M10,20L30,40"
     * This example features two commands: `M`, with arguments `(10, 20)` and `L` with arguments `(30, 40)`. Uppercase letter commands express coordinates in absolute terms, while lowercase commands express them in relative terms from the most recently declared coordinates.
     *
     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a> or <a href="https://developer.mozilla.org/en/SVG/Tutorial/Paths">article about path strings at MDN</a>.</p>
     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
     * * _Catmull-Rom curveto_ is a not standard SVG command and added to make life easier.
     * Note: there is a special case when a path consists of only three commands: `M10,10R…z`. In this case the path connects back to its starting point.
     > Usage
     | var c = paper.path("M10 10L90 90");
     | // draw a diagonal line:
     | // move to 10,10, line to 90,90
    \*/ proto.path = function(d) {
        var attr;
        if (is(d, "object") && !is(d, "array")) attr = d;
        else if (d) attr = {
            d: d
        };
        return this.el("path", attr);
    };
    /*\
     * Paper.g
     [ method ]
     **
     * Creates a group element
     **
     - varargs (…) #optional elements to nest within the group
     = (object) the `g` element
     **
     > Usage
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g(c2, c1); // note that the order of elements is different
     * or
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g();
     | g.add(c2, c1);
    \*/ /*\
     * Paper.group
     [ method ]
     **
     * See @Paper.g
    \*/ proto.group = proto.g = function(first) {
        var attr, el = this.el("g");
        if (arguments.length == 1 && first && !first.type) el.attr(first);
        else if (arguments.length) el.add(Array.prototype.slice.call(arguments, 0));
        return el;
    };
    /*\
     * Paper.svg
     [ method ]
     **
     * Creates a nested SVG element.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `svg` element
     **
    \*/ proto.svg = function(x, y, width, height, vbx, vby, vbw, vbh) {
        var attrs = {};
        if (is(x, "object") && y == null) attrs = x;
        else {
            if (x != null) attrs.x = x;
            if (y != null) attrs.y = y;
            if (width != null) attrs.width = width;
            if (height != null) attrs.height = height;
            if (vbx != null && vby != null && vbw != null && vbh != null) attrs.viewBox = [
                vbx,
                vby,
                vbw,
                vbh
            ];
        }
        return this.el("svg", attrs);
    };
    /*\
     * Paper.mask
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a mask.
     **
     = (object) the `mask` element
     **
    \*/ proto.mask = function(first) {
        var attr, el = this.el("mask");
        if (arguments.length == 1 && first && !first.type) el.attr(first);
        else if (arguments.length) el.add(Array.prototype.slice.call(arguments, 0));
        return el;
    };
    /*\
     * Paper.ptrn
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a pattern.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `pattern` element
     **
    \*/ proto.ptrn = function(x, y, width, height, vx, vy, vw, vh) {
        if (is(x, "object")) var attr = x;
        else {
            attr = {
                patternUnits: "userSpaceOnUse"
            };
            if (x) attr.x = x;
            if (y) attr.y = y;
            if (width != null) attr.width = width;
            if (height != null) attr.height = height;
            if (vx != null && vy != null && vw != null && vh != null) attr.viewBox = [
                vx,
                vy,
                vw,
                vh
            ];
            else attr.viewBox = [
                x || 0,
                y || 0,
                width || 0,
                height || 0
            ];
        }
        return this.el("pattern", attr);
    };
    /*\
     * Paper.use
     [ method ]
     **
     * Creates a <use> element.
     - id (string) @optional id of element to link
     * or
     - id (Element) @optional element to link
     **
     = (object) the `use` element
     **
    \*/ proto.use = function(id) {
        if (id != null) {
            if (id instanceof Element) {
                if (!id.attr("id")) id.attr({
                    id: Snap._.id(id)
                });
                id = id.attr("id");
            }
            if (String(id).charAt() == "#") id = id.substring(1);
            return this.el("use", {
                "xlink:href": "#" + id
            });
        } else return Element.prototype.use.call(this);
    };
    /*\
     * Paper.symbol
     [ method ]
     **
     * Creates a <symbol> element.
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     = (object) the `symbol` element
     **
    \*/ proto.symbol = function(vx, vy, vw, vh) {
        var attr = {};
        if (vx != null && vy != null && vw != null && vh != null) attr.viewBox = [
            vx,
            vy,
            vw,
            vh
        ];
        return this.el("symbol", attr);
    };
    /*\
     * Paper.text
     [ method ]
     **
     * Draws a text string
     **
     - x (number) x coordinate position
     - y (number) y coordinate position
     - text (string|array) The text string to draw or array of strings to nest within separate `<tspan>` elements
     = (object) the `text` element
     **
     > Usage
     | var t1 = paper.text(50, 50, "Snap");
     | var t2 = paper.text(50, 50, ["S","n","a","p"]);
     | // Text path usage
     | t1.attr({textpath: "M10,10L100,100"});
     | // or
     | var pth = paper.path("M10,10L100,100");
     | t1.attr({textpath: pth});
    \*/ proto.text = function(x, y, text) {
        var attr = {};
        if (is(x, "object")) attr = x;
        else if (x != null) attr = {
            x: x,
            y: y,
            text: text || ""
        };
        return this.el("text", attr);
    };
    /*\
     * Paper.line
     [ method ]
     **
     * Draws a line
     **
     - x1 (number) x coordinate position of the start
     - y1 (number) y coordinate position of the start
     - x2 (number) x coordinate position of the end
     - y2 (number) y coordinate position of the end
     = (object) the `line` element
     **
     > Usage
     | var t1 = paper.line(50, 50, 100, 100);
    \*/ proto.line = function(x1, y1, x2, y2) {
        var attr = {};
        if (is(x1, "object")) attr = x1;
        else if (x1 != null) attr = {
            x1: x1,
            x2: x2,
            y1: y1,
            y2: y2
        };
        return this.el("line", attr);
    };
    /*\
     * Paper.polyline
     [ method ]
     **
     * Draws a polyline
     **
     - points (array) array of points
     * or
     - varargs (…) points
     = (object) the `polyline` element
     **
     > Usage
     | var p1 = paper.polyline([10, 10, 100, 100]);
     | var p2 = paper.polyline(10, 10, 100, 100);
    \*/ proto.polyline = function(points) {
        if (arguments.length > 1) points = Array.prototype.slice.call(arguments, 0);
        var attr = {};
        if (is(points, "object") && !is(points, "array")) attr = points;
        else if (points != null) attr = {
            points: points
        };
        return this.el("polyline", attr);
    };
    /*\
     * Paper.polygon
     [ method ]
     **
     * Draws a polygon. See @Paper.polyline
    \*/ proto.polygon = function(points) {
        if (arguments.length > 1) points = Array.prototype.slice.call(arguments, 0);
        var attr = {};
        if (is(points, "object") && !is(points, "array")) attr = points;
        else if (points != null) attr = {
            points: points
        };
        return this.el("polygon", attr);
    };
    // gradients
    (function() {
        var $ = Snap._.$;
        // gradients' helpers
        /*\
         * Element.stops
         [ method ]
         **
         * Only for gradients!
         * Returns array of gradient stops elements.
         = (array) the stops array.
        \*/ function Gstops() {
            return this.selectAll("stop");
        }
        /*\
         * Element.addStop
         [ method ]
         **
         * Only for gradients!
         * Adds another stop to the gradient.
         - color (string) stops color
         - offset (number) stops offset 0..100
         = (object) gradient element
        \*/ function GaddStop(color, offset) {
            var stop = $("stop"), attr = {
                offset: +offset + "%"
            };
            color = Snap.color(color);
            attr["stop-color"] = color.hex;
            if (color.opacity < 1) attr["stop-opacity"] = color.opacity;
            $(stop, attr);
            var stops = this.stops(), inserted;
            for(var i = 0; i < stops.length; i++){
                var stopOffset = parseFloat(stops[i].attr("offset"));
                if (stopOffset > offset) {
                    this.node.insertBefore(stop, stops[i].node);
                    inserted = true;
                    break;
                }
            }
            if (!inserted) this.node.appendChild(stop);
            return this;
        }
        function GgetBBox() {
            if (this.type == "linearGradient") {
                var x1 = $(this.node, "x1") || 0, x2 = $(this.node, "x2") || 1, y1 = $(this.node, "y1") || 0, y2 = $(this.node, "y2") || 0;
                return Snap._.box(x1, y1, math.abs(x2 - x1), math.abs(y2 - y1));
            } else {
                var cx = this.node.cx || .5, cy = this.node.cy || .5, r = this.node.r || 0;
                return Snap._.box(cx - r, cy - r, r * 2, r * 2);
            }
        }
        /*\
         * Element.setStops
         [ method ]
         **
         * Only for gradients!
         * Updates stops of the gradient based on passed gradient descriptor. See @Ppaer.gradient
         - str (string) gradient descriptor part after `()`.
         = (object) gradient element
         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
         | g.setStops("#fff-#000-#f00-#fc0");
        \*/ function GsetStops(str) {
            var grad = str, stops = this.stops();
            if (typeof str == "string") grad = eve("snap.util.grad.parse", null, "l(0,0,0,1)" + str).firstDefined().stops;
            if (!Snap.is(grad, "array")) return;
            for(var i = 0; i < stops.length; i++)if (grad[i]) {
                var color = Snap.color(grad[i].color), attr = {
                    "offset": grad[i].offset + "%"
                };
                attr["stop-color"] = color.hex;
                if (color.opacity < 1) attr["stop-opacity"] = color.opacity;
                stops[i].attr(attr);
            } else stops[i].remove();
            for(i = stops.length; i < grad.length; i++)this.addStop(grad[i].color, grad[i].offset);
            return this;
        }
        function gradient(defs, str) {
            var grad = eve("snap.util.grad.parse", null, str).firstDefined(), el;
            if (!grad) return null;
            grad.params.unshift(defs);
            if (grad.type.toLowerCase() == "l") el = gradientLinear.apply(0, grad.params);
            else el = gradientRadial.apply(0, grad.params);
            if (grad.type != grad.type.toLowerCase()) $(el.node, {
                gradientUnits: "userSpaceOnUse"
            });
            var stops = grad.stops, len = stops.length;
            for(var i = 0; i < len; i++){
                var stop = stops[i];
                el.addStop(stop.color, stop.offset);
            }
            return el;
        }
        function gradientLinear(defs, x1, y1, x2, y2) {
            var el = Snap._.make("linearGradient", defs);
            el.stops = Gstops;
            el.addStop = GaddStop;
            el.getBBox = GgetBBox;
            el.setStops = GsetStops;
            if (x1 != null) $(el.node, {
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2
            });
            return el;
        }
        function gradientRadial(defs, cx, cy, r, fx, fy) {
            var el = Snap._.make("radialGradient", defs);
            el.stops = Gstops;
            el.addStop = GaddStop;
            el.getBBox = GgetBBox;
            if (cx != null) $(el.node, {
                cx: cx,
                cy: cy,
                r: r
            });
            if (fx != null && fy != null) $(el.node, {
                fx: fx,
                fy: fy
            });
            return el;
        }
        /*\
         * Paper.gradient
         [ method ]
         **
         * Creates a gradient element
         **
         - gradient (string) gradient descriptor
         > Gradient Descriptor
         * The gradient descriptor is an expression formatted as
         * follows: `<type>(<coords>)<colors>`.  The `<type>` can be
         * either linear or radial.  The uppercase `L` or `R` letters
         * indicate absolute coordinates offset from the SVG surface.
         * Lowercase `l` or `r` letters indicate coordinates
         * calculated relative to the element to which the gradient is
         * applied.  Coordinates specify a linear gradient vector as
         * `x1`, `y1`, `x2`, `y2`, or a radial gradient as `cx`, `cy`,
         * `r` and optional `fx`, `fy` specifying a focal point away
         * from the center of the circle. Specify `<colors>` as a list
         * of dash-separated CSS color values.  Each color may be
         * followed by a custom offset value, separated with a colon
         * character.
         > Examples
         * Linear gradient, relative from top-left corner to bottom-right
         * corner, from black through red to white:
         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
         * Linear gradient, absolute from (0, 0) to (100, 100), from black
         * through red at 25% to white:
         | var g = paper.gradient("L(0, 0, 100, 100)#000-#f00:25-#fff");
         * Radial gradient, relative from the center of the element with radius
         * half the width, from black to white:
         | var g = paper.gradient("r(0.5, 0.5, 0.5)#000-#fff");
         * To apply the gradient:
         | paper.circle(50, 50, 40).attr({
         |     fill: g
         | });
         = (object) the `gradient` element
        \*/ proto.gradient = function(str) {
            return gradient(this.defs, str);
        };
        proto.gradientLinear = function(x1, y1, x2, y2) {
            return gradientLinear(this.defs, x1, y1, x2, y2);
        };
        proto.gradientRadial = function(cx, cy, r, fx, fy) {
            return gradientRadial(this.defs, cx, cy, r, fx, fy);
        };
        /*\
         * Paper.toString
         [ method ]
         **
         * Returns SVG code for the @Paper
         = (string) SVG code for the @Paper
        \*/ proto.toString = function() {
            var doc = this.node.ownerDocument, f = doc.createDocumentFragment(), d = doc.createElement("div"), svg = this.node.cloneNode(true), res1;
            f.appendChild(d);
            d.appendChild(svg);
            Snap._.$(svg, {
                xmlns: "http://www.w3.org/2000/svg"
            });
            res1 = d.innerHTML;
            f.removeChild(f.firstChild);
            return res1;
        };
        /*\
         * Paper.toDataURL
         [ method ]
         **
         * Returns SVG code for the @Paper as Data URI string.
         = (string) Data URI string
        \*/ proto.toDataURL = function() {
            if (window && window.btoa) return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
        };
        /*\
         * Paper.clear
         [ method ]
         **
         * Removes all child nodes of the paper, except <defs>.
        \*/ proto.clear = function() {
            var node = this.node.firstChild, next;
            while(node){
                next = node.nextSibling;
                if (node.tagName != "defs") node.parentNode.removeChild(node);
                else proto.clear.call({
                    node: node
                });
                node = next;
            }
        };
    })();
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob) {
    var elproto = Element.prototype, is = Snap.is, clone = Snap._.clone, has = "hasOwnProperty", p2s = /,?([a-z]),?/gi, toFloat = parseFloat, math1 = Math, PI = math1.PI, mmin = math1.min, mmax = math1.max, pow = math1.pow, abs = math1.abs;
    function paths(ps) {
        var p = paths.ps = paths.ps || {};
        if (p[ps]) p[ps].sleep = 100;
        else p[ps] = {
            sleep: 100
        };
        setTimeout(function() {
            for(var key in p)if (p[has](key) && key != ps) {
                p[key].sleep--;
                !p[key].sleep && delete p[key];
            }
        });
        return p[ps];
    }
    function box(x, y, width, height) {
        if (x == null) x = y = width = height = 0;
        if (y == null) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        return {
            x: x,
            y: y,
            width: width,
            w: width,
            height: height,
            h: height,
            x2: x + width,
            y2: y + height,
            cx: x + width / 2,
            cy: y + height / 2,
            r1: math1.min(width, height) / 2,
            r2: math1.max(width, height) / 2,
            r0: math1.sqrt(width * width + height * height) / 2,
            path: rectPath(x, y, width, height),
            vb: [
                x,
                y,
                width,
                height
            ].join(" ")
        };
    }
    function toString() {
        return this.join(",").replace(p2s, "$1");
    }
    function pathClone(pathArray) {
        var res1 = clone(pathArray);
        res1.toString = toString;
        return res1;
    }
    function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
        if (length == null) return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
        else return findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
    }
    function getLengthFactory(istotal, subpath) {
        function O(val) {
            return +(+val).toFixed(3);
        }
        return Snap._.cacher(function(path, length, onlystart) {
            if (path instanceof Element) path = path.attr("d");
            path = path2curve(path);
            var x, y, p, l, sp = "", subpaths = {}, point, len = 0;
            for(var i = 0, ii = path.length; i < ii; i++){
                p = path[i];
                if (p[0] == "M") {
                    x = +p[1];
                    y = +p[2];
                } else {
                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                    if (len + l > length) {
                        if (subpath && !subpaths.start) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            sp += [
                                "C" + O(point.start.x),
                                O(point.start.y),
                                O(point.m.x),
                                O(point.m.y),
                                O(point.x),
                                O(point.y)
                            ];
                            if (onlystart) return sp;
                            subpaths.start = sp;
                            sp = [
                                "M" + O(point.x),
                                O(point.y) + "C" + O(point.n.x),
                                O(point.n.y),
                                O(point.end.x),
                                O(point.end.y),
                                O(p[5]),
                                O(p[6])
                            ].join();
                            len += l;
                            x = +p[5];
                            y = +p[6];
                            continue;
                        }
                        if (!istotal && !subpath) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            return point;
                        }
                    }
                    len += l;
                    x = +p[5];
                    y = +p[6];
                }
                sp += p.shift() + p;
            }
            subpaths.end = sp;
            point = istotal ? len : subpath ? subpaths : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
            return point;
        }, null, Snap._.clone);
    }
    var getTotalLength = getLengthFactory(1), getPointAtLength = getLengthFactory(), getSubpathsAtLength = getLengthFactory(0, 1);
    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t, t13 = pow(t1, 3), t12 = pow(t1, 2), t2 = t * t, t3 = t2 * t, x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x, y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y, mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x), my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y), nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x), ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y), ax = t1 * p1x + t * c1x, ay = t1 * p1y + t * c1y, cx = t1 * c2x + t * p2x, cy = t1 * c2y + t * p2y, alpha = 90 - math1.atan2(mx - nx, my - ny) * 180 / PI;
        // (mx > nx || my < ny) && (alpha += 180);
        return {
            x: x,
            y: y,
            m: {
                x: mx,
                y: my
            },
            n: {
                x: nx,
                y: ny
            },
            start: {
                x: ax,
                y: ay
            },
            end: {
                x: cx,
                y: cy
            },
            alpha: alpha
        };
    }
    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
        if (!Snap.is(p1x, "array")) p1x = [
            p1x,
            p1y,
            c1x,
            c1y,
            c2x,
            c2y,
            p2x,
            p2y
        ];
        var bbox = curveDim.apply(null, p1x);
        return box(bbox.min.x, bbox.min.y, bbox.max.x - bbox.min.x, bbox.max.y - bbox.min.y);
    }
    function isPointInsideBBox(bbox, x, y) {
        return x >= bbox.x && x <= bbox.x + bbox.width && y >= bbox.y && y <= bbox.y + bbox.height;
    }
    function isBBoxIntersect(bbox1, bbox2) {
        bbox1 = box(bbox1);
        bbox2 = box(bbox2);
        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y) || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y) || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2) || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2) || isPointInsideBBox(bbox1, bbox2.x, bbox2.y) || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y) || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2) || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2) || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x) && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
    }
    function base3(t, p1, p2, p3, p4) {
        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4, t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
        return t * t2 - 3 * p1 + 3 * p2;
    }
    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
        if (z == null) z = 1;
        z = z > 1 ? 1 : z < 0 ? 0 : z;
        var z2 = z / 2, n = 12, Tvalues = [
            -0.1252,
            .1252,
            -0.3678,
            .3678,
            -0.5873,
            .5873,
            -0.7699,
            .7699,
            -0.9041,
            .9041,
            -0.9816,
            .9816
        ], Cvalues = [
            0.2491,
            0.2491,
            0.2335,
            0.2335,
            0.2032,
            0.2032,
            0.1601,
            0.1601,
            0.1069,
            0.1069,
            0.0472,
            0.0472
        ], sum = 0;
        for(var i = 0; i < n; i++){
            var ct = z2 * Tvalues[i] + z2, xbase = base3(ct, x1, x2, x3, x4), ybase = base3(ct, y1, y2, y3, y4), comb = xbase * xbase + ybase * ybase;
            sum += Cvalues[i] * math1.sqrt(comb);
        }
        return z2 * sum;
    }
    function getTotLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) return;
        var t = 1, step = t / 2, t2 = t - step, l, e = .01;
        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        while(abs(l - ll) > e){
            step /= 2;
            t2 += (l < ll ? 1 : -1) * step;
            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        }
        return t2;
    }
    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
        if (mmax(x1, x2) < mmin(x3, x4) || mmin(x1, x2) > mmax(x3, x4) || mmax(y1, y2) < mmin(y3, y4) || mmin(y1, y2) > mmax(y3, y4)) return;
        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4), ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4), denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
        if (!denominator) return;
        var px = nx / denominator, py = ny / denominator, px2 = +px.toFixed(2), py2 = +py.toFixed(2);
        if (px2 < +mmin(x1, x2).toFixed(2) || px2 > +mmax(x1, x2).toFixed(2) || px2 < +mmin(x3, x4).toFixed(2) || px2 > +mmax(x3, x4).toFixed(2) || py2 < +mmin(y1, y2).toFixed(2) || py2 > +mmax(y1, y2).toFixed(2) || py2 < +mmin(y3, y4).toFixed(2) || py2 > +mmax(y3, y4).toFixed(2)) return;
        return {
            x: px,
            y: py
        };
    }
    function inter(bez1, bez2) {
        return interHelper(bez1, bez2);
    }
    function interCount(bez1, bez2) {
        return interHelper(bez1, bez2, 1);
    }
    function interHelper(bez1, bez2, justCount) {
        var bbox1 = bezierBBox(bez1), bbox2 = bezierBBox(bez2);
        if (!isBBoxIntersect(bbox1, bbox2)) return justCount ? 0 : [];
        var l1 = bezlen.apply(0, bez1), l2 = bezlen.apply(0, bez2), n1 = ~~(l1 / 8), n2 = ~~(l2 / 8), dots1 = [], dots2 = [], xy = {}, res1 = justCount ? 0 : [];
        for(var i = 0; i < n1 + 1; i++){
            var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
            dots1.push({
                x: p.x,
                y: p.y,
                t: i / n1
            });
        }
        for(i = 0; i < n2 + 1; i++){
            p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
            dots2.push({
                x: p.x,
                y: p.y,
                t: i / n2
            });
        }
        for(i = 0; i < n1; i++)for(var j = 0; j < n2; j++){
            var di = dots1[i], di1 = dots1[i + 1], dj = dots2[j], dj1 = dots2[j + 1], ci = abs(di1.x - di.x) < .001 ? "y" : "x", cj = abs(dj1.x - dj.x) < .001 ? "y" : "x", is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
            if (is) {
                if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) continue;
                xy[is.x.toFixed(4)] = is.y.toFixed(4);
                var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t), t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
                if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
                    if (justCount) res1++;
                    else res1.push({
                        x: is.x,
                        y: is.y,
                        t1: t1,
                        t2: t2
                    });
                }
            }
        }
        return res1;
    }
    function pathIntersection(path1, path2) {
        return interPathHelper(path1, path2);
    }
    function pathIntersectionNumber(path1, path2) {
        return interPathHelper(path1, path2, 1);
    }
    function interPathHelper(path1, path2, justCount) {
        path1 = path2curve(path1);
        path2 = path2curve(path2);
        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2, res1 = justCount ? 0 : [];
        for(var i = 0, ii = path1.length; i < ii; i++){
            var pi = path1[i];
            if (pi[0] == "M") {
                x1 = x1m = pi[1];
                y1 = y1m = pi[2];
            } else {
                if (pi[0] == "C") {
                    bez1 = [
                        x1,
                        y1
                    ].concat(pi.slice(1));
                    x1 = bez1[6];
                    y1 = bez1[7];
                } else {
                    bez1 = [
                        x1,
                        y1,
                        x1,
                        y1,
                        x1m,
                        y1m,
                        x1m,
                        y1m
                    ];
                    x1 = x1m;
                    y1 = y1m;
                }
                for(var j = 0, jj = path2.length; j < jj; j++){
                    var pj = path2[j];
                    if (pj[0] == "M") {
                        x2 = x2m = pj[1];
                        y2 = y2m = pj[2];
                    } else {
                        if (pj[0] == "C") {
                            bez2 = [
                                x2,
                                y2
                            ].concat(pj.slice(1));
                            x2 = bez2[6];
                            y2 = bez2[7];
                        } else {
                            bez2 = [
                                x2,
                                y2,
                                x2,
                                y2,
                                x2m,
                                y2m,
                                x2m,
                                y2m
                            ];
                            x2 = x2m;
                            y2 = y2m;
                        }
                        var intr = interHelper(bez1, bez2, justCount);
                        if (justCount) res1 += intr;
                        else {
                            for(var k = 0, kk = intr.length; k < kk; k++){
                                intr[k].segment1 = i;
                                intr[k].segment2 = j;
                                intr[k].bez1 = bez1;
                                intr[k].bez2 = bez2;
                            }
                            res1 = res1.concat(intr);
                        }
                    }
                }
            }
        }
        return res1;
    }
    function isPointInsidePath(path, x, y) {
        var bbox = pathBBox(path);
        return isPointInsideBBox(bbox, x, y) && interPathHelper(path, [
            [
                "M",
                x,
                y
            ],
            [
                "H",
                bbox.x2 + 10
            ]
        ], 1) % 2 == 1;
    }
    function pathBBox(path) {
        var pth = paths(path);
        if (pth.bbox) return clone(pth.bbox);
        if (!path) return box();
        path = path2curve(path);
        var x = 0, y = 0, X = [], Y = [], p;
        for(var i = 0, ii = path.length; i < ii; i++){
            p = path[i];
            if (p[0] == "M") {
                x = p[1];
                y = p[2];
                X.push(x);
                Y.push(y);
            } else {
                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                X = X.concat(dim.min.x, dim.max.x);
                Y = Y.concat(dim.min.y, dim.max.y);
                x = p[5];
                y = p[6];
            }
        }
        var xmin = mmin.apply(0, X), ymin = mmin.apply(0, Y), xmax = mmax.apply(0, X), ymax = mmax.apply(0, Y), bb = box(xmin, ymin, xmax - xmin, ymax - ymin);
        pth.bbox = clone(bb);
        return bb;
    }
    function rectPath(x, y, w, h, r) {
        if (r) return [
            [
                "M",
                +x + +r,
                y
            ],
            [
                "l",
                w - r * 2,
                0
            ],
            [
                "a",
                r,
                r,
                0,
                0,
                1,
                r,
                r
            ],
            [
                "l",
                0,
                h - r * 2
            ],
            [
                "a",
                r,
                r,
                0,
                0,
                1,
                -r,
                r
            ],
            [
                "l",
                r * 2 - w,
                0
            ],
            [
                "a",
                r,
                r,
                0,
                0,
                1,
                -r,
                -r
            ],
            [
                "l",
                0,
                r * 2 - h
            ],
            [
                "a",
                r,
                r,
                0,
                0,
                1,
                r,
                -r
            ],
            [
                "z"
            ]
        ];
        var res1 = [
            [
                "M",
                x,
                y
            ],
            [
                "l",
                w,
                0
            ],
            [
                "l",
                0,
                h
            ],
            [
                "l",
                -w,
                0
            ],
            [
                "z"
            ]
        ];
        res1.toString = toString;
        return res1;
    }
    function ellipsePath(x, y, rx, ry, a) {
        if (a == null && ry == null) ry = rx;
        x = +x;
        y = +y;
        rx = +rx;
        ry = +ry;
        if (a != null) var rad = Math.PI / 180, x1 = x + rx * Math.cos(-ry * rad), x2 = x + rx * Math.cos(-a * rad), y1 = y + rx * Math.sin(-ry * rad), y2 = y + rx * Math.sin(-a * rad), res1 = [
            [
                "M",
                x1,
                y1
            ],
            [
                "A",
                rx,
                rx,
                0,
                +(a - ry > 180),
                0,
                x2,
                y2
            ]
        ];
        else res1 = [
            [
                "M",
                x,
                y
            ],
            [
                "m",
                0,
                -ry
            ],
            [
                "a",
                rx,
                ry,
                0,
                1,
                1,
                0,
                2 * ry
            ],
            [
                "a",
                rx,
                ry,
                0,
                1,
                1,
                0,
                -2 * ry
            ],
            [
                "z"
            ]
        ];
        res1.toString = toString;
        return res1;
    }
    var unit2px = Snap._unit2px, getPath = {
        path: function(el) {
            return el.attr("path");
        },
        circle: function(el) {
            var attr = unit2px(el);
            return ellipsePath(attr.cx, attr.cy, attr.r);
        },
        ellipse: function(el) {
            var attr = unit2px(el);
            return ellipsePath(attr.cx || 0, attr.cy || 0, attr.rx, attr.ry);
        },
        rect: function(el) {
            var attr = unit2px(el);
            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height, attr.rx, attr.ry);
        },
        image: function(el) {
            var attr = unit2px(el);
            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height);
        },
        line: function(el) {
            return "M" + [
                el.attr("x1") || 0,
                el.attr("y1") || 0,
                el.attr("x2"),
                el.attr("y2")
            ];
        },
        polyline: function(el) {
            return "M" + el.attr("points");
        },
        polygon: function(el) {
            return "M" + el.attr("points") + "z";
        },
        deflt: function(el) {
            var bbox = el.node.getBBox();
            return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
        }
    };
    function pathToRelative(pathArray) {
        var pth = paths(pathArray), lowerCase = String.prototype.toLowerCase;
        if (pth.rel) return pathClone(pth.rel);
        if (!Snap.is(pathArray, "array") || !Snap.is(pathArray && pathArray[0], "array")) pathArray = Snap.parsePathString(pathArray);
        var res1 = [], x = 0, y = 0, mx = 0, my = 0, start = 0;
        if (pathArray[0][0] == "M") {
            x = pathArray[0][1];
            y = pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res1.push([
                "M",
                x,
                y
            ]);
        }
        for(var i = start, ii = pathArray.length; i < ii; i++){
            var r = res1[i] = [], pa = pathArray[i];
            if (pa[0] != lowerCase.call(pa[0])) {
                r[0] = lowerCase.call(pa[0]);
                switch(r[0]){
                    case "a":
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +(pa[6] - x).toFixed(3);
                        r[7] = +(pa[7] - y).toFixed(3);
                        break;
                    case "v":
                        r[1] = +(pa[1] - y).toFixed(3);
                        break;
                    case "m":
                        mx = pa[1];
                        my = pa[2];
                    default:
                        for(var j = 1, jj = pa.length; j < jj; j++)r[j] = +(pa[j] - (j % 2 ? x : y)).toFixed(3);
                }
            } else {
                r = res1[i] = [];
                if (pa[0] == "m") {
                    mx = pa[1] + x;
                    my = pa[2] + y;
                }
                for(var k = 0, kk = pa.length; k < kk; k++)res1[i][k] = pa[k];
            }
            var len = res1[i].length;
            switch(res1[i][0]){
                case "z":
                    x = mx;
                    y = my;
                    break;
                case "h":
                    x += +res1[i][len - 1];
                    break;
                case "v":
                    y += +res1[i][len - 1];
                    break;
                default:
                    x += +res1[i][len - 2];
                    y += +res1[i][len - 1];
            }
        }
        res1.toString = toString;
        pth.rel = pathClone(res1);
        return res1;
    }
    function pathToAbsolute(pathArray) {
        var pth = paths(pathArray);
        if (pth.abs) return pathClone(pth.abs);
        if (!is(pathArray, "array") || !is(pathArray && pathArray[0], "array")) pathArray = Snap.parsePathString(pathArray);
        if (!pathArray || !pathArray.length) return [
            [
                "M",
                0,
                0
            ]
        ];
        var res1 = [], x = 0, y = 0, mx = 0, my = 0, start = 0, pa0;
        if (pathArray[0][0] == "M") {
            x = +pathArray[0][1];
            y = +pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res1[0] = [
                "M",
                x,
                y
            ];
        }
        var crz = pathArray.length == 3 && pathArray[0][0] == "M" && pathArray[1][0].toUpperCase() == "R" && pathArray[2][0].toUpperCase() == "Z";
        for(var r, pa, i = start, ii = pathArray.length; i < ii; i++){
            res1.push(r = []);
            pa = pathArray[i];
            pa0 = pa[0];
            if (pa0 != pa0.toUpperCase()) {
                r[0] = pa0.toUpperCase();
                switch(r[0]){
                    case "A":
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +pa[6] + x;
                        r[7] = +pa[7] + y;
                        break;
                    case "V":
                        r[1] = +pa[1] + y;
                        break;
                    case "H":
                        r[1] = +pa[1] + x;
                        break;
                    case "R":
                        var dots = [
                            x,
                            y
                        ].concat(pa.slice(1));
                        for(var j = 2, jj = dots.length; j < jj; j++){
                            dots[j] = +dots[j] + x;
                            dots[++j] = +dots[j] + y;
                        }
                        res1.pop();
                        res1 = res1.concat(catmullRom2bezier(dots, crz));
                        break;
                    case "O":
                        res1.pop();
                        dots = ellipsePath(x, y, pa[1], pa[2]);
                        dots.push(dots[0]);
                        res1 = res1.concat(dots);
                        break;
                    case "U":
                        res1.pop();
                        res1 = res1.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                        r = [
                            "U"
                        ].concat(res1[res1.length - 1].slice(-2));
                        break;
                    case "M":
                        mx = +pa[1] + x;
                        my = +pa[2] + y;
                    default:
                        for(j = 1, jj = pa.length; j < jj; j++)r[j] = +pa[j] + (j % 2 ? x : y);
                }
            } else if (pa0 == "R") {
                dots = [
                    x,
                    y
                ].concat(pa.slice(1));
                res1.pop();
                res1 = res1.concat(catmullRom2bezier(dots, crz));
                r = [
                    "R"
                ].concat(pa.slice(-2));
            } else if (pa0 == "O") {
                res1.pop();
                dots = ellipsePath(x, y, pa[1], pa[2]);
                dots.push(dots[0]);
                res1 = res1.concat(dots);
            } else if (pa0 == "U") {
                res1.pop();
                res1 = res1.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                r = [
                    "U"
                ].concat(res1[res1.length - 1].slice(-2));
            } else for(var k = 0, kk = pa.length; k < kk; k++)r[k] = pa[k];
            pa0 = pa0.toUpperCase();
            if (pa0 != "O") switch(r[0]){
                case "Z":
                    x = +mx;
                    y = +my;
                    break;
                case "H":
                    x = r[1];
                    break;
                case "V":
                    y = r[1];
                    break;
                case "M":
                    mx = r[r.length - 2];
                    my = r[r.length - 1];
                default:
                    x = r[r.length - 2];
                    y = r[r.length - 1];
            }
        }
        res1.toString = toString;
        pth.abs = pathClone(res1);
        return res1;
    }
    function l2c(x1, y1, x2, y2) {
        return [
            x1,
            y1,
            x2,
            y2,
            x2,
            y2
        ];
    }
    function q2c(x1, y1, ax, ay, x2, y2) {
        var _13 = 1 / 3, _23 = 2 / 3;
        return [
            _13 * x1 + _23 * ax,
            _13 * y1 + _23 * ay,
            _13 * x2 + _23 * ax,
            _13 * y2 + _23 * ay,
            x2,
            y2
        ];
    }
    function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
        // for more information of where this math came from visit:
        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
        var _120 = PI * 120 / 180, rad = PI / 180 * (+angle || 0), res1 = [], xy, rotate = Snap._.cacher(function(x, y, rad) {
            var X = x * math1.cos(rad) - y * math1.sin(rad), Y = x * math1.sin(rad) + y * math1.cos(rad);
            return {
                x: X,
                y: Y
            };
        });
        if (!rx || !ry) return [
            x1,
            y1,
            x2,
            y2,
            x2,
            y2
        ];
        if (!recursive) {
            xy = rotate(x1, y1, -rad);
            x1 = xy.x;
            y1 = xy.y;
            xy = rotate(x2, y2, -rad);
            x2 = xy.x;
            y2 = xy.y;
            var cos = math1.cos(PI / 180 * angle), sin = math1.sin(PI / 180 * angle), x = (x1 - x2) / 2, y = (y1 - y2) / 2;
            var h = x * x / (rx * rx) + y * y / (ry * ry);
            if (h > 1) {
                h = math1.sqrt(h);
                rx = h * rx;
                ry = h * ry;
            }
            var rx2 = rx * rx, ry2 = ry * ry, k = (large_arc_flag == sweep_flag ? -1 : 1) * math1.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))), cx = k * rx * y / ry + (x1 + x2) / 2, cy = k * -ry * x / rx + (y1 + y2) / 2, f1 = math1.asin(((y1 - cy) / ry).toFixed(9)), f2 = math1.asin(((y2 - cy) / ry).toFixed(9));
            f1 = x1 < cx ? PI - f1 : f1;
            f2 = x2 < cx ? PI - f2 : f2;
            f1 < 0 && (f1 = PI * 2 + f1);
            f2 < 0 && (f2 = PI * 2 + f2);
            if (sweep_flag && f1 > f2) f1 = f1 - PI * 2;
            if (!sweep_flag && f2 > f1) f2 = f2 - PI * 2;
        } else {
            f1 = recursive[0];
            f2 = recursive[1];
            cx = recursive[2];
            cy = recursive[3];
        }
        var df = f2 - f1;
        if (abs(df) > _120) {
            var f2old = f2, x2old = x2, y2old = y2;
            f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
            x2 = cx + rx * math1.cos(f2);
            y2 = cy + ry * math1.sin(f2);
            res1 = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [
                f2,
                f2old,
                cx,
                cy
            ]);
        }
        df = f2 - f1;
        var c1 = math1.cos(f1), s1 = math1.sin(f1), c2 = math1.cos(f2), s2 = math1.sin(f2), t = math1.tan(df / 4), hx = 4 / 3 * rx * t, hy = 4 / 3 * ry * t, m1 = [
            x1,
            y1
        ], m2 = [
            x1 + hx * s1,
            y1 - hy * c1
        ], m3 = [
            x2 + hx * s2,
            y2 - hy * c2
        ], m4 = [
            x2,
            y2
        ];
        m2[0] = 2 * m1[0] - m2[0];
        m2[1] = 2 * m1[1] - m2[1];
        if (recursive) return [
            m2,
            m3,
            m4
        ].concat(res1);
        else {
            res1 = [
                m2,
                m3,
                m4
            ].concat(res1).join().split(",");
            var newres = [];
            for(var i = 0, ii = res1.length; i < ii; i++)newres[i] = i % 2 ? rotate(res1[i - 1], res1[i], rad).y : rotate(res1[i], res1[i + 1], rad).x;
            return newres;
        }
    }
    function findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t;
        return {
            x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
            y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
        };
    }
    // Returns bounding box of cubic bezier curve.
    // Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
    // Original version: NISHIO Hirokazu
    // Modifications: https://github.com/timo22345
    function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
        var tvalues = [], bounds = [
            [],
            []
        ], a, b, c, t, t1, t2, b2ac, sqrtb2ac;
        for(var i = 0; i < 2; ++i){
            if (i == 0) {
                b = 6 * x0 - 12 * x1 + 6 * x2;
                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                c = 3 * x1 - 3 * x0;
            } else {
                b = 6 * y0 - 12 * y1 + 6 * y2;
                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                c = 3 * y1 - 3 * y0;
            }
            if (abs(a) < 1e-12) {
                if (abs(b) < 1e-12) continue;
                t = -c / b;
                if (0 < t && t < 1) tvalues.push(t);
                continue;
            }
            b2ac = b * b - 4 * c * a;
            sqrtb2ac = math1.sqrt(b2ac);
            if (b2ac < 0) continue;
            t1 = (-b + sqrtb2ac) / (2 * a);
            if (0 < t1 && t1 < 1) tvalues.push(t1);
            t2 = (-b - sqrtb2ac) / (2 * a);
            if (0 < t2 && t2 < 1) tvalues.push(t2);
        }
        var x, y, j = tvalues.length, jlen = j, mt;
        while(j--){
            t = tvalues[j];
            mt = 1 - t;
            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
        }
        bounds[0][jlen] = x0;
        bounds[1][jlen] = y0;
        bounds[0][jlen + 1] = x3;
        bounds[1][jlen + 1] = y3;
        bounds[0].length = bounds[1].length = jlen + 2;
        return {
            min: {
                x: mmin.apply(0, bounds[0]),
                y: mmin.apply(0, bounds[1])
            },
            max: {
                x: mmax.apply(0, bounds[0]),
                y: mmax.apply(0, bounds[1])
            }
        };
    }
    function path2curve(path, path2) {
        var pth = !path2 && paths(path);
        if (!path2 && pth.curve) return pathClone(pth.curve);
        var p = pathToAbsolute(path), p2 = path2 && pathToAbsolute(path2), attrs = {
            x: 0,
            y: 0,
            bx: 0,
            by: 0,
            X: 0,
            Y: 0,
            qx: null,
            qy: null
        }, attrs2 = {
            x: 0,
            y: 0,
            bx: 0,
            by: 0,
            X: 0,
            Y: 0,
            qx: null,
            qy: null
        }, processPath = function(path, d, pcom) {
            var nx, ny;
            if (!path) return [
                "C",
                d.x,
                d.y,
                d.x,
                d.y,
                d.x,
                d.y
            ];
            !(path[0] in {
                T: 1,
                Q: 1
            }) && (d.qx = d.qy = null);
            switch(path[0]){
                case "M":
                    d.X = path[1];
                    d.Y = path[2];
                    break;
                case "A":
                    path = [
                        "C"
                    ].concat(a2c.apply(0, [
                        d.x,
                        d.y
                    ].concat(path.slice(1))));
                    break;
                case "S":
                    if (pcom == "C" || pcom == "S") {
                        nx = d.x * 2 - d.bx; // And reflect the previous
                        ny = d.y * 2 - d.by; // command's control point relative to the current point.
                    } else {
                        nx = d.x;
                        ny = d.y;
                    }
                    path = [
                        "C",
                        nx,
                        ny
                    ].concat(path.slice(1));
                    break;
                case "T":
                    if (pcom == "Q" || pcom == "T") {
                        d.qx = d.x * 2 - d.qx; // And make a reflection similar
                        d.qy = d.y * 2 - d.qy; // to case "S".
                    } else {
                        d.qx = d.x;
                        d.qy = d.y;
                    }
                    path = [
                        "C"
                    ].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
                    break;
                case "Q":
                    d.qx = path[1];
                    d.qy = path[2];
                    path = [
                        "C"
                    ].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
                    break;
                case "L":
                    path = [
                        "C"
                    ].concat(l2c(d.x, d.y, path[1], path[2]));
                    break;
                case "H":
                    path = [
                        "C"
                    ].concat(l2c(d.x, d.y, path[1], d.y));
                    break;
                case "V":
                    path = [
                        "C"
                    ].concat(l2c(d.x, d.y, d.x, path[1]));
                    break;
                case "Z":
                    path = [
                        "C"
                    ].concat(l2c(d.x, d.y, d.X, d.Y));
                    break;
            }
            return path;
        }, fixArc = function(pp, i) {
            if (pp[i].length > 7) {
                pp[i].shift();
                var pi = pp[i];
                while(pi.length){
                    pcoms1[i] = "A"; // if created multiple C:s, their original seg is saved
                    p2 && (pcoms2[i] = "A"); // the same as above
                    pp.splice(i++, 0, [
                        "C"
                    ].concat(pi.splice(0, 6)));
                }
                pp.splice(i, 1);
                ii = mmax(p.length, p2 && p2.length || 0);
            }
        }, fixM = function(path1, path2, a1, a2, i) {
            if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
                path2.splice(i, 0, [
                    "M",
                    a2.x,
                    a2.y
                ]);
                a1.bx = 0;
                a1.by = 0;
                a1.x = path1[i][1];
                a1.y = path1[i][2];
                ii = mmax(p.length, p2 && p2.length || 0);
            }
        }, pcoms1 = [], pcoms2 = [], pfirst = "", pcom = ""; // holder for previous path command of original path
        for(var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++){
            p[i] && (pfirst = p[i][0]); // save current path command
            if (pfirst != "C") {
                pcoms1[i] = pfirst; // Save current path command
                i && (pcom = pcoms1[i - 1]); // Get previous path command pcom
            }
            p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath
            if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
            // which may produce multiple C:s
            // so we have to make sure that C is also C in original path
            fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1
            if (p2) {
                p2[i] && (pfirst = p2[i][0]);
                if (pfirst != "C") {
                    pcoms2[i] = pfirst;
                    i && (pcom = pcoms2[i - 1]);
                }
                p2[i] = processPath(p2[i], attrs2, pcom);
                if (pcoms2[i] != "A" && pfirst == "C") pcoms2[i] = "C";
                fixArc(p2, i);
            }
            fixM(p, p2, attrs, attrs2, i);
            fixM(p2, p, attrs2, attrs, i);
            var seg = p[i], seg2 = p2 && p2[i], seglen = seg.length, seg2len = p2 && seg2.length;
            attrs.x = seg[seglen - 2];
            attrs.y = seg[seglen - 1];
            attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
            attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
            attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
            attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
            attrs2.x = p2 && seg2[seg2len - 2];
            attrs2.y = p2 && seg2[seg2len - 1];
        }
        if (!p2) pth.curve = pathClone(p);
        return p2 ? [
            p,
            p2
        ] : p;
    }
    function mapPath(path, matrix) {
        if (!matrix) return path;
        var x, y, i, j, ii, jj, pathi;
        path = path2curve(path);
        for(i = 0, ii = path.length; i < ii; i++){
            pathi = path[i];
            for(j = 1, jj = pathi.length; j < jj; j += 2){
                x = matrix.x(pathi[j], pathi[j + 1]);
                y = matrix.y(pathi[j], pathi[j + 1]);
                pathi[j] = x;
                pathi[j + 1] = y;
            }
        }
        return path;
    }
    // http://schepers.cc/getting-to-the-point
    function catmullRom2bezier(crp, z) {
        var d = [];
        for(var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2){
            var p = [
                {
                    x: +crp[i - 2],
                    y: +crp[i - 1]
                },
                {
                    x: +crp[i],
                    y: +crp[i + 1]
                },
                {
                    x: +crp[i + 2],
                    y: +crp[i + 3]
                },
                {
                    x: +crp[i + 4],
                    y: +crp[i + 5]
                }
            ];
            if (z) {
                if (!i) p[0] = {
                    x: +crp[iLen - 2],
                    y: +crp[iLen - 1]
                };
                else if (iLen - 4 == i) p[3] = {
                    x: +crp[0],
                    y: +crp[1]
                };
                else if (iLen - 2 == i) {
                    p[2] = {
                        x: +crp[0],
                        y: +crp[1]
                    };
                    p[3] = {
                        x: +crp[2],
                        y: +crp[3]
                    };
                }
            } else {
                if (iLen - 4 == i) p[3] = p[2];
                else if (!i) p[0] = {
                    x: +crp[i],
                    y: +crp[i + 1]
                };
            }
            d.push([
                "C",
                (-p[0].x + 6 * p[1].x + p[2].x) / 6,
                (-p[0].y + 6 * p[1].y + p[2].y) / 6,
                (p[1].x + 6 * p[2].x - p[3].x) / 6,
                (p[1].y + 6 * p[2].y - p[3].y) / 6,
                p[2].x,
                p[2].y
            ]);
        }
        return d;
    }
    // export
    Snap.path = paths;
    /*\
     * Snap.path.getTotalLength
     [ method ]
     **
     * Returns the length of the given path in pixels
     **
     - path (string) SVG path string
     **
     = (number) length
    \*/ Snap.path.getTotalLength = getTotalLength;
    /*\
     * Snap.path.getPointAtLength
     [ method ]
     **
     * Returns the coordinates of the point located at the given length along the given path
     **
     - path (string) SVG path string
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/ Snap.path.getPointAtLength = getPointAtLength;
    /*\
     * Snap.path.getSubpath
     [ method ]
     **
     * Returns the subpath of a given path between given start and end lengths
     **
     - path (string) SVG path string
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/ Snap.path.getSubpath = function(path, from, to) {
        if (this.getTotalLength(path) - to < 1e-6) return getSubpathsAtLength(path, from).end;
        var a = getSubpathsAtLength(path, to, 1);
        return from ? getSubpathsAtLength(a, from).end : a;
    };
    /*\
     * Element.getTotalLength
     [ method ]
     **
     * Returns the length of the path in pixels (only works for `path` elements)
     = (number) length
    \*/ elproto.getTotalLength = function() {
        if (this.node.getTotalLength) return this.node.getTotalLength();
    };
    // SIERRA Element.getPointAtLength()/Element.getTotalLength(): If a <path> is broken into different segments, is the jump distance to the new coordinates set by the _M_ or _m_ commands calculated as part of the path's total length?
    /*\
     * Element.getPointAtLength
     [ method ]
     **
     * Returns coordinates of the point located at the given length on the given path (only works for `path` elements)
     **
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/ elproto.getPointAtLength = function(length) {
        return getPointAtLength(this.attr("d"), length);
    };
    // SIERRA Element.getSubpath(): Similar to the problem for Element.getPointAtLength(). Unclear how this would work for a segmented path. Overall, the concept of _subpath_ and what I'm calling a _segment_ (series of non-_M_ or _Z_ commands) is unclear.
    /*\
     * Element.getSubpath
     [ method ]
     **
     * Returns subpath of a given element from given start and end lengths (only works for `path` elements)
     **
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/ elproto.getSubpath = function(from, to) {
        return Snap.path.getSubpath(this.attr("d"), from, to);
    };
    Snap._.box = box;
    /*\
     * Snap.path.findDotsAtSegment
     [ method ]
     **
     * Utility method
     **
     * Finds dot coordinates on the given cubic beziér curve at the given t
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     - t (number) position on the curve (0..1)
     = (object) point information in format:
     o {
     o     x: (number) x coordinate of the point,
     o     y: (number) y coordinate of the point,
     o     m: {
     o         x: (number) x coordinate of the left anchor,
     o         y: (number) y coordinate of the left anchor
     o     },
     o     n: {
     o         x: (number) x coordinate of the right anchor,
     o         y: (number) y coordinate of the right anchor
     o     },
     o     start: {
     o         x: (number) x coordinate of the start of the curve,
     o         y: (number) y coordinate of the start of the curve
     o     },
     o     end: {
     o         x: (number) x coordinate of the end of the curve,
     o         y: (number) y coordinate of the end of the curve
     o     },
     o     alpha: (number) angle of the curve derivative at the point
     o }
    \*/ Snap.path.findDotsAtSegment = findDotsAtSegment;
    /*\
     * Snap.path.bezierBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given cubic beziér curve
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     * or
     - bez (array) array of six points for beziér curve
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/ Snap.path.bezierBBox = bezierBBox;
    /*\
     * Snap.path.isPointInsideBBox
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside bounding box
     - bbox (string) bounding box
     - x (string) x coordinate of the point
     - y (string) y coordinate of the point
     = (boolean) `true` if point is inside
    \*/ Snap.path.isPointInsideBBox = isPointInsideBBox;
    Snap.closest = function(x, y, X, Y) {
        var r = 100, b = box(x - r / 2, y - r / 2, r, r), inside = [], getter = X[0].hasOwnProperty("x") ? function(i) {
            return {
                x: X[i].x,
                y: X[i].y
            };
        } : function(i) {
            return {
                x: X[i],
                y: Y[i]
            };
        }, found = 0;
        while(r <= 1e6 && !found){
            for(var i = 0, ii = X.length; i < ii; i++){
                var xy = getter(i);
                if (isPointInsideBBox(b, xy.x, xy.y)) {
                    found++;
                    inside.push(xy);
                    break;
                }
            }
            if (!found) {
                r *= 2;
                b = box(x - r / 2, y - r / 2, r, r);
            }
        }
        if (r == 1e6) return;
        var len = Infinity, res1;
        for(i = 0, ii = inside.length; i < ii; i++){
            var l = Snap.len(x, y, inside[i].x, inside[i].y);
            if (len > l) {
                len = l;
                inside[i].len = l;
                res1 = inside[i];
            }
        }
        return res1;
    };
    /*\
     * Snap.path.isBBoxIntersect
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if two bounding boxes intersect
     - bbox1 (string) first bounding box
     - bbox2 (string) second bounding box
     = (boolean) `true` if bounding boxes intersect
    \*/ Snap.path.isBBoxIntersect = isBBoxIntersect;
    /*\
     * Snap.path.intersection
     [ method ]
     **
     * Utility method
     **
     * Finds intersections of two paths
     - path1 (string) path string
     - path2 (string) path string
     = (array) dots of intersection
     o [
     o     {
     o         x: (number) x coordinate of the point,
     o         y: (number) y coordinate of the point,
     o         t1: (number) t value for segment of path1,
     o         t2: (number) t value for segment of path2,
     o         segment1: (number) order number for segment of path1,
     o         segment2: (number) order number for segment of path2,
     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1,
     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
     o     }
     o ]
    \*/ Snap.path.intersection = pathIntersection;
    Snap.path.intersectionNumber = pathIntersectionNumber;
    /*\
     * Snap.path.isPointInside
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside a given closed path.
     *
     * Note: fill mode doesn’t affect the result of this method.
     - path (string) path string
     - x (number) x of the point
     - y (number) y of the point
     = (boolean) `true` if point is inside the path
    \*/ Snap.path.isPointInside = isPointInsidePath;
    /*\
     * Snap.path.getBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given path
     - path (string) path string
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/ Snap.path.getBBox = pathBBox;
    Snap.path.get = getPath;
    /*\
     * Snap.path.toRelative
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into relative values
     - path (string) path string
     = (array) path string
    \*/ Snap.path.toRelative = pathToRelative;
    /*\
     * Snap.path.toAbsolute
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into absolute values
     - path (string) path string
     = (array) path string
    \*/ Snap.path.toAbsolute = pathToAbsolute;
    /*\
     * Snap.path.toCubic
     [ method ]
     **
     * Utility method
     **
     * Converts path to a new path where all segments are cubic beziér curves
     - pathString (string|array) path string or array of segments
     = (array) array of segments
    \*/ Snap.path.toCubic = path2curve;
    /*\
     * Snap.path.map
     [ method ]
     **
     * Transform the path string with the given matrix
     - path (string) path string
     - matrix (object) see @Matrix
     = (string) transformed path string
    \*/ Snap.path.map = mapPath;
    Snap.path.toString = toString;
    Snap.path.clone = pathClone;
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob) {
    var mmax = Math.max, mmin = Math.min;
    // Set
    var Set = function(items) {
        this.items = [];
        this.bindings = {};
        this.length = 0;
        this.type = "set";
        if (items) {
            for(var i = 0, ii = items.length; i < ii; i++)if (items[i]) {
                this[this.items.length] = this.items[this.items.length] = items[i];
                this.length++;
            }
        }
    }, setproto = Set.prototype;
    /*\
     * Set.push
     [ method ]
     **
     * Adds each argument to the current set
     = (object) original element
    \*/ setproto.push = function() {
        var item, len;
        for(var i = 0, ii = arguments.length; i < ii; i++){
            item = arguments[i];
            if (item) {
                len = this.items.length;
                this[len] = this.items[len] = item;
                this.length++;
            }
        }
        return this;
    };
    /*\
     * Set.pop
     [ method ]
     **
     * Removes last element and returns it
     = (object) element
    \*/ setproto.pop = function() {
        this.length && delete this[this.length--];
        return this.items.pop();
    };
    /*\
     * Set.forEach
     [ method ]
     **
     * Executes given function for each element in the set
     *
     * If the function returns `false`, the loop stops running.
     **
     - callback (function) function to run
     - thisArg (object) context object for the callback
     = (object) Set object
    \*/ setproto.forEach = function(callback, thisArg) {
        for(var i = 0, ii = this.items.length; i < ii; i++){
            if (callback.call(thisArg, this.items[i], i) === false) return this;
        }
        return this;
    };
    /*\
     * Set.animate
     [ method ]
     **
     * Animates each element in set in sync.
     *
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     * or
     - animation (array) array of animation parameter for each element in set in format `[attrs, duration, easing, callback]`
     > Usage
     | // animate all elements in set to radius 10
     | set.animate({r: 10}, 500, mina.easein);
     | // or
     | // animate first element to radius 10, but second to radius 20 and in different time
     | set.animate([{r: 10}, 500, mina.easein], [{r: 20}, 1500, mina.easein]);
     = (Element) the current element
    \*/ setproto.animate = function(attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = $f098236b7e761f68$var$mina.linear;
        }
        if (attrs instanceof Snap._.Animation) {
            callback = attrs.callback;
            easing = attrs.easing;
            ms = easing.dur;
            attrs = attrs.attr;
        }
        var args = arguments;
        if (Snap.is(attrs, "array") && Snap.is(args[args.length - 1], "array")) var each = true;
        var begin, handler = function() {
            if (begin) this.b = begin;
            else begin = this.b;
        }, cb = 0, set = this, callbacker = callback && function() {
            if (++cb == set.length) callback.call(this);
        };
        return this.forEach(function(el, i) {
            eve.once("snap.animcreated." + el.id, handler);
            if (each) args[i] && el.animate.apply(el, args[i]);
            else el.animate(attrs, ms, easing, callbacker);
        });
    };
    /*\
     * Set.remove
     [ method ]
     **
     * Removes all children of the set.
     *
     = (object) Set object
    \*/ setproto.remove = function() {
        while(this.length)this.pop().remove();
        return this;
    };
    /*\
     * Set.bind
     [ method ]
     **
     * Specifies how to handle a specific attribute when applied
     * to a set.
     *
     **
     - attr (string) attribute name
     - callback (function) function to run
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     - eattr (string) attribute on the element to bind the attribute to
     = (object) Set object
    \*/ setproto.bind = function(attr, a, b) {
        var data = {};
        if (typeof a == "function") this.bindings[attr] = a;
        else {
            var aname = b || attr;
            this.bindings[attr] = function(v) {
                data[aname] = v;
                a.attr(data);
            };
        }
        return this;
    };
    /*\
     * Set.attr
     [ method ]
     **
     * Equivalent of @Element.attr.
     = (object) Set object
    \*/ setproto.attr = function(value) {
        var unbound = {};
        for(var k in value)if (this.bindings[k]) this.bindings[k](value[k]);
        else unbound[k] = value[k];
        for(var i = 0, ii = this.items.length; i < ii; i++)this.items[i].attr(unbound);
        return this;
    };
    /*\
     * Set.clear
     [ method ]
     **
     * Removes all elements from the set
    \*/ setproto.clear = function() {
        while(this.length)this.pop();
    };
    /*\
     * Set.splice
     [ method ]
     **
     * Removes range of elements from the set
     **
     - index (number) position of the deletion
     - count (number) number of element to remove
     - insertion… (object) #optional elements to insert
     = (object) set elements that were deleted
    \*/ setproto.splice = function(index, count, insertion) {
        index = index < 0 ? mmax(this.length + index, 0) : index;
        count = mmax(0, mmin(this.length - index, count));
        var tail = [], todel = [], args = [], i;
        for(i = 2; i < arguments.length; i++)args.push(arguments[i]);
        for(i = 0; i < count; i++)todel.push(this[index + i]);
        for(; i < this.length - index; i++)tail.push(this[index + i]);
        var arglen = args.length;
        for(i = 0; i < arglen + tail.length; i++)this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
        i = this.items.length = this.length -= count - arglen;
        while(this[i])delete this[i++];
        return new Set(todel);
    };
    /*\
     * Set.exclude
     [ method ]
     **
     * Removes given element from the set
     **
     - element (object) element to remove
     = (boolean) `true` if object was found and removed from the set
    \*/ setproto.exclude = function(el) {
        for(var i = 0, ii = this.length; i < ii; i++)if (this[i] == el) {
            this.splice(i, 1);
            return true;
        }
        return false;
    };
    /*\
     * Set.insertAfter
     [ method ]
     **
     * Inserts set elements after given element.
     **
     - element (object) set will be inserted after this element
     = (object) Set object
    \*/ setproto.insertAfter = function(el) {
        var i = this.items.length;
        while(i--)this.items[i].insertAfter(el);
        return this;
    };
    /*\
     * Set.getBBox
     [ method ]
     **
     * Union of all bboxes of the set. See @Element.getBBox.
     = (object) bounding box descriptor. See @Element.getBBox.
    \*/ setproto.getBBox = function() {
        var x = [], y = [], x2 = [], y2 = [];
        for(var i = this.items.length; i--;)if (!this.items[i].removed) {
            var box = this.items[i].getBBox();
            x.push(box.x);
            y.push(box.y);
            x2.push(box.x + box.width);
            y2.push(box.y + box.height);
        }
        x = mmin.apply(0, x);
        y = mmin.apply(0, y);
        x2 = mmax.apply(0, x2);
        y2 = mmax.apply(0, y2);
        return {
            x: x,
            y: y,
            x2: x2,
            y2: y2,
            width: x2 - x,
            height: y2 - y,
            cx: x + (x2 - x) / 2,
            cy: y + (y2 - y) / 2
        };
    };
    /*\
     * Set.insertAfter
     [ method ]
     **
     * Creates a clone of the set.
     **
     = (object) New Set object
    \*/ setproto.clone = function(s) {
        s = new Set;
        for(var i = 0, ii = this.items.length; i < ii; i++)s.push(this.items[i].clone());
        return s;
    };
    setproto.toString = function() {
        return "Snap\u2018s set";
    };
    setproto.type = "set";
    // export
    /*\
     * Snap.Set
     [ property ]
     **
     * Set constructor.
    \*/ Snap.Set = Set;
    /*\
     * Snap.set
     [ method ]
     **
     * Creates a set and fills it with list of arguments.
     **
     = (object) New Set object
     | var r = paper.rect(0, 0, 10, 10),
     |     s1 = Snap.set(), // empty set
     |     s2 = Snap.set(r, paper.circle(100, 100, 20)); // prefilled set
    \*/ Snap.set = function() {
        var set = new Set;
        if (arguments.length) set.push.apply(set, Array.prototype.slice.call(arguments, 0));
        return set;
    };
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob) {
    var names = {}, reUnit = /[%a-z]+$/i, Str = String;
    names.stroke = names.fill = "colour";
    function getEmpty(item) {
        var l = item[0];
        switch(l.toLowerCase()){
            case "t":
                return [
                    l,
                    0,
                    0
                ];
            case "m":
                return [
                    l,
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
            case "r":
                if (item.length == 4) return [
                    l,
                    0,
                    item[2],
                    item[3]
                ];
                else return [
                    l,
                    0
                ];
            case "s":
                if (item.length == 5) return [
                    l,
                    1,
                    1,
                    item[3],
                    item[4]
                ];
                else if (item.length == 3) return [
                    l,
                    1,
                    1
                ];
                else return [
                    l,
                    1
                ];
        }
    }
    function equaliseTransform(t1, t2, getBBox) {
        t1 = t1 || new Snap.Matrix;
        t2 = t2 || new Snap.Matrix;
        t1 = Snap.parseTransformString(t1.toTransformString()) || [];
        t2 = Snap.parseTransformString(t2.toTransformString()) || [];
        var maxlength = Math.max(t1.length, t2.length), from = [], to = [], i = 0, j, jj, tt1, tt2;
        for(; i < maxlength; i++){
            tt1 = t1[i] || getEmpty(t2[i]);
            tt2 = t2[i] || getEmpty(tt1);
            if (tt1[0] != tt2[0] || tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3]) || tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4])) {
                t1 = Snap._.transform2matrix(t1, getBBox());
                t2 = Snap._.transform2matrix(t2, getBBox());
                from = [
                    [
                        "m",
                        t1.a,
                        t1.b,
                        t1.c,
                        t1.d,
                        t1.e,
                        t1.f
                    ]
                ];
                to = [
                    [
                        "m",
                        t2.a,
                        t2.b,
                        t2.c,
                        t2.d,
                        t2.e,
                        t2.f
                    ]
                ];
                break;
            }
            from[i] = [];
            to[i] = [];
            for(j = 0, jj = Math.max(tt1.length, tt2.length); j < jj; j++){
                j in tt1 && (from[i][j] = tt1[j]);
                j in tt2 && (to[i][j] = tt2[j]);
            }
        }
        return {
            from: path2array(from),
            to: path2array(to),
            f: getPath(from)
        };
    }
    function getNumber(val) {
        return val;
    }
    function getUnit(unit) {
        return function(val) {
            return +val.toFixed(3) + unit;
        };
    }
    function getViewBox(val) {
        return val.join(" ");
    }
    function getColour(clr) {
        return Snap.rgb(clr[0], clr[1], clr[2], clr[3]);
    }
    function getPath(path) {
        var k = 0, i, ii, j, jj, out, a, b = [];
        for(i = 0, ii = path.length; i < ii; i++){
            out = "[";
            a = [
                '"' + path[i][0] + '"'
            ];
            for(j = 1, jj = path[i].length; j < jj; j++)a[j] = "val[" + k++ + "]";
            out += a + "]";
            b[i] = out;
        }
        return Function("val", "return Snap.path.toString.call([" + b + "])");
    }
    function path2array(path) {
        var out = [];
        for(var i = 0, ii = path.length; i < ii; i++)for(var j = 1, jj = path[i].length; j < jj; j++)out.push(path[i][j]);
        return out;
    }
    function isNumeric(obj) {
        return isFinite(obj);
    }
    function arrayEqual(arr1, arr2) {
        if (!Snap.is(arr1, "array") || !Snap.is(arr2, "array")) return false;
        return arr1.toString() == arr2.toString();
    }
    Element.prototype.equal = function(name, b) {
        return eve("snap.util.equal", this, name, b).firstDefined();
    };
    eve.on("snap.util.equal", function(name, b) {
        var A, B, a = Str(this.attr(name) || ""), el = this;
        if (names[name] == "colour") {
            A = Snap.color(a);
            B = Snap.color(b);
            return {
                from: [
                    A.r,
                    A.g,
                    A.b,
                    A.opacity
                ],
                to: [
                    B.r,
                    B.g,
                    B.b,
                    B.opacity
                ],
                f: getColour
            };
        }
        if (name == "viewBox") {
            A = this.attr(name).vb.split(" ").map(Number);
            B = b.split(" ").map(Number);
            return {
                from: A,
                to: B,
                f: getViewBox
            };
        }
        if (name == "transform" || name == "gradientTransform" || name == "patternTransform") {
            if (typeof b == "string") b = Str(b).replace(/\.{3}|\u2026/g, a);
            a = this.matrix;
            if (!Snap._.rgTransform.test(b)) b = Snap._.transform2matrix(Snap._.svgTransform2string(b), this.getBBox());
            else b = Snap._.transform2matrix(b, this.getBBox());
            return equaliseTransform(a, b, function() {
                return el.getBBox(1);
            });
        }
        if (name == "d" || name == "path") {
            A = Snap.path.toCubic(a, b);
            return {
                from: path2array(A[0]),
                to: path2array(A[1]),
                f: getPath(A[0])
            };
        }
        if (name == "points") {
            A = Str(a).split(Snap._.separator);
            B = Str(b).split(Snap._.separator);
            return {
                from: A,
                to: B,
                f: function(val) {
                    return val;
                }
            };
        }
        if (isNumeric(a) && isNumeric(b)) return {
            from: parseFloat(a),
            to: parseFloat(b),
            f: getNumber
        };
        var aUnit = a.match(reUnit), bUnit = Str(b).match(reUnit);
        if (aUnit && arrayEqual(aUnit, bUnit)) return {
            from: parseFloat(a),
            to: parseFloat(b),
            f: getUnit(aUnit)
        };
        else return {
            from: this.asPX(name),
            to: this.asPX(name, b),
            f: getNumber
        };
    });
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob) {
    var elproto = Element.prototype, has = "hasOwnProperty", supportsTouch = "createTouch" in glob.doc, events = [
        "click",
        "dblclick",
        "mousedown",
        "mousemove",
        "mouseout",
        "mouseover",
        "mouseup",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel"
    ], touchMap = {
        mousedown: "touchstart",
        mousemove: "touchmove",
        mouseup: "touchend"
    }, getScroll = function(xy, el) {
        var name = xy == "y" ? "scrollTop" : "scrollLeft", doc = el && el.node ? el.node.ownerDocument : glob.doc;
        return doc[name in doc.documentElement ? "documentElement" : "body"][name];
    }, preventDefault = function() {
        this.returnValue = false;
    }, preventTouch = function() {
        return this.originalEvent.preventDefault();
    }, stopPropagation = function() {
        this.cancelBubble = true;
    }, stopTouch = function() {
        return this.originalEvent.stopPropagation();
    }, addEvent = function(obj, type, fn, element) {
        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type, f = function(e) {
            var scrollY = getScroll("y", element), scrollX = getScroll("x", element);
            if (supportsTouch && touchMap[has](type)) {
                for(var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++)if (e.targetTouches[i].target == obj || obj.contains(e.targetTouches[i].target)) {
                    var olde = e;
                    e = e.targetTouches[i];
                    e.originalEvent = olde;
                    e.preventDefault = preventTouch;
                    e.stopPropagation = stopTouch;
                    break;
                }
            }
            var x = e.clientX + scrollX, y = e.clientY + scrollY;
            return fn.call(element, e, x, y);
        };
        if (type !== realName) obj.addEventListener(type, f, false);
        obj.addEventListener(realName, f, false);
        return function() {
            if (type !== realName) obj.removeEventListener(type, f, false);
            obj.removeEventListener(realName, f, false);
            return true;
        };
    }, drag = [], dragMove = function(e) {
        var x = e.clientX, y = e.clientY, scrollY = getScroll("y"), scrollX = getScroll("x"), dragi, j = drag.length;
        while(j--){
            dragi = drag[j];
            if (supportsTouch) {
                var i = e.touches && e.touches.length, touch;
                while(i--){
                    touch = e.touches[i];
                    if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
                        x = touch.clientX;
                        y = touch.clientY;
                        (e.originalEvent ? e.originalEvent : e).preventDefault();
                        break;
                    }
                }
            } else e.preventDefault();
            var node = dragi.el.node, o, next = node.nextSibling, parent = node.parentNode, display = node.style.display;
            // glob.win.opera && parent.removeChild(node);
            // node.style.display = "none";
            // o = dragi.el.paper.getElementByPoint(x, y);
            // node.style.display = display;
            // glob.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
            // o && eve("snap.drag.over." + dragi.el.id, dragi.el, o);
            x += scrollX;
            y += scrollY;
            eve("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
        }
    }, dragUp = function(e) {
        Snap.unmousemove(dragMove).unmouseup(dragUp);
        var i = drag.length, dragi;
        while(i--){
            dragi = drag[i];
            dragi.el._drag = {};
            eve("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
            eve.off("snap.drag.*." + dragi.el.id);
        }
        drag = [];
    };
    /*\
     * Element.click
     [ method ]
     **
     * Adds a click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.unclick
     [ method ]
     **
     * Removes a click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.dblclick
     [ method ]
     **
     * Adds a double click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.undblclick
     [ method ]
     **
     * Removes a double click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.mousedown
     [ method ]
     **
     * Adds a mousedown event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.unmousedown
     [ method ]
     **
     * Removes a mousedown event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.mousemove
     [ method ]
     **
     * Adds a mousemove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.unmousemove
     [ method ]
     **
     * Removes a mousemove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.mouseout
     [ method ]
     **
     * Adds a mouseout event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.unmouseout
     [ method ]
     **
     * Removes a mouseout event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.mouseover
     [ method ]
     **
     * Adds a mouseover event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.unmouseover
     [ method ]
     **
     * Removes a mouseover event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.mouseup
     [ method ]
     **
     * Adds a mouseup event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.unmouseup
     [ method ]
     **
     * Removes a mouseup event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.touchstart
     [ method ]
     **
     * Adds a touchstart event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.untouchstart
     [ method ]
     **
     * Removes a touchstart event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.touchmove
     [ method ]
     **
     * Adds a touchmove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.untouchmove
     [ method ]
     **
     * Removes a touchmove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.touchend
     [ method ]
     **
     * Adds a touchend event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.untouchend
     [ method ]
     **
     * Removes a touchend event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.touchcancel
     [ method ]
     **
     * Adds a touchcancel event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.untouchcancel
     [ method ]
     **
     * Removes a touchcancel event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ for(var i = events.length; i--;)(function(eventName) {
        Snap[eventName] = elproto[eventName] = function(fn, scope) {
            if (Snap.is(fn, "function")) {
                this.events = this.events || [];
                this.events.push({
                    name: eventName,
                    f: fn,
                    unbind: addEvent(this.node || document, eventName, fn, scope || this)
                });
            } else {
                for(var i = 0, ii = this.events.length; i < ii; i++)if (this.events[i].name == eventName) try {
                    this.events[i].f.call(this);
                } catch (e) {}
            }
            return this;
        };
        Snap["un" + eventName] = elproto["un" + eventName] = function(fn) {
            var events = this.events || [], l = events.length;
            while(l--)if (events[l].name == eventName && (events[l].f == fn || !fn)) {
                events[l].unbind();
                events.splice(l, 1);
                !events.length && delete this.events;
                return this;
            }
            return this;
        };
    })(events[i]);
    /*\
     * Element.hover
     [ method ]
     **
     * Adds hover event handlers to the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     - icontext (object) #optional context for hover in handler
     - ocontext (object) #optional context for hover out handler
     = (object) @Element
    \*/ elproto.hover = function(f_in, f_out, scope_in, scope_out) {
        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
    };
    /*\
     * Element.unhover
     [ method ]
     **
     * Removes hover event handlers from the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     = (object) @Element
    \*/ elproto.unhover = function(f_in, f_out) {
        return this.unmouseover(f_in).unmouseout(f_out);
    };
    var draggable = [];
    // SIERRA unclear what _context_ refers to for starting, ending, moving the drag gesture.
    // SIERRA Element.drag(): _x position of the mouse_: Where are the x/y values offset from?
    // SIERRA Element.drag(): much of this member's doc appears to be duplicated for some reason.
    // SIERRA Unclear about this sentence: _Additionally following drag events will be triggered: drag.start.<id> on start, drag.end.<id> on end and drag.move.<id> on every move._ Is there a global _drag_ object to which you can assign handlers keyed by an element's ID?
    /*\
     * Element.drag
     [ method ]
     **
     * Adds event handlers for an element's drag gesture
     **
     - onmove (function) handler for moving
     - onstart (function) handler for drag start
     - onend (function) handler for drag end
     - mcontext (object) #optional context for moving handler
     - scontext (object) #optional context for drag start handler
     - econtext (object) #optional context for drag end handler
     * Additionaly following `drag` events are triggered: `drag.start.<id>` on start, 
     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element is dragged over another element 
     * `drag.over.<id>` fires as well.
     *
     * Start event and start handler are called in specified context or in context of the element with following parameters:
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * Move event and move handler are called in specified context or in context of the element with following parameters:
     o dx (number) shift by x from the start point
     o dy (number) shift by y from the start point
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * End event and end handler are called in specified context or in context of the element with following parameters:
     o event (object) DOM event object
     = (object) @Element
    \*/ elproto.drag = function(onmove, onstart, onend, move_scope, start_scope, end_scope) {
        var el = this;
        if (!arguments.length) {
            var origTransform;
            return el.drag(function(dx, dy) {
                this.attr({
                    transform: origTransform + (origTransform ? "T" : "t") + [
                        dx,
                        dy
                    ]
                });
            }, function() {
                origTransform = this.transform().local;
            });
        }
        function start(e, x, y) {
            (e.originalEvent || e).preventDefault();
            el._drag.x = x;
            el._drag.y = y;
            el._drag.id = e.identifier;
            !drag.length && Snap.mousemove(dragMove).mouseup(dragUp);
            drag.push({
                el: el,
                move_scope: move_scope,
                start_scope: start_scope,
                end_scope: end_scope
            });
            onstart && eve.on("snap.drag.start." + el.id, onstart);
            onmove && eve.on("snap.drag.move." + el.id, onmove);
            onend && eve.on("snap.drag.end." + el.id, onend);
            eve("snap.drag.start." + el.id, start_scope || move_scope || el, x, y, e);
        }
        function init(e, x, y) {
            eve("snap.draginit." + el.id, el, e, x, y);
        }
        eve.on("snap.draginit." + el.id, start);
        el._drag = {};
        draggable.push({
            el: el,
            start: start,
            init: init
        });
        el.mousedown(init);
        return el;
    };
    /*
     * Element.onDragOver
     [ method ]
     **
     * Shortcut to assign event handler for `drag.over.<id>` event, where `id` is the element's `id` (see @Element.id)
     - f (function) handler for event, first argument would be the element you are dragging over
    \*/ // elproto.onDragOver = function (f) {
    //     f ? eve.on("snap.drag.over." + this.id, f) : eve.unbind("snap.drag.over." + this.id);
    // };
    /*\
     * Element.undrag
     [ method ]
     **
     * Removes all drag event handlers from the given element
    \*/ elproto.undrag = function() {
        var i = draggable.length;
        while(i--)if (draggable[i].el == this) {
            this.unmousedown(draggable[i].init);
            draggable.splice(i, 1);
            eve.unbind("snap.drag.*." + this.id);
            eve.unbind("snap.draginit." + this.id);
        }
        !draggable.length && Snap.unmousemove(dragMove).unmouseup(dragUp);
        return this;
    };
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob) {
    var elproto = Element.prototype, pproto = Paper.prototype, rgurl = /^\s*url\((.+)\)/, Str = String, $ = Snap._.$;
    Snap.filter = {};
    /*\
     * Paper.filter
     [ method ]
     **
     * Creates a `<filter>` element
     **
     - filstr (string) SVG fragment of filter provided as a string
     = (object) @Element
     * Note: It is recommended to use filters embedded into the page inside an empty SVG element.
     > Usage
     | var f = paper.filter('<feGaussianBlur stdDeviation="2"/>'),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/ pproto.filter = function(filstr) {
        var paper = this;
        if (paper.type != "svg") paper = paper.paper;
        var f = Snap.parse(Str(filstr)), id = Snap._.id(), width = paper.node.offsetWidth, height = paper.node.offsetHeight, filter = $("filter");
        $(filter, {
            id: id,
            filterUnits: "userSpaceOnUse"
        });
        filter.appendChild(f.node);
        paper.defs.appendChild(filter);
        return new Element(filter);
    };
    eve.on("snap.util.getattr.filter", function() {
        eve.stop();
        var p = $(this.node, "filter");
        if (p) {
            var match = Str(p).match(rgurl);
            return match && Snap.select(match[1]);
        }
    });
    eve.on("snap.util.attr.filter", function(value) {
        if (value instanceof Element && value.type == "filter") {
            eve.stop();
            var id = value.node.id;
            if (!id) {
                $(value.node, {
                    id: value.id
                });
                id = value.id;
            }
            $(this.node, {
                filter: Snap.url(id)
            });
        }
        if (!value || value == "none") {
            eve.stop();
            this.node.removeAttribute("filter");
        }
    });
    /*\
     * Snap.filter.blur
     [ method ]
     **
     * Returns an SVG markup string for the blur filter
     **
     - x (number) amount of horizontal blur, in pixels
     - y (number) #optional amount of vertical blur, in pixels
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.blur(5, 10)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/ Snap.filter.blur = function(x, y) {
        if (x == null) x = 2;
        var def = y == null ? x : [
            x,
            y
        ];
        return Snap.format('\<feGaussianBlur stdDeviation="{def}"/>', {
            def: def
        });
    };
    Snap.filter.blur.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.shadow
     [ method ]
     **
     * Returns an SVG markup string for the shadow filter
     **
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - blur (number) #optional amount of blur
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * which makes blur default to `4`. Or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - opacity (number) #optional `0..1` opacity of the shadow
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.shadow(0, 2, .3)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/ Snap.filter.shadow = function(dx, dy, blur, color, opacity) {
        if (opacity == null) {
            if (color == null) {
                opacity = blur;
                blur = 4;
                color = "#000";
            } else {
                opacity = color;
                color = blur;
                blur = 4;
            }
        }
        if (blur == null) blur = 4;
        if (opacity == null) opacity = 1;
        if (dx == null) {
            dx = 0;
            dy = 2;
        }
        if (dy == null) dy = dx;
        color = Snap.color(color);
        return Snap.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
            color: color,
            dx: dx,
            dy: dy,
            blur: blur,
            opacity: opacity
        });
    };
    Snap.filter.shadow.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.grayscale
     [ method ]
     **
     * Returns an SVG markup string for the grayscale filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/ Snap.filter.grayscale = function(amount) {
        if (amount == null) amount = 1;
        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
            a: 0.2126 + 0.7874 * (1 - amount),
            b: 0.7152 - 0.7152 * (1 - amount),
            c: 0.0722 - 0.0722 * (1 - amount),
            d: 0.2126 - 0.2126 * (1 - amount),
            e: 0.7152 + 0.2848 * (1 - amount),
            f: 0.0722 - 0.0722 * (1 - amount),
            g: 0.2126 - 0.2126 * (1 - amount),
            h: 0.0722 + 0.9278 * (1 - amount)
        });
    };
    Snap.filter.grayscale.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.sepia
     [ method ]
     **
     * Returns an SVG markup string for the sepia filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/ Snap.filter.sepia = function(amount) {
        if (amount == null) amount = 1;
        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
            a: 0.393 + 0.607 * (1 - amount),
            b: 0.769 - 0.769 * (1 - amount),
            c: 0.189 - 0.189 * (1 - amount),
            d: 0.349 - 0.349 * (1 - amount),
            e: 0.686 + 0.314 * (1 - amount),
            f: 0.168 - 0.168 * (1 - amount),
            g: 0.272 - 0.272 * (1 - amount),
            h: 0.534 - 0.534 * (1 - amount),
            i: 0.131 + 0.869 * (1 - amount)
        });
    };
    Snap.filter.sepia.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.saturate
     [ method ]
     **
     * Returns an SVG markup string for the saturate filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/ Snap.filter.saturate = function(amount) {
        if (amount == null) amount = 1;
        return Snap.format('<feColorMatrix type="saturate" values="{amount}"/>', {
            amount: 1 - amount
        });
    };
    Snap.filter.saturate.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.hueRotate
     [ method ]
     **
     * Returns an SVG markup string for the hue-rotate filter
     **
     - angle (number) angle of rotation
     = (string) filter representation
    \*/ Snap.filter.hueRotate = function(angle) {
        angle = angle || 0;
        return Snap.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
            angle: angle
        });
    };
    Snap.filter.hueRotate.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.invert
     [ method ]
     **
     * Returns an SVG markup string for the invert filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/ Snap.filter.invert = function(amount) {
        if (amount == null) amount = 1;
        //        <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB"/>
        return Snap.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
            amount: amount,
            amount2: 1 - amount
        });
    };
    Snap.filter.invert.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.brightness
     [ method ]
     **
     * Returns an SVG markup string for the brightness filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/ Snap.filter.brightness = function(amount) {
        if (amount == null) amount = 1;
        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
            amount: amount
        });
    };
    Snap.filter.brightness.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.contrast
     [ method ]
     **
     * Returns an SVG markup string for the contrast filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/ Snap.filter.contrast = function(amount) {
        if (amount == null) amount = 1;
        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
            amount: amount,
            amount2: .5 - amount / 2
        });
    };
    Snap.filter.contrast.toString = function() {
        return this();
    };
});
// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var box = Snap._.box, is = Snap.is, firstLetter = /^[^a-z]*([tbmlrc])/i, toString = function() {
        return "T" + this.dx + "," + this.dy;
    };
    /*\
     * Element.getAlign
     [ method ]
     **
     * Returns shift needed to align the element relatively to given element.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object|string) Object in format `{dx: , dy: }` also has a string representation as a transformation string
     > Usage
     | el.transform(el.getAlign(el2, "top"));
     * or
     | var dy = el.getAlign(el2, "top").dy;
    \*/ Element.prototype.getAlign = function(el, way) {
        if (way == null && is(el, "string")) {
            way = el;
            el = null;
        }
        el = el || this.paper;
        var bx = el.getBBox ? el.getBBox() : box(el), bb = this.getBBox(), out = {};
        way = way && way.match(firstLetter);
        way = way ? way[1].toLowerCase() : "c";
        switch(way){
            case "t":
                out.dx = 0;
                out.dy = bx.y - bb.y;
                break;
            case "b":
                out.dx = 0;
                out.dy = bx.y2 - bb.y2;
                break;
            case "m":
                out.dx = 0;
                out.dy = bx.cy - bb.cy;
                break;
            case "l":
                out.dx = bx.x - bb.x;
                out.dy = 0;
                break;
            case "r":
                out.dx = bx.x2 - bb.x2;
                out.dy = 0;
                break;
            default:
                out.dx = bx.cx - bb.cx;
                out.dy = 0;
                break;
        }
        out.toString = toString;
        return out;
    };
    /*\
     * Element.align
     [ method ]
     **
     * Aligns the element relatively to given one via transformation.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object) this element
     > Usage
     | el.align(el2, "top");
     * or
     | el.align("middle");
    \*/ Element.prototype.align = function(el, way) {
        return this.transform("..." + this.getAlign(el, way));
    };
});
// Copyright (c) 2016 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var elproto = Element.prototype, is = Snap.is, Str = String, has = "hasOwnProperty";
    function slice(from, to, f) {
        return function(arr) {
            var res1 = arr.slice(from, to);
            if (res1.length == 1) res1 = res1[0];
            return f ? f(res1) : res1;
        };
    }
    var Animation = function(attr, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = $f098236b7e761f68$var$mina.linear;
        }
        this.attr = attr;
        this.dur = ms;
        easing && (this.easing = easing);
        callback && (this.callback = callback);
    };
    Snap._.Animation = Animation;
    /*\
     * Snap.animation
     [ method ]
     **
     * Creates an animation object
     **
     - attr (object) attributes of final destination
     - duration (number) duration of the animation, in milliseconds
     - easing (function) #optional one of easing functions of @mina or custom one
     - callback (function) #optional callback function that fires when animation ends
     = (object) animation object
    \*/ Snap.animation = function(attr, ms, easing, callback) {
        return new Animation(attr, ms, easing, callback);
    };
    /*\
     * Element.inAnim
     [ method ]
     **
     * Returns a set of animations that may be able to manipulate the current element
     **
     = (object) in format:
     o {
     o     anim (object) animation object,
     o     mina (object) @mina object,
     o     curStatus (number) 0..1 — status of the animation: 0 — just started, 1 — just finished,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
    \*/ elproto.inAnim = function() {
        var el = this, res1 = [];
        for(var id in el.anims)if (el.anims[has](id)) (function(a) {
            res1.push({
                anim: new Animation(a._attrs, a.dur, a.easing, a._callback),
                mina: a,
                curStatus: a.status(),
                status: function(val) {
                    return a.status(val);
                },
                stop: function() {
                    a.stop();
                }
            });
        })(el.anims[id]);
        return res1;
    };
    /*\
     * Snap.animate
     [ method ]
     **
     * Runs generic animation of one number into another with a caring function
     **
     - from (number|array) number or array of numbers
     - to (number|array) number or array of numbers
     - setter (function) caring function that accepts one number argument
     - duration (number) duration, in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function to execute when animation ends
     = (object) animation object in @mina format
     o {
     o     id (string) animation id, consider it read-only,
     o     duration (function) gets or sets the duration of the animation,
     o     easing (function) easing,
     o     speed (function) gets or sets the speed of the animation,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
     | var rect = Snap().rect(0, 0, 10, 10);
     | Snap.animate(0, 10, function (val) {
     |     rect.attr({
     |         x: val
     |     });
     | }, 1000);
     | // in given context is equivalent to
     | rect.animate({x: 10}, 1000);
    \*/ Snap.animate = function(from, to, setter, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = $f098236b7e761f68$var$mina.linear;
        }
        var now = $f098236b7e761f68$var$mina.time(), anim = $f098236b7e761f68$var$mina(from, to, now, now + ms, $f098236b7e761f68$var$mina.time, setter, easing);
        callback && eve.once("mina.finish." + anim.id, callback);
        return anim;
    };
    /*\
     * Element.stop
     [ method ]
     **
     * Stops all the animations for the current element
     **
     = (Element) the current element
    \*/ elproto.stop = function() {
        var anims = this.inAnim();
        for(var i = 0, ii = anims.length; i < ii; i++)anims[i].stop();
        return this;
    };
    /*\
     * Element.animate
     [ method ]
     **
     * Animates the given attributes of the element
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     = (Element) the current element
    \*/ elproto.animate = function(attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = $f098236b7e761f68$var$mina.linear;
        }
        if (attrs instanceof Animation) {
            callback = attrs.callback;
            easing = attrs.easing;
            ms = attrs.dur;
            attrs = attrs.attr;
        }
        var fkeys = [], tkeys = [], keys = {}, from, to, f, eq, el = this;
        for(var key in attrs)if (attrs[has](key)) {
            if (el.equal) {
                eq = el.equal(key, Str(attrs[key]));
                from = eq.from;
                to = eq.to;
                f = eq.f;
            } else {
                from = +el.attr(key);
                to = +attrs[key];
            }
            var len = is(from, "array") ? from.length : 1;
            keys[key] = slice(fkeys.length, fkeys.length + len, f);
            fkeys = fkeys.concat(from);
            tkeys = tkeys.concat(to);
        }
        var now = $f098236b7e761f68$var$mina.time(), anim = $f098236b7e761f68$var$mina(fkeys, tkeys, now, now + ms, $f098236b7e761f68$var$mina.time, function(val) {
            var attr = {};
            for(var key in keys)if (keys[has](key)) attr[key] = keys[key](val);
            el.attr(attr);
        }, easing);
        el.anims[anim.id] = anim;
        anim._attrs = attrs;
        anim._callback = callback;
        eve("snap.animcreated." + el.id, anim);
        eve.once("mina.finish." + anim.id, function() {
            eve.off("mina.*." + anim.id);
            delete el.anims[anim.id];
            callback && callback.call(el);
        });
        eve.once("mina.stop." + anim.id, function() {
            eve.off("mina.*." + anim.id);
            delete el.anims[anim.id];
        });
        return el;
    };
});
// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob) {
    // Colours are from https://www.materialui.co
    var red = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000", pink = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162", purple = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF", deeppurple = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA", indigo = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE", blue = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF", lightblue = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA", cyan = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4", teal = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5", green = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853", lightgreen = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17", lime = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00", yellow = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600", amber = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00", orange = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00", deeporange = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00", brown = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723", grey = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121", bluegrey = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
    /*\
     * Snap.mui
     [ property ]
     **
     * Contain Material UI colours.
     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.mui.deeppurple, stroke: Snap.mui.amber[600]});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/ Snap.mui = {};
    /*\
     * Snap.flat
     [ property ]
     **
     * Contain Flat UI colours.
     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.flat.carrot, stroke: Snap.flat.wetasphalt});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/ Snap.flat = {};
    function saveColor(colors) {
        colors = colors.split(/(?=#)/);
        var color = new String(colors[5]);
        color[50] = colors[0];
        color[100] = colors[1];
        color[200] = colors[2];
        color[300] = colors[3];
        color[400] = colors[4];
        color[500] = colors[5];
        color[600] = colors[6];
        color[700] = colors[7];
        color[800] = colors[8];
        color[900] = colors[9];
        if (colors[10]) {
            color.A100 = colors[10];
            color.A200 = colors[11];
            color.A400 = colors[12];
            color.A700 = colors[13];
        }
        return color;
    }
    Snap.mui.red = saveColor(red);
    Snap.mui.pink = saveColor(pink);
    Snap.mui.purple = saveColor(purple);
    Snap.mui.deeppurple = saveColor(deeppurple);
    Snap.mui.indigo = saveColor(indigo);
    Snap.mui.blue = saveColor(blue);
    Snap.mui.lightblue = saveColor(lightblue);
    Snap.mui.cyan = saveColor(cyan);
    Snap.mui.teal = saveColor(teal);
    Snap.mui.green = saveColor(green);
    Snap.mui.lightgreen = saveColor(lightgreen);
    Snap.mui.lime = saveColor(lime);
    Snap.mui.yellow = saveColor(yellow);
    Snap.mui.amber = saveColor(amber);
    Snap.mui.orange = saveColor(orange);
    Snap.mui.deeporange = saveColor(deeporange);
    Snap.mui.brown = saveColor(brown);
    Snap.mui.grey = saveColor(grey);
    Snap.mui.bluegrey = saveColor(bluegrey);
    Snap.flat.turquoise = "#1abc9c";
    Snap.flat.greensea = "#16a085";
    Snap.flat.sunflower = "#f1c40f";
    Snap.flat.orange = "#f39c12";
    Snap.flat.emerland = "#2ecc71";
    Snap.flat.nephritis = "#27ae60";
    Snap.flat.carrot = "#e67e22";
    Snap.flat.pumpkin = "#d35400";
    Snap.flat.peterriver = "#3498db";
    Snap.flat.belizehole = "#2980b9";
    Snap.flat.alizarin = "#e74c3c";
    Snap.flat.pomegranate = "#c0392b";
    Snap.flat.amethyst = "#9b59b6";
    Snap.flat.wisteria = "#8e44ad";
    Snap.flat.clouds = "#ecf0f1";
    Snap.flat.silver = "#bdc3c7";
    Snap.flat.wetasphalt = "#34495e";
    Snap.flat.midnightblue = "#2c3e50";
    Snap.flat.concrete = "#95a5a6";
    Snap.flat.asbestos = "#7f8c8d";
    /*\
     * Snap.importMUIColors
     [ method ]
     **
     * Imports Material UI colours into global object.
     | Snap.importMUIColors();
     | Snap().rect(0, 0, 10, 10).attr({fill: deeppurple, stroke: amber[600]});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/ Snap.importMUIColors = function() {
        for(var color in Snap.mui)if (Snap.mui.hasOwnProperty(color)) window[color] = Snap.mui[color];
    };
});
module.exports = $f098236b7e761f68$var$Snap;

});
parcelRegister("fXTr3", function(module, exports) {
// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ┌────────────────────────────────────────────────────────────┐ \\
// │ Eve 0.5.4 - JavaScript Events Library                      │ \\
// ├────────────────────────────────────────────────────────────┤ \\
// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
// └────────────────────────────────────────────────────────────┘ \\
(function(glob) {
    var version = "0.5.4", has = "hasOwnProperty", separator = /[\.\/]/, comaseparator = /\s*,\s*/, wildcard = "*", numsort = function(a, b) {
        return a - b;
    }, current_event, stop, events = {
        n: {}
    }, firstDefined = function() {
        for(var i = 0, ii = this.length; i < ii; i++){
            if (typeof this[i] != "undefined") return this[i];
        }
    }, lastDefined = function() {
        var i = this.length;
        while(--i){
            if (typeof this[i] != "undefined") return this[i];
        }
    }, objtos = Object.prototype.toString, Str = String, isArray = Array.isArray || function(ar) {
        return ar instanceof Array || objtos.call(ar) == "[object Array]";
    }, /*\
     * eve
     [ method ]

     * Fires event with given `name`, given scope and other parameters.

     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
     - scope (object) context for the event handlers
     - varargs (...) the rest of arguments will be sent to event handlers

     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
    \*/ eve = function(name, scope) {
        var oldstop = stop, args = Array.prototype.slice.call(arguments, 2), listeners = eve.listeners(name), z = 0, l, indexed = [], queue = {}, out = [], ce = current_event;
        out.firstDefined = firstDefined;
        out.lastDefined = lastDefined;
        current_event = name;
        stop = 0;
        for(var i = 0, ii = listeners.length; i < ii; i++)if ("zIndex" in listeners[i]) {
            indexed.push(listeners[i].zIndex);
            if (listeners[i].zIndex < 0) queue[listeners[i].zIndex] = listeners[i];
        }
        indexed.sort(numsort);
        while(indexed[z] < 0){
            l = queue[indexed[z++]];
            out.push(l.apply(scope, args));
            if (stop) {
                stop = oldstop;
                return out;
            }
        }
        for(i = 0; i < ii; i++){
            l = listeners[i];
            if ("zIndex" in l) {
                if (l.zIndex == indexed[z]) {
                    out.push(l.apply(scope, args));
                    if (stop) break;
                    do {
                        z++;
                        l = queue[indexed[z]];
                        l && out.push(l.apply(scope, args));
                        if (stop) break;
                    }while (l);
                } else queue[l.zIndex] = l;
            } else {
                out.push(l.apply(scope, args));
                if (stop) break;
            }
        }
        stop = oldstop;
        current_event = ce;
        return out;
    };
    // Undocumented. Debug only.
    eve._events = events;
    /*\
     * eve.listeners
     [ method ]

     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.

     - name (string) name of the event, dot (`.`) or slash (`/`) separated

     = (array) array of event handlers
    \*/ eve.listeners = function(name) {
        var names = isArray(name) ? name : name.split(separator), e = events, item, items, k, i, ii, j, jj, nes, es = [
            e
        ], out = [];
        for(i = 0, ii = names.length; i < ii; i++){
            nes = [];
            for(j = 0, jj = es.length; j < jj; j++){
                e = es[j].n;
                items = [
                    e[names[i]],
                    e[wildcard]
                ];
                k = 2;
                while(k--){
                    item = items[k];
                    if (item) {
                        nes.push(item);
                        out = out.concat(item.f || []);
                    }
                }
            }
            es = nes;
        }
        return out;
    };
    /*\
     * eve.separator
     [ method ]

     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
     * here. Be aware that if you pass a string longer than one character it will be treated as
     * a list of characters.

     - separator (string) new separator. Empty string resets to default: `.` or `/`.
    \*/ eve.separator = function(sep) {
        if (sep) {
            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
            sep = "[" + sep + "]";
            separator = new RegExp(sep);
        } else separator = /[\.\/]/;
    };
    /*\
     * eve.on
     [ method ]
     **
     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
     | eve.on("*.under.*", f);
     | eve("mouse.under.floor"); // triggers f
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     - name (array) if you don’t want to use separators, you can use array of strings
     - f (function) event handler function
     **
     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment.
     > Example:
     | eve.on("mouse", eatIt)(2);
     | eve.on("mouse", scream);
     | eve.on("mouse", catchIt)(1);
     * This will ensure that `catchIt` function will be called before `eatIt`.
     *
     * If you want to put your handler before non-indexed handlers, specify a negative value.
     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
    \*/ eve.on = function(name, f) {
        if (typeof f != "function") return function() {};
        var names = isArray(name) ? isArray(name[0]) ? name : [
            name
        ] : Str(name).split(comaseparator);
        for(var i = 0, ii = names.length; i < ii; i++)(function(name) {
            var names = isArray(name) ? name : Str(name).split(separator), e = events, exist;
            for(var i = 0, ii = names.length; i < ii; i++){
                e = e.n;
                e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {
                    n: {}
                });
            }
            e.f = e.f || [];
            for(i = 0, ii = e.f.length; i < ii; i++)if (e.f[i] == f) {
                exist = true;
                break;
            }
            !exist && e.f.push(f);
        })(names[i]);
        return function(zIndex) {
            if (+zIndex == +zIndex) f.zIndex = +zIndex;
        };
    };
    /*\
     * eve.f
     [ method ]
     **
     * Returns function that will fire given event with optional arguments.
     * Arguments that will be passed to the result function will be also
     * concated to the list of final arguments.
     | el.onclick = eve.f("click", 1, 2);
     | eve.on("click", function (a, b, c) {
     |     console.log(a, b, c); // 1, 2, [event object]
     | });
     - event (string) event name
     - varargs (…) and any other arguments
     = (function) possible event handler function
    \*/ eve.f = function(event) {
        var attrs = [].slice.call(arguments, 1);
        return function() {
            eve.apply(null, [
                event,
                null
            ].concat(attrs).concat([].slice.call(arguments, 0)));
        };
    };
    /*\
     * eve.stop
     [ method ]
     **
     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
    \*/ eve.stop = function() {
        stop = 1;
    };
    /*\
     * eve.nt
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     - subname (string) #optional subname of the event
     **
     = (string) name of the event, if `subname` is not specified
     * or
     = (boolean) `true`, if current event’s name contains `subname`
    \*/ eve.nt = function(subname) {
        var cur = isArray(current_event) ? current_event.join(".") : current_event;
        if (subname) return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
        return cur;
    };
    /*\
     * eve.nts
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     **
     = (array) names of the event
    \*/ eve.nts = function() {
        return isArray(current_event) ? current_event : current_event.split(separator);
    };
    /*\
     * eve.off
     [ method ]
     **
     * Removes given function from the list of event listeners assigned to given name.
     * If no arguments specified all the events will be cleared.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
    \*/ /*\
     * eve.unbind
     [ method ]
     **
     * See @eve.off
    \*/ eve.off = eve.unbind = function(name, f) {
        if (!name) {
            eve._events = events = {
                n: {}
            };
            return;
        }
        var names = isArray(name) ? isArray(name[0]) ? name : [
            name
        ] : Str(name).split(comaseparator);
        if (names.length > 1) {
            for(var i = 0, ii = names.length; i < ii; i++)eve.off(names[i], f);
            return;
        }
        names = isArray(name) ? name : Str(name).split(separator);
        var e, key, splice, i, ii, j, jj, cur = [
            events
        ], inodes = [];
        for(i = 0, ii = names.length; i < ii; i++)for(j = 0; j < cur.length; j += splice.length - 2){
            splice = [
                j,
                1
            ];
            e = cur[j].n;
            if (names[i] != wildcard) {
                if (e[names[i]]) {
                    splice.push(e[names[i]]);
                    inodes.unshift({
                        n: e,
                        name: names[i]
                    });
                }
            } else {
                for(key in e)if (e[has](key)) {
                    splice.push(e[key]);
                    inodes.unshift({
                        n: e,
                        name: key
                    });
                }
            }
            cur.splice.apply(cur, splice);
        }
        for(i = 0, ii = cur.length; i < ii; i++){
            e = cur[i];
            while(e.n){
                if (f) {
                    if (e.f) {
                        for(j = 0, jj = e.f.length; j < jj; j++)if (e.f[j] == f) {
                            e.f.splice(j, 1);
                            break;
                        }
                        !e.f.length && delete e.f;
                    }
                    for(key in e.n)if (e.n[has](key) && e.n[key].f) {
                        var funcs = e.n[key].f;
                        for(j = 0, jj = funcs.length; j < jj; j++)if (funcs[j] == f) {
                            funcs.splice(j, 1);
                            break;
                        }
                        !funcs.length && delete e.n[key].f;
                    }
                } else {
                    delete e.f;
                    for(key in e.n)if (e.n[has](key) && e.n[key].f) delete e.n[key].f;
                }
                e = e.n;
            }
        }
        // prune inner nodes in path
        prune: for(i = 0, ii = inodes.length; i < ii; i++){
            e = inodes[i];
            for(key in e.n[e.name].f)continue prune;
            for(key in e.n[e.name].n)continue prune;
            // is empty
            delete e.n[e.name];
        }
    };
    /*\
     * eve.once
     [ method ]
     **
     * Binds given event handler with a given name to only run once then unbind itself.
     | eve.once("login", f);
     | eve("login"); // triggers f
     | eve("login"); // no listeners
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) same return function as @eve.on
    \*/ eve.once = function(name, f) {
        var f2 = function() {
            eve.off(name, f2);
            return f.apply(this, arguments);
        };
        return eve.on(name, f2);
    };
    /*\
     * eve.version
     [ property (string) ]
     **
     * Current version of the library.
    \*/ eve.version = version;
    eve.toString = function() {
        return "You are running Eve " + version;
    };
    glob.eve = eve;
    module.exports ? module.exports = eve : typeof define === "function" && define.amd ? define("eve", [], function() {
        return eve;
    }) : glob.eve = eve;
})(typeof window != "undefined" ? window : module.exports);

});



parcelRegister("e1he6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a34e857d010d1d35$var$pxToNum = function pxToNum(val) {
    return parseInt(val.slice(0, -2), 10);
};
module.exports.pxToNum = $a34e857d010d1d35$var$pxToNum;

});


parcelRegister("63d8t", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $467d365c461d701b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $c3Chv = parcelRequire("c3Chv");
var $467d365c461d701b$var$_helpersSnapsvgImporter2 = $467d365c461d701b$var$_interopRequireDefault($c3Chv);

var $6muFC = parcelRequire("6muFC");
var $467d365c461d701b$var$_menuFactory2 = $467d365c461d701b$var$_interopRequireDefault($6muFC);

var $e1he6 = parcelRequire("e1he6");
var $467d365c461d701b$var$BUBBLE_WIDTH = 140;
var $467d365c461d701b$var$styles = {
    svg: {
        lib: $467d365c461d701b$var$_helpersSnapsvgImporter2['default'],
        pathInitial: 'M-7.312,0H0c0,0,0,113.839,0,400c0,264.506,0,400,0,400h-7.312V0z',
        pathOpen: 'M-7.312,0H15c0,0,66,113.339,66,399.5C81,664.006,15,800,15,800H-7.312V0z;M-7.312,0H100c0,0,0,113.839,0,400c0,264.506,0,400,0,400H-7.312V0z',
        animate: function animate(path) {
            var pos = 0;
            var steps = this.pathOpen.split(';');
            var stepsTotal = steps.length;
            var mina = window.mina;
            var nextStep = function nextStep() {
                if (pos > stepsTotal - 1) return;
                path.animate({
                    path: steps[pos]
                }, pos === 0 ? 400 : 500, pos === 0 ? mina.easein : mina.elastic, function() {
                    nextStep();
                });
                pos++;
            };
            nextStep();
        }
    },
    morphShape: function morphShape(isOpen, width, right) {
        return {
            position: 'absolute',
            width: '100%',
            height: '100%',
            right: right ? 'inherit' : 0,
            left: right ? 0 : 'inherit',
            MozTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
            MsTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
            OTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
            WebkitTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
            transform: right ? 'rotateY(180deg)' : 'rotateY(0deg)'
        };
    },
    menuWrap: function menuWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            transition: isOpen ? 'transform 0.4s 0s' : 'transform 0.4s'
        };
    },
    menu: function menu(isOpen, width, right) {
        var finalWidth = (0, $e1he6.pxToNum)(width) - $467d365c461d701b$var$BUBBLE_WIDTH;
        return {
            position: 'fixed',
            MozTransform: isOpen ? '' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            transition: isOpen ? 'opacity 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
            opacity: isOpen ? 1 : 0
        };
    },
    item: function item(isOpen, width, right, nthChild) {
        var finalWidth = (0, $e1he6.pxToNum)(width) - $467d365c461d701b$var$BUBBLE_WIDTH;
        return {
            MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            transition: isOpen ? 'opacity 0.3s 0.4s, transform 0.3s 0.4s' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
            opacity: isOpen ? 1 : 0
        };
    },
    closeButton: function closeButton(isOpen, width, right) {
        var finalWidth = (0, $e1he6.pxToNum)(width) - $467d365c461d701b$var$BUBBLE_WIDTH;
        return {
            MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            transition: isOpen ? 'opacity 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
            opacity: isOpen ? 1 : 0
        };
    }
};
module.exports['default'] = (0, $467d365c461d701b$var$_menuFactory2['default'])($467d365c461d701b$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("d9Mhz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $99419183d31f2cf3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $99419183d31f2cf3$var$_menuFactory2 = $99419183d31f2cf3$var$_interopRequireDefault($6muFC);
var $99419183d31f2cf3$var$styles = {
    pageWrap: function pageWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            transition: 'all 0.5s'
        };
    },
    outerContainer: function outerContainer(isOpen) {
        return {
            overflow: isOpen ? '' : 'hidden'
        };
    }
};
module.exports['default'] = (0, $99419183d31f2cf3$var$_menuFactory2['default'])($99419183d31f2cf3$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("cJH6C", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $945b1fef15f87dd8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $945b1fef15f87dd8$var$_menuFactory2 = $945b1fef15f87dd8$var$_interopRequireDefault($6muFC);
var $945b1fef15f87dd8$var$styles = {
    pageWrap: function pageWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
            MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
            OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
            transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
            transformOrigin: right ? '100% 50%' : '0% 50%',
            transformStyle: 'preserve-3d',
            transition: 'all 0.5s'
        };
    },
    outerContainer: function outerContainer(isOpen) {
        return {
            perspective: '1500px',
            overflow: isOpen ? '' : 'hidden'
        };
    }
};
module.exports['default'] = (0, $945b1fef15f87dd8$var$_menuFactory2['default'])($945b1fef15f87dd8$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("1v5Sr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $117d3ec0376391d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $117d3ec0376391d4$var$_menuFactory2 = $117d3ec0376391d4$var$_interopRequireDefault($6muFC);
var $117d3ec0376391d4$var$styles = {
    pageWrap: function pageWrap(isOpen, width) {
        return {
            MozTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
            MsTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
            OTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
            WebkitTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
            transform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
            transformOrigin: '100%',
            transformStyle: 'preserve-3d',
            transition: 'all 0.5s'
        };
    },
    outerContainer: function outerContainer() {
        return {
            perspective: '1500px'
        };
    }
};
module.exports['default'] = (0, $117d3ec0376391d4$var$_menuFactory2['default'])($117d3ec0376391d4$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("i1zqH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $d1f3cd9079abce5f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $d1f3cd9079abce5f$var$_menuFactory2 = $d1f3cd9079abce5f$var$_interopRequireDefault($6muFC);
var $d1f3cd9079abce5f$var$styles = {
    pageWrap: function pageWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
            MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
            OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
            transform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
            transformStyle: 'preserve-3d',
            transition: 'all 0.5s',
            overflow: isOpen ? '' : 'hidden'
        };
    },
    outerContainer: function outerContainer(isOpen) {
        return {
            perspective: '1500px',
            overflow: isOpen ? '' : 'hidden'
        };
    }
};
module.exports['default'] = (0, $d1f3cd9079abce5f$var$_menuFactory2['default'])($d1f3cd9079abce5f$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("k9vVI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $eabd6a816097098a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $eabd6a816097098a$var$_menuFactory2 = $eabd6a816097098a$var$_interopRequireDefault($6muFC);
var $eabd6a816097098a$var$styles = {
    menuWrap: function menuWrap(isOpen) {
        return {
            MozTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
            MsTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
            OTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
            WebkitTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
            transform: isOpen ? '' : 'translate3d(0, -100%, 0)',
            transition: 'all 0.5s ease-in-out'
        };
    },
    pageWrap: function pageWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            transition: 'all 0.5s'
        };
    },
    outerContainer: function outerContainer(isOpen) {
        return {
            perspective: '1500px',
            perspectiveOrigin: '0% 50%',
            overflow: isOpen ? '' : 'hidden'
        };
    }
};
module.exports['default'] = (0, $eabd6a816097098a$var$_menuFactory2['default'])($eabd6a816097098a$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("6UWsR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $509552e2c96be21e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $509552e2c96be21e$var$_menuFactory2 = $509552e2c96be21e$var$_interopRequireDefault($6muFC);
var $509552e2c96be21e$var$styles = {
    menuWrap: function menuWrap(isOpen, width, right) {
        return {
            MozTransform: 'translate3d(0, 0, 0)',
            MsTransform: 'translate3d(0, 0, 0)',
            OTransform: 'translate3d(0, 0, 0)',
            WebkitTransform: 'translate3d(0, 0, 0)',
            transform: 'translate3d(0, 0, 0)',
            zIndex: isOpen ? 1000 : -1
        };
    },
    overlay: function overlay(isOpen, width, right) {
        return {
            zIndex: 1400,
            MozTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            MsTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            OTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            WebkitTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            transform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            transition: 'all 0.5s',
            visibility: isOpen ? 'visible' : 'hidden'
        };
    },
    pageWrap: function pageWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            transition: 'all 0.5s',
            zIndex: 1200,
            position: 'relative'
        };
    },
    burgerIcon: function burgerIcon(isOpen, width, right) {
        return {
            MozTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            MsTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            OTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            WebkitTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            transform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            transition: 'all 0.1s',
            position: 'relative',
            zIndex: 1300
        };
    },
    outerContainer: function outerContainer(isOpen) {
        return {
            overflow: isOpen ? '' : 'hidden'
        };
    }
};
module.exports['default'] = (0, $509552e2c96be21e$var$_menuFactory2['default'])($509552e2c96be21e$var$styles);
module.exports = module.exports['default'];

});

var $d82c3842d7dda3f8$exports = {};
$parcel$extendImportMap({
    "kPsoI": "web-vitals.645e30e4.js",
    "kEDyG": "chevron.left.b742c9f8.svg",
    "6pPtb": "options-icon.6e5b49d2.svg",
    "63aom": "plus.cef30f04.svg",
    "5eOiC": "pencil.b8c5706e.svg",
    "f7jIs": "trash.bb9c5ac1.svg",
    "1BhH4": "share.a0dee636.svg",
    "96vVz": "churchhub-logo.fac3d1bd.png",
    "hXw2B": "planning-center-white.b0494edd.svg",
    "8nLu6": "planning-center-full-color.7a78942d.svg",
    "aJ728": "smartwaiver-logo.ab86e67f.svg",
    "kroiJ": "error-icon.3ca358df.svg",
    "1MmLB": "linkArrow.9cdcce79.svg",
    "l9fer": "event-placeholder.70832a6b.png",
    "fYzlm": "registrations-icon.a17a8982.png",
    "LuWrb": "salt-icon.95e97c75.png",
    "abwkZ": "events-icon.0cf12a90.svg",
    "iq4SA": "chevron.right.plain.6d034a94.svg",
    "5pgWl": "HeaderLogo.bc96b6f1.png",
    "ltOob": "HeaderLogo-dark.fbbb76a3.png",
    "bBooK": "house.1fc3ab23.svg",
    "es6ZK": "connections.23b99b17.svg",
    "aKLVB": "music.list.4cfa019c.svg",
    "kGQfz": "arrow.right.d98dd07b.svg",
    "ha6AV": "person.a0669ef7.svg",
    "7Tmfa": "sidebar.7204249a.svg",
    "ahs3Z": "volunteer-icon.ce1c9201.svg",
    "jCnJv": "close.e79222ed.svg",
    "g0W8j": "checkmark-circle.c728f695.svg",
    "9YVV8": "waivers-icon.f81ee61a.svg",
    "ktzxf": "smartwaiver-icon.fc1416b1.svg"
});

var $824c049f32d4395d$exports = {};
'use strict';

$824c049f32d4395d$exports = (parcelRequire("2nzLi"));



var $fw0lo = parcelRequire("fw0lo");

const $5a0342ebaab9f2d7$var$reportWebVitals = (onPerfEntry)=>{
    if (onPerfEntry && onPerfEntry instanceof Function) (parcelRequire("lzq3r")).then(({ getCLS: getCLS, getFID: getFID, getFCP: getFCP, getLCP: getLCP, getTTFB: getTTFB })=>{
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
    });
};
var $5a0342ebaab9f2d7$export$2e2bcd8739ae039 = $5a0342ebaab9f2d7$var$reportWebVitals;


/**
 * React Router v6.0.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f43c50d92a19d876$export$2e2bcd8739ae039.apply(this, arguments);
}


var $91da240b76094466$export$e19cd5f9376f8cee, $91da240b76094466$var$B = $91da240b76094466$export$e19cd5f9376f8cee || ($91da240b76094466$export$e19cd5f9376f8cee = {});
$91da240b76094466$var$B.Pop = "POP";
$91da240b76094466$var$B.Push = "PUSH";
$91da240b76094466$var$B.Replace = "REPLACE";
var $91da240b76094466$var$C = function(b) {
    return b;
};
function $91da240b76094466$var$D(b, h) {
    if (!b) {
        "undefined" !== typeof console && console.warn(h);
        try {
            throw Error(h);
        } catch (k) {}
    }
}
function $91da240b76094466$var$E(b) {
    b.preventDefault();
    b.returnValue = "";
}
function $91da240b76094466$var$F() {
    var b = [];
    return {
        get length () {
            return b.length;
        },
        push: function(h) {
            b.push(h);
            return function() {
                b = b.filter(function(k) {
                    return k !== h;
                });
            };
        },
        call: function(h) {
            b.forEach(function(k) {
                return k && k(h);
            });
        }
    };
}
function $91da240b76094466$var$H() {
    return Math.random().toString(36).substr(2, 8);
}
function $91da240b76094466$export$fe53371bee54353d(b) {
    var h = b.pathname, k = b.search;
    b = b.hash;
    return (void 0 === h ? "/" : h) + (void 0 === k ? "" : k) + (void 0 === b ? "" : b);
}
function $91da240b76094466$export$8ccf933b0513f8d0(b) {
    var h = {};
    if (b) {
        var k = b.indexOf("#");
        0 <= k && (h.hash = b.substr(k), b = b.substr(0, k));
        k = b.indexOf("?");
        0 <= k && (h.search = b.substr(k), b = b.substr(0, k));
        b && (h.pathname = b);
    }
    return h;
}
function $91da240b76094466$export$719fc203c4e16dee(b) {
    function h() {
        var c = p.location, a = m.state || {};
        return [
            a.idx,
            $91da240b76094466$var$C({
                pathname: c.pathname,
                search: c.search,
                hash: c.hash,
                state: a.usr || null,
                key: a.key || "default"
            })
        ];
    }
    function k(c) {
        return "string" === typeof c ? c : $91da240b76094466$export$fe53371bee54353d(c);
    }
    function x(c, a) {
        void 0 === a && (a = null);
        return $91da240b76094466$var$C((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            pathname: q.pathname,
            hash: "",
            search: ""
        }, "string" === typeof c ? $91da240b76094466$export$8ccf933b0513f8d0(c) : c, {
            state: a,
            key: $91da240b76094466$var$H()
        }));
    }
    function z(c) {
        t = c;
        c = h();
        v = c[0];
        q = c[1];
        d.call({
            action: t,
            location: q
        });
    }
    function A(c, a) {
        function e() {
            A(c, a);
        }
        var l = $91da240b76094466$export$e19cd5f9376f8cee.Push, g = x(c, a);
        if (!f.length || (f.call({
            action: l,
            location: g,
            retry: e
        }), !1)) {
            var n = [
                {
                    usr: g.state,
                    key: g.key,
                    idx: v + 1
                },
                k(g)
            ];
            g = n[0];
            n = n[1];
            try {
                m.pushState(g, "", n);
            } catch (G) {
                p.location.assign(n);
            }
            z(l);
        }
    }
    function y(c, a) {
        function e() {
            y(c, a);
        }
        var l = $91da240b76094466$export$e19cd5f9376f8cee.Replace, g = x(c, a);
        f.length && (f.call({
            action: l,
            location: g,
            retry: e
        }), 1) || (g = [
            {
                usr: g.state,
                key: g.key,
                idx: v
            },
            k(g)
        ], m.replaceState(g[0], "", g[1]), z(l));
    }
    function w(c) {
        m.go(c);
    }
    void 0 === b && (b = {});
    b = b.window;
    var p = void 0 === b ? document.defaultView : b, m = p.history, u = null;
    p.addEventListener("popstate", function() {
        if (u) f.call(u), u = null;
        else {
            var c = $91da240b76094466$export$e19cd5f9376f8cee.Pop, a = h(), e = a[0];
            a = a[1];
            if (f.length) {
                if (null != e) {
                    var l = v - e;
                    l && (u = {
                        action: c,
                        location: a,
                        retry: function() {
                            w(-1 * l);
                        }
                    }, w(l));
                }
            } else z(c);
        }
    });
    var t = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
    b = h();
    var v = b[0], q = b[1], d = $91da240b76094466$var$F(), f = $91da240b76094466$var$F();
    null == v && (v = 0, m.replaceState((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, m.state, {
        idx: v
    }), ""));
    return {
        get action () {
            return t;
        },
        get location () {
            return q;
        },
        createHref: k,
        push: A,
        replace: y,
        go: w,
        back: function() {
            w(-1);
        },
        forward: function() {
            w(1);
        },
        listen: function(c) {
            return d.push(c);
        },
        block: function(c) {
            var a = f.push(c);
            1 === f.length && p.addEventListener("beforeunload", $91da240b76094466$var$E);
            return function() {
                a();
                f.length || p.removeEventListener("beforeunload", $91da240b76094466$var$E);
            };
        }
    };
}
function $91da240b76094466$export$b71fdd3798280242(b) {
    function h() {
        var a = $91da240b76094466$export$8ccf933b0513f8d0(m.location.hash.substr(1)), e = a.pathname, l = a.search;
        a = a.hash;
        var g = u.state || {};
        return [
            g.idx,
            $91da240b76094466$var$C({
                pathname: void 0 === e ? "/" : e,
                search: void 0 === l ? "" : l,
                hash: void 0 === a ? "" : a,
                state: g.usr || null,
                key: g.key || "default"
            })
        ];
    }
    function k() {
        if (t) c.call(t), t = null;
        else {
            var a = $91da240b76094466$export$e19cd5f9376f8cee.Pop, e = h(), l = e[0];
            e = e[1];
            if (c.length) {
                if (null != l) {
                    var g = q - l;
                    g && (t = {
                        action: a,
                        location: e,
                        retry: function() {
                            p(-1 * g);
                        }
                    }, p(g));
                }
            } else A(a);
        }
    }
    function x(a) {
        var e = document.querySelector("base"), l = "";
        e && e.getAttribute("href") && (e = m.location.href, l = e.indexOf("#"), l = -1 === l ? e : e.slice(0, l));
        return l + "#" + ("string" === typeof a ? a : $91da240b76094466$export$fe53371bee54353d(a));
    }
    function z(a, e) {
        void 0 === e && (e = null);
        return $91da240b76094466$var$C((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            pathname: d.pathname,
            hash: "",
            search: ""
        }, "string" === typeof a ? $91da240b76094466$export$8ccf933b0513f8d0(a) : a, {
            state: e,
            key: $91da240b76094466$var$H()
        }));
    }
    function A(a) {
        v = a;
        a = h();
        q = a[0];
        d = a[1];
        f.call({
            action: v,
            location: d
        });
    }
    function y(a, e) {
        function l() {
            y(a, e);
        }
        var g = $91da240b76094466$export$e19cd5f9376f8cee.Push, n = z(a, e);
        if (!c.length || (c.call({
            action: g,
            location: n,
            retry: l
        }), !1)) {
            var G = [
                {
                    usr: n.state,
                    key: n.key,
                    idx: q + 1
                },
                x(n)
            ];
            n = G[0];
            G = G[1];
            try {
                u.pushState(n, "", G);
            } catch (K) {
                m.location.assign(G);
            }
            A(g);
        }
    }
    function w(a, e) {
        function l() {
            w(a, e);
        }
        var g = $91da240b76094466$export$e19cd5f9376f8cee.Replace, n = z(a, e);
        c.length && (c.call({
            action: g,
            location: n,
            retry: l
        }), 1) || (n = [
            {
                usr: n.state,
                key: n.key,
                idx: q
            },
            x(n)
        ], u.replaceState(n[0], "", n[1]), A(g));
    }
    function p(a) {
        u.go(a);
    }
    void 0 === b && (b = {});
    b = b.window;
    var m = void 0 === b ? document.defaultView : b, u = m.history, t = null;
    m.addEventListener("popstate", k);
    m.addEventListener("hashchange", function() {
        var a = h()[1];
        $91da240b76094466$export$fe53371bee54353d(a) !== $91da240b76094466$export$fe53371bee54353d(d) && k();
    });
    var v = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
    b = h();
    var q = b[0], d = b[1], f = $91da240b76094466$var$F(), c = $91da240b76094466$var$F();
    null == q && (q = 0, u.replaceState((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, u.state, {
        idx: q
    }), ""));
    return {
        get action () {
            return v;
        },
        get location () {
            return d;
        },
        createHref: x,
        push: y,
        replace: w,
        go: p,
        back: function() {
            p(-1);
        },
        forward: function() {
            p(1);
        },
        listen: function(a) {
            return f.push(a);
        },
        block: function(a) {
            var e = c.push(a);
            1 === c.length && m.addEventListener("beforeunload", $91da240b76094466$var$E);
            return function() {
                e();
                c.length || m.removeEventListener("beforeunload", $91da240b76094466$var$E);
            };
        }
    };
}
function $91da240b76094466$export$2b76ad033c6e6d08(b) {
    function h(d, f) {
        void 0 === f && (f = null);
        return $91da240b76094466$var$C((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            pathname: t.pathname,
            search: "",
            hash: ""
        }, "string" === typeof d ? $91da240b76094466$export$8ccf933b0513f8d0(d) : d, {
            state: f,
            key: $91da240b76094466$var$H()
        }));
    }
    function k(d, f, c) {
        return !q.length || (q.call({
            action: d,
            location: f,
            retry: c
        }), !1);
    }
    function x(d, f) {
        u = d;
        t = f;
        v.call({
            action: u,
            location: t
        });
    }
    function z(d, f) {
        var c = $91da240b76094466$export$e19cd5f9376f8cee.Push, a = h(d, f);
        k(c, a, function() {
            z(d, f);
        }) && (m += 1, p.splice(m, p.length, a), x(c, a));
    }
    function A(d, f) {
        var c = $91da240b76094466$export$e19cd5f9376f8cee.Replace, a = h(d, f);
        k(c, a, function() {
            A(d, f);
        }) && (p[m] = a, x(c, a));
    }
    function y(d) {
        var f = Math.min(Math.max(m + d, 0), p.length - 1), c = $91da240b76094466$export$e19cd5f9376f8cee.Pop, a = p[f];
        k(c, a, function() {
            y(d);
        }) && (m = f, x(c, a));
    }
    void 0 === b && (b = {});
    var w = b;
    b = w.initialEntries;
    w = w.initialIndex;
    var p = (void 0 === b ? [
        "/"
    ] : b).map(function(d) {
        var f = $91da240b76094466$var$C((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            pathname: "/",
            search: "",
            hash: "",
            state: null,
            key: $91da240b76094466$var$H()
        }, "string" === typeof d ? $91da240b76094466$export$8ccf933b0513f8d0(d) : d));
        return f;
    }), m = Math.min(Math.max(null == w ? p.length - 1 : w, 0), p.length - 1), u = $91da240b76094466$export$e19cd5f9376f8cee.Pop, t = p[m], v = $91da240b76094466$var$F(), q = $91da240b76094466$var$F();
    return {
        get index () {
            return m;
        },
        get action () {
            return u;
        },
        get location () {
            return t;
        },
        createHref: function(d) {
            return "string" === typeof d ? d : $91da240b76094466$export$fe53371bee54353d(d);
        },
        push: z,
        replace: A,
        go: y,
        back: function() {
            y(-1);
        },
        forward: function() {
            y(1);
        },
        listen: function(d) {
            return v.push(d);
        },
        block: function(d) {
            return q.push(d);
        }
    };
}


function $6de75bb8982f6eaa$var$invariant(cond, message) {
    if (!cond) throw new Error(message);
}
function $6de75bb8982f6eaa$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
const $6de75bb8982f6eaa$var$alreadyWarned = {};
function $6de75bb8982f6eaa$var$warningOnce(key, cond, message) {
    if (!cond && !$6de75bb8982f6eaa$var$alreadyWarned[key]) $6de75bb8982f6eaa$var$alreadyWarned[key] = true;
} ///////////////////////////////////////////////////////////////////////////////
// CONTEXT
///////////////////////////////////////////////////////////////////////////////
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6de75bb8982f6eaa$export$26749e8557646306 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $6de75bb8982f6eaa$export$c7914228fb69b0f5 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $6de75bb8982f6eaa$export$9072aa6dd1f93057 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    outlet: null,
    matches: []
});
// COMPONENTS
///////////////////////////////////////////////////////////////////////////////
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/docs/en/v6/api#memoryrouter
 */ function $6de75bb8982f6eaa$export$ae46f04cfaffe093(_ref) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref;
    let historyRef = (0, $7fPBF.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $91da240b76094466$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex
    });
    let history = historyRef.current;
    let [state, setState] = (0, $7fPBF.useState)({
        action: history.action,
        location: history.location
    });
    (0, $7fPBF.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $7fPBF.createElement)($6de75bb8982f6eaa$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/docs/en/v6/api#navigate
 */ function $6de75bb8982f6eaa$export$444b3ab0cb9aec40(_ref2) {
    let { to: to, replace: replace, state: state } = _ref2;
    !$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    let navigate = $6de75bb8982f6eaa$export$9770f232ac06a008();
    (0, $7fPBF.useEffect)(()=>{
        navigate(to, {
            replace: replace,
            state: state
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/docs/en/v6/api#outlet
 */ function $6de75bb8982f6eaa$export$910ae8079b2c2852(_props) {
    return $6de75bb8982f6eaa$export$a3be3530d8e40d0b();
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#route
 */ function $6de75bb8982f6eaa$export$e7b0ac011bb776c6(_props) {
    $6de75bb8982f6eaa$var$invariant(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/docs/en/v6/api#router
 */ function $6de75bb8982f6eaa$export$55185c17a0fcbe46(_ref3) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $91da240b76094466$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref3;
    !!$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    let basename = $6de75bb8982f6eaa$var$normalizePathname(basenameProp);
    let navigationContext = (0, $7fPBF.useMemo)(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $91da240b76094466$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = (0, $7fPBF.useMemo)(()=>{
        let trailingPathname = $6de75bb8982f6eaa$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ (0, $7fPBF.createElement)($6de75bb8982f6eaa$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ (0, $7fPBF.createElement)($6de75bb8982f6eaa$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#routes
 */ function $6de75bb8982f6eaa$export$3565eb3d00ca5a74(_ref4) {
    let { children: children, location: location } = _ref4;
    return $6de75bb8982f6eaa$export$5d3fca4a98652595($6de75bb8982f6eaa$export$16da398f5434bdec(children), location);
} ///////////////////////////////////////////////////////////////////////////////
// HOOKS
///////////////////////////////////////////////////////////////////////////////
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usehref
 */ function $6de75bb8982f6eaa$export$b66bb29c5006f12f(to) {
    !$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    let { basename: basename, navigator: navigator } = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6de75bb8982f6eaa$export$e75d2a2d1b3c245b(to);
    let joinedPathname = pathname;
    if (basename !== "/") {
        let toPathname = $6de75bb8982f6eaa$var$getToPathname(to);
        let endsWithSlash = toPathname != null && toPathname.endsWith("/");
        joinedPathname = pathname === "/" ? basename + (endsWithSlash ? "/" : "") : $6de75bb8982f6eaa$var$joinPaths([
            basename,
            pathname
        ]);
    }
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useinroutercontext
 */ function $6de75bb8982f6eaa$export$9c954a9d03d32f4a() {
    return (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/docs/en/v6/api#uselocation
 */ function $6de75bb8982f6eaa$export$45d76561a5302f2b() {
    !$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    return (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigationtype
 */ function $6de75bb8982f6eaa$export$1b3f31771c5d07c() {
    return (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns true if the URL for the given "to" value matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usematch
 */ function $6de75bb8982f6eaa$export$6c330e8992e8a295(pattern) {
    !$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    return $6de75bb8982f6eaa$export$81336c211d5ff295(pattern, $6de75bb8982f6eaa$export$45d76561a5302f2b().pathname);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigate
 */ function $6de75bb8982f6eaa$export$9770f232ac06a008() {
    !$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    let { basename: basename, navigator: navigator } = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$26749e8557646306);
    let { matches: matches } = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6de75bb8982f6eaa$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    let activeRef = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(()=>{
        activeRef.current = true;
    });
    let navigate = (0, $7fPBF.useCallback)(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $6de75bb8982f6eaa$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname);
        if (basename !== "/") path.pathname = $6de75bb8982f6eaa$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useoutlet
 */ function $6de75bb8982f6eaa$export$a3be3530d8e40d0b() {
    return (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$9072aa6dd1f93057).outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useparams
 */ function $6de75bb8982f6eaa$export$99eaa27ddbbb95ef() {
    let { matches: matches } = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useresolvedpath
 */ function $6de75bb8982f6eaa$export$e75d2a2d1b3c245b(to) {
    let { matches: matches } = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6de75bb8982f6eaa$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    return (0, $7fPBF.useMemo)(()=>$6de75bb8982f6eaa$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname), [
        to,
        routePathnamesJson,
        locationPathname
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useroutes
 */ function $6de75bb8982f6eaa$export$5d3fca4a98652595(routes, locationArg) {
    !$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    let { matches: parentMatches } = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6de75bb8982f6eaa$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $91da240b76094466$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && $6de75bb8982f6eaa$var$invariant(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = $6de75bb8982f6eaa$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    return $6de75bb8982f6eaa$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $6de75bb8982f6eaa$var$joinPaths([
                parentPathnameBase,
                match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $6de75bb8982f6eaa$var$joinPaths([
                parentPathnameBase,
                match.pathnameBase
            ])
        })), parentMatches);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/docs/en/v6/api#createroutesfromchildren
 */ function $6de75bb8982f6eaa$export$16da398f5434bdec(children) {
    let routes = [];
    (0, $7fPBF.Children).forEach(children, (element)=>{
        if (!/*#__PURE__*/ (0, $7fPBF.isValidElement)(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === (0, $7fPBF.Fragment)) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6de75bb8982f6eaa$export$16da398f5434bdec(element.props.children));
            return;
        }
        !(element.type === $6de75bb8982f6eaa$export$e7b0ac011bb776c6) && $6de75bb8982f6eaa$var$invariant(false);
        let route = {
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path
        };
        if (element.props.children) route.children = $6de75bb8982f6eaa$export$16da398f5434bdec(element.props.children);
        routes.push(route);
    });
    return routes;
}
/**
 * The parameters that were parsed from the URL path.
 */ /**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/docs/en/v6/api#generatepath
 */ function $6de75bb8982f6eaa$export$82476f982757e71e(path, params) {
    if (params === void 0) params = {};
    return path.replace(/:(\w+)/g, (_, key)=>{
        !(params[key] != null) && $6de75bb8982f6eaa$var$invariant(false);
        return params[key];
    }).replace(/\/*\*$/, (_)=>params["*"] == null ? "" : params["*"].replace(/^\/*/, "/"));
}
/**
 * A RouteMatch contains info about how a route matched a URL.
 */ /**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchroutes
 */ function $6de75bb8982f6eaa$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? (0, $91da240b76094466$export$8ccf933b0513f8d0)(locationArg) : locationArg;
    let pathname = $6de75bb8982f6eaa$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $6de75bb8982f6eaa$var$flattenRoutes(routes);
    $6de75bb8982f6eaa$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $6de75bb8982f6eaa$var$matchRouteBranch(branches[i], routes, pathname);
    return matches;
}
function $6de75bb8982f6eaa$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    routes.forEach((route, index)=>{
        let meta = {
            relativePath: route.path || "",
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index
        };
        if (meta.relativePath.startsWith("/")) {
            !meta.relativePath.startsWith(parentPath) && $6de75bb8982f6eaa$var$invariant(false);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $6de75bb8982f6eaa$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            !(route.index !== true) && $6de75bb8982f6eaa$var$invariant(false);
            $6de75bb8982f6eaa$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $6de75bb8982f6eaa$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $6de75bb8982f6eaa$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $6de75bb8982f6eaa$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $6de75bb8982f6eaa$var$paramRe = /^:\w+$/;
const $6de75bb8982f6eaa$var$dynamicSegmentValue = 3;
const $6de75bb8982f6eaa$var$indexRouteValue = 2;
const $6de75bb8982f6eaa$var$emptySegmentValue = 1;
const $6de75bb8982f6eaa$var$staticSegmentValue = 10;
const $6de75bb8982f6eaa$var$splatPenalty = -2;
const $6de75bb8982f6eaa$var$isSplat = (s)=>s === "*";
function $6de75bb8982f6eaa$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($6de75bb8982f6eaa$var$isSplat)) initialScore += $6de75bb8982f6eaa$var$splatPenalty;
    if (index) initialScore += $6de75bb8982f6eaa$var$indexRouteValue;
    return segments.filter((s)=>!$6de75bb8982f6eaa$var$isSplat(s)).reduce((score, segment)=>score + ($6de75bb8982f6eaa$var$paramRe.test(segment) ? $6de75bb8982f6eaa$var$dynamicSegmentValue : segment === "" ? $6de75bb8982f6eaa$var$emptySegmentValue : $6de75bb8982f6eaa$var$staticSegmentValue), initialScore);
}
function $6de75bb8982f6eaa$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $6de75bb8982f6eaa$var$matchRouteBranch(branch, routesArg, pathname) {
    let routes = routesArg;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $6de75bb8982f6eaa$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = routes[meta.childrenIndex];
        matches.push({
            params: matchedParams,
            pathname: $6de75bb8982f6eaa$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $6de75bb8982f6eaa$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ]),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $6de75bb8982f6eaa$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
        routes = route.children;
    }
    return matches;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6de75bb8982f6eaa$export$daf73786167a7f72(matches) {
    return $6de75bb8982f6eaa$var$_renderMatches(matches);
}
function $6de75bb8982f6eaa$var$_renderMatches(matches, parentMatches) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) return null;
    return matches.reduceRight((outlet, match, index)=>{
        return /*#__PURE__*/ (0, $7fPBF.createElement)($6de75bb8982f6eaa$export$9072aa6dd1f93057.Provider, {
            children: match.route.element !== undefined ? match.route.element : /*#__PURE__*/ (0, $7fPBF.createElement)($6de75bb8982f6eaa$export$910ae8079b2c2852, null),
            value: {
                outlet: outlet,
                matches: parentMatches.concat(matches.slice(0, index + 1))
            }
        });
    }, null);
}
/**
 * A PathPattern is used to match on some portion of a URL pathname.
 */ /**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchpath
 */ function $6de75bb8982f6eaa$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $6de75bb8982f6eaa$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $6de75bb8982f6eaa$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $6de75bb8982f6eaa$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else regexpSource += end ? "\\/*$" // When matching to the end, ignore trailing slashes
     : // routes to matching only their own words and nothing more, e.g. parent
    // route "/home" should not match "/home2".
    "(?:\\b|$)";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $6de75bb8982f6eaa$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/docs/en/v6/api#resolvepath
 */ function $6de75bb8982f6eaa$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $91da240b76094466$export$8ccf933b0513f8d0)(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $6de75bb8982f6eaa$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $6de75bb8982f6eaa$var$normalizeSearch(search),
        hash: $6de75bb8982f6eaa$var$normalizeHash(hash)
    };
}
function $6de75bb8982f6eaa$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $6de75bb8982f6eaa$var$resolveTo(toArg, routePathnames, locationPathname) {
    let to = typeof toArg === "string" ? (0, $91da240b76094466$export$8ccf933b0513f8d0)(toArg) : toArg;
    let toPathname = toArg === "" || to.pathname === "" ? "/" : to.pathname; // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $6de75bb8982f6eaa$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original to value had one.
    if (toPathname && toPathname !== "/" && toPathname.endsWith("/") && !path.pathname.endsWith("/")) path.pathname += "/";
    return path;
}
function $6de75bb8982f6eaa$var$getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? (0, $91da240b76094466$export$8ccf933b0513f8d0)(to).pathname : to.pathname;
}
function $6de75bb8982f6eaa$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let nextChar = pathname.charAt(basename.length);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(basename.length) || "/";
}
const $6de75bb8982f6eaa$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
const $6de75bb8982f6eaa$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
const $6de75bb8982f6eaa$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $6de75bb8982f6eaa$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash; ///////////////////////////////////////////////////////////////////////////////


/**
 * React Router DOM v6.0.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");


function $1a29469ea96a6022$var$_extends() {
    $1a29469ea96a6022$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a29469ea96a6022$var$_extends.apply(this, arguments);
}
function $1a29469ea96a6022$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $1a29469ea96a6022$var$_excluded = [
    "onClick",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to"
], $1a29469ea96a6022$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to"
];
function $1a29469ea96a6022$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} ////////////////////////////////////////////////////////////////////////////////
// COMPONENTS
////////////////////////////////////////////////////////////////////////////////
/**
 * A <Router> for use in web browsers. Provides the cleanest URLs.
 */ function $1a29469ea96a6022$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window } = _ref;
    let historyRef = (0, $7fPBF.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $91da240b76094466$export$719fc203c4e16dee)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $7fPBF.useState)({
        action: history.action,
        location: history.location
    });
    (0, $7fPBF.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $7fPBF.createElement)((0, $6de75bb8982f6eaa$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A <Router> for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $1a29469ea96a6022$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window } = _ref2;
    let historyRef = (0, $7fPBF.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $91da240b76094466$export$b71fdd3798280242)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $7fPBF.useState)({
        action: history.action,
        location: history.location
    });
    (0, $7fPBF.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $7fPBF.createElement)((0, $6de75bb8982f6eaa$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $1a29469ea96a6022$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */ const $1a29469ea96a6022$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function LinkWithRef(_ref3, ref) {
    let { onClick: onClick, reloadDocument: reloadDocument, replace: replace = false, state: state, target: target, to: to } = _ref3, rest = $1a29469ea96a6022$var$_objectWithoutPropertiesLoose(_ref3, $1a29469ea96a6022$var$_excluded);
    let href = (0, $6de75bb8982f6eaa$export$b66bb29c5006f12f)(to);
    let internalOnClick = $1a29469ea96a6022$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented && !reloadDocument) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    (0, $7fPBF.createElement)("a", $1a29469ea96a6022$var$_extends({}, rest, {
        href: href,
        onClick: handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $1a29469ea96a6022$export$b0d92dbee9b5b60d = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function NavLinkWithRef(_ref4, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to } = _ref4, rest = $1a29469ea96a6022$var$_objectWithoutPropertiesLoose(_ref4, $1a29469ea96a6022$var$_excluded2);
    let location = (0, $6de75bb8982f6eaa$export$45d76561a5302f2b)();
    let path = (0, $6de75bb8982f6eaa$export$e75d2a2d1b3c245b)(to);
    let locationPathname = location.pathname;
    let toPathname = path.pathname;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive
    }) : styleProp;
    return /*#__PURE__*/ (0, $7fPBF.createElement)($1a29469ea96a6022$export$a6c7ac8248d6e38a, $1a29469ea96a6022$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }));
});
// HOOKS
////////////////////////////////////////////////////////////////////////////////
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $1a29469ea96a6022$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    let location = (0, $6de75bb8982f6eaa$export$45d76561a5302f2b)();
    let path = (0, $6de75bb8982f6eaa$export$e75d2a2d1b3c245b)(to);
    return (0, $7fPBF.useCallback)((event)=>{
        if (event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
        !$1a29469ea96a6022$var$isModifiedEvent(event) // Ignore clicks with modifier keys
        ) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here.
            let replace = !!replaceProp || (0, $91da240b76094466$export$fe53371bee54353d)(location) === (0, $91da240b76094466$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $1a29469ea96a6022$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = (0, $7fPBF.useRef)($1a29469ea96a6022$export$a2e4e2dcc7b1f22f(defaultInit));
    let location = (0, $6de75bb8982f6eaa$export$45d76561a5302f2b)();
    let searchParams = (0, $7fPBF.useMemo)(()=>{
        let searchParams = $1a29469ea96a6022$export$a2e4e2dcc7b1f22f(location.search);
        for (let key of defaultSearchParamsRef.current.keys())if (!searchParams.has(key)) defaultSearchParamsRef.current.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
        return searchParams;
    }, [
        location.search
    ]);
    let navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    let setSearchParams = (0, $7fPBF.useCallback)((nextInit, navigateOptions)=>{
        navigate("?" + $1a29469ea96a6022$export$a2e4e2dcc7b1f22f(nextInit), navigateOptions);
    }, [
        navigate
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $1a29469ea96a6022$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}



var $c6ba0193c6fadd6f$exports = {};

$c6ba0193c6fadd6f$exports = (parcelRequire("a04va"));


var $7f6f67fb8f6e889a$exports = {};






$7f6f67fb8f6e889a$exports = {
    decode: (parcelRequire("asDSe")),
    verify: (parcelRequire("7RGJO")),
    sign: (parcelRequire("6Grea")),
    JsonWebTokenError: (parcelRequire("ifPfG")),
    NotBeforeError: (parcelRequire("63AiW")),
    TokenExpiredError: (parcelRequire("bB7TK"))
};


class $b299c3de35dcaad6$export$2e2bcd8739ae039 {
    static getInstance() {
        if (!this.instance) this.instance = new $b299c3de35dcaad6$export$2e2bcd8739ae039();
        return this.instance;
    }
    // Methods
    getRefreshToken() {
        return localStorage.getItem("refreshToken");
    }
    hasRefreshToken() {
        return this.getRefreshToken() != null;
    }
    setRefreshToken(newToken) {
        if (newToken === null) return localStorage.removeItem("refreshToken");
        localStorage.setItem("refreshToken", newToken);
    }
    getAccessToken() {
        return this.accessToken || null;
    }
    setAccessToken(newToken) {
        this.accessToken = newToken === null ? undefined : newToken;
    }
    isTokenExpired(token) {
        if (token === null) return true;
        const payload = (0, (/*@__PURE__*/$parcel$interopDefault($7f6f67fb8f6e889a$exports))).decode(token);
        var _payload_exp;
        return typeof payload !== 'object' || ((_payload_exp = payload === null || payload === void 0 ? void 0 : payload.exp) !== null && _payload_exp !== void 0 ? _payload_exp : 0) < Date.now() / 1000;
    }
    constructor(){}
}


var $45c7c1b07e176ae0$export$43de73c489c61e6b = /*#__PURE__*/ function(NetworkEndpoint) {
    NetworkEndpoint["STAFF_LOGIN"] = "/auth/staff/email/sign-in";
    NetworkEndpoint["STAFF_USE_REFRESH_TOKEN"] = "/auth/staff/refresh-token";
    NetworkEndpoint["STAFF_RESET_PASSWORD"] = "/auth/staff/email/reset-password";
    NetworkEndpoint["STAFF_REQUEST_RESET_PASSWORD"] = "/auth/staff/email/request-reset-password";
    return NetworkEndpoint;
}({});
class $45c7c1b07e176ae0$export$2e2bcd8739ae039 {
    static async performRequest(request, consumeRefreshToken, useRefreshTokenIfNeeded = true) {
        return this.performRequestAt("https://api.saltplatform.com", request, consumeRefreshToken, useRefreshTokenIfNeeded);
    }
    static async performRequestAt(baseURL, request, consumeRefreshToken, useRefreshTokenIfNeeded = true) {
        try {
            if (request.endpoint !== "/auth/staff/refresh-token" && request.endpoint !== "/auth/staff/email/sign-in" && request.endpoint !== "/auth/staff/email/reset-password" && request.endpoint !== "/auth/staff/email/request-reset-password") {
                const tokenProvider = (0, $b299c3de35dcaad6$export$2e2bcd8739ae039).getInstance();
                let accessToken = tokenProvider.getAccessToken();
                if (accessToken !== null) {
                    if (tokenProvider.isTokenExpired(accessToken)) {
                        const success = useRefreshTokenIfNeeded ? await consumeRefreshToken() : false;
                        if (!success) throw new Error("Invalid session. Please login again.");
                        accessToken = tokenProvider.getAccessToken();
                    }
                    request.headers["Authorization"] = `Bearer ${accessToken}`;
                }
            }
            const result = await (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports)))({
                method: request.method,
                url: baseURL + request.endpoint,
                data: request.body || {},
                headers: request.headers
            });
            return {
                body: result.data
            };
        } catch (error) {
            var _error_response, _error_response_data, _error_response1;
            if (request.endpoint !== "/auth/staff/email/sign-in" && request.endpoint !== "/auth/staff/refresh-token" && useRefreshTokenIfNeeded && ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 403) {
                const success = await consumeRefreshToken();
                if (success) // Re-run request now
                return await this.performRequest(request, consumeRefreshToken, false);
            }
            let errorMessage = "Something went wrong. Please try again later.";
            if (error.hasOwnProperty('response') && error.response !== undefined && error.response.hasOwnProperty('data')) {
                const { data: data } = error.response;
                if (data.hasOwnProperty('error')) errorMessage = data.error;
                else if (data.hasOwnProperty('errorMessage')) errorMessage = data.errorMessage;
            }
            return {
                error: errorMessage,
                extra: error === null || error === void 0 ? void 0 : (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : (_error_response_data = _error_response1.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.extra
            };
        }
    }
    static async performSignedPost(instructions, data, mimeType) {
        const formData = new FormData();
        for(const field in instructions.fields)formData.append(field, instructions.fields[field]);
        // This must be last! Thanks AWS D:
        formData.append("file", data);
        try {
            const result = await (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).post(instructions.url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return result.status >= 200 && result.status <= 299;
        } catch (error) {
            console.log(error.response);
            return false;
        }
    }
}
class $45c7c1b07e176ae0$export$3df08bb5d0f8b499 {
    constructor(method, endpoint, body, headers){
        this.headers = headers || {};
        this.method = method;
        this.endpoint = endpoint;
        this.body = body;
    }
}
var $45c7c1b07e176ae0$export$f03a741ee867f39c = /*#__PURE__*/ function(HTTPMethod) {
    HTTPMethod["GET"] = "get";
    HTTPMethod["POST"] = "post";
    HTTPMethod["PATCH"] = "patch";
    HTTPMethod["PUT"] = "put";
    HTTPMethod["DELETE"] = "delete";
    return HTTPMethod;
}({});


var $490c7b02975ed1ea$export$d636315ee2b4886d = /*#__PURE__*/ function(SupportedChurchVideoService) {
    SupportedChurchVideoService["YOUTUBE"] = "YOUTUBE";
    SupportedChurchVideoService["FACEBOOK"] = "FACEBOOK";
    return SupportedChurchVideoService;
}({});
var $490c7b02975ed1ea$export$3e2a2388f3561d5 = /*#__PURE__*/ function(StaffRole) {
    StaffRole["ADMIN"] = "Admin";
    StaffRole["CHECK_IN_MANAGER"] = "Check-In Manager";
    StaffRole["CHECK_IN_VIEWER"] = "Check-In Viewer";
    StaffRole["MINISTRY_MANAGER"] = "Ministry Manager";
    StaffRole["VIDEO_MANAGER"] = "Video Manager";
    StaffRole["DEVO_MANAGER"] = "Devo Manager";
    StaffRole["LIBRARY_MANAGER"] = "Library Manager";
    return StaffRole;
}({});
const $490c7b02975ed1ea$export$613954afd987de13 = [
    "Admin",
    "Check-In Manager",
    "Check-In Viewer",
    "Ministry Manager"
];
var $490c7b02975ed1ea$export$dd9f17662886326 = /*#__PURE__*/ function(StaffAction) {
    StaffAction[StaffAction["VIEW_CHECK_IN_STATS"] = 0] = "VIEW_CHECK_IN_STATS";
    StaffAction[StaffAction["MANAGE_CHECK_IN_REGIONS"] = 1] = "MANAGE_CHECK_IN_REGIONS";
    StaffAction[StaffAction["DELETE_STAFF_USER"] = 2] = "DELETE_STAFF_USER";
    StaffAction[StaffAction["CREATE_STAFF_USER"] = 3] = "CREATE_STAFF_USER";
    StaffAction[StaffAction["EDIT_STAFF_USER"] = 4] = "EDIT_STAFF_USER";
    StaffAction[StaffAction["EDIT_CHURCH_METADATA"] = 5] = "EDIT_CHURCH_METADATA";
    StaffAction[StaffAction["UPDATE_CONNECTED_SERVICE_CREDENTIALS"] = 6] = "UPDATE_CONNECTED_SERVICE_CREDENTIALS";
    StaffAction[StaffAction["UPLOAD_VIDEO"] = 7] = "UPLOAD_VIDEO";
    StaffAction[StaffAction["EDIT_MINISTRY_DATA"] = 8] = "EDIT_MINISTRY_DATA";
    StaffAction[StaffAction["CREATE_MINISTRY_DATA"] = 9] = "CREATE_MINISTRY_DATA";
    StaffAction[StaffAction["DELETE_MINISTRY_DATA"] = 10] = "DELETE_MINISTRY_DATA";
    StaffAction[StaffAction["CREATE_DAILY_DEVOTIONAL"] = 11] = "CREATE_DAILY_DEVOTIONAL";
    StaffAction[StaffAction["CREATE_VIDEO_SERIES"] = 12] = "CREATE_VIDEO_SERIES";
    StaffAction[StaffAction["EDIT_VIDEO_SERIES"] = 13] = "EDIT_VIDEO_SERIES";
    StaffAction[StaffAction["DELETE_VIDEO_SERIES"] = 14] = "DELETE_VIDEO_SERIES";
    StaffAction[StaffAction["CREATE_VIDEO_IN_SERIES"] = 15] = "CREATE_VIDEO_IN_SERIES";
    StaffAction[StaffAction["EDIT_VIDEO_IN_SERIES"] = 16] = "EDIT_VIDEO_IN_SERIES";
    StaffAction[StaffAction["DELETE_VIDEO_IN_SERIES"] = 17] = "DELETE_VIDEO_IN_SERIES";
    StaffAction[StaffAction["CREATE_PLAYLIST"] = 18] = "CREATE_PLAYLIST";
    StaffAction[StaffAction["EDIT_PLAYLIST"] = 19] = "EDIT_PLAYLIST";
    StaffAction[StaffAction["DELETE_PLAYLIST"] = 20] = "DELETE_PLAYLIST";
    return StaffAction;
}({});
const $490c7b02975ed1ea$export$f43caee112d022e1 = {
    [0]: [
        "Admin",
        "Check-In Manager",
        "Check-In Viewer"
    ],
    [1]: [
        "Admin",
        "Check-In Manager"
    ],
    [2]: [
        "Admin"
    ],
    [4]: [
        "Admin"
    ],
    [3]: [
        "Admin"
    ],
    [5]: [
        "Admin"
    ],
    [6]: [
        "Admin"
    ],
    [7]: [
        "Video Manager",
        "Admin"
    ],
    [8]: [
        "Ministry Manager",
        "Admin"
    ],
    [9]: [
        "Ministry Manager",
        "Admin"
    ],
    [10]: [
        "Ministry Manager",
        "Admin"
    ],
    [11]: [
        "Admin",
        "Devo Manager"
    ],
    [12]: [
        "Admin",
        "Library Manager"
    ],
    [13]: [
        "Admin",
        "Library Manager"
    ],
    [14]: [
        "Admin",
        "Library Manager"
    ],
    [15]: [
        "Admin",
        "Library Manager"
    ],
    [16]: [
        "Admin",
        "Library Manager"
    ],
    [17]: [
        "Admin",
        "Library Manager"
    ],
    [18]: [
        "Admin",
        "Library Manager"
    ],
    [19]: [
        "Admin",
        "Library Manager"
    ],
    [20]: [
        "Admin",
        "Library Manager"
    ]
};



var $7fPBF = parcelRequire("7fPBF");


let $12342e602c448a3c$var$AuthContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
function $12342e602c448a3c$export$2e2bcd8739ae039({ children: children }) {
    let cachedUser;
    if (localStorage.getItem("user") !== null) cachedUser = JSON.parse(localStorage.getItem("user"));
    let [user, setUser] = (0, $7fPBF.useState)(cachedUser);
    let [churchId, setChurchId] = (0, $7fPBF.useState)(undefined);
    (0, $7fPBF.useEffect)(()=>{
        if (user === undefined) return;
        localStorage.setItem("user", JSON.stringify(user));
    }, [
        user,
        churchId
    ]);
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    let signIn = async (email, password)=>{
        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, (0, $45c7c1b07e176ae0$export$43de73c489c61e6b).STAFF_LOGIN, {
            email: email,
            password: password
        }), consumeRefreshToken);
        if (response.error !== undefined || response.body === undefined) throw new Error(response.error || "Something went wrong while communicating with Salt systems.");
        const { accessToken: accessToken, refreshToken: refreshToken, staff: staff, churchId: churchId } = response.body;
        const authTokenProvider = (0, $b299c3de35dcaad6$export$2e2bcd8739ae039).getInstance();
        authTokenProvider.setAccessToken(accessToken);
        authTokenProvider.setRefreshToken(refreshToken);
        setUser(staff);
        setChurchId(churchId);
        return staff;
    };
    let resetPassword = async (token, password)=>{
        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, (0, $45c7c1b07e176ae0$export$43de73c489c61e6b).STAFF_RESET_PASSWORD, {
            token: token,
            password: password
        }), consumeRefreshToken);
        if (response.error !== undefined || response.body === undefined) throw new Error(response.error || "Something went wrong while communicating with Salt systems.");
        return response.body.success;
    };
    let requestPasswordReset = async (email)=>{
        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, (0, $45c7c1b07e176ae0$export$43de73c489c61e6b).STAFF_REQUEST_RESET_PASSWORD, {
            email: email
        }), consumeRefreshToken);
        if (response.error !== undefined || response.body === undefined) throw new Error(response.error || "Something went wrong while communicating with Salt systems.");
        return response.body.message;
    };
    let signOut = (callback)=>{
        const authTokenProvider = (0, $b299c3de35dcaad6$export$2e2bcd8739ae039).getInstance();
        authTokenProvider.setAccessToken(null);
        authTokenProvider.setRefreshToken(null);
        setUser(undefined);
        setChurchId(undefined);
        localStorage.removeItem("user");
        callback();
    };
    let consumeRefreshToken = async ()=>{
        const authTokenProvider = (0, $b299c3de35dcaad6$export$2e2bcd8739ae039).getInstance();
        const existingRefreshToken = authTokenProvider.getRefreshToken();
        if (existingRefreshToken === null || authTokenProvider.isTokenExpired(existingRefreshToken)) {
            signOut(()=>{
                navigate("/");
            });
            return false;
        }
        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, (0, $45c7c1b07e176ae0$export$43de73c489c61e6b).STAFF_USE_REFRESH_TOKEN, {
            refreshToken: existingRefreshToken
        }), async ()=>{
            return false;
        }, false);
        if (response.error || !response.body) {
            signOut(()=>{
                navigate("/");
            });
            return false;
        }
        const { user: user, churchId: churchId, accessToken: accessToken, refreshToken: refreshToken } = response.body;
        authTokenProvider.setAccessToken(accessToken);
        authTokenProvider.setRefreshToken(refreshToken);
        setUser(user);
        setChurchId(churchId);
        return true;
    };
    let hasPermission = (permission)=>{
        if (user === undefined) return false;
        const validRoles = (0, $490c7b02975ed1ea$export$f43caee112d022e1)[permission];
        return validRoles.filter((validRole)=>{
            return user === null || user === void 0 ? void 0 : user.roles.includes(validRole);
        }).length > 0;
    };
    let value = {
        user: user,
        signIn: signIn,
        signOut: signOut,
        resetPassword: resetPassword,
        requestPasswordReset: requestPasswordReset,
        churchId: churchId,
        consumeRefreshToken: consumeRefreshToken,
        hasPermission: hasPermission
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($12342e602c448a3c$var$AuthContext.Provider, {
        value: value,
        children: children
    });
}
function $12342e602c448a3c$export$1d39dc5b47e56ff0() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($12342e602c448a3c$var$AuthContext);
}






function $f1b5de3ad0a0b51c$export$2e2bcd8739ae039() {
    let auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    let location = (0, $6de75bb8982f6eaa$export$45d76561a5302f2b)();
    if ((0, $b299c3de35dcaad6$export$2e2bcd8739ae039).getInstance().getAccessToken() == null && (0, $b299c3de35dcaad6$export$2e2bcd8739ae039).getInstance().getRefreshToken() != null) {
        auth.consumeRefreshToken();
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$910ae8079b2c2852), {});
    }
    if (!auth.user) // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$444b3ab0cb9aec40), {
        to: "/login",
        state: {
            from: location
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$910ae8079b2c2852), {});
}





var $7fPBF = parcelRequire("7fPBF");


var $7a214a4d04f41b8d$export$ca1f2f1c178e9c72 = /*#__PURE__*/ function(ExternalVendor) {
    ExternalVendor["PLANNING_CENTER"] = "PLANNING_CENTER";
    ExternalVendor["SMART_WAIVER"] = "SMART_WAIVER";
    return ExternalVendor;
}({});
class $7a214a4d04f41b8d$export$2e2bcd8739ae039 {
    static async fetchConnectionStatus(churchID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/connections/${churchID}`), auth.consumeRefreshToken);
    }
    static async fetchConfigureConnectionURLForProvider(churchID, provider, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/connections/${churchID}/${provider}/setup`), auth.consumeRefreshToken);
    }
    static async saveAPIKeyForProvider(churchID, provider, apiKey, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/connections/${churchID}/${provider}/save/api-key`, {
            apiKey: apiKey
        }), auth.consumeRefreshToken);
    }
}
$7a214a4d04f41b8d$export$2e2bcd8739ae039.baseURL = "https://events-api.saltplatform.com";




let $516c6e0c0adbc42f$var$ChurchDataContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
function $516c6e0c0adbc42f$export$2e2bcd8739ae039({ children: children }) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    let [church, setChurch] = (0, $7fPBF.useState)(undefined);
    let [regions, setRegions] = (0, $7fPBF.useState)([]);
    let [staff, setStaff] = (0, $7fPBF.useState)([]);
    let [checkInReports, setCheckInReports] = (0, $7fPBF.useState)([]);
    let [totalCheckIns, setTotalCheckIns] = (0, $7fPBF.useState)(0);
    let [connectionsMetadata, setConnectionsMetadata] = (0, $7fPBF.useState)(undefined);
    let [ministryData, setMinistryData] = (0, $7fPBF.useState)([]);
    let [connectionStatus, setConnectionStatus] = (0, $7fPBF.useState)(null);
    const reloadCurrentWeekCheckInData = (0, $7fPBF.useCallback)(async (churchId)=>{
        if (!auth.hasPermission((0, $490c7b02975ed1ea$export$dd9f17662886326).VIEW_CHECK_IN_STATS)) return;
        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchId}/check-in/stats`), auth.consumeRefreshToken);
        if (response.error || !response.body) return console.error(response.error);
        setCheckInReports(response.body.results);
    }, [
        auth
    ]);
    const reloadChurch = (0, $7fPBF.useCallback)(async (churchId)=>{
        if (!auth.user) return;
        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchId}?includeStaff=true&includeConnectionMetadata=true`), auth.consumeRefreshToken);
        if (response.error || !response.body) return auth.signOut(()=>{
            navigate("/");
        });
        const { church: church, staff: staff, regions: regions, connectionsMetadata: connectionsMetadata } = response.body;
        setChurch(church);
        setStaff(staff === undefined ? [] : staff);
        setRegions(regions);
        setConnectionsMetadata(connectionsMetadata);
        // also refresh connection status
        try {
            const resp = await (0, $7a214a4d04f41b8d$export$2e2bcd8739ae039).fetchConnectionStatus(churchId, auth);
            if (!resp.error && resp.body) setConnectionStatus(resp.body.statuses);
        } catch (err) {
            console.error('Failed to load connection status', err);
        }
    // reloadCurrentWeekCheckInData(churchId);
    }, [
        auth,
        navigate
    ]);
    const loadMinistryData = (0, $7fPBF.useCallback)(async ()=>{
        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${church === null || church === void 0 ? void 0 : church.id}/ministry-data`), auth.consumeRefreshToken);
        var _response_error;
        if (response.error || !response.body) throw new Error((_response_error = response.error) !== null && _response_error !== void 0 ? _response_error : "Failed to load service plans. Please try again later.");
        const data = response.body.results;
        setMinistryData(data);
        return data;
    }, [
        auth.consumeRefreshToken,
        church === null || church === void 0 ? void 0 : church.id
    ]);
    const reloadConnectionStatus = (0, $7fPBF.useCallback)(async ()=>{
        if (!auth.churchId) return;
        try {
            const resp = await (0, $7a214a4d04f41b8d$export$2e2bcd8739ae039).fetchConnectionStatus(auth.churchId, auth);
            if (!resp.error && resp.body) setConnectionStatus(resp.body.statuses);
        } catch (err) {
            console.error('Failed to load connection status', err);
        }
    }, [
        auth
    ]);
    const clear = ()=>{
        setChurch(undefined);
        setRegions([]);
        setStaff([]);
        setCheckInReports([]);
        setConnectionsMetadata(undefined);
        setMinistryData([]);
        setConnectionStatus(null);
    };
    // Modify data when user changes
    (0, $7fPBF.useEffect)(()=>{
        if (auth.user !== undefined && auth.churchId !== undefined) reloadChurch(auth.churchId);
        else clear();
    }, [
        auth.user,
        reloadChurch,
        auth.churchId
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setTotalCheckIns(checkInReports.map((report)=>report.count).reduce((one, two)=>{
            return one + two;
        }, 0));
    }, [
        checkInReports
    ]);
    let value = {
        church: church,
        regions: regions,
        staff: staff,
        checkInReports: checkInReports,
        totalCheckIns: totalCheckIns,
        connectionsMetadata: connectionsMetadata,
        connectionStatus: connectionStatus,
        reloadConnectionStatus: reloadConnectionStatus,
        reloadChurch: ()=>{
            if (!auth.user || !auth.churchId) return;
            reloadChurch(auth.churchId);
        },
        reloadCurrentWeekCheckInData: reloadCurrentWeekCheckInData,
        loadMinistryData: loadMinistryData,
        ministryData: ministryData,
        clear: clear
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($516c6e0c0adbc42f$var$ChurchDataContext.Provider, {
        value: value,
        children: children
    });
}
function $516c6e0c0adbc42f$export$2f841eb01d18b05e() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($516c6e0c0adbc42f$var$ChurchDataContext);
}




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");


var $7857575a213426db$exports = {};
"use strict";
Object.defineProperty($7857575a213426db$exports, "__esModule", {
    value: true
});
var $01d836b69da8407b$exports = {};
"use strict";
Object.defineProperty($01d836b69da8407b$exports, "__esModule", {
    value: true
});
$01d836b69da8407b$exports.bodyOpenClassName = $01d836b69da8407b$exports.portalClassName = undefined;
var $01d836b69da8407b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $01d836b69da8407b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");
var $01d836b69da8407b$var$_react2 = $01d836b69da8407b$var$_interopRequireDefault($7fPBF);

var $fw0lo = parcelRequire("fw0lo");
var $01d836b69da8407b$var$_reactDom2 = $01d836b69da8407b$var$_interopRequireDefault($fw0lo);

var $2oXYc = parcelRequire("2oXYc");
var $01d836b69da8407b$var$_propTypes2 = $01d836b69da8407b$var$_interopRequireDefault($2oXYc);
var $b5b678a3df90cd43$exports = {};
"use strict";
Object.defineProperty($b5b678a3df90cd43$exports, "__esModule", {
    value: true
});
var $b5b678a3df90cd43$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b5b678a3df90cd43$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $b5b678a3df90cd43$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $b5b678a3df90cd43$var$_propTypes2 = $b5b678a3df90cd43$var$_interopRequireDefault($2oXYc);
var $bdd76cd1d420fe67$exports = {};
"use strict";
Object.defineProperty($bdd76cd1d420fe67$exports, "__esModule", {
    value: true
});
$bdd76cd1d420fe67$exports.resetState = $bdd76cd1d420fe67$var$resetState;
$bdd76cd1d420fe67$exports.log = $bdd76cd1d420fe67$var$log;
$bdd76cd1d420fe67$exports.handleBlur = $bdd76cd1d420fe67$var$handleBlur;
$bdd76cd1d420fe67$exports.handleFocus = $bdd76cd1d420fe67$var$handleFocus;
$bdd76cd1d420fe67$exports.markForFocusLater = $bdd76cd1d420fe67$var$markForFocusLater;
$bdd76cd1d420fe67$exports.returnFocus = $bdd76cd1d420fe67$var$returnFocus;
$bdd76cd1d420fe67$exports.popWithoutFocus = $bdd76cd1d420fe67$var$popWithoutFocus;
$bdd76cd1d420fe67$exports.setupScopedFocus = $bdd76cd1d420fe67$var$setupScopedFocus;
$bdd76cd1d420fe67$exports.teardownScopedFocus = $bdd76cd1d420fe67$var$teardownScopedFocus;
var $7db76db89ad06fec$exports = {};
"use strict";
Object.defineProperty($7db76db89ad06fec$exports, "__esModule", {
    value: true
});
$7db76db89ad06fec$exports.default = $7db76db89ad06fec$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $7db76db89ad06fec$var$tabbableNode = /input|select|textarea|button|object/;
function $7db76db89ad06fec$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        return zeroSize ? style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
        element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $7db76db89ad06fec$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($7db76db89ad06fec$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $7db76db89ad06fec$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $7db76db89ad06fec$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $7db76db89ad06fec$var$visible(element);
}
function $7db76db89ad06fec$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $7db76db89ad06fec$var$focusable(element, !isTabIndexNaN);
}
function $7db76db89ad06fec$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $7db76db89ad06fec$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($7db76db89ad06fec$var$tabbable);
}
$7db76db89ad06fec$exports = $7db76db89ad06fec$exports["default"];


var $bdd76cd1d420fe67$var$_tabbable2 = $bdd76cd1d420fe67$var$_interopRequireDefault($7db76db89ad06fec$exports);
function $bdd76cd1d420fe67$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bdd76cd1d420fe67$var$focusLaterElements = [];
var $bdd76cd1d420fe67$var$modalElement = null;
var $bdd76cd1d420fe67$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $bdd76cd1d420fe67$var$resetState() {
    $bdd76cd1d420fe67$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $bdd76cd1d420fe67$var$log() {}
/* eslint-enable no-console */ function $bdd76cd1d420fe67$var$handleBlur() {
    $bdd76cd1d420fe67$var$needToFocus = true;
}
function $bdd76cd1d420fe67$var$handleFocus() {
    if ($bdd76cd1d420fe67$var$needToFocus) {
        $bdd76cd1d420fe67$var$needToFocus = false;
        if (!$bdd76cd1d420fe67$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($bdd76cd1d420fe67$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $bdd76cd1d420fe67$var$_tabbable2.default)($bdd76cd1d420fe67$var$modalElement)[0] || $bdd76cd1d420fe67$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $bdd76cd1d420fe67$var$markForFocusLater() {
    $bdd76cd1d420fe67$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $bdd76cd1d420fe67$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($bdd76cd1d420fe67$var$focusLaterElements.length !== 0) {
            toFocus = $bdd76cd1d420fe67$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $bdd76cd1d420fe67$var$popWithoutFocus() {
    $bdd76cd1d420fe67$var$focusLaterElements.length > 0 && $bdd76cd1d420fe67$var$focusLaterElements.pop();
}
function $bdd76cd1d420fe67$var$setupScopedFocus(element) {
    $bdd76cd1d420fe67$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $bdd76cd1d420fe67$var$handleBlur, false);
        document.addEventListener("focus", $bdd76cd1d420fe67$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $bdd76cd1d420fe67$var$handleBlur);
        document.attachEvent("onFocus", $bdd76cd1d420fe67$var$handleFocus);
    }
}
function $bdd76cd1d420fe67$var$teardownScopedFocus() {
    $bdd76cd1d420fe67$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $bdd76cd1d420fe67$var$handleBlur);
        document.removeEventListener("focus", $bdd76cd1d420fe67$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $bdd76cd1d420fe67$var$handleBlur);
        document.detachEvent("onFocus", $bdd76cd1d420fe67$var$handleFocus);
    }
}


var $b5b678a3df90cd43$var$focusManager = $b5b678a3df90cd43$var$_interopRequireWildcard($bdd76cd1d420fe67$exports);
var $6af62020494a2c19$exports = {};
"use strict";
Object.defineProperty($6af62020494a2c19$exports, "__esModule", {
    value: true
});
$6af62020494a2c19$exports.default = $6af62020494a2c19$var$scopeTab;

var $6af62020494a2c19$var$_tabbable2 = $6af62020494a2c19$var$_interopRequireDefault($7db76db89ad06fec$exports);
function $6af62020494a2c19$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6af62020494a2c19$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $6af62020494a2c19$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $6af62020494a2c19$var$scopeTab(node, event) {
    var tabbable = (0, $6af62020494a2c19$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $6af62020494a2c19$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
$6af62020494a2c19$exports = $6af62020494a2c19$exports["default"];


var $b5b678a3df90cd43$var$_scopeTab2 = $b5b678a3df90cd43$var$_interopRequireDefault($6af62020494a2c19$exports);
var $037a42a7720a4af2$exports = {};
"use strict";
Object.defineProperty($037a42a7720a4af2$exports, "__esModule", {
    value: true
});
$037a42a7720a4af2$exports.resetState = $037a42a7720a4af2$var$resetState;
$037a42a7720a4af2$exports.log = $037a42a7720a4af2$var$log;
$037a42a7720a4af2$exports.assertNodeList = $037a42a7720a4af2$var$assertNodeList;
$037a42a7720a4af2$exports.setElement = $037a42a7720a4af2$var$setElement;
$037a42a7720a4af2$exports.validateElement = $037a42a7720a4af2$var$validateElement;
$037a42a7720a4af2$exports.hide = $037a42a7720a4af2$var$hide;
$037a42a7720a4af2$exports.show = $037a42a7720a4af2$var$show;
$037a42a7720a4af2$exports.documentNotReadyOrSSRTesting = $037a42a7720a4af2$var$documentNotReadyOrSSRTesting;

var $6Buvl = parcelRequire("6Buvl");
var $037a42a7720a4af2$var$_warning2 = $037a42a7720a4af2$var$_interopRequireDefault($6Buvl);
var $af300acd1d5fd7ac$exports = {};
"use strict";
Object.defineProperty($af300acd1d5fd7ac$exports, "__esModule", {
    value: true
});
$af300acd1d5fd7ac$exports.canUseDOM = $af300acd1d5fd7ac$exports.SafeNodeList = $af300acd1d5fd7ac$exports.SafeHTMLCollection = undefined;
var $913ab7e52a911d58$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if ($913ab7e52a911d58$exports) $913ab7e52a911d58$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $af300acd1d5fd7ac$var$_exenv2 = $af300acd1d5fd7ac$var$_interopRequireDefault($913ab7e52a911d58$exports);
function $af300acd1d5fd7ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $af300acd1d5fd7ac$var$EE = $af300acd1d5fd7ac$var$_exenv2.default;
var $af300acd1d5fd7ac$var$SafeHTMLElement = $af300acd1d5fd7ac$var$EE.canUseDOM ? window.HTMLElement : {};
var $af300acd1d5fd7ac$var$SafeHTMLCollection = $af300acd1d5fd7ac$exports.SafeHTMLCollection = $af300acd1d5fd7ac$var$EE.canUseDOM ? window.HTMLCollection : {};
var $af300acd1d5fd7ac$var$SafeNodeList = $af300acd1d5fd7ac$exports.SafeNodeList = $af300acd1d5fd7ac$var$EE.canUseDOM ? window.NodeList : {};
var $af300acd1d5fd7ac$var$canUseDOM = $af300acd1d5fd7ac$exports.canUseDOM = $af300acd1d5fd7ac$var$EE.canUseDOM;
$af300acd1d5fd7ac$exports.default = $af300acd1d5fd7ac$var$SafeHTMLElement;


function $037a42a7720a4af2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $037a42a7720a4af2$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $037a42a7720a4af2$var$resetState() {
    if ($037a42a7720a4af2$var$globalElement) {
        if ($037a42a7720a4af2$var$globalElement.removeAttribute) $037a42a7720a4af2$var$globalElement.removeAttribute("aria-hidden");
        else if ($037a42a7720a4af2$var$globalElement.length != null) $037a42a7720a4af2$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($037a42a7720a4af2$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $037a42a7720a4af2$var$globalElement = null;
}
/* istanbul ignore next */ function $037a42a7720a4af2$var$log() {
    var check;
}
/* eslint-enable no-console */ function $037a42a7720a4af2$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $037a42a7720a4af2$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $af300acd1d5fd7ac$exports.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $037a42a7720a4af2$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $037a42a7720a4af2$var$globalElement = useElement || $037a42a7720a4af2$var$globalElement;
    return $037a42a7720a4af2$var$globalElement;
}
function $037a42a7720a4af2$var$validateElement(appElement) {
    var el = appElement || $037a42a7720a4af2$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $037a42a7720a4af2$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $037a42a7720a4af2$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $037a42a7720a4af2$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $037a42a7720a4af2$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $037a42a7720a4af2$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $037a42a7720a4af2$var$documentNotReadyOrSSRTesting() {
    $037a42a7720a4af2$var$globalElement = null;
}


var $b5b678a3df90cd43$var$ariaAppHider = $b5b678a3df90cd43$var$_interopRequireWildcard($037a42a7720a4af2$exports);
var $52182e4d88153cf9$exports = {};
"use strict";
Object.defineProperty($52182e4d88153cf9$exports, "__esModule", {
    value: true
});
$52182e4d88153cf9$exports.resetState = $52182e4d88153cf9$var$resetState;
$52182e4d88153cf9$exports.log = $52182e4d88153cf9$var$log;
var $52182e4d88153cf9$var$htmlClassList = {};
var $52182e4d88153cf9$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $52182e4d88153cf9$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $52182e4d88153cf9$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $52182e4d88153cf9$var$htmlClassList)$52182e4d88153cf9$var$removeClass(htmlElement, $52182e4d88153cf9$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $52182e4d88153cf9$var$docBodyClassList)$52182e4d88153cf9$var$removeClass(body, $52182e4d88153cf9$var$docBodyClassList[_cls]);
    $52182e4d88153cf9$var$htmlClassList = {};
    $52182e4d88153cf9$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $52182e4d88153cf9$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $52182e4d88153cf9$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $52182e4d88153cf9$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $52182e4d88153cf9$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $52182e4d88153cf9$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $52182e4d88153cf9$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $52182e4d88153cf9$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $52182e4d88153cf9$var$add = $52182e4d88153cf9$exports.add = function add(element, classString) {
    return $52182e4d88153cf9$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $52182e4d88153cf9$var$htmlClassList : $52182e4d88153cf9$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $52182e4d88153cf9$var$remove = $52182e4d88153cf9$exports.remove = function remove(element, classString) {
    return $52182e4d88153cf9$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $52182e4d88153cf9$var$htmlClassList : $52182e4d88153cf9$var$docBodyClassList, classString.split(" "));
};


var $b5b678a3df90cd43$var$classList = $b5b678a3df90cd43$var$_interopRequireWildcard($52182e4d88153cf9$exports);

var $b5b678a3df90cd43$var$_safeHTMLElement2 = $b5b678a3df90cd43$var$_interopRequireDefault($af300acd1d5fd7ac$exports);
var $6e0d329bb9e22275$exports = {};
"use strict";
Object.defineProperty($6e0d329bb9e22275$exports, "__esModule", {
    value: true
});
$6e0d329bb9e22275$exports.log = $6e0d329bb9e22275$var$log;
$6e0d329bb9e22275$exports.resetState = $6e0d329bb9e22275$var$resetState;
function $6e0d329bb9e22275$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $6e0d329bb9e22275$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $6e0d329bb9e22275$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $6e0d329bb9e22275$var$portalOpenInstances = new $6e0d329bb9e22275$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $6e0d329bb9e22275$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($6e0d329bb9e22275$var$portalOpenInstances.openInstances.length);
    $6e0d329bb9e22275$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $6e0d329bb9e22275$var$resetState() {
    $6e0d329bb9e22275$var$portalOpenInstances = new $6e0d329bb9e22275$var$PortalOpenInstances();
}
/* eslint-enable no-console */ $6e0d329bb9e22275$exports.default = $6e0d329bb9e22275$var$portalOpenInstances;


var $b5b678a3df90cd43$var$_portalOpenInstances2 = $b5b678a3df90cd43$var$_interopRequireDefault($6e0d329bb9e22275$exports);
var $f3e26d1d9b6811c1$exports = {};
"use strict";
Object.defineProperty($f3e26d1d9b6811c1$exports, "__esModule", {
    value: true
});
$f3e26d1d9b6811c1$exports.resetState = $f3e26d1d9b6811c1$var$resetState;
$f3e26d1d9b6811c1$exports.log = $f3e26d1d9b6811c1$var$log;

var $f3e26d1d9b6811c1$var$_portalOpenInstances2 = $f3e26d1d9b6811c1$var$_interopRequireDefault($6e0d329bb9e22275$exports);
function $f3e26d1d9b6811c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $f3e26d1d9b6811c1$var$before = void 0, $f3e26d1d9b6811c1$var$after = void 0, $f3e26d1d9b6811c1$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $f3e26d1d9b6811c1$var$resetState() {
    var _arr = [
        $f3e26d1d9b6811c1$var$before,
        $f3e26d1d9b6811c1$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $f3e26d1d9b6811c1$var$before = $f3e26d1d9b6811c1$var$after = null;
    $f3e26d1d9b6811c1$var$instances = [];
}
/* istanbul ignore next */ function $f3e26d1d9b6811c1$var$log() {
    console.log("bodyTrap ----------");
    console.log($f3e26d1d9b6811c1$var$instances.length);
    var _arr2 = [
        $f3e26d1d9b6811c1$var$before,
        $f3e26d1d9b6811c1$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $f3e26d1d9b6811c1$var$focusContent() {
    if ($f3e26d1d9b6811c1$var$instances.length === 0) return;
    $f3e26d1d9b6811c1$var$instances[$f3e26d1d9b6811c1$var$instances.length - 1].focusContent();
}
function $f3e26d1d9b6811c1$var$bodyTrap(eventType, openInstances) {
    if (!$f3e26d1d9b6811c1$var$before && !$f3e26d1d9b6811c1$var$after) {
        $f3e26d1d9b6811c1$var$before = document.createElement("div");
        $f3e26d1d9b6811c1$var$before.setAttribute("data-react-modal-body-trap", "");
        $f3e26d1d9b6811c1$var$before.style.position = "absolute";
        $f3e26d1d9b6811c1$var$before.style.opacity = "0";
        $f3e26d1d9b6811c1$var$before.setAttribute("tabindex", "0");
        $f3e26d1d9b6811c1$var$before.addEventListener("focus", $f3e26d1d9b6811c1$var$focusContent);
        $f3e26d1d9b6811c1$var$after = $f3e26d1d9b6811c1$var$before.cloneNode();
        $f3e26d1d9b6811c1$var$after.addEventListener("focus", $f3e26d1d9b6811c1$var$focusContent);
    }
    $f3e26d1d9b6811c1$var$instances = openInstances;
    if ($f3e26d1d9b6811c1$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $f3e26d1d9b6811c1$var$before) document.body.insertBefore($f3e26d1d9b6811c1$var$before, document.body.firstChild);
        if (document.body.lastChild !== $f3e26d1d9b6811c1$var$after) document.body.appendChild($f3e26d1d9b6811c1$var$after);
    } else {
        // Remove focus trap
        if ($f3e26d1d9b6811c1$var$before.parentElement) $f3e26d1d9b6811c1$var$before.parentElement.removeChild($f3e26d1d9b6811c1$var$before);
        if ($f3e26d1d9b6811c1$var$after.parentElement) $f3e26d1d9b6811c1$var$after.parentElement.removeChild($f3e26d1d9b6811c1$var$after);
    }
}
$f3e26d1d9b6811c1$var$_portalOpenInstances2.default.subscribe($f3e26d1d9b6811c1$var$bodyTrap);


function $b5b678a3df90cd43$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $b5b678a3df90cd43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b5b678a3df90cd43$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b5b678a3df90cd43$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b5b678a3df90cd43$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $b5b678a3df90cd43$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
var $b5b678a3df90cd43$var$TAB_KEY = 9;
var $b5b678a3df90cd43$var$ESC_KEY = 27;
var $b5b678a3df90cd43$var$ariaHiddenInstances = 0;
var $b5b678a3df90cd43$var$ModalPortal = function(_Component) {
    $b5b678a3df90cd43$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $b5b678a3df90cd43$var$_classCallCheck(this, ModalPortal);
        var _this = $b5b678a3df90cd43$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName;
            // Remove classes.
            bodyOpenClassName && $b5b678a3df90cd43$var$classList.remove(document.body, bodyOpenClassName);
            htmlOpenClassName && $b5b678a3df90cd43$var$classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $b5b678a3df90cd43$var$ariaHiddenInstances > 0) {
                $b5b678a3df90cd43$var$ariaHiddenInstances -= 1;
                if ($b5b678a3df90cd43$var$ariaHiddenInstances === 0) $b5b678a3df90cd43$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $b5b678a3df90cd43$var$focusManager.returnFocus(_this.props.preventScroll);
                    $b5b678a3df90cd43$var$focusManager.teardownScopedFocus();
                } else $b5b678a3df90cd43$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $b5b678a3df90cd43$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $b5b678a3df90cd43$var$focusManager.setupScopedFocus(_this.node);
                    $b5b678a3df90cd43$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if (event.keyCode === $b5b678a3df90cd43$var$TAB_KEY) (0, $b5b678a3df90cd43$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && event.keyCode === $b5b678a3df90cd43$var$ESC_KEY) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $b5b678a3df90cd43$var$_typeof(additional)) === "object" ? additional : {
                base: $b5b678a3df90cd43$var$CLASS_NAMES[which],
                afterOpen: $b5b678a3df90cd43$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $b5b678a3df90cd43$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $b5b678a3df90cd43$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName;
                // Add classes.
                bodyOpenClassName && $b5b678a3df90cd43$var$classList.add(document.body, bodyOpenClassName);
                htmlOpenClassName && $b5b678a3df90cd43$var$classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $b5b678a3df90cd43$var$ariaHiddenInstances += 1;
                    $b5b678a3df90cd43$var$ariaAppHider.hide(appElement);
                }
                $b5b678a3df90cd43$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $b5b678a3df90cd43$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $b5b678a3df90cd43$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $b5b678a3df90cd43$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $b5b678a3df90cd43$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($7fPBF.Component);
$b5b678a3df90cd43$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$b5b678a3df90cd43$var$ModalPortal.propTypes = {
    isOpen: $b5b678a3df90cd43$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $b5b678a3df90cd43$var$_propTypes2.default.shape({
        content: $b5b678a3df90cd43$var$_propTypes2.default.object,
        overlay: $b5b678a3df90cd43$var$_propTypes2.default.object
    }),
    style: $b5b678a3df90cd43$var$_propTypes2.default.shape({
        content: $b5b678a3df90cd43$var$_propTypes2.default.object,
        overlay: $b5b678a3df90cd43$var$_propTypes2.default.object
    }),
    className: $b5b678a3df90cd43$var$_propTypes2.default.oneOfType([
        $b5b678a3df90cd43$var$_propTypes2.default.string,
        $b5b678a3df90cd43$var$_propTypes2.default.object
    ]),
    overlayClassName: $b5b678a3df90cd43$var$_propTypes2.default.oneOfType([
        $b5b678a3df90cd43$var$_propTypes2.default.string,
        $b5b678a3df90cd43$var$_propTypes2.default.object
    ]),
    bodyOpenClassName: $b5b678a3df90cd43$var$_propTypes2.default.string,
    htmlOpenClassName: $b5b678a3df90cd43$var$_propTypes2.default.string,
    ariaHideApp: $b5b678a3df90cd43$var$_propTypes2.default.bool,
    appElement: $b5b678a3df90cd43$var$_propTypes2.default.oneOfType([
        $b5b678a3df90cd43$var$_propTypes2.default.instanceOf($b5b678a3df90cd43$var$_safeHTMLElement2.default),
        $b5b678a3df90cd43$var$_propTypes2.default.instanceOf($af300acd1d5fd7ac$exports.SafeHTMLCollection),
        $b5b678a3df90cd43$var$_propTypes2.default.instanceOf($af300acd1d5fd7ac$exports.SafeNodeList),
        $b5b678a3df90cd43$var$_propTypes2.default.arrayOf($b5b678a3df90cd43$var$_propTypes2.default.instanceOf($b5b678a3df90cd43$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $b5b678a3df90cd43$var$_propTypes2.default.func,
    onAfterClose: $b5b678a3df90cd43$var$_propTypes2.default.func,
    onRequestClose: $b5b678a3df90cd43$var$_propTypes2.default.func,
    closeTimeoutMS: $b5b678a3df90cd43$var$_propTypes2.default.number,
    shouldFocusAfterRender: $b5b678a3df90cd43$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $b5b678a3df90cd43$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $b5b678a3df90cd43$var$_propTypes2.default.bool,
    preventScroll: $b5b678a3df90cd43$var$_propTypes2.default.bool,
    role: $b5b678a3df90cd43$var$_propTypes2.default.string,
    contentLabel: $b5b678a3df90cd43$var$_propTypes2.default.string,
    aria: $b5b678a3df90cd43$var$_propTypes2.default.object,
    data: $b5b678a3df90cd43$var$_propTypes2.default.object,
    children: $b5b678a3df90cd43$var$_propTypes2.default.node,
    shouldCloseOnEsc: $b5b678a3df90cd43$var$_propTypes2.default.bool,
    overlayRef: $b5b678a3df90cd43$var$_propTypes2.default.func,
    contentRef: $b5b678a3df90cd43$var$_propTypes2.default.func,
    id: $b5b678a3df90cd43$var$_propTypes2.default.string,
    overlayElement: $b5b678a3df90cd43$var$_propTypes2.default.func,
    contentElement: $b5b678a3df90cd43$var$_propTypes2.default.func,
    testId: $b5b678a3df90cd43$var$_propTypes2.default.string
};
$b5b678a3df90cd43$exports.default = $b5b678a3df90cd43$var$ModalPortal;
$b5b678a3df90cd43$exports = $b5b678a3df90cd43$exports["default"];


var $01d836b69da8407b$var$_ModalPortal2 = $01d836b69da8407b$var$_interopRequireDefault($b5b678a3df90cd43$exports);

var $01d836b69da8407b$var$ariaAppHider = $01d836b69da8407b$var$_interopRequireWildcard($037a42a7720a4af2$exports);

var $01d836b69da8407b$var$_safeHTMLElement2 = $01d836b69da8407b$var$_interopRequireDefault($af300acd1d5fd7ac$exports);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $bd136de90080c1b8$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $bd136de90080c1b8$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $bd136de90080c1b8$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$bd136de90080c1b8$var$componentWillMount.__suppressDeprecationWarning = true;
$bd136de90080c1b8$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$bd136de90080c1b8$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $bd136de90080c1b8$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $bd136de90080c1b8$var$componentWillMount;
        prototype.componentWillReceiveProps = $bd136de90080c1b8$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $bd136de90080c1b8$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


function $01d836b69da8407b$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $01d836b69da8407b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $01d836b69da8407b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $01d836b69da8407b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $01d836b69da8407b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $01d836b69da8407b$var$portalClassName = $01d836b69da8407b$exports.portalClassName = "ReactModalPortal";
var $01d836b69da8407b$var$bodyOpenClassName = $01d836b69da8407b$exports.bodyOpenClassName = "ReactModal__Body--open";
var $01d836b69da8407b$var$isReact16 = $af300acd1d5fd7ac$exports.canUseDOM && $01d836b69da8407b$var$_reactDom2.default.createPortal !== undefined;
var $01d836b69da8407b$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $01d836b69da8407b$var$getCreatePortal = function getCreatePortal() {
    return $01d836b69da8407b$var$isReact16 ? $01d836b69da8407b$var$_reactDom2.default.createPortal : $01d836b69da8407b$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $01d836b69da8407b$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $01d836b69da8407b$var$Modal = function(_Component) {
    $01d836b69da8407b$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $01d836b69da8407b$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $01d836b69da8407b$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$01d836b69da8407b$var$isReact16 && $01d836b69da8407b$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $01d836b69da8407b$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $01d836b69da8407b$var$getCreatePortal();
            var portal = createPortal(_this, $01d836b69da8407b$var$_react2.default.createElement($01d836b69da8407b$var$_ModalPortal2.default, $01d836b69da8407b$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $01d836b69da8407b$var$_possibleConstructorReturn(_this, _ret);
    }
    $01d836b69da8407b$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$af300acd1d5fd7ac$exports.canUseDOM) return;
                if (!$01d836b69da8407b$var$isReact16) this.node = $01d836b69da8407b$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $01d836b69da8407b$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$01d836b69da8407b$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $01d836b69da8407b$var$getParentElement(prevProps.parentSelector);
                var nextParent = $01d836b69da8407b$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$af300acd1d5fd7ac$exports.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$01d836b69da8407b$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$af300acd1d5fd7ac$exports.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$af300acd1d5fd7ac$exports.canUseDOM || !$01d836b69da8407b$var$isReact16) return null;
                if (!this.node && $01d836b69da8407b$var$isReact16) this.node = $01d836b69da8407b$var$createHTMLElement("div");
                var createPortal = $01d836b69da8407b$var$getCreatePortal();
                return createPortal($01d836b69da8407b$var$_react2.default.createElement($01d836b69da8407b$var$_ModalPortal2.default, $01d836b69da8407b$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $01d836b69da8407b$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($7fPBF.Component);
$01d836b69da8407b$var$Modal.propTypes = {
    isOpen: $01d836b69da8407b$var$_propTypes2.default.bool.isRequired,
    style: $01d836b69da8407b$var$_propTypes2.default.shape({
        content: $01d836b69da8407b$var$_propTypes2.default.object,
        overlay: $01d836b69da8407b$var$_propTypes2.default.object
    }),
    portalClassName: $01d836b69da8407b$var$_propTypes2.default.string,
    bodyOpenClassName: $01d836b69da8407b$var$_propTypes2.default.string,
    htmlOpenClassName: $01d836b69da8407b$var$_propTypes2.default.string,
    className: $01d836b69da8407b$var$_propTypes2.default.oneOfType([
        $01d836b69da8407b$var$_propTypes2.default.string,
        $01d836b69da8407b$var$_propTypes2.default.shape({
            base: $01d836b69da8407b$var$_propTypes2.default.string.isRequired,
            afterOpen: $01d836b69da8407b$var$_propTypes2.default.string.isRequired,
            beforeClose: $01d836b69da8407b$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $01d836b69da8407b$var$_propTypes2.default.oneOfType([
        $01d836b69da8407b$var$_propTypes2.default.string,
        $01d836b69da8407b$var$_propTypes2.default.shape({
            base: $01d836b69da8407b$var$_propTypes2.default.string.isRequired,
            afterOpen: $01d836b69da8407b$var$_propTypes2.default.string.isRequired,
            beforeClose: $01d836b69da8407b$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $01d836b69da8407b$var$_propTypes2.default.oneOfType([
        $01d836b69da8407b$var$_propTypes2.default.instanceOf($01d836b69da8407b$var$_safeHTMLElement2.default),
        $01d836b69da8407b$var$_propTypes2.default.instanceOf($af300acd1d5fd7ac$exports.SafeHTMLCollection),
        $01d836b69da8407b$var$_propTypes2.default.instanceOf($af300acd1d5fd7ac$exports.SafeNodeList),
        $01d836b69da8407b$var$_propTypes2.default.arrayOf($01d836b69da8407b$var$_propTypes2.default.instanceOf($01d836b69da8407b$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $01d836b69da8407b$var$_propTypes2.default.func,
    onRequestClose: $01d836b69da8407b$var$_propTypes2.default.func,
    closeTimeoutMS: $01d836b69da8407b$var$_propTypes2.default.number,
    ariaHideApp: $01d836b69da8407b$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $01d836b69da8407b$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $01d836b69da8407b$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $01d836b69da8407b$var$_propTypes2.default.bool,
    preventScroll: $01d836b69da8407b$var$_propTypes2.default.bool,
    parentSelector: $01d836b69da8407b$var$_propTypes2.default.func,
    aria: $01d836b69da8407b$var$_propTypes2.default.object,
    data: $01d836b69da8407b$var$_propTypes2.default.object,
    role: $01d836b69da8407b$var$_propTypes2.default.string,
    contentLabel: $01d836b69da8407b$var$_propTypes2.default.string,
    shouldCloseOnEsc: $01d836b69da8407b$var$_propTypes2.default.bool,
    overlayRef: $01d836b69da8407b$var$_propTypes2.default.func,
    contentRef: $01d836b69da8407b$var$_propTypes2.default.func,
    id: $01d836b69da8407b$var$_propTypes2.default.string,
    overlayElement: $01d836b69da8407b$var$_propTypes2.default.func,
    contentElement: $01d836b69da8407b$var$_propTypes2.default.func
};
$01d836b69da8407b$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $01d836b69da8407b$var$portalClassName,
    bodyOpenClassName: $01d836b69da8407b$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $01d836b69da8407b$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $01d836b69da8407b$var$_react2.default.createElement("div", props, children);
    }
};
$01d836b69da8407b$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $bd136de90080c1b8$export$cea1c58a6db52bca)($01d836b69da8407b$var$Modal);
$01d836b69da8407b$exports.default = $01d836b69da8407b$var$Modal;


var $7857575a213426db$var$_Modal2 = $7857575a213426db$var$_interopRequireDefault($01d836b69da8407b$exports);
function $7857575a213426db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$7857575a213426db$exports.default = $7857575a213426db$var$_Modal2.default;
$7857575a213426db$exports = $7857575a213426db$exports["default"];


var $63d64463cd01676b$export$46c1ead11549edea = /*#__PURE__*/ function(ModalButtonStyle) {
    ModalButtonStyle["FILLED"] = "filled";
    ModalButtonStyle["OUTLINE"] = "outline";
    return ModalButtonStyle;
}({});
function $63d64463cd01676b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7857575a213426db$exports))), {
        isOpen: props.isOpen,
        id: props.id,
        closeTimeoutMS: 200,
        className: "modal",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "content-holder",
            children: [
                props.headerTitle !== undefined ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "header",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        children: props.headerTitle
                    })
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "modal-content",
                    children: props.children
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("footer", {
                    style: props.footerButtons.length === 1 ? {
                        gridTemplateColumns: '1fr'
                    } : {},
                    children: props.footerButtons.map((button)=>{
                        var _button_enabled;
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: `button-${button.style} ${!((_button_enabled = button.enabled) !== null && _button_enabled !== void 0 ? _button_enabled : true) ? 'disabled' : ''}`,
                            onClick: (e)=>{
                                e.preventDefault();
                                if (button.enabled !== undefined && !button.enabled) return;
                                button.onClick();
                            },
                            children: button.title
                        }, button.title);
                    })
                })
            ]
        })
    });
}







function $27b68b5c97f312c6$export$2e2bcd8739ae039(props) {
    var _props_user, _props_user1, _props_user2;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchData = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const [name, setName] = (0, $7fPBF.useState)(((_props_user = props.user) === null || _props_user === void 0 ? void 0 : _props_user.name) || "");
    const [email, setEmail] = (0, $7fPBF.useState)(((_props_user1 = props.user) === null || _props_user1 === void 0 ? void 0 : _props_user1.email) || "");
    const [roles, setRoles] = (0, $7fPBF.useState)(((_props_user2 = props.user) === null || _props_user2 === void 0 ? void 0 : _props_user2.roles) || []);
    const [isSaving, setSaving] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (props.isOpen && props.user !== undefined) {
            setName(props.user.name);
            setEmail(props.user.email);
            setRoles(props.user.roles);
        }
        if (!props.isOpen) setTimeout(()=>{
            setName("");
            setEmail("");
            setRoles([]);
        }, 200);
    }, [
        props.isOpen,
        props.user
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "team-member-modal",
        isOpen: props.isOpen,
        headerTitle: props.user === undefined ? "New Team Member" : `Edit ${props.user.name}`,
        footerButtons: [
            {
                title: props.user === undefined ? "Invite Team Member" : "Save Changes",
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !isSaving,
                onClick: async ()=>{
                    setSaving(true);
                    try {
                        var _churchData_church, _churchData_church1;
                        // make request to create or update user
                        const payload = {
                            email: email,
                            name: name,
                            roles: roles.map((role)=>role.toString())
                        };
                        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(props.user === undefined ? new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/church/${(_churchData_church = churchData.church) === null || _churchData_church === void 0 ? void 0 : _churchData_church.id}/staff`, payload) : new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/church/${(_churchData_church1 = churchData.church) === null || _churchData_church1 === void 0 ? void 0 : _churchData_church1.id}/staff/${props.user.id}`, payload), auth.consumeRefreshToken);
                        if (response.body !== undefined) props.setIsOpen(false);
                        else console.error(response.error);
                    } catch (error) {
                        console.error(error);
                    }
                    setSaving(false);
                }
            },
            {
                title: "Cancel",
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                onClick: ()=>{
                    props.setIsOpen(false);
                }
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "info-holder",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "name",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    type: "text",
                                    name: "name",
                                    value: name,
                                    onChange: (e)=>{
                                        setName(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "email",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    type: "email",
                                    name: "email",
                                    value: email,
                                    onChange: (e)=>{
                                        setEmail(e.target.value);
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "separator"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    children: "Roles"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "roles-holder",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "checkboxes",
                        children: (0, $490c7b02975ed1ea$export$613954afd987de13).map((role, i)=>{
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: roles.includes(role),
                                        onChange: (e)=>{
                                            e.preventDefault();
                                            if (e.target.checked) setRoles([
                                                ...roles,
                                                role
                                            ]);
                                            else setRoles(roles.filter((role)=>role !== role));
                                            console.log(roles);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        children: role
                                    })
                                ]
                            }, role);
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "separator"
                })
            ]
        })
    });
}





function $9cd0e8a59318e171$export$2e2bcd8739ae039(props) {
    if (props.user === undefined) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "delete-team-member-modal",
        isOpen: props.isOpen,
        headerTitle: `Delete ${props.user.name} from Salt?`,
        footerButtons: [
            {
                title: `Delete ${props.user.name}`,
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                onClick: ()=>{}
            },
            {
                title: `Cancel`,
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                onClick: ()=>{
                    props.setIsOpen(false);
                }
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
            children: [
                "Are you sure you want to delete ",
                props.user.name,
                "'s Salt Church Hub account? This will prevent them from being able to access Salt Church hub."
            ]
        })
    });
}


function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $919ebf39980bf8f3$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}





var $48a08cc73bd1bdd6$exports = {};
$48a08cc73bd1bdd6$exports = $parcel$resolve("kEDyG");





var $7fPBF = parcelRequire("7fPBF");
var $f4914239429a8982$exports = {};
$f4914239429a8982$exports = $parcel$resolve("6pPtb");


var $0298034ab94cd70d$export$3ed8400b82efd319 = /*#__PURE__*/ function(DropdownItemIcon) {
    DropdownItemIcon[DropdownItemIcon["DOCUMENT"] = 0] = "DOCUMENT";
    DropdownItemIcon[DropdownItemIcon["SHARE"] = 1] = "SHARE";
    DropdownItemIcon[DropdownItemIcon["MAIL"] = 2] = "MAIL";
    return DropdownItemIcon;
}({});
const $0298034ab94cd70d$var$iconComponent = (icon)=>{
    const fill = "#F58B8B";
    switch(icon){
        case 0:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                width: "66",
                height: "83",
                viewBox: "0 0 66 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M17.7246 52.6367C16.0156 52.6367 14.7949 51.416 14.7949 49.8535C14.7949 48.2422 16.0156 47.0215 17.7246 47.0215H47.3633C49.0235 47.0215 50.293 48.2422 50.293 49.8535C50.293 51.416 49.0235 52.6367 47.3633 52.6367H17.7246ZM17.7246 67.334C16.0156 67.334 14.7949 66.1133 14.7949 64.5019C14.7949 62.9394 16.0156 61.6699 17.7246 61.6699H47.3633C49.0235 61.6699 50.293 62.9394 50.293 64.5019C50.293 66.1133 49.0235 67.334 47.3633 67.334H17.7246ZM12.2559 82.3242H52.7344C60.9375 82.3242 65.0391 78.1738 65.0391 69.873V35.9863H37.1094C31.9336 35.9863 29.4922 33.5449 29.4922 28.3691V0H12.2559C4.05278 0 0 4.1504 0 12.4512V69.873C0 78.2226 4.05278 82.3242 12.2559 82.3242ZM37.1094 30.2734H64.5996C64.3555 28.4668 63.1348 26.7578 61.084 24.6582L40.8203 3.9551C38.8184 1.9043 37.0117 0.634797 35.2051 0.341797V28.3691C35.2051 29.6387 35.8887 30.2734 37.1094 30.2734Z",
                    fill: fill
                })
            });
        case 2:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                width: "94",
                height: "67",
                viewBox: "0 0 94 67",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M46.5332 37.207C47.7539 37.207 48.9746 36.7188 50.0977 35.6934L88.5742 1.9531C86.377 0.585902 83.9844 0 80.6641 0H12.4512C9.13088 0 6.73828 0.585902 4.49218 1.9531L43.0176 35.6934C44.1406 36.7188 45.3614 37.207 46.5332 37.207ZM0.83008 59.9121L28.9551 31.7871L0.73238 7.0801C0.43948 7.7149 0 9.5703 0 12.2559V54.4434C0 56.8359 0.34178 58.5449 0.83008 59.9121ZM11.084 66.6992H82.0313C84.7656 66.6992 86.9629 66.0645 88.4278 65.0879L59.2774 35.9863L53.8574 40.8203C51.5625 42.8223 49.0235 43.8477 46.5332 43.8477C44.0918 43.8477 41.5528 42.8223 39.2578 40.8203L33.7891 35.9863L4.63868 65.0879C6.10348 66.0645 8.34958 66.6992 11.084 66.6992ZM92.2854 59.9121C92.7244 58.5449 93.1154 56.8359 93.1154 54.4434V12.2559C93.1154 9.5703 92.6754 7.7149 92.3824 7.0801L64.1602 31.7871L92.2854 59.9121Z",
                    fill: fill
                })
            });
        case 1:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                width: "88",
                height: "111",
                viewBox: "0 0 88 111",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M15.839 110.248H71.8423C82.0744 110.248 87.1603 105.141 87.1603 95.085V46.4341C87.1603 36.3679 82.0744 31.2714 71.8423 31.2714H58.2569V39.1661H71.7177C76.5001 39.1661 79.3068 41.7859 79.3068 46.8175V94.7016C79.3068 99.7849 76.5001 102.342 71.7177 102.342H15.9636C11.0873 102.342 8.3745 99.7849 8.3745 94.7016V46.8175C8.3745 41.7859 11.0873 39.1661 15.9636 39.1661H29.4455V31.2714H15.839C5.6587 31.2714 0.520996 36.3468 0.520996 46.4341V95.085C0.520996 105.162 5.6587 110.248 15.839 110.248ZM43.8148 72.0197C45.9387 72.0197 47.7415 70.2686 47.7415 68.1965V18.1006L47.4204 10.7612L50.6914 14.2497L58.0936 22.1177C58.8086 22.8844 59.8034 23.2783 60.736 23.2783C62.7871 23.2783 64.3311 21.8378 64.3311 19.8797C64.3311 18.7919 63.896 18.0357 63.1292 17.3207L46.6431 1.3933C45.6694 0.419495 44.8509 0.0878906 43.8148 0.0878906C42.8305 0.0878906 42.0014 0.419495 40.9864 1.3933L24.4898 17.3207C23.7748 18.0357 23.3396 18.7919 23.3396 19.8797C23.3396 21.8378 24.8214 23.2783 26.883 23.2783C27.8156 23.2783 28.8622 22.8844 29.5666 22.1177L36.9794 14.2497L40.2609 10.7506L39.9398 18.1006V68.1965C39.9398 70.2686 41.7426 72.0197 43.8148 72.0197Z",
                    fill: fill
                })
            });
    }
};
function $0298034ab94cd70d$export$2e2bcd8739ae039(props) {
    const menuRef = (0, $7fPBF.useRef)(null);
    const [isDropdownVisible, setDropdownVisible] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setDropdownVisible(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "menu",
        ref: menuRef,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                onClick: (e)=>{
                    e.stopPropagation();
                    setDropdownVisible(!isDropdownVisible);
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f4914239429a8982$exports))),
                    alt: "Menu"
                })
            }),
            isDropdownVisible && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "dropdown-menu",
                children: [
                    props.title && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "title",
                        children: props.title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                        children: props.items.map((item, idx)=>{
                            const icon = $0298034ab94cd70d$var$iconComponent(item.icon);
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
                                children: [
                                    idx !== 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "divider"
                                    }) : null,
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            item.onClick();
                                            setDropdownVisible(false);
                                        },
                                        children: [
                                            icon,
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: item.title
                                            })
                                        ]
                                    })
                                ]
                            }, item.title);
                        })
                    })
                ]
            })
        ]
    });
}


function $7f236beed1e911ce$export$2e2bcd8739ae039(props) {
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "page-header",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "content",
                children: [
                    props.showBackButton === undefined || props.showBackButton === true ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                        className: "back",
                        href: "#back",
                        onClick: ()=>{
                            var _props_backLocation;
                            return navigate((_props_backLocation = props.backLocation) !== null && _props_backLocation !== void 0 ? _props_backLocation : "/");
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($48a08cc73bd1bdd6$exports))),
                                alt: "Left arrow icon"
                            }),
                            " Back"
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        className: "header-title",
                        children: props.title
                    }),
                    props.subtitle !== undefined ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: "header-subtitle",
                        children: props.subtitle
                    }) : null,
                    props.links !== undefined ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "header-links",
                        children: props.links.map((link)=>{
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                href: link.title,
                                onClick: (e)=>{
                                    e.preventDefault();
                                    link.onClick();
                                },
                                children: [
                                    link.icon !== undefined ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        src: link.icon,
                                        alt: `${link.title} icon`
                                    }) : null,
                                    link.title
                                ]
                            }, link.title);
                        })
                    }) : null
                ]
            }),
            props.dropdown && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0298034ab94cd70d$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props.dropdown))
        ]
    });
}



var $5c981babe04388d0$exports = {};
$5c981babe04388d0$exports = $parcel$resolve("63aom");


var $a9cdc003ba228dda$exports = {};
$a9cdc003ba228dda$exports = $parcel$resolve("5eOiC");


var $f382a5c80f18c5e3$exports = {};
$f382a5c80f18c5e3$exports = $parcel$resolve("f7jIs");



function $09e93e778c8a89c9$export$2e2bcd8739ae039(props) {
    const [showingMemberModal, setShowingMemberModal] = (0, $7fPBF.useState)(false);
    const [showDeleteMemberModal, setShowDeleteMemberModal] = (0, $7fPBF.useState)(false);
    const [selectedUser, setSelectedUser] = (0, $7fPBF.useState)(undefined);
    const churchData = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const churchDataRef = (0, $7fPBF.useRef)(churchData);
    (0, $7fPBF.useEffect)(()=>{
        churchDataRef.current.reloadChurch();
    }, [
        churchDataRef
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "team-manager",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: "Staff Management",
                showBackButton: false,
                links: [
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5c981babe04388d0$exports))),
                        title: "Add Staff Member",
                        onClick: ()=>{
                            setShowingMemberModal(true);
                        }
                    }
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mobile-warning",
                children: "We recommend using a larger device for Staff Management."
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27b68b5c97f312c6$export$2e2bcd8739ae039), {
                isOpen: showingMemberModal,
                setIsOpen: (isOpen)=>{
                    setShowingMemberModal(isOpen);
                    if (!isOpen) setTimeout(()=>{
                        setSelectedUser(undefined);
                    }, 200);
                },
                user: selectedUser
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9cd0e8a59318e171$export$2e2bcd8739ae039), {
                user: selectedUser,
                isOpen: showDeleteMemberModal,
                setIsOpen: (isOpen)=>{
                    setShowDeleteMemberModal(isOpen);
                    if (!isOpen) setTimeout(()=>{
                        setSelectedUser(undefined);
                    }, 200);
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "card-holder",
                children: churchData.staff.sort((one, two)=>{
                    return one.name < two.name ? -1 : 1;
                }).map((user)=>{
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($09e93e778c8a89c9$var$StaffCard, {
                        user: user,
                        onEditClicked: ()=>{
                            setSelectedUser(user);
                            setShowingMemberModal(true);
                        },
                        onDeleteClicked: ()=>{
                            setSelectedUser(user);
                            setShowDeleteMemberModal(true);
                        }
                    }, user.id);
                })
            })
        ]
    });
}
function $09e93e778c8a89c9$var$StaffCard(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "card",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: props.user.name
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                href: `mailto:${props.user.email}`,
                children: props.user.email
            }),
            props.user.roles.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "No Roles."
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                children: [
                    "Roles: ",
                    props.user.roles.map((role, idx)=>{
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                            children: [
                                role,
                                idx === props.user.roles.length - 1 ? "" : ", "
                            ]
                        }, role);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "divider"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                        href: "#edit",
                        onClick: (e)=>{
                            e.preventDefault();
                            props.onEditClicked();
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a9cdc003ba228dda$exports)))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: "Edit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                        href: "#delete",
                        onClick: (e)=>{
                            e.preventDefault();
                            props.onDeleteClicked();
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f382a5c80f18c5e3$exports)))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: "Delete"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");










var $7fPBF = parcelRequire("7fPBF");

function $91421d36d4ae7fe1$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [deleting, setDeleting] = (0, $7fPBF.useState)(false);
    if (props.plan === undefined) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "delete-service-plan-modal",
        isOpen: props.isOpen,
        headerTitle: `Delete Service Plan`,
        footerButtons: [
            {
                title: `Delete`,
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !deleting,
                onClick: async ()=>{
                    setDeleting(true);
                    try {
                        var _props_plan, _props_plan1;
                        await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/church/${props.churchId}/ministry-data/${(_props_plan = props.plan) === null || _props_plan === void 0 ? void 0 : _props_plan.ministry}/${(_props_plan1 = props.plan) === null || _props_plan1 === void 0 ? void 0 : _props_plan1.id}`), auth.consumeRefreshToken);
                        alert("Deleted!");
                        props.setIsOpen(false);
                    } catch (error) {
                        alert("Failed to delete: " + error);
                    }
                    setDeleting(false);
                }
            },
            {
                title: `Cancel`,
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                enabled: !deleting,
                onClick: ()=>{
                    props.setIsOpen(false);
                }
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            children: "Are you sure you want to delete this service plan?"
        })
    });
}


function $8c98534f3985332e$export$2e2bcd8739ae039() {
    var _churchData_church;
    const churchData = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    const [attemptedLoad, setAttemptedLoad] = (0, $7fPBF.useState)(false);
    const [loadingError, setLoadingError] = (0, $7fPBF.useState)(undefined);
    const [planToDelete, setPlanToDelete] = (0, $7fPBF.useState)(undefined);
    (0, $7fPBF.useEffect)(()=>{
        if (!attemptedLoad) {
            setAttemptedLoad(true);
            churchData.loadMinistryData().catch((error)=>{
                setLoadingError(error.message);
            });
        }
    }, [
        churchData,
        attemptedLoad
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "week-data-container container",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: "Service Plans",
                showBackButton: false,
                links: [
                    {
                        title: "Create Service Plan",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5c981babe04388d0$exports))),
                        onClick: ()=>{
                            navigate("/service-plans/new");
                        }
                    }
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91421d36d4ae7fe1$export$2e2bcd8739ae039), {
                churchId: (_churchData_church = churchData.church) === null || _churchData_church === void 0 ? void 0 : _churchData_church.id,
                plan: planToDelete,
                isOpen: planToDelete !== undefined,
                setIsOpen: ()=>{
                    churchData.loadMinistryData().catch((error)=>{
                        setLoadingError(error.message);
                    });
                    setPlanToDelete(undefined);
                }
            }),
            loadingError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "error",
                children: loadingError
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "card-holder",
                children: churchData.ministryData.map((data)=>{
                    var _data_sermonMetadata;
                    var _data_subministry, _data_sermonMetadata_sermonTitle;
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: `status ${data.status.toLowerCase()}`,
                                children: data.status.charAt(0).toUpperCase() + data.status.slice(1)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: `status-bar ${data.status.toLowerCase()}`
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h3", {
                                className: "subtitle",
                                children: [
                                    data.ministry,
                                    " / ",
                                    (_data_subministry = data.subministry) !== null && _data_subministry !== void 0 ? _data_subministry : "No Subministry"
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                children: (_data_sermonMetadata_sermonTitle = (_data_sermonMetadata = data.sermonMetadata) === null || _data_sermonMetadata === void 0 ? void 0 : _data_sermonMetadata.sermonTitle) !== null && _data_sermonMetadata_sermonTitle !== void 0 ? _data_sermonMetadata_sermonTitle : "No Sermon"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    data.worshipSongs.length,
                                    " worship song",
                                    data.worshipSongs.length === 1 ? "" : "s"
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "secondary",
                                children: [
                                    "Active from ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: data.startDate
                                    }),
                                    " to ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: data.endDate
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a29469ea96a6022$export$a6c7ac8248d6e38a), {
                                        to: `/service-plans/${data.ministry}/${data.id}`,
                                        children: "Edit"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                        href: "#delete",
                                        onClick: ()=>{
                                            setPlanToDelete(data);
                                        },
                                        children: "Delete"
                                    })
                                ]
                            })
                        ]
                    }, data.id);
                })
            })
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");


var $34a899f6d421b489$exports = {};
$34a899f6d421b489$exports = $parcel$resolve("1BhH4");











var $7fPBF = parcelRequire("7fPBF");

function $a39d0220e0abc509$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [adding, setAdding] = (0, $7fPBF.useState)(false);
    const [playlistURL, setPlaylistURL] = (0, $7fPBF.useState)("");
    const [error, setError] = (0, $7fPBF.useState)(null);
    const createPlaylist = async (playlistURL)=>{
        const res = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/church/${auth.churchId}/library/worship/playlists`, {
            playlistURL: playlistURL
        }), auth.consumeRefreshToken);
        if (res.error) throw Error(res.error);
        if (res.body) {
            props.onPlaylistAdded(res.body.result);
            props.setIsOpen(false);
        } else throw Error("Failed to create playlist. Please try again later.");
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "add-playlist-modal",
        isOpen: props.isOpen,
        headerTitle: `Add Playlist`,
        footerButtons: [
            {
                title: `Add`,
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !adding && playlistURL.length > 0,
                onClick: async ()=>{
                    setAdding(true);
                    try {
                        await createPlaylist(playlistURL);
                    } catch (error) {
                        if (error instanceof Error) setError(error.message);
                        else setError("An unknown error occurred. Please try again later.");
                    }
                    setAdding(false);
                }
            },
            {
                title: `Cancel`,
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                enabled: !adding,
                onClick: ()=>{
                    props.setIsOpen(false);
                }
            }
        ],
        children: [
            error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "error",
                children: error
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "Please paste the URL of your playlist:"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                type: "text",
                placeholder: "Playlist URL",
                value: playlistURL,
                onChange: (e)=>{
                    setPlaylistURL(e.target.value);
                }
            })
        ]
    });
}







var $7fPBF = parcelRequire("7fPBF");

function $dcf26dbd3025efae$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [deleting, setAdding] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const deletePlaylist = async ()=>{
        var _props_playlist;
        const res = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/church/${auth.churchId}/library/worship/playlists/${(_props_playlist = props.playlist) === null || _props_playlist === void 0 ? void 0 : _props_playlist.id}`), auth.consumeRefreshToken);
        if (res.error) throw Error(res.error);
        if (res.body) {
            props.onPlaylistRemoved();
            props.setIsOpen(false);
        } else throw Error("Failed to delete playlist. Please try again later.");
    };
    if (props.playlist === null) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "delete-playlist-modal",
        isOpen: props.isOpen,
        headerTitle: `Delete Playlist`,
        footerButtons: [
            {
                title: `Delete`,
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !deleting,
                onClick: async ()=>{
                    setAdding(true);
                    try {
                        await deletePlaylist();
                    } catch (error) {
                        if (error instanceof Error) setError(error.message);
                        else setError("An unknown error occurred. Please try again later.");
                    }
                    setAdding(false);
                }
            },
            {
                title: `Cancel`,
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                enabled: !deleting,
                onClick: ()=>{
                    props.setIsOpen(false);
                }
            }
        ],
        children: [
            error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "error",
                children: error
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "Are you sure you'd like to delete this playlist?"
            })
        ]
    });
}


function $642e727260322576$export$2e2bcd8739ae039() {
    var _library_worshipPlaylists;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchData = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const [library, setLibrary] = (0, $7fPBF.useState)(null);
    const [isAddPlaylistModalOpen, setIsAddPlaylistModalOpen] = (0, $7fPBF.useState)(false);
    const [isDeletePlaylistModalOpen, setIsDeletePlaylistModalOpen] = (0, $7fPBF.useState)(false);
    const [playlistToDelete, setPlaylistToDelete] = (0, $7fPBF.useState)(null);
    const fetchLibrary = (0, $7fPBF.useCallback)(async ()=>{
        if (!auth.churchId) return; // haven't loaded yet
        const res = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${auth.churchId}/library/worship`), auth.consumeRefreshToken);
        if (res.body) setLibrary(res.body.result);
        else console.error(res);
    }, [
        auth.churchId,
        auth.consumeRefreshToken
    ]);
    (0, $7fPBF.useEffect)(()=>{
        fetchLibrary();
    }, [
        fetchLibrary
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "playlists",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: "Playlists",
                subtitle: "Create playlists for your church to listen to.",
                showBackButton: false,
                links: [
                    {
                        title: 'Add Playlist',
                        onClick: ()=>{
                            setIsAddPlaylistModalOpen(true);
                        },
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5c981babe04388d0$exports)))
                    }
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a39d0220e0abc509$export$2e2bcd8739ae039), {
                isOpen: isAddPlaylistModalOpen,
                setIsOpen: setIsAddPlaylistModalOpen,
                onPlaylistAdded: (playlist)=>{
                    setLibrary({
                        worshipPlaylists: [
                            ...(library === null || library === void 0 ? void 0 : library.worshipPlaylists) || [],
                            playlist
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dcf26dbd3025efae$export$2e2bcd8739ae039), {
                isOpen: isDeletePlaylistModalOpen,
                setIsOpen: setIsDeletePlaylistModalOpen,
                playlist: playlistToDelete,
                onPlaylistRemoved: ()=>{
                    if (!playlistToDelete) return;
                    setLibrary({
                        worshipPlaylists: (library === null || library === void 0 ? void 0 : library.worshipPlaylists.filter((playlist)=>playlist.id !== playlistToDelete.id)) || []
                    });
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "playlists-list",
                children: library === null || library === void 0 ? void 0 : (_library_worshipPlaylists = library.worshipPlaylists) === null || _library_worshipPlaylists === void 0 ? void 0 : _library_worshipPlaylists.sort((a, b)=>a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0).map((playlist)=>{
                    var _churchData_church;
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "playlist",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "background",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                            className: "title",
                                            children: playlist.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "options",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                href: `${"https://playlists.saltplatform.com"}/${(_churchData_church = churchData.church) === null || _churchData_church === void 0 ? void 0 : _churchData_church.id}/${playlist.id}`,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                title: "Open Playlist Link",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($34a899f6d421b489$exports))),
                                                    alt: "Share"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                onClick: async (e)=>{
                                                    e.preventDefault();
                                                    setPlaylistToDelete(playlist);
                                                    setIsDeletePlaylistModalOpen(true);
                                                },
                                                title: "Delete Playlist",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f382a5c80f18c5e3$exports))),
                                                    alt: "Delete"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($642e727260322576$var$PlaylistDetail, {
                                playlist: playlist
                            })
                        ]
                    }, playlist.id);
                })
            })
        ]
    });
}
const $642e727260322576$var$PlaylistDetail = (props)=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
        children: props.playlist.songs.map((song)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                className: "song",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: song.albumArtURL,
                        alt: song.songTitle,
                        className: "cover-art"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                children: song.songTitle
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: song.artistName
                            })
                        ]
                    })
                ]
            }, song.id))
    });
};




var $44775bf8c84ed14b$exports = {};
$44775bf8c84ed14b$exports = $parcel$resolve("96vVz");


function $0c522a61e1633b5f$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "welcome",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($44775bf8c84ed14b$exports))),
                alt: "Church Hub logo"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "\uD83D\uDC4B Welcome to Church Hub!"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "Church Hub is designed with care to be your church's toolbox."
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: "https://saltplatform.com/support",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Get Support"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: "mailto:jordan@saltplatform.com?subject=Salt%20Feature%20Request",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Request a Feature"
                    })
                ]
            })
        ]
    });
}





var $88a4dbdd97534f81$exports = {};
$88a4dbdd97534f81$exports = $parcel$resolve("hXw2B");


var $d6ed300fdf537ea3$exports = {};
$d6ed300fdf537ea3$exports = $parcel$resolve("8nLu6");


var $76492af6a51f5838$exports = {};
$76492af6a51f5838$exports = $parcel$resolve("aJ728");



var $7fPBF = parcelRequire("7fPBF");
var $5cc3ec176bbf7015$export$14faa19a0f3bbeb2 = /*#__PURE__*/ function(Theme) {
    Theme[Theme["LIGHT"] = 0] = "LIGHT";
    Theme[Theme["DARK"] = 1] = "DARK";
    return Theme;
}({});
function $5cc3ec176bbf7015$export$2e2bcd8739ae039() {
    const [mode, setMode] = (0, $7fPBF.useState)(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light");
    (0, $7fPBF.useEffect)(()=>{
        const modeMe = (e)=>{
            setMode(e.matches ? "dark" : "light");
        };
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', modeMe);
        return window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', modeMe);
    }, []);
    return mode === "light" ? 0 : 1;
}



var $7fPBF = parcelRequire("7fPBF");





function $ebf906ca24cd582c$export$2e2bcd8739ae039(props = {
    fullScreen: true
}) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: props.fullScreen === undefined || props.fullScreen === true ? "loading-indicator full-screen" : 'loading-indicator',
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "loading-spinner"
        })
    });
}



function $8b78cb05ee8c928f$export$2e2bcd8739ae039() {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const darkMode = (0, $5cc3ec176bbf7015$export$2e2bcd8739ae039)();
    const { connectionStatus: connectionStatus, reloadConnectionStatus: reloadConnectionStatus } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const [loadingConnectionInfo, setLoadingConnectionInfo] = (0, $7fPBF.useState)(false);
    const [showAPIKeyModal, setShowAPIKeyModal] = (0, $7fPBF.useState)(false);
    const [savingAPIKey, setSavingAPIKey] = (0, $7fPBF.useState)(false);
    const [apiKeyInstructions, setAPIKeyInstructions] = (0, $7fPBF.useState)(null);
    const fetchConnectionSetupInformation = async (provider)=>{
        if (!auth.churchId || loadingConnectionInfo) return;
        setLoadingConnectionInfo(true);
        try {
            const response = await (0, $7a214a4d04f41b8d$export$2e2bcd8739ae039).fetchConfigureConnectionURLForProvider(auth.churchId, provider, auth);
            if (!response.body) {
                window.alert("Failed to load configuration information for provider. Please try again later.");
                console.log(response.error);
                return;
            }
            const body = response.body;
            if (body.authMethod === 'oauth') {
                const authURL = body.authDetails.url;
                window.location.href = authURL;
            } else if (body.authMethod === 'apiKey') {
                const instructions = body.authDetails.instructions;
                setAPIKeyInstructions({
                    instructions: instructions,
                    provider: provider
                });
            }
        } finally{
            setLoadingConnectionInfo(false);
        }
    };
    const saveAPIKeyForSelectedProvider = async (apiKey)=>{
        if (!auth.churchId || !apiKeyInstructions) return;
        setSavingAPIKey(true);
        try {
            const response = await (0, $7a214a4d04f41b8d$export$2e2bcd8739ae039).saveAPIKeyForProvider(auth.churchId, apiKeyInstructions.provider, apiKey, auth);
            if (response.error) {
                window.alert(response.error);
                console.log(response.error);
            } else {
                setShowAPIKeyModal(false);
                reloadConnectionStatus();
            }
        } catch (e) {
            window.alert("Failed to save API Key. Please try again later.");
        } finally{
            setSavingAPIKey(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        // Ensure we have the latest connection status when this page mounts
        reloadConnectionStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (apiKeyInstructions !== null) setShowAPIKeyModal(true);
    }, [
        apiKeyInstructions
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!showAPIKeyModal) setTimeout(()=>{
            setAPIKeyInstructions(null);
        }, 400);
    }, [
        showAPIKeyModal
    ]);
    if (!connectionStatus) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "connections-container",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {})
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "connections-container",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: "Connections",
                showBackButton: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8b78cb05ee8c928f$var$APIKeyConnectionInstructionsModal, {
                isOpen: showAPIKeyModal,
                instructions: apiKeyInstructions,
                close: ()=>{
                    setShowAPIKeyModal(false);
                },
                save: (apiKey)=>{
                    saveAPIKeyForSelectedProvider(apiKey);
                },
                isSaving: savingAPIKey
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "cards",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8b78cb05ee8c928f$var$ConnectionCard, {
                        logo: darkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($88a4dbdd97534f81$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($d6ed300fdf537ea3$exports))),
                        description: "Connecting with Planning Center enables your church to sync Planning Center registrations with Salt Events.",
                        isConnected: connectionStatus[(0, $7a214a4d04f41b8d$export$ca1f2f1c178e9c72).PLANNING_CENTER],
                        attemptingConnection: loadingConnectionInfo,
                        connectButtonClicked: ()=>{
                            fetchConnectionSetupInformation((0, $7a214a4d04f41b8d$export$ca1f2f1c178e9c72).PLANNING_CENTER);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8b78cb05ee8c928f$var$ConnectionCard, {
                        logo: (0, (/*@__PURE__*/$parcel$interopDefault($76492af6a51f5838$exports))),
                        description: "Connecting with Smartwaiver allows completed waivers to be automatically linked to event registrations in Salt Events.",
                        isConnected: connectionStatus[(0, $7a214a4d04f41b8d$export$ca1f2f1c178e9c72).SMART_WAIVER],
                        attemptingConnection: loadingConnectionInfo,
                        connectButtonClicked: ()=>{
                            fetchConnectionSetupInformation((0, $7a214a4d04f41b8d$export$ca1f2f1c178e9c72).SMART_WAIVER);
                        }
                    })
                ]
            })
        ]
    });
}
function $8b78cb05ee8c928f$var$ConnectionCard(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "connection-card card",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "header",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: props.logo
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "description",
                children: props.description
            }),
            props.isConnected ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                className: "connected-text",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "connected-dot",
                        "aria-hidden": "true"
                    }),
                    " Connected"
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                onClick: props.connectButtonClicked,
                disabled: props.attemptingConnection,
                children: "Connect"
            })
        ]
    });
}
function $8b78cb05ee8c928f$var$APIKeyConnectionInstructionsModal(props) {
    const [apiKey, setAPIKey] = (0, $7fPBF.useState)('');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "apiKey",
        isOpen: props.isOpen,
        footerButtons: [
            {
                title: 'Cancel',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                onClick: props.close,
                enabled: !props.isSaving
            },
            {
                title: 'Save',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                onClick: ()=>{
                    props.save(apiKey);
                },
                enabled: apiKey.length > 0 && !props.isSaving
            }
        ],
        children: props.instructions ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: {
                padding: '4px 0 16px 0'
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    children: "Instructions"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    dangerouslySetInnerHTML: {
                        __html: props.instructions.instructions.replace(/\n/g, '<br />')
                    }
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                    id: "apiKey",
                    type: "text",
                    placeholder: "API Key",
                    style: {
                        width: '100%',
                        boxSizing: 'border-box',
                        height: '48px',
                        border: 'none',
                        borderRadius: '8px',
                        paddingLeft: '16px',
                        fontFamily: 'monospace'
                    },
                    value: apiKey,
                    onChange: (e)=>{
                        setAPIKey(e.target.value);
                    }
                })
            ]
        }) : null
    });
}






var $7fPBF = parcelRequire("7fPBF");



class $6857e104788587b0$export$2e2bcd8739ae039 {
    static async fetchEvents(churchID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchID}/events`), auth.consumeRefreshToken);
    }
    static async createEvent(churchID, body, auth) {
        let payload = {
            eventAttributes: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, body.event),
            planningCenterMetadata: null
        };
        if (body.planningCenterMetadata) payload.planningCenterMetadata = body.planningCenterMetadata;
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/church/${churchID}/events`, payload), auth.consumeRefreshToken);
    }
    static async fetchExternalImportOptions(churchID, provider, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchID}/events/external-import-options/${provider}`), auth.consumeRefreshToken);
    }
    static async fetchExternalEventDetails(churchID, provider, externalEventID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchID}/events/external-import-options/${provider}/${externalEventID}`), auth.consumeRefreshToken);
    }
    static async fetchEvent(churchID, eventID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchID}/events/${eventID}`), auth.consumeRefreshToken);
    }
    static async fetchAttendeesForEvent(churchID, eventID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchID}/events/${eventID}/attendees`), auth.consumeRefreshToken);
    }
    static async fetchAvailableExternalWaivers(churchID, provider, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchID}/events/available-waivers/${provider}`), auth.consumeRefreshToken);
    }
    static async attachExternalWaiverToEvent(churchID, eventID, externalWaiver, instructions, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PUT, `/church/${churchID}/events/${eventID}/waivers/external`, {
            externalWaiver: externalWaiver,
            instructions: instructions
        }), auth.consumeRefreshToken);
    }
    static async createManualWaiverForEvent(churchID, eventID, waiver, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PUT, `/church/${churchID}/events/${eventID}/waivers`, waiver), auth.consumeRefreshToken);
    }
    static async sendWaiverReminderEmails(churchID, eventID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/church/${churchID}/events/${eventID}/actions/send-waiver-reminder-emails`), auth.consumeRefreshToken);
    }
    static async submitAttendeeWaiverCompletions(churchID, eventID, waiverID, markAsComplete, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/church/${churchID}/events/${eventID}/waivers/${waiverID}/actions/mark-attendees-complete`, {
            attendees: markAsComplete.map((attendee)=>attendee.id)
        }), auth.consumeRefreshToken);
    }
}
$6857e104788587b0$export$2e2bcd8739ae039.baseURL = "https://events-api.saltplatform.com";


function $5e99117a3c3f973f$export$2e2bcd8739ae039(providedChurchId) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchId = providedChurchId || auth.churchId;
    const [events, setEvents] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchId) return;
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $6857e104788587b0$export$2e2bcd8739ae039).fetchEvents(churchId, auth);
            if (response.error) {
                setError(response.error);
                setEvents(null);
            } else if (response.body) setEvents(response.body.events);
            else setEvents(null);
        } catch (err) {
            setError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to load events');
            setEvents(null);
        } finally{
            setLoading(false);
        }
    }, [
        churchId,
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!churchId) return;
        let isMounted = true;
        const performFetch = async ()=>{
            await fetch();
            if (!isMounted) return;
        };
        performFetch();
        return ()=>{
            isMounted = false;
        };
    }, [
        churchId,
        fetch
    ]);
    return {
        events: events,
        loading: loading,
        error: error,
        refetch: fetch
    };
}





var $5407115776bd457c$exports = {};
$5407115776bd457c$exports = $parcel$resolve("kroiJ");



function $1bcae8edd2c9b338$export$2e2bcd8739ae039(props) {
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    var _props_buttonAction, _props_buttonText;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "error-view",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5407115776bd457c$exports))),
                alt: "Error icon"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "Error"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: props.error
            }),
            props.showButton !== false ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                href: "#",
                onClick: (_props_buttonAction = props.buttonAction) !== null && _props_buttonAction !== void 0 ? _props_buttonAction : ()=>navigate(-1),
                children: (_props_buttonText = props.buttonText) !== null && _props_buttonText !== void 0 ? _props_buttonText : "Go Back"
            }) : null
        ]
    });
}





var $2f86ea90ef359998$exports = {};
$2f86ea90ef359998$exports = $parcel$resolve("1MmLB");


var $230c122f42a9c337$exports = {};
$230c122f42a9c337$exports = $parcel$resolve("l9fer");


function $5a439522e12ead21$var$formatDateRange(startISO, endISO, showTimes = true) {
    if (!startISO) return "";
    const start = new Date(startISO);
    const end = endISO ? new Date(endISO) : null;
    const options = showTimes ? {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    } : {
        month: 'short',
        day: 'numeric'
    };
    if (!end) return start.toLocaleString(undefined, options);
    // If same day, show range of times
    if (start.toDateString() === end.toDateString()) {
        const datePart = start.toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric'
        });
        const startTime = start.toLocaleTimeString(undefined, {
            hour: 'numeric',
            minute: 'numeric'
        });
        const endTime = end.toLocaleTimeString(undefined, {
            hour: 'numeric',
            minute: 'numeric'
        });
        return `${datePart} \u{2022} ${startTime} - ${endTime}`;
    }
    // Different days
    return `${start.toLocaleString(undefined, options)} - ${end.toLocaleString(undefined, options)}`;
}
function $5a439522e12ead21$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        className: "event-card card",
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: props.thumbnailURL ? props.thumbnailURL : (0, (/*@__PURE__*/$parcel$interopDefault($230c122f42a9c337$exports))),
                    className: "thumbnail",
                    alt: props.title
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "content-left",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    className: "title",
                                    children: props.title
                                }),
                                props.dateInfo ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "date",
                                    children: $5a439522e12ead21$var$formatDateRange(props.dateInfo.startsAt, props.dateInfo.endsAt, props.dateInfo.showTimes)
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($2f86ea90ef359998$exports))),
                            alt: "Open event",
                            className: "link-arrow"
                        })
                    ]
                })
            ]
        })
    });
}


function $2a0798e511c3602a$export$2e2bcd8739ae039() {
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    const { events: events, loading: loading, error: error, refetch: refetch } = (0, $5e99117a3c3f973f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "events-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: "Events",
                showBackButton: false,
                links: [
                    {
                        title: "New Event",
                        onClick: ()=>{
                            navigate('/events/create');
                        }
                    }
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "events-container",
                children: [
                    loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {}) : null,
                    error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                        error: error,
                        buttonText: "Retry",
                        buttonAction: ()=>refetch()
                    }) : null,
                    events && events.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "no-events",
                        children: "No upcoming events."
                    }) : null,
                    events && events.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "cards",
                        children: events.map((e)=>{
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5a439522e12ead21$export$2e2bcd8739ae039), {
                                title: e.title,
                                thumbnailURL: e.thumbnailURL,
                                dateInfo: {
                                    showTimes: e.showTimes,
                                    startsAt: e.startsAt,
                                    endsAt: e.endsAt
                                },
                                onClick: ()=>{
                                    navigate(`/events/${e.id}`);
                                }
                            }, e.id);
                        })
                    }) : null
                ]
            })
        ]
    });
}






var $c7554617f7771263$exports = {};
$c7554617f7771263$exports = $parcel$resolve("fYzlm");


var $9a6c88b634913c19$exports = {};
$9a6c88b634913c19$exports = $parcel$resolve("LuWrb");


var $729bd1a2fa55fb37$exports = {};
$729bd1a2fa55fb37$exports = $parcel$resolve("abwkZ");




var $7fPBF = parcelRequire("7fPBF");



var $e5c73394f0bf85aa$exports = {};
$e5c73394f0bf85aa$exports = $parcel$resolve("iq4SA");


function $77186c032b6447f6$export$2e2bcd8739ae039(props) {
    const enabled = props.cards.filter((card)=>card.enabled);
    const disabled = props.cards.filter((card)=>!card.enabled);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "chooser",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "chooser-header",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: props.icon.image,
                        className: "icon",
                        alt: props.icon.alt
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        children: props.title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: props.description
                    })
                ]
            }),
            enabled.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "card",
                children: enabled.map((card, idx)=>{
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            idx !== 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "divider"
                            }) : null,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($77186c032b6447f6$var$CreateOption, {
                                onClick: card.onClick,
                                logo: card.logo,
                                title: card.title,
                                description: card.description
                            })
                        ]
                    }, card.title);
                })
            }) : null,
            disabled.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        style: {
                            marginBottom: '0'
                        },
                        children: "Unavailable"
                    }),
                    disabled.map((card)=>{
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "card unavailable",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($77186c032b6447f6$var$CreateOption, {
                                onClick: null,
                                logo: card.logo,
                                title: card.title,
                                description: card.description
                            })
                        }, card.title);
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        style: {
                            margin: '0'
                        },
                        children: props.unavailableText
                    })
                ]
            }) : null
        ]
    });
}
function $77186c032b6447f6$var$CreateOption(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: 'option-row',
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "option",
            onClick: ()=>{
                props.onClick && props.onClick();
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: props.logo.image,
                    className: "provider-logo",
                    alt: props.logo.alt
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "option-text",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                            children: props.title
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: props.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e5c73394f0bf85aa$exports))),
                    className: "chevron",
                    alt: ""
                })
            ]
        })
    });
}


function $7391c474f3fbb6e2$export$2e2bcd8739ae039() {
    const { connectionStatus: connectionStatus, reloadConnectionStatus: reloadConnectionStatus } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    (0, $7fPBF.useEffect)(()=>{
        // Ensure we have the latest connection status when this page mounts
        reloadConnectionStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadedConnectionStatus = connectionStatus !== undefined && connectionStatus !== null;
    const isPlanningCenterConnected = (connectionStatus === null || connectionStatus === void 0 ? void 0 : connectionStatus.PLANNING_CENTER) == true;
    const planningCenterCard = {
        title: "Import from Planning Center",
        description: "Pick an event from Planning Center to import. Events imported from Planning Center will regularly sync attendees and other data with Salt.",
        logo: {
            image: (0, (/*@__PURE__*/$parcel$interopDefault($c7554617f7771263$exports))),
            alt: 'Planning Center'
        },
        enabled: true,
        onClick: ()=>{
            if (isPlanningCenterConnected) navigate('/events/create/import?provider=PLANNING_CENTER');
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "create-event-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: "",
                showBackButton: true,
                backLocation: "/events"
            }),
            !loadedConnectionStatus && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {}),
            loadedConnectionStatus === true && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77186c032b6447f6$export$2e2bcd8739ae039), {
                title: "New Event",
                description: "Create events that your church members can attend.",
                icon: {
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($729bd1a2fa55fb37$exports))),
                    alt: 'Events'
                },
                unavailableText: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        "Unavailable creation methods may require you to connect an external provider in ",
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            href: "/connections",
                            children: "Connections"
                        })
                    ]
                }),
                cards: [
                    {
                        title: "Create in Salt",
                        description: "Create a fully custom event, managed in Salt.",
                        logo: {
                            image: (0, (/*@__PURE__*/$parcel$interopDefault($9a6c88b634913c19$exports))),
                            alt: 'Salt'
                        },
                        enabled: true,
                        onClick: ()=>navigate('/events/create/details')
                    },
                    planningCenterCard
                ]
            })
        ]
    });
}



function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}




var $7fPBF = parcelRequire("7fPBF");





var $c51974f9c71f40b1$exports = {};






























































!function(e, t) {
    t($c51974f9c71f40b1$exports, (parcelRequire("7fPBF")), (parcelRequire("2oXYc")), (parcelRequire("jicu4")), (parcelRequire("a5Tnv")), (parcelRequire("4K8y5")), (parcelRequire("MqaTG")), (parcelRequire("9o4jv")), (parcelRequire("ikvbb")), (parcelRequire("g2qsw")), (parcelRequire("kyhHe")), (parcelRequire("fHB48")), (parcelRequire("56MqC")), (parcelRequire("3WWqy")), (parcelRequire("7XbaL")), (parcelRequire("kOZIv")), (parcelRequire("5Q5cq")), (parcelRequire("47vGx")), (parcelRequire("83lF6")), (parcelRequire("1AHlB")), (parcelRequire("9haxa")), (parcelRequire("hWihv")), (parcelRequire("7EB9n")), (parcelRequire("6szzw")), (parcelRequire("fM9Kf")), (parcelRequire("5m1kc")), (parcelRequire("3J3av")), (parcelRequire("bGmT1")), (parcelRequire("h8bGW")), (parcelRequire("bKtOQ")), (parcelRequire("gi6xd")), (parcelRequire("ks4l0")), (parcelRequire("81pra")), (parcelRequire("3gYJv")), (parcelRequire("eZ85K")), (parcelRequire("dQzgo")), (parcelRequire("1r0i5")), (parcelRequire("1n0nj")), (parcelRequire("848HI")), (parcelRequire("aYd0L")), (parcelRequire("5aOOs")), (parcelRequire("jk6bs")), (parcelRequire("7yFGs")), (parcelRequire("jYJM6")), (parcelRequire("1ML50")), (parcelRequire("kb4zK")), (parcelRequire("7YbDm")), (parcelRequire("519j3")), (parcelRequire("hoAlg")), (parcelRequire("xNYKg")), (parcelRequire("bnDdH")), (parcelRequire("8nupm")), (parcelRequire("kW7J5")), (parcelRequire("7csev")), (parcelRequire("4uWbm")), (parcelRequire("cj6VA")), (parcelRequire("g7Fca")), (parcelRequire("uikl2")), (parcelRequire("jqdd7")), (parcelRequire("1RhTA")), (parcelRequire("bGse9")), (parcelRequire("fw0lo")), (parcelRequire("aYFRA")));
}($c51974f9c71f40b1$exports, function(e, t, r, a, n, o, s, i, p, l, d, c, u, f, h, m, y, D, v, w, g, k, b, S, C, _, M, P, E, N, O, x, Y, I, T, L, R, F, A, q, W, B, K, H, j, Q, V, U, $, z, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe) {
    "use strict";
    function le(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var de = le(t), ce = le(a), ue = le(n), fe = le(o), he = le(s), me = le(i), ye = le(p), De = le(l), ve = le(d), we = le(c), ge = le(u), ke = le(m), be = le(y), Se = le(D), Ce = le(v), _e = le(w), Me = le(g), Pe = le(k), Ee = le(b), Ne = le(S), Oe = le(C), xe = le(_), Ye = le(M), Ie = le(P), Te = le(E), Le = le(N), Re = le(O), Fe = le(x), Ae = le(Y), qe = le(I), We = le(T), Be = le(L), Ke = le(R), He = le(F), je = le(A), Qe = le(W), Ve = le(B), Ue = le(K), $e = le(H), ze = le(j), Ge = le(Q), Je = le(V), Xe = le(z), Ze = le(G), et = le(J), tt = le(X), rt = le(Z), at = le(ee), nt = le(te), ot = le(re), st = le(ae), it = le(ne), pt = le(oe), lt = le(se), dt = le(ie);
    function ct(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            t && (a = a.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function ut(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ct(Object(r), !0).forEach(function(t) {
                Dt(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ct(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function ft(e) {
        return (ft = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
    }
    function ht(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function mt(e, t) {
        for(var r = 0; r < t.length; r++){
            var a = t[r];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
    }
    function yt(e, t, r) {
        return t && mt(e.prototype, t), r && mt(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function Dt(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function vt() {
        return (vt = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var a in r)Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
            }
            return e;
        }).apply(this, arguments);
    }
    function wt(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        Object.defineProperty(e, "prototype", {
            value: Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }),
            writable: !1
        }), t && kt(e, t);
    }
    function gt(e) {
        return (gt = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
    }
    function kt(e, t) {
        return (kt = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        })(e, t);
    }
    function bt(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function St(e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return bt(e);
    }
    function Ct(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = gt(e);
            if (t) {
                var n = gt(this).constructor;
                r = Reflect.construct(a, arguments, n);
            } else r = a.apply(this, arguments);
            return St(this, r);
        };
    }
    function _t(e) {
        return function(e) {
            if (Array.isArray(e)) return Mt(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return Mt(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Mt(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Mt(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    function Pt(e, t) {
        switch(e){
            case "P":
                return t.date({
                    width: "short"
                });
            case "PP":
                return t.date({
                    width: "medium"
                });
            case "PPP":
                return t.date({
                    width: "long"
                });
            case "PPPP":
            default:
                return t.date({
                    width: "full"
                });
        }
    }
    function Et(e, t) {
        switch(e){
            case "p":
                return t.time({
                    width: "short"
                });
            case "pp":
                return t.time({
                    width: "medium"
                });
            case "ppp":
                return t.time({
                    width: "long"
                });
            case "pppp":
            default:
                return t.time({
                    width: "full"
                });
        }
    }
    var Nt = {
        p: Et,
        P: function(e, t) {
            var r, a = e.match(/(P+)(p+)?/) || [], n = a[1], o = a[2];
            if (!o) return Pt(e, t);
            switch(n){
                case "P":
                    r = t.dateTime({
                        width: "short"
                    });
                    break;
                case "PP":
                    r = t.dateTime({
                        width: "medium"
                    });
                    break;
                case "PPP":
                    r = t.dateTime({
                        width: "long"
                    });
                    break;
                case "PPPP":
                default:
                    r = t.dateTime({
                        width: "full"
                    });
            }
            return r.replace("{{date}}", Pt(n, t)).replace("{{time}}", Et(o, t));
        }
    }, Ot = 12, xt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Yt(e) {
        var t = e ? "string" == typeof e || e instanceof String ? pt.default(e) : st.default(e) : new Date;
        return Tt(t) ? t : null;
    }
    function It(e, t, r, a, n) {
        var o = null, s = Xt(r) || Xt(Jt()), i = !0;
        return Array.isArray(t) ? (t.forEach(function(t) {
            var p = it.default(e, t, new Date, {
                locale: s
            });
            a && (i = Tt(p, n) && e === Lt(p, t, r)), Tt(p, n) && i && (o = p);
        }), o) : (o = it.default(e, t, new Date, {
            locale: s
        }), a ? i = Tt(o) && e === Lt(o, t, r) : Tt(o) || (t = t.match(xt).map(function(e) {
            var t = e[0];
            return "p" === t || "P" === t ? s ? (0, Nt[t])(e, s.formatLong) : t : e;
        }).join(""), e.length > 0 && (o = it.default(e, t.slice(0, e.length), new Date)), Tt(o) || (o = new Date(e))), Tt(o) && i ? o : null);
    }
    function Tt(e, t) {
        return t = t || new Date("1/1/1000"), fe.default(e) && !nt.default(e, t);
    }
    function Lt(e, t, r) {
        if ("en" === r) return he.default(e, t, {
            awareOfUnicodeTokens: !0
        });
        var a = Xt(r);
        return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !a && Jt() && Xt(Jt()) && (a = Xt(Jt())), he.default(e, t, {
            locale: a || null,
            awareOfUnicodeTokens: !0
        });
    }
    function Rt(e, t) {
        var r = t.dateFormat, a = t.locale;
        return e && Lt(e, Array.isArray(r) ? r[0] : r, a) || "";
    }
    function Ft(e, t) {
        var r = t.hour, a = void 0 === r ? 0 : r, n = t.minute, o = void 0 === n ? 0 : n, s = t.second, i = void 0 === s ? 0 : s;
        return Fe.default(Re.default(Le.default(e, i), o), a);
    }
    function At(e, t) {
        var r = t && Xt(t) || Jt() && Xt(Jt());
        return Oe.default(e, r ? {
            locale: r
        } : null);
    }
    function qt(e, t) {
        return Lt(e, "ddd", t);
    }
    function Wt(e) {
        return Ve.default(e);
    }
    function Bt(e, t, r) {
        var a = Xt(t || Jt());
        return Ue.default(e, {
            locale: a,
            weekStartsOn: r
        });
    }
    function Kt(e) {
        return $e.default(e);
    }
    function Ht(e) {
        return Ge.default(e);
    }
    function jt(e) {
        return ze.default(e);
    }
    function Qt(e, t) {
        return e && t ? tt.default(e, t) : !e && !t;
    }
    function Vt(e, t) {
        return e && t ? et.default(e, t) : !e && !t;
    }
    function Ut(e, t) {
        return e && t ? rt.default(e, t) : !e && !t;
    }
    function $t(e, t) {
        return e && t ? Ze.default(e, t) : !e && !t;
    }
    function zt(e, t) {
        return e && t ? Xe.default(e, t) : !e && !t;
    }
    function Gt(e, t, r) {
        var a, n = Ve.default(t), o = Je.default(r);
        try {
            a = ot.default(e, {
                start: n,
                end: o
            });
        } catch (e) {
            a = !1;
        }
        return a;
    }
    function Jt() {
        return ("undefined" != typeof window ? window : globalThis).__localeId__;
    }
    function Xt(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : globalThis;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function Zt(e, t) {
        return Lt(Ae.default(Yt(), e), "LLLL", t);
    }
    function er(e, t) {
        return Lt(Ae.default(Yt(), e), "LLL", t);
    }
    function tr(e, t) {
        return Lt(qe.default(Yt(), e), "QQQ", t);
    }
    function rr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.excludeDateIntervals, s = t.includeDates, i = t.includeDateIntervals, p = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return $t(e, t);
        }) || o && o.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) || s && !s.some(function(t) {
            return $t(e, t);
        }) || i && !i.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) || p && !p(Yt(e)) || !1;
    }
    function ar(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeDates, a = t.excludeDateIntervals;
        return a && a.length > 0 ? a.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) : r && r.some(function(t) {
            return $t(e, t);
        }) || !1;
    }
    function nr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Vt(e, t);
        }) || o && !o.some(function(t) {
            return Vt(e, t);
        }) || s && !s(Yt(e)) || !1;
    }
    function or(e, t, r, a) {
        var n = Ie.default(e), o = xe.default(e), s = Ie.default(t), i = xe.default(t), p = Ie.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function sr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Ut(e, t);
        }) || o && !o.some(function(t) {
            return Ut(e, t);
        }) || s && !s(Yt(e)) || !1;
    }
    function ir(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = new Date(e, 0, 1);
        return lr(n, {
            minDate: r,
            maxDate: a
        }) || !1;
    }
    function pr(e, t, r, a) {
        var n = Ie.default(e), o = Ye.default(e), s = Ie.default(t), i = Ye.default(t), p = Ie.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function lr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate;
        return r && He.default(e, r) < 0 || a && He.default(e, a) > 0;
    }
    function dr(e, t) {
        return t.some(function(t) {
            return Pe.default(t) === Pe.default(e) && Me.default(t) === Me.default(e);
        });
    }
    function cr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeTimes, a = t.includeTimes, n = t.filterTime;
        return r && dr(e, r) || a && !dr(e, a) || n && !n(e) || !1;
    }
    function ur(e, t) {
        var r = t.minTime, a = t.maxTime;
        if (!r || !a) throw new Error("Both minTime and maxTime props required");
        var n, o = Yt(), s = Fe.default(Re.default(o, Me.default(e)), Pe.default(e)), i = Fe.default(Re.default(o, Me.default(r)), Pe.default(r)), p = Fe.default(Re.default(o, Me.default(a)), Pe.default(a));
        try {
            n = !ot.default(s, {
                start: i,
                end: p
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function fr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Se.default(e, 1);
        return r && je.default(r, n) > 0 || a && a.every(function(e) {
            return je.default(e, n) > 0;
        }) || !1;
    }
    function hr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = we.default(e, 1);
        return r && je.default(n, r) > 0 || a && a.every(function(e) {
            return je.default(n, e) > 0;
        }) || !1;
    }
    function mr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Ce.default(e, 1);
        return r && Qe.default(r, n) > 0 || a && a.every(function(e) {
            return Qe.default(e, n) > 0;
        }) || !1;
    }
    function yr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = ge.default(e, 1);
        return r && Qe.default(n, r) > 0 || a && a.every(function(e) {
            return Qe.default(n, e) > 0;
        }) || !1;
    }
    function Dr(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return He.default(e, t) >= 0;
            });
            return Be.default(a);
        }
        return r ? Be.default(r) : t;
    }
    function vr(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return He.default(e, t) <= 0;
            });
            return Ke.default(a);
        }
        return r ? Ke.default(r) : t;
    }
    function wr() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, a = 0, n = e.length; a < n; a++){
            var o = e[a];
            if (ue.default(o)) {
                var s = Lt(o, "MM.dd.yyyy"), i = r.get(s) || [];
                i.includes(t) || (i.push(t), r.set(s, i));
            } else if ("object" === ft(o)) {
                var p = Object.keys(o), l = p[0], d = o[p[0]];
                if ("string" == typeof l && d.constructor === Array) for(var c = 0, u = d.length; c < u; c++){
                    var f = Lt(d[c], "MM.dd.yyyy"), h = r.get(f) || [];
                    h.includes(l) || (h.push(l), r.set(f, h));
                }
            }
        }
        return r;
    }
    function gr(e, t, r, a, n) {
        for(var o = n.length, s = [], i = 0; i < o; i++){
            var p = me.default(ye.default(e, Pe.default(n[i])), Me.default(n[i])), l = me.default(e, (r + 1) * a);
            at.default(p, t) && nt.default(p, l) && s.push(n[i]);
        }
        return s;
    }
    function kr(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function br(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Ot, r = Math.ceil(Ie.default(e) / t) * t, a = r - (t - 1);
        return {
            startPeriod: a,
            endPeriod: r
        };
    }
    function Sr(e, t, r, a) {
        for(var n = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = Ie.default(r) <= s), a && i && (i = Ie.default(a) >= s), i && n.push(s);
        }
        return n;
    }
    var Cr = function(e) {
        wt(a, e);
        var r = Ct(a);
        function a(e) {
            var n;
            ht(this, a), Dt(bt(n = r.call(this, e)), "renderOptions", function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return de.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(bt(n), t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? de.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = n.props.minDate ? Ie.default(n.props.minDate) : null, a = n.props.maxDate ? Ie.default(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }), Dt(bt(n), "onChange", function(e) {
                n.props.onChange(e);
            }), Dt(bt(n), "handleClickOutside", function() {
                n.props.onCancel();
            }), Dt(bt(n), "shiftYears", function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }), Dt(bt(n), "incrementYears", function() {
                return n.shiftYears(1);
            }), Dt(bt(n), "decrementYears", function() {
                return n.shiftYears(-1);
            });
            var o = e.yearDropdownItemNumber, s = e.scrollableYearDropdown, i = o || (s ? 10 : 5);
            return n.state = {
                yearsList: Sr(n.props.year, i, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = t.createRef(), n;
        }
        return yt(a, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.dropdownRef.current;
                    e && (e.scrollTop = e.scrollHeight / 2 - e.clientHeight / 2);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = ce.default({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e,
                        ref: this.dropdownRef
                    }, this.renderOptions());
                }
            }
        ]), a;
    }(de.default.Component), _r = lt.default(Cr), Mr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function() {
                for(var t = e.props.minDate ? Ie.default(e.props.minDate) : 1900, r = e.props.maxDate ? Ie.default(e.props.maxDate) : 2100, a = [], n = t; n <= r; n++)a.push(de.default.createElement("option", {
                    key: n,
                    value: n
                }, n));
                return a;
            }), Dt(bt(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Dt(bt(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Dt(bt(e), "renderReadView", function(t) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, e.props.year));
            }), Dt(bt(e), "renderDropdown", function() {
                return de.default.createElement(_r, {
                    key: "dropdown",
                    year: e.props.year,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableYearDropdown: e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: e.props.yearDropdownItemNumber
                });
            }), Dt(bt(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
            }), Dt(bt(e), "toggleDropdown", function(t) {
                e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                }, function() {
                    e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
                });
            }), Dt(bt(e), "handleYearChange", function(t, r) {
                e.onSelect(t, r), e.setOpen();
            }), Dt(bt(e), "onSelect", function(t, r) {
                e.props.onSelect && e.props.onSelect(t, r);
            }), Dt(bt(e), "setOpen", function() {
                e.props.setOpen && e.props.setOpen(!0);
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Pr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "isSelectedMonth", function(t) {
                return e.props.month === t;
            }), Dt(bt(e), "renderOptions", function() {
                return e.props.monthNames.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: e.onChange.bind(bt(e), r),
                        "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
                    }, e.isSelectedMonth(r) ? de.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), Dt(bt(e), "onChange", function(t) {
                return e.props.onChange(t);
            }), Dt(bt(e), "handleClickOutside", function() {
                return e.props.onCancel();
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Er = lt.default(Pr), Nr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return de.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), Dt(bt(e), "renderSelectMode", function(t) {
                return de.default.createElement("select", {
                    value: e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(t) {
                        return e.onChange(t.target.value);
                    }
                }, e.renderSelectOptions(t));
            }), Dt(bt(e), "renderReadView", function(t, r) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: e.toggleDropdown
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[e.props.month]));
            }), Dt(bt(e), "renderDropdown", function(t) {
                return de.default.createElement(Er, {
                    key: "dropdown",
                    month: e.props.month,
                    monthNames: t,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown
                });
            }), Dt(bt(e), "renderScrollMode", function(t) {
                var r = e.state.dropdownVisible, a = [
                    e.renderReadView(!r, t)
                ];
                return r && a.unshift(e.renderDropdown(t)), a;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
            }), Dt(bt(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this, r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return er(e, t.props.locale);
                    } : function(e) {
                        return Zt(e, t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(r);
                            break;
                        case "select":
                            e = this.renderSelectMode(r);
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component);
    function Or(e, t) {
        for(var r = [], a = Kt(e), n = Kt(t); !at.default(a, n);)r.push(Yt(a)), a = we.default(a, 1);
        return r;
    }
    var xr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "renderOptions", function() {
                return a.state.monthYearsList.map(function(e) {
                    var t = Te.default(e), r = Qt(a.props.date, e) && Vt(a.props.date, e);
                    return de.default.createElement("div", {
                        className: r ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: a.onChange.bind(bt(a), t),
                        "aria-selected": r ? "true" : void 0
                    }, r ? de.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Lt(e, a.props.dateFormat, a.props.locale));
                });
            }), Dt(bt(a), "onChange", function(e) {
                return a.props.onChange(e);
            }), Dt(bt(a), "handleClickOutside", function() {
                a.props.onCancel();
            }), a.state = {
                monthYearsList: Or(a.props.minDate, a.props.maxDate)
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = ce.default({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Yr = lt.default(xr), Ir = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function() {
                for(var t = Kt(e.props.minDate), r = Kt(e.props.maxDate), a = []; !at.default(t, r);){
                    var n = Te.default(t);
                    a.push(de.default.createElement("option", {
                        key: n,
                        value: n
                    }, Lt(t, e.props.dateFormat, e.props.locale))), t = we.default(t, 1);
                }
                return a;
            }), Dt(bt(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Dt(bt(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: Te.default(Kt(e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Dt(bt(e), "renderReadView", function(t) {
                var r = Lt(e.props.date, e.props.dateFormat, e.props.locale);
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), Dt(bt(e), "renderDropdown", function() {
                return de.default.createElement(Yr, {
                    key: "dropdown",
                    date: e.props.date,
                    dateFormat: e.props.dateFormat,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
                    locale: e.props.locale
                });
            }), Dt(bt(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown();
                var r = Yt(parseInt(t));
                Qt(e.props.date, r) && Vt(e.props.date, r) || e.props.onChange(r);
            }), Dt(bt(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Tr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "dayEl", de.default.createRef()), Dt(bt(e), "handleClick", function(t) {
                !e.isDisabled() && e.props.onClick && e.props.onClick(t);
            }), Dt(bt(e), "handleMouseEnter", function(t) {
                !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
            }), Dt(bt(e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Dt(bt(e), "isSameDay", function(t) {
                return $t(e.props.day, t);
            }), Dt(bt(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !e.isSameDay(e.props.selected) && e.isSameDay(e.props.preSelection);
            }), Dt(bt(e), "isDisabled", function() {
                return rr(e.props.day, e.props);
            }), Dt(bt(e), "isExcluded", function() {
                return ar(e.props.day, e.props);
            }), Dt(bt(e), "getHighLightedClass", function(t) {
                var r = e.props, a = r.day, n = r.highlightDates;
                if (!n) return !1;
                var o = Lt(a, "MM.dd.yyyy");
                return n.get(o);
            }), Dt(bt(e), "isInRange", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Gt(r, a, n);
            }), Dt(bt(e), "isInSelectingRange", function() {
                var t, r = e.props, a = r.day, n = r.selectsStart, o = r.selectsEnd, s = r.selectsRange, i = r.selectsDisabledDaysInRange, p = r.startDate, l = r.endDate, d = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return !(!(n || o || s) || !d || !i && e.isDisabled()) && (n && l && (nt.default(d, l) || zt(d, l)) ? Gt(a, d, l) : (o && p && (at.default(d, p) || zt(d, p)) || !(!s || !p || l || !at.default(d, p) && !zt(d, p))) && Gt(a, p, d));
            }), Dt(bt(e), "isSelectingRangeStart", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.startDate, o = r.selectsStart, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return $t(a, o ? s : n);
            }), Dt(bt(e), "isSelectingRangeEnd", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.endDate, o = r.selectsEnd, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return $t(a, o ? s : n);
            }), Dt(bt(e), "isRangeStart", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && $t(a, r);
            }), Dt(bt(e), "isRangeEnd", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && $t(n, r);
            }), Dt(bt(e), "isWeekend", function() {
                var t = Ee.default(e.props.day);
                return 0 === t || 6 === t;
            }), Dt(bt(e), "isAfterMonth", function() {
                return void 0 !== e.props.month && (e.props.month + 1) % 12 === xe.default(e.props.day);
            }), Dt(bt(e), "isBeforeMonth", function() {
                return void 0 !== e.props.month && (xe.default(e.props.day) + 1) % 12 === e.props.month;
            }), Dt(bt(e), "isCurrentDay", function() {
                return e.isSameDay(Yt());
            }), Dt(bt(e), "isSelected", function() {
                return e.isSameDay(e.props.selected);
            }), Dt(bt(e), "getClassNames", function(t) {
                var r = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
                return ce.default("react-datepicker__day", r, "react-datepicker__day--" + qt(e.props.day), {
                    "react-datepicker__day--disabled": e.isDisabled(),
                    "react-datepicker__day--excluded": e.isExcluded(),
                    "react-datepicker__day--selected": e.isSelected(),
                    "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": e.isRangeStart(),
                    "react-datepicker__day--range-end": e.isRangeEnd(),
                    "react-datepicker__day--in-range": e.isInRange(),
                    "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": e.isCurrentDay(),
                    "react-datepicker__day--weekend": e.isWeekend(),
                    "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
                }, e.getHighLightedClass("react-datepicker__day--highlighted"));
            }), Dt(bt(e), "getAriaLabel", function() {
                var t = e.props, r = t.day, a = t.ariaLabelPrefixWhenEnabled, n = void 0 === a ? "Choose" : a, o = t.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = e.isDisabled() || e.isExcluded() ? s : n;
                return "".concat(i, " ").concat(Lt(r, "PPPP", e.props.locale));
            }), Dt(bt(e), "getTabIndex", function(t, r) {
                var a = t || e.props.selected, n = r || e.props.preSelection;
                return e.isKeyboardSelected() || e.isSameDay(a) && $t(n, a) ? 0 : -1;
            }), Dt(bt(e), "handleFocusDay", function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = !1;
                0 === e.getTabIndex() && !t.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (r = !0)), r && e.dayEl.current.focus({
                    preventScroll: !0
                });
            }), Dt(bt(e), "renderDayContents", function() {
                return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(Ne.default(e.props.day), e.props.day) : Ne.default(e.props.day);
            }), Dt(bt(e), "render", function() {
                return de.default.createElement("div", {
                    ref: e.dayEl,
                    className: e.getClassNames(e.props.day),
                    onKeyDown: e.handleOnKeyDown,
                    onClick: e.handleClick,
                    onMouseEnter: e.handleMouseEnter,
                    tabIndex: e.getTabIndex(),
                    "aria-label": e.getAriaLabel(),
                    role: "option",
                    "aria-disabled": e.isDisabled(),
                    "aria-current": e.isCurrentDay() ? "date" : void 0,
                    "aria-selected": e.isSelected()
                }, e.renderDayContents());
            }), e;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusDay(e);
                }
            }
        ]), r;
    }(de.default.Component), Lr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "handleClick", function(t) {
                e.props.onClick && e.props.onClick(t);
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.weekNumber, r = e.ariaLabelPrefix, a = void 0 === r ? "week " : r, n = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!e.onClick
                    };
                    return de.default.createElement("div", {
                        className: ce.default(n),
                        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick
                    }, t);
                }
            }
        ]), r;
    }(de.default.Component), Rr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r);
            }), Dt(bt(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Dt(bt(e), "handleWeekClick", function(t, r, a) {
                "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, a), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
            }), Dt(bt(e), "formatWeekNumber", function(t) {
                return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : At(t);
            }), Dt(bt(e), "renderDays", function() {
                var t = Bt(e.props.day, e.props.locale, e.props.calendarStartDay), r = [], a = e.formatWeekNumber(t);
                if (e.props.showWeekNumber) {
                    var n = e.props.onWeekSelect ? e.handleWeekClick.bind(bt(e), t, a) : void 0;
                    r.push(de.default.createElement(Lr, {
                        key: "W",
                        weekNumber: a,
                        onClick: n,
                        ariaLabelPrefix: e.props.ariaLabelPrefix
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var a = De.default(t, r);
                    return de.default.createElement(Tr, {
                        ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
                        key: a.valueOf(),
                        day: a,
                        month: e.props.month,
                        onClick: e.handleDayClick.bind(bt(e), a),
                        onMouseEnter: e.handleDayMouseEnter.bind(bt(e), a),
                        minDate: e.props.minDate,
                        maxDate: e.props.maxDate,
                        excludeDates: e.props.excludeDates,
                        excludeDateIntervals: e.props.excludeDateIntervals,
                        includeDates: e.props.includeDates,
                        includeDateIntervals: e.props.includeDateIntervals,
                        highlightDates: e.props.highlightDates,
                        selectingDate: e.props.selectingDate,
                        filterDate: e.props.filterDate,
                        preSelection: e.props.preSelection,
                        selected: e.props.selected,
                        selectsStart: e.props.selectsStart,
                        selectsEnd: e.props.selectsEnd,
                        selectsRange: e.props.selectsRange,
                        selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                        startDate: e.props.startDate,
                        endDate: e.props.endDate,
                        dayClassName: e.props.dayClassName,
                        renderDayContents: e.props.renderDayContents,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef,
                        inline: e.props.inline,
                        shouldFocusDayInline: e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
                        locale: e.props.locale
                    });
                }));
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__week"
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Fr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "MONTH_REFS", _t(Array(12)).map(function() {
                return de.default.createRef();
            })), Dt(bt(e), "isDisabled", function(t) {
                return rr(t, e.props);
            }), Dt(bt(e), "isExcluded", function(t) {
                return ar(t, e.props);
            }), Dt(bt(e), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
            }), Dt(bt(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Dt(bt(e), "handleMouseLeave", function() {
                e.props.onMouseLeave && e.props.onMouseLeave();
            }), Dt(bt(e), "isRangeStartMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Vt(Ae.default(a, t), n);
            }), Dt(bt(e), "isRangeStartQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Ut(qe.default(a, t), n);
            }), Dt(bt(e), "isRangeEndMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Vt(Ae.default(a, t), o);
            }), Dt(bt(e), "isRangeEndQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Ut(qe.default(a, t), o);
            }), Dt(bt(e), "isWeekInMonth", function(t) {
                var r = e.props.day, a = De.default(t, 6);
                return Vt(t, r) || Vt(a, r);
            }), Dt(bt(e), "isCurrentMonth", function(e, t) {
                return Ie.default(e) === Ie.default(Yt()) && t === xe.default(Yt());
            }), Dt(bt(e), "isSelectedMonth", function(e, t, r) {
                return xe.default(e) === t && Ie.default(e) === Ie.default(r);
            }), Dt(bt(e), "isSelectedQuarter", function(e, t, r) {
                return Ye.default(e) === t && Ie.default(e) === Ie.default(r);
            }), Dt(bt(e), "renderWeeks", function() {
                for(var t = [], r = e.props.fixedHeight, a = 0, n = !1, o = Bt(Kt(e.props.day), e.props.locale, e.props.calendarStartDay); t.push(de.default.createElement(Rr, {
                    ariaLabelPrefix: e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
                    key: a,
                    day: o,
                    month: xe.default(e.props.day),
                    onDayClick: e.handleDayClick,
                    onDayMouseEnter: e.handleDayMouseEnter,
                    onWeekSelect: e.props.onWeekSelect,
                    formatWeekNumber: e.props.formatWeekNumber,
                    locale: e.props.locale,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    excludeDates: e.props.excludeDates,
                    excludeDateIntervals: e.props.excludeDateIntervals,
                    includeDates: e.props.includeDates,
                    includeDateIntervals: e.props.includeDateIntervals,
                    inline: e.props.inline,
                    shouldFocusDayInline: e.props.shouldFocusDayInline,
                    highlightDates: e.props.highlightDates,
                    selectingDate: e.props.selectingDate,
                    filterDate: e.props.filterDate,
                    preSelection: e.props.preSelection,
                    selected: e.props.selected,
                    selectsStart: e.props.selectsStart,
                    selectsEnd: e.props.selectsEnd,
                    selectsRange: e.props.selectsRange,
                    selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                    showWeekNumber: e.props.showWeekNumbers,
                    startDate: e.props.startDate,
                    endDate: e.props.endDate,
                    dayClassName: e.props.dayClassName,
                    setOpen: e.props.setOpen,
                    shouldCloseOnSelect: e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                    renderDayContents: e.props.renderDayContents,
                    handleOnKeyDown: e.props.handleOnKeyDown,
                    isInputFocused: e.props.isInputFocused,
                    containerRef: e.props.containerRef,
                    calendarStartDay: e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
                })), !n;){
                    a++, o = ve.default(o, 1);
                    var s = r && a >= 6, i = !r && !e.isWeekInMonth(o);
                    if (s || i) {
                        if (!e.props.peekNextMonth) break;
                        n = !0;
                    }
                }
                return t;
            }), Dt(bt(e), "onMonthClick", function(t, r) {
                e.handleDayClick(Kt(Ae.default(e.props.day, r)), t);
            }), Dt(bt(e), "handleMonthNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
            }), Dt(bt(e), "onMonthKeyDown", function(t, r) {
                var a = t.key;
                if (!e.props.disabledKeyboardNavigation) switch(a){
                    case "Enter":
                        e.onMonthClick(t, r), e.props.setPreSelection(e.props.selected);
                        break;
                    case "ArrowRight":
                        e.handleMonthNavigation(11 === r ? 0 : r + 1, we.default(e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        e.handleMonthNavigation(0 === r ? 11 : r - 1, Se.default(e.props.preSelection, 1));
                }
            }), Dt(bt(e), "onQuarterClick", function(t, r) {
                e.handleDayClick(jt(qe.default(e.props.day, r)), t);
            }), Dt(bt(e), "getMonthClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate, l = r.preSelection, d = r.monthClassName, c = d ? d(a) : void 0;
                return ce.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), c, {
                    "react-datepicker__month--disabled": (i || p) && nr(Ae.default(a, t), e.props),
                    "react-datepicker__month--selected": e.isSelectedMonth(a, t, s),
                    "react-datepicker__month-text--keyboard-selected": xe.default(l) === t,
                    "react-datepicker__month--in-range": or(n, o, t, a),
                    "react-datepicker__month--range-start": e.isRangeStartMonth(t),
                    "react-datepicker__month--range-end": e.isRangeEndMonth(t),
                    "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
                });
            }), Dt(bt(e), "getTabIndex", function(t) {
                var r = xe.default(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Dt(bt(e), "getAriaLabel", function(t) {
                var r = e.props, a = r.ariaLabelPrefix, n = void 0 === a ? "Choose" : a, o = r.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = r.day, p = Ae.default(i, t), l = e.isDisabled(p) || e.isExcluded(p) ? s : n;
                return "".concat(l, " ").concat(Lt(p, "MMMM yyyy"));
            }), Dt(bt(e), "getQuarterClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate;
                return ce.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter--disabled": (i || p) && sr(qe.default(a, t), e.props),
                    "react-datepicker__quarter--selected": e.isSelectedQuarter(a, t, s),
                    "react-datepicker__quarter--in-range": pr(n, o, t, a),
                    "react-datepicker__quarter--range-start": e.isRangeStartQuarter(t),
                    "react-datepicker__quarter--range-end": e.isRangeEndQuarter(t)
                });
            }), Dt(bt(e), "renderMonths", function() {
                var t = e.props, r = t.showFullMonthYearPicker, a = t.showTwoColumnMonthYearPicker, n = t.showFourColumnMonthYearPicker, o = t.locale, s = t.day, i = t.selected;
                return (n ? [
                    [
                        0,
                        1,
                        2,
                        3
                    ],
                    [
                        4,
                        5,
                        6,
                        7
                    ],
                    [
                        8,
                        9,
                        10,
                        11
                    ]
                ] : a ? [
                    [
                        0,
                        1
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        6,
                        7
                    ],
                    [
                        8,
                        9
                    ],
                    [
                        10,
                        11
                    ]
                ] : [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        3,
                        4,
                        5
                    ],
                    [
                        6,
                        7,
                        8
                    ],
                    [
                        9,
                        10,
                        11
                    ]
                ]).map(function(t, a) {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: a
                    }, t.map(function(t, a) {
                        return de.default.createElement("div", {
                            ref: e.MONTH_REFS[t],
                            key: a,
                            onClick: function(r) {
                                e.onMonthClick(r, t);
                            },
                            onKeyDown: function(r) {
                                e.onMonthKeyDown(r, t);
                            },
                            tabIndex: e.getTabIndex(t),
                            className: e.getMonthClassNames(t),
                            role: "option",
                            "aria-label": e.getAriaLabel(t),
                            "aria-current": e.isCurrentMonth(s, t) ? "date" : void 0,
                            "aria-selected": e.isSelectedMonth(s, t, i)
                        }, r ? Zt(t, o) : er(t, o));
                    }));
                });
            }), Dt(bt(e), "renderQuarters", function() {
                var t = e.props, r = t.day, a = t.selected;
                return de.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, n) {
                    return de.default.createElement("div", {
                        key: n,
                        role: "option",
                        onClick: function(r) {
                            e.onQuarterClick(r, t);
                        },
                        className: e.getQuarterClassNames(t),
                        "aria-selected": e.isSelectedQuarter(r, t, a)
                    }, tr(t, e.props.locale));
                }));
            }), Dt(bt(e), "getClassNames", function() {
                var t = e.props;
                t.day;
                var r = t.selectingDate, a = t.selectsStart, n = t.selectsEnd, o = t.showMonthYearPicker, s = t.showQuarterYearPicker;
                return ce.default("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || n)
                }, {
                    "react-datepicker__monthPicker": o
                }, {
                    "react-datepicker__quarterPicker": s
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, a = e.day, n = e.ariaLabelPrefix, o = void 0 === n ? "month " : n;
                    return de.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.handleMouseLeave,
                        "aria-label": "".concat(o, " ").concat(Lt(a, "yyyy-MM")),
                        role: "listbox"
                    }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]), r;
    }(de.default.Component), Ar = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                height: null
            }), Dt(bt(e), "handleClick", function(t) {
                (e.props.minTime || e.props.maxTime) && ur(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cr(t, e.props) || e.props.onChange(t);
            }), Dt(bt(e), "isSelectedTime", function(t, r, a) {
                return e.props.selected && r === Pe.default(t) && a === Me.default(t);
            }), Dt(bt(e), "liClasses", function(t, r, a) {
                var n = [
                    "react-datepicker__time-list-item",
                    e.props.timeClassName ? e.props.timeClassName(t, r, a) : void 0
                ];
                return e.isSelectedTime(t, r, a) && n.push("react-datepicker__time-list-item--selected"), ((e.props.minTime || e.props.maxTime) && ur(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cr(t, e.props)) && n.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * Pe.default(t) + Me.default(t)) % e.props.intervals != 0 && n.push("react-datepicker__time-list-item--injected"), n.join(" ");
            }), Dt(bt(e), "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
            }), Dt(bt(e), "renderTimes", function() {
                for(var t = [], r = e.props.format ? e.props.format : "p", a = e.props.intervals, n = Wt(Yt(e.props.selected)), o = 1440 / a, s = e.props.injectTimes && e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), i = e.props.selected || e.props.openToDate || Yt(), p = Pe.default(i), l = Me.default(i), d = Fe.default(Re.default(n, l), p), c = 0; c < o; c++){
                    var u = me.default(n, c * a);
                    if (t.push(u), s) {
                        var f = gr(n, u, c, a, s);
                        t = t.concat(f);
                    }
                }
                return t.map(function(t, a) {
                    return de.default.createElement("li", {
                        key: a,
                        onClick: e.handleClick.bind(bt(e), t),
                        className: e.liClasses(t, p, l),
                        ref: function(r) {
                            (nt.default(t, d) || zt(t, d)) && (e.centerLi = r);
                        },
                        onKeyDown: function(r) {
                            e.handleOnKeyDown(r, t);
                        },
                        tabIndex: "0",
                        "aria-selected": e.isSelectedTime(t, p, l) ? "true" : void 0
                    }, Lt(t, r, e.props.locale));
                });
            }), e;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.list.scrollTop = r.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.state.height;
                    return de.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, de.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function(t) {
                            e.header = t;
                        }
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), de.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, de.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: t ? {
                            height: t
                        } : {},
                        tabIndex: "0"
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]), r;
    }(de.default.Component);
    Dt(Ar, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var qr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "YEAR_REFS", _t(Array(a.props.yearItemNumber)).map(function() {
                return de.default.createRef();
            })), Dt(bt(a), "isDisabled", function(e) {
                return rr(e, a.props);
            }), Dt(bt(a), "isExcluded", function(e) {
                return ar(e, a.props);
            }), Dt(bt(a), "updateFocusOnPaginate", function(e) {
                var t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(bt(a));
                window.requestAnimationFrame(t);
            }), Dt(bt(a), "handleYearClick", function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t);
            }), Dt(bt(a), "handleYearNavigation", function(e, t) {
                var r = a.props, n = r.date, o = r.yearItemNumber, s = br(n, o).startPeriod;
                a.isDisabled(t) || a.isExcluded(t) || (a.props.setPreSelection(t), e - s == -1 ? a.updateFocusOnPaginate(o - 1) : e - s === o ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[e - s].current.focus());
            }), Dt(bt(a), "isSameDay", function(e, t) {
                return $t(e, t);
            }), Dt(bt(a), "isCurrentYear", function(e) {
                return e === Ie.default(Yt());
            }), Dt(bt(a), "isKeyboardSelected", function(e) {
                var t = Ht(We.default(a.props.date, e));
                return !a.props.disabledKeyboardNavigation && !a.props.inline && !$t(t, Ht(a.props.selected)) && $t(t, Ht(a.props.preSelection));
            }), Dt(bt(a), "onYearClick", function(e, t) {
                var r = a.props.date;
                a.handleYearClick(Ht(We.default(r, t)), e);
            }), Dt(bt(a), "onYearKeyDown", function(e, t) {
                var r = e.key;
                if (!a.props.disabledKeyboardNavigation) switch(r){
                    case "Enter":
                        a.onYearClick(e, t), a.props.setPreSelection(a.props.selected);
                        break;
                    case "ArrowRight":
                        a.handleYearNavigation(t + 1, ge.default(a.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        a.handleYearNavigation(t - 1, Ce.default(a.props.preSelection, 1));
                }
            }), Dt(bt(a), "getYearClassNames", function(e) {
                var t = a.props, r = t.minDate, n = t.maxDate, o = t.selected;
                return ce.default("react-datepicker__year-text", {
                    "react-datepicker__year-text--selected": e === Ie.default(o),
                    "react-datepicker__year-text--disabled": (r || n) && ir(e, a.props),
                    "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
                    "react-datepicker__year-text--today": a.isCurrentYear(e)
                });
            }), Dt(bt(a), "getYearTabIndex", function(e) {
                return a.props.disabledKeyboardNavigation ? "-1" : e === Ie.default(a.props.preSelection) ? "0" : "-1";
            }), a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    for(var e = this, t = [], r = this.props, a = br(r.date, r.yearItemNumber), n = a.startPeriod, o = a.endPeriod, s = function(r) {
                        t.push(de.default.createElement("div", {
                            ref: e.YEAR_REFS[r - n],
                            onClick: function(t) {
                                e.onYearClick(t, r);
                            },
                            onKeyDown: function(t) {
                                e.onYearKeyDown(t, r);
                            },
                            tabIndex: e.getYearTabIndex(r),
                            className: e.getYearClassNames(r),
                            key: r,
                            "aria-current": e.isCurrentYear(r) ? "date" : void 0
                        }, r));
                    }, i = n; i <= o; i++)s(i);
                    return de.default.createElement("div", {
                        className: "react-datepicker__year"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__year-wrapper"
                    }, t));
                }
            }
        ]), r;
    }(de.default.Component), Wr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "onTimeChange", function(e) {
                a.setState({
                    time: e
                });
                var t = new Date;
                t.setHours(e.split(":")[0]), t.setMinutes(e.split(":")[1]), a.props.onChange(t);
            }), Dt(bt(a), "renderTimeInput", function() {
                var e = a.state.time, t = a.props, r = t.date, n = t.timeString, o = t.customTimeInput;
                return o ? de.default.cloneElement(o, {
                    date: r,
                    value: e,
                    onChange: a.onTimeChange
                }) : de.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        a.onTimeChange(e.target.value || n);
                    }
                });
            }), a.state = {
                time: a.props.timeString
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), de.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]), r;
    }(de.default.Component);
    function Br(e) {
        var t = e.className, r = e.children, a = e.showPopperArrow, n = e.arrowProps, o = void 0 === n ? {} : n;
        return de.default.createElement("div", {
            className: t
        }, a && de.default.createElement("div", vt({
            className: "react-datepicker__triangle"
        }, o)), r);
    }
    var Kr = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Hr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "handleClickOutside", function(e) {
                a.props.onClickOutside(e);
            }), Dt(bt(a), "setClickOutsideRef", function() {
                return a.containerRef.current;
            }), Dt(bt(a), "handleDropdownFocus", function(e) {
                (function() {
                    var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return Kr.some(function(t) {
                        return e.indexOf(t) >= 0;
                    });
                })(e.target) && a.props.onDropdownFocus();
            }), Dt(bt(a), "getDateInView", function() {
                var e = a.props, t = e.preSelection, r = e.selected, n = e.openToDate, o = Dr(a.props), s = vr(a.props), i = Yt(), p = n || r || t;
                return p || (o && nt.default(i, o) ? o : s && at.default(i, s) ? s : i);
            }), Dt(bt(a), "increaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: we.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "decreaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Se.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "handleDayClick", function(e, t, r) {
                a.props.onSelect(e, t, r), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleDayMouseEnter", function(e) {
                a.setState({
                    selectingDate: e
                }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
            }), Dt(bt(a), "handleMonthMouseLeave", function() {
                a.setState({
                    selectingDate: null
                }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
            }), Dt(bt(a), "handleYearChange", function(e) {
                a.props.onYearChange && a.props.onYearChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleMonthChange", function(e) {
                a.props.onMonthChange && a.props.onMonthChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleMonthYearChange", function(e) {
                a.handleYearChange(e), a.handleMonthChange(e);
            }), Dt(bt(a), "changeYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: We.default(r, e)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "changeMonth", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Ae.default(r, e)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "changeMonthYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: We.default(Ae.default(r, xe.default(e)), Ie.default(e))
                    };
                }, function() {
                    return a.handleMonthYearChange(a.state.date);
                });
            }), Dt(bt(a), "header", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = Bt(e, a.props.locale, a.props.calendarStartDay), r = [];
                return a.props.showWeekNumbers && r.push(de.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, a.props.weekLabel || "#")), r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(e) {
                    var r = De.default(t, e), n = a.formatWeekday(r, a.props.locale), o = a.props.weekDayClassName ? a.props.weekDayClassName(r) : void 0;
                    return de.default.createElement("div", {
                        key: e,
                        className: ce.default("react-datepicker__day-name", o)
                    }, n);
                }));
            }), Dt(bt(a), "formatWeekday", function(e, t) {
                return a.props.formatWeekDay ? function(e, t, r) {
                    return t(Lt(e, "EEEE", r));
                }(e, a.props.formatWeekDay, t) : a.props.useWeekdaysShort ? function(e, t) {
                    return Lt(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Lt(e, "EEEEEE", t);
                }(e, t);
            }), Dt(bt(a), "decreaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Ce.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "renderPreviousButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = mr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.yearItemNumber, n = void 0 === a ? Ot : a, o = br(Ht(Ce.default(e, n)), n).endPeriod, s = r && Ie.default(r);
                                return s && s > o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = fr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], r = a.decreaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.decreaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.previousMonthButtonLabel, i = o.previousYearButtonLabel, p = a.props, l = p.previousMonthAriaLabel, d = void 0 === l ? "string" == typeof s ? s : "Previous Month" : l, c = p.previousYearAriaLabel, u = void 0 === c ? "string" == typeof i ? i : "Previous Year" : c;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : d
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, n ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
                    }
                }
            }), Dt(bt(a), "increaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ge.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "renderNextButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = yr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.yearItemNumber, n = void 0 === a ? Ot : a, o = br(ge.default(e, n), n).startPeriod, s = r && Ie.default(r);
                                return s && s < o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = hr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        a.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
                        var r = a.increaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.increaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.nextMonthButtonLabel, i = o.nextYearButtonLabel, p = a.props, l = p.nextMonthAriaLabel, d = void 0 === l ? "string" == typeof s ? s : "Next Month" : l, c = p.nextYearAriaLabel, u = void 0 === c ? "string" == typeof i ? i : "Next Year" : c;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : d
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, n ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
                    }
                }
            }), Dt(bt(a), "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = [
                    "react-datepicker__current-month"
                ];
                return a.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), de.default.createElement("div", {
                    className: t.join(" ")
                }, Lt(e, a.props.dateFormat, a.props.locale));
            }), Dt(bt(a), "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showYearDropdown && !e) return de.default.createElement(Mr, {
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    date: a.state.date,
                    onSelect: a.props.onSelect,
                    setOpen: a.props.setOpen,
                    dropdownMode: a.props.dropdownMode,
                    onChange: a.changeYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    year: Ie.default(a.state.date),
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber
                });
            }), Dt(bt(a), "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthDropdown && !e) return de.default.createElement(Nr, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    onChange: a.changeMonth,
                    month: xe.default(a.state.date),
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown
                });
            }), Dt(bt(a), "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthYearDropdown && !e) return de.default.createElement(Ir, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    dateFormat: a.props.dateFormat,
                    onChange: a.changeMonthYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    date: a.state.date,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown
                });
            }), Dt(bt(a), "renderTodayButton", function() {
                if (a.props.todayButton && !a.props.showTimeSelectOnly) return de.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return a.props.onSelect(Ve.default(Yt()), e);
                    }
                }, a.props.todayButton);
            }), Dt(bt(a), "renderDefaultHeader", function(e) {
                var t = e.monthDate, r = e.i;
                return de.default.createElement("div", {
                    className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, a.renderCurrentMonth(t), de.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),
                    onFocus: a.handleDropdownFocus
                }, a.renderMonthDropdown(0 !== r), a.renderMonthYearDropdown(0 !== r), a.renderYearDropdown(0 !== r)), de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), Dt(bt(a), "renderCustomHeader", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.monthDate, r = e.i;
                if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly) return null;
                var n = fr(a.state.date, a.props), o = hr(a.state.date, a.props), s = mr(a.state.date, a.props), i = yr(a.state.date, a.props), p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: a.props.onDropdownFocus
                }, a.props.renderCustomHeader(ut(ut({}, a.state), {}, {
                    customHeaderCount: r,
                    monthDate: t,
                    changeMonth: a.changeMonth,
                    changeYear: a.changeYear,
                    decreaseMonth: a.decreaseMonth,
                    increaseMonth: a.increaseMonth,
                    decreaseYear: a.decreaseYear,
                    increaseYear: a.increaseYear,
                    prevMonthButtonDisabled: n,
                    nextMonthButtonDisabled: o,
                    prevYearButtonDisabled: s,
                    nextYearButtonDisabled: i
                })), p && de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), Dt(bt(a), "renderYearHeader", function() {
                var e = a.state.date, t = a.props, r = t.showYearPicker, n = br(e, t.yearItemNumber), o = n.startPeriod, s = n.endPeriod;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, r ? "".concat(o, " - ").concat(s) : Ie.default(e));
            }), Dt(bt(a), "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== a.props.renderCustomHeader:
                        return a.renderCustomHeader(e);
                    case a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker:
                        return a.renderYearHeader(e);
                    default:
                        return a.renderDefaultHeader(e);
                }
            }), Dt(bt(a), "renderMonths", function() {
                if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
                    for(var e = [], t = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, r = Se.default(a.state.date, t), n = 0; n < a.props.monthsShown; ++n){
                        var o = n - a.props.monthSelectedIn, s = we.default(r, o), i = "month-".concat(n), p = n < a.props.monthsShown - 1, l = n > 0;
                        e.push(de.default.createElement("div", {
                            key: i,
                            ref: function(e) {
                                a.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, a.renderHeader({
                            monthDate: s,
                            i: n
                        }), de.default.createElement(Fr, {
                            chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                            onChange: a.changeMonthYear,
                            day: s,
                            dayClassName: a.props.dayClassName,
                            calendarStartDay: a.props.calendarStartDay,
                            monthClassName: a.props.monthClassName,
                            onDayClick: a.handleDayClick,
                            handleOnKeyDown: a.props.handleOnDayKeyDown,
                            onDayMouseEnter: a.handleDayMouseEnter,
                            onMouseLeave: a.handleMonthMouseLeave,
                            onWeekSelect: a.props.onWeekSelect,
                            orderInDisplay: n,
                            formatWeekNumber: a.props.formatWeekNumber,
                            locale: a.props.locale,
                            minDate: a.props.minDate,
                            maxDate: a.props.maxDate,
                            excludeDates: a.props.excludeDates,
                            excludeDateIntervals: a.props.excludeDateIntervals,
                            highlightDates: a.props.highlightDates,
                            selectingDate: a.state.selectingDate,
                            includeDates: a.props.includeDates,
                            includeDateIntervals: a.props.includeDateIntervals,
                            inline: a.props.inline,
                            shouldFocusDayInline: a.props.shouldFocusDayInline,
                            fixedHeight: a.props.fixedHeight,
                            filterDate: a.props.filterDate,
                            preSelection: a.props.preSelection,
                            setPreSelection: a.props.setPreSelection,
                            selected: a.props.selected,
                            selectsStart: a.props.selectsStart,
                            selectsEnd: a.props.selectsEnd,
                            selectsRange: a.props.selectsRange,
                            selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                            showWeekNumbers: a.props.showWeekNumbers,
                            startDate: a.props.startDate,
                            endDate: a.props.endDate,
                            peekNextMonth: a.props.peekNextMonth,
                            setOpen: a.props.setOpen,
                            shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                            renderDayContents: a.props.renderDayContents,
                            disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                            showMonthYearPicker: a.props.showMonthYearPicker,
                            showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                            showYearPicker: a.props.showYearPicker,
                            showQuarterYearPicker: a.props.showQuarterYearPicker,
                            isInputFocused: a.props.isInputFocused,
                            containerRef: a.containerRef,
                            monthShowsDuplicateDaysEnd: p,
                            monthShowsDuplicateDaysStart: l
                        })));
                    }
                    return e;
                }
            }), Dt(bt(a), "renderYears", function() {
                if (!a.props.showTimeSelectOnly) return a.props.showYearPicker ? de.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, a.renderHeader(), de.default.createElement(qr, vt({
                    onDayClick: a.handleDayClick,
                    date: a.state.date
                }, a.props))) : void 0;
            }), Dt(bt(a), "renderTimeSection", function() {
                if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly)) return de.default.createElement(Ar, {
                    selected: a.props.selected,
                    openToDate: a.props.openToDate,
                    onChange: a.props.onTimeChange,
                    timeClassName: a.props.timeClassName,
                    format: a.props.timeFormat,
                    includeTimes: a.props.includeTimes,
                    intervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    todayButton: a.props.todayButton,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    monthRef: a.state.monthContainer,
                    injectTimes: a.props.injectTimes,
                    locale: a.props.locale,
                    handleOnKeyDown: a.props.handleOnKeyDown,
                    showTimeSelectOnly: a.props.showTimeSelectOnly
                });
            }), Dt(bt(a), "renderInputTimeSection", function() {
                var e = new Date(a.props.selected), t = Tt(e) && Boolean(a.props.selected) ? "".concat(kr(e.getHours()), ":").concat(kr(e.getMinutes())) : "";
                if (a.props.showTimeInput) return de.default.createElement(Wr, {
                    date: e,
                    timeString: t,
                    timeInputLabel: a.props.timeInputLabel,
                    onChange: a.props.onTimeChange,
                    customTimeInput: a.props.customTimeInput
                });
            }), a.containerRef = de.default.createRef(), a.state = {
                date: a.getDateInView(),
                selectingDate: null,
                monthContainer: null
            }, a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.props.preSelection && !$t(this.props.preSelection, e.preSelection) ? this.setState({
                        date: this.props.preSelection
                    }) : this.props.openToDate && !$t(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || Br;
                    return de.default.createElement("div", {
                        ref: this.containerRef
                    }, de.default.createElement(e, {
                        className: ce.default("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showPopperArrow: this.props.showPopperArrow,
                        arrowProps: this.props.arrowProps
                    }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.props.children));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        monthSelectedIn: 0,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: Ot
                    };
                }
            }
        ]), r;
    }(de.default.Component), jr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), (a = t.call(this, e)).el = document.createElement("div"), a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function() {
                    return dt.default.createPortal(this.props.children, this.el);
                }
            }
        ]), r;
    }(de.default.Component), Qr = function(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, Vr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "getTabChildren", function() {
                return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(Qr);
            }), Dt(bt(a), "handleFocusStart", function(e) {
                var t = a.getTabChildren();
                t && t.length > 1 && t[t.length - 1].focus();
            }), Dt(bt(a), "handleFocusEnd", function(e) {
                var t = a.getTabChildren();
                t && t.length > 1 && t[0].focus();
            }), a.tabLoopRef = de.default.createRef(), a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return this.props.enableTabLoop ? de.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Ur = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            return ht(this, r), t.apply(this, arguments);
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this.props, r = t.className, a = t.wrapperClassName, n = t.hidePopper, o = t.popperComponent, s = t.popperModifiers, i = t.popperPlacement, p = t.popperProps, l = t.targetComponent, d = t.enableTabLoop, c = t.popperOnKeyDown, u = t.portalId, f = t.portalHost;
                    if (!n) {
                        var h = ce.default("react-datepicker-popper", r);
                        e = de.default.createElement(pe.Popper, vt({
                            modifiers: s,
                            placement: i
                        }, p), function(e) {
                            var t = e.ref, r = e.style, a = e.placement, n = e.arrowProps;
                            return de.default.createElement(Vr, {
                                enableTabLoop: d
                            }, de.default.createElement("div", {
                                ref: t,
                                style: r,
                                className: h,
                                "data-placement": a,
                                onKeyDown: c
                            }, de.default.cloneElement(o, {
                                arrowProps: n
                            })));
                        });
                    }
                    this.props.popperContainer && (e = de.default.createElement(this.props.popperContainer, {}, e)), u && !n && (e = de.default.createElement(jr, {
                        portalId: u,
                        portalHost: f
                    }, e));
                    var m = ce.default("react-datepicker-wrapper", a);
                    return de.default.createElement(pe.Manager, {
                        className: "react-datepicker-manager"
                    }, de.default.createElement(pe.Reference, null, function(e) {
                        var t = e.ref;
                        return de.default.createElement("div", {
                            ref: t,
                            className: m
                        }, l);
                    }), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0,
                        popperModifiers: [],
                        popperProps: {},
                        popperPlacement: "bottom-start"
                    };
                }
            }
        ]), r;
    }(de.default.Component), $r = "react-datepicker-ignore-onclickoutside", zr = lt.default(Hr);
    var Gr = "Date input not valid.", Jr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "getPreSelection", function() {
                return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : Yt();
            }), Dt(bt(a), "calcInitialState", function() {
                var e, t = a.getPreSelection(), r = Dr(a.props), n = vr(a.props), o = r && nt.default(t, Ve.default(r)) ? r : n && at.default(t, Je.default(n)) ? n : t;
                return {
                    open: a.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (e = a.props.selectsRange ? a.props.startDate : a.props.selected) && void 0 !== e ? e : o,
                    highlightDates: wr(a.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1
                };
            }), Dt(bt(a), "clearPreventFocusTimeout", function() {
                a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
            }), Dt(bt(a), "setFocus", function() {
                a.input && a.input.focus && a.input.focus({
                    preventScroll: !0
                });
            }), Dt(bt(a), "setBlur", function() {
                a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
            }), Dt(bt(a), "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                a.setState({
                    open: e,
                    preSelection: e && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection,
                    lastPreSelectChange: Zr
                }, function() {
                    e || a.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && a.setBlur(), a.setState({
                            inputValue: null
                        });
                    });
                });
            }), Dt(bt(a), "inputOk", function() {
                return ue.default(a.state.preSelection);
            }), Dt(bt(a), "isCalendarOpen", function() {
                return void 0 === a.props.open ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
            }), Dt(bt(a), "handleFocus", function(e) {
                a.state.preventFocus || (a.props.onFocus(e), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({
                    focused: !0
                });
            }), Dt(bt(a), "cancelFocusInput", function() {
                clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
            }), Dt(bt(a), "deferFocusInput", function() {
                a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
                    return a.setFocus();
                }, 1);
            }), Dt(bt(a), "handleDropdownFocus", function() {
                a.cancelFocusInput();
            }), Dt(bt(a), "handleBlur", function(e) {
                (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(e), a.setState({
                    focused: !1
                });
            }), Dt(bt(a), "handleCalendarClickOutside", function(e) {
                a.props.inline || a.setOpen(!1), a.props.onClickOutside(e), a.props.withPortal && e.preventDefault();
            }), Dt(bt(a), "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                var n = t[0];
                if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(bt(a), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
                    a.setState({
                        inputValue: n.target.value,
                        lastPreSelectChange: Xr
                    });
                    var o = It(n.target.value, a.props.dateFormat, a.props.locale, a.props.strictParsing, a.props.minDate);
                    !o && n.target.value || a.setSelected(o, n, !0);
                }
            }), Dt(bt(a), "handleSelect", function(e, t, r) {
                if (a.setState({
                    preventFocus: !0
                }, function() {
                    return a.preventFocusTimeout = setTimeout(function() {
                        return a.setState({
                            preventFocus: !1
                        });
                    }, 50), a.preventFocusTimeout;
                }), a.props.onChangeRaw && a.props.onChangeRaw(t), a.setSelected(e, t, !1, r), !a.props.shouldCloseOnSelect || a.props.showTimeSelect) a.setPreSelection(e);
                else if (!a.props.inline) {
                    a.props.selectsRange || a.setOpen(!1);
                    var n = a.props, o = n.startDate, s = n.endDate;
                    !o || s || nt.default(e, o) || a.setOpen(!1);
                }
            }), Dt(bt(a), "setSelected", function(e, t, r, n) {
                var o = e;
                if (null === o || !rr(o, a.props)) {
                    var s = a.props, i = s.onChange, p = s.selectsRange, l = s.startDate, d = s.endDate;
                    if (!zt(a.props.selected, o) || a.props.allowSameDay || p) {
                        if (null !== o && (!a.props.selected || r && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (o = Ft(o, {
                            hour: Pe.default(a.props.selected),
                            minute: Me.default(a.props.selected),
                            second: _e.default(a.props.selected)
                        })), a.props.inline || a.setState({
                            preSelection: o
                        }), a.props.focusSelectedMonth || a.setState({
                            monthSelectedIn: n
                        })), p) {
                            var c = l && !d, u = l && d;
                            !l && !d ? i([
                                o,
                                null
                            ], t) : c && (nt.default(o, l) ? i([
                                o,
                                null
                            ], t) : i([
                                l,
                                o
                            ], t)), u && i([
                                o,
                                null
                            ], t);
                        } else i(o, t);
                    }
                    r || (a.props.onSelect(o, t), a.setState({
                        inputValue: null
                    }));
                }
            }), Dt(bt(a), "setPreSelection", function(e) {
                var t = void 0 !== a.props.minDate, r = void 0 !== a.props.maxDate, n = !0;
                if (e) {
                    var o = Ve.default(e);
                    if (t && r) n = Gt(e, a.props.minDate, a.props.maxDate);
                    else if (t) {
                        var s = Ve.default(a.props.minDate);
                        n = at.default(e, s) || zt(o, s);
                    } else if (r) {
                        var i = Je.default(a.props.maxDate);
                        n = nt.default(e, i) || zt(o, i);
                    }
                }
                n && a.setState({
                    preSelection: e
                });
            }), Dt(bt(a), "handleTimeChange", function(e) {
                var t = Ft(a.props.selected ? a.props.selected : a.getPreSelection(), {
                    hour: Pe.default(e),
                    minute: Me.default(e)
                });
                a.setState({
                    preSelection: t
                }), a.props.onChange(t), a.props.shouldCloseOnSelect && a.setOpen(!1), a.props.showTimeInput && a.setOpen(!0), a.setState({
                    inputValue: null
                });
            }), Dt(bt(a), "onInputClick", function() {
                a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
            }), Dt(bt(a), "onInputKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key;
                if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
                    if (a.state.open) {
                        if ("ArrowDown" === t || "ArrowUp" === t) {
                            e.preventDefault();
                            var r = a.calendar.componentNode && a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
                            return void (r && r.focus({
                                preventScroll: !0
                            }));
                        }
                        var n = Yt(a.state.preSelection);
                        "Enter" === t ? (e.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === Zr ? (a.handleSelect(n, e), !a.props.shouldCloseOnSelect && a.setPreSelection(n)) : a.setOpen(!1)) : "Escape" === t && (e.preventDefault(), a.setOpen(!1)), a.inputOk() || a.props.onInputError({
                            code: 1,
                            msg: Gr
                        });
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || a.onInputClick();
            }), Dt(bt(a), "onDayKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key, r = Yt(a.state.preSelection);
                if ("Enter" === t) e.preventDefault(), a.handleSelect(r, e), !a.props.shouldCloseOnSelect && a.setPreSelection(r);
                else if ("Escape" === t) e.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({
                    code: 1,
                    msg: Gr
                });
                else if (!a.props.disabledKeyboardNavigation) {
                    var n;
                    switch(t){
                        case "ArrowLeft":
                            n = ke.default(r, 1);
                            break;
                        case "ArrowRight":
                            n = De.default(r, 1);
                            break;
                        case "ArrowUp":
                            n = be.default(r, 1);
                            break;
                        case "ArrowDown":
                            n = ve.default(r, 1);
                            break;
                        case "PageUp":
                            n = Se.default(r, 1);
                            break;
                        case "PageDown":
                            n = we.default(r, 1);
                            break;
                        case "Home":
                            n = Ce.default(r, 1);
                            break;
                        case "End":
                            n = ge.default(r, 1);
                    }
                    if (!n) return void (a.props.onInputError && a.props.onInputError({
                        code: 1,
                        msg: Gr
                    }));
                    if (e.preventDefault(), a.setState({
                        lastPreSelectChange: Zr
                    }), a.props.adjustDateOnChange && a.setSelected(n), a.setPreSelection(n), a.props.inline) {
                        var o = xe.default(r), s = xe.default(n), i = Ie.default(r), p = Ie.default(n);
                        o !== s || i !== p ? a.setState({
                            shouldFocusDayInline: !0
                        }) : a.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), Dt(bt(a), "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), a.setState({
                    preventFocus: !0
                }, function() {
                    a.setOpen(!1), setTimeout(function() {
                        a.setFocus(), a.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), Dt(bt(a), "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), a.props.selectsRange ? a.props.onChange([
                    null,
                    null
                ], e) : a.props.onChange(null, e), a.setState({
                    inputValue: null
                });
            }), Dt(bt(a), "clear", function() {
                a.onClearClick();
            }), Dt(bt(a), "onScroll", function(e) {
                "boolean" == typeof a.props.closeOnScroll && a.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || a.setOpen(!1) : "function" == typeof a.props.closeOnScroll && a.props.closeOnScroll(e) && a.setOpen(!1);
            }), Dt(bt(a), "renderCalendar", function() {
                return a.props.inline || a.isCalendarOpen() ? de.default.createElement(zr, {
                    ref: function(e) {
                        a.calendar = e;
                    },
                    locale: a.props.locale,
                    calendarStartDay: a.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    setOpen: a.setOpen,
                    shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                    dateFormat: a.props.dateFormatCalendar,
                    useWeekdaysShort: a.props.useWeekdaysShort,
                    formatWeekDay: a.props.formatWeekDay,
                    dropdownMode: a.props.dropdownMode,
                    selected: a.props.selected,
                    preSelection: a.state.preSelection,
                    onSelect: a.handleSelect,
                    onWeekSelect: a.props.onWeekSelect,
                    openToDate: a.props.openToDate,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    selectsStart: a.props.selectsStart,
                    selectsEnd: a.props.selectsEnd,
                    selectsRange: a.props.selectsRange,
                    startDate: a.props.startDate,
                    endDate: a.props.endDate,
                    excludeDates: a.props.excludeDates,
                    excludeDateIntervals: a.props.excludeDateIntervals,
                    filterDate: a.props.filterDate,
                    onClickOutside: a.handleCalendarClickOutside,
                    formatWeekNumber: a.props.formatWeekNumber,
                    highlightDates: a.state.highlightDates,
                    includeDates: a.props.includeDates,
                    includeDateIntervals: a.props.includeDateIntervals,
                    includeTimes: a.props.includeTimes,
                    injectTimes: a.props.injectTimes,
                    inline: a.props.inline,
                    shouldFocusDayInline: a.state.shouldFocusDayInline,
                    peekNextMonth: a.props.peekNextMonth,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showPreviousMonths: a.props.showPreviousMonths,
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showWeekNumbers: a.props.showWeekNumbers,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    forceShowMonthNavigation: a.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: a.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
                    todayButton: a.props.todayButton,
                    weekLabel: a.props.weekLabel,
                    outsideClickIgnoreClass: $r,
                    fixedHeight: a.props.fixedHeight,
                    monthsShown: a.props.monthsShown,
                    monthSelectedIn: a.state.monthSelectedIn,
                    onDropdownFocus: a.handleDropdownFocus,
                    onMonthChange: a.props.onMonthChange,
                    onYearChange: a.props.onYearChange,
                    dayClassName: a.props.dayClassName,
                    weekDayClassName: a.props.weekDayClassName,
                    monthClassName: a.props.monthClassName,
                    timeClassName: a.props.timeClassName,
                    showTimeSelect: a.props.showTimeSelect,
                    showTimeSelectOnly: a.props.showTimeSelectOnly,
                    onTimeChange: a.handleTimeChange,
                    timeFormat: a.props.timeFormat,
                    timeIntervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    className: a.props.calendarClassName,
                    container: a.props.calendarContainer,
                    yearItemNumber: a.props.yearItemNumber,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber,
                    previousMonthAriaLabel: a.props.previousMonthAriaLabel,
                    previousMonthButtonLabel: a.props.previousMonthButtonLabel,
                    nextMonthAriaLabel: a.props.nextMonthAriaLabel,
                    nextMonthButtonLabel: a.props.nextMonthButtonLabel,
                    previousYearAriaLabel: a.props.previousYearAriaLabel,
                    previousYearButtonLabel: a.props.previousYearButtonLabel,
                    nextYearAriaLabel: a.props.nextYearAriaLabel,
                    nextYearButtonLabel: a.props.nextYearButtonLabel,
                    timeInputLabel: a.props.timeInputLabel,
                    disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                    renderCustomHeader: a.props.renderCustomHeader,
                    popperProps: a.props.popperProps,
                    renderDayContents: a.props.renderDayContents,
                    onDayMouseEnter: a.props.onDayMouseEnter,
                    onMonthMouseLeave: a.props.onMonthMouseLeave,
                    selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                    showTimeInput: a.props.showTimeInput,
                    showMonthYearPicker: a.props.showMonthYearPicker,
                    showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                    showYearPicker: a.props.showYearPicker,
                    showQuarterYearPicker: a.props.showQuarterYearPicker,
                    showPopperArrow: a.props.showPopperArrow,
                    excludeScrollbar: a.props.excludeScrollbar,
                    handleOnKeyDown: a.props.onKeyDown,
                    handleOnDayKeyDown: a.onDayKeyDown,
                    isInputFocused: a.state.focused,
                    customTimeInput: a.props.customTimeInput,
                    setPreSelection: a.setPreSelection
                }, a.props.children) : null;
            }), Dt(bt(a), "renderDateInput", function() {
                var e, t = ce.default(a.props.className, Dt({}, $r, a.state.open)), r = a.props.customInput || de.default.createElement("input", {
                    type: "text"
                }), n = a.props.customInputRef || "ref", o = "string" == typeof a.props.value ? a.props.value : "string" == typeof a.state.inputValue ? a.state.inputValue : a.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var a = Rt(e, r), n = t ? Rt(t, r) : "";
                    return "".concat(a, " - ").concat(n);
                }(a.props.startDate, a.props.endDate, a.props) : Rt(a.props.selected, a.props);
                return de.default.cloneElement(r, (Dt(e = {}, n, function(e) {
                    a.input = e;
                }), Dt(e, "value", o), Dt(e, "onBlur", a.handleBlur), Dt(e, "onChange", a.handleChange), Dt(e, "onClick", a.onInputClick), Dt(e, "onFocus", a.handleFocus), Dt(e, "onKeyDown", a.onInputKeyDown), Dt(e, "id", a.props.id), Dt(e, "name", a.props.name), Dt(e, "autoFocus", a.props.autoFocus), Dt(e, "placeholder", a.props.placeholderText), Dt(e, "disabled", a.props.disabled), Dt(e, "autoComplete", a.props.autoComplete), Dt(e, "className", ce.default(r.props.className, t)), Dt(e, "title", a.props.title), Dt(e, "readOnly", a.props.readOnly), Dt(e, "required", a.props.required), Dt(e, "tabIndex", a.props.tabIndex), Dt(e, "aria-describedby", a.props.ariaDescribedBy), Dt(e, "aria-invalid", a.props.ariaInvalid), Dt(e, "aria-labelledby", a.props.ariaLabelledBy), Dt(e, "aria-required", a.props.ariaRequired), e));
            }), Dt(bt(a), "renderClearButton", function() {
                var e = a.props, t = e.isClearable, r = e.selected, n = e.startDate, o = e.endDate, s = e.clearButtonTitle, i = e.clearButtonClassName, p = void 0 === i ? "" : i, l = e.ariaLabelClose, d = void 0 === l ? "Close" : l;
                return !t || null == r && null == n && null == o ? null : de.default.createElement("button", {
                    type: "button",
                    className: "react-datepicker__close-icon ".concat(p).trim(),
                    "aria-label": d,
                    onClick: a.onClearClick,
                    title: s,
                    tabIndex: -1
                });
            }), a.state = a.calcInitialState(), a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, a;
                    e.inline && (r = e.selected, a = this.props.selected, r && a ? xe.default(r) !== xe.default(a) || Ie.default(r) !== Ie.default(a) : r !== a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: wr(this.props.highlightDates)
                    }), t.focused || zt(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-container"
                    }, this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    if (this.props.inline) return e;
                    if (this.props.withPortal) {
                        var t = this.state.open ? de.default.createElement("div", {
                            className: "react-datepicker__portal"
                        }, e) : null;
                        return this.state.open && this.props.portalId && (t = de.default.createElement(jr, {
                            portalId: this.props.portalId,
                            portalHost: this.props.portalHost
                        }, t)), de.default.createElement("div", null, this.renderInputContainer(), t);
                    }
                    return de.default.createElement(Ur, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        selectsDisabledDaysInRange: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        strictParsing: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthAriaLabel: "Previous Month",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthAriaLabel: "Next Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearAriaLabel: "Previous Year",
                        previousYearButtonLabel: "Previous Year",
                        nextYearAriaLabel: "Next Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: Ot,
                        renderDayContents: function(e) {
                            return e;
                        },
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Xr = "input", Zr = "navigate";
    e.CalendarContainer = Br, e.default = Jr, e.getDefaultLocale = Jt, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : globalThis;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});



var $f5d42bf9f2214658$exports = {};
"use strict";
var $f5d42bf9f2214658$var$__importDefault = $f5d42bf9f2214658$exports && $f5d42bf9f2214658$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f5d42bf9f2214658$exports, "__esModule", {
    value: true
});
$f5d42bf9f2214658$exports.default = void 0;
var $12bf920d97bb896c$exports = {};
"use strict";
var $12bf920d97bb896c$var$__createBinding = $12bf920d97bb896c$exports && $12bf920d97bb896c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $12bf920d97bb896c$var$__setModuleDefault = $12bf920d97bb896c$exports && $12bf920d97bb896c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $12bf920d97bb896c$var$__importStar = $12bf920d97bb896c$exports && $12bf920d97bb896c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $12bf920d97bb896c$var$__createBinding(result, mod, k);
    }
    $12bf920d97bb896c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($12bf920d97bb896c$exports, "__esModule", {
    value: true
});

var $12bf920d97bb896c$var$react_1 = $12bf920d97bb896c$var$__importStar((parcelRequire("7fPBF")));
function $12bf920d97bb896c$var$FadeIn(props) {
    var _a = $12bf920d97bb896c$var$react_1.useState(0), maxIsVisible = _a[0], setMaxIsVisible = _a[1];
    var transitionDuration = props.transitionDuration || 400;
    var delay = props.delay || 50;
    var WrapperTag = props.wrapperTag || "div";
    var ChildTag = props.childTag || "div";
    var visible = typeof props.visible === "undefined" ? true : props.visible;
    $12bf920d97bb896c$var$react_1.useEffect(function() {
        var count = $12bf920d97bb896c$var$react_1.default.Children.count(props.children);
        if (!visible) // Animate all children out
        count = 0;
        if (count == maxIsVisible) {
            // We're done updating maxVisible, notify when animation is done
            var timeout_1 = setTimeout(function() {
                if (props.onComplete) props.onComplete();
            }, transitionDuration);
            return function() {
                return clearTimeout(timeout_1);
            };
        }
        // Move maxIsVisible toward count
        var increment = count > maxIsVisible ? 1 : -1;
        var timeout = setTimeout(function() {
            setMaxIsVisible(maxIsVisible + increment);
        }, delay);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        $12bf920d97bb896c$var$react_1.default.Children.count(props.children),
        delay,
        maxIsVisible,
        visible,
        transitionDuration
    ]);
    return $12bf920d97bb896c$var$react_1.default.createElement(WrapperTag, {
        className: props.className
    }, $12bf920d97bb896c$var$react_1.default.Children.map(props.children, function(child, i) {
        return $12bf920d97bb896c$var$react_1.default.createElement(ChildTag, {
            className: props.childClassName,
            style: {
                transition: "opacity " + transitionDuration + "ms, transform " + transitionDuration + "ms",
                transform: maxIsVisible > i ? "none" : "translateY(20px)",
                opacity: maxIsVisible > i ? 1 : 0
            }
        }, child);
    }));
}
$12bf920d97bb896c$exports.default = $12bf920d97bb896c$var$FadeIn;


Object.defineProperty($f5d42bf9f2214658$exports, "default", {
    enumerable: true,
    get: function() {
        return $f5d42bf9f2214658$var$__importDefault($12bf920d97bb896c$exports).default;
    }
});


function $1931765328266215$export$2e2bcd8739ae039() {
    var _location_state;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    const location = (0, $6de75bb8982f6eaa$export$45d76561a5302f2b)();
    const [searchParams] = (0, $1a29469ea96a6022$export$f1a78c17382fe22a)();
    const isMountedRef = (0, $7fPBF.useRef)(true);
    // allow prefill from external import
    const externalPrefill = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.externalEvent;
    // Get query params
    const queryTitle = searchParams.get('title');
    const queryDescription = searchParams.get('description');
    const queryRegistrationURL = searchParams.get('registrationURL');
    const queryThumbnailURL = searchParams.get('thumbnailURL');
    const queryExternalEventID = searchParams.get('externalEventID');
    const queryExternalProvider = searchParams.get('provider');
    const [title, setTitle] = (0, $7fPBF.useState)((externalPrefill === null || externalPrefill === void 0 ? void 0 : externalPrefill.name) || queryTitle || '');
    const [startsAt, setStartsAt] = (0, $7fPBF.useState)(new Date());
    const [endsAt, setEndsAt] = (0, $7fPBF.useState)(new Date());
    const [showTimes, setShowTimes] = (0, $7fPBF.useState)(true);
    const [description, setDescription] = (0, $7fPBF.useState)(queryDescription || '');
    const [locationText, setLocationText] = (0, $7fPBF.useState)('');
    const [registrationURL, setRegistrationURL] = (0, $7fPBF.useState)(queryRegistrationURL || '');
    const [thumbnailURL, setThumbnailURL] = (0, $7fPBF.useState)((externalPrefill === null || externalPrefill === void 0 ? void 0 : externalPrefill.thumbnailImageURL) || queryThumbnailURL || '');
    const [saving, setSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [externalEventDetails, setExternalEventDetails] = (0, $7fPBF.useState)(null);
    const [loadingExternalDetails, setLoadingExternalDetails] = (0, $7fPBF.useState)(false);
    const [roleMap, setRoleMap] = (0, $7fPBF.useState)({});
    // Fetch external event details if externalEventID and provider are present
    (0, $7fPBF.useEffect)(()=>{
        if (!queryExternalEventID || !queryExternalProvider || !auth.churchId) return;
        let isMounted = true;
        const fetchDetails = async ()=>{
            setLoadingExternalDetails(true);
            try {
                const resp = await (0, $6857e104788587b0$export$2e2bcd8739ae039).fetchExternalEventDetails(auth.churchId || '', queryExternalProvider, queryExternalEventID, auth);
                if (isMounted) {
                    if (!resp.error && resp.body) setExternalEventDetails(resp.body);
                }
            } catch (err) {
                if (isMounted) console.error('Failed to fetch external event details:', err);
            } finally{
                if (isMounted) setLoadingExternalDetails(false);
            }
        };
        fetchDetails();
        return ()=>{
            isMounted = false;
        };
    }, [
        queryExternalEventID,
        queryExternalProvider,
        auth.churchId,
        auth
    ]);
    // Cleanup ref on unmount to prevent state updates after navigation
    (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    const onSubmit = async ()=>{
        if (!auth.churchId || !canSubmit()) return;
        setSaving(true);
        setError(null);
        const payload = {
            id: '',
            churchID: auth.churchId,
            title: title,
            startsAt: startsAt ? startsAt.toISOString() : new Date().toISOString(),
            endsAt: endsAt ? endsAt.toISOString() : new Date().toISOString(),
            showTimes: showTimes,
            description: description || null,
            location: locationText || null,
            registrationURL: registrationURL || null,
            thumbnailURL: thumbnailURL || null,
            waivers: []
        };
        let planningCenterMetadata = null;
        if (queryExternalProvider === 'PLANNING_CENTER') planningCenterMetadata = {
            signupID: queryExternalEventID || '',
            selectionTypeMap: roleMap
        };
        try {
            const resp = await (0, $6857e104788587b0$export$2e2bcd8739ae039).createEvent(auth.churchId, {
                event: payload,
                planningCenterMetadata: planningCenterMetadata
            }, auth);
            if (isMountedRef.current) {
                if (resp.error) setError(resp.error);
                else navigate('/events');
            }
        } catch (err) {
            if (isMountedRef.current) setError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to create event');
        } finally{
            if (isMountedRef.current) setSaving(false);
        }
    };
    const canSubmit = ()=>{
        if (saving) return false;
        if (!title || title.trim().length === 0) return false;
        if (!startsAt || !endsAt) return false;
        if (queryExternalProvider !== null && externalEventDetails === null) return false; // if we have a provider, we MUST wait for these to be loaded.
        // If using Planning Center, ensure all role mappings are set
        if (queryExternalProvider === 'PLANNING_CENTER') {
            var _externalEventDetails_planningCenter;
            const selectionTypes = (externalEventDetails === null || externalEventDetails === void 0 ? void 0 : (_externalEventDetails_planningCenter = externalEventDetails.planningCenter) === null || _externalEventDetails_planningCenter === void 0 ? void 0 : _externalEventDetails_planningCenter.selectionTypes) || [];
            if (selectionTypes.length > 0) {
                const allRolesMapped = selectionTypes.every((type)=>roleMap[type.id]);
                if (!allRolesMapped) return false;
            }
        }
        return true;
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "create-event-internal",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: "",
                showBackButton: true,
                backLocation: "/events/create"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "form",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        children: "New Event"
                    }),
                    error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "error",
                        children: error
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Details"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "input",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    type: "text",
                                    name: "title",
                                    placeholder: "Title",
                                    value: title,
                                    onChange: (e)=>setTitle(e.target.value),
                                    disabled: saving
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1931765328266215$var$Separator, {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "input",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                    name: "description",
                                    placeholder: "Event Description",
                                    value: description,
                                    onChange: (e)=>setDescription(e.target.value),
                                    disabled: saving
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section",
                        style: {
                            marginTop: 18
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "input",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    type: "text",
                                    name: "registrationURL",
                                    placeholder: "Registration Link",
                                    value: registrationURL,
                                    onChange: (e)=>setRegistrationURL(e.target.value),
                                    disabled: saving
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1931765328266215$var$Separator, {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "input",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    type: "text",
                                    name: "location",
                                    placeholder: "Location",
                                    value: locationText,
                                    onChange: (e)=>setLocationText(e.target.value),
                                    disabled: saving
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Schedule"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "input",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "Start Date"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c51974f9c71f40b1$exports))), {
                                        className: "date-picker",
                                        selected: startsAt,
                                        disabled: saving,
                                        showTimeInput: true,
                                        timeInputLabel: "Time",
                                        timeFormat: "p",
                                        dateFormat: "Pp",
                                        onChange: (date)=>{
                                            if (saving) return;
                                            setStartsAt(date);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1931765328266215$var$Separator, {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "input",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "End Date"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c51974f9c71f40b1$exports))), {
                                        className: "date-picker",
                                        selected: endsAt,
                                        disabled: saving,
                                        showTimeInput: true,
                                        timeInputLabel: "Time",
                                        timeFormat: "p",
                                        dateFormat: "Pp",
                                        onChange: (date)=>{
                                            if (saving) return;
                                            setEndsAt(date);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1931765328266215$var$Separator, {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "input",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "Show times"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: showTimes,
                                        onChange: (e)=>setShowTimes(e.target.checked),
                                        disabled: saving
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "footnote",
                        children: 'Turning on "Show times" will display the time alongside the event dates in the Salt app.'
                    }),
                    loadingExternalDetails ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "footnote",
                        children: "Loading external event details..."
                    }) : null,
                    queryExternalProvider === 'PLANNING_CENTER' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1931765328266215$var$PlanningCenterSpecificConfig, {
                        details: externalEventDetails,
                        roleMap: roleMap,
                        setRoleMap: setRoleMap,
                        saving: saving
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        disabled: !canSubmit(),
                        className: "submit",
                        onClick: (e)=>{
                            e.preventDefault();
                            onSubmit();
                        },
                        children: saving ? "Saving..." : "Create Event"
                    })
                ]
            })
        ]
    });
}
function $1931765328266215$var$PlanningCenterSpecificConfig({ details: details, roleMap: roleMap, setRoleMap: setRoleMap, saving: saving }) {
    var _details_planningCenter;
    if (!details || !((_details_planningCenter = details.planningCenter) === null || _details_planningCenter === void 0 ? void 0 : _details_planningCenter.selectionTypes) || details.planningCenter.selectionTypes.length === 0) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f5d42bf9f2214658$exports))), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "planning-center-config",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    children: "Role Mapping"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "section",
                    children: details.planningCenter.selectionTypes.map((selectionType, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                idx > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1931765328266215$var$Separator, {}),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "input",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            children: selectionType.name
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                            className: "role-select",
                                            value: roleMap[selectionType.id] || '',
                                            onChange: (e)=>setRoleMap((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, roleMap), {
                                                    [selectionType.id]: e.target.value
                                                })),
                                            disabled: saving,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                    value: "",
                                                    children: "Select a role..."
                                                }),
                                                [
                                                    'standard',
                                                    'volunteer',
                                                    'admin'
                                                ].map((role)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                        value: role,
                                                        children: role.charAt(0).toUpperCase() + role.slice(1)
                                                    }, role))
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, selectionType.id))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "footnote",
                    children: "Map each Planning Center selection type to a Salt role, so that if an attendee links their registration to their Salt account they will have an appropriate level of access."
                })
            ]
        })
    });
}
function $1931765328266215$var$Separator() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            width: "100%",
            height: 1,
            backgroundColor: "#eaeaea",
            opacity: 0.10,
            margin: '12px 0'
        }
    });
}




var $7fPBF = parcelRequire("7fPBF");







function $fd33414c39acb8d6$export$2e2bcd8739ae039() {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    const [searchParams] = (0, $1a29469ea96a6022$export$f1a78c17382fe22a)();
    const [externalLoading, setExternalLoading] = (0, $7fPBF.useState)(false);
    const [externalError, setExternalError] = (0, $7fPBF.useState)(null);
    const [externalEvents, setExternalEvents] = (0, $7fPBF.useState)(null);
    const provider = searchParams.get('provider');
    let providerName = '';
    if (provider === 'PLANNING_CENTER') providerName = 'Planning Center';
    // If provider is missing/unsupported, declaratively redirect back to the chooser.
    if (!provider || provider !== 'PLANNING_CENTER') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$444b3ab0cb9aec40), {
        to: "/events/create",
        replace: true
    });
    // Only fetch external events when we have a valid provider and church context.
    (0, $7fPBF.useEffect)(()=>{
        if (!provider || provider !== 'PLANNING_CENTER') return;
        let isMounted = true;
        const performFetch = async ()=>{
            if (!auth.churchId) return;
            setExternalLoading(true);
            setExternalError(null);
            setExternalEvents(null);
            try {
                const resp = await (0, $6857e104788587b0$export$2e2bcd8739ae039).fetchExternalImportOptions(auth.churchId, provider, auth);
                if (!isMounted) return;
                if (resp.error) setExternalError(resp.error);
                else if (resp.body) setExternalEvents(resp.body.externalEvents);
            } catch (err) {
                setExternalError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to load external events');
            } finally{
                setExternalLoading(false);
            }
        };
        performFetch();
        return ()=>{
            isMounted = false;
        };
    // eslint-disable-next-line
    }, [
        provider,
        auth.churchId
    ]);
    const navigateToCreateForEvent = (ev)=>{
        const params = new URLSearchParams();
        if (ev.name) params.set('title', ev.name);
        if (ev.description) params.set('description', ev.description);
        if (ev.registrationURL) params.set('registrationURL', ev.registrationURL);
        if (ev.thumbnailImageURL) params.set('thumbnailURL', ev.thumbnailImageURL);
        params.set('externalEventID', ev.externalID);
        params.set('provider', provider);
        const search = params.toString();
        navigate({
            pathname: '/events/create/details',
            search: search ? `?${search}` : ''
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "create-event-external",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: `Select ${providerName} Event`,
                showBackButton: true,
                backLocation: "/events/create"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "external-list",
                children: [
                    externalLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {}) : null,
                    externalError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "error",
                        children: externalError
                    }) : null,
                    externalEvents ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            externalEvents.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "No events available to import."
                            }) : null,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "cards",
                                children: externalEvents.map((ev)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5a439522e12ead21$export$2e2bcd8739ae039), {
                                        title: ev.name,
                                        thumbnailURL: ev.thumbnailImageURL,
                                        dateInfo: null,
                                        onClick: ()=>{
                                            navigateToCreateForEvent(ev);
                                        }
                                    }, ev.externalID))
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
}





var $5400a2a63bd6350c$exports = {};
$5400a2a63bd6350c$exports = $parcel$resolve("5pgWl");


var $8acff66747a6c928$exports = {};
$8acff66747a6c928$exports = $parcel$resolve("ltOob");





var $7fPBF = parcelRequire("7fPBF");
var $f20b05b49aeba227$var$Context = /*#__PURE__*/ function(Context) {
    Context[Context["LOGIN"] = 0] = "LOGIN";
    Context[Context["REQUEST_RESET"] = 1] = "REQUEST_RESET";
    return Context;
}($f20b05b49aeba227$var$Context || {});
function $f20b05b49aeba227$export$2e2bcd8739ae039(props) {
    var _location_state_from, _location_state;
    let navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    let location = (0, $6de75bb8982f6eaa$export$45d76561a5302f2b)();
    let auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [performingAction, setPerformingAction] = (0, $7fPBF.useState)(false);
    const [context, setContext] = (0, $7fPBF.useState)(0);
    const [error, setError] = (0, $7fPBF.useState)("");
    const [email, setEmail] = (0, $7fPBF.useState)("");
    const [password, setPassword] = (0, $7fPBF.useState)("");
    const theme = (0, $5cc3ec176bbf7015$export$2e2bcd8739ae039)();
    let from = ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : (_location_state_from = _location_state.from) === null || _location_state_from === void 0 ? void 0 : _location_state_from.pathname) || '/';
    async function handleSubmit() {
        if (performingAction) return;
        if (context === 0) submitLogin();
        else submitReset();
    }
    async function submitLogin() {
        if (email.length === 0) {
            setError("Please enter your email.");
            return;
        }
        if (password.length === 0) {
            setError("Please enter your password.");
            return;
        }
        setError("");
        setPerformingAction(true);
        try {
            await auth.signIn(email, password);
            navigate(from, {
                replace: true
            });
        } catch (error) {
            setError(error.message);
            setPerformingAction(false);
        }
    }
    async function submitReset() {
        if (email.length === 0) {
            setError("Please enter your email.");
            return;
        }
        setError("");
        setPerformingAction(true);
        try {
            const message = await auth.requestPasswordReset(email);
            alert(message);
        } catch (error) {
            setError(error.message);
        }
        setPerformingAction(false);
    }
    async function handleContextChangeButtonClick() {
        if (performingAction) return;
        setError("");
        setContext(context === 0 ? 1 : 0);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "login-screen",
        children: [
            theme === (0, $5cc3ec176bbf7015$export$14faa19a0f3bbeb2).DARK ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "opacity-layer"
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "login-form",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: theme === (0, $5cc3ec176bbf7015$export$14faa19a0f3bbeb2).LIGHT ? (0, (/*@__PURE__*/$parcel$interopDefault($5400a2a63bd6350c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8acff66747a6c928$exports))),
                        draggable: false,
                        alt: "Salt Logo"
                    }),
                    error !== "" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "error",
                        children: error
                    }) : "",
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        style: {
                            textAlign: 'center'
                        },
                        children: context === 0 ? "Please use your Salt Church Hub credentials to login." : "Please enter your email to reset your password for your Salt Church Hub account."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "input-holder",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                type: "email",
                                placeholder: "Email",
                                value: email,
                                disabled: performingAction,
                                onChange: (e)=>{
                                    setEmail(e.target.value);
                                    setError("");
                                }
                            }),
                            context === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                type: "password",
                                placeholder: "Password",
                                value: password,
                                disabled: performingAction,
                                onChange: (e)=>{
                                    setPassword(e.target.value);
                                    setError("");
                                }
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: `login ${performingAction ? "disabled" : ""}`,
                        disabled: performingAction,
                        onClick: handleSubmit,
                        children: context === 0 ? "Login" : "Request Reset"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: "forgot",
                        disabled: performingAction,
                        onClick: handleContextChangeButtonClick,
                        children: context === 0 ? "Forgot Password?" : "Login Instead"
                    })
                ]
            })
        ]
    });
}












var $7fPBF = parcelRequire("7fPBF");

function $14b7ba2e956aca92$export$2e2bcd8739ae039() {
    const [searchParams] = (0, $1a29469ea96a6022$export$f1a78c17382fe22a)();
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const type = searchParams.get("type");
    const token = searchParams.get("token");
    const theme = (0, $5cc3ec176bbf7015$export$2e2bcd8739ae039)();
    const [error, setError] = (0, $7fPBF.useState)("");
    const [performingAction, setPerformingAction] = (0, $7fPBF.useState)(false);
    const [newPassword, setNewPassword] = (0, $7fPBF.useState)("");
    const [newPasswordConfirm, setNewPasswordConfirm] = (0, $7fPBF.useState)("");
    if (!token) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$444b3ab0cb9aec40), {
        to: "/login"
    });
    const handleSubmit = async ()=>{
        if (newPassword !== newPasswordConfirm) return setError("Your passwords do not match");
        if (newPassword.match(/^(.{0,7}|[^0-9]*|[^A-Z]*|[^a-z]*|[a-zA-Z0-9]*)$/) !== null) return setError("Your password must be at least 8 characters long, contain a lowercase and uppercase letter, at least one number, and a special character.");
        setPerformingAction(true);
        setError("");
        try {
            const success = await auth.resetPassword(token, newPassword);
            if (success) {
                alert("Your password has been reset. Please login with your new password.");
                navigate("/login");
            } else setError("Failed to reset your password. Please try again later.");
        } catch (error) {
            setError(error.message);
        }
        setPerformingAction(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "container reset-password-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                src: theme === (0, $5cc3ec176bbf7015$export$14faa19a0f3bbeb2).LIGHT ? (0, (/*@__PURE__*/$parcel$interopDefault($5400a2a63bd6350c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8acff66747a6c928$exports))),
                draggable: false,
                alt: "Salt Logo"
            }),
            error !== "" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "error",
                children: error
            }) : "",
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                style: {
                    textAlign: 'center'
                },
                children: [
                    "Use this form to ",
                    type === 'initial' ? 'set' : 'reset',
                    " your Salt Church Hub password."
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                type: "password",
                placeholder: "New Password",
                value: newPassword,
                disabled: performingAction,
                onChange: (e)=>{
                    setNewPassword(e.target.value);
                    setError("");
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                type: "password",
                placeholder: "New Password (Confirm)",
                value: newPasswordConfirm,
                disabled: performingAction,
                onChange: (e)=>{
                    setNewPasswordConfirm(e.target.value);
                    setError("");
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                className: `reset ${performingAction ? "disabled" : ""}`,
                disabled: performingAction,
                onClick: handleSubmit,
                children: [
                    type === 'initial' ? 'Set' : 'Reset',
                    " Password"
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                className: "login",
                disabled: performingAction,
                onClick: ()=>navigate("/"),
                children: "Login Instead"
            })
        ]
    });
}








var $49ae69acb74a3943$exports = {};
$49ae69acb74a3943$exports = $parcel$resolve("bBooK");


var $6f588133950e6aa3$exports = {};
$6f588133950e6aa3$exports = $parcel$resolve("es6ZK");


var $ec0551d2c7d279c4$exports = {};
$ec0551d2c7d279c4$exports = $parcel$resolve("aKLVB");


var $67945e64350c48fb$exports = {};
$67945e64350c48fb$exports = $parcel$resolve("kGQfz");


var $6e961e8ad9a8f0e3$exports = {};
$6e961e8ad9a8f0e3$exports = $parcel$resolve("ha6AV");



var $7cb3273eb8a138bf$exports = {};
$7cb3273eb8a138bf$exports = $parcel$resolve("7Tmfa");




var $ce5d85dadab4b28c$exports = {};
'use strict';
Object.defineProperty($ce5d85dadab4b28c$exports, '__esModule', {
    value: true
});










$ce5d85dadab4b28c$exports['default'] = {
    slide: (parcelRequire("as5xI")),
    stack: (parcelRequire("8LDbR")),
    elastic: (parcelRequire("5Z3UW")),
    bubble: (parcelRequire("63d8t")),
    push: (parcelRequire("d9Mhz")),
    pushRotate: (parcelRequire("cJH6C")),
    scaleDown: (parcelRequire("1v5Sr")),
    scaleRotate: (parcelRequire("i1zqH")),
    fallDown: (parcelRequire("k9vVI")),
    reveal: (parcelRequire("6UWsR"))
};
$ce5d85dadab4b28c$exports = $ce5d85dadab4b28c$exports['default'];



var $7fPBF = parcelRequire("7fPBF");

const $405982bdd950bba4$var$routes = [
    {
        path: 'home',
        name: 'Home',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($49ae69acb74a3943$exports))),
        requiredPermission: null
    },
    {
        type: 'separator',
        label: 'Content'
    },
    // this is disabled until we decide it's a useful feature & we build out the removed screens
    // {
    //   path: 'service-plans',
    //   name: 'Service Plans',
    //   icon: servicePlansIcon,
    //   requiredPermission: StaffAction.CREATE_MINISTRY_DATA
    // },
    {
        path: 'playlists',
        name: 'Playlists',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ec0551d2c7d279c4$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).CREATE_PLAYLIST
    },
    {
        path: 'events',
        name: 'Events',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($729bd1a2fa55fb37$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).CREATE_MINISTRY_DATA // TODO: this will need to be tweaked at some point
    },
    // Add a separator here to group integrations / admin links
    {
        type: 'separator',
        label: 'Settings'
    },
    {
        path: 'team',
        name: 'Team Members',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6e961e8ad9a8f0e3$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).EDIT_STAFF_USER
    },
    {
        path: 'connections',
        name: 'Connections',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6f588133950e6aa3$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).EDIT_CHURCH_METADATA
    }
];
function $405982bdd950bba4$export$2e2bcd8739ae039(props) {
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(false);
    const sidebarContent = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($405982bdd950bba4$var$SidebarContent, {
        churchName: props.churchName,
        closeSidebar: ()=>{
            setIsOpen(false);
        }
    });
    return props.isMobile ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("header", {
                className: "sidebar-header",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        onClick: (e)=>{
                            e.preventDefault();
                            setIsOpen(true);
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7cb3273eb8a138bf$exports)))
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        children: "Salt Church Hub"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce5d85dadab4b28c$exports.slide), {
                isOpen: isOpen,
                onStateChange: (state)=>setIsOpen(state.isOpen),
                className: "sidebar",
                styles: {
                    bmBurgerButton: {
                        display: 'none'
                    }
                },
                children: sidebarContent
            })
        ]
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "sidebar sidebar-div",
        children: sidebarContent
    });
}
function $405982bdd950bba4$var$SidebarContent(props) {
    var _auth_user;
    const theme = (0, $5cc3ec176bbf7015$export$2e2bcd8739ae039)();
    const location = (0, $6de75bb8982f6eaa$export$45d76561a5302f2b)();
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const path = location.pathname;
    let pathComponents = path.split('/');
    let route = pathComponents[1];
    if (route === "") route = "home";
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                src: theme === (0, $5cc3ec176bbf7015$export$14faa19a0f3bbeb2).LIGHT ? (0, (/*@__PURE__*/$parcel$interopDefault($5400a2a63bd6350c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8acff66747a6c928$exports))),
                draggable: false,
                alt: "Salt Icon",
                className: "logo"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                className: "greeting",
                children: [
                    "\uD83D\uDC4B Hi, ",
                    (_auth_user = auth.user) === null || _auth_user === void 0 ? void 0 : _auth_user.name,
                    "!"
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "churchName",
                children: props.churchName
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "divider"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                children: $405982bdd950bba4$var$routes.map((r, i)=>{
                    // handle separator items
                    if (r.type === 'separator') {
                        const sep = r;
                        if (sep.requiredPermission && !auth.hasPermission(sep.requiredPermission)) return null;
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                            className: "route-separator",
                            children: sep.label ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "separator-label",
                                children: sep.label
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "separator-line"
                            })
                        }, `sep-${i}`);
                    }
                    const routeItem = r;
                    if (routeItem.requiredPermission && !auth.hasPermission(routeItem.requiredPermission)) return null;
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: route == routeItem.path ? 'selected' : '',
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                            href: `/${routeItem.path}`,
                            onClick: (e)=>{
                                e.preventDefault();
                                navigate(`/${routeItem.path}`);
                                props.closeSidebar();
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    src: routeItem.icon
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: routeItem.name
                                })
                            ]
                        })
                    }, i);
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "divider"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                        href: "/logout",
                        onClick: (e)=>{
                            e.preventDefault();
                            auth.signOut(()=>navigate("/"));
                            props.closeSidebar();
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                style: {
                                    marginRight: 8
                                },
                                children: "Sign Out"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($67945e64350c48fb$exports)))
                            })
                        ]
                    })
                })
            })
        ]
    });
}




function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $75dbb8f78ee65245$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $7fPBF = parcelRequire("7fPBF");
var $66dfb6eb404a098b$exports = {};
'use strict';
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var $5f306376e4d30ca7$export$4659b591c19bdf3d;
var $5f306376e4d30ca7$export$98e6a39c04603d36;
'use strict';
$5f306376e4d30ca7$export$4659b591c19bdf3d = $5f306376e4d30ca7$var$matchQuery;
$5f306376e4d30ca7$export$98e6a39c04603d36 = $5f306376e4d30ca7$var$parseQuery;
// -----------------------------------------------------------------------------
var $5f306376e4d30ca7$var$RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, $5f306376e4d30ca7$var$RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, $5f306376e4d30ca7$var$RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, $5f306376e4d30ca7$var$RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, $5f306376e4d30ca7$var$RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
function $5f306376e4d30ca7$var$matchQuery(mediaQuery, values) {
    return $5f306376e4d30ca7$var$parseQuery(mediaQuery).some(function(query) {
        var inverse = query.inverse;
        // Either the parsed or specified `type` is "all", or the types must be
        // equal for a match.
        var typeMatch = query.type === 'all' || values.type === query.type;
        // Quit early when `type` doesn't match, but take "not" into account.
        if (typeMatch && inverse || !(typeMatch || inverse)) return false;
        var expressionsMatch = query.expressions.every(function(expression) {
            var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
            // Missing or falsy values don't match.
            if (!value) return false;
            switch(feature){
                case 'orientation':
                case 'scan':
                    return value.toLowerCase() === expValue.toLowerCase();
                case 'width':
                case 'height':
                case 'device-width':
                case 'device-height':
                    expValue = $5f306376e4d30ca7$var$toPx(expValue);
                    value = $5f306376e4d30ca7$var$toPx(value);
                    break;
                case 'resolution':
                    expValue = $5f306376e4d30ca7$var$toDpi(expValue);
                    value = $5f306376e4d30ca7$var$toDpi(value);
                    break;
                case 'aspect-ratio':
                case 'device-aspect-ratio':
                case /* Deprecated */ 'device-pixel-ratio':
                    expValue = $5f306376e4d30ca7$var$toDecimal(expValue);
                    value = $5f306376e4d30ca7$var$toDecimal(value);
                    break;
                case 'grid':
                case 'color':
                case 'color-index':
                case 'monochrome':
                    expValue = parseInt(expValue, 10) || 1;
                    value = parseInt(value, 10) || 0;
                    break;
            }
            switch(modifier){
                case 'min':
                    return value >= expValue;
                case 'max':
                    return value <= expValue;
                default:
                    return value === expValue;
            }
        });
        return expressionsMatch && !inverse || !expressionsMatch && inverse;
    });
}
function $5f306376e4d30ca7$var$parseQuery(mediaQuery) {
    return mediaQuery.split(',').map(function(query) {
        query = query.trim();
        var captures = query.match($5f306376e4d30ca7$var$RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || '', parsed = {};
        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
        parsed.type = type ? type.toLowerCase() : 'all';
        // Split expressions into a list.
        expressions = expressions.match(/\([^\)]+\)/g) || [];
        parsed.expressions = expressions.map(function(expression) {
            var captures = expression.match($5f306376e4d30ca7$var$RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match($5f306376e4d30ca7$var$RE_MQ_FEATURE);
            return {
                modifier: feature[1],
                feature: feature[2],
                value: captures[2]
            };
        });
        return parsed;
    });
}
// -- Utilities ----------------------------------------------------------------
function $5f306376e4d30ca7$var$toDecimal(ratio) {
    var decimal = Number(ratio), numbers;
    if (!decimal) {
        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
        decimal = numbers[1] / numbers[2];
    }
    return decimal;
}
function $5f306376e4d30ca7$var$toDpi(resolution) {
    var value = parseFloat(resolution), units = String(resolution).match($5f306376e4d30ca7$var$RE_RESOLUTION_UNIT)[1];
    switch(units){
        case 'dpcm':
            return value / 2.54;
        case 'dppx':
            return value * 96;
        default:
            return value;
    }
}
function $5f306376e4d30ca7$var$toPx(length) {
    var value = parseFloat(length), units = String(length).match($5f306376e4d30ca7$var$RE_LENGTH_UNIT)[1];
    switch(units){
        case 'em':
            return value * 16;
        case 'rem':
            return value * 16;
        case 'cm':
            return value * 96 / 2.54;
        case 'mm':
            return value * 96 / 2.54 / 10;
        case 'in':
            return value * 96;
        case 'pt':
            return value * 72;
        case 'pc':
            return value * 72 / 12;
        default:
            return value;
    }
}


var $66dfb6eb404a098b$require$staticMatch = $5f306376e4d30ca7$export$4659b591c19bdf3d;
var $66dfb6eb404a098b$var$dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;
// our fake MediaQueryList
function $66dfb6eb404a098b$var$Mql(query, values, forceStatic) {
    var self = this;
    var mql;
    // matchMedia will return null in FF when it's called in a hidden iframe
    // ref: https://stackoverflow.com/a/12330568
    if ($66dfb6eb404a098b$var$dynamicMatch && !forceStatic) mql = $66dfb6eb404a098b$var$dynamicMatch.call(window, query);
    if (mql) {
        this.matches = mql.matches;
        this.media = mql.media;
        // TODO: is there a time it makes sense to remove this listener?
        mql.addListener(update);
    } else {
        this.matches = $66dfb6eb404a098b$require$staticMatch(query, values);
        this.media = query;
    }
    this.addListener = addListener;
    this.removeListener = removeListener;
    this.dispose = dispose;
    function addListener(listener) {
        if (mql) mql.addListener(listener);
    }
    function removeListener(listener) {
        if (mql) mql.removeListener(listener);
    }
    // update ourselves!
    function update(evt) {
        self.matches = evt.matches;
        self.media = evt.media;
    }
    function dispose() {
        if (mql) mql.removeListener(update);
    }
}
function $66dfb6eb404a098b$var$matchMedia(query, values, forceStatic) {
    return new $66dfb6eb404a098b$var$Mql(query, values, forceStatic);
}
$66dfb6eb404a098b$exports = $66dfb6eb404a098b$var$matchMedia;


/* eslint-disable no-var, prefer-template */ var $1b42eaed349bc9b0$var$uppercasePattern = /[A-Z]/g;
var $1b42eaed349bc9b0$var$msPattern = /^ms-/;
var $1b42eaed349bc9b0$var$cache = {};
function $1b42eaed349bc9b0$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $1b42eaed349bc9b0$var$hyphenateStyleName(name) {
    if ($1b42eaed349bc9b0$var$cache.hasOwnProperty(name)) return $1b42eaed349bc9b0$var$cache[name];
    var hName = name.replace($1b42eaed349bc9b0$var$uppercasePattern, $1b42eaed349bc9b0$var$toHyphenLower);
    return $1b42eaed349bc9b0$var$cache[name] = $1b42eaed349bc9b0$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $1b42eaed349bc9b0$export$2e2bcd8739ae039 = $1b42eaed349bc9b0$var$hyphenateStyleName;


function $99216e69d1643bce$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $99216e69d1643bce$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $99216e69d1643bce$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $99216e69d1643bce$export$967a6b9924a689f7(a, b);
    return $99216e69d1643bce$export$3e67810a3f0e9f1c(a, b);
}



var $2oXYc = parcelRequire("2oXYc");
const $92f580e302e93e6f$var$stringOrNumber = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
]);
// media types
const $92f580e302e93e6f$var$types = {
    all: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    grid: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    aural: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    braille: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    handheld: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    print: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    projection: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    screen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    tty: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    tv: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    embossed: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
// properties that match media queries
const $92f580e302e93e6f$var$matchers = {
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        'portrait',
        'landscape'
    ]),
    scan: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        'progressive',
        'interlace'
    ]),
    aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    deviceAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    height: $92f580e302e93e6f$var$stringOrNumber,
    deviceHeight: $92f580e302e93e6f$var$stringOrNumber,
    width: $92f580e302e93e6f$var$stringOrNumber,
    deviceWidth: $92f580e302e93e6f$var$stringOrNumber,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    colorIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    monochrome: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    resolution: $92f580e302e93e6f$var$stringOrNumber,
    type: Object.keys($92f580e302e93e6f$var$types)
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { type: $92f580e302e93e6f$var$type } = $92f580e302e93e6f$var$matchers, $92f580e302e93e6f$var$featureMatchers = (0, $8901fc92b5563702$export$71511d61b312f219)($92f580e302e93e6f$var$matchers, [
    "type"
]);
// media features
const $92f580e302e93e6f$var$features = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
    minAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    maxAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    minDeviceAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    maxDeviceAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    minHeight: $92f580e302e93e6f$var$stringOrNumber,
    maxHeight: $92f580e302e93e6f$var$stringOrNumber,
    minDeviceHeight: $92f580e302e93e6f$var$stringOrNumber,
    maxDeviceHeight: $92f580e302e93e6f$var$stringOrNumber,
    minWidth: $92f580e302e93e6f$var$stringOrNumber,
    maxWidth: $92f580e302e93e6f$var$stringOrNumber,
    minDeviceWidth: $92f580e302e93e6f$var$stringOrNumber,
    maxDeviceWidth: $92f580e302e93e6f$var$stringOrNumber,
    minColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    maxColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    minColorIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    maxColorIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    minMonochrome: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    maxMonochrome: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    minResolution: $92f580e302e93e6f$var$stringOrNumber,
    maxResolution: $92f580e302e93e6f$var$stringOrNumber
}, $92f580e302e93e6f$var$featureMatchers);
const $92f580e302e93e6f$var$all = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $92f580e302e93e6f$var$types, $92f580e302e93e6f$var$features);
var $92f580e302e93e6f$var$mq = {
    all: $92f580e302e93e6f$var$all,
    types: $92f580e302e93e6f$var$types,
    matchers: $92f580e302e93e6f$var$matchers,
    features: $92f580e302e93e6f$var$features
};
const $92f580e302e93e6f$var$negate = (cond)=>`not ${cond}`;
const $92f580e302e93e6f$var$keyVal = (k, v)=>{
    const realKey = (0, $1b42eaed349bc9b0$export$2e2bcd8739ae039)(k);
    // px shorthand
    if (typeof v === 'number') v = `${v}px`;
    if (v === true) return realKey;
    if (v === false) return $92f580e302e93e6f$var$negate(realKey);
    return `(${realKey}: ${v})`;
};
const $92f580e302e93e6f$var$join = (conds)=>conds.join(' and ');
const $92f580e302e93e6f$export$da99e50c1f5e8cc8 = (obj)=>{
    const rules = [];
    Object.keys($92f580e302e93e6f$var$mq.all).forEach((k)=>{
        const v = obj[k];
        if (v != null) rules.push($92f580e302e93e6f$var$keyVal(k, v));
    });
    return $92f580e302e93e6f$var$join(rules);
};
const $92f580e302e93e6f$export$841858b892ce1f4c = (0, $7fPBF.createContext)(undefined);
const $92f580e302e93e6f$var$makeQuery = (settings)=>settings.query || $92f580e302e93e6f$export$da99e50c1f5e8cc8(settings);
const $92f580e302e93e6f$var$hyphenateKeys = (obj)=>{
    if (!obj) return undefined;
    const keys = Object.keys(obj);
    return keys.reduce((result, key)=>{
        result[(0, $1b42eaed349bc9b0$export$2e2bcd8739ae039)(key)] = obj[key];
        return result;
    }, {});
};
const $92f580e302e93e6f$var$useIsUpdate = ()=>{
    const ref = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(()=>{
        ref.current = true;
    }, []);
    return ref.current;
};
const $92f580e302e93e6f$var$useDevice = (deviceFromProps)=>{
    const deviceFromContext = (0, $7fPBF.useContext)($92f580e302e93e6f$export$841858b892ce1f4c);
    const getDevice = ()=>$92f580e302e93e6f$var$hyphenateKeys(deviceFromProps) || $92f580e302e93e6f$var$hyphenateKeys(deviceFromContext);
    const [device, setDevice] = (0, $7fPBF.useState)(getDevice);
    (0, $7fPBF.useEffect)(()=>{
        const newDevice = getDevice();
        if (!(0, $99216e69d1643bce$export$3e67810a3f0e9f1c)(device, newDevice)) setDevice(newDevice);
    }, [
        deviceFromProps,
        deviceFromContext
    ]);
    return device;
};
const $92f580e302e93e6f$var$useQuery = (settings)=>{
    const getQuery = ()=>$92f580e302e93e6f$var$makeQuery(settings);
    const [query, setQuery] = (0, $7fPBF.useState)(getQuery);
    (0, $7fPBF.useEffect)(()=>{
        const newQuery = getQuery();
        if (query !== newQuery) setQuery(newQuery);
    }, [
        settings
    ]);
    return query;
};
const $92f580e302e93e6f$var$useMatchMedia = (query, device)=>{
    const getMatchMedia = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($66dfb6eb404a098b$exports)))(query, device || {}, !!device);
    const [mq, setMq] = (0, $7fPBF.useState)(getMatchMedia);
    const isUpdate = $92f580e302e93e6f$var$useIsUpdate();
    (0, $7fPBF.useEffect)(()=>{
        if (isUpdate) {
            // skip on mounting, it has already been set
            const newMq = getMatchMedia();
            setMq(newMq);
            return ()=>{
                if (newMq) newMq.dispose();
            };
        }
    }, [
        query,
        device
    ]);
    return mq;
};
const $92f580e302e93e6f$var$useMatches = (mediaQuery)=>{
    const [matches, setMatches] = (0, $7fPBF.useState)(mediaQuery.matches);
    (0, $7fPBF.useEffect)(()=>{
        const updateMatches = (ev)=>{
            setMatches(ev.matches);
        };
        mediaQuery.addListener(updateMatches);
        setMatches(mediaQuery.matches);
        return ()=>{
            mediaQuery.removeListener(updateMatches);
        };
    }, [
        mediaQuery
    ]);
    return matches;
};
const $92f580e302e93e6f$export$32d5543ab307c01 = (settings, device, onChange)=>{
    const deviceSettings = $92f580e302e93e6f$var$useDevice(device);
    const query = $92f580e302e93e6f$var$useQuery(settings);
    if (!query) throw new Error('Invalid or missing MediaQuery!');
    const mq = $92f580e302e93e6f$var$useMatchMedia(query, deviceSettings);
    const matches = $92f580e302e93e6f$var$useMatches(mq);
    const isUpdate = $92f580e302e93e6f$var$useIsUpdate();
    (0, $7fPBF.useEffect)(()=>{
        if (isUpdate && onChange) onChange(matches);
    }, [
        matches
    ]);
    (0, $7fPBF.useEffect)(()=>()=>{
            if (mq) mq.dispose();
        }, []);
    return matches;
};
// ReactNode and ReactElement typings are a little funky for functional components, so the ReactElement cast is needed on the return
const $92f580e302e93e6f$export$2e2bcd8739ae039 = (_param)=>{
    var { children: children, device: device, onChange: onChange } = _param, settings = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "children",
        "device",
        "onChange"
    ]);
    const matches = $92f580e302e93e6f$export$32d5543ab307c01(settings, device, onChange);
    if (typeof children === 'function') return children(matches);
    return matches ? children : null;
};



function $2471b8f7d7b0c863$export$2e2bcd8739ae039() {
    var _churchData_church;
    const churchData = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const isMobile = (0, $92f580e302e93e6f$export$32d5543ab307c01)({
        query: `(max-width: 800px)`
    });
    var _churchData_church_name;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "Appv2",
        style: {
            display: 'flex'
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $405982bdd950bba4$export$2e2bcd8739ae039), {
                churchName: (_churchData_church_name = (_churchData_church = churchData.church) === null || _churchData_church === void 0 ? void 0 : _churchData_church.name) !== null && _churchData_church_name !== void 0 ? _churchData_church_name : "",
                isMobile: isMobile
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    marginTop: isMobile ? '80px' : '0',
                    width: '100%',
                    overflow: 'hidden'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$910ae8079b2c2852), {})
            })
        ]
    });
}






function $4b0f979acc21dbbe$export$2e2bcd8739ae039() {
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    const [searchParams] = (0, $1a29469ea96a6022$export$f1a78c17382fe22a)();
    const provider = searchParams.get("provider");
    const success = searchParams.get("success") == "true";
    let providerName = '';
    switch(provider){
        case 'pco':
            providerName = 'Planning Center';
            break;
        default:
            providerName = 'provider';
            break;
    }
    if (!success) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        error: `Failed to connect with ${providerName}.`,
        buttonText: "Continue",
        buttonAction: ()=>navigate('/connections')
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "redirect-success-view",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "\u2705"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "Successfully Connected!"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                children: [
                    "You've successfully connected with ",
                    providerName,
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                href: "#",
                onClick: ()=>navigate('/connections'),
                children: "Continue"
            })
        ]
    });
}






var $7fPBF = parcelRequire("7fPBF");




var $6df11232f48ec2ff$exports = {};
$6df11232f48ec2ff$exports = $parcel$resolve("ahs3Z");


var $ee65f54ee732d431$exports = {};
'use strict';
Object.defineProperty($ee65f54ee732d431$exports, '__esModule', {
    value: true
});
function $ee65f54ee732d431$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ee65f54ee732d431$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ee65f54ee732d431$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ee65f54ee732d431$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ee65f54ee732d431$var$_extends() {
    $ee65f54ee732d431$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ee65f54ee732d431$var$_extends.apply(this, arguments);
}
function $ee65f54ee732d431$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $ee65f54ee732d431$var$_setPrototypeOf(subClass, superClass);
}
function $ee65f54ee732d431$var$_getPrototypeOf(o) {
    $ee65f54ee732d431$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ee65f54ee732d431$var$_getPrototypeOf(o);
}
function $ee65f54ee732d431$var$_setPrototypeOf(o, p) {
    $ee65f54ee732d431$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ee65f54ee732d431$var$_setPrototypeOf(o, p);
}
function $ee65f54ee732d431$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ee65f54ee732d431$var$_construct(Parent, args, Class) {
    if ($ee65f54ee732d431$var$_isNativeReflectConstruct()) $ee65f54ee732d431$var$_construct = Reflect.construct;
    else $ee65f54ee732d431$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $ee65f54ee732d431$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $ee65f54ee732d431$var$_construct.apply(null, arguments);
}
function $ee65f54ee732d431$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $ee65f54ee732d431$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $ee65f54ee732d431$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$ee65f54ee732d431$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $ee65f54ee732d431$var$_construct(Class, arguments, $ee65f54ee732d431$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $ee65f54ee732d431$var$_setPrototypeOf(Wrapper, Class);
    };
    return $ee65f54ee732d431$var$_wrapNativeSuper(Class);
}
function $ee65f54ee732d431$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ee65f54ee732d431$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ee65f54ee732d431$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ee65f54ee732d431$var$_arrayLikeToArray(o, minLen);
}
function $ee65f54ee732d431$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ee65f54ee732d431$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $ee65f54ee732d431$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $ee65f54ee732d431$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $ee65f54ee732d431$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $ee65f54ee732d431$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $ee65f54ee732d431$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $ee65f54ee732d431$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($ee65f54ee732d431$var$LuxonError);
/**
 * @private
 */ var $ee65f54ee732d431$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $ee65f54ee732d431$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($ee65f54ee732d431$var$LuxonError);
/**
 * @private
 */ var $ee65f54ee732d431$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $ee65f54ee732d431$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($ee65f54ee732d431$var$LuxonError);
/**
 * @private
 */ var $ee65f54ee732d431$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $ee65f54ee732d431$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($ee65f54ee732d431$var$LuxonError);
/**
 * @private
 */ var $ee65f54ee732d431$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $ee65f54ee732d431$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($ee65f54ee732d431$var$LuxonError);
/**
 * @private
 */ var $ee65f54ee732d431$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $ee65f54ee732d431$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($ee65f54ee732d431$var$LuxonError);
/**
 * @private
 */ var $ee65f54ee732d431$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $ee65f54ee732d431$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($ee65f54ee732d431$var$LuxonError);
/**
 * @private
 */ var $ee65f54ee732d431$var$n = "numeric", $ee65f54ee732d431$var$s = "short", $ee65f54ee732d431$var$l = "long";
var $ee65f54ee732d431$var$DATE_SHORT = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$n,
    day: $ee65f54ee732d431$var$n
};
var $ee65f54ee732d431$var$DATE_MED = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$s,
    day: $ee65f54ee732d431$var$n
};
var $ee65f54ee732d431$var$DATE_MED_WITH_WEEKDAY = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$s,
    day: $ee65f54ee732d431$var$n,
    weekday: $ee65f54ee732d431$var$s
};
var $ee65f54ee732d431$var$DATE_FULL = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$l,
    day: $ee65f54ee732d431$var$n
};
var $ee65f54ee732d431$var$DATE_HUGE = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$l,
    day: $ee65f54ee732d431$var$n,
    weekday: $ee65f54ee732d431$var$l
};
var $ee65f54ee732d431$var$TIME_SIMPLE = {
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n
};
var $ee65f54ee732d431$var$TIME_WITH_SECONDS = {
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    second: $ee65f54ee732d431$var$n
};
var $ee65f54ee732d431$var$TIME_WITH_SHORT_OFFSET = {
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    second: $ee65f54ee732d431$var$n,
    timeZoneName: $ee65f54ee732d431$var$s
};
var $ee65f54ee732d431$var$TIME_WITH_LONG_OFFSET = {
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    second: $ee65f54ee732d431$var$n,
    timeZoneName: $ee65f54ee732d431$var$l
};
var $ee65f54ee732d431$var$TIME_24_SIMPLE = {
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    hourCycle: "h23"
};
var $ee65f54ee732d431$var$TIME_24_WITH_SECONDS = {
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    second: $ee65f54ee732d431$var$n,
    hourCycle: "h23"
};
var $ee65f54ee732d431$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    second: $ee65f54ee732d431$var$n,
    hourCycle: "h23",
    timeZoneName: $ee65f54ee732d431$var$s
};
var $ee65f54ee732d431$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    second: $ee65f54ee732d431$var$n,
    hourCycle: "h23",
    timeZoneName: $ee65f54ee732d431$var$l
};
var $ee65f54ee732d431$var$DATETIME_SHORT = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$n,
    day: $ee65f54ee732d431$var$n,
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n
};
var $ee65f54ee732d431$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$n,
    day: $ee65f54ee732d431$var$n,
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    second: $ee65f54ee732d431$var$n
};
var $ee65f54ee732d431$var$DATETIME_MED = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$s,
    day: $ee65f54ee732d431$var$n,
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n
};
var $ee65f54ee732d431$var$DATETIME_MED_WITH_SECONDS = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$s,
    day: $ee65f54ee732d431$var$n,
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    second: $ee65f54ee732d431$var$n
};
var $ee65f54ee732d431$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$s,
    day: $ee65f54ee732d431$var$n,
    weekday: $ee65f54ee732d431$var$s,
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n
};
var $ee65f54ee732d431$var$DATETIME_FULL = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$l,
    day: $ee65f54ee732d431$var$n,
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    timeZoneName: $ee65f54ee732d431$var$s
};
var $ee65f54ee732d431$var$DATETIME_FULL_WITH_SECONDS = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$l,
    day: $ee65f54ee732d431$var$n,
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    second: $ee65f54ee732d431$var$n,
    timeZoneName: $ee65f54ee732d431$var$s
};
var $ee65f54ee732d431$var$DATETIME_HUGE = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$l,
    day: $ee65f54ee732d431$var$n,
    weekday: $ee65f54ee732d431$var$l,
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    timeZoneName: $ee65f54ee732d431$var$l
};
var $ee65f54ee732d431$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $ee65f54ee732d431$var$n,
    month: $ee65f54ee732d431$var$l,
    day: $ee65f54ee732d431$var$n,
    weekday: $ee65f54ee732d431$var$l,
    hour: $ee65f54ee732d431$var$n,
    minute: $ee65f54ee732d431$var$n,
    second: $ee65f54ee732d431$var$n,
    timeZoneName: $ee65f54ee732d431$var$l
};
/**
 * @private
 */ // TYPES
function $ee65f54ee732d431$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $ee65f54ee732d431$var$isNumber(o) {
    return typeof o === "number";
}
function $ee65f54ee732d431$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $ee65f54ee732d431$var$isString(o) {
    return typeof o === "string";
}
function $ee65f54ee732d431$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
} // CAPABILITIES
function $ee65f54ee732d431$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
} // OBJECTS AND ARRAYS
function $ee65f54ee732d431$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $ee65f54ee732d431$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $ee65f54ee732d431$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $ee65f54ee732d431$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
} // NUMBERS AND STRINGS
function $ee65f54ee732d431$var$integerBetween(thing, bottom, top) {
    return $ee65f54ee732d431$var$isInteger(thing) && thing >= bottom && thing <= top;
} // x % n but takes the sign of n instead of x
function $ee65f54ee732d431$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $ee65f54ee732d431$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $ee65f54ee732d431$var$parseInteger(string) {
    if ($ee65f54ee732d431$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $ee65f54ee732d431$var$parseFloating(string) {
    if ($ee65f54ee732d431$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $ee65f54ee732d431$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($ee65f54ee732d431$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $ee65f54ee732d431$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
} // DATE BASICS
function $ee65f54ee732d431$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $ee65f54ee732d431$var$daysInYear(year) {
    return $ee65f54ee732d431$var$isLeapYear(year) ? 366 : 365;
}
function $ee65f54ee732d431$var$daysInMonth(year, month) {
    var modMonth = $ee65f54ee732d431$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $ee65f54ee732d431$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
} // covert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $ee65f54ee732d431$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond); // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        d.setUTCFullYear(d.getUTCFullYear() - 1900);
    }
    return +d;
}
function $ee65f54ee732d431$var$weeksInWeekYear(weekYear) {
    var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
    return p1 === 4 || p2 === 3 ? 53 : 52;
}
function $ee65f54ee732d431$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > 60 ? 1900 + year : 2000 + year;
} // PARSING
function $ee65f54ee732d431$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $ee65f54ee732d431$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
} // signedOffset('-5', '30') -> -330
function $ee65f54ee732d431$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10); // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
} // COERCION
function $ee65f54ee732d431$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $ee65f54ee732d431$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $ee65f54ee732d431$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($ee65f54ee732d431$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $ee65f54ee732d431$var$asNumber(v);
    }
    return normalized;
}
function $ee65f54ee732d431$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $ee65f54ee732d431$var$padStart(hours, 2) + ":" + $ee65f54ee732d431$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $ee65f54ee732d431$var$padStart(hours, 2) + $ee65f54ee732d431$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $ee65f54ee732d431$var$timeObject(obj) {
    return $ee65f54ee732d431$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
var $ee65f54ee732d431$var$ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z0-9_+-]{1,256}(\/[A-Za-z0-9_+-]{1,256})?)?/;
/**
 * @private
 */ var $ee65f54ee732d431$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $ee65f54ee732d431$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $ee65f54ee732d431$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $ee65f54ee732d431$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($ee65f54ee732d431$var$monthsNarrow);
        case "short":
            return [].concat($ee65f54ee732d431$var$monthsShort);
        case "long":
            return [].concat($ee65f54ee732d431$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $ee65f54ee732d431$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $ee65f54ee732d431$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $ee65f54ee732d431$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $ee65f54ee732d431$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($ee65f54ee732d431$var$weekdaysNarrow);
        case "short":
            return [].concat($ee65f54ee732d431$var$weekdaysShort);
        case "long":
            return [].concat($ee65f54ee732d431$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $ee65f54ee732d431$var$meridiems = [
    "AM",
    "PM"
];
var $ee65f54ee732d431$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $ee65f54ee732d431$var$erasShort = [
    "BC",
    "AD"
];
var $ee65f54ee732d431$var$erasNarrow = [
    "B",
    "A"
];
function $ee65f54ee732d431$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($ee65f54ee732d431$var$erasNarrow);
        case "short":
            return [].concat($ee65f54ee732d431$var$erasShort);
        case "long":
            return [].concat($ee65f54ee732d431$var$erasLong);
        default:
            return null;
    }
}
function $ee65f54ee732d431$var$meridiemForDateTime(dt) {
    return $ee65f54ee732d431$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $ee65f54ee732d431$var$weekdayForDateTime(dt, length) {
    return $ee65f54ee732d431$var$weekdays(length)[dt.weekday - 1];
}
function $ee65f54ee732d431$var$monthForDateTime(dt, length) {
    return $ee65f54ee732d431$var$months(length)[dt.month - 1];
}
function $ee65f54ee732d431$var$eraForDateTime(dt, length) {
    return $ee65f54ee732d431$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $ee65f54ee732d431$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $ee65f54ee732d431$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $ee65f54ee732d431$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $ee65f54ee732d431$var$_macroTokenToFormatOpts = {
    D: $ee65f54ee732d431$var$DATE_SHORT,
    DD: $ee65f54ee732d431$var$DATE_MED,
    DDD: $ee65f54ee732d431$var$DATE_FULL,
    DDDD: $ee65f54ee732d431$var$DATE_HUGE,
    t: $ee65f54ee732d431$var$TIME_SIMPLE,
    tt: $ee65f54ee732d431$var$TIME_WITH_SECONDS,
    ttt: $ee65f54ee732d431$var$TIME_WITH_SHORT_OFFSET,
    tttt: $ee65f54ee732d431$var$TIME_WITH_LONG_OFFSET,
    T: $ee65f54ee732d431$var$TIME_24_SIMPLE,
    TT: $ee65f54ee732d431$var$TIME_24_WITH_SECONDS,
    TTT: $ee65f54ee732d431$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $ee65f54ee732d431$var$TIME_24_WITH_LONG_OFFSET,
    f: $ee65f54ee732d431$var$DATETIME_SHORT,
    ff: $ee65f54ee732d431$var$DATETIME_MED,
    fff: $ee65f54ee732d431$var$DATETIME_FULL,
    ffff: $ee65f54ee732d431$var$DATETIME_HUGE,
    F: $ee65f54ee732d431$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $ee65f54ee732d431$var$DATETIME_MED_WITH_SECONDS,
    FFF: $ee65f54ee732d431$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $ee65f54ee732d431$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $ee65f54ee732d431$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed,
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: false,
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed,
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $ee65f54ee732d431$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $ee65f54ee732d431$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $ee65f54ee732d431$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $ee65f54ee732d431$var$_extends({}, this.opts, opts));
        return df.formatToParts();
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $ee65f54ee732d431$var$_extends({}, this.opts, opts));
        return df.resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $ee65f54ee732d431$var$padStart(n, p);
        var opts = $ee65f54ee732d431$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $ee65f54ee732d431$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $ee65f54ee732d431$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $ee65f54ee732d431$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $ee65f54ee732d431$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $ee65f54ee732d431$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $ee65f54ee732d431$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
var $ee65f54ee732d431$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
/**
 * @interface
 */ var $ee65f54ee732d431$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $ee65f54ee732d431$var$ZoneIsAbstractError();
    };
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $ee65f54ee732d431$var$ZoneIsAbstractError();
    };
    _proto.offset = function offset(ts) {
        throw new $ee65f54ee732d431$var$ZoneIsAbstractError();
    };
    _proto.equals = function equals(otherZone) {
        throw new $ee65f54ee732d431$var$ZoneIsAbstractError();
    };
    $ee65f54ee732d431$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $ee65f54ee732d431$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $ee65f54ee732d431$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $ee65f54ee732d431$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $ee65f54ee732d431$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $ee65f54ee732d431$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $ee65f54ee732d431$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $ee65f54ee732d431$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $ee65f54ee732d431$var$parseZoneInfo(ts, format, locale);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $ee65f54ee732d431$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    };
    $ee65f54ee732d431$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($ee65f54ee732d431$var$singleton$1 === null) $ee65f54ee732d431$var$singleton$1 = new SystemZone();
                return $ee65f54ee732d431$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($ee65f54ee732d431$var$Zone);
RegExp("^" + $ee65f54ee732d431$var$ianaRegex.source + "$");
var $ee65f54ee732d431$var$dtfCache = {};
function $ee65f54ee732d431$var$makeDTF(zone) {
    if (!$ee65f54ee732d431$var$dtfCache[zone]) $ee65f54ee732d431$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    });
    return $ee65f54ee732d431$var$dtfCache[zone];
}
var $ee65f54ee732d431$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $ee65f54ee732d431$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fHour = parsed[4], fMinute = parsed[5], fSecond = parsed[6];
    return [
        fYear,
        fMonth,
        fDay,
        fHour,
        fMinute,
        fSecond
    ];
}
function $ee65f54ee732d431$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date), filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value, pos = $ee65f54ee732d431$var$typeToPos[type];
        if (!$ee65f54ee732d431$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $ee65f54ee732d431$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $ee65f54ee732d431$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $ee65f54ee732d431$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$ee65f54ee732d431$var$ianaZoneCache[name]) $ee65f54ee732d431$var$ianaZoneCache[name] = new IANAZone(name);
        return $ee65f54ee732d431$var$ianaZoneCache[name];
    };
    IANAZone.resetCache = function resetCache() {
        $ee65f54ee732d431$var$ianaZoneCache = {};
        $ee65f54ee732d431$var$dtfCache = {};
    };
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    };
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $ee65f54ee732d431$var$parseZoneInfo(ts, format, locale, this.name);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $ee65f54ee732d431$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $ee65f54ee732d431$var$makeDTF(this.name), _ref2 = dtf.formatToParts ? $ee65f54ee732d431$var$partsOffset(dtf, date) : $ee65f54ee732d431$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], hour = _ref2[3], minute = _ref2[4], second = _ref2[5]; // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $ee65f54ee732d431$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    };
    $ee65f54ee732d431$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($ee65f54ee732d431$var$Zone);
var $ee65f54ee732d431$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $ee65f54ee732d431$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $ee65f54ee732d431$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    };
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($ee65f54ee732d431$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $ee65f54ee732d431$var$formatOffset(this.fixed, format);
    };
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    };
    $ee65f54ee732d431$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $ee65f54ee732d431$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($ee65f54ee732d431$var$singleton === null) $ee65f54ee732d431$var$singleton = new FixedOffsetZone(0);
                return $ee65f54ee732d431$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($ee65f54ee732d431$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $ee65f54ee732d431$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $ee65f54ee732d431$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    };
    _proto.formatOffset = function formatOffset() {
        return "";
    };
    _proto.offset = function offset() {
        return NaN;
    };
    _proto.equals = function equals() {
        return false;
    };
    $ee65f54ee732d431$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($ee65f54ee732d431$var$Zone);
/**
 * @private
 */ function $ee65f54ee732d431$var$normalizeZone(input, defaultZone) {
    if ($ee65f54ee732d431$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $ee65f54ee732d431$var$Zone) return input;
    else if ($ee65f54ee732d431$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "local" || lowered === "system") return defaultZone;
        else if (lowered === "utc" || lowered === "gmt") return $ee65f54ee732d431$var$FixedOffsetZone.utcInstance;
        else return $ee65f54ee732d431$var$FixedOffsetZone.parseSpecifier(lowered) || $ee65f54ee732d431$var$IANAZone.create(input);
    } else if ($ee65f54ee732d431$var$isNumber(input)) return $ee65f54ee732d431$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && input.offset && typeof input.offset === "number") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $ee65f54ee732d431$var$InvalidZone(input);
}
var $ee65f54ee732d431$var$now = function now() {
    return Date.now();
}, $ee65f54ee732d431$var$defaultZone = "system", $ee65f54ee732d431$var$defaultLocale = null, $ee65f54ee732d431$var$defaultNumberingSystem = null, $ee65f54ee732d431$var$defaultOutputCalendar = null, $ee65f54ee732d431$var$throwOnInvalid;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $ee65f54ee732d431$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $ee65f54ee732d431$var$Locale.resetCache();
        $ee65f54ee732d431$var$IANAZone.resetCache();
    };
    $ee65f54ee732d431$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $ee65f54ee732d431$var$now;
            },
            set: function set(n) {
                $ee65f54ee732d431$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $ee65f54ee732d431$var$normalizeZone($ee65f54ee732d431$var$defaultZone, $ee65f54ee732d431$var$SystemZone.instance);
            },
            set: function set(zone) {
                $ee65f54ee732d431$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $ee65f54ee732d431$var$defaultLocale;
            },
            set: function set(locale) {
                $ee65f54ee732d431$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $ee65f54ee732d431$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $ee65f54ee732d431$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $ee65f54ee732d431$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $ee65f54ee732d431$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $ee65f54ee732d431$var$throwOnInvalid;
            },
            set: function set(t) {
                $ee65f54ee732d431$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $ee65f54ee732d431$var$_excluded = [
    "base"
], $ee65f54ee732d431$var$_excluded2 = [
    "padTo",
    "floor"
];
var $ee65f54ee732d431$var$intlLFCache = {};
function $ee65f54ee732d431$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $ee65f54ee732d431$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $ee65f54ee732d431$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $ee65f54ee732d431$var$intlDTCache = {};
function $ee65f54ee732d431$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $ee65f54ee732d431$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $ee65f54ee732d431$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $ee65f54ee732d431$var$intlNumCache = {};
function $ee65f54ee732d431$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $ee65f54ee732d431$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $ee65f54ee732d431$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $ee65f54ee732d431$var$intlRelCache = {};
function $ee65f54ee732d431$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $ee65f54ee732d431$var$_objectWithoutPropertiesLoose(_opts, $ee65f54ee732d431$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $ee65f54ee732d431$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $ee65f54ee732d431$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $ee65f54ee732d431$var$sysLocaleCache = null;
function $ee65f54ee732d431$var$systemLocale() {
    if ($ee65f54ee732d431$var$sysLocaleCache) return $ee65f54ee732d431$var$sysLocaleCache;
    else {
        $ee65f54ee732d431$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $ee65f54ee732d431$var$sysLocaleCache;
    }
}
function $ee65f54ee732d431$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var smaller = localeStr.substring(0, uIndex);
        try {
            options = $ee65f54ee732d431$var$getCachedDTF(localeStr).resolvedOptions();
        } catch (e) {
            options = $ee65f54ee732d431$var$getCachedDTF(smaller).resolvedOptions();
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar; // return the smaller one so that we can append the calendar and numbering overrides to it
        return [
            smaller,
            numberingSystem,
            calendar
        ];
    }
}
function $ee65f54ee732d431$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $ee65f54ee732d431$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $ee65f54ee732d431$var$DateTime.utc(2016, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $ee65f54ee732d431$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $ee65f54ee732d431$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $ee65f54ee732d431$var$listStuff(loc, length, defaultOK, englishFn, intlFn) {
    var mode = loc.listingMode(defaultOK);
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $ee65f54ee732d431$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $ee65f54ee732d431$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $ee65f54ee732d431$var$_objectWithoutPropertiesLoose(opts, $ee65f54ee732d431$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $ee65f54ee732d431$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $ee65f54ee732d431$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $ee65f54ee732d431$var$roundTo(i, 3);
            return $ee65f54ee732d431$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $ee65f54ee732d431$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        var z;
        if (dt.zone.isUniversal) {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $ee65f54ee732d431$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata.
                // So we have to make do. Two cases:
                // 1. The format options tell us to show the zone. We can't do that, so the best
                // we can do is format the date in UTC.
                // 2. The format options don't tell us to show the zone. Then we can adjust them
                // the time and tell the formatter to show it to us in UTC, so that the time is right
                // and the bad zone doesn't show up.
                z = "UTC";
                if (opts.timeZoneName) this.dt = dt;
                else this.dt = dt.offset === 0 ? dt : $ee65f54ee732d431$var$DateTime.fromMillis(dt.ts + dt.offset * 60000);
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else {
            this.dt = dt;
            z = dt.zone.name;
        }
        var intlOpts = $ee65f54ee732d431$var$_extends({}, this.opts);
        if (z) intlOpts.timeZone = z;
        this.dtf = $ee65f54ee732d431$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        return this.dtf.formatToParts(this.dt.toJSDate());
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $ee65f54ee732d431$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $ee65f54ee732d431$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $ee65f54ee732d431$var$hasRelative()) this.rtf = $ee65f54ee732d431$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $ee65f54ee732d431$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
/**
 * @private
 */ var $ee65f54ee732d431$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $ee65f54ee732d431$var$Settings.defaultLocale; // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $ee65f54ee732d431$var$systemLocale());
        var numberingSystemR = numberingSystem || $ee65f54ee732d431$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $ee65f54ee732d431$var$Settings.defaultOutputCalendar;
        return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $ee65f54ee732d431$var$sysLocaleCache = null;
        $ee65f54ee732d431$var$intlDTCache = {};
        $ee65f54ee732d431$var$intlNumCache = {};
        $ee65f54ee732d431$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, outputCalendar = _ref.outputCalendar;
        return Locale.create(locale, numberingSystem, outputCalendar);
    };
    function Locale(locale, numbering, outputCalendar, specifiedLocale) {
        var _parseLocaleString = $ee65f54ee732d431$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.intl = $ee65f54ee732d431$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($ee65f54ee732d431$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($ee65f54ee732d431$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format, defaultOK) {
        var _this = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $ee65f54ee732d431$var$listStuff(this, length, defaultOK, $ee65f54ee732d431$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this.monthsCache[formatStr][length]) _this.monthsCache[formatStr][length] = $ee65f54ee732d431$var$mapMonths(function(dt) {
                return _this.extract(dt, intl, "month");
            });
            return _this.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
        var _this2 = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $ee65f54ee732d431$var$listStuff(this, length, defaultOK, $ee65f54ee732d431$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.weekdaysCache[formatStr][length]) _this2.weekdaysCache[formatStr][length] = $ee65f54ee732d431$var$mapWeekdays(function(dt) {
                return _this2.extract(dt, intl, "weekday");
            });
            return _this2.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1(defaultOK) {
        var _this3 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $ee65f54ee732d431$var$listStuff(this, undefined, defaultOK, function() {
            return $ee65f54ee732d431$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this3.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this3.meridiemCache = [
                    $ee65f54ee732d431$var$DateTime.utc(2016, 11, 13, 9),
                    $ee65f54ee732d431$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this3.extract(dt, intl, "dayperiod");
                });
            }
            return _this3.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length, defaultOK) {
        var _this4 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $ee65f54ee732d431$var$listStuff(this, length, defaultOK, $ee65f54ee732d431$var$eras, function() {
            var intl = {
                era: length
            }; // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this4.eraCache[length]) _this4.eraCache[length] = [
                $ee65f54ee732d431$var$DateTime.utc(-40, 1, 1),
                $ee65f54ee732d431$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this4.extract(dt, intl, "era");
            });
            return _this4.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $ee65f54ee732d431$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $ee65f54ee732d431$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $ee65f54ee732d431$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $ee65f54ee732d431$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $ee65f54ee732d431$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $ee65f54ee732d431$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ function $ee65f54ee732d431$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $ee65f54ee732d431$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $ee65f54ee732d431$var$_extends({}, mergedVals, val),
                mergedZone || zone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $ee65f54ee732d431$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $ee65f54ee732d431$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $ee65f54ee732d431$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
} // ISO and SQL parsing
var $ee65f54ee732d431$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, $ee65f54ee732d431$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, $ee65f54ee732d431$var$isoTimeRegex = RegExp("" + $ee65f54ee732d431$var$isoTimeBaseRegex.source + $ee65f54ee732d431$var$offsetRegex.source + "?"), $ee65f54ee732d431$var$isoTimeExtensionRegex = RegExp("(?:T" + $ee65f54ee732d431$var$isoTimeRegex.source + ")?"), $ee65f54ee732d431$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, $ee65f54ee732d431$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/, $ee65f54ee732d431$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/, $ee65f54ee732d431$var$extractISOWeekData = $ee65f54ee732d431$var$simpleParse("weekYear", "weekNumber", "weekDay"), $ee65f54ee732d431$var$extractISOOrdinalData = $ee65f54ee732d431$var$simpleParse("year", "ordinal"), $ee65f54ee732d431$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/, // dumbed-down version of the ISO one
$ee65f54ee732d431$var$sqlTimeRegex = RegExp($ee65f54ee732d431$var$isoTimeBaseRegex.source + " ?(?:" + $ee65f54ee732d431$var$offsetRegex.source + "|(" + $ee65f54ee732d431$var$ianaRegex.source + "))?"), $ee65f54ee732d431$var$sqlTimeExtensionRegex = RegExp("(?: " + $ee65f54ee732d431$var$sqlTimeRegex.source + ")?");
function $ee65f54ee732d431$var$int(match, pos, fallback) {
    var m = match[pos];
    return $ee65f54ee732d431$var$isUndefined(m) ? fallback : $ee65f54ee732d431$var$parseInteger(m);
}
function $ee65f54ee732d431$var$extractISOYmd(match, cursor) {
    var item = {
        year: $ee65f54ee732d431$var$int(match, cursor),
        month: $ee65f54ee732d431$var$int(match, cursor + 1, 1),
        day: $ee65f54ee732d431$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $ee65f54ee732d431$var$extractISOTime(match, cursor) {
    var item = {
        hours: $ee65f54ee732d431$var$int(match, cursor, 0),
        minutes: $ee65f54ee732d431$var$int(match, cursor + 1, 0),
        seconds: $ee65f54ee732d431$var$int(match, cursor + 2, 0),
        milliseconds: $ee65f54ee732d431$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $ee65f54ee732d431$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $ee65f54ee732d431$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $ee65f54ee732d431$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $ee65f54ee732d431$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $ee65f54ee732d431$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
} // ISO time parsing
var $ee65f54ee732d431$var$isoTimeOnly = RegExp("^T?" + $ee65f54ee732d431$var$isoTimeBaseRegex.source + "$"); // ISO duration parsing
var $ee65f54ee732d431$var$isoDuration = /^-?P(?:(?:(-?\d{1,9}(?:\.\d{1,9})?)Y)?(?:(-?\d{1,9}(?:\.\d{1,9})?)M)?(?:(-?\d{1,9}(?:\.\d{1,9})?)W)?(?:(-?\d{1,9}(?:\.\d{1,9})?)D)?(?:T(?:(-?\d{1,9}(?:\.\d{1,9})?)H)?(?:(-?\d{1,9}(?:\.\d{1,9})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,9}))?S)?)?)$/;
function $ee65f54ee732d431$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($ee65f54ee732d431$var$parseFloating(yearStr)),
            months: maybeNegate($ee65f54ee732d431$var$parseFloating(monthStr)),
            weeks: maybeNegate($ee65f54ee732d431$var$parseFloating(weekStr)),
            days: maybeNegate($ee65f54ee732d431$var$parseFloating(dayStr)),
            hours: maybeNegate($ee65f54ee732d431$var$parseFloating(hourStr)),
            minutes: maybeNegate($ee65f54ee732d431$var$parseFloating(minuteStr)),
            seconds: maybeNegate($ee65f54ee732d431$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($ee65f54ee732d431$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
} // These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $ee65f54ee732d431$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $ee65f54ee732d431$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $ee65f54ee732d431$var$untruncateYear($ee65f54ee732d431$var$parseInteger(yearStr)) : $ee65f54ee732d431$var$parseInteger(yearStr),
        month: $ee65f54ee732d431$var$monthsShort.indexOf(monthStr) + 1,
        day: $ee65f54ee732d431$var$parseInteger(dayStr),
        hour: $ee65f54ee732d431$var$parseInteger(hourStr),
        minute: $ee65f54ee732d431$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $ee65f54ee732d431$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $ee65f54ee732d431$var$weekdaysLong.indexOf(weekdayStr) + 1 : $ee65f54ee732d431$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
} // RFC 2822/5322
var $ee65f54ee732d431$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $ee65f54ee732d431$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $ee65f54ee732d431$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $ee65f54ee732d431$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $ee65f54ee732d431$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $ee65f54ee732d431$var$FixedOffsetZone(offset)
    ];
}
function $ee65f54ee732d431$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
} // http date
var $ee65f54ee732d431$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $ee65f54ee732d431$var$rfc850 = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $ee65f54ee732d431$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $ee65f54ee732d431$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $ee65f54ee732d431$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $ee65f54ee732d431$var$FixedOffsetZone.utcInstance
    ];
}
function $ee65f54ee732d431$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $ee65f54ee732d431$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $ee65f54ee732d431$var$FixedOffsetZone.utcInstance
    ];
}
var $ee65f54ee732d431$var$isoYmdWithTimeExtensionRegex = $ee65f54ee732d431$var$combineRegexes($ee65f54ee732d431$var$isoYmdRegex, $ee65f54ee732d431$var$isoTimeExtensionRegex);
var $ee65f54ee732d431$var$isoWeekWithTimeExtensionRegex = $ee65f54ee732d431$var$combineRegexes($ee65f54ee732d431$var$isoWeekRegex, $ee65f54ee732d431$var$isoTimeExtensionRegex);
var $ee65f54ee732d431$var$isoOrdinalWithTimeExtensionRegex = $ee65f54ee732d431$var$combineRegexes($ee65f54ee732d431$var$isoOrdinalRegex, $ee65f54ee732d431$var$isoTimeExtensionRegex);
var $ee65f54ee732d431$var$isoTimeCombinedRegex = $ee65f54ee732d431$var$combineRegexes($ee65f54ee732d431$var$isoTimeRegex);
var $ee65f54ee732d431$var$extractISOYmdTimeAndOffset = $ee65f54ee732d431$var$combineExtractors($ee65f54ee732d431$var$extractISOYmd, $ee65f54ee732d431$var$extractISOTime, $ee65f54ee732d431$var$extractISOOffset);
var $ee65f54ee732d431$var$extractISOWeekTimeAndOffset = $ee65f54ee732d431$var$combineExtractors($ee65f54ee732d431$var$extractISOWeekData, $ee65f54ee732d431$var$extractISOTime, $ee65f54ee732d431$var$extractISOOffset);
var $ee65f54ee732d431$var$extractISOOrdinalDateAndTime = $ee65f54ee732d431$var$combineExtractors($ee65f54ee732d431$var$extractISOOrdinalData, $ee65f54ee732d431$var$extractISOTime, $ee65f54ee732d431$var$extractISOOffset);
var $ee65f54ee732d431$var$extractISOTimeAndOffset = $ee65f54ee732d431$var$combineExtractors($ee65f54ee732d431$var$extractISOTime, $ee65f54ee732d431$var$extractISOOffset);
/**
 * @private
 */ function $ee65f54ee732d431$var$parseISODate(s) {
    return $ee65f54ee732d431$var$parse(s, [
        $ee65f54ee732d431$var$isoYmdWithTimeExtensionRegex,
        $ee65f54ee732d431$var$extractISOYmdTimeAndOffset
    ], [
        $ee65f54ee732d431$var$isoWeekWithTimeExtensionRegex,
        $ee65f54ee732d431$var$extractISOWeekTimeAndOffset
    ], [
        $ee65f54ee732d431$var$isoOrdinalWithTimeExtensionRegex,
        $ee65f54ee732d431$var$extractISOOrdinalDateAndTime
    ], [
        $ee65f54ee732d431$var$isoTimeCombinedRegex,
        $ee65f54ee732d431$var$extractISOTimeAndOffset
    ]);
}
function $ee65f54ee732d431$var$parseRFC2822Date(s) {
    return $ee65f54ee732d431$var$parse($ee65f54ee732d431$var$preprocessRFC2822(s), [
        $ee65f54ee732d431$var$rfc2822,
        $ee65f54ee732d431$var$extractRFC2822
    ]);
}
function $ee65f54ee732d431$var$parseHTTPDate(s) {
    return $ee65f54ee732d431$var$parse(s, [
        $ee65f54ee732d431$var$rfc1123,
        $ee65f54ee732d431$var$extractRFC1123Or850
    ], [
        $ee65f54ee732d431$var$rfc850,
        $ee65f54ee732d431$var$extractRFC1123Or850
    ], [
        $ee65f54ee732d431$var$ascii,
        $ee65f54ee732d431$var$extractASCII
    ]);
}
function $ee65f54ee732d431$var$parseISODuration(s) {
    return $ee65f54ee732d431$var$parse(s, [
        $ee65f54ee732d431$var$isoDuration,
        $ee65f54ee732d431$var$extractISODuration
    ]);
}
var $ee65f54ee732d431$var$extractISOTimeOnly = $ee65f54ee732d431$var$combineExtractors($ee65f54ee732d431$var$extractISOTime);
function $ee65f54ee732d431$var$parseISOTimeOnly(s) {
    return $ee65f54ee732d431$var$parse(s, [
        $ee65f54ee732d431$var$isoTimeOnly,
        $ee65f54ee732d431$var$extractISOTimeOnly
    ]);
}
var $ee65f54ee732d431$var$sqlYmdWithTimeExtensionRegex = $ee65f54ee732d431$var$combineRegexes($ee65f54ee732d431$var$sqlYmdRegex, $ee65f54ee732d431$var$sqlTimeExtensionRegex);
var $ee65f54ee732d431$var$sqlTimeCombinedRegex = $ee65f54ee732d431$var$combineRegexes($ee65f54ee732d431$var$sqlTimeRegex);
var $ee65f54ee732d431$var$extractISOYmdTimeOffsetAndIANAZone = $ee65f54ee732d431$var$combineExtractors($ee65f54ee732d431$var$extractISOYmd, $ee65f54ee732d431$var$extractISOTime, $ee65f54ee732d431$var$extractISOOffset, $ee65f54ee732d431$var$extractIANAZone);
var $ee65f54ee732d431$var$extractISOTimeOffsetAndIANAZone = $ee65f54ee732d431$var$combineExtractors($ee65f54ee732d431$var$extractISOTime, $ee65f54ee732d431$var$extractISOOffset, $ee65f54ee732d431$var$extractIANAZone);
function $ee65f54ee732d431$var$parseSQL(s) {
    return $ee65f54ee732d431$var$parse(s, [
        $ee65f54ee732d431$var$sqlYmdWithTimeExtensionRegex,
        $ee65f54ee732d431$var$extractISOYmdTimeOffsetAndIANAZone
    ], [
        $ee65f54ee732d431$var$sqlTimeCombinedRegex,
        $ee65f54ee732d431$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $ee65f54ee732d431$var$INVALID$2 = "Invalid Duration"; // unit conversion constants
var $ee65f54ee732d431$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $ee65f54ee732d431$var$casualMatrix = $ee65f54ee732d431$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $ee65f54ee732d431$var$lowOrderMatrix), $ee65f54ee732d431$var$daysInYearAccurate = 365.2425, $ee65f54ee732d431$var$daysInMonthAccurate = 30.436875, $ee65f54ee732d431$var$accurateMatrix = $ee65f54ee732d431$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $ee65f54ee732d431$var$daysInYearAccurate / 7,
        days: $ee65f54ee732d431$var$daysInYearAccurate,
        hours: $ee65f54ee732d431$var$daysInYearAccurate * 24,
        minutes: $ee65f54ee732d431$var$daysInYearAccurate * 1440,
        seconds: $ee65f54ee732d431$var$daysInYearAccurate * 86400,
        milliseconds: $ee65f54ee732d431$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $ee65f54ee732d431$var$daysInYearAccurate / 28,
        days: $ee65f54ee732d431$var$daysInYearAccurate / 4,
        hours: $ee65f54ee732d431$var$daysInYearAccurate * 24 / 4,
        minutes: $ee65f54ee732d431$var$daysInYearAccurate * 1440 / 4,
        seconds: $ee65f54ee732d431$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $ee65f54ee732d431$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $ee65f54ee732d431$var$daysInMonthAccurate / 7,
        days: $ee65f54ee732d431$var$daysInMonthAccurate,
        hours: $ee65f54ee732d431$var$daysInMonthAccurate * 24,
        minutes: $ee65f54ee732d431$var$daysInMonthAccurate * 1440,
        seconds: $ee65f54ee732d431$var$daysInMonthAccurate * 86400,
        milliseconds: $ee65f54ee732d431$var$daysInMonthAccurate * 86400000
    }
}, $ee65f54ee732d431$var$lowOrderMatrix); // units ordered by size
var $ee65f54ee732d431$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $ee65f54ee732d431$var$reverseUnits = $ee65f54ee732d431$var$orderedUnits$1.slice(0).reverse(); // clone really means "create another instance just like this one, but with these changes"
function $ee65f54ee732d431$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $ee65f54ee732d431$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
    };
    return new $ee65f54ee732d431$var$Duration(conf);
}
function $ee65f54ee732d431$var$antiTrunc(n) {
    return n < 0 ? Math.floor(n) : Math.ceil(n);
} // NB: mutates parameters
function $ee65f54ee732d431$var$convert(matrix, fromMap, fromUnit, toMap, toUnit) {
    var conv = matrix[toUnit][fromUnit], raw = fromMap[fromUnit] / conv, sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]), // ok, so this is wild, but see the matrix in the tests
    added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? $ee65f54ee732d431$var$antiTrunc(raw) : Math.trunc(raw);
    toMap[toUnit] += added;
    fromMap[fromUnit] -= added * conv;
} // NB: mutates parameters
function $ee65f54ee732d431$var$normalizeValues(matrix, vals) {
    $ee65f54ee732d431$var$reverseUnits.reduce(function(previous, current) {
        if (!$ee65f54ee732d431$var$isUndefined(vals[current])) {
            if (previous) $ee65f54ee732d431$var$convert(matrix, vals, previous, vals, current);
            return current;
        } else return previous;
    }, null);
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration#fromMillis}, {@link Duration#fromObject}, or {@link Duration#fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration.months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $ee65f54ee732d431$var$Duration = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $ee65f54ee732d431$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = accurate ? $ee65f54ee732d431$var$accurateMatrix : $ee65f54ee732d431$var$casualMatrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    };
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $ee65f54ee732d431$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $ee65f54ee732d431$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $ee65f54ee732d431$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy
        });
    };
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($ee65f54ee732d431$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $ee65f54ee732d431$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    };
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $ee65f54ee732d431$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $ee65f54ee732d431$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $ee65f54ee732d431$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $ee65f54ee732d431$var$Invalid ? reason : new $ee65f54ee732d431$var$Invalid(reason, explanation);
        if ($ee65f54ee732d431$var$Settings.throwOnInvalid) throw new $ee65f54ee732d431$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    };
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $ee65f54ee732d431$var$InvalidUnitError(unit);
        return normalized;
    };
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    };
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $ee65f54ee732d431$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $ee65f54ee732d431$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $ee65f54ee732d431$var$INVALID$2;
    };
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        var l = $ee65f54ee732d431$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($ee65f54ee732d431$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($ee65f54ee732d431$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($ee65f54ee732d431$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    };
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $ee65f54ee732d431$var$_extends({}, this.values);
    };
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $ee65f54ee732d431$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $ee65f54ee732d431$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts);
        var value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
        var fmt = opts.format === "basic" ? "hhmm" : "hh:mm";
        if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
            fmt += opts.format === "basic" ? "ss" : ":ss";
            if (!opts.suppressMilliseconds || value.milliseconds !== 0) fmt += ".SSS";
        }
        var str = value.toFormat(fmt);
        if (opts.includePrefix) str = "T" + str;
        return str;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toString = function toString() {
        return this.toISO();
    };
    _proto.toMillis = function toMillis() {
        return this.as("milliseconds");
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _iterator = $ee65f54ee732d431$var$_createForOfIteratorHelperLoose($ee65f54ee732d431$var$orderedUnits$1), _step; !(_step = _iterator()).done;){
            var k = _step.value;
            if ($ee65f54ee732d431$var$hasOwnProperty(dur.values, k) || $ee65f54ee732d431$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $ee65f54ee732d431$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    };
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i = 0, _Object$keys = Object.keys(this.values); _i < _Object$keys.length; _i++){
            var k = _Object$keys[_i];
            result[k] = $ee65f54ee732d431$var$asNumber(fn(this.values[k], k));
        }
        return $ee65f54ee732d431$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $ee65f54ee732d431$var$_extends({}, this.values, $ee65f54ee732d431$var$normalizeObject(values, Duration.normalizeUnit));
        return $ee65f54ee732d431$var$clone$1(this, {
            values: mixed
        });
    };
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        }), opts = {
            loc: loc
        };
        if (conversionAccuracy) opts.conversionAccuracy = conversionAccuracy;
        return $ee65f54ee732d431$var$clone$1(this, opts);
    };
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    };
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $ee65f54ee732d431$var$normalizeValues(this.matrix, vals);
        return $ee65f54ee732d431$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _iterator2 = $ee65f54ee732d431$var$_createForOfIteratorHelperLoose($ee65f54ee732d431$var$orderedUnits$1), _step2; !(_step2 = _iterator2()).done;){
            var k = _step2.value;
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0; // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                } // plus anything that's already in this unit
                if ($ee65f54ee732d431$var$isNumber(vals[k])) own += vals[k];
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000; // plus anything further down the chain that should be rolled up in to this
                for(var down in vals)if ($ee65f54ee732d431$var$orderedUnits$1.indexOf(down) > $ee65f54ee732d431$var$orderedUnits$1.indexOf(k)) $ee65f54ee732d431$var$convert(this.matrix, vals, down, built, k);
                 // otherwise, keep it in the wings to boil it later
            } else if ($ee65f54ee732d431$var$isNumber(vals[k])) accumulated[k] = vals[k];
        } // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        return $ee65f54ee732d431$var$clone$1(this, {
            values: built
        }, true).normalize();
    };
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i2 = 0, _Object$keys2 = Object.keys(this.values); _i2 < _Object$keys2.length; _i2++){
            var k = _Object$keys2[_i2];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $ee65f54ee732d431$var$clone$1(this, {
            values: negated
        }, true);
    };
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _iterator3 = $ee65f54ee732d431$var$_createForOfIteratorHelperLoose($ee65f54ee732d431$var$orderedUnits$1), _step3; !(_step3 = _iterator3()).done;){
            var u = _step3.value;
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $ee65f54ee732d431$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}();
var $ee65f54ee732d431$var$INVALID$1 = "Invalid Interval"; // checks if the start is equal to or before the end
function $ee65f54ee732d431$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $ee65f54ee732d431$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $ee65f54ee732d431$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $ee65f54ee732d431$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval#fromDateTimes}, {@link Interval#after}, {@link Interval#before}, or {@link Interval#fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval#merge}, {@link Interval#xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $ee65f54ee732d431$var$Interval = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $ee65f54ee732d431$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $ee65f54ee732d431$var$Invalid ? reason : new $ee65f54ee732d431$var$Invalid(reason, explanation);
        if ($ee65f54ee732d431$var$Settings.throwOnInvalid) throw new $ee65f54ee732d431$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    };
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $ee65f54ee732d431$var$friendlyDateTime(start), builtEnd = $ee65f54ee732d431$var$friendlyDateTime(end);
        var validateError = $ee65f54ee732d431$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    };
    Interval.after = function after(start, duration) {
        var dur = $ee65f54ee732d431$var$Duration.fromDurationLike(duration), dt = $ee65f54ee732d431$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    };
    Interval.before = function before(end, duration) {
        var dur = $ee65f54ee732d431$var$Duration.fromDurationLike(duration), dt = $ee65f54ee732d431$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    };
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $ee65f54ee732d431$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $ee65f54ee732d431$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $ee65f54ee732d431$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $ee65f54ee732d431$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    };
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    };
    _proto.count = function count(unit) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit), end = this.end.startOf(unit);
        return Math.floor(end.diff(start, unit).get(unit)) + 1;
    };
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    };
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    };
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    };
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    };
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    };
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    };
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($ee65f54ee732d431$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    };
    _proto.splitBy = function splitBy(duration) {
        var dur = $ee65f54ee732d431$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    };
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    };
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    };
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    };
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    };
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    };
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    };
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    };
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    };
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    };
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $ee65f54ee732d431$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    };
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    };
    _proto.toString = function toString() {
        if (!this.isValid) return $ee65f54ee732d431$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    };
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $ee65f54ee732d431$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    };
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $ee65f54ee732d431$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $ee65f54ee732d431$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    };
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $ee65f54ee732d431$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    };
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $ee65f54ee732d431$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    };
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $ee65f54ee732d431$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}();
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $ee65f54ee732d431$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $ee65f54ee732d431$var$Settings.defaultZone;
        var proto = $ee65f54ee732d431$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    };
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $ee65f54ee732d431$var$IANAZone.isValidZone(zone);
    };
    Info.normalizeZone = function normalizeZone$1(input) {
        return $ee65f54ee732d431$var$normalizeZone(input, $ee65f54ee732d431$var$Settings.defaultZone);
    };
    Info.months = function months(length, _temp) {
        if (length === void 0) length = "long";
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$numberingSystem = _ref.numberingSystem, numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj, _ref$outputCalendar = _ref.outputCalendar, outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
        return (locObj || $ee65f54ee732d431$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    };
    Info.monthsFormat = function monthsFormat(length, _temp2) {
        if (length === void 0) length = "long";
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$numberingSystem = _ref2.numberingSystem, numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj, _ref2$outputCalendar = _ref2.outputCalendar, outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
        return (locObj || $ee65f54ee732d431$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    };
    Info.weekdays = function weekdays(length, _temp3) {
        if (length === void 0) length = "long";
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$numberingSystem = _ref3.numberingSystem, numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        return (locObj || $ee65f54ee732d431$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    };
    Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;
        return (locObj || $ee65f54ee732d431$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    };
    Info.meridiems = function meridiems(_temp5) {
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale;
        return $ee65f54ee732d431$var$Locale.create(locale).meridiems();
    };
    Info.eras = function eras(length, _temp6) {
        if (length === void 0) length = "short";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale;
        return $ee65f54ee732d431$var$Locale.create(locale, null, "gregory").eras(length);
    };
    Info.features = function features() {
        return {
            relative: $ee65f54ee732d431$var$hasRelative()
        };
    };
    return Info;
}();
function $ee65f54ee732d431$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($ee65f54ee732d431$var$Duration.fromMillis(ms).as("days"));
}
function $ee65f54ee732d431$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $ee65f54ee732d431$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $ee65f54ee732d431$var$dayDiff
        ]
    ];
    var results = {};
    var lowestOrder, highWater;
    for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            var _cursor$plus;
            lowestOrder = unit;
            var delta = differ(cursor, later);
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[unit] = delta, _cursor$plus));
            if (highWater > later) {
                var _cursor$plus2;
                cursor = cursor.plus((_cursor$plus2 = {}, _cursor$plus2[unit] = delta - 1, _cursor$plus2));
                delta -= 1;
            } else cursor = highWater;
            results[unit] = delta;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $ee65f54ee732d431$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $ee65f54ee732d431$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus3;
            highWater = cursor.plus((_cursor$plus3 = {}, _cursor$plus3[lowestOrder] = 1, _cursor$plus3));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $ee65f54ee732d431$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $ee65f54ee732d431$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $ee65f54ee732d431$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $ee65f54ee732d431$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $ee65f54ee732d431$var$hanidecChars = $ee65f54ee732d431$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $ee65f54ee732d431$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($ee65f54ee732d431$var$numberingSystems.hanidec) !== -1) value += $ee65f54ee732d431$var$hanidecChars.indexOf(str[i]);
            else for(var key in $ee65f54ee732d431$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $ee65f54ee732d431$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $ee65f54ee732d431$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $ee65f54ee732d431$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $ee65f54ee732d431$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $ee65f54ee732d431$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($ee65f54ee732d431$var$parseDigits(s));
        }
    };
}
var $ee65f54ee732d431$var$NBSP = String.fromCharCode(160);
var $ee65f54ee732d431$var$spaceOrNBSP = "( |" + $ee65f54ee732d431$var$NBSP + ")";
var $ee65f54ee732d431$var$spaceOrNBSPRegExp = new RegExp($ee65f54ee732d431$var$spaceOrNBSP, "g");
function $ee65f54ee732d431$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($ee65f54ee732d431$var$spaceOrNBSPRegExp, $ee65f54ee732d431$var$spaceOrNBSP);
}
function $ee65f54ee732d431$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($ee65f54ee732d431$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $ee65f54ee732d431$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($ee65f54ee732d431$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $ee65f54ee732d431$var$stripInsensitivities(s) === $ee65f54ee732d431$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $ee65f54ee732d431$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $ee65f54ee732d431$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $ee65f54ee732d431$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $ee65f54ee732d431$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function $ee65f54ee732d431$var$unitForToken(token, loc) {
    var one = $ee65f54ee732d431$var$digitRegex(loc), two = $ee65f54ee732d431$var$digitRegex(loc, "{2}"), three = $ee65f54ee732d431$var$digitRegex(loc, "{3}"), four = $ee65f54ee732d431$var$digitRegex(loc, "{4}"), six = $ee65f54ee732d431$var$digitRegex(loc, "{6}"), oneOrTwo = $ee65f54ee732d431$var$digitRegex(loc, "{1,2}"), oneToThree = $ee65f54ee732d431$var$digitRegex(loc, "{1,3}"), oneToSix = $ee65f54ee732d431$var$digitRegex(loc, "{1,6}"), oneToNine = $ee65f54ee732d431$var$digitRegex(loc, "{1,9}"), twoToFour = $ee65f54ee732d431$var$digitRegex(loc, "{2,4}"), fourToSix = $ee65f54ee732d431$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($ee65f54ee732d431$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $ee65f54ee732d431$var$oneOf(loc.eras("short", false), 0);
            case "GG":
                return $ee65f54ee732d431$var$oneOf(loc.eras("long", false), 0);
            // years
            case "y":
                return $ee65f54ee732d431$var$intUnit(oneToSix);
            case "yy":
                return $ee65f54ee732d431$var$intUnit(twoToFour, $ee65f54ee732d431$var$untruncateYear);
            case "yyyy":
                return $ee65f54ee732d431$var$intUnit(four);
            case "yyyyy":
                return $ee65f54ee732d431$var$intUnit(fourToSix);
            case "yyyyyy":
                return $ee65f54ee732d431$var$intUnit(six);
            // months
            case "M":
                return $ee65f54ee732d431$var$intUnit(oneOrTwo);
            case "MM":
                return $ee65f54ee732d431$var$intUnit(two);
            case "MMM":
                return $ee65f54ee732d431$var$oneOf(loc.months("short", true, false), 1);
            case "MMMM":
                return $ee65f54ee732d431$var$oneOf(loc.months("long", true, false), 1);
            case "L":
                return $ee65f54ee732d431$var$intUnit(oneOrTwo);
            case "LL":
                return $ee65f54ee732d431$var$intUnit(two);
            case "LLL":
                return $ee65f54ee732d431$var$oneOf(loc.months("short", false, false), 1);
            case "LLLL":
                return $ee65f54ee732d431$var$oneOf(loc.months("long", false, false), 1);
            // dates
            case "d":
                return $ee65f54ee732d431$var$intUnit(oneOrTwo);
            case "dd":
                return $ee65f54ee732d431$var$intUnit(two);
            // ordinals
            case "o":
                return $ee65f54ee732d431$var$intUnit(oneToThree);
            case "ooo":
                return $ee65f54ee732d431$var$intUnit(three);
            // time
            case "HH":
                return $ee65f54ee732d431$var$intUnit(two);
            case "H":
                return $ee65f54ee732d431$var$intUnit(oneOrTwo);
            case "hh":
                return $ee65f54ee732d431$var$intUnit(two);
            case "h":
                return $ee65f54ee732d431$var$intUnit(oneOrTwo);
            case "mm":
                return $ee65f54ee732d431$var$intUnit(two);
            case "m":
                return $ee65f54ee732d431$var$intUnit(oneOrTwo);
            case "q":
                return $ee65f54ee732d431$var$intUnit(oneOrTwo);
            case "qq":
                return $ee65f54ee732d431$var$intUnit(two);
            case "s":
                return $ee65f54ee732d431$var$intUnit(oneOrTwo);
            case "ss":
                return $ee65f54ee732d431$var$intUnit(two);
            case "S":
                return $ee65f54ee732d431$var$intUnit(oneToThree);
            case "SSS":
                return $ee65f54ee732d431$var$intUnit(three);
            case "u":
                return $ee65f54ee732d431$var$simple(oneToNine);
            case "uu":
                return $ee65f54ee732d431$var$simple(oneOrTwo);
            case "uuu":
                return $ee65f54ee732d431$var$intUnit(one);
            // meridiem
            case "a":
                return $ee65f54ee732d431$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $ee65f54ee732d431$var$intUnit(four);
            case "kk":
                return $ee65f54ee732d431$var$intUnit(twoToFour, $ee65f54ee732d431$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $ee65f54ee732d431$var$intUnit(oneOrTwo);
            case "WW":
                return $ee65f54ee732d431$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $ee65f54ee732d431$var$intUnit(one);
            case "EEE":
                return $ee65f54ee732d431$var$oneOf(loc.weekdays("short", false, false), 1);
            case "EEEE":
                return $ee65f54ee732d431$var$oneOf(loc.weekdays("long", false, false), 1);
            case "ccc":
                return $ee65f54ee732d431$var$oneOf(loc.weekdays("short", true, false), 1);
            case "cccc":
                return $ee65f54ee732d431$var$oneOf(loc.weekdays("long", true, false), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $ee65f54ee732d431$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $ee65f54ee732d431$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $ee65f54ee732d431$var$simple(/[a-z_+-/]{1,256}?/i);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $ee65f54ee732d431$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $ee65f54ee732d431$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour: {
        numeric: "h",
        "2-digit": "hh"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    }
};
function $ee65f54ee732d431$var$tokenForPart(part, locale, formatOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") return {
        literal: true,
        val: value
    };
    var style = formatOpts[type];
    var val = $ee65f54ee732d431$var$partTypeStyleToTokenVal[type];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $ee65f54ee732d431$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $ee65f54ee732d431$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($ee65f54ee732d431$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $ee65f54ee732d431$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$ee65f54ee732d431$var$isUndefined(matches.z)) zone = $ee65f54ee732d431$var$IANAZone.create(matches.z);
    if (!$ee65f54ee732d431$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $ee65f54ee732d431$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$ee65f54ee732d431$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$ee65f54ee732d431$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$ee65f54ee732d431$var$isUndefined(matches.u)) matches.S = $ee65f54ee732d431$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $ee65f54ee732d431$var$dummyDateTimeCache = null;
function $ee65f54ee732d431$var$getDummyDateTime() {
    if (!$ee65f54ee732d431$var$dummyDateTimeCache) $ee65f54ee732d431$var$dummyDateTimeCache = $ee65f54ee732d431$var$DateTime.fromMillis(1555555555555);
    return $ee65f54ee732d431$var$dummyDateTimeCache;
}
function $ee65f54ee732d431$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $ee65f54ee732d431$var$Formatter.macroTokenToFormatOpts(token.val);
    if (!formatOpts) return token;
    var formatter = $ee65f54ee732d431$var$Formatter.create(locale, formatOpts);
    var parts = formatter.formatDateTimeParts($ee65f54ee732d431$var$getDummyDateTime());
    var tokens = parts.map(function(p) {
        return $ee65f54ee732d431$var$tokenForPart(p, locale, formatOpts);
    });
    if (tokens.includes(undefined)) return token;
    return tokens;
}
function $ee65f54ee732d431$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $ee65f54ee732d431$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $ee65f54ee732d431$var$explainFromTokens(locale, input, format) {
    var tokens = $ee65f54ee732d431$var$expandMacroTokens($ee65f54ee732d431$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $ee65f54ee732d431$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $ee65f54ee732d431$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $ee65f54ee732d431$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $ee65f54ee732d431$var$dateTimeFromMatches(matches) : [
            null,
            null,
            undefined
        ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
        if ($ee65f54ee732d431$var$hasOwnProperty(matches, "a") && $ee65f54ee732d431$var$hasOwnProperty(matches, "H")) throw new $ee65f54ee732d431$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone,
            specificOffset: specificOffset
        };
    }
}
function $ee65f54ee732d431$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $ee65f54ee732d431$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
var $ee65f54ee732d431$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $ee65f54ee732d431$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $ee65f54ee732d431$var$unitOutOfRange(unit, value) {
    return new $ee65f54ee732d431$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $ee65f54ee732d431$var$dayOfWeek(year, month, day) {
    var js = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
    return js === 0 ? 7 : js;
}
function $ee65f54ee732d431$var$computeOrdinal(year, month, day) {
    return day + ($ee65f54ee732d431$var$isLeapYear(year) ? $ee65f54ee732d431$var$leapLadder : $ee65f54ee732d431$var$nonLeapLadder)[month - 1];
}
function $ee65f54ee732d431$var$uncomputeOrdinal(year, ordinal) {
    var table = $ee65f54ee732d431$var$isLeapYear(year) ? $ee65f54ee732d431$var$leapLadder : $ee65f54ee732d431$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
/**
 * @private
 */ function $ee65f54ee732d431$var$gregorianToWeek(gregObj) {
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $ee65f54ee732d431$var$computeOrdinal(year, month, day), weekday = $ee65f54ee732d431$var$dayOfWeek(year, month, day);
    var weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $ee65f54ee732d431$var$weeksInWeekYear(weekYear);
    } else if (weekNumber > $ee65f54ee732d431$var$weeksInWeekYear(year)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $ee65f54ee732d431$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $ee65f54ee732d431$var$timeObject(gregObj));
}
function $ee65f54ee732d431$var$weekToGregorian(weekData) {
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $ee65f54ee732d431$var$dayOfWeek(weekYear, 1, 4), yearInDays = $ee65f54ee732d431$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $ee65f54ee732d431$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $ee65f54ee732d431$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $ee65f54ee732d431$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $ee65f54ee732d431$var$_extends({
        year: year,
        month: month,
        day: day
    }, $ee65f54ee732d431$var$timeObject(weekData));
}
function $ee65f54ee732d431$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $ee65f54ee732d431$var$computeOrdinal(year, month, day);
    return $ee65f54ee732d431$var$_extends({
        year: year,
        ordinal: ordinal
    }, $ee65f54ee732d431$var$timeObject(gregData));
}
function $ee65f54ee732d431$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $ee65f54ee732d431$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $ee65f54ee732d431$var$_extends({
        year: year,
        month: month,
        day: day
    }, $ee65f54ee732d431$var$timeObject(ordinalData));
}
function $ee65f54ee732d431$var$hasInvalidWeekData(obj) {
    var validYear = $ee65f54ee732d431$var$isInteger(obj.weekYear), validWeek = $ee65f54ee732d431$var$integerBetween(obj.weekNumber, 1, $ee65f54ee732d431$var$weeksInWeekYear(obj.weekYear)), validWeekday = $ee65f54ee732d431$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $ee65f54ee732d431$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $ee65f54ee732d431$var$unitOutOfRange("week", obj.week);
    else if (!validWeekday) return $ee65f54ee732d431$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $ee65f54ee732d431$var$hasInvalidOrdinalData(obj) {
    var validYear = $ee65f54ee732d431$var$isInteger(obj.year), validOrdinal = $ee65f54ee732d431$var$integerBetween(obj.ordinal, 1, $ee65f54ee732d431$var$daysInYear(obj.year));
    if (!validYear) return $ee65f54ee732d431$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $ee65f54ee732d431$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $ee65f54ee732d431$var$hasInvalidGregorianData(obj) {
    var validYear = $ee65f54ee732d431$var$isInteger(obj.year), validMonth = $ee65f54ee732d431$var$integerBetween(obj.month, 1, 12), validDay = $ee65f54ee732d431$var$integerBetween(obj.day, 1, $ee65f54ee732d431$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $ee65f54ee732d431$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $ee65f54ee732d431$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $ee65f54ee732d431$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $ee65f54ee732d431$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $ee65f54ee732d431$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $ee65f54ee732d431$var$integerBetween(minute, 0, 59), validSecond = $ee65f54ee732d431$var$integerBetween(second, 0, 59), validMillisecond = $ee65f54ee732d431$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $ee65f54ee732d431$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $ee65f54ee732d431$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $ee65f54ee732d431$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $ee65f54ee732d431$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
var $ee65f54ee732d431$var$INVALID = "Invalid DateTime";
var $ee65f54ee732d431$var$MAX_DATE = 8.64e15;
function $ee65f54ee732d431$var$unsupportedZone(zone) {
    return new $ee65f54ee732d431$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
} // we cache week data on the DT object and this intermediates the cache
function $ee65f54ee732d431$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $ee65f54ee732d431$var$gregorianToWeek(dt.c);
    return dt.weekData;
} // clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $ee65f54ee732d431$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $ee65f54ee732d431$var$DateTime($ee65f54ee732d431$var$_extends({}, current, alts, {
        old: current
    }));
} // find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $ee65f54ee732d431$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000; // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess); // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
     // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000; // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
     // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
} // convert an epoch timestamp into a calendar object with the given offset
function $ee65f54ee732d431$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
} // convert a calendar object to a epoch timestamp
function $ee65f54ee732d431$var$objToTS(obj, offset, zone) {
    return $ee65f54ee732d431$var$fixOffset($ee65f54ee732d431$var$objToLocalTS(obj), offset, zone);
} // create a new DT instance by adding a duration, adjusting for DSTs
function $ee65f54ee732d431$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $ee65f54ee732d431$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $ee65f54ee732d431$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $ee65f54ee732d431$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $ee65f54ee732d431$var$objToLocalTS(c);
    var _fixOffset = $ee65f54ee732d431$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd; // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
} // helper useful in turning the results of parsing into real dates
// by handling the zone options
function $ee65f54ee732d431$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0) {
        var interpretationZone = parsedZone || zone, inst = $ee65f54ee732d431$var$DateTime.fromObject(parsed, $ee65f54ee732d431$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $ee65f54ee732d431$var$DateTime.invalid(new $ee65f54ee732d431$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
} // if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $ee65f54ee732d431$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $ee65f54ee732d431$var$Formatter.create($ee65f54ee732d431$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $ee65f54ee732d431$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $ee65f54ee732d431$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $ee65f54ee732d431$var$padStart(o.c.month);
        c += "-";
        c += $ee65f54ee732d431$var$padStart(o.c.day);
    } else {
        c += $ee65f54ee732d431$var$padStart(o.c.month);
        c += $ee65f54ee732d431$var$padStart(o.c.day);
    }
    return c;
}
function $ee65f54ee732d431$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset) {
    var c = $ee65f54ee732d431$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $ee65f54ee732d431$var$padStart(o.c.minute);
        if (o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $ee65f54ee732d431$var$padStart(o.c.minute);
    if (o.c.second !== 0 || !suppressSeconds) {
        c += $ee65f54ee732d431$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $ee65f54ee732d431$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $ee65f54ee732d431$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $ee65f54ee732d431$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $ee65f54ee732d431$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $ee65f54ee732d431$var$padStart(Math.trunc(o.o % 60));
        }
    }
    return c;
} // defaults for unspecified units in the supported calendars
var $ee65f54ee732d431$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $ee65f54ee732d431$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $ee65f54ee732d431$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}; // Units in the supported calendars, sorted by bigness
var $ee65f54ee732d431$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $ee65f54ee732d431$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $ee65f54ee732d431$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
]; // standardize case and plurality in units
function $ee65f54ee732d431$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $ee65f54ee732d431$var$InvalidUnitError(unit);
    return normalized;
} // this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $ee65f54ee732d431$var$quickDT(obj, opts) {
    var zone = $ee65f54ee732d431$var$normalizeZone(opts.zone, $ee65f54ee732d431$var$Settings.defaultZone), loc = $ee65f54ee732d431$var$Locale.fromObject(opts), tsNow = $ee65f54ee732d431$var$Settings.now();
    var ts, o; // assume we have the higher-order units
    if (!$ee65f54ee732d431$var$isUndefined(obj.year)) {
        for(var _iterator = $ee65f54ee732d431$var$_createForOfIteratorHelperLoose($ee65f54ee732d431$var$orderedUnits), _step; !(_step = _iterator()).done;){
            var u = _step.value;
            if ($ee65f54ee732d431$var$isUndefined(obj[u])) obj[u] = $ee65f54ee732d431$var$defaultUnitValues[u];
        }
        var invalid = $ee65f54ee732d431$var$hasInvalidGregorianData(obj) || $ee65f54ee732d431$var$hasInvalidTimeData(obj);
        if (invalid) return $ee65f54ee732d431$var$DateTime.invalid(invalid);
        var offsetProvis = zone.offset(tsNow);
        var _objToTS = $ee65f54ee732d431$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = tsNow;
    return new $ee65f54ee732d431$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $ee65f54ee732d431$var$diffRelative(start, end, opts) {
    var round = $ee65f54ee732d431$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $ee65f54ee732d431$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator2 = $ee65f54ee732d431$var$_createForOfIteratorHelperLoose(opts.units), _step2; !(_step2 = _iterator2()).done;){
        var unit = _step2.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $ee65f54ee732d431$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime#local}, {@link DateTime#utc}, and (most flexibly) {@link DateTime#fromObject}. To create one from a standard string format, use {@link DateTime#fromISO}, {@link DateTime#fromHTTP}, and {@link DateTime#fromRFC2822}. To create one from a custom string format, use {@link DateTime#fromFormat}. To create one from a native JS date, use {@link DateTime#fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $ee65f54ee732d431$var$DateTime = /*#__PURE__*/ function() {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $ee65f54ee732d431$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $ee65f54ee732d431$var$Invalid("invalid input") : null) || (!zone.isValid ? $ee65f54ee732d431$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $ee65f54ee732d431$var$isUndefined(config.ts) ? $ee65f54ee732d431$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $ee65f54ee732d431$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $ee65f54ee732d431$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $ee65f54ee732d431$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    } // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    };
    DateTime.local = function local() {
        var _lastOpts = $ee65f54ee732d431$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $ee65f54ee732d431$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.utc = function utc() {
        var _lastOpts2 = $ee65f54ee732d431$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $ee65f54ee732d431$var$FixedOffsetZone.utcInstance;
        return $ee65f54ee732d431$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $ee65f54ee732d431$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $ee65f54ee732d431$var$normalizeZone(options.zone, $ee65f54ee732d431$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($ee65f54ee732d431$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $ee65f54ee732d431$var$Locale.fromObject(options)
        });
    };
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$ee65f54ee732d431$var$isNumber(milliseconds)) throw new $ee65f54ee732d431$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$ee65f54ee732d431$var$MAX_DATE || milliseconds > $ee65f54ee732d431$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $ee65f54ee732d431$var$normalizeZone(options.zone, $ee65f54ee732d431$var$Settings.defaultZone),
            loc: $ee65f54ee732d431$var$Locale.fromObject(options)
        });
    };
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$ee65f54ee732d431$var$isNumber(seconds)) throw new $ee65f54ee732d431$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $ee65f54ee732d431$var$normalizeZone(options.zone, $ee65f54ee732d431$var$Settings.defaultZone),
            loc: $ee65f54ee732d431$var$Locale.fromObject(options)
        });
    };
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $ee65f54ee732d431$var$normalizeZone(opts.zone, $ee65f54ee732d431$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($ee65f54ee732d431$var$unsupportedZone(zoneToUse));
        var tsNow = $ee65f54ee732d431$var$Settings.now(), offsetProvis = !$ee65f54ee732d431$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), normalized = $ee65f54ee732d431$var$normalizeObject(obj, $ee65f54ee732d431$var$normalizeUnit), containsOrdinal = !$ee65f54ee732d431$var$isUndefined(normalized.ordinal), containsGregorYear = !$ee65f54ee732d431$var$isUndefined(normalized.year), containsGregorMD = !$ee65f54ee732d431$var$isUndefined(normalized.month) || !$ee65f54ee732d431$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = $ee65f54ee732d431$var$Locale.fromObject(opts); // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $ee65f54ee732d431$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $ee65f54ee732d431$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor; // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $ee65f54ee732d431$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $ee65f54ee732d431$var$orderedWeekUnits;
            defaultValues = $ee65f54ee732d431$var$defaultWeekUnitValues;
            objNow = $ee65f54ee732d431$var$gregorianToWeek(objNow);
        } else if (containsOrdinal) {
            units = $ee65f54ee732d431$var$orderedOrdinalUnits;
            defaultValues = $ee65f54ee732d431$var$defaultOrdinalUnitValues;
            objNow = $ee65f54ee732d431$var$gregorianToOrdinal(objNow);
        } else {
            units = $ee65f54ee732d431$var$orderedUnits;
            defaultValues = $ee65f54ee732d431$var$defaultUnitValues;
        } // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator3 = $ee65f54ee732d431$var$_createForOfIteratorHelperLoose(units), _step3; !(_step3 = _iterator3()).done;){
            var u = _step3.value;
            var v = normalized[u];
            if (!$ee65f54ee732d431$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        } // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $ee65f54ee732d431$var$hasInvalidWeekData(normalized) : containsOrdinal ? $ee65f54ee732d431$var$hasInvalidOrdinalData(normalized) : $ee65f54ee732d431$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $ee65f54ee732d431$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
         // compute the actual time
        var gregorian = useWeekData ? $ee65f54ee732d431$var$weekToGregorian(normalized) : containsOrdinal ? $ee65f54ee732d431$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $ee65f54ee732d431$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        }); // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    };
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $ee65f54ee732d431$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $ee65f54ee732d431$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    };
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $ee65f54ee732d431$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $ee65f54ee732d431$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    };
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $ee65f54ee732d431$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $ee65f54ee732d431$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    };
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($ee65f54ee732d431$var$isUndefined(text) || $ee65f54ee732d431$var$isUndefined(fmt)) throw new $ee65f54ee732d431$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $ee65f54ee732d431$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $ee65f54ee732d431$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $ee65f54ee732d431$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    };
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    };
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $ee65f54ee732d431$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $ee65f54ee732d431$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    };
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $ee65f54ee732d431$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $ee65f54ee732d431$var$Invalid ? reason : new $ee65f54ee732d431$var$Invalid(reason, explanation);
        if ($ee65f54ee732d431$var$Settings.throwOnInvalid) throw new $ee65f54ee732d431$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    };
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } // INFO
    ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    };
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $ee65f54ee732d431$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } // TRANSFORM
    ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($ee65f54ee732d431$var$FixedOffsetZone.instance(offset), opts);
    };
    _proto.toLocal = function toLocal() {
        return this.setZone($ee65f54ee732d431$var$Settings.defaultZone);
    };
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $ee65f54ee732d431$var$normalizeZone(zone, $ee65f54ee732d431$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($ee65f54ee732d431$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $ee65f54ee732d431$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $ee65f54ee732d431$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    };
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $ee65f54ee732d431$var$clone(this, {
            loc: loc
        });
    };
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $ee65f54ee732d431$var$normalizeObject(values, $ee65f54ee732d431$var$normalizeUnit), settingWeekStuff = !$ee65f54ee732d431$var$isUndefined(normalized.weekYear) || !$ee65f54ee732d431$var$isUndefined(normalized.weekNumber) || !$ee65f54ee732d431$var$isUndefined(normalized.weekday), containsOrdinal = !$ee65f54ee732d431$var$isUndefined(normalized.ordinal), containsGregorYear = !$ee65f54ee732d431$var$isUndefined(normalized.year), containsGregorMD = !$ee65f54ee732d431$var$isUndefined(normalized.month) || !$ee65f54ee732d431$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $ee65f54ee732d431$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $ee65f54ee732d431$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $ee65f54ee732d431$var$weekToGregorian($ee65f54ee732d431$var$_extends({}, $ee65f54ee732d431$var$gregorianToWeek(this.c), normalized));
        else if (!$ee65f54ee732d431$var$isUndefined(normalized.ordinal)) mixed = $ee65f54ee732d431$var$ordinalToGregorian($ee65f54ee732d431$var$_extends({}, $ee65f54ee732d431$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $ee65f54ee732d431$var$_extends({}, this.toObject(), normalized); // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($ee65f54ee732d431$var$isUndefined(normalized.day)) mixed.day = Math.min($ee65f54ee732d431$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $ee65f54ee732d431$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $ee65f54ee732d431$var$clone(this, {
            ts: ts,
            o: o
        });
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $ee65f54ee732d431$var$Duration.fromDurationLike(duration);
        return $ee65f54ee732d431$var$clone(this, $ee65f54ee732d431$var$adjustTime(this, dur));
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $ee65f54ee732d431$var$Duration.fromDurationLike(duration).negate();
        return $ee65f54ee732d431$var$clone(this, $ee65f54ee732d431$var$adjustTime(this, dur));
    };
    _proto.startOf = function startOf(unit) {
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $ee65f54ee732d431$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") o.weekday = 1;
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    };
    _proto.endOf = function endOf(unit) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
    } // OUTPUT
    ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $ee65f54ee732d431$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $ee65f54ee732d431$var$INVALID;
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $ee65f54ee732d431$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $ee65f54ee732d431$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $ee65f54ee732d431$var$INVALID;
    };
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $ee65f54ee732d431$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    };
    _proto.toISO = function toISO(_temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$format = _ref4.format, format = _ref4$format === void 0 ? "extended" : _ref4$format, _ref4$suppressSeconds = _ref4.suppressSeconds, suppressSeconds = _ref4$suppressSeconds === void 0 ? false : _ref4$suppressSeconds, _ref4$suppressMillise = _ref4.suppressMilliseconds, suppressMilliseconds = _ref4$suppressMillise === void 0 ? false : _ref4$suppressMillise, _ref4$includeOffset = _ref4.includeOffset, includeOffset = _ref4$includeOffset === void 0 ? true : _ref4$includeOffset;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $ee65f54ee732d431$var$_toISODate(this, ext);
        c += "T";
        c += $ee65f54ee732d431$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset);
        return c;
    };
    _proto.toISODate = function toISODate(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format;
        if (!this.isValid) return null;
        return $ee65f54ee732d431$var$_toISODate(this, format === "extended");
    };
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $ee65f54ee732d431$var$toTechFormat(this, "kkkk-'W'WW-c");
    };
    _proto.toISOTime = function toISOTime(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$suppressMillise = _ref6.suppressMilliseconds, suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise, _ref6$suppressSeconds = _ref6.suppressSeconds, suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds, _ref6$includeOffset = _ref6.includeOffset, includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset, _ref6$includePrefix = _ref6.includePrefix, includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $ee65f54ee732d431$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset);
    };
    _proto.toRFC2822 = function toRFC2822() {
        return $ee65f54ee732d431$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    };
    _proto.toHTTP = function toHTTP() {
        return $ee65f54ee732d431$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    };
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $ee65f54ee732d431$var$_toISODate(this, true);
    };
    _proto.toSQLTime = function toSQLTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includeZone = _ref7.includeZone, includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone, _ref7$includeOffsetSp = _ref7.includeOffsetSpace, includeOffsetSpace = _ref7$includeOffsetSp === void 0 ? true : _ref7$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $ee65f54ee732d431$var$toTechFormat(this, fmt, true);
    };
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    };
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $ee65f54ee732d431$var$INVALID;
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    };
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    };
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $ee65f54ee732d431$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } // COMPARE
    ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $ee65f54ee732d431$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $ee65f54ee732d431$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $ee65f54ee732d431$var$maybeArray(unit).map($ee65f54ee732d431$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $ee65f54ee732d431$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    };
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    };
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $ee65f54ee732d431$var$Interval.fromDateTimes(this, otherDateTime) : this;
    };
    _proto.hasSame = function hasSame(otherDateTime, unit) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
    };
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    };
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $ee65f54ee732d431$var$diffRelative(base, this.plus(padding), $ee65f54ee732d431$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    };
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $ee65f54ee732d431$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $ee65f54ee732d431$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    };
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $ee65f54ee732d431$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $ee65f54ee732d431$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    };
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $ee65f54ee732d431$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $ee65f54ee732d431$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } // MISC
    ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $ee65f54ee732d431$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $ee65f54ee732d431$var$explainFromTokens(localeToUse, text, fmt);
    };
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } // FORMAT PRESETS
    ;
    $ee65f54ee732d431$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $ee65f54ee732d431$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $ee65f54ee732d431$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $ee65f54ee732d431$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $ee65f54ee732d431$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $ee65f54ee732d431$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $ee65f54ee732d431$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $ee65f54ee732d431$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $ee65f54ee732d431$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $ee65f54ee732d431$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $ee65f54ee732d431$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $ee65f54ee732d431$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $ee65f54ee732d431$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $ee65f54ee732d431$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $ee65f54ee732d431$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $ee65f54ee732d431$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $ee65f54ee732d431$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $ee65f54ee732d431$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $ee65f54ee732d431$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $ee65f54ee732d431$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $ee65f54ee732d431$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $ee65f54ee732d431$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $ee65f54ee732d431$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $ee65f54ee732d431$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $ee65f54ee732d431$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $ee65f54ee732d431$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $ee65f54ee732d431$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $ee65f54ee732d431$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $ee65f54ee732d431$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $ee65f54ee732d431$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $ee65f54ee732d431$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $ee65f54ee732d431$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $ee65f54ee732d431$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $ee65f54ee732d431$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $ee65f54ee732d431$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}();
function $ee65f54ee732d431$var$friendlyDateTime(dateTimeish) {
    if ($ee65f54ee732d431$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $ee65f54ee732d431$var$isNumber(dateTimeish.valueOf())) return $ee65f54ee732d431$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $ee65f54ee732d431$var$DateTime.fromObject(dateTimeish);
    else throw new $ee65f54ee732d431$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $ee65f54ee732d431$var$VERSION = "2.3.1";
$ee65f54ee732d431$exports.DateTime = $ee65f54ee732d431$var$DateTime;
$ee65f54ee732d431$exports.Duration = $ee65f54ee732d431$var$Duration;
$ee65f54ee732d431$exports.FixedOffsetZone = $ee65f54ee732d431$var$FixedOffsetZone;
$ee65f54ee732d431$exports.IANAZone = $ee65f54ee732d431$var$IANAZone;
$ee65f54ee732d431$exports.Info = $ee65f54ee732d431$var$Info;
$ee65f54ee732d431$exports.Interval = $ee65f54ee732d431$var$Interval;
$ee65f54ee732d431$exports.InvalidZone = $ee65f54ee732d431$var$InvalidZone;
$ee65f54ee732d431$exports.Settings = $ee65f54ee732d431$var$Settings;
$ee65f54ee732d431$exports.SystemZone = $ee65f54ee732d431$var$SystemZone;
$ee65f54ee732d431$exports.VERSION = $ee65f54ee732d431$var$VERSION;
$ee65f54ee732d431$exports.Zone = $ee65f54ee732d431$var$Zone;





var $3254a4d5e28fabfa$exports = {};
$3254a4d5e28fabfa$exports = $parcel$resolve("jCnJv");





var $7fPBF = parcelRequire("7fPBF");




var $6fbd1f95f867c609$exports = {};
$6fbd1f95f867c609$exports = $parcel$resolve("g0W8j");


function $9f2c42b26582cc85$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "success-view-header",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6fbd1f95f867c609$exports))),
                className: "icon",
                alt: "Success"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: props.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: props.description
            })
        ]
    });
}



function $a879c7c9b4e34f4c$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [showProgressIndicator, setShowProgressIndicator] = (0, $7fPBF.useState)(false);
    const [showSuccess, setShowSuccess] = (0, $7fPBF.useState)(false);
    const [totalSent, setTotalSent] = (0, $7fPBF.useState)(0);
    const [totalFailed, setTotalFailed] = (0, $7fPBF.useState)(0);
    const [error, setError] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (!props.isOpen) return;
        setError(null);
        setShowProgressIndicator(false);
        setShowSuccess(false);
    }, [
        props.isOpen
    ]);
    const sendWaiverReminder = async ()=>{
        setShowProgressIndicator(true);
        try {
            var _response_body, _response_body1;
            const response = await (0, $6857e104788587b0$export$2e2bcd8739ae039).sendWaiverReminderEmails(props.event.churchID, props.event.id, auth);
            if (response.error) {
                setError(response.error);
                return;
            }
            var _response_body_totalSent;
            setTotalSent((_response_body_totalSent = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.totalSent) !== null && _response_body_totalSent !== void 0 ? _response_body_totalSent : 0);
            var _response_body_totalFailed;
            setTotalFailed((_response_body_totalFailed = (_response_body1 = response.body) === null || _response_body1 === void 0 ? void 0 : _response_body1.totalFailed) !== null && _response_body_totalFailed !== void 0 ? _response_body_totalFailed : 0);
            setShowSuccess(true);
        } catch (e) {
            setError(e);
        } finally{
            setShowProgressIndicator(false);
        }
    };
    const closeButton = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
        className: "close",
        href: "#",
        onClick: (e)=>{
            e.preventDefault();
            props.close();
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
            className: "icon",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
            alt: "Close icon"
        })
    });
    const hideFooterButtons = showProgressIndicator || showSuccess || error !== null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "waiver-reminder-modal",
        isOpen: props.isOpen,
        footerButtons: hideFooterButtons ? [] : [
            {
                title: 'Send Reminder Email',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                onClick: ()=>{
                    sendWaiverReminder();
                }
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            style: {
                paddingTop: 32
            },
            children: showProgressIndicator ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                fullScreen: false
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    closeButton,
                    showSuccess ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9f2c42b26582cc85$export$2e2bcd8739ae039), {
                        title: "Reminders Sent",
                        description: `Successfully sent ${totalSent} reminder email${totalSent == 1 ? '' : 's'}.` + (totalFailed > 0 ? ` (${totalFailed} failed to send. Please contact support.)` : "")
                    }) : null,
                    error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                        error: error,
                        showButton: false
                    }),
                    !error && !showSuccess ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: "Confirm Waiver Reminder Email"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Would you like to send a reminder to all attendees who have not completed their waivers? This action cannot be undone."
                            })
                        ]
                    }) : null
                ]
            })
        })
    });
}














var $7fPBF = parcelRequire("7fPBF");
var $5cac7a7b6d0c0db7$exports = {};
$5cac7a7b6d0c0db7$exports = $parcel$resolve("9YVV8");


var $436c0d5fb2f377a3$exports = {};
$436c0d5fb2f377a3$exports = $parcel$resolve("ktzxf");






function $75c3ed5f39befefd$export$2e2bcd8739ae039(props) {
    const { connectionStatus: connectionStatus, church: church } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [showManualWaiverCreation, setShowManualWaiverCreation] = (0, $7fPBF.useState)(false);
    const [selectedProvider, setSelectedProvider] = (0, $7fPBF.useState)(null);
    const [selectedWaiver, setSelectedWaiver] = (0, $7fPBF.useState)(null);
    const [saving, setSaving] = (0, $7fPBF.useState)(false);
    const [showSuccess, setShowSuccess] = (0, $7fPBF.useState)(false);
    const [saveError, setSaveError] = (0, $7fPBF.useState)(null);
    const [externalWaivers, setExternalWaivers] = (0, $7fPBF.useState)(null);
    const [externalWaiverLoadingError, setExternalWaiversLoadingError] = (0, $7fPBF.useState)(null);
    const [waiverInstructions, setWaiverInstructions] = (0, $7fPBF.useState)(null);
    const fetchExternalWaivers = (0, $7fPBF.useCallback)(async ()=>{
        if (!selectedProvider || !church) return;
        try {
            const response = await (0, $6857e104788587b0$export$2e2bcd8739ae039).fetchAvailableExternalWaivers(church.id, selectedProvider, auth);
            if (response.body) {
                setExternalWaivers(response.body.externalWaivers);
                setExternalWaiversLoadingError(null);
            } else {
                setExternalWaivers(null);
                setExternalWaiversLoadingError(response.error || "Failed to load available waivers from that provider.");
            }
        } catch (error) {
            setExternalWaiversLoadingError(error);
        }
    }, [
        selectedProvider,
        church
    ]);
    const attachExternalWaiver = async (externalWaiver)=>{
        save(()=>(0, $6857e104788587b0$export$2e2bcd8739ae039).attachExternalWaiverToEvent(props.event.churchID, props.event.id, externalWaiver, waiverInstructions, auth));
    };
    const createWaiver = async (name, url, instructions)=>{
        save(()=>(0, $6857e104788587b0$export$2e2bcd8739ae039).createManualWaiverForEvent(props.event.churchID, props.event.id, {
                name: name,
                url: url,
                instructions: instructions
            }, auth));
    };
    const save = async (action)=>{
        setSaving(true);
        try {
            const response = await action();
            if (response.error) {
                setSaveError(response.error);
                return;
            }
            const body = response.body;
            if (body) props.updateEvent(body.event);
            setShowSuccess(true);
        } catch (e) {
            setSaveError(e);
        } finally{
            setSaving(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!props.isOpen) return;
        setSaveError(null);
        setSaving(false);
        setShowSuccess(false);
        setSelectedProvider(null);
        setExternalWaivers(null);
        setExternalWaiversLoadingError(null);
        setSelectedWaiver(null);
        setShowManualWaiverCreation(false);
    }, [
        props.isOpen
    ]);
    const optionsForm = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77186c032b6447f6$export$2e2bcd8739ae039), {
        icon: {
            image: (0, (/*@__PURE__*/$parcel$interopDefault($5cac7a7b6d0c0db7$exports))),
            alt: 'Waivers'
        },
        title: "Add Waiver",
        description: "Get started by selecting a waiver provider.",
        unavailableText: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                "Unavailable creation methods may require you to connect an external provider in ",
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                    href: "/connections",
                    children: "Connections"
                })
            ]
        }),
        cards: [
            {
                title: 'Smartwaiver',
                logo: {
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($436c0d5fb2f377a3$exports))),
                    alt: 'Smartwaiver'
                },
                description: 'Import a Smartwaiver template',
                enabled: (connectionStatus === null || connectionStatus === void 0 ? void 0 : connectionStatus.SMART_WAIVER) === true,
                onClick: ()=>{
                    setSelectedProvider((0, $7a214a4d04f41b8d$export$ca1f2f1c178e9c72).SMART_WAIVER);
                }
            },
            {
                title: "Manual Waiver",
                description: "Create a waiver that must be manually updated when completed by each attendee",
                enabled: true,
                logo: {
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($a9cdc003ba228dda$exports))),
                    alt: 'Manual Waiver'
                },
                onClick: ()=>{
                    setShowManualWaiverCreation(true);
                }
            }
        ]
    });
    const closeButton = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
        className: "close",
        href: "#",
        onClick: (e)=>{
            e.preventDefault();
            props.close();
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
            className: "icon",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
            alt: "Close icon"
        })
    });
    const backButton = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
        className: "back",
        href: "#",
        onClick: (e)=>{
            e.preventDefault();
            if (selectedWaiver) setSelectedWaiver(null);
            else {
                setSelectedProvider(null);
                setExternalWaivers(null);
                setExternalWaiversLoadingError(null);
                setShowManualWaiverCreation(false);
            }
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: "icon",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($48a08cc73bd1bdd6$exports))),
                alt: "Left arrow icon"
            }),
            " Back"
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "waiver-setup",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            style: {
                paddingTop: 32
            },
            children: saving || showSuccess || saveError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    saving && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                        fullScreen: false
                    }),
                    saveError && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            closeButton,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                                error: saveError,
                                showButton: false
                            })
                        ]
                    }),
                    showSuccess && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            closeButton,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9f2c42b26582cc85$export$2e2bcd8739ae039), {
                                title: "Waiver Added",
                                description: `Waiver successfully added to ${props.event.title}.`
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "buttons",
                        children: [
                            selectedProvider && backButton,
                            showManualWaiverCreation && backButton,
                            !selectedProvider && !showManualWaiverCreation && closeButton
                        ]
                    }),
                    !connectionStatus && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                        fullScreen: false
                    }),
                    selectedProvider === null && connectionStatus && !showManualWaiverCreation ? optionsForm : null,
                    selectedProvider && !selectedWaiver && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($75c3ed5f39befefd$var$ExternalWaiverList, {
                        event: props.event,
                        selectedProvider: selectedProvider,
                        externalWaiverLoadingError: externalWaiverLoadingError,
                        externalWaivers: externalWaivers,
                        fetchExternalWaivers: fetchExternalWaivers,
                        externalWaiverSelected: (waiver)=>{
                            setSelectedWaiver(waiver);
                        }
                    }),
                    selectedWaiver && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "selectedWaiverDetails",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h3", {
                                children: [
                                    "Instructions for ",
                                    selectedWaiver.name
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "If you would like to display specific instructions for this waiver, enter them below. Then, click the Attach button to complete setup."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                placeholder: "Custom Waiver Instructions",
                                value: waiverInstructions || "",
                                onChange: (e)=>{
                                    setWaiverInstructions(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: (e)=>{
                                    e.preventDefault();
                                    attachExternalWaiver(selectedWaiver);
                                },
                                children: "Attach Waiver to Event"
                            })
                        ]
                    }),
                    showManualWaiverCreation && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($75c3ed5f39befefd$var$ManualWaiverSetup, {
                        onCreateClicked: (name, url, instructions)=>{
                            createWaiver(name, url, instructions);
                        }
                    })
                ]
            })
        })
    });
}
function $75c3ed5f39befefd$var$ManualWaiverSetup(props) {
    const [name, setName] = (0, $7fPBF.useState)("");
    const [url, setURL] = (0, $7fPBF.useState)("");
    const [instructions, setInstructions] = (0, $7fPBF.useState)(null);
    const canCreate = name.length > 0 && url.length > 0;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "manualWaivers",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "header",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Manual Waiver Setup"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Manual Waivers should be created for waivers that don't directly integrate with Salt."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "heading",
                        style: {
                            marginBottom: '0.5rem'
                        },
                        children: "Information"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                type: "text",
                                name: "waiverName",
                                placeholder: "Waiver Name",
                                value: name || '',
                                onChange: (e)=>setName(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($75c3ed5f39befefd$var$Separator, {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                type: "text",
                                name: "waiverURL",
                                placeholder: "Waiver URL",
                                value: url || '',
                                onChange: (e)=>setURL(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($75c3ed5f39befefd$var$Separator, {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                placeholder: "Instructions",
                                name: "instructions",
                                value: instructions || '',
                                onChange: (e)=>setInstructions(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "footnote",
                        children: "Instructions will be sent alongside attendee Waiver Reminder emails."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                onClick: (e)=>{
                    e.preventDefault();
                    if (!canCreate) return;
                    props.onCreateClicked(name, url, instructions);
                },
                disabled: !canCreate,
                children: "Create Waiver"
            })
        ]
    });
}
function $75c3ed5f39befefd$var$ExternalWaiverList(props) {
    const prettyProviderName = (0, $7fPBF.useMemo)(()=>{
        if (!props.selectedProvider) return '';
        switch(props.selectedProvider){
            case (0, $7a214a4d04f41b8d$export$ca1f2f1c178e9c72).SMART_WAIVER:
                return 'Smartwaiver';
            default:
                return null;
        }
    }, [
        props.selectedProvider
    ]);
    (0, $7fPBF.useEffect)(()=>{
        let mounted = true;
        const performFetch = async ()=>{
            await props.fetchExternalWaivers();
            if (!mounted) return;
        };
        performFetch();
        return ()=>{
            mounted = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            !props.externalWaivers && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                fullScreen: false
            }),
            props.externalWaivers && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "availableExternalWaivers",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h3", {
                        children: [
                            "Available Waivers from ",
                            prettyProviderName
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Select a waiver to attach to ",
                            props.event.title,
                            "."
                        ]
                    }),
                    props.externalWaiverLoadingError && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "error",
                        children: props.externalWaiverLoadingError
                    }),
                    props.externalWaivers.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            marginTop: 16
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "card",
                            children: props.externalWaivers.map((waiver, idx)=>{
                                const existingWaiver = props.event.waivers.find((existingWaiver)=>{
                                    var _existingWaiver_externalMetadata;
                                    return ((_existingWaiver_externalMetadata = existingWaiver.externalMetadata) === null || _existingWaiver_externalMetadata === void 0 ? void 0 : _existingWaiver_externalMetadata.externalID) == waiver.externalID;
                                });
                                const alreadyAdded = existingWaiver !== undefined;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        idx !== 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "separator"
                                        }) : null,
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            style: {
                                                padding: 8,
                                                paddingTop: 16,
                                                paddingBottom: 16
                                            },
                                            role: "button",
                                            className: 'waiver-option ' + (alreadyAdded ? "existing" : ""),
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                if (alreadyAdded) return;
                                                props.externalWaiverSelected(waiver);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "text",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            style: {
                                                                margin: 0,
                                                                fontWeight: 500
                                                            },
                                                            children: waiver.name
                                                        }),
                                                        alreadyAdded ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: "existing-warning",
                                                            children: "This waiver is already attached to this event."
                                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            href: waiver.url,
                                                            children: waiver.url
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e5c73394f0bf85aa$exports))),
                                                    className: "chevron",
                                                    alt: ""
                                                })
                                            ]
                                        })
                                    ]
                                }, waiver.externalID);
                            })
                        })
                    }) : null
                ]
            })
        ]
    });
}
function $75c3ed5f39befefd$var$Separator() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            width: "100%",
            height: 1,
            backgroundColor: "#eaeaea",
            opacity: 0.10,
            margin: '12px 0'
        }
    });
}







var $7fPBF = parcelRequire("7fPBF");
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ 
var $ifbub = parcelRequire("ifbub");
var $a1a91b25d7598376$require$Buffer = $ifbub.Buffer;
var $a1a91b25d7598376$var$XLSX = {};
$a1a91b25d7598376$var$XLSX.version = '0.20.3';
var $a1a91b25d7598376$var$current_codepage = 1200, $a1a91b25d7598376$var$current_ansi = 1252;
/*:: declare var cptable:any; */ /*global cptable:true, window */ var $a1a91b25d7598376$var$$cptable;
var $a1a91b25d7598376$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $a1a91b25d7598376$var$CS2CP = {
    0: 1252,
    /* ANSI */ 1: 65001,
    /* DEFAULT */ 2: 65001,
    /* SYMBOL */ 77: 10000,
    /* MAC */ 128: 932,
    /* SHIFTJIS */ 129: 949,
    /* HANGUL */ 130: 1361,
    /* JOHAB */ 134: 936,
    /* GB2312 */ 136: 950,
    /* CHINESEBIG5 */ 161: 1253,
    /* GREEK */ 162: 1254,
    /* TURKISH */ 163: 1258,
    /* VIETNAMESE */ 177: 1255,
    /* HEBREW */ 178: 1256,
    /* ARABIC */ 186: 1257,
    /* BALTIC */ 204: 1251,
    /* RUSSIAN */ 222: 874,
    /* THAI */ 238: 1250,
    /* EASTEUROPE */ 255: 1252,
    /* OEM */ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $a1a91b25d7598376$var$set_ansi = function(cp /*:number*/ ) {
    if ($a1a91b25d7598376$var$VALID_ANSI.indexOf(cp) == -1) return;
    $a1a91b25d7598376$var$current_ansi = $a1a91b25d7598376$var$CS2CP[0] = cp;
};
function $a1a91b25d7598376$var$reset_ansi() {
    $a1a91b25d7598376$var$set_ansi(1252);
}
var $a1a91b25d7598376$var$set_cp = function(cp /*:number*/ ) {
    $a1a91b25d7598376$var$current_codepage = cp;
    $a1a91b25d7598376$var$set_ansi(cp);
};
function $a1a91b25d7598376$var$reset_cp() {
    $a1a91b25d7598376$var$set_cp(1200);
    $a1a91b25d7598376$var$reset_ansi();
}
function $a1a91b25d7598376$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $a1a91b25d7598376$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $a1a91b25d7598376$var$utf16lereadu(data /*:Uint8Array*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data[2 * i] + (data[2 * i + 1] << 8));
    return o.join("");
}
function $a1a91b25d7598376$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $a1a91b25d7598376$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $a1a91b25d7598376$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $a1a91b25d7598376$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $a1a91b25d7598376$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $a1a91b25d7598376$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
function $a1a91b25d7598376$export$58f247d16f363b86(cptable) {
    $a1a91b25d7598376$var$$cptable = cptable;
    $a1a91b25d7598376$var$set_cp = function(cp /*:number*/ ) {
        $a1a91b25d7598376$var$current_codepage = cp;
        $a1a91b25d7598376$var$set_ansi(cp);
    };
    $a1a91b25d7598376$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $a1a91b25d7598376$var$$cptable.utils.decode(1200, $a1a91b25d7598376$var$char_codes(data.slice(2)));
        return data;
    };
    $a1a91b25d7598376$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($a1a91b25d7598376$var$current_codepage === 1200) return String.fromCharCode(x);
        return $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $a1a91b25d7598376$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_ansi, [
            x
        ])[0];
    };
    $a1a91b25d7598376$var$cpdoit();
}
var $a1a91b25d7598376$var$DENSE = null;
var $a1a91b25d7598376$var$DIF_XL = true;
var $a1a91b25d7598376$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $a1a91b25d7598376$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $a1a91b25d7598376$var$Base64_map.charAt(e1) + $a1a91b25d7598376$var$Base64_map.charAt(e2) + $a1a91b25d7598376$var$Base64_map.charAt(e3) + $a1a91b25d7598376$var$Base64_map.charAt(e4);
    }
    return o;
}
function $a1a91b25d7598376$var$Base64_encode_pass(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        if (c1 > 255) c1 = 95;
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        if (c2 > 255) c2 = 95;
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        if (c3 > 255) c3 = 95;
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $a1a91b25d7598376$var$Base64_map.charAt(e1) + $a1a91b25d7598376$var$Base64_map.charAt(e2) + $a1a91b25d7598376$var$Base64_map.charAt(e3) + $a1a91b25d7598376$var$Base64_map.charAt(e4);
    }
    return o;
}
function $a1a91b25d7598376$var$Base64_encode_arr(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input[i++];
        e1 = c1 >> 2;
        c2 = input[i++];
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input[i++];
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $a1a91b25d7598376$var$Base64_map.charAt(e1) + $a1a91b25d7598376$var$Base64_map.charAt(e2) + $a1a91b25d7598376$var$Base64_map.charAt(e3) + $a1a91b25d7598376$var$Base64_map.charAt(e4);
    }
    return o;
}
function $a1a91b25d7598376$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    if (input.slice(0, 5) == "data:") {
        var i = input.slice(0, 1024).indexOf(";base64,");
        if (i > -1) input = input.slice(i + 8);
    }
    input = input.replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $a1a91b25d7598376$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $a1a91b25d7598376$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $a1a91b25d7598376$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $a1a91b25d7598376$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $a1a91b25d7598376$var$has_buf = /*#__PURE__*/ function() {
    return typeof $a1a91b25d7598376$require$Buffer !== 'undefined' && false;
}();
var $a1a91b25d7598376$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $a1a91b25d7598376$require$Buffer !== 'undefined') {
        var nbfs = !$a1a91b25d7598376$require$Buffer.from;
        if (!nbfs) try {
            $a1a91b25d7598376$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $a1a91b25d7598376$require$Buffer(buf, enc) : new $a1a91b25d7598376$require$Buffer(buf);
        } : $a1a91b25d7598376$require$Buffer.from.bind($a1a91b25d7598376$require$Buffer);
    }
    return function() {};
}();
var $a1a91b25d7598376$var$buf_utf16le = /*#__PURE__*/ function() {
    if (typeof $a1a91b25d7598376$require$Buffer === 'undefined') return false;
    var x = $a1a91b25d7598376$var$Buffer_from([
        65,
        0
    ]);
    if (!x) return false;
    var o = x.toString("utf16le");
    return o.length == 1;
}();
function $a1a91b25d7598376$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$require$Buffer.alloc ? $a1a91b25d7598376$require$Buffer.alloc(len) : new $a1a91b25d7598376$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $a1a91b25d7598376$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$require$Buffer.allocUnsafe ? $a1a91b25d7598376$require$Buffer.allocUnsafe(len) : new $a1a91b25d7598376$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $a1a91b25d7598376$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $a1a91b25d7598376$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === 'undefined') return $a1a91b25d7598376$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $a1a91b25d7598376$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $a1a91b25d7598376$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === 'undefined') throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $a1a91b25d7598376$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $a1a91b25d7598376$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $a1a91b25d7598376$var$bconcat = $a1a91b25d7598376$var$has_buf ? function(bufs) {
    return $a1a91b25d7598376$require$Buffer.concat(bufs.map(function(buf) {
        return $a1a91b25d7598376$require$Buffer.isBuffer(buf) ? buf : $a1a91b25d7598376$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") o.set(new Uint8Array($a1a91b25d7598376$var$s2a(bufs[i])), maxlen);
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $a1a91b25d7598376$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $a1a91b25d7598376$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $a1a91b25d7598376$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $a1a91b25d7598376$var$bconcat(out);
}
var $a1a91b25d7598376$var$chr0 = /\u0000/g, $a1a91b25d7598376$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $a1a91b25d7598376$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $a1a91b25d7598376$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $a1a91b25d7598376$var$fill('0', d - t.length) + t;
}
function $a1a91b25d7598376$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $a1a91b25d7598376$var$fill(' ', d - t.length) + t;
}
function $a1a91b25d7598376$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $a1a91b25d7598376$var$fill(' ', d - t.length);
}
function $a1a91b25d7598376$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $a1a91b25d7598376$var$fill('0', d - t.length) + t;
}
function $a1a91b25d7598376$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $a1a91b25d7598376$var$fill('0', d - t.length) + t;
}
var $a1a91b25d7598376$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $a1a91b25d7598376$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $a1a91b25d7598376$var$p2_32 || v < -$a1a91b25d7598376$var$p2_32) return $a1a91b25d7598376$var$pad0r1(v, d);
    var i = Math.round(v);
    return $a1a91b25d7598376$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $a1a91b25d7598376$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $a1a91b25d7598376$var$days /*:Array<Array<string> >*/  = [
    [
        'Sun',
        'Sunday'
    ],
    [
        'Mon',
        'Monday'
    ],
    [
        'Tue',
        'Tuesday'
    ],
    [
        'Wed',
        'Wednesday'
    ],
    [
        'Thu',
        'Thursday'
    ],
    [
        'Fri',
        'Friday'
    ],
    [
        'Sat',
        'Saturday'
    ]
];
var $a1a91b25d7598376$var$months /*:Array<Array<string> >*/  = [
    [
        'J',
        'Jan',
        'January'
    ],
    [
        'F',
        'Feb',
        'February'
    ],
    [
        'M',
        'Mar',
        'March'
    ],
    [
        'A',
        'Apr',
        'April'
    ],
    [
        'M',
        'May',
        'May'
    ],
    [
        'J',
        'Jun',
        'June'
    ],
    [
        'J',
        'Jul',
        'July'
    ],
    [
        'A',
        'Aug',
        'August'
    ],
    [
        'S',
        'Sep',
        'September'
    ],
    [
        'O',
        'Oct',
        'October'
    ],
    [
        'N',
        'Nov',
        'November'
    ],
    [
        'D',
        'Dec',
        'December'
    ]
];
function $a1a91b25d7598376$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = 'General';
    t[1] = '0';
    t[2] = '0.00';
    t[3] = '#,##0';
    t[4] = '#,##0.00';
    t[9] = '0%';
    t[10] = '0.00%';
    t[11] = '0.00E+00';
    t[12] = '# ?/?';
    t[13] = '# ??/??';
    t[14] = 'm/d/yy';
    t[15] = 'd-mmm-yy';
    t[16] = 'd-mmm';
    t[17] = 'mmm-yy';
    t[18] = 'h:mm AM/PM';
    t[19] = 'h:mm:ss AM/PM';
    t[20] = 'h:mm';
    t[21] = 'h:mm:ss';
    t[22] = 'm/d/yy h:mm';
    t[37] = '#,##0 ;(#,##0)';
    t[38] = '#,##0 ;[Red](#,##0)';
    t[39] = '#,##0.00;(#,##0.00)';
    t[40] = '#,##0.00;[Red](#,##0.00)';
    t[45] = 'mm:ss';
    t[46] = '[h]:mm:ss';
    t[47] = 'mmss.0';
    t[48] = '##0.0E+0';
    t[49] = '@';
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $a1a91b25d7598376$var$table_fmt = {
    0: 'General',
    1: '0',
    2: '0.00',
    3: '#,##0',
    4: '#,##0.00',
    9: '0%',
    10: '0.00%',
    11: '0.00E+00',
    12: '# ?/?',
    13: '# ??/??',
    14: 'm/d/yy',
    15: 'd-mmm-yy',
    16: 'd-mmm',
    17: 'mmm-yy',
    18: 'h:mm AM/PM',
    19: 'h:mm:ss AM/PM',
    20: 'h:mm',
    21: 'h:mm:ss',
    22: 'm/d/yy h:mm',
    37: '#,##0 ;(#,##0)',
    38: '#,##0 ;[Red](#,##0)',
    39: '#,##0.00;(#,##0.00)',
    40: '#,##0.00;[Red](#,##0.00)',
    45: 'mm:ss',
    46: '[h]:mm:ss',
    47: 'mmss.0',
    48: '##0.0E+0',
    49: '@',
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $a1a91b25d7598376$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $a1a91b25d7598376$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $a1a91b25d7598376$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $a1a91b25d7598376$var$SSF_normalize_xl_unsafe(v /*:number*/ ) /*:number*/ {
    var s = v.toPrecision(16);
    if (s.indexOf("e") > -1) {
        var m = s.slice(0, s.indexOf("e"));
        m = m.indexOf(".") > -1 ? m.slice(0, m.slice(0, 2) == "0." ? 17 : 16) : m.slice(0, 15) + $a1a91b25d7598376$var$fill("0", m.length - 15);
        return m + s.slice(s.indexOf("e"));
    }
    var n = s.indexOf(".") > -1 ? s.slice(0, s.slice(0, 2) == "0." ? 17 : 16) : s.slice(0, 15) + $a1a91b25d7598376$var$fill("0", s.length - 15);
    return Number(n);
}
function $a1a91b25d7598376$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    v = $a1a91b25d7598376$var$SSF_normalize_xl_unsafe(v);
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $a1a91b25d7598376$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $a1a91b25d7598376$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $a1a91b25d7598376$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $a1a91b25d7598376$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $a1a91b25d7598376$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $a1a91b25d7598376$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $a1a91b25d7598376$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $a1a91b25d7598376$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    if (!isFinite(v)) return isNaN(v) ? "#NUM!" : "#DIV/0!";
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $a1a91b25d7598376$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $a1a91b25d7598376$var$SSF_large_exp(v);
    return $a1a91b25d7598376$var$SSF_strip_decimal($a1a91b25d7598376$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $a1a91b25d7598376$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? "TRUE" : "FALSE";
        case 'number':
            return (v | 0) === v ? v.toString(10) : $a1a91b25d7598376$var$SSF_general_num(v);
        case 'undefined':
            return "";
        case 'object':
            if (v == null) return "";
            if (v instanceof Date) return $a1a91b25d7598376$var$SSF_format(14, $a1a91b25d7598376$var$datenum(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $a1a91b25d7598376$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $a1a91b25d7598376$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val1, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val1.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val1.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $a1a91b25d7598376$var$months[val1.m - 1][1];
                case 5:
                    return $a1a91b25d7598376$var$months[val1.m - 1][0];
                default:
                    return $a1a91b25d7598376$var$months[val1.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $a1a91b25d7598376$var$days[val1.q][0];
                default:
                    return $a1a91b25d7598376$var$days[val1.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val1.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.H;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.M;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad minute format: ' + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
            if (val1.u === 0 && (fmt == "s" || fmt == "ss")) return $a1a91b25d7598376$var$pad0(val1.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val1.S + val1.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === 's') return ss === 0 ? "0" : "" + ss / tt;
            o = $a1a91b25d7598376$var$pad0(ss, 2 + ss0);
            if (fmt === 'ss') return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case '[h]':
                case '[hh]':
                    out = val1.D * 24 + val1.H;
                    break;
                case '[m]':
                case '[mm]':
                    out = (val1.D * 24 + val1.H) * 60 + val1.M;
                    break;
                case '[s]':
                case '[ss]':
                    out = ((val1.D * 24 + val1.H) * 60 + val1.M) * 60 + (ss0 == 0 ? Math.round(val1.S + val1.u) : val1.S);
                    break;
                default:
                    throw 'bad abstime format: ' + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $a1a91b25d7598376$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $a1a91b25d7598376$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $a1a91b25d7598376$var$pct1 = /%/g;
function $a1a91b25d7598376$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($a1a91b25d7598376$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $a1a91b25d7598376$var$write_num(type, sfmt, val1 * Math.pow(10, 2 * mul)) + $a1a91b25d7598376$var$fill("%", mul);
}
function $a1a91b25d7598376$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $a1a91b25d7598376$var$write_num(type, fmt.substr(0, idx), val1 / Math.pow(10, 3 * (fmt.length - idx)));
}
function $a1a91b25d7598376$var$write_num_exp(fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val1 == 0) return "0.0E+0";
        else if (val1 < 0) return "-" + $a1a91b25d7598376$var$write_num_exp(fmt, -val1);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val1) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val1 / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val1) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val1.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $a1a91b25d7598376$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $a1a91b25d7598376$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $a1a91b25d7598376$var$fill(" ", r[1].length + 1 + r[4].length) : $a1a91b25d7598376$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $a1a91b25d7598376$var$pad0(myd, r[4].length));
}
function $a1a91b25d7598376$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $a1a91b25d7598376$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $a1a91b25d7598376$var$dec1 = /^#*0*\.([0#]+)/;
var $a1a91b25d7598376$var$closeparen = /\)[^)]*[0#]/;
var $a1a91b25d7598376$var$phone = /\(###\) ###\\?-####/;
function $a1a91b25d7598376$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $a1a91b25d7598376$var$rnd(val1 /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val1 * dd) / dd;
}
function $a1a91b25d7598376$var$dec(val1 /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val1 - Math.floor(val1), dd = Math.pow(10, d);
    if (d < ('' + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $a1a91b25d7598376$var$carry(val1 /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ('' + Math.round((val1 - Math.floor(val1)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $a1a91b25d7598376$var$flr(val1 /*:number*/ ) /*:string*/ {
    if (val1 < 2147483647 && val1 > -2147483648) return "" + (val1 >= 0 ? val1 | 0 : val1 - 1 | 0);
    return "" + Math.floor(val1);
}
function $a1a91b25d7598376$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($a1a91b25d7598376$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val1 >= 0) return $a1a91b25d7598376$var$write_num_flt('n', ffmt, val1);
        return '(' + $a1a91b25d7598376$var$write_num_flt('n', ffmt, -val1) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $a1a91b25d7598376$var$write_num_cm(type, fmt, val1);
    if (fmt.indexOf('%') !== -1) return $a1a91b25d7598376$var$write_num_pct(type, fmt, val1);
    if (fmt.indexOf('E') !== -1) return $a1a91b25d7598376$var$write_num_exp(fmt, val1);
    if (fmt.charCodeAt(0) === 36) return "$" + $a1a91b25d7598376$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val1);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val1), sign = val1 < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $a1a91b25d7598376$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $a1a91b25d7598376$var$pad0r(val1, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $a1a91b25d7598376$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($a1a91b25d7598376$var$frac1)) return $a1a91b25d7598376$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $a1a91b25d7598376$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($a1a91b25d7598376$var$dec1)) {
        o = $a1a91b25d7598376$var$rnd(val1, r[1].length).replace(/^([^\.]+)$/, "$1." + $a1a91b25d7598376$var$hashq(r[1])).replace(/\.$/, "." + $a1a91b25d7598376$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $a1a91b25d7598376$var$fill("0", $a1a91b25d7598376$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $a1a91b25d7598376$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $a1a91b25d7598376$var$commaify($a1a91b25d7598376$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val1 < 0 ? "-" + $a1a91b25d7598376$var$write_num_flt(type, fmt, -val1) : $a1a91b25d7598376$var$commaify("" + (Math.floor(val1) + $a1a91b25d7598376$var$carry(val1, r[1].length))) + "." + $a1a91b25d7598376$var$pad0($a1a91b25d7598376$var$dec(val1, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $a1a91b25d7598376$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val1);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $a1a91b25d7598376$var$_strrev($a1a91b25d7598376$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val1));
        ri = 0;
        return $a1a91b25d7598376$var$_strrev($a1a91b25d7598376$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($a1a91b25d7598376$var$phone)) {
        o = $a1a91b25d7598376$var$write_num_flt(type, "##########", val1);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $a1a91b25d7598376$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $a1a91b25d7598376$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $a1a91b25d7598376$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $a1a91b25d7598376$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $a1a91b25d7598376$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $a1a91b25d7598376$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $a1a91b25d7598376$var$rpad_(ff[2], ri) : $a1a91b25d7598376$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $a1a91b25d7598376$var$pad0r(val1, 0);
        if (fmt.length <= o.length) return o;
        return $a1a91b25d7598376$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val1.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $a1a91b25d7598376$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $a1a91b25d7598376$var$dec(val1, r[1].length);
        return val1 < 0 ? "-" + $a1a91b25d7598376$var$write_num_flt(type, fmt, -val1) : $a1a91b25d7598376$var$commaify($a1a91b25d7598376$var$flr(val1)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $a1a91b25d7598376$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $a1a91b25d7598376$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $a1a91b25d7598376$var$write_num_flt(type, "#,##0.00", val1);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $a1a91b25d7598376$var$commaify($a1a91b25d7598376$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $a1a91b25d7598376$var$write_num_flt(type, "###,##0.00", val1).replace(/^0\./, ".");
        case "#,###.00":
            return $a1a91b25d7598376$var$write_num_flt(type, "#,##0.00", val1).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $a1a91b25d7598376$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $a1a91b25d7598376$var$write_num(type, fmt.substr(0, idx), val1 / Math.pow(10, 3 * (fmt.length - idx)));
}
function $a1a91b25d7598376$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($a1a91b25d7598376$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $a1a91b25d7598376$var$write_num(type, sfmt, val1 * Math.pow(10, 2 * mul)) + $a1a91b25d7598376$var$fill("%", mul);
}
function $a1a91b25d7598376$var$write_num_exp2(fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val1 == 0) return "0.0E+0";
        else if (val1 < 0) return "-" + $a1a91b25d7598376$var$write_num_exp2(fmt, -val1);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val1) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val1 / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val1) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val1.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $a1a91b25d7598376$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($a1a91b25d7598376$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val1 >= 0) return $a1a91b25d7598376$var$write_num_int('n', ffmt, val1);
        return '(' + $a1a91b25d7598376$var$write_num_int('n', ffmt, -val1) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $a1a91b25d7598376$var$write_num_cm2(type, fmt, val1);
    if (fmt.indexOf('%') !== -1) return $a1a91b25d7598376$var$write_num_pct2(type, fmt, val1);
    if (fmt.indexOf('E') !== -1) return $a1a91b25d7598376$var$write_num_exp2(fmt, val1);
    if (fmt.charCodeAt(0) === 36) return "$" + $a1a91b25d7598376$var$write_num_int(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val1);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val1), sign = val1 < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $a1a91b25d7598376$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val1;
        if (val1 === 0) o = "";
        return o.length > fmt.length ? o : $a1a91b25d7598376$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($a1a91b25d7598376$var$frac1)) return $a1a91b25d7598376$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $a1a91b25d7598376$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($a1a91b25d7598376$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val1).replace(/^([^\.]+)$/, "$1." + $a1a91b25d7598376$var$hashq(r[1])).replace(/\.$/, "." + $a1a91b25d7598376$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $a1a91b25d7598376$var$fill("0", $a1a91b25d7598376$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $a1a91b25d7598376$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val1 < 0 ? "-" + $a1a91b25d7598376$var$write_num_int(type, fmt, -val1) : $a1a91b25d7598376$var$commaify("" + val1) + "." + $a1a91b25d7598376$var$fill('0', r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $a1a91b25d7598376$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val1);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $a1a91b25d7598376$var$_strrev($a1a91b25d7598376$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val1));
        ri = 0;
        return $a1a91b25d7598376$var$_strrev($a1a91b25d7598376$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($a1a91b25d7598376$var$phone)) {
        o = $a1a91b25d7598376$var$write_num_int(type, "##########", val1);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $a1a91b25d7598376$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $a1a91b25d7598376$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $a1a91b25d7598376$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $a1a91b25d7598376$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $a1a91b25d7598376$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $a1a91b25d7598376$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $a1a91b25d7598376$var$rpad_(ff[2], ri) : $a1a91b25d7598376$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val1;
        if (fmt.length <= o.length) return o;
        return $a1a91b25d7598376$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val1.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $a1a91b25d7598376$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val1 < 0 ? "-" + $a1a91b25d7598376$var$write_num_int(type, fmt, -val1) : $a1a91b25d7598376$var$commaify("" + val1).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $a1a91b25d7598376$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $a1a91b25d7598376$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $a1a91b25d7598376$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $a1a91b25d7598376$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val1) + $a1a91b25d7598376$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $a1a91b25d7598376$var$write_num(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    return (val1 | 0) === val1 ? $a1a91b25d7598376$var$write_num_int(type, fmt, val1) : $a1a91b25d7598376$var$write_num_flt(type, fmt, val1);
}
function $a1a91b25d7598376$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $a1a91b25d7598376$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $a1a91b25d7598376$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            if ($a1a91b25d7598376$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case '\\':
            i += 2;
            break;
        case '_':
            i += 2;
            break;
        case '@':
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            return true;
        case 'A':
        case 'a':
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.match($a1a91b25d7598376$var$SSF_abstime)) return true;
            break;
        case '.':
        /* falls through */ case '0':
        case '#':
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == '\\' && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case '?':
            while(fmt.charAt(++i) === c);
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break;
        case '(':
        case ')':
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case ' ':
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $a1a91b25d7598376$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = 't', dt, j, cc;
    var hr = 'H';
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            /* General */ if (!$a1a91b25d7598376$var$SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 'G',
                v: 'General'
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: 't',
                v: o
            };
            ++i;
            break;
        case '\\':
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : 't';
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case '_':
            out[out.length] = {
                t: 't',
                v: " "
            };
            i += 2;
            break;
        case '@':
            /* Text Placeholder */ out[out.length] = {
                t: 'T',
                v: v
            };
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $a1a91b25d7598376$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'X',
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
            c = c.toLowerCase();
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            if (v < 0) return "";
            if (dt == null) {
                dt = $a1a91b25d7598376$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === 'm' && lst.toLowerCase() === 'h') c = 'M';
            if (c === 'h') c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case 'A':
        case 'a':
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $a1a91b25d7598376$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? fmt.charAt(i + 2) : c;
                q.t = 'T';
                hr = 'h';
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === 'T') return "";
            out[out.length] = q;
            lst = c;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
            if (o.match($a1a91b25d7598376$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $a1a91b25d7598376$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'Z',
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$a1a91b25d7598376$var$fmt_is_date(fmt)) out[out.length] = {
                    t: 't',
                    v: o
                };
            }
            break;
        /* Numbers */ case '.':
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: 's',
                    v: o
                };
                break;
            }
        /* falls through */ case '0':
        case '#':
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: 'n',
                v: o
            };
            break;
        case '?':
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break; // **
        case '(':
        case ')':
            out[out.length] = {
                t: flen === 1 ? 't' : c,
                v: c
            };
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: 'D',
                v: o
            };
            break;
        case ' ':
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case '$':
            out[out.length] = {
                t: 't',
                v: '$'
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 't',
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = 't'; i >= 0; --i)switch(out[i].t){
        case 'h':
        case 'H':
            out[i].t = hr;
            lst = 'h';
            if (bt < 1) bt = 1;
            break;
        case 's':
            if (ssm = out[i].v.match(/\.0+$/)) {
                ss0 = Math.max(ss0, ssm[0].length - 1);
                bt = 4;
            }
            if (bt < 3) bt = 3;
        /* falls through */ case 'd':
        case 'y':
        case 'e':
            lst = out[i].t;
            break;
        case 'M':
            lst = out[i].t;
            if (bt < 2) bt = 2;
            break;
        case 'm':
            if (lst === 's') {
                out[i].t = 'M';
                if (bt < 2) bt = 2;
            }
            break;
        case 'X':
            break;
        case 'Z':
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ var _dt;
    switch(bt){
        case 0:
            break;
        case 1:
        case 2:
        case 3:
            if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $a1a91b25d7598376$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
        case 4:
            switch(ss0){
                case 1:
                    dt.u = Math.round(dt.u * 10) / 10;
                    break;
                case 2:
                    dt.u = Math.round(dt.u * 100) / 100;
                    break;
                case 3:
                    dt.u = Math.round(dt.u * 1000) / 1000;
                    break;
            }
            if (dt.u >= 1) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $a1a91b25d7598376$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case 't':
        case 'T':
        case ' ':
        case 'D':
            break;
        case 'X':
            out[i].v = "";
            out[i].t = ";";
            break;
        case 'd':
        case 'm':
        case 'y':
        case 'h':
        case 'H':
        case 'M':
        case 's':
        case 'e':
        case 'b':
        case 'Z':
            /*::if(!dt) throw "unreachable"; */ out[i].v = $a1a91b25d7598376$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = 't';
            break;
        case 'n':
        case '?':
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === '?' || out[jj + 1].t === "t" && out[jj + 1].v === '/') || out[i].t === '(' && (c === ' ' || c === 'n' || c === ')') || c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj + 1] != null && out[jj + 1].t == '?'))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case 'G':
            out[i].t = 't';
            out[i].v = $a1a91b25d7598376$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $a1a91b25d7598376$var$write_num('n', nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $a1a91b25d7598376$var$write_num('n', nstr, myv);
            if (myv < 0 && out[0] && out[0].t == 't') {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || 'n?('.indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && 'n?'.indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $a1a91b25d7598376$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = 't';
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $a1a91b25d7598376$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $a1a91b25d7598376$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $a1a91b25d7598376$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $a1a91b25d7598376$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    /* NOTE: most spreadsheet software do not support NaN or infinities */ if (typeof v === "number" && !isFinite(v)) v = 0;
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($a1a91b25d7598376$var$cfregex2);
        var m2 = fmt[1].match($a1a91b25d7598376$var$cfregex2);
        return $a1a91b25d7598376$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $a1a91b25d7598376$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $a1a91b25d7598376$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $a1a91b25d7598376$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$a1a91b25d7598376$var$SSF_default_map[fmt]] || $a1a91b25d7598376$var$table_fmt[$a1a91b25d7598376$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $a1a91b25d7598376$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($a1a91b25d7598376$var$SSF_isgeneral(sfmt, 0)) return $a1a91b25d7598376$var$SSF_general(v, o);
    if (v instanceof Date) v = $a1a91b25d7598376$var$datenum(v, o.date1904);
    var f = $a1a91b25d7598376$var$choose_fmt(sfmt, v);
    if ($a1a91b25d7598376$var$SSF_isgeneral(f[1])) return $a1a91b25d7598376$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    else if (isNaN(v) && f[1].indexOf("0") > -1) return "#NUM!";
    else if (!isFinite(v) && f[1].indexOf("0") > -1) return "#DIV/0!";
    return $a1a91b25d7598376$var$eval_fmt(f[1], v, o, f[0]);
}
function $a1a91b25d7598376$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != 'number') {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($a1a91b25d7598376$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($a1a91b25d7598376$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $a1a91b25d7598376$var$table_fmt[idx] = fmt;
    return idx;
}
function $a1a91b25d7598376$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $a1a91b25d7598376$var$SSF_load(tbl[i], i);
}
function $a1a91b25d7598376$var$make_ssf() {
    $a1a91b25d7598376$var$table_fmt = $a1a91b25d7598376$var$SSF_init_table();
}
var $a1a91b25d7598376$export$40d8edd678456c2b = {
    format: $a1a91b25d7598376$var$SSF_format,
    load: $a1a91b25d7598376$var$SSF_load,
    _table: $a1a91b25d7598376$var$table_fmt,
    load_table: $a1a91b25d7598376$var$SSF_load_table,
    parse_date_code: $a1a91b25d7598376$var$SSF_parse_date_code,
    is_date: $a1a91b25d7598376$var$fmt_is_date,
    get_table: function get_table() {
        return $a1a91b25d7598376$export$40d8edd678456c2b._table = $a1a91b25d7598376$var$table_fmt;
    }
};
var $a1a91b25d7598376$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": 'General',
    "24": 'General',
    "25": 'General',
    "26": 'General',
    "27": 'm/d/yy',
    "28": 'm/d/yy',
    "29": 'm/d/yy',
    "30": 'm/d/yy',
    "31": 'm/d/yy',
    "32": 'h:mm:ss',
    "33": 'h:mm:ss',
    "34": 'h:mm:ss',
    "35": 'h:mm:ss',
    "36": 'm/d/yy',
    "41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
    "50": 'm/d/yy',
    "51": 'm/d/yy',
    "52": 'm/d/yy',
    "53": 'm/d/yy',
    "54": 'm/d/yy',
    "55": 'm/d/yy',
    "56": 'm/d/yy',
    "57": 'm/d/yy',
    "58": 'm/d/yy',
    "59": '0',
    "60": '0.00',
    "61": '#,##0',
    "62": '#,##0.00',
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": '0%',
    "68": '0.00%',
    "69": '# ?/?',
    "70": '# ??/??',
    "71": 'm/d/yy',
    "72": 'm/d/yy',
    "73": 'd-mmm-yy',
    "74": 'd-mmm',
    "75": 'mmm-yy',
    "76": 'h:mm',
    "77": 'h:mm:ss',
    "78": 'm/d/yy h:mm',
    "79": 'mm:ss',
    "80": '[h]:mm:ss',
    "81": 'mmss.0'
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $a1a91b25d7598376$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $a1a91b25d7598376$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $a1a91b25d7598376$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($a1a91b25d7598376$var$dateNFregex, "(\\d+)");
    $a1a91b25d7598376$var$dateNFregex.lastIndex = 0;
    return new RegExp("^" + fmt + "$");
}
function $a1a91b25d7598376$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($a1a91b25d7598376$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case 'y':
                Y = v;
                break;
            case 'd':
                d = v;
                break;
            case 'h':
                H = v;
                break;
            case 's':
                S = v;
                break;
            case 'm':
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    $a1a91b25d7598376$var$dateNFregex.lastIndex = 0;
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/* table of bad formats written by third-party tools */ var $a1a91b25d7598376$var$bad_formats = {
    "d.m": "d\\.m" // Issue #2571 Google Sheets writes invalid format 'd.m', correct format is 'd"."m' or 'd\\.m'
};
function $a1a91b25d7598376$var$SSF__load(fmt, idx) {
    return $a1a91b25d7598376$var$SSF_load($a1a91b25d7598376$var$bad_formats[fmt] || fmt, idx);
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $a1a91b25d7598376$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = '1.2.0';
    /*::
type CRC32TableType = Array<number> | Int32Array;
*/ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== 'undefined' && typeof table.subarray == "function" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:?number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $a1a91b25d7598376$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports /*:CFBModule*/  = /*::(*/ {} /*:: :any)*/ ;
    exports.version = '1.2.2';
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val1 = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val1.setMilliseconds(0);
        val1.setFullYear(ymd + 1980);
        val1.setMonth(m - 1);
        val1.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val1.setHours(hms);
        val1.setMinutes(M);
        val1.setSeconds(S << 1);
        return val1;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $a1a91b25d7598376$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
                /* ZIP64 Extended Information Field */ case 0x0001:
                    var sz1 = blob.read_shift(4), sz2 = blob.read_shift(4);
                    p.usz = sz2 * Math.pow(2, 32) + sz1;
                    sz1 = blob.read_shift(4);
                    sz2 = blob.read_shift(4);
                    p.csz = sz2 * Math.pow(2, 32) + sz1;
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = $a1a91b25d7598376$var$_fs);
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $a1a91b25d7598376$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $a1a91b25d7598376$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, 'i');
        if (mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, 'i');
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk('00100000', 'Mini Stream Cutoff Size: ');
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, 'i');
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, 'i');
        // First DIFAT sector location
        difat_start = blob.read_shift(4, 'i');
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, 'i');
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, 'i');
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        if (dir_start < sector_list.length) sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, 'u');
        return [
            blob.read_shift(2, 'u'),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift);
                break;
            default:
                throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
        }
        // Mini Sector Shift
        blob.chk('0600', 'Mini Sector Shift: ');
        // Reserved
        blob.chk('000000000000', 'Reserved: ');
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $a1a91b25d7598376$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $a1a91b25d7598376$var$new_buf(0);
        return $a1a91b25d7598376$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $a1a91b25d7598376$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            if (cnt >= 1) sleuth_fat($a1a91b25d7598376$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $a1a91b25d7598376$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $a1a91b25d7598376$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $a1a91b25d7598376$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $a1a91b25d7598376$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $a1a91b25d7598376$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $a1a91b25d7598376$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, 'i'),
                R: blob.read_shift(4, 'i'),
                C: blob.read_shift(4, 'i'),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, 'i'),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, 'i');
            o.size = blob.read_shift(4, 'i');
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = 'fat';
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = 'minifat';
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $a1a91b25d7598376$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($a1a91b25d7598376$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $a1a91b25d7598376$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($a1a91b25d7598376$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\u0001Sh33tJ5";
        if ($a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $a1a91b25d7598376$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            while(!s){
                while(dirname(dad) && !fullPaths[dirname(dad)])dad = dirname(dad);
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
                dad = dirname(data[i][0]);
                s = fullPaths[dad];
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == 'mad') return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case 'zip':
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $a1a91b25d7598376$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            if (_nm.length > 31) {
                console.error("Name " + _nm + " will be truncated to " + _nm.slice(0, 31));
                _nm = _nm.slice(0, 31);
            }
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($a1a91b25d7598376$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($a1a91b25d7598376$var$chr1);
        UCPath = UCPath.replace($a1a91b25d7598376$var$chr0, '');
        if (m) UCPath = UCPath.replace($a1a91b25d7598376$var$chr1, '!');
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($a1a91b25d7598376$var$chr1, '!') : UCFullPaths[w]).replace($a1a91b25d7598376$var$chr0, '') == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($a1a91b25d7598376$var$chr1, '!') : UCPaths[w]).replace($a1a91b25d7598376$var$chr0, '') == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = '00000000000000000000000000000000';
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: '3e00',
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            'unknown',
            'storage',
            'stream',
            'lockbytes',
            'property',
            'root'
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $a1a91b25d7598376$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$require$Buffer.isBuffer(o) ? o : $a1a91b25d7598376$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $a1a91b25d7598376$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== 'undefined';
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($a1a91b25d7598376$var$has_buf) {
            var o = $a1a91b25d7598376$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $a1a91b25d7598376$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $a1a91b25d7598376$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $a1a91b25d7598376$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== 'undefined') console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $a1a91b25d7598376$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            /* ZIP64 lengths */ if (EF && EF[0x0001]) {
                if ((EF[0x0001] || {}).usz) usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) csz = EF[0x0001].csz;
            }
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if ((ef[0x0001] || {}).usz) _usz = ef[0x0001].usz;
            if ((ef[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            if (EF) {
                if ((EF[0x5455] || {}).mt) date = EF[0x5455].mt;
                if ((EF[0x0001] || {}).usz) _usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) _csz = EF[0x0001].csz;
            }
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                blob.l += _csz;
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $a1a91b25d7598376$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || Array.isArray(fi.content) && fi.content.length == 0 || fp == "\u0001Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $a1a91b25d7598376$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = typeof fi.content == "string" ? $a1a91b25d7598376$var$CRC32.bstr(fi.content, 0) : $a1a91b25d7598376$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = typeof fi.content == "string" ? $a1a91b25d7598376$var$s2a(fi.content) : fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $a1a91b25d7598376$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $a1a91b25d7598376$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $a1a91b25d7598376$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $a1a91b25d7598376$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $a1a91b25d7598376$var$bconcat([
            $a1a91b25d7598376$var$bconcat(out /*:any*/ ),
            $a1a91b25d7598376$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $a1a91b25d7598376$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $a1a91b25d7598376$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^([^:]*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case 'base64':
                fdata = $a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(data.slice(di).join("")));
                break;
            case 'quoted-printable':
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = '------=' + boundary;
        var out = [
            'MIME-Version: 1.0',
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            '',
            '',
            ''
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
            out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
            out.push('Content-Type: ' + get_content_type(fi, fp));
            out.push('');
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + '--\r\n');
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $a1a91b25d7598376$var$ReadShift,
        CheckField: $a1a91b25d7598376$var$CheckField,
        prep_blob: $a1a91b25d7598376$var$prep_blob,
        bconcat: $a1a91b25d7598376$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
var $a1a91b25d7598376$var$_fs;
function $a1a91b25d7598376$export$a48eb669e1768bcf(fs) {
    $a1a91b25d7598376$var$_fs = fs;
}
/* normalize data for blob ctor */ function $a1a91b25d7598376$var$blobify(data) {
    if (typeof data === "string") return $a1a91b25d7598376$var$s2ab(data);
    if (Array.isArray(data)) return $a1a91b25d7598376$var$a2u(data);
    return data;
}
/* write or download file */ function $a1a91b25d7598376$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $a1a91b25d7598376$var$_fs !== 'undefined' && $a1a91b25d7598376$var$_fs.writeFileSync) return enc ? $a1a91b25d7598376$var$_fs.writeFileSync(fname, payload, enc) : $a1a91b25d7598376$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== 'undefined') {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $a1a91b25d7598376$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $a1a91b25d7598376$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
    if (typeof Blob !== 'undefined') {
        var blob = new Blob([
            $a1a91b25d7598376$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== 'undefined') return saveAs(blob, fname);
        if (typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === 'object' && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        } else if (typeof URL !== 'undefined' && !URL.createObjectURL && typeof chrome === 'object') {
            /* manifest v3 extensions -- no URL.createObjectURL */ var b64 = "data:application/octet-stream;base64," + $a1a91b25d7598376$var$Base64_encode_arr(new Uint8Array($a1a91b25d7598376$var$blobify(data)));
            return chrome.downloads.download({
                url: b64,
                filename: fname,
                saveAs: true
            });
        }
    }
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $a1a91b25d7598376$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $a1a91b25d7598376$var$read_binary(path /*:string*/ ) {
    if (typeof $a1a91b25d7598376$var$_fs !== 'undefined') return $a1a91b25d7598376$var$_fs.readFileSync(path);
    if (typeof Deno !== 'undefined') return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $a1a91b25d7598376$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $a1a91b25d7598376$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $a1a91b25d7598376$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $a1a91b25d7598376$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $a1a91b25d7598376$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $a1a91b25d7598376$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $a1a91b25d7598376$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $a1a91b25d7598376$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $a1a91b25d7598376$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $a1a91b25d7598376$var$dnthresh = /*#__PURE__*/ Date.UTC(1899, 11, 30, 0, 0, 0); // -2209161600000
var $a1a91b25d7598376$var$dnthresh1 = /*#__PURE__*/ Date.UTC(1899, 11, 31, 0, 0, 0); // -2209075200000
var $a1a91b25d7598376$var$dnthresh2 = /*#__PURE__*/ Date.UTC(1904, 0, 1, 0, 0, 0); // -2209075200000
function $a1a91b25d7598376$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    var res = (epoch - $a1a91b25d7598376$var$dnthresh) / 86400000;
    if (date1904) {
        res -= 1462;
        return res < -1402 ? res - 1 : res;
    }
    return res < 60 ? res - 1 : res;
}
function $a1a91b25d7598376$var$numdate(v /*:number*/ ) /*:Date|number*/ {
    if (v >= 60 && v < 61) return v;
    var out = new Date();
    out.setTime((v > 60 ? v : v + 1) * 86400000 + $a1a91b25d7598376$var$dnthresh);
    return out;
}
/* ISO 8601 Duration */ function $a1a91b25d7598376$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case 'Y':
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case 'D':
                mt *= 24;
            /* falls through */ case 'H':
                mt *= 60;
            /* falls through */ case 'M':
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case 'S':
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
/* Blame https://bugs.chromium.org/p/v8/issues/detail?id=7863 for the regexide */ var $a1a91b25d7598376$var$pdre1 = /^(\d+):(\d+)(:\d+)?(\.\d+)?$/; // HH:MM[:SS[.UUU]]
var $a1a91b25d7598376$var$pdre2 = /^(\d+)-(\d+)-(\d+)$/; // YYYY-mm-dd
var $a1a91b25d7598376$var$pdre3 = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)?(\.\d+)?$/; // YYYY-mm-dd(T or space)HH:MM[:SS[.UUU]], sans "Z"
/* parses a date string as a UTC date */ function $a1a91b25d7598376$var$parseDate(str /*:string*/ , date1904 /*:boolean*/ ) /*:Date*/ {
    if (str instanceof Date) return str;
    var m = str.match($a1a91b25d7598376$var$pdre1);
    if (m) return new Date((date1904 ? $a1a91b25d7598376$var$dnthresh2 : $a1a91b25d7598376$var$dnthresh1) + ((parseInt(m[1], 10) * 60 + parseInt(m[2], 10)) * 60 + (m[3] ? parseInt(m[3].slice(1), 10) : 0)) * 1000 + (m[4] ? parseInt((m[4] + "000").slice(1, 4), 10) : 0));
    m = str.match($a1a91b25d7598376$var$pdre2);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 0, 0, 0, 0));
    /* TODO: 1900-02-29T00:00:00.000 should return a flag to treat as a date code (affects xlml) */ m = str.match($a1a91b25d7598376$var$pdre3);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], m[6] && parseInt(m[6].slice(1), 10) || 0, m[7] && parseInt((m[7] + "0000").slice(1, 4), 10) || 0));
    var d = new Date(str);
    return d;
}
function $a1a91b25d7598376$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(arr)) {
        if (debomit && $a1a91b25d7598376$var$buf_utf16le) {
            // TODO: temporary patch
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $a1a91b25d7598376$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $a1a91b25d7598376$var$utf8write($a1a91b25d7598376$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $a1a91b25d7598376$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $a1a91b25d7598376$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20ac": "\x80",
            "\u201a": "\x82",
            "\u0192": "\x83",
            "\u201e": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02c6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017d": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201c": "\x93",
            "\u201d": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02dc": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203a": "\x9b",
            "\u0153": "\x9c",
            "\u017e": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [], i = 0;
    // this cascade is for the browsers and runtimes of antiquity (and for modern runtimes that lack TextEncoder)
    try {
        for(i = 0; i < arr.length - 65536; i += 65536)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 65536)));
        o.push(String.fromCharCode.apply(0, arr.slice(i)));
    } catch (e) {
        try {
            for(; i < arr.length - 16384; i += 16384)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 16384)));
            o.push(String.fromCharCode.apply(0, arr.slice(i)));
        } catch (e) {
            for(; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
        }
    }
    return o.join("");
}
function $a1a91b25d7598376$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != 'object' || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $a1a91b25d7598376$var$dup(o[k]);
    return out;
}
function $a1a91b25d7598376$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $a1a91b25d7598376$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(]([^()]*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
/* NOTE: Chrome rejects bare times like 1:23 PM */ var $a1a91b25d7598376$var$FDRE1 = /^(0?\d|1[0-2])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))\s+([ap])m?$/;
var $a1a91b25d7598376$var$FDRE2 = /^([01]?\d|2[0-3])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))$/;
var $a1a91b25d7598376$var$FDISO = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)(\.\d+)?[Z]?$/; // YYYY-mm-dd(T or space)HH:MM:SS[.UUU][Z]
/* TODO: 1904 adjustment */ var $a1a91b25d7598376$var$utc_append_works = new Date("6/9/69 00:00 UTC").valueOf() == -17798400000;
function $a1a91b25d7598376$var$fuzzytime1(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, M[7] == "p" ? 12 : 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], 0, 0));
}
function $a1a91b25d7598376$var$fuzzytime2(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1], 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], 0, 0));
}
var $a1a91b25d7598376$var$lower_months = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
];
function $a1a91b25d7598376$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    // See issue 2863 -- this is technically not supported in Excel but is otherwise useful
    if ($a1a91b25d7598376$var$FDISO.test(s)) return s.indexOf("Z") == -1 ? $a1a91b25d7598376$var$local_to_utc(new Date(s)) : new Date(s);
    var lower = s.toLowerCase();
    var lnos = lower.replace(/\s+/g, " ").trim();
    var M = lnos.match($a1a91b25d7598376$var$FDRE1);
    if (M) return $a1a91b25d7598376$var$fuzzytime1(M);
    M = lnos.match($a1a91b25d7598376$var$FDRE2);
    if (M) return $a1a91b25d7598376$var$fuzzytime2(M);
    M = lnos.match($a1a91b25d7598376$var$pdre3);
    if (M) return new Date(Date.UTC(+M[1], +M[2] - 1, +M[3], +M[4], +M[5], M[6] && parseInt(M[6].slice(1), 10) || 0, M[7] && parseInt((M[7] + "0000").slice(1, 4), 10) || 0));
    var o = new Date($a1a91b25d7598376$var$utc_append_works && s.indexOf("UTC") == -1 ? s + " UTC" : s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $a1a91b25d7598376$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.replace(/[ap]m?/, "").match(/[a-z]/)) return n;
    if (y < 0 || y > 8099 || s.match(/[^-0-9:,\/\\\ ]/)) return n;
    return o;
}
var $a1a91b25d7598376$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $a1a91b25d7598376$var$utc_to_local(utc) {
    return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate(), utc.getUTCHours(), utc.getUTCMinutes(), utc.getUTCSeconds(), utc.getUTCMilliseconds());
}
function $a1a91b25d7598376$var$local_to_utc(local) {
    return new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds(), local.getMilliseconds()));
}
function $a1a91b25d7598376$var$remove_doctype(str) {
    var preamble = str.slice(0, 1024);
    var si = preamble.indexOf("<!DOCTYPE");
    if (si == -1) return str;
    var m = str.match(/<[\w]/);
    if (!m) return str;
    return str.slice(0, si) + str.slice(m.index);
}
/* str.match(/<!--[\s\S]*?-->/g) --> str_match_ng(str, "<!--", "-->") */ function $a1a91b25d7598376$var$str_match_ng(str, s, e) {
    var out = [];
    var si = str.indexOf(s);
    while(si > -1){
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        out.push(str.slice(si, ei + e.length));
        si = str.indexOf(s, ei + e.length);
    }
    return out.length > 0 ? out : null;
}
/* str.replace(/<!--[\s\S]*?-->/g, "") --> str_remove_ng(str, "<!--", "-->") */ function $a1a91b25d7598376$var$str_remove_ng(str, s, e) {
    var out = [], last = 0;
    var si = str.indexOf(s);
    if (si == -1) return str;
    while(si > -1){
        out.push(str.slice(last, si));
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        if ((si = str.indexOf(s, last = ei + e.length)) == -1) out.push(str.slice(last));
    }
    return out.join("");
}
/* str.match(/<tag\b[^>]*?>([\s\S]*?)</tag>/) --> str_match_xml(str, "tag") */ var $a1a91b25d7598376$var$xml_boundary = {
    " ": 1,
    "\t": 1,
    "\r": 1,
    "\n": 1,
    ">": 1
};
function $a1a91b25d7598376$var$str_match_xml(str, tag) {
    var si = str.indexOf('<' + tag), w = tag.length + 1, L = str.length;
    while(si >= 0 && si <= L - w && !$a1a91b25d7598376$var$xml_boundary[str.charAt(si + w)])si = str.indexOf('<' + tag, si + 1);
    if (si === -1) return null;
    var sf = str.indexOf(">", si + tag.length);
    if (sf === -1) return null;
    var et = "</" + tag + ">";
    var ei = str.indexOf(et, sf);
    if (ei == -1) return null;
    return [
        str.slice(si, ei + et.length),
        str.slice(sf + 1, ei)
    ];
}
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/) --> str_match_xml(str, "tag") */ var $a1a91b25d7598376$var$str_match_xml_ns = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m = res[0].exec(str);
        if (!m) return null;
        var si = m.index;
        var sf = res[0].lastIndex;
        res[1].lastIndex = res[0].lastIndex;
        m = res[1].exec(str);
        if (!m) return null;
        var ei = m.index;
        var ef = res[1].lastIndex;
        return [
            str.slice(si, ef),
            str.slice(sf, ei)
        ];
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/g) --> str_match_xml_ns_g(str, "tag") */ var $a1a91b25d7598376$var$str_match_xml_ns_g = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
var $a1a91b25d7598376$var$str_remove_xml_ns_g = /*#__PURE__*/ function() {
    var str_remove_xml_ns_cache = {};
    return function str_remove_xml_ns_g(str, tag) {
        var out = [];
        var res = str_remove_xml_ns_cache[tag];
        if (!res) str_remove_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        var si = 0, ef = 0;
        while(m = res[0].exec(str)){
            si = m.index;
            out.push(str.slice(ef, si));
            ef = si;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            ef = res[1].lastIndex;
            res[0].lastIndex = res[1].lastIndex;
        }
        out.push(str.slice(ef));
        return out.length == 0 ? "" : out.join("");
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/gi) --> str_match_xml_ns_ig(str, "tag") */ var $a1a91b25d7598376$var$str_match_xml_ig = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<' + tag + '\\b[^<>]*>', "ig"),
            new RegExp('</' + tag + '>', "ig")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
function $a1a91b25d7598376$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $a1a91b25d7598376$var$cc2str(data.content, true);
    if (data.data) return $a1a91b25d7598376$var$debom(data.data);
    if (data.asNodeBuffer && $a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$var$debom(data.asNodeBuffer().toString('binary'));
    if (data.asBinary) return $a1a91b25d7598376$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $a1a91b25d7598376$var$debom($a1a91b25d7598376$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $a1a91b25d7598376$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $a1a91b25d7598376$var$char_codes(data.data);
    if (data.asNodeBuffer && $a1a91b25d7598376$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $a1a91b25d7598376$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $a1a91b25d7598376$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $a1a91b25d7598376$var$getdatabin(data) : $a1a91b25d7598376$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $a1a91b25d7598376$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $a1a91b25d7598376$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g, '\/');
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $a1a91b25d7598376$var$getzipfile(zip, file /*:string*/ ) {
    var o = $a1a91b25d7598376$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $a1a91b25d7598376$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $a1a91b25d7598376$var$getdata($a1a91b25d7598376$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $a1a91b25d7598376$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $a1a91b25d7598376$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $a1a91b25d7598376$var$getdatastr($a1a91b25d7598376$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $a1a91b25d7598376$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $a1a91b25d7598376$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $a1a91b25d7598376$var$getdatabin($a1a91b25d7598376$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $a1a91b25d7598376$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $a1a91b25d7598376$var$zipentries(zip) {
    var k = zip.FullPaths || $a1a91b25d7598376$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $a1a91b25d7598376$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (Array.isArray(content) && typeof content[0] == "string") content = content.join("");
        if (typeof content == "string") {
            var res;
            if ($a1a91b25d7598376$var$has_buf) res = $a1a91b25d7598376$var$Buffer_from(content);
            else res = $a1a91b25d7598376$var$utf8decode(content);
            return $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $a1a91b25d7598376$var$zip_new() {
    return $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_new();
}
function $a1a91b25d7598376$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $a1a91b25d7598376$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $a1a91b25d7598376$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $a1a91b25d7598376$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $a1a91b25d7598376$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split('/');
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split('/');
    while(target.length !== 0){
        var step = target.shift();
        if (step === '..') result.pop();
        else if (step !== '.') result.push(step);
    }
    return result.join('/');
}
var $a1a91b25d7598376$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $a1a91b25d7598376$var$attregexg = /\s([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $a1a91b25d7598376$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?<>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'"<>\s=]+))*\s*[\/\?]?>/mg, $a1a91b25d7598376$var$tagregex2 = /<[^<>]*>/g;
var $a1a91b25d7598376$var$tagregex = /*#__PURE__*/ $a1a91b25d7598376$var$XML_HEADER.match($a1a91b25d7598376$var$tagregex1) ? $a1a91b25d7598376$var$tagregex1 : $a1a91b25d7598376$var$tagregex2;
var $a1a91b25d7598376$var$nsregex = /<\w*:/, $a1a91b25d7598376$var$nsregex2 = /<(\/?)\w+:/;
function $a1a91b25d7598376$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($a1a91b25d7598376$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $a1a91b25d7598376$var$parsexmltagraw(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($a1a91b25d7598376$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
        z[q] = v;
        if (!skip_LC) z[q.toLowerCase()] = v;
    }
    return z;
}
function $a1a91b25d7598376$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($a1a91b25d7598376$var$nsregex2, "<$1");
}
var $a1a91b25d7598376$var$encodings = {
    '&quot;': '"',
    '&apos;': "'",
    '&gt;': '>',
    '&lt;': '<',
    '&amp;': '&'
};
var $a1a91b25d7598376$var$rencoding = /*#__PURE__*/ $a1a91b25d7598376$var$evert($a1a91b25d7598376$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $a1a91b25d7598376$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    function raw_unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + '', i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $a1a91b25d7598376$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return raw_unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + raw_unescapexml(s.slice(j + 3));
    }
    return function unescapexml(text /*:string*/ , xlsx /*:boolean*/ ) {
        var out = raw_unescapexml(text);
        return xlsx ? out.replace(/\r\n/g, "\n") : out;
    };
}();
var $a1a91b25d7598376$var$decregex = /[&<>'"]/g, $a1a91b25d7598376$var$charegex = /[\u0000-\u0008\u000b-\u001f\uFFFE-\uFFFF]/g;
function $a1a91b25d7598376$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($a1a91b25d7598376$var$decregex, function(y) {
        return $a1a91b25d7598376$var$rencoding[y];
    }).replace($a1a91b25d7598376$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $a1a91b25d7598376$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $a1a91b25d7598376$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $a1a91b25d7598376$var$htmlcharegex = /[\u0000-\u001f]/g;
function $a1a91b25d7598376$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($a1a91b25d7598376$var$decregex, function(y) {
        return $a1a91b25d7598376$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($a1a91b25d7598376$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $a1a91b25d7598376$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($a1a91b25d7598376$var$decregex, function(y) {
        return $a1a91b25d7598376$var$rencoding[y];
    }).replace($a1a91b25d7598376$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $a1a91b25d7598376$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $a1a91b25d7598376$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "\&#10;");
}
/* note: xsd:boolean valid values: true / 1 / false / 0 */ function $a1a91b25d7598376$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case '1':
        case 'true':
            return true;
        case 0:
        case false:
        case '0':
        case 'false':
            return false;
    }
    return false;
}
function $a1a91b25d7598376$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $a1a91b25d7598376$var$utf8readb(data) {
    var out = $a1a91b25d7598376$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString('ucs2');
}
function $a1a91b25d7598376$var$utf8readc(data) {
    return $a1a91b25d7598376$var$Buffer_from(data, 'binary').toString('utf8');
}
var $a1a91b25d7598376$var$utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
var $a1a91b25d7598376$var$utf8read = $a1a91b25d7598376$var$has_buf && /*#__PURE__*/ ($a1a91b25d7598376$var$utf8readc($a1a91b25d7598376$var$utf8corpus) == /*#__PURE__*/ $a1a91b25d7598376$var$utf8reada($a1a91b25d7598376$var$utf8corpus) && $a1a91b25d7598376$var$utf8readc || /*#__PURE__*/ $a1a91b25d7598376$var$utf8readb($a1a91b25d7598376$var$utf8corpus) == /*#__PURE__*/ $a1a91b25d7598376$var$utf8reada($a1a91b25d7598376$var$utf8corpus) && $a1a91b25d7598376$var$utf8readb) || $a1a91b25d7598376$var$utf8reada;
var $a1a91b25d7598376$var$utf8write /*:StringConv*/  = $a1a91b25d7598376$var$has_buf ? function(data) {
    return $a1a91b25d7598376$var$Buffer_from(data, 'utf8').toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
var $a1a91b25d7598376$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            'nbsp',
            ' '
        ],
        [
            'middot',
            "\xb7"
        ],
        [
            'quot',
            '"'
        ],
        [
            'apos',
            "'"
        ],
        [
            'gt',
            '>'
        ],
        [
            'lt',
            '<'
        ],
        [
            'amp',
            '&'
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp('&' + x[0] + ';', "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/(^|[^\t\n\r ])[\t\n\r ]+$/, "$1")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\b\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^<>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $a1a91b25d7598376$var$vtvregex = /<\/?(?:vt:)?variant>/g, $a1a91b25d7598376$var$vtmregex = /<(?:vt:)([^<"'>]*)>([\s\S]*)</;
function $a1a91b25d7598376$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $a1a91b25d7598376$var$parsexmltag(data);
    var matches /*:Array<string>*/  = $a1a91b25d7598376$var$str_match_xml_ns_g(data, h.baseType) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($a1a91b25d7598376$var$vtvregex, "").match($a1a91b25d7598376$var$vtmregex);
        if (v) res.push({
            v: $a1a91b25d7598376$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $a1a91b25d7598376$var$wtregex = /(^\s|\s$|\n)/;
function $a1a91b25d7598376$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return '<' + f + (g.match($a1a91b25d7598376$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f + '>';
}
function $a1a91b25d7598376$var$wxt_helper(h) /*:string*/ {
    return $a1a91b25d7598376$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $a1a91b25d7598376$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return '<' + f + (h != null ? $a1a91b25d7598376$var$wxt_helper(h) : "") + (g != null ? (g.match($a1a91b25d7598376$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';
}
function $a1a91b25d7598376$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $a1a91b25d7598376$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case 'string':
            var o = $a1a91b25d7598376$var$writextag('vt:lpwstr', $a1a91b25d7598376$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case 'number':
            return $a1a91b25d7598376$var$writextag((s | 0) == s ? 'vt:i4' : 'vt:r8', $a1a91b25d7598376$var$escapexml(String(s)));
        case 'boolean':
            return $a1a91b25d7598376$var$writextag('vt:bool', s ? 'true' : 'false');
    }
    if (s instanceof Date) return $a1a91b25d7598376$var$writextag('vt:filetime', $a1a91b25d7598376$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $a1a91b25d7598376$var$xlml_normalize(d) /*:string*/ {
    if ($a1a91b25d7598376$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $a1a91b25d7598376$require$Buffer.isBuffer(d)) return d.toString('utf8');
    if (typeof d === 'string') return d;
    /* duktape */ if (typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return $a1a91b25d7598376$var$utf8read($a1a91b25d7598376$var$a2s($a1a91b25d7598376$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags, ODS uses invalid XML */ var $a1a91b25d7598376$var$xlmlregex = /<([\/]?)([^\s?><!\/:"]*:|)([^\s?<>:\/"]+)(?:\s+[^<>=?"'\s]+="[^"]*?")*\s*[\/]?>/mg;
var $a1a91b25d7598376$var$XMLNS = {
    CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
    RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
    TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
    'dc': 'http://purl.org/dc/elements/1.1/',
    'dcterms': 'http://purl.org/dc/terms/',
    'dcmitype': 'http://purl.org/dc/dcmitype/',
    'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
    'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
    'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
    'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
    'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
    'xsd': 'http://www.w3.org/2001/XMLSchema'
} /*:any*/ ;
var $a1a91b25d7598376$var$XMLNS_main = [
    'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
    'http://purl.oclc.org/ooxml/spreadsheetml/main',
    'http://schemas.microsoft.com/office/excel/2006/main',
    'http://schemas.microsoft.com/office/excel/2006/2'
];
var $a1a91b25d7598376$var$XLMLNS = {
    'o': 'urn:schemas-microsoft-com:office:office',
    'x': 'urn:schemas-microsoft-com:office:excel',
    'ss': 'urn:schemas-microsoft-com:office:spreadsheet',
    'dt': 'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
    'mv': 'http://macVmlSchemaUri',
    'v': 'urn:schemas-microsoft-com:vml',
    'html': 'http://www.w3.org/TR/REC-html40'
} /*:any*/ ;
function $a1a91b25d7598376$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $a1a91b25d7598376$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $a1a91b25d7598376$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $a1a91b25d7598376$var$__toBuffer = $a1a91b25d7598376$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $a1a91b25d7598376$require$Buffer.isBuffer(bufs[0][0]) ? $a1a91b25d7598376$require$Buffer.concat(bufs[0].map(function(x) {
        return $a1a91b25d7598376$require$Buffer.isBuffer(x) ? x : $a1a91b25d7598376$var$Buffer_from(x);
    })) : $a1a91b25d7598376$var$___toBuffer(bufs);
} : $a1a91b25d7598376$var$___toBuffer;
var $a1a91b25d7598376$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($a1a91b25d7598376$var$__readUInt16LE(b, i)));
    return ss.join("").replace($a1a91b25d7598376$var$chr0, '');
};
var $a1a91b25d7598376$var$__utf16le = $a1a91b25d7598376$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$a1a91b25d7598376$require$Buffer.isBuffer(b) || !$a1a91b25d7598376$var$buf_utf16le) return $a1a91b25d7598376$var$___utf16le(b, s, e);
    return b.toString('utf16le', s, e).replace($a1a91b25d7598376$var$chr0, '') /*.replace(chr1,'!')*/ ;
} : $a1a91b25d7598376$var$___utf16le;
var $a1a91b25d7598376$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $a1a91b25d7598376$var$__hexlify = $a1a91b25d7598376$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $a1a91b25d7598376$require$Buffer.isBuffer(b) ? b.toString('hex', s, s + l) : $a1a91b25d7598376$var$___hexlify(b, s, l);
} : $a1a91b25d7598376$var$___hexlify;
var $a1a91b25d7598376$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($a1a91b25d7598376$var$__readUInt8(b, i)));
    return ss.join("");
};
var $a1a91b25d7598376$var$__utf8 = $a1a91b25d7598376$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $a1a91b25d7598376$require$Buffer.isBuffer(b) ? b.toString('utf8', s, e) : $a1a91b25d7598376$var$___utf8(b, s, e);
} : $a1a91b25d7598376$var$___utf8;
var $a1a91b25d7598376$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $a1a91b25d7598376$var$__lpstr = $a1a91b25d7598376$var$___lpstr;
var $a1a91b25d7598376$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $a1a91b25d7598376$var$__cpstr = $a1a91b25d7598376$var$___cpstr;
var $a1a91b25d7598376$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $a1a91b25d7598376$var$__lpwstr = $a1a91b25d7598376$var$___lpwstr;
var $a1a91b25d7598376$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $a1a91b25d7598376$var$__lpp4 = $a1a91b25d7598376$var$___lpp4;
var $a1a91b25d7598376$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $a1a91b25d7598376$var$__8lpp4 = $a1a91b25d7598376$var$___8lpp4;
var $a1a91b25d7598376$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $a1a91b25d7598376$var$read_double_le(b, idx);
};
var $a1a91b25d7598376$var$__double = $a1a91b25d7598376$var$___double;
var $a1a91b25d7598376$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($a1a91b25d7598376$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $a1a91b25d7598376$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b)) return $a1a91b25d7598376$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $a1a91b25d7598376$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b)) return $a1a91b25d7598376$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $a1a91b25d7598376$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b) || !$a1a91b25d7598376$var$buf_utf16le) return $a1a91b25d7598376$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len - 1);
    };
    $a1a91b25d7598376$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b) || !$a1a91b25d7598376$var$buf_utf16le) return $a1a91b25d7598376$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len);
    };
    $a1a91b25d7598376$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b)) return $a1a91b25d7598376$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf8', i + 4, i + 4 + len);
    };
    $a1a91b25d7598376$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($a1a91b25d7598376$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $a1a91b25d7598376$var$___double(b, i);
    };
    $a1a91b25d7598376$var$is_buf = function is_buf_b(a) {
        return $a1a91b25d7598376$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $a1a91b25d7598376$var$cpdoit() {
    $a1a91b25d7598376$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $a1a91b25d7598376$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($a1a91b25d7598376$var$chr0, '');
    };
    $a1a91b25d7598376$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $a1a91b25d7598376$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $a1a91b25d7598376$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $a1a91b25d7598376$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $a1a91b25d7598376$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $a1a91b25d7598376$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $a1a91b25d7598376$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined') $a1a91b25d7598376$var$cpdoit();
var $a1a91b25d7598376$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $a1a91b25d7598376$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $a1a91b25d7598376$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $a1a91b25d7598376$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $a1a91b25d7598376$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $a1a91b25d7598376$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $a1a91b25d7598376$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case 'dbcs':
            loc = this.l;
            if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(this) && $a1a91b25d7598376$var$buf_utf16le) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($a1a91b25d7598376$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case 'utf8':
            o = $a1a91b25d7598376$var$__utf8(this, this.l, this.l + size);
            break;
        case 'utf16le':
            size *= 2;
            o = $a1a91b25d7598376$var$__utf16le(this, this.l, this.l + size);
            break;
        case 'wstr':
            if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined') o = $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $a1a91b25d7598376$var$ReadShift.call(this, size, 'dbcs');
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case 'lpstr-ansi':
            o = $a1a91b25d7598376$var$__lpstr(this, this.l);
            size = 4 + $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            break;
        case 'lpstr-cp':
            o = $a1a91b25d7598376$var$__cpstr(this, this.l);
            size = 4 + $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case 'lpwstr':
            o = $a1a91b25d7598376$var$__lpwstr(this, this.l);
            size = 4 + 2 * $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case 'lpp4':
            size = 4 + $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            o = $a1a91b25d7598376$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case '8lpp4':
            size = 4 + $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            o = $a1a91b25d7598376$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case 'cstr':
            size = 0;
            o = "";
            while((w = $a1a91b25d7598376$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($a1a91b25d7598376$var$_getchar(w));
            o = oo.join("");
            break;
        case '_wstr':
            size = 0;
            o = "";
            while((w = $a1a91b25d7598376$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($a1a91b25d7598376$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case 'dbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $a1a91b25d7598376$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $a1a91b25d7598376$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($a1a91b25d7598376$var$_getchar($a1a91b25d7598376$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case 'cpstr':
            if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined') {
                o = $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case 'sbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $a1a91b25d7598376$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $a1a91b25d7598376$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($a1a91b25d7598376$var$_getchar($a1a91b25d7598376$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $a1a91b25d7598376$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === 'i' ? $a1a91b25d7598376$var$__readInt16LE : $a1a91b25d7598376$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === 'i' || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $a1a91b25d7598376$var$__readInt32LE : $a1a91b25d7598376$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === 'f') {
                        if (size == 8) oR = $a1a91b25d7598376$var$__double(this, this.l);
                        else oR = $a1a91b25d7598376$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $a1a91b25d7598376$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $a1a91b25d7598376$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >>> 8 & 0xFF;
    b[idx + 2] = val1 >>> 16 & 0xFF;
    b[idx + 3] = val1 >>> 24 & 0xFF;
};
var $a1a91b25d7598376$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >> 8 & 0xFF;
    b[idx + 2] = val1 >> 16 & 0xFF;
    b[idx + 3] = val1 >> 24 & 0xFF;
};
var $a1a91b25d7598376$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >>> 8 & 0xFF;
};
function $a1a91b25d7598376$var$WriteShift(t /*:number*/ , val1 /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === 'dbcs') {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i)$a1a91b25d7598376$var$__writeUInt16LE(this, val1.charCodeAt(i), this.l + 2 * i);
        size = 2 * val1.length;
    } else if (f === 'sbcs' || f == 'cpstr') {
        if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined' && $a1a91b25d7598376$var$current_ansi == 874) {
            /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i){
                var cpp = $a1a91b25d7598376$var$$cptable.utils.encode($a1a91b25d7598376$var$current_ansi, val1.charAt(i));
                this[this.l + i] = cpp[0];
            }
            size = val1.length;
        } else if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined' && f == 'cpstr') {
            cpp = $a1a91b25d7598376$var$$cptable.utils.encode($a1a91b25d7598376$var$current_codepage, val1);
            /* replace null bytes with _ when relevant */ if (cpp.length == val1.length) {
                for(i = 0; i < val1.length; ++i)if (cpp[i] == 0 && val1.charCodeAt(i) != 0) cpp[i] = 0x5F;
            }
            if (cpp.length == 2 * val1.length) {
                for(i = 0; i < val1.length; ++i)if (cpp[2 * i] == 0 && cpp[2 * i + 1] == 0 && val1.charCodeAt(i) != 0) cpp[2 * i] = 0x5F;
            }
            for(i = 0; i < cpp.length; ++i)this[this.l + i] = cpp[i];
            size = cpp.length;
        } else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val1 = val1.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i)this[this.l + i] = val1.charCodeAt(i) & 0xFF;
            size = val1.length;
        }
    } else if (f === 'hex') {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val1.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === 'utf16le') {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val1.length, t); ++i){
            var cc = val1.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val1 & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 1] = val1 & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 1] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 2] = val1 & 0xFF;
            break;
        case 4:
            size = 4;
            $a1a91b25d7598376$var$__writeUInt32LE(this, val1, this.l);
            break;
        case 8:
            size = 8;
            if (f === 'f') {
                $a1a91b25d7598376$var$write_double_le(this, val1, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $a1a91b25d7598376$var$__writeInt32LE(this, val1, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $a1a91b25d7598376$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $a1a91b25d7598376$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
    this.l += hexstr.length >> 1;
}
function $a1a91b25d7598376$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $a1a91b25d7598376$var$ReadShift /*:: :any)*/ ;
    blob.chk = $a1a91b25d7598376$var$CheckField;
    blob.write_shift = $a1a91b25d7598376$var$WriteShift;
}
function $a1a91b25d7598376$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $a1a91b25d7598376$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $a1a91b25d7598376$var$new_raw_buf(sz);
    $a1a91b25d7598376$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $a1a91b25d7598376$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $a1a91b25d7598376$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $a1a91b25d7598376$var$XLSBRecordEnum[RT] || $a1a91b25d7598376$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $a1a91b25d7598376$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $a1a91b25d7598376$var$has_buf ? 16384 : 2048;
    var has_buf_copy = $a1a91b25d7598376$var$has_buf && typeof $a1a91b25d7598376$var$new_buf(blksz).copy == "function";
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $a1a91b25d7598376$var$new_buf(sz);
        $a1a91b25d7598376$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        // workaround for new Buffer(3).slice(0,0) bug in bun 0.1.3
        if (curbuf.l) {
            if (curbuf.length > curbuf.l) {
                curbuf = curbuf.slice(0, curbuf.l);
                curbuf.l = curbuf.length;
            }
            if (curbuf.length > 0) bufs.push(curbuf);
        }
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $a1a91b25d7598376$var$bconcat(bufs);
    };
    var end2 = function() {
        endbuf();
        return bufs;
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs,
        end2: end2
    } /*:any*/ ;
}
function $a1a91b25d7598376$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $a1a91b25d7598376$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $a1a91b25d7598376$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $a1a91b25d7598376$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $a1a91b25d7598376$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $a1a91b25d7598376$var$shift_range_xls(cell, range, opts) {
    var out = $a1a91b25d7598376$var$dup(cell);
    out.s = $a1a91b25d7598376$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $a1a91b25d7598376$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $a1a91b25d7598376$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $a1a91b25d7598376$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $a1a91b25d7598376$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $a1a91b25d7598376$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $a1a91b25d7598376$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $a1a91b25d7598376$var$fix_row(s);
    return s;
}
function $a1a91b25d7598376$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $a1a91b25d7598376$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $a1a91b25d7598376$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $a1a91b25d7598376$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $a1a91b25d7598376$var$encode_row(r.e.r);
    }
    return $a1a91b25d7598376$var$encode_cell_xls(r.s, opts.biff) + ":" + $a1a91b25d7598376$var$encode_cell_xls(r.e, opts.biff);
}
function $a1a91b25d7598376$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($a1a91b25d7598376$var$unfix_row(rowstr), 10) - 1;
}
function $a1a91b25d7598376$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $a1a91b25d7598376$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $a1a91b25d7598376$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $a1a91b25d7598376$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $a1a91b25d7598376$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $a1a91b25d7598376$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $a1a91b25d7598376$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $a1a91b25d7598376$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $a1a91b25d7598376$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function $a1a91b25d7598376$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
function $a1a91b25d7598376$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $a1a91b25d7598376$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $a1a91b25d7598376$var$decode_cell(range),
        e: $a1a91b25d7598376$var$decode_cell(range)
    };
    return {
        s: $a1a91b25d7598376$var$decode_cell(range.slice(0, idx)),
        e: $a1a91b25d7598376$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $a1a91b25d7598376$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === 'undefined' || typeof ce === 'number') /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $a1a91b25d7598376$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== 'string') cs = $a1a91b25d7598376$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== 'string') ce = $a1a91b25d7598376$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $a1a91b25d7598376$var$fix_range(a1 /*:string*/ ) /*:string*/ {
    var s = $a1a91b25d7598376$var$decode_range(a1);
    return "$" + $a1a91b25d7598376$var$encode_col(s.s.c) + "$" + $a1a91b25d7598376$var$encode_row(s.s.r) + ":$" + $a1a91b25d7598376$var$encode_col(s.e.c) + "$" + $a1a91b25d7598376$var$encode_row(s.e.r);
}
// List of invalid characters needs to be tested further
function $a1a91b25d7598376$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname.replace(/'/g, "''") + "'";
    return sname;
}
function $a1a91b25d7598376$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $a1a91b25d7598376$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == 'd' && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $a1a91b25d7598376$var$SSF_format(cell.z, q ? $a1a91b25d7598376$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $a1a91b25d7598376$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $a1a91b25d7598376$var$datenum(v) : v);
    } catch (e) {
        return '' + v;
    }
}
function $a1a91b25d7598376$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == 'z') return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $a1a91b25d7598376$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $a1a91b25d7598376$var$safe_format_cell(cell, cell.v);
    return $a1a91b25d7598376$var$safe_format_cell(cell, v);
}
function $a1a91b25d7598376$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $a1a91b25d7598376$var$sheet_new(opts) {
    var out = {};
    var o = opts || {};
    if (o.dense) out["!data"] = [];
    return out;
}
function $a1a91b25d7598376$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($a1a91b25d7598376$var$DENSE != null && dense == null) dense = $a1a91b25d7598376$var$DENSE;
    var ws /*:Worksheet*/  = _ws || (dense ? {
        "!data": []
    } : {} /*:any*/ );
    if (dense && !ws["!data"]) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $a1a91b25d7598376$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = ws["!ref"] ? _range.e.r + 1 : 0;
    } else range.s.c = range.e.c = range.s.r = range.e.r = 0;
    var row = [], seen = false;
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        var __R = _R + R;
        if (dense) {
            if (!ws["!data"][__R]) ws["!data"][__R] = [];
            row = ws["!data"][__R];
        }
        var data_R = data[R];
        for(var C = 0; C != data_R.length; ++C){
            if (typeof data_R[C] === 'undefined') continue;
            var cell /*:Cell*/  = {
                v: data_R[C],
                t: ""
            } /*:any*/ ;
            var __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            seen = true;
            if (data_R[C] && typeof data_R[C] === 'object' && !Array.isArray(data_R[C]) && !(data_R[C] instanceof Date)) cell = data_R[C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data_R[C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = 'n';
                    else if (o.nullError) {
                        cell.t = 'e';
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = 'z';
                } else if (typeof cell.v === 'number') {
                    if (isFinite(cell.v)) cell.t = 'n';
                    else if (isNaN(cell.v)) {
                        cell.t = 'e';
                        cell.v = 0x0F; /* #VALUE! */ 
                    } else {
                        cell.t = 'e';
                        cell.v = 0x07; /*# DIV/0 */ 
                    }
                } else if (typeof cell.v === 'boolean') cell.t = 'b';
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                    if (!o.UTC) cell.v = $a1a91b25d7598376$var$local_to_utc(cell.v);
                    if (o.cellDates) {
                        cell.t = 'd';
                        cell.w = $a1a91b25d7598376$var$SSF_format(cell.z, $a1a91b25d7598376$var$datenum(cell.v, o.date1904));
                    } else {
                        cell.t = 'n';
                        cell.v = $a1a91b25d7598376$var$datenum(cell.v, o.date1904);
                        cell.w = $a1a91b25d7598376$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = 's';
            }
            if (dense) {
                if (row[__C] && row[__C].z) cell.z = row[__C].z;
                row[__C] = cell;
            } else {
                var cell_ref = $a1a91b25d7598376$var$encode_col(__C) + (__R + 1 /*:any*/ );
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (seen && range.s.c < 10400000) ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
    return ws;
}
function $a1a91b25d7598376$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $a1a91b25d7598376$var$sheet_add_aoa(null, data, opts);
}
function $a1a91b25d7598376$var$parse_Int32LE(data) {
    return data.read_shift(4, 'i');
}
function $a1a91b25d7598376$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $a1a91b25d7598376$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $a1a91b25d7598376$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $a1a91b25d7598376$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $a1a91b25d7598376$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $a1a91b25d7598376$var$write_StrRun(run, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $a1a91b25d7598376$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $a1a91b25d7598376$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($a1a91b25d7598376$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $a1a91b25d7598376$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $a1a91b25d7598376$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $a1a91b25d7598376$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $a1a91b25d7598376$var$parse_BrtCommentText = $a1a91b25d7598376$var$parse_RichStr;
function $a1a91b25d7598376$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $a1a91b25d7598376$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $a1a91b25d7598376$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $a1a91b25d7598376$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $a1a91b25d7598376$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $a1a91b25d7598376$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $a1a91b25d7598376$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $a1a91b25d7598376$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $a1a91b25d7598376$var$parse_XLSBCodeName = $a1a91b25d7598376$var$parse_XLWideString;
var $a1a91b25d7598376$var$write_XLSBCodeName = $a1a91b25d7598376$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $a1a91b25d7598376$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $a1a91b25d7598376$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $a1a91b25d7598376$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $a1a91b25d7598376$var$parse_XLNameWideString = $a1a91b25d7598376$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $a1a91b25d7598376$var$parse_RelID = $a1a91b25d7598376$var$parse_XLNullableWideString;
var $a1a91b25d7598376$var$write_RelID = $a1a91b25d7598376$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $a1a91b25d7598376$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $a1a91b25d7598376$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $a1a91b25d7598376$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $a1a91b25d7598376$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $a1a91b25d7598376$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $a1a91b25d7598376$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $a1a91b25d7598376$var$parse_UncheckedRfX = $a1a91b25d7598376$var$parse_RfX;
var $a1a91b25d7598376$var$write_UncheckedRfX = $a1a91b25d7598376$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $a1a91b25d7598376$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, 'f');
}
function $a1a91b25d7598376$var$write_Xnum(data, o) {
    return (o || $a1a91b25d7598376$var$new_buf(8)).write_shift(8, data, 'f');
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $a1a91b25d7598376$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, 'i');
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $a1a91b25d7598376$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $a1a91b25d7598376$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $a1a91b25d7598376$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $a1a91b25d7598376$var$write_BrtColor(color, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || 'FFFFFF';
        if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $a1a91b25d7598376$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $a1a91b25d7598376$var$write_FontFlags(font, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $a1a91b25d7598376$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $a1a91b25d7598376$var$parse_ClipboardFormatOrAnsiString(o) {
    return $a1a91b25d7598376$var$parse_ClipboardFormatOrString(o, 1);
}
function $a1a91b25d7598376$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $a1a91b25d7598376$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $a1a91b25d7598376$var$VT_I2 = 0x0002;
var $a1a91b25d7598376$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $a1a91b25d7598376$var$VT_BOOL = 0x000B;
var $a1a91b25d7598376$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $a1a91b25d7598376$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
//var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $a1a91b25d7598376$var$VT_FILETIME = 0x0040;
var $a1a91b25d7598376$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $a1a91b25d7598376$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
//var VT_VECTOR   = 0x1000;
var $a1a91b25d7598376$var$VT_VECTOR_VARIANT = 0x100C;
var $a1a91b25d7598376$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $a1a91b25d7598376$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $a1a91b25d7598376$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $a1a91b25d7598376$var$VT_CUSTOM = [
    $a1a91b25d7598376$var$VT_STRING,
    $a1a91b25d7598376$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $a1a91b25d7598376$var$DocSummaryPIDDSI = {
    0x01: {
        n: 'CodePage',
        t: $a1a91b25d7598376$var$VT_I2
    },
    0x02: {
        n: 'Category',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x03: {
        n: 'PresentationFormat',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x04: {
        n: 'ByteCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x05: {
        n: 'LineCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x06: {
        n: 'ParagraphCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x07: {
        n: 'SlideCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x08: {
        n: 'NoteCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x09: {
        n: 'HiddenCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x0a: {
        n: 'MultimediaClipCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x0b: {
        n: 'ScaleCrop',
        t: $a1a91b25d7598376$var$VT_BOOL
    },
    0x0c: {
        n: 'HeadingPairs',
        t: $a1a91b25d7598376$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    0x0d: {
        n: 'TitlesOfParts',
        t: $a1a91b25d7598376$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    0x0e: {
        n: 'Manager',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x0f: {
        n: 'Company',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x10: {
        n: 'LinksUpToDate',
        t: $a1a91b25d7598376$var$VT_BOOL
    },
    0x11: {
        n: 'CharacterCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x13: {
        n: 'SharedDoc',
        t: $a1a91b25d7598376$var$VT_BOOL
    },
    0x16: {
        n: 'HyperlinksChanged',
        t: $a1a91b25d7598376$var$VT_BOOL
    },
    0x17: {
        n: 'AppVersion',
        t: $a1a91b25d7598376$var$VT_I4,
        p: 'version'
    },
    0x18: {
        n: 'DigSig',
        t: $a1a91b25d7598376$var$VT_BLOB
    },
    0x1A: {
        n: 'ContentType',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x1B: {
        n: 'ContentStatus',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x1C: {
        n: 'Language',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x1D: {
        n: 'Version',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $a1a91b25d7598376$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $a1a91b25d7598376$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $a1a91b25d7598376$var$SummaryPIDSI = {
    0x01: {
        n: 'CodePage',
        t: $a1a91b25d7598376$var$VT_I2
    },
    0x02: {
        n: 'Title',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x03: {
        n: 'Subject',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x04: {
        n: 'Author',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x05: {
        n: 'Keywords',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x06: {
        n: 'Comments',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x07: {
        n: 'Template',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x08: {
        n: 'LastAuthor',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x09: {
        n: 'RevNumber',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x0A: {
        n: 'EditTime',
        t: $a1a91b25d7598376$var$VT_FILETIME
    },
    0x0B: {
        n: 'LastPrinted',
        t: $a1a91b25d7598376$var$VT_FILETIME
    },
    0x0C: {
        n: 'CreatedDate',
        t: $a1a91b25d7598376$var$VT_FILETIME
    },
    0x0D: {
        n: 'ModifiedDate',
        t: $a1a91b25d7598376$var$VT_FILETIME
    },
    0x0E: {
        n: 'PageCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x0F: {
        n: 'WordCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x10: {
        n: 'CharCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x11: {
        n: 'Thumbnail',
        t: $a1a91b25d7598376$var$VT_CF
    },
    0x12: {
        n: 'Application',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x13: {
        n: 'DocSecurity',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $a1a91b25d7598376$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $a1a91b25d7598376$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $a1a91b25d7598376$var$CountryEnum = {
    0x0001: "US",
    0x0002: "CA",
    0x0003: "",
    0x0007: "RU",
    0x0014: "EG",
    0x001E: "GR",
    0x001F: "NL",
    0x0020: "BE",
    0x0021: "FR",
    0x0022: "ES",
    0x0024: "HU",
    0x0027: "IT",
    0x0029: "CH",
    0x002B: "AT",
    0x002C: "GB",
    0x002D: "DK",
    0x002E: "SE",
    0x002F: "NO",
    0x0030: "PL",
    0x0031: "DE",
    0x0034: "MX",
    0x0037: "BR",
    0x003d: "AU",
    0x0040: "NZ",
    0x0042: "TH",
    0x0051: "JP",
    0x0052: "KR",
    0x0054: "VN",
    0x0056: "CN",
    0x005A: "TR",
    0x0069: "JS",
    0x00D5: "DZ",
    0x00D8: "MA",
    0x00DA: "LY",
    0x015F: "PT",
    0x0162: "IS",
    0x0166: "FI",
    0x01A4: "CZ",
    0x0376: "TW",
    0x03C1: "LB",
    0x03C2: "JO",
    0x03C3: "SY",
    0x03C4: "IQ",
    0x03C5: "KW",
    0x03C6: "SA",
    0x03CB: "AE",
    0x03CC: "IL",
    0x03CE: "QA",
    0x03D5: "IR",
    0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $a1a91b25d7598376$var$XLSFillPattern = [
    null,
    'solid',
    'mediumGray',
    'darkGray',
    'lightGray',
    'darkHorizontal',
    'darkVertical',
    'darkDown',
    'darkUp',
    'darkGrid',
    'darkTrellis',
    'lightHorizontal',
    'lightVertical',
    'lightDown',
    'lightUp',
    'lightGrid',
    'lightTrellis',
    'gray125',
    'gray0625'
];
function $a1a91b25d7598376$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $a1a91b25d7598376$var$_XLSIcv = /*#__PURE__*/ $a1a91b25d7598376$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0x000000,
    /* 0x40 icvForeground ?? */ 0xFFFFFF,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $a1a91b25d7598376$var$XLSIcv = /*#__PURE__*/ $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $a1a91b25d7598376$var$BErr = {
    0x00: "#NULL!",
    0x07: "#DIV/0!",
    0x0F: "#VALUE!",
    0x17: "#REF!",
    0x1D: "#NAME?",
    0x24: "#NUM!",
    0x2A: "#N/A",
    0x2B: "#GETTING_DATA",
    0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $a1a91b25d7598376$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
var $a1a91b25d7598376$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $a1a91b25d7598376$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $a1a91b25d7598376$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $a1a91b25d7598376$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $a1a91b25d7598376$var$parse_ct(data /*:?string*/ ) {
    var ct = $a1a91b25d7598376$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch(y[0].replace($a1a91b25d7598376$var$nsregex, "<")){
            case '<?xml':
                break;
            case '<Types':
                ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case '<Default':
                ctext[y.Extension.toLowerCase()] = y.ContentType;
                break;
            case '<Override':
                if (ct[$a1a91b25d7598376$var$ct2type[y.ContentType]] !== undefined) ct[$a1a91b25d7598376$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $a1a91b25d7598376$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $a1a91b25d7598376$var$write_ct(ct, opts, raw) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $a1a91b25d7598376$var$evert_arr($a1a91b25d7598376$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    if (!raw) {
        o[o.length] = $a1a91b25d7598376$var$XML_HEADER;
        o[o.length] = $a1a91b25d7598376$var$writextag('Types', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS.CT,
            'xmlns:xsd': $a1a91b25d7598376$var$XMLNS.xsd,
            'xmlns:xsi': $a1a91b25d7598376$var$XMLNS.xsi
        });
        o = o.concat([
            [
                'xml',
                'application/xml'
            ],
            [
                'bin',
                'application/vnd.ms-excel.sheet.binary.macroEnabled.main'
            ],
            [
                'vml',
                'application/vnd.openxmlformats-officedocument.vmlDrawing'
            ],
            [
                'data',
                'application/vnd.openxmlformats-officedocument.model+data'
            ],
            /* from test files */ [
                'bmp',
                'image/bmp'
            ],
            [
                'png',
                'image/png'
            ],
            [
                'gif',
                'image/gif'
            ],
            [
                'emf',
                'image/x-emf'
            ],
            [
                'wmf',
                'image/x-wmf'
            ],
            [
                'jpg',
                'image/jpeg'
            ],
            [
                'jpeg',
                'image/jpeg'
            ],
            [
                'tif',
                'image/tiff'
            ],
            [
                'tiff',
                'image/tiff'
            ],
            [
                'pdf',
                'application/pdf'
            ],
            [
                'rels',
                'application/vnd.openxmlformats-package.relationships+xml'
            ]
        ].map(function(x) {
            return $a1a91b25d7598376$var$writextag('Default', null, {
                'Extension': x[0],
                'ContentType': x[1]
            });
        }));
    }
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $a1a91b25d7598376$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $a1a91b25d7598376$var$CT_LIST[w][opts.bookType] || $a1a91b25d7598376$var$CT_LIST[w]['xlsx']
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $a1a91b25d7598376$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $a1a91b25d7598376$var$CT_LIST[w][opts.bookType] || $a1a91b25d7598376$var$CT_LIST[w]['xlsx']
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $a1a91b25d7598376$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': type2ct[t][0]
            });
        });
    };
    f1('workbooks');
    f2('sheets');
    f2('charts');
    f3('themes');
    [
        'strs',
        'styles'
    ].forEach(f1);
    [
        'coreprops',
        'extprops',
        'custprops'
    ].forEach(f3);
    f3('vba');
    f3('comments');
    f3('threadedcomments');
    f3('drawings');
    f2('metadata');
    f3('people');
    if (!raw && o.length > 2) {
        o[o.length] = '</Types>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $a1a91b25d7598376$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
    CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    CONN: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/connections",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $a1a91b25d7598376$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + '_rels/' + file.slice(n + 1) + ".rels";
}
function $a1a91b25d7598376$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== '/') currentFilePath = '/' + currentFilePath;
    var hash = {};
    (data.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === '<Relationship') {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = $a1a91b25d7598376$var$unescapexml(y.Target);
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === 'External' ? y.Target : $a1a91b25d7598376$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $a1a91b25d7598376$var$write_rels(rels) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('Relationships', null, {
            //'xmlns:ns0': XMLNS.RELS,
            'xmlns': $a1a91b25d7598376$var$XMLNS.RELS
        })
    ];
    $a1a91b25d7598376$var$keys(rels['!id']).forEach(function(rid) {
        o[o.length] = $a1a91b25d7598376$var$writextag('Relationship', null, rels['!id'][rid]);
    });
    if (o.length > 2) {
        o[o.length] = '</Relationships>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $a1a91b25d7598376$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels['!id']) rels['!id'] = {};
    if (!rels['!idx']) rels['!idx'] = 1;
    if (rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId);
    rels['!idx'] = rId + 1;
    relobj.Id = 'rId' + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $a1a91b25d7598376$var$RELS.HLINK,
        $a1a91b25d7598376$var$RELS.XPATH,
        $a1a91b25d7598376$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels['!id'][relobj.Id] = relobj;
    rels[('/' + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
var $a1a91b25d7598376$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $a1a91b25d7598376$var$parse_manifest(d, opts) {
    var str = $a1a91b25d7598376$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $a1a91b25d7598376$var$xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break;
        case "file-entry":
            FEtag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== $a1a91b25d7598376$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $a1a91b25d7598376$var$write_manifest(manifest) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
function $a1a91b25d7598376$var$write_rdf_type(file, res, tag) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $a1a91b25d7598376$var$write_rdf_has(base, file) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $a1a91b25d7598376$var$write_rdf(rdf) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($a1a91b25d7598376$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($a1a91b25d7598376$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($a1a91b25d7598376$var$write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
function $a1a91b25d7598376$var$write_meta_ods(wb, opts) {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $a1a91b25d7598376$var$XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $a1a91b25d7598376$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        'date'
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        'date'
    ]
];
function $a1a91b25d7598376$var$parse_core_props(data) {
    var p = {};
    data = $a1a91b25d7598376$var$utf8read(data);
    for(var i = 0; i < $a1a91b25d7598376$var$CORE_PROPS.length; ++i){
        var f = $a1a91b25d7598376$var$CORE_PROPS[i], cur = $a1a91b25d7598376$var$str_match_xml(data, f[0]);
        if (cur != null && cur.length > 0) p[f[1]] = $a1a91b25d7598376$var$unescapexml(cur[1]);
        if (f[2] === 'date' && p[f[1]]) p[f[1]] = $a1a91b25d7598376$var$parseDate(p[f[1]]);
    }
    return p;
}
function $a1a91b25d7598376$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $a1a91b25d7598376$var$escapexml(g);
    o[o.length] = h ? $a1a91b25d7598376$var$writextag(f, g, h) : $a1a91b25d7598376$var$writetag(f, g);
}
function $a1a91b25d7598376$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('cp:coreProperties', null, {
            //'xmlns': XMLNS.CORE_PROPS,
            'xmlns:cp': $a1a91b25d7598376$var$XMLNS.CORE_PROPS,
            'xmlns:dc': $a1a91b25d7598376$var$XMLNS.dc,
            'xmlns:dcterms': $a1a91b25d7598376$var$XMLNS.dcterms,
            'xmlns:dcmitype': $a1a91b25d7598376$var$XMLNS.dcmitype,
            'xmlns:xsi': $a1a91b25d7598376$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $a1a91b25d7598376$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $a1a91b25d7598376$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $a1a91b25d7598376$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $a1a91b25d7598376$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $a1a91b25d7598376$var$CORE_PROPS.length; ++i){
        var f = $a1a91b25d7598376$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $a1a91b25d7598376$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = '</cp:coreProperties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $a1a91b25d7598376$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $a1a91b25d7598376$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $a1a91b25d7598376$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $a1a91b25d7598376$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $a1a91b25d7598376$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $a1a91b25d7598376$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $a1a91b25d7598376$var$utf8read(data);
    $a1a91b25d7598376$var$EXT_PROPS.forEach(function(f) {
        var xml = ($a1a91b25d7598376$var$str_match_xml_ns(data, f[0]) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $a1a91b25d7598376$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = $a1a91b25d7598376$var$str_match_xml(data, f[0]);
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $a1a91b25d7598376$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $a1a91b25d7598376$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $a1a91b25d7598376$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $a1a91b25d7598376$var$XML_HEADER;
    o[o.length] = $a1a91b25d7598376$var$writextag('Properties', null, {
        'xmlns': $a1a91b25d7598376$var$XMLNS.EXT_PROPS,
        'xmlns:vt': $a1a91b25d7598376$var$XMLNS.vt
    });
    $a1a91b25d7598376$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case 'string':
                v = $a1a91b25d7598376$var$escapexml(String(cp[f[1]]));
                break;
            case 'bool':
                v = cp[f[1]] ? 'true' : 'false';
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>') + W('vt:variant', W('vt:i4', String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $a1a91b25d7598376$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $a1a91b25d7598376$var$custregex = /<[^<>]+>[^<]*/g;
function $a1a91b25d7598376$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($a1a91b25d7598376$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<Properties':
                break;
            case '<property':
                name = $a1a91b25d7598376$var$unescapexml(y.name);
                break;
            case '</property>':
                name = null;
                break;
            default:
                if (x.indexOf('<vt:') === 0) {
                    var toks = x.split('>');
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case 'lpstr':
                        case 'bstr':
                        case 'lpwstr':
                            p[name] = $a1a91b25d7598376$var$unescapexml(text);
                            break;
                        case 'bool':
                            p[name] = $a1a91b25d7598376$var$parsexmlbool(text);
                            break;
                        case 'i1':
                        case 'i2':
                        case 'i4':
                        case 'i8':
                        case 'int':
                        case 'uint':
                            p[name] = parseInt(text, 10);
                            break;
                        case 'r4':
                        case 'r8':
                        case 'decimal':
                            p[name] = parseFloat(text);
                            break;
                        case 'filetime':
                        case 'date':
                            p[name] = $a1a91b25d7598376$var$parseDate(text);
                            break;
                        case 'cy':
                        case 'error':
                            p[name] = $a1a91b25d7598376$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == '/') break;
                            if (opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $a1a91b25d7598376$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('Properties', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS.CUST_PROPS,
            'xmlns:vt': $a1a91b25d7598376$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $a1a91b25d7598376$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $a1a91b25d7598376$var$writextag('property', $a1a91b25d7598376$var$write_vt(cp[k], true), {
            'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
            'pid': pid,
            'name': $a1a91b25d7598376$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $a1a91b25d7598376$var$XLMLDocPropsMap = {
    Title: 'Title',
    Subject: 'Subject',
    Author: 'Author',
    Keywords: 'Keywords',
    Comments: 'Description',
    LastAuthor: 'LastAuthor',
    RevNumber: 'Revision',
    Application: 'AppName',
    /* TotalTime: 'TotalTime', */ LastPrinted: 'LastPrinted',
    CreatedDate: 'Created',
    ModifiedDate: 'LastSaved',
    /* Pages */ /* Words */ /* Characters */ Category: 'Category',
    /* PresentationFormat */ Manager: 'Manager',
    Company: 'Company',
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: 'Version',
    ContentStatus: 'ContentStatus',
    /* NOTE: missing from schema */ Identifier: 'Identifier',
    /* NOTE: missing from schema */ Language: 'Language' /* NOTE: missing from schema */ 
};
var $a1a91b25d7598376$var$evert_XLMLDPM;
function $a1a91b25d7598376$var$xlml_set_prop(Props, tag /*:string*/ , val1) {
    if (!$a1a91b25d7598376$var$evert_XLMLDPM) $a1a91b25d7598376$var$evert_XLMLDPM = $a1a91b25d7598376$var$evert($a1a91b25d7598376$var$XLMLDocPropsMap);
    tag = $a1a91b25d7598376$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val1;
}
function $a1a91b25d7598376$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $a1a91b25d7598376$var$keys($a1a91b25d7598376$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $a1a91b25d7598376$var$CORE_PROPS.length; ++i)if ($a1a91b25d7598376$var$CORE_PROPS[i][1] == m) return $a1a91b25d7598376$var$CORE_PROPS[i];
        for(i = 0; i < $a1a91b25d7598376$var$EXT_PROPS.length; ++i)if ($a1a91b25d7598376$var$EXT_PROPS[i][1] == m) return $a1a91b25d7598376$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case 'date':
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == 'number') m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($a1a91b25d7598376$var$writetag($a1a91b25d7598376$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $a1a91b25d7598376$var$writextag('DocumentProperties', o.join(""), {
        xmlns: $a1a91b25d7598376$var$XLMLNS.o
    });
}
function $a1a91b25d7598376$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = 'CustomDocumentProperties';
    var o /*:Array<string>*/  = [];
    if (Props) $a1a91b25d7598376$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $a1a91b25d7598376$var$CORE_PROPS.length; ++i)if (k == $a1a91b25d7598376$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $a1a91b25d7598376$var$EXT_PROPS.length; ++i)if (k == $a1a91b25d7598376$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($a1a91b25d7598376$var$writextag($a1a91b25d7598376$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $a1a91b25d7598376$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($a1a91b25d7598376$var$writextag($a1a91b25d7598376$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return '<' + T + ' xmlns="' + $a1a91b25d7598376$var$XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $a1a91b25d7598376$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $a1a91b25d7598376$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $a1a91b25d7598376$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, 'lpstr-cp');
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $a1a91b25d7598376$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, 'lpwstr');
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $a1a91b25d7598376$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $a1a91b25d7598376$var$parse_lpwstr(blob);
    return $a1a91b25d7598376$var$parse_lpstr(blob, stringType, pad);
}
function $a1a91b25d7598376$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $a1a91b25d7598376$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $a1a91b25d7598376$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $a1a91b25d7598376$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $a1a91b25d7598376$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, 'lpwstr').replace($a1a91b25d7598376$var$chr0, '');
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $a1a91b25d7598376$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, 'lpstr-cp').replace($a1a91b25d7598376$var$chr0, '');
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $a1a91b25d7598376$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, $a1a91b25d7598376$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, $a1a91b25d7598376$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $a1a91b25d7598376$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($a1a91b25d7598376$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $a1a91b25d7598376$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? 'utf16le' : 'utf8').replace($a1a91b25d7598376$var$chr0, '').replace($a1a91b25d7598376$var$chr1, '!');
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $a1a91b25d7598376$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $a1a91b25d7598376$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $a1a91b25d7598376$var$VT_VARIANT) {
        if (t !== type && $a1a91b25d7598376$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
    }
    switch(type === $a1a91b25d7598376$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, 'i');
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, 'i');
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            blob.l += 4;
            val = $a1a91b25d7598376$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
            break;
        case 0x1F /*VT_LPWSTR*/ :
            blob.l += 4;
            val = $a1a91b25d7598376$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
            break;
        case 0x40 /*VT_FILETIME*/ :
            return $a1a91b25d7598376$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $a1a91b25d7598376$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $a1a91b25d7598376$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $a1a91b25d7598376$var$parse_VtString(blob, t, !opts.raw).replace($a1a91b25d7598376$var$chr0, '');
        case 0x51 /*VT_USTR*/ :
            return $a1a91b25d7598376$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($a1a91b25d7598376$var$chr0, '');
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $a1a91b25d7598376$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $a1a91b25d7598376$var$parse_VtVecLpwstrValue(blob) : $a1a91b25d7598376$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $a1a91b25d7598376$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $a1a91b25d7598376$var$new_buf(4), p = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $a1a91b25d7598376$var$new_buf(8);
            p.write_shift(8, value, 'f');
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $a1a91b25d7598376$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $a1a91b25d7598376$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $a1a91b25d7598376$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $a1a91b25d7598376$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
        }
        if (PIDSI) {
            if (Props[i][0] == 0 && Props.length > i + 1 && Props[i][1] == Props[i + 1][1]) continue; // R9
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $a1a91b25d7598376$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, $a1a91b25d7598376$var$VT_I2);
                $a1a91b25d7598376$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $a1a91b25d7598376$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $a1a91b25d7598376$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val1;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val1 = $a1a91b25d7598376$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val1 = $a1a91b25d7598376$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val1 = $a1a91b25d7598376$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(4, 'i');
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(8, 'f');
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val1 = $a1a91b25d7598376$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val1 = $a1a91b25d7598376$var$parseDate($a1a91b25d7598376$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val1;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $a1a91b25d7598376$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
];
function $a1a91b25d7598376$var$guess_property_type(val1 /*:any*/ ) /*:number*/ {
    switch(typeof val1){
        case "boolean":
            return 0x0B;
        case "number":
            return (val1 | 0) == val1 ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val1 instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $a1a91b25d7598376$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $a1a91b25d7598376$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $a1a91b25d7598376$var$new_buf(8), pio = $a1a91b25d7598376$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $a1a91b25d7598376$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $a1a91b25d7598376$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $a1a91b25d7598376$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $a1a91b25d7598376$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($a1a91b25d7598376$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $a1a91b25d7598376$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val1 = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val1 == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val1.split(".");
                val1 = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $a1a91b25d7598376$var$write_TypedPropertyValue(pinfo.t, val1);
        } else {
            var T = $a1a91b25d7598376$var$guess_property_type(val1);
            if (T == -1) {
                T = 0x1F;
                val1 = String(val1);
            }
            pr = $a1a91b25d7598376$var$write_TypedPropertyValue(T, val1);
        }
        prop.push(pr);
        pio = $a1a91b25d7598376$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $a1a91b25d7598376$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $a1a91b25d7598376$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $a1a91b25d7598376$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk('feff', 'Byte Order: ');
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $a1a91b25d7598376$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $a1a91b25d7598376$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $a1a91b25d7598376$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $a1a91b25d7598376$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $a1a91b25d7598376$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $a1a91b25d7598376$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $a1a91b25d7598376$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $a1a91b25d7598376$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $a1a91b25d7598376$var$bconcat(bufs);
}
function $a1a91b25d7598376$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $a1a91b25d7598376$var$writezeroes(n, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $a1a91b25d7598376$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $a1a91b25d7598376$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $a1a91b25d7598376$var$writebool(v /*:any*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $a1a91b25d7598376$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, 'u');
}
function $a1a91b25d7598376$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $a1a91b25d7598376$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $a1a91b25d7598376$var$parslurp(blob, length, $a1a91b25d7598376$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $a1a91b25d7598376$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $a1a91b25d7598376$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(2);
    o.write_shift(1, t == 'e' ? +v : +!!v);
    o.write_shift(1, t == 'e' ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = 'sbcs-cont';
    var cp = $a1a91b25d7598376$var$current_codepage;
    if (opts && opts.biff >= 8) $a1a91b25d7598376$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = 'dbcs-cont';
    } else if (opts.biff == 12) encoding = 'wstr';
    if (opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $a1a91b25d7598376$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $a1a91b25d7598376$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $a1a91b25d7598376$var$current_codepage;
    $a1a91b25d7598376$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $a1a91b25d7598376$var$current_codepage = cp;
    return z;
}
function $a1a91b25d7598376$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $a1a91b25d7598376$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $a1a91b25d7598376$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, 'utf16le');
    var out = [
        hdr,
        otext
    ];
    return $a1a91b25d7598376$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
        if (opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, 'sbcs-cont');
    else retval = blob.read_shift(cch, 'dbcs-cont');
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $a1a91b25d7598376$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $a1a91b25d7598376$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */ function $a1a91b25d7598376$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, 'utf16le');
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $a1a91b25d7598376$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $a1a91b25d7598376$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, 'utf16le').replace($a1a91b25d7598376$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $a1a91b25d7598376$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, 'lpstr-ansi');
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, 'utf16le').replace($a1a91b25d7598376$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $a1a91b25d7598376$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $a1a91b25d7598376$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $a1a91b25d7598376$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $a1a91b25d7598376$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, 'utf16le').replace($a1a91b25d7598376$var$chr0, "") : "";
    return o;
}
function $a1a91b25d7598376$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $a1a91b25d7598376$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $a1a91b25d7598376$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $a1a91b25d7598376$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $a1a91b25d7598376$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $a1a91b25d7598376$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $a1a91b25d7598376$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $a1a91b25d7598376$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $a1a91b25d7598376$var$write_Hyperlink(hl) {
    var out = $a1a91b25d7598376$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $a1a91b25d7598376$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $a1a91b25d7598376$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $a1a91b25d7598376$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $a1a91b25d7598376$var$parse_LongRGB(blob, length) {
    var x = $a1a91b25d7598376$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $a1a91b25d7598376$var$parse_XLSCell(blob, length, opts) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ret = {
        r: rw,
        c: col,
        ixfe: 0
    } /*:any*/ ;
    if (opts && opts.biff == 2 || length == 7) {
        /* TODO: pass back flags */ var flags = blob.read_shift(1);
        ret.ixfe = flags & 0x3F;
        blob.l += 2;
    /*
		var ifntifmt = blob.read_shift(1);
		var ifmt = ifntifmt & 0x3f, ifnt = ifntifmt >> 6;
		var flags3 = blob.read_shift(1);
		*/ } else ret.ixfe = blob.read_shift(2);
    return ret;
}
function $a1a91b25d7598376$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $a1a91b25d7598376$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $a1a91b25d7598376$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $a1a91b25d7598376$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, 'i'), itabLast = blob.read_shift(w, 'i');
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $a1a91b25d7598376$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $a1a91b25d7598376$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $a1a91b25d7598376$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $a1a91b25d7598376$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $a1a91b25d7598376$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $a1a91b25d7598376$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $a1a91b25d7598376$var$parse_Ref = $a1a91b25d7598376$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $a1a91b25d7598376$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $a1a91b25d7598376$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $a1a91b25d7598376$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $a1a91b25d7598376$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $a1a91b25d7598376$var$FtTab = {
    0x00: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtEnd */ 0x04: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtMacro */ 0x05: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtButton */ 0x06: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtGmo */ 0x07: $a1a91b25d7598376$var$parse_FtCf,
    /* FtCf */ 0x08: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtPioGrbit */ 0x09: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtPictFmla */ 0x0A: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtCbls */ 0x0B: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtRbo */ 0x0C: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtSbs */ 0x0D: $a1a91b25d7598376$var$parse_FtNts,
    /* FtNts */ 0x0E: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtSbsFmla */ 0x0F: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtGboData */ 0x10: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtEdoData */ 0x11: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtRboData */ 0x12: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtCblsData */ 0x13: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtLbsData */ 0x14: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtCblsFmla */ 0x15: $a1a91b25d7598376$var$parse_FtCmo
};
function $a1a91b25d7598376$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts[ft] = $a1a91b25d7598376$var$FtTab[ft](blob, tgt - blob.l);
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $a1a91b25d7598376$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $a1a91b25d7598376$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case 'biff8':
            break;
        case 'biff5':
            h = 0x0500;
            w = 8;
            break;
        case 'biff4':
            h = 0x0004;
            w = 6;
            break;
        case 'biff3':
            h = 0x0003;
            w = 6;
            break;
        case 'biff2':
            h = 0x0002;
            w = 4;
            break;
        case 'xla':
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $a1a91b25d7598376$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $a1a91b25d7598376$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $a1a91b25d7598376$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $a1a91b25d7598376$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $a1a91b25d7598376$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $a1a91b25d7598376$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $a1a91b25d7598376$var$parse_BoundSheet8(blob, length, opts) {
    var name = "";
    if (opts.biff == 4) {
        name = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, 0, opts);
        if (name.length === 0) name = "Sheet1";
        return {
            name: name
        };
    }
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = 'Worksheet';
            break;
        case 1:
            dt = 'Macrosheet';
            break;
        case 2:
            dt = 'Chartsheet';
            break;
        case 6:
            dt = 'VBAModule';
            break;
    }
    name = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $a1a91b25d7598376$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $a1a91b25d7598376$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $a1a91b25d7598376$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($a1a91b25d7598376$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $a1a91b25d7598376$var$write_SST(sst, opts) {
    var header = $a1a91b25d7598376$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $a1a91b25d7598376$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $a1a91b25d7598376$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $a1a91b25d7598376$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $a1a91b25d7598376$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $a1a91b25d7598376$var$parse_ForceFullCalculation(blob) {
    var header = $a1a91b25d7598376$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $a1a91b25d7598376$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $a1a91b25d7598376$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $a1a91b25d7598376$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $a1a91b25d7598376$var$write_Window1() {
    var o = $a1a91b25d7598376$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $a1a91b25d7598376$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $a1a91b25d7598376$var$write_Window2(view) {
    var o = $a1a91b25d7598376$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $a1a91b25d7598376$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $a1a91b25d7598376$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $a1a91b25d7598376$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $a1a91b25d7598376$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $a1a91b25d7598376$var$parse_LabelSst(blob, length, opts) {
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, length, opts);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $a1a91b25d7598376$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(10);
    $a1a91b25d7598376$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $a1a91b25d7598376$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, length, opts);
    var str = $a1a91b25d7598376$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $a1a91b25d7598376$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $a1a91b25d7598376$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $a1a91b25d7598376$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $a1a91b25d7598376$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $a1a91b25d7598376$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $a1a91b25d7598376$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? 'sbcs' : 'utf16le');
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $a1a91b25d7598376$var$parse_BIFF2Format = $a1a91b25d7598376$var$parse_XLUnicodeString2;
function $a1a91b25d7598376$var$write_BIFF2Format(f /*:string*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(1 + f.length);
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
function $a1a91b25d7598376$var$write_BIFF4Format(f /*:string*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(3 + f.length);
    o.l += 2;
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.90 */ function $a1a91b25d7598376$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $a1a91b25d7598376$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $a1a91b25d7598376$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $a1a91b25d7598376$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $a1a91b25d7598376$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $a1a91b25d7598376$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($a1a91b25d7598376$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $a1a91b25d7598376$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $a1a91b25d7598376$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $a1a91b25d7598376$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $a1a91b25d7598376$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $a1a91b25d7598376$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $a1a91b25d7598376$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $a1a91b25d7598376$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
function $a1a91b25d7598376$var$parse_BIFF2XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    blob.l++;
    o.flags = blob.read_shift(1);
    o.numFmtId = o.flags & 0x3F;
    o.flags >>= 6;
    o.fStyle = 0;
    o.data = {}; // TODO
    return o;
}
function $a1a91b25d7598376$var$write_BIFF2XF(xf) {
    var o = $a1a91b25d7598376$var$new_buf(4);
    o.l += 2;
    o.write_shift(1, xf.numFmtId);
    o.l++;
    return o;
}
function $a1a91b25d7598376$var$write_BIFF3XF(xf) {
    var o = $a1a91b25d7598376$var$new_buf(12);
    o.l++;
    o.write_shift(1, xf.numFmtId);
    o.l += 10;
    return o;
}
/* TODO: check other fields */ var $a1a91b25d7598376$var$write_BIFF4XF = $a1a91b25d7598376$var$write_BIFF3XF;
function $a1a91b25d7598376$var$parse_BIFF3XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
function $a1a91b25d7598376$var$parse_BIFF4XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
/* [MS-XLS] 2.4.134 */ function $a1a91b25d7598376$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $a1a91b25d7598376$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $a1a91b25d7598376$var$parse_BoolErr(blob, length, opts) {
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6, opts);
    var val1 = $a1a91b25d7598376$var$parse_Bes(blob, 2);
    cell.val = val1;
    cell.t = val1 === true || val1 === false ? 'b' : 'e';
    return cell;
}
function $a1a91b25d7598376$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(8);
    $a1a91b25d7598376$var$write_XLSCell(R, C, os, o);
    $a1a91b25d7598376$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $a1a91b25d7598376$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6, opts);
    var xnum = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $a1a91b25d7598376$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(14);
    $a1a91b25d7598376$var$write_XLSCell(R, C, os, o);
    $a1a91b25d7598376$var$write_Xnum(v, o);
    return o;
}
var $a1a91b25d7598376$var$parse_XLHeaderFooter = $a1a91b25d7598376$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $a1a91b25d7598376$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($a1a91b25d7598376$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $a1a91b25d7598376$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $a1a91b25d7598376$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ function $a1a91b25d7598376$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $a1a91b25d7598376$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $a1a91b25d7598376$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: legacy record filename encoding */ function $a1a91b25d7598376$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $a1a91b25d7598376$var$parse_BIFF5ExternSheet(blob, length, opts);
    /* see issue 2907 */ if (!(opts.biff > 8) && length == blob[blob.l] + (blob[blob.l + 1] == 0x03 ? 1 : 0) + 1) return $a1a91b25d7598376$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($a1a91b25d7598376$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $a1a91b25d7598376$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $a1a91b25d7598376$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $a1a91b25d7598376$var$parse_ShrFmla(blob, length, opts) {
    var ref = $a1a91b25d7598376$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $a1a91b25d7598376$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $a1a91b25d7598376$var$parse_Array(blob, length, opts) {
    var ref = $a1a91b25d7598376$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $a1a91b25d7598376$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $a1a91b25d7598376$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 */ function $a1a91b25d7598376$var$parse_NoteSh(blob, length, opts) {
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $a1a91b25d7598376$var$parse_Note(blob, length, opts) {
    if (opts && opts.biff < 8) {
        var row = blob.read_shift(2), col = blob.read_shift(2);
        if (row == 0xFFFF || row == -1) return; // TODO: test continuation
        var cch = blob.read_shift(2);
        var cmnt = blob.read_shift(Math.min(cch, 2048), 'cpstr');
        return [
            {
                r: row,
                c: col
            },
            cmnt
        ];
    }
    /* TODO: Support revisions */ return $a1a91b25d7598376$var$parse_NoteSh(blob, length, opts);
}
function $a1a91b25d7598376$var$write_NOTE_BIFF2(text /*:string*/ , R /*:number*/ , C /*:number*/ , len /*?:number*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(6 + (len || text.length));
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, len || text.length);
    o.write_shift(text.length, text, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.168 */ function $a1a91b25d7598376$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($a1a91b25d7598376$var$parse_Ref8U(blob, length));
    return merges;
}
function $a1a91b25d7598376$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$a1a91b25d7598376$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $a1a91b25d7598376$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $a1a91b25d7598376$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $a1a91b25d7598376$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $a1a91b25d7598376$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $a1a91b25d7598376$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $a1a91b25d7598376$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($a1a91b25d7598376$var$parse_BIFF5OT[ot] || $a1a91b25d7598376$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $a1a91b25d7598376$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $a1a91b25d7598376$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $a1a91b25d7598376$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $a1a91b25d7598376$var$parse_HLink(blob, length) {
    var ref = $a1a91b25d7598376$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $a1a91b25d7598376$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $a1a91b25d7598376$var$write_HLink(hl) {
    var O = $a1a91b25d7598376$var$new_buf(24);
    var ref = $a1a91b25d7598376$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $a1a91b25d7598376$var$bconcat([
        O,
        $a1a91b25d7598376$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $a1a91b25d7598376$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $a1a91b25d7598376$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, 'dbcs-cont');
    wzTooltip = wzTooltip.replace($a1a91b25d7598376$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $a1a91b25d7598376$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $a1a91b25d7598376$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $a1a91b25d7598376$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $a1a91b25d7598376$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $a1a91b25d7598376$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $a1a91b25d7598376$var$CountryEnum[d] || d;
    return o;
}
function $a1a91b25d7598376$var$write_Country(o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $a1a91b25d7598376$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($a1a91b25d7598376$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $a1a91b25d7598376$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($a1a91b25d7598376$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $a1a91b25d7598376$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $a1a91b25d7598376$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $a1a91b25d7598376$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $a1a91b25d7598376$var$write_ColInfo(col, idx) {
    var o = $a1a91b25d7598376$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $a1a91b25d7598376$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
    o.footer = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $a1a91b25d7598376$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $a1a91b25d7598376$var$write_RRTabId(n /*:number*/ ) {
    var out = $a1a91b25d7598376$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $a1a91b25d7598376$var$parse_Blank = $a1a91b25d7598376$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $a1a91b25d7598376$var$parse_Scl = $a1a91b25d7598376$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $a1a91b25d7598376$var$parse_String = $a1a91b25d7598376$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $a1a91b25d7598376$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
function $a1a91b25d7598376$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    if (!out) out = $a1a91b25d7598376$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(1, ixfe || 0 /* & 0x3F */ );
    out.write_shift(1, ifmt || 0 /* & 0x3F */ );
    out.write_shift(1, 0);
    return out;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $a1a91b25d7598376$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 7, opts);
    var str = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $a1a91b25d7598376$var$parse_BIFF2NUM(blob, length, opts) {
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 7, opts);
    var num = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $a1a91b25d7598376$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val1 /*:number*/ , ixfe, ifmt) {
    var out = $a1a91b25d7598376$var$new_buf(15);
    $a1a91b25d7598376$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(8, val1, 'f');
    return out;
}
function $a1a91b25d7598376$var$parse_BIFF2INT(blob, length, opts) {
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 7, opts);
    var num = blob.read_shift(2);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $a1a91b25d7598376$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val1 /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    var out = $a1a91b25d7598376$var$new_buf(9);
    $a1a91b25d7598376$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(2, val1);
    return out;
}
function $a1a91b25d7598376$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, 'sbcs-cont');
}
function $a1a91b25d7598376$var$parse_BIFF2BOOLERR(blob, length, opts) {
    var bestart = blob.l + 7;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6, opts);
    blob.l = bestart;
    var val1 = $a1a91b25d7598376$var$parse_Bes(blob, 2);
    cell.val = val1;
    cell.t = val1 === true || val1 === false ? 'b' : 'e';
    return cell;
}
/* TODO: convert to BIFF8 font struct */ function $a1a91b25d7598376$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $a1a91b25d7598376$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6, opts);
    var cch = blob.read_shift(2);
    var str = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $a1a91b25d7598376$var$parse_BIFF4SheetInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(4);
    var cch = blob.read_shift(1), name = blob.read_shift(cch, "sbcs");
    if (name.length === 0) name = "Sheet1";
    return {
        flags: flags,
        name: name
    };
}
var $a1a91b25d7598376$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $a1a91b25d7598376$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ 0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        /* shapefile DBF extension */ 0x00: 20127,
        0x08: 865,
        0x09: 437,
        0x0A: 850,
        0x0B: 437,
        0x0D: 437,
        0x0E: 850,
        0x0F: 437,
        0x10: 850,
        0x11: 437,
        0x12: 850,
        0x13: 932,
        0x14: 850,
        0x15: 437,
        0x16: 850,
        0x17: 865,
        0x18: 437,
        0x19: 437,
        0x1A: 850,
        0x1B: 437,
        0x1C: 863,
        0x1D: 850,
        0x1F: 852,
        0x22: 852,
        0x23: 852,
        0x24: 860,
        0x25: 850,
        0x26: 866,
        0x37: 850,
        0x40: 852,
        0x4D: 936,
        0x4E: 949,
        0x4F: 950,
        0x50: 874,
        0x57: 1252,
        0x58: 1252,
        0x59: 1252,
        0x6C: 863,
        0x86: 737,
        0x87: 852,
        0x88: 857,
        0xCC: 1257,
        0xFF: 16969
    };
    var dbf_reverse_map = $a1a91b25d7598376$var$evert({
        0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $a1a91b25d7598376$var$new_raw_buf(1);
        switch(opts.type){
            case 'base64':
                d = $a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(buf));
                break;
            case 'binary':
                d = $a1a91b25d7598376$var$s2a(buf);
                break;
            case 'buffer':
            case 'array':
                d = buf;
                break;
        }
        $a1a91b25d7598376$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = (typeof $a1a91b25d7598376$var$$cptable !== "undefined" ? $a1a91b25d7598376$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)) : $a1a91b25d7598376$var$a2s(d.slice(d.l, d.l + ww))).replace(/[\u0000\r\n][\S\s]*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case 'B':
                    if ((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case 'G':
                case 'P':
                    if (opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case '+':
                case '0':
                case '@':
                case 'C':
                case 'D':
                case 'F':
                case 'I':
                case 'L':
                case 'M':
                case 'N':
                case 'O':
                case 'T':
                case 'Y':
                    break;
                default:
                    throw new Error('Unknown Field Type: ' + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $a1a91b25d7598376$var$prep_blob(dd, 0);
                var s = typeof $a1a91b25d7598376$var$$cptable !== "undefined" ? $a1a91b25d7598376$var$$cptable.utils.decode(current_cp, dd) : $a1a91b25d7598376$var$a2s(dd);
                switch(fields[C].type){
                    case 'C':
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/([^\s])\s+$/, "$1");
                        break;
                    case 'D':
                        if (s.length === 8) {
                            out[R][C] = new Date(Date.UTC(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8), 0, 0, 0, 0));
                            if (!(opts && opts.UTC)) out[R][C] = $a1a91b25d7598376$var$utc_to_local(out[R][C]);
                        } else out[R][C] = s;
                        break;
                    case 'F':
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case '+':
                    case 'I':
                        out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i');
                        break;
                    case 'L':
                        switch(s.trim().toUpperCase()){
                            case 'Y':
                            case 'T':
                                out[R][C] = true;
                                break;
                            case 'N':
                            case 'F':
                                out[R][C] = false;
                                break;
                            case '':
                            case '\x00':
                            case '?':
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case 'M':
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case 'N':
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case '@':
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
                        break;
                    case 'T':
                        var hi = dd.read_shift(4), lo = dd.read_shift(4);
                        if (hi == 0 && lo == 0) break;
                        out[R][C] = new Date((hi - 0x253D8C) * 0x5265C00 + lo);
                        if (!(opts && opts.UTC)) out[R][C] = $a1a91b25d7598376$var$utc_to_local(out[R][C]);
                        break;
                    case 'Y':
                        out[R][C] = dd.read_shift(4, 'i') / 1e4 + dd.read_shift(4, 'i') / 1e4 * Math.pow(2, 32);
                        break;
                    case 'O':
                        out[R][C] = -dd.read_shift(-8, 'f');
                        break;
                    case 'B':
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, 'f');
                            break;
                        }
                    /* falls through */ case 'G':
                    case 'P':
                        dd.l += fields[C].len;
                        break;
                    case '0':
                        if (fields[C].name === '_NullFlags') break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $a1a91b25d7598376$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            var o = $a1a91b25d7598376$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
            o.bookType = "dbf";
            return o;
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        'B': 8,
        'C': 250,
        'L': 1,
        'D': 8,
        '?': 0,
        '': 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DBF");
        var o = opts || {};
        var old_cp = $a1a91b25d7598376$var$current_codepage;
        if (+o.codepage >= 0) $a1a91b25d7598376$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $a1a91b25d7598376$var$buf_array();
        var aoa /*:AOA*/  = $a1a91b25d7598376$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = '', _guess = '', maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = '?';
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case 'number':
                        _guess = 'B';
                        break;
                    case 'string':
                        _guess = 'C';
                        break;
                    case 'boolean':
                        _guess = 'L';
                        break;
                    case 'object':
                        _guess = col[j] instanceof Date ? 'D' : 'C';
                        break;
                    default:
                        _guess = 'C';
                }
                /* TODO: cache the values instead of encoding twice */ maxlen = Math.max(maxlen, (typeof $a1a91b25d7598376$var$$cptable !== "undefined" && typeof col[j] == "string" ? $a1a91b25d7598376$var$$cptable.utils.encode($a1a91b25d7598376$var$current_ansi, col[j]) : String(col[j])).length);
                guess = guess && guess != _guess ? 'C' : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == 'C') {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == 'B' && _guess == 'N') {
                guess = 'N';
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        var cp = +dbf_reverse_map[/*::String(*/ $a1a91b25d7598376$var$current_codepage /*::)*/ ] || 0x03;
        h.write_shift(4, 0x00000000 | cp << 8);
        if (dbf_codepage_map[cp] != +o.codepage) {
            if (o.codepage) console.error("DBF Unsupported codepage " + $a1a91b25d7598376$var$current_codepage + ", using 1252");
            $a1a91b25d7598376$var$current_codepage = 1252;
        }
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            /* TODO: test how applications handle non-ASCII field names */ var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case 'L':
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case 'B':
                        rout.write_shift(8, data[i][j] || 0, 'f');
                        break;
                    case 'N':
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        if (_n.length > colwidths[j]) _n = _n.slice(0, colwidths[j]); // addresses decimal > width
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case 'D':
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case 'C':
                        var _l = rout.l;
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "cpstr");
                        _l += colwidths[j] - rout.l;
                        for(hcnt = 0; hcnt < _l; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        $a1a91b25d7598376$var$current_codepage = old_cp;
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $a1a91b25d7598376$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        0: 176,
        1: 177,
        2: 178,
        3: 179,
        5: 181,
        6: 182,
        7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\u001BN(" + $a1a91b25d7598376$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1").replace("{", "\\{") + "|\\|)", "gm");
    try {
        sylk_char_regex = new RegExp("\u001BN(" + $a1a91b25d7598376$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    } catch (e) {}
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $a1a91b25d7598376$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $a1a91b25d7598376$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* TODO: evert the escape map */ var encode_sylk_str = function($$) {
        return $$.replace(/\n/g, "\x1b :").replace(/\r/g, "\x1b =");
    };
    /* https://oss.sheetjs.com/notes/sylk/ for more details */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case 'base64':
                return sylk_to_aoa_str($a1a91b25d7598376$var$Base64_decode(d), opts);
            case 'binary':
                return sylk_to_aoa_str(d, opts);
            case 'buffer':
                return sylk_to_aoa_str($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(d) ? d.toString('binary') : $a1a91b25d7598376$var$a2s(d), opts);
            case 'array':
                return sylk_to_aoa_str($a1a91b25d7598376$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        var wb = {
            Workbook: {
                WBProps: {},
                Names: []
            }
        };
        if (+opts.codepage >= 0) $a1a91b25d7598376$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\u0000").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val1;
            if (rstr.length > 0) switch(RT){
                case 'ID':
                    break; /* header */ 
                case 'E':
                    break; /* EOF */ 
                case 'B':
                    break; /* dimensions */ 
                case 'O':
                    /* workbook options */ for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'V':
                            var d1904 = parseInt(record[rj].slice(1), 10);
                            // NOTE: it is technically an error if d1904 >= 5 or < 0
                            if (d1904 >= 1 && d1904 <= 4) wb.Workbook.WBProps.date1904 = true;
                            break;
                    }
                    break;
                case 'W':
                    break; /* window */ 
                case 'P':
                    switch(record[1].charAt(0)){
                        case 'P':
                            formats.push(rstr.slice(3).replace(/;;/g, ";"));
                            break;
                    }
                    break;
                case 'NN':
                    var nn = {
                        Sheet: 0
                    };
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'N':
                            nn.Name = record[rj].slice(1);
                            break;
                        case 'E':
                            nn.Ref = (opts && opts.sheet || "Sheet1") + "!" + $a1a91b25d7598376$var$rc_to_a1(record[rj].slice(1));
                            break;
                    }
                    wb.Workbook.Names.push(nn);
                    break;
                // case 'NE': // ??
                // case 'NU': // ??
                case 'C':
                    /* cell */ var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1, formula = "", cell_t = "z";
                    var cmnt = "";
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'A':
                            cmnt = record[rj].slice(1);
                            break; // TODO: comment
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            C_seen_X = true;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'K':
                            val1 = record[rj].slice(1);
                            if (val1.charAt(0) === '"') {
                                val1 = val1.slice(1, val1.length - 1);
                                cell_t = "s";
                            } else if (val1 === 'TRUE' || val1 === 'FALSE') {
                                val1 = val1 === 'TRUE';
                                cell_t = "b";
                            } else if (val1.charAt(0) == "#" && $a1a91b25d7598376$var$RBErr[val1] != null) {
                                cell_t = "e";
                                val1 = $a1a91b25d7598376$var$RBErr[val1];
                            } else if (!isNaN($a1a91b25d7598376$var$fuzzynum(val1))) {
                                val1 = $a1a91b25d7598376$var$fuzzynum(val1);
                                cell_t = "n";
                                if (next_cell_format !== null && $a1a91b25d7598376$var$fmt_is_date(next_cell_format) && opts.cellDates) {
                                    val1 = $a1a91b25d7598376$var$numdate(wb.Workbook.WBProps.date1904 ? val1 + 1462 : val1);
                                    cell_t = typeof val1 == "number" ? "n" : "d";
                                }
                            }
                            if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined' && typeof val1 == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val1 = $a1a91b25d7598376$var$$cptable.utils.decode(opts.codepage, val1);
                            C_seen_K = true;
                            break;
                        case 'E':
                            C_seen_E = true;
                            formula = $a1a91b25d7598376$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            break;
                        case 'S':
                            C_seen_S = true;
                            break;
                        case 'G':
                            break; // unknown
                        case 'R':
                            _R = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        case 'C':
                            _C = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        // case 'P': // ??
                        // case 'D': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: cell_t,
                            v: val1
                        };
                        else {
                            arr[R][C].t = cell_t;
                            arr[R][C].v = val1;
                        }
                        if (next_cell_format) arr[R][C].z = next_cell_format;
                        if (opts.cellText !== false && next_cell_format) arr[R][C].w = $a1a91b25d7598376$var$SSF_format(arr[R][C].z, arr[R][C].v, {
                            date1904: wb.Workbook.WBProps.date1904
                        });
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        formula = $a1a91b25d7598376$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    if (formula) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'n',
                            f: formula
                        };
                        else arr[R][C].f = formula;
                    }
                    if (cmnt) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'z'
                        };
                        arr[R][C].c = [
                            {
                                a: "SheetJSYLK",
                                t: cmnt
                            }
                        ];
                    }
                    break;
                case 'F':
                    /* Format */ var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            ++F_seen;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'M':
                            Mval = parseInt(record[rj].slice(1), 10) / 20;
                            break;
                        case 'F':
                            break; /* ??? */ 
                        case 'G':
                            break; /* hide grid */ 
                        case 'P':
                            next_cell_format = formats[parseInt(record[rj].slice(1), 10)];
                            break;
                        case 'S':
                            break; /* cell style */ 
                        case 'D':
                            break; /* column */ 
                        case 'N':
                            break; /* font */ 
                        case 'W':
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                            }
                            break;
                        case 'C':
                            /* default column format */ C = parseInt(record[rj].slice(1), 10) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case 'R':
                            /* row properties */ R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $a1a91b25d7598376$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        // case 'K': // ??
                        // case 'E': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht['!rows'] = rowinfo;
        if (colinfo.length > 0) sht['!cols'] = colinfo;
        colinfo.forEach(function(col) {
            $a1a91b25d7598376$var$process_col(col);
        });
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht,
            wb
        ];
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1], wb = aoasht[2];
        var _opts = $a1a91b25d7598376$var$dup(opts);
        _opts.date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var o = $a1a91b25d7598376$var$aoa_to_sheet(aoa, _opts);
        $a1a91b25d7598376$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        var outwb = $a1a91b25d7598376$var$sheet_to_workbook(o, opts);
        $a1a91b25d7598376$var$keys(wb).forEach(function(k) {
            outwb[k] = wb[k];
        });
        outwb.bookType = "sylk";
        return outwb;
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case 'n':
                o += isFinite(cell.v) ? cell.v || 0 : $a1a91b25d7598376$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
                if (cell.f && !cell.F) o += ";E" + $a1a91b25d7598376$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case 'b':
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case 'e':
                o += cell.w || $a1a91b25d7598376$var$BErr[cell.v] || cell.v;
                break;
            case 'd':
                o += $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v, date1904), date1904);
                break;
            case 's':
                o += '"' + (cell.v == null ? "" : String(cell.v)).replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cmnt_sylk(cmnt /*:Comment*/ , R /*:number*/ , C /*:number*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";A";
        /* TODO: max length? */ o += encode_sylk_str(cmnt.map(function(c) {
            return c.t;
        }).join(""));
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == 'number' && !col.wpx) col.wpx = $a1a91b25d7598376$var$width2px(col.width);
                if (typeof col.wpx == 'number' && !col.wch) col.wch = $a1a91b25d7598376$var$px2char(col.wpx);
                if (typeof col.wch == 'number') rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $a1a91b25d7598376$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ , wb /*:?WorkBook*/ ) /*:string*/ {
        if (!opts) opts = {};
        opts._formats = [
            "General"
        ];
        /* TODO: codepage */ var preamble /*:Array<string>*/  = [
            "ID;PSheetJS;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $a1a91b25d7598376$var$safe_decode_range(ws['!ref'] || "A1"), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        var RS = "\r\n";
        var d1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var _lastfmt = "General";
        preamble.push("P;PGeneral");
        /* Excel has been inconsistent in comment placement */ var R = r.s.r, C = r.s.c, p = [];
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R)];
                if (!cell || !cell.c) continue;
                p.push(write_ws_cmnt_sylk(cell.c, R, C));
            }
            if (p.length) o.push(p.join(RS));
        }
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R)];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                if ((cell.z || (cell.t == "d" ? $a1a91b25d7598376$var$table_fmt[14] : "General")) != _lastfmt) {
                    var ifmt = opts._formats.indexOf(cell.z);
                    if (ifmt == -1) {
                        opts._formats.push(cell.z);
                        ifmt = opts._formats.length - 1;
                        preamble.push("P;P" + cell.z.replace(/;/g, ";;"));
                    }
                    p.push("F;P" + ifmt + ";Y" + (R + 1) + ";X" + (C + 1));
                }
                p.push(write_ws_cell_sylk(cell, ws, R, C, opts, d1904));
            }
            o.push(p.join(RS));
        }
        preamble.push("F;P0;DG0G8;M255");
        if (ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
        if (ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
        if (ws["!ref"]) preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        preamble.push("O;L;D;B" + (d1904 ? ";V4" : "") + ";K47;G100 0.001");
        delete opts._formats;
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        from_sheet: sheet_to_sylk
    };
}();
var $a1a91b25d7598376$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case 'base64':
                return dif_to_aoa_str($a1a91b25d7598376$var$Base64_decode(d), opts);
            case 'binary':
                return dif_to_aoa_str(d, opts);
            case 'buffer':
                return dif_to_aoa_str($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(d) ? d.toString('binary') : $a1a91b25d7598376$var$a2s(d), opts);
            case 'array':
                return dif_to_aoa_str($a1a91b25d7598376$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === 'BOT') {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === 'BOT') {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === 'TRUE') arr[R][C] = true;
                    else if (data === 'FALSE') arr[R][C] = false;
                    else if (!isNaN($a1a91b25d7598376$var$fuzzynum(value))) arr[R][C] = $a1a91b25d7598376$var$fuzzynum(value);
                    else if (!isNaN($a1a91b25d7598376$var$fuzzydate(value).getDate())) {
                        arr[R][C] = $a1a91b25d7598376$var$parseDate(value);
                        if (!(opts && opts.UTC)) arr[R][C] = $a1a91b25d7598376$var$utc_to_local(arr[R][C]);
                    } else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($a1a91b25d7598376$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== '' ? data : null;
                    break;
            }
            if (data === 'EOD') break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $a1a91b25d7598376$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        var o = $a1a91b25d7598376$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
        o.bookType = "dif";
        return o;
    }
    function make_value(v /*:number*/ , s /*:string*/ ) /*:string*/ {
        return "0," + String(v) + "\r\n" + s;
    }
    function make_value_str(s /*:string*/ ) /*:string*/ {
        return "1,0\r\n\"" + s.replace(/"/g, '""') + '"';
    }
    function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var _DIF_XL = $a1a91b25d7598376$var$DIF_XL;
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DIF");
        var r = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        var o /*:Array<string>*/  = [
            "TABLE\r\n0,1\r\n\"sheetjs\"\r\n",
            "VECTORS\r\n0," + (r.e.r - r.s.r + 1) + "\r\n\"\"\r\n",
            "TUPLES\r\n0," + (r.e.c - r.s.c + 1) + "\r\n\"\"\r\n",
            "DATA\r\n0,0\r\n\"\"\r\n"
        ];
        for(var R = r.s.r; R <= r.e.r; ++R){
            var row = dense ? ws["!data"][R] : [];
            var p = "-1,0\r\nBOT\r\n";
            for(var C = r.s.c; C <= r.e.c; ++C){
                var cell /*:Cell*/  = dense ? row && row[C] : ws[$a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (cell == null) {
                    p += "1,0\r\n\"\"\r\n";
                    continue;
                }
                switch(cell.t){
                    case 'n':
                        if (_DIF_XL) {
                            if (cell.w != null) p += "0," + cell.w + "\r\nV";
                            else if (cell.v != null) p += make_value(cell.v, "V"); // TODO: should this call SSF_format?
                            else if (cell.f != null && !cell.F) p += make_value_str("=" + cell.f);
                            else p += "1,0\r\n\"\"";
                        } else if (cell.v == null) p += "1,0\r\n\"\"";
                        else p += make_value(cell.v, "V");
                        break;
                    case 'b':
                        p += cell.v ? make_value(1, "TRUE") : make_value(0, "FALSE");
                        break;
                    case 's':
                        p += make_value_str(!_DIF_XL || isNaN(+cell.v) ? cell.v : '="' + cell.v + '"');
                        break;
                    case 'd':
                        if (!cell.w) cell.w = $a1a91b25d7598376$var$SSF_format(cell.z || $a1a91b25d7598376$var$table_fmt[14], $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v)));
                        if (_DIF_XL) p += make_value(cell.w, "V");
                        else p += make_value_str(cell.w);
                        break;
                    default:
                        p += "1,0\r\n\"\"";
                }
                p += "\r\n";
            }
            o.push(p);
        }
        return o.join("") + "-1,0\r\nEOD";
    }
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $a1a91b25d7598376$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== 'cell') continue;
            var addr = $a1a91b25d7598376$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case 't':
                    arr[R][C] = decode(record[3]);
                    break;
                case 'v':
                    arr[R][C] = +record[3];
                    break;
                case 'vtf':
                    var _f = record[record.length - 1];
                /* falls through */ case 'vtc':
                    switch(record[3]){
                        case 'nl':
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = record[record.length - 1].charAt(0) == "#" ? {
                                t: "e",
                                v: $a1a91b25d7598376$var$RBErr[record[record.length - 1]]
                            } : +record[4];
                            break;
                    }
                    if (record[2] == 'vtf') arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $a1a91b25d7598376$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $a1a91b25d7598376$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws['!ref']) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $a1a91b25d7598376$var$decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $a1a91b25d7598376$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === 'z') continue;
            oo = [
                "cell",
                coord,
                't'
            ];
            switch(cell.t){
                case 's':
                    oo.push(encode(cell.v));
                    break;
                case 'b':
                    oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                    oo[3] = 'nl';
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? 'TRUE' : 'FALSE'));
                    break;
                case 'd':
                    var t = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v));
                    oo[2] = 'vtc';
                    oo[3] = 'nd';
                    oo[4] = "" + t;
                    oo[5] = cell.w || $a1a91b25d7598376$var$SSF_format(cell.z || $a1a91b25d7598376$var$table_fmt[14], t);
                    break;
                case 'n':
                    if (isFinite(cell.v)) {
                        if (!cell.f) {
                            oo[2] = 'v';
                            oo[3] = cell.v;
                        } else {
                            oo[2] = 'vtf';
                            oo[3] = 'n';
                            oo[4] = cell.v;
                            oo[5] = encode(cell.f);
                        }
                    } else {
                        oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                        oo[3] = "e" + $a1a91b25d7598376$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
                        oo[4] = "0";
                        oo[5] = cell.f || oo[3].slice(1);
                        oo[6] = "e";
                        oo[7] = oo[3].slice(1);
                    }
                    break;
                case 'e':
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $a1a91b25d7598376$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === 'TRUE') arr[R][C] = true;
        else if (data === 'FALSE') arr[R][C] = false;
        else if (!isNaN($a1a91b25d7598376$var$fuzzynum(data))) arr[R][C] = $a1a91b25d7598376$var$fuzzynum(data);
        else if (!isNaN($a1a91b25d7598376$var$fuzzydate(data).getDate())) arr[R][C] = $a1a91b25d7598376$var$parseDate(data);
        else if (data.charCodeAt(0) == 35 /* # */  && $a1a91b25d7598376$var$RBErr[data] != null) arr[R][C] = {
            t: 'e',
            v: $a1a91b25d7598376$var$RBErr[data],
            w: data
        };
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        0x2C: ',',
        0x09: "\t",
        0x3B: ';',
        0x7C: '|'
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        0x2C: 3,
        0x09: 2,
        0x3B: 1,
        0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($a1a91b25d7598376$var$DENSE != null && o.dense == null) o.dense = $a1a91b25d7598376$var$DENSE;
        var ws /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) ws["!data"] = [];
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        var _re /*:?RegExp*/  = o.dateNF != null ? $a1a91b25d7598376$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            /* TODO: fuzzy parsers should pass back assumed number format */ var s = str.slice(start, end);
            if (s.slice(-1) == "\r") s = s.slice(0, -1);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (o.cellText !== false) cell.w = s;
            if (s.length === 0) cell.t = 'z';
            else if (o.raw) {
                cell.t = 's';
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = 's';
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = 's';
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($a1a91b25d7598376$var$fuzzyfmla(s)) {
                    cell.t = 's';
                    cell.f = s.slice(1);
                    cell.v = s;
                } else {
                    cell.t = 's';
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = 'b';
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = 'b';
                cell.v = false;
            } else if (!isNaN(v = $a1a91b25d7598376$var$fuzzynum(s))) {
                cell.t = 'n';
                cell.v = v;
            } else if (!isNaN((v = $a1a91b25d7598376$var$fuzzydate(s)).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                if (_re && s.match(_re)) {
                    var news = $a1a91b25d7598376$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    v = $a1a91b25d7598376$var$parseDate(news);
                    if (o && o.UTC === false) v = $a1a91b25d7598376$var$utc_to_local(v);
                } else if (o && o.UTC === false) v = $a1a91b25d7598376$var$utc_to_local(v);
                else if (o.cellText !== false && o.dateNF) cell.w = $a1a91b25d7598376$var$SSF_format(cell.z, v);
                if (o.cellDates) {
                    cell.t = 'd';
                    cell.v = v;
                } else {
                    cell.t = 'n';
                    cell.v = $a1a91b25d7598376$var$datenum(v);
                }
                if (!o.cellNF) delete cell.z;
            } else if (s.charCodeAt(0) == 35 /* # */  && $a1a91b25d7598376$var$RBErr[s] != null) {
                cell.t = 'e';
                cell.w = s;
                cell.v = $a1a91b25d7598376$var$RBErr[s];
            } else {
                cell.t = 's';
                cell.v = s;
            }
            if (cell.t == 'z') ;
            else if (o.dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = cell;
            } else ws[$a1a91b25d7598376$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case 0x0d:
                if (instr) break;
                if (str.charCodeAt(end + 1) == 0x0a) ++end;
            /* falls through */ case sepcc:
            case 0x0a:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $a1a91b25d7598376$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == 'string' ? [
            0,
            0,
            0,
            0
        ] : $a1a91b25d7598376$var$firstbyte(d, opts);
        switch(opts.type){
            case 'base64':
                str = $a1a91b25d7598376$var$Base64_decode(d);
                break;
            case 'binary':
                str = d;
                break;
            case 'buffer':
                if (opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
                else if (opts.codepage && typeof $a1a91b25d7598376$var$$cptable !== 'undefined') str = $a1a91b25d7598376$var$$cptable.utils.decode(opts.codepage, d);
                else str = $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(d) ? d.toString('binary') : $a1a91b25d7598376$var$a2s(d);
                break;
            case 'array':
                str = $a1a91b25d7598376$var$cc2str(d);
                break;
            case 'string':
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $a1a91b25d7598376$var$utf8read(str.slice(3));
        else if (opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = $a1a91b25d7598376$var$utf8read(str);
        else if (opts.type == 'binary' && typeof $a1a91b25d7598376$var$$cptable !== 'undefined' && opts.codepage) str = $a1a91b25d7598376$var$$cptable.utils.decode(opts.codepage, $a1a91b25d7598376$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $a1a91b25d7598376$var$ETH.to_sheet(opts.type == 'string' ? str : $a1a91b25d7598376$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $a1a91b25d7598376$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        if (!ws["!ref"]) return "";
        var r = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($a1a91b25d7598376$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $a1a91b25d7598376$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $a1a91b25d7598376$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (e.message.indexOf("SYLK bad record ID") == -1 && OLD_WTF) throw e;
        return $a1a91b25d7598376$var$PRN.to_workbook(d, opts);
    }
}
var $a1a91b25d7598376$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $a1a91b25d7598376$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case 'base64':
                return lotus_to_workbook_buf($a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(d)), opts);
            case 'binary':
                return lotus_to_workbook_buf($a1a91b25d7598376$var$s2a(d), opts);
            case 'buffer':
            case 'array':
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    /* NOTE: this list intentionally starts at 1 */ var LOTUS_DATE_FMTS = [
        "mmmm",
        "dd-mmm-yyyy",
        "dd-mmm",
        "mmm-yyyy",
        "@",
        "mm/dd",
        "hh:mm:ss AM/PM",
        "hh:mm AM/PM",
        "mm/dd/yyyy",
        "mm/dd",
        "hh:mm:ss",
        "hh:mm" // 12
    ];
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($a1a91b25d7598376$var$DENSE != null && o.dense == null) o.dense = $a1a91b25d7598376$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ , n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [], sdata = [];
        if (o.dense) sdata = s["!data"] = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        var lastcell = {};
        if (d[4] == 0x51 && d[5] == 0x50 && d[6] == 0x57) return qpw_to_workbook_buf(d, opts);
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val1, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val1;
                        if (val1 >= 0x1000) o.qpro = true;
                        break;
                    case 0xFF:
                        /* BOF (works 3+) */ o.vers = val1;
                        o.works = true;
                        break;
                    case 0x06:
                        refguess = val1;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val1) next_n = val1;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val1;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if ((!o.qpro && !o.works || RT == 0x33) && val1[1].v.charCodeAt(0) < 0x30) val1[1].v = val1[1].v.slice(1);
                        if (o.works || o.works2) val1[1].v = val1[1].v.replace(/\r\n/g, "\n");
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if ((val1[2] & 0x70) == 0x70 && (val1[2] & 0x0F) > 1 && (val1[2] & 0x0F) < 15) {
                            val1[1].z = o.dateNF || LOTUS_DATE_FMTS[(val1[2] & 0x0F) - 1] || $a1a91b25d7598376$var$table_fmt[14];
                            if (o.cellDates) {
                                val1[1].v = $a1a91b25d7598376$var$numdate(val1[1].v);
                                val1[1].t = typeof val1[1].v == "number" ? 'n' : 'd';
                            }
                        }
                        if (o.qpro) {
                            if (val1[3] > sidx) {
                                s["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = {} /*:any*/ ;
                                if (o.dense) sdata = s["!data"] = [];
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val1[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (sdata[val1[0].r] || [])[val1[0].c] : s[$a1a91b25d7598376$var$encode_cell(val1[0])];
                        if (tmpcell) {
                            tmpcell.t = val1[1].t;
                            tmpcell.v = val1[1].v;
                            if (val1[1].z != null) tmpcell.z = val1[1].z;
                            if (val1[1].f != null) tmpcell.f = val1[1].f;
                            lastcell = tmpcell;
                            break;
                        }
                        if (o.dense) {
                            if (!sdata[val1[0].r]) sdata[val1[0].r] = [];
                            sdata[val1[0].r][val1[0].c] = val1[1];
                        } else s[$a1a91b25d7598376$var$encode_cell(val1[0])] = val1[1];
                        lastcell = val1[1];
                        break;
                    case 0x5405:
                        o.works2 = true;
                        break;
                    case 0x5402:
                        /* TODO: enumerate all extended number formats */ if (val1 == 0x14a1) {
                            lastcell.z = "hh:mm:ss";
                            if (o.cellDates && lastcell.t == "n") {
                                lastcell.v = $a1a91b25d7598376$var$numdate(lastcell.v);
                                lastcell.t = typeof lastcell.v == "number" ? 'n' : 'd';
                            }
                        }
                        break;
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val1, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val1;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ if (val1[1].v.charCodeAt(0) < 0x30) val1[1].v = val1[1].v.slice(1);
                        // TODO: R9 appears to encode control codes this way -- verify against other versions
                        val1[1].v = val1[1].v.replace(/\x0F./g, function($$) {
                            return String.fromCharCode($$.charCodeAt(1) - 0x20);
                        }).replace(/\r\n/g, "\n");
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val1[3] > sidx) {
                            s["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = {} /*:any*/ ;
                            if (o.dense) sdata = s["!data"] = [];
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val1[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val1[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!sdata[val1[0].r]) sdata[val1[0].r] = [];
                            sdata[val1[0].r][val1[0].c] = val1[1];
                        } else s[$a1a91b25d7598376$var$encode_cell(val1[0])] = val1[1];
                        if (refguess.e.c < val1[0].c) refguess.e.c = val1[0].c;
                        if (refguess.e.r < val1[0].r) refguess.e.r = val1[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val1[0x36b0]) realnames[val1[0x36b0][0]] = val1[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val1[0]] = val1[1];
                        if (val1[0] == sidx) n = val1[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $a1a91b25d7598376$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $a1a91b25d7598376$var$buf_array();
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to WK1");
        var range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var cols = [];
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $a1a91b25d7598376$var$encode_row(R);
            for(C = range.s.c; C <= range.e.c; ++C){
                var cell = dense ? (ws["!data"][R] || [])[C] : ws[cols[C] + rr];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ switch(cell.t){
                    case "n":
                        if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell));
                        else $a1a91b25d7598376$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell));
                        break;
                    case "d":
                        var dc = $a1a91b25d7598376$var$datenum(cell.v);
                        if ((dc | 0) == dc && dc >= -32768 && dc <= 32767) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $a1a91b25d7598376$var$table_fmt[14]
                        }));
                        else $a1a91b25d7598376$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $a1a91b25d7598376$var$table_fmt[14]
                        }));
                        break;
                    default:
                        var str = $a1a91b25d7598376$var$format_cell(cell);
                        $a1a91b25d7598376$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $a1a91b25d7598376$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $a1a91b25d7598376$var$buf_array();
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $a1a91b25d7598376$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
            var dense = ws["!data"] != null;
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $a1a91b25d7598376$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $a1a91b25d7598376$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $a1a91b25d7598376$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $a1a91b25d7598376$var$format_cell(cell);
                        /* TODO: max len? */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $a1a91b25d7598376$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $a1a91b25d7598376$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $a1a91b25d7598376$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else if (opts.works) {
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
            o[2] = blob.read_shift(2);
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function get_wk1_fmt(cell) /*:number*/ {
        /* TODO: some fuzzy matching on the number format */ if (cell.z && $a1a91b25d7598376$var$fmt_is_date(cell.z)) return 0xf0 | (LOTUS_DATE_FMTS.indexOf(cell.z) + 1 || 2);
        return 0xFF;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if ((opts.vers & 0xFFFE) == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $a1a91b25d7598376$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_STRING(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if (opts.vers == 0x5120) {
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, 'i');
        return o;
    }
    function write_INTEGER(R, C, cell) {
        var o = $a1a91b25d7598376$var$new_buf(7);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, cell.v, 'i');
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, 'f');
        return o;
    }
    function write_NUMBER(R, C, cell) {
        var o = $a1a91b25d7598376$var$new_buf(13);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, cell.v, 'f');
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, 'f');
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $a1a91b25d7598376$var$encode_col(V) : $a1a91b25d7598376$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x1F: [
            "NA",
            0
        ],
        // 0x20: ["ERR", 0],
        0x21: [
            "ABS",
            1
        ],
        0x22: [
            "TRUNC",
            1
        ],
        0x23: [
            "SQRT",
            1
        ],
        0x24: [
            "LOG",
            1
        ],
        0x25: [
            "LN",
            1
        ],
        0x26: [
            "PI",
            0
        ],
        0x27: [
            "SIN",
            1
        ],
        0x28: [
            "COS",
            1
        ],
        0x29: [
            "TAN",
            1
        ],
        0x2A: [
            "ATAN2",
            2
        ],
        0x2B: [
            "ATAN",
            1
        ],
        0x2C: [
            "ASIN",
            1
        ],
        0x2D: [
            "ACOS",
            1
        ],
        0x2E: [
            "EXP",
            1
        ],
        0x2F: [
            "MOD",
            2
        ],
        // 0x30
        0x31: [
            "ISNA",
            1
        ],
        0x32: [
            "ISERR",
            1
        ],
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x35: [
            "RAND",
            0
        ],
        0x36: [
            "DATE",
            3
        ],
        // 0x37 NOW
        // 0x38 PMT
        // 0x39 PV
        // 0x3A FV
        // 0x3B IF
        // 0x3C DAY
        // 0x3D MONTH
        // 0x3E YEAR
        0x3F: [
            "ROUND",
            2
        ],
        0x40: [
            "TIME",
            3
        ],
        // 0x41 HOUR
        // 0x42 MINUTE
        // 0x43 SECOND
        0x44: [
            "ISNUMBER",
            1
        ],
        0x45: [
            "ISTEXT",
            1
        ],
        0x46: [
            "LEN",
            1
        ],
        0x47: [
            "VALUE",
            1
        ],
        // 0x48: ["FIXED", ?? 1],
        0x49: [
            "MID",
            3
        ],
        0x4A: [
            "CHAR",
            1
        ],
        // 0x4B
        // 0x4C FIND
        // 0x4D DATEVALUE
        // 0x4E TIMEVALUE
        // 0x4F CELL
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        // 0x55 VLOOKUP
        // 0x56 NPV
        // 0x57 VAR
        // 0x58 STD
        // 0x59 IRR
        // 0x5A HLOOKUP
        // 0x5B DSUM
        // 0x5C DAVERAGE
        // 0x5D DCOUNTA
        // 0x5E DMIN
        // 0x5F DMAX
        // 0x60 DVARP
        // 0x61 DSTDEVP
        // 0x62 INDEX
        // 0x63 COLS
        // 0x64 ROWS
        // 0x65 REPEAT
        0x66: [
            "UPPER",
            1
        ],
        0x67: [
            "LOWER",
            1
        ],
        // 0x68 LEFT
        // 0x69 RIGHT
        // 0x6A REPLACE
        0x6B: [
            "PROPER",
            1
        ],
        // 0x6C CELL
        0x6D: [
            "TRIM",
            1
        ],
        // 0x6E CLEAN
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $a1a91b25d7598376$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, 'f'));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = 's';
        o[1].v = blob.read_shift(length - 4, 'cstr');
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $a1a91b25d7598376$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $a1a91b25d7598376$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, 'f');
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 12);
        blob.l += length - 12; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, 'cstr');
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $a1a91b25d7598376$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        0x0000: {
            n: "BOF",
            f: $a1a91b25d7598376$var$parseuint16
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "CALCMODE"
        },
        0x0003: {
            n: "CALCORDER"
        },
        0x0004: {
            n: "SPLIT"
        },
        0x0005: {
            n: "SYNC"
        },
        0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        0x0007: {
            n: "WINDOW1"
        },
        0x0008: {
            n: "COLW1"
        },
        0x0009: {
            n: "WINTWO"
        },
        0x000A: {
            n: "COLW2"
        },
        0x000B: {
            n: "NAME"
        },
        0x000C: {
            n: "BLANK"
        },
        0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        0x0018: {
            n: "TABLE"
        },
        0x0019: {
            n: "ORANGE"
        },
        0x001A: {
            n: "PRANGE"
        },
        0x001B: {
            n: "SRANGE"
        },
        0x001C: {
            n: "FRANGE"
        },
        0x001D: {
            n: "KRANGE1"
        },
        0x0020: {
            n: "HRANGE"
        },
        0x0023: {
            n: "KRANGE2"
        },
        0x0024: {
            n: "PROTEC"
        },
        0x0025: {
            n: "FOOTER"
        },
        0x0026: {
            n: "HEADER"
        },
        0x0027: {
            n: "SETUP"
        },
        0x0028: {
            n: "MARGINS"
        },
        0x0029: {
            n: "LABELFMT"
        },
        0x002A: {
            n: "TITLES"
        },
        0x002B: {
            n: "SHEETJS"
        },
        0x002D: {
            n: "GRAPH"
        },
        0x002E: {
            n: "NGRAPH"
        },
        0x002F: {
            n: "CALCCOUNT"
        },
        0x0030: {
            n: "UNFORMATTED"
        },
        0x0031: {
            n: "CURSORW12"
        },
        0x0032: {
            n: "WINDOW"
        },
        0x0033: {
            n: "STRING",
            f: parse_STRING
        },
        0x0037: {
            n: "PASSWORD"
        },
        0x0038: {
            n: "LOCKED"
        },
        0x003C: {
            n: "QUERY"
        },
        0x003D: {
            n: "QUERYNAME"
        },
        0x003E: {
            n: "PRINT"
        },
        0x003F: {
            n: "PRINTNAME"
        },
        0x0040: {
            n: "GRAPH2"
        },
        0x0041: {
            n: "GRAPHNAME"
        },
        0x0042: {
            n: "ZOOM"
        },
        0x0043: {
            n: "SYMSPLIT"
        },
        0x0044: {
            n: "NSROWS"
        },
        0x0045: {
            n: "NSCOLS"
        },
        0x0046: {
            n: "RULER"
        },
        0x0047: {
            n: "NNAME"
        },
        0x0048: {
            n: "ACOMM"
        },
        0x0049: {
            n: "AMACRO"
        },
        0x004A: {
            n: "PARSE"
        },
        // 0x0064
        0x0066: {
            n: "PRANGES??"
        },
        0x0067: {
            n: "RRANGES??"
        },
        0x0068: {
            n: "FNAME??"
        },
        0x0069: {
            n: "MRANGES??"
        },
        // 0x0096
        // 0x0099
        // 0x009A
        // 0x009B
        // 0x009C
        // 0x00C0
        // 0x00C7
        // 0x00C9
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        // 0x00CD
        0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        0x00FF: {
            n: "BOF",
            f: $a1a91b25d7598376$var$parseuint16
        },
        0x5402: {
            n: "WKSNF",
            f: $a1a91b25d7598376$var$parseuint16
        },
        0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        0x0000: {
            n: "BOF"
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "PASSWORD"
        },
        0x0003: {
            n: "CALCSET"
        },
        0x0004: {
            n: "WINDOWSET"
        },
        0x0005: {
            n: "SHEETCELLPTR"
        },
        0x0006: {
            n: "SHEETLAYOUT"
        },
        0x0007: {
            n: "COLUMNWIDTH"
        },
        0x0008: {
            n: "HIDDENCOLUMN"
        },
        0x0009: {
            n: "USERRANGE"
        },
        0x000A: {
            n: "SYSTEMRANGE"
        },
        0x000B: {
            n: "ZEROFORCE"
        },
        0x000C: {
            n: "SORTKEYDIR"
        },
        0x000D: {
            n: "FILESEAL"
        },
        0x000E: {
            n: "DATAFILLNUMS"
        },
        0x000F: {
            n: "PRINTMAIN"
        },
        0x0010: {
            n: "PRINTSTRING"
        },
        0x0011: {
            n: "GRAPHMAIN"
        },
        0x0012: {
            n: "GRAPHSTRING"
        },
        0x0013: {
            n: "??"
        },
        0x0014: {
            n: "ERRCELL"
        },
        0x0015: {
            n: "NACELL"
        },
        0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        0x001A: {
            n: "FORMULA1A"
        },
        0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        0x001C: {
            n: "DTLABELMISC"
        },
        0x001D: {
            n: "DTLABELCELL"
        },
        0x001E: {
            n: "GRAPHWINDOW"
        },
        0x001F: {
            n: "CPA"
        },
        0x0020: {
            n: "LPLAUTO"
        },
        0x0021: {
            n: "QUERY"
        },
        0x0022: {
            n: "HIDDENSHEET"
        },
        0x0023: {
            n: "??"
        },
        0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        0x0026: {
            n: "??"
        },
        0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        0x008E: {
            n: "??"
        },
        0x0093: {
            n: "??"
        },
        0x0096: {
            n: "??"
        },
        0x0097: {
            n: "??"
        },
        0x0098: {
            n: "??"
        },
        0x0099: {
            n: "??"
        },
        0x009A: {
            n: "??"
        },
        0x009B: {
            n: "??"
        },
        0x009C: {
            n: "??"
        },
        0x00A3: {
            n: "??"
        },
        0x00AE: {
            n: "??"
        },
        0x00AF: {
            n: "??"
        },
        0x00B0: {
            n: "??"
        },
        0x00B1: {
            n: "??"
        },
        0x00B8: {
            n: "??"
        },
        0x00B9: {
            n: "??"
        },
        0x00BA: {
            n: "??"
        },
        0x00BB: {
            n: "??"
        },
        0x00BC: {
            n: "??"
        },
        0x00C3: {
            n: "??"
        },
        0x00C9: {
            n: "??"
        },
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        0x00CD: {
            n: "??"
        },
        0x00CE: {
            n: "??"
        },
        0x00CF: {
            n: "??"
        },
        0x00D0: {
            n: "??"
        },
        0x0100: {
            n: "??"
        },
        0x0103: {
            n: "??"
        },
        0x0104: {
            n: "??"
        },
        0x0105: {
            n: "??"
        },
        0x0106: {
            n: "??"
        },
        0x0107: {
            n: "??"
        },
        0x0109: {
            n: "??"
        },
        0x010A: {
            n: "??"
        },
        0x010B: {
            n: "??"
        },
        0x010C: {
            n: "??"
        },
        0x010E: {
            n: "??"
        },
        0x010F: {
            n: "??"
        },
        0x0180: {
            n: "??"
        },
        0x0185: {
            n: "??"
        },
        0x0186: {
            n: "??"
        },
        0x0189: {
            n: "??"
        },
        0x018C: {
            n: "??"
        },
        0x0200: {
            n: "??"
        },
        0x0202: {
            n: "??"
        },
        0x0201: {
            n: "??"
        },
        0x0204: {
            n: "??"
        },
        0x0205: {
            n: "??"
        },
        0x0280: {
            n: "??"
        },
        0x0281: {
            n: "??"
        },
        0x0282: {
            n: "??"
        },
        0x0283: {
            n: "??"
        },
        0x0284: {
            n: "??"
        },
        0x0285: {
            n: "??"
        },
        0x0286: {
            n: "??"
        },
        0x0287: {
            n: "??"
        },
        0x0288: {
            n: "??"
        },
        0x0292: {
            n: "??"
        },
        0x0293: {
            n: "??"
        },
        0x0294: {
            n: "??"
        },
        0x0295: {
            n: "??"
        },
        0x0296: {
            n: "??"
        },
        0x0299: {
            n: "??"
        },
        0x029A: {
            n: "??"
        },
        0x0300: {
            n: "??"
        },
        0x0304: {
            n: "??"
        },
        0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        0x0640: {
            n: "??"
        },
        0x0642: {
            n: "??"
        },
        0x0701: {
            n: "??"
        },
        0x0702: {
            n: "??"
        },
        0x0703: {
            n: "??"
        },
        0x0704: {
            n: "??"
        },
        0x0780: {
            n: "??"
        },
        0x0800: {
            n: "??"
        },
        0x0801: {
            n: "??"
        },
        0x0804: {
            n: "??"
        },
        0x0A80: {
            n: "??"
        },
        0x2AF6: {
            n: "??"
        },
        0x3231: {
            n: "??"
        },
        0x6E49: {
            n: "??"
        },
        0x6F44: {
            n: "??"
        },
        0xFFFF: {
            n: ""
        }
    };
    /* TODO: fill out and verify this table across QP versions */ var QPWNFTable = {
        0x05: "dd-mmm-yy",
        0x06: "dd-mmm",
        0x07: "mmm-yy",
        0x08: "mm/dd/yy",
        0x0A: "hh:mm:ss AM/PM",
        0x0B: "hh:mm AM/PM",
        0x0E: "dd-mmm-yyyy",
        0x0F: "mmm-yyyy",
        /* It is suspected that the the low nybble specifies decimal places */ 0x0022: "0.00",
        0x0032: "0.00;[Red]0.00",
        0x0042: "0.00;\(0.00\)",
        0x0052: "0.00;[Red]\(0.00\)",
        0x00A2: '"$"#,##0.00;\\("$"#,##0.00\\)',
        0x0120: '0%',
        0x0130: '0E+00',
        0x0140: '# ?/?'
    };
    function parse_qpw_str(p) {
        var cch = p.read_shift(2);
        var flags = p.read_shift(1);
        /* TODO: find examples with nonzero flags */ if (flags != 0) throw "unsupported QPW string type " + flags.toString(16);
        return p.read_shift(cch, "sbcs-cont");
    }
    /* QPW uses a different set of record types */ function qpw_to_workbook_buf(d, opts) /*:Workbook*/ {
        $a1a91b25d7598376$var$prep_blob(d, 0);
        var o = opts || {};
        if ($a1a91b25d7598376$var$DENSE != null && o.dense == null) o.dense = $a1a91b25d7598376$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) s["!data"] = [];
        var SST = [], sname = "", formulae = [];
        var range = {
            s: {
                r: -1,
                c: -1
            },
            e: {
                r: -1,
                c: -1
            }
        };
        var cnt = 0, type = 0, C = 0, R = 0;
        var wb = {
            SheetNames: [],
            Sheets: {}
        };
        var FMTS = [];
        outer: while(d.l < d.length){
            var RT = d.read_shift(2), length = d.read_shift(2);
            var p = d.slice(d.l, d.l + length);
            $a1a91b25d7598376$var$prep_blob(p, 0);
            switch(RT){
                case 0x01:
                    /* BOF */ if (p.read_shift(4) != 0x39575051) throw "Bad QPW9 BOF!";
                    break;
                case 0x02:
                    break outer;
                case 0x08:
                    break; // TODO: this is tied to custom number formats
                case 0x0A:
                    var fcnt = p.read_shift(4);
                    var step = (p.length - p.l) / fcnt | 0;
                    for(var ifmt = 0; ifmt < fcnt; ++ifmt){
                        var end = p.l + step;
                        var fmt = {};
                        p.l += 2;
                        fmt.numFmtId = p.read_shift(2);
                        if (QPWNFTable[fmt.numFmtId]) fmt.z = QPWNFTable[fmt.numFmtId];
                        p.l = end;
                        FMTS.push(fmt);
                    }
                    break;
                /* TODO: The behavior here should be consistent with Numbers: QP Notebook ~ .TN.SheetArchive, QP Sheet ~ .TST.TableModelArchive */ case 0x0401:
                    break;
                case 0x0402:
                    break;
                case 0x0407:
                    p.l += 12;
                    while(p.l < p.length){
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        SST.push(p.read_shift(cnt, 'cstr'));
                    }
                    break;
                case 0x0408:
                    break;
                case 0x0601:
                    var sidx = p.read_shift(2);
                    s = {} /*:any*/ ;
                    if (o.dense) s["!data"] = [];
                    range.s.c = p.read_shift(2);
                    range.e.c = p.read_shift(2);
                    range.s.r = p.read_shift(4);
                    range.e.r = p.read_shift(4);
                    p.l += 4;
                    if (p.l + 2 < p.length) {
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        sname = cnt == 0 ? "" : p.read_shift(cnt, 'cstr');
                    }
                    if (!sname) sname = $a1a91b25d7598376$var$encode_col(sidx);
                    break;
                case 0x0602:
                    /* NOTE: QP valid range A1:IV1000000 */ if (range.s.c > 0xFF || range.s.r > 999999) break;
                    if (range.e.c < range.s.c) range.e.c = range.s.c;
                    if (range.e.r < range.s.r) range.e.r = range.s.r;
                    s["!ref"] = $a1a91b25d7598376$var$encode_range(range);
                    $a1a91b25d7598376$var$book_append_sheet(wb, s, sname); // TODO: a barrel roll
                    break;
                case 0x0A01:
                    C = p.read_shift(2);
                    if (range.e.c < C) range.e.c = C;
                    if (range.s.c > C) range.s.c = C;
                    R = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    R = p.read_shift(4);
                    if (range.e.r < R) range.e.r = R;
                    break;
                case 0x0C01:
                    R = p.read_shift(4), cnt = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    if (range.e.r < R + cnt - 1) range.e.r = R + cnt - 1;
                    var CC = $a1a91b25d7598376$var$encode_col(C);
                    while(p.l < p.length){
                        var cell = {
                            t: "z"
                        };
                        var flags = p.read_shift(1), fmtidx = -1;
                        if (flags & 0x80) fmtidx = p.read_shift(2);
                        var mul = flags & 0x40 ? p.read_shift(2) - 1 : 0;
                        switch(flags & 0x1F){
                            case 0:
                                break;
                            case 1:
                                break;
                            case 2:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2)
                                };
                                break;
                            case 3:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2, 'i')
                                };
                                break;
                            case 4:
                                cell = {
                                    t: "n",
                                    v: $a1a91b25d7598376$var$parse_RkNumber(p)
                                };
                                break;
                            case 5:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                break;
                            case 7:
                                cell = {
                                    t: "s",
                                    v: SST[type = p.read_shift(4) - 1]
                                };
                                break;
                            case 8:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                p.l += 2; /* cell.f = formulae[p.read_shift(4)]; */ 
                                p.l += 4;
                                if (isNaN(cell.v)) cell = {
                                    t: "e",
                                    v: 0x0F
                                }; // #VALUE!
                                break;
                            default:
                                throw "Unrecognized QPW cell type " + (flags & 0x1F);
                        }
                        if (fmtidx != -1 && (FMTS[fmtidx - 1] || {}).z) cell.z = FMTS[fmtidx - 1].z;
                        var delta = 0;
                        if (flags & 0x20) switch(flags & 0x1F){
                            case 2:
                                delta = p.read_shift(2);
                                break;
                            case 3:
                                delta = p.read_shift(2, 'i');
                                break;
                            case 7:
                                delta = p.read_shift(2);
                                break;
                            default:
                                throw "Unsupported delta for QPW cell type " + (flags & 0x1F);
                        }
                        if (!(!o.sheetStubs && cell.t == "z")) {
                            var newcell = $a1a91b25d7598376$var$dup(cell);
                            if (cell.t == "n" && cell.z && $a1a91b25d7598376$var$fmt_is_date(cell.z) && o.cellDates) {
                                newcell.v = $a1a91b25d7598376$var$numdate(cell.v);
                                newcell.t = typeof newcell.v == "number" ? 'n' : 'd';
                            }
                            if (s["!data"] != null) {
                                if (!s["!data"][R]) s["!data"][R] = [];
                                s["!data"][R][C] = newcell;
                            } else s[CC + $a1a91b25d7598376$var$encode_row(R)] = newcell;
                        }
                        ++R;
                        --cnt;
                        while(mul-- > 0 && cnt >= 0){
                            if (flags & 0x20) switch(flags & 0x1F){
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    break;
                                case 3:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    if (cell.v > 0x7FFF) cell.v -= 0x10000;
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = type + delta >>> 0]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply delta for QPW cell type " + (flags & 0x1F);
                            }
                            else switch(flags & 0x1F){
                                case 1:
                                    cell = {
                                        t: "z"
                                    };
                                    break;
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: p.read_shift(2)
                                    };
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = p.read_shift(4) - 1]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply repeat for QPW cell type " + (flags & 0x1F);
                            }
                            fmtidx;
                            if (!(!o.sheetStubs && cell.t == "z")) {
                                if (s["!data"] != null) {
                                    if (!s["!data"][R]) s["!data"][R] = [];
                                    s["!data"][R][C] = cell;
                                } else s[CC + $a1a91b25d7598376$var$encode_row(R)] = cell;
                            }
                            ++R;
                            --cnt;
                        }
                    }
                    break;
                case 0x0C02:
                    C = p.read_shift(2);
                    R = p.read_shift(4);
                    var str = parse_qpw_str(p);
                    /* TODO: QP10 record has an additional unknown character after the string */ if (s["!data"] != null) {
                        if (!s["!data"][R]) s["!data"][R] = [];
                        s["!data"][R][C] = {
                            t: "s",
                            v: str
                        };
                    } else s[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R)] = {
                        t: "s",
                        v: str
                    };
                    break;
                default:
                    break;
            }
            d.l += length;
        }
        return wb;
    }
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $a1a91b25d7598376$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($a1a91b25d7598376$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $a1a91b25d7598376$var$parsexmltag(m[i]);
        switch(y[0].replace(/<\w*:/g, "<")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case '<condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case '<extend':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case '<shadow':
                if (!y.val) break;
            /* falls through */ case '<shadow>':
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case '<charset':
                if (y.val == '1') break;
                font.cp = $a1a91b25d7598376$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case '<outline':
                if (!y.val) break;
            /* falls through */ case '<outline>':
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
                break;
            /* 18.4.5 rFont CT_FontName */ case '<rFont':
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                if (!y.val) break;
            /* falls through */ case '<strike>':
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                if (!y.val) break;
                switch(y.val){
                    case 'double':
                        font.uval = "double";
                        break;
                    case 'singleAccounting':
                        font.uval = "single-accounting";
                        break;
                    case 'doubleAccounting':
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case '<u>':
            case '<u/>':
                font.u = 1;
                break;
            case '</u>':
                break;
            /* 18.8.2 b */ case '<b':
                if (y.val == '0') break;
            /* falls through */ case '<b>':
            case '<b/>':
                font.b = 1;
                break;
            case '</b>':
                break;
            /* 18.8.26 i */ case '<i':
                if (y.val == '0') break;
            /* falls through */ case '<i>':
            case '<i/>':
                font.i = 1;
                break;
            case '</i>':
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case '<color':
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case '<color>':
            case '<color/>':
            case '</color>':
                break;
            /* 18.8.18 family ST_FontFamily */ case '<family':
                font.family = y.val;
                break;
            case '<family>':
            case '<family/>':
            case '</family>':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case '<vertAlign':
                font.valign = y.val;
                break;
            case '<vertAlign>':
            case '<vertAlign/>':
            case '</vertAlign>':
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case '<scheme':
                break;
            case '<scheme>':
            case '<scheme/>':
            case '</scheme>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
        }
    }
    return font;
}
var $a1a91b25d7598376$var$parse_rs = /*#__PURE__*/ function() {
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = $a1a91b25d7598376$var$str_match_xml_ns(r, "t") /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: 's',
            v: $a1a91b25d7598376$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = $a1a91b25d7598376$var$str_match_xml_ns(r, "rPr");
        if (rpr) o.s = $a1a91b25d7598376$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $a1a91b25d7598376$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, '<br/>') + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $a1a91b25d7598376$var$sitregex = /<(?:\w+:)?t\b[^<>]*>([^<]*)<\/(?:\w+:)?t>/g, $a1a91b25d7598376$var$sirregex = /<(?:\w+:)?r\b[^<>]*>/;
function $a1a91b25d7598376$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""), true);
        z.r = $a1a91b25d7598376$var$utf8read(x);
        if (html) z.h = $a1a91b25d7598376$var$escapehtml(z.t);
    } else if (/*y = */ x.match($a1a91b25d7598376$var$sirregex)) {
        z.r = $a1a91b25d7598376$var$utf8read(x);
        z.t = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(($a1a91b25d7598376$var$str_remove_xml_ns_g(x, "rPh").match($a1a91b25d7598376$var$sitregex) || []).join("").replace($a1a91b25d7598376$var$tagregex, "")), true);
        if (html) z.h = $a1a91b25d7598376$var$rs_to_html($a1a91b25d7598376$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $a1a91b25d7598376$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $a1a91b25d7598376$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $a1a91b25d7598376$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = $a1a91b25d7598376$var$str_match_xml_ns(data, "sst");
    if (sst) {
        ss = sst[1].replace($a1a91b25d7598376$var$sstr1, "").split($a1a91b25d7598376$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $a1a91b25d7598376$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $a1a91b25d7598376$var$parsexmltag(sst[0].slice(0, sst[0].indexOf(">")));
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $a1a91b25d7598376$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $a1a91b25d7598376$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o[o.length] = $a1a91b25d7598376$var$writextag('sst', null, {
        xmlns: $a1a91b25d7598376$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (typeof s.t !== "string") s.t = String(s.t);
            if (s.t.match($a1a91b25d7598376$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $a1a91b25d7598376$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = '</sst>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $a1a91b25d7598376$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $a1a91b25d7598376$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function hopper_sst(val1, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val1[0];
                s.Unique = val1[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val1);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $a1a91b25d7598376$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $a1a91b25d7598376$var$write_BrtSSTItem = $a1a91b25d7598376$var$write_RichStr;
function $a1a91b25d7598376$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_record(ba, 0x009F /* BrtBeginSst */ , $a1a91b25d7598376$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$a1a91b25d7598376$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $a1a91b25d7598376$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $a1a91b25d7598376$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $a1a91b25d7598376$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined') return $a1a91b25d7598376$var$$cptable.utils.encode($a1a91b25d7598376$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $a1a91b25d7598376$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, 'lpp4');
    o.R = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    o.U = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    o.W = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $a1a91b25d7598376$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, 'lpp4')
    });
    o.name = blob.read_shift(0, 'lpp4');
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $a1a91b25d7598376$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($a1a91b25d7598376$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $a1a91b25d7598376$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, 'lpp4'));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $a1a91b25d7598376$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, 'lpp4');
    o.name = blob.read_shift(0, 'lpp4');
    o.R = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    o.U = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    o.W = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $a1a91b25d7598376$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $a1a91b25d7598376$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, '8lpp4');
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $a1a91b25d7598376$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw 'Unrecognized encryption algorithm: ' + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, 'utf16le');
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $a1a91b25d7598376$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $a1a91b25d7598376$var$parse_EncryptionInfo(blob) {
    var vers = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $a1a91b25d7598376$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $a1a91b25d7598376$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $a1a91b25d7598376$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $a1a91b25d7598376$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $a1a91b25d7598376$var$parse_EncryptionHeader(blob, sz);
    var verifier = $a1a91b25d7598376$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $a1a91b25d7598376$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $a1a91b25d7598376$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, 'utf8');
    var o = {};
    xml.replace($a1a91b25d7598376$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<encryption':
            case '</encryption>':
                break;
            case '<keyData':
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case '<dataIntegrity':
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case '<keyEncryptors>':
            case '<keyEncryptors':
                o.encs = [];
                break;
            case '</keyEncryptors>':
                break;
            case '<keyEncryptor':
                o.uri = y.uri;
                break;
            case '</keyEncryptor>':
                break;
            case '<encryptedKey':
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $a1a91b25d7598376$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $a1a91b25d7598376$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $a1a91b25d7598376$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $a1a91b25d7598376$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $a1a91b25d7598376$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $a1a91b25d7598376$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $a1a91b25d7598376$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $a1a91b25d7598376$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $a1a91b25d7598376$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $a1a91b25d7598376$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $a1a91b25d7598376$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $a1a91b25d7598376$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $a1a91b25d7598376$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $a1a91b25d7598376$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $a1a91b25d7598376$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $a1a91b25d7598376$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $a1a91b25d7598376$var$parseuint16(blob),
        verificationBytes: $a1a91b25d7598376$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $a1a91b25d7598376$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $a1a91b25d7598376$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $a1a91b25d7598376$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $a1a91b25d7598376$var$parse_RC4Header(blob, length);
    else o.Data = $a1a91b25d7598376$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $a1a91b25d7598376$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $a1a91b25d7598376$var$parse_FilePassHeader(blob, length - 2, o);
    else $a1a91b25d7598376$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
function $a1a91b25d7598376$var$rtf_to_sheet(d, opts) {
    switch(opts.type){
        case "base64":
            return $a1a91b25d7598376$var$rtf_to_sheet_str($a1a91b25d7598376$var$Base64_decode(d), opts);
        case "binary":
            return $a1a91b25d7598376$var$rtf_to_sheet_str(d, opts);
        case "buffer":
            return $a1a91b25d7598376$var$rtf_to_sheet_str($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(d) ? d.toString("binary") : $a1a91b25d7598376$var$a2s(d), opts);
        case "array":
            return $a1a91b25d7598376$var$rtf_to_sheet_str($a1a91b25d7598376$var$cc2str(d), opts);
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $a1a91b25d7598376$var$rtf_to_sheet_str(str, opts) {
    var o = opts || {};
    var ws = {};
    var dense = o.dense;
    if (dense) ws["!data"] = [];
    var rows = $a1a91b25d7598376$var$str_match_ng(str, "\\trowd", "\\row");
    if (!rows) throw new Error("RTF missing table");
    var range = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: rows.length - 1
        }
    };
    var row = [];
    rows.forEach(function(rowtf, R) {
        if (dense) row = ws["!data"][R] = [];
        var rtfre = /\\[\w\-]+\b/g;
        var last_index = 0;
        var res;
        var C = -1;
        var payload = [];
        while((res = rtfre.exec(rowtf)) != null){
            var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
            if (data.charCodeAt(0) == 32) data = data.slice(1);
            if (data.length) payload.push(data);
            switch(res[0]){
                case "\\cell":
                    ++C;
                    if (payload.length) {
                        var cell = {
                            v: payload.join(""),
                            t: "s"
                        };
                        if (cell.v == "TRUE" || cell.v == "FALSE") {
                            cell.v = cell.v == "TRUE";
                            cell.t = "b";
                        } else if (!isNaN($a1a91b25d7598376$var$fuzzynum(cell.v))) {
                            cell.t = "n";
                            if (o.cellText !== false) cell.w = cell.v;
                            cell.v = $a1a91b25d7598376$var$fuzzynum(cell.v);
                        } else if ($a1a91b25d7598376$var$RBErr[cell.v] != null) {
                            cell.t = "e";
                            cell.w = cell.v;
                            cell.v = $a1a91b25d7598376$var$RBErr[cell.v];
                        }
                        if (dense) row[C] = cell;
                        else ws[$a1a91b25d7598376$var$encode_cell({
                            r: R,
                            c: C
                        })] = cell;
                    }
                    payload = [];
                    break;
                case "\\par":
                    payload.push("\n");
                    break;
            }
            last_index = rtfre.lastIndex;
        }
        if (C > range.e.c) range.e.c = C;
    });
    ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
    return ws;
}
function $a1a91b25d7598376$var$rtf_to_workbook(d, opts) {
    var wb = $a1a91b25d7598376$var$sheet_to_workbook($a1a91b25d7598376$var$rtf_to_sheet(d, opts), opts);
    wb.bookType = "rtf";
    return wb;
}
function $a1a91b25d7598376$var$sheet_to_rtf(ws, opts) {
    var o = [
        "{\\rtf1\\ansi"
    ];
    if (!ws["!ref"]) return o[0] + "}";
    var r = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]), cell;
    var dense = ws["!data"] != null, row = [];
    for(var R = r.s.r; R <= r.e.r; ++R){
        o.push("\\trowd\\trautofit1");
        for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
        o.push("\\pard\\intbl");
        if (dense) row = ws["!data"][R] || [];
        for(C = r.s.c; C <= r.e.c; ++C){
            var coord = $a1a91b25d7598376$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? row[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) {
                o.push(" \\cell");
                continue;
            }
            o.push(" " + (cell.w || ($a1a91b25d7598376$var$format_cell(cell), cell.w) || "").replace(/[\r\n]/g, "\\par "));
            o.push("\\cell");
        }
        o.push("\\pard\\intbl\\row");
    }
    return o.join("") + "}";
}
function $a1a91b25d7598376$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $a1a91b25d7598376$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $a1a91b25d7598376$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $a1a91b25d7598376$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $a1a91b25d7598376$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $a1a91b25d7598376$var$rgb2HSL($a1a91b25d7598376$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $a1a91b25d7598376$var$rgb2Hex($a1a91b25d7598376$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $a1a91b25d7598376$var$DEF_MDW = 6, $a1a91b25d7598376$var$MAX_MDW = 15, $a1a91b25d7598376$var$MIN_MDW = 1, $a1a91b25d7598376$var$MDW = $a1a91b25d7598376$var$DEF_MDW;
function $a1a91b25d7598376$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $a1a91b25d7598376$var$MDW) / 256) * $a1a91b25d7598376$var$MDW);
}
function $a1a91b25d7598376$var$px2char(px) {
    return Math.floor((px - 5) / $a1a91b25d7598376$var$MDW * 100 + 0.5) / 100;
}
function $a1a91b25d7598376$var$char2width(chr) {
    return Math.round((chr * $a1a91b25d7598376$var$MDW + 5) / $a1a91b25d7598376$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $a1a91b25d7598376$var$cycle_width(collw) {
    return $a1a91b25d7598376$var$char2width($a1a91b25d7598376$var$px2char($a1a91b25d7598376$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $a1a91b25d7598376$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $a1a91b25d7598376$var$cycle_width(collw)), _MDW = $a1a91b25d7598376$var$MDW;
    if (delta > 0.005) {
        for($a1a91b25d7598376$var$MDW = $a1a91b25d7598376$var$MIN_MDW; $a1a91b25d7598376$var$MDW < $a1a91b25d7598376$var$MAX_MDW; ++$a1a91b25d7598376$var$MDW)if (Math.abs(collw - $a1a91b25d7598376$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $a1a91b25d7598376$var$cycle_width(collw));
            _MDW = $a1a91b25d7598376$var$MDW;
        }
    }
    $a1a91b25d7598376$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $a1a91b25d7598376$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $a1a91b25d7598376$var$width2px(coll.width);
        coll.wch = $a1a91b25d7598376$var$px2char(coll.wpx);
        coll.MDW = $a1a91b25d7598376$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $a1a91b25d7598376$var$px2char(coll.wpx);
        coll.width = $a1a91b25d7598376$var$char2width(coll.wch);
        coll.MDW = $a1a91b25d7598376$var$MDW;
    } else if (typeof coll.wch == 'number') {
        coll.width = $a1a91b25d7598376$var$char2width(coll.wch);
        coll.wpx = $a1a91b25d7598376$var$width2px(coll.width);
        coll.MDW = $a1a91b25d7598376$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $a1a91b25d7598376$var$DEF_PPI = 96, $a1a91b25d7598376$var$PPI = $a1a91b25d7598376$var$DEF_PPI;
function $a1a91b25d7598376$var$px2pt(px) {
    return px * 96 / $a1a91b25d7598376$var$PPI;
}
function $a1a91b25d7598376$var$pt2px(pt) {
    return pt * $a1a91b25d7598376$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $a1a91b25d7598376$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $a1a91b25d7598376$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<borders':
            case '<borders>':
            case '</borders>':
                break;
            /* 18.8.4 border CT_Border */ case '<border':
            case '<border>':
            case '<border/>':
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $a1a91b25d7598376$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $a1a91b25d7598376$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case '</border>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<left/>':
                break;
            case '<left':
            case '<left>':
                break;
            case '</left>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<right/>':
                break;
            case '<right':
            case '<right>':
                break;
            case '</right>':
                break;
            /* 18.8.43 top CT_BorderPr */ case '<top/>':
                break;
            case '<top':
            case '<top>':
                break;
            case '</top>':
                break;
            /* 18.8.6 bottom CT_BorderPr */ case '<bottom/>':
                break;
            case '<bottom':
            case '<bottom>':
                break;
            case '</bottom>':
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case '<diagonal':
            case '<diagonal>':
            case '<diagonal/>':
                break;
            case '</diagonal>':
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case '<horizontal':
            case '<horizontal>':
            case '<horizontal/>':
                break;
            case '</horizontal>':
                break;
            /* 18.8.44 vertical CT_BorderPr */ case '<vertical':
            case '<vertical>':
            case '<vertical/>':
                break;
            case '</vertical>':
                break;
            /* 18.8.37 start CT_BorderPr */ case '<start':
            case '<start>':
            case '<start/>':
                break;
            case '</start>':
                break;
            /* 18.8.16 end CT_BorderPr */ case '<end':
            case '<end>':
            case '<end/>':
                break;
            case '</end>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color>':
                break;
            case '<color/>':
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $a1a91b25d7598376$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<fills':
            case '<fills>':
            case '</fills>':
                break;
            /* 18.8.20 fill CT_Fill */ case '<fill>':
            case '<fill':
            case '<fill/>':
                fill = {};
                styles.Fills.push(fill);
                break;
            case '</fill>':
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case '<gradientFill>':
                break;
            case '<gradientFill':
            case '</gradientFill>':
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case '<patternFill':
            case '<patternFill>':
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case '<patternFill/>':
            case '</patternFill>':
                break;
            /* 18.8.3 bgColor CT_Color */ case '<bgColor':
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case '<bgColor/>':
            case '</bgColor>':
                break;
            /* 18.8.19 fgColor CT_Color */ case '<fgColor':
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case '<fgColor/>':
            case '</fgColor>':
                break;
            /* 18.8.38 stop CT_GradientStop */ case '<stop':
            case '<stop/>':
                break;
            case '</stop>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color/>':
                break;
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $a1a91b25d7598376$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<fonts':
            case '<fonts>':
            case '</fonts>':
                break;
            /* 18.8.22 font CT_Font */ case '<font':
            case '<font>':
                break;
            case '</font>':
            case '<font/>':
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case '<name':
                if (y.val) font.name = $a1a91b25d7598376$var$utf8read(y.val);
                break;
            case '<name/>':
            case '</name>':
                break;
            /* 18.8.2  b CT_BooleanProperty */ case '<b':
                font.bold = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<b/>':
                font.bold = 1;
                break;
            case '</b>':
            case '</b':
                break;
            /* 18.8.26 i CT_BooleanProperty */ case '<i':
                font.italic = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<i/>':
                font.italic = 1;
                break;
            case '</i>':
            case '</i':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case '<u/>':
                font.underline = 1;
                break;
            case '</u>':
            case '</u':
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                font.strike = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
            case '</strike':
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case '<outline':
                font.outline = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
            case '</outline':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case '<shadow':
                font.shadow = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
            case '</shadow':
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case '<condense':
                font.condense = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<condense/>':
                font.condense = 1;
                break;
            case '</condense>':
            case '</condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case '<extend':
                font.extend = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<extend/>':
                font.extend = 1;
                break;
            case '</extend>':
            case '</extend':
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                if (y.val) font.sz = +y.val;
                break;
            case '<sz/>':
            case '</sz>':
            case '</sz':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case '<vertAlign':
                if (y.val) font.vertAlign = y.val;
                break;
            case '<vertAlign/>':
            case '</vertAlign>':
            case '</vertAlign':
                break;
            /* 18.8.18 family CT_FontFamily */ case '<family':
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case '<family/>':
            case '</family>':
            case '</family':
                break;
            /* 18.8.35 scheme CT_FontScheme */ case '<scheme':
                if (y.val) font.scheme = y.val;
                break;
            case '<scheme/>':
            case '</scheme>':
            case '</scheme':
                break;
            /* 18.4.1 charset CT_IntProperty */ case '<charset':
                if (y.val == '1') break;
                y.codepage = $a1a91b25d7598376$var$CS2CP[parseInt(y.val, 10)];
                break;
            case '<charset/>':
            case '</charset>':
            case '</charset':
                break;
            /* 18.?.? color CT_Color */ case '<color':
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $a1a91b25d7598376$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $a1a91b25d7598376$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $a1a91b25d7598376$var$XLSIcv[1];
                    if (!icv) icv = $a1a91b25d7598376$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $a1a91b25d7598376$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case '<color/>':
            case '</color>':
            case '</color':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                pass = true;
                break;
            case '</AlternateContent>':
            case '</AlternateContent':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $a1a91b25d7598376$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $a1a91b25d7598376$var$keys($a1a91b25d7598376$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $a1a91b25d7598376$var$table_fmt[k[i]];
    var m = t.match($a1a91b25d7598376$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $a1a91b25d7598376$var$parsexmltag(m[i]);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<numFmts':
            case '</numFmts>':
            case '<numFmts/>':
            case '<numFmts>':
                break;
            case '<numFmt':
                var f = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $a1a91b25d7598376$var$SSF__load(f, j);
                }
                break;
            case '</numFmt>':
                break;
            default:
                if (opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
        }
    }
}
function $a1a91b25d7598376$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $a1a91b25d7598376$var$writextag('numFmt', null, {
            numFmtId: i,
            formatCode: $a1a91b25d7598376$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $a1a91b25d7598376$var$writextag('numFmts', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $a1a91b25d7598376$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $a1a91b25d7598376$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $a1a91b25d7598376$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x), i = 0;
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<cellXfs':
            case '<cellXfs>':
            case '<cellXfs/>':
            case '</cellXfs>':
                break;
            /* 18.8.45 xf CT_Xf */ case '<xf':
            case '<xf/>':
            case '<xf>':
                xf = y;
                delete xf[0];
                for(i = 0; i < $a1a91b25d7598376$var$cellXF_uint.length; ++i)if (xf[$a1a91b25d7598376$var$cellXF_uint[i]]) xf[$a1a91b25d7598376$var$cellXF_uint[i]] = parseInt(xf[$a1a91b25d7598376$var$cellXF_uint[i]], 10);
                for(i = 0; i < $a1a91b25d7598376$var$cellXF_bool.length; ++i)if (xf[$a1a91b25d7598376$var$cellXF_bool[i]]) xf[$a1a91b25d7598376$var$cellXF_bool[i]] = $a1a91b25d7598376$var$parsexmlbool(xf[$a1a91b25d7598376$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case '</xf>':
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case '<alignment':
            case '<alignment/>':
            case '<alignment>':
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $a1a91b25d7598376$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case '</alignment>':
                break;
            /* 18.8.33 protection CT_CellProtection */ case '<protection':
            case '<protection>':
                break;
            case '</protection>':
            case '<protection/>':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
                }
        }
    });
}
function $a1a91b25d7598376$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $a1a91b25d7598376$var$writextag('cellXfs', null);
    cellXfs.forEach(function(c) {
        o[o.length] = $a1a91b25d7598376$var$writextag('xf', null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $a1a91b25d7598376$var$writextag('cellXfs', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $a1a91b25d7598376$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = $a1a91b25d7598376$var$remove_doctype($a1a91b25d7598376$var$str_remove_ng(data, "<!--", "-->"));
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = $a1a91b25d7598376$var$str_match_xml_ns(data, "numFmts")) $a1a91b25d7598376$var$parse_numFmts(t[0], styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = $a1a91b25d7598376$var$str_match_xml_ns(data, "fonts")) $a1a91b25d7598376$var$parse_fonts(t[0], styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = $a1a91b25d7598376$var$str_match_xml_ns(data, "fills")) $a1a91b25d7598376$var$parse_fills(t[0], styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = $a1a91b25d7598376$var$str_match_xml_ns(data, "borders")) $a1a91b25d7598376$var$parse_borders(t[0], styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = $a1a91b25d7598376$var$str_match_xml_ns(data, "cellXfs")) $a1a91b25d7598376$var$parse_cellXfs(t[0], styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $a1a91b25d7598376$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('styleSheet', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS_main[0],
            'xmlns:vt': $a1a91b25d7598376$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $a1a91b25d7598376$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $a1a91b25d7598376$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = '</styleSheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $a1a91b25d7598376$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $a1a91b25d7598376$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $a1a91b25d7598376$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $a1a91b25d7598376$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $a1a91b25d7598376$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $a1a91b25d7598376$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $a1a91b25d7598376$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $a1a91b25d7598376$var$parse_XLWideString(data, length - 21);
    return out;
}
function $a1a91b25d7598376$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $a1a91b25d7598376$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $a1a91b25d7598376$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $a1a91b25d7598376$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $a1a91b25d7598376$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $a1a91b25d7598376$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $a1a91b25d7598376$var$parse_BrtFill = $a1a91b25d7598376$var$parsenoop;
function $a1a91b25d7598376$var$write_BrtFill(fill, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(84);
    if (!$a1a91b25d7598376$var$rev_XLSBFillPTNames) $a1a91b25d7598376$var$rev_XLSBFillPTNames = $a1a91b25d7598376$var$evert($a1a91b25d7598376$var$XLSBFillPTNames);
    var fls /*:number*/  = $a1a91b25d7598376$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $a1a91b25d7598376$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $a1a91b25d7598376$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $a1a91b25d7598376$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $a1a91b25d7598376$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $a1a91b25d7598376$var$write_Blxf(data, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $a1a91b25d7598376$var$parse_BrtBorder = $a1a91b25d7598376$var$parsenoop;
function $a1a91b25d7598376$var$write_BrtBorder(border, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* top */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* bottom */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* left */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* right */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $a1a91b25d7598376$var$write_BrtStyle(style, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $a1a91b25d7598376$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $a1a91b25d7598376$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $a1a91b25d7598376$var$new_buf(2052);
    o.write_shift(4, cnt);
    $a1a91b25d7598376$var$write_XLNullableWideString(defTableStyle, o);
    $a1a91b25d7598376$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $a1a91b25d7598376$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $a1a91b25d7598376$var$table_fmt)styles.NumberFmt[y] = $a1a91b25d7598376$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function hopper_sty(val1, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val1[0]] = val1[1];
                $a1a91b25d7598376$var$SSF__load(val1[1], val1[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val1);
                if (val1.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val1.color.rgb = $a1a91b25d7598376$var$rgb_tint(themes.themeElements.clrScheme[val1.color.theme].rgb, val1.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val1);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $a1a91b25d7598376$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $a1a91b25d7598376$var$write_record(ba, 0x002C /* BrtFmt */ , $a1a91b25d7598376$var$write_BrtFmt(i, NF[i]));
    });
    $a1a91b25d7598376$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $a1a91b25d7598376$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x002B /* BrtFont */ , $a1a91b25d7598376$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $a1a91b25d7598376$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $a1a91b25d7598376$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $a1a91b25d7598376$var$write_record(ba, 0x025B /* BrtBeginFills */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x002D /* BrtFill */ , $a1a91b25d7598376$var$write_BrtFill({
        patternType: "none"
    }));
    $a1a91b25d7598376$var$write_record(ba, 0x002D /* BrtFill */ , $a1a91b25d7598376$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $a1a91b25d7598376$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $a1a91b25d7598376$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x002E /* BrtBorder */ , $a1a91b25d7598376$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $a1a91b25d7598376$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $a1a91b25d7598376$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $a1a91b25d7598376$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x002F /* BrtXF */ , $a1a91b25d7598376$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $a1a91b25d7598376$var$write_CELLXFS_bin(ba, data) {
    $a1a91b25d7598376$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $a1a91b25d7598376$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $a1a91b25d7598376$var$write_record(ba, 0x002F /* BrtXF */ , $a1a91b25d7598376$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $a1a91b25d7598376$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $a1a91b25d7598376$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x0030 /* BrtStyle */ , $a1a91b25d7598376$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $a1a91b25d7598376$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $a1a91b25d7598376$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $a1a91b25d7598376$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $a1a91b25d7598376$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $a1a91b25d7598376$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $a1a91b25d7598376$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $a1a91b25d7598376$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $a1a91b25d7598376$var$write_sty_bin(wb, opts) {
    var ba = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $a1a91b25d7598376$var$write_FMTS_bin(ba, wb.SSF);
    $a1a91b25d7598376$var$write_FONTS_bin(ba, wb);
    $a1a91b25d7598376$var$write_FILLS_bin(ba, wb);
    $a1a91b25d7598376$var$write_BORDERS_bin(ba, wb);
    $a1a91b25d7598376$var$write_CELLSTYLEXFS_bin(ba, wb);
    $a1a91b25d7598376$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $a1a91b25d7598376$var$write_STYLES_bin(ba, wb);
    $a1a91b25d7598376$var$write_DXFS_bin(ba, wb);
    $a1a91b25d7598376$var$write_TABLESTYLES_bin(ba, wb);
    $a1a91b25d7598376$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $a1a91b25d7598376$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $a1a91b25d7598376$var$XLSXThemeClrScheme = [
    '</a:lt1>',
    '</a:dk1>',
    '</a:lt2>',
    '</a:dk2>',
    '</a:accent1>',
    '</a:accent2>',
    '</a:accent3>',
    '</a:accent4>',
    '</a:accent5>',
    '</a:accent6>',
    '</a:hlink>',
    '</a:folHlink>'
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $a1a91b25d7598376$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case '<a:clrScheme':
            case '</a:clrScheme>':
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case '<a:srgbClr':
                color.rgb = y.val;
                break;
            case '</a:srgbClr>':
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case '<a:sysClr':
                color.rgb = y.lastClr;
                break;
            case '</a:sysClr>':
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case '</a:dk1>':
            case '</a:lt1>':
            case '<a:dk1>':
            case '<a:lt1>':
            case '<a:dk2>':
            case '</a:dk2>':
            case '<a:lt2>':
            case '</a:lt2>':
            case '<a:accent1>':
            case '</a:accent1>':
            case '<a:accent2>':
            case '</a:accent2>':
            case '<a:accent3>':
            case '</a:accent3>':
            case '<a:accent4>':
            case '</a:accent4>':
            case '<a:accent5>':
            case '</a:accent5>':
            case '<a:accent6>':
            case '</a:accent6>':
            case '<a:hlink>':
            case '</a:hlink>':
            case '<a:folHlink>':
            case '</a:folHlink>':
                if (y[0].charAt(1) === '/') {
                    themes.themeElements.clrScheme[$a1a91b25d7598376$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $a1a91b25d7598376$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $a1a91b25d7598376$var$parse_fmtScheme() {}
/* 20.1.6.10 themeElements CT_BaseStyles */ function $a1a91b25d7598376$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    /* clrScheme CT_ColorScheme */ if (!(t = $a1a91b25d7598376$var$str_match_xml(data, "a:clrScheme"))) throw new Error('clrScheme not found in themeElements');
    $a1a91b25d7598376$var$parse_clrScheme(t, themes, opts);
    /* fontScheme CT_FontScheme */ if (!(t = $a1a91b25d7598376$var$str_match_xml(data, "a:fontScheme"))) throw new Error('fontScheme not found in themeElements');
    $a1a91b25d7598376$var$parse_fontScheme(t, themes, opts);
    /* fmtScheme CT_StyleMatrix */ if (!(t = $a1a91b25d7598376$var$str_match_xml(data, "a:fmtScheme"))) throw new Error('fmtScheme not found in themeElements');
    $a1a91b25d7598376$var$parse_fmtScheme(t, themes, opts);
}
/* 14.2.7 Theme Part */ function $a1a91b25d7598376$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $a1a91b25d7598376$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = $a1a91b25d7598376$var$str_match_xml(data, "a:themeElements"))) throw new Error('themeElements not found in theme');
    $a1a91b25d7598376$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $a1a91b25d7598376$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = '<a:themeElements>';
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = '</a:clrScheme>';
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = '<a:majorFont>';
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:majorFont>';
    o[o.length] = '<a:minorFont>';
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:minorFont>';
    o[o.length] = '</a:fontScheme>';
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = '<a:fillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:fillStyleLst>';
    o[o.length] = '<a:lnStyleLst>';
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '</a:lnStyleLst>';
    o[o.length] = '<a:effectStyleLst>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '</a:effectStyleLst>';
    o[o.length] = '<a:bgFillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:bgFillStyleLst>';
    o[o.length] = '</a:fmtScheme>';
    o[o.length] = '</a:themeElements>';
    o[o.length] = '<a:objectDefaults>';
    o[o.length] = '<a:spDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = '</a:spDef>';
    o[o.length] = '<a:lnDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = '</a:lnDef>';
    o[o.length] = '</a:objectDefaults>';
    o[o.length] = '<a:extraClrSchemeLst/>';
    o[o.length] = '</a:theme>';
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $a1a91b25d7598376$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $a1a91b25d7598376$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $a1a91b25d7598376$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $a1a91b25d7598376$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $a1a91b25d7598376$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $a1a91b25d7598376$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $a1a91b25d7598376$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $a1a91b25d7598376$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $a1a91b25d7598376$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $a1a91b25d7598376$var$parse_IcvXF(blob, length) {
    return $a1a91b25d7598376$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $a1a91b25d7598376$var$parse_XFExtGradient(blob, length) {
    return $a1a91b25d7598376$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $a1a91b25d7598376$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $a1a91b25d7598376$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $a1a91b25d7598376$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $a1a91b25d7598376$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($a1a91b25d7598376$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $a1a91b25d7598376$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $a1a91b25d7598376$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $a1a91b25d7598376$var$parse_XLWideString(data, length - 8)
    };
}
function $a1a91b25d7598376$var$write_BrtMdtinfo(data) {
    var o = $a1a91b25d7598376$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $a1a91b25d7598376$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $a1a91b25d7598376$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $a1a91b25d7598376$var$write_BrtMdb(mdb) {
    var o = $a1a91b25d7598376$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $a1a91b25d7598376$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $a1a91b25d7598376$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $a1a91b25d7598376$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $a1a91b25d7598376$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $a1a91b25d7598376$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $a1a91b25d7598376$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $a1a91b25d7598376$var$recordhopper(data, function(val1, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val1.name
                });
                break;
            case 51:
                val1.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val1 ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $a1a91b25d7598376$var$write_xlmeta_bin() {
    var ba = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_record(ba, 332);
    $a1a91b25d7598376$var$write_record(ba, 334, $a1a91b25d7598376$var$write_UInt32LE(1));
    $a1a91b25d7598376$var$write_record(ba, 335, $a1a91b25d7598376$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $a1a91b25d7598376$var$write_record(ba, 336);
    $a1a91b25d7598376$var$write_record(ba, 339, $a1a91b25d7598376$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $a1a91b25d7598376$var$write_record(ba, 52);
    $a1a91b25d7598376$var$write_record(ba, 35, $a1a91b25d7598376$var$write_UInt32LE(514));
    $a1a91b25d7598376$var$write_record(ba, 4096, $a1a91b25d7598376$var$write_UInt32LE(0));
    $a1a91b25d7598376$var$write_record(ba, 4097, $a1a91b25d7598376$var$writeuint16(1));
    $a1a91b25d7598376$var$write_record(ba, 36);
    $a1a91b25d7598376$var$write_record(ba, 53);
    $a1a91b25d7598376$var$write_record(ba, 340);
    $a1a91b25d7598376$var$write_record(ba, 337, $a1a91b25d7598376$var$write_BrtBeginEsmdb(1, true));
    $a1a91b25d7598376$var$write_record(ba, 51, $a1a91b25d7598376$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $a1a91b25d7598376$var$write_record(ba, 338);
    $a1a91b25d7598376$var$write_record(ba, 333);
    return ba.end();
}
function $a1a91b25d7598376$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($a1a91b25d7598376$var$tagregex, function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && (opts == null ? void 0 : opts.WTF)) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $a1a91b25d7598376$var$write_xlmeta_xml() {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $a1a91b25d7598376$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch(y[0]){
            case '<?xml':
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case '<calcChain':
            case '<calcChain>':
            case '</calcChain>':
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case '<c':
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $a1a91b25d7598376$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $a1a91b25d7598376$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = '1';
    if (flags & 0x8) out.a = '1';
    return out;
}
/* 18.6 Calculation Chain */ function $a1a91b25d7598376$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function hopper_cc(val1, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val1);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $a1a91b25d7598376$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $a1a91b25d7598376$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $a1a91b25d7598376$var$recordhopper(data, function xlink_parse(val1, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $a1a91b25d7598376$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^<>]*r:id="([^<>"]*)"/) || [
        "",
        ""
    ])[1];
    return rels['!id'][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ function $a1a91b25d7598376$var$parse_vml(data /*:string*/ , sheet, comments) {
    var cidx = 0;
    ($a1a91b25d7598376$var$str_match_xml_ns_g(data, "shape") || []).forEach(function(m) {
        var type = "";
        var hidden = true;
        var aidx = -1;
        var R = -1, C = -1;
        m.replace($a1a91b25d7598376$var$tagregex, function(x /*:string*/ , idx /*:number*/ ) {
            var y = $a1a91b25d7598376$var$parsexmltag(x);
            switch($a1a91b25d7598376$var$strip_ns(y[0])){
                case '<ClientData':
                    if (y.ObjectType) type = y.ObjectType;
                    break;
                case '<Visible':
                case '<Visible/>':
                    hidden = false;
                    break;
                case '<Row':
                case '<Row>':
                    aidx = idx + x.length;
                    break;
                case '</Row>':
                    R = +m.slice(aidx, idx).trim();
                    break;
                case '<Column':
                case '<Column>':
                    aidx = idx + x.length;
                    break;
                case '</Column>':
                    C = +m.slice(aidx, idx).trim();
                    break;
            }
            return "";
        });
        switch(type){
            case 'Note':
                var cell = $a1a91b25d7598376$var$ws_get_cell_stub(sheet, R >= 0 && C >= 0 ? $a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                }) : comments[cidx].ref);
                if (cell.c) cell.c.hidden = hidden;
                ++cidx;
                break;
        }
    });
}
/* comment boxes */ function $a1a91b25d7598376$var$write_vml(rId /*:number*/ , comments, ws) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $a1a91b25d7598376$var$writextag("xml", null, {
            'xmlns:v': $a1a91b25d7598376$var$XLMLNS.v,
            'xmlns:o': $a1a91b25d7598376$var$XLMLNS.o,
            'xmlns:x': $a1a91b25d7598376$var$XLMLNS.x,
            'xmlns:mv': $a1a91b25d7598376$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $a1a91b25d7598376$var$writextag("o:shapelayout", $a1a91b25d7598376$var$writextag("o:idmap", null, {
            'v:ext': "edit",
            'data': rId
        }), {
            'v:ext': "edit"
        })
    ];
    var _shapeid = 65536 * rId;
    var _comments = comments || [];
    if (_comments.length > 0) o.push($a1a91b25d7598376$var$writextag("v:shapetype", [
        $a1a91b25d7598376$var$writextag("v:stroke", null, {
            joinstyle: "miter"
        }),
        $a1a91b25d7598376$var$writextag("v:path", null, {
            gradientshapeok: "t",
            'o:connecttype': "rect"
        })
    ].join(""), {
        id: "_x0000_t202",
        coordsize: csize.join(","),
        'o:spt': 202,
        path: bbox
    }));
    _comments.forEach(function(x) {
        ++_shapeid;
        o.push($a1a91b25d7598376$var$write_vml_comment(x, _shapeid));
    });
    o.push('</xml>');
    return o.join("");
}
function $a1a91b25d7598376$var$write_vml_comment(x, _shapeid, ws) /*:string*/ {
    var c = $a1a91b25d7598376$var$decode_cell(x[0]);
    var fillopts = /*::(*/ {
        'color2': "#BEFF82",
        'type': "gradient"
    } /*:: :any)*/ ;
    if (fillopts.type == "gradient") fillopts.angle = "-180";
    var fillparm = fillopts.type == "gradient" ? $a1a91b25d7598376$var$writextag("o:fill", null, {
        type: "gradientUnscaled",
        'v:ext': "view"
    }) : null;
    var fillxml = $a1a91b25d7598376$var$writextag('v:fill', fillparm, fillopts);
    var shadata = {
        on: "t",
        'obscured': "t"
    } /*:any*/ ;
    return [
        '<v:shape' + $a1a91b25d7598376$var$wxt_helper({
            id: '_x0000_s' + _shapeid,
            type: "#_x0000_t202",
            style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
            fillcolor: "#ECFAD4",
            strokecolor: "#edeaa1"
        }) + '>',
        fillxml,
        $a1a91b25d7598376$var$writextag("v:shadow", null, shadata),
        $a1a91b25d7598376$var$writextag("v:path", null, {
            'o:connecttype': "none"
        }),
        '<v:textbox><div style="text-align:left"></div></v:textbox>',
        '<x:ClientData ObjectType="Note">',
        '<x:MoveWithCells/>',
        '<x:SizeWithCells/>',
        /* Part 4 19.4.2.3 Anchor (Anchor) */ $a1a91b25d7598376$var$writetag('x:Anchor', [
            c.c + 1,
            0,
            c.r + 1,
            0,
            c.c + 3,
            20,
            c.r + 5,
            20
        ].join(",")),
        $a1a91b25d7598376$var$writetag('x:AutoFill', "False"),
        $a1a91b25d7598376$var$writetag('x:Row', String(c.r)),
        $a1a91b25d7598376$var$writetag('x:Column', String(c.c)),
        x[1].hidden ? '' : '<x:Visible/>',
        '</x:ClientData>',
        '</v:shape>'
    ].join("");
}
function $a1a91b25d7598376$var$sheet_insert_comments(sheet /*:WorkSheet*/ , comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = sheet["!data"] != null;
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $a1a91b25d7598376$var$decode_cell(comment.ref);
        if (r.r < 0 || r.c < 0) return;
        if (dense) {
            if (!sheet["!data"][r.r]) sheet["!data"][r.r] = [];
            cell = sheet["!data"][r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet["!data"][r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $a1a91b25d7598376$var$encode_range(range);
            sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $a1a91b25d7598376$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = $a1a91b25d7598376$var$str_match_xml_ns(data, "authors");
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^<>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = $a1a91b25d7598376$var$str_match_xml_ns(data, "commentList");
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^<>]*>/);
        if (!cm) return;
        var y = $a1a91b25d7598376$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $a1a91b25d7598376$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = $a1a91b25d7598376$var$str_match_xml_ns(x, "text");
        var rt = !!textMatch && !!textMatch[1] && $a1a91b25d7598376$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $a1a91b25d7598376$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('comments', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $a1a91b25d7598376$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [], tcnt = 0;
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($a1a91b25d7598376$var$escapexml(c.a));
            if (c.T) ++tcnt;
            ts.push(c.t == null ? "" : $a1a91b25d7598376$var$escapexml(c.t));
        });
        if (tcnt === 0) d[1].forEach(function(c) {
            o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf($a1a91b25d7598376$var$escapexml(c.a)) + '"><text>');
            o.push($a1a91b25d7598376$var$writetag("t", c.t == null ? "" : $a1a91b25d7598376$var$escapexml(c.t)));
            o.push('</text></comment>');
        });
        else {
            if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
            /* based on Threaded Comments -> Comments projection */ o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
            var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($a1a91b25d7598376$var$writetag("t", $a1a91b25d7598376$var$escapexml(t)));
            o.push('</text></comment>');
        }
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = '</comments>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $a1a91b25d7598376$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($a1a91b25d7598376$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case '<ThreadedComments':
                break;
            case '</ThreadedComments>':
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case '<threadedComment':
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case '</threadedComment>':
                if (comment.t != null) out.push(comment);
                break;
            case '<text>':
            case '<text':
                tidx = idx + x.length;
                break;
            case '</text>':
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case '<mentions':
            case '<mentions>':
                pass = true;
                break;
            case '</mentions>':
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $a1a91b25d7598376$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('ThreadedComments', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($a1a91b25d7598376$var$writextag('threadedComment', $a1a91b25d7598376$var$writetag('text', c.t || ""), tcopts));
        });
    });
    o.push('</ThreadedComments>');
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $a1a91b25d7598376$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($a1a91b25d7598376$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.4.85 personList CT_PersonList */ case '<personList':
                break;
            case '</personList>':
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case '<person':
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case '</person>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $a1a91b25d7598376$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('personList', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS.TCMNT,
            'xmlns:x': $a1a91b25d7598376$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($a1a91b25d7598376$var$writextag('person', null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $a1a91b25d7598376$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $a1a91b25d7598376$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $a1a91b25d7598376$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $a1a91b25d7598376$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $a1a91b25d7598376$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $a1a91b25d7598376$var$parse_BrtCommentAuthor = $a1a91b25d7598376$var$parse_XLWideString;
function $a1a91b25d7598376$var$write_BrtCommentAuthor(data) {
    return $a1a91b25d7598376$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $a1a91b25d7598376$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function hopper_cmnt(val1, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val1);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val1;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val1.t;
                c.h = val1.h;
                c.r = val1.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $a1a91b25d7598376$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $a1a91b25d7598376$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $a1a91b25d7598376$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $a1a91b25d7598376$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $a1a91b25d7598376$var$write_BrtCommentAuthor(c.a));
            if (c.T && c.ID && iauthor.indexOf("tc=" + c.ID) == -1) {
                iauthor.push("tc=" + c.ID);
                $a1a91b25d7598376$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $a1a91b25d7598376$var$write_BrtCommentAuthor("tc=" + c.ID));
            }
        });
    });
    $a1a91b25d7598376$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            var _ia = -1;
            if (c.ID) _ia = iauthor.indexOf("tc=" + c.ID);
            if (_ia == -1 && comment[1][0].T && comment[1][0].ID) _ia = iauthor.indexOf("tc=" + comment[1][0].ID);
            if (_ia == -1) _ia = iauthor.indexOf(c.a);
            c.iauthor = _ia;
            var range = {
                s: $a1a91b25d7598376$var$decode_cell(comment[0]),
                e: $a1a91b25d7598376$var$decode_cell(comment[0])
            };
            $a1a91b25d7598376$var$write_record(ba, 0x027B /* BrtBeginComment */ , $a1a91b25d7598376$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $a1a91b25d7598376$var$write_record(ba, 0x027D /* BrtCommentText */ , $a1a91b25d7598376$var$write_BrtCommentText(c));
            $a1a91b25d7598376$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $a1a91b25d7598376$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $a1a91b25d7598376$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $a1a91b25d7598376$var$make_vba_xls(cfb) {
    var newcfb = $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $a1a91b25d7598376$export$9f0e51cd97c572a.write(newcfb);
}
function $a1a91b25d7598376$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/^[\/]*[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $a1a91b25d7598376$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $a1a91b25d7598376$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $a1a91b25d7598376$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $a1a91b25d7598376$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
function $a1a91b25d7598376$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
/* TODO: it will be useful to parse the function str */ var $a1a91b25d7598376$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $a1a91b25d7598376$var$encode_col(C) + (rRel ? "" : "$") + $a1a91b25d7598376$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $a1a91b25d7598376$var$crefregex = /(^|[^._A-Z0-9])(\$?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])(\$?)(\d{1,7})(?![_.\(A-Za-z0-9])/g;
try {
    $a1a91b25d7598376$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
} catch (e) {}
var $a1a91b25d7598376$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($a1a91b25d7598376$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $a1a91b25d7598376$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $a1a91b25d7598376$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = $4 == "$" ? r + 1 : r == 0 ? "" : "[" + r + "]";
            var C = $2 == "$" ? c + 1 : c == 0 ? "" : "[" + c + "]";
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $a1a91b25d7598376$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($a1a91b25d7598376$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $a1a91b25d7598376$var$encode_col($a1a91b25d7598376$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $a1a91b25d7598376$var$encode_row($a1a91b25d7598376$var$decode_row($5) + delta.r));
    });
}
function $a1a91b25d7598376$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $a1a91b25d7598376$var$decode_range(range), s = r.s, c = $a1a91b25d7598376$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $a1a91b25d7598376$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $a1a91b25d7598376$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $a1a91b25d7598376$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $a1a91b25d7598376$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $a1a91b25d7598376$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $a1a91b25d7598376$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $a1a91b25d7598376$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    var C = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $a1a91b25d7598376$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $a1a91b25d7598376$var$parse_ColRelU(blob, 2), R = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $a1a91b25d7598376$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $a1a91b25d7598376$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    var C = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $a1a91b25d7598376$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $a1a91b25d7598376$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $a1a91b25d7598376$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $a1a91b25d7598376$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $a1a91b25d7598376$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $a1a91b25d7598376$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $a1a91b25d7598376$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $a1a91b25d7598376$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $a1a91b25d7598376$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $a1a91b25d7598376$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, 'i');
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $a1a91b25d7598376$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $a1a91b25d7598376$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $a1a91b25d7598376$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $a1a91b25d7598376$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $a1a91b25d7598376$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $a1a91b25d7598376$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $a1a91b25d7598376$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $a1a91b25d7598376$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $a1a91b25d7598376$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $a1a91b25d7598376$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $a1a91b25d7598376$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $a1a91b25d7598376$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $a1a91b25d7598376$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $a1a91b25d7598376$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $a1a91b25d7598376$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $a1a91b25d7598376$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $a1a91b25d7598376$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $a1a91b25d7598376$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $a1a91b25d7598376$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $a1a91b25d7598376$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $a1a91b25d7598376$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $a1a91b25d7598376$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $a1a91b25d7598376$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $a1a91b25d7598376$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $a1a91b25d7598376$var$FtabArgc[iftab],
        $a1a91b25d7598376$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $a1a91b25d7598376$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $a1a91b25d7598376$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $a1a91b25d7598376$var$Ftab : $a1a91b25d7598376$var$Cetab)[tab[1]]
    ];
}
function $a1a91b25d7598376$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $a1a91b25d7598376$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $a1a91b25d7598376$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, 'i'),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $a1a91b25d7598376$var$parse_PtgErr(blob) {
    blob.l++;
    return $a1a91b25d7598376$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $a1a91b25d7598376$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $a1a91b25d7598376$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $a1a91b25d7598376$var$parse_PtgNum(blob) {
    blob.l++;
    return $a1a91b25d7598376$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $a1a91b25d7598376$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $a1a91b25d7598376$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val1 = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val1[0]){
        case 0x02:
            val1[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val1[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val1[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val1[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val1[0]){
        case 0x04:
            /* SerBool -- boolean */ val1[1] = $a1a91b25d7598376$var$parsebool(blob, 1) ? 'TRUE' : 'FALSE';
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val1[1] = $a1a91b25d7598376$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val1[1] = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val1[1] = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val1[0]); /* Unreachable */ 
    }
    return val1;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $a1a91b25d7598376$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $a1a91b25d7598376$var$parse_UncheckedRfX : $a1a91b25d7598376$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $a1a91b25d7598376$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $a1a91b25d7598376$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $a1a91b25d7598376$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $a1a91b25d7598376$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $a1a91b25d7598376$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $a1a91b25d7598376$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, 'i'); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $a1a91b25d7598376$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $a1a91b25d7598376$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $a1a91b25d7598376$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $a1a91b25d7598376$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $a1a91b25d7598376$var$parse_PtgMemErr = $a1a91b25d7598376$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $a1a91b25d7598376$var$parse_PtgMemNoMem = $a1a91b25d7598376$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $a1a91b25d7598376$var$parse_PtgTbl = $a1a91b25d7598376$var$parsenoop;
function $a1a91b25d7598376$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $a1a91b25d7598376$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $a1a91b25d7598376$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $a1a91b25d7598376$var$parse_PtgElfCol = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $a1a91b25d7598376$var$parse_PtgElfColS = $a1a91b25d7598376$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $a1a91b25d7598376$var$parse_PtgElfColSV = $a1a91b25d7598376$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $a1a91b25d7598376$var$parse_PtgElfColV = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $a1a91b25d7598376$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $a1a91b25d7598376$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $a1a91b25d7598376$var$parse_PtgElfRadical = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $a1a91b25d7598376$var$parse_PtgElfRadicalLel = $a1a91b25d7598376$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $a1a91b25d7598376$var$parse_PtgElfRadicalS = $a1a91b25d7598376$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $a1a91b25d7598376$var$parse_PtgElfRw = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $a1a91b25d7598376$var$parse_PtgElfRwV = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $a1a91b25d7598376$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $a1a91b25d7598376$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $a1a91b25d7598376$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $a1a91b25d7598376$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $a1a91b25d7598376$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $a1a91b25d7598376$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $a1a91b25d7598376$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $a1a91b25d7598376$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $a1a91b25d7598376$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $a1a91b25d7598376$var$PtgTypes = {
    0x01: {
        n: 'PtgExp',
        f: $a1a91b25d7598376$var$parse_PtgExp
    },
    0x02: {
        n: 'PtgTbl',
        f: $a1a91b25d7598376$var$parse_PtgTbl
    },
    0x03: {
        n: 'PtgAdd',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x04: {
        n: 'PtgSub',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x05: {
        n: 'PtgMul',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x06: {
        n: 'PtgDiv',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x07: {
        n: 'PtgPower',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x08: {
        n: 'PtgConcat',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x09: {
        n: 'PtgLt',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x0A: {
        n: 'PtgLe',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x0B: {
        n: 'PtgEq',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x0C: {
        n: 'PtgGe',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x0D: {
        n: 'PtgGt',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x0E: {
        n: 'PtgNe',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x0F: {
        n: 'PtgIsect',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x10: {
        n: 'PtgUnion',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x11: {
        n: 'PtgRange',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x12: {
        n: 'PtgUplus',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x13: {
        n: 'PtgUminus',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x14: {
        n: 'PtgPercent',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x15: {
        n: 'PtgParen',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x16: {
        n: 'PtgMissArg',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x17: {
        n: 'PtgStr',
        f: $a1a91b25d7598376$var$parse_PtgStr
    },
    0x1A: {
        n: 'PtgSheet',
        f: $a1a91b25d7598376$var$parse_PtgSheet
    },
    0x1B: {
        n: 'PtgEndSheet',
        f: $a1a91b25d7598376$var$parse_PtgEndSheet
    },
    0x1C: {
        n: 'PtgErr',
        f: $a1a91b25d7598376$var$parse_PtgErr
    },
    0x1D: {
        n: 'PtgBool',
        f: $a1a91b25d7598376$var$parse_PtgBool
    },
    0x1E: {
        n: 'PtgInt',
        f: $a1a91b25d7598376$var$parse_PtgInt
    },
    0x1F: {
        n: 'PtgNum',
        f: $a1a91b25d7598376$var$parse_PtgNum
    },
    0x20: {
        n: 'PtgArray',
        f: $a1a91b25d7598376$var$parse_PtgArray
    },
    0x21: {
        n: 'PtgFunc',
        f: $a1a91b25d7598376$var$parse_PtgFunc
    },
    0x22: {
        n: 'PtgFuncVar',
        f: $a1a91b25d7598376$var$parse_PtgFuncVar
    },
    0x23: {
        n: 'PtgName',
        f: $a1a91b25d7598376$var$parse_PtgName
    },
    0x24: {
        n: 'PtgRef',
        f: $a1a91b25d7598376$var$parse_PtgRef
    },
    0x25: {
        n: 'PtgArea',
        f: $a1a91b25d7598376$var$parse_PtgArea
    },
    0x26: {
        n: 'PtgMemArea',
        f: $a1a91b25d7598376$var$parse_PtgMemArea
    },
    0x27: {
        n: 'PtgMemErr',
        f: $a1a91b25d7598376$var$parse_PtgMemErr
    },
    0x28: {
        n: 'PtgMemNoMem',
        f: $a1a91b25d7598376$var$parse_PtgMemNoMem
    },
    0x29: {
        n: 'PtgMemFunc',
        f: $a1a91b25d7598376$var$parse_PtgMemFunc
    },
    0x2A: {
        n: 'PtgRefErr',
        f: $a1a91b25d7598376$var$parse_PtgRefErr
    },
    0x2B: {
        n: 'PtgAreaErr',
        f: $a1a91b25d7598376$var$parse_PtgAreaErr
    },
    0x2C: {
        n: 'PtgRefN',
        f: $a1a91b25d7598376$var$parse_PtgRefN
    },
    0x2D: {
        n: 'PtgAreaN',
        f: $a1a91b25d7598376$var$parse_PtgAreaN
    },
    0x2E: {
        n: 'PtgMemAreaN',
        f: $a1a91b25d7598376$var$parse_PtgMemAreaN
    },
    0x2F: {
        n: 'PtgMemNoMemN',
        f: $a1a91b25d7598376$var$parse_PtgMemNoMemN
    },
    0x39: {
        n: 'PtgNameX',
        f: $a1a91b25d7598376$var$parse_PtgNameX
    },
    0x3A: {
        n: 'PtgRef3d',
        f: $a1a91b25d7598376$var$parse_PtgRef3d
    },
    0x3B: {
        n: 'PtgArea3d',
        f: $a1a91b25d7598376$var$parse_PtgArea3d
    },
    0x3C: {
        n: 'PtgRefErr3d',
        f: $a1a91b25d7598376$var$parse_PtgRefErr3d
    },
    0x3D: {
        n: 'PtgAreaErr3d',
        f: $a1a91b25d7598376$var$parse_PtgAreaErr3d
    },
    0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $a1a91b25d7598376$var$PtgDupes = {
    0x40: 0x20,
    0x60: 0x20,
    0x41: 0x21,
    0x61: 0x21,
    0x42: 0x22,
    0x62: 0x22,
    0x43: 0x23,
    0x63: 0x23,
    0x44: 0x24,
    0x64: 0x24,
    0x45: 0x25,
    0x65: 0x25,
    0x46: 0x26,
    0x66: 0x26,
    0x47: 0x27,
    0x67: 0x27,
    0x48: 0x28,
    0x68: 0x28,
    0x49: 0x29,
    0x69: 0x29,
    0x4A: 0x2A,
    0x6A: 0x2A,
    0x4B: 0x2B,
    0x6B: 0x2B,
    0x4C: 0x2C,
    0x6C: 0x2C,
    0x4D: 0x2D,
    0x6D: 0x2D,
    0x4E: 0x2E,
    0x6E: 0x2E,
    0x4F: 0x2F,
    0x6F: 0x2F,
    0x58: 0x22,
    0x78: 0x22,
    0x59: 0x39,
    0x79: 0x39,
    0x5A: 0x3A,
    0x7A: 0x3A,
    0x5B: 0x3B,
    0x7B: 0x3B,
    0x5C: 0x3C,
    0x7C: 0x3C,
    0x5D: 0x3D,
    0x7D: 0x3D
};
var $a1a91b25d7598376$var$Ptg18 = {
    0x01: {
        n: 'PtgElfLel',
        f: $a1a91b25d7598376$var$parse_PtgElfLel
    },
    0x02: {
        n: 'PtgElfRw',
        f: $a1a91b25d7598376$var$parse_PtgElfRw
    },
    0x03: {
        n: 'PtgElfCol',
        f: $a1a91b25d7598376$var$parse_PtgElfCol
    },
    0x06: {
        n: 'PtgElfRwV',
        f: $a1a91b25d7598376$var$parse_PtgElfRwV
    },
    0x07: {
        n: 'PtgElfColV',
        f: $a1a91b25d7598376$var$parse_PtgElfColV
    },
    0x0A: {
        n: 'PtgElfRadical',
        f: $a1a91b25d7598376$var$parse_PtgElfRadical
    },
    0x0B: {
        n: 'PtgElfRadicalS',
        f: $a1a91b25d7598376$var$parse_PtgElfRadicalS
    },
    0x0D: {
        n: 'PtgElfColS',
        f: $a1a91b25d7598376$var$parse_PtgElfColS
    },
    0x0F: {
        n: 'PtgElfColSV',
        f: $a1a91b25d7598376$var$parse_PtgElfColSV
    },
    0x10: {
        n: 'PtgElfRadicalLel',
        f: $a1a91b25d7598376$var$parse_PtgElfRadicalLel
    },
    0x19: {
        n: 'PtgList',
        f: $a1a91b25d7598376$var$parse_PtgList
    },
    0x1D: {
        n: 'PtgSxName',
        f: $a1a91b25d7598376$var$parse_PtgSxName
    },
    0xFF: {}
};
var $a1a91b25d7598376$var$Ptg19 = {
    0x00: {
        n: 'PtgAttrNoop',
        f: $a1a91b25d7598376$var$parse_PtgAttrNoop
    },
    0x01: {
        n: 'PtgAttrSemi',
        f: $a1a91b25d7598376$var$parse_PtgAttrSemi
    },
    0x02: {
        n: 'PtgAttrIf',
        f: $a1a91b25d7598376$var$parse_PtgAttrIf
    },
    0x04: {
        n: 'PtgAttrChoose',
        f: $a1a91b25d7598376$var$parse_PtgAttrChoose
    },
    0x08: {
        n: 'PtgAttrGoto',
        f: $a1a91b25d7598376$var$parse_PtgAttrGoto
    },
    0x10: {
        n: 'PtgAttrSum',
        f: $a1a91b25d7598376$var$parse_PtgAttrSum
    },
    0x20: {
        n: 'PtgAttrBaxcel',
        f: $a1a91b25d7598376$var$parse_PtgAttrBaxcel
    },
    0x21: {
        n: 'PtgAttrBaxcel',
        f: $a1a91b25d7598376$var$parse_PtgAttrBaxcel
    },
    0x40: {
        n: 'PtgAttrSpace',
        f: $a1a91b25d7598376$var$parse_PtgAttrSpace
    },
    0x41: {
        n: 'PtgAttrSpaceSemi',
        f: $a1a91b25d7598376$var$parse_PtgAttrSpaceSemi
    },
    0x80: {
        n: 'PtgAttrIfError',
        f: $a1a91b25d7598376$var$parse_PtgAttrIfError
    },
    0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $a1a91b25d7598376$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $a1a91b25d7598376$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case 'PtgArray':
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $a1a91b25d7598376$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case 'PtgMemArea':
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $a1a91b25d7598376$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case 'PtgExp':
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case 'PtgList':
        /* TODO: PtgList -> PtgExtraList */ case 'PtgElfRadicalS':
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case 'PtgElfColS':
        /* TODO: PtgElfColS -> PtgExtraElf */ case 'PtgElfColSV':
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($a1a91b25d7598376$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $a1a91b25d7598376$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $a1a91b25d7598376$var$PtgTypes[id] || $a1a91b25d7598376$var$PtgTypes[$a1a91b25d7598376$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $a1a91b25d7598376$var$Ptg18 : $a1a91b25d7598376$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $a1a91b25d7598376$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $a1a91b25d7598376$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $a1a91b25d7598376$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// TODO: explore space
function $a1a91b25d7598376$var$make_3d_range(start, end) {
    var s = start.lastIndexOf("!"), e = end.lastIndexOf("!");
    if (s == -1 && e == -1) return start + ":" + end;
    if (s > 0 && e > 0 && start.slice(0, s).toLowerCase() == end.slice(0, e).toLowerCase()) return start + ":" + end.slice(e + 1);
    console.error("Cannot hydrate range", start, end);
    return start + ":" + end;
}
function $a1a91b25d7598376$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $a1a91b25d7598376$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $a1a91b25d7598376$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $a1a91b25d7598376$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $a1a91b25d7598376$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case 'PtgUminus':
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case 'PtgUplus':
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case 'PtgPercent':
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case 'PtgAdd':
            /* [MS-XLS] 2.5.198.26 */ case 'PtgConcat':
            /* [MS-XLS] 2.5.198.43 */ case 'PtgDiv':
            /* [MS-XLS] 2.5.198.45 */ case 'PtgEq':
            /* [MS-XLS] 2.5.198.56 */ case 'PtgGe':
            /* [MS-XLS] 2.5.198.64 */ case 'PtgGt':
            /* [MS-XLS] 2.5.198.65 */ case 'PtgLe':
            /* [MS-XLS] 2.5.198.68 */ case 'PtgLt':
            /* [MS-XLS] 2.5.198.69 */ case 'PtgMul':
            /* [MS-XLS] 2.5.198.75 */ case 'PtgNe':
            /* [MS-XLS] 2.5.198.78 */ case 'PtgPower':
            /* [MS-XLS] 2.5.198.82 */ case 'PtgSub':
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $a1a91b25d7598376$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $a1a91b25d7598376$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $a1a91b25d7598376$var$PtgBinOp[f[0]] + e1);
                break;
            case 'PtgIsect':
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case 'PtgUnion':
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case 'PtgRange':
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push($a1a91b25d7598376$var$make_3d_range(e2, e1));
                break;
            case 'PtgAttrChoose':
                break;
            case 'PtgAttrGoto':
                break;
            case 'PtgAttrIf':
                break;
            case 'PtgAttrIfError':
                break;
            case 'PtgRef':
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $a1a91b25d7598376$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($a1a91b25d7598376$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRefN':
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $a1a91b25d7598376$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($a1a91b25d7598376$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRef3d':
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $a1a91b25d7598376$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $a1a91b25d7598376$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $a1a91b25d7598376$var$encode_cell_xls(c, biff));
                break;
            case 'PtgFunc':
            /* [MS-XLS] 2.5.198.62 */ case 'PtgFuncVar':
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === 'User') func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case 'PtgBool':
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case 'PtgInt':
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgNum':
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case 'PtgStr':
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case 'PtgErr':
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgAreaN':
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $a1a91b25d7598376$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($a1a91b25d7598376$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea':
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $a1a91b25d7598376$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($a1a91b25d7598376$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea3d':
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $a1a91b25d7598376$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $a1a91b25d7598376$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgAttrSum':
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case 'PtgAttrBaxcel':
            /* [MS-XLS] 2.5.198.33 */ case 'PtgAttrSemi':
                break;
            case 'PtgName':
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case 'PtgNameX':
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($a1a91b25d7598376$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case 'PtgParen':
                /* [MS-XLS] 2.5.198.80 */ var lp = '(', rp = ')';
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $a1a91b25d7598376$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $a1a91b25d7598376$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $a1a91b25d7598376$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $a1a91b25d7598376$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case 'PtgRefErr':
                /* [MS-XLS] 2.5.198.86 */ stack.push('#REF!');
                break;
            case 'PtgRefErr3d':
                /* [MS-XLS] 2.5.198.87 */ stack.push('#REF!');
                break;
            case 'PtgExp':
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$a1a91b25d7598376$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$a1a91b25d7598376$var$encode_cell(c)];
                    stack.push($a1a91b25d7598376$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($a1a91b25d7598376$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case 'PtgArray':
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $a1a91b25d7598376$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case 'PtgMemArea':
                break;
            case 'PtgAttrSpace':
            /* [MS-XLS] 2.5.198.38 */ case 'PtgAttrSpaceSemi':
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case 'PtgTbl':
                break;
            case 'PtgMemErr':
                break;
            case 'PtgMissArg':
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case 'PtgAreaErr':
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case 'PtgAreaErr3d':
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case 'PtgList':
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case 'PtgMemAreaN':
            case 'PtgMemNoMemN':
            case 'PtgAttrNoop':
            case 'PtgSheet':
            case 'PtgEndSheet':
                break;
            case 'PtgMemFunc':
                break;
            case 'PtgMemNoMem':
                break;
            case 'PtgElfCol':
            /* [MS-XLS] 2.5.198.46 */ case 'PtgElfColS':
            /* [MS-XLS] 2.5.198.47 */ case 'PtgElfColSV':
            /* [MS-XLS] 2.5.198.48 */ case 'PtgElfColV':
            /* [MS-XLS] 2.5.198.49 */ case 'PtgElfLel':
            /* [MS-XLS] 2.5.198.50 */ case 'PtgElfRadical':
            /* [MS-XLS] 2.5.198.51 */ case 'PtgElfRadicalLel':
            /* [MS-XLS] 2.5.198.52 */ case 'PtgElfRadicalS':
            /* [MS-XLS] 2.5.198.53 */ case 'PtgElfRw':
            /* [MS-XLS] 2.5.198.54 */ case 'PtgElfRwV':
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case 'PtgSxName':
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error('Unrecognized Formula Token: ' + String(f));
            default:
                throw new Error('Unrecognized Formula Token: ' + String(f));
        }
        var PtgNonDisp = [
            'PtgAttrSpace',
            'PtgAttrSpaceSemi',
            'PtgAttrGoto'
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $a1a91b25d7598376$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $a1a91b25d7598376$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    if (stack[0] == "TRUE") return true;
    if (stack[0] == "FALSE") return false;
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $a1a91b25d7598376$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $a1a91b25d7598376$var$parsenoop(blob, length - 2)
    ];
    var rgce = $a1a91b25d7598376$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $a1a91b25d7598376$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $a1a91b25d7598376$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $a1a91b25d7598376$var$parsenoop(blob, length - 2)
    ];
    var rgce = $a1a91b25d7598376$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $a1a91b25d7598376$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $a1a91b25d7598376$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $a1a91b25d7598376$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $a1a91b25d7598376$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $a1a91b25d7598376$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $a1a91b25d7598376$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $a1a91b25d7598376$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $a1a91b25d7598376$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $a1a91b25d7598376$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($a1a91b25d7598376$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $a1a91b25d7598376$var$parse_Xnum(blob),
        'n'
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                's'
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                'b'
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                'e'
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                's'
            ];
    }
    return [];
}
function $a1a91b25d7598376$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $a1a91b25d7598376$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $a1a91b25d7598376$var$write_Xnum(value);
    return $a1a91b25d7598376$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $a1a91b25d7598376$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6, opts);
    var val1 = $a1a91b25d7598376$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $a1a91b25d7598376$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val1[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val1[1]
    };
}
function $a1a91b25d7598376$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $a1a91b25d7598376$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $a1a91b25d7598376$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $a1a91b25d7598376$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $a1a91b25d7598376$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $a1a91b25d7598376$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $a1a91b25d7598376$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $a1a91b25d7598376$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $a1a91b25d7598376$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $a1a91b25d7598376$var$parse_XLSBArrayParsedFormula = $a1a91b25d7598376$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $a1a91b25d7598376$var$parse_XLSBCellParsedFormula = $a1a91b25d7598376$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $a1a91b25d7598376$var$parse_XLSBNameParsedFormula = $a1a91b25d7598376$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $a1a91b25d7598376$var$parse_XLSBSharedParsedFormula = $a1a91b25d7598376$var$parse_XLSBParsedFormula;
/* Writes a PtgNum or PtgInt */ function $a1a91b25d7598376$var$write_XLSBFormulaNum(val1 /*:number*/ ) {
    if ((val1 | 0) == val1 && val1 < Math.pow(2, 16) && val1 >= 0) {
        var oint = $a1a91b25d7598376$var$new_buf(11);
        oint.write_shift(4, 3);
        oint.write_shift(1, 0x1e);
        oint.write_shift(2, val1);
        oint.write_shift(4, 0);
        return oint;
    }
    var num = $a1a91b25d7598376$var$new_buf(17);
    num.write_shift(4, 11);
    num.write_shift(1, 0x1f);
    num.write_shift(8, val1);
    num.write_shift(4, 0);
    return num;
}
/* Writes a PtgErr */ function $a1a91b25d7598376$var$write_XLSBFormulaErr(val1 /*:number*/ ) {
    var oint = $a1a91b25d7598376$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1C);
    oint.write_shift(1, val1);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgBool */ function $a1a91b25d7598376$var$write_XLSBFormulaBool(val1 /*:boolean*/ ) {
    var oint = $a1a91b25d7598376$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1D);
    oint.write_shift(1, val1 ? 1 : 0);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgStr */ function $a1a91b25d7598376$var$write_XLSBFormulaStr(val1 /*:string*/ ) {
    var preamble = $a1a91b25d7598376$var$new_buf(7);
    preamble.write_shift(4, 3 + 2 * val1.length);
    preamble.write_shift(1, 0x17);
    preamble.write_shift(2, val1.length);
    var body = $a1a91b25d7598376$var$new_buf(2 * val1.length);
    body.write_shift(2 * val1.length, val1, "utf16le");
    var postamble = $a1a91b25d7598376$var$new_buf(4);
    postamble.write_shift(4, 0);
    return $a1a91b25d7598376$var$bconcat([
        preamble,
        body,
        postamble
    ]);
}
/* Writes a PtgRef */ function $a1a91b25d7598376$var$write_XLSBFormulaRef(str) {
    var cell = $a1a91b25d7598376$var$decode_cell(str);
    var out = $a1a91b25d7598376$var$new_buf(15);
    out.write_shift(4, 7);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRef3d */ function $a1a91b25d7598376$var$write_XLSBFormulaRef3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    var cell = $a1a91b25d7598376$var$decode_cell(str);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $a1a91b25d7598376$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRefErr3d */ function $a1a91b25d7598376$var$write_XLSBFormulaRefErr3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $a1a91b25d7598376$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 60);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, 0);
    out.write_shift(2, 0); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a single sheet range [PtgRef PtgRef PtgRange] */ function $a1a91b25d7598376$var$write_XLSBFormulaRange(_str) {
    var parts = _str.split(":"), str = parts[0];
    var out = $a1a91b25d7598376$var$new_buf(23);
    out.write_shift(4, 15);
    /* start cell */ str = parts[0];
    var cell = $a1a91b25d7598376$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* end cell */ str = parts[1];
    cell = $a1a91b25d7598376$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgRef3D PtgRef3D PtgRange] */ function $a1a91b25d7598376$var$write_XLSBFormulaRangeWS(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var parts = _str.split(":");
    var out = $a1a91b25d7598376$var$new_buf(27);
    out.write_shift(4, 19);
    /* start cell */ var str = parts[0], cell = $a1a91b25d7598376$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* end cell */ str = parts[1];
    cell = $a1a91b25d7598376$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgArea3d] */ function $a1a91b25d7598376$var$write_XLSBFormulaArea3D(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var range = $a1a91b25d7598376$var$decode_range(_str);
    var out = $a1a91b25d7598376$var$new_buf(23);
    out.write_shift(4, 15);
    out.write_shift(1, 59);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, range.s.r);
    out.write_shift(4, range.e.r);
    out.write_shift(2, range.s.c);
    out.write_shift(2, range.e.c);
    out.write_shift(4, 0);
    return out;
}
/* General Formula */ function $a1a91b25d7598376$var$write_XLSBFormula(val1 /*:string|number*/ , wb) {
    if (typeof val1 == "number") return $a1a91b25d7598376$var$write_XLSBFormulaNum(val1);
    if (typeof val1 == "boolean") return $a1a91b25d7598376$var$write_XLSBFormulaBool(val1);
    if (/^#(DIV\/0!|GETTING_DATA|N\/A|NAME\?|NULL!|NUM!|REF!|VALUE!)$/.test(val1)) return $a1a91b25d7598376$var$write_XLSBFormulaErr(+$a1a91b25d7598376$var$RBErr[val1]);
    if (val1.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaRef(val1);
    if (val1.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaRange(val1);
    if (val1.match(/^#REF!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaArea3D(val1, wb);
    if (val1.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaRef3D(val1, wb);
    if (val1.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaRangeWS(val1, wb);
    if (/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!#REF!$/.test(val1)) return $a1a91b25d7598376$var$write_XLSBFormulaRefErr3D(val1, wb);
    if (/^".*"$/.test(val1)) return $a1a91b25d7598376$var$write_XLSBFormulaStr(val1);
    if (/^[+-]\d+$/.test(val1)) return $a1a91b25d7598376$var$write_XLSBFormulaNum(parseInt(val1, 10));
    throw "Formula |" + val1 + "| not supported for XLSB";
}
var $a1a91b25d7598376$var$write_XLSBNameParsedFormula = $a1a91b25d7598376$var$write_XLSBFormula;
var $a1a91b25d7598376$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $a1a91b25d7598376$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $a1a91b25d7598376$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $a1a91b25d7598376$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    f = f.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    f = f.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $a1a91b25d7598376$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($a1a91b25d7598376$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $a1a91b25d7598376$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    r = r.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    r = r.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $a1a91b25d7598376$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/!/, ".").replace(/:/, ":.");
}
var $a1a91b25d7598376$var$strs = {}; // shared strings
var $a1a91b25d7598376$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $a1a91b25d7598376$var$browser_has_Map = typeof Map !== 'undefined';
function $a1a91b25d7598376$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($a1a91b25d7598376$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $a1a91b25d7598376$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($a1a91b25d7598376$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $a1a91b25d7598376$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $a1a91b25d7598376$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $a1a91b25d7598376$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $a1a91b25d7598376$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $a1a91b25d7598376$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == 'xlml') defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $a1a91b25d7598376$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $a1a91b25d7598376$var$SSF__load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $a1a91b25d7598376$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles, date1904) {
    try {
        if (opts.cellNF) p.z = $a1a91b25d7598376$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === 'z' && !opts.cellStyles) return;
    if (p.t === 'd' && typeof p.v === 'string') p.v = $a1a91b25d7598376$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== 'z') try {
        if ($a1a91b25d7598376$var$table_fmt[fmtid] == null) $a1a91b25d7598376$var$SSF__load($a1a91b25d7598376$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === 'e') p.w = p.w || $a1a91b25d7598376$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $a1a91b25d7598376$var$SSF_general_num(p.v);
            } else if (p.t === 'd') {
                var dd = $a1a91b25d7598376$var$datenum(p.v, !!date1904);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $a1a91b25d7598376$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $a1a91b25d7598376$var$SSF_general(p.v, $a1a91b25d7598376$var$_ssfopts);
        } else if (p.t === 'd') p.w = $a1a91b25d7598376$var$SSF_format(fmtid, $a1a91b25d7598376$var$datenum(p.v, !!date1904), $a1a91b25d7598376$var$_ssfopts);
        else p.w = $a1a91b25d7598376$var$SSF_format(fmtid, p.v, $a1a91b25d7598376$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $a1a91b25d7598376$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $a1a91b25d7598376$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $a1a91b25d7598376$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws['!ref']) {
        var range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
    }
}
function $a1a91b25d7598376$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $a1a91b25d7598376$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $a1a91b25d7598376$var$encode_range(d);
}
var $a1a91b25d7598376$var$mergecregex = /<(?:\w+:)?mergeCell ref=["'][A-Z0-9:]+['"]\s*[\/]?>/g;
var $a1a91b25d7598376$var$hlinkregex = /<(?:\w+:)?hyperlink [^<>]*>/mg;
var $a1a91b25d7598376$var$dimregex = /"(\w*:\w*)"/;
var $a1a91b25d7598376$var$colregex = /<(?:\w+:)?col\b[^<>]*[\/]?>/g;
var $a1a91b25d7598376$var$afregex = /<(?:\w+:)?autoFilter[^>]*/g;
var $a1a91b25d7598376$var$marginregex = /<(?:\w+:)?pageMargins[^<>]*\/>/g;
var $a1a91b25d7598376$var$sheetprregex = /<(?:\w+:)?sheetPr\b[^<>]*?\/>/;
/* 18.3 Worksheets */ function $a1a91b25d7598376$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    if ($a1a91b25d7598376$var$DENSE != null && opts.dense == null) opts.dense = $a1a91b25d7598376$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = {} /*:any*/ ;
    if (opts.dense) s["!data"] = [];
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = $a1a91b25d7598376$var$str_match_xml_ns(data, "sheetData");
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($a1a91b25d7598376$var$sheetprregex);
    if (sheetPr) $a1a91b25d7598376$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = $a1a91b25d7598376$var$str_match_xml_ns(data1, "sheetPr")) $a1a91b25d7598376$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($a1a91b25d7598376$var$dimregex);
        if (ref && !(opts && opts.nodim)) $a1a91b25d7598376$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = $a1a91b25d7598376$var$str_match_xml_ns(data1, "sheetViews");
    if (svs && svs[1]) $a1a91b25d7598376$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($a1a91b25d7598376$var$colregex);
        if (cols) $a1a91b25d7598376$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $a1a91b25d7598376$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles, wb);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($a1a91b25d7598376$var$afregex);
    if (afilter) s['!autofilter'] = $a1a91b25d7598376$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($a1a91b25d7598376$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $a1a91b25d7598376$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("=") + 2));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($a1a91b25d7598376$var$hlinkregex);
    if (hlink) $a1a91b25d7598376$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($a1a91b25d7598376$var$marginregex);
    if (margins) s['!margins'] = $a1a91b25d7598376$var$parse_ws_xml_margins($a1a91b25d7598376$var$parsexmltag(margins[0]));
    /* legacyDrawing */ var m;
    if (m = data2.match(/legacyDrawing r:id="(.*?)"/)) s['!legrel'] = m[1];
    if (opts && opts.nodim) refguess.s.c = refguess.s.r = 0;
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $a1a91b25d7598376$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $a1a91b25d7598376$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
function $a1a91b25d7598376$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $a1a91b25d7598376$var$encode_range(merges[i]) + '"/>';
    return o + '</mergeCells>';
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $a1a91b25d7598376$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $a1a91b25d7598376$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(data.codeName));
}
function $a1a91b25d7598376$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $a1a91b25d7598376$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $a1a91b25d7598376$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== 'xlsx' && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $a1a91b25d7598376$var$utf8write($a1a91b25d7598376$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $a1a91b25d7598376$var$writextag('outlinePr', null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $a1a91b25d7598376$var$writextag('sheetPr', payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $a1a91b25d7598376$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $a1a91b25d7598376$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $a1a91b25d7598376$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $a1a91b25d7598376$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $a1a91b25d7598376$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $a1a91b25d7598376$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $a1a91b25d7598376$var$writextag('sheetProtection', null, o);
}
function $a1a91b25d7598376$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = s["!data"] != null;
    for(var i = 0; i != data.length; ++i){
        var val1 = $a1a91b25d7598376$var$parsexmltag($a1a91b25d7598376$var$utf8read(data[i]), true);
        if (!val1.ref) return;
        var rel = ((rels || {})['!id'] || [])[val1.id];
        if (rel) {
            val1.Target = rel.Target;
            if (val1.location) val1.Target += "#" + $a1a91b25d7598376$var$unescapexml(val1.location);
        } else {
            val1.Target = "#" + $a1a91b25d7598376$var$unescapexml(val1.location);
            rel = {
                Target: val1.Target,
                TargetMode: 'Internal'
            };
        }
        val1.Rel = rel;
        if (val1.tooltip) {
            val1.Tooltip = val1.tooltip;
            delete val1.tooltip;
        }
        var rng = $a1a91b25d7598376$var$safe_decode_range(val1.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R);
            if (dense) {
                if (!s["!data"][R]) s["!data"][R] = [];
                if (!s["!data"][R][C]) s["!data"][R][C] = {
                    t: "z",
                    v: undefined
                };
                s["!data"][R][C].l = val1;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val1;
            }
        }
    }
}
function $a1a91b25d7598376$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $a1a91b25d7598376$var$write_ws_xml_margins(margin) /*:string*/ {
    $a1a91b25d7598376$var$default_margins(margin);
    return $a1a91b25d7598376$var$writextag('pageMargins', null, margin);
}
function $a1a91b25d7598376$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $a1a91b25d7598376$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $a1a91b25d7598376$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $a1a91b25d7598376$var$find_mdw_colw(coll.width);
        }
        $a1a91b25d7598376$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $a1a91b25d7598376$var$dup(coll);
    }
}
function $a1a91b25d7598376$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $a1a91b25d7598376$var$writextag('col', null, $a1a91b25d7598376$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $a1a91b25d7598376$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $a1a91b25d7598376$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $a1a91b25d7598376$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $a1a91b25d7598376$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $a1a91b25d7598376$var$decode_range(ws["!ref"]).e.r;
        ref = $a1a91b25d7598376$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $a1a91b25d7598376$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $a1a91b25d7598376$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $a1a91b25d7598376$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $a1a91b25d7598376$var$sviewregex = /<(?:\w:)?sheetView(?:[^<>a-z][^<>]*)?\/?>/g;
function $a1a91b25d7598376$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($a1a91b25d7598376$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $a1a91b25d7598376$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if (tag.rightToLeft && $a1a91b25d7598376$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $a1a91b25d7598376$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $a1a91b25d7598376$var$writextag("sheetViews", $a1a91b25d7598376$var$writextag("sheetView", null, sview), {});
}
function $a1a91b25d7598376$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts, idx, wb, date1904) /*:string*/ {
    if (cell.c) ws['!comments'].push([
        ref,
        cell.c
    ]);
    if ((cell.v === undefined || cell.t === "z" && !(opts || {}).sheetStubs) && typeof cell.f !== "string" && typeof cell.z == "undefined") return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'n':
            if (isNaN(cell.v)) {
                cell.t = "e";
                vv = $a1a91b25d7598376$var$BErr[cell.v = 0x24];
            } else if (!isFinite(cell.v)) {
                cell.t = "e";
                vv = $a1a91b25d7598376$var$BErr[cell.v = 0x07];
            } else vv = '' + cell.v;
            break;
        case 'e':
            vv = $a1a91b25d7598376$var$BErr[cell.v];
            break;
        case 'd':
            if (opts && opts.cellDates) {
                var _vv = $a1a91b25d7598376$var$parseDate(cell.v, date1904);
                vv = _vv.toISOString();
                if (_vv.getUTCFullYear() < 1900) vv = vv.slice(vv.indexOf("T") + 1).replace("Z", "");
            } else {
                cell = $a1a91b25d7598376$var$dup(cell);
                cell.t = 'n';
                vv = '' + (cell.v = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v, date1904), date1904));
            }
            if (typeof cell.z === 'undefined') cell.z = $a1a91b25d7598376$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = cell.t == "z" || cell.v == null ? "" : $a1a91b25d7598376$var$writetag('v', $a1a91b25d7598376$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case 'n':
            break;
        case 'd':
            o.t = "d";
            break;
        case 'b':
            o.t = "b";
            break;
        case 'e':
            o.t = "e";
            break;
        case 'z':
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $a1a91b25d7598376$var$writetag('v', '' + $a1a91b25d7598376$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            } else o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $a1a91b25d7598376$var$writextag('f', $a1a91b25d7598376$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) {
        cell.l.display = $a1a91b25d7598376$var$escapexml(vv);
        ws['!links'].push([
            ref,
            cell.l
        ]);
    }
    if (cell.D) o.cm = 1;
    return $a1a91b25d7598376$var$writextag('c', v, o);
}
var $a1a91b25d7598376$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/;
    var refregex = /ref=["']([^"']*)["']/;
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles, wb) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = s["!data"] != null;
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        var date1904 = !!((wb || {}).WBProps || {}).date1904;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $a1a91b25d7598376$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $a1a91b25d7598376$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden && $a1a91b25d7598376$var$parsexmlbool(tag.hidden)) {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $a1a91b25d7598376$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (!opts.nodim) {
                if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
                if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            }
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $a1a91b25d7598376$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden && $a1a91b25d7598376$var$parsexmlbool(tag.hidden)) {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $a1a91b25d7598376$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $a1a91b25d7598376$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = $a1a91b25d7598376$var$str_match_xml_ns(d, "v")) != null && /*::cref != null && */ cref[1] !== '') p.v = $a1a91b25d7598376$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = $a1a91b25d7598376$var$str_match_xml_ns(d, "f")) != null) {
                        if (cref[1] == "") {
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $a1a91b25d7598376$var$parsexmltag(cref[0]);
                                if (sharedf[ftag.si]) p.f = $a1a91b25d7598376$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                            }
                        } else {
                            /* TODO: match against XLSXFutureFunctions */ p.f = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(cref[1]), true);
                            if (!opts.xlfn) p.f = $a1a91b25d7598376$var$_xlfn(p.f);
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                                p.F = (d.match(refregex) || [])[1];
                                if (p.F.indexOf(":") > -1) arrayf.push([
                                    $a1a91b25d7598376$var$safe_decode_range(p.F),
                                    p.F
                                ]);
                            } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $a1a91b25d7598376$var$parsexmltag(cref[0]);
                                var ___f = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(cref[1]));
                                if (!opts.xlfn) ___f = $a1a91b25d7598376$var$_xlfn(___f);
                                sharedf[parseInt(ftag.si, 10)] = [
                                    ftag,
                                    ___f,
                                    tag.r
                                ];
                            }
                        }
                    } else if (cref = d.match(/<f[^<>]*\/>/)) {
                        ftag = $a1a91b25d7598376$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $a1a91b25d7598376$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $a1a91b25d7598376$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case 'n':
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else p.v = parseFloat(p.v);
                        break;
                    case 's':
                        if (typeof p.v == 'undefined') {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else {
                            sstr = $a1a91b25d7598376$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case 'str':
                        p.t = "s";
                        p.v = p.v != null ? $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(p.v), true) : '';
                        if (opts.cellHTML) p.h = $a1a91b25d7598376$var$escapehtml(p.v);
                        break;
                    case 'inlineStr':
                        cref = $a1a91b25d7598376$var$str_match_xml_ns(d, "is");
                        p.t = 's';
                        if (cref != null && (sstr = $a1a91b25d7598376$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case 'b':
                        p.v = $a1a91b25d7598376$var$parsexmlbool(p.v);
                        break;
                    case 'd':
                        if (opts.cellDates) p.v = $a1a91b25d7598376$var$parseDate(p.v, date1904);
                        else {
                            p.v = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(p.v, date1904), date1904);
                            p.t = 'n';
                        }
                        break;
                    /* error string in .w, number in .v */ case 'e':
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $a1a91b25d7598376$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $a1a91b25d7598376$var$safe_format(p, fmtid, fillid, opts, themes, styles, date1904);
                if (opts.cellDates && do_format && p.t == 'n' && $a1a91b25d7598376$var$fmt_is_date($a1a91b25d7598376$var$table_fmt[fmtid])) {
                    p.v = $a1a91b25d7598376$var$numdate(p.v + (date1904 ? 1462 : 0));
                    p.t = typeof p.v == "number" ? 'n' : 'd';
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == 'XLDAPR') p.D = true;
                }
                var _r;
                if (opts.nodim) {
                    _r = $a1a91b25d7598376$var$decode_cell(tag.r);
                    if (guess.s.r > _r.r) guess.s.r = _r.r;
                    if (guess.e.r < _r.r) guess.e.r = _r.r;
                }
                if (dense) {
                    _r = $a1a91b25d7598376$var$decode_cell(tag.r);
                    if (!s["!data"][_r.r]) s["!data"][_r.r] = [];
                    s["!data"][_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s['!rows'] = rows;
    };
}();
function $a1a91b25d7598376$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws['!rows'];
    var dense = ws["!data"] != null, data = dense ? ws["!data"] : [];
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $a1a91b25d7598376$var$encode_row(R);
        var data_R = dense ? data[R] : [];
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? data_R[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $a1a91b25d7598376$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb, date1904)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $a1a91b25d7598376$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $a1a91b25d7598376$var$writextag('row', r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $a1a91b25d7598376$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $a1a91b25d7598376$var$writextag('row', "", params);
        }
    }
    return o.join("");
}
function $a1a91b25d7598376$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('worksheet', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS_main[0],
            'xmlns:r': $a1a91b25d7598376$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws['!ref'] || 'A1';
    var range = $a1a91b25d7598376$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $a1a91b25d7598376$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws['!comments'] = [];
    var _drawing = [];
    $a1a91b25d7598376$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $a1a91b25d7598376$var$writextag('dimension', null, {
        'ref': ref
    });
    o[o.length] = $a1a91b25d7598376$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $a1a91b25d7598376$var$writextag('sheetFormatPr', null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || '16',
        baseColWidth: opts.sheetFormat.baseColWidth || '10',
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || '7'
    });
    if (ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_cols(ws, ws['!cols']);
    o[sidx = o.length] = '<sheetData/>';
    ws['!links'] = [];
    if (ws['!ref'] != null) {
        rdata = $a1a91b25d7598376$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = '</sheetData>';
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws['!protect']) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_protection(ws['!protect']);
    /* protectedRanges */ /* scenarios */ if (ws['!autofilter'] != null) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_merges(ws['!merges']);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws['!links']/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws['!links']/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $a1a91b25d7598376$var$add_rels(rels, -1, $a1a91b25d7598376$var$escapexml(l[1].Target).replace(/#[\s\S]*$/, ""), $a1a91b25d7598376$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $a1a91b25d7598376$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $a1a91b25d7598376$var$escapexml(l[1].Tooltip);
            rel.display = l[1].display;
            o[o.length] = $a1a91b25d7598376$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws['!links'];
    /* printOptions */ if (ws['!margins'] != null) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_margins(ws['!margins']);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $a1a91b25d7598376$var$writetag("ignoredErrors", $a1a91b25d7598376$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $a1a91b25d7598376$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $a1a91b25d7598376$var$RELS.DRAW);
        o[o.length] = $a1a91b25d7598376$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws['!drawing'] = _drawing;
    }
    if (ws['!comments'].length > 0) {
        rId = $a1a91b25d7598376$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $a1a91b25d7598376$var$RELS.VML);
        o[o.length] = $a1a91b25d7598376$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws['!legacy'] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = '</worksheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $a1a91b25d7598376$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $a1a91b25d7598376$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $a1a91b25d7598376$var$new_buf(145);
    var row = (ws['!rows'] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $a1a91b25d7598376$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    var dense = ws["!data"] != null;
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = dense ? (ws["!data"][caddr.r] || [])[caddr.c] : ws[$a1a91b25d7598376$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $a1a91b25d7598376$var$write_row_header(ba, ws, range, R) {
    var o = $a1a91b25d7598376$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws['!rows'] || [])[R]) $a1a91b25d7598376$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $a1a91b25d7598376$var$parse_BrtWsDim = $a1a91b25d7598376$var$parse_UncheckedRfX;
var $a1a91b25d7598376$var$write_BrtWsDim = $a1a91b25d7598376$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $a1a91b25d7598376$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $a1a91b25d7598376$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $a1a91b25d7598376$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $a1a91b25d7598376$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $a1a91b25d7598376$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $a1a91b25d7598376$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $a1a91b25d7598376$var$parse_BrtCellBlank(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $a1a91b25d7598376$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    return $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
}
function $a1a91b25d7598376$var$parse_BrtShortBlank(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $a1a91b25d7598376$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(4);
    return $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $a1a91b25d7598376$var$parse_BrtCellBool(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $a1a91b25d7598376$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(9);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortBool(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $a1a91b25d7598376$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(5);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $a1a91b25d7598376$var$parse_BrtCellError(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $a1a91b25d7598376$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(9);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortError(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $a1a91b25d7598376$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $a1a91b25d7598376$var$parse_BrtCellIsst(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $a1a91b25d7598376$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(12);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortIsst(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $a1a91b25d7598376$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $a1a91b25d7598376$var$parse_BrtCellReal(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var value = $a1a91b25d7598376$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $a1a91b25d7598376$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(16);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    $a1a91b25d7598376$var$write_Xnum(cell.v, o);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortReal(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var value = $a1a91b25d7598376$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $a1a91b25d7598376$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(12);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    $a1a91b25d7598376$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $a1a91b25d7598376$var$parse_BrtCellRk(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var value = $a1a91b25d7598376$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $a1a91b25d7598376$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(12);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    $a1a91b25d7598376$var$write_RkNumber(cell.v, o);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortRk(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var value = $a1a91b25d7598376$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $a1a91b25d7598376$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    $a1a91b25d7598376$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $a1a91b25d7598376$var$parse_BrtCellRString(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var value = $a1a91b25d7598376$var$parse_RichStr(data);
    return [
        cell,
        value,
        'is'
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $a1a91b25d7598376$var$parse_BrtCellSt(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var value = $a1a91b25d7598376$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $a1a91b25d7598376$var$write_BrtCellSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $a1a91b25d7598376$var$new_buf(12 + 4 * cell.v.length);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    $a1a91b25d7598376$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $a1a91b25d7598376$var$parse_BrtShortSt(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var value = $a1a91b25d7598376$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $a1a91b25d7598376$var$write_BrtShortSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8 + 4 * data.length);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    $a1a91b25d7598376$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $a1a91b25d7598376$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'b'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $a1a91b25d7598376$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $a1a91b25d7598376$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $a1a91b25d7598376$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'e'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $a1a91b25d7598376$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $a1a91b25d7598376$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $a1a91b25d7598376$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $a1a91b25d7598376$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        'n'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $a1a91b25d7598376$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $a1a91b25d7598376$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $a1a91b25d7598376$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $a1a91b25d7598376$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        'str'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $a1a91b25d7598376$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $a1a91b25d7598376$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $a1a91b25d7598376$var$parse_BrtMergeCell = $a1a91b25d7598376$var$parse_UncheckedRfX;
var $a1a91b25d7598376$var$write_BrtMergeCell = $a1a91b25d7598376$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $a1a91b25d7598376$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $a1a91b25d7598376$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $a1a91b25d7598376$var$parse_UncheckedRfX(data, 16);
    var relId = $a1a91b25d7598376$var$parse_XLNullableWideString(data);
    var loc = $a1a91b25d7598376$var$parse_XLWideString(data);
    var tooltip = $a1a91b25d7598376$var$parse_XLWideString(data);
    var display = $a1a91b25d7598376$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $a1a91b25d7598376$var$write_BrtHLink(l, rId) {
    var o = $a1a91b25d7598376$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $a1a91b25d7598376$var$write_UncheckedRfX({
        s: $a1a91b25d7598376$var$decode_cell(l[0]),
        e: $a1a91b25d7598376$var$decode_cell(l[0])
    }, o);
    $a1a91b25d7598376$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $a1a91b25d7598376$var$write_XLWideString(loc || "", o);
    $a1a91b25d7598376$var$write_XLWideString(l[1].Tooltip || "", o);
    $a1a91b25d7598376$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $a1a91b25d7598376$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $a1a91b25d7598376$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $a1a91b25d7598376$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $a1a91b25d7598376$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $a1a91b25d7598376$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $a1a91b25d7598376$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $a1a91b25d7598376$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $a1a91b25d7598376$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(18);
    var p = $a1a91b25d7598376$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == 'number') flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $a1a91b25d7598376$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $a1a91b25d7598376$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $a1a91b25d7598376$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $a1a91b25d7598376$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $a1a91b25d7598376$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(48);
    $a1a91b25d7598376$var$default_margins(margins);
    $a1a91b25d7598376$var$BrtMarginKeys.forEach(function(k) {
        $a1a91b25d7598376$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $a1a91b25d7598376$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $a1a91b25d7598376$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $a1a91b25d7598376$var$write_BrtCellIgnoreEC(ref) {
    var o = $a1a91b25d7598376$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $a1a91b25d7598376$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $a1a91b25d7598376$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(66);
    o.write_shift(2, sp.password ? $a1a91b25d7598376$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $a1a91b25d7598376$var$parse_BrtDVal() {}
function $a1a91b25d7598376$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $a1a91b25d7598376$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        '!id': {}
    };
    if ($a1a91b25d7598376$var$DENSE != null && opts.dense == null) opts.dense = $a1a91b25d7598376$var$DENSE;
    var s /*:Worksheet*/  = {};
    if (opts.dense) s["!data"] = [];
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts['!row'] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $a1a91b25d7598376$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $a1a91b25d7598376$var$parse_BrtShortReal
    };
    var cm, vm;
    var date1904 = 1462 * +!!((wb || {}).WBProps || {}).date1904;
    $a1a91b25d7598376$var$recordhopper(data, function ws_parse(val1, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val1;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val1;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $a1a91b25d7598376$var$encode_row(R = row.r);
                opts['!row'] = row.r;
                if (val1.hidden || val1.hpt || val1.level != null) {
                    if (val1.hpt) val1.hpx = $a1a91b25d7598376$var$pt2px(val1.hpt);
                    rowinfo[val1.r] = val1;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val1[2]
                } /*:any*/ ;
                switch(val1[2]){
                    case 'n':
                        p.v = val1[1];
                        break;
                    case 's':
                        sstr = $a1a91b25d7598376$var$strs[val1[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case 'b':
                        p.v = val1[1] ? true : false;
                        break;
                    case 'e':
                        p.v = val1[1];
                        if (opts.cellText !== false) p.w = $a1a91b25d7598376$var$BErr[p.v];
                        break;
                    case 'str':
                        p.t = 's';
                        p.v = val1[1];
                        break;
                    case 'is':
                        p.t = 's';
                        p.v = val1[1].t;
                        break;
                }
                if (cf = styles.CellXf[val1[0].iStyleRef]) $a1a91b25d7598376$var$safe_format(p, cf.numFmtId, null, opts, themes, styles, date1904 > 0);
                C = val1[0].c == -1 ? C + 1 : val1[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$a1a91b25d7598376$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $a1a91b25d7598376$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val1.length > 3) p.f = val1[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == 'n' && $a1a91b25d7598376$var$fmt_is_date($a1a91b25d7598376$var$table_fmt[cf.numFmtId])) {
                    var _d = $a1a91b25d7598376$var$SSF_parse_date_code(p.v + date1904);
                    if (_d) {
                        p.t = 'd';
                        p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
                    }
                }
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: 'z',
                    v: void 0
                } /*:any*/ ;
                C = val1[0].c == -1 ? C + 1 : val1[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$a1a91b25d7598376$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val1);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val1 - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels['!id'][val1.relId];
                if (rel) {
                    val1.Target = rel.Target;
                    if (val1.loc) val1.Target += "#" + val1.loc;
                    val1.Rel = rel;
                } else if (val1.relId == '') val1.Target = "#" + val1.loc;
                for(R = val1.rfx.s.r; R <= val1.rfx.e.r; ++R)for(C = val1.rfx.s.c; C <= val1.rfx.e.c; ++C)if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    if (!s["!data"][R][C]) s["!data"][R][C] = {
                        t: 'z',
                        v: undefined
                    };
                    s["!data"][R][C].l = val1;
                } else {
                    addr = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R);
                    if (!s[addr]) s[addr] = {
                        t: 'z',
                        v: undefined
                    };
                    s[addr].l = val1;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val1);
                cell = opts.dense ? s["!data"][R][C] : s[$a1a91b25d7598376$var$encode_col(C) + rr];
                cell.f = $a1a91b25d7598376$var$stringify_formula(val1[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $a1a91b25d7598376$var$encode_range(val1[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$a1a91b25d7598376$var$encode_cell(val1[0].s)] = val1[1];
                cell = opts.dense ? s["!data"][R][C] : s[$a1a91b25d7598376$var$encode_col(C) + rr];
                cell.f = $a1a91b25d7598376$var$stringify_formula(val1[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val1.e >= val1.s){
                    colinfo[val1.e--] = {
                        width: val1.w / 256,
                        hidden: !!(val1.flags & 0x01),
                        level: val1.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $a1a91b25d7598376$var$find_mdw_colw(val1.w / 256);
                    }
                    $a1a91b25d7598376$var$process_col(colinfo[val1.e + 1]);
                }
                break;
            case 0x0227:
                /* 'BrtLegacyDrawing' */ if (val1) s["!legrel"] = val1;
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s['!autofilter'] = {
                    ref: $a1a91b25d7598376$var$encode_range(val1)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s['!margins'] = val1;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val1.name) wb.Sheets[idx].CodeName = val1.name;
                if (val1.above || val1.left) s['!outline'] = {
                    above: val1.above,
                    left: val1.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val1.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts['!row'];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $a1a91b25d7598376$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $a1a91b25d7598376$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $a1a91b25d7598376$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
/* TODO: something useful -- this is a stub */ function $a1a91b25d7598376$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ , date1904 /*:boolean*/ ) /*:boolean*/ {
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    if (cell.c) ws['!comments'].push([
        $a1a91b25d7598376$var$encode_cell(o),
        cell.c
    ]);
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'd':
            cell = $a1a91b25d7598376$var$dup(cell);
            cell.z = cell.z || $a1a91b25d7598376$var$table_fmt[14];
            cell.v = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v, date1904), date1904);
            cell.t = 'n';
            break;
        /* falls through */ case 'n':
        case 'e':
            vv = '' + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    /* TODO: cell style */ o.s = $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws['!links'].push([
        $a1a91b25d7598376$var$encode_cell(o),
        cell.l
    ]);
    switch(cell.t){
        case 's':
        case 'str':
            if (opts.bookSST) {
                vv = $a1a91b25d7598376$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $a1a91b25d7598376$var$write_BrtShortIsst(cell, o));
                else $a1a91b25d7598376$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $a1a91b25d7598376$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x0011 /* BrtShortSt */ , $a1a91b25d7598376$var$write_BrtShortSt(cell, o));
                else $a1a91b25d7598376$var$write_record(ba, 0x0006 /* BrtCellSt */ , $a1a91b25d7598376$var$write_BrtCellSt(cell, o));
            }
            return true;
        case 'n':
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000D /* BrtShortRk */ , $a1a91b25d7598376$var$write_BrtShortRk(cell, o));
                else $a1a91b25d7598376$var$write_record(ba, 0x0002 /* BrtCellRk */ , $a1a91b25d7598376$var$write_BrtCellRk(cell, o));
            } else if (!isFinite(cell.v)) {
                o.t = "e";
                if (isNaN(cell.v)) {
                    if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000E /* BrtShortError */ , $a1a91b25d7598376$var$write_BrtShortError({
                        t: "e",
                        v: 0x24
                    }, o)); // #NUM!
                    else $a1a91b25d7598376$var$write_record(ba, 0x0003 /* BrtCellError */ , $a1a91b25d7598376$var$write_BrtCellError({
                        t: "e",
                        v: 0x24
                    }, o)); // #NUM!
                } else if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000E /* BrtShortError */ , $a1a91b25d7598376$var$write_BrtShortError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
                else $a1a91b25d7598376$var$write_record(ba, 0x0003 /* BrtCellError */ , $a1a91b25d7598376$var$write_BrtCellError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
            } else if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x0010 /* BrtShortReal */ , $a1a91b25d7598376$var$write_BrtShortReal(cell, o));
            else $a1a91b25d7598376$var$write_record(ba, 0x0005 /* BrtCellReal */ , $a1a91b25d7598376$var$write_BrtCellReal(cell, o));
            return true;
        case 'b':
            o.t = "b";
            if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000F /* BrtShortBool */ , $a1a91b25d7598376$var$write_BrtShortBool(cell, o));
            else $a1a91b25d7598376$var$write_record(ba, 0x0004 /* BrtCellBool */ , $a1a91b25d7598376$var$write_BrtCellBool(cell, o));
            return true;
        case 'e':
            o.t = "e";
            if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000E /* BrtShortError */ , $a1a91b25d7598376$var$write_BrtShortError(cell, o));
            else $a1a91b25d7598376$var$write_record(ba, 0x0003 /* BrtCellError */ , $a1a91b25d7598376$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000C /* BrtShortBlank */ , $a1a91b25d7598376$var$write_BrtShortBlank(cell, o));
    else $a1a91b25d7598376$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $a1a91b25d7598376$var$write_BrtCellBlank(cell, o));
    return true;
}
function $a1a91b25d7598376$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    $a1a91b25d7598376$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = ws["!data"] != null, row = dense ? ws["!data"][range.s.r] : [];
    var cap = range.e.r;
    if (ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $a1a91b25d7598376$var$encode_row(R);
        if (dense) row = ws["!data"][R];
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $a1a91b25d7598376$var$write_row_header(ba, ws, range, R);
        if (dense && !row) continue;
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $a1a91b25d7598376$var$encode_col(C);
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $a1a91b25d7598376$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen, date1904);
        }
    }
    $a1a91b25d7598376$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $a1a91b25d7598376$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!merges']) return;
    $a1a91b25d7598376$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $a1a91b25d7598376$var$write_BrtBeginMergeCells(ws['!merges'].length));
    ws['!merges'].forEach(function(m) {
        $a1a91b25d7598376$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $a1a91b25d7598376$var$write_BrtMergeCell(m));
    });
    $a1a91b25d7598376$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $a1a91b25d7598376$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws['!cols']) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws['!cols'].forEach(function(m, i) {
        if (m) $a1a91b25d7598376$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $a1a91b25d7598376$var$write_BrtColInfo(i, m));
    });
    $a1a91b25d7598376$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $a1a91b25d7598376$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!ref']) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $a1a91b25d7598376$var$write_BrtCellIgnoreEC($a1a91b25d7598376$var$safe_decode_range(ws['!ref'])));
    $a1a91b25d7598376$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $a1a91b25d7598376$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws['!links'].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $a1a91b25d7598376$var$add_rels(rels, -1, l[1].Target.replace(/#[\s\S]*$/, ""), $a1a91b25d7598376$var$RELS.HLINK);
        $a1a91b25d7598376$var$write_record(ba, 0x01EE /* BrtHLink */ , $a1a91b25d7598376$var$write_BrtHLink(l, rId));
    });
    delete ws['!links'];
}
function $a1a91b25d7598376$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws['!comments'].length > 0) {
        var rId = $a1a91b25d7598376$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $a1a91b25d7598376$var$RELS.VML);
        $a1a91b25d7598376$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $a1a91b25d7598376$var$write_RelID("rId" + rId));
        ws['!legacy'] = rId;
    }
}
function $a1a91b25d7598376$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws['!autofilter']) return;
    var data = ws['!autofilter'];
    var ref = typeof data.ref === "string" ? data.ref : $a1a91b25d7598376$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $a1a91b25d7598376$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $a1a91b25d7598376$var$decode_range(ws["!ref"]).e.r;
        ref = $a1a91b25d7598376$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $a1a91b25d7598376$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $a1a91b25d7598376$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: $a1a91b25d7598376$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $a1a91b25d7598376$var$fix_range(ref)
    });
    $a1a91b25d7598376$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $a1a91b25d7598376$var$write_UncheckedRfX($a1a91b25d7598376$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $a1a91b25d7598376$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $a1a91b25d7598376$var$write_WSVIEWS2(ba, ws, Workbook) {
    $a1a91b25d7598376$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $a1a91b25d7598376$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $a1a91b25d7598376$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $a1a91b25d7598376$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $a1a91b25d7598376$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $a1a91b25d7598376$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $a1a91b25d7598376$var$write_SHEETPROTECT(ba, ws) {
    if (!ws['!protect']) return;
    /* [BrtSheetProtectionIso] */ $a1a91b25d7598376$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $a1a91b25d7598376$var$write_BrtSheetProtection(ws['!protect']));
}
function $a1a91b25d7598376$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $a1a91b25d7598376$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $a1a91b25d7598376$var$safe_decode_range(ws['!ref'] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws['!links'] = [];
    /* passed back to write_zip and removed there */ ws['!comments'] = [];
    $a1a91b25d7598376$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws['!outline']) $a1a91b25d7598376$var$write_record(ba, 0x0093 /* BrtWsProp */ , $a1a91b25d7598376$var$write_BrtWsProp(c, ws['!outline']));
    $a1a91b25d7598376$var$write_record(ba, 0x0094 /* BrtWsDim */ , $a1a91b25d7598376$var$write_BrtWsDim(r));
    $a1a91b25d7598376$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $a1a91b25d7598376$var$write_WSFMTINFO(ba, ws);
    $a1a91b25d7598376$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $a1a91b25d7598376$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $a1a91b25d7598376$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $a1a91b25d7598376$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $a1a91b25d7598376$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $a1a91b25d7598376$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws['!margins']) $a1a91b25d7598376$var$write_record(ba, 0x01DC /* BrtMargins */ , $a1a91b25d7598376$var$write_BrtMargins(ws['!margins']));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $a1a91b25d7598376$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $a1a91b25d7598376$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $a1a91b25d7598376$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $a1a91b25d7598376$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<])<\/c:v><\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<]*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $a1a91b25d7598376$var$unescapexml(($a1a91b25d7598376$var$str_match_xml(data, "c:formatCode") || [
        "",
        "General"
    ])[1]);
    ($a1a91b25d7598376$var$str_match_ng(data, "<c:f>", "</c:f>") || []).forEach(function(F) {
        f = F.replace(/<[^<>]*>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $a1a91b25d7598376$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ ($a1a91b25d7598376$var$str_match_ng(data, "<c:numCache>", "</c:numCache>") || []).forEach(function(nc) {
        var cache = $a1a91b25d7598376$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $a1a91b25d7598376$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            if (cs["!data"]) {
                if (!cs["!data"][i]) cs["!data"][i] = [];
                cs["!data"][i][C] = {
                    t: 'n',
                    v: n,
                    z: cache[1]
                };
            } else cs[col + $a1a91b25d7598376$var$encode_row(i)] = {
                t: 'n',
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $a1a91b25d7598376$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($a1a91b25d7598376$var$sheetprregex);
    if (sheetPr) $a1a91b25d7598376$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s['!rel'] = m[1];
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
//	var o = [XML_HEADER, writextag('chartsheet', null, {
//		'xmlns': XMLNS_main[0],
//		'xmlns:r': XMLNS.r
//	})];
//	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
//	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
//	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
//	return o.join("");
//}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $a1a91b25d7598376$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $a1a91b25d7598376$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $a1a91b25d7598376$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function cs_parse(val1, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s['!rel'] = val1;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val1.name) wb.Sheets[idx].CodeName = val1.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_bin(/*::idx:number, opts, wb:Workbook, rels*/) {
//	var ba = buf_array();
//	write_record(ba, 0x0081 /* BrtBeginSheet */);
//	/* [BrtCsProp] */
//	/* CSVIEWS */
//	/* [[BrtCsProtectionIso] BrtCsProtection] */
//	/* [USERCSVIEWS] */
//	/* [BrtMargins] */
//	/* [BrtCsPageSetup] */
//	/* [HEADERFOOTER] */
//	/* BrtDrawing */
//	/* [BrtLegacyDrawing] */
//	/* [BrtLegacyDrawingHF] */
//	/* [BrtBkHim] */
//	/* [WEBPUBITEMS] */
//	/* FRTCHARTSHEET */
//	write_record(ba, 0x0082 /* BrtEndSheet */);
//	return ba.end();
//}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $a1a91b25d7598376$var$WBPropsDef = [
    [
        'allowRefreshQuery',
        false,
        "bool"
    ],
    [
        'autoCompressPictures',
        true,
        "bool"
    ],
    [
        'backupFile',
        false,
        "bool"
    ],
    [
        'checkCompatibility',
        false,
        "bool"
    ],
    [
        'CodeName',
        ''
    ],
    [
        'date1904',
        false,
        "bool"
    ],
    [
        'defaultThemeVersion',
        0,
        "int"
    ],
    [
        'filterPrivacy',
        false,
        "bool"
    ],
    [
        'hidePivotFieldList',
        false,
        "bool"
    ],
    [
        'promptedSolutions',
        false,
        "bool"
    ],
    [
        'publishItems',
        false,
        "bool"
    ],
    [
        'refreshAllConnections',
        false,
        "bool"
    ],
    [
        'saveExternalLinkValues',
        true,
        "bool"
    ],
    [
        'showBorderUnselectedTables',
        true,
        "bool"
    ],
    [
        'showInkAnnotation',
        true,
        "bool"
    ],
    [
        'showObjects',
        'all'
    ],
    [
        'showPivotChartFilter',
        false,
        "bool"
    ],
    [
        'updateLinks',
        'userSet'
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $a1a91b25d7598376$var$WBViewDef = [
    [
        'activeTab',
        0,
        "int"
    ],
    [
        'autoFilterDateGrouping',
        true,
        "bool"
    ],
    [
        'firstSheet',
        0,
        "int"
    ],
    [
        'minimized',
        false,
        "bool"
    ],
    [
        'showHorizontalScroll',
        true,
        "bool"
    ],
    [
        'showSheetTabs',
        true,
        "bool"
    ],
    [
        'showVerticalScroll',
        true,
        "bool"
    ],
    [
        'tabRatio',
        600,
        "int"
    ],
    [
        'visibility',
        'visible'
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $a1a91b25d7598376$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $a1a91b25d7598376$var$CalcPrDef = [
    [
        'calcCompleted',
        'true'
    ],
    [
        'calcMode',
        'auto'
    ],
    [
        'calcOnSave',
        'true'
    ],
    [
        'concurrentCalc',
        'true'
    ],
    [
        'fullCalcOnLoad',
        'false'
    ],
    [
        'fullPrecision',
        'true'
    ],
    [
        'iterate',
        'false'
    ],
    [
        'iterateCount',
        '100'
    ],
    [
        'iterateDelta',
        '0.001'
    ],
    [
        'refMode',
        'A1'
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $a1a91b25d7598376$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $a1a91b25d7598376$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $a1a91b25d7598376$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $a1a91b25d7598376$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $a1a91b25d7598376$var$parse_wb_defaults(wb) {
    $a1a91b25d7598376$var$push_defaults(wb.WBProps, $a1a91b25d7598376$var$WBPropsDef);
    $a1a91b25d7598376$var$push_defaults(wb.CalcPr, $a1a91b25d7598376$var$CalcPrDef);
    $a1a91b25d7598376$var$push_defaults_array(wb.WBView, $a1a91b25d7598376$var$WBViewDef);
    $a1a91b25d7598376$var$push_defaults_array(wb.Sheets, $a1a91b25d7598376$var$SheetDef);
    $a1a91b25d7598376$var$_ssfopts.date1904 = $a1a91b25d7598376$var$parsexmlbool(wb.WBProps.date1904);
}
function $a1a91b25d7598376$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $a1a91b25d7598376$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $a1a91b25d7598376$var$badchars = /*#__PURE__*/ ":][*?\/\\".split("");
function $a1a91b25d7598376$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    try {
        if (n == "") throw new Error("Sheet name cannot be blank");
        if (n.length > 31) throw new Error("Sheet name cannot exceed 31 chars");
        if (n.charCodeAt(0) == 0x27 || n.charCodeAt(n.length - 1) == 0x27) throw new Error("Sheet name cannot start or end with apostrophe (')");
        if (n.toLowerCase() == "history") throw new Error("Sheet name cannot be 'History'");
        $a1a91b25d7598376$var$badchars.forEach(function(c) {
            if (n.indexOf(c) == -1) return;
            throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        });
    } catch (e) {
        if (safe) return false;
        throw e;
    }
    return true;
}
function $a1a91b25d7598376$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $a1a91b25d7598376$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $a1a91b25d7598376$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $a1a91b25d7598376$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$a1a91b25d7598376$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
    wb.SheetNames.forEach(function(n, i) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!autofilter"]) return;
        var DN;
        if (!wb.Workbook) wb.Workbook = {};
        if (!wb.Workbook.Names) wb.Workbook.Names = [];
        wb.Workbook.Names.forEach(function(dn) {
            if (dn.Name == "_xlnm._FilterDatabase" && dn.Sheet == i) DN = dn;
        });
        var nn = $a1a91b25d7598376$var$formula_quote_sheet_name(n) + "!" + $a1a91b25d7598376$var$fix_range(ws["!autofilter"].ref);
        if (DN) DN.Ref = nn;
        else wb.Workbook.Names.push({
            Name: "_xlnm._FilterDatabase",
            Sheet: i,
            Ref: nn
        });
    });
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $a1a91b25d7598376$var$wbnsregex = /<\w+:workbook/;
function $a1a91b25d7598376$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($a1a91b25d7598376$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case '<workbook':
                if (x.match($a1a91b25d7598376$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case '</workbook>':
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case '<fileVersion':
                delete y[0];
                wb.AppVersion = y;
                break;
            case '<fileVersion/>':
            case '</fileVersion>':
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case '<fileSharing':
                break;
            case '<fileSharing/>':
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case '<workbookPr':
            case '<workbookPr/>':
                $a1a91b25d7598376$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $a1a91b25d7598376$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $a1a91b25d7598376$var$utf8read(y.codeName);
                break;
            case '</workbookPr>':
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case '<workbookProtection':
                break;
            case '<workbookProtection/>':
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case '<bookViews':
            case '<bookViews>':
            case '</bookViews>':
                break;
            /* 18.2.30   workbookView CT_BookView + */ case '<workbookView':
            case '<workbookView/>':
                delete y[0];
                wb.WBView.push(y);
                break;
            case '</workbookView>':
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case '<sheets':
            case '<sheets>':
            case '</sheets>':
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case '<sheet':
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case '</sheet>':
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case '<functionGroups':
            case '<functionGroups/>':
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case '<functionGroup':
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case '<externalReferences':
            case '</externalReferences>':
            case '<externalReferences>':
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case '<externalReference':
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case '<definedNames/>':
                break;
            case '<definedNames>':
            case '<definedNames':
                pass = true;
                break;
            case '</definedNames>':
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case '<definedName':
                dname = {};
                dname.Name = $a1a91b25d7598376$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($a1a91b25d7598376$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case '</definedName>':
                dname.Ref = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case '<definedName/>':
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case '<calcPr':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '<calcPr/>':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '</calcPr>':
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case '<oleSize':
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case '<customWorkbookViews>':
            case '</customWorkbookViews>':
            case '<customWorkbookViews':
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case '<customWorkbookView':
            case '</customWorkbookView>':
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case '<pivotCaches>':
            case '</pivotCaches>':
            case '<pivotCaches':
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case '<pivotCache':
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case '<smartTagPr':
            case '<smartTagPr/>':
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case '<smartTagTypes':
            case '<smartTagTypes>':
            case '</smartTagTypes>':
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case '<smartTagType':
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case '<webPublishing':
            case '<webPublishing/>':
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case '<fileRecoveryPr':
            case '<fileRecoveryPr/>':
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case '<webPublishObjects>':
            case '<webPublishObjects':
            case '</webPublishObjects>':
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case '<webPublishObject':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break; //TODO: check with versions of excel
            case '</ext>':
                pass = false;
                break;
            /* Others */ case '<ArchID':
                break;
            case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* TODO */ case '<revisionPtr':
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
        }
        return x;
    });
    if ($a1a91b25d7598376$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $a1a91b25d7598376$var$parse_wb_defaults(wb);
    return wb;
}
function $a1a91b25d7598376$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o[o.length] = $a1a91b25d7598376$var$writextag('workbook', null, {
        'xmlns': $a1a91b25d7598376$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        'xmlns:r': $a1a91b25d7598376$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $a1a91b25d7598376$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $a1a91b25d7598376$var$writextag('workbookPr', null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $a1a91b25d7598376$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $a1a91b25d7598376$var$writextag('sheet', null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $a1a91b25d7598376$var$writextag('definedName', $a1a91b25d7598376$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = '</workbook>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $a1a91b25d7598376$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $a1a91b25d7598376$var$parse_RelID(data, length - 8);
    z.name = $a1a91b25d7598376$var$parse_XLWideString(data);
    return z;
}
function $a1a91b25d7598376$var$write_BrtBundleSh(data, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $a1a91b25d7598376$var$write_RelID(data.strRelID, o);
    $a1a91b25d7598376$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $a1a91b25d7598376$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $a1a91b25d7598376$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $a1a91b25d7598376$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(72);
    var flags = 0;
    if (data) {
        /* TODO: mirror parse_BrtWbProp fields */ if (data.date1904) flags |= 0x01;
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $a1a91b25d7598376$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $a1a91b25d7598376$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $a1a91b25d7598376$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $a1a91b25d7598376$var$parse_XLNameWideString(data);
    var formula;
    var comment = "";
    try {
        formula = $a1a91b25d7598376$var$parse_XLSBNameParsedFormula(data, 0, opts);
        try {
            comment = $a1a91b25d7598376$var$parse_XLNullableWideString(data);
        } catch (e) {}
    } catch (e) {
        console.error("Could not parse defined name " + name);
    }
    if (flags & 0x20) name = "_xlnm." + name;
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula,
        Flags: flags
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
function $a1a91b25d7598376$var$write_BrtName(name, wb) {
    var o = $a1a91b25d7598376$var$new_buf(9);
    var flags = 0;
    var dname = name.Name;
    if ($a1a91b25d7598376$var$XLSLblBuiltIn.indexOf(dname) > -1) {
        flags |= 0x20;
        dname = dname.slice(6);
    }
    o.write_shift(4, flags); // flags
    o.write_shift(1, 0); // chKey
    o.write_shift(4, name.Sheet == null ? 0xFFFFFFFF : name.Sheet);
    var arr = [
        o,
        $a1a91b25d7598376$var$write_XLWideString(dname),
        $a1a91b25d7598376$var$write_XLSBNameParsedFormula(name.Ref, wb)
    ];
    if (name.Comment) arr.push($a1a91b25d7598376$var$write_XLNullableWideString(name.Comment));
    else {
        var x = $a1a91b25d7598376$var$new_buf(4);
        x.write_shift(4, 0xFFFFFFFF);
        arr.push(x);
    }
    // if macro (flags & 0x0F):
    // write_shift(4, 0xFFFFFFFF);
    // write_XLNullableWideString(description)
    // write_XLNullableWideString(helpTopic)
    // write_shift(4, 0xFFFFFFFF);
    return $a1a91b25d7598376$var$bconcat(arr);
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $a1a91b25d7598376$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $a1a91b25d7598376$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $a1a91b25d7598376$var$parse_BrtFRTArchID$
    };
    $a1a91b25d7598376$var$recordhopper(data, function hopper_wb(val1, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val1.name);
                wb.Sheets.push(val1);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val1;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val1.Sheet != null) opts.SID = val1.Sheet;
                val1.Ref = val1.Ptg ? $a1a91b25d7598376$var$stringify_formula(val1.Ptg, null, null, supbooks, opts) : "#REF!";
                delete opts.SID;
                delete val1.Ptg;
                Names.push(val1);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val1
                ];
                else supbooks.push([
                    RT,
                    val1
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val1);
                supbooks.XTI = supbooks.XTI.concat(val1);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $a1a91b25d7598376$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $a1a91b25d7598376$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $a1a91b25d7598376$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: 'rId' + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $a1a91b25d7598376$var$write_record(ba, 0x009C /* BrtBundleSh */ , $a1a91b25d7598376$var$write_BrtBundleSh(d));
    }
    $a1a91b25d7598376$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $a1a91b25d7598376$var$write_BrtFileVersion(data, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $a1a91b25d7598376$var$write_XLWideString("SheetJS", o);
    $a1a91b25d7598376$var$write_XLWideString($a1a91b25d7598376$var$XLSX.version, o);
    $a1a91b25d7598376$var$write_XLWideString($a1a91b25d7598376$var$XLSX.version, o);
    $a1a91b25d7598376$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $a1a91b25d7598376$var$write_BrtBookView(idx, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $a1a91b25d7598376$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $a1a91b25d7598376$var$write_record(ba, 0x009E /* BrtBookView */ , $a1a91b25d7598376$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
function $a1a91b25d7598376$var$write_BRTNAMES(ba, wb) {
    if (!wb.Workbook || !wb.Workbook.Names) return;
    wb.Workbook.Names.forEach(function(name) {
        try {
            if (name.Flags & 0x0e) return; // TODO: macro name write
            $a1a91b25d7598376$var$write_record(ba, 0x0027 /* BrtName */ , $a1a91b25d7598376$var$write_BrtName(name, wb));
        } catch (e) {
            console.error("Could not serialize defined name " + JSON.stringify(name));
        }
    });
}
function $a1a91b25d7598376$var$write_SELF_EXTERNS_xlsb(wb) {
    var L = wb.SheetNames.length;
    var o = $a1a91b25d7598376$var$new_buf(12 * L + 28);
    o.write_shift(4, L + 2);
    o.write_shift(4, 0);
    o.write_shift(4, -2);
    o.write_shift(4, -2); // workbook-level reference
    o.write_shift(4, 0);
    o.write_shift(4, -1);
    o.write_shift(4, -1); // #REF!...
    for(var i = 0; i < L; ++i){
        o.write_shift(4, 0);
        o.write_shift(4, i);
        o.write_shift(4, i);
    }
    return o;
}
function $a1a91b25d7598376$var$write_EXTERNALS_xlsb(ba, wb) {
    $a1a91b25d7598376$var$write_record(ba, 0x0161 /* BrtBeginExternals */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0165 /* BrtSupSelf */ );
    $a1a91b25d7598376$var$write_record(ba, 0x016A /* BrtExternSheet */ , $a1a91b25d7598376$var$write_SELF_EXTERNS_xlsb(wb, 0));
    $a1a91b25d7598376$var$write_record(ba, 0x0162 /* BrtEndExternals */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $a1a91b25d7598376$var$write_wb_bin(wb, opts) {
    var ba = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $a1a91b25d7598376$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $a1a91b25d7598376$var$write_record(ba, 0x0099 /* BrtWbProp */ , $a1a91b25d7598376$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $a1a91b25d7598376$var$write_BOOKVIEWS(ba, wb, opts);
    $a1a91b25d7598376$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ $a1a91b25d7598376$var$write_EXTERNALS_xlsb(ba, wb);
    if ((wb.Workbook || {}).Names) $a1a91b25d7598376$var$write_BRTNAMES(ba, wb);
    /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $a1a91b25d7598376$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $a1a91b25d7598376$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_wb_bin(data /*:any*/ , opts);
    return $a1a91b25d7598376$var$parse_wb_xml(data /*:any*/ , opts);
}
function $a1a91b25d7598376$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $a1a91b25d7598376$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $a1a91b25d7598376$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $a1a91b25d7598376$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $a1a91b25d7598376$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $a1a91b25d7598376$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $a1a91b25d7598376$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $a1a91b25d7598376$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $a1a91b25d7598376$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $a1a91b25d7598376$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $a1a91b25d7598376$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_sst_bin(data /*:any*/ , opts);
    return $a1a91b25d7598376$var$parse_sst_xml(data /*:any*/ , opts);
}
function $a1a91b25d7598376$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_comments_bin(data /*:any*/ , opts);
    return $a1a91b25d7598376$var$parse_comments_xml(data /*:any*/ , opts);
}
function $a1a91b25d7598376$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $a1a91b25d7598376$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $a1a91b25d7598376$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $a1a91b25d7598376$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $a1a91b25d7598376$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $a1a91b25d7598376$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
var $a1a91b25d7598376$var$attregexg2 = /\b((?:\w+:)?[\w]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $a1a91b25d7598376$var$attregex2 = /\b((?:\w+:)?[\w]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $a1a91b25d7598376$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($a1a91b25d7598376$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($a1a91b25d7598376$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $a1a91b25d7598376$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($a1a91b25d7598376$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($a1a91b25d7598376$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $a1a91b25d7598376$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $a1a91b25d7598376$var$xlml_format(format, value, date1904) /*:string*/ {
    var fmt = $a1a91b25d7598376$var$XLMLFormatMap[format] || $a1a91b25d7598376$var$unescapexml(format);
    if (fmt === "General") return $a1a91b25d7598376$var$SSF_general(value);
    return $a1a91b25d7598376$var$SSF_format(fmt, value, {
        date1904: !!date1904
    });
}
function $a1a91b25d7598376$var$xlml_set_custprop(Custprops, key, cp, val1 /*:string*/ ) {
    var oval /*:any*/  = val1;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $a1a91b25d7598376$var$parsexmlbool(val1);
            break;
        case "i2":
        case "int":
            oval = parseInt(val1, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val1);
            break;
        case "date":
        case "dateTime.tz":
            oval = $a1a91b25d7598376$var$parseDate(val1);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$a1a91b25d7598376$var$unescapexml(key)] = oval;
}
function $a1a91b25d7598376$var$safe_format_xlml(cell /*:Cell*/ , nf, o, date1904) {
    if (cell.t === 'z') return;
    if (!o || o.cellText !== false) try {
        if (cell.t === 'e') cell.w = cell.w || $a1a91b25d7598376$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === 'n') {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $a1a91b25d7598376$var$SSF_general_num(cell.v);
            } else cell.w = $a1a91b25d7598376$var$SSF_general(cell.v);
        } else cell.w = $a1a91b25d7598376$var$xlml_format(nf || "General", cell.v, date1904);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $a1a91b25d7598376$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == 'n' && $a1a91b25d7598376$var$fmt_is_date(z)) {
            var _d = $a1a91b25d7598376$var$SSF_parse_date_code(cell.v + (date1904 ? 1462 : 0));
            if (_d) {
                cell.t = 'd';
                cell.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $a1a91b25d7598376$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $a1a91b25d7598376$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $a1a91b25d7598376$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o, date1904) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        var ssid = styles[sid];
        if (ssid.nf) nf = ssid.nf;
        if (ssid.Interior) interiors.push(ssid.Interior);
        if (!ssid.Parent) break;
        sid = ssid.Parent;
    }
    switch(data.Type){
        case 'Boolean':
            cell.t = 'b';
            cell.v = $a1a91b25d7598376$var$parsexmlbool(xml);
            break;
        case 'String':
            cell.t = 's';
            cell.r = $a1a91b25d7598376$var$xlml_fixstr($a1a91b25d7598376$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $a1a91b25d7598376$var$unescapexml(ss || xml).replace(/<[^<>]*>/g, "") : cell.r; // todo: BR etc
            break;
        case 'DateTime':
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(xml, date1904), date1904);
            if (cell.v !== cell.v) cell.v = $a1a91b25d7598376$var$unescapexml(xml);
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case 'Number':
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = 'n';
            break;
        case 'Error':
            cell.t = 'e';
            cell.v = $a1a91b25d7598376$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = 'z';
            else {
                cell.t = 's';
                cell.v = $a1a91b25d7598376$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $a1a91b25d7598376$var$safe_format_xlml(cell, nf, o, date1904);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $a1a91b25d7598376$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $a1a91b25d7598376$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $a1a91b25d7598376$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $a1a91b25d7598376$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $a1a91b25d7598376$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $a1a91b25d7598376$var$xlml_prefix_dname(dname) {
    return $a1a91b25d7598376$var$XLSLblBuiltIn.indexOf("_xlnm." + dname) > -1 ? "_xlnm." + dname : dname;
}
function $a1a91b25d7598376$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $a1a91b25d7598376$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $a1a91b25d7598376$var$make_ssf();
    var str = $a1a91b25d7598376$var$debom($a1a91b25d7598376$var$xlml_normalize(d));
    if (opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
        if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined') str = $a1a91b25d7598376$var$$cptable.utils.decode(65001, $a1a91b25d7598376$var$char_codes(str));
        else str = $a1a91b25d7598376$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $a1a91b25d7598376$var$dup(opts);
        _o.type = "string";
        return $a1a91b25d7598376$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $a1a91b25d7598376$var$html_to_workbook(str, opts);
    $a1a91b25d7598376$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $a1a91b25d7598376$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $a1a91b25d7598376$var$table_fmt[15],
        "Short Date": $a1a91b25d7598376$var$table_fmt[14],
        "Long Time": $a1a91b25d7598376$var$table_fmt[19],
        "Medium Time": $a1a91b25d7598376$var$table_fmt[18],
        "Short Time": $a1a91b25d7598376$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $a1a91b25d7598376$var$table_fmt[2],
        "Standard": $a1a91b25d7598376$var$table_fmt[4],
        "Percent": $a1a91b25d7598376$var$table_fmt[10],
        "Scientific": $a1a91b25d7598376$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($a1a91b25d7598376$var$DENSE != null && opts.dense == null) opts.dense = $a1a91b25d7598376$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = {}, sheetname = "";
    if (opts.dense) cursheet["!data"] = [];
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $a1a91b25d7598376$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $a1a91b25d7598376$var$xlmlregex.lastIndex = 0;
    str = $a1a91b25d7598376$var$str_remove_ng(str, "<!--", "-->");
    var raw_Rn3 = "";
    while(Rn = $a1a91b25d7598376$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case 'data' /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === '/') $a1a91b25d7598376$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts, Workbook.WBProps.date1904);
            else {
                ss = "";
                dtag = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case 'cell' /*case 'Cell'*/ :
            if (Rn[1] === '/') {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== void 0) {
                    if (opts.dense) {
                        if (!cursheet["!data"][r]) cursheet["!data"][r] = [];
                        cursheet["!data"][r][c] = cell;
                    } else cursheet[$a1a91b25d7598376$var$encode_col(c) + $a1a91b25d7598376$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $a1a91b25d7598376$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    if (cc > c || rr > r) merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet["!data"][cmd]) cursheet["!data"][cmd] = [];
                                cursheet["!data"][cmd][cma] = {
                                    t: 'z'
                                };
                            } else cursheet[$a1a91b25d7598376$var$encode_col(cma) + $a1a91b25d7598376$var$encode_row(cmd)] = {
                                t: 'z'
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $a1a91b25d7598376$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case 'row' /*case 'Row'*/ :
            if (Rn[1] === '/' || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $a1a91b25d7598376$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case 'worksheet' /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                sheetname = $a1a91b25d7598376$var$unescapexml(tmp.Name);
                cursheet = {};
                if (opts.dense) cursheet["!data"] = [];
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case 'table' /*case 'Table'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case 'style' /*case 'Style'*/ :
            if (Rn[1] === '/') $a1a91b25d7598376$var$process_style_xlml(styles, stag, opts);
            else stag = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'numberformat' /*case 'NumberFormat'*/ :
            stag.nf = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($a1a91b25d7598376$var$XLMLFormatMap[stag.nf]) stag.nf = $a1a91b25d7598376$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($a1a91b25d7598376$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($a1a91b25d7598376$var$table_fmt[ssfidx] == null) {
                    $a1a91b25d7598376$var$SSF__load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case 'column' /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ 'table') break;
            if (Rn[1] === '/') break;
            csty = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $a1a91b25d7598376$var$MDW = $a1a91b25d7598376$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $a1a91b25d7598376$var$process_col(cstys[_col]);
            }
            if (seencol) $a1a91b25d7598376$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $a1a91b25d7598376$var$dup(csty);
            break;
        case 'namedrange' /*case 'NamedRange'*/ :
            if (Rn[1] === '/') break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $a1a91b25d7598376$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: $a1a91b25d7598376$var$xlml_prefix_dname(_NamedRange.Name),
                Ref: $a1a91b25d7598376$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case 'namedcell' /*case 'NamedCell'*/ :
            break;
        case 'b' /*case 'B'*/ :
            break;
        case 'i' /*case 'I'*/ :
            break;
        case 'u' /*case 'U'*/ :
            break;
        case 's' /*case 'S'*/ :
            break;
        case 'em' /*case 'EM'*/ :
            break;
        case 'h2' /*case 'H2'*/ :
            break;
        case 'h3' /*case 'H3'*/ :
            break;
        case 'sub' /*case 'Sub'*/ :
            break;
        case 'sup' /*case 'Sup'*/ :
            break;
        case 'span' /*case 'Span'*/ :
            break;
        case 'alignment' /*case 'Alignment'*/ :
            break;
        case 'borders' /*case 'Borders'*/ :
            break;
        case 'border' /*case 'Border'*/ :
            break;
        case 'font' /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case 'interior' /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'protection' /*case 'Protection'*/ :
            break;
        case 'author' /*case 'Author'*/ :
        case 'title' /*case 'Title'*/ :
        case 'description' /*case 'Description'*/ :
        case 'created' /*case 'Created'*/ :
        case 'keywords' /*case 'Keywords'*/ :
        case 'subject' /*case 'Subject'*/ :
        case 'category' /*case 'Category'*/ :
        case 'company' /*case 'Company'*/ :
        case 'lastauthor' /*case 'LastAuthor'*/ :
        case 'lastsaved' /*case 'LastSaved'*/ :
        case 'lastprinted' /*case 'LastPrinted'*/ :
        case 'version' /*case 'Version'*/ :
        case 'revision' /*case 'Revision'*/ :
        case 'totaltime' /*case 'TotalTime'*/ :
        case 'hyperlinkbase' /*case 'HyperlinkBase'*/ :
        case 'manager' /*case 'Manager'*/ :
        case 'contentstatus' /*case 'ContentStatus'*/ :
        case 'identifier' /*case 'Identifier'*/ :
        case 'language' /*case 'Language'*/ :
        case 'appname' /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $a1a91b25d7598376$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'paragraphs' /*case 'Paragraphs'*/ :
            break;
        case 'styles' /*case 'Styles'*/ :
        case 'workbook' /*case 'Workbook'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case 'comment' /*case 'Comment'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $a1a91b25d7598376$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                if (!$a1a91b25d7598376$var$parsexmlbool(tmp["ShowAlways"] || "0")) comments.hidden = true;
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case 'autofilter' /*case 'AutoFilter'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                var AutoFilter = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                cursheet['!autofilter'] = {
                    ref: $a1a91b25d7598376$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case 'name' /*case 'Name'*/ :
            break;
        case 'datavalidation' /*case 'DataValidation'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'pixelsperinch' /*case 'PixelsPerInch'*/ :
            break;
        case 'componentoptions' /*case 'ComponentOptions'*/ :
        case 'documentproperties' /*case 'DocumentProperties'*/ :
        case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/ :
        case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
        case 'pivottable' /*case 'PivotTable'*/ :
        case 'pivotcache' /*case 'PivotCache'*/ :
        case 'names' /*case 'Names'*/ :
        case 'mapinfo' /*case 'MapInfo'*/ :
        case 'pagebreaks' /*case 'PageBreaks'*/ :
        case 'querytable' /*case 'QueryTable'*/ :
        case 'sorting' /*case 'Sorting'*/ :
        case 'schema' /*case 'Schema'*/ :
        case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
        case 'smarttagtype' /*case 'SmartTagType'*/ :
        case 'smarttags' /*case 'SmartTags'*/ :
        case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
        case 'workbookoptions' /*case 'WorkbookOptions'*/ :
        case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'null' /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $a1a91b25d7598376$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $a1a91b25d7598376$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case 'allowpng' /*case 'AllowPNG'*/ :
                            break;
                        case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/ :
                            break;
                        case 'downloadcomponents' /*case 'DownloadComponents'*/ :
                            break;
                        case 'locationofcomponents' /*case 'LocationOfComponents'*/ :
                            break;
                        case 'colors' /*case 'Colors'*/ :
                            break;
                        case 'color' /*case 'Color'*/ :
                            break;
                        case 'index' /*case 'Index'*/ :
                            break;
                        case 'rgb' /*case 'RGB'*/ :
                            break;
                        case 'targetscreensize' /*case 'TargetScreenSize'*/ :
                            break;
                        case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case 'componentoptions' /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case 'toolbar' /*case 'Toolbar'*/ :
                            break;
                        case 'hideofficelogo' /*case 'HideOfficeLogo'*/ :
                            break;
                        case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case 'label' /*case 'Label'*/ :
                            break;
                        case 'caption' /*case 'Caption'*/ :
                            break;
                        case 'maxheight' /*case 'MaxHeight'*/ :
                            break;
                        case 'maxwidth' /*case 'MaxWidth'*/ :
                            break;
                        case 'nextsheetnumber' /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case 'date1904' /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case 'hidehorizontalscrollbar' /*case 'HideHorizontalScrollBar'*/ :
                            break;
                        case 'hideverticalscrollbar' /*case 'HideVerticalScrollBar'*/ :
                            break;
                        case 'hideworkbooktabs' /*case 'HideWorkbookTabs'*/ :
                            break;
                        case 'windowheight' /*case 'WindowHeight'*/ :
                            break;
                        case 'windowwidth' /*case 'WindowWidth'*/ :
                            break;
                        case 'windowtopx' /*case 'WindowTopX'*/ :
                            break;
                        case 'windowtopy' /*case 'WindowTopY'*/ :
                            break;
                        case 'tabratio' /*case 'TabRatio'*/ :
                            break;
                        case 'protectstructure' /*case 'ProtectStructure'*/ :
                            break;
                        case 'protectwindow' /*case 'ProtectWindow'*/ :
                            break;
                        case 'protectwindows' /*case 'ProtectWindows'*/ :
                            break;
                        case 'activesheet' /*case 'ActiveSheet'*/ :
                            break;
                        case 'displayinknotes' /*case 'DisplayInkNotes'*/ :
                            break;
                        case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/ :
                            break;
                        case 'supbook' /*case 'SupBook'*/ :
                            break;
                        case 'sheetname' /*case 'SheetName'*/ :
                            break;
                        case 'sheetindex' /*case 'SheetIndex'*/ :
                            break;
                        case 'sheetindexfirst' /*case 'SheetIndexFirst'*/ :
                            break;
                        case 'sheetindexlast' /*case 'SheetIndexLast'*/ :
                            break;
                        case 'dll' /*case 'Dll'*/ :
                            break;
                        case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case 'iteration' /*case 'Iteration'*/ :
                            break;
                        case 'maxiterations' /*case 'MaxIterations'*/ :
                            break;
                        case 'maxchange' /*case 'MaxChange'*/ :
                            break;
                        case 'path' /*case 'Path'*/ :
                            break;
                        case 'xct' /*case 'Xct'*/ :
                            break;
                        case 'count' /*case 'Count'*/ :
                            break;
                        case 'selectedsheets' /*case 'SelectedSheets'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        case 'uncalced' /*case 'Uncalced'*/ :
                            break;
                        case 'startupprompt' /*case 'StartupPrompt'*/ :
                            break;
                        case 'crn' /*case 'Crn'*/ :
                            break;
                        case 'externname' /*case 'ExternName'*/ :
                            break;
                        case 'formula' /*case 'Formula'*/ :
                            break;
                        case 'colfirst' /*case 'ColFirst'*/ :
                            break;
                        case 'collast' /*case 'ColLast'*/ :
                            break;
                        case 'wantadvise' /*case 'WantAdvise'*/ :
                            break;
                        case 'boolean' /*case 'Boolean'*/ :
                            break;
                        case 'error' /*case 'Error'*/ :
                            break;
                        case 'text' /*case 'Text'*/ :
                            break;
                        case 'ole' /*case 'OLE'*/ :
                            break;
                        case 'noautorecover' /*case 'NoAutoRecover'*/ :
                            break;
                        case 'publishobjects' /*case 'PublishObjects'*/ :
                            break;
                        case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'refmoder1c1' /*case 'RefModeR1C1'*/ :
                            break;
                        case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case 'workbookoptions' /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case 'owcversion' /*case 'OWCVersion'*/ :
                            break;
                        case 'height' /*case 'Height'*/ :
                            break;
                        case 'width' /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case 'visible' /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case 'header' /*case 'Header'*/ :
                            if (!cursheet['!margins']) $a1a91b25d7598376$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$a1a91b25d7598376$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +$a1a91b25d7598376$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'footer' /*case 'Footer'*/ :
                            if (!cursheet['!margins']) $a1a91b25d7598376$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$a1a91b25d7598376$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +$a1a91b25d7598376$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'pagemargins' /*case 'PageMargins'*/ :
                            var pagemargins = $a1a91b25d7598376$var$parsexmltag(Rn[0]);
                            if (!cursheet['!margins']) $a1a91b25d7598376$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
                            break;
                        case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case 'freezepanes' /*case 'FreezePanes'*/ :
                            break;
                        case 'frozennosplit' /*case 'FrozenNoSplit'*/ :
                            break;
                        case 'splithorizontal' /*case 'SplitHorizontal'*/ :
                        case 'splitvertical' /*case 'SplitVertical'*/ :
                            break;
                        case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case 'activerow' /*case 'ActiveRow'*/ :
                            break;
                        case 'activecol' /*case 'ActiveCol'*/ :
                            break;
                        case 'toprowbottompane' /*case 'TopRowBottomPane'*/ :
                            break;
                        case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/ :
                            break;
                        case 'unsynced' /*case 'Unsynced'*/ :
                            break;
                        case 'print' /*case 'Print'*/ :
                            break;
                        case 'printerrors' /*case 'PrintErrors'*/ :
                            break;
                        case 'panes' /*case 'Panes'*/ :
                            break;
                        case 'scale' /*case 'Scale'*/ :
                            break;
                        case 'pane' /*case 'Pane'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'layout' /*case 'Layout'*/ :
                            break;
                        case 'pagesetup' /*case 'PageSetup'*/ :
                            break;
                        case 'selected' /*case 'Selected'*/ :
                            break;
                        case 'protectobjects' /*case 'ProtectObjects'*/ :
                            break;
                        case 'enableselection' /*case 'EnableSelection'*/ :
                            break;
                        case 'protectscenarios' /*case 'ProtectScenarios'*/ :
                            break;
                        case 'validprinterinfo' /*case 'ValidPrinterInfo'*/ :
                            break;
                        case 'horizontalresolution' /*case 'HorizontalResolution'*/ :
                            break;
                        case 'verticalresolution' /*case 'VerticalResolution'*/ :
                            break;
                        case 'numberofcopies' /*case 'NumberofCopies'*/ :
                            break;
                        case 'activepane' /*case 'ActivePane'*/ :
                            break;
                        case 'toprowvisible' /*case 'TopRowVisible'*/ :
                            break;
                        case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/ :
                            break;
                        case 'fittopage' /*case 'FitToPage'*/ :
                            break;
                        case 'rangeselection' /*case 'RangeSelection'*/ :
                            break;
                        case 'papersizeindex' /*case 'PaperSizeIndex'*/ :
                            break;
                        case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/ :
                            break;
                        case 'pagebreakzoom' /*case 'PageBreakZoom'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'fitwidth' /*case 'FitWidth'*/ :
                            break;
                        case 'fitheight' /*case 'FitHeight'*/ :
                            break;
                        case 'commentslayout' /*case 'CommentsLayout'*/ :
                            break;
                        case 'zoom' /*case 'Zoom'*/ :
                            break;
                        case 'lefttoright' /*case 'LeftToRight'*/ :
                            break;
                        case 'gridlines' /*case 'Gridlines'*/ :
                            break;
                        case 'allowsort' /*case 'AllowSort'*/ :
                            break;
                        case 'allowfilter' /*case 'AllowFilter'*/ :
                            break;
                        case 'allowinsertrows' /*case 'AllowInsertRows'*/ :
                            break;
                        case 'allowdeleterows' /*case 'AllowDeleteRows'*/ :
                            break;
                        case 'allowinsertcols' /*case 'AllowInsertCols'*/ :
                            break;
                        case 'allowdeletecols' /*case 'AllowDeleteCols'*/ :
                            break;
                        case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case 'allowformatcells' /*case 'AllowFormatCells'*/ :
                            break;
                        case 'allowsizecols' /*case 'AllowSizeCols'*/ :
                            break;
                        case 'allowsizerows' /*case 'AllowSizeRows'*/ :
                            break;
                        case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case 'tabcolorindex' /*case 'TabColorIndex'*/ :
                            break;
                        case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case 'blackandwhite' /*case 'BlackAndWhite'*/ :
                            break;
                        case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case 'displaypagebreak' /*case 'DisplayPageBreak'*/ :
                            break;
                        case 'rowcolheadings' /*case 'RowColHeadings'*/ :
                            break;
                        case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case 'noorientation' /*case 'NoOrientation'*/ :
                            break;
                        case 'allowusepivottables' /*case 'AllowUsePivotTables'*/ :
                            break;
                        case 'zeroheight' /*case 'ZeroHeight'*/ :
                            break;
                        case 'viewablerange' /*case 'ViewableRange'*/ :
                            break;
                        case 'selection' /*case 'Selection'*/ :
                            break;
                        case 'protectcontents' /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case 'pivottable' /*case 'PivotTable'*/ :
                case 'pivotcache' /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case 'compactrowindent' /*case 'CompactRowIndent'*/ :
                            break;
                        case 'location' /*case 'Location'*/ :
                            break;
                        case 'pivotfield' /*case 'PivotField'*/ :
                            break;
                        case 'orientation' /*case 'Orientation'*/ :
                            break;
                        case 'layoutform' /*case 'LayoutForm'*/ :
                            break;
                        case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case 'layoutcompactrow' /*case 'LayoutCompactRow'*/ :
                            break;
                        case 'position' /*case 'Position'*/ :
                            break;
                        case 'pivotitem' /*case 'PivotItem'*/ :
                            break;
                        case 'datatype' /*case 'DataType'*/ :
                            break;
                        case 'datafield' /*case 'DataField'*/ :
                            break;
                        case 'sourcename' /*case 'SourceName'*/ :
                            break;
                        case 'parentfield' /*case 'ParentField'*/ :
                            break;
                        case 'ptlineitems' /*case 'PTLineItems'*/ :
                            break;
                        case 'ptlineitem' /*case 'PTLineItem'*/ :
                            break;
                        case 'countofsameitems' /*case 'CountOfSameItems'*/ :
                            break;
                        case 'item' /*case 'Item'*/ :
                            break;
                        case 'itemtype' /*case 'ItemType'*/ :
                            break;
                        case 'ptsource' /*case 'PTSource'*/ :
                            break;
                        case 'cacheindex' /*case 'CacheIndex'*/ :
                            break;
                        case 'consolidationreference' /*case 'ConsolidationReference'*/ :
                            break;
                        case 'filename' /*case 'FileName'*/ :
                            break;
                        case 'reference' /*case 'Reference'*/ :
                            break;
                        case 'nocolumngrand' /*case 'NoColumnGrand'*/ :
                            break;
                        case 'norowgrand' /*case 'NoRowGrand'*/ :
                            break;
                        case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/ :
                            break;
                        case 'hidden' /*case 'Hidden'*/ :
                            break;
                        case 'subtotal' /*case 'Subtotal'*/ :
                            break;
                        case 'basefield' /*case 'BaseField'*/ :
                            break;
                        case 'mapchilditems' /*case 'MapChildItems'*/ :
                            break;
                        case 'function' /*case 'Function'*/ :
                            break;
                        case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case 'printsettitles' /*case 'PrintSetTitles'*/ :
                            break;
                        case 'mergelabels' /*case 'MergeLabels'*/ :
                            break;
                        case 'defaultversion' /*case 'DefaultVersion'*/ :
                            break;
                        case 'refreshname' /*case 'RefreshName'*/ :
                            break;
                        case 'refreshdate' /*case 'RefreshDate'*/ :
                            break;
                        case 'refreshdatecopy' /*case 'RefreshDateCopy'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        case 'versionlastupdate' /*case 'VersionLastUpdate'*/ :
                            break;
                        case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/ :
                            break;
                        case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case 'pagebreaks' /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case 'colbreaks' /*case 'ColBreaks'*/ :
                            break;
                        case 'colbreak' /*case 'ColBreak'*/ :
                            break;
                        case 'rowbreaks' /*case 'RowBreaks'*/ :
                            break;
                        case 'rowbreak' /*case 'RowBreak'*/ :
                            break;
                        case 'colstart' /*case 'ColStart'*/ :
                            break;
                        case 'colend' /*case 'ColEnd'*/ :
                            break;
                        case 'rowend' /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case 'autofilter' /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case 'autofiltercolumn' /*case 'AutoFilterColumn'*/ :
                            break;
                        case 'autofiltercondition' /*case 'AutoFilterCondition'*/ :
                            break;
                        case 'autofilterand' /*case 'AutoFilterAnd'*/ :
                            break;
                        case 'autofilteror' /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case 'querytable' /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case 'id' /*case 'Id'*/ :
                            break;
                        case 'autoformatfont' /*case 'AutoFormatFont'*/ :
                            break;
                        case 'autoformatpattern' /*case 'AutoFormatPattern'*/ :
                            break;
                        case 'querysource' /*case 'QuerySource'*/ :
                            break;
                        case 'querytype' /*case 'QueryType'*/ :
                            break;
                        case 'enableredirections' /*case 'EnableRedirections'*/ :
                            break;
                        case 'refreshedinxl9' /*case 'RefreshedInXl9'*/ :
                            break;
                        case 'urlstring' /*case 'URLString'*/ :
                            break;
                        case 'htmltables' /*case 'HTMLTables'*/ :
                            break;
                        case 'connection' /*case 'Connection'*/ :
                            break;
                        case 'commandtext' /*case 'CommandText'*/ :
                            break;
                        case 'refreshinfo' /*case 'RefreshInfo'*/ :
                            break;
                        case 'notitles' /*case 'NoTitles'*/ :
                            break;
                        case 'nextid' /*case 'NextId'*/ :
                            break;
                        case 'columninfo' /*case 'ColumnInfo'*/ :
                            break;
                        case 'overwritecells' /*case 'OverwriteCells'*/ :
                            break;
                        case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/ :
                            break;
                        case 'textwizardsettings' /*case 'TextWizardSettings'*/ :
                            break;
                        case 'source' /*case 'Source'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'decimal' /*case 'Decimal'*/ :
                            break;
                        case 'thousandseparator' /*case 'ThousandSeparator'*/ :
                            break;
                        case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case 'formatsettings' /*case 'FormatSettings'*/ :
                            break;
                        case 'fieldtype' /*case 'FieldType'*/ :
                            break;
                        case 'delimiters' /*case 'Delimiters'*/ :
                            break;
                        case 'tab' /*case 'Tab'*/ :
                            break;
                        case 'comma' /*case 'Comma'*/ :
                            break;
                        case 'autoformatname' /*case 'AutoFormatName'*/ :
                            break;
                        case 'versionlastedit' /*case 'VersionLastEdit'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'datavalidation' /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'sorting' /*case 'Sorting'*/ :
                case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case 'mapinfo' /*case 'MapInfo'*/ :
                case 'schema' /*case 'Schema'*/ :
                case 'data' /*case 'data'*/ :
                    switch(Rn[3]){
                        case 'map' /*case 'Map'*/ :
                            break;
                        case 'entry' /*case 'Entry'*/ :
                            break;
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'xpath' /*case 'XPath'*/ :
                            break;
                        case 'field' /*case 'Field'*/ :
                            break;
                        case 'xsdtype' /*case 'XSDType'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'aggregate' /*case 'Aggregate'*/ :
                            break;
                        case 'elementtype' /*case 'ElementType'*/ :
                            break;
                        case 'attributetype' /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case 'schema' /*case 'schema'*/ :
                        case 'element' /*case 'element'*/ :
                        case 'complextype' /*case 'complexType'*/ :
                        case 'datatype' /*case 'datatype'*/ :
                        case 'all' /*case 'all'*/ :
                        case 'attribute' /*case 'attribute'*/ :
                        case 'extends' /*case 'extends'*/ :
                            break;
                        case 'row' /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case 'smarttags' /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ 'customdocumentproperties') {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $a1a91b25d7598376$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    out.bookType = "xlml";
    return out;
}
function $a1a91b25d7598376$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $a1a91b25d7598376$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $a1a91b25d7598376$var$parse_xlml_xml($a1a91b25d7598376$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $a1a91b25d7598376$var$parse_xlml_xml(data, opts);
        case "array":
            return $a1a91b25d7598376$var$parse_xlml_xml($a1a91b25d7598376$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $a1a91b25d7598376$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($a1a91b25d7598376$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($a1a91b25d7598376$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $a1a91b25d7598376$var$write_wb_xlml(wb /*::, opts*/ ) /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ if ((((wb || {}).Workbook || {}).WBProps || {}).date1904) return '<ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"><Date1904/></ExcelWorkbook>';
    return "";
}
/* TODO */ function $a1a91b25d7598376$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($a1a91b25d7598376$var$writextag('NumberFormat', null, {
            "ss:Format": $a1a91b25d7598376$var$escapexml($a1a91b25d7598376$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($a1a91b25d7598376$var$writextag('Style', payload.join(""), o));
    });
    return $a1a91b25d7598376$var$writextag("Styles", styles.join(""));
}
function $a1a91b25d7598376$var$write_name_xlml(n) {
    return $a1a91b25d7598376$var$writextag("NamedRange", null, {
        "ss:Name": n.Name.slice(0, 6) == "_xlnm." ? n.Name.slice(6) : n.Name,
        "ss:RefersTo": "=" + $a1a91b25d7598376$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $a1a91b25d7598376$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($a1a91b25d7598376$var$write_name_xlml(n));
    }
    return $a1a91b25d7598376$var$writextag("Names", out.join(""));
}
function $a1a91b25d7598376$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($a1a91b25d7598376$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $a1a91b25d7598376$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws['!margins']) {
        o.push("<PageSetup>");
        if (ws['!margins'].header) o.push($a1a91b25d7598376$var$writextag("Header", null, {
            'x:Margin': ws['!margins'].header
        }));
        if (ws['!margins'].footer) o.push($a1a91b25d7598376$var$writextag("Footer", null, {
            'x:Margin': ws['!margins'].footer
        }));
        o.push($a1a91b25d7598376$var$writextag("PageMargins", null, {
            'x:Bottom': ws['!margins'].bottom || "0.75",
            'x:Left': ws['!margins'].left || "0.7",
            'x:Right': ws['!margins'].right || "0.7",
            'x:Top': ws['!margins'].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($a1a91b25d7598376$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws['!protect']) {
        o.push($a1a91b25d7598376$var$writetag("ProtectContents", "True"));
        if (ws['!protect'].objects) o.push($a1a91b25d7598376$var$writetag("ProtectObjects", "True"));
        if (ws['!protect'].scenarios) o.push($a1a91b25d7598376$var$writetag("ProtectScenarios", "True"));
        if (ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push($a1a91b25d7598376$var$writetag("EnableSelection", "NoSelection"));
        else if (ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push($a1a91b25d7598376$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws['!protect'][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $a1a91b25d7598376$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $a1a91b25d7598376$var$XLMLNS.x
    });
}
function $a1a91b25d7598376$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    /* TODO: test multiple comments */ return comments.map(function(c) {
        // TODO: formatted text
        var t = $a1a91b25d7598376$var$xlml_unfixstr(c.t || "");
        var d = $a1a91b25d7598376$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        var p = {};
        if (c.a) p["ss:Author"] = c.a;
        if (!comments.hidden) p["ss:ShowAlways"] = "1";
        return $a1a91b25d7598376$var$writextag("Comment", d, p);
    }).join("");
}
function $a1a91b25d7598376$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $a1a91b25d7598376$var$escapexml($a1a91b25d7598376$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $a1a91b25d7598376$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $a1a91b25d7598376$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $a1a91b25d7598376$var$escapexml(cell.l.Tooltip);
    }
    if (ws['!merges']) {
        var marr = ws['!merges'];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case 'z':
            if (!opts.sheetStubs) return "";
            break;
        case 'n':
            if (!isFinite(cell.v)) {
                t = 'Error';
                p = $a1a91b25d7598376$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
            } else {
                t = 'Number';
                p = String(cell.v);
            }
            break;
        case 'b':
            t = 'Boolean';
            p = cell.v ? "1" : "0";
            break;
        case 'e':
            t = 'Error';
            p = $a1a91b25d7598376$var$BErr[cell.v];
            break;
        case 'd':
            t = 'DateTime';
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $a1a91b25d7598376$var$table_fmt[14];
            break;
        case 's':
            t = 'String';
            p = $a1a91b25d7598376$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == 'z' ? "" : '<Data ss:Type="' + t + '">' + _v + '</Data>';
    if ((cell.c || []).length > 0) m += $a1a91b25d7598376$var$write_ws_xlml_comment(cell.c);
    return $a1a91b25d7598376$var$writextag("Cell", m, attr);
}
function $a1a91b25d7598376$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $a1a91b25d7598376$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + '>';
}
/* TODO */ function $a1a91b25d7598376$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws['!ref']) return "";
    var range /*:Range*/  = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']);
    var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
        $a1a91b25d7598376$var$process_col(n);
        var w = !!n.width;
        var p = $a1a91b25d7598376$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k['ss:Width'] = $a1a91b25d7598376$var$width2px(p.width);
        if (n.hidden) k['ss:Hidden'] = "1";
        o.push($a1a91b25d7598376$var$writextag("Column", null, k));
    });
    var dense = ws["!data"] != null;
    var addr = {
        r: 0,
        c: 0
    };
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $a1a91b25d7598376$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
        ];
        addr.r = R;
        for(var C = range.s.c; C <= range.e.c; ++C){
            addr.c = C;
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var ref = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            row.push($a1a91b25d7598376$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $a1a91b25d7598376$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $a1a91b25d7598376$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $a1a91b25d7598376$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($a1a91b25d7598376$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    if (ws && ws["!autofilter"]) o.push('<AutoFilter x:Range="' + $a1a91b25d7598376$var$a1_to_rc($a1a91b25d7598376$var$fix_range(ws["!autofilter"].ref), {
        r: 0,
        c: 0
    }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
    return o.join("");
}
function $a1a91b25d7598376$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($a1a91b25d7598376$var$write_props_xlml(wb, opts));
    d.push($a1a91b25d7598376$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push($a1a91b25d7598376$var$write_names_xlml(wb, opts));
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($a1a91b25d7598376$var$writextag("Worksheet", $a1a91b25d7598376$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $a1a91b25d7598376$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $a1a91b25d7598376$var$write_sty_xlml(wb, opts);
    return $a1a91b25d7598376$var$XML_HEADER + $a1a91b25d7598376$var$writextag("Workbook", d.join(""), {
        'xmlns': $a1a91b25d7598376$var$XLMLNS.ss,
        'xmlns:o': $a1a91b25d7598376$var$XLMLNS.o,
        'xmlns:x': $a1a91b25d7598376$var$XLMLNS.x,
        'xmlns:ss': $a1a91b25d7598376$var$XLMLNS.ss,
        'xmlns:dt': $a1a91b25d7598376$var$XLMLNS.dt,
        'xmlns:html': $a1a91b25d7598376$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $a1a91b25d7598376$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $a1a91b25d7598376$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $a1a91b25d7598376$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $a1a91b25d7598376$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $a1a91b25d7598376$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002F /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00E1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $a1a91b25d7598376$var$__readUInt16LE(blob, blob.l), next = $a1a91b25d7598376$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $a1a91b25d7598376$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $a1a91b25d7598376$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $a1a91b25d7598376$var$XLSRecordEnum[nextrt = $a1a91b25d7598376$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $a1a91b25d7598376$var$bconcat(bufs);
    $a1a91b25d7598376$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $a1a91b25d7598376$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === 'z') return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF && p.z == null) p.z = $a1a91b25d7598376$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === 'e') p.w = p.w || $a1a91b25d7598376$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $a1a91b25d7598376$var$SSF_general_num(p.v);
            } else p.w = $a1a91b25d7598376$var$SSF_general(p.v);
        } else p.w = $a1a91b25d7598376$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == 'n' && $a1a91b25d7598376$var$fmt_is_date($a1a91b25d7598376$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $a1a91b25d7598376$var$SSF_parse_date_code(p.v + (date1904 ? 1462 : 0));
        if (_d) {
            p.t = 'd';
            p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
        }
    }
}
function $a1a91b25d7598376$var$make_cell(val1, ixfe, t) /*:Cell*/ {
    return {
        v: val1,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $a1a91b25d7598376$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($a1a91b25d7598376$var$DENSE != null && options.dense == null) options.dense = $a1a91b25d7598376$var$DENSE;
    var out /*:Worksheet*/  = {} /*:any*/ ;
    if (options.dense) out["!data"] = [];
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var biff4w = false;
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $a1a91b25d7598376$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $a1a91b25d7598376$var$XLSIcv[icv];
        return $a1a91b25d7598376$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $a1a91b25d7598376$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $a1a91b25d7598376$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (!biff4w && file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $a1a91b25d7598376$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $a1a91b25d7598376$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $a1a91b25d7598376$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out["!data"][cell.r]) out["!data"][cell.r] = [];
            out["!data"][cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $a1a91b25d7598376$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $a1a91b25d7598376$var$XLSRecordEnum[RecordType];
        if (file_depth == 0 && [
            0x0009,
            0x0209,
            0x0409,
            0x0809
        ].indexOf(RecordType) == -1 /* BOF */ ) break;
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val1 /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val1 = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val1 = /*::(*/ $a1a91b25d7598376$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* BOF */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val1;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val1;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val1.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val1.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val1;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val1);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $a1a91b25d7598376$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val1;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val1;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val1;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val1;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val1;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val1;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val1;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val1;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val1;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val1;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val1;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val1.fDialog) out["!type"] = "dialog";
                    if (!val1.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val1.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x0043:
                /* BIFF2XF */ case 0x0243:
                /* BIFF3XF */ case 0x0443:
                /* BIFF4XF */ case 0x00e0 /* XF */ :
                    XFs.push(val1);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val1
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val1);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val1.Name,
                        Ref: $a1a91b25d7598376$var$stringify_formula(val1.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val1.itab > 0) last_lbl.Sheet = val1.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val1);
                    if (val1.Name == "_xlnm._FilterDatabase" && val1.itab > 0) {
                        if (val1.rgce && val1.rgce[0] && val1.rgce[0][0] && val1.rgce[0][0][0] == 'PtgArea3d') FilterDatabases[val1.itab - 1] = {
                            ref: $a1a91b25d7598376$var$encode_range(val1.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val1;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val1);
                    supbooks.XTI = supbooks.XTI.concat(val1);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val1[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val1;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val1 !== 0 && opts.WTF) console.error("Password verifier: " + val1);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[opts.biff == 4 ? opts.snames.length : val1.pos] = val1;
                    opts.snames.push(val1.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth ? !biff4w : biff4w) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $a1a91b25d7598376$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $a1a91b25d7598376$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        0x0009: 2,
                        0x0209: 3,
                        0x0409: 4
                    })[RecordType] || ({
                        0x0200: 2,
                        0x0300: 3,
                        0x0400: 4,
                        0x0500: 5,
                        0x0600: 8,
                        0x0002: 2,
                        0x0007: 2
                    })[val1.BIFFVer] || 8;
                    opts.biffguess = val1.BIFFVer == 0;
                    if (val1.BIFFVer == 0 && val1.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $a1a91b25d7598376$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 4 && val1.dt & 0x100) biff4w = true;
                    if (opts.biff == 8 && val1.BIFFVer == 0 && val1.dt == 16) opts.biff = 2;
                    if (file_depth++ && !biff4w) break;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $a1a91b25d7598376$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff == 4 && biff4w) cur_sheet = (Directory[opts.snames.indexOf(cur_sheet) + 1] || {
                        name: ""
                    }).name;
                    else if (opts.biff < 5 || val1.BIFFVer == 0 && val1.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val1.dt == 0x20) out["!type"] = "chart";
                    if (val1.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out["!data"][val1.r] || [])[val1.c] : out[$a1a91b25d7598376$var$encode_col(val1.c) + $a1a91b25d7598376$var$encode_row(val1.r)]) ++val1.c;
                    }
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe] || {},
                        v: val1.val,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe],
                        v: val1.val,
                        t: val1.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe],
                        v: val1.rknum,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val1.c; j <= val1.C; ++j){
                        var ixfe = val1.rkrec[j - val1.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val1.rkrec[j - val1.c][1],
                            t: 'n'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val1.val == 'String') {
                        last_formula = val1;
                        break;
                    }
                    temp_val = $a1a91b25d7598376$var$make_cell(val1.val, val1.cell.ixfe, val1.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val1.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $a1a91b25d7598376$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $a1a91b25d7598376$var$stringify_formula(val1.formula, range, val1.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out["!data"][_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $a1a91b25d7598376$var$stringify_formula(val1.formula, range, val1.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val1.cell, temp_val, options);
                    last_formula = val1;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val1;
                        temp_val = $a1a91b25d7598376$var$make_cell(val1, last_formula.cell.ixfe, 's');
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $a1a91b25d7598376$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val1);
                    var _arraystart = $a1a91b25d7598376$var$encode_cell(val1[0].s);
                    cc = options.dense ? (out["!data"][val1[0].s.r] || [])[val1[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $a1a91b25d7598376$var$stringify_formula(val1[1], range, val1[0], supbooks, opts);
                        cc.F = $a1a91b25d7598376$var$encode_range(val1[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$a1a91b25d7598376$var$encode_cell(last_formula.cell)] = val1[0];
                        cc = options.dense ? (out["!data"][last_formula.cell.r] || [])[last_formula.cell.c] : out[$a1a91b25d7598376$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $a1a91b25d7598376$var$stringify_formula(val1[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $a1a91b25d7598376$var$make_cell(sst[val1.isst].t, val1.ixfe, 's');
                    if (sst[val1.isst].h) temp_val.h = sst[val1.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val1.ixfe,
                            XF: XFs[val1.ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val1.c,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val1.c; _j <= val1.C; ++_j){
                        var _ixfe = val1.ixfe[_j - val1.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $a1a91b25d7598376$var$make_cell(val1.val, val1.ixfe, 's');
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val1; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val1;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff >= 3 && opts.biff <= 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val1[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($a1a91b25d7598376$var$table_fmt[b4idx] == val1[1]) break;
                        if (b4idx >= 163) $a1a91b25d7598376$var$SSF__load(val1[1], BIFF2Fmt + 163);
                    } else $a1a91b25d7598376$var$SSF__load(val1[1], val1[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val1;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($a1a91b25d7598376$var$table_fmt[b2idx] == val1) break;
                    if (b2idx >= 163) $a1a91b25d7598376$var$SSF__load(val1, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val1);
                    break;
                case 0x005d /* Obj */ :
                    objects[val1.cmo[0]] = opts.lastobj = val1;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val1;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val1;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val1[0].s.r; rngR <= val1[0].e.r; ++rngR)for(rngC = val1[0].s.c; rngC <= val1[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$a1a91b25d7598376$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val1[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val1[0].s.r; rngR <= val1[0].e.r; ++rngR)for(rngC = val1[0].s.c; rngC <= val1[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$a1a91b25d7598376$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val1[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    /* TODO: comment continuation (row == -1 / 0xFFFF) */ cc = options.dense ? (out["!data"][val1[0].r] || [])[val1[0].c] : out[$a1a91b25d7598376$var$encode_cell(val1[0])];
                    if (!cc) {
                        if (options.dense) {
                            if (!out["!data"][val1[0].r]) out["!data"][val1[0].r] = [];
                            cc = out["!data"][val1[0].r][val1[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$a1a91b25d7598376$var$encode_cell(val1[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val1[0].r);
                        range.s.r = Math.min(range.s.r, val1[0].r);
                        range.e.c = Math.max(range.e.c, val1[0].c);
                        range.s.c = Math.min(range.s.c, val1[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    if (opts.biff <= 5 && opts.biff >= 2) cmnt = {
                        a: "SheetJ5",
                        t: val1[1]
                    };
                    else {
                        var noteobj = objects[val1[2]];
                        cmnt = {
                            a: val1[1],
                            t: noteobj.TxO.t
                        };
                        if (val1[3] != null && !(val1[3] & 0x02)) cc.c.hidden = true;
                    }
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $a1a91b25d7598376$var$update_xfext(XFs[val1.ixfe], val1.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val1.e >= val1.s){
                        colinfo[val1.e--] = {
                            width: val1.w / 256,
                            level: val1.level || 0,
                            hidden: !!(val1.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $a1a91b25d7598376$var$find_mdw_colw(val1.w / 256);
                        }
                        $a1a91b25d7598376$var$process_col(colinfo[val1.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val1.level != null) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.level = val1.level;
                    }
                    if (val1.hidden) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val1.hpt) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.hpt = val1.hpt;
                        rowobj.hpx = $a1a91b25d7598376$var$pt2px(val1.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out['!margins']) $a1a91b25d7598376$var$default_margins(out['!margins'] = {});
                    out['!margins'][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val1;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out['!margins']) $a1a91b25d7598376$var$default_margins(out['!margins'] = {});
                    out['!margins'].header = val1.header;
                    out['!margins'].footer = val1.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val1.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val1;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val1;
                    break;
                case 0x008c /* Country */ :
                    country = val1;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val1 || "ThisWorkbook";
                    else wsprops.CodeName = val1 || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $a1a91b25d7598376$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r;
    });
    wb.Strings = sst;
    wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $a1a91b25d7598376$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $a1a91b25d7598376$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '/!DocumentSummaryInformation');
    if (DSI && DSI.size > 0) try {
        var DocSummary = $a1a91b25d7598376$var$parse_PropertySetStream(DSI, $a1a91b25d7598376$var$DocSummaryPIDDSI, $a1a91b25d7598376$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '/!SummaryInformation');
    if (SI && SI.size > 0) try {
        var Summary = $a1a91b25d7598376$var$parse_PropertySetStream(SI, $a1a91b25d7598376$var$SummaryPIDSI, $a1a91b25d7598376$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $a1a91b25d7598376$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $a1a91b25d7598376$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $a1a91b25d7598376$var$evert_key($a1a91b25d7598376$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $a1a91b25d7598376$var$evert_key($a1a91b25d7598376$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $a1a91b25d7598376$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $a1a91b25d7598376$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($a1a91b25d7598376$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $a1a91b25d7598376$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005SummaryInformation", $a1a91b25d7598376$var$write_PropertySetStream(SEntries, $a1a91b25d7598376$var$PSCLSID.SI, SummaryRE, $a1a91b25d7598376$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", $a1a91b25d7598376$var$write_PropertySetStream(DSEntries, $a1a91b25d7598376$var$PSCLSID.DSI, DocSummaryRE, $a1a91b25d7598376$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $a1a91b25d7598376$var$PSCLSID.UDI));
}
function $a1a91b25d7598376$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $a1a91b25d7598376$var$fix_read_opts(options);
    $a1a91b25d7598376$var$reset_cp();
    if (options.codepage) $a1a91b25d7598376$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '/encryption')) throw new Error("File is password-protected");
        CompObj = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '!CompObj');
        WB = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '/Workbook') || $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '/Book');
    } else {
        switch(options.type){
            case 'base64':
                cfb = $a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(cfb));
                break;
            case 'binary':
                cfb = $a1a91b25d7598376$var$s2a(cfb);
                break;
            case 'buffer':
                break;
            case 'array':
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $a1a91b25d7598376$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $a1a91b25d7598376$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $a1a91b25d7598376$var$has_buf ? 'buffer' : 'array';
        if (WB && WB.content) WorkbookP = $a1a91b25d7598376$var$parse_workbook(WB.content, options);
        else if ((_data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = $a1a91b25d7598376$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = $a1a91b25d7598376$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = $a1a91b25d7598376$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $a1a91b25d7598376$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $a1a91b25d7598376$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $a1a91b25d7598376$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $a1a91b25d7598376$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $a1a91b25d7598376$var$fill_vba_xls(cfb, $a1a91b25d7598376$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $a1a91b25d7598376$var$XLSBRecordEnum = {
    0x0000: {
        f: $a1a91b25d7598376$var$parse_BrtRowHdr
    },
    0x0001: {
        f: $a1a91b25d7598376$var$parse_BrtCellBlank
    },
    0x0002: {
        f: $a1a91b25d7598376$var$parse_BrtCellRk
    },
    0x0003: {
        f: $a1a91b25d7598376$var$parse_BrtCellError
    },
    0x0004: {
        f: $a1a91b25d7598376$var$parse_BrtCellBool
    },
    0x0005: {
        f: $a1a91b25d7598376$var$parse_BrtCellReal
    },
    0x0006: {
        f: $a1a91b25d7598376$var$parse_BrtCellSt
    },
    0x0007: {
        f: $a1a91b25d7598376$var$parse_BrtCellIsst
    },
    0x0008: {
        f: $a1a91b25d7598376$var$parse_BrtFmlaString
    },
    0x0009: {
        f: $a1a91b25d7598376$var$parse_BrtFmlaNum
    },
    0x000A: {
        f: $a1a91b25d7598376$var$parse_BrtFmlaBool
    },
    0x000B: {
        f: $a1a91b25d7598376$var$parse_BrtFmlaError
    },
    0x000C: {
        f: $a1a91b25d7598376$var$parse_BrtShortBlank
    },
    0x000D: {
        f: $a1a91b25d7598376$var$parse_BrtShortRk
    },
    0x000E: {
        f: $a1a91b25d7598376$var$parse_BrtShortError
    },
    0x000F: {
        f: $a1a91b25d7598376$var$parse_BrtShortBool
    },
    0x0010: {
        f: $a1a91b25d7598376$var$parse_BrtShortReal
    },
    0x0011: {
        f: $a1a91b25d7598376$var$parse_BrtShortSt
    },
    0x0012: {
        f: $a1a91b25d7598376$var$parse_BrtShortIsst
    },
    0x0013: {
        f: $a1a91b25d7598376$var$parse_RichStr
    },
    0x0014: {},
    0x0015: {},
    0x0016: {},
    0x0017: {},
    0x0018: {},
    0x0019: {},
    0x001A: {},
    0x001B: {},
    0x001C: {},
    0x001D: {},
    0x001E: {},
    0x001F: {},
    0x0020: {},
    0x0021: {},
    0x0022: {},
    0x0023: {
        T: 1
    },
    0x0024: {
        T: -1
    },
    0x0025: {
        T: 1
    },
    0x0026: {
        T: -1
    },
    0x0027: {
        f: $a1a91b25d7598376$var$parse_BrtName
    },
    0x0028: {},
    0x002A: {},
    0x002B: {
        f: $a1a91b25d7598376$var$parse_BrtFont
    },
    0x002C: {
        f: $a1a91b25d7598376$var$parse_BrtFmt
    },
    0x002D: {
        f: $a1a91b25d7598376$var$parse_BrtFill
    },
    0x002E: {
        f: $a1a91b25d7598376$var$parse_BrtBorder
    },
    0x002F: {
        f: $a1a91b25d7598376$var$parse_BrtXF
    },
    0x0030: {},
    0x0031: {
        f: $a1a91b25d7598376$var$parse_Int32LE
    },
    0x0032: {},
    0x0033: {
        f: $a1a91b25d7598376$var$parse_BrtMdb
    },
    0x0034: {
        T: 1
    },
    0x0035: {
        T: -1
    },
    0x0036: {
        T: 1
    },
    0x0037: {
        T: -1
    },
    0x0038: {
        T: 1
    },
    0x0039: {
        T: -1
    },
    0x003A: {},
    0x003B: {},
    0x003C: {
        f: $a1a91b25d7598376$var$parse_ColInfo
    },
    0x003E: {
        f: $a1a91b25d7598376$var$parse_BrtCellRString
    },
    0x003F: {
        f: $a1a91b25d7598376$var$parse_BrtCalcChainItem$
    },
    0x0040: {
        f: $a1a91b25d7598376$var$parse_BrtDVal
    },
    0x0041: {},
    0x0042: {},
    0x0043: {},
    0x0044: {},
    0x0045: {},
    0x0046: {},
    0x0080: {},
    0x0081: {
        T: 1
    },
    0x0082: {
        T: -1
    },
    0x0083: {
        T: 1,
        f: $a1a91b25d7598376$var$parsenoop,
        p: 0
    },
    0x0084: {
        T: -1
    },
    0x0085: {
        T: 1
    },
    0x0086: {
        T: -1
    },
    0x0087: {
        T: 1
    },
    0x0088: {
        T: -1
    },
    0x0089: {
        T: 1,
        f: $a1a91b25d7598376$var$parse_BrtBeginWsView
    },
    0x008A: {
        T: -1
    },
    0x008B: {
        T: 1
    },
    0x008C: {
        T: -1
    },
    0x008D: {
        T: 1
    },
    0x008E: {
        T: -1
    },
    0x008F: {
        T: 1
    },
    0x0090: {
        T: -1
    },
    0x0091: {
        T: 1
    },
    0x0092: {
        T: -1
    },
    0x0093: {
        f: $a1a91b25d7598376$var$parse_BrtWsProp
    },
    0x0094: {
        f: $a1a91b25d7598376$var$parse_BrtWsDim,
        p: 16
    },
    0x0097: {
        f: $a1a91b25d7598376$var$parse_BrtPane
    },
    0x0098: {},
    0x0099: {
        f: $a1a91b25d7598376$var$parse_BrtWbProp
    },
    0x009A: {},
    0x009B: {},
    0x009C: {
        f: $a1a91b25d7598376$var$parse_BrtBundleSh
    },
    0x009D: {},
    0x009E: {},
    0x009F: {
        T: 1,
        f: $a1a91b25d7598376$var$parse_BrtBeginSst
    },
    0x00A0: {
        T: -1
    },
    0x00A1: {
        T: 1,
        f: $a1a91b25d7598376$var$parse_UncheckedRfX
    },
    0x00A2: {
        T: -1
    },
    0x00A3: {
        T: 1
    },
    0x00A4: {
        T: -1
    },
    0x00A5: {
        T: 1
    },
    0x00A6: {
        T: -1
    },
    0x00A7: {},
    0x00A8: {},
    0x00A9: {},
    0x00AA: {},
    0x00AB: {},
    0x00AC: {
        T: 1
    },
    0x00AD: {
        T: -1
    },
    0x00AE: {},
    0x00AF: {},
    0x00B0: {
        f: $a1a91b25d7598376$var$parse_BrtMergeCell
    },
    0x00B1: {
        T: 1
    },
    0x00B2: {
        T: -1
    },
    0x00B3: {
        T: 1
    },
    0x00B4: {
        T: -1
    },
    0x00B5: {
        T: 1
    },
    0x00B6: {
        T: -1
    },
    0x00B7: {
        T: 1
    },
    0x00B8: {
        T: -1
    },
    0x00B9: {
        T: 1
    },
    0x00BA: {
        T: -1
    },
    0x00BB: {
        T: 1
    },
    0x00BC: {
        T: -1
    },
    0x00BD: {
        T: 1
    },
    0x00BE: {
        T: -1
    },
    0x00BF: {
        T: 1
    },
    0x00C0: {
        T: -1
    },
    0x00C1: {
        T: 1
    },
    0x00C2: {
        T: -1
    },
    0x00C3: {
        T: 1
    },
    0x00C4: {
        T: -1
    },
    0x00C5: {
        T: 1
    },
    0x00C6: {
        T: -1
    },
    0x00C7: {
        T: 1
    },
    0x00C8: {
        T: -1
    },
    0x00C9: {
        T: 1
    },
    0x00CA: {
        T: -1
    },
    0x00CB: {
        T: 1
    },
    0x00CC: {
        T: -1
    },
    0x00CD: {
        T: 1
    },
    0x00CE: {
        T: -1
    },
    0x00CF: {
        T: 1
    },
    0x00D0: {
        T: -1
    },
    0x00D1: {
        T: 1
    },
    0x00D2: {
        T: -1
    },
    0x00D3: {
        T: 1
    },
    0x00D4: {
        T: -1
    },
    0x00D5: {
        T: 1
    },
    0x00D6: {
        T: -1
    },
    0x00D7: {
        T: 1
    },
    0x00D8: {
        T: -1
    },
    0x00D9: {
        T: 1
    },
    0x00DA: {
        T: -1
    },
    0x00DB: {
        T: 1
    },
    0x00DC: {
        T: -1
    },
    0x00DD: {
        T: 1
    },
    0x00DE: {
        T: -1
    },
    0x00DF: {
        T: 1
    },
    0x00E0: {
        T: -1
    },
    0x00E1: {
        T: 1
    },
    0x00E2: {
        T: -1
    },
    0x00E3: {
        T: 1
    },
    0x00E4: {
        T: -1
    },
    0x00E5: {
        T: 1
    },
    0x00E6: {
        T: -1
    },
    0x00E7: {
        T: 1
    },
    0x00E8: {
        T: -1
    },
    0x00E9: {
        T: 1
    },
    0x00EA: {
        T: -1
    },
    0x00EB: {
        T: 1
    },
    0x00EC: {
        T: -1
    },
    0x00ED: {
        T: 1
    },
    0x00EE: {
        T: -1
    },
    0x00EF: {
        T: 1
    },
    0x00F0: {
        T: -1
    },
    0x00F1: {
        T: 1
    },
    0x00F2: {
        T: -1
    },
    0x00F3: {
        T: 1
    },
    0x00F4: {
        T: -1
    },
    0x00F5: {
        T: 1
    },
    0x00F6: {
        T: -1
    },
    0x00F7: {
        T: 1
    },
    0x00F8: {
        T: -1
    },
    0x00F9: {
        T: 1
    },
    0x00FA: {
        T: -1
    },
    0x00FB: {
        T: 1
    },
    0x00FC: {
        T: -1
    },
    0x00FD: {
        T: 1
    },
    0x00FE: {
        T: -1
    },
    0x00FF: {
        T: 1
    },
    0x0100: {
        T: -1
    },
    0x0101: {
        T: 1
    },
    0x0102: {
        T: -1
    },
    0x0103: {
        T: 1
    },
    0x0104: {
        T: -1
    },
    0x0105: {
        T: 1
    },
    0x0106: {
        T: -1
    },
    0x0107: {
        T: 1
    },
    0x0108: {
        T: -1
    },
    0x0109: {
        T: 1
    },
    0x010A: {
        T: -1
    },
    0x010B: {
        T: 1
    },
    0x010C: {
        T: -1
    },
    0x010D: {
        T: 1
    },
    0x010E: {
        T: -1
    },
    0x010F: {
        T: 1
    },
    0x0110: {
        T: -1
    },
    0x0111: {
        T: 1
    },
    0x0112: {
        T: -1
    },
    0x0113: {
        T: 1
    },
    0x0114: {
        T: -1
    },
    0x0115: {},
    0x0116: {
        T: 1
    },
    0x0117: {
        T: -1
    },
    0x0118: {
        T: 1
    },
    0x0119: {
        T: -1
    },
    0x011A: {
        T: 1
    },
    0x011B: {
        T: 1
    },
    0x011C: {
        T: -1
    },
    0x011D: {
        T: 1
    },
    0x011E: {
        T: -1
    },
    0x011F: {
        T: 1
    },
    0x0120: {
        T: -1
    },
    0x0121: {
        T: 1
    },
    0x0122: {
        T: -1
    },
    0x0123: {
        T: 1
    },
    0x0124: {
        T: -1
    },
    0x0125: {
        T: 1
    },
    0x0126: {
        T: -1
    },
    0x0127: {
        T: 1
    },
    0x0128: {
        T: -1
    },
    0x0129: {
        T: 1
    },
    0x012A: {
        T: -1
    },
    0x012B: {
        T: 1
    },
    0x012C: {
        T: -1
    },
    0x012D: {
        T: 1
    },
    0x012E: {
        T: -1
    },
    0x012F: {
        T: 1
    },
    0x0130: {
        T: -1
    },
    0x0131: {
        T: 1
    },
    0x0132: {
        T: -1
    },
    0x0133: {
        T: 1
    },
    0x0134: {
        T: -1
    },
    0x0135: {
        T: 1
    },
    0x0136: {
        T: -1
    },
    0x0137: {
        T: 1
    },
    0x0138: {
        T: -1
    },
    0x0139: {
        T: -1
    },
    0x013A: {
        T: 1
    },
    0x013B: {
        T: -1
    },
    0x013C: {
        T: 1
    },
    0x013D: {
        T: -1
    },
    0x013E: {
        T: 1
    },
    0x013F: {
        T: -1
    },
    0x0140: {
        T: 1
    },
    0x0141: {
        T: -1
    },
    0x0142: {
        T: 1
    },
    0x0143: {
        T: -1
    },
    0x0144: {
        T: 1
    },
    0x0145: {
        T: -1
    },
    0x0146: {
        T: 1
    },
    0x0147: {
        T: -1
    },
    0x0148: {
        T: 1
    },
    0x0149: {
        T: -1
    },
    0x014A: {
        T: 1
    },
    0x014B: {
        T: -1
    },
    0x014C: {
        T: 1
    },
    0x014D: {
        T: -1
    },
    0x014E: {
        T: 1
    },
    0x014F: {
        f: $a1a91b25d7598376$var$parse_BrtMdtinfo
    },
    0x0150: {
        T: -1
    },
    0x0151: {
        f: $a1a91b25d7598376$var$parse_BrtBeginEsmdb,
        T: 1
    },
    0x0152: {
        T: -1
    },
    0x0153: {
        T: 1
    },
    0x0154: {
        T: -1
    },
    0x0155: {
        T: 1
    },
    0x0156: {
        T: -1
    },
    0x0157: {
        T: 1
    },
    0x0158: {
        T: -1
    },
    0x0159: {
        T: 1
    },
    0x015A: {
        T: -1
    },
    0x015B: {
        T: 1
    },
    0x015C: {
        T: -1
    },
    0x015D: {
        T: 1
    },
    0x015E: {
        T: -1
    },
    0x015F: {},
    0x0160: {},
    0x0161: {
        T: 1
    },
    0x0162: {
        T: -1
    },
    0x0163: {
        f: $a1a91b25d7598376$var$parse_RelID
    },
    0x0165: {},
    0x0166: {},
    0x0167: {},
    0x0168: {
        T: 1
    },
    0x0169: {},
    0x016A: {
        f: $a1a91b25d7598376$var$parse_ExternSheet
    },
    0x016B: {},
    0x016C: {},
    0x016E: {},
    0x016F: {},
    0x0170: {},
    0x0171: {},
    0x0172: {},
    0x0173: {},
    0x0174: {
        T: 1
    },
    0x0175: {
        T: -1
    },
    0x0176: {
        T: 1
    },
    0x0177: {
        T: -1
    },
    0x0178: {
        T: 1
    },
    0x0179: {
        T: -1
    },
    0x017A: {
        T: 1
    },
    0x017B: {
        T: -1
    },
    0x017C: {
        T: 1
    },
    0x017D: {
        T: -1
    },
    0x017E: {
        T: 1
    },
    0x017F: {
        T: -1
    },
    0x0180: {
        T: 1
    },
    0x0181: {
        T: -1
    },
    0x0182: {
        T: 1
    },
    0x0183: {
        T: -1
    },
    0x0184: {
        T: 1
    },
    0x0185: {
        T: -1
    },
    0x0186: {
        T: 1
    },
    0x0187: {
        T: -1
    },
    0x0188: {
        T: 1
    },
    0x0189: {
        T: -1
    },
    0x018A: {
        T: 1
    },
    0x018B: {
        T: -1
    },
    0x018C: {},
    0x018D: {},
    0x018E: {},
    0x018F: {},
    0x0190: {},
    0x0191: {
        T: 1
    },
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x0199: {},
    0x019A: {},
    0x019B: {},
    0x019C: {},
    0x019D: {},
    0x019E: {},
    0x019F: {},
    0x01A0: {},
    0x01A1: {},
    0x01A2: {},
    0x01A3: {},
    0x01A4: {},
    0x01A5: {},
    0x01A6: {
        T: 1
    },
    0x01A7: {
        T: 1
    },
    0x01A8: {
        T: -1
    },
    0x01A9: {
        T: -1
    },
    0x01AA: {
        f: $a1a91b25d7598376$var$parse_BrtArrFmla
    },
    0x01AB: {
        f: $a1a91b25d7598376$var$parse_BrtShrFmla
    },
    0x01AC: {},
    0x01AD: {
        T: 1
    },
    0x01AE: {
        T: -1
    },
    0x01AF: {
        T: 1
    },
    0x01B0: {
        T: -1
    },
    0x01B1: {
        T: 1
    },
    0x01B2: {
        T: -1
    },
    0x01B3: {
        T: 1
    },
    0x01B4: {
        T: -1
    },
    0x01B5: {
        T: 1
    },
    0x01B6: {
        T: -1
    },
    0x01B7: {
        T: 1
    },
    0x01B8: {
        T: -1
    },
    0x01B9: {
        T: 1
    },
    0x01BA: {
        T: -1
    },
    0x01BB: {
        T: 1
    },
    0x01BC: {
        T: -1
    },
    0x01BD: {
        T: 1
    },
    0x01BE: {
        T: -1
    },
    0x01BF: {
        T: 1
    },
    0x01C0: {
        T: -1
    },
    0x01C1: {
        T: 1
    },
    0x01C2: {
        T: -1
    },
    0x01C3: {
        T: 1
    },
    0x01C4: {
        T: -1
    },
    0x01C5: {
        T: 1
    },
    0x01C6: {
        T: -1
    },
    0x01C7: {
        T: 1
    },
    0x01C8: {
        T: -1
    },
    0x01C9: {
        T: 1
    },
    0x01CA: {
        T: -1
    },
    0x01CB: {
        T: 1
    },
    0x01CC: {
        T: -1
    },
    0x01CD: {
        T: 1
    },
    0x01CE: {
        T: -1
    },
    0x01CF: {
        T: 1
    },
    0x01D0: {
        T: -1
    },
    0x01D1: {
        T: 1
    },
    0x01D2: {
        T: -1
    },
    0x01D3: {
        T: 1
    },
    0x01D4: {
        T: -1
    },
    0x01D5: {
        T: 1
    },
    0x01D6: {
        T: -1
    },
    0x01D7: {},
    0x01D8: {},
    0x01D9: {
        T: 1
    },
    0x01DA: {
        T: -1
    },
    0x01DB: {},
    0x01DC: {
        f: $a1a91b25d7598376$var$parse_BrtMargins
    },
    0x01DD: {},
    0x01DE: {},
    0x01DF: {
        T: 1
    },
    0x01E0: {
        T: -1
    },
    0x01E1: {
        T: 1
    },
    0x01E2: {
        T: -1
    },
    0x01E3: {
        T: 1
    },
    0x01E4: {
        T: -1
    },
    0x01E5: {
        f: $a1a91b25d7598376$var$parse_BrtWsFmtInfo
    },
    0x01E6: {
        T: 1
    },
    0x01E7: {
        T: -1
    },
    0x01E8: {
        T: 1
    },
    0x01E9: {
        T: -1
    },
    0x01EA: {
        T: 1
    },
    0x01EB: {
        T: -1
    },
    0x01EC: {
        T: 1
    },
    0x01ED: {
        T: -1
    },
    0x01EE: {
        f: $a1a91b25d7598376$var$parse_BrtHLink
    },
    0x01EF: {
        T: 1
    },
    0x01F0: {
        T: -1
    },
    0x01F1: {
        T: 1
    },
    0x01F2: {
        T: -1
    },
    0x01F3: {},
    0x01F4: {
        T: 1
    },
    0x01F5: {
        T: -1
    },
    0x01F6: {
        T: 1
    },
    0x01F7: {
        T: -1
    },
    0x01F8: {},
    0x01F9: {
        T: 1
    },
    0x01FA: {
        T: -1
    },
    0x01FB: {},
    0x01FC: {
        T: 1
    },
    0x01FD: {
        T: -1
    },
    0x01FE: {
        T: 1
    },
    0x01FF: {
        T: -1
    },
    0x0200: {},
    0x0201: {},
    0x0202: {
        T: 1
    },
    0x0203: {
        T: -1
    },
    0x0204: {
        T: 1
    },
    0x0205: {
        T: -1
    },
    0x0206: {
        T: 1
    },
    0x0207: {
        T: -1
    },
    0x0208: {
        T: 1
    },
    0x0209: {
        T: -1
    },
    0x020A: {},
    0x020B: {},
    0x020C: {},
    0x020D: {},
    0x020E: {},
    0x020F: {},
    0x0210: {
        T: 1
    },
    0x0211: {
        T: -1
    },
    0x0212: {
        T: 1
    },
    0x0213: {
        T: -1
    },
    0x0214: {
        T: 1
    },
    0x0215: {
        T: -1
    },
    0x0216: {},
    0x0217: {},
    0x0218: {},
    0x0219: {},
    0x021A: {
        T: 1
    },
    0x021B: {
        T: -1
    },
    0x021C: {
        T: 1
    },
    0x021D: {
        T: -1
    },
    0x021E: {
        T: 1
    },
    0x0224: {},
    0x0225: {},
    0x0226: {
        f: $a1a91b25d7598376$var$parse_RelID
    },
    0x0227: {
        f: $a1a91b25d7598376$var$parse_XLNullableWideString
    },
    0x0228: {},
    0x0229: {},
    0x022A: {
        T: 1
    },
    0x022B: {
        T: -1
    },
    0x022C: {
        T: 1
    },
    0x022D: {
        T: -1
    },
    0x022E: {
        T: 1
    },
    0x022F: {
        T: -1
    },
    0x0230: {
        T: 1
    },
    0x0231: {
        T: -1
    },
    0x0232: {},
    0x0234: {},
    0x0235: {
        T: 1
    },
    0x0236: {
        T: -1
    },
    0x0239: {
        T: 1
    },
    0x023A: {
        T: -1
    },
    0x023C: {},
    0x023D: {
        T: 1
    },
    0x023E: {
        T: -1
    },
    0x0241: {},
    0x0242: {},
    0x0243: {},
    0x0244: {},
    0x0245: {},
    0x0246: {},
    0x0247: {},
    0x0248: {},
    0x0249: {},
    0x024A: {},
    0x024B: {},
    0x024C: {
        T: -1
    },
    0x024D: {},
    0x024E: {
        T: 1
    },
    0x024F: {
        T: -1
    },
    0x0250: {
        T: 1
    },
    0x0251: {
        T: -1
    },
    0x0252: {
        T: 1
    },
    0x0253: {
        T: -1
    },
    0x0254: {},
    0x0255: {
        T: 1
    },
    0x0256: {
        T: -1
    },
    0x0257: {
        T: 1
    },
    0x0258: {
        T: -1
    },
    0x0259: {
        T: 1
    },
    0x025A: {
        T: -1
    },
    0x025B: {
        T: 1
    },
    0x025C: {
        T: -1
    },
    0x025D: {
        T: 1
    },
    0x025E: {
        T: -1
    },
    0x025F: {},
    0x0260: {
        T: 1
    },
    0x0261: {
        T: -1
    },
    0x0262: {},
    0x0263: {
        T: 1
    },
    0x0264: {
        T: -1
    },
    0x0265: {
        T: 1
    },
    0x0266: {
        T: -1
    },
    0x0267: {
        T: 1
    },
    0x0268: {
        T: -1
    },
    0x0269: {
        T: 1
    },
    0x026A: {
        T: -1
    },
    0x026B: {
        T: 1
    },
    0x026C: {
        T: -1
    },
    0x0271: {},
    0x0272: {
        T: 1
    },
    0x0273: {
        T: -1
    },
    0x0274: {
        T: 1
    },
    0x0275: {
        T: -1
    },
    0x0276: {
        T: 1
    },
    0x0277: {
        T: -1
    },
    0x0278: {
        f: $a1a91b25d7598376$var$parse_BrtCommentAuthor
    },
    0x0279: {
        T: 1
    },
    0x027A: {
        T: -1
    },
    0x027B: {
        T: 1,
        f: $a1a91b25d7598376$var$parse_BrtBeginComment
    },
    0x027C: {
        T: -1
    },
    0x027D: {
        f: $a1a91b25d7598376$var$parse_BrtCommentText
    },
    0x027E: {
        T: 1
    },
    0x027F: {},
    0x0280: {
        T: -1
    },
    0x0281: {
        T: 1
    },
    0x0282: {
        T: -1
    },
    0x0283: {
        T: 1
    },
    0x0284: {},
    0x0285: {
        T: -1
    },
    0x0286: {
        T: 1
    },
    0x0288: {
        T: 1
    },
    0x0289: {},
    0x028A: {
        T: -1
    },
    0x028B: {
        f: $a1a91b25d7598376$var$parse_BrtCsProp
    },
    0x028C: {},
    0x028D: {
        T: 1
    },
    0x028E: {
        T: -1
    },
    0x028F: {
        T: 1
    },
    0x0290: {
        T: -1
    },
    0x0291: {
        T: 1
    },
    0x0292: {
        T: -1
    },
    0x0293: {},
    0x0294: {
        T: 1
    },
    0x0295: {},
    0x0296: {
        T: -1
    },
    0x0297: {},
    0x0298: {
        T: 1
    },
    0x0299: {},
    0x029A: {
        T: -1
    },
    0x029B: {},
    0x029C: {},
    0x029D: {},
    0x029F: {
        T: 1
    },
    0x02A0: {
        T: -1
    },
    0x02A1: {
        T: 1
    },
    0x02A2: {
        T: -1
    },
    0x02A3: {},
    0x02A4: {},
    0x02A5: {},
    0x02A6: {},
    0x02A7: {},
    0x02A8: {},
    0x02A9: {},
    0x0400: {},
    0x0401: {},
    0x0402: {
        T: 1
    },
    0x0403: {
        T: -1
    },
    0x0404: {
        T: 1
    },
    0x0405: {
        T: -1
    },
    0x0406: {},
    0x0407: {
        T: 1
    },
    0x0408: {
        T: -1
    },
    0x0409: {
        T: 1
    },
    0x040A: {
        T: -1
    },
    0x040B: {},
    0x040C: {},
    0x040D: {},
    0x040E: {
        T: 1
    },
    0x040F: {
        T: -1
    },
    0x0410: {},
    0x0411: {
        T: 1
    },
    0x0412: {
        T: -1
    },
    0x0413: {},
    0x0414: {},
    0x0415: {},
    0x0416: {
        T: 1
    },
    0x0417: {
        T: -1
    },
    0x0418: {
        T: 1
    },
    0x0419: {
        T: -1
    },
    0x041A: {},
    0x041B: {
        T: 1
    },
    0x041C: {
        T: 1
    },
    0x041D: {
        f: $a1a91b25d7598376$var$parse_BrtDVal14
    },
    0x041E: {
        T: 1
    },
    0x041F: {},
    0x0420: {
        T: 1
    },
    0x0421: {
        T: -1
    },
    0x0422: {
        T: 1
    },
    0x0423: {
        T: -1
    },
    0x0425: {},
    0x0426: {
        T: 1
    },
    0x0427: {
        T: -1
    },
    0x0428: {
        T: 1
    },
    0x0429: {
        T: -1
    },
    0x042A: {
        T: 1
    },
    0x042B: {
        T: -1
    },
    0x042C: {
        T: 1
    },
    0x042D: {
        T: -1
    },
    0x042E: {
        T: 1
    },
    0x042F: {
        T: -1
    },
    0x0430: {
        T: 1
    },
    0x0431: {
        T: -1
    },
    0x0433: {
        T: 1
    },
    0x0434: {
        T: -1
    },
    0x0435: {
        T: 1
    },
    0x0436: {
        T: -1
    },
    0x0437: {
        T: 1
    },
    0x0438: {
        T: -1
    },
    0x0439: {
        T: 1
    },
    0x043A: {
        T: -1
    },
    0x043B: {
        T: 1
    },
    0x043C: {
        T: -1
    },
    0x043D: {},
    0x043E: {
        T: 1
    },
    0x043F: {
        T: -1
    },
    0x0440: {
        T: 1
    },
    0x0441: {
        T: -1
    },
    0x0442: {
        T: 1
    },
    0x0443: {
        T: -1
    },
    0x0444: {
        T: 1
    },
    0x0445: {
        T: -1
    },
    0x0446: {
        T: 1
    },
    0x0447: {
        T: -1
    },
    0x0448: {},
    0x0449: {
        T: 1
    },
    0x044A: {},
    0x044B: {
        T: -1
    },
    0x044C: {
        T: 1
    },
    0x044D: {
        T: -1
    },
    0x044E: {},
    0x044F: {},
    0x0450: {},
    0x0451: {},
    0x0457: {},
    0x0458: {},
    0x0459: {
        T: 1
    },
    0x045A: {
        T: -1
    },
    0x045B: {
        T: 1
    },
    0x045C: {
        T: -1
    },
    0x045D: {},
    0x045E: {
        T: 1
    },
    0x045F: {
        T: -1
    },
    0x0460: {
        T: 1
    },
    0x0461: {
        T: -1
    },
    0x0462: {
        T: 1
    },
    0x0463: {
        T: -1
    },
    0x0464: {
        T: 1
    },
    0x0465: {
        T: -1
    },
    0x0466: {},
    0x0468: {
        T: 1
    },
    0x0469: {
        T: -1
    },
    0x046A: {},
    0x046B: {
        T: 1
    },
    0x046C: {
        T: -1
    },
    0x046D: {
        T: 1
    },
    0x046E: {
        T: -1
    },
    0x046F: {
        T: 1
    },
    0x0470: {
        T: -1
    },
    0x0471: {
        T: 1
    },
    0x0472: {
        T: -1
    },
    0x0473: {
        T: 1
    },
    0x0474: {
        T: -1
    },
    0x0475: {},
    0x0476: {
        T: 1
    },
    0x0477: {
        T: -1
    },
    0x0478: {
        T: 1
    },
    0x0479: {
        T: -1
    },
    0x047A: {},
    0x047B: {
        T: 1
    },
    0x047C: {
        T: -1
    },
    0x047D: {
        T: 1
    },
    0x047E: {
        T: -1
    },
    0x0480: {
        T: 1
    },
    0x0481: {
        T: -1
    },
    0x0482: {
        T: -1
    },
    0x0483: {
        T: -1
    },
    0x0484: {
        T: -1
    },
    0x0485: {
        T: 1
    },
    0x0486: {
        T: -1
    },
    0x0487: {
        T: 1
    },
    0x0488: {
        T: -1
    },
    0x0489: {
        T: 1
    },
    0x048A: {
        T: -1
    },
    0x048B: {
        T: 1
    },
    0x048C: {
        T: -1
    },
    0x048D: {
        T: 1
    },
    0x048E: {
        T: -1
    },
    0x048F: {
        T: 1
    },
    0x0490: {
        T: -1
    },
    0x0491: {
        T: 1
    },
    0x0492: {
        T: -1
    },
    0x0493: {},
    0x0494: {
        T: 1
    },
    0x0495: {
        T: -1
    },
    0x0499: {},
    0x049A: {
        T: 1
    },
    0x049C: {},
    0x049D: {},
    0x049E: {},
    0x0800: {
        T: 1
    },
    0x0801: {
        T: -1
    },
    0x0802: {},
    0x0803: {
        T: 1
    },
    0x0804: {
        T: -1
    },
    0x0805: {},
    0x0806: {},
    0x0807: {
        T: 1
    },
    0x0808: {
        T: -1
    },
    0x0809: {
        T: 1
    },
    0x080A: {
        T: -1
    },
    0x080C: {},
    0x0813: {},
    0x0814: {
        T: 1
    },
    0x0815: {
        T: -1
    },
    0x0816: {},
    0x0817: {},
    0x0818: {
        T: 1
    },
    0x0819: {
        T: -1
    },
    0x081B: {},
    0x081C: {},
    0x081D: {
        T: 1
    },
    0x081E: {
        T: -1
    },
    0x081F: {},
    0x0820: {
        T: 1
    },
    0x0821: {
        T: -1
    },
    0x0822: {},
    0x0823: {
        T: 1
    },
    0x0824: {
        T: -1
    },
    0x0825: {
        T: 1
    },
    0x0826: {
        T: -1
    },
    0x0827: {
        T: 1
    },
    0x0828: {
        T: -1
    },
    0x0829: {
        T: 1
    },
    0x082A: {
        T: -1
    },
    0x082B: {},
    0x082C: {},
    0x082D: {
        T: 1
    },
    0x082E: {
        T: -1
    },
    0x082F: {},
    0x0830: {
        T: 1
    },
    0x0831: {
        T: -1
    },
    0x0832: {
        T: 1
    },
    0x0833: {
        T: -1
    },
    0x0834: {
        T: 1
    },
    0x0835: {
        T: -1
    },
    0x0836: {},
    0x0837: {
        T: 1
    },
    0x0838: {
        T: -1
    },
    0x0839: {},
    0x083A: {
        T: 1
    },
    0x083B: {
        T: -1
    },
    0x083C: {},
    0x083D: {
        T: 1
    },
    0x083E: {
        T: -1
    },
    0x083F: {
        T: 1
    },
    0x0840: {
        T: -1
    },
    0x0841: {
        T: 1
    },
    0x0842: {
        T: -1
    },
    0x0843: {},
    0x0844: {},
    0x0845: {},
    0x0846: {
        T: 1
    },
    0x0847: {
        T: -1
    },
    0x0848: {},
    0x0849: {
        T: 1
    },
    0x084A: {
        T: -1
    },
    0x084B: {
        T: 1
    },
    0x084C: {
        T: -1
    },
    0x084D: {},
    0x084E: {
        T: 1
    },
    0x084F: {
        T: -1
    },
    0x0850: {},
    0x0851: {
        T: 1
    },
    0x0852: {
        T: -1
    },
    0x0853: {
        T: 1
    },
    0x0854: {
        T: -1
    },
    0x0855: {
        T: 1
    },
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {
        T: 1
    },
    0x085A: {
        T: -1
    },
    0x085B: {
        T: 1
    },
    0x085C: {
        T: -1
    },
    0x085D: {},
    0x0C00: {},
    0x0C01: {},
    0x1000: {
        T: 1
    },
    0x1001: {
        T: -1
    },
    0x138A: {
        T: 1
    },
    0x138B: {
        T: -1
    },
    0x13D9: {
        T: 1
    },
    0x13DA: {
        T: -1
    },
    0x13DB: {},
    0x13DC: {
        T: 1
    },
    0x13DD: {
        T: -1
    },
    0x13DE: {
        T: 1
    },
    0x13DF: {
        T: -1
    },
    0x13E0: {},
    0x13E1: {},
    0x13E2: {},
    0x13E4: {
        T: 1
    },
    0x13E5: {
        T: -1
    },
    0x13E6: {},
    0x13E7: {
        T: 1
    },
    0x13E8: {
        T: -1
    },
    0x13E9: {},
    0x13EB: {},
    0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $a1a91b25d7598376$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ 0x0006: {
        f: $a1a91b25d7598376$var$parse_Formula
    },
    0x000a: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x000c: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x000d: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x000e: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x000f: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0010: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    0x0011: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0012: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0013: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x0014: {
        f: $a1a91b25d7598376$var$parse_XLHeaderFooter
    },
    0x0015: {
        f: $a1a91b25d7598376$var$parse_XLHeaderFooter
    },
    0x0017: {
        f: $a1a91b25d7598376$var$parse_ExternSheet
    },
    0x0018: {
        f: $a1a91b25d7598376$var$parse_Lbl
    },
    0x0019: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x001a: {},
    0x001b: {},
    0x001c: {
        f: $a1a91b25d7598376$var$parse_Note
    },
    0x001d: {},
    0x0022: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0023: {
        f: $a1a91b25d7598376$var$parse_ExternName
    },
    0x0026: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    0x0027: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    0x0028: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    0x0029: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    0x002a: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x002b: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x002f: {
        f: $a1a91b25d7598376$var$parse_FilePass
    },
    0x0031: {
        f: $a1a91b25d7598376$var$parse_Font
    },
    0x0033: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x003c: {},
    0x003d: {
        f: $a1a91b25d7598376$var$parse_Window1
    },
    0x0040: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0041: {
        f: $a1a91b25d7598376$var$parse_Pane
    },
    0x0042: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x004d: {},
    0x0050: {},
    0x0051: {},
    0x0052: {},
    0x0055: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x0059: {},
    0x005a: {},
    0x005b: {},
    0x005c: {
        f: $a1a91b25d7598376$var$parse_WriteAccess
    },
    0x005d: {
        f: $a1a91b25d7598376$var$parse_Obj
    },
    0x005e: {},
    0x005f: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0060: {},
    0x0061: {},
    0x0063: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x007d: {
        f: $a1a91b25d7598376$var$parse_ColInfo
    },
    0x0080: {
        f: $a1a91b25d7598376$var$parse_Guts
    },
    0x0081: {
        f: $a1a91b25d7598376$var$parse_WsBool
    },
    0x0082: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x0083: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0084: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0085: {
        f: $a1a91b25d7598376$var$parse_BoundSheet8
    },
    0x0086: {},
    0x008c: {
        f: $a1a91b25d7598376$var$parse_Country
    },
    0x008d: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x0090: {},
    0x0092: {
        f: $a1a91b25d7598376$var$parse_Palette
    },
    0x0097: {},
    0x0098: {},
    0x0099: {},
    0x009a: {},
    0x009b: {},
    0x009c: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x009d: {},
    0x009e: {},
    0x00a0: {
        f: $a1a91b25d7598376$var$parse_Scl
    },
    0x00a1: {
        f: $a1a91b25d7598376$var$parse_Setup
    },
    0x00ae: {},
    0x00af: {},
    0x00b0: {},
    0x00b1: {},
    0x00b2: {},
    0x00b4: {},
    0x00b5: {},
    0x00b6: {},
    0x00b8: {},
    0x00b9: {},
    0x00bd: {
        f: $a1a91b25d7598376$var$parse_MulRk
    },
    0x00be: {
        f: $a1a91b25d7598376$var$parse_MulBlank
    },
    0x00c1: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x00c5: {},
    0x00c6: {},
    0x00c7: {},
    0x00c8: {},
    0x00c9: {},
    0x00ca: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x00cb: {},
    0x00cc: {},
    0x00cd: {},
    0x00ce: {},
    0x00cf: {},
    0x00d0: {},
    0x00d1: {},
    0x00d2: {},
    0x00d3: {},
    0x00d5: {},
    0x00d7: {},
    0x00d8: {},
    0x00d9: {},
    0x00da: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x00dc: {},
    0x00dd: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x00de: {},
    0x00e0: {
        f: $a1a91b25d7598376$var$parse_XF
    },
    0x00e1: {
        f: $a1a91b25d7598376$var$parse_InterfaceHdr
    },
    0x00e2: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x00e3: {},
    0x00e5: {
        f: $a1a91b25d7598376$var$parse_MergeCells
    },
    0x00e9: {},
    0x00eb: {},
    0x00ec: {},
    0x00ed: {},
    0x00ef: {},
    0x00f0: {},
    0x00f1: {},
    0x00f2: {},
    0x00f4: {},
    0x00f5: {},
    0x00f6: {},
    0x00f7: {},
    0x00f8: {},
    0x00f9: {},
    0x00fb: {},
    0x00fc: {
        f: $a1a91b25d7598376$var$parse_SST
    },
    0x00fd: {
        f: $a1a91b25d7598376$var$parse_LabelSst
    },
    0x00ff: {
        f: $a1a91b25d7598376$var$parse_ExtSST
    },
    0x0100: {},
    0x0103: {},
    0x0122: {},
    0x0137: {},
    0x0138: {},
    0x013b: {},
    0x013d: {
        f: $a1a91b25d7598376$var$parseuint16a
    },
    0x013e: {},
    0x013f: {},
    0x0140: {},
    0x014a: {},
    0x014b: {},
    0x014d: {},
    0x014e: {},
    0x014f: {},
    0x0150: {},
    0x0151: {},
    0x0152: {},
    0x0153: {},
    0x0154: {},
    0x015f: {},
    0x0160: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0161: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x0191: {},
    0x0192: {},
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x01a9: {},
    0x01aa: {},
    0x01ab: {},
    0x01ac: {},
    0x01ad: {},
    0x01ae: {
        f: $a1a91b25d7598376$var$parse_SupBook
    },
    0x01af: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x01b0: {},
    0x01b1: {},
    0x01b2: {},
    0x01b5: {},
    0x01b6: {
        f: $a1a91b25d7598376$var$parse_TxO
    },
    0x01b7: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x01b8: {
        f: $a1a91b25d7598376$var$parse_HLink
    },
    0x01b9: {},
    0x01ba: {
        f: $a1a91b25d7598376$var$parse_XLUnicodeString
    },
    0x01bb: {},
    0x01bc: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x01bd: {},
    0x01be: {},
    0x01c0: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x01c1: {
        f: $a1a91b25d7598376$var$parse_RecalcId,
        r: 2
    },
    0x01c2: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x0200: {
        f: $a1a91b25d7598376$var$parse_Dimensions
    },
    0x0201: {
        f: $a1a91b25d7598376$var$parse_Blank
    },
    0x0203: {
        f: $a1a91b25d7598376$var$parse_Number
    },
    0x0204: {
        f: $a1a91b25d7598376$var$parse_Label
    },
    0x0205: {
        f: $a1a91b25d7598376$var$parse_BoolErr
    },
    0x0207: {
        f: $a1a91b25d7598376$var$parse_String
    },
    0x0208: {
        f: $a1a91b25d7598376$var$parse_Row
    },
    0x020b: {},
    0x0221: {
        f: $a1a91b25d7598376$var$parse_Array
    },
    0x0225: {
        f: $a1a91b25d7598376$var$parse_DefaultRowHeight
    },
    0x0236: {},
    0x023e: {
        f: $a1a91b25d7598376$var$parse_Window2
    },
    0x027e: {
        f: $a1a91b25d7598376$var$parse_RK
    },
    0x0293: {},
    0x0418: {},
    0x041e: {
        f: $a1a91b25d7598376$var$parse_Format
    },
    0x043c: {},
    0x04bc: {
        f: $a1a91b25d7598376$var$parse_ShrFmla
    },
    0x0800: {
        f: $a1a91b25d7598376$var$parse_HLinkTooltip
    },
    0x0801: {},
    0x0802: {},
    0x0803: {},
    0x0804: {},
    0x0805: {},
    0x0806: {},
    0x0807: {},
    0x0808: {},
    0x0809: {
        f: $a1a91b25d7598376$var$parse_BOF
    },
    0x080a: {},
    0x080b: {},
    0x080c: {},
    0x080d: {},
    0x080e: {},
    0x080f: {},
    0x0810: {},
    0x0812: {},
    0x0813: {},
    0x0850: {},
    0x0851: {},
    0x0852: {},
    0x0853: {},
    0x0854: {},
    0x0855: {},
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {},
    0x085a: {},
    0x0862: {},
    0x0863: {
        r: 12
    },
    0x0864: {},
    0x0865: {},
    0x0866: {},
    0x0867: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x0868: {},
    0x086a: {},
    0x086b: {},
    0x086c: {},
    0x0871: {},
    0x0872: {},
    0x0874: {},
    0x0875: {},
    0x0876: {},
    0x0877: {},
    0x0878: {},
    0x0879: {},
    0x087a: {},
    0x087b: {},
    0x087c: {
        f: $a1a91b25d7598376$var$parse_XFCRC,
        r: 12
    },
    0x087d: {
        f: $a1a91b25d7598376$var$parse_XFExt,
        r: 12
    },
    0x087e: {},
    0x087f: {},
    0x0884: {},
    0x0885: {},
    0x0886: {},
    0x0887: {},
    0x0888: {},
    0x0889: {},
    0x088a: {},
    0x088b: {},
    0x088c: {
        f: $a1a91b25d7598376$var$parsebool,
        r: 12
    },
    0x088d: {},
    0x088e: {
        r: 12
    },
    0x088f: {},
    0x0890: {},
    0x0892: {},
    0x0893: {},
    0x0894: {
        f: $a1a91b25d7598376$var$parse_NameCmt,
        r: 12
    },
    0x0895: {},
    0x0896: {
        f: $a1a91b25d7598376$var$parse_Theme,
        r: 12
    },
    0x0897: {},
    0x0898: {},
    0x0899: {},
    0x089a: {
        f: $a1a91b25d7598376$var$parse_MTRSettings,
        r: 12
    },
    0x089b: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x089c: {},
    0x089d: {},
    0x089e: {},
    0x089f: {},
    0x08a3: {
        f: $a1a91b25d7598376$var$parse_ForceFullCalculation
    },
    0x08a4: {},
    0x08a5: {},
    0x08a6: {},
    0x08a7: {},
    0x1001: {},
    0x1002: {},
    0x1003: {},
    0x1006: {},
    0x1007: {},
    0x1009: {},
    0x100a: {},
    0x100b: {},
    0x100c: {},
    0x100d: {},
    0x1014: {},
    0x1015: {},
    0x1016: {},
    0x1017: {},
    0x1018: {},
    0x1019: {},
    0x101a: {},
    0x101b: {},
    0x101c: {},
    0x101d: {},
    0x101e: {},
    0x101f: {},
    0x1020: {},
    0x1021: {},
    0x1022: {},
    0x1024: {},
    0x1025: {},
    0x1026: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x1027: {},
    0x1032: {},
    0x1033: {},
    0x1034: {},
    0x1035: {},
    0x103a: {},
    0x103c: {},
    0x103d: {},
    0x103e: {},
    0x103f: {},
    0x1040: {},
    0x1041: {},
    0x1043: {},
    0x1044: {
        f: $a1a91b25d7598376$var$parse_ShtProps
    },
    0x1045: {},
    0x1046: {},
    0x1048: {},
    0x104a: {},
    0x104b: {},
    0x104e: {},
    0x104f: {},
    0x1050: {},
    0x1051: {},
    0x105b: {},
    0x105c: {
        f: $a1a91b25d7598376$var$parse_ClrtClient
    },
    0x105d: {},
    0x105f: {},
    0x1060: {},
    0x1061: {},
    0x1062: {},
    0x1063: {},
    0x1064: {},
    0x1065: {},
    0x1066: {},
    0x1067: {},
    0x1068: {},
    0x0000: {
        f: $a1a91b25d7598376$var$parse_Dimensions
    },
    0x0001: {},
    0x0002: {
        f: $a1a91b25d7598376$var$parse_BIFF2INT
    },
    0x0003: {
        f: $a1a91b25d7598376$var$parse_BIFF2NUM
    },
    0x0004: {
        f: $a1a91b25d7598376$var$parse_BIFF2STR
    },
    0x0005: {
        f: $a1a91b25d7598376$var$parse_BIFF2BOOLERR
    },
    0x0007: {
        f: $a1a91b25d7598376$var$parse_BIFF2STRING
    },
    0x0008: {},
    0x0009: {
        f: $a1a91b25d7598376$var$parse_BOF
    },
    0x000b: {},
    0x0016: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x001e: {
        f: $a1a91b25d7598376$var$parse_BIFF2Format
    },
    0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ 0x0020: {},
    0x0021: {
        f: $a1a91b25d7598376$var$parse_Array
    },
    0x0024: {},
    0x0025: {
        f: $a1a91b25d7598376$var$parse_DefaultRowHeight
    },
    // 0x002c ??
    // 0x002d ??
    // 0x002e ??
    // 0x0030 FONTCOUNT: number of fonts
    0x0032: {
        f: $a1a91b25d7598376$var$parse_BIFF2FONTXTRA
    },
    // 0x0035: INFOOPTS
    // 0x0036: TABLE (BIFF2 only)
    // 0x0037: TABLE2 (BIFF2 only)
    // 0x0038: WNDESK
    // 0x0039 ??
    // 0x003a: BEGINPREF
    // 0x003b: ENDPREF
    0x003e: {},
    // 0x003f ??
    // 0x0046: SHOWSCROLL
    // 0x0047: SHOWFORMULA
    // 0x0048: STATUSBAR
    // 0x0049: SHORTMENUS
    // 0x004A:
    // 0x004B:
    // 0x004C:
    // 0x004E:
    // 0x004F:
    // 0x0058: TOOLBAR (BIFF3)
    /* - - - */ 0x0034: {},
    0x0043: {
        f: $a1a91b25d7598376$var$parse_BIFF2XF
    },
    0x0044: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x0045: {},
    0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ 0x007e: {},
    /* Not necessarily same as 0x027e */ 0x007f: {
        f: $a1a91b25d7598376$var$parse_ImData
    },
    0x0087: {},
    0x0088: {},
    0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    0x008F: {
        f: $a1a91b25d7598376$var$parse_BIFF4SheetInfo
    },
    0x0091: {},
    // 0x93 STYLE
    0x0094: {},
    0x0095: {},
    0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    0x00a9: {},
    0x00ab: {},
    0x00bc: {},
    /* Not necessarily same as 0x04bc */ 0x00bf: {},
    0x00c0: {},
    0x00c2: {},
    0x00c3: {},
    0x00d6: {
        f: $a1a91b25d7598376$var$parse_RString
    },
    0x00df: {},
    0x00ea: {},
    0x0162: {},
    0x01a5: {},
    0x0206: {
        f: $a1a91b25d7598376$var$parse_Formula
    },
    0x0209: {
        f: $a1a91b25d7598376$var$parse_BOF
    },
    0x0218: {
        f: $a1a91b25d7598376$var$parse_Lbl
    },
    0x0223: {
        f: $a1a91b25d7598376$var$parse_ExternName
    },
    0x0231: {},
    0x0243: {
        f: $a1a91b25d7598376$var$parse_BIFF3XF
    },
    0x0406: {
        f: $a1a91b25d7598376$var$parse_Formula
    },
    0x0409: {
        f: $a1a91b25d7598376$var$parse_BOF
    },
    0x0443: {
        f: $a1a91b25d7598376$var$parse_BIFF4XF
    },
    0x086d: {},
    0x0873: {},
    0x0881: {},
    0x08c0: {},
    0x08c1: {},
    0x08c2: {},
    0x08c3: {},
    0x08c4: {},
    0x08c5: {},
    0x08c6: {},
    0x08c7: {},
    0x08c8: {},
    0x08c9: {},
    0x08ca: {},
    0x08cb: {},
    0x08d6: {
        r: 12
    },
    /* --- multiplan 4 records --- */ 0x0065: {},
    0x0066: {},
    0x0069: {},
    0x006a: {},
    0x006b: {},
    0x006d: {},
    0x0070: {},
    0x0072: {},
    0x7262: {}
};
function $a1a91b25d7598376$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $a1a91b25d7598376$var$is_buf(payload)) ba.push(payload);
}
function $a1a91b25d7598376$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $a1a91b25d7598376$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $a1a91b25d7598376$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val1, t /*:?string*/ ) {
    var out = $a1a91b25d7598376$var$new_buf(9);
    $a1a91b25d7598376$var$write_BIFF2Cell(out, r, c);
    $a1a91b25d7598376$var$write_Bes(val1, t || 'b', out);
    return out;
}
/* TODO: codepage, large strings */ function $a1a91b25d7598376$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val1) {
    var out = $a1a91b25d7598376$var$new_buf(8 + 2 * val1.length);
    $a1a91b25d7598376$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val1.length);
    out.write_shift(val1.length, val1, 'sbcs');
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $a1a91b25d7598376$var$write_comments_biff2(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    comments.forEach(function(data) {
        var text = data[0].map(function(cc) {
            return cc.t;
        }).join("");
        // TODO: should '\n' be translated to '\r' to correct for Excel 5.0 bug when exporting to BIFF2/3 ?
        if (text.length <= 2048) return $a1a91b25d7598376$var$write_biff_rec(ba, 0x001C, $a1a91b25d7598376$var$write_NOTE_BIFF2(text, data[1], data[2]));
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x001C, $a1a91b25d7598376$var$write_NOTE_BIFF2(text.slice(0, 2048), data[1], data[2], text.length));
        for(var i = 2048; i < text.length; i += 2048)$a1a91b25d7598376$var$write_biff_rec(ba, 0x001C, $a1a91b25d7598376$var$write_NOTE_BIFF2(text.slice(i, Math.min(i + 2048, text.length)), -1, -1, Math.min(2048, text.length - i)));
    });
}
/* TODO: BIFF3/4 use different records -- see comments*/ function $a1a91b25d7598376$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var ifmt = 0;
    if (cell.z != null) {
        ifmt = opts._BIFF2FmtTable.indexOf(cell.z);
        if (ifmt == -1) {
            opts._BIFF2FmtTable.push(cell.z);
            ifmt = opts._BIFF2FmtTable.length - 1;
        }
    }
    var ixfe = 0;
    if (cell.z != null) {
        for(; ixfe < opts.cellXfs.length; ++ixfe)if (opts.cellXfs[ixfe].numFmtId == ifmt) break;
        if (ixfe == opts.cellXfs.length) opts.cellXfs.push({
            numFmtId: ifmt
        });
    }
    if (cell.v != null) switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (opts.biff == 2 && v == (v | 0) && v >= 0 && v < 65536) // 0x027E (RK) in BIFF3/4
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0002, $a1a91b25d7598376$var$write_BIFF2INT(R, C, v, ixfe, ifmt));
            else if (isNaN(v)) // 0x0205 in BIFF3/4
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0005, $a1a91b25d7598376$var$write_BIFF2BERR(R, C, 0x24, "e")); // #NUM!
            else if (!isFinite(v)) // 0x0205 in BIFF3/4
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0005, $a1a91b25d7598376$var$write_BIFF2BERR(R, C, 0x07, "e")); // #DIV/0!
            else // 0x0203 in BIFF3/4
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0003, $a1a91b25d7598376$var$write_BIFF2NUM(R, C, v, ixfe, ifmt));
            return;
        case 'b':
        case 'e':
            // 0x0205 in BIFF3/4
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0005, $a1a91b25d7598376$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            // 0x0204 in BIFF3/4
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0004, $a1a91b25d7598376$var$write_BIFF2LABEL(R, C, cell.v == null ? "" : String(cell.v).slice(0, 255)));
            return;
    }
    // 0x0201 in BIFF3/4
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0001, $a1a91b25d7598376$var$write_BIFF2Cell(null, R, C));
}
function $a1a91b25d7598376$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var dense = ws["!data"] != null;
    var range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.r, 0x3FFF);
    }
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    var row = [], comments = [];
    /* TODO: 0x0000 / 0x0200 dimensions? */ for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $a1a91b25d7598376$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $a1a91b25d7598376$var$write_ws_biff2_cell(ba, cell, R, C, opts, date1904);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    /* ... 0x12 0x19 0x13 (Password) */ $a1a91b25d7598376$var$write_comments_biff2(ba, comments);
/* 0x3d (Window1) ... */ }
/* Based on test files */ function $a1a91b25d7598376$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var ba = $a1a91b25d7598376$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $a1a91b25d7598376$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $a1a91b25d7598376$var$write_BOF(wb, 0x10, o));
    if (((wb.Workbook || {}).WBProps || {}).date1904) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0022, $a1a91b25d7598376$var$writebool(true));
    o.cellXfs = [
        {
            numFmtId: 0
        }
    ];
    o._BIFF2FmtTable = [
        "General"
    ];
    o._Fonts = [];
    var body = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_ws_biff2(body, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    o._BIFF2FmtTable.forEach(function(f) {
        if (o.biff <= 3) $a1a91b25d7598376$var$write_biff_rec(ba, 0x001E, $a1a91b25d7598376$var$write_BIFF2Format(f));
        else $a1a91b25d7598376$var$write_biff_rec(ba, 0x041E, $a1a91b25d7598376$var$write_BIFF4Format(f));
    });
    o.cellXfs.forEach(function(xf) {
        switch(o.biff){
            case 2:
                $a1a91b25d7598376$var$write_biff_rec(ba, 0x0043, $a1a91b25d7598376$var$write_BIFF2XF(xf));
                break;
            case 3:
                $a1a91b25d7598376$var$write_biff_rec(ba, 0x0243, $a1a91b25d7598376$var$write_BIFF3XF(xf));
                break;
            case 4:
                $a1a91b25d7598376$var$write_biff_rec(ba, 0x0443, $a1a91b25d7598376$var$write_BIFF4XF(xf));
                break;
        }
    });
    delete o._BIFF2FmtTable;
    delete o.cellXfs;
    delete o._Fonts;
    ba.push(body.end());
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
var $a1a91b25d7598376$var$b8oid = 1, $a1a91b25d7598376$var$b8ocnts /*:Array<[number, number, number]>*/  = [];
function $a1a91b25d7598376$var$write_MsoDrawingGroup() {
    var buf = $a1a91b25d7598376$var$new_buf(82 + 8 * $a1a91b25d7598376$var$b8ocnts.length);
    /* [MS-ODRAW] 2.2.12 OfficeArtDggContainer */ buf.write_shift(2, 0x0F);
    buf.write_shift(2, 0xF000);
    buf.write_shift(4, 74 + 8 * $a1a91b25d7598376$var$b8ocnts.length);
    buf.write_shift(2, 0);
    buf.write_shift(2, 0xF006);
    buf.write_shift(4, 16 + 8 * $a1a91b25d7598376$var$b8ocnts.length);
    buf.write_shift(4, $a1a91b25d7598376$var$b8oid);
    buf.write_shift(4, $a1a91b25d7598376$var$b8ocnts.length + 1);
    var acc = 0;
    for(var i = 0; i < $a1a91b25d7598376$var$b8ocnts.length; ++i)acc += $a1a91b25d7598376$var$b8ocnts[i] && $a1a91b25d7598376$var$b8ocnts[i][1] || 0;
    buf.write_shift(4, acc);
    buf.write_shift(4, $a1a91b25d7598376$var$b8ocnts.length);
    /* 2.2.46 OfficeArtIDCL + */ $a1a91b25d7598376$var$b8ocnts.forEach(function(b8) {
        buf.write_shift(4, b8[0]);
        buf.write_shift(4, b8[2]);
    });
    buf.write_shift(2, 0x33); // 0x03 | (3 << 4)
    buf.write_shift(2, 0xF00B);
    buf.write_shift(4, 0x12); // 3 * 6
    /* 2.3.21.15 Text Boolean Properties */ buf.write_shift(2, 0xBF);
    buf.write_shift(4, 0x00080008);
    /* 2.3.7.2 fillColor */ buf.write_shift(2, 0x0181);
    buf.write_shift(4, 0x08000041);
    /* 2.3.8.1 lineColor */ buf.write_shift(2, 0x01C0);
    buf.write_shift(4, 0x08000040);
    buf.write_shift(2, 0x40);
    buf.write_shift(2, 0xF11E);
    buf.write_shift(4, 16);
    buf.write_shift(4, 0x0800000D);
    buf.write_shift(4, 0x0800000C);
    buf.write_shift(4, 0x08000017);
    buf.write_shift(4, 0x100000F7);
    return buf;
}
function $a1a91b25d7598376$var$write_comments_biff8(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    var notes /*:Array<RawData>*/  = [], sz = 0, pl = $a1a91b25d7598376$var$buf_array(), baseid = $a1a91b25d7598376$var$b8oid;
    var _oasc;
    comments.forEach(function(c, ci) {
        var author = "";
        var text = c[0].map(function(t) {
            if (t.a && !author) author = t.a;
            return t.t;
        }).join("");
        ++$a1a91b25d7598376$var$b8oid;
        var oasc = $a1a91b25d7598376$var$new_buf(0x96);
        oasc.write_shift(2, 0x0F);
        oasc.write_shift(2, 0xF004);
        oasc.write_shift(4, 0x96);
        oasc.write_shift(2, 0xca2); // 0x02 | (0xca << 4)
        oasc.write_shift(2, 0xF00A);
        oasc.write_shift(4, 8);
        oasc.write_shift(4, $a1a91b25d7598376$var$b8oid);
        oasc.write_shift(4, 0xA00);
        oasc.write_shift(2, 0xE3); // 0x03 | (14 << 4)
        oasc.write_shift(2, 0xF00B);
        oasc.write_shift(4, 0x54); // 14 * 6
        /* 2.3.21.1 ITxid */ oasc.write_shift(2, 0x80);
        oasc.write_shift(4, 0);
        /* 2.3.21.12 txdir */ oasc.write_shift(2, 0x8B);
        oasc.write_shift(4, 0x02);
        /* 2.3.21.15 Text Boolean Properties */ oasc.write_shift(2, 0xBF);
        oasc.write_shift(4, 0x00080008);
        /* 2.3.6.30 cxk */ oasc.write_shift(2, 0x0158);
        oasc.l += 4;
        /* 2.3.7.2 fillColor */ oasc.write_shift(2, 0x0181);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.4 fillBackColor */ oasc.write_shift(2, 0x0183);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.6 fillCrMod */ oasc.write_shift(2, 0x0185);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.7.43 Fill Style Boolean Properties */ oasc.write_shift(2, 0x01BF);
        oasc.write_shift(4, 0x00100010);
        /* 2.3.8.1 lineColor */ oasc.write_shift(2, 0x01C0);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.8.4 lineCrMod */ oasc.write_shift(2, 0x01C3);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.2 shadowColor */ oasc.write_shift(2, 0x0201);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.13.4 shadowCrMod */ oasc.write_shift(2, 0x0203);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.23 Shadow Style Boolean Properties */ oasc.write_shift(2, 0x023F);
        oasc.write_shift(4, 0x00030001);
        /* 2.3.4.44 Group Shape Boolean Properties */ oasc.write_shift(2, 0x03BF);
        oasc.write_shift(4, 0x00020000 | (c[0].hidden ? 2 : 0));
        oasc.l += 2;
        oasc.write_shift(2, 0xF010);
        oasc.write_shift(4, 0x12);
        oasc.write_shift(2, 0x3); // do not move or size with cells
        oasc.write_shift(2, c[2] + 2);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 1);
        oasc.l += 2;
        oasc.write_shift(2, c[2] + 4);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 5);
        oasc.l += 2;
        oasc.l += 2;
        oasc.write_shift(2, 0xF011);
        oasc.l += 4;
        oasc.l = 0x96;
        if (ci == 0) /* write_biff_rec(pl, 0x003C, oasc); */ _oasc = oasc;
        else $a1a91b25d7598376$var$write_biff_rec(pl, 0x00EC, oasc);
        sz += 0x96;
        var obj = $a1a91b25d7598376$var$new_buf(52); // 22 + 26 + 4
        /* [MS-XLS] 2.5.143 FtCmo */ obj.write_shift(2, 0x15);
        obj.write_shift(2, 0x12);
        obj.write_shift(2, 0x19);
        obj.write_shift(2, $a1a91b25d7598376$var$b8oid);
        obj.write_shift(2, 0);
        obj.l = 22;
        /* [MS-XLS] 2.5.149 FtNts */ obj.write_shift(2, 0x0D);
        obj.write_shift(2, 0x16);
        obj.write_shift(4, 0x62726272);
        obj.write_shift(4, 0x95374305);
        obj.write_shift(4, 0x80301328);
        obj.write_shift(4, 0x69696904 + $a1a91b25d7598376$var$b8oid * 256);
        obj.write_shift(2, 0);
        obj.write_shift(4, 0);
        // reserved
        obj.l += 4;
        $a1a91b25d7598376$var$write_biff_rec(pl, 0x005D, obj);
        var oact = $a1a91b25d7598376$var$new_buf(8);
        oact.l += 2;
        oact.write_shift(2, 0xF00D);
        oact.l += 4;
        $a1a91b25d7598376$var$write_biff_rec(pl, 0x00EC, oact);
        sz += 8;
        var txo = $a1a91b25d7598376$var$new_buf(18);
        txo.write_shift(2, 0x12);
        txo.l += 8;
        txo.write_shift(2, text.length);
        txo.write_shift(2, 0x10);
        txo.l += 4;
        $a1a91b25d7598376$var$write_biff_rec(pl, 0x01b6, txo);
        var cont = $a1a91b25d7598376$var$new_buf(1 + text.length);
        cont.write_shift(1, 0);
        cont.write_shift(text.length, text, "sbcs");
        $a1a91b25d7598376$var$write_biff_rec(pl, 0x003C, cont);
        var conf = $a1a91b25d7598376$var$new_buf(0x10);
        conf.l += 8;
        conf.write_shift(2, text.length);
        conf.l += 6;
        $a1a91b25d7598376$var$write_biff_rec(pl, 0x003C, conf);
        var notesh = $a1a91b25d7598376$var$new_buf(12 + author.length);
        notesh.write_shift(2, c[1]);
        notesh.write_shift(2, c[2]);
        notesh.write_shift(2, 0 | (c[0].hidden ? 0 : 2));
        notesh.write_shift(2, $a1a91b25d7598376$var$b8oid);
        notesh.write_shift(2, author.length);
        notesh.write_shift(1, 0);
        notesh.write_shift(author.length, author, "sbcs");
        notesh.l++;
        notes.push(notesh);
    });
    var hdr = $a1a91b25d7598376$var$new_buf(80);
    hdr.write_shift(2, 0x0F);
    hdr.write_shift(2, 0xF002);
    hdr.write_shift(4, sz + hdr.length - 8);
    hdr.write_shift(2, 0x10);
    hdr.write_shift(2, 0xF008);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, comments.length + 1);
    hdr.write_shift(4, $a1a91b25d7598376$var$b8oid);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF003);
    hdr.write_shift(4, sz + 0x30);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF004);
    hdr.write_shift(4, 0x28);
    hdr.write_shift(2, 0x01);
    hdr.write_shift(2, 0xF009);
    hdr.write_shift(4, 0x10);
    hdr.l += 16;
    hdr.write_shift(2, 0x02);
    hdr.write_shift(2, 0xF00A);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, baseid);
    hdr.write_shift(4, 0x05);
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x00EC, /* hdr */ _oasc ? $a1a91b25d7598376$var$bconcat([
        hdr,
        _oasc
    ]) : hdr);
    ba.push(pl.end());
    notes.forEach(function(n) {
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x001C, n);
    });
    $a1a91b25d7598376$var$b8ocnts.push([
        baseid,
        comments.length + 1,
        $a1a91b25d7598376$var$b8oid
    ]);
    ++$a1a91b25d7598376$var$b8oid;
}
function $a1a91b25d7598376$var$write_FONTS_biff8(ba, data, opts) {
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0031 /* Font */ , $a1a91b25d7598376$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $a1a91b25d7598376$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $a1a91b25d7598376$var$write_biff_rec(ba, 0x041E /* Format */ , $a1a91b25d7598376$var$write_Format(i, NF[i], opts));
    });
}
function $a1a91b25d7598376$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $a1a91b25d7598376$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $a1a91b25d7598376$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $a1a91b25d7598376$var$write_Ref8U($a1a91b25d7598376$var$safe_decode_range(ws['!ref'] || "A1"), o);
    o.write_shift(4, 4);
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $a1a91b25d7598376$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$a1a91b25d7598376$var$write_biff_rec(ba, 0x00e0 /* XF */ , $a1a91b25d7598376$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x00e0 /* XF */ , $a1a91b25d7598376$var$write_XF(c, 0, opts));
    });
}
function $a1a91b25d7598376$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws['!links'].length; ++R){
        var HL = ws['!links'][R];
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $a1a91b25d7598376$var$write_HLink(HL));
        if (HL[1].Tooltip) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $a1a91b25d7598376$var$write_HLinkTooltip(HL));
    }
    delete ws['!links'];
}
function $a1a91b25d7598376$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $a1a91b25d7598376$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $a1a91b25d7598376$var$write_ColInfo($a1a91b25d7598376$var$col_obj_w(idx, col), idx));
    });
}
function $a1a91b25d7598376$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var os = 16 + $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x0201 /* Blank */ , $a1a91b25d7598376$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0006 /* Formula */ , $a1a91b25d7598376$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (isNaN(v)) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $a1a91b25d7598376$var$write_BoolErr(R, C, 0x24, os, opts, "e")); // #NUM!
            else if (!isFinite(v)) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $a1a91b25d7598376$var$write_BoolErr(R, C, 0x07, os, opts, "e")); // #DIV/0!
            else $a1a91b25d7598376$var$write_biff_rec(ba, 0x0203 /* Number */ , $a1a91b25d7598376$var$write_Number(R, C, v, os, opts));
            break;
        case 'b':
        case 'e':
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $a1a91b25d7598376$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            if (opts.bookSST) {
                var isst = $a1a91b25d7598376$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                $a1a91b25d7598376$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $a1a91b25d7598376$var$write_LabelSst(R, C, isst, os, opts));
            } else $a1a91b25d7598376$var$write_biff_rec(ba, 0x0204 /* Label */ , $a1a91b25d7598376$var$write_Label(R, C, (cell.v == null ? "" : String(cell.v)).slice(0, 255), os, opts));
            break;
        default:
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0201 /* Blank */ , $a1a91b25d7598376$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $a1a91b25d7598376$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $a1a91b25d7598376$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = ws["!data"] != null;
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref'] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV" + MAX_ROWS);
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.r, MAX_ROWS - 1);
    }
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0809, $a1a91b25d7598376$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $a1a91b25d7598376$var$writeuint16(1));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $a1a91b25d7598376$var$writeuint16(100));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $a1a91b25d7598376$var$writebool(true));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $a1a91b25d7598376$var$write_Xnum(0.001));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $a1a91b25d7598376$var$writebool(true));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $a1a91b25d7598376$var$writeuint16(1));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0080 /* Guts */ , $a1a91b25d7598376$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $a1a91b25d7598376$var$writebool(false));
    /* ... */ if (b8) $a1a91b25d7598376$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x0200 /* Dimensions */ , $a1a91b25d7598376$var$write_Dimensions(range, opts));
    /* ... */ var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    if (b8) ws['!links'] = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
    var comments = [];
    var row = [];
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $a1a91b25d7598376$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $a1a91b25d7598376$var$write_ws_biff8_cell(ba, cell, R, C, opts, date1904);
            if (b8 && cell.l) ws['!links'].push([
                cols[C] + rr,
                cell.l
            ]);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ if (b8) $a1a91b25d7598376$var$write_comments_biff8(ba, comments);
    else $a1a91b25d7598376$var$write_comments_biff2(ba, comments);
    /* ... */ if (b8) $a1a91b25d7598376$var$write_biff_rec(ba, 0x023e /* Window2 */ , $a1a91b25d7598376$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws['!merges'] || []).length) $a1a91b25d7598376$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $a1a91b25d7598376$var$write_MergeCells(ws['!merges']));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $a1a91b25d7598376$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $a1a91b25d7598376$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $a1a91b25d7598376$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $a1a91b25d7598376$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $a1a91b25d7598376$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0809, $a1a91b25d7598376$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $a1a91b25d7598376$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $a1a91b25d7598376$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $a1a91b25d7598376$var$writeuint16(0x04b0) : null);
    $a1a91b25d7598376$var$write_biff_rec(A, 0x00c1 /* Mms */ , $a1a91b25d7598376$var$writezeroes(2));
    if (b5) $a1a91b25d7598376$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $a1a91b25d7598376$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $a1a91b25d7598376$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $a1a91b25d7598376$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $a1a91b25d7598376$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $a1a91b25d7598376$var$write_biff_rec(A, 0x0042 /* CodePage */ , $a1a91b25d7598376$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x0161 /* DSF */ , $a1a91b25d7598376$var$writeuint16(0));
    if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $a1a91b25d7598376$var$write_biff_rec(A, 0x013d /* RRTabId */ , $a1a91b25d7598376$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $a1a91b25d7598376$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $a1a91b25d7598376$var$write_biff_rec(A, 0x01ba /* CodeName */ , $a1a91b25d7598376$var$write_XLUnicodeString(cname, opts));
    }
    $a1a91b25d7598376$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $a1a91b25d7598376$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $a1a91b25d7598376$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0012 /* Protect */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0013 /* Password */ , $a1a91b25d7598376$var$writeuint16(0));
    if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $a1a91b25d7598376$var$writebool(false));
    if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $a1a91b25d7598376$var$writeuint16(0));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x003d /* Window1 */ , $a1a91b25d7598376$var$write_Window1(opts));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0040 /* Backup */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x008d /* HideObj */ , $a1a91b25d7598376$var$writeuint16(0));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $a1a91b25d7598376$var$writebool($a1a91b25d7598376$var$safe1904(wb) == "true"));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $a1a91b25d7598376$var$writebool(true));
    if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x00DA /* BookBool */ , $a1a91b25d7598376$var$writeuint16(0));
    /* ... */ $a1a91b25d7598376$var$write_FONTS_biff8(A, wb, opts);
    $a1a91b25d7598376$var$write_FMTS_biff8(A, wb.SSF, opts);
    $a1a91b25d7598376$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $a1a91b25d7598376$var$writebool(false));
    var a = A.end();
    var C = $a1a91b25d7598376$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $a1a91b25d7598376$var$write_biff_rec(C, 0x008C /* Country */ , $a1a91b25d7598376$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture */ /* BIFF8: MsoDrawingGroup [*Continue] */ if (b8 && $a1a91b25d7598376$var$b8ocnts.length) $a1a91b25d7598376$var$write_biff_rec(C, 0x00EB /* MsoDrawingGroup */ , $a1a91b25d7598376$var$write_MsoDrawingGroup());
    /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $a1a91b25d7598376$var$write_biff_continue(C, 0x00FC /* SST */ , $a1a91b25d7598376$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $a1a91b25d7598376$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $a1a91b25d7598376$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $a1a91b25d7598376$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $a1a91b25d7598376$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $a1a91b25d7598376$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $a1a91b25d7598376$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb && wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    $a1a91b25d7598376$var$b8oid = 1;
    $a1a91b25d7598376$var$b8ocnts = [];
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $a1a91b25d7598376$var$fix_write_opts(o);
    o.cellXfs = [];
    $a1a91b25d7598376$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $a1a91b25d7598376$var$write_ws_biff8(i, o, wb);
    bufs.unshift($a1a91b25d7598376$var$write_biff8_global(wb, bufs, o));
    return $a1a91b25d7598376$var$bconcat(bufs);
}
function $a1a91b25d7598376$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
        if (range.e.r > 65535) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond row 65536.  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $a1a91b25d7598376$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $a1a91b25d7598376$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $a1a91b25d7598376$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    var dense = opts.dense != null ? opts.dense : $a1a91b25d7598376$var$DENSE;
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (dense) ws["!data"] = [];
    str = $a1a91b25d7598376$var$str_remove_ng(str, "<!--", "-->");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $a1a91b25d7598376$var$split_regex(str.slice(i, j), /(:?<tr[^<>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $a1a91b25d7598376$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $a1a91b25d7598376$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: 's',
                v: m
            };
            if (opts.raw || !m.trim().length || _t == 's') ;
            else if (m === 'TRUE') o = {
                t: 'b',
                v: true
            };
            else if (m === 'FALSE') o = {
                t: 'b',
                v: false
            };
            else if (!isNaN($a1a91b25d7598376$var$fuzzynum(m))) o = {
                t: 'n',
                v: $a1a91b25d7598376$var$fuzzynum(m)
            };
            else if (!isNaN($a1a91b25d7598376$var$fuzzydate(m).getDate())) {
                o = {
                    t: 'd',
                    v: $a1a91b25d7598376$var$parseDate(m)
                } /*:any*/ ;
                if (opts.UTC === false) o.v = $a1a91b25d7598376$var$utc_to_local(o.v);
                if (!opts.cellDates) o = {
                    t: 'n',
                    v: $a1a91b25d7598376$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $a1a91b25d7598376$var$table_fmt[14];
            } else if (m.charCodeAt(0) == 35 /* # */  && $a1a91b25d7598376$var$RBErr[m] != null) {
                o.t = 'e';
                o.w = m;
                o.v = $a1a91b25d7598376$var$RBErr[m];
            }
            if (o.cellText !== false) o.w = m;
            if (dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = o;
            } else ws[$a1a91b25d7598376$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $a1a91b25d7598376$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws['!merges'] || [];
    var oo /*:Array<string>*/  = [];
    var sp = {} /*:any*/ ;
    var dense = ws["!data"] != null;
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R);
        var cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
        if (cell && cell.t == 'n' && cell.v != null && !isFinite(cell.v)) {
            if (isNaN(cell.v)) cell = {
                t: 'e',
                v: 0x24,
                w: $a1a91b25d7598376$var$BErr[0x24]
            };
            else cell = {
                t: 'e',
                v: 0x07,
                w: $a1a91b25d7598376$var$BErr[0x07]
            };
        }
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $a1a91b25d7598376$var$escapehtml(cell.w || ($a1a91b25d7598376$var$format_cell(cell), cell.w) || "")) || "";
        sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + '</span>';
        else if (cell) {
            sp["data-t"] = cell && cell.t || 'z';
            // note: data-v is unaffected by the timezone interpretation
            if (cell.v != null) sp["data-v"] = $a1a91b25d7598376$var$escapehtml(cell.v instanceof Date ? cell.v.toISOString() : cell.v);
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + $a1a91b25d7598376$var$escapehtml(cell.l.Target) + '">' + w + '</a>';
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($a1a91b25d7598376$var$writextag('td', w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $a1a91b25d7598376$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $a1a91b25d7598376$var$HTML_END = '</body></html>';
function $a1a91b25d7598376$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = $a1a91b25d7598376$var$str_match_xml_ig(str, "table");
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) {
        var w = $a1a91b25d7598376$var$sheet_to_workbook($a1a91b25d7598376$var$html_to_sheet(mtch[0], opts), opts);
        w.bookType = "html";
        return w;
    }
    var wb = $a1a91b25d7598376$var$book_new();
    mtch.forEach(function(s, idx) {
        $a1a91b25d7598376$var$book_append_sheet(wb, $a1a91b25d7598376$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    wb.bookType = "html";
    return wb;
}
function $a1a91b25d7598376$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
}
function $a1a91b25d7598376$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $a1a91b25d7598376$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $a1a91b25d7598376$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $a1a91b25d7598376$var$decode_range(ws['!ref'] || "A1");
    out.push($a1a91b25d7598376$var$make_html_preamble(ws, r, o));
    if (ws["!ref"]) for(var R = r.s.r; R <= r.e.r; ++R)out.push($a1a91b25d7598376$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $a1a91b25d7598376$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.rows;
    if (!rows) /* not an HTML TABLE */ throw "Unsupported origin when " + table.tagName + " is not a TABLE";
    var opts = _opts || {};
    var dense = ws["!data"] != null;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == 'number') or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $a1a91b25d7598376$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws['!cols'] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($a1a91b25d7598376$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.cells;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $a1a91b25d7598376$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : $a1a91b25d7598376$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute('data-z') || elt.getAttribute('z');
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: 's',
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || 'z';
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (_t == "e" && $a1a91b25d7598376$var$BErr[+v]) o = {
                    t: 'e',
                    v: +v,
                    w: $a1a91b25d7598376$var$BErr[+v]
                };
                else if (v === 'TRUE') o = {
                    t: 'b',
                    v: true
                };
                else if (v === 'FALSE') o = {
                    t: 'b',
                    v: false
                };
                else if (!isNaN($a1a91b25d7598376$var$fuzzynum(v))) o = {
                    t: 'n',
                    v: $a1a91b25d7598376$var$fuzzynum(v)
                };
                else if (!isNaN($a1a91b25d7598376$var$fuzzydate(v).getDate())) {
                    o = {
                        t: 'd',
                        v: $a1a91b25d7598376$var$parseDate(v)
                    } /*:any*/ ;
                    if (opts.UTC) o.v = $a1a91b25d7598376$var$local_to_utc(o.v);
                    if (!opts.cellDates) o = {
                        t: 'n',
                        v: $a1a91b25d7598376$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                } else if (v.charCodeAt(0) == 35 /* # */  && $a1a91b25d7598376$var$RBErr[v] != null) o = {
                    t: 'e',
                    v: $a1a91b25d7598376$var$RBErr[v],
                    w: v
                };
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#" && l.slice(0, 11).toLowerCase() != 'javascript:') o.l = {
                Target: l
            };
            if (dense) {
                if (!ws["!data"][R + or_R]) ws["!data"][R + or_R] = [];
                ws["!data"][R + or_R][C + or_C] = o;
            } else ws[$a1a91b25d7598376$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
    if (R >= sheetRows) ws['!fullref'] = $a1a91b25d7598376$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $a1a91b25d7598376$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    return $a1a91b25d7598376$var$sheet_add_dom(ws, table, _opts);
}
function $a1a91b25d7598376$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    var o = $a1a91b25d7598376$var$sheet_to_workbook($a1a91b25d7598376$var$parse_dom_table(table, opts), opts);
    //o.bookType = "dom"; // TODO: define a type for this
    return o;
}
function $a1a91b25d7598376$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = '';
    var get_computed_style /*:?function*/  = $a1a91b25d7598376$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue('display');
    if (!display) display = element.style && element.style.display;
    return display === 'none';
}
/* global getComputedStyle */ function $a1a91b25d7598376$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === 'function') return getComputedStyle;
    return null;
}
/* OpenDocument */ function $a1a91b25d7598376$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^<>]*\/>/g, "\t").replace(/<text:line-break\/>/g, "\n");
    var v = $a1a91b25d7598376$var$unescapexml(fixed.replace(/<[^<>]*>/g, ""));
    return [
        v
    ];
}
/* Note: ODS can stick styles in content.xml or styles.xml, FODS blurs lines */ function $a1a91b25d7598376$var$parse_ods_styles(d /*:string*/ , _opts, _nfm) {
    var number_format_map = _nfm || {};
    var str = $a1a91b25d7598376$var$xlml_normalize(d);
    $a1a91b25d7598376$var$xlmlregex.lastIndex = 0;
    str = $a1a91b25d7598376$var$remove_doctype($a1a91b25d7598376$var$str_remove_ng(str, "<!--", "-->"));
    var Rn, NFtag, NF = "", tNF = "", y, etpos = 0, tidx = -1, infmt = false, payload = "";
    while(Rn = $a1a91b25d7598376$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        /* Number Format Definitions */ case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
        case 'text-style':
            if (Rn[1] === '/') {
                infmt = false;
                if (NFtag['truncate-on-overflow'] == "false") {
                    if (NF.match(/h/)) NF = NF.replace(/h+/, "[$&]");
                    else if (NF.match(/m/)) NF = NF.replace(/m+/, "[$&]");
                    else if (NF.match(/s/)) NF = NF.replace(/s+/, "[$&]");
                }
                number_format_map[NFtag.name] = NF;
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            }
            break;
        // LibreOffice bug https://bugs.documentfoundation.org/show_bug.cgi?id=149484
        case 'boolean-style':
            if (Rn[1] === '/') {
                infmt = false;
                number_format_map[NFtag.name] = "General";
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            }
            break;
        /* Number Format Elements */ case 'boolean':
            NF += "General"; // ODF spec is unfortunately underspecified here
            break;
        case 'text':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                if (payload == "%" && NFtag[0] == '<number:percentage-style') NF += "%";
                else NF += '"' + payload.replace(/"/g, '""') + '"';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
            break;
        case 'day':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "d";
                    break;
                case "long":
                    NF += "dd";
                    break;
                default:
                    NF += "dd";
                    break; // TODO: error condition
            }
            break;
        case 'day-of-week':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ddd";
                    break;
                case "long":
                    NF += "dddd";
                    break;
                default:
                    NF += "ddd";
                    break;
            }
            break;
        case 'era':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ee";
                    break;
                case "long":
                    NF += "eeee";
                    break;
                default:
                    NF += "eeee";
                    break; // TODO: error condition
            }
            break;
        case 'hours':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "h";
                    break;
                case "long":
                    NF += "hh";
                    break;
                default:
                    NF += "hh";
                    break; // TODO: error condition
            }
            break;
        case 'minutes':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "mm";
                    break; // TODO: error condition
            }
            break;
        case 'month':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (y["textual"]) NF += "mm";
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "m";
                    break;
            }
            break;
        case 'seconds':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "s";
                    break;
                case "long":
                    NF += "ss";
                    break;
                default:
                    NF += "ss";
                    break; // TODO: error condition
            }
            if (y["decimal-places"]) NF += "." + $a1a91b25d7598376$var$fill("0", +y["decimal-places"]);
            break;
        case 'year':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "yy";
                    break;
                case "long":
                    NF += "yyyy";
                    break;
                default:
                    NF += "yy";
                    break; // TODO: error condition
            }
            break;
        case 'am-pm':
            NF += "AM/PM"; // LO autocorrects A/P -> AM/PM
            break;
        case 'week-of-year':
        case 'quarter':
            console.error("Excel does not support ODS format token " + Rn[3]);
            break;
        case 'fill-character':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                NF += '"' + payload.replace(/"/g, '""') + '"*';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
            break;
        case 'scientific-number':
            // TODO: find a mapping for all parameters
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            NF += "0." + $a1a91b25d7598376$var$fill("0", +y["min-decimal-places"] || +y["decimal-places"] || 2) + $a1a91b25d7598376$var$fill("?", +y["decimal-places"] - +y["min-decimal-places"] || 0) + "E" + ($a1a91b25d7598376$var$parsexmlbool(y["forced-exponent-sign"]) ? "+" : "") + $a1a91b25d7598376$var$fill("0", +y["min-exponent-digits"] || 2);
            break;
        case 'fraction':
            // TODO: find a mapping for all parameters
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (!+y["min-integer-digits"]) NF += "#";
            else NF += $a1a91b25d7598376$var$fill("0", +y["min-integer-digits"]);
            NF += " ";
            NF += $a1a91b25d7598376$var$fill("?", +y["min-numerator-digits"] || 1);
            NF += "/";
            if (+y["denominator-value"]) NF += y["denominator-value"];
            else NF += $a1a91b25d7598376$var$fill("?", +y["min-denominator-digits"] || 1);
            break;
        case 'currency-symbol':
            // TODO: localization with [$-...]
            if (Rn[1] === '/') NF += '"' + str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
            else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
            else NF += "$";
            break;
        case 'text-properties':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch((y["color"] || "").toLowerCase().replace("#", "")){
                case "ff0000":
                case "red":
                    NF = "[Red]" + NF;
                    break;
            }
            break;
        case 'text-content':
            NF += "@";
            break;
        case 'map':
            // TODO: handle more complex maps
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if ($a1a91b25d7598376$var$unescapexml(y["condition"]) == "value()>=0") NF = number_format_map[y["apply-style-name"]] + ";" + NF;
            else console.error("ODS number format may be incorrect: " + y["condition"]);
            break;
        case 'number':
            // TODO: handle all the attributes
            if (Rn[1] === '/') break;
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            tNF = "";
            tNF += $a1a91b25d7598376$var$fill("0", +y["min-integer-digits"] || 1);
            if ($a1a91b25d7598376$var$parsexmlbool(y["grouping"])) tNF = $a1a91b25d7598376$var$commaify($a1a91b25d7598376$var$fill("#", Math.max(0, 4 - tNF.length)) + tNF);
            if (+y["min-decimal-places"] || +y["decimal-places"]) tNF += ".";
            if (+y["min-decimal-places"]) tNF += $a1a91b25d7598376$var$fill("0", +y["min-decimal-places"] || 1);
            if (+y["decimal-places"] - (+y["min-decimal-places"] || 0)) tNF += $a1a91b25d7598376$var$fill("0", +y["decimal-places"] - (+y["min-decimal-places"] || 0)); // TODO: should this be "#" ?
            NF += tNF;
            break;
        case 'embedded-text':
            // TODO: verify interplay with grouping et al
            if (Rn[1] === '/') {
                if (etpos == 0) NF += '"' + str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
                else NF = NF.slice(0, etpos) + '"' + str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"' + NF.slice(etpos);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                tidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
                etpos = -+$a1a91b25d7598376$var$parsexmltag(Rn[0], false)["position"] || 0;
            }
            break;
    }
    return number_format_map;
}
function $a1a91b25d7598376$var$parse_content_xml(d /*:string*/ , _opts, _nfm) /*:Workbook*/ {
    var opts = _opts || {};
    if ($a1a91b25d7598376$var$DENSE != null && opts.dense == null) opts.dense = $a1a91b25d7598376$var$DENSE;
    var str = $a1a91b25d7598376$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var nfidx, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ , ctag2 = {} /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ , oldtextp = "", oldtextpidx = 0;
    var textR = [], oldtextR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = _nfm || {}, styles = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: [],
        WBProps: {}
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    $a1a91b25d7598376$var$xlmlregex.lastIndex = 0;
    str = $a1a91b25d7598376$var$remove_doctype($a1a91b25d7598376$var$str_remove_ng(str, "<!--", "-->"));
    while(Rn = $a1a91b25d7598376$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        case 'table':
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === '/') {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
                else ws['!ref'] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws['!fullref'] = ws['!ref'];
                    range.e.r = opts.sheetRows - 1;
                    ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
                }
                if (merges.length) ws['!merges'] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== 'undefined') JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                sheetag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = {} /*:any*/ ;
                if (opts.dense) ws["!data"] = [];
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case 'table-row-group':
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case 'table-row':
        case "\u884C":
            if (Rn[1] === '/') {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag['number-rows-repeated'] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case 'covered-table-cell':
            if (Rn[1] !== '/') {
                ++C;
                ctag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10) || 1;
                if (opts.sheetStubs) {
                    while(colpeat-- > 0){
                        if (opts.dense) {
                            if (!ws["!data"][R]) ws["!data"][R] = [];
                            ws["!data"][R][C] = {
                                t: 'z'
                            };
                        } else ws[$a1a91b25d7598376$var$encode_cell({
                            r: R,
                            c: C
                        })] = {
                            t: 'z'
                        };
                        ++C;
                    }
                    --C;
                } else C += colpeat - 1;
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case 'table-cell':
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === '/') {
                ++C;
                ctag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10) || 1;
                q = {
                    t: 'z',
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $a1a91b25d7598376$var$ods_to_csf_formula($a1a91b25d7598376$var$unescapexml(ctag.formula));
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type']) == "string") {
                    q.t = "s";
                    q.v = $a1a91b25d7598376$var$unescapexml(ctag['string-value'] || "");
                    if (opts.dense) {
                        if (!ws["!data"][R]) ws["!data"][R] = [];
                        ws["!data"][R][C] = q;
                    } else ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R)] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== '/') {
                ++C;
                textp = oldtextp = "";
                textpidx = oldtextpidx = 0;
                textR = [];
                oldtextR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                ctag2 = $a1a91b25d7598376$var$parsexmltagraw(Rn[0], true);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type'],
                    v: null
                } /*:any*/ ;
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $a1a91b25d7598376$var$unescapexml(ctag.formula);
                    if (ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
                        mR = parseInt(ctag['number-matrix-rows-spanned'], 10) || 0;
                        mC = parseInt(ctag['number-matrix-columns-spanned'], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $a1a91b25d7598376$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $a1a91b25d7598376$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
                    mR = parseInt(ctag['number-rows-spanned'] || "1", 10) || 1;
                    mC = parseInt(ctag['number-columns-spanned'] || "1", 10) || 1;
                    if (mR * mC > 1) {
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        merges.push(mrange);
                    }
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
                /* 19.385 office:value-type TODO: verify ODS and UOS */ switch(q.t){
                    case 'boolean':
                        q.t = 'b';
                        q.v = $a1a91b25d7598376$var$parsexmlbool(ctag['boolean-value']) || +ctag['boolean-value'] >= 1;
                        break;
                    case 'float':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        if (opts.cellDates && q.z && $a1a91b25d7598376$var$fmt_is_date(q.z)) {
                            q.v = $a1a91b25d7598376$var$numdate(q.v + (WB.WBProps.date1904 ? 1462 : 0));
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        break;
                    case 'percentage':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'currency':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'date':
                        q.t = 'd';
                        q.v = $a1a91b25d7598376$var$parseDate(ctag['date-value'], WB.WBProps.date1904);
                        if (!opts.cellDates) {
                            q.t = 'n';
                            q.v = $a1a91b25d7598376$var$datenum(q.v, WB.WBProps.date1904);
                        }
                        if (!q.z) q.z = 'm/d/yy';
                        break;
                    /* NOTE: for `time`, Excel ODS export incorrectly uses durations relative to 1900 epoch even if 1904 is specified */ case 'time':
                        q.t = 'n';
                        q.v = $a1a91b25d7598376$var$parse_isodur(ctag['time-value']) / 86400;
                        if (opts.cellDates) {
                            q.v = $a1a91b25d7598376$var$numdate(q.v);
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        if (!q.z) q.z = 'HH:MM:SS';
                        break;
                    case 'number':
                        q.t = 'n';
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === 'string' || q.t === 'text' || !q.t) {
                            q.t = 's';
                            if (ctag['string-value'] != null) {
                                textp = $a1a91b25d7598376$var$unescapexml(ctag['string-value']);
                                textR = [];
                            }
                        } else throw new Error('Unsupported value type ' + q.t);
                }
            } else {
                isstub = false;
                if (ctag2['calcext:value-type'] == "error" && $a1a91b25d7598376$var$RBErr[textp] != null) {
                    q.t = 'e';
                    q.w = textp;
                    q.v = $a1a91b25d7598376$var$RBErr[textp];
                }
                if (q.t === 's') {
                    q.v = textp || '';
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                        if (opts.dense) {
                            if (!ws["!data"][R + rpt]) ws["!data"][R + rpt] = [];
                            ws["!data"][R + rpt][C] = rpt == 0 ? q : $a1a91b25d7598376$var$dup(q);
                            while(--colpeat > 0)ws["!data"][R + rpt][C + colpeat] = $a1a91b25d7598376$var$dup(q);
                        } else {
                            ws[$a1a91b25d7598376$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$a1a91b25d7598376$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $a1a91b25d7598376$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case 'document':
        case 'document-content':
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case 'spreadsheet':
        case "\u4E3B\u4F53":
        case 'scripts':
        case 'styles':
        case 'font-face-decls':
        case 'master-styles':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'annotation':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
                textp = oldtextp;
                textpidx = oldtextpidx;
                textR = oldtextR;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                state.push([
                    Rn[3],
                    false
                ]);
                var annotag = $a1a91b25d7598376$var$parsexmltag(Rn[0], true);
                /* office:display TODO: check if there is a global override */ if (!(annotag["display"] && $a1a91b25d7598376$var$parsexmlbool(annotag["display"]))) comments.hidden = true;
                oldtextp = textp;
                oldtextpidx = textpidx;
                oldtextR = textR;
                textp = "";
                textpidx = 0;
                textR = [];
            }
            creator = "";
            creatoridx = 0;
            break;
        case 'creator':
            if (Rn[1] === '/') creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case 'meta':
        case "\u5143\u6570\u636E":
        case 'settings':
        case 'config-item-set':
        case 'config-item-map-indexed':
        case 'config-item-map-entry':
        case 'config-item-map-named':
        case 'shapes':
        case 'frame':
        case 'text-box':
        case 'image':
        case 'data-pilot-tables':
        case 'list-style':
        case 'form':
        case 'dde-links':
        case 'event-listeners':
        case 'chart':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case 'scientific-number':
        case 'currency-symbol':
        case 'fill-character':
            break;
        case 'text-style':
        case 'boolean-style':
        case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
            if (Rn[1] === '/') {
                var xlmlidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
                $a1a91b25d7598376$var$parse_ods_styles(str.slice(nfidx, $a1a91b25d7598376$var$xlmlregex.lastIndex), _opts, number_format_map);
                $a1a91b25d7598376$var$xlmlregex.lastIndex = xlmlidx;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') nfidx = $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length;
            break;
        case 'script':
            break; // 3.13 <office:script>
        case 'libraries':
            break; // TODO: <ooo:libraries>
        case 'automatic-styles':
            break; // 3.15.3 <office:automatic-styles>
        case 'default-style':
        case 'page-layout':
            break; // TODO: <style:page-layout>
        case 'style':
            var styletag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (styletag["family"] == "table-cell" && number_format_map[styletag["data-style-name"]]) styles[styletag["name"]] = number_format_map[styletag["data-style-name"]];
            break;
        case 'map':
            break; // 16.3 <style:map>
        case 'font-face':
            break; // 16.21 <style:font-face>
        case 'paragraph-properties':
            break; // 17.6 <style:paragraph-properties>
        case 'table-properties':
            break; // 17.15 <style:table-properties>
        case 'table-column-properties':
            break; // 17.16 <style:table-column-properties>
        case 'table-row-properties':
            break; // 17.17 <style:table-row-properties>
        case 'table-cell-properties':
            break; // 17.18 <style:table-cell-properties>
        case 'number':
            break;
        case 'fraction':
            break; // TODO 16.27.6 <number:fraction>
        case 'day':
        case 'month':
        case 'year':
        case 'era':
        case 'day-of-week':
        case 'week-of-year':
        case 'quarter':
        case 'hours':
        case 'minutes':
        case 'seconds':
        case 'am-pm':
            break;
        case 'boolean':
            break; // 16.27.24 <number:boolean>
        case 'text':
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case 'number-style':
                case 'date-style':
                case 'time-style':
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'named-range':
            tag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            _Ref = $a1a91b25d7598376$var$ods_to_csf_3D(tag['cell-range-address']);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + '!' + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case 'text-content':
            break; // 16.27.27 <number:text-content>
        case 'text-properties':
            break; // 16.27.27 <style:text-properties>
        case 'embedded-text':
            break; // 16.27.4 <number:embedded-text>
        case 'body':
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case 'forms':
            break; // 12.25.2 13.2
        case 'table-column':
            break; // 9.1.6 <table:table-column>
        case 'table-header-rows':
            break; // 9.1.7 <table:table-header-rows>
        case 'table-rows':
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case 'table-column-group':
            break; // 9.1.10 <table:table-column-group>
        case 'table-header-columns':
            break; // 9.1.11 <table:table-header-columns>
        case 'table-columns':
            break; // 9.1.12 <table:table-columns>
        case 'null-date':
            tag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(tag["date-value"]){
                case "1904-01-01":
                    WB.WBProps.date1904 = true;
                    break;
            }
            break;
        case 'graphic-properties':
            break; // 17.21 <style:graphic-properties>
        case 'calculation-settings':
            break; // 9.4.1 <table:calculation-settings>
        case 'named-expressions':
            break; // 9.4.11 <table:named-expressions>
        case 'label-range':
            break; // 9.4.9 <table:label-range>
        case 'label-ranges':
            break; // 9.4.10 <table:label-ranges>
        case 'named-expression':
            break; // 9.4.13 <table:named-expression>
        case 'sort':
            break; // 9.4.19 <table:sort>
        case 'sort-by':
            break; // 9.4.20 <table:sort-by>
        case 'sort-groups':
            break; // 9.4.22 <table:sort-groups>
        case 'tab':
            break; // 6.1.4 <text:tab>
        case 'line-break':
            break; // 6.1.5 <text:line-break>
        case 'span':
            break; // 6.1.7 <text:span>
        case 'p':
        case "\u6587\u672C\u4E32":
            if ([
                'master-styles'
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === '/' && (!ctag || !ctag['string-value'])) {
                var ptp = $a1a91b25d7598376$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else if (Rn[0].slice(-2) == "/>") /* TODO: is self-closing 文本串 valid? */ textp += "\n";
            else {
                textptag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case 's':
            break; // <text:s>
        case 'database-range':
            if (Rn[1] === '/') break;
            try {
                _Ref = $a1a91b25d7598376$var$ods_to_csf_3D($a1a91b25d7598376$var$parsexmltag(Rn[0])['target-range-address']);
                Sheets[_Ref[0]]['!autofilter'] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case 'date':
            break; // <*:date>
        case 'object':
            break; // 10.4.6.2 <draw:object>
        case 'title':
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case 'desc':
            break; // <*:desc>
        case 'binary-data':
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case 'table-source':
            break; // 9.2.6
        case 'scenario':
            break; // 9.2.6
        case 'iteration':
            break; // 9.4.3 <table:iteration>
        case 'content-validations':
            break; // 9.4.4 <table:
        case 'content-validation':
            break; // 9.4.5 <table:
        case 'help-message':
            break; // 9.4.6 <table:
        case 'error-message':
            break; // 9.4.7 <table:
        case 'database-ranges':
            break; // 9.4.14 <table:database-ranges>
        /* 9.5 Filters */ case 'filter':
            break; // 9.5.2 <table:filter>
        case 'filter-and':
            break; // 9.5.3 <table:filter-and>
        case 'filter-or':
            break; // 9.5.4 <table:filter-or>
        case 'filter-condition':
            break; // 9.5.5 <table:filter-condition>
        case 'filter-set-item':
            break; // 9.5.6 <table:filter-condition>
        case 'list-level-style-bullet':
            break; // 16.31 <text:
        case 'list-level-style-number':
            break; // 16.32 <text:
        case 'list-level-properties':
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case 'sender-firstname':
        case 'sender-lastname':
        case 'sender-initials':
        case 'sender-title':
        case 'sender-position':
        case 'sender-email':
        case 'sender-phone-private':
        case 'sender-fax':
        case 'sender-company':
        case 'sender-phone-work':
        case 'sender-street':
        case 'sender-city':
        case 'sender-postal-code':
        case 'sender-country':
        case 'sender-state-or-province':
        case 'author-name':
        case 'author-initials':
        case 'chapter':
        case 'file-name':
        case 'template-name':
        case 'sheet-name':
            break;
        case 'event-listener':
            break;
        /* TODO: FODS Properties */ case 'initial-creator':
        case 'creation-date':
        case 'print-date':
        case 'generator':
        case 'document-statistic':
        case 'user-defined':
        case 'editing-duration':
        case 'editing-cycles':
            break;
        /* TODO: FODS Config */ case 'config-item':
            break;
        /* TODO: style tokens */ case 'page-number':
            break; // TODO <text:page-number>
        case 'page-count':
            break; // TODO <text:page-count>
        case 'time':
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case 'cell-range-source':
            break; // 9.3.1 <table:
        case 'detective':
            break; // 9.3.2 <table:
        case 'operation':
            break; // 9.3.3 <table:
        case 'highlighted-range':
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case 'data-pilot-table':
        case 'source-cell-range':
        case 'source-service':
        case 'data-pilot-field':
        case 'data-pilot-level':
        case 'data-pilot-subtotals':
        case 'data-pilot-subtotal':
        case 'data-pilot-members':
        case 'data-pilot-member':
        case 'data-pilot-display-info':
        case 'data-pilot-sort-info':
        case 'data-pilot-layout-info':
        case 'data-pilot-field-reference':
        case 'data-pilot-groups':
        case 'data-pilot-group':
        case 'data-pilot-group-member':
            break;
        /* 10.3 Drawing Shapes */ case 'rect':
            break;
        /* 14.6 DDE Connections */ case 'dde-connection-decls':
        case 'dde-connection-decl':
        case 'dde-link':
        case 'dde-source':
            break;
        case 'properties':
            break; // 13.7 <form:properties>
        case 'property':
            break; // 13.8 <form:property>
        case 'a':
            if (Rn[1] !== '/') {
                atag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $a1a91b25d7598376$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $a1a91b25d7598376$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case 'table-protection':
            break;
        case 'data-pilot-grand-total':
            break; // <table:
        case 'office-document-common-attrs':
            break; // bare
        default:
            switch(Rn[2]){
                case 'dc:':
                case 'calcext:':
                case 'loext:':
                case 'ooo:':
                case 'chartooo:':
                case 'draw:':
                case 'style:':
                case 'chart:':
                case 'form:':
                case 'uof:':
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $a1a91b25d7598376$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($a1a91b25d7598376$var$safegetzipfile(zip, 'META-INF/manifest.xml')) $a1a91b25d7598376$var$parse_manifest($a1a91b25d7598376$var$getzipdata(zip, 'META-INF/manifest.xml'), opts);
    var styles = $a1a91b25d7598376$var$getzipstr(zip, 'styles.xml');
    var Styles = styles && $a1a91b25d7598376$var$parse_ods_styles($a1a91b25d7598376$var$utf8read(styles), opts);
    var content = $a1a91b25d7598376$var$getzipstr(zip, 'content.xml');
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $a1a91b25d7598376$var$parse_content_xml($a1a91b25d7598376$var$utf8read(content), opts, Styles);
    if ($a1a91b25d7598376$var$safegetzipfile(zip, 'meta.xml')) wb.Props = $a1a91b25d7598376$var$parse_core_props($a1a91b25d7598376$var$getzipdata(zip, 'meta.xml'));
    wb.bookType = "ods";
    return wb;
}
function $a1a91b25d7598376$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var wb = $a1a91b25d7598376$var$parse_content_xml(data, opts);
    wb.bookType = "fods";
    return wb;
}
/* OpenDocument */ var $a1a91b25d7598376$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        '<office:master-styles>',
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        '<style:header/>',
        '<style:header-left style:display="false"/>',
        '<style:footer/>',
        '<style:footer-left style:display="false"/>',
        '</style:master-page>',
        '</office:master-styles>'
    ].join("");
    var payload = '<office:document-styles ' + $a1a91b25d7598376$var$wxt_helper({
        'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        'xmlns:xlink': "http://www.w3.org/1999/xlink",
        'xmlns:dc': "http://purl.org/dc/elements/1.1/",
        'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        'office:version': "1.2"
    }) + '>' + master_styles + '</office:document-styles>';
    return function wso() {
        return $a1a91b25d7598376$var$XML_HEADER + payload;
    };
}();
// TODO: find out if anyone actually read the spec.  LO has some wild errors
function $a1a91b25d7598376$var$write_number_format_ods(nf /*:string*/ , nfidx /*:string*/ ) /*:string*/ {
    var type = "number", payload = "", nopts = {
        "style:name": nfidx
    }, c = "", i = 0;
    nf = nf.replace(/"[$]"/g, "$");
    /* TODO: replace with an actual parser based on a real grammar */ j: {
        // TODO: support style maps
        if (nf.indexOf(";") > -1) {
            console.error("Unsupported ODS Style Map exported.  Using first branch of " + nf);
            nf = nf.slice(0, nf.indexOf(";"));
        }
        if (nf == "@") {
            type = "text";
            payload = "<number:text-content/>";
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* opening string literal */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* fractions */ var t = nf.match(/# (\?+)\/(\?+)/);
        if (t) {
            payload += $a1a91b25d7598376$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:max-denominator-value": Math.max(+t[1].replace(/./g, "9"), +t[2].replace(/./g, "9"))
            });
            break j;
        }
        if (t = nf.match(/# (\?+)\/(\d+)/)) {
            payload += $a1a91b25d7598376$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:denominator-value": +t[2]
            });
            break j;
        }
        /* percentages */ if (t = nf.match(/\b(\d+)(|\.\d+)%/)) {
            type = "percentage";
            payload += $a1a91b25d7598376$var$writextag("number:number", null, {
                "number:decimal-places": t[2] && t.length - 1 || 0,
                "number:min-decimal-places": t[2] && t.length - 1 || 0,
                "number:min-integer-digits": t[1].length
            }) + "<number:text>%</number:text>";
            break j;
        }
        /* datetime */ var has_time = false;
        if ([
            "y",
            "m",
            "d"
        ].indexOf(nf[0]) > -1) {
            type = "date";
            k: for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "s":
                    has_time = true;
                    --i;
                    break k;
                case "m":
                    l: for(var h = i + 1; h < nf.length; ++h)switch(nf[h]){
                        case "y":
                        case "d":
                            break l;
                        case "h":
                        case "s":
                            has_time = true;
                            --i;
                            break k;
                    }
                /* falls through */ case "y":
                case "d":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "y":
                        case "yy":
                            payload += "<number:year/>";
                            break;
                        case "yyy":
                        case "yyyy":
                            payload += '<number:year number:style="long"/>';
                            break;
                        case "mmmmm":
                            console.error("ODS has no equivalent of format |mmmmm|");
                        /* falls through */ case "m":
                        case "mm":
                        case "mmm":
                        case "mmmm":
                            payload += '<number:month number:style="' + (c.length % 2 ? "short" : "long") + '" number:textual="' + (c.length >= 3 ? "true" : "false") + '"/>';
                            break;
                        case "d":
                        case "dd":
                            payload += '<number:day number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "ddd":
                        case "dddd":
                            payload += '<number:day-of-week number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '\\':
                    c = nf[++i];
                    payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c) + '</number:text>';
                    break;
                default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            if (!has_time) break j;
            nf = nf.slice(i + 1);
            i = 0;
        }
        if (nf.match(/^\[?[hms]/)) {
            if (type == "number") type = "time";
            if (nf.match(/\[/)) {
                nf = nf.replace(/[\[\]]/g, "");
                nopts['number:truncate-on-overflow'] = "false";
            }
            for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "m":
                case "s":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "h":
                        case "hh":
                            payload += '<number:hours number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "m":
                        case "mm":
                            payload += '<number:minutes number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "s":
                        case "ss":
                            if (nf[i + 1] == ".") do {
                                c += nf[i + 1];
                                ++i;
                            }while (nf[i + 1] == "0");
                            payload += '<number:seconds number:style="' + (c.match("ss") ? "long" : "short") + '"' + (c.match(/\./) ? ' number:decimal-places="' + (c.match(/0+/) || [
                                ""
                            ])[0].length + '"' : "") + '/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c) + '</number:text>';
                    break;
                case "a":
                    if (nf.slice(i, i + 3).toLowerCase() == "a/p") {
                        payload += '<number:am-pm/>';
                        i += 2;
                        break;
                    } // Note: ODF does not support A/P
                    if (nf.slice(i, i + 5).toLowerCase() == "am/pm") {
                        payload += '<number:am-pm/>';
                        i += 4;
                        break;
                    }
                /* falls through */ default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* should be in a char loop */ if (nf[0] == "$") {
            payload += '<number:currency-symbol number:language="en" number:country="US">$</number:currency-symbol>';
            nf = nf.slice(1);
            i = 0;
        }
        i = 0;
        if (nf[i] == '"') {
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* number TODO: interstitial text e.g. 000)000-0000 */ var np = nf.match(/([#0][0#,]*)(\.[0#]*|)(E[+]?0*|)/i);
        if (!np || !np[0]) console.error("Could not find numeric part of " + nf);
        else {
            var base = np[1].replace(/,/g, "");
            payload += '<number:' + (np[3] ? "scientific-" : "") + 'number' + ' number:min-integer-digits="' + (base.indexOf("0") == -1 ? "0" : base.length - base.indexOf("0")) + '"' + (np[0].indexOf(",") > -1 ? ' number:grouping="true"' : "") + (np[2] && ' number:decimal-places="' + (np[2].length - 1) + '"' || ' number:decimal-places="0"') + (np[3] && np[3].indexOf("+") > -1 ? ' number:forced-exponent-sign="true"' : "") + (np[3] ? ' number:min-exponent-digits="' + np[3].match(/0+/)[0].length + '"' : "") + '>' + /* TODO: interstitial text placeholders */ '</number:' + (np[3] ? "scientific-" : "") + 'number>';
            i = np.index + np[0].length;
        }
        /* residual text */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
        }
    }
    if (!payload) {
        console.error("Could not generate ODS number format for |" + nf + "|");
        return "";
    }
    return $a1a91b25d7598376$var$writextag("number:" + type + "-style", payload, nopts);
}
function $a1a91b25d7598376$var$write_names_ods(Names, SheetNames, idx) {
    //var scoped = Names.filter(function(name) { return name.Sheet == (idx == -1 ? null : idx); });
    var scoped = [];
    for(var namei = 0; namei < Names.length; ++namei){
        var name = Names[namei];
        if (!name) continue;
        if (name.Sheet == (idx == -1 ? null : idx)) scoped.push(name);
    }
    if (!scoped.length) return "";
    return "      <table:named-expressions>\n" + scoped.map(function(name) {
        var odsref = (idx == -1 ? "$" : "") + $a1a91b25d7598376$var$csf_to_ods_3D(name.Ref);
        return "        " + $a1a91b25d7598376$var$writextag("table:named-range", null, {
            "table:name": name.Name,
            "table:cell-range-address": odsref,
            "table:base-cell-address": odsref.replace(/[\.][^\.]*$/, ".$A$1")
        });
    }).join("\n") + "\n      </table:named-expressions>\n";
}
var $a1a91b25d7598376$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ , span) /*:string*/ {
        return $a1a91b25d7598376$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, span ? "<text:line-break/>" : "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = '          <table:table-cell />\n';
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/ , opts, nfs, date1904) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $a1a91b25d7598376$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $a1a91b25d7598376$var$decode_range(ws['!ref'] || "A1");
        var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
        var dense = ws["!data"] != null;
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '></table:table-row>\n');
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '>\n');
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct['table:number-columns-spanned'] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct['table:number-rows-spanned'] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push('          <table:covered-table-cell/>\n');
                    continue;
                }
                var ref = $a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct['table:formula'] = $a1a91b25d7598376$var$escapexml($a1a91b25d7598376$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $a1a91b25d7598376$var$decode_range(cell.F);
                            ct['table:number-matrix-columns-spanned'] = _Fref.e.c - _Fref.s.c + 1;
                            ct['table:number-matrix-rows-spanned'] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case 'b':
                        textp = cell.v ? 'TRUE' : 'FALSE';
                        ct['office:value-type'] = "boolean";
                        ct['office:boolean-value'] = cell.v ? 'true' : 'false';
                        break;
                    case 'n':
                        if (!isFinite(cell.v)) {
                            if (isNaN(cell.v)) {
                                textp = "#NUM!";
                                ct['table:formula'] = "of:=#NUM!";
                            } else {
                                textp = "#DIV/0!";
                                ct['table:formula'] = "of:=" + (cell.v < 0 ? "-" : "") + "1/0";
                            }
                            ct['office:string-value'] = "";
                            ct['office:value-type'] = "string";
                            ct['calcext:value-type'] = "error";
                        } else {
                            textp = cell.w || String(cell.v || 0);
                            ct['office:value-type'] = "float";
                            ct['office:value'] = cell.v || 0;
                        }
                        break;
                    case 's':
                    case 'str':
                        textp = cell.v == null ? "" : cell.v;
                        ct['office:value-type'] = "string";
                        break;
                    case 'd':
                        textp = cell.w || $a1a91b25d7598376$var$parseDate(cell.v, date1904).toISOString();
                        ct['office:value-type'] = "date";
                        ct['office:date-value'] = $a1a91b25d7598376$var$parseDate(cell.v, date1904).toISOString();
                        ct['table:style-name'] = "ce1";
                        break;
                    //case 'e': // TODO: translate to ODS errors
                    default:
                        o.push(null_cell_xml);
                        continue; // TODO: empty cell with comments
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $a1a91b25d7598376$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
                    text_p = $a1a91b25d7598376$var$writextag('text:a', text_p, {
                        'xlink:href': _tgt.replace(/&/g, "&amp;")
                    });
                }
                if (nfs[cell.z]) ct["table:style-name"] = "ce" + nfs[cell.z].slice(1);
                var payload = $a1a91b25d7598376$var$writextag('text:p', text_p, {});
                if (cell.c) {
                    var acreator = "", apayload = "", aprops = {};
                    for(var ci = 0; ci < cell.c.length; ++ci){
                        if (!acreator && cell.c[ci].a) acreator = cell.c[ci].a;
                        apayload += "<text:p>" + write_text_p(cell.c[ci].t) + "</text:p>";
                    }
                    if (!cell.c.hidden) aprops["office:display"] = true;
                    payload = $a1a91b25d7598376$var$writextag('office:annotation', apayload, aprops) + payload;
                }
                o.push('          ' + $a1a91b25d7598376$var$writextag('table:table-cell', payload, ct) + '\n');
            }
            o.push('        </table:table-row>\n');
        }
        if ((wb.Workbook || {}).Names) o.push($a1a91b25d7598376$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, i));
        o.push('      </table:table>\n');
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(' <office:automatic-styles>\n');
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $a1a91b25d7598376$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push('  </style:style>\n');
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push('  </style:style>\n');
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push('  </style:style>\n');
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:day number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:year/>\n');
        o.push('  </number:date-style>\n');
        /* number formats, table cells, text */ var nfs = {};
        var nfi = 69;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            var dense = ws["!data"] != null;
            if (!ws["!ref"]) return;
            var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
            for(var R = 0; R <= range.e.r; ++R)for(var C = 0; C <= range.e.c; ++C){
                var c = dense ? (ws["!data"][R] || [])[C] : ws[$a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (!c || !c.z || c.z.toLowerCase() == "general") continue;
                if (!nfs[c.z]) {
                    var out = $a1a91b25d7598376$var$write_number_format_ods(c.z, "N" + nfi);
                    if (out) {
                        nfs[c.z] = "N" + nfi;
                        ++nfi;
                        o.push(out + "\n");
                    }
                }
            }
        });
        o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        $a1a91b25d7598376$var$keys(nfs).forEach(function(nf) {
            o.push('<style:style style:name="ce' + nfs[nf].slice(1) + '" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="' + nfs[nf] + '"/>\n');
        });
        /* page-layout */ o.push(' </office:automatic-styles>\n');
        return nfs;
    };
    return function wcx(wb, opts) {
        var o = [
            $a1a91b25d7598376$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $a1a91b25d7598376$var$wxt_helper({
            'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            'xmlns:xlink': "http://www.w3.org/1999/xlink",
            'xmlns:dc': "http://purl.org/dc/elements/1.1/",
            'xmlns:meta': "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            'xmlns:chart': "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            'xmlns:dr3d': "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            'xmlns:math': "http://www.w3.org/1998/Math/MathML",
            'xmlns:form': "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            'xmlns:script': "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            'xmlns:ooo': "http://openoffice.org/2004/office",
            'xmlns:ooow': "http://openoffice.org/2004/writer",
            'xmlns:oooc': "http://openoffice.org/2004/calc",
            'xmlns:dom': "http://www.w3.org/2001/xml-events",
            'xmlns:xforms': "http://www.w3.org/2002/xforms",
            'xmlns:xsd': "http://www.w3.org/2001/XMLSchema",
            'xmlns:xsi': "http://www.w3.org/2001/XMLSchema-instance",
            'xmlns:sheet': "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            'xmlns:rpt': "http://openoffice.org/2005/report",
            'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            'xmlns:xhtml': "http://www.w3.org/1999/xhtml",
            'xmlns:grddl': "http://www.w3.org/2003/g/data-view#",
            'xmlns:tableooo': "http://openoffice.org/2009/table",
            'xmlns:drawooo': "http://openoffice.org/2010/draw",
            'xmlns:calcext': "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            'xmlns:loext': "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            'xmlns:field': "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            'xmlns:formx': "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            'xmlns:css3t': "http://www.w3.org/TR/css3-text/",
            'office:version': "1.2"
        });
        var fods = $a1a91b25d7598376$var$wxt_helper({
            'xmlns:config': "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push('<office:document' + attr + fods + '>\n');
            o.push($a1a91b25d7598376$var$write_meta_ods().replace(/<office:document-meta[^<>]*?>/, "").replace(/<\/office:document-meta>/, "") + "\n");
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push('<office:document-content' + attr + '>\n');
        // o.push('  <office:scripts/>\n');
        var nfs = write_automatic_styles_ods(o, wb);
        o.push('  <office:body>\n');
        o.push('    <office:spreadsheet>\n');
        if (((wb.Workbook || {}).WBProps || {}).date1904) o.push('      <table:calculation-settings table:case-sensitive="false" table:search-criteria-must-apply-to-whole-cell="true" table:use-wildcards="true" table:use-regular-expressions="false" table:automatic-find-labels="false">\n        <table:null-date table:date-value="1904-01-01"/>\n      </table:calculation-settings>\n');
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts, nfs, ((wb.Workbook || {}).WBProps || {}).date1904));
        if ((wb.Workbook || {}).Names) o.push($a1a91b25d7598376$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, -1));
        o.push('    </office:spreadsheet>\n');
        o.push('  </office:body>\n');
        if (opts.bookType == "fods") o.push('</office:document>');
        else o.push('</office:document-content>');
        return o.join("");
    };
}();
function $a1a91b25d7598376$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $a1a91b25d7598376$var$write_content_ods(wb, opts);
    var zip = $a1a91b25d7598376$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $a1a91b25d7598376$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$XML_HEADER + $a1a91b25d7598376$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ var $a1a91b25d7598376$var$subarray = function() {
    try {
        if (typeof Uint8Array == "undefined") return "slice";
        if (typeof Uint8Array.prototype.subarray == "undefined") return "slice";
        if (typeof $a1a91b25d7598376$require$Buffer !== "undefined") {
            if (typeof $a1a91b25d7598376$require$Buffer.prototype.subarray == "undefined") return "slice";
            if ((typeof $a1a91b25d7598376$require$Buffer.from == "function" ? $a1a91b25d7598376$require$Buffer.from([
                72,
                62
            ]) : new $a1a91b25d7598376$require$Buffer([
                72,
                62
            ])) instanceof Uint8Array) return "subarray";
            return "slice";
        }
        return "subarray";
    } catch (e) {
        return "slice";
    }
}();
function $a1a91b25d7598376$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $a1a91b25d7598376$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $a1a91b25d7598376$var$utf8read($a1a91b25d7598376$var$a2s(u8));
}
function $a1a91b25d7598376$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$utf8write(str));
}
function $a1a91b25d7598376$var$u8concat(u8a) {
    var len = 0;
    for(var i = 0; i < u8a.length; ++i)len += u8a[i].length;
    var out = new Uint8Array(len);
    var off = 0;
    for(i = 0; i < u8a.length; ++i){
        var u8 = u8a[i], L = u8.length;
        if (L < 250) for(var j = 0; j < L; ++j)out[off++] = u8[j];
        else {
            out.set(u8, off);
            off += L;
        }
    }
    return out;
}
function $a1a91b25d7598376$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $a1a91b25d7598376$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $a1a91b25d7598376$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 16;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $a1a91b25d7598376$var$parse_varint49(buf, ptr) {
    var l = ptr.l;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    ptr.l = l;
    return usz;
}
function $a1a91b25d7598376$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz[$a1a91b25d7598376$var$subarray](0, L);
}
function $a1a91b25d7598376$var$parse_packed_varints(buf) {
    var ptr = {
        l: 0
    };
    var out = [];
    while(ptr.l < buf.length)out.push($a1a91b25d7598376$var$parse_varint49(buf, ptr));
    return out;
}
function $a1a91b25d7598376$var$write_packed_varints(nums) {
    return $a1a91b25d7598376$var$u8concat(nums.map(function(x) {
        return $a1a91b25d7598376$var$write_varint49(x);
    }));
}
function $a1a91b25d7598376$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 7;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 14;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 21;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 15) << 28;
    return i32;
}
function $a1a91b25d7598376$var$varint_to_u64(buf) {
    var l = 0, lo = buf[l] & 127, hi = 0;
    varint: if (buf[l++] >= 128) {
        lo |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 28;
        hi = buf[l] >> 4 & 7;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 3;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 10;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 17;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 24;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 31;
    }
    return [
        lo >>> 0,
        hi >>> 0
    ];
}
function $a1a91b25d7598376$var$parse_shallow(buf) {
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var off = ptr.l;
        var num = $a1a91b25d7598376$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = num / 8 | 0;
        var data;
        var l = ptr.l;
        switch(type){
            case 0:
                while(buf[l++] >= 128);
                data = buf[$a1a91b25d7598376$var$subarray](ptr.l, l);
                ptr.l = l;
                break;
            case 1:
                data = buf[$a1a91b25d7598376$var$subarray](l, l + 8);
                ptr.l = l + 8;
                break;
            case 2:
                var len = $a1a91b25d7598376$var$parse_varint49(buf, ptr);
                data = buf[$a1a91b25d7598376$var$subarray](ptr.l, ptr.l + len);
                ptr.l += len;
                break;
            case 5:
                data = buf[$a1a91b25d7598376$var$subarray](l, l + 4);
                ptr.l = l + 4;
                break;
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: data,
            type: type
        };
        if (out[num] == null) out[num] = [];
        out[num].push(v);
    }
    return out;
}
function $a1a91b25d7598376$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        if (idx == 0) return;
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($a1a91b25d7598376$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($a1a91b25d7598376$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $a1a91b25d7598376$var$u8concat(out);
}
function $a1a91b25d7598376$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $a1a91b25d7598376$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var len = $a1a91b25d7598376$var$parse_varint49(buf, ptr);
        var ai = $a1a91b25d7598376$var$parse_shallow(buf[$a1a91b25d7598376$var$subarray](ptr.l, ptr.l + len));
        ptr.l += len;
        var res = {
            id: $a1a91b25d7598376$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $a1a91b25d7598376$var$parse_shallow(b.data);
            var fl = $a1a91b25d7598376$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf[$a1a91b25d7598376$var$subarray](ptr.l, ptr.l + fl)
            });
            ptr.l += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $a1a91b25d7598376$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $a1a91b25d7598376$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [
            [],
            [
                {
                    data: $a1a91b25d7598376$var$write_varint49(ia.id),
                    type: 0
                }
            ],
            []
        ];
        if (ia.merge != null) ai[3] = [
            {
                data: $a1a91b25d7598376$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $a1a91b25d7598376$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $a1a91b25d7598376$var$write_shallow(ai);
        bufs.push($a1a91b25d7598376$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $a1a91b25d7598376$var$u8concat(bufs);
}
function $a1a91b25d7598376$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = {
        l: 0
    };
    var usz = $a1a91b25d7598376$var$parse_varint49(buf, ptr);
    var chunks = [];
    var l = ptr.l;
    while(l < buf.length){
        var tag = buf[l] & 3;
        if (tag == 0) {
            var len = buf[l++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[l];
                if (c > 1) len |= buf[l + 1] << 8;
                if (c > 2) len |= buf[l + 2] << 16;
                if (c > 3) len |= buf[l + 3] << 24;
                len >>>= 0;
                len++;
                l += c;
            }
            chunks.push(buf[$a1a91b25d7598376$var$subarray](l, l + len));
            l += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[l] >> 2 & 7) + 4;
                offset = (buf[l++] & 224) << 3;
                offset |= buf[l++];
            } else {
                length = (buf[l++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[l] | buf[l + 1] << 8;
                    l += 2;
                } else {
                    offset = (buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16 | buf[l + 3] << 24) >>> 0;
                    l += 4;
                }
            }
            if (offset == 0) throw new Error("Invalid offset 0");
            var j = chunks.length - 1, off = offset;
            while(j >= 0 && off >= chunks[j].length){
                off -= chunks[j].length;
                --j;
            }
            if (j < 0) {
                if (off == 0) off = chunks[j = 0].length;
                else throw new Error("Invalid offset beyond length");
            }
            if (length < off) chunks.push(chunks[j][$a1a91b25d7598376$var$subarray](chunks[j].length - off, chunks[j].length - off + length));
            else {
                if (off > 0) {
                    chunks.push(chunks[j][$a1a91b25d7598376$var$subarray](chunks[j].length - off));
                    length -= off;
                }
                ++j;
                while(length >= chunks[j].length){
                    chunks.push(chunks[j]);
                    length -= chunks[j].length;
                    ++j;
                }
                if (length) chunks.push(chunks[j][$a1a91b25d7598376$var$subarray](0, length));
            }
            if (chunks.length > 25) chunks = [
                $a1a91b25d7598376$var$u8concat(chunks)
            ];
        }
    }
    var clen = 0;
    for(var u8i = 0; u8i < chunks.length; ++u8i)clen += chunks[u8i].length;
    if (clen != usz) throw new Error("Unexpected length: ".concat(clen, " != ").concat(usz));
    return chunks;
}
function $a1a91b25d7598376$var$decompress_iwa_file(buf) {
    if (Array.isArray(buf)) buf = new Uint8Array(buf);
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push.apply(out, $a1a91b25d7598376$var$parse_snappy_chunk(t, buf[$a1a91b25d7598376$var$subarray](l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return out.length == 1 ? out[0] : $a1a91b25d7598376$var$u8concat(out);
}
function $a1a91b25d7598376$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $a1a91b25d7598376$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf[$a1a91b25d7598376$var$subarray](l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $a1a91b25d7598376$var$u8concat(out);
}
var $a1a91b25d7598376$var$numbers_lut_new = function() {
    return {
        sst: [],
        rsst: [],
        ofmt: [],
        nfmt: [],
        fmla: [],
        ferr: [],
        cmnt: []
    };
};
function $a1a91b25d7598376$var$numbers_format_cell(cell, t, flags, ofmt, nfmt) {
    var _a, _b, _c, _d;
    var ctype = t & 255, ver = t >> 8;
    var fmt = ver >= 5 ? nfmt : ofmt;
    dur: if (flags & (ver > 4 ? 8 : 4) && cell.t == "n" && ctype == 7) {
        var dstyle = ((_a = fmt[7]) == null ? void 0 : _a[0]) ? $a1a91b25d7598376$var$varint_to_i32(fmt[7][0].data) : -1;
        if (dstyle == -1) break dur;
        var dmin = ((_b = fmt[15]) == null ? void 0 : _b[0]) ? $a1a91b25d7598376$var$varint_to_i32(fmt[15][0].data) : -1;
        var dmax = ((_c = fmt[16]) == null ? void 0 : _c[0]) ? $a1a91b25d7598376$var$varint_to_i32(fmt[16][0].data) : -1;
        var auto = ((_d = fmt[40]) == null ? void 0 : _d[0]) ? $a1a91b25d7598376$var$varint_to_i32(fmt[40][0].data) : -1;
        var d = cell.v, dd = d;
        autodur: if (auto) {
            if (d == 0) {
                dmin = dmax = 2;
                break autodur;
            }
            if (d >= 604800) dmin = 1;
            else if (d >= 86400) dmin = 2;
            else if (d >= 3600) dmin = 4;
            else if (d >= 60) dmin = 8;
            else if (d >= 1) dmin = 16;
            else dmin = 32;
            if (Math.floor(d) != d) dmax = 32;
            else if (d % 60) dmax = 16;
            else if (d % 3600) dmax = 8;
            else if (d % 86400) dmax = 4;
            else if (d % 604800) dmax = 2;
            if (dmax < dmin) dmax = dmin;
        }
        if (dmin == -1 || dmax == -1) break dur;
        var dstr = [], zstr = [];
        if (dmin == 1) {
            dd = d / 604800;
            if (dmax == 1) zstr.push('d"d"');
            else {
                dd |= 0;
                d -= 604800 * dd;
            }
            dstr.push(dd + (dstyle == 2 ? " week" + (dd == 1 ? "" : "s") : dstyle == 1 ? "w" : ""));
        }
        if (dmin <= 2 && dmax >= 2) {
            dd = d / 86400;
            if (dmax > 2) {
                dd |= 0;
                d -= 86400 * dd;
            }
            zstr.push('d"d"');
            dstr.push(dd + (dstyle == 2 ? " day" + (dd == 1 ? "" : "s") : dstyle == 1 ? "d" : ""));
        }
        if (dmin <= 4 && dmax >= 4) {
            dd = d / 3600;
            if (dmax > 4) {
                dd |= 0;
                d -= 3600 * dd;
            }
            zstr.push((dmin >= 4 ? "[h]" : "h") + '"h"');
            dstr.push(dd + (dstyle == 2 ? " hour" + (dd == 1 ? "" : "s") : dstyle == 1 ? "h" : ""));
        }
        if (dmin <= 8 && dmax >= 8) {
            dd = d / 60;
            if (dmax > 8) {
                dd |= 0;
                d -= 60 * dd;
            }
            zstr.push((dmin >= 8 ? "[m]" : "m") + '"m"');
            if (dstyle == 0) dstr.push((dmin == 8 && dmax == 8 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " minute" + (dd == 1 ? "" : "s") : dstyle == 1 ? "m" : ""));
        }
        if (dmin <= 16 && dmax >= 16) {
            dd = d;
            if (dmax > 16) {
                dd |= 0;
                d -= dd;
            }
            zstr.push((dmin >= 16 ? "[s]" : "s") + '"s"');
            if (dstyle == 0) dstr.push((dmax == 16 && dmin == 16 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " second" + (dd == 1 ? "" : "s") : dstyle == 1 ? "s" : ""));
        }
        if (dmax >= 32) {
            dd = Math.round(1e3 * d);
            if (dmin < 32) zstr.push('.000"ms"');
            if (dstyle == 0) dstr.push((dd >= 100 ? "" : dd >= 10 ? "0" : "00") + dd);
            else dstr.push(dd + (dstyle == 2 ? " millisecond" + (dd == 1 ? "" : "s") : dstyle == 1 ? "ms" : ""));
        }
        cell.w = dstr.join(dstyle == 0 ? ":" : " ");
        cell.z = zstr.join(dstyle == 0 ? '":"' : " ");
        if (dstyle == 0) cell.w = cell.w.replace(/:(\d\d\d)$/, ".$1");
    }
}
function $a1a91b25d7598376$var$parse_old_storage(buf, lut, v, opts) {
    var dv = $a1a91b25d7598376$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var ridx = -1, sidx = -1, zidx = -1, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1));
    var doff = v > 1 ? 12 : 8;
    if (flags & 2) {
        zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $a1a91b25d7598376$var$popcnt(flags & (v > 1 ? 3468 : 396)) * 4;
    if (flags & 512) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $a1a91b25d7598376$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (v > 1) {
        flags = dv.getUint32(8, true) >>> 16;
        if (flags & 255) {
            if (zidx == -1) zidx = dv.getUint32(doff, true);
            doff += 4;
        }
    }
    var ret;
    var t = buf[v >= 4 ? 1 : 2];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $a1a91b25d7598376$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[$a1a91b25d7598376$var$subarray](0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[$a1a91b25d7598376$var$subarray](0, 4)));
    }
    if (zidx > -1) $a1a91b25d7598376$var$numbers_format_cell(ret, t | v << 8, flags, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $a1a91b25d7598376$var$parse_new_storage(buf, lut, opts) {
    var dv = $a1a91b25d7598376$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var fields = dv.getUint32(8, true);
    var doff = 12;
    var ridx = -1, sidx = -1, zidx = -1, d128 = NaN, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1)), eidx = -1, fidx = -1;
    if (fields & 1) {
        d128 = $a1a91b25d7598376$var$readDecimal128LE(buf, doff);
        doff += 16;
    }
    if (fields & 2) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (fields & 4) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (fields & 8) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 16) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $a1a91b25d7598376$var$popcnt(fields & 480) * 4;
    if (fields & 512) {
        fidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $a1a91b25d7598376$var$popcnt(fields & 1024) * 4;
    if (fields & 2048) {
        eidx = dv.getUint32(doff, true);
        doff += 4;
    }
    var ret;
    var t = buf[1];
    switch(t){
        case 0:
            ret = {
                t: "z"
            };
            break;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $a1a91b25d7598376$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$a1a91b25d7598376$var$subarray](0, 4)));
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$a1a91b25d7598376$var$subarray](0, 4)));
    }
    doff += $a1a91b25d7598376$var$popcnt(fields & 4096) * 4;
    if (fields & 516096) {
        if (zidx == -1) zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 524288) {
        var cmntidx = dv.getUint32(doff, true);
        doff += 4;
        if (lut.cmnt[cmntidx]) ret.c = $a1a91b25d7598376$var$iwa_to_s5s_comment(lut.cmnt[cmntidx]);
    }
    if (zidx > -1) $a1a91b25d7598376$var$numbers_format_cell(ret, t | 1280, fields >> 13, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $a1a91b25d7598376$var$write_new_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $a1a91b25d7598376$var$u8_to_dataview(out), l = 12, fields = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            if (cell.z && $a1a91b25d7598376$var$fmt_is_date(cell.z)) {
                out[1] = 5;
                dv.setFloat64(l, ($a1a91b25d7598376$var$numdate(cell.v + 1462).getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
                fields |= 4;
                l += 8;
                break;
            } else {
                out[1] = 2;
                $a1a91b25d7598376$var$writeDecimal128LE(out, l, cell.v);
                fields |= 1;
                l += 16;
            }
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 2;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 16;
                l += 4;
            } else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 8;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 4;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        lut.cmnt.push($a1a91b25d7598376$var$s5s_to_iwa_comment(cell.c));
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 524288;
        l += 4;
    }
    dv.setUint32(8, fields, true);
    return out[$a1a91b25d7598376$var$subarray](0, l);
}
function $a1a91b25d7598376$var$write_old_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $a1a91b25d7598376$var$u8_to_dataview(out), l = 12, fields = 0, s = "";
    out[0] = 4;
    switch(cell.t){
        case "n":
            break;
        case "b":
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 512;
                l += 4;
            }
            break;
        case "d":
            break;
        case "e":
            break;
        case "z":
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 4096;
        l += 4;
    }
    switch(cell.t){
        case "n":
            out[1] = 2;
            dv.setFloat64(l, cell.v, true);
            fields |= 32;
            l += 8;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 32;
            l += 8;
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) ;
            else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 16;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 64;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, fields, true);
    return out[$a1a91b25d7598376$var$subarray](0, l);
}
function $a1a91b25d7598376$var$parse_cell_storage(buf, lut, opts) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return $a1a91b25d7598376$var$parse_old_storage(buf, lut, buf[0], opts);
        case 5:
            return $a1a91b25d7598376$var$parse_new_storage(buf, lut, opts);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $a1a91b25d7598376$var$parse_TSP_Reference(buf) {
    var pb = $a1a91b25d7598376$var$parse_shallow(buf);
    return $a1a91b25d7598376$var$varint_to_i32(pb[1][0].data);
}
function $a1a91b25d7598376$var$write_TSP_Reference(idx) {
    return $a1a91b25d7598376$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(idx)
            }
        ]
    ]);
}
function $a1a91b25d7598376$var$numbers_add_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $a1a91b25d7598376$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    var orefidx = orefs.indexOf(ref);
    if (orefidx == -1) {
        orefs.push(ref);
        iwa.messages[0].meta[5] = [
            {
                type: 2,
                data: $a1a91b25d7598376$var$write_packed_varints(orefs)
            }
        ];
    }
}
function $a1a91b25d7598376$var$numbers_del_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $a1a91b25d7598376$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    iwa.messages[0].meta[5] = [
        {
            type: 2,
            data: $a1a91b25d7598376$var$write_packed_varints(orefs.filter(function(r) {
                return r != ref;
            }))
        }
    ];
}
function $a1a91b25d7598376$var$parse_TST_TableDataList(M, root) {
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var type = $a1a91b25d7598376$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var _a, _b;
        var le = $a1a91b25d7598376$var$parse_shallow(entry.data);
        if (!le[1]) return;
        var key = $a1a91b25d7598376$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $a1a91b25d7598376$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$a1a91b25d7598376$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $a1a91b25d7598376$var$parse_shallow(rt.data);
                var rtpref = M[$a1a91b25d7598376$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $a1a91b25d7598376$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $a1a91b25d7598376$var$parse_shallow(rtpref.data);
                var richtext = {
                    v: tswpsa[3].map(function(x) {
                        return $a1a91b25d7598376$var$u8str(x.data);
                    }).join("")
                };
                data[key] = richtext;
                sfields: if ((_a = tswpsa == null ? void 0 : tswpsa[11]) == null ? void 0 : _a[0]) {
                    var smartfields = (_b = $a1a91b25d7598376$var$parse_shallow(tswpsa[11][0].data)) == null ? void 0 : _b[1];
                    if (!smartfields) break sfields;
                    smartfields.forEach(function(sf) {
                        var _a2, _b2, _c;
                        var attr = $a1a91b25d7598376$var$parse_shallow(sf.data);
                        if ((_a2 = attr[2]) == null ? void 0 : _a2[0]) {
                            var obj = M[$a1a91b25d7598376$var$parse_TSP_Reference((_b2 = attr[2]) == null ? void 0 : _b2[0].data)][0];
                            var objtype = $a1a91b25d7598376$var$varint_to_i32(obj.meta[1][0].data);
                            switch(objtype){
                                case 2032:
                                    var hlink = $a1a91b25d7598376$var$parse_shallow(obj.data);
                                    if (((_c = hlink == null ? void 0 : hlink[2]) == null ? void 0 : _c[0]) && !richtext.l) richtext.l = $a1a91b25d7598376$var$u8str(hlink[2][0].data);
                                    break;
                                case 2039:
                                    break;
                                default:
                                    console.log("unrecognized ObjectAttribute type ".concat(objtype));
                            }
                        }
                    });
                }
                break;
            case 2:
                data[key] = $a1a91b25d7598376$var$parse_shallow(le[6][0].data);
                break;
            case 3:
                data[key] = $a1a91b25d7598376$var$parse_shallow(le[5][0].data);
                break;
            case 10:
                var cs = M[$a1a91b25d7598376$var$parse_TSP_Reference(le[10][0].data)][0];
                data[key] = $a1a91b25d7598376$var$parse_TSD_CommentStorageArchive(M, cs.data);
                break;
            default:
                throw type;
        }
    });
    return data;
}
function $a1a91b25d7598376$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $a1a91b25d7598376$var$parse_shallow(u8);
    var R = $a1a91b25d7598376$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $a1a91b25d7598376$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $a1a91b25d7598376$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $a1a91b25d7598376$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage[$a1a91b25d7598376$var$subarray](offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage[$a1a91b25d7598376$var$subarray](offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $a1a91b25d7598376$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var storage = -1;
    if ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) {
        if ($a1a91b25d7598376$var$varint_to_i32(pb[7][0].data) >>> 0) storage = 1;
        else storage = 0;
    }
    var ri = $a1a91b25d7598376$var$mappa(pb[5], function(u8) {
        return $a1a91b25d7598376$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $a1a91b25d7598376$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $a1a91b25d7598376$var$parse_TSD_CommentStorageArchive(M, data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    var out = {
        t: "",
        a: ""
    };
    var csp = $a1a91b25d7598376$var$parse_shallow(data);
    if ((_b = (_a = csp == null ? void 0 : csp[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) out.t = $a1a91b25d7598376$var$u8str((_d = (_c = csp == null ? void 0 : csp[1]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) || "";
    if ((_f = (_e = csp == null ? void 0 : csp[3]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data) {
        var as = M[$a1a91b25d7598376$var$parse_TSP_Reference((_h = (_g = csp == null ? void 0 : csp[3]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data)][0];
        var asp = $a1a91b25d7598376$var$parse_shallow(as.data);
        if ((_j = (_i = asp[1]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) out.a = $a1a91b25d7598376$var$u8str(asp[1][0].data);
    }
    if (csp == null ? void 0 : csp[4]) {
        out.replies = [];
        csp[4].forEach(function(pi) {
            var cs = M[$a1a91b25d7598376$var$parse_TSP_Reference(pi.data)][0];
            out.replies.push($a1a91b25d7598376$var$parse_TSD_CommentStorageArchive(M, cs.data));
        });
    }
    return out;
}
function $a1a91b25d7598376$var$iwa_to_s5s_comment(iwa) {
    var out = [];
    out.push({
        t: iwa.t || "",
        a: iwa.a,
        T: iwa.replies && iwa.replies.length > 0
    });
    if (iwa.replies) iwa.replies.forEach(function(reply) {
        out.push({
            t: reply.t || "",
            a: reply.a,
            T: true
        });
    });
    return out;
}
function $a1a91b25d7598376$var$s5s_to_iwa_comment(s5s) {
    var out = {
        a: "",
        t: "",
        replies: []
    };
    for(var i = 0; i < s5s.length; ++i)if (i == 0) {
        out.a = s5s[i].a;
        out.t = s5s[i].t;
    } else out.replies.push({
        a: s5s[i].a,
        t: s5s[i].t
    });
    return out;
}
function $a1a91b25d7598376$var$parse_TST_TableModelArchive(M, root, ws, opts) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($a1a91b25d7598376$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($a1a91b25d7598376$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
    var dense = ws["!data"] != null, dws = ws;
    var store = $a1a91b25d7598376$var$parse_shallow(pb[4][0].data);
    var lut = $a1a91b25d7598376$var$numbers_lut_new();
    if ((_a = store[4]) == null ? void 0 : _a[0]) lut.sst = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[4][0].data)][0]);
    if ((_b = store[6]) == null ? void 0 : _b[0]) lut.fmla = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[6][0].data)][0]);
    if ((_c = store[11]) == null ? void 0 : _c[0]) lut.ofmt = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[11][0].data)][0]);
    if ((_d = store[12]) == null ? void 0 : _d[0]) lut.ferr = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[12][0].data)][0]);
    if ((_e = store[17]) == null ? void 0 : _e[0]) lut.rsst = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[17][0].data)][0]);
    if ((_f = store[19]) == null ? void 0 : _f[0]) lut.cmnt = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[19][0].data)][0]);
    if ((_g = store[22]) == null ? void 0 : _g[0]) lut.nfmt = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[22][0].data)][0]);
    var tile = $a1a91b25d7598376$var$parse_shallow(store[3][0].data);
    var _R = 0;
    if (!((_h = store[9]) == null ? void 0 : _h[0])) throw "NUMBERS file missing row tree";
    var rtt = $a1a91b25d7598376$var$parse_shallow(store[9][0].data)[1].map(function(p) {
        return $a1a91b25d7598376$var$parse_shallow(p.data);
    });
    rtt.forEach(function(kv) {
        _R = $a1a91b25d7598376$var$varint_to_i32(kv[1][0].data);
        var tidx = $a1a91b25d7598376$var$varint_to_i32(kv[2][0].data);
        var t = tile[1][tidx];
        if (!t) throw "NUMBERS missing tile " + tidx;
        var tl = $a1a91b25d7598376$var$parse_shallow(t.data);
        var ref2 = M[$a1a91b25d7598376$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype2 = $a1a91b25d7598376$var$varint_to_i32(ref2.meta[1][0].data);
        if (mtype2 != 6002) throw new Error("6001 unexpected reference to ".concat(mtype2));
        var _tile = $a1a91b25d7598376$var$parse_TST_Tile(M, ref2);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var res = $a1a91b25d7598376$var$parse_cell_storage(buf, lut, opts);
                if (res) {
                    if (dense) {
                        if (!dws["!data"][_R + R]) dws["!data"][_R + R] = [];
                        dws["!data"][_R + R][C] = res;
                    } else ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(_R + R)] = res;
                }
            });
        });
        _R += _tile.nrows;
    });
    if ((_i = store[13]) == null ? void 0 : _i[0]) {
        var ref = M[$a1a91b25d7598376$var$parse_TSP_Reference(store[13][0].data)][0];
        var mtype = $a1a91b25d7598376$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6144) throw new Error("Expected merge type 6144, found ".concat(mtype));
        ws["!merges"] = (_j = $a1a91b25d7598376$var$parse_shallow(ref.data)) == null ? void 0 : _j[1].map(function(pi) {
            var merge = $a1a91b25d7598376$var$parse_shallow(pi.data);
            var origin = $a1a91b25d7598376$var$u8_to_dataview($a1a91b25d7598376$var$parse_shallow(merge[1][0].data)[1][0].data), size = $a1a91b25d7598376$var$u8_to_dataview($a1a91b25d7598376$var$parse_shallow(merge[2][0].data)[1][0].data);
            return {
                s: {
                    r: origin.getUint16(0, true),
                    c: origin.getUint16(2, true)
                },
                e: {
                    r: origin.getUint16(0, true) + size.getUint16(0, true) - 1,
                    c: origin.getUint16(2, true) + size.getUint16(2, true) - 1
                }
            };
        });
    }
    if (!((_k = ws["!merges"]) == null ? void 0 : _k.length) && ((_l = pb[47]) == null ? void 0 : _l[0])) {
        var merge_owner = $a1a91b25d7598376$var$parse_shallow(pb[47][0].data);
        if ((_m = merge_owner[2]) == null ? void 0 : _m[0]) {
            var formula_store = $a1a91b25d7598376$var$parse_shallow(merge_owner[2][0].data);
            if ((_n = formula_store[3]) == null ? void 0 : _n[0]) ws["!merges"] = $a1a91b25d7598376$var$mappa(formula_store[3], function(u) {
                var _a2, _b2, _c2, _d2, _e2;
                var formula_pair = $a1a91b25d7598376$var$parse_shallow(u);
                var formula = $a1a91b25d7598376$var$parse_shallow(formula_pair[2][0].data);
                var AST_node_array = $a1a91b25d7598376$var$parse_shallow(formula[1][0].data);
                if (!((_a2 = AST_node_array[1]) == null ? void 0 : _a2[0])) return;
                var AST_node0 = $a1a91b25d7598376$var$parse_shallow(AST_node_array[1][0].data);
                var AST_node_type = $a1a91b25d7598376$var$varint_to_i32(AST_node0[1][0].data);
                if (AST_node_type != 67) return;
                var AST_colon_tract = $a1a91b25d7598376$var$parse_shallow(AST_node0[40][0].data);
                if (!((_b2 = AST_colon_tract[3]) == null ? void 0 : _b2[0]) || !((_c2 = AST_colon_tract[4]) == null ? void 0 : _c2[0])) return;
                var colrange = $a1a91b25d7598376$var$parse_shallow(AST_colon_tract[3][0].data);
                var rowrange = $a1a91b25d7598376$var$parse_shallow(AST_colon_tract[4][0].data);
                var c = $a1a91b25d7598376$var$varint_to_i32(colrange[1][0].data);
                var C = ((_d2 = colrange[2]) == null ? void 0 : _d2[0]) ? $a1a91b25d7598376$var$varint_to_i32(colrange[2][0].data) : c;
                var r = $a1a91b25d7598376$var$varint_to_i32(rowrange[1][0].data);
                var R = ((_e2 = rowrange[2]) == null ? void 0 : _e2[0]) ? $a1a91b25d7598376$var$varint_to_i32(rowrange[2][0].data) : r;
                return {
                    s: {
                        r: r,
                        c: c
                    },
                    e: {
                        r: R,
                        c: C
                    }
                };
            }).filter(function(x) {
                return x != null;
            });
        }
    }
}
function $a1a91b25d7598376$var$parse_TST_TableInfoArchive(M, root, opts) {
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    if (opts == null ? void 0 : opts.dense) out["!data"] = [];
    var tableref = M[$a1a91b25d7598376$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $a1a91b25d7598376$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $a1a91b25d7598376$var$parse_TST_TableModelArchive(M, tableref[0], out, opts);
    return out;
}
function $a1a91b25d7598376$var$parse_TN_SheetArchive(M, root, opts) {
    var _a;
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $a1a91b25d7598376$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $a1a91b25d7598376$var$mappa(pb[2], $a1a91b25d7598376$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $a1a91b25d7598376$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($a1a91b25d7598376$var$parse_TST_TableInfoArchive(M, m, opts));
        });
    });
    return out;
}
function $a1a91b25d7598376$var$parse_TN_DocumentArchive(M, root, opts) {
    var _a;
    var out = $a1a91b25d7598376$var$book_new();
    out.Workbook = {
        WBProps: {
            date1904: true
        }
    };
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    if ((_a = pb[2]) == null ? void 0 : _a[0]) throw new Error("Keynote presentations are not supported");
    var sheetoffs = $a1a91b25d7598376$var$mappa(pb[1], $a1a91b25d7598376$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $a1a91b25d7598376$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $a1a91b25d7598376$var$parse_TN_SheetArchive(M, m, opts);
                root2.sheets.forEach(function(sheet, idx) {
                    $a1a91b25d7598376$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    out.bookType = "numbers";
    return out;
}
function $a1a91b25d7598376$var$parse_numbers_iwa(cfb, opts) {
    var _a, _b, _c, _d, _e, _f, _g;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        if (s.content[0] != 0) return;
        var o;
        try {
            o = $a1a91b25d7598376$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $a1a91b25d7598376$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    if (((_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0].meta) == null ? void 0 : _b[1]) == null ? void 0 : _c[0].data) && $a1a91b25d7598376$var$varint_to_i32(M[1][0].meta[1][0].data) == 1e4) throw new Error("Pages documents are not supported");
    var docroot = ((_g = (_f = (_e = (_d = M == null ? void 0 : M[1]) == null ? void 0 : _d[0]) == null ? void 0 : _e.meta) == null ? void 0 : _f[1]) == null ? void 0 : _g[0].data) && $a1a91b25d7598376$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $a1a91b25d7598376$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $a1a91b25d7598376$var$parse_TN_DocumentArchive(M, docroot, opts);
}
function $a1a91b25d7598376$var$write_TST_TileRowInfo(data, lut, wide) {
    var _a, _b, _c;
    var tri = [
        [],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(0)
            }
        ],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(0)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(5)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(1)
            }
        ]
    ];
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var cnt = 0;
    if (tri[7][0].data.length < 2 * data.length) {
        var new_7 = new Uint8Array(2 * data.length);
        new_7.set(tri[7][0].data);
        tri[7][0].data = new_7;
    }
    if (tri[4][0].data.length < 2 * data.length) {
        var new_4 = new Uint8Array(2 * data.length);
        new_4.set(tri[4][0].data);
        tri[4][0].data = new_4;
    }
    var dv = $a1a91b25d7598376$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $a1a91b25d7598376$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    var width = wide ? 4 : 1;
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null || data[C].t == "z" && !((_c = data[C].c) == null ? void 0 : _c.length) || data[C].t == "e") {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset / width, true);
        _dv.setUint16(C * 2, _last_offset / width, true);
        var celload, _celload;
        switch(data[C].t){
            case "d":
                if (data[C].v instanceof Date) {
                    celload = $a1a91b25d7598376$var$write_new_storage(data[C], lut);
                    _celload = $a1a91b25d7598376$var$write_old_storage(data[C], lut);
                    break;
                }
                celload = $a1a91b25d7598376$var$write_new_storage(data[C], lut);
                _celload = $a1a91b25d7598376$var$write_old_storage(data[C], lut);
                break;
            case "s":
            case "n":
            case "b":
            case "z":
                celload = $a1a91b25d7598376$var$write_new_storage(data[C], lut);
                _celload = $a1a91b25d7598376$var$write_old_storage(data[C], lut);
                break;
            default:
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $a1a91b25d7598376$var$write_varint49(cnt);
    tri[5][0].data = $a1a91b25d7598376$var$write_varint49(5);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $a1a91b25d7598376$var$u8concat(cell_storage);
    tri[3][0].data = $a1a91b25d7598376$var$u8concat(_cell_storage);
    tri[8] = [
        {
            type: 0,
            data: $a1a91b25d7598376$var$write_varint49(wide ? 1 : 0)
        }
    ];
    return tri;
}
function $a1a91b25d7598376$var$write_iwam(type, payload) {
    return {
        meta: [
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(type)
                }
            ]
        ],
        data: payload
    };
}
function $a1a91b25d7598376$var$get_unique_msgid(dep, dependents) {
    if (!dependents.last) dependents.last = 927262;
    for(var i = dependents.last; i < 2e6; ++i)if (!dependents[i]) {
        dependents[dependents.last = i] = dep;
        return i;
    }
    throw new Error("Too many messages");
}
function $a1a91b25d7598376$var$build_numbers_deps(cfb) {
    var dependents = {};
    var indices = [];
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $a1a91b25d7598376$var$parse_iwa_file($a1a91b25d7598376$var$decompress_iwa_file(fi.content)).forEach(function(packet) {
            indices.push(packet.id);
            dependents[packet.id] = {
                deps: [],
                location: fp,
                type: $a1a91b25d7598376$var$varint_to_i32(packet.messages[0].meta[1][0].data)
            };
        });
    });
    cfb.FileIndex.forEach(function(fi) {
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $a1a91b25d7598376$var$parse_iwa_file($a1a91b25d7598376$var$decompress_iwa_file(fi.content)).forEach(function(ia) {
            ia.messages.forEach(function(mess) {
                [
                    5,
                    6
                ].forEach(function(f) {
                    if (!mess.meta[f]) return;
                    mess.meta[f].forEach(function(x) {
                        dependents[ia.id].deps.push($a1a91b25d7598376$var$varint_to_i32(x.data));
                    });
                });
            });
        });
    });
    return dependents;
}
function $a1a91b25d7598376$var$write_TSP_Color_RGB(r, g, b) {
    return $a1a91b25d7598376$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(1)
            }
        ],
        [],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    r / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    g / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    b / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    1
                ]).buffer)
            }
        ],
        [],
        [],
        [],
        [],
        [],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(1)
            }
        ]
    ]);
}
function $a1a91b25d7598376$var$get_author_color(n) {
    switch(n){
        case 0:
            return $a1a91b25d7598376$var$write_TSP_Color_RGB(99, 222, 171);
        case 1:
            return $a1a91b25d7598376$var$write_TSP_Color_RGB(162, 197, 240);
        case 2:
            return $a1a91b25d7598376$var$write_TSP_Color_RGB(255, 189, 189);
    }
    return $a1a91b25d7598376$var$write_TSP_Color_RGB(Math.random() * 255, Math.random() * 255, Math.random() * 255);
}
function $a1a91b25d7598376$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var cfb = $a1a91b25d7598376$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    var deps = $a1a91b25d7598376$var$build_numbers_deps(cfb);
    var docroot = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, 1);
    if (docroot == null) throw "Could not find message ".concat(1, " in Numbers template");
    var sheetrefs = $a1a91b25d7598376$var$mappa($a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data)[1], $a1a91b25d7598376$var$parse_TSP_Reference);
    if (sheetrefs.length > 1) throw new Error("Template NUMBERS file must have exactly one sheet");
    wb.SheetNames.forEach(function(name, idx) {
        if (idx >= 1) {
            $a1a91b25d7598376$var$numbers_add_ws(cfb, deps, idx + 1);
            docroot = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, 1);
            sheetrefs = $a1a91b25d7598376$var$mappa($a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data)[1], $a1a91b25d7598376$var$parse_TSP_Reference);
        }
        $a1a91b25d7598376$var$write_numbers_ws(cfb, deps, wb.Sheets[name], name, idx, sheetrefs[idx]);
    });
    return cfb;
}
function $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, id, cb) {
    var entry = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $a1a91b25d7598376$var$parse_iwa_file($a1a91b25d7598376$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    cb(ainfo, x);
    entry.content = $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file(x));
    entry.size = entry.content.length;
}
function $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, id) {
    var entry = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $a1a91b25d7598376$var$parse_iwa_file($a1a91b25d7598376$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    return ainfo;
}
function $a1a91b25d7598376$var$numbers_add_meta(mlist, newid, newloc) {
    mlist[3].push({
        type: 2,
        data: $a1a91b25d7598376$var$write_shallow([
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(newid)
                }
            ],
            [
                {
                    type: 2,
                    data: $a1a91b25d7598376$var$stru8(newloc.replace(/-[\s\S]*$/, ""))
                }
            ],
            [
                {
                    type: 2,
                    data: $a1a91b25d7598376$var$stru8(newloc)
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [],
            [],
            [],
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(0)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(0)
                }
            ]
        ])
    });
    mlist[1] = [
        {
            type: 0,
            data: $a1a91b25d7598376$var$write_varint49(Math.max(newid + 1, $a1a91b25d7598376$var$varint_to_i32(mlist[1][0].data)))
        }
    ];
}
function $a1a91b25d7598376$var$numbers_add_msg(cfb, type, msg, path, deps, id) {
    if (!id) id = $a1a91b25d7598376$var$get_unique_msgid({
        deps: [],
        location: "",
        type: type
    }, deps);
    var loc = "".concat(path, "-").concat(id, ".iwa");
    deps[id].location = "Root Entry" + loc;
    $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, loc, $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
        {
            id: id,
            messages: [
                $a1a91b25d7598376$var$write_iwam(type, $a1a91b25d7598376$var$write_shallow(msg))
            ]
        }
    ])));
    var newloc = loc.replace(/^[\/]/, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
        $a1a91b25d7598376$var$numbers_add_meta(mlist, id || 0, newloc);
        ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
    });
    return id;
}
function $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $a1a91b25d7598376$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $a1a91b25d7598376$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $a1a91b25d7598376$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $a1a91b25d7598376$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    (Array.isArray(dep) ? dep : [
        dep
    ]).forEach(function(dep2) {
        parent[6].push({
            type: 2,
            data: $a1a91b25d7598376$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $a1a91b25d7598376$var$write_varint49(dep2)
                    }
                ]
            ])
        });
    });
    mlist[3][parentidx].data = $a1a91b25d7598376$var$write_shallow(parent);
}
function $a1a91b25d7598376$var$numbers_meta_del_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $a1a91b25d7598376$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $a1a91b25d7598376$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $a1a91b25d7598376$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $a1a91b25d7598376$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    parent[6] = parent[6].filter(function(m) {
        return $a1a91b25d7598376$var$varint_to_i32($a1a91b25d7598376$var$parse_shallow(m.data)[1][0].data) != dep;
    });
    mlist[3][parentidx].data = $a1a91b25d7598376$var$write_shallow(parent);
}
function $a1a91b25d7598376$var$numbers_add_ws(cfb, deps, wsidx) {
    var sheetref = -1, newsheetref = -1;
    var remap = {};
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 1, function(docroot, arch) {
        var doc = $a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data);
        sheetref = $a1a91b25d7598376$var$parse_TSP_Reference($a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data)[1][0].data);
        newsheetref = $a1a91b25d7598376$var$get_unique_msgid({
            deps: [
                1
            ],
            location: deps[sheetref].location,
            type: 2
        }, deps);
        remap[sheetref] = newsheetref;
        $a1a91b25d7598376$var$numbers_add_oref(docroot, newsheetref);
        doc[1].push({
            type: 2,
            data: $a1a91b25d7598376$var$write_TSP_Reference(newsheetref)
        });
        var sheet = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, sheetref);
        sheet.id = newsheetref;
        if (deps[1].location == deps[newsheetref].location) arch.push(sheet);
        else $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, newsheetref, function(_, x) {
            return x.push(sheet);
        });
        docroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(doc);
    });
    var tiaref = -1;
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, newsheetref, function(sheetroot, arch) {
        var sa = $a1a91b25d7598376$var$parse_shallow(sheetroot.messages[0].data);
        for(var i = 3; i <= 69; ++i)delete sa[i];
        var drawables = $a1a91b25d7598376$var$mappa(sa[2], $a1a91b25d7598376$var$parse_TSP_Reference);
        drawables.forEach(function(n) {
            return $a1a91b25d7598376$var$numbers_del_oref(sheetroot, n);
        });
        tiaref = $a1a91b25d7598376$var$get_unique_msgid({
            deps: [
                newsheetref
            ],
            location: deps[drawables[0]].location,
            type: deps[drawables[0]].type
        }, deps);
        $a1a91b25d7598376$var$numbers_add_oref(sheetroot, tiaref);
        remap[drawables[0]] = tiaref;
        sa[2] = [
            {
                type: 2,
                data: $a1a91b25d7598376$var$write_TSP_Reference(tiaref)
            }
        ];
        var tia = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, drawables[0]);
        tia.id = tiaref;
        if (deps[drawables[0]].location == deps[newsheetref].location) arch.push(tia);
        else {
            $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, newsheetref, tiaref);
                ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
            });
            $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tiaref, function(_, x) {
                return x.push(tia);
            });
        }
        sheetroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(sa);
    });
    var tmaref = -1;
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tiaref, function(tiaroot, arch) {
        var tia = $a1a91b25d7598376$var$parse_shallow(tiaroot.messages[0].data);
        var da = $a1a91b25d7598376$var$parse_shallow(tia[1][0].data);
        for(var i = 3; i <= 69; ++i)delete da[i];
        var dap = $a1a91b25d7598376$var$parse_TSP_Reference(da[2][0].data);
        da[2][0].data = $a1a91b25d7598376$var$write_TSP_Reference(remap[dap]);
        tia[1][0].data = $a1a91b25d7598376$var$write_shallow(da);
        var oldtmaref = $a1a91b25d7598376$var$parse_TSP_Reference(tia[2][0].data);
        $a1a91b25d7598376$var$numbers_del_oref(tiaroot, oldtmaref);
        tmaref = $a1a91b25d7598376$var$get_unique_msgid({
            deps: [
                tiaref
            ],
            location: deps[oldtmaref].location,
            type: deps[oldtmaref].type
        }, deps);
        $a1a91b25d7598376$var$numbers_add_oref(tiaroot, tmaref);
        remap[oldtmaref] = tmaref;
        tia[2][0].data = $a1a91b25d7598376$var$write_TSP_Reference(tmaref);
        var tma = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, oldtmaref);
        tma.id = tmaref;
        if (deps[tiaref].location == deps[tmaref].location) arch.push(tma);
        else $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tmaref, function(_, x) {
            return x.push(tma);
        });
        tiaroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(tia);
    });
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tmaref, function(tmaroot, arch) {
        var _a, _b;
        var tma = $a1a91b25d7598376$var$parse_shallow(tmaroot.messages[0].data);
        var uuid = $a1a91b25d7598376$var$u8str(tma[1][0].data), new_uuid = uuid.replace(/-[A-Z0-9]*/, "-".concat(("0000" + wsidx.toString(16)).slice(-4)));
        tma[1][0].data = $a1a91b25d7598376$var$stru8(new_uuid);
        [
            12,
            13,
            29,
            31,
            32,
            33,
            39,
            44,
            47,
            81,
            82,
            84
        ].forEach(function(n) {
            return delete tma[n];
        });
        if (tma[45]) {
            var srrta = $a1a91b25d7598376$var$parse_shallow(tma[45][0].data);
            var ref = $a1a91b25d7598376$var$parse_TSP_Reference(srrta[1][0].data);
            $a1a91b25d7598376$var$numbers_del_oref(tmaroot, ref);
            delete tma[45];
        }
        if (tma[70]) {
            var hsoa = $a1a91b25d7598376$var$parse_shallow(tma[70][0].data);
            (_a = hsoa[2]) == null || _a.forEach(function(item) {
                var hsa = $a1a91b25d7598376$var$parse_shallow(item.data);
                [
                    2,
                    3
                ].map(function(n) {
                    return hsa[n][0];
                }).forEach(function(hseadata) {
                    var hsea = $a1a91b25d7598376$var$parse_shallow(hseadata.data);
                    if (!hsea[8]) return;
                    var ref2 = $a1a91b25d7598376$var$parse_TSP_Reference(hsea[8][0].data);
                    $a1a91b25d7598376$var$numbers_del_oref(tmaroot, ref2);
                });
            });
            delete tma[70];
        }
        [
            46,
            30,
            34,
            35,
            36,
            38,
            48,
            49,
            60,
            61,
            62,
            63,
            64,
            71,
            72,
            73,
            74,
            75,
            85,
            86,
            87,
            88,
            89
        ].forEach(function(n) {
            if (!tma[n]) return;
            var ref2 = $a1a91b25d7598376$var$parse_TSP_Reference(tma[n][0].data);
            delete tma[n];
            $a1a91b25d7598376$var$numbers_del_oref(tmaroot, ref2);
        });
        var store = $a1a91b25d7598376$var$parse_shallow(tma[4][0].data);
        [
            2,
            4,
            5,
            6,
            11,
            12,
            13,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22
        ].forEach(function(n) {
            var _a2;
            if (!((_a2 = store[n]) == null ? void 0 : _a2[0])) return;
            var oldref = $a1a91b25d7598376$var$parse_TSP_Reference(store[n][0].data);
            var newref = $a1a91b25d7598376$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $a1a91b25d7598376$var$numbers_del_oref(tmaroot, oldref);
            $a1a91b25d7598376$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                    $a1a91b25d7598376$var$numbers_add_meta(mlist, newref, newloc);
                    $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                });
            }
            store[n][0].data = $a1a91b25d7598376$var$write_TSP_Reference(newref);
        });
        var row_headers = $a1a91b25d7598376$var$parse_shallow(store[1][0].data);
        (_b = row_headers[2]) == null || _b.forEach(function(tspref) {
            var oldref = $a1a91b25d7598376$var$parse_TSP_Reference(tspref.data);
            var newref = $a1a91b25d7598376$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $a1a91b25d7598376$var$numbers_del_oref(tmaroot, oldref);
            $a1a91b25d7598376$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                    $a1a91b25d7598376$var$numbers_add_meta(mlist, newref, newloc);
                    $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                });
            }
            tspref.data = $a1a91b25d7598376$var$write_TSP_Reference(newref);
        });
        store[1][0].data = $a1a91b25d7598376$var$write_shallow(row_headers);
        var tiles = $a1a91b25d7598376$var$parse_shallow(store[3][0].data);
        tiles[1].forEach(function(t) {
            var tst = $a1a91b25d7598376$var$parse_shallow(t.data);
            var oldtileref = $a1a91b25d7598376$var$parse_TSP_Reference(tst[2][0].data);
            var newtileref = remap[oldtileref];
            if (!remap[oldtileref]) {
                newtileref = $a1a91b25d7598376$var$get_unique_msgid({
                    deps: [
                        tmaref
                    ],
                    location: "",
                    type: deps[oldtileref].type
                }, deps);
                deps[newtileref].location = "Root Entry/Index/Tables/Tile-".concat(newtileref, ".iwa");
                remap[oldtileref] = newtileref;
                var oldtile = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, oldtileref);
                oldtile.id = newtileref;
                $a1a91b25d7598376$var$numbers_del_oref(tmaroot, oldtileref);
                $a1a91b25d7598376$var$numbers_add_oref(tmaroot, newtileref);
                $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileref, ".iwa"), $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
                    oldtile
                ])));
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $a1a91b25d7598376$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(newtileref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $a1a91b25d7598376$var$stru8("Tables/Tile")
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $a1a91b25d7598376$var$stru8("Tables/Tile-".concat(newtileref))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(Math.max(newtileref + 1, $a1a91b25d7598376$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileref);
                    ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                });
            }
            tst[2][0].data = $a1a91b25d7598376$var$write_TSP_Reference(newtileref);
            t.data = $a1a91b25d7598376$var$write_shallow(tst);
        });
        store[3][0].data = $a1a91b25d7598376$var$write_shallow(tiles);
        tma[4][0].data = $a1a91b25d7598376$var$write_shallow(store);
        tmaroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(tma);
    });
}
function $a1a91b25d7598376$var$write_numbers_ws(cfb, deps, ws, wsname, sheetidx, rootref) {
    var drawables = [];
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, rootref, function(docroot) {
        var sheetref = $a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data);
        sheetref[1] = [
            {
                type: 2,
                data: $a1a91b25d7598376$var$stru8(wsname)
            }
        ];
        drawables = $a1a91b25d7598376$var$mappa(sheetref[2], $a1a91b25d7598376$var$parse_TSP_Reference);
        docroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(sheetref);
    });
    var tia = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, drawables[0]);
    var tmaref = $a1a91b25d7598376$var$parse_TSP_Reference($a1a91b25d7598376$var$parse_shallow(tia.messages[0].data)[2][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tmaref, function(docroot, x) {
        return $a1a91b25d7598376$var$write_numbers_tma(cfb, deps, ws, docroot, x, tmaref);
    });
}
var $a1a91b25d7598376$var$USE_WIDE_ROWS = true;
function $a1a91b25d7598376$var$write_numbers_tma(cfb, deps, ws, tmaroot, tmafile, tmaref) {
    if (!ws["!ref"]) throw new Error("Cannot export empty sheet to NUMBERS");
    var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 999) {
        trunc = true;
        range.e.c = 999;
    }
    if (range.e.r > 999999) {
        trunc = true;
        range.e.r = 999999;
    }
    if (trunc) console.error("Truncating to ".concat($a1a91b25d7598376$var$encode_range(range)));
    var data = [];
    if (ws["!data"]) data = ws["!data"];
    else {
        var colstr = [];
        for(var _C = 0; _C <= range.e.c; ++_C)colstr[_C] = $a1a91b25d7598376$var$encode_col(_C);
        for(var R_ = 0; R_ <= range.e.r; ++R_){
            data[R_] = [];
            var _R = "" + (R_ + 1);
            for(_C = 0; _C <= range.e.c; ++_C){
                var _cell = ws[colstr[_C] + _R];
                if (!_cell) continue;
                data[R_][_C] = _cell;
            }
        }
    }
    var LUT = {
        cmnt: [
            {
                a: "~54ee77S~",
                t: "... the people who are crazy enough to think they can change the world, are the ones who do."
            }
        ],
        ferr: [],
        fmla: [],
        nfmt: [],
        ofmt: [],
        rsst: [
            {
                v: "~54ee77S~",
                l: "https://sheetjs.com/"
            }
        ],
        sst: [
            "~Sh33tJ5~"
        ]
    };
    var pb = $a1a91b25d7598376$var$parse_shallow(tmaroot.messages[0].data);
    pb[6][0].data = $a1a91b25d7598376$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $a1a91b25d7598376$var$write_varint49(range.e.c + 1);
    delete pb[46];
    var store = $a1a91b25d7598376$var$parse_shallow(pb[4][0].data);
    var row_header_ref = $a1a91b25d7598376$var$parse_TSP_Reference($a1a91b25d7598376$var$parse_shallow(store[1][0].data)[2][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, row_header_ref, function(rowhead, _x) {
        var _a;
        var base_bucket = $a1a91b25d7598376$var$parse_shallow(rowhead.messages[0].data);
        if ((_a = base_bucket == null ? void 0 : base_bucket[2]) == null ? void 0 : _a[0]) for(var R2 = 0; R2 < data.length; ++R2){
            var _bucket = $a1a91b25d7598376$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $a1a91b25d7598376$var$write_varint49(R2);
            _bucket[4][0].data = $a1a91b25d7598376$var$write_varint49(data[R2].length);
            base_bucket[2][R2] = {
                type: base_bucket[2][0].type,
                data: $a1a91b25d7598376$var$write_shallow(_bucket)
            };
        }
        rowhead.messages[0].data = $a1a91b25d7598376$var$write_shallow(base_bucket);
    });
    var col_header_ref = $a1a91b25d7598376$var$parse_TSP_Reference(store[2][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, col_header_ref, function(colhead, _x) {
        var base_bucket = $a1a91b25d7598376$var$parse_shallow(colhead.messages[0].data);
        for(var C = 0; C <= range.e.c; ++C){
            var _bucket = $a1a91b25d7598376$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $a1a91b25d7598376$var$write_varint49(C);
            _bucket[4][0].data = $a1a91b25d7598376$var$write_varint49(range.e.r + 1);
            base_bucket[2][C] = {
                type: base_bucket[2][0].type,
                data: $a1a91b25d7598376$var$write_shallow(_bucket)
            };
        }
        colhead.messages[0].data = $a1a91b25d7598376$var$write_shallow(base_bucket);
    });
    var rbtree = $a1a91b25d7598376$var$parse_shallow(store[9][0].data);
    rbtree[1] = [];
    var tilestore = $a1a91b25d7598376$var$parse_shallow(store[3][0].data);
    var tstride = 256;
    tilestore[2] = [
        {
            type: 0,
            data: $a1a91b25d7598376$var$write_varint49(tstride)
        }
    ];
    var tileref = $a1a91b25d7598376$var$parse_TSP_Reference($a1a91b25d7598376$var$parse_shallow(tilestore[1][0].data)[2][0].data);
    var save_token = function() {
        var metadata = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, 2);
        var mlist = $a1a91b25d7598376$var$parse_shallow(metadata.messages[0].data);
        var mlst = mlist[3].filter(function(m) {
            return $a1a91b25d7598376$var$varint_to_i32($a1a91b25d7598376$var$parse_shallow(m.data)[1][0].data) == tileref;
        });
        return (mlst == null ? void 0 : mlst.length) ? $a1a91b25d7598376$var$varint_to_i32($a1a91b25d7598376$var$parse_shallow(mlst[0].data)[12][0].data) : 0;
    }();
    $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_del(cfb, deps[tileref].location);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
        mlist[3] = mlist[3].filter(function(m) {
            return $a1a91b25d7598376$var$varint_to_i32($a1a91b25d7598376$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        $a1a91b25d7598376$var$numbers_meta_del_dep(mlist, deps, tmaref, tileref);
        ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
    });
    $a1a91b25d7598376$var$numbers_del_oref(tmaroot, tileref);
    tilestore[1] = [];
    var ntiles = Math.ceil((range.e.r + 1) / tstride);
    for(var tidx = 0; tidx < ntiles; ++tidx){
        var newtileid = $a1a91b25d7598376$var$get_unique_msgid({
            deps: [],
            location: "",
            type: 6002
        }, deps);
        deps[newtileid].location = "Root Entry/Index/Tables/Tile-".concat(newtileid, ".iwa");
        var tiledata = [
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(Math.min(range.e.r + 1, (tidx + 1) * tstride))
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(Math.min((tidx + 1) * tstride, range.e.r + 1) - tidx * tstride)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(5)
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(1)
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49($a1a91b25d7598376$var$USE_WIDE_ROWS ? 1 : 0)
                }
            ]
        ];
        for(var R = tidx * tstride; R <= Math.min(range.e.r, (tidx + 1) * tstride - 1); ++R){
            var tilerow = $a1a91b25d7598376$var$write_TST_TileRowInfo(data[R], LUT, $a1a91b25d7598376$var$USE_WIDE_ROWS);
            tilerow[1][0].data = $a1a91b25d7598376$var$write_varint49(R - tidx * tstride);
            tiledata[5].push({
                data: $a1a91b25d7598376$var$write_shallow(tilerow),
                type: 2
            });
        }
        tilestore[1].push({
            type: 2,
            data: $a1a91b25d7598376$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $a1a91b25d7598376$var$write_varint49(tidx)
                    }
                ],
                [
                    {
                        type: 2,
                        data: $a1a91b25d7598376$var$write_TSP_Reference(newtileid)
                    }
                ]
            ])
        });
        var newtile = {
            id: newtileid,
            messages: [
                $a1a91b25d7598376$var$write_iwam(6002, $a1a91b25d7598376$var$write_shallow(tiledata))
            ]
        };
        var tilecontent = $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
            newtile
        ]));
        $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileid, ".iwa"), tilecontent);
        $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
            mlist[3].push({
                type: 2,
                data: $a1a91b25d7598376$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(newtileid)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8("Tables/Tile")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8("Tables/Tile-".concat(newtileid))
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(0)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(save_token)
                        }
                    ]
                ])
            });
            mlist[1] = [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(Math.max(newtileid + 1, $a1a91b25d7598376$var$varint_to_i32(mlist[1][0].data)))
                }
            ];
            $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileid);
            ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
        });
        $a1a91b25d7598376$var$numbers_add_oref(tmaroot, newtileid);
        rbtree[1].push({
            type: 2,
            data: $a1a91b25d7598376$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $a1a91b25d7598376$var$write_varint49(tidx * tstride)
                    }
                ],
                [
                    {
                        type: 0,
                        data: $a1a91b25d7598376$var$write_varint49(tidx)
                    }
                ]
            ])
        });
    }
    store[3][0].data = $a1a91b25d7598376$var$write_shallow(tilestore);
    store[9][0].data = $a1a91b25d7598376$var$write_shallow(rbtree);
    store[10] = [
        {
            type: 2,
            data: new Uint8Array([])
        }
    ];
    if (ws["!merges"]) {
        var mergeid = $a1a91b25d7598376$var$get_unique_msgid({
            type: 6144,
            deps: [
                tmaref
            ],
            location: deps[tmaref].location
        }, deps);
        tmafile.push({
            id: mergeid,
            messages: [
                $a1a91b25d7598376$var$write_iwam(6144, $a1a91b25d7598376$var$write_shallow([
                    [],
                    ws["!merges"].map(function(m) {
                        return {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 2,
                                        data: $a1a91b25d7598376$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.s.r,
                                                        m.s.c
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ],
                                [
                                    {
                                        type: 2,
                                        data: $a1a91b25d7598376$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.e.r - m.s.r + 1,
                                                        m.e.c - m.s.c + 1
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ]
                            ])
                        };
                    })
                ]))
            ]
        });
        store[13] = [
            {
                type: 2,
                data: $a1a91b25d7598376$var$write_TSP_Reference(mergeid)
            }
        ];
        $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
            $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tmaref, mergeid);
            ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
        });
        $a1a91b25d7598376$var$numbers_add_oref(tmaroot, mergeid);
    } else delete store[13];
    var sstref = $a1a91b25d7598376$var$parse_TSP_Reference(store[4][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, sstref, function(sstroot) {
        var sstdata = $a1a91b25d7598376$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        LUT.sst.forEach(function(str, i) {
            if (i == 0) return;
            sstdata[3].push({
                type: 2,
                data: $a1a91b25d7598376$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(1)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8(str)
                        }
                    ]
                ])
            });
        });
        sstroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(sstdata);
    });
    var rsstref = $a1a91b25d7598376$var$parse_TSP_Reference(store[17][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, rsstref, function(rsstroot) {
        var rsstdata = $a1a91b25d7598376$var$parse_shallow(rsstroot.messages[0].data);
        rsstdata[3] = [];
        var style_indices = [
            904980,
            903835,
            903815,
            903845
        ];
        LUT.rsst.forEach(function(rsst, i) {
            if (i == 0) return;
            var tswpsa = [
                [],
                [
                    {
                        type: 0,
                        data: new Uint8Array([
                            5
                        ])
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: $a1a91b25d7598376$var$stru8(rsst.v)
                    }
                ]
            ];
            tswpsa[10] = [
                {
                    type: 0,
                    data: new Uint8Array([
                        1
                    ])
                }
            ];
            tswpsa[19] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        18,
                        2,
                        101,
                        110
                    ])
                }
            ];
            tswpsa[5] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        155,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[2] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        8,
                        148,
                        158,
                        55
                    ])
                }
            ];
            tswpsa[6] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[7] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        135,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[8] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        165,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[14] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[24] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            var tswpsaid = $a1a91b25d7598376$var$get_unique_msgid({
                deps: [],
                location: "",
                type: 2001
            }, deps);
            var tswpsarefs = [];
            if (rsst.l) {
                var newhlinkid = $a1a91b25d7598376$var$numbers_add_msg(cfb, 2032, [
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8(rsst.l)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                tswpsa[11] = [];
                var smartfield = [
                    [],
                    []
                ];
                if (!smartfield[1]) smartfield[1] = [];
                smartfield[1].push({
                    type: 2,
                    data: $a1a91b25d7598376$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $a1a91b25d7598376$var$write_varint49(0)
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$write_TSP_Reference(newhlinkid)
                            }
                        ]
                    ])
                });
                tswpsa[11][0] = {
                    type: 2,
                    data: $a1a91b25d7598376$var$write_shallow(smartfield)
                };
                tswpsarefs.push(newhlinkid);
            }
            $a1a91b25d7598376$var$numbers_add_msg(cfb, 2001, tswpsa, "/Index/Tables/DataList", deps, tswpsaid);
            $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tswpsaid, function(iwa) {
                style_indices.forEach(function(ref) {
                    return $a1a91b25d7598376$var$numbers_add_oref(iwa, ref);
                });
                tswpsarefs.forEach(function(ref) {
                    return $a1a91b25d7598376$var$numbers_add_oref(iwa, ref);
                });
            });
            var rtpaid = $a1a91b25d7598376$var$numbers_add_msg(cfb, 6218, [
                [],
                [
                    {
                        type: 2,
                        data: $a1a91b25d7598376$var$write_TSP_Reference(tswpsaid)
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: new Uint8Array([
                            13,
                            255,
                            255,
                            255,
                            0,
                            18,
                            10,
                            16,
                            255,
                            255,
                            1,
                            24,
                            255,
                            255,
                            255,
                            255,
                            7
                        ])
                    }
                ]
            ], "/Index/Tables/DataList", deps);
            $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, rtpaid, function(iwa) {
                return $a1a91b25d7598376$var$numbers_add_oref(iwa, tswpsaid);
            });
            rsstdata[3].push({
                type: 2,
                data: $a1a91b25d7598376$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(1)
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_TSP_Reference(rtpaid)
                        }
                    ]
                ])
            });
            $a1a91b25d7598376$var$numbers_add_oref(rsstroot, rtpaid);
            $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, rsstref, rtpaid);
                $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, rtpaid, tswpsaid);
                $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tswpsaid, tswpsarefs);
                $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tswpsaid, style_indices);
                ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
            });
        });
        rsstroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(rsstdata);
    });
    if (LUT.cmnt.length > 1) {
        var cmntref = $a1a91b25d7598376$var$parse_TSP_Reference(store[19][0].data);
        var authors = {}, iauthor = 0;
        $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, cmntref, function(cmntroot) {
            var cmntdata = $a1a91b25d7598376$var$parse_shallow(cmntroot.messages[0].data);
            cmntdata[3] = [];
            LUT.cmnt.forEach(function(cc, i) {
                if (i == 0) return;
                var replies = [];
                if (cc.replies) cc.replies.forEach(function(c) {
                    if (!authors[c.a || ""]) authors[c.a || ""] = $a1a91b25d7598376$var$numbers_add_msg(cfb, 212, [
                        [],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$stru8(c.a || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$get_author_color(++iauthor)
                            }
                        ],
                        [],
                        [
                            {
                                type: 0,
                                data: $a1a91b25d7598376$var$write_varint49(0)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    var aaaid2 = authors[c.a || ""];
                    var csaid2 = $a1a91b25d7598376$var$numbers_add_msg(cfb, 3056, [
                        [],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$stru8(c.t || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$write_shallow([
                                    [],
                                    [
                                        {
                                            type: 1,
                                            data: new Uint8Array([
                                                0,
                                                0,
                                                0,
                                                128,
                                                116,
                                                109,
                                                182,
                                                65
                                            ])
                                        }
                                    ]
                                ])
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$write_TSP_Reference(aaaid2)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, csaid2, function(iwa) {
                        return $a1a91b25d7598376$var$numbers_add_oref(iwa, aaaid2);
                    });
                    replies.push(csaid2);
                    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                        var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                        $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, csaid2, aaaid2);
                        ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                    });
                });
                if (!authors[cc.a || ""]) authors[cc.a || ""] = $a1a91b25d7598376$var$numbers_add_msg(cfb, 212, [
                    [],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8(cc.a || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$get_author_color(++iauthor)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(0)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                var aaaid = authors[cc.a || ""];
                var csaid = $a1a91b25d7598376$var$numbers_add_msg(cfb, 3056, [
                    [],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8(cc.t || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 1,
                                        data: new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            128,
                                            116,
                                            109,
                                            182,
                                            65
                                        ])
                                    }
                                ]
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_TSP_Reference(aaaid)
                        }
                    ],
                    replies.map(function(r) {
                        return {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_TSP_Reference(r)
                        };
                    }),
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 0,
                                        data: $a1a91b25d7598376$var$write_varint49(i)
                                    }
                                ],
                                [
                                    {
                                        type: 0,
                                        data: $a1a91b25d7598376$var$write_varint49(0)
                                    }
                                ]
                            ])
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, csaid, function(iwa) {
                    $a1a91b25d7598376$var$numbers_add_oref(iwa, aaaid);
                    replies.forEach(function(r) {
                        return $a1a91b25d7598376$var$numbers_add_oref(iwa, r);
                    });
                });
                cmntdata[3].push({
                    type: 2,
                    data: $a1a91b25d7598376$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $a1a91b25d7598376$var$write_varint49(i)
                            }
                        ],
                        [
                            {
                                type: 0,
                                data: $a1a91b25d7598376$var$write_varint49(1)
                            }
                        ],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$write_TSP_Reference(csaid)
                            }
                        ]
                    ])
                });
                $a1a91b25d7598376$var$numbers_add_oref(cmntroot, csaid);
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                    $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, cmntref, csaid);
                    $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, csaid, aaaid);
                    if (replies.length) $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, csaid, replies);
                    ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                });
            });
            cmntdata[2][0].data = $a1a91b25d7598376$var$write_varint49(LUT.cmnt.length + 1);
            cmntroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(cmntdata);
        });
    }
    pb[4][0].data = $a1a91b25d7598376$var$write_shallow(store);
    tmaroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(pb);
}
function $a1a91b25d7598376$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $a1a91b25d7598376$var$fix_read_opts(opts) {
    $a1a91b25d7598376$var$fix_opts_func([
        [
            'cellNF',
            false
        ],
        /* emit cell number format string as .z */ [
            'cellHTML',
            true
        ],
        /* emit html string as .h */ [
            'cellFormula',
            true
        ],
        /* emit formulae as .f */ [
            'cellStyles',
            false
        ],
        /* emits style/theme as .s */ [
            'cellText',
            true
        ],
        /* emit formatted text as .w */ [
            'cellDates',
            false
        ],
        /* emit date cells with type `d` */ [
            'sheetStubs',
            false
        ],
        /* emit empty cells */ [
            'sheetRows',
            0,
            'n'
        ],
        /* read n rows (0 = read all rows) */ [
            'bookDeps',
            false
        ],
        /* parse calculation chains */ [
            'bookSheets',
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            'bookProps',
            false
        ],
        /* only try to get properties (no Sheets) */ [
            'bookFiles',
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            'bookVBA',
            false
        ],
        /* include vba raw data (vbaraw) */ [
            'password',
            ''
        ],
        /* password */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $a1a91b25d7598376$var$fix_write_opts(opts) {
    $a1a91b25d7598376$var$fix_opts_func([
        [
            'cellDates',
            false
        ],
        /* write date cells with type `d` */ [
            'bookSST',
            false
        ],
        /* Generate Shared String Table */ [
            'bookType',
            'xlsx'
        ],
        /* Type of workbook (xlsx/m/b) */ [
            'compression',
            false
        ],
        /* Use file compression */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $a1a91b25d7598376$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($a1a91b25d7598376$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($a1a91b25d7598376$var$RELS.CS && n == $a1a91b25d7598376$var$RELS.CS) return "chart";
    if ($a1a91b25d7598376$var$RELS.DS && n == $a1a91b25d7598376$var$RELS.DS) return "dialog";
    if ($a1a91b25d7598376$var$RELS.MS && n == $a1a91b25d7598376$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $a1a91b25d7598376$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels['!id'][w.id].Target,
                $a1a91b25d7598376$var$get_sheet_type(wbrels['!id'][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $a1a91b25d7598376$var$parse_sheet_legacy_drawing(sheet, type, zip, path, idx, opts, wb, comments) {
    if (!sheet || !sheet['!legdrawel']) return;
    var dfile = $a1a91b25d7598376$var$resolve_path(sheet['!legdrawel'].Target, path);
    var draw = $a1a91b25d7598376$var$getzipstr(zip, dfile, true);
    if (draw) $a1a91b25d7598376$var$parse_vml($a1a91b25d7598376$var$utf8read(draw), sheet, comments || []);
}
function $a1a91b25d7598376$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, relsPath, true), path);
        var data = $a1a91b25d7598376$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case 'sheet':
                _ws = $a1a91b25d7598376$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'chart':
                _ws = $a1a91b25d7598376$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws['!drawel']) break;
                var dfile = $a1a91b25d7598376$var$resolve_path(_ws['!drawel'].Target, path);
                var drelsp = $a1a91b25d7598376$var$get_rels_path(dfile);
                var draw = $a1a91b25d7598376$var$parse_drawing($a1a91b25d7598376$var$getzipstr(zip, dfile, true), $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $a1a91b25d7598376$var$resolve_path(draw, dfile);
                var crelsp = $a1a91b25d7598376$var$get_rels_path(chartp);
                _ws = $a1a91b25d7598376$var$parse_chart($a1a91b25d7598376$var$getzipstr(zip, chartp, true), chartp, opts, $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case 'macro':
                _ws = $a1a91b25d7598376$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'dialog':
                _ws = $a1a91b25d7598376$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var comments = [], tcomments = [];
        if (sheetRels && sheetRels[sheet]) $a1a91b25d7598376$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $a1a91b25d7598376$var$RELS.CMNT) {
                dfile = $a1a91b25d7598376$var$resolve_path(sheetRels[sheet][n].Target, path);
                comments = $a1a91b25d7598376$var$parse_cmnt($a1a91b25d7598376$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $a1a91b25d7598376$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $a1a91b25d7598376$var$RELS.TCMNT) {
                dfile = $a1a91b25d7598376$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($a1a91b25d7598376$var$parse_tcmnt_xml($a1a91b25d7598376$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $a1a91b25d7598376$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
        $a1a91b25d7598376$var$parse_sheet_legacy_drawing(_ws, stype, zip, path, idx, opts, wb, comments);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $a1a91b25d7598376$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == '/' ? x.slice(1) : x;
}
function $a1a91b25d7598376$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $a1a91b25d7598376$var$make_ssf();
    opts = opts || {};
    $a1a91b25d7598376$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($a1a91b25d7598376$var$safegetzipfile(zip, 'META-INF/manifest.xml')) return $a1a91b25d7598376$var$parse_ods(zip, opts);
    /* UOC */ if ($a1a91b25d7598376$var$safegetzipfile(zip, 'objectdata.xml')) return $a1a91b25d7598376$var$parse_ods(zip, opts);
    /* Numbers */ if ($a1a91b25d7598376$var$safegetzipfile(zip, 'Index/Document.iwa')) {
        if (typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
        if (typeof $a1a91b25d7598376$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $a1a91b25d7598376$var$parse_numbers_iwa(zip, opts);
            var _zip = $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_new();
            $a1a91b25d7598376$var$zipentries(zip).forEach(function(e) {
                $a1a91b25d7598376$var$zip_add_file(_zip, e, $a1a91b25d7598376$var$getzipbin(zip, e));
            });
            return $a1a91b25d7598376$var$parse_numbers_iwa(_zip, opts);
        }
        throw new Error('Unsupported NUMBERS file');
    }
    if (!$a1a91b25d7598376$var$safegetzipfile(zip, '[Content_Types].xml')) {
        if ($a1a91b25d7598376$var$safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
        if ($a1a91b25d7598376$var$safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
        var index_zip = $a1a91b25d7598376$export$9f0e51cd97c572a.find(zip, 'Index.zip');
        if (index_zip) {
            opts = $a1a91b25d7598376$var$dup(opts);
            delete opts.type;
            if (typeof index_zip.content == "string") opts.type = "binary";
            // TODO: Bun buffer bug
            if (typeof Bun !== "undefined" && $a1a91b25d7598376$require$Buffer.isBuffer(index_zip.content)) return $a1a91b25d7598376$export$aafa59e2e03f2942(new Uint8Array(index_zip.content), opts);
            return $a1a91b25d7598376$export$aafa59e2e03f2942(index_zip.content, opts);
        }
        throw new Error('Unsupported ZIP file');
    }
    var entries = $a1a91b25d7598376$var$zipentries(zip);
    var dir = $a1a91b25d7598376$var$parse_ct($a1a91b25d7598376$var$getzipstr(zip, '[Content_Types].xml'));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($a1a91b25d7598376$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$a1a91b25d7598376$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $a1a91b25d7598376$var$strs = [];
        if (dir.sst) try {
            $a1a91b25d7598376$var$strs = $a1a91b25d7598376$var$parse_sst($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $a1a91b25d7598376$var$parse_theme_xml($a1a91b25d7598376$var$getzipstr(zip, dir.themes[0].replace(/^\//, ''), true) || "", opts);
        if (dir.style) styles = $a1a91b25d7598376$var$parse_sty($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, $a1a91b25d7598376$var$get_rels_path($a1a91b25d7598376$var$strip_front_slash(link))), link);
            return $a1a91b25d7598376$var$parse_xlink($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $a1a91b25d7598376$var$parse_wb($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $a1a91b25d7598376$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $a1a91b25d7598376$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $a1a91b25d7598376$var$getzipstr(zip, $a1a91b25d7598376$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $a1a91b25d7598376$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $a1a91b25d7598376$var$parse_cc($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$a1a91b25d7598376$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
    var wbrels = $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $a1a91b25d7598376$var$parse_xlmeta($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $a1a91b25d7598376$var$parse_people_xml($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $a1a91b25d7598376$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $a1a91b25d7598376$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = 'xl/' + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$a1a91b25d7598376$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$a1a91b25d7598376$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/[\S\s]*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = 'xl/worksheets/sheet' + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $a1a91b25d7598376$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $a1a91b25d7598376$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $a1a91b25d7598376$var$CT_VBA) out.vbaraw = $a1a91b25d7598376$var$getzipdata(zip, 'xl/vbaProject.bin', true);
    }
    // TODO: pass back content types metadata for xlsm/xlsx resolution
    out.bookType = xlsb ? "xlsb" : "xlsx";
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $a1a91b25d7598376$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = 'Workbook', data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = '/!DataSpaces/Version';
        data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $a1a91b25d7598376$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = '/!DataSpaces/DataSpaceMap';
        data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $a1a91b25d7598376$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
        data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $a1a91b25d7598376$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
        data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $a1a91b25d7598376$var$parse_Primary(data.content);
    } catch (e) {}
    f = '/EncryptionInfo';
    data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $a1a91b25d7598376$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = '/EncryptedPackage';
    data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $a1a91b25d7598376$var$write_zip_xlsb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb && wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($a1a91b25d7598376$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "bin";
    var vbafmt = true;
    var ct = $a1a91b25d7598376$var$new_ct();
    $a1a91b25d7598376$var$fix_write_opts(opts = opts || {});
    var zip = $a1a91b25d7598376$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 2, f, $a1a91b25d7598376$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 3, f, $a1a91b25d7598376$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $a1a91b25d7598376$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $a1a91b25d7598376$var$add_rels(opts.rels, 4, f, $a1a91b25d7598376$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_ws_bin(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $a1a91b25d7598376$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $a1a91b25d7598376$var$zip_add_file(zip, cf, $a1a91b25d7598376$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $a1a91b25d7598376$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $a1a91b25d7598376$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $a1a91b25d7598376$var$zip_add_file(zip, cf, $a1a91b25d7598376$var$write_comments_bin(comments, opts));
                ct.comments.push(cf);
                $a1a91b25d7598376$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $a1a91b25d7598376$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $a1a91b25d7598376$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $a1a91b25d7598376$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $a1a91b25d7598376$var$zip_add_file(zip, $a1a91b25d7598376$var$get_rels_path(f), $a1a91b25d7598376$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_sst_bin(opts.Strings, opts));
        ct.strs.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $a1a91b25d7598376$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_wb_bin(wb, opts));
    ct.workbooks.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 1, f, $a1a91b25d7598376$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    var ww = $a1a91b25d7598376$var$write_theme(wb.Themes, opts);
    $a1a91b25d7598376$var$zip_add_file(zip, f, ww);
    ct.themes.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $a1a91b25d7598376$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_sty_bin(wb, opts));
    ct.styles.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "styles." + wbext, $a1a91b25d7598376$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $a1a91b25d7598376$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $a1a91b25d7598376$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_xlmeta_bin());
    ct.metadata.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $a1a91b25d7598376$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_people_xml(people, opts));
        ct.people.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "persons/person.xml", $a1a91b25d7598376$var$RELS.PEOPLE);
    }
    $a1a91b25d7598376$var$zip_add_file(zip, "[Content_Types].xml", $a1a91b25d7598376$var$write_ct(ct, opts));
    $a1a91b25d7598376$var$zip_add_file(zip, '_rels/.rels', $a1a91b25d7598376$var$write_rels(opts.rels));
    $a1a91b25d7598376$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $a1a91b25d7598376$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $a1a91b25d7598376$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb && wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($a1a91b25d7598376$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $a1a91b25d7598376$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $a1a91b25d7598376$var$new_ct();
    $a1a91b25d7598376$var$fix_write_opts(opts = opts || {});
    var zip = $a1a91b25d7598376$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 2, f, $a1a91b25d7598376$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 3, f, $a1a91b25d7598376$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $a1a91b25d7598376$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $a1a91b25d7598376$var$add_rels(opts.rels, 4, f, $a1a91b25d7598376$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $a1a91b25d7598376$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $a1a91b25d7598376$var$zip_add_file(zip, cf, $a1a91b25d7598376$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $a1a91b25d7598376$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $a1a91b25d7598376$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $a1a91b25d7598376$var$zip_add_file(zip, cf, $a1a91b25d7598376$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $a1a91b25d7598376$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $a1a91b25d7598376$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $a1a91b25d7598376$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $a1a91b25d7598376$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $a1a91b25d7598376$var$zip_add_file(zip, $a1a91b25d7598376$var$get_rels_path(f), $a1a91b25d7598376$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $a1a91b25d7598376$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 1, f, $a1a91b25d7598376$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $a1a91b25d7598376$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "styles." + wbext, $a1a91b25d7598376$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $a1a91b25d7598376$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $a1a91b25d7598376$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $a1a91b25d7598376$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_people_xml(people, opts));
        ct.people.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "persons/person.xml", $a1a91b25d7598376$var$RELS.PEOPLE);
    }
    $a1a91b25d7598376$var$zip_add_file(zip, "[Content_Types].xml", $a1a91b25d7598376$var$write_ct(ct, opts));
    $a1a91b25d7598376$var$zip_add_file(zip, '_rels/.rels', $a1a91b25d7598376$var$write_rels(opts.rels));
    $a1a91b25d7598376$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $a1a91b25d7598376$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $a1a91b25d7598376$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case 'buffer':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case 'base64':
            x = $a1a91b25d7598376$var$Base64_decode(f.slice(0, 12));
            break;
        case 'binary':
            x = f;
            break;
        case 'array':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $a1a91b25d7598376$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $a1a91b25d7598376$var$parse_xlsxcfb(cfb, opts);
    return $a1a91b25d7598376$export$b41972a043aba84c(cfb, opts);
}
function $a1a91b25d7598376$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $a1a91b25d7598376$var$zip_read(d, o);
    return $a1a91b25d7598376$export$b165387946f79a1(zip, o);
}
function $a1a91b25d7598376$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $a1a91b25d7598376$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $a1a91b25d7598376$var$PRN.to_workbook(data, o);
}
function $a1a91b25d7598376$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $a1a91b25d7598376$var$firstbyte(data, o);
    switch(o.type){
        case 'base64':
            str = $a1a91b25d7598376$var$Base64_decode(data);
            break;
        case 'binary':
            str = data;
            break;
        case 'buffer':
            str = data.toString('binary');
            break;
        case 'array':
            str = $a1a91b25d7598376$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $a1a91b25d7598376$var$utf8read(str);
    o.type = "binary";
    return $a1a91b25d7598376$var$read_plaintext(str, o);
}
function $a1a91b25d7598376$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == 'base64') d = $a1a91b25d7598376$var$Base64_decode(d);
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) d = new Uint8Array(data);
    d = typeof $a1a91b25d7598376$var$$cptable !== "undefined" ? $a1a91b25d7598376$var$$cptable.utils.decode(1200, d.slice(2), 'str') : $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(data) ? data.slice(2).toString("utf16le") : typeof Uint8Array !== "undefined" && d instanceof Uint8Array ? typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le").decode(d.slice(2)) : $a1a91b25d7598376$var$utf16lereadu(d.slice(2)) : $a1a91b25d7598376$var$utf16leread(d.slice(2));
    o.type = "binary";
    return $a1a91b25d7598376$var$read_plaintext(d, o);
}
function $a1a91b25d7598376$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $a1a91b25d7598376$var$utf8write(data);
}
function $a1a91b25d7598376$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $a1a91b25d7598376$var$PRN.to_workbook(data, o);
    }
    return $a1a91b25d7598376$var$PRN.to_workbook(d, o);
}
function $a1a91b25d7598376$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $a1a91b25d7598376$var$reset_cp();
    var o = opts || {};
    if (o.codepage && typeof $a1a91b25d7598376$var$$cptable === "undefined") console.error("Codepage tables are not loaded.  Non-ASCII characters may not give expected results");
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return $a1a91b25d7598376$export$aafa59e2e03f2942(new Uint8Array(data), (o = $a1a91b25d7598376$var$dup(o), o.type = "array", o));
    /* Javet projects `byte[]` to `Int8Array` */ if (typeof Int8Array !== 'undefined' && data instanceof Int8Array) return $a1a91b25d7598376$export$aafa59e2e03f2942(new Uint8Array(data.buffer, data.byteOffset, data.length), o);
    if (typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $a1a91b25d7598376$var$_ssfopts = {};
    if (o.dateNF) $a1a91b25d7598376$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $a1a91b25d7598376$var$has_buf ? "buffer" : "binary";
        d = $a1a91b25d7598376$var$read_binary(data);
        if (typeof Uint8Array !== 'undefined' && !$a1a91b25d7598376$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $a1a91b25d7598376$var$bstrify(data);
    }
    if (o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $a1a91b25d7598376$var$dup(o);
            o.type = 'array';
            return $a1a91b25d7598376$export$aafa59e2e03f2942($a1a91b25d7598376$var$ab2a(d), o);
        }
    }
    switch((n = $a1a91b25d7598376$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $a1a91b25d7598376$var$read_cfb($a1a91b25d7598376$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $a1a91b25d7598376$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $a1a91b25d7598376$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $a1a91b25d7598376$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $a1a91b25d7598376$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $a1a91b25d7598376$var$read_zip(d, o) : $a1a91b25d7598376$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $a1a91b25d7598376$var$parse_xlml(d, o) : $a1a91b25d7598376$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $a1a91b25d7598376$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $a1a91b25d7598376$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $a1a91b25d7598376$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $a1a91b25d7598376$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $a1a91b25d7598376$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $a1a91b25d7598376$var$rtf_to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $a1a91b25d7598376$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
        case 0x08:
            if (n[1] === 0xE7) throw new Error("Unsupported Multiplan 1.x file!");
            break;
        case 0x0C:
            if (n[1] === 0xEC) throw new Error("Unsupported Multiplan 2.x file!");
            if (n[1] === 0xED) throw new Error("Unsupported Multiplan 3.x file!");
            break;
    }
    if ($a1a91b25d7598376$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $a1a91b25d7598376$var$DBF.to_workbook(d, o);
    return $a1a91b25d7598376$var$read_prn(data, d, o, str);
}
function $a1a91b25d7598376$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = 'file';
    return $a1a91b25d7598376$export$aafa59e2e03f2942(filename, o);
}
function $a1a91b25d7598376$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $a1a91b25d7598376$var$write_dl(o.file, $a1a91b25d7598376$export$9f0e51cd97c572a.write(cfb, {
                type: $a1a91b25d7598376$var$has_buf ? 'buffer' : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $a1a91b25d7598376$export$9f0e51cd97c572a.write(cfb, o);
}
function $a1a91b25d7598376$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    switch(opts.bookType){
        case "ods":
            return $a1a91b25d7598376$var$write_ods(wb, opts);
        case "numbers":
            return $a1a91b25d7598376$var$write_numbers_iwa(wb, opts);
        case "xlsb":
            return $a1a91b25d7598376$var$write_zip_xlsb(wb, opts);
        default:
            return $a1a91b25d7598376$var$write_zip_xlsx(wb, opts);
    }
}
/*:: declare var encrypt_agile:any; */ function $a1a91b25d7598376$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $a1a91b25d7598376$var$dup(opts || {});
    var z = $a1a91b25d7598376$var$write_zip(wb, o);
    return $a1a91b25d7598376$var$write_zip_denouement(z, o);
}
function $a1a91b25d7598376$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $a1a91b25d7598376$var$dup(opts || {});
    var z = $a1a91b25d7598376$var$write_zip_xlsx(wb, o);
    return $a1a91b25d7598376$var$write_zip_denouement(z, o);
}
function $a1a91b25d7598376$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $a1a91b25d7598376$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = 'DEFLATE';
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $a1a91b25d7598376$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($a1a91b25d7598376$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== 'undefined') return $a1a91b25d7598376$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $a1a91b25d7598376$var$write_dl(o.file, out);
    return o.type == "string" ? $a1a91b25d7598376$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $a1a91b25d7598376$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $a1a91b25d7598376$var$write_xlscfb(wb, o);
    return $a1a91b25d7598376$var$write_cfb_ctr(cfb, o);
}
function $a1a91b25d7598376$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $a1a91b25d7598376$var$Base64_encode($a1a91b25d7598376$var$utf8write(o));
        case "binary":
            return $a1a91b25d7598376$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $a1a91b25d7598376$var$write_dl(opts.file, o, 'utf8');
        case "buffer":
            if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$var$Buffer_from(o, 'utf8');
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $a1a91b25d7598376$var$write_string_type(o, {
                type: 'binary'
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $a1a91b25d7598376$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $a1a91b25d7598376$var$Base64_encode_pass(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $a1a91b25d7598376$var$write_dl(opts.file, out, 'binary');
        case "buffer":
            if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$var$Buffer_from(out, 'binary');
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $a1a91b25d7598376$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == 'base64' ? $a1a91b25d7598376$var$Base64_encode(bstr) : opts.type == 'string' ? $a1a91b25d7598376$var$utf8read(bstr) : bstr;
        case "file":
            return $a1a91b25d7598376$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $a1a91b25d7598376$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $a1a91b25d7598376$var$reset_cp();
    $a1a91b25d7598376$var$check_wb(wb);
    var o = $a1a91b25d7598376$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $a1a91b25d7598376$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $a1a91b25d7598376$var$s2ab(out);
    }
    return $a1a91b25d7598376$var$write_zip_typeXLSX(wb, o);
}
function $a1a91b25d7598376$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $a1a91b25d7598376$var$reset_cp();
    $a1a91b25d7598376$var$check_wb(wb);
    var o = $a1a91b25d7598376$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $a1a91b25d7598376$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $a1a91b25d7598376$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || 'xlsb'){
        case 'xml':
        case 'xlml':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$write_xlml(wb, o), o);
        case 'slk':
        case 'sylk':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb), o);
        case 'htm':
        case 'html':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'txt':
            return $a1a91b25d7598376$var$write_stxt_type($a1a91b25d7598376$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'csv':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
        case 'dif':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'dbf':
            return $a1a91b25d7598376$var$write_binary_type($a1a91b25d7598376$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'prn':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'rtf':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$sheet_to_rtf(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'eth':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'fods':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$write_ods(wb, o), o);
        case 'wk1':
            return $a1a91b25d7598376$var$write_binary_type($a1a91b25d7598376$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'wk3':
            return $a1a91b25d7598376$var$write_binary_type($a1a91b25d7598376$var$WK_.book_to_wk3(wb, o), o);
        case 'biff2':
            if (!o.biff) o.biff = 2; /* falls through */ 
        case 'biff3':
            if (!o.biff) o.biff = 3; /* falls through */ 
        case 'biff4':
            if (!o.biff) o.biff = 4;
            return $a1a91b25d7598376$var$write_binary_type($a1a91b25d7598376$var$write_biff_buf(wb, o), o);
        case 'biff5':
            if (!o.biff) o.biff = 5; /* falls through */ 
        case 'biff8':
        case 'xla':
        case 'xls':
            if (!o.biff) o.biff = 8;
            return $a1a91b25d7598376$var$write_cfb_type(wb, o);
        case 'xlsx':
        case 'xlsm':
        case 'xlam':
        case 'xlsb':
        case 'numbers':
        case 'ods':
            return $a1a91b25d7598376$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $a1a91b25d7598376$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $a1a91b25d7598376$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $a1a91b25d7598376$var$resolve_book_type(o);
    return $a1a91b25d7598376$export$68d8715fc104d294(wb, o);
}
function $a1a91b25d7598376$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $a1a91b25d7598376$var$resolve_book_type(o);
    return $a1a91b25d7598376$export$f6ca43591cb061b1(wb, o);
}
function $a1a91b25d7598376$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $a1a91b25d7598376$var$resolve_book_type(o);
    o.type = 'buffer';
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $a1a91b25d7598376$var$_fs.writeFile(filename, $a1a91b25d7598376$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $a1a91b25d7598376$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $a1a91b25d7598376$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true, dense = sheet["!data"] != null;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, '__rowNum__', {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet["!data"][R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val1 = dense ? (sheet["!data"][R] || [])[C] : sheet[cols[C] + rr];
        if (val1 == null || val1.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val1.v;
        switch(val1.t){
            case 'z':
                if (v == null) break;
                continue;
            case 'e':
                v = v == 0 ? null : void 0;
                break;
            case 's':
            case 'b':
            case 'n':
                if (!val1.z || !$a1a91b25d7598376$var$fmt_is_date(val1.z)) break;
                v = $a1a91b25d7598376$var$numdate(v); // TODO: date1904 setting should also be stored in worksheet object
                if (typeof v == "number") break;
            /* falls through */ case 'd':
                if (!(o && (o.UTC || o.raw === false))) v = $a1a91b25d7598376$var$utc_to_local(new Date(v));
                break;
            default:
                throw new Error('unrecognized type ' + val1.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val1.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = (val1.t === 'n' && typeof o.rawNumbers === 'boolean' ? o.rawNumbers : raw) ? v : $a1a91b25d7598376$var$format_cell(val1, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $a1a91b25d7598376$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val1 = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case 'string':
            r = $a1a91b25d7598376$var$safe_decode_range(range);
            break;
        case 'number':
            r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $a1a91b25d7598376$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $a1a91b25d7598376$var$encode_col(C);
        val1 = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val1 == null) val1 = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $a1a91b25d7598376$var$format_cell(val1, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $a1a91b25d7598376$var$make_json_row(sheet, r, R, cols, header, hdr, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $a1a91b25d7598376$var$qreg = /"/g;
function $a1a91b25d7598376$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , w /*:number*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $a1a91b25d7598376$var$encode_row(R);
    var dense = sheet["!data"] != null;
    var datarow = dense && sheet["!data"][R] || [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val1 = dense ? datarow[C] : sheet[cols[C] + rr];
        if (val1 == null) txt = "";
        else if (val1.v != null) {
            isempty = false;
            txt = '' + (o.rawNumbers && val1.t == "n" ? val1.v : $a1a91b25d7598376$var$format_cell(val1, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = "\"" + txt.replace($a1a91b25d7598376$var$qreg, '""') + "\"";
                break;
            }
            if (txt == "ID" && w == 0 && row.length == 0) txt = '"ID"';
        } else if (val1.f != null && !val1.F) {
            isempty = false;
            txt = '=' + val1.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($a1a91b25d7598376$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.strip) while(row[row.length - 1] === "")--row.length;
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $a1a91b25d7598376$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $a1a91b25d7598376$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $a1a91b25d7598376$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, w, o);
        if (row == null) continue;
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    return out.join("");
}
function $a1a91b25d7598376$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "\t";
    opts.RS = "\n";
    var s = $a1a91b25d7598376$var$sheet_to_csv(sheet, opts);
    if (typeof $a1a91b25d7598376$var$$cptable == 'undefined' || opts.type == 'string') return s;
    var o = $a1a91b25d7598376$var$$cptable.utils.encode(1200, s, 'str');
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $a1a91b25d7598376$var$sheet_to_formulae(sheet /*:Worksheet*/ , opts /*:?Sheet2FormulaOpts*/ ) /*:Array<string>*/ {
    var y = "", x, val1 = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $a1a91b25d7598376$var$safe_decode_range(sheet['!ref']), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = sheet["!data"] != null;
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $a1a91b25d7598376$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet["!data"][R] || [])[C] : sheet[y];
            val1 = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val1 = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val1 = x.f;
            else if (opts && opts.values === false) continue;
            else if (x.t == 'z') continue;
            else if (x.t == 'n' && x.v != null) val1 = "" + x.v;
            else if (x.t == 'b') val1 = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val1 = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == 's') val1 = "'" + x.v;
            else val1 = "" + x.v;
            cmds[cmds.length] = y + "=" + val1;
        }
    }
    return cmds;
}
function $a1a91b25d7598376$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($a1a91b25d7598376$var$DENSE != null && dense == null) dense = $a1a91b25d7598376$var$DENSE;
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {};
    if (!_ws && dense) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $a1a91b25d7598376$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws['!ref']) {
        var _range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    var ROW = [];
    js.forEach(function(JS, R /*:number*/ ) {
        if (dense && !ws["!data"][_R + R + offset]) ws["!data"][_R + R + offset] = [];
        if (dense) ROW = ws["!data"][_R + R + offset];
        $a1a91b25d7598376$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = 'z';
            var z = "";
            var ref = dense ? "" : $a1a91b25d7598376$var$encode_col(_C + C) + $a1a91b25d7598376$var$encode_row(_R + R + offset);
            var cell /*:Cell*/  = dense ? ROW[_C + C] : ws[ref];
            if (v && typeof v === 'object' && !(v instanceof Date)) {
                if (dense) ROW[_C + C] = v;
                else ws[ref] = v;
            } else {
                if (typeof v == 'number') t = 'n';
                else if (typeof v == 'boolean') t = 'b';
                else if (typeof v == 'string') t = 's';
                else if (v instanceof Date) {
                    t = 'd';
                    if (!o.UTC) v = $a1a91b25d7598376$var$local_to_utc(v);
                    if (!o.cellDates) {
                        t = 'n';
                        v = $a1a91b25d7598376$var$datenum(v);
                    }
                    z = cell != null && cell.z && $a1a91b25d7598376$var$fmt_is_date(cell.z) ? cell.z : o.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = 'e';
                    v = 0;
                }
                if (!cell) {
                    if (!dense) ws[ref] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                    else ROW[_C + C] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                } else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $a1a91b25d7598376$var$encode_row(_R);
    if (dense && !ws["!data"][_R]) ws["!data"][_R] = [];
    if (offset) for(C = 0; C < hdr.length; ++C)if (dense) ws["!data"][_R][C + _C] = {
        t: 's',
        v: hdr[C]
    };
    else ws[$a1a91b25d7598376$var$encode_col(C + _C) + __R] = {
        t: 's',
        v: hdr[C]
    };
    ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
    return ws;
}
function $a1a91b25d7598376$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $a1a91b25d7598376$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $a1a91b25d7598376$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        if (ws["!data"] != null) {
            var RC = $a1a91b25d7598376$var$decode_cell(R);
            if (!ws["!data"][RC.r]) ws["!data"][RC.r] = [];
            return ws["!data"][RC.r][RC.c] || (ws["!data"][RC.r][RC.c] = {
                t: 'z'
            });
        }
        return ws[R] || (ws[R] = {
            t: 'z'
        });
    }
    /* cell address object */ if (typeof R != "number") return $a1a91b25d7598376$var$ws_get_cell_stub(ws, $a1a91b25d7598376$var$encode_cell(R));
    /* R and C are 0-based indices */ return $a1a91b25d7598376$var$ws_get_cell_stub(ws, $a1a91b25d7598376$var$encode_col(C || 0) + $a1a91b25d7598376$var$encode_row(R));
}
/* find sheet index for given name / validate index */ function $a1a91b25d7598376$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank or single-sheet workbook object */ function $a1a91b25d7598376$var$book_new(ws /*:?Worksheet*/ , wsname /*:?string*/ ) /*:Workbook*/ {
    var wb = {
        SheetNames: [],
        Sheets: {}
    };
    if (ws) $a1a91b25d7598376$var$book_append_sheet(wb, ws, wsname || "Sheet1");
    return wb;
}
/* add a worksheet to the end of a given workbook */ function $a1a91b25d7598376$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0 && name.length < 32) {
        var m = name.match(/\d+$/); // at this point, name length is capped at 32
        i = m && +m[0] || 0;
        var root = m && name.slice(0, m.index) || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $a1a91b25d7598376$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $a1a91b25d7598376$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $a1a91b25d7598376$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $a1a91b25d7598376$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $a1a91b25d7598376$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $a1a91b25d7598376$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $a1a91b25d7598376$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $a1a91b25d7598376$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $a1a91b25d7598376$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $a1a91b25d7598376$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $a1a91b25d7598376$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $a1a91b25d7598376$var$ws_get_cell_stub(ws, R, C);
        cell.t = 'n';
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    var wsr = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
    if (wsr.s.r > rng.s.r) wsr.s.r = rng.s.r;
    if (wsr.s.c > rng.s.c) wsr.s.c = rng.s.c;
    if (wsr.e.r < rng.e.r) wsr.e.r = rng.e.r;
    if (wsr.e.c < rng.e.c) wsr.e.c = rng.e.c;
    ws["!ref"] = $a1a91b25d7598376$var$encode_range(wsr);
    return ws;
}
var $a1a91b25d7598376$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $a1a91b25d7598376$var$encode_col,
    encode_row: $a1a91b25d7598376$var$encode_row,
    encode_cell: $a1a91b25d7598376$var$encode_cell,
    encode_range: $a1a91b25d7598376$var$encode_range,
    decode_col: $a1a91b25d7598376$var$decode_col,
    decode_row: $a1a91b25d7598376$var$decode_row,
    split_cell: $a1a91b25d7598376$var$split_cell,
    decode_cell: $a1a91b25d7598376$var$decode_cell,
    decode_range: $a1a91b25d7598376$var$decode_range,
    format_cell: $a1a91b25d7598376$var$format_cell,
    sheet_new: $a1a91b25d7598376$var$sheet_new,
    sheet_add_aoa: $a1a91b25d7598376$var$sheet_add_aoa,
    sheet_add_json: $a1a91b25d7598376$var$sheet_add_json,
    sheet_add_dom: $a1a91b25d7598376$var$sheet_add_dom,
    aoa_to_sheet: $a1a91b25d7598376$var$aoa_to_sheet,
    json_to_sheet: $a1a91b25d7598376$var$json_to_sheet,
    table_to_sheet: $a1a91b25d7598376$var$parse_dom_table,
    table_to_book: $a1a91b25d7598376$var$table_to_book,
    sheet_to_csv: $a1a91b25d7598376$var$sheet_to_csv,
    sheet_to_txt: $a1a91b25d7598376$var$sheet_to_txt,
    sheet_to_json: $a1a91b25d7598376$var$sheet_to_json,
    sheet_to_html: $a1a91b25d7598376$var$sheet_to_html,
    sheet_to_formulae: $a1a91b25d7598376$var$sheet_to_formulae,
    sheet_to_row_object_array: $a1a91b25d7598376$var$sheet_to_json,
    sheet_get_cell: $a1a91b25d7598376$var$ws_get_cell_stub,
    book_new: $a1a91b25d7598376$var$book_new,
    book_append_sheet: $a1a91b25d7598376$var$book_append_sheet,
    book_set_sheet_visibility: $a1a91b25d7598376$var$book_set_sheet_visibility,
    cell_set_number_format: $a1a91b25d7598376$var$cell_set_number_format,
    cell_set_hyperlink: $a1a91b25d7598376$var$cell_set_hyperlink,
    cell_set_internal_link: $a1a91b25d7598376$var$cell_set_internal_link,
    cell_add_comment: $a1a91b25d7598376$var$cell_add_comment,
    sheet_set_array_formula: $a1a91b25d7598376$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $a1a91b25d7598376$var$_Readable;
function $a1a91b25d7598376$var$set_readable(R) {
    $a1a91b25d7598376$var$_Readable = R;
}
function $a1a91b25d7598376$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $a1a91b25d7598376$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $a1a91b25d7598376$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $a1a91b25d7598376$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, w, o);
            if (row != null) {
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $a1a91b25d7598376$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $a1a91b25d7598376$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $a1a91b25d7598376$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $a1a91b25d7598376$var$HTML_END;
    stream.push(header);
    var r = $a1a91b25d7598376$var$decode_range(ws['!ref']);
    stream.push($a1a91b25d7598376$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($a1a91b25d7598376$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $a1a91b25d7598376$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $a1a91b25d7598376$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val1 = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case 'string':
            r = $a1a91b25d7598376$var$safe_decode_range(range);
            break;
        case 'number':
            r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $a1a91b25d7598376$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $a1a91b25d7598376$var$encode_col(C);
        val1 = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val1 == null) val1 = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $a1a91b25d7598376$var$format_cell(val1, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $a1a91b25d7598376$var$make_json_row(sheet, r, R, cols, header, hdr, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $a1a91b25d7598376$var$write_xlml_stream(wb /*:Workbook*/ , o /*:?Sheet2XLMLOpts*/ ) {
    var stream = $a1a91b25d7598376$var$_Readable();
    var opts = o == null ? {} : o;
    var stride = +opts.stride || 10;
    if (!wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    /* do one pass to determine styles since they must be added before tables */ wb.SheetNames.forEach(function(n) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!ref"]) return;
        var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var ddata = dense ? ws["!data"] : [];
        var addr = {
            r: 0,
            c: 0
        };
        for(var R = range.s.r; R <= range.e.r; ++R){
            addr.r = R;
            if (dense && !ddata[R]) continue;
            for(var C = range.s.c; C <= range.e.c; ++C){
                addr.c = C;
                var cell = dense ? ddata[R][C] : ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R)];
                if (!cell) continue;
                if (cell.t == "d" && cell.z == null) {
                    cell = $a1a91b25d7598376$var$dup(cell);
                    cell.z = $a1a91b25d7598376$var$table_fmt[14];
                }
                $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
            }
        }
    });
    var sty = $a1a91b25d7598376$var$write_sty_xlml(wb, opts);
    var stage = 0, wsidx = 0, ws = wb.Sheets[wb.SheetNames[wsidx]], range = $a1a91b25d7598376$var$safe_decode_range(ws), R = -1, T = false;
    var marr = [], mi = 0, dense = false, darr = [], addr = {
        r: 0,
        c: 0
    };
    stream._read = function() {
        switch(stage){
            /* header */ case 0:
                stage = 1;
                stream.push($a1a91b25d7598376$var$XML_HEADER);
                stream.push("<Workbook" + $a1a91b25d7598376$var$wxt_helper({
                    'xmlns': $a1a91b25d7598376$var$XLMLNS.ss,
                    'xmlns:o': $a1a91b25d7598376$var$XLMLNS.o,
                    'xmlns:x': $a1a91b25d7598376$var$XLMLNS.x,
                    'xmlns:ss': $a1a91b25d7598376$var$XLMLNS.ss,
                    'xmlns:dt': $a1a91b25d7598376$var$XLMLNS.dt,
                    'xmlns:html': $a1a91b25d7598376$var$XLMLNS.html
                }) + ">");
                break;
            /* preamble */ case 1:
                stage = 2;
                stream.push($a1a91b25d7598376$var$write_props_xlml(wb, opts));
                stream.push($a1a91b25d7598376$var$write_wb_xlml(wb, opts));
                break;
            /* style and name tables */ case 2:
                stage = 3;
                stream.push(sty);
                stream.push($a1a91b25d7598376$var$write_names_xlml(wb, opts));
                break;
            /* worksheet preamble */ case 3:
                T = false;
                if (wsidx >= wb.SheetNames.length) {
                    stage = -1;
                    stream.push("");
                    break;
                }
                stream.push("<Worksheet" + $a1a91b25d7598376$var$wxt_helper({
                    "ss:Name": $a1a91b25d7598376$var$escapexml(wb.SheetNames[wsidx])
                }) + ">");
                ws = wb.Sheets[wb.SheetNames[wsidx]];
                if (!ws) {
                    stream.push("</Worksheet>");
                    return void ++wsidx;
                }
                var names = $a1a91b25d7598376$var$write_ws_xlml_names(ws, opts, wsidx, wb);
                if (names.length) stream.push("<Names>" + names + "</Names>");
                if (!ws["!ref"]) return stage = 5;
                range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
                R = range.s.r;
                stage = 4;
                break;
            /* worksheet intramble */ case 4:
                if (R < 0 || R > range.e.r) {
                    if (T) stream.push("</Table>");
                    return void (stage = 5);
                }
                if (R <= range.s.r) {
                    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
                        $a1a91b25d7598376$var$process_col(n);
                        var w = !!n.width;
                        var p = $a1a91b25d7598376$var$col_obj_w(i, n);
                        var k /*:any*/  = {
                            "ss:Index": i + 1
                        };
                        if (w) k['ss:Width'] = $a1a91b25d7598376$var$width2px(p.width);
                        if (n.hidden) k['ss:Hidden'] = "1";
                        if (!T) {
                            T = true;
                            stream.push("<Table>");
                        }
                        stream.push($a1a91b25d7598376$var$writextag("Column", null, k));
                    });
                    dense = ws["!data"] != null;
                    if (dense) darr = ws["!data"];
                    addr.r = addr.c = 0;
                }
                /* process `stride` rows per invocation */ for(var cnt = 0; R <= range.e.r && cnt < stride; ++R, ++cnt){
                    var row = [
                        $a1a91b25d7598376$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
                    ];
                    addr.r = R;
                    if (!(dense && !darr[R])) for(var C = range.s.c; C <= range.e.c; ++C){
                        addr.c = C;
                        var skip = false;
                        for(mi = 0; mi != marr.length; ++mi){
                            if (marr[mi].s.c > C) continue;
                            if (marr[mi].s.r > R) continue;
                            if (marr[mi].e.c < C) continue;
                            if (marr[mi].e.r < R) continue;
                            if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                            break;
                        }
                        if (skip) continue;
                        var ref = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R), cell = dense ? darr[R][C] : ws[ref];
                        row.push($a1a91b25d7598376$var$write_ws_xlml_cell(cell, ref, ws, opts, wsidx, wb, addr));
                    }
                    row.push("</Row>");
                    if (!T) {
                        T = true;
                        stream.push("<Table>");
                    }
                    stream.push(row.join(""));
                }
                break;
            /* worksheet postamble */ case 5:
                stream.push($a1a91b25d7598376$var$write_ws_xlml_wsopts(ws, opts, wsidx, wb));
                if (ws && ws["!autofilter"]) stream.push('<AutoFilter x:Range="' + $a1a91b25d7598376$var$a1_to_rc($a1a91b25d7598376$var$fix_range(ws["!autofilter"].ref), {
                    r: 0,
                    c: 0
                }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
                stream.push("</Worksheet>");
                wsidx++;
                R = -1;
                return void (stage = 3);
            /* footer */ case -1:
                stage = -2;
                stream.push("</Workbook>");
                break;
            /* exeunt */ case -2:
                stream.push(null);
                break;
        }
    };
    return stream;
}
var $a1a91b25d7598376$export$4938110305e6185f = {
    to_json: $a1a91b25d7598376$var$write_json_stream,
    to_html: $a1a91b25d7598376$var$write_html_stream,
    to_csv: $a1a91b25d7598376$var$write_csv_stream,
    to_xlml: $a1a91b25d7598376$var$write_xlml_stream,
    set_readable: $a1a91b25d7598376$var$set_readable
};
const $a1a91b25d7598376$export$83d89fbfd8236492 = $a1a91b25d7598376$var$XLSX.version;
var $a1a91b25d7598376$export$2e2bcd8739ae039 = {
    parse_xlscfb: $a1a91b25d7598376$export$b41972a043aba84c,
    parse_zip: $a1a91b25d7598376$export$b165387946f79a1,
    read: $a1a91b25d7598376$export$aafa59e2e03f2942,
    readFile: $a1a91b25d7598376$export$72c04af63de9061a,
    readFileSync: $a1a91b25d7598376$export$72c04af63de9061a,
    write: $a1a91b25d7598376$export$68d8715fc104d294,
    writeFile: $a1a91b25d7598376$export$552bfb764b5cd2b4,
    writeFileSync: $a1a91b25d7598376$export$552bfb764b5cd2b4,
    writeFileAsync: $a1a91b25d7598376$export$25469296c4b8ebda,
    writeXLSX: $a1a91b25d7598376$export$f6ca43591cb061b1,
    writeFileXLSX: $a1a91b25d7598376$export$40a06aea54ee074e,
    utils: $a1a91b25d7598376$export$eab97d15b1788b8d,
    set_fs: $a1a91b25d7598376$export$a48eb669e1768bcf,
    set_cptable: $a1a91b25d7598376$export$58f247d16f363b86,
    stream: $a1a91b25d7598376$export$4938110305e6185f,
    SSF: $a1a91b25d7598376$export$40d8edd678456c2b,
    CFB: $a1a91b25d7598376$export$9f0e51cd97c572a
};








function $7739a5f0c43df8e2$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [pendingSelectedWaiver, setPendingSelectedWaiver] = (0, $7fPBF.useState)(null);
    const [selectedWaiver, setSelectedWaiver] = (0, $7fPBF.useState)(null);
    const [file, setFile] = (0, $7fPBF.useState)(null);
    const [sheetJSON, setSheetJSON] = (0, $7fPBF.useState)(null);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [selectedColumnIndex, setSelectedColumnIndex] = (0, $7fPBF.useState)(null);
    const [proposedUpdate, setProposedUpdate] = (0, $7fPBF.useState)(null);
    const [saving, setSaving] = (0, $7fPBF.useState)(false);
    const [success, setSuccess] = (0, $7fPBF.useState)(false);
    const createProposedUpdates = ()=>{
        if (!selectedColumnIndex || !sheetJSON || !selectedWaiver) return;
        let newlyCompleted = [];
        let failedToFindMatch = [];
        // Take off header
        for (const row of sheetJSON.slice(1)){
            const name = row[selectedColumnIndex];
            if (!name || typeof name !== 'string') continue;
            let replace = name.replace(/[^a-zA-Z0-9 ,]/g, ' ').trim();
            let split = replace.split(', ').filter((s)=>s.length > 0);
            for (const item of split){
                const matchingAttendee = props.attendees.find((attendee)=>{
                    const attendeeName = attendee.name.toLowerCase();
                    return attendeeName === item.toLowerCase();
                });
                if (matchingAttendee) // only add if attendee hasn't completed waiver.
                {
                    if (!matchingAttendee.completedWaivers.find((w)=>w.id === selectedWaiver.id)) newlyCompleted.push(matchingAttendee);
                } else failedToFindMatch.push(item);
            }
        }
        setProposedUpdate({
            newlyCompleted: newlyCompleted,
            failedToFindMatch: failedToFindMatch
        });
    };
    const submitAttendeeUpdate = async (markAsComplete)=>{
        if (!selectedWaiver) return;
        setSaving(true);
        setError(null);
        try {
            const response = await (0, $6857e104788587b0$export$2e2bcd8739ae039).submitAttendeeWaiverCompletions(props.event.churchID, props.event.id, selectedWaiver.id, markAsComplete, auth);
            if (response.error || !response.body) {
                setError(response.error || "Failed to save updates. Please try again later.");
                return;
            }
            props.onAttendeesUpdated(response.body.attendees);
            setSuccess(true);
        } catch (err) {
            setError("Failed to save updates. Please try again later.");
        } finally{
            setSaving(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!props.isOpen) return;
        setError(null);
        setFile(null);
        setSheetJSON(null);
        setSelectedColumnIndex(null);
        setProposedUpdate(null);
        setSelectedWaiver(null);
        setPendingSelectedWaiver(null);
        setSaving(false);
        setSuccess(false);
    }, [
        props.isOpen
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!file) return;
        const parseFile = async ()=>{
            try {
                const ab = await file.arrayBuffer();
                const workbook = (0, $a1a91b25d7598376$export$2e2bcd8739ae039).read(ab, {
                    type: "array"
                });
                const firstSheetName = workbook.SheetNames[0];
                if (firstSheetName) {
                    const sheet = workbook.Sheets[firstSheetName];
                    const data = (0, $a1a91b25d7598376$export$2e2bcd8739ae039).utils.sheet_to_json(sheet, {
                        header: 1
                    });
                    setSheetJSON(data);
                } else setError("Failed to parse sheets from file. Please contact support with a copy of your spreadsheet.");
            } catch (err) {
                setError("Failed to parse sheets from file. Please contact support with a copy of your spreadsheet.");
            }
        };
        parseFile();
    }, [
        file
    ]);
    const closeButton = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
        className: "close",
        href: "#",
        onClick: (e)=>{
            e.preventDefault();
            props.close();
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
            className: "icon",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
            alt: "Close icon"
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        isOpen: props.isOpen,
        id: "manual-waiver-upload",
        footerButtons: [],
        children: [
            saving && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                fullScreen: false
            }),
            !error && !saving && !success && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "header",
                children: [
                    closeButton,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Manual Waiver Upload"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                ]
            }),
            error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    marginTop: 24
                },
                children: [
                    closeButton,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                        error: error,
                        showButton: false
                    })
                ]
            }),
            !error && !selectedWaiver && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "selectWaiver",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Please select the waiver which you would like to update attendee status for."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                        value: pendingSelectedWaiver ? pendingSelectedWaiver.id : 'null',
                        onChange: (e)=>{
                            const waiver = props.event.waivers.find((w)=>w.id === e.target.value);
                            setPendingSelectedWaiver(waiver || null);
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                value: 'null',
                                disabled: true,
                                children: "-- Select Waiver --"
                            }),
                            props.event.waivers.map((waiver)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                    value: waiver.id,
                                    children: waiver.name
                                }, waiver.id))
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        disabled: !pendingSelectedWaiver,
                        onClick: (e)=>{
                            e.preventDefault();
                            setSelectedWaiver(pendingSelectedWaiver);
                        },
                        children: "Next"
                    })
                ]
            }),
            !error && selectedWaiver && !sheetJSON && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Please select a spreadsheet (CSV or Excel files supported)"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                        type: "file",
                        name: "spreadsheet",
                        accept: ".xlsx,.xls,.csv",
                        onChange: (e)=>{
                            var _e_target_files;
                            e.preventDefault();
                            setFile(((_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0]) || null);
                        }
                    })
                ]
            }),
            !error && sheetJSON && !proposedUpdate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "columnSelect",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Please select which column contains the names of attendees"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                        value: selectedColumnIndex === null ? 'null' : selectedColumnIndex,
                        onChange: (e)=>{
                            if (e.target.value === 'null') {
                                setSelectedColumnIndex(null);
                                return;
                            }
                            setSelectedColumnIndex(parseInt(e.target.value));
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                value: 'null',
                                disabled: true,
                                children: "-- Select Column --"
                            }),
                            sheetJSON[0] && sheetJSON[0].map((col, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                    value: idx,
                                    children: col || `Column ${idx + 1}`
                                }, idx))
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        disabled: selectedColumnIndex === null,
                        onClick: (e)=>{
                            e.preventDefault();
                            createProposedUpdates();
                        },
                        children: "Next"
                    })
                ]
            }),
            !error && proposedUpdate && selectedWaiver && !saving && !success && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7739a5f0c43df8e2$var$ProposedUpdateEditor, {
                proposedUpdate: proposedUpdate,
                attendees: props.attendees,
                waiver: selectedWaiver,
                onConfirm: (markAsComplete)=>{
                    submitAttendeeUpdate(markAsComplete);
                }
            }),
            success && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    marginTop: 24
                },
                children: [
                    closeButton,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9f2c42b26582cc85$export$2e2bcd8739ae039), {
                        title: "Waiver Submissions Updated",
                        description: "Successfully updated the waiver submissions for this event."
                    })
                ]
            })
        ]
    });
}
function $7739a5f0c43df8e2$var$ProposedUpdateEditor(props) {
    const { proposedUpdate: proposedUpdate } = props;
    const [participantOverride, setParticipantOverride] = (0, $7fPBF.useState)({});
    const availableAttendees = (0, $7fPBF.useMemo)(()=>{
        const newlyCompletedIds = new Set(proposedUpdate.newlyCompleted.map((a)=>a.id));
        return props.attendees.filter((attendee)=>!newlyCompletedIds.has(attendee.id)) // not recently completed
        .filter((attendee)=>attendee.completedWaivers.find((w)=>w.id == props.waiver.id) == null) // not already completed
        .filter((attendee)=>!Object.values(participantOverride).includes(attendee.id)); // not already selected as override
    }, [
        props.attendees,
        participantOverride
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "proposedUpdates",
        children: [
            proposedUpdate.newlyCompleted.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                        children: "Proposed Status Updates"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "These attendees will be marked as having recently completed the selected waiver."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                        className: "attendeeList",
                        children: proposedUpdate.newlyCompleted.map((attendee, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                className: "attendee",
                                children: attendee.name
                            }, idx))
                    })
                ]
            }),
            proposedUpdate.failedToFindMatch.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                        children: "Unmatched Names"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "The following names could not be matched to any attendees who have not already completed the selected waiver. You may manually select an attendee per unmatched name, or leave blank to skip."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                        className: "attendeeList",
                        children: proposedUpdate.failedToFindMatch.map((name, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                className: "attendee",
                                children: [
                                    name,
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                        value: participantOverride[name] || 'null',
                                        onChange: (e)=>{
                                            const selected = e.target.value;
                                            const newOverrides = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, participantOverride);
                                            if (selected === 'null') delete newOverrides[name];
                                            else newOverrides[name] = selected;
                                            setParticipantOverride(newOverrides);
                                            console.log(newOverrides);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: 'null',
                                                children: "-- Select Attendee --"
                                            }),
                                            props.attendees.map((attendee)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                    value: attendee.id,
                                                    disabled: !availableAttendees.includes(attendee) && attendee.id !== participantOverride[name],
                                                    children: attendee.name
                                                }, attendee.id))
                                        ]
                                    })
                                ]
                            }, idx))
                    })
                ]
            }),
            proposedUpdate.failedToFindMatch.length === 0 && proposedUpdate.newlyCompleted.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "No updates were found in the uploaded spreadsheet. Either the spreadsheet was impossible to read, or all attendees within have already been marked as having completed the selected waiver."
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                onClick: (e)=>{
                    e.preventDefault();
                    const finalNewlyCompleted = [
                        ...proposedUpdate.newlyCompleted
                    ];
                    for (const [_, attendeeId] of Object.entries(participantOverride)){
                        const attendee = props.attendees.find((a)=>a.id === attendeeId);
                        if (attendee) finalNewlyCompleted.push(attendee);
                    }
                    props.onConfirm(finalNewlyCompleted);
                },
                children: "Confirm Update"
            })
        ]
    });
}


function $ed4b406b926302af$var$useEventAttendees(eventID) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchId = auth.churchId;
    const [event, setEvent] = (0, $7fPBF.useState)(null);
    const [attendees, setAttendees] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchId) return;
        setLoading(true);
        setError(null);
        try {
            const [eventResponse, attendeesResponse] = await Promise.all([
                (0, $6857e104788587b0$export$2e2bcd8739ae039).fetchEvent(churchId, eventID, auth),
                (0, $6857e104788587b0$export$2e2bcd8739ae039).fetchAttendeesForEvent(churchId, eventID, auth)
            ]);
            if (eventResponse.error) {
                setError(eventResponse.error);
                setAttendees(null);
                setEvent(null);
            } else if (attendeesResponse.error) {
                setError(attendeesResponse.error);
                setAttendees(null);
                setEvent(null);
            } else if (eventResponse.body && attendeesResponse.body) {
                setEvent(eventResponse.body.event);
                setAttendees(attendeesResponse.body.attendees);
            } else {
                setAttendees(null);
                setEvent(null);
            }
        } catch (err) {
            setError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to load events');
            setAttendees(null);
            setEvent(null);
        } finally{
            setLoading(false);
        }
    }, [
        churchId,
        eventID,
        auth
    ]);
    const updateEvent = (newEvent)=>{
        setEvent(newEvent);
    };
    const updateAttendees = (newAttendees)=>{
        setAttendees(newAttendees);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!churchId || !eventID) return;
        let isMounted = true;
        const performFetch = async ()=>{
            await fetch();
            if (!isMounted) return;
        };
        performFetch();
        return ()=>{
            isMounted = false;
        };
    }, [
        churchId,
        fetch
    ]);
    return {
        attendees: attendees,
        event: event,
        loading: loading,
        error: error,
        refetch: fetch,
        updateEvent: updateEvent,
        updateAttendees: updateAttendees
    };
}
function $ed4b406b926302af$export$2e2bcd8739ae039() {
    const pathParams = (0, $6de75bb8982f6eaa$export$99eaa27ddbbb95ef)();
    const eventID = pathParams.eventID;
    if (!eventID) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$444b3ab0cb9aec40), {
        to: "/events",
        replace: true
    });
    const [showSetupWaiverModal, setShowWaiverSetupModal] = (0, $7fPBF.useState)(false);
    const [showManualWaiverUploadModal, setShowManualWaiverUploadModal] = (0, $7fPBF.useState)(false);
    const [showSendWaiverEmailModal, setShowWaiverEmailModal] = (0, $7fPBF.useState)(false);
    const { attendees: attendees, event: event, loading: loading, error: error, updateEvent: updateEvent, updateAttendees: updateAttendees } = $ed4b406b926302af$var$useEventAttendees(eventID);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "event-details-page",
        children: [
            loading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {}),
            error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                className: "error",
                children: [
                    "Error loading event details: ",
                    error
                ]
            }),
            event && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                        title: event === null || event === void 0 ? void 0 : event.title,
                        backLocation: "/events",
                        dropdown: {
                            title: 'Event Actions',
                            items: [
                                {
                                    title: 'New Waiver',
                                    icon: (0, $0298034ab94cd70d$export$3ed8400b82efd319).DOCUMENT,
                                    onClick: ()=>{
                                        setShowWaiverSetupModal(true);
                                    }
                                },
                                {
                                    title: 'Manual Waiver Upload',
                                    icon: (0, $0298034ab94cd70d$export$3ed8400b82efd319).SHARE,
                                    onClick: ()=>{
                                        setShowManualWaiverUploadModal(true);
                                    }
                                },
                                {
                                    title: 'Send Reminder Emails',
                                    icon: (0, $0298034ab94cd70d$export$3ed8400b82efd319).MAIL,
                                    onClick: ()=>{
                                        setShowWaiverEmailModal(true);
                                    }
                                }
                            ]
                        },
                        links: []
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $75c3ed5f39befefd$export$2e2bcd8739ae039), {
                        event: event,
                        isOpen: showSetupWaiverModal,
                        updateEvent: updateEvent,
                        close: ()=>{
                            setShowWaiverSetupModal(false);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a879c7c9b4e34f4c$export$2e2bcd8739ae039), {
                        event: event,
                        isOpen: showSendWaiverEmailModal,
                        close: ()=>{
                            setShowWaiverEmailModal(false);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7739a5f0c43df8e2$export$2e2bcd8739ae039), {
                        event: event,
                        attendees: attendees || [],
                        isOpen: showManualWaiverUploadModal,
                        onAttendeesUpdated: (attendees)=>{
                            updateAttendees(attendees);
                        },
                        close: ()=>{
                            setShowManualWaiverUploadModal(false);
                        }
                    }),
                    attendees && event && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h3", {
                                style: {
                                    margin: 0
                                },
                                children: [
                                    "Attendees (",
                                    attendees.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                style: {
                                    margin: 0
                                },
                                children: "If this event was just imported from Planning Center, it may take some time before attendees are available."
                            }),
                            attendees.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "No attendees registered for this event."
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "legend grid-format",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: "Waivers"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {}),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        style: {
                                            textAlign: 'end'
                                        },
                                        children: "Submitted"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "cards",
                                children: [
                                    ...attendees
                                ].sort((a, b)=>{
                                    const roleCompare = a.role.localeCompare(b.role);
                                    if (roleCompare !== 0) return roleCompare;
                                    const nameCompare = a.name.localeCompare(b.name);
                                    if (nameCompare !== 0) return nameCompare;
                                    return a.createdAt && b.createdAt ? new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime() : 0;
                                }).map((attendee)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ed4b406b926302af$var$AttendeeCard, {
                                        attendee: attendee,
                                        waivers: event.waivers
                                    }, attendee.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $ed4b406b926302af$var$AttendeeCard(props) {
    const completedAllWaivers = props.waivers.every((waiver)=>props.attendee.completedWaivers.find((cw)=>cw.id === waiver.id) !== undefined);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: 'attendee-card card grid-format ' + (completedAllWaivers ? 'complete' : 'incomplete'),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "status-strip",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "metadata",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "name",
                        children: props.attendee.name
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        className: 'role-label ' + props.attendee.role.toLowerCase(),
                        children: [
                            props.attendee.role == 'volunteer' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6df11232f48ec2ff$exports))),
                                alt: "Volunteer icon"
                            }) : null,
                            props.attendee.role.charAt(0).toUpperCase() + props.attendee.role.slice(1)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "waivers",
                role: "group",
                "aria-label": "Waiver status",
                children: props.waivers.map((waiver)=>{
                    const completed = props.attendee.completedWaivers.find((cw)=>cw.id === waiver.id) !== undefined;
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "waiver " + (completed ? "waiver--complete" : "waiver--incomplete"),
                        "aria-label": waiver.name
                    }, waiver.id);
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "date",
                children: props.attendee.createdAt ? (0, $ee65f54ee732d431$exports.DateTime).fromISO(props.attendee.createdAt).toFormat("LLL dd, yyyy") : null
            })
        ]
    });
}


(0, (/*@__PURE__*/$parcel$interopDefault($7857575a213426db$exports))).setAppElement('#root');
(0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a29469ea96a6022$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12342e602c448a3c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $516c6e0c0adbc42f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6de75bb8982f6eaa$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f1b5de3ad0a0b51c$export$2e2bcd8739ae039), {}),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2471b8f7d7b0c863$export$2e2bcd8739ae039), {}),
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c522a61e1633b5f$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        path: "home",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c522a61e1633b5f$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        path: "service-plans",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c98534f3985332e$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        path: "playlists",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $642e727260322576$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        path: "team",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09e93e778c8a89c9$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        path: "connections/redirect",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b0f979acc21dbbe$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        path: "connections",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8b78cb05ee8c928f$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        path: "events",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2a0798e511c3602a$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        path: "events/create",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7391c474f3fbb6e2$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        path: "events/create/details",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1931765328266215$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        path: "events/create/import",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd33414c39acb8d6$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        path: "events/:eventID",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ed4b406b926302af$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("main", {
                                            style: {
                                                padding: "1rem"
                                            },
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                children: "There's nothing here!"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                            path: "/login",
                            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f20b05b49aeba227$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                            path: "/reset-password",
                            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $14b7ba2e956aca92$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            })
        })
    })
}), document.getElementById('root'));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, $5a0342ebaab9f2d7$export$2e2bcd8739ae039)();


//# sourceMappingURL=public.9ae4cb2a.js.map
